[
  {
    "prefixo": "01001",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01002",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01003",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01004",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01005",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01006",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01007",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01008",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01009",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01010",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01011",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01012",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01013",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01014",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01015",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01016",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01017",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01018",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01019",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01020",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01021",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01022",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01023",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01024",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01025",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01026",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01027",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01028",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01029",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01030",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01031",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01032",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01033",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01034",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01035",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01036",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01037",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01038",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01039",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01040",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01041",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01042",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01043",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01044",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01045",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01046",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01047",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01048",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01049",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01050",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01101",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01102",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01103",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01104",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01105",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01106",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01107",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01108",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01109",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01120",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01121",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01122",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01123",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01124",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01125",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01126",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01127",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01128",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01129",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01130",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01131",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01132",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01133",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01134",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01135",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01136",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01137",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01138",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01139",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01140",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01141",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01142",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01144",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01150",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01151",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01152",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01153",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01154",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01155",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01156",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01201",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01202",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01203",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01204",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01205",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01206",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01207",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01208",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01209",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01210",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01211",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01212",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01213",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01214",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01215",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01216",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01217",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01218",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01219",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01220",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01221",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01222",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01223",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01224",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01225",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01226",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01227",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01228",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01229",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01230",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01231",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01232",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01233",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01234",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01235",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01236",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01237",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01238",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01239",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01240",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01241",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01242",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01243",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01244",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01245",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01246",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01247",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01248",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01249",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01250",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01251",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01252",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01253",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01254",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01255",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01256",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01257",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01258",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01259",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01262",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01301",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01302",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01303",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01304",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01305",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01306",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01307",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01308",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01309",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01310",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01311",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01312",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01313",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01314",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01315",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01316",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01317",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01318",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01319",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01320",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01321",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01322",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01323",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01324",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01325",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01326",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01327",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01328",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01329",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01330",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01331",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01332",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01333",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01401",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01402",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01403",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01404",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01405",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01406",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01407",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01408",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01409",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01410",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01411",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01412",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01413",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01414",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01415",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01416",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01417",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01418",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01419",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01420",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01421",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01422",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01423",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01424",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01425",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01426",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01427",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01428",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01429",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01430",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01431",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01432",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01433",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01434",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01435",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01436",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01437",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01438",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01439",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01440",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01441",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01442",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01443",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01444",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01445",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01446",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01447",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01448",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01449",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01450",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01451",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01452",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01453",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01454",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01455",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01456",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01457",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01501",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01502",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01503",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01504",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01505",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01506",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01507",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01508",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01509",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01510",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01511",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01512",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01513",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01514",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01515",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01516",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01517",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01518",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01519",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01520",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01521",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01522",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01523",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01524",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01525",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01526",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01527",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01528",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01529",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01530",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01531",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01532",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01533",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01534",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01535",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01536",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01537",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01538",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01539",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01540",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01541",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01542",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01543",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01544",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01545",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01546",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01547",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01548",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01549",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01550",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01551",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01552",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "01553",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02010",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02011",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02012",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02013",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02016",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02017",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02018",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02019",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02020",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02021",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02022",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02028",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02029",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02030",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02031",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02032",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02033",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02034",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02035",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02036",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02037",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02038",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02039",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02040",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02041",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02042",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02043",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02044",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02045",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02046",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02047",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02049",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02050",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02051",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02052",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02053",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02054",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02055",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02056",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02060",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02063",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02064",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02065",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02066",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02067",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02068",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02069",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02071",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02072",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02073",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02074",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02075",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02076",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02077",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02078",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02079",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02080",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02081",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02082",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02083",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02084",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02085",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02110",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02111",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02112",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02113",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02114",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02115",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02116",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02117",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02118",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02119",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02120",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02121",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02122",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02123",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02124",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02125",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02126",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02127",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02128",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02129",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02130",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02131",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02132",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02133",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02134",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02135",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02136",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02137",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02138",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02139",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02140",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02141",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02142",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02143",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02144",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02145",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02146",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02147",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02150",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02151",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02152",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02161",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02162",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02165",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02166",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02167",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02168",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02169",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02170",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02174",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02175",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02176",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02177",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02178",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02179",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02180",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02181",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02185",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02186",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02187",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02188",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02189",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02190",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02201",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02202",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02203",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02204",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02205",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02206",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02207",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02208",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02209",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02210",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02211",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02212",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02213",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02214",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02215",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02216",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02217",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02218",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02219",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02220",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02221",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02222",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02223",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02224",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02225",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02226",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02227",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02228",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02229",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02230",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02231",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02232",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02233",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02234",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02235",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02236",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02237",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02238",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02239",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02240",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02241",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02242",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02243",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02244",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02245",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02246",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02247",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02248",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02249",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02250",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02251",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02252",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02253",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02254",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02255",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02256",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02257",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02258",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02259",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02260",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02261",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02262",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02263",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02264",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02265",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02266",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02267",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02268",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02269",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02270",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02271",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02272",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02273",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02274",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02275",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02276",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02277",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02278",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02279",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02280",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02281",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02282",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02283",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02284",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02285",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02286",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02287",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02288",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02289",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02290",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02301",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02302",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02303",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02304",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02305",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02306",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02307",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02308",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02309",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02310",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02311",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02312",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02313",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02314",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02315",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02316",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02317",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02318",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02319",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02320",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02321",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02322",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02323",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02324",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02325",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02326",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02327",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02328",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02329",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02330",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02331",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02332",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02333",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02334",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02335",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02336",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02337",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02338",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02339",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02340",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02341",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02342",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02343",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02344",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02345",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02346",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02347",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02348",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02349",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02350",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02351",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02352",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02353",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02354",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02355",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02356",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02357",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02358",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02359",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02360",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02361",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02362",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02363",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02364",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02365",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02366",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02367",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02368",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02370",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02371",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02372",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02373",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02374",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02375",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02376",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02377",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02378",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02379",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02401",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02402",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02403",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02404",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02405",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02406",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02407",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02408",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02409",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02410",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02411",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02413",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02415",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02416",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02417",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02418",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02419",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02420",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02421",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02422",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02423",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02430",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02431",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02432",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02433",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02434",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02435",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02436",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02440",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02441",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02442",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02443",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02450",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02451",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02452",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02460",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02461",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02462",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02463",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02464",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02465",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02466",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02467",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02468",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02469",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02470",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02471",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02472",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02473",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02474",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02475",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02478",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02479",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02501",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02508",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02510",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02511",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02512",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02513",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02514",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02515",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02516",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02517",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02518",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02519",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02520",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02521",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02522",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02523",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02524",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02525",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02526",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02530",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02531",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02532",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02533",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02534",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02535",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02536",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02537",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02538",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02539",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02540",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02541",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02542",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02543",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02544",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02545",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02546",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02550",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02551",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02552",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02553",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02554",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02555",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02556",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02557",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02558",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02559",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02560",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02561",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02562",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02563",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02564",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02565",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02566",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02567",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02610",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02611",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02612",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02613",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02614",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02615",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02616",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02617",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02618",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02630",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02631",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02632",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02633",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02634",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02635",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02636",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02637",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02639",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02649",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02650",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02651",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02652",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02653",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02670",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02671",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02672",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02673",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02674",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02675",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02676",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02677",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02678",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02679",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02680",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02701",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02710",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02712",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02713",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02714",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02715",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02716",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02717",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02720",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02721",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02722",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02723",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02724",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02725",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02726",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02727",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02728",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02729",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02730",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02731",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02732",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02733",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02734",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02735",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02736",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02737",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02738",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02739",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02750",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02751",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02752",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02753",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02754",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02755",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02756",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02757",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02758",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02759",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02760",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02762",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02763",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02764",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02765",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02801",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02802",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02803",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02804",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02805",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02806",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02807",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02808",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02809",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02810",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02811",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02812",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02813",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02814",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02815",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02816",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02817",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02820",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02831",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02832",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02833",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02834",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02835",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02836",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02837",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02839",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02840",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02841",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02842",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02844",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02845",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02846",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02847",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02848",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02849",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02850",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02851",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02852",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02853",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02854",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02855",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02856",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02857",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02858",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02859",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02860",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02861",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02862",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02863",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02864",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02865",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02866",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02867",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02870",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02871",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02872",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02873",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02874",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02875",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02876",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02877",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02878",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02879",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02880",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02881",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02882",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02883",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02901",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02910",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02911",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02912",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02913",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02914",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02915",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02916",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02917",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02918",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02919",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02920",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02921",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02924",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02925",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02926",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02927",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02928",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02929",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02930",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02931",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02932",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02933",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02934",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02935",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02936",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02937",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02938",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02939",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02940",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02941",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02942",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02943",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02944",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02945",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02950",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02951",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02952",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02955",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02956",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02957",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02959",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02960",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02961",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02962",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02963",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02964",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02965",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02966",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02967",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02968",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02969",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02970",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02971",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02972",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02975",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02976",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02977",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02978",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02979",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02981",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02982",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02983",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02984",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02985",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02986",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02987",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02988",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02989",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02990",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02991",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02992",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02993",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02994",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02995",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02996",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02997",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "02998",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03001",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03002",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03003",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03004",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03005",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03006",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03007",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03008",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03009",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03010",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03011",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03012",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03013",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03014",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03015",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03016",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03017",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03018",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03019",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03020",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03021",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03022",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03023",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03024",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03025",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03026",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03027",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03028",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03029",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03030",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03031",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03032",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03033",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03034",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03035",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03036",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03040",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03041",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03042",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03043",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03044",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03045",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03046",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03047",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03050",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03051",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03052",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03053",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03054",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03055",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03057",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03058",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03059",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03060",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03061",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03062",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03063",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03064",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03065",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03066",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03067",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03068",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03069",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03070",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03071",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03072",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03073",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03074",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03076",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03077",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03080",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03081",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03084",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03085",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03086",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03087",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03088",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03089",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03090",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03101",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03102",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03103",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03104",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03105",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03106",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03107",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03108",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03109",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03110",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03111",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03112",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03113",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03114",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03115",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03116",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03117",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03118",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03119",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03120",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03121",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03122",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03123",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03124",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03125",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03126",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03127",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03128",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03129",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03130",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03131",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03132",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03133",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03134",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03135",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03136",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03137",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03138",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03139",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03140",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03141",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03142",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03143",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03144",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03145",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03146",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03147",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03149",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03150",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03151",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03152",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03153",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03154",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03155",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03156",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03157",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03158",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03159",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03160",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03161",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03162",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03163",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03164",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03165",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03166",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03167",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03168",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03169",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03170",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03171",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03172",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03173",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03174",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03175",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03176",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03177",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03178",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03179",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03180",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03181",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03182",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03183",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03184",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03185",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03186",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03187",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03188",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03189",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03190",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03191",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03192",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03193",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03194",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03195",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03201",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03202",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03203",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03204",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03205",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03206",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03207",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03208",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03209",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03210",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03211",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03212",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03213",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03214",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03215",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03216",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03220",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03221",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03222",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03223",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03224",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03225",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03226",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03227",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03236",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03237",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03238",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03239",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03240",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03241",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03242",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03243",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03244",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03245",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03249",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03250",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03251",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03252",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03253",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03254",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03255",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03256",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03257",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03258",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03259",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03260",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03261",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03262",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03263",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03264",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03265",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03266",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03267",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03268",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03269",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03270",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03271",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03272",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03273",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03274",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03275",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03276",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03277",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03278",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03279",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03280",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03281",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03282",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03283",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03284",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03286",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03287",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03288",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03289",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03294",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03295",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03301",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03302",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03303",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03304",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03305",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03306",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03307",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03308",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03309",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03310",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03311",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03312",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03313",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03314",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03315",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03316",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03317",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03318",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03319",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03320",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03321",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03322",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03323",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03324",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03325",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03330",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03331",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03332",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03333",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03334",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03335",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03336",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03337",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03338",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03340",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03342",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03343",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03344",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03345",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03346",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03347",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03348",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03349",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03350",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03351",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03355",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03356",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03357",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03358",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03359",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03360",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03361",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03362",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03363",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03364",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03365",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03366",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03367",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03370",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03371",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03372",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03373",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03374",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03375",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03376",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03377",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03378",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03379",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03380",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03381",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03382",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03383",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03384",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03385",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03386",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03387",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03388",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03389",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03390",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03401",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03402",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03403",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03404",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03405",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03406",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03407",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03408",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03409",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03410",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03411",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03412",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03413",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03414",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03415",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03416",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03417",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03420",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03421",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03422",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03423",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03424",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03425",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03426",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03427",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03428",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03429",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03430",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03431",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03432",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03433",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03434",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03435",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03436",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03437",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03438",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03440",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03441",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03442",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03443",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03444",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03445",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03446",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03447",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03448",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03449",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03450",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03451",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03452",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03453",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03454",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03455",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03456",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03460",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03461",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03462",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03463",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03470",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03471",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03472",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03474",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03475",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03476",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03477",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03478",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03479",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03480",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03490",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03501",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03502",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03503",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03504",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03505",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03506",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03507",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03508",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03509",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03510",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03511",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03512",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03513",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03514",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03515",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03516",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03517",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03518",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03519",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03520",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03521",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03522",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03523",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03524",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03525",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03526",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03527",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03530",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03531",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03532",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03533",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03534",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03535",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03540",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03541",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03542",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03543",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03544",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03545",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03546",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03547",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03548",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03550",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03551",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03552",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03553",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03554",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03555",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03556",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03557",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03558",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03559",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03560",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03561",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03562",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03563",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03564",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03565",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03566",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03567",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03568",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03569",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03570",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03571",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03572",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03573",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03574",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03575",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03576",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03577",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03578",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03579",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03580",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03581",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03582",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03583",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03584",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03585",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03586",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03587",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03588",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03589",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03590",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03591",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03601",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03602",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03603",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03604",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03605",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03606",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03607",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03608",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03609",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03610",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03611",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03612",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03613",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03614",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03615",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03616",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03617",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03618",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03619",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03620",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03621",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03622",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03623",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03624",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03625",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03626",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03627",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03630",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03631",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03632",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03633",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03634",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03635",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03636",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03637",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03638",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03639",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03640",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03641",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03642",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03643",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03644",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03645",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03646",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03647",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03648",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03649",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03650",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03651",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03652",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03653",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03654",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03655",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03656",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03657",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03658",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03659",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03660",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03661",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03662",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03663",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03664",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03665",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03666",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03667",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03668",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03669",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03670",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03671",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03672",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03673",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03674",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03675",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03676",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03677",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03678",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03679",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03680",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03681",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03682",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03683",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03685",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03687",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03688",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03689",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03690",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03691",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03692",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03693",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03694",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03695",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03701",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03702",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03703",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03704",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03707",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03710",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03711",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03712",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03713",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03714",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03715",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03716",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03717",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03718",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03719",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03720",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03721",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03725",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03726",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03727",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03728",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03729",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03730",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03731",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03732",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03733",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03734",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03735",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03736",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03737",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03738",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03739",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03755",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03756",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03757",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03758",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03759",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03801",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03802",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03803",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03804",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03805",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03806",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03807",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03808",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03809",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03810",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03811",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03812",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03813",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03814",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03816",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03817",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03818",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03819",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03820",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03821",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03822",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03823",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03827",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03828",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03870",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03871",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03872",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03873",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03874",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03875",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03876",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03877",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03878",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03880",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03881",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03882",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03883",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03884",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03886",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03887",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03888",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03889",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03890",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03891",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03892",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03893",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03894",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03895",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03896",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03901",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03904",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03905",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03906",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03907",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03908",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03909",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03910",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03911",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03912",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03916",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03917",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03918",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03919",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03920",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03921",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03922",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03923",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03924",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03925",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03926",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03927",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03928",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03929",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03930",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03931",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03932",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03933",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03934",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03935",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03936",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03937",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03938",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03939",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03940",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03941",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03942",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03943",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03944",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03945",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03946",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03947",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03948",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03949",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03950",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03951",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03952",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03953",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03958",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03959",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03960",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03961",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03962",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03963",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03964",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03965",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03966",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03967",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03968",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03969",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03970",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03971",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03972",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03973",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03974",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03975",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03976",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03977",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03978",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03979",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03980",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03981",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03982",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03983",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03984",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03985",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03986",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03987",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03988",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "03989",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04001",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04002",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04003",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04004",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04005",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04006",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04007",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04008",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04009",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04010",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04011",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04012",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04013",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04014",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04015",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04016",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04017",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04018",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04019",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04020",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04021",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04022",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04023",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04024",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04025",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04026",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04027",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04028",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04029",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04030",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04031",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04032",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04035",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04036",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04037",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04038",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04039",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04040",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04041",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04042",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04043",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04044",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04045",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04046",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04047",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04048",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04049",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04050",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04051",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04052",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04053",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04054",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04055",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04057",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04058",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04059",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04060",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04061",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04062",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04063",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04064",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04065",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04066",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04067",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04068",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04069",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04070",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04071",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04072",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04074",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04075",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04076",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04077",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04078",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04079",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04080",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04081",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04082",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04083",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04084",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04085",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04086",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04087",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04088",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04089",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04090",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04094",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04101",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04102",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04103",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04104",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04105",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04106",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04107",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04108",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04109",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04110",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04111",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04112",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04113",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04114",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04115",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04116",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04117",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04118",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04119",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04120",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04121",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04122",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04123",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04124",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04125",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04126",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04127",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04128",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04129",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04130",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04131",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04132",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04133",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04134",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04135",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04136",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04137",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04138",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04139",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04140",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04141",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04142",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04143",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04144",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04145",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04146",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04147",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04148",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04149",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04150",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04151",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04152",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04153",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04154",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04155",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04156",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04157",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04158",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04159",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04160",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04161",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04162",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04163",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04164",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04165",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04166",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04167",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04168",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04169",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04170",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04171",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04173",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04174",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04176",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04177",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04180",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04181",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04182",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04183",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04184",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04185",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04186",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04187",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04190",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04191",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04193",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04194",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04195",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04201",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04202",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04203",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04204",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04205",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04206",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04207",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04208",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04209",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04210",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04211",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04212",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04213",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04214",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04215",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04216",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04217",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04218",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04220",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04221",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04222",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04223",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04224",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04225",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04226",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04229",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04230",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04231",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04232",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04233",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04235",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04236",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04240",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04241",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04242",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04243",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04244",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04246",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04247",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04248",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04249",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04250",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04251",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04252",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04253",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04254",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04255",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04256",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04257",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04258",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04260",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04261",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04262",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04263",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04264",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04265",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04266",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04267",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04268",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04269",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04270",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04271",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04272",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04273",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04274",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04275",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04276",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04277",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04278",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04279",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04280",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04281",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04282",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04283",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04284",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04285",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04286",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04287",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04288",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04289",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04290",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04291",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04292",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04293",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04294",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04295",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04296",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04297",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04298",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04301",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04302",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04303",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04304",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04305",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04306",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04307",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04308",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04309",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04310",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04311",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04312",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04313",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04314",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04315",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04316",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04317",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04318",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04319",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04320",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04321",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04323",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04324",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04325",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04326",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04327",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04328",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04329",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04330",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04331",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04332",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04333",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04334",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04335",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04336",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04337",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04338",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04339",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04340",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04342",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04343",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04344",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04345",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04346",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04347",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04348",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04349",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04350",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04351",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04355",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04356",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04357",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04358",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04359",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04360",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04361",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04362",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04363",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04364",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04365",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04366",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04367",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04368",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04369",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04370",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04371",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04372",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04373",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04374",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04375",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04376",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04377",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04378",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04379",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04381",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04382",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04383",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04384",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04385",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04386",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04387",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04401",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04402",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04403",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04404",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04405",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04406",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04407",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04408",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04409",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04410",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04411",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04412",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04413",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04414",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04415",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04416",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04417",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04419",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04421",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04423",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04424",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04425",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04426",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04427",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04428",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04429",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04430",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04431",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04432",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04433",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04434",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04436",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04437",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04438",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04439",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04444",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04445",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04446",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04447",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04455",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04456",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04457",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04458",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04459",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04460",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04461",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04462",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04463",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04464",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04466",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04467",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04468",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04469",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04470",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04472",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04473",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04474",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04475",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04476",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04477",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04501",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04502",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04503",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04504",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04505",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04506",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04507",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04508",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04509",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04510",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04511",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04512",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04513",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04514",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04515",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04516",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04517",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04518",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04520",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04521",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04522",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04523",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04524",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04530",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04531",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04532",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04533",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04534",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04535",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04536",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04537",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04538",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04542",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04543",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04544",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04545",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04546",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04547",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04548",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04549",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04550",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04551",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04552",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04553",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04555",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04556",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04557",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04558",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04559",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04560",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04561",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04562",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04563",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04564",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04565",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04566",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04567",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04568",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04569",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04570",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04571",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04575",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04576",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04578",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04580",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04581",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04582",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04583",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04601",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04602",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04603",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04604",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04605",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04606",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04607",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04608",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04609",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04610",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04611",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04612",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04613",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04614",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04615",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04616",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04617",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04618",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04619",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04620",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04621",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04622",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04623",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04624",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04625",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04626",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04627",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04630",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04631",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04632",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04633",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04634",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04635",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04636",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04637",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04638",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04639",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04640",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04641",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04642",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04643",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04644",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04645",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04646",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04647",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04648",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04649",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04650",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04651",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04652",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04653",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04654",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04655",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04657",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04658",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04660",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04661",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04662",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04663",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04664",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04671",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04672",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04673",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04674",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04675",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04676",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04677",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04678",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04679",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04685",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04686",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04688",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04689",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04690",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04691",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04692",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04693",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04696",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04701",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04702",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04703",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04704",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04705",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04707",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04708",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04709",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04710",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04711",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04713",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04714",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04715",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04716",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04717",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04718",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04719",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04720",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04721",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04722",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04723",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04724",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04725",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04726",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04727",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04728",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04729",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04730",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04733",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04734",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04735",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04736",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04737",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04738",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04739",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04740",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04741",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04742",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04743",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04744",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04745",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04746",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04747",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04748",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04750",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04751",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04752",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04753",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04754",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04755",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04756",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04757",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04760",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04761",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04762",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04763",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04764",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04765",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04766",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04767",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04768",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04770",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04771",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04772",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04773",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04774",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04775",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04776",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04777",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04781",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04782",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04783",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04784",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04785",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04786",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04787",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04788",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04789",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04792",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04794",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04795",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04801",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04802",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04803",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04805",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04806",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04807",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04809",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04810",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04811",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04812",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04813",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04814",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04815",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04816",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04820",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04821",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04822",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04823",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04824",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04826",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04827",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04828",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04829",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04830",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04831",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04832",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04833",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04835",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04836",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04837",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04840",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04841",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04842",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04843",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04844",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04845",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04846",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04847",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04848",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04849",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04850",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04851",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04852",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04853",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04854",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04855",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04856",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04857",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04858",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04859",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04860",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04861",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04862",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04863",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04864",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04865",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04866",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04867",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04870",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04872",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04873",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04874",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04875",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04877",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04880",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04881",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04882",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04883",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04884",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04886",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04888",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04889",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04890",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04891",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04892",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04893",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04894",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04895",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04896",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04897",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04898",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04902",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04904",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04905",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04906",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04909",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04910",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04911",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04912",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04913",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04914",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04915",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04916",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04917",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04918",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04920",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04921",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04922",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04923",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04925",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04926",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04928",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04929",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04930",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04931",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04932",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04933",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04935",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04937",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04938",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04939",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04940",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04941",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04942",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04943",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04944",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04945",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04946",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04947",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04948",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04949",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04950",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04951",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04952",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04953",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04956",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04960",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04961",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04962",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04963",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04965",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04966",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "04967",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05001",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05002",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05003",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05004",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05005",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05006",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05007",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05008",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05009",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05010",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05011",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05012",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05013",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05014",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05015",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05016",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05017",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05018",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05019",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05020",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05021",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05022",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05023",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05024",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05025",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05026",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05027",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05028",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05029",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05030",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05033",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05035",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05036",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05037",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05038",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05040",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05041",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05042",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05043",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05044",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05045",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05046",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05047",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05048",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05049",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05050",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05051",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05052",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05053",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05054",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05055",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05056",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05057",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05058",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05059",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05060",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05061",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05065",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05068",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05069",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05072",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05073",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05074",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05075",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05076",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05077",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05078",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05079",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05080",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05081",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05082",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05083",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05084",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05085",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05086",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05087",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05088",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05089",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05092",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05093",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05094",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05095",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05101",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05102",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05103",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05104",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05105",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05106",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05107",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05108",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05109",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05110",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05112",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05113",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05114",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05115",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05116",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05117",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05118",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05119",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05120",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05121",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05122",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05123",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05124",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05125",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05126",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05127",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05128",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05131",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05132",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05133",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05134",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05135",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05136",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05138",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05139",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05140",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05141",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05142",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05143",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05144",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05145",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05146",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05154",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05157",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05158",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05159",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05160",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05161",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05162",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05163",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05164",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05165",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05170",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05171",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05172",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05173",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05174",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05175",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05176",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05177",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05180",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05181",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05182",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05183",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05184",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05185",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05186",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05187",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05201",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05202",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05203",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05204",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05205",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05206",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05207",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05208",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05209",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05210",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05211",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05212",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05215",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05220",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05223",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05224",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05230",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05240",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05245",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05263",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05264",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05265",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05266",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05267",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05268",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05269",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05270",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05271",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05272",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05273",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05274",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05275",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05276",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05280",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05281",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05282",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05283",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05301",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05302",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05303",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05304",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05305",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05307",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05308",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05310",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05311",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05312",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05313",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05314",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05315",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05317",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05318",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05319",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05320",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05321",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05322",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05323",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05324",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05325",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05326",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05327",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05328",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05329",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05330",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05331",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05332",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05333",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05334",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05335",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05336",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05337",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05338",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05339",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05340",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05343",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05344",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05345",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05346",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05347",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05348",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05350",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05351",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05352",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05353",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05356",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05358",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05359",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05360",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05361",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05362",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05363",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05364",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05365",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05366",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05367",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05368",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05371",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05372",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05373",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05374",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05376",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05379",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05381",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05382",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05386",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05387",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05388",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05396",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05397",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05398",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05399",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05401",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05402",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05403",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05404",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05405",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05406",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05407",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05408",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05409",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05410",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05411",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05412",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05413",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05414",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05415",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05416",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05417",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05418",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05419",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05420",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05421",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05422",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05423",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05424",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05425",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05426",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05427",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05428",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05429",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05432",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05433",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05434",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05435",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05436",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05437",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05438",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05439",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05440",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05441",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05442",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05443",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05444",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05445",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05446",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05447",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05448",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05449",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05450",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05451",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05452",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05453",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05454",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05455",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05458",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05459",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05460",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05461",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05462",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05463",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05464",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05465",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05466",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05467",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05468",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05469",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05470",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05471",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05472",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05477",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05501",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05502",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05503",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05505",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05506",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05507",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05508",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05509",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05510",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05511",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05512",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05513",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05514",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05515",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05516",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05517",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05518",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05519",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05520",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05521",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05522",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05523",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05524",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05525",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05526",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05527",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05528",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05529",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05530",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05531",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05532",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05533",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05534",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05535",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05536",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05537",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05538",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05539",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05540",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05541",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05542",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05543",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05544",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05545",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05546",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05547",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05548",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05549",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05550",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05551",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05560",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05563",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05564",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05565",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05566",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05567",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05568",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05569",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05570",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05571",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05572",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05574",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05576",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05577",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05578",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05579",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05580",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05581",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05582",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05583",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05584",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05585",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05586",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05587",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05588",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05589",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05590",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05591",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05592",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05593",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05594",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05595",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05596",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05601",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05602",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05603",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05604",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05605",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05606",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05607",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05608",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05609",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05610",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05611",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05612",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05613",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05614",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05615",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05616",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05617",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05618",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05619",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05620",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05621",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05622",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05623",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05624",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05625",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05626",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05627",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05628",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05629",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05630",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05632",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05633",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05634",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05635",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05638",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05639",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05640",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05641",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05642",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05650",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05651",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05652",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05653",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05654",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05655",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05656",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05657",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05658",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05659",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05660",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05661",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05662",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05663",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05664",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05665",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05670",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05671",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05672",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05673",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05674",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05675",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05676",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05678",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05679",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05683",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05684",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05685",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05686",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05687",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05688",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05690",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05691",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05692",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05704",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05705",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05706",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05707",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05709",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05710",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05711",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05712",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05713",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05715",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05716",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05717",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05718",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05723",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05724",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05725",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05726",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05727",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05728",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05729",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05730",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05731",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05734",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05735",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05736",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05740",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05741",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05742",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05743",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05745",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05749",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05750",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05752",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05754",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05755",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05756",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05757",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05758",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05759",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05760",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05761",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05762",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05763",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05765",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05766",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05767",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05772",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05773",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05774",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05775",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05776",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05777",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05778",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05780",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05781",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05782",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05783",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05784",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05785",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05786",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05787",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05788",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05789",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05790",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05791",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05792",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05793",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05794",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05795",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05796",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05797",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05798",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05801",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05802",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05804",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05805",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05812",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05813",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05814",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05815",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05816",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05818",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05819",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05820",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05821",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05822",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05823",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05830",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05831",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05832",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05833",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05834",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05835",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05836",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05840",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05841",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05842",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05843",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05844",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05845",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05846",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05847",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05848",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05849",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05850",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05851",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05852",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05853",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05854",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05855",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05856",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05857",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05858",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05859",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05860",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05861",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05862",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05863",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05864",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05866",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05867",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05868",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05869",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05870",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05871",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05872",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05873",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05874",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05875",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05876",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05877",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05878",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05879",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05880",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05881",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05882",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05883",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05884",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05885",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05886",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05887",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05888",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05889",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05890",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05891",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05892",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05893",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "05894",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "06010",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06013",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06016",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06018",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06020",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06023",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06026",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06028",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06030",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06033",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06036",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06038",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06040",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06045",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06050",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06053",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06056",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06060",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06065",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06070",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06075",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06080",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06083",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06086",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06090",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06093",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06097",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06110",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06112",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06114",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06120",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06122",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06124",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06126",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06130",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06132",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06140",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06141",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06142",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06144",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06145",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06147",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06149",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06150",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06152",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06154",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06160",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06162",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06170",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06172",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06180",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06182",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06184",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06186",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06187",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06190",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06192",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06194",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06210",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06213",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06216",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06220",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06223",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06226",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06230",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06233",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06235",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06236",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06240",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06243",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06246",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06250",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06253",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06260",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06263",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06264",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06266",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06268",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06270",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06273",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06276",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06278",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06280",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06283",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06286",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06288",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06290",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06293",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06296",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06298",
    "uf": "SP",
    "codigoIbge": 3534401,
    "cidade": "Osasco"
  },
  {
    "prefixo": "06310",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06311",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06315",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06317",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06320",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06321",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06322",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06325",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06326",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06327",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06328",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06329",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06330",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06331",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06332",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06333",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06334",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06335",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06340",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06341",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06342",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06343",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06345",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06350",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06351",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06352",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06355",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06360",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06361",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06362",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06363",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06364",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06365",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06366",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06380",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06381",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06382",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06384",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06385",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06386",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06387",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06390",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06394",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06395",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06396",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06397",
    "uf": "SP",
    "codigoIbge": 3510609,
    "cidade": "Carapicuíba"
  },
  {
    "prefixo": "06401",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06402",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06404",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06405",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06406",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06407",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06408",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06409",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06410",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06411",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06412",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06413",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06414",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06415",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06416",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06417",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06418",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06419",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06420",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06421",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06422",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06423",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06428",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06429",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06433",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06434",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06435",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06436",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06437",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06440",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06442",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06443",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06444",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06445",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06447",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06448",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06449",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06453",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06454",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06455",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06458",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06460",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06462",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06463",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06465",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06470",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06471",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06472",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06473",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06474",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06475",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06485",
    "uf": "SP",
    "codigoIbge": 3505708,
    "cidade": "Barueri"
  },
  {
    "prefixo": "06501",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06502",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06503",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06504",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06505",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06506",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06509",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06511",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06513",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06514",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06515",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06516",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06517",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06519",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06520",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06522",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06523",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06524",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06525",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06526",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06528",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06529",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06530",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06531",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06532",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06533",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06534",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06535",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06537",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06539",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06540",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06541",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06542",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06543",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06544",
    "uf": "SP",
    "codigoIbge": 3547304,
    "cidade": "Santana de Parnaíba"
  },
  {
    "prefixo": "06550",
    "uf": "SP",
    "codigoIbge": 3539103,
    "cidade": "Pirapora do Bom Jesus"
  },
  {
    "prefixo": "06600",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06602",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06604",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06606",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06608",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06609",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06610",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06612",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06616",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06618",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06620",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06622",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06624",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06626",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06630",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06631",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06634",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06636",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06640",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06642",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06648",
    "uf": "SP",
    "codigoIbge": 3525003,
    "cidade": "Jandira"
  },
  {
    "prefixo": "06652",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06653",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06654",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06655",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06656",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06657",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06660",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06663",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06665",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06667",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06670",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06673",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06675",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06680",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06683",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06685",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06690",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06693",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06694",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06695",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06696",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06699",
    "uf": "SP",
    "codigoIbge": 3522505,
    "cidade": "Itapevi"
  },
  {
    "prefixo": "06700",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06701",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06702",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06703",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06704",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06705",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06706",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06707",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06708",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06709",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06710",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06711",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06712",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06713",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06714",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06715",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06716",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06717",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06719",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06720",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06721",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06722",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06723",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06724",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06725",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06726",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06727",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06728",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06729",
    "uf": "SP",
    "codigoIbge": 3513009,
    "cidade": "Cotia"
  },
  {
    "prefixo": "06730",
    "uf": "SP",
    "codigoIbge": 3556453,
    "cidade": "Vargem Grande Paulista"
  },
  {
    "prefixo": "06731",
    "uf": "SP",
    "codigoIbge": 3556453,
    "cidade": "Vargem Grande Paulista"
  },
  {
    "prefixo": "06732",
    "uf": "SP",
    "codigoIbge": 3556453,
    "cidade": "Vargem Grande Paulista"
  },
  {
    "prefixo": "06733",
    "uf": "SP",
    "codigoIbge": 3556453,
    "cidade": "Vargem Grande Paulista"
  },
  {
    "prefixo": "06734",
    "uf": "SP",
    "codigoIbge": 3556453,
    "cidade": "Vargem Grande Paulista"
  },
  {
    "prefixo": "06735",
    "uf": "SP",
    "codigoIbge": 3556453,
    "cidade": "Vargem Grande Paulista"
  },
  {
    "prefixo": "06736",
    "uf": "SP",
    "codigoIbge": 3556453,
    "cidade": "Vargem Grande Paulista"
  },
  {
    "prefixo": "06737",
    "uf": "SP",
    "codigoIbge": 3556453,
    "cidade": "Vargem Grande Paulista"
  },
  {
    "prefixo": "06738",
    "uf": "SP",
    "codigoIbge": 3556453,
    "cidade": "Vargem Grande Paulista"
  },
  {
    "prefixo": "06739",
    "uf": "SP",
    "codigoIbge": 3556453,
    "cidade": "Vargem Grande Paulista"
  },
  {
    "prefixo": "06740",
    "uf": "SP",
    "codigoIbge": 3556453,
    "cidade": "Vargem Grande Paulista"
  },
  {
    "prefixo": "06741",
    "uf": "SP",
    "codigoIbge": 3556453,
    "cidade": "Vargem Grande Paulista"
  },
  {
    "prefixo": "06742",
    "uf": "SP",
    "codigoIbge": 3556453,
    "cidade": "Vargem Grande Paulista"
  },
  {
    "prefixo": "06753",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06754",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06755",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06756",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06757",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06760",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06763",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06764",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06765",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06766",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06767",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06768",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06770",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06773",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06774",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06775",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06780",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06783",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06784",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06785",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06786",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06787",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06790",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06793",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06794",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06795",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06799",
    "uf": "SP",
    "codigoIbge": 3552809,
    "cidade": "Taboão da Serra"
  },
  {
    "prefixo": "06803",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06804",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06805",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06806",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06807",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06810",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06813",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06814",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06815",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06816",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06817",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06818",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06820",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06823",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06824",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06825",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06826",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06830",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06833",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06835",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06840",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06843",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06844",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06845",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06846",
    "uf": "SP",
    "codigoIbge": 3515004,
    "cidade": "Embu das Artes"
  },
  {
    "prefixo": "06850",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06851",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06852",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06853",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06854",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06855",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06856",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06857",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06858",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06859",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06860",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06861",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06863",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06864",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06865",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06866",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06867",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06868",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06869",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06870",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06871",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06872",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06873",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06874",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06875",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06876",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06877",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06880",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06881",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06882",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06885",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06886",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06887",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06888",
    "uf": "SP",
    "codigoIbge": 3522208,
    "cidade": "Itapecerica da Serra"
  },
  {
    "prefixo": "06890",
    "uf": "SP",
    "codigoIbge": 3549953,
    "cidade": "São Lourenço da Serra"
  },
  {
    "prefixo": "06900",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06901",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06902",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06903",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06904",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06905",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06906",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06907",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06908",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06909",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06910",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06911",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06912",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06913",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06914",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06915",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06916",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06917",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06918",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06919",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06920",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06921",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06922",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06923",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06924",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06925",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06926",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06927",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06928",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06929",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06930",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06931",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06932",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06933",
    "uf": "SP",
    "codigoIbge": 3515103,
    "cidade": "Embu-Guaçu"
  },
  {
    "prefixo": "06950",
    "uf": "SP",
    "codigoIbge": 3526209,
    "cidade": "Juquitiba"
  },
  {
    "prefixo": "06951",
    "uf": "SP",
    "codigoIbge": 3526209,
    "cidade": "Juquitiba"
  },
  {
    "prefixo": "07010",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07011",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07012",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07013",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07020",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07021",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07022",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07023",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07024",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07025",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07030",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07031",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07032",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07033",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07034",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07040",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07041",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07042",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07043",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07044",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07050",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07051",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07052",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07053",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07054",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07055",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07056",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07060",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07061",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07062",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07063",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07064",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07070",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07071",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07072",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07073",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07074",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07075",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07076",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07077",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07080",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07081",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07082",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07083",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07084",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07085",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07087",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07090",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07091",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07092",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07093",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07094",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07095",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07096",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07097",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07110",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07111",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07112",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07113",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07114",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07115",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07120",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07121",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07122",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07123",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07124",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07125",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07130",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07131",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07132",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07133",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07134",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07135",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07140",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07141",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07142",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07143",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07144",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07145",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07150",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07151",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07152",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07153",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07154",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07155",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07156",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07158",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07159",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07160",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07161",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07162",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07170",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07171",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07172",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07173",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07174",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07175",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07176",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07177",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07178",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07179",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07180",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07181",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07182",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07183",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07184",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07190",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07191",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07192",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07193",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07194",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07195",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07196",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07197",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07210",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07215",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07220",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07221",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07222",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07223",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07224",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07230",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07231",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07232",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07240",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07241",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07242",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07243",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07244",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07250",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07251",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07252",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07260",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07261",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07262",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07263",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07269",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07270",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07271",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07272",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07273",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07274",
    "uf": "SP",
    "codigoIbge": 3518800,
    "cidade": "Guarulhos"
  },
  {
    "prefixo": "07400",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07401",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07402",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07403",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07404",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07405",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07406",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07407",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07411",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07412",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07413",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07414",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07415",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07417",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07418",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07420",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07421",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07424",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07428",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07429",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07430",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07431",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07432",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07434",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07435",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07436",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07437",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07438",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07439",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07440",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07442",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07443",
    "uf": "SP",
    "codigoIbge": 3503901,
    "cidade": "Arujá"
  },
  {
    "prefixo": "07500",
    "uf": "SP",
    "codigoIbge": 3546801,
    "cidade": "Santa Isabel"
  },
  {
    "prefixo": "07600",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07601",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07602",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07604",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07605",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07606",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07607",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07608",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07609",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07610",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07611",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07612",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07613",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07615",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07617",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07618",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07619",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07620",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07621",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07622",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07623",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07625",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07626",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07627",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07628",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07629",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07631",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07632",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07634",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07635",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07636",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07637",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07638",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07642",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07645",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07648",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07649",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07652",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07654",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07655",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07656",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07657",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07658",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07659",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07660",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07661",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07662",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07663",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07664",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07665",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07666",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07667",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07668",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07669",
    "uf": "SP",
    "codigoIbge": 3528502,
    "cidade": "Mairiporã"
  },
  {
    "prefixo": "07700",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07703",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07704",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07705",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07713",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07714",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07715",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07716",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07717",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07718",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07721",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07722",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07723",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07724",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07725",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07726",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07727",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07729",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07730",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07731",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07733",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07734",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07739",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07740",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07741",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07742",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07743",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07744",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07745",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07747",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07748",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07749",
    "uf": "SP",
    "codigoIbge": 3509007,
    "cidade": "Caieiras"
  },
  {
    "prefixo": "07750",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07752",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07754",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07755",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07756",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07757",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07762",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07764",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07765",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07766",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07767",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07768",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07769",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07775",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07776",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07778",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07779",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07781",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07782",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07784",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07785",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07786",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07787",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07788",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07789",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07790",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07791",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07792",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07793",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07794",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07799",
    "uf": "SP",
    "codigoIbge": 3509205,
    "cidade": "Cajamar"
  },
  {
    "prefixo": "07801",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07802",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07803",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07804",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07807",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07808",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07809",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07810",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07811",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07812",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07813",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07830",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07832",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07834",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07835",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07836",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07840",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07841",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07842",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07844",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07845",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07846",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07847",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07849",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07850",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07851",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07852",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07853",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07854",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07855",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07856",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07857",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07858",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07859",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07860",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07861",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07862",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07863",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07864",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07865",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07866",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07867",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07868",
    "uf": "SP",
    "codigoIbge": 3516408,
    "cidade": "Franco da Rocha"
  },
  {
    "prefixo": "07901",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07902",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07903",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07904",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07905",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07906",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07907",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07908",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07909",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07910",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07911",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07912",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07913",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07914",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07915",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07916",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07917",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07918",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07919",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07920",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07921",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07929",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07930",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07932",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07934",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07935",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07936",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07940",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07941",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07942",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07943",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07944",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07945",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07946",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07950",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07951",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07952",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07953",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07955",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07956",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07957",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07980",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07983",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07985",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07986",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07987",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07988",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07989",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07990",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07991",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07992",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07994",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07995",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07996",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07997",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "07998",
    "uf": "SP",
    "codigoIbge": 3516309,
    "cidade": "Francisco Morato"
  },
  {
    "prefixo": "08010",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08011",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08020",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08021",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08022",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08030",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08031",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08032",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08040",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08041",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08042",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08050",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08051",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08060",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08061",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08062",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08070",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08071",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08072",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08080",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08081",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08090",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08110",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08111",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08115",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08120",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08121",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08122",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08130",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08131",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08132",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08140",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08141",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08142",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08143",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08150",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08151",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08152",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08160",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08161",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08180",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08190",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08191",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08210",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08215",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08220",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08223",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08225",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08226",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08230",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08235",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08240",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08241",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08245",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08246",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08247",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08248",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08250",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08253",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08255",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08257",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08260",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08265",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08270",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08275",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08280",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08285",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08290",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08295",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08310",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08311",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08320",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08321",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08330",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08331",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08340",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08341",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08342",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08343",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08344",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08345",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08346",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08347",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08370",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08371",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08372",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08373",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08375",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08380",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08381",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08382",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08383",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08390",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08391",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08395",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08410",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08411",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08412",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08420",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08421",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08430",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08431",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08440",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08441",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08450",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08451",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08452",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08460",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08461",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08465",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08466",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08470",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08471",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08472",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08473",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08474",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08475",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08476",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08485",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08490",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08491",
    "uf": "SP",
    "codigoIbge": 3550308,
    "cidade": "São Paulo"
  },
  {
    "prefixo": "08500",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08501",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08502",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08503",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08504",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08505",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08506",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08507",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08508",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08509",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08510",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08511",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08512",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08513",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08514",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08515",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08516",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08517",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08525",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08526",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08527",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08528",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08529",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08530",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08531",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08532",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08533",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08534",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08535",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08536",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08537",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08538",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08539",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08540",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08541",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08542",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08543",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08544",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08545",
    "uf": "SP",
    "codigoIbge": 3515707,
    "cidade": "Ferraz de Vasconcelos"
  },
  {
    "prefixo": "08550",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08551",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08552",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08553",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08554",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08555",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08556",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08557",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08558",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08559",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08560",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08561",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08562",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08563",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08564",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08565",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08566",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08567",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08568",
    "uf": "SP",
    "codigoIbge": 3539806,
    "cidade": "Poá"
  },
  {
    "prefixo": "08570",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08571",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08572",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08573",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08574",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08575",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08576",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08577",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08578",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08579",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08580",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08581",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08582",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08583",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08584",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08585",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08586",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08587",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08588",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08589",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08590",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08591",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08592",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08593",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08594",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08595",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08596",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08597",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08598",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08599",
    "uf": "SP",
    "codigoIbge": 3523107,
    "cidade": "Itaquaquecetuba"
  },
  {
    "prefixo": "08610",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08613",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08615",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08616",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08620",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08621",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08625",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08630",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08633",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08634",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08635",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08640",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08645",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08650",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08653",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08655",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08656",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08660",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08663",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08664",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08665",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08666",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08670",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08671",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08673",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08674",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08675",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08676",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08680",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08683",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08685",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08686",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08690",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08692",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08693",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08694",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08695",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08696",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08699",
    "uf": "SP",
    "codigoIbge": 3552502,
    "cidade": "Suzano"
  },
  {
    "prefixo": "08700",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08710",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08715",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08717",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08720",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08725",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08726",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08727",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08730",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08735",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08737",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08738",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08740",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08742",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08743",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08744",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08745",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08746",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08747",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08750",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08751",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08752",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08753",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08755",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08760",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08761",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08762",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08763",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08765",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08766",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08767",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08769",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08770",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08771",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08772",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08773",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08774",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08775",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08777",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08779",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08780",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08790",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08793",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08795",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08810",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08820",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08830",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08831",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08832",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08833",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08840",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08850",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08880",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08889",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08890",
    "uf": "SP",
    "codigoIbge": 3530607,
    "cidade": "Mogi das Cruzes"
  },
  {
    "prefixo": "08900",
    "uf": "SP",
    "codigoIbge": 3518305,
    "cidade": "Guararema"
  },
  {
    "prefixo": "08940",
    "uf": "SP",
    "codigoIbge": 3506607,
    "cidade": "Biritiba Mirim"
  },
  {
    "prefixo": "08970",
    "uf": "SP",
    "codigoIbge": 3545001,
    "cidade": "Salesópolis"
  },
  {
    "prefixo": "08980",
    "uf": "SP",
    "codigoIbge": 3545001,
    "cidade": "Salesópolis"
  },
  {
    "prefixo": "09010",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09015",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09020",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09030",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09040",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09041",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09050",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09051",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09060",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09061",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09070",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09071",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09080",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09090",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09091",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09110",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09111",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09112",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09120",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09121",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09122",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09123",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09130",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09131",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09132",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09133",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09134",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09135",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09139",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09150",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09151",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09152",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09153",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09154",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09160",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09161",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09162",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09163",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09164",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09169",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09170",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09171",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09172",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09175",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09176",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09180",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09181",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09182",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09183",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09185",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09190",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09195",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09210",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09220",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09230",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09240",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09241",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09250",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09251",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09260",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09270",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09271",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09272",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09273",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09274",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09280",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09290",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09291",
    "uf": "SP",
    "codigoIbge": 3547809,
    "cidade": "Santo André"
  },
  {
    "prefixo": "09310",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09311",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09312",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09320",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09321",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09322",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09330",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09331",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09332",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09333",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09334",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09335",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09336",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09340",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09341",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09350",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09351",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09360",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09361",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09370",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09371",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09372",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09380",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09381",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09390",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09391",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09392",
    "uf": "SP",
    "codigoIbge": 3529401,
    "cidade": "Mauá"
  },
  {
    "prefixo": "09400",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09401",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09402",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09403",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09404",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09405",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09406",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09407",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09410",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09411",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09412",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09413",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09414",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09415",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09416",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09420",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09421",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09422",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09423",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09424",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09425",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09426",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09430",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09431",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09432",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09433",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09434",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09435",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09436",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09440",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09441",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09442",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09443",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09444",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09445",
    "uf": "SP",
    "codigoIbge": 3543303,
    "cidade": "Ribeirão Pires"
  },
  {
    "prefixo": "09450",
    "uf": "SP",
    "codigoIbge": 3544103,
    "cidade": "Rio Grande da Serra"
  },
  {
    "prefixo": "09510",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09520",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09521",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09530",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09531",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09540",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09541",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09550",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09551",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09560",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09561",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09570",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09571",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09572",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09580",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09581",
    "uf": "SP",
    "codigoIbge": 3548807,
    "cidade": "São Caetano do Sul"
  },
  {
    "prefixo": "09600",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09601",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09604",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09605",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09606",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09607",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09608",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09609",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09610",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09611",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09612",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09613",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09614",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09615",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09616",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09617",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09618",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09619",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09620",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09621",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09623",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09624",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09625",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09626",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09627",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09628",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09629",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09631",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09632",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09633",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09634",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09635",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09636",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09637",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09638",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09640",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09641",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09642",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09643",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09651",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09655",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09657",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09660",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09661",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09662",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09663",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09664",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09665",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09666",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09667",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09668",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09669",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09670",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09671",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09672",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09682",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09683",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09684",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09685",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09686",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09687",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09688",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09689",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09690",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09691",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09692",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09693",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09694",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09695",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09696",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09710",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09715",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09720",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09721",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09723",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09725",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09726",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09732",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09733",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09750",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09751",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09760",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09761",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09762",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09764",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09765",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09770",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09771",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09772",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09780",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09781",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09782",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09783",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09784",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09785",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09790",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09791",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09792",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09810",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09811",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09812",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09820",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09821",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09822",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09823",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09830",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09831",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09832",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09834",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09835",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09836",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09837",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09838",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09840",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09841",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09842",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09843",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09844",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09845",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09846",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09847",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09850",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09851",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09852",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09853",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09854",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09855",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09856",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09857",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09860",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09861",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09862",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09890",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09891",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09892",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09893",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09894",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09895",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09896",
    "uf": "SP",
    "codigoIbge": 3548708,
    "cidade": "São Bernardo do Campo"
  },
  {
    "prefixo": "09910",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09911",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09912",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09913",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09914",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09920",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09921",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09925",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09930",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09931",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09932",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09935",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09940",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09941",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09942",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09943",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09950",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09951",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09952",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09960",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09961",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09962",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09963",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09970",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09971",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09972",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09973",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09974",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09980",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09981",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09990",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09991",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09992",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "09993",
    "uf": "SP",
    "codigoIbge": 3513801,
    "cidade": "Diadema"
  },
  {
    "prefixo": "11010",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11013",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11015",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11020",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11025",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11030",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11035",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11040",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11045",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11050",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11055",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11060",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11065",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11070",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11075",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11080",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11081",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11082",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11085",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11086",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11087",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11088",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11089",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11090",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11095",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11096",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11200",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11210",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11220",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11230",
    "uf": "SP",
    "codigoIbge": 3548500,
    "cidade": "Santos"
  },
  {
    "prefixo": "11250",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11251",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11252",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11253",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11254",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11256",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11258",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11259",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11260",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11261",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11262",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11263",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11265",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11267",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11268",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11269",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11270",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11271",
    "uf": "SP",
    "codigoIbge": 3506359,
    "cidade": "Bertioga"
  },
  {
    "prefixo": "11310",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11320",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11321",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11325",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11330",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11335",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11340",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11345",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11346",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11347",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11348",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11349",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11350",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11355",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11360",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11365",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11370",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11380",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11390",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11399",
    "uf": "SP",
    "codigoIbge": 3551009,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "11410",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11420",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11421",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11425",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11430",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11431",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11432",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11434",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11435",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11436",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11437",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11440",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11441",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11442",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11443",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11444",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11445",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11446",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11447",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11449",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11450",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11451",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11453",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11454",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11460",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11461",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11462",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11463",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11470",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11471",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11472",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11473",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11495",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11497",
    "uf": "SP",
    "codigoIbge": 3518701,
    "cidade": "Guarujá"
  },
  {
    "prefixo": "11500",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11505",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11510",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11515",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11520",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11523",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11525",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11530",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11531",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11533",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11534",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11535",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11538",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11539",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11540",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11542",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11543",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11545",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11546",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11547",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11548",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11550",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11553",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11555",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11570",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11573",
    "uf": "SP",
    "codigoIbge": 3513504,
    "cidade": "Cubatão"
  },
  {
    "prefixo": "11600",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11601",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11602",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11603",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11604",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11605",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11606",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11608",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11609",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11610",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11611",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11612",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11614",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11615",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11616",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11617",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11618",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11619",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11621",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11622",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11623",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11624",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11625",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11626",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11628",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11629",
    "uf": "SP",
    "codigoIbge": 3550704,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "11630",
    "uf": "SP",
    "codigoIbge": 3520400,
    "cidade": "Ilhabela"
  },
  {
    "prefixo": "11631",
    "uf": "SP",
    "codigoIbge": 3520400,
    "cidade": "Ilhabela"
  },
  {
    "prefixo": "11633",
    "uf": "SP",
    "codigoIbge": 3520400,
    "cidade": "Ilhabela"
  },
  {
    "prefixo": "11634",
    "uf": "SP",
    "codigoIbge": 3520400,
    "cidade": "Ilhabela"
  },
  {
    "prefixo": "11635",
    "uf": "SP",
    "codigoIbge": 3520400,
    "cidade": "Ilhabela"
  },
  {
    "prefixo": "11640",
    "uf": "SP",
    "codigoIbge": 3520400,
    "cidade": "Ilhabela"
  },
  {
    "prefixo": "11641",
    "uf": "SP",
    "codigoIbge": 3520400,
    "cidade": "Ilhabela"
  },
  {
    "prefixo": "11660",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11661",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11662",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11663",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11664",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11665",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11666",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11667",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11668",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11669",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11670",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11671",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11672",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11673",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11674",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11675",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11676",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11677",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11678",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11679",
    "uf": "SP",
    "codigoIbge": 3510500,
    "cidade": "Caraguatatuba"
  },
  {
    "prefixo": "11680",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11681",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11682",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11683",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11684",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11685",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11686",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11687",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11688",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11689",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11690",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11691",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11692",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11693",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11694",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11695",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11696",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11697",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11698",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11699",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "11700",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11701",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11702",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11703",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11704",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11705",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11706",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11707",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11708",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11709",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11710",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11711",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11712",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11713",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11714",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11715",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11716",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11717",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11718",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11719",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11720",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11721",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11722",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11723",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11724",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11725",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11726",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11729",
    "uf": "SP",
    "codigoIbge": 3541000,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "11730",
    "uf": "SP",
    "codigoIbge": 3531100,
    "cidade": "Mongaguá"
  },
  {
    "prefixo": "11740",
    "uf": "SP",
    "codigoIbge": 3522109,
    "cidade": "Itanhaém"
  },
  {
    "prefixo": "11754",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11760",
    "uf": "SP",
    "codigoIbge": 3523305,
    "cidade": "Itariri"
  },
  {
    "prefixo": "11770",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11771",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11772",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11773",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11774",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11775",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11776",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11777",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11778",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11781",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11782",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11783",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11784",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11785",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11786",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11789",
    "uf": "SP",
    "codigoIbge": 3537602,
    "cidade": "Peruíbe"
  },
  {
    "prefixo": "11790",
    "uf": "SP",
    "codigoIbge": 3537206,
    "cidade": "Pedro de Toledo"
  },
  {
    "prefixo": "11800",
    "uf": "SP",
    "codigoIbge": 3526100,
    "cidade": "Juquiá"
  },
  {
    "prefixo": "11850",
    "uf": "SP",
    "codigoIbge": 3529906,
    "cidade": "Miracatu"
  },
  {
    "prefixo": "11855",
    "uf": "SP",
    "codigoIbge": 3529906,
    "cidade": "Miracatu"
  },
  {
    "prefixo": "11860",
    "uf": "SP",
    "codigoIbge": 3529906,
    "cidade": "Miracatu"
  },
  {
    "prefixo": "11870",
    "uf": "SP",
    "codigoIbge": 3529906,
    "cidade": "Miracatu"
  },
  {
    "prefixo": "11900",
    "uf": "SP",
    "codigoIbge": 3542602,
    "cidade": "Registro"
  },
  {
    "prefixo": "11910",
    "uf": "SP",
    "codigoIbge": 3551801,
    "cidade": "Sete Barras"
  },
  {
    "prefixo": "11920",
    "uf": "SP",
    "codigoIbge": 3520301,
    "cidade": "Iguape"
  },
  {
    "prefixo": "11925",
    "uf": "SP",
    "codigoIbge": 3520426,
    "cidade": "Ilha Comprida"
  },
  {
    "prefixo": "11930",
    "uf": "SP",
    "codigoIbge": 3536208,
    "cidade": "Pariquera-Açu"
  },
  {
    "prefixo": "11940",
    "uf": "SP",
    "codigoIbge": 3524600,
    "cidade": "Jacupiranga"
  },
  {
    "prefixo": "11950",
    "uf": "SP",
    "codigoIbge": 3509254,
    "cidade": "Cajati"
  },
  {
    "prefixo": "11955",
    "uf": "SP",
    "codigoIbge": 3505401,
    "cidade": "Barra do Turvo"
  },
  {
    "prefixo": "11960",
    "uf": "SP",
    "codigoIbge": 3514809,
    "cidade": "Eldorado"
  },
  {
    "prefixo": "11980",
    "uf": "SP",
    "codigoIbge": 3514809,
    "cidade": "Eldorado"
  },
  {
    "prefixo": "11990",
    "uf": "SP",
    "codigoIbge": 3509908,
    "cidade": "Cananéia"
  },
  {
    "prefixo": "11995",
    "uf": "SP",
    "codigoIbge": 3509908,
    "cidade": "Cananéia"
  },
  {
    "prefixo": "12010",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12020",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12030",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12031",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12032",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12040",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12041",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12042",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12043",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12044",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12045",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12050",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12051",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12052",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12053",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12054",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12060",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12061",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12062",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12070",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12071",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12072",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12080",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12081",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12082",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12085",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12086",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12090",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12091",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12092",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12093",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12095",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12096",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12097",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12098",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12099",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12119",
    "uf": "SP",
    "codigoIbge": 3554102,
    "cidade": "Taubaté"
  },
  {
    "prefixo": "12120",
    "uf": "SP",
    "codigoIbge": 3554805,
    "cidade": "Tremembé"
  },
  {
    "prefixo": "12121",
    "uf": "SP",
    "codigoIbge": 3554805,
    "cidade": "Tremembé"
  },
  {
    "prefixo": "12122",
    "uf": "SP",
    "codigoIbge": 3554805,
    "cidade": "Tremembé"
  },
  {
    "prefixo": "12125",
    "uf": "SP",
    "codigoIbge": 3554805,
    "cidade": "Tremembé"
  },
  {
    "prefixo": "12127",
    "uf": "SP",
    "codigoIbge": 3554805,
    "cidade": "Tremembé"
  },
  {
    "prefixo": "12128",
    "uf": "SP",
    "codigoIbge": 3554805,
    "cidade": "Tremembé"
  },
  {
    "prefixo": "12129",
    "uf": "SP",
    "codigoIbge": 3554805,
    "cidade": "Tremembé"
  },
  {
    "prefixo": "12130",
    "uf": "SP",
    "codigoIbge": 3526308,
    "cidade": "Lagoinha"
  },
  {
    "prefixo": "12132",
    "uf": "SP",
    "codigoIbge": 3526308,
    "cidade": "Lagoinha"
  },
  {
    "prefixo": "12140",
    "uf": "SP",
    "codigoIbge": 3550001,
    "cidade": "São Luiz do Paraitinga"
  },
  {
    "prefixo": "12150",
    "uf": "SP",
    "codigoIbge": 3550001,
    "cidade": "São Luiz do Paraitinga"
  },
  {
    "prefixo": "12170",
    "uf": "SP",
    "codigoIbge": 3542305,
    "cidade": "Redenção da Serra"
  },
  {
    "prefixo": "12180",
    "uf": "SP",
    "codigoIbge": 3532306,
    "cidade": "Natividade da Serra"
  },
  {
    "prefixo": "12190",
    "uf": "SP",
    "codigoIbge": 3532306,
    "cidade": "Natividade da Serra"
  },
  {
    "prefixo": "12209",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12210",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12211",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12212",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12213",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12214",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12215",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12216",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12220",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12221",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12223",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12224",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12225",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12226",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12227",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12228",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12229",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12230",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12231",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12232",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12233",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12234",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12235",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12236",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12237",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12238",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12239",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12240",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12241",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12242",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12243",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12244",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12245",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12246",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12247",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12248",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12249",
    "uf": "SP",
    "codigoIbge": 3549904,
    "cidade": "São José dos Campos"
  },
  {
    "prefixo": "12250",
    "uf": "SP",
    "codigoIbge": 3531704,
    "cidade": "Monteiro Lobato"
  },
  {
    "prefixo": "12260",
    "uf": "SP",
    "codigoIbge": 3535606,
    "cidade": "Paraibuna"
  },
  {
    "prefixo": "12270",
    "uf": "SP",
    "codigoIbge": 3524907,
    "cidade": "Jambeiro"
  },
  {
    "prefixo": "12280",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12281",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12282",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12283",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12284",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12285",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12286",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12287",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12288",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12289",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12290",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12291",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12294",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12295",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12296",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12297",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12299",
    "uf": "SP",
    "codigoIbge": 3508504,
    "cidade": "Caçapava"
  },
  {
    "prefixo": "12301",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12302",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12305",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12306",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12307",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12308",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12309",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12310",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12311",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12312",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12315",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12316",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12318",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12319",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12320",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12321",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12322",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12323",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12324",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12325",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12326",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12327",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12328",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12329",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12330",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12331",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12332",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12333",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12334",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12335",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12340",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12341",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12349",
    "uf": "SP",
    "codigoIbge": 3524402,
    "cidade": "Jacareí"
  },
  {
    "prefixo": "12350",
    "uf": "SP",
    "codigoIbge": 3520202,
    "cidade": "Igaratá"
  },
  {
    "prefixo": "12380",
    "uf": "SP",
    "codigoIbge": 3546009,
    "cidade": "Santa Branca"
  },
  {
    "prefixo": "12400",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12401",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12402",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12403",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12404",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12405",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12410",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12411",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12412",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12413",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12414",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12415",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12420",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12421",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12422",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12423",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12424",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12425",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12426",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12440",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12441",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12442",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12443",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12444",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12445",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12446",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12449",
    "uf": "SP",
    "codigoIbge": 3538006,
    "cidade": "Pindamonhangaba"
  },
  {
    "prefixo": "12450",
    "uf": "SP",
    "codigoIbge": 3548203,
    "cidade": "Santo Antônio do Pinhal"
  },
  {
    "prefixo": "12460",
    "uf": "SP",
    "codigoIbge": 3509700,
    "cidade": "Campos do Jordão"
  },
  {
    "prefixo": "12462",
    "uf": "SP",
    "codigoIbge": 3509700,
    "cidade": "Campos do Jordão"
  },
  {
    "prefixo": "12465",
    "uf": "SP",
    "codigoIbge": 3509700,
    "cidade": "Campos do Jordão"
  },
  {
    "prefixo": "12466",
    "uf": "SP",
    "codigoIbge": 3509700,
    "cidade": "Campos do Jordão"
  },
  {
    "prefixo": "12467",
    "uf": "SP",
    "codigoIbge": 3509700,
    "cidade": "Campos do Jordão"
  },
  {
    "prefixo": "12470",
    "uf": "SP",
    "codigoIbge": 3509700,
    "cidade": "Campos do Jordão"
  },
  {
    "prefixo": "12471",
    "uf": "SP",
    "codigoIbge": 3509700,
    "cidade": "Campos do Jordão"
  },
  {
    "prefixo": "12472",
    "uf": "SP",
    "codigoIbge": 3509700,
    "cidade": "Campos do Jordão"
  },
  {
    "prefixo": "12475",
    "uf": "SP",
    "codigoIbge": 3509700,
    "cidade": "Campos do Jordão"
  },
  {
    "prefixo": "12477",
    "uf": "SP",
    "codigoIbge": 3509700,
    "cidade": "Campos do Jordão"
  },
  {
    "prefixo": "12490",
    "uf": "SP",
    "codigoIbge": 3548609,
    "cidade": "São Bento do Sapucaí"
  },
  {
    "prefixo": "12500",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12501",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12502",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12503",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12504",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12505",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12506",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12507",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12508",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12509",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12510",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12511",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12512",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12513",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12514",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12515",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12516",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12517",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12518",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12519",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12520",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12521",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12522",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12523",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12524",
    "uf": "SP",
    "codigoIbge": 3518404,
    "cidade": "Guaratinguetá"
  },
  {
    "prefixo": "12525",
    "uf": "SP",
    "codigoIbge": 3540754,
    "cidade": "Potim"
  },
  {
    "prefixo": "12526",
    "uf": "SP",
    "codigoIbge": 3540754,
    "cidade": "Potim"
  },
  {
    "prefixo": "12529",
    "uf": "SP",
    "codigoIbge": 3540606,
    "cidade": "Porto Feliz"
  },
  {
    "prefixo": "12530",
    "uf": "SP",
    "codigoIbge": 3513603,
    "cidade": "Cunha"
  },
  {
    "prefixo": "12540",
    "uf": "SP",
    "codigoIbge": 3513603,
    "cidade": "Cunha"
  },
  {
    "prefixo": "12570",
    "uf": "SP",
    "codigoIbge": 3502507,
    "cidade": "Aparecida"
  },
  {
    "prefixo": "12573",
    "uf": "SP",
    "codigoIbge": 3502507,
    "cidade": "Aparecida"
  },
  {
    "prefixo": "12575",
    "uf": "SP",
    "codigoIbge": 3502507,
    "cidade": "Aparecida"
  },
  {
    "prefixo": "12576",
    "uf": "SP",
    "codigoIbge": 3502507,
    "cidade": "Aparecida"
  },
  {
    "prefixo": "12579",
    "uf": "SP",
    "codigoIbge": 3502507,
    "cidade": "Aparecida"
  },
  {
    "prefixo": "12580",
    "uf": "SP",
    "codigoIbge": 3544301,
    "cidade": "Roseira"
  },
  {
    "prefixo": "12582",
    "uf": "SP",
    "codigoIbge": 3544301,
    "cidade": "Roseira"
  },
  {
    "prefixo": "12589",
    "uf": "SP",
    "codigoIbge": 3544301,
    "cidade": "Roseira"
  },
  {
    "prefixo": "12600",
    "uf": "SP",
    "codigoIbge": 3527207,
    "cidade": "Lorena"
  },
  {
    "prefixo": "12601",
    "uf": "SP",
    "codigoIbge": 3527207,
    "cidade": "Lorena"
  },
  {
    "prefixo": "12602",
    "uf": "SP",
    "codigoIbge": 3527207,
    "cidade": "Lorena"
  },
  {
    "prefixo": "12603",
    "uf": "SP",
    "codigoIbge": 3527207,
    "cidade": "Lorena"
  },
  {
    "prefixo": "12604",
    "uf": "SP",
    "codigoIbge": 3527207,
    "cidade": "Lorena"
  },
  {
    "prefixo": "12605",
    "uf": "SP",
    "codigoIbge": 3527207,
    "cidade": "Lorena"
  },
  {
    "prefixo": "12606",
    "uf": "SP",
    "codigoIbge": 3527207,
    "cidade": "Lorena"
  },
  {
    "prefixo": "12607",
    "uf": "SP",
    "codigoIbge": 3527207,
    "cidade": "Lorena"
  },
  {
    "prefixo": "12608",
    "uf": "SP",
    "codigoIbge": 3527207,
    "cidade": "Lorena"
  },
  {
    "prefixo": "12609",
    "uf": "SP",
    "codigoIbge": 3527207,
    "cidade": "Lorena"
  },
  {
    "prefixo": "12610",
    "uf": "SP",
    "codigoIbge": 3527207,
    "cidade": "Lorena"
  },
  {
    "prefixo": "12611",
    "uf": "SP",
    "codigoIbge": 3527207,
    "cidade": "Lorena"
  },
  {
    "prefixo": "12612",
    "uf": "SP",
    "codigoIbge": 3527207,
    "cidade": "Lorena"
  },
  {
    "prefixo": "12614",
    "uf": "SP",
    "codigoIbge": 3527207,
    "cidade": "Lorena"
  },
  {
    "prefixo": "12615",
    "uf": "SP",
    "codigoIbge": 3509957,
    "cidade": "Canas"
  },
  {
    "prefixo": "12620",
    "uf": "SP",
    "codigoIbge": 3538501,
    "cidade": "Piquete"
  },
  {
    "prefixo": "12630",
    "uf": "SP",
    "codigoIbge": 3508603,
    "cidade": "Cachoeira Paulista"
  },
  {
    "prefixo": "12690",
    "uf": "SP",
    "codigoIbge": 3552007,
    "cidade": "Silveiras"
  },
  {
    "prefixo": "12701",
    "uf": "SP",
    "codigoIbge": 3513405,
    "cidade": "Cruzeiro"
  },
  {
    "prefixo": "12702",
    "uf": "SP",
    "codigoIbge": 3513405,
    "cidade": "Cruzeiro"
  },
  {
    "prefixo": "12703",
    "uf": "SP",
    "codigoIbge": 3513405,
    "cidade": "Cruzeiro"
  },
  {
    "prefixo": "12704",
    "uf": "SP",
    "codigoIbge": 3513405,
    "cidade": "Cruzeiro"
  },
  {
    "prefixo": "12705",
    "uf": "SP",
    "codigoIbge": 3513405,
    "cidade": "Cruzeiro"
  },
  {
    "prefixo": "12710",
    "uf": "SP",
    "codigoIbge": 3513405,
    "cidade": "Cruzeiro"
  },
  {
    "prefixo": "12711",
    "uf": "SP",
    "codigoIbge": 3513405,
    "cidade": "Cruzeiro"
  },
  {
    "prefixo": "12712",
    "uf": "SP",
    "codigoIbge": 3513405,
    "cidade": "Cruzeiro"
  },
  {
    "prefixo": "12720",
    "uf": "SP",
    "codigoIbge": 3513405,
    "cidade": "Cruzeiro"
  },
  {
    "prefixo": "12721",
    "uf": "SP",
    "codigoIbge": 3513405,
    "cidade": "Cruzeiro"
  },
  {
    "prefixo": "12722",
    "uf": "SP",
    "codigoIbge": 3513405,
    "cidade": "Cruzeiro"
  },
  {
    "prefixo": "12723",
    "uf": "SP",
    "codigoIbge": 3513405,
    "cidade": "Cruzeiro"
  },
  {
    "prefixo": "12730",
    "uf": "SP",
    "codigoIbge": 3513405,
    "cidade": "Cruzeiro"
  },
  {
    "prefixo": "12759",
    "uf": "SP",
    "codigoIbge": 3513405,
    "cidade": "Cruzeiro"
  },
  {
    "prefixo": "12760",
    "uf": "SP",
    "codigoIbge": 3526605,
    "cidade": "Lavrinhas"
  },
  {
    "prefixo": "12800",
    "uf": "SP",
    "codigoIbge": 3541901,
    "cidade": "Queluz"
  },
  {
    "prefixo": "12820",
    "uf": "SP",
    "codigoIbge": 3503505,
    "cidade": "Areias"
  },
  {
    "prefixo": "12830",
    "uf": "SP",
    "codigoIbge": 3549607,
    "cidade": "São José do Barreiro"
  },
  {
    "prefixo": "12850",
    "uf": "SP",
    "codigoIbge": 3504909,
    "cidade": "Bananal"
  },
  {
    "prefixo": "12870",
    "uf": "SP",
    "codigoIbge": 3503158,
    "cidade": "Arapeí"
  },
  {
    "prefixo": "12900",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12902",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12903",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12904",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12906",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12908",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12910",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12912",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12913",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12914",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12915",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12916",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12917",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12918",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12919",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12921",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12922",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12923",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12924",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12926",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12927",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12928",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12929",
    "uf": "SP",
    "codigoIbge": 3507605,
    "cidade": "Bragança Paulista"
  },
  {
    "prefixo": "12930",
    "uf": "SP",
    "codigoIbge": 3554953,
    "cidade": "Tuiuti"
  },
  {
    "prefixo": "12935",
    "uf": "SP",
    "codigoIbge": 3556354,
    "cidade": "Vargem"
  },
  {
    "prefixo": "12940",
    "uf": "SP",
    "codigoIbge": 3504107,
    "cidade": "Atibaia"
  },
  {
    "prefixo": "12941",
    "uf": "SP",
    "codigoIbge": 3504107,
    "cidade": "Atibaia"
  },
  {
    "prefixo": "12942",
    "uf": "SP",
    "codigoIbge": 3504107,
    "cidade": "Atibaia"
  },
  {
    "prefixo": "12943",
    "uf": "SP",
    "codigoIbge": 3504107,
    "cidade": "Atibaia"
  },
  {
    "prefixo": "12944",
    "uf": "SP",
    "codigoIbge": 3504107,
    "cidade": "Atibaia"
  },
  {
    "prefixo": "12945",
    "uf": "SP",
    "codigoIbge": 3504107,
    "cidade": "Atibaia"
  },
  {
    "prefixo": "12946",
    "uf": "SP",
    "codigoIbge": 3504107,
    "cidade": "Atibaia"
  },
  {
    "prefixo": "12947",
    "uf": "SP",
    "codigoIbge": 3504107,
    "cidade": "Atibaia"
  },
  {
    "prefixo": "12948",
    "uf": "SP",
    "codigoIbge": 3504107,
    "cidade": "Atibaia"
  },
  {
    "prefixo": "12949",
    "uf": "SP",
    "codigoIbge": 3504107,
    "cidade": "Atibaia"
  },
  {
    "prefixo": "12950",
    "uf": "SP",
    "codigoIbge": 3504107,
    "cidade": "Atibaia"
  },
  {
    "prefixo": "12951",
    "uf": "SP",
    "codigoIbge": 3504107,
    "cidade": "Atibaia"
  },
  {
    "prefixo": "12952",
    "uf": "SP",
    "codigoIbge": 3504107,
    "cidade": "Atibaia"
  },
  {
    "prefixo": "12953",
    "uf": "SP",
    "codigoIbge": 3504107,
    "cidade": "Atibaia"
  },
  {
    "prefixo": "12954",
    "uf": "SP",
    "codigoIbge": 3504107,
    "cidade": "Atibaia"
  },
  {
    "prefixo": "12955",
    "uf": "SP",
    "codigoIbge": 3507100,
    "cidade": "Bom Jesus dos Perdões"
  },
  {
    "prefixo": "12960",
    "uf": "SP",
    "codigoIbge": 3532405,
    "cidade": "Nazaré Paulista"
  },
  {
    "prefixo": "12969",
    "uf": "SP",
    "codigoIbge": 3532405,
    "cidade": "Nazaré Paulista"
  },
  {
    "prefixo": "12970",
    "uf": "SP",
    "codigoIbge": 3538600,
    "cidade": "Piracaia"
  },
  {
    "prefixo": "12975",
    "uf": "SP",
    "codigoIbge": 3538600,
    "cidade": "Piracaia"
  },
  {
    "prefixo": "12980",
    "uf": "SP",
    "codigoIbge": 3525508,
    "cidade": "Joanópolis"
  },
  {
    "prefixo": "12990",
    "uf": "SP",
    "codigoIbge": 3536802,
    "cidade": "Pedra Bela"
  },
  {
    "prefixo": "12995",
    "uf": "SP",
    "codigoIbge": 3538204,
    "cidade": "Pinhalzinho"
  },
  {
    "prefixo": "13010",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13012",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13013",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13015",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13020",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13023",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13024",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13025",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13026",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13030",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13031",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13032",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13033",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13034",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13035",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13036",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13040",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13041",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13042",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13043",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13044",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13045",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13046",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13049",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13050",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13051",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13052",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13053",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13054",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13055",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13056",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13057",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13058",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13059",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13060",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13061",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13063",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13064",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13065",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13067",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13068",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13069",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13070",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13073",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13075",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13076",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13077",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13080",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13081",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13082",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13083",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13084",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13085",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13086",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13087",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13088",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13090",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13091",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13092",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13094",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13096",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13097",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13098",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13099",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13100",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13101",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13104",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13105",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13106",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13107",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13108",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13139",
    "uf": "SP",
    "codigoIbge": 3509502,
    "cidade": "Campinas"
  },
  {
    "prefixo": "13140",
    "uf": "SP",
    "codigoIbge": 3536505,
    "cidade": "Paulínia"
  },
  {
    "prefixo": "13141",
    "uf": "SP",
    "codigoIbge": 3536505,
    "cidade": "Paulínia"
  },
  {
    "prefixo": "13142",
    "uf": "SP",
    "codigoIbge": 3536505,
    "cidade": "Paulínia"
  },
  {
    "prefixo": "13144",
    "uf": "SP",
    "codigoIbge": 3536505,
    "cidade": "Paulínia"
  },
  {
    "prefixo": "13145",
    "uf": "SP",
    "codigoIbge": 3536505,
    "cidade": "Paulínia"
  },
  {
    "prefixo": "13146",
    "uf": "SP",
    "codigoIbge": 3536505,
    "cidade": "Paulínia"
  },
  {
    "prefixo": "13147",
    "uf": "SP",
    "codigoIbge": 3536505,
    "cidade": "Paulínia"
  },
  {
    "prefixo": "13148",
    "uf": "SP",
    "codigoIbge": 3536505,
    "cidade": "Paulínia"
  },
  {
    "prefixo": "13150",
    "uf": "SP",
    "codigoIbge": 3512803,
    "cidade": "Cosmópolis"
  },
  {
    "prefixo": "13151",
    "uf": "SP",
    "codigoIbge": 3512803,
    "cidade": "Cosmópolis"
  },
  {
    "prefixo": "13152",
    "uf": "SP",
    "codigoIbge": 3512803,
    "cidade": "Cosmópolis"
  },
  {
    "prefixo": "13154",
    "uf": "SP",
    "codigoIbge": 3512803,
    "cidade": "Cosmópolis"
  },
  {
    "prefixo": "13155",
    "uf": "SP",
    "codigoIbge": 3512803,
    "cidade": "Cosmópolis"
  },
  {
    "prefixo": "13157",
    "uf": "SP",
    "codigoIbge": 3512803,
    "cidade": "Cosmópolis"
  },
  {
    "prefixo": "13159",
    "uf": "SP",
    "codigoIbge": 3512803,
    "cidade": "Cosmópolis"
  },
  {
    "prefixo": "13160",
    "uf": "SP",
    "codigoIbge": 3503802,
    "cidade": "Artur Nogueira"
  },
  {
    "prefixo": "13161",
    "uf": "SP",
    "codigoIbge": 3503802,
    "cidade": "Artur Nogueira"
  },
  {
    "prefixo": "13162",
    "uf": "SP",
    "codigoIbge": 3503802,
    "cidade": "Artur Nogueira"
  },
  {
    "prefixo": "13163",
    "uf": "SP",
    "codigoIbge": 3503802,
    "cidade": "Artur Nogueira"
  },
  {
    "prefixo": "13164",
    "uf": "SP",
    "codigoIbge": 3503802,
    "cidade": "Artur Nogueira"
  },
  {
    "prefixo": "13165",
    "uf": "SP",
    "codigoIbge": 3503802,
    "cidade": "Artur Nogueira"
  },
  {
    "prefixo": "13167",
    "uf": "SP",
    "codigoIbge": 3503802,
    "cidade": "Artur Nogueira"
  },
  {
    "prefixo": "13168",
    "uf": "SP",
    "codigoIbge": 3503802,
    "cidade": "Artur Nogueira"
  },
  {
    "prefixo": "13169",
    "uf": "SP",
    "codigoIbge": 3503802,
    "cidade": "Artur Nogueira"
  },
  {
    "prefixo": "13170",
    "uf": "SP",
    "codigoIbge": 3552403,
    "cidade": "Sumaré"
  },
  {
    "prefixo": "13171",
    "uf": "SP",
    "codigoIbge": 3552403,
    "cidade": "Sumaré"
  },
  {
    "prefixo": "13172",
    "uf": "SP",
    "codigoIbge": 3552403,
    "cidade": "Sumaré"
  },
  {
    "prefixo": "13173",
    "uf": "SP",
    "codigoIbge": 3552403,
    "cidade": "Sumaré"
  },
  {
    "prefixo": "13174",
    "uf": "SP",
    "codigoIbge": 3552403,
    "cidade": "Sumaré"
  },
  {
    "prefixo": "13175",
    "uf": "SP",
    "codigoIbge": 3552403,
    "cidade": "Sumaré"
  },
  {
    "prefixo": "13176",
    "uf": "SP",
    "codigoIbge": 3552403,
    "cidade": "Sumaré"
  },
  {
    "prefixo": "13177",
    "uf": "SP",
    "codigoIbge": 3552403,
    "cidade": "Sumaré"
  },
  {
    "prefixo": "13178",
    "uf": "SP",
    "codigoIbge": 3552403,
    "cidade": "Sumaré"
  },
  {
    "prefixo": "13179",
    "uf": "SP",
    "codigoIbge": 3552403,
    "cidade": "Sumaré"
  },
  {
    "prefixo": "13180",
    "uf": "SP",
    "codigoIbge": 3552403,
    "cidade": "Sumaré"
  },
  {
    "prefixo": "13181",
    "uf": "SP",
    "codigoIbge": 3552403,
    "cidade": "Sumaré"
  },
  {
    "prefixo": "13182",
    "uf": "SP",
    "codigoIbge": 3552403,
    "cidade": "Sumaré"
  },
  {
    "prefixo": "13183",
    "uf": "SP",
    "codigoIbge": 3519071,
    "cidade": "Hortolândia"
  },
  {
    "prefixo": "13184",
    "uf": "SP",
    "codigoIbge": 3519071,
    "cidade": "Hortolândia"
  },
  {
    "prefixo": "13185",
    "uf": "SP",
    "codigoIbge": 3519071,
    "cidade": "Hortolândia"
  },
  {
    "prefixo": "13186",
    "uf": "SP",
    "codigoIbge": 3519071,
    "cidade": "Hortolândia"
  },
  {
    "prefixo": "13187",
    "uf": "SP",
    "codigoIbge": 3519071,
    "cidade": "Hortolândia"
  },
  {
    "prefixo": "13188",
    "uf": "SP",
    "codigoIbge": 3519071,
    "cidade": "Hortolândia"
  },
  {
    "prefixo": "13189",
    "uf": "SP",
    "codigoIbge": 3519071,
    "cidade": "Hortolândia"
  },
  {
    "prefixo": "13190",
    "uf": "SP",
    "codigoIbge": 3531803,
    "cidade": "Monte Mor"
  },
  {
    "prefixo": "13191",
    "uf": "SP",
    "codigoIbge": 3531803,
    "cidade": "Monte Mor"
  },
  {
    "prefixo": "13193",
    "uf": "SP",
    "codigoIbge": 3531803,
    "cidade": "Monte Mor"
  },
  {
    "prefixo": "13194",
    "uf": "SP",
    "codigoIbge": 3531803,
    "cidade": "Monte Mor"
  },
  {
    "prefixo": "13196",
    "uf": "SP",
    "codigoIbge": 3531803,
    "cidade": "Monte Mor"
  },
  {
    "prefixo": "13197",
    "uf": "SP",
    "codigoIbge": 3531803,
    "cidade": "Monte Mor"
  },
  {
    "prefixo": "13198",
    "uf": "SP",
    "codigoIbge": 3531803,
    "cidade": "Monte Mor"
  },
  {
    "prefixo": "13199",
    "uf": "SP",
    "codigoIbge": 3531803,
    "cidade": "Monte Mor"
  },
  {
    "prefixo": "13201",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13202",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13203",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13205",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13206",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13207",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13208",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13209",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13210",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13211",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13212",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13213",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13214",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13215",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13216",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13218",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13219",
    "uf": "SP",
    "codigoIbge": 3525904,
    "cidade": "Jundiaí"
  },
  {
    "prefixo": "13220",
    "uf": "SP",
    "codigoIbge": 3556503,
    "cidade": "Várzea Paulista"
  },
  {
    "prefixo": "13221",
    "uf": "SP",
    "codigoIbge": 3556503,
    "cidade": "Várzea Paulista"
  },
  {
    "prefixo": "13222",
    "uf": "SP",
    "codigoIbge": 3556503,
    "cidade": "Várzea Paulista"
  },
  {
    "prefixo": "13223",
    "uf": "SP",
    "codigoIbge": 3556503,
    "cidade": "Várzea Paulista"
  },
  {
    "prefixo": "13224",
    "uf": "SP",
    "codigoIbge": 3556503,
    "cidade": "Várzea Paulista"
  },
  {
    "prefixo": "13225",
    "uf": "SP",
    "codigoIbge": 3556503,
    "cidade": "Várzea Paulista"
  },
  {
    "prefixo": "13226",
    "uf": "SP",
    "codigoIbge": 3556503,
    "cidade": "Várzea Paulista"
  },
  {
    "prefixo": "13227",
    "uf": "SP",
    "codigoIbge": 3556503,
    "cidade": "Várzea Paulista"
  },
  {
    "prefixo": "13230",
    "uf": "SP",
    "codigoIbge": 3509601,
    "cidade": "Campo Limpo Paulista"
  },
  {
    "prefixo": "13231",
    "uf": "SP",
    "codigoIbge": 3509601,
    "cidade": "Campo Limpo Paulista"
  },
  {
    "prefixo": "13232",
    "uf": "SP",
    "codigoIbge": 3509601,
    "cidade": "Campo Limpo Paulista"
  },
  {
    "prefixo": "13233",
    "uf": "SP",
    "codigoIbge": 3509601,
    "cidade": "Campo Limpo Paulista"
  },
  {
    "prefixo": "13234",
    "uf": "SP",
    "codigoIbge": 3509601,
    "cidade": "Campo Limpo Paulista"
  },
  {
    "prefixo": "13236",
    "uf": "SP",
    "codigoIbge": 3509601,
    "cidade": "Campo Limpo Paulista"
  },
  {
    "prefixo": "13238",
    "uf": "SP",
    "codigoIbge": 3509601,
    "cidade": "Campo Limpo Paulista"
  },
  {
    "prefixo": "13239",
    "uf": "SP",
    "codigoIbge": 3509601,
    "cidade": "Campo Limpo Paulista"
  },
  {
    "prefixo": "13240",
    "uf": "SP",
    "codigoIbge": 3525201,
    "cidade": "Jarinu"
  },
  {
    "prefixo": "13241",
    "uf": "SP",
    "codigoIbge": 3525201,
    "cidade": "Jarinu"
  },
  {
    "prefixo": "13242",
    "uf": "SP",
    "codigoIbge": 3525201,
    "cidade": "Jarinu"
  },
  {
    "prefixo": "13243",
    "uf": "SP",
    "codigoIbge": 3525201,
    "cidade": "Jarinu"
  },
  {
    "prefixo": "13244",
    "uf": "SP",
    "codigoIbge": 3525201,
    "cidade": "Jarinu"
  },
  {
    "prefixo": "13246",
    "uf": "SP",
    "codigoIbge": 3525201,
    "cidade": "Jarinu"
  },
  {
    "prefixo": "13247",
    "uf": "SP",
    "codigoIbge": 3525201,
    "cidade": "Jarinu"
  },
  {
    "prefixo": "13248",
    "uf": "SP",
    "codigoIbge": 3525201,
    "cidade": "Jarinu"
  },
  {
    "prefixo": "13249",
    "uf": "SP",
    "codigoIbge": 3525201,
    "cidade": "Jarinu"
  },
  {
    "prefixo": "13250",
    "uf": "SP",
    "codigoIbge": 3523404,
    "cidade": "Itatiba"
  },
  {
    "prefixo": "13251",
    "uf": "SP",
    "codigoIbge": 3523404,
    "cidade": "Itatiba"
  },
  {
    "prefixo": "13252",
    "uf": "SP",
    "codigoIbge": 3523404,
    "cidade": "Itatiba"
  },
  {
    "prefixo": "13253",
    "uf": "SP",
    "codigoIbge": 3523404,
    "cidade": "Itatiba"
  },
  {
    "prefixo": "13254",
    "uf": "SP",
    "codigoIbge": 3523404,
    "cidade": "Itatiba"
  },
  {
    "prefixo": "13255",
    "uf": "SP",
    "codigoIbge": 3523404,
    "cidade": "Itatiba"
  },
  {
    "prefixo": "13256",
    "uf": "SP",
    "codigoIbge": 3523404,
    "cidade": "Itatiba"
  },
  {
    "prefixo": "13257",
    "uf": "SP",
    "codigoIbge": 3523404,
    "cidade": "Itatiba"
  },
  {
    "prefixo": "13258",
    "uf": "SP",
    "codigoIbge": 3523404,
    "cidade": "Itatiba"
  },
  {
    "prefixo": "13260",
    "uf": "SP",
    "codigoIbge": 3532009,
    "cidade": "Morungaba"
  },
  {
    "prefixo": "13270",
    "uf": "SP",
    "codigoIbge": 3556206,
    "cidade": "Valinhos"
  },
  {
    "prefixo": "13271",
    "uf": "SP",
    "codigoIbge": 3556206,
    "cidade": "Valinhos"
  },
  {
    "prefixo": "13272",
    "uf": "SP",
    "codigoIbge": 3556206,
    "cidade": "Valinhos"
  },
  {
    "prefixo": "13273",
    "uf": "SP",
    "codigoIbge": 3556206,
    "cidade": "Valinhos"
  },
  {
    "prefixo": "13274",
    "uf": "SP",
    "codigoIbge": 3556206,
    "cidade": "Valinhos"
  },
  {
    "prefixo": "13275",
    "uf": "SP",
    "codigoIbge": 3556206,
    "cidade": "Valinhos"
  },
  {
    "prefixo": "13276",
    "uf": "SP",
    "codigoIbge": 3556206,
    "cidade": "Valinhos"
  },
  {
    "prefixo": "13277",
    "uf": "SP",
    "codigoIbge": 3556206,
    "cidade": "Valinhos"
  },
  {
    "prefixo": "13278",
    "uf": "SP",
    "codigoIbge": 3556206,
    "cidade": "Valinhos"
  },
  {
    "prefixo": "13279",
    "uf": "SP",
    "codigoIbge": 3556206,
    "cidade": "Valinhos"
  },
  {
    "prefixo": "13280",
    "uf": "SP",
    "codigoIbge": 3556701,
    "cidade": "Vinhedo"
  },
  {
    "prefixo": "13281",
    "uf": "SP",
    "codigoIbge": 3556701,
    "cidade": "Vinhedo"
  },
  {
    "prefixo": "13282",
    "uf": "SP",
    "codigoIbge": 3556701,
    "cidade": "Vinhedo"
  },
  {
    "prefixo": "13283",
    "uf": "SP",
    "codigoIbge": 3556701,
    "cidade": "Vinhedo"
  },
  {
    "prefixo": "13284",
    "uf": "SP",
    "codigoIbge": 3556701,
    "cidade": "Vinhedo"
  },
  {
    "prefixo": "13285",
    "uf": "SP",
    "codigoIbge": 3556701,
    "cidade": "Vinhedo"
  },
  {
    "prefixo": "13286",
    "uf": "SP",
    "codigoIbge": 3556701,
    "cidade": "Vinhedo"
  },
  {
    "prefixo": "13287",
    "uf": "SP",
    "codigoIbge": 3556701,
    "cidade": "Vinhedo"
  },
  {
    "prefixo": "13288",
    "uf": "SP",
    "codigoIbge": 3556701,
    "cidade": "Vinhedo"
  },
  {
    "prefixo": "13289",
    "uf": "SP",
    "codigoIbge": 3556701,
    "cidade": "Vinhedo"
  },
  {
    "prefixo": "13290",
    "uf": "SP",
    "codigoIbge": 3527306,
    "cidade": "Louveira"
  },
  {
    "prefixo": "13291",
    "uf": "SP",
    "codigoIbge": 3527306,
    "cidade": "Louveira"
  },
  {
    "prefixo": "13293",
    "uf": "SP",
    "codigoIbge": 3527306,
    "cidade": "Louveira"
  },
  {
    "prefixo": "13294",
    "uf": "SP",
    "codigoIbge": 3527306,
    "cidade": "Louveira"
  },
  {
    "prefixo": "13295",
    "uf": "SP",
    "codigoIbge": 3524006,
    "cidade": "Itupeva"
  },
  {
    "prefixo": "13296",
    "uf": "SP",
    "codigoIbge": 3524006,
    "cidade": "Itupeva"
  },
  {
    "prefixo": "13297",
    "uf": "SP",
    "codigoIbge": 3524006,
    "cidade": "Itupeva"
  },
  {
    "prefixo": "13298",
    "uf": "SP",
    "codigoIbge": 3524006,
    "cidade": "Itupeva"
  },
  {
    "prefixo": "13299",
    "uf": "SP",
    "codigoIbge": 3524006,
    "cidade": "Itupeva"
  },
  {
    "prefixo": "13300",
    "uf": "SP",
    "codigoIbge": 3523909,
    "cidade": "Itu"
  },
  {
    "prefixo": "13301",
    "uf": "SP",
    "codigoIbge": 3523909,
    "cidade": "Itu"
  },
  {
    "prefixo": "13302",
    "uf": "SP",
    "codigoIbge": 3523909,
    "cidade": "Itu"
  },
  {
    "prefixo": "13303",
    "uf": "SP",
    "codigoIbge": 3523909,
    "cidade": "Itu"
  },
  {
    "prefixo": "13304",
    "uf": "SP",
    "codigoIbge": 3523909,
    "cidade": "Itu"
  },
  {
    "prefixo": "13305",
    "uf": "SP",
    "codigoIbge": 3523909,
    "cidade": "Itu"
  },
  {
    "prefixo": "13306",
    "uf": "SP",
    "codigoIbge": 3523909,
    "cidade": "Itu"
  },
  {
    "prefixo": "13307",
    "uf": "SP",
    "codigoIbge": 3523909,
    "cidade": "Itu"
  },
  {
    "prefixo": "13308",
    "uf": "SP",
    "codigoIbge": 3523909,
    "cidade": "Itu"
  },
  {
    "prefixo": "13309",
    "uf": "SP",
    "codigoIbge": 3523909,
    "cidade": "Itu"
  },
  {
    "prefixo": "13310",
    "uf": "SP",
    "codigoIbge": 3523909,
    "cidade": "Itu"
  },
  {
    "prefixo": "13311",
    "uf": "SP",
    "codigoIbge": 3523909,
    "cidade": "Itu"
  },
  {
    "prefixo": "13312",
    "uf": "SP",
    "codigoIbge": 3523909,
    "cidade": "Itu"
  },
  {
    "prefixo": "13313",
    "uf": "SP",
    "codigoIbge": 3523909,
    "cidade": "Itu"
  },
  {
    "prefixo": "13314",
    "uf": "SP",
    "codigoIbge": 3523909,
    "cidade": "Itu"
  },
  {
    "prefixo": "13315",
    "uf": "SP",
    "codigoIbge": 3508405,
    "cidade": "Cabreúva"
  },
  {
    "prefixo": "13316",
    "uf": "SP",
    "codigoIbge": 3508405,
    "cidade": "Cabreúva"
  },
  {
    "prefixo": "13317",
    "uf": "SP",
    "codigoIbge": 3508405,
    "cidade": "Cabreúva"
  },
  {
    "prefixo": "13318",
    "uf": "SP",
    "codigoIbge": 3508405,
    "cidade": "Cabreúva"
  },
  {
    "prefixo": "13319",
    "uf": "SP",
    "codigoIbge": 3508405,
    "cidade": "Cabreúva"
  },
  {
    "prefixo": "13320",
    "uf": "SP",
    "codigoIbge": 3545209,
    "cidade": "Salto"
  },
  {
    "prefixo": "13321",
    "uf": "SP",
    "codigoIbge": 3545209,
    "cidade": "Salto"
  },
  {
    "prefixo": "13322",
    "uf": "SP",
    "codigoIbge": 3545209,
    "cidade": "Salto"
  },
  {
    "prefixo": "13323",
    "uf": "SP",
    "codigoIbge": 3545209,
    "cidade": "Salto"
  },
  {
    "prefixo": "13324",
    "uf": "SP",
    "codigoIbge": 3545209,
    "cidade": "Salto"
  },
  {
    "prefixo": "13325",
    "uf": "SP",
    "codigoIbge": 3545209,
    "cidade": "Salto"
  },
  {
    "prefixo": "13326",
    "uf": "SP",
    "codigoIbge": 3545209,
    "cidade": "Salto"
  },
  {
    "prefixo": "13327",
    "uf": "SP",
    "codigoIbge": 3545209,
    "cidade": "Salto"
  },
  {
    "prefixo": "13328",
    "uf": "SP",
    "codigoIbge": 3545209,
    "cidade": "Salto"
  },
  {
    "prefixo": "13329",
    "uf": "SP",
    "codigoIbge": 3545209,
    "cidade": "Salto"
  },
  {
    "prefixo": "13330",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13331",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13332",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13333",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13334",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13335",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13336",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13337",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13338",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13339",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13340",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13341",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13342",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13343",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13344",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13345",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13346",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13347",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13348",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13349",
    "uf": "SP",
    "codigoIbge": 3520509,
    "cidade": "Indaiatuba"
  },
  {
    "prefixo": "13350",
    "uf": "SP",
    "codigoIbge": 3514908,
    "cidade": "Elias Fausto"
  },
  {
    "prefixo": "13355",
    "uf": "SP",
    "codigoIbge": 3514908,
    "cidade": "Elias Fausto"
  },
  {
    "prefixo": "13360",
    "uf": "SP",
    "codigoIbge": 3510401,
    "cidade": "Capivari"
  },
  {
    "prefixo": "13362",
    "uf": "SP",
    "codigoIbge": 3510401,
    "cidade": "Capivari"
  },
  {
    "prefixo": "13363",
    "uf": "SP",
    "codigoIbge": 3510401,
    "cidade": "Capivari"
  },
  {
    "prefixo": "13365",
    "uf": "SP",
    "codigoIbge": 3510401,
    "cidade": "Capivari"
  },
  {
    "prefixo": "13366",
    "uf": "SP",
    "codigoIbge": 3510401,
    "cidade": "Capivari"
  },
  {
    "prefixo": "13367",
    "uf": "SP",
    "codigoIbge": 3510401,
    "cidade": "Capivari"
  },
  {
    "prefixo": "13368",
    "uf": "SP",
    "codigoIbge": 3510401,
    "cidade": "Capivari"
  },
  {
    "prefixo": "13369",
    "uf": "SP",
    "codigoIbge": 3510401,
    "cidade": "Capivari"
  },
  {
    "prefixo": "13370",
    "uf": "SP",
    "codigoIbge": 3542107,
    "cidade": "Rafard"
  },
  {
    "prefixo": "13375",
    "uf": "SP",
    "codigoIbge": 3530904,
    "cidade": "Mombuca"
  },
  {
    "prefixo": "13380",
    "uf": "SP",
    "codigoIbge": 3533403,
    "cidade": "Nova Odessa"
  },
  {
    "prefixo": "13381",
    "uf": "SP",
    "codigoIbge": 3533403,
    "cidade": "Nova Odessa"
  },
  {
    "prefixo": "13382",
    "uf": "SP",
    "codigoIbge": 3533403,
    "cidade": "Nova Odessa"
  },
  {
    "prefixo": "13383",
    "uf": "SP",
    "codigoIbge": 3533403,
    "cidade": "Nova Odessa"
  },
  {
    "prefixo": "13385",
    "uf": "SP",
    "codigoIbge": 3533403,
    "cidade": "Nova Odessa"
  },
  {
    "prefixo": "13386",
    "uf": "SP",
    "codigoIbge": 3533403,
    "cidade": "Nova Odessa"
  },
  {
    "prefixo": "13387",
    "uf": "SP",
    "codigoIbge": 3533403,
    "cidade": "Nova Odessa"
  },
  {
    "prefixo": "13388",
    "uf": "SP",
    "codigoIbge": 3533403,
    "cidade": "Nova Odessa"
  },
  {
    "prefixo": "13389",
    "uf": "SP",
    "codigoIbge": 3533403,
    "cidade": "Nova Odessa"
  },
  {
    "prefixo": "13390",
    "uf": "SP",
    "codigoIbge": 3544004,
    "cidade": "Rio das Pedras"
  },
  {
    "prefixo": "13392",
    "uf": "SP",
    "codigoIbge": 3544004,
    "cidade": "Rio das Pedras"
  },
  {
    "prefixo": "13395",
    "uf": "SP",
    "codigoIbge": 3544004,
    "cidade": "Rio das Pedras"
  },
  {
    "prefixo": "13397",
    "uf": "SP",
    "codigoIbge": 3544004,
    "cidade": "Rio das Pedras"
  },
  {
    "prefixo": "13398",
    "uf": "SP",
    "codigoIbge": 3544004,
    "cidade": "Rio das Pedras"
  },
  {
    "prefixo": "13399",
    "uf": "SP",
    "codigoIbge": 3544004,
    "cidade": "Rio das Pedras"
  },
  {
    "prefixo": "13400",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13401",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13402",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13403",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13404",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13405",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13406",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13408",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13409",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13410",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13411",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13412",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13413",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13414",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13415",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13416",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13417",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13418",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13419",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13420",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13421",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13422",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13423",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13424",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13425",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13426",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13427",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13428",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13432",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13433",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13434",
    "uf": "SP",
    "codigoIbge": 3538709,
    "cidade": "Piracicaba"
  },
  {
    "prefixo": "13440",
    "uf": "SP",
    "codigoIbge": 3545159,
    "cidade": "Saltinho"
  },
  {
    "prefixo": "13442",
    "uf": "SP",
    "codigoIbge": 3545159,
    "cidade": "Saltinho"
  },
  {
    "prefixo": "13444",
    "uf": "SP",
    "codigoIbge": 3545159,
    "cidade": "Saltinho"
  },
  {
    "prefixo": "13445",
    "uf": "SP",
    "codigoIbge": 3515152,
    "cidade": "Engenheiro Coelho"
  },
  {
    "prefixo": "13448",
    "uf": "SP",
    "codigoIbge": 3515152,
    "cidade": "Engenheiro Coelho"
  },
  {
    "prefixo": "13449",
    "uf": "SP",
    "codigoIbge": 3515152,
    "cidade": "Engenheiro Coelho"
  },
  {
    "prefixo": "13450",
    "uf": "SP",
    "codigoIbge": 3545803,
    "cidade": "Santa Bárbara d'Oeste"
  },
  {
    "prefixo": "13451",
    "uf": "SP",
    "codigoIbge": 3545803,
    "cidade": "Santa Bárbara d'Oeste"
  },
  {
    "prefixo": "13452",
    "uf": "SP",
    "codigoIbge": 3545803,
    "cidade": "Santa Bárbara d'Oeste"
  },
  {
    "prefixo": "13453",
    "uf": "SP",
    "codigoIbge": 3545803,
    "cidade": "Santa Bárbara d'Oeste"
  },
  {
    "prefixo": "13454",
    "uf": "SP",
    "codigoIbge": 3545803,
    "cidade": "Santa Bárbara d'Oeste"
  },
  {
    "prefixo": "13455",
    "uf": "SP",
    "codigoIbge": 3545803,
    "cidade": "Santa Bárbara d'Oeste"
  },
  {
    "prefixo": "13456",
    "uf": "SP",
    "codigoIbge": 3545803,
    "cidade": "Santa Bárbara d'Oeste"
  },
  {
    "prefixo": "13457",
    "uf": "SP",
    "codigoIbge": 3545803,
    "cidade": "Santa Bárbara d'Oeste"
  },
  {
    "prefixo": "13458",
    "uf": "SP",
    "codigoIbge": 3545803,
    "cidade": "Santa Bárbara d'Oeste"
  },
  {
    "prefixo": "13459",
    "uf": "SP",
    "codigoIbge": 3545803,
    "cidade": "Santa Bárbara d'Oeste"
  },
  {
    "prefixo": "13465",
    "uf": "SP",
    "codigoIbge": 3501608,
    "cidade": "Americana"
  },
  {
    "prefixo": "13466",
    "uf": "SP",
    "codigoIbge": 3501608,
    "cidade": "Americana"
  },
  {
    "prefixo": "13467",
    "uf": "SP",
    "codigoIbge": 3501608,
    "cidade": "Americana"
  },
  {
    "prefixo": "13468",
    "uf": "SP",
    "codigoIbge": 3501608,
    "cidade": "Americana"
  },
  {
    "prefixo": "13469",
    "uf": "SP",
    "codigoIbge": 3501608,
    "cidade": "Americana"
  },
  {
    "prefixo": "13470",
    "uf": "SP",
    "codigoIbge": 3501608,
    "cidade": "Americana"
  },
  {
    "prefixo": "13471",
    "uf": "SP",
    "codigoIbge": 3501608,
    "cidade": "Americana"
  },
  {
    "prefixo": "13472",
    "uf": "SP",
    "codigoIbge": 3501608,
    "cidade": "Americana"
  },
  {
    "prefixo": "13473",
    "uf": "SP",
    "codigoIbge": 3501608,
    "cidade": "Americana"
  },
  {
    "prefixo": "13474",
    "uf": "SP",
    "codigoIbge": 3501608,
    "cidade": "Americana"
  },
  {
    "prefixo": "13475",
    "uf": "SP",
    "codigoIbge": 3501608,
    "cidade": "Americana"
  },
  {
    "prefixo": "13476",
    "uf": "SP",
    "codigoIbge": 3501608,
    "cidade": "Americana"
  },
  {
    "prefixo": "13477",
    "uf": "SP",
    "codigoIbge": 3501608,
    "cidade": "Americana"
  },
  {
    "prefixo": "13478",
    "uf": "SP",
    "codigoIbge": 3501608,
    "cidade": "Americana"
  },
  {
    "prefixo": "13479",
    "uf": "SP",
    "codigoIbge": 3501608,
    "cidade": "Americana"
  },
  {
    "prefixo": "13480",
    "uf": "SP",
    "codigoIbge": 3526902,
    "cidade": "Limeira"
  },
  {
    "prefixo": "13481",
    "uf": "SP",
    "codigoIbge": 3526902,
    "cidade": "Limeira"
  },
  {
    "prefixo": "13482",
    "uf": "SP",
    "codigoIbge": 3526902,
    "cidade": "Limeira"
  },
  {
    "prefixo": "13483",
    "uf": "SP",
    "codigoIbge": 3526902,
    "cidade": "Limeira"
  },
  {
    "prefixo": "13484",
    "uf": "SP",
    "codigoIbge": 3526902,
    "cidade": "Limeira"
  },
  {
    "prefixo": "13485",
    "uf": "SP",
    "codigoIbge": 3526902,
    "cidade": "Limeira"
  },
  {
    "prefixo": "13486",
    "uf": "SP",
    "codigoIbge": 3526902,
    "cidade": "Limeira"
  },
  {
    "prefixo": "13487",
    "uf": "SP",
    "codigoIbge": 3526902,
    "cidade": "Limeira"
  },
  {
    "prefixo": "13489",
    "uf": "SP",
    "codigoIbge": 3526902,
    "cidade": "Limeira"
  },
  {
    "prefixo": "13490",
    "uf": "SP",
    "codigoIbge": 3512407,
    "cidade": "Cordeirópolis"
  },
  {
    "prefixo": "13491",
    "uf": "SP",
    "codigoIbge": 3512407,
    "cidade": "Cordeirópolis"
  },
  {
    "prefixo": "13492",
    "uf": "SP",
    "codigoIbge": 3512407,
    "cidade": "Cordeirópolis"
  },
  {
    "prefixo": "13493",
    "uf": "SP",
    "codigoIbge": 3512407,
    "cidade": "Cordeirópolis"
  },
  {
    "prefixo": "13494",
    "uf": "SP",
    "codigoIbge": 3512407,
    "cidade": "Cordeirópolis"
  },
  {
    "prefixo": "13495",
    "uf": "SP",
    "codigoIbge": 3521408,
    "cidade": "Iracemápolis"
  },
  {
    "prefixo": "13496",
    "uf": "SP",
    "codigoIbge": 3521408,
    "cidade": "Iracemápolis"
  },
  {
    "prefixo": "13497",
    "uf": "SP",
    "codigoIbge": 3521408,
    "cidade": "Iracemápolis"
  },
  {
    "prefixo": "13498",
    "uf": "SP",
    "codigoIbge": 3521408,
    "cidade": "Iracemápolis"
  },
  {
    "prefixo": "13499",
    "uf": "SP",
    "codigoIbge": 3521408,
    "cidade": "Iracemápolis"
  },
  {
    "prefixo": "13500",
    "uf": "SP",
    "codigoIbge": 3543907,
    "cidade": "Rio Claro"
  },
  {
    "prefixo": "13501",
    "uf": "SP",
    "codigoIbge": 3543907,
    "cidade": "Rio Claro"
  },
  {
    "prefixo": "13502",
    "uf": "SP",
    "codigoIbge": 3543907,
    "cidade": "Rio Claro"
  },
  {
    "prefixo": "13503",
    "uf": "SP",
    "codigoIbge": 3543907,
    "cidade": "Rio Claro"
  },
  {
    "prefixo": "13504",
    "uf": "SP",
    "codigoIbge": 3543907,
    "cidade": "Rio Claro"
  },
  {
    "prefixo": "13505",
    "uf": "SP",
    "codigoIbge": 3543907,
    "cidade": "Rio Claro"
  },
  {
    "prefixo": "13506",
    "uf": "SP",
    "codigoIbge": 3543907,
    "cidade": "Rio Claro"
  },
  {
    "prefixo": "13507",
    "uf": "SP",
    "codigoIbge": 3543907,
    "cidade": "Rio Claro"
  },
  {
    "prefixo": "13508",
    "uf": "SP",
    "codigoIbge": 3543907,
    "cidade": "Rio Claro"
  },
  {
    "prefixo": "13509",
    "uf": "SP",
    "codigoIbge": 3543907,
    "cidade": "Rio Claro"
  },
  {
    "prefixo": "13510",
    "uf": "SP",
    "codigoIbge": 3546702,
    "cidade": "Santa Gertrudes"
  },
  {
    "prefixo": "13512",
    "uf": "SP",
    "codigoIbge": 3546702,
    "cidade": "Santa Gertrudes"
  },
  {
    "prefixo": "13513",
    "uf": "SP",
    "codigoIbge": 3546702,
    "cidade": "Santa Gertrudes"
  },
  {
    "prefixo": "13514",
    "uf": "SP",
    "codigoIbge": 3546702,
    "cidade": "Santa Gertrudes"
  },
  {
    "prefixo": "13515",
    "uf": "SP",
    "codigoIbge": 3511706,
    "cidade": "Charqueada"
  },
  {
    "prefixo": "13516",
    "uf": "SP",
    "codigoIbge": 3511706,
    "cidade": "Charqueada"
  },
  {
    "prefixo": "13517",
    "uf": "SP",
    "codigoIbge": 3511706,
    "cidade": "Charqueada"
  },
  {
    "prefixo": "13518",
    "uf": "SP",
    "codigoIbge": 3511706,
    "cidade": "Charqueada"
  },
  {
    "prefixo": "13519",
    "uf": "SP",
    "codigoIbge": 3511706,
    "cidade": "Charqueada"
  },
  {
    "prefixo": "13520",
    "uf": "SP",
    "codigoIbge": 3550407,
    "cidade": "São Pedro"
  },
  {
    "prefixo": "13521",
    "uf": "SP",
    "codigoIbge": 3550407,
    "cidade": "São Pedro"
  },
  {
    "prefixo": "13522",
    "uf": "SP",
    "codigoIbge": 3550407,
    "cidade": "São Pedro"
  },
  {
    "prefixo": "13523",
    "uf": "SP",
    "codigoIbge": 3550407,
    "cidade": "São Pedro"
  },
  {
    "prefixo": "13524",
    "uf": "SP",
    "codigoIbge": 3550407,
    "cidade": "São Pedro"
  },
  {
    "prefixo": "13528",
    "uf": "SP",
    "codigoIbge": 3500600,
    "cidade": "Águas de São Pedro"
  },
  {
    "prefixo": "13529",
    "uf": "SP",
    "codigoIbge": 3500600,
    "cidade": "Águas de São Pedro"
  },
  {
    "prefixo": "13530",
    "uf": "SP",
    "codigoIbge": 3523602,
    "cidade": "Itirapina"
  },
  {
    "prefixo": "13535",
    "uf": "SP",
    "codigoIbge": 3523602,
    "cidade": "Itirapina"
  },
  {
    "prefixo": "13537",
    "uf": "SP",
    "codigoIbge": 3521101,
    "cidade": "Ipeúna"
  },
  {
    "prefixo": "13539",
    "uf": "SP",
    "codigoIbge": 3521101,
    "cidade": "Ipeúna"
  },
  {
    "prefixo": "13540",
    "uf": "SP",
    "codigoIbge": 3512704,
    "cidade": "Corumbataí"
  },
  {
    "prefixo": "13550",
    "uf": "SP",
    "codigoIbge": 3502002,
    "cidade": "Analândia"
  },
  {
    "prefixo": "13560",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13561",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13562",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13563",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13564",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13565",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13566",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13567",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13568",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13569",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13570",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13571",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13572",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13573",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13574",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13575",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13577",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13578",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13579",
    "uf": "SP",
    "codigoIbge": 3548906,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "13580",
    "uf": "SP",
    "codigoIbge": 3542909,
    "cidade": "Ribeirão Bonito"
  },
  {
    "prefixo": "13582",
    "uf": "SP",
    "codigoIbge": 3542909,
    "cidade": "Ribeirão Bonito"
  },
  {
    "prefixo": "13584",
    "uf": "SP",
    "codigoIbge": 3542909,
    "cidade": "Ribeirão Bonito"
  },
  {
    "prefixo": "13585",
    "uf": "SP",
    "codigoIbge": 3542909,
    "cidade": "Ribeirão Bonito"
  },
  {
    "prefixo": "13588",
    "uf": "SP",
    "codigoIbge": 3542909,
    "cidade": "Ribeirão Bonito"
  },
  {
    "prefixo": "13590",
    "uf": "SP",
    "codigoIbge": 3514304,
    "cidade": "Dourado"
  },
  {
    "prefixo": "13600",
    "uf": "SP",
    "codigoIbge": 3503307,
    "cidade": "Araras"
  },
  {
    "prefixo": "13601",
    "uf": "SP",
    "codigoIbge": 3503307,
    "cidade": "Araras"
  },
  {
    "prefixo": "13602",
    "uf": "SP",
    "codigoIbge": 3503307,
    "cidade": "Araras"
  },
  {
    "prefixo": "13603",
    "uf": "SP",
    "codigoIbge": 3503307,
    "cidade": "Araras"
  },
  {
    "prefixo": "13604",
    "uf": "SP",
    "codigoIbge": 3503307,
    "cidade": "Araras"
  },
  {
    "prefixo": "13605",
    "uf": "SP",
    "codigoIbge": 3503307,
    "cidade": "Araras"
  },
  {
    "prefixo": "13606",
    "uf": "SP",
    "codigoIbge": 3503307,
    "cidade": "Araras"
  },
  {
    "prefixo": "13607",
    "uf": "SP",
    "codigoIbge": 3503307,
    "cidade": "Araras"
  },
  {
    "prefixo": "13608",
    "uf": "SP",
    "codigoIbge": 3503307,
    "cidade": "Araras"
  },
  {
    "prefixo": "13609",
    "uf": "SP",
    "codigoIbge": 3503307,
    "cidade": "Araras"
  },
  {
    "prefixo": "13610",
    "uf": "SP",
    "codigoIbge": 3526704,
    "cidade": "Leme"
  },
  {
    "prefixo": "13611",
    "uf": "SP",
    "codigoIbge": 3526704,
    "cidade": "Leme"
  },
  {
    "prefixo": "13612",
    "uf": "SP",
    "codigoIbge": 3526704,
    "cidade": "Leme"
  },
  {
    "prefixo": "13613",
    "uf": "SP",
    "codigoIbge": 3526704,
    "cidade": "Leme"
  },
  {
    "prefixo": "13614",
    "uf": "SP",
    "codigoIbge": 3526704,
    "cidade": "Leme"
  },
  {
    "prefixo": "13615",
    "uf": "SP",
    "codigoIbge": 3526704,
    "cidade": "Leme"
  },
  {
    "prefixo": "13616",
    "uf": "SP",
    "codigoIbge": 3526704,
    "cidade": "Leme"
  },
  {
    "prefixo": "13617",
    "uf": "SP",
    "codigoIbge": 3526704,
    "cidade": "Leme"
  },
  {
    "prefixo": "13624",
    "uf": "SP",
    "codigoIbge": 3526704,
    "cidade": "Leme"
  },
  {
    "prefixo": "13625",
    "uf": "SP",
    "codigoIbge": 3546207,
    "cidade": "Santa Cruz da Conceição"
  },
  {
    "prefixo": "13626",
    "uf": "SP",
    "codigoIbge": 3546207,
    "cidade": "Santa Cruz da Conceição"
  },
  {
    "prefixo": "13627",
    "uf": "SP",
    "codigoIbge": 3546207,
    "cidade": "Santa Cruz da Conceição"
  },
  {
    "prefixo": "13628",
    "uf": "SP",
    "codigoIbge": 3546207,
    "cidade": "Santa Cruz da Conceição"
  },
  {
    "prefixo": "13629",
    "uf": "SP",
    "codigoIbge": 3546207,
    "cidade": "Santa Cruz da Conceição"
  },
  {
    "prefixo": "13630",
    "uf": "SP",
    "codigoIbge": 3539301,
    "cidade": "Pirassununga"
  },
  {
    "prefixo": "13631",
    "uf": "SP",
    "codigoIbge": 3539301,
    "cidade": "Pirassununga"
  },
  {
    "prefixo": "13632",
    "uf": "SP",
    "codigoIbge": 3539301,
    "cidade": "Pirassununga"
  },
  {
    "prefixo": "13633",
    "uf": "SP",
    "codigoIbge": 3539301,
    "cidade": "Pirassununga"
  },
  {
    "prefixo": "13634",
    "uf": "SP",
    "codigoIbge": 3539301,
    "cidade": "Pirassununga"
  },
  {
    "prefixo": "13635",
    "uf": "SP",
    "codigoIbge": 3539301,
    "cidade": "Pirassununga"
  },
  {
    "prefixo": "13636",
    "uf": "SP",
    "codigoIbge": 3539301,
    "cidade": "Pirassununga"
  },
  {
    "prefixo": "13638",
    "uf": "SP",
    "codigoIbge": 3539301,
    "cidade": "Pirassununga"
  },
  {
    "prefixo": "13640",
    "uf": "SP",
    "codigoIbge": 3539301,
    "cidade": "Pirassununga"
  },
  {
    "prefixo": "13641",
    "uf": "SP",
    "codigoIbge": 3539301,
    "cidade": "Pirassununga"
  },
  {
    "prefixo": "13643",
    "uf": "SP",
    "codigoIbge": 3539301,
    "cidade": "Pirassununga"
  },
  {
    "prefixo": "13644",
    "uf": "SP",
    "codigoIbge": 3539301,
    "cidade": "Pirassununga"
  },
  {
    "prefixo": "13645",
    "uf": "SP",
    "codigoIbge": 3539301,
    "cidade": "Pirassununga"
  },
  {
    "prefixo": "13650",
    "uf": "SP",
    "codigoIbge": 3546306,
    "cidade": "Santa Cruz das Palmeiras"
  },
  {
    "prefixo": "13652",
    "uf": "SP",
    "codigoIbge": 3546306,
    "cidade": "Santa Cruz das Palmeiras"
  },
  {
    "prefixo": "13653",
    "uf": "SP",
    "codigoIbge": 3546306,
    "cidade": "Santa Cruz das Palmeiras"
  },
  {
    "prefixo": "13655",
    "uf": "SP",
    "codigoIbge": 3546306,
    "cidade": "Santa Cruz das Palmeiras"
  },
  {
    "prefixo": "13657",
    "uf": "SP",
    "codigoIbge": 3546306,
    "cidade": "Santa Cruz das Palmeiras"
  },
  {
    "prefixo": "13659",
    "uf": "SP",
    "codigoIbge": 3546306,
    "cidade": "Santa Cruz das Palmeiras"
  },
  {
    "prefixo": "13660",
    "uf": "SP",
    "codigoIbge": 3540705,
    "cidade": "Porto Ferreira"
  },
  {
    "prefixo": "13661",
    "uf": "SP",
    "codigoIbge": 3540705,
    "cidade": "Porto Ferreira"
  },
  {
    "prefixo": "13662",
    "uf": "SP",
    "codigoIbge": 3540705,
    "cidade": "Porto Ferreira"
  },
  {
    "prefixo": "13664",
    "uf": "SP",
    "codigoIbge": 3540705,
    "cidade": "Porto Ferreira"
  },
  {
    "prefixo": "13665",
    "uf": "SP",
    "codigoIbge": 3540705,
    "cidade": "Porto Ferreira"
  },
  {
    "prefixo": "13667",
    "uf": "SP",
    "codigoIbge": 3540705,
    "cidade": "Porto Ferreira"
  },
  {
    "prefixo": "13668",
    "uf": "SP",
    "codigoIbge": 3540705,
    "cidade": "Porto Ferreira"
  },
  {
    "prefixo": "13669",
    "uf": "SP",
    "codigoIbge": 3540705,
    "cidade": "Porto Ferreira"
  },
  {
    "prefixo": "13670",
    "uf": "SP",
    "codigoIbge": 3547502,
    "cidade": "Santa Rita do Passa Quatro"
  },
  {
    "prefixo": "13675",
    "uf": "SP",
    "codigoIbge": 3547502,
    "cidade": "Santa Rita do Passa Quatro"
  },
  {
    "prefixo": "13690",
    "uf": "SP",
    "codigoIbge": 3513702,
    "cidade": "Descalvado"
  },
  {
    "prefixo": "13700",
    "uf": "SP",
    "codigoIbge": 3510807,
    "cidade": "Casa Branca"
  },
  {
    "prefixo": "13705",
    "uf": "SP",
    "codigoIbge": 3510807,
    "cidade": "Casa Branca"
  },
  {
    "prefixo": "13707",
    "uf": "SP",
    "codigoIbge": 3510807,
    "cidade": "Casa Branca"
  },
  {
    "prefixo": "13710",
    "uf": "SP",
    "codigoIbge": 3553302,
    "cidade": "Tambaú"
  },
  {
    "prefixo": "13715",
    "uf": "SP",
    "codigoIbge": 3523800,
    "cidade": "Itobi"
  },
  {
    "prefixo": "13720",
    "uf": "SP",
    "codigoIbge": 3549706,
    "cidade": "São José do Rio Pardo"
  },
  {
    "prefixo": "13730",
    "uf": "SP",
    "codigoIbge": 3530508,
    "cidade": "Mococa"
  },
  {
    "prefixo": "13731",
    "uf": "SP",
    "codigoIbge": 3530508,
    "cidade": "Mococa"
  },
  {
    "prefixo": "13732",
    "uf": "SP",
    "codigoIbge": 3530508,
    "cidade": "Mococa"
  },
  {
    "prefixo": "13733",
    "uf": "SP",
    "codigoIbge": 3530508,
    "cidade": "Mococa"
  },
  {
    "prefixo": "13734",
    "uf": "SP",
    "codigoIbge": 3530508,
    "cidade": "Mococa"
  },
  {
    "prefixo": "13735",
    "uf": "SP",
    "codigoIbge": 3530508,
    "cidade": "Mococa"
  },
  {
    "prefixo": "13736",
    "uf": "SP",
    "codigoIbge": 3530508,
    "cidade": "Mococa"
  },
  {
    "prefixo": "13737",
    "uf": "SP",
    "codigoIbge": 3530508,
    "cidade": "Mococa"
  },
  {
    "prefixo": "13738",
    "uf": "SP",
    "codigoIbge": 3530508,
    "cidade": "Mococa"
  },
  {
    "prefixo": "13739",
    "uf": "SP",
    "codigoIbge": 3530508,
    "cidade": "Mococa"
  },
  {
    "prefixo": "13749",
    "uf": "SP",
    "codigoIbge": 3530508,
    "cidade": "Mococa"
  },
  {
    "prefixo": "13750",
    "uf": "SP",
    "codigoIbge": 3530508,
    "cidade": "Mococa"
  },
  {
    "prefixo": "13755",
    "uf": "SP",
    "codigoIbge": 3530508,
    "cidade": "Mococa"
  },
  {
    "prefixo": "13760",
    "uf": "SP",
    "codigoIbge": 3553609,
    "cidade": "Tapiratiba"
  },
  {
    "prefixo": "13770",
    "uf": "SP",
    "codigoIbge": 3508702,
    "cidade": "Caconde"
  },
  {
    "prefixo": "13775",
    "uf": "SP",
    "codigoIbge": 3508702,
    "cidade": "Caconde"
  },
  {
    "prefixo": "13780",
    "uf": "SP",
    "codigoIbge": 3513900,
    "cidade": "Divinolândia"
  },
  {
    "prefixo": "13785",
    "uf": "SP",
    "codigoIbge": 3513900,
    "cidade": "Divinolândia"
  },
  {
    "prefixo": "13790",
    "uf": "SP",
    "codigoIbge": 3550803,
    "cidade": "São Sebastião da Grama"
  },
  {
    "prefixo": "13800",
    "uf": "SP",
    "codigoIbge": 3530805,
    "cidade": "Mogi Mirim"
  },
  {
    "prefixo": "13801",
    "uf": "SP",
    "codigoIbge": 3530805,
    "cidade": "Mogi Mirim"
  },
  {
    "prefixo": "13802",
    "uf": "SP",
    "codigoIbge": 3530805,
    "cidade": "Mogi Mirim"
  },
  {
    "prefixo": "13803",
    "uf": "SP",
    "codigoIbge": 3530805,
    "cidade": "Mogi Mirim"
  },
  {
    "prefixo": "13804",
    "uf": "SP",
    "codigoIbge": 3530805,
    "cidade": "Mogi Mirim"
  },
  {
    "prefixo": "13805",
    "uf": "SP",
    "codigoIbge": 3530805,
    "cidade": "Mogi Mirim"
  },
  {
    "prefixo": "13806",
    "uf": "SP",
    "codigoIbge": 3530805,
    "cidade": "Mogi Mirim"
  },
  {
    "prefixo": "13807",
    "uf": "SP",
    "codigoIbge": 3530805,
    "cidade": "Mogi Mirim"
  },
  {
    "prefixo": "13808",
    "uf": "SP",
    "codigoIbge": 3530805,
    "cidade": "Mogi Mirim"
  },
  {
    "prefixo": "13814",
    "uf": "SP",
    "codigoIbge": 3530805,
    "cidade": "Mogi Mirim"
  },
  {
    "prefixo": "13817",
    "uf": "SP",
    "codigoIbge": 3530805,
    "cidade": "Mogi Mirim"
  },
  {
    "prefixo": "13820",
    "uf": "SP",
    "codigoIbge": 3531209,
    "cidade": "Monte Alegre do Sul"
  },
  {
    "prefixo": "13824",
    "uf": "SP",
    "codigoIbge": 3531209,
    "cidade": "Monte Alegre do Sul"
  },
  {
    "prefixo": "13825",
    "uf": "SP",
    "codigoIbge": 3519055,
    "cidade": "Holambra"
  },
  {
    "prefixo": "13826",
    "uf": "SP",
    "codigoIbge": 3519055,
    "cidade": "Holambra"
  },
  {
    "prefixo": "13827",
    "uf": "SP",
    "codigoIbge": 3519055,
    "cidade": "Holambra"
  },
  {
    "prefixo": "13828",
    "uf": "SP",
    "codigoIbge": 3519055,
    "cidade": "Holambra"
  },
  {
    "prefixo": "13829",
    "uf": "SP",
    "codigoIbge": 3519055,
    "cidade": "Holambra"
  },
  {
    "prefixo": "13830",
    "uf": "SP",
    "codigoIbge": 3548005,
    "cidade": "Santo Antônio de Posse"
  },
  {
    "prefixo": "13831",
    "uf": "SP",
    "codigoIbge": 3548005,
    "cidade": "Santo Antônio de Posse"
  },
  {
    "prefixo": "13832",
    "uf": "SP",
    "codigoIbge": 3548005,
    "cidade": "Santo Antônio de Posse"
  },
  {
    "prefixo": "13833",
    "uf": "SP",
    "codigoIbge": 3548005,
    "cidade": "Santo Antônio de Posse"
  },
  {
    "prefixo": "13834",
    "uf": "SP",
    "codigoIbge": 3548005,
    "cidade": "Santo Antônio de Posse"
  },
  {
    "prefixo": "13835",
    "uf": "SP",
    "codigoIbge": 3512209,
    "cidade": "Conchal"
  },
  {
    "prefixo": "13836",
    "uf": "SP",
    "codigoIbge": 3512209,
    "cidade": "Conchal"
  },
  {
    "prefixo": "13837",
    "uf": "SP",
    "codigoIbge": 3512209,
    "cidade": "Conchal"
  },
  {
    "prefixo": "13838",
    "uf": "SP",
    "codigoIbge": 3512209,
    "cidade": "Conchal"
  },
  {
    "prefixo": "13839",
    "uf": "SP",
    "codigoIbge": 3512209,
    "cidade": "Conchal"
  },
  {
    "prefixo": "13840",
    "uf": "SP",
    "codigoIbge": 3530706,
    "cidade": "Mogi Guaçu"
  },
  {
    "prefixo": "13841",
    "uf": "SP",
    "codigoIbge": 3530706,
    "cidade": "Mogi Guaçu"
  },
  {
    "prefixo": "13842",
    "uf": "SP",
    "codigoIbge": 3530706,
    "cidade": "Mogi Guaçu"
  },
  {
    "prefixo": "13843",
    "uf": "SP",
    "codigoIbge": 3530706,
    "cidade": "Mogi Guaçu"
  },
  {
    "prefixo": "13844",
    "uf": "SP",
    "codigoIbge": 3530706,
    "cidade": "Mogi Guaçu"
  },
  {
    "prefixo": "13845",
    "uf": "SP",
    "codigoIbge": 3530706,
    "cidade": "Mogi Guaçu"
  },
  {
    "prefixo": "13846",
    "uf": "SP",
    "codigoIbge": 3530706,
    "cidade": "Mogi Guaçu"
  },
  {
    "prefixo": "13847",
    "uf": "SP",
    "codigoIbge": 3530706,
    "cidade": "Mogi Guaçu"
  },
  {
    "prefixo": "13848",
    "uf": "SP",
    "codigoIbge": 3530706,
    "cidade": "Mogi Guaçu"
  },
  {
    "prefixo": "13849",
    "uf": "SP",
    "codigoIbge": 3530706,
    "cidade": "Mogi Guaçu"
  },
  {
    "prefixo": "13855",
    "uf": "SP",
    "codigoIbge": 3530706,
    "cidade": "Mogi Guaçu"
  },
  {
    "prefixo": "13857",
    "uf": "SP",
    "codigoIbge": 3557303,
    "cidade": "Estiva Gerbi"
  },
  {
    "prefixo": "13858",
    "uf": "SP",
    "codigoIbge": 3557303,
    "cidade": "Estiva Gerbi"
  },
  {
    "prefixo": "13860",
    "uf": "SP",
    "codigoIbge": 3500303,
    "cidade": "Aguaí"
  },
  {
    "prefixo": "13862",
    "uf": "SP",
    "codigoIbge": 3500303,
    "cidade": "Aguaí"
  },
  {
    "prefixo": "13863",
    "uf": "SP",
    "codigoIbge": 3500303,
    "cidade": "Aguaí"
  },
  {
    "prefixo": "13864",
    "uf": "SP",
    "codigoIbge": 3500303,
    "cidade": "Aguaí"
  },
  {
    "prefixo": "13866",
    "uf": "SP",
    "codigoIbge": 3500303,
    "cidade": "Aguaí"
  },
  {
    "prefixo": "13868",
    "uf": "SP",
    "codigoIbge": 3500303,
    "cidade": "Aguaí"
  },
  {
    "prefixo": "13869",
    "uf": "SP",
    "codigoIbge": 3500303,
    "cidade": "Aguaí"
  },
  {
    "prefixo": "13870",
    "uf": "SP",
    "codigoIbge": 3549102,
    "cidade": "São João da Boa Vista"
  },
  {
    "prefixo": "13871",
    "uf": "SP",
    "codigoIbge": 3549102,
    "cidade": "São João da Boa Vista"
  },
  {
    "prefixo": "13872",
    "uf": "SP",
    "codigoIbge": 3549102,
    "cidade": "São João da Boa Vista"
  },
  {
    "prefixo": "13873",
    "uf": "SP",
    "codigoIbge": 3549102,
    "cidade": "São João da Boa Vista"
  },
  {
    "prefixo": "13874",
    "uf": "SP",
    "codigoIbge": 3549102,
    "cidade": "São João da Boa Vista"
  },
  {
    "prefixo": "13875",
    "uf": "SP",
    "codigoIbge": 3549102,
    "cidade": "São João da Boa Vista"
  },
  {
    "prefixo": "13876",
    "uf": "SP",
    "codigoIbge": 3549102,
    "cidade": "São João da Boa Vista"
  },
  {
    "prefixo": "13877",
    "uf": "SP",
    "codigoIbge": 3549102,
    "cidade": "São João da Boa Vista"
  },
  {
    "prefixo": "13879",
    "uf": "SP",
    "codigoIbge": 3549102,
    "cidade": "São João da Boa Vista"
  },
  {
    "prefixo": "13880",
    "uf": "SP",
    "codigoIbge": 3556404,
    "cidade": "Vargem Grande do Sul"
  },
  {
    "prefixo": "13890",
    "uf": "SP",
    "codigoIbge": 3500402,
    "cidade": "Águas da Prata"
  },
  {
    "prefixo": "13895",
    "uf": "SP",
    "codigoIbge": 3500402,
    "cidade": "Águas da Prata"
  },
  {
    "prefixo": "13900",
    "uf": "SP",
    "codigoIbge": 3501905,
    "cidade": "Amparo"
  },
  {
    "prefixo": "13901",
    "uf": "SP",
    "codigoIbge": 3501905,
    "cidade": "Amparo"
  },
  {
    "prefixo": "13902",
    "uf": "SP",
    "codigoIbge": 3501905,
    "cidade": "Amparo"
  },
  {
    "prefixo": "13903",
    "uf": "SP",
    "codigoIbge": 3501905,
    "cidade": "Amparo"
  },
  {
    "prefixo": "13904",
    "uf": "SP",
    "codigoIbge": 3501905,
    "cidade": "Amparo"
  },
  {
    "prefixo": "13905",
    "uf": "SP",
    "codigoIbge": 3501905,
    "cidade": "Amparo"
  },
  {
    "prefixo": "13907",
    "uf": "SP",
    "codigoIbge": 3501905,
    "cidade": "Amparo"
  },
  {
    "prefixo": "13908",
    "uf": "SP",
    "codigoIbge": 3501905,
    "cidade": "Amparo"
  },
  {
    "prefixo": "13909",
    "uf": "SP",
    "codigoIbge": 3501905,
    "cidade": "Amparo"
  },
  {
    "prefixo": "13910",
    "uf": "SP",
    "codigoIbge": 3524709,
    "cidade": "Jaguariúna"
  },
  {
    "prefixo": "13911",
    "uf": "SP",
    "codigoIbge": 3524709,
    "cidade": "Jaguariúna"
  },
  {
    "prefixo": "13912",
    "uf": "SP",
    "codigoIbge": 3524709,
    "cidade": "Jaguariúna"
  },
  {
    "prefixo": "13913",
    "uf": "SP",
    "codigoIbge": 3524709,
    "cidade": "Jaguariúna"
  },
  {
    "prefixo": "13914",
    "uf": "SP",
    "codigoIbge": 3524709,
    "cidade": "Jaguariúna"
  },
  {
    "prefixo": "13915",
    "uf": "SP",
    "codigoIbge": 3524709,
    "cidade": "Jaguariúna"
  },
  {
    "prefixo": "13916",
    "uf": "SP",
    "codigoIbge": 3524709,
    "cidade": "Jaguariúna"
  },
  {
    "prefixo": "13917",
    "uf": "SP",
    "codigoIbge": 3524709,
    "cidade": "Jaguariúna"
  },
  {
    "prefixo": "13918",
    "uf": "SP",
    "codigoIbge": 3524709,
    "cidade": "Jaguariúna"
  },
  {
    "prefixo": "13919",
    "uf": "SP",
    "codigoIbge": 3524709,
    "cidade": "Jaguariúna"
  },
  {
    "prefixo": "13920",
    "uf": "SP",
    "codigoIbge": 3537107,
    "cidade": "Pedreira"
  },
  {
    "prefixo": "13921",
    "uf": "SP",
    "codigoIbge": 3537107,
    "cidade": "Pedreira"
  },
  {
    "prefixo": "13922",
    "uf": "SP",
    "codigoIbge": 3537107,
    "cidade": "Pedreira"
  },
  {
    "prefixo": "13923",
    "uf": "SP",
    "codigoIbge": 3537107,
    "cidade": "Pedreira"
  },
  {
    "prefixo": "13925",
    "uf": "SP",
    "codigoIbge": 3537107,
    "cidade": "Pedreira"
  },
  {
    "prefixo": "13927",
    "uf": "SP",
    "codigoIbge": 3537107,
    "cidade": "Pedreira"
  },
  {
    "prefixo": "13928",
    "uf": "SP",
    "codigoIbge": 3537107,
    "cidade": "Pedreira"
  },
  {
    "prefixo": "13930",
    "uf": "SP",
    "codigoIbge": 3551603,
    "cidade": "Serra Negra"
  },
  {
    "prefixo": "13940",
    "uf": "SP",
    "codigoIbge": 3500501,
    "cidade": "Águas de Lindóia"
  },
  {
    "prefixo": "13950",
    "uf": "SP",
    "codigoIbge": 3527009,
    "cidade": "Lindóia"
  },
  {
    "prefixo": "13960",
    "uf": "SP",
    "codigoIbge": 3552106,
    "cidade": "Socorro"
  },
  {
    "prefixo": "13970",
    "uf": "SP",
    "codigoIbge": 3522604,
    "cidade": "Itapira"
  },
  {
    "prefixo": "13971",
    "uf": "SP",
    "codigoIbge": 3522604,
    "cidade": "Itapira"
  },
  {
    "prefixo": "13972",
    "uf": "SP",
    "codigoIbge": 3522604,
    "cidade": "Itapira"
  },
  {
    "prefixo": "13973",
    "uf": "SP",
    "codigoIbge": 3522604,
    "cidade": "Itapira"
  },
  {
    "prefixo": "13974",
    "uf": "SP",
    "codigoIbge": 3522604,
    "cidade": "Itapira"
  },
  {
    "prefixo": "13975",
    "uf": "SP",
    "codigoIbge": 3522604,
    "cidade": "Itapira"
  },
  {
    "prefixo": "13976",
    "uf": "SP",
    "codigoIbge": 3522604,
    "cidade": "Itapira"
  },
  {
    "prefixo": "13977",
    "uf": "SP",
    "codigoIbge": 3522604,
    "cidade": "Itapira"
  },
  {
    "prefixo": "13985",
    "uf": "SP",
    "codigoIbge": 3522604,
    "cidade": "Itapira"
  },
  {
    "prefixo": "13986",
    "uf": "SP",
    "codigoIbge": 3522604,
    "cidade": "Itapira"
  },
  {
    "prefixo": "13988",
    "uf": "SP",
    "codigoIbge": 3522604,
    "cidade": "Itapira"
  },
  {
    "prefixo": "13990",
    "uf": "SP",
    "codigoIbge": 3515186,
    "cidade": "Espírito Santo do Pinhal"
  },
  {
    "prefixo": "13995",
    "uf": "SP",
    "codigoIbge": 3548104,
    "cidade": "Santo Antônio do Jardim"
  },
  {
    "prefixo": "14000",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14010",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14015",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14020",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14021",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14022",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14024",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14025",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14026",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14027",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14028",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14029",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14030",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14031",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14032",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14033",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14034",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14035",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14037",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14039",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14040",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14050",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14051",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14052",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14055",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14056",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14057",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14058",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14059",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14060",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14061",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14062",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14063",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14065",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14066",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14070",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14071",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14072",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14073",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14075",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14076",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14077",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14078",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14079",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14080",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14085",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14090",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14091",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14092",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14093",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14094",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14095",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14096",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14097",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14098",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14101",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14106",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14109",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14110",
    "uf": "SP",
    "codigoIbge": 3543402,
    "cidade": "Ribeirão Preto"
  },
  {
    "prefixo": "14115",
    "uf": "SP",
    "codigoIbge": 3518859,
    "cidade": "Guatapará"
  },
  {
    "prefixo": "14120",
    "uf": "SP",
    "codigoIbge": 3514601,
    "cidade": "Dumont"
  },
  {
    "prefixo": "14140",
    "uf": "SP",
    "codigoIbge": 3513108,
    "cidade": "Cravinhos"
  },
  {
    "prefixo": "14150",
    "uf": "SP",
    "codigoIbge": 3551504,
    "cidade": "Serrana"
  },
  {
    "prefixo": "14160",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14161",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14164",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14165",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14166",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14168",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14169",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14170",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14171",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14173",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14174",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14175",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14176",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14177",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14178",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14179",
    "uf": "SP",
    "codigoIbge": 3551702,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "14180",
    "uf": "SP",
    "codigoIbge": 3540200,
    "cidade": "Pontal"
  },
  {
    "prefixo": "14185",
    "uf": "SP",
    "codigoIbge": 3540200,
    "cidade": "Pontal"
  },
  {
    "prefixo": "14200",
    "uf": "SP",
    "codigoIbge": 3550902,
    "cidade": "São Simão"
  },
  {
    "prefixo": "14210",
    "uf": "SP",
    "codigoIbge": 3527603,
    "cidade": "Luís Antônio"
  },
  {
    "prefixo": "14212",
    "uf": "SP",
    "codigoIbge": 3527603,
    "cidade": "Luís Antônio"
  },
  {
    "prefixo": "14214",
    "uf": "SP",
    "codigoIbge": 3527603,
    "cidade": "Luís Antônio"
  },
  {
    "prefixo": "14216",
    "uf": "SP",
    "codigoIbge": 3527603,
    "cidade": "Luís Antônio"
  },
  {
    "prefixo": "14230",
    "uf": "SP",
    "codigoIbge": 3551405,
    "cidade": "Serra Azul"
  },
  {
    "prefixo": "14240",
    "uf": "SP",
    "codigoIbge": 3509403,
    "cidade": "Cajuru"
  },
  {
    "prefixo": "14250",
    "uf": "SP",
    "codigoIbge": 3546256,
    "cidade": "Santa Cruz da Esperança"
  },
  {
    "prefixo": "14260",
    "uf": "SP",
    "codigoIbge": 3510906,
    "cidade": "Cássia dos Coqueiros"
  },
  {
    "prefixo": "14270",
    "uf": "SP",
    "codigoIbge": 3547601,
    "cidade": "Santa Rosa de Viterbo"
  },
  {
    "prefixo": "14300",
    "uf": "SP",
    "codigoIbge": 3505906,
    "cidade": "Batatais"
  },
  {
    "prefixo": "14302",
    "uf": "SP",
    "codigoIbge": 3505906,
    "cidade": "Batatais"
  },
  {
    "prefixo": "14305",
    "uf": "SP",
    "codigoIbge": 3505906,
    "cidade": "Batatais"
  },
  {
    "prefixo": "14307",
    "uf": "SP",
    "codigoIbge": 3505906,
    "cidade": "Batatais"
  },
  {
    "prefixo": "14310",
    "uf": "SP",
    "codigoIbge": 3505906,
    "cidade": "Batatais"
  },
  {
    "prefixo": "14312",
    "uf": "SP",
    "codigoIbge": 3505906,
    "cidade": "Batatais"
  },
  {
    "prefixo": "14313",
    "uf": "SP",
    "codigoIbge": 3505906,
    "cidade": "Batatais"
  },
  {
    "prefixo": "14315",
    "uf": "SP",
    "codigoIbge": 3505906,
    "cidade": "Batatais"
  },
  {
    "prefixo": "14316",
    "uf": "SP",
    "codigoIbge": 3505906,
    "cidade": "Batatais"
  },
  {
    "prefixo": "14319",
    "uf": "SP",
    "codigoIbge": 3505906,
    "cidade": "Batatais"
  },
  {
    "prefixo": "14340",
    "uf": "SP",
    "codigoIbge": 3507803,
    "cidade": "Brodowski"
  },
  {
    "prefixo": "14350",
    "uf": "SP",
    "codigoIbge": 3501004,
    "cidade": "Altinópolis"
  },
  {
    "prefixo": "14352",
    "uf": "SP",
    "codigoIbge": 3501004,
    "cidade": "Altinópolis"
  },
  {
    "prefixo": "14355",
    "uf": "SP",
    "codigoIbge": 3501004,
    "cidade": "Altinópolis"
  },
  {
    "prefixo": "14357",
    "uf": "SP",
    "codigoIbge": 3501004,
    "cidade": "Altinópolis"
  },
  {
    "prefixo": "14390",
    "uf": "SP",
    "codigoIbge": 3547908,
    "cidade": "Santo Antônio da Alegria"
  },
  {
    "prefixo": "14400",
    "uf": "SP",
    "codigoIbge": 3516200,
    "cidade": "Franca"
  },
  {
    "prefixo": "14401",
    "uf": "SP",
    "codigoIbge": 3516200,
    "cidade": "Franca"
  },
  {
    "prefixo": "14402",
    "uf": "SP",
    "codigoIbge": 3516200,
    "cidade": "Franca"
  },
  {
    "prefixo": "14403",
    "uf": "SP",
    "codigoIbge": 3516200,
    "cidade": "Franca"
  },
  {
    "prefixo": "14404",
    "uf": "SP",
    "codigoIbge": 3516200,
    "cidade": "Franca"
  },
  {
    "prefixo": "14405",
    "uf": "SP",
    "codigoIbge": 3516200,
    "cidade": "Franca"
  },
  {
    "prefixo": "14406",
    "uf": "SP",
    "codigoIbge": 3516200,
    "cidade": "Franca"
  },
  {
    "prefixo": "14407",
    "uf": "SP",
    "codigoIbge": 3516200,
    "cidade": "Franca"
  },
  {
    "prefixo": "14408",
    "uf": "SP",
    "codigoIbge": 3516200,
    "cidade": "Franca"
  },
  {
    "prefixo": "14409",
    "uf": "SP",
    "codigoIbge": 3516200,
    "cidade": "Franca"
  },
  {
    "prefixo": "14410",
    "uf": "SP",
    "codigoIbge": 3516200,
    "cidade": "Franca"
  },
  {
    "prefixo": "14412",
    "uf": "SP",
    "codigoIbge": 3516200,
    "cidade": "Franca"
  },
  {
    "prefixo": "14414",
    "uf": "SP",
    "codigoIbge": 3516200,
    "cidade": "Franca"
  },
  {
    "prefixo": "14415",
    "uf": "SP",
    "codigoIbge": 3536307,
    "cidade": "Patrocínio Paulista"
  },
  {
    "prefixo": "14416",
    "uf": "SP",
    "codigoIbge": 3536307,
    "cidade": "Patrocínio Paulista"
  },
  {
    "prefixo": "14417",
    "uf": "SP",
    "codigoIbge": 3536307,
    "cidade": "Patrocínio Paulista"
  },
  {
    "prefixo": "14420",
    "uf": "SP",
    "codigoIbge": 3523701,
    "cidade": "Itirapuã"
  },
  {
    "prefixo": "14430",
    "uf": "SP",
    "codigoIbge": 3542701,
    "cidade": "Restinga"
  },
  {
    "prefixo": "14440",
    "uf": "SP",
    "codigoIbge": 3549508,
    "cidade": "São José da Bela Vista"
  },
  {
    "prefixo": "14445",
    "uf": "SP",
    "codigoIbge": 3543105,
    "cidade": "Ribeirão Corrente"
  },
  {
    "prefixo": "14450",
    "uf": "SP",
    "codigoIbge": 3525409,
    "cidade": "Jeriquara"
  },
  {
    "prefixo": "14460",
    "uf": "SP",
    "codigoIbge": 3513207,
    "cidade": "Cristais Paulista"
  },
  {
    "prefixo": "14470",
    "uf": "SP",
    "codigoIbge": 3537008,
    "cidade": "Pedregulho"
  },
  {
    "prefixo": "14475",
    "uf": "SP",
    "codigoIbge": 3537008,
    "cidade": "Pedregulho"
  },
  {
    "prefixo": "14480",
    "uf": "SP",
    "codigoIbge": 3537008,
    "cidade": "Pedregulho"
  },
  {
    "prefixo": "14490",
    "uf": "SP",
    "codigoIbge": 3543600,
    "cidade": "Rifaina"
  },
  {
    "prefixo": "14500",
    "uf": "SP",
    "codigoIbge": 3524105,
    "cidade": "Ituverava"
  },
  {
    "prefixo": "14505",
    "uf": "SP",
    "codigoIbge": 3524105,
    "cidade": "Ituverava"
  },
  {
    "prefixo": "14508",
    "uf": "SP",
    "codigoIbge": 3524105,
    "cidade": "Ituverava"
  },
  {
    "prefixo": "14530",
    "uf": "SP",
    "codigoIbge": 3529708,
    "cidade": "Miguelópolis"
  },
  {
    "prefixo": "14540",
    "uf": "SP",
    "codigoIbge": 3520103,
    "cidade": "Igarapava"
  },
  {
    "prefixo": "14550",
    "uf": "SP",
    "codigoIbge": 3503000,
    "cidade": "Aramina"
  },
  {
    "prefixo": "14552",
    "uf": "SP",
    "codigoIbge": 3503000,
    "cidade": "Aramina"
  },
  {
    "prefixo": "14555",
    "uf": "SP",
    "codigoIbge": 3503000,
    "cidade": "Aramina"
  },
  {
    "prefixo": "14559",
    "uf": "SP",
    "codigoIbge": 3503000,
    "cidade": "Aramina"
  },
  {
    "prefixo": "14570",
    "uf": "SP",
    "codigoIbge": 3508207,
    "cidade": "Buritizal"
  },
  {
    "prefixo": "14580",
    "uf": "SP",
    "codigoIbge": 3517703,
    "cidade": "Guará"
  },
  {
    "prefixo": "14600",
    "uf": "SP",
    "codigoIbge": 3549409,
    "cidade": "São Joaquim da Barra"
  },
  {
    "prefixo": "14610",
    "uf": "SP",
    "codigoIbge": 3521309,
    "cidade": "Ipuã"
  },
  {
    "prefixo": "14620",
    "uf": "SP",
    "codigoIbge": 3534302,
    "cidade": "Orlândia"
  },
  {
    "prefixo": "14640",
    "uf": "SP",
    "codigoIbge": 3531902,
    "cidade": "Morro Agudo"
  },
  {
    "prefixo": "14642",
    "uf": "SP",
    "codigoIbge": 3531902,
    "cidade": "Morro Agudo"
  },
  {
    "prefixo": "14645",
    "uf": "SP",
    "codigoIbge": 3531902,
    "cidade": "Morro Agudo"
  },
  {
    "prefixo": "14647",
    "uf": "SP",
    "codigoIbge": 3531902,
    "cidade": "Morro Agudo"
  },
  {
    "prefixo": "14660",
    "uf": "SP",
    "codigoIbge": 3544905,
    "cidade": "Sales Oliveira"
  },
  {
    "prefixo": "14670",
    "uf": "SP",
    "codigoIbge": 3533601,
    "cidade": "Nuporanga"
  },
  {
    "prefixo": "14680",
    "uf": "SP",
    "codigoIbge": 3525102,
    "cidade": "Jardinópolis"
  },
  {
    "prefixo": "14690",
    "uf": "SP",
    "codigoIbge": 3525102,
    "cidade": "Jardinópolis"
  },
  {
    "prefixo": "14700",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14701",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14702",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14703",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14704",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14705",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14706",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14707",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14708",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14709",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14710",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14711",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14713",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14714",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14715",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14716",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14717",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14718",
    "uf": "SP",
    "codigoIbge": 3506102,
    "cidade": "Bebedouro"
  },
  {
    "prefixo": "14720",
    "uf": "SP",
    "codigoIbge": 3553203,
    "cidade": "Taiúva"
  },
  {
    "prefixo": "14725",
    "uf": "SP",
    "codigoIbge": 3553104,
    "cidade": "Taiaçu"
  },
  {
    "prefixo": "14730",
    "uf": "SP",
    "codigoIbge": 3531506,
    "cidade": "Monte Azul Paulista"
  },
  {
    "prefixo": "14733",
    "uf": "SP",
    "codigoIbge": 3531506,
    "cidade": "Monte Azul Paulista"
  },
  {
    "prefixo": "14735",
    "uf": "SP",
    "codigoIbge": 3551900,
    "cidade": "Severínia"
  },
  {
    "prefixo": "14740",
    "uf": "SP",
    "codigoIbge": 3556800,
    "cidade": "Viradouro"
  },
  {
    "prefixo": "14745",
    "uf": "SP",
    "codigoIbge": 3554409,
    "cidade": "Terra Roxa"
  },
  {
    "prefixo": "14750",
    "uf": "SP",
    "codigoIbge": 3539509,
    "cidade": "Pitangueiras"
  },
  {
    "prefixo": "14760",
    "uf": "SP",
    "codigoIbge": 3539509,
    "cidade": "Pitangueiras"
  },
  {
    "prefixo": "14765",
    "uf": "SP",
    "codigoIbge": 3553658,
    "cidade": "Taquaral"
  },
  {
    "prefixo": "14770",
    "uf": "SP",
    "codigoIbge": 3512001,
    "cidade": "Colina"
  },
  {
    "prefixo": "14775",
    "uf": "SP",
    "codigoIbge": 3524204,
    "cidade": "Jaborandi"
  },
  {
    "prefixo": "14780",
    "uf": "SP",
    "codigoIbge": 3505500,
    "cidade": "Barretos"
  },
  {
    "prefixo": "14781",
    "uf": "SP",
    "codigoIbge": 3505500,
    "cidade": "Barretos"
  },
  {
    "prefixo": "14782",
    "uf": "SP",
    "codigoIbge": 3505500,
    "cidade": "Barretos"
  },
  {
    "prefixo": "14783",
    "uf": "SP",
    "codigoIbge": 3505500,
    "cidade": "Barretos"
  },
  {
    "prefixo": "14784",
    "uf": "SP",
    "codigoIbge": 3505500,
    "cidade": "Barretos"
  },
  {
    "prefixo": "14785",
    "uf": "SP",
    "codigoIbge": 3505500,
    "cidade": "Barretos"
  },
  {
    "prefixo": "14786",
    "uf": "SP",
    "codigoIbge": 3505500,
    "cidade": "Barretos"
  },
  {
    "prefixo": "14787",
    "uf": "SP",
    "codigoIbge": 3505500,
    "cidade": "Barretos"
  },
  {
    "prefixo": "14788",
    "uf": "SP",
    "codigoIbge": 3505500,
    "cidade": "Barretos"
  },
  {
    "prefixo": "14789",
    "uf": "SP",
    "codigoIbge": 3505500,
    "cidade": "Barretos"
  },
  {
    "prefixo": "14790",
    "uf": "SP",
    "codigoIbge": 3517406,
    "cidade": "Guaíra"
  },
  {
    "prefixo": "14795",
    "uf": "SP",
    "codigoIbge": 3512100,
    "cidade": "Colômbia"
  },
  {
    "prefixo": "14800",
    "uf": "SP",
    "codigoIbge": 3503208,
    "cidade": "Araraquara"
  },
  {
    "prefixo": "14801",
    "uf": "SP",
    "codigoIbge": 3503208,
    "cidade": "Araraquara"
  },
  {
    "prefixo": "14802",
    "uf": "SP",
    "codigoIbge": 3503208,
    "cidade": "Araraquara"
  },
  {
    "prefixo": "14803",
    "uf": "SP",
    "codigoIbge": 3503208,
    "cidade": "Araraquara"
  },
  {
    "prefixo": "14804",
    "uf": "SP",
    "codigoIbge": 3503208,
    "cidade": "Araraquara"
  },
  {
    "prefixo": "14805",
    "uf": "SP",
    "codigoIbge": 3503208,
    "cidade": "Araraquara"
  },
  {
    "prefixo": "14806",
    "uf": "SP",
    "codigoIbge": 3503208,
    "cidade": "Araraquara"
  },
  {
    "prefixo": "14807",
    "uf": "SP",
    "codigoIbge": 3503208,
    "cidade": "Araraquara"
  },
  {
    "prefixo": "14808",
    "uf": "SP",
    "codigoIbge": 3503208,
    "cidade": "Araraquara"
  },
  {
    "prefixo": "14809",
    "uf": "SP",
    "codigoIbge": 3503208,
    "cidade": "Araraquara"
  },
  {
    "prefixo": "14810",
    "uf": "SP",
    "codigoIbge": 3503208,
    "cidade": "Araraquara"
  },
  {
    "prefixo": "14811",
    "uf": "SP",
    "codigoIbge": 3503208,
    "cidade": "Araraquara"
  },
  {
    "prefixo": "14812",
    "uf": "SP",
    "codigoIbge": 3503208,
    "cidade": "Araraquara"
  },
  {
    "prefixo": "14813",
    "uf": "SP",
    "codigoIbge": 3516853,
    "cidade": "Gavião Peixoto"
  },
  {
    "prefixo": "14815",
    "uf": "SP",
    "codigoIbge": 3519303,
    "cidade": "Ibaté"
  },
  {
    "prefixo": "14816",
    "uf": "SP",
    "codigoIbge": 3519303,
    "cidade": "Ibaté"
  },
  {
    "prefixo": "14817",
    "uf": "SP",
    "codigoIbge": 3519303,
    "cidade": "Ibaté"
  },
  {
    "prefixo": "14818",
    "uf": "SP",
    "codigoIbge": 3519303,
    "cidade": "Ibaté"
  },
  {
    "prefixo": "14820",
    "uf": "SP",
    "codigoIbge": 3501707,
    "cidade": "Américo Brasiliense"
  },
  {
    "prefixo": "14821",
    "uf": "SP",
    "codigoIbge": 3501707,
    "cidade": "Américo Brasiliense"
  },
  {
    "prefixo": "14823",
    "uf": "SP",
    "codigoIbge": 3501707,
    "cidade": "Américo Brasiliense"
  },
  {
    "prefixo": "14824",
    "uf": "SP",
    "codigoIbge": 3501707,
    "cidade": "Américo Brasiliense"
  },
  {
    "prefixo": "14825",
    "uf": "SP",
    "codigoIbge": 3546900,
    "cidade": "Santa Lúcia"
  },
  {
    "prefixo": "14827",
    "uf": "SP",
    "codigoIbge": 3546900,
    "cidade": "Santa Lúcia"
  },
  {
    "prefixo": "14830",
    "uf": "SP",
    "codigoIbge": 3543709,
    "cidade": "Rincão"
  },
  {
    "prefixo": "14832",
    "uf": "SP",
    "codigoIbge": 3543709,
    "cidade": "Rincão"
  },
  {
    "prefixo": "14834",
    "uf": "SP",
    "codigoIbge": 3543709,
    "cidade": "Rincão"
  },
  {
    "prefixo": "14835",
    "uf": "SP",
    "codigoIbge": 3532058,
    "cidade": "Motuca"
  },
  {
    "prefixo": "14840",
    "uf": "SP",
    "codigoIbge": 3518602,
    "cidade": "Guariba"
  },
  {
    "prefixo": "14841",
    "uf": "SP",
    "codigoIbge": 3518602,
    "cidade": "Guariba"
  },
  {
    "prefixo": "14842",
    "uf": "SP",
    "codigoIbge": 3518602,
    "cidade": "Guariba"
  },
  {
    "prefixo": "14845",
    "uf": "SP",
    "codigoIbge": 3518602,
    "cidade": "Guariba"
  },
  {
    "prefixo": "14847",
    "uf": "SP",
    "codigoIbge": 3518602,
    "cidade": "Guariba"
  },
  {
    "prefixo": "14850",
    "uf": "SP",
    "codigoIbge": 3540903,
    "cidade": "Pradópolis"
  },
  {
    "prefixo": "14860",
    "uf": "SP",
    "codigoIbge": 3505609,
    "cidade": "Barrinha"
  },
  {
    "prefixo": "14870",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14871",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14872",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14873",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14874",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14875",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14876",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14877",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14882",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14883",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14884",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14885",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14887",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14888",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14890",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14892",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14896",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14897",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14898",
    "uf": "SP",
    "codigoIbge": 3524303,
    "cidade": "Jaboticabal"
  },
  {
    "prefixo": "14900",
    "uf": "SP",
    "codigoIbge": 3522703,
    "cidade": "Itápolis"
  },
  {
    "prefixo": "14902",
    "uf": "SP",
    "codigoIbge": 3522703,
    "cidade": "Itápolis"
  },
  {
    "prefixo": "14904",
    "uf": "SP",
    "codigoIbge": 3522703,
    "cidade": "Itápolis"
  },
  {
    "prefixo": "14906",
    "uf": "SP",
    "codigoIbge": 3522703,
    "cidade": "Itápolis"
  },
  {
    "prefixo": "14907",
    "uf": "SP",
    "codigoIbge": 3522703,
    "cidade": "Itápolis"
  },
  {
    "prefixo": "14908",
    "uf": "SP",
    "codigoIbge": 3522703,
    "cidade": "Itápolis"
  },
  {
    "prefixo": "14909",
    "uf": "SP",
    "codigoIbge": 3522703,
    "cidade": "Itápolis"
  },
  {
    "prefixo": "14910",
    "uf": "SP",
    "codigoIbge": 3552700,
    "cidade": "Tabatinga"
  },
  {
    "prefixo": "14913",
    "uf": "SP",
    "codigoIbge": 3552700,
    "cidade": "Tabatinga"
  },
  {
    "prefixo": "14914",
    "uf": "SP",
    "codigoIbge": 3552700,
    "cidade": "Tabatinga"
  },
  {
    "prefixo": "14918",
    "uf": "SP",
    "codigoIbge": 3552700,
    "cidade": "Tabatinga"
  },
  {
    "prefixo": "14919",
    "uf": "SP",
    "codigoIbge": 3552700,
    "cidade": "Tabatinga"
  },
  {
    "prefixo": "14920",
    "uf": "SP",
    "codigoIbge": 3532900,
    "cidade": "Nova Europa"
  },
  {
    "prefixo": "14930",
    "uf": "SP",
    "codigoIbge": 3506706,
    "cidade": "Boa Esperança do Sul"
  },
  {
    "prefixo": "14935",
    "uf": "SP",
    "codigoIbge": 3554755,
    "cidade": "Trabiju"
  },
  {
    "prefixo": "14940",
    "uf": "SP",
    "codigoIbge": 3519600,
    "cidade": "Ibitinga"
  },
  {
    "prefixo": "14942",
    "uf": "SP",
    "codigoIbge": 3519600,
    "cidade": "Ibitinga"
  },
  {
    "prefixo": "14943",
    "uf": "SP",
    "codigoIbge": 3519600,
    "cidade": "Ibitinga"
  },
  {
    "prefixo": "14944",
    "uf": "SP",
    "codigoIbge": 3519600,
    "cidade": "Ibitinga"
  },
  {
    "prefixo": "14945",
    "uf": "SP",
    "codigoIbge": 3519600,
    "cidade": "Ibitinga"
  },
  {
    "prefixo": "14946",
    "uf": "SP",
    "codigoIbge": 3519600,
    "cidade": "Ibitinga"
  },
  {
    "prefixo": "14947",
    "uf": "SP",
    "codigoIbge": 3519600,
    "cidade": "Ibitinga"
  },
  {
    "prefixo": "14948",
    "uf": "SP",
    "codigoIbge": 3519600,
    "cidade": "Ibitinga"
  },
  {
    "prefixo": "14949",
    "uf": "SP",
    "codigoIbge": 3519600,
    "cidade": "Ibitinga"
  },
  {
    "prefixo": "14955",
    "uf": "SP",
    "codigoIbge": 3507407,
    "cidade": "Borborema"
  },
  {
    "prefixo": "14960",
    "uf": "SP",
    "codigoIbge": 3533502,
    "cidade": "Novo Horizonte"
  },
  {
    "prefixo": "14962",
    "uf": "SP",
    "codigoIbge": 3533502,
    "cidade": "Novo Horizonte"
  },
  {
    "prefixo": "14965",
    "uf": "SP",
    "codigoIbge": 3533502,
    "cidade": "Novo Horizonte"
  },
  {
    "prefixo": "14966",
    "uf": "SP",
    "codigoIbge": 3533502,
    "cidade": "Novo Horizonte"
  },
  {
    "prefixo": "14967",
    "uf": "SP",
    "codigoIbge": 3533502,
    "cidade": "Novo Horizonte"
  },
  {
    "prefixo": "14968",
    "uf": "SP",
    "codigoIbge": 3533502,
    "cidade": "Novo Horizonte"
  },
  {
    "prefixo": "14969",
    "uf": "SP",
    "codigoIbge": 3533502,
    "cidade": "Novo Horizonte"
  },
  {
    "prefixo": "14980",
    "uf": "SP",
    "codigoIbge": 3544806,
    "cidade": "Sales"
  },
  {
    "prefixo": "14990",
    "uf": "SP",
    "codigoIbge": 3521507,
    "cidade": "Irapuã"
  },
  {
    "prefixo": "15010",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15013",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15014",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15015",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15020",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15025",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15030",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15035",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15038",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15040",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15041",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15042",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15043",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15044",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15045",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15046",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15047",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15048",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15050",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15051",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15052",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15053",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15054",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15055",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15056",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15057",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15060",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15061",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15062",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15063",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15064",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15070",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15075",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15076",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15077",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15080",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15081",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15082",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15084",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15085",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15086",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15087",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15090",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15091",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15092",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15093",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15102",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15104",
    "uf": "SP",
    "codigoIbge": 3549805,
    "cidade": "São José do Rio Preto"
  },
  {
    "prefixo": "15105",
    "uf": "SP",
    "codigoIbge": 3540804,
    "cidade": "Potirendaba"
  },
  {
    "prefixo": "15108",
    "uf": "SP",
    "codigoIbge": 3521150,
    "cidade": "Ipiguá"
  },
  {
    "prefixo": "15109",
    "uf": "SP",
    "codigoIbge": 3521150,
    "cidade": "Ipiguá"
  },
  {
    "prefixo": "15110",
    "uf": "SP",
    "codigoIbge": 3517505,
    "cidade": "Guapiaçu"
  },
  {
    "prefixo": "15115",
    "uf": "SP",
    "codigoIbge": 3504602,
    "cidade": "Bady Bassitt"
  },
  {
    "prefixo": "15120",
    "uf": "SP",
    "codigoIbge": 3532504,
    "cidade": "Neves Paulista"
  },
  {
    "prefixo": "15121",
    "uf": "SP",
    "codigoIbge": 3532504,
    "cidade": "Neves Paulista"
  },
  {
    "prefixo": "15122",
    "uf": "SP",
    "codigoIbge": 3532504,
    "cidade": "Neves Paulista"
  },
  {
    "prefixo": "15123",
    "uf": "SP",
    "codigoIbge": 3532504,
    "cidade": "Neves Paulista"
  },
  {
    "prefixo": "15125",
    "uf": "SP",
    "codigoIbge": 3532504,
    "cidade": "Neves Paulista"
  },
  {
    "prefixo": "15128",
    "uf": "SP",
    "codigoIbge": 3532504,
    "cidade": "Neves Paulista"
  },
  {
    "prefixo": "15129",
    "uf": "SP",
    "codigoIbge": 3532504,
    "cidade": "Neves Paulista"
  },
  {
    "prefixo": "15130",
    "uf": "SP",
    "codigoIbge": 3530300,
    "cidade": "Mirassol"
  },
  {
    "prefixo": "15131",
    "uf": "SP",
    "codigoIbge": 3530300,
    "cidade": "Mirassol"
  },
  {
    "prefixo": "15132",
    "uf": "SP",
    "codigoIbge": 3530300,
    "cidade": "Mirassol"
  },
  {
    "prefixo": "15133",
    "uf": "SP",
    "codigoIbge": 3530300,
    "cidade": "Mirassol"
  },
  {
    "prefixo": "15134",
    "uf": "SP",
    "codigoIbge": 3530300,
    "cidade": "Mirassol"
  },
  {
    "prefixo": "15135",
    "uf": "SP",
    "codigoIbge": 3530300,
    "cidade": "Mirassol"
  },
  {
    "prefixo": "15137",
    "uf": "SP",
    "codigoIbge": 3530300,
    "cidade": "Mirassol"
  },
  {
    "prefixo": "15138",
    "uf": "SP",
    "codigoIbge": 3530300,
    "cidade": "Mirassol"
  },
  {
    "prefixo": "15139",
    "uf": "SP",
    "codigoIbge": 3530300,
    "cidade": "Mirassol"
  },
  {
    "prefixo": "15140",
    "uf": "SP",
    "codigoIbge": 3504800,
    "cidade": "Bálsamo"
  },
  {
    "prefixo": "15145",
    "uf": "SP",
    "codigoIbge": 3530409,
    "cidade": "Mirassolândia"
  },
  {
    "prefixo": "15150",
    "uf": "SP",
    "codigoIbge": 3531407,
    "cidade": "Monte Aprazível"
  },
  {
    "prefixo": "15152",
    "uf": "SP",
    "codigoIbge": 3531407,
    "cidade": "Monte Aprazível"
  },
  {
    "prefixo": "15153",
    "uf": "SP",
    "codigoIbge": 3531407,
    "cidade": "Monte Aprazível"
  },
  {
    "prefixo": "15154",
    "uf": "SP",
    "codigoIbge": 3531407,
    "cidade": "Monte Aprazível"
  },
  {
    "prefixo": "15155",
    "uf": "SP",
    "codigoIbge": 3524501,
    "cidade": "Jaci"
  },
  {
    "prefixo": "15160",
    "uf": "SP",
    "codigoIbge": 3539905,
    "cidade": "Poloni"
  },
  {
    "prefixo": "15162",
    "uf": "SP",
    "codigoIbge": 3539905,
    "cidade": "Poloni"
  },
  {
    "prefixo": "15170",
    "uf": "SP",
    "codigoIbge": 3553401,
    "cidade": "Tanabi"
  },
  {
    "prefixo": "15175",
    "uf": "SP",
    "codigoIbge": 3553401,
    "cidade": "Tanabi"
  },
  {
    "prefixo": "15180",
    "uf": "SP",
    "codigoIbge": 3551306,
    "cidade": "Sebastianópolis do Sul"
  },
  {
    "prefixo": "15190",
    "uf": "SP",
    "codigoIbge": 3532603,
    "cidade": "Nhandeara"
  },
  {
    "prefixo": "15195",
    "uf": "SP",
    "codigoIbge": 3532603,
    "cidade": "Nhandeara"
  },
  {
    "prefixo": "15200",
    "uf": "SP",
    "codigoIbge": 3525706,
    "cidade": "José Bonifácio"
  },
  {
    "prefixo": "15208",
    "uf": "SP",
    "codigoIbge": 3525706,
    "cidade": "José Bonifácio"
  },
  {
    "prefixo": "15210",
    "uf": "SP",
    "codigoIbge": 3532801,
    "cidade": "Nova Aliança"
  },
  {
    "prefixo": "15215",
    "uf": "SP",
    "codigoIbge": 3532801,
    "cidade": "Nova Aliança"
  },
  {
    "prefixo": "15220",
    "uf": "SP",
    "codigoIbge": 3529500,
    "cidade": "Mendonça"
  },
  {
    "prefixo": "15225",
    "uf": "SP",
    "codigoIbge": 3555356,
    "cidade": "Ubarana"
  },
  {
    "prefixo": "15230",
    "uf": "SP",
    "codigoIbge": 3500204,
    "cidade": "Adolfo"
  },
  {
    "prefixo": "15240",
    "uf": "SP",
    "codigoIbge": 3532702,
    "cidade": "Nipoã"
  },
  {
    "prefixo": "15250",
    "uf": "SP",
    "codigoIbge": 3555703,
    "cidade": "União Paulista"
  },
  {
    "prefixo": "15260",
    "uf": "SP",
    "codigoIbge": 3539608,
    "cidade": "Planalto"
  },
  {
    "prefixo": "15265",
    "uf": "SP",
    "codigoIbge": 3557154,
    "cidade": "Zacarias"
  },
  {
    "prefixo": "15270",
    "uf": "SP",
    "codigoIbge": 3528106,
    "cidade": "Macaubal"
  },
  {
    "prefixo": "15275",
    "uf": "SP",
    "codigoIbge": 3531001,
    "cidade": "Monções"
  },
  {
    "prefixo": "15280",
    "uf": "SP",
    "codigoIbge": 3555208,
    "cidade": "Turiúba"
  },
  {
    "prefixo": "15284",
    "uf": "SP",
    "codigoIbge": 3555208,
    "cidade": "Turiúba"
  },
  {
    "prefixo": "15285",
    "uf": "SP",
    "codigoIbge": 3527256,
    "cidade": "Lourdes"
  },
  {
    "prefixo": "15290",
    "uf": "SP",
    "codigoIbge": 3508108,
    "cidade": "Buritama"
  },
  {
    "prefixo": "15300",
    "uf": "SP",
    "codigoIbge": 3516903,
    "cidade": "General Salgado"
  },
  {
    "prefixo": "15307",
    "uf": "SP",
    "codigoIbge": 3516903,
    "cidade": "General Salgado"
  },
  {
    "prefixo": "15310",
    "uf": "SP",
    "codigoIbge": 3528304,
    "cidade": "Magda"
  },
  {
    "prefixo": "15313",
    "uf": "SP",
    "codigoIbge": 3532868,
    "cidade": "Nova Castilho"
  },
  {
    "prefixo": "15315",
    "uf": "SP",
    "codigoIbge": 3549250,
    "cidade": "São João de Iracema"
  },
  {
    "prefixo": "15320",
    "uf": "SP",
    "codigoIbge": 3515905,
    "cidade": "Floreal"
  },
  {
    "prefixo": "15330",
    "uf": "SP",
    "codigoIbge": 3516804,
    "cidade": "Gastão Vidigal"
  },
  {
    "prefixo": "15340",
    "uf": "SP",
    "codigoIbge": 3533304,
    "cidade": "Nova Luzitânia"
  },
  {
    "prefixo": "15350",
    "uf": "SP",
    "codigoIbge": 3504206,
    "cidade": "Auriflama"
  },
  {
    "prefixo": "15355",
    "uf": "SP",
    "codigoIbge": 3518909,
    "cidade": "Guzolândia"
  },
  {
    "prefixo": "15360",
    "uf": "SP",
    "codigoIbge": 3552304,
    "cidade": "Sud Mennucci"
  },
  {
    "prefixo": "15367",
    "uf": "SP",
    "codigoIbge": 3552304,
    "cidade": "Sud Mennucci"
  },
  {
    "prefixo": "15370",
    "uf": "SP",
    "codigoIbge": 3537404,
    "cidade": "Pereira Barreto"
  },
  {
    "prefixo": "15371",
    "uf": "SP",
    "codigoIbge": 3537404,
    "cidade": "Pereira Barreto"
  },
  {
    "prefixo": "15372",
    "uf": "SP",
    "codigoIbge": 3537404,
    "cidade": "Pereira Barreto"
  },
  {
    "prefixo": "15375",
    "uf": "SP",
    "codigoIbge": 3537404,
    "cidade": "Pereira Barreto"
  },
  {
    "prefixo": "15378",
    "uf": "SP",
    "codigoIbge": 3537404,
    "cidade": "Pereira Barreto"
  },
  {
    "prefixo": "15379",
    "uf": "SP",
    "codigoIbge": 3537404,
    "cidade": "Pereira Barreto"
  },
  {
    "prefixo": "15380",
    "uf": "SP",
    "codigoIbge": 3552551,
    "cidade": "Suzanápolis"
  },
  {
    "prefixo": "15381",
    "uf": "SP",
    "codigoIbge": 3552551,
    "cidade": "Suzanápolis"
  },
  {
    "prefixo": "15385",
    "uf": "SP",
    "codigoIbge": 3520442,
    "cidade": "Ilha Solteira"
  },
  {
    "prefixo": "15387",
    "uf": "SP",
    "codigoIbge": 3520442,
    "cidade": "Ilha Solteira"
  },
  {
    "prefixo": "15388",
    "uf": "SP",
    "codigoIbge": 3520442,
    "cidade": "Ilha Solteira"
  },
  {
    "prefixo": "15390",
    "uf": "SP",
    "codigoIbge": 3523008,
    "cidade": "Itapura"
  },
  {
    "prefixo": "15400",
    "uf": "SP",
    "codigoIbge": 3533908,
    "cidade": "Olímpia"
  },
  {
    "prefixo": "15402",
    "uf": "SP",
    "codigoIbge": 3533908,
    "cidade": "Olímpia"
  },
  {
    "prefixo": "15404",
    "uf": "SP",
    "codigoIbge": 3533908,
    "cidade": "Olímpia"
  },
  {
    "prefixo": "15405",
    "uf": "SP",
    "codigoIbge": 3533908,
    "cidade": "Olímpia"
  },
  {
    "prefixo": "15406",
    "uf": "SP",
    "codigoIbge": 3533908,
    "cidade": "Olímpia"
  },
  {
    "prefixo": "15407",
    "uf": "SP",
    "codigoIbge": 3533908,
    "cidade": "Olímpia"
  },
  {
    "prefixo": "15409",
    "uf": "SP",
    "codigoIbge": 3533908,
    "cidade": "Olímpia"
  },
  {
    "prefixo": "15410",
    "uf": "SP",
    "codigoIbge": 3509304,
    "cidade": "Cajobi"
  },
  {
    "prefixo": "15417",
    "uf": "SP",
    "codigoIbge": 3509304,
    "cidade": "Cajobi"
  },
  {
    "prefixo": "15420",
    "uf": "SP",
    "codigoIbge": 3517901,
    "cidade": "Guaraci"
  },
  {
    "prefixo": "15425",
    "uf": "SP",
    "codigoIbge": 3514957,
    "cidade": "Embaúba"
  },
  {
    "prefixo": "15430",
    "uf": "SP",
    "codigoIbge": 3500907,
    "cidade": "Altair"
  },
  {
    "prefixo": "15434",
    "uf": "SP",
    "codigoIbge": 3500907,
    "cidade": "Altair"
  },
  {
    "prefixo": "15440",
    "uf": "SP",
    "codigoIbge": 3533007,
    "cidade": "Nova Granada"
  },
  {
    "prefixo": "15445",
    "uf": "SP",
    "codigoIbge": 3533007,
    "cidade": "Nova Granada"
  },
  {
    "prefixo": "15448",
    "uf": "SP",
    "codigoIbge": 3533007,
    "cidade": "Nova Granada"
  },
  {
    "prefixo": "15450",
    "uf": "SP",
    "codigoIbge": 3534005,
    "cidade": "Onda Verde"
  },
  {
    "prefixo": "15460",
    "uf": "SP",
    "codigoIbge": 3519808,
    "cidade": "Icém"
  },
  {
    "prefixo": "15470",
    "uf": "SP",
    "codigoIbge": 3535002,
    "cidade": "Palestina"
  },
  {
    "prefixo": "15472",
    "uf": "SP",
    "codigoIbge": 3535002,
    "cidade": "Palestina"
  },
  {
    "prefixo": "15475",
    "uf": "SP",
    "codigoIbge": 3535002,
    "cidade": "Palestina"
  },
  {
    "prefixo": "15480",
    "uf": "SP",
    "codigoIbge": 3534203,
    "cidade": "Orindiúva"
  },
  {
    "prefixo": "15482",
    "uf": "SP",
    "codigoIbge": 3534203,
    "cidade": "Orindiúva"
  },
  {
    "prefixo": "15490",
    "uf": "SP",
    "codigoIbge": 3536604,
    "cidade": "Paulo de Faria"
  },
  {
    "prefixo": "15495",
    "uf": "SP",
    "codigoIbge": 3544202,
    "cidade": "Riolândia"
  },
  {
    "prefixo": "15496",
    "uf": "SP",
    "codigoIbge": 3544202,
    "cidade": "Riolândia"
  },
  {
    "prefixo": "15500",
    "uf": "SP",
    "codigoIbge": 3557105,
    "cidade": "Votuporanga"
  },
  {
    "prefixo": "15501",
    "uf": "SP",
    "codigoIbge": 3557105,
    "cidade": "Votuporanga"
  },
  {
    "prefixo": "15502",
    "uf": "SP",
    "codigoIbge": 3557105,
    "cidade": "Votuporanga"
  },
  {
    "prefixo": "15503",
    "uf": "SP",
    "codigoIbge": 3557105,
    "cidade": "Votuporanga"
  },
  {
    "prefixo": "15504",
    "uf": "SP",
    "codigoIbge": 3557105,
    "cidade": "Votuporanga"
  },
  {
    "prefixo": "15505",
    "uf": "SP",
    "codigoIbge": 3557105,
    "cidade": "Votuporanga"
  },
  {
    "prefixo": "15506",
    "uf": "SP",
    "codigoIbge": 3557105,
    "cidade": "Votuporanga"
  },
  {
    "prefixo": "15507",
    "uf": "SP",
    "codigoIbge": 3557105,
    "cidade": "Votuporanga"
  },
  {
    "prefixo": "15508",
    "uf": "SP",
    "codigoIbge": 3557105,
    "cidade": "Votuporanga"
  },
  {
    "prefixo": "15509",
    "uf": "SP",
    "codigoIbge": 3557105,
    "cidade": "Votuporanga"
  },
  {
    "prefixo": "15515",
    "uf": "SP",
    "codigoIbge": 3557105,
    "cidade": "Votuporanga"
  },
  {
    "prefixo": "15520",
    "uf": "SP",
    "codigoIbge": 3556107,
    "cidade": "Valentim Gentil"
  },
  {
    "prefixo": "15525",
    "uf": "SP",
    "codigoIbge": 3536257,
    "cidade": "Parisi"
  },
  {
    "prefixo": "15530",
    "uf": "SP",
    "codigoIbge": 3512902,
    "cidade": "Cosmorama"
  },
  {
    "prefixo": "15540",
    "uf": "SP",
    "codigoIbge": 3501202,
    "cidade": "Álvares Florence"
  },
  {
    "prefixo": "15545",
    "uf": "SP",
    "codigoIbge": 3501202,
    "cidade": "Álvares Florence"
  },
  {
    "prefixo": "15550",
    "uf": "SP",
    "codigoIbge": 3501806,
    "cidade": "Américo de Campos"
  },
  {
    "prefixo": "15560",
    "uf": "SP",
    "codigoIbge": 3540309,
    "cidade": "Pontes Gestal"
  },
  {
    "prefixo": "15570",
    "uf": "SP",
    "codigoIbge": 3510708,
    "cidade": "Cardoso"
  },
  {
    "prefixo": "15575",
    "uf": "SP",
    "codigoIbge": 3510708,
    "cidade": "Cardoso"
  },
  {
    "prefixo": "15580",
    "uf": "SP",
    "codigoIbge": 3530003,
    "cidade": "Mira Estrela"
  },
  {
    "prefixo": "15600",
    "uf": "SP",
    "codigoIbge": 3515509,
    "cidade": "Fernandópolis"
  },
  {
    "prefixo": "15601",
    "uf": "SP",
    "codigoIbge": 3515509,
    "cidade": "Fernandópolis"
  },
  {
    "prefixo": "15603",
    "uf": "SP",
    "codigoIbge": 3515509,
    "cidade": "Fernandópolis"
  },
  {
    "prefixo": "15604",
    "uf": "SP",
    "codigoIbge": 3515509,
    "cidade": "Fernandópolis"
  },
  {
    "prefixo": "15606",
    "uf": "SP",
    "codigoIbge": 3515509,
    "cidade": "Fernandópolis"
  },
  {
    "prefixo": "15607",
    "uf": "SP",
    "codigoIbge": 3515509,
    "cidade": "Fernandópolis"
  },
  {
    "prefixo": "15608",
    "uf": "SP",
    "codigoIbge": 3515509,
    "cidade": "Fernandópolis"
  },
  {
    "prefixo": "15610",
    "uf": "SP",
    "codigoIbge": 3515509,
    "cidade": "Fernandópolis"
  },
  {
    "prefixo": "15612",
    "uf": "SP",
    "codigoIbge": 3515509,
    "cidade": "Fernandópolis"
  },
  {
    "prefixo": "15613",
    "uf": "SP",
    "codigoIbge": 3515509,
    "cidade": "Fernandópolis"
  },
  {
    "prefixo": "15614",
    "uf": "SP",
    "codigoIbge": 3515509,
    "cidade": "Fernandópolis"
  },
  {
    "prefixo": "15620",
    "uf": "SP",
    "codigoIbge": 3528205,
    "cidade": "Macedônia"
  },
  {
    "prefixo": "15625",
    "uf": "SP",
    "codigoIbge": 3529609,
    "cidade": "Meridiano"
  },
  {
    "prefixo": "15630",
    "uf": "SP",
    "codigoIbge": 3536901,
    "cidade": "Pedranópolis"
  },
  {
    "prefixo": "15635",
    "uf": "SP",
    "codigoIbge": 3536901,
    "cidade": "Pedranópolis"
  },
  {
    "prefixo": "15640",
    "uf": "SP",
    "codigoIbge": 3549201,
    "cidade": "São João das Duas Pontes"
  },
  {
    "prefixo": "15650",
    "uf": "SP",
    "codigoIbge": 3515202,
    "cidade": "Estrela d'Oeste"
  },
  {
    "prefixo": "15670",
    "uf": "SP",
    "codigoIbge": 3540408,
    "cidade": "Populina"
  },
  {
    "prefixo": "15680",
    "uf": "SP",
    "codigoIbge": 3518008,
    "cidade": "Guarani d'Oeste"
  },
  {
    "prefixo": "15685",
    "uf": "SP",
    "codigoIbge": 3534757,
    "cidade": "Ouroeste"
  },
  {
    "prefixo": "15688",
    "uf": "SP",
    "codigoIbge": 3534757,
    "cidade": "Ouroeste"
  },
  {
    "prefixo": "15690",
    "uf": "SP",
    "codigoIbge": 3520707,
    "cidade": "Indiaporã"
  },
  {
    "prefixo": "15700",
    "uf": "SP",
    "codigoIbge": 3524808,
    "cidade": "Jales"
  },
  {
    "prefixo": "15703",
    "uf": "SP",
    "codigoIbge": 3524808,
    "cidade": "Jales"
  },
  {
    "prefixo": "15704",
    "uf": "SP",
    "codigoIbge": 3524808,
    "cidade": "Jales"
  },
  {
    "prefixo": "15706",
    "uf": "SP",
    "codigoIbge": 3524808,
    "cidade": "Jales"
  },
  {
    "prefixo": "15707",
    "uf": "SP",
    "codigoIbge": 3524808,
    "cidade": "Jales"
  },
  {
    "prefixo": "15708",
    "uf": "SP",
    "codigoIbge": 3524808,
    "cidade": "Jales"
  },
  {
    "prefixo": "15709",
    "uf": "SP",
    "codigoIbge": 3524808,
    "cidade": "Jales"
  },
  {
    "prefixo": "15710",
    "uf": "SP",
    "codigoIbge": 3549003,
    "cidade": "São Francisco"
  },
  {
    "prefixo": "15712",
    "uf": "SP",
    "codigoIbge": 3549003,
    "cidade": "São Francisco"
  },
  {
    "prefixo": "15713",
    "uf": "SP",
    "codigoIbge": 3556958,
    "cidade": "Vitória Brasil"
  },
  {
    "prefixo": "15714",
    "uf": "SP",
    "codigoIbge": 3556958,
    "cidade": "Vitória Brasil"
  },
  {
    "prefixo": "15715",
    "uf": "SP",
    "codigoIbge": 3513850,
    "cidade": "Dirce Reis"
  },
  {
    "prefixo": "15718",
    "uf": "SP",
    "codigoIbge": 3540259,
    "cidade": "Pontalinda"
  },
  {
    "prefixo": "15720",
    "uf": "SP",
    "codigoIbge": 3535200,
    "cidade": "Palmeira d'Oeste"
  },
  {
    "prefixo": "15725",
    "uf": "SP",
    "codigoIbge": 3535200,
    "cidade": "Palmeira d'Oeste"
  },
  {
    "prefixo": "15730",
    "uf": "SP",
    "codigoIbge": 3529104,
    "cidade": "Marinópolis"
  },
  {
    "prefixo": "15734",
    "uf": "SP",
    "codigoIbge": 3529104,
    "cidade": "Marinópolis"
  },
  {
    "prefixo": "15735",
    "uf": "SP",
    "codigoIbge": 3502606,
    "cidade": "Aparecida d'Oeste"
  },
  {
    "prefixo": "15740",
    "uf": "SP",
    "codigoIbge": 3514205,
    "cidade": "Dolcinópolis"
  },
  {
    "prefixo": "15745",
    "uf": "SP",
    "codigoIbge": 3535903,
    "cidade": "Paranapuã"
  },
  {
    "prefixo": "15748",
    "uf": "SP",
    "codigoIbge": 3529658,
    "cidade": "Mesópolis"
  },
  {
    "prefixo": "15750",
    "uf": "SP",
    "codigoIbge": 3545704,
    "cidade": "Santa Albertina"
  },
  {
    "prefixo": "15755",
    "uf": "SP",
    "codigoIbge": 3555307,
    "cidade": "Turmalina"
  },
  {
    "prefixo": "15757",
    "uf": "SP",
    "codigoIbge": 3555307,
    "cidade": "Turmalina"
  },
  {
    "prefixo": "15759",
    "uf": "SP",
    "codigoIbge": 3555307,
    "cidade": "Turmalina"
  },
  {
    "prefixo": "15760",
    "uf": "SP",
    "codigoIbge": 3555802,
    "cidade": "Urânia"
  },
  {
    "prefixo": "15763",
    "uf": "SP",
    "codigoIbge": 3503950,
    "cidade": "Aspásia"
  },
  {
    "prefixo": "15765",
    "uf": "SP",
    "codigoIbge": 3547205,
    "cidade": "Santana da Ponte Pensa"
  },
  {
    "prefixo": "15768",
    "uf": "SP",
    "codigoIbge": 3547650,
    "cidade": "Santa Salete"
  },
  {
    "prefixo": "15770",
    "uf": "SP",
    "codigoIbge": 3554904,
    "cidade": "Três Fronteiras"
  },
  {
    "prefixo": "15773",
    "uf": "SP",
    "codigoIbge": 3532843,
    "cidade": "Nova Canaã Paulista"
  },
  {
    "prefixo": "15775",
    "uf": "SP",
    "codigoIbge": 3546603,
    "cidade": "Santa Fé do Sul"
  },
  {
    "prefixo": "15780",
    "uf": "SP",
    "codigoIbge": 3547403,
    "cidade": "Santa Rita d'Oeste"
  },
  {
    "prefixo": "15783",
    "uf": "SP",
    "codigoIbge": 3547403,
    "cidade": "Santa Rita d'Oeste"
  },
  {
    "prefixo": "15785",
    "uf": "SP",
    "codigoIbge": 3546108,
    "cidade": "Santa Clara d'Oeste"
  },
  {
    "prefixo": "15790",
    "uf": "SP",
    "codigoIbge": 3544509,
    "cidade": "Rubinéia"
  },
  {
    "prefixo": "15795",
    "uf": "SP",
    "codigoIbge": 3544509,
    "cidade": "Rubinéia"
  },
  {
    "prefixo": "15800",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15801",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15802",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15803",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15804",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15805",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15806",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15807",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15808",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15809",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15810",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15811",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15812",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15813",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15816",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15819",
    "uf": "SP",
    "codigoIbge": 3511102,
    "cidade": "Catanduva"
  },
  {
    "prefixo": "15820",
    "uf": "SP",
    "codigoIbge": 3539004,
    "cidade": "Pirangi"
  },
  {
    "prefixo": "15822",
    "uf": "SP",
    "codigoIbge": 3539004,
    "cidade": "Pirangi"
  },
  {
    "prefixo": "15823",
    "uf": "SP",
    "codigoIbge": 3514924,
    "cidade": "Elisiário"
  },
  {
    "prefixo": "15825",
    "uf": "SP",
    "codigoIbge": 3535705,
    "cidade": "Paraíso"
  },
  {
    "prefixo": "15828",
    "uf": "SP",
    "codigoIbge": 3535101,
    "cidade": "Palmares Paulista"
  },
  {
    "prefixo": "15829",
    "uf": "SP",
    "codigoIbge": 3535101,
    "cidade": "Palmares Paulista"
  },
  {
    "prefixo": "15830",
    "uf": "SP",
    "codigoIbge": 3538105,
    "cidade": "Pindorama"
  },
  {
    "prefixo": "15835",
    "uf": "SP",
    "codigoIbge": 3538105,
    "cidade": "Pindorama"
  },
  {
    "prefixo": "15840",
    "uf": "SP",
    "codigoIbge": 3521903,
    "cidade": "Itajobi"
  },
  {
    "prefixo": "15843",
    "uf": "SP",
    "codigoIbge": 3521903,
    "cidade": "Itajobi"
  },
  {
    "prefixo": "15845",
    "uf": "SP",
    "codigoIbge": 3528858,
    "cidade": "Marapoama"
  },
  {
    "prefixo": "15850",
    "uf": "SP",
    "codigoIbge": 3556008,
    "cidade": "Urupês"
  },
  {
    "prefixo": "15852",
    "uf": "SP",
    "codigoIbge": 3556008,
    "cidade": "Urupês"
  },
  {
    "prefixo": "15854",
    "uf": "SP",
    "codigoIbge": 3556008,
    "cidade": "Urupês"
  },
  {
    "prefixo": "15855",
    "uf": "SP",
    "codigoIbge": 3556008,
    "cidade": "Urupês"
  },
  {
    "prefixo": "15856",
    "uf": "SP",
    "codigoIbge": 3556008,
    "cidade": "Urupês"
  },
  {
    "prefixo": "15858",
    "uf": "SP",
    "codigoIbge": 3556008,
    "cidade": "Urupês"
  },
  {
    "prefixo": "15860",
    "uf": "SP",
    "codigoIbge": 3519402,
    "cidade": "Ibirá"
  },
  {
    "prefixo": "15861",
    "uf": "SP",
    "codigoIbge": 3519402,
    "cidade": "Ibirá"
  },
  {
    "prefixo": "15863",
    "uf": "SP",
    "codigoIbge": 3519402,
    "cidade": "Ibirá"
  },
  {
    "prefixo": "15868",
    "uf": "SP",
    "codigoIbge": 3519402,
    "cidade": "Ibirá"
  },
  {
    "prefixo": "15869",
    "uf": "SP",
    "codigoIbge": 3519402,
    "cidade": "Ibirá"
  },
  {
    "prefixo": "15870",
    "uf": "SP",
    "codigoIbge": 3511201,
    "cidade": "Catiguá"
  },
  {
    "prefixo": "15872",
    "uf": "SP",
    "codigoIbge": 3511201,
    "cidade": "Catiguá"
  },
  {
    "prefixo": "15880",
    "uf": "SP",
    "codigoIbge": 3552601,
    "cidade": "Tabapuã"
  },
  {
    "prefixo": "15881",
    "uf": "SP",
    "codigoIbge": 3552601,
    "cidade": "Tabapuã"
  },
  {
    "prefixo": "15882",
    "uf": "SP",
    "codigoIbge": 3552601,
    "cidade": "Tabapuã"
  },
  {
    "prefixo": "15883",
    "uf": "SP",
    "codigoIbge": 3552601,
    "cidade": "Tabapuã"
  },
  {
    "prefixo": "15885",
    "uf": "SP",
    "codigoIbge": 3533254,
    "cidade": "Novais"
  },
  {
    "prefixo": "15890",
    "uf": "SP",
    "codigoIbge": 3555604,
    "cidade": "Uchoa"
  },
  {
    "prefixo": "15891",
    "uf": "SP",
    "codigoIbge": 3555604,
    "cidade": "Uchoa"
  },
  {
    "prefixo": "15893",
    "uf": "SP",
    "codigoIbge": 3555604,
    "cidade": "Uchoa"
  },
  {
    "prefixo": "15895",
    "uf": "SP",
    "codigoIbge": 3511300,
    "cidade": "Cedral"
  },
  {
    "prefixo": "15900",
    "uf": "SP",
    "codigoIbge": 3553708,
    "cidade": "Taquaritinga"
  },
  {
    "prefixo": "15901",
    "uf": "SP",
    "codigoIbge": 3553708,
    "cidade": "Taquaritinga"
  },
  {
    "prefixo": "15902",
    "uf": "SP",
    "codigoIbge": 3553708,
    "cidade": "Taquaritinga"
  },
  {
    "prefixo": "15903",
    "uf": "SP",
    "codigoIbge": 3553708,
    "cidade": "Taquaritinga"
  },
  {
    "prefixo": "15904",
    "uf": "SP",
    "codigoIbge": 3553708,
    "cidade": "Taquaritinga"
  },
  {
    "prefixo": "15905",
    "uf": "SP",
    "codigoIbge": 3553708,
    "cidade": "Taquaritinga"
  },
  {
    "prefixo": "15906",
    "uf": "SP",
    "codigoIbge": 3553708,
    "cidade": "Taquaritinga"
  },
  {
    "prefixo": "15908",
    "uf": "SP",
    "codigoIbge": 3553708,
    "cidade": "Taquaritinga"
  },
  {
    "prefixo": "15909",
    "uf": "SP",
    "codigoIbge": 3553708,
    "cidade": "Taquaritinga"
  },
  {
    "prefixo": "15910",
    "uf": "SP",
    "codigoIbge": 3531308,
    "cidade": "Monte Alto"
  },
  {
    "prefixo": "15915",
    "uf": "SP",
    "codigoIbge": 3531308,
    "cidade": "Monte Alto"
  },
  {
    "prefixo": "15920",
    "uf": "SP",
    "codigoIbge": 3556909,
    "cidade": "Vista Alegre do Alto"
  },
  {
    "prefixo": "15930",
    "uf": "SP",
    "codigoIbge": 3510104,
    "cidade": "Cândido Rodrigues"
  },
  {
    "prefixo": "15940",
    "uf": "SP",
    "codigoIbge": 3515608,
    "cidade": "Fernando Prestes"
  },
  {
    "prefixo": "15945",
    "uf": "SP",
    "codigoIbge": 3515608,
    "cidade": "Fernando Prestes"
  },
  {
    "prefixo": "15950",
    "uf": "SP",
    "codigoIbge": 3545605,
    "cidade": "Santa Adélia"
  },
  {
    "prefixo": "15953",
    "uf": "SP",
    "codigoIbge": 3545605,
    "cidade": "Santa Adélia"
  },
  {
    "prefixo": "15955",
    "uf": "SP",
    "codigoIbge": 3545605,
    "cidade": "Santa Adélia"
  },
  {
    "prefixo": "15960",
    "uf": "SP",
    "codigoIbge": 3503703,
    "cidade": "Ariranha"
  },
  {
    "prefixo": "15961",
    "uf": "SP",
    "codigoIbge": 3503703,
    "cidade": "Ariranha"
  },
  {
    "prefixo": "15962",
    "uf": "SP",
    "codigoIbge": 3503703,
    "cidade": "Ariranha"
  },
  {
    "prefixo": "15964",
    "uf": "SP",
    "codigoIbge": 3503703,
    "cidade": "Ariranha"
  },
  {
    "prefixo": "15970",
    "uf": "SP",
    "codigoIbge": 3546504,
    "cidade": "Santa Ernestina"
  },
  {
    "prefixo": "15980",
    "uf": "SP",
    "codigoIbge": 3514007,
    "cidade": "Dobrada"
  },
  {
    "prefixo": "15990",
    "uf": "SP",
    "codigoIbge": 3529302,
    "cidade": "Matão"
  },
  {
    "prefixo": "15991",
    "uf": "SP",
    "codigoIbge": 3529302,
    "cidade": "Matão"
  },
  {
    "prefixo": "15992",
    "uf": "SP",
    "codigoIbge": 3529302,
    "cidade": "Matão"
  },
  {
    "prefixo": "15993",
    "uf": "SP",
    "codigoIbge": 3529302,
    "cidade": "Matão"
  },
  {
    "prefixo": "15994",
    "uf": "SP",
    "codigoIbge": 3529302,
    "cidade": "Matão"
  },
  {
    "prefixo": "15995",
    "uf": "SP",
    "codigoIbge": 3529302,
    "cidade": "Matão"
  },
  {
    "prefixo": "15996",
    "uf": "SP",
    "codigoIbge": 3529302,
    "cidade": "Matão"
  },
  {
    "prefixo": "15997",
    "uf": "SP",
    "codigoIbge": 3529302,
    "cidade": "Matão"
  },
  {
    "prefixo": "15998",
    "uf": "SP",
    "codigoIbge": 3529302,
    "cidade": "Matão"
  },
  {
    "prefixo": "15999",
    "uf": "SP",
    "codigoIbge": 3529302,
    "cidade": "Matão"
  },
  {
    "prefixo": "16010",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16011",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16012",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16013",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16015",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16016",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16018",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16020",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16021",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16022",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16023",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16024",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16025",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16026",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16027",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16050",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16052",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16055",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16056",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16057",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16058",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16060",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16069",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16070",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16071",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16072",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16074",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16075",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16076",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16078",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16080",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16087",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16129",
    "uf": "SP",
    "codigoIbge": 3502804,
    "cidade": "Araçatuba"
  },
  {
    "prefixo": "16130",
    "uf": "SP",
    "codigoIbge": 3548054,
    "cidade": "Santo Antônio do Aracanguá"
  },
  {
    "prefixo": "16140",
    "uf": "SP",
    "codigoIbge": 3548054,
    "cidade": "Santo Antônio do Aracanguá"
  },
  {
    "prefixo": "16150",
    "uf": "SP",
    "codigoIbge": 3548054,
    "cidade": "Santo Antônio do Aracanguá"
  },
  {
    "prefixo": "16200",
    "uf": "SP",
    "codigoIbge": 3506508,
    "cidade": "Birigui"
  },
  {
    "prefixo": "16201",
    "uf": "SP",
    "codigoIbge": 3506508,
    "cidade": "Birigui"
  },
  {
    "prefixo": "16202",
    "uf": "SP",
    "codigoIbge": 3506508,
    "cidade": "Birigui"
  },
  {
    "prefixo": "16203",
    "uf": "SP",
    "codigoIbge": 3506508,
    "cidade": "Birigui"
  },
  {
    "prefixo": "16204",
    "uf": "SP",
    "codigoIbge": 3506508,
    "cidade": "Birigui"
  },
  {
    "prefixo": "16205",
    "uf": "SP",
    "codigoIbge": 3506508,
    "cidade": "Birigui"
  },
  {
    "prefixo": "16206",
    "uf": "SP",
    "codigoIbge": 3506508,
    "cidade": "Birigui"
  },
  {
    "prefixo": "16207",
    "uf": "SP",
    "codigoIbge": 3506508,
    "cidade": "Birigui"
  },
  {
    "prefixo": "16208",
    "uf": "SP",
    "codigoIbge": 3506508,
    "cidade": "Birigui"
  },
  {
    "prefixo": "16209",
    "uf": "SP",
    "codigoIbge": 3506508,
    "cidade": "Birigui"
  },
  {
    "prefixo": "16210",
    "uf": "SP",
    "codigoIbge": 3506409,
    "cidade": "Bilac"
  },
  {
    "prefixo": "16220",
    "uf": "SP",
    "codigoIbge": 3516507,
    "cidade": "Gabriel Monteiro"
  },
  {
    "prefixo": "16230",
    "uf": "SP",
    "codigoIbge": 3537701,
    "cidade": "Piacatu"
  },
  {
    "prefixo": "16240",
    "uf": "SP",
    "codigoIbge": 3548401,
    "cidade": "Santópolis do Aguapeí"
  },
  {
    "prefixo": "16250",
    "uf": "SP",
    "codigoIbge": 3511904,
    "cidade": "Clementina"
  },
  {
    "prefixo": "16255",
    "uf": "SP",
    "codigoIbge": 3511904,
    "cidade": "Clementina"
  },
  {
    "prefixo": "16260",
    "uf": "SP",
    "codigoIbge": 3512506,
    "cidade": "Coroados"
  },
  {
    "prefixo": "16265",
    "uf": "SP",
    "codigoIbge": 3507753,
    "cidade": "Brejo Alegre"
  },
  {
    "prefixo": "16270",
    "uf": "SP",
    "codigoIbge": 3517109,
    "cidade": "Glicério"
  },
  {
    "prefixo": "16280",
    "uf": "SP",
    "codigoIbge": 3517109,
    "cidade": "Glicério"
  },
  {
    "prefixo": "16290",
    "uf": "SP",
    "codigoIbge": 3507704,
    "cidade": "Braúna"
  },
  {
    "prefixo": "16300",
    "uf": "SP",
    "codigoIbge": 3537305,
    "cidade": "Penápolis"
  },
  {
    "prefixo": "16301",
    "uf": "SP",
    "codigoIbge": 3537305,
    "cidade": "Penápolis"
  },
  {
    "prefixo": "16303",
    "uf": "SP",
    "codigoIbge": 3537305,
    "cidade": "Penápolis"
  },
  {
    "prefixo": "16304",
    "uf": "SP",
    "codigoIbge": 3537305,
    "cidade": "Penápolis"
  },
  {
    "prefixo": "16305",
    "uf": "SP",
    "codigoIbge": 3537305,
    "cidade": "Penápolis"
  },
  {
    "prefixo": "16306",
    "uf": "SP",
    "codigoIbge": 3537305,
    "cidade": "Penápolis"
  },
  {
    "prefixo": "16308",
    "uf": "SP",
    "codigoIbge": 3537305,
    "cidade": "Penápolis"
  },
  {
    "prefixo": "16309",
    "uf": "SP",
    "codigoIbge": 3537305,
    "cidade": "Penápolis"
  },
  {
    "prefixo": "16310",
    "uf": "SP",
    "codigoIbge": 3501103,
    "cidade": "Alto Alegre"
  },
  {
    "prefixo": "16320",
    "uf": "SP",
    "codigoIbge": 3501103,
    "cidade": "Alto Alegre"
  },
  {
    "prefixo": "16330",
    "uf": "SP",
    "codigoIbge": 3501103,
    "cidade": "Alto Alegre"
  },
  {
    "prefixo": "16340",
    "uf": "SP",
    "codigoIbge": 3527702,
    "cidade": "Luiziânia"
  },
  {
    "prefixo": "16350",
    "uf": "SP",
    "codigoIbge": 3505104,
    "cidade": "Barbosa"
  },
  {
    "prefixo": "16360",
    "uf": "SP",
    "codigoIbge": 3504404,
    "cidade": "Avanhandava"
  },
  {
    "prefixo": "16370",
    "uf": "SP",
    "codigoIbge": 3541604,
    "cidade": "Promissão"
  },
  {
    "prefixo": "16400",
    "uf": "SP",
    "codigoIbge": 3527108,
    "cidade": "Lins"
  },
  {
    "prefixo": "16401",
    "uf": "SP",
    "codigoIbge": 3527108,
    "cidade": "Lins"
  },
  {
    "prefixo": "16402",
    "uf": "SP",
    "codigoIbge": 3527108,
    "cidade": "Lins"
  },
  {
    "prefixo": "16403",
    "uf": "SP",
    "codigoIbge": 3527108,
    "cidade": "Lins"
  },
  {
    "prefixo": "16404",
    "uf": "SP",
    "codigoIbge": 3527108,
    "cidade": "Lins"
  },
  {
    "prefixo": "16406",
    "uf": "SP",
    "codigoIbge": 3527108,
    "cidade": "Lins"
  },
  {
    "prefixo": "16419",
    "uf": "SP",
    "codigoIbge": 3527108,
    "cidade": "Lins"
  },
  {
    "prefixo": "16420",
    "uf": "SP",
    "codigoIbge": 3527108,
    "cidade": "Lins"
  },
  {
    "prefixo": "16430",
    "uf": "SP",
    "codigoIbge": 3517208,
    "cidade": "Guaiçara"
  },
  {
    "prefixo": "16432",
    "uf": "SP",
    "codigoIbge": 3517208,
    "cidade": "Guaiçara"
  },
  {
    "prefixo": "16434",
    "uf": "SP",
    "codigoIbge": 3517208,
    "cidade": "Guaiçara"
  },
  {
    "prefixo": "16439",
    "uf": "SP",
    "codigoIbge": 3517208,
    "cidade": "Guaiçara"
  },
  {
    "prefixo": "16440",
    "uf": "SP",
    "codigoIbge": 3544608,
    "cidade": "Sabino"
  },
  {
    "prefixo": "16444",
    "uf": "SP",
    "codigoIbge": 3544608,
    "cidade": "Sabino"
  },
  {
    "prefixo": "16445",
    "uf": "SP",
    "codigoIbge": 3544608,
    "cidade": "Sabino"
  },
  {
    "prefixo": "16449",
    "uf": "SP",
    "codigoIbge": 3544608,
    "cidade": "Sabino"
  },
  {
    "prefixo": "16450",
    "uf": "SP",
    "codigoIbge": 3517000,
    "cidade": "Getulina"
  },
  {
    "prefixo": "16451",
    "uf": "SP",
    "codigoIbge": 3517000,
    "cidade": "Getulina"
  },
  {
    "prefixo": "16452",
    "uf": "SP",
    "codigoIbge": 3517000,
    "cidade": "Getulina"
  },
  {
    "prefixo": "16454",
    "uf": "SP",
    "codigoIbge": 3517000,
    "cidade": "Getulina"
  },
  {
    "prefixo": "16457",
    "uf": "SP",
    "codigoIbge": 3517000,
    "cidade": "Getulina"
  },
  {
    "prefixo": "16458",
    "uf": "SP",
    "codigoIbge": 3517000,
    "cidade": "Getulina"
  },
  {
    "prefixo": "16459",
    "uf": "SP",
    "codigoIbge": 3517000,
    "cidade": "Getulina"
  },
  {
    "prefixo": "16480",
    "uf": "SP",
    "codigoIbge": 3517307,
    "cidade": "Guaimbê"
  },
  {
    "prefixo": "16482",
    "uf": "SP",
    "codigoIbge": 3517307,
    "cidade": "Guaimbê"
  },
  {
    "prefixo": "16489",
    "uf": "SP",
    "codigoIbge": 3517307,
    "cidade": "Guaimbê"
  },
  {
    "prefixo": "16500",
    "uf": "SP",
    "codigoIbge": 3508801,
    "cidade": "Cafelândia"
  },
  {
    "prefixo": "16503",
    "uf": "SP",
    "codigoIbge": 3508801,
    "cidade": "Cafelândia"
  },
  {
    "prefixo": "16506",
    "uf": "SP",
    "codigoIbge": 3508801,
    "cidade": "Cafelândia"
  },
  {
    "prefixo": "16507",
    "uf": "SP",
    "codigoIbge": 3508801,
    "cidade": "Cafelândia"
  },
  {
    "prefixo": "16509",
    "uf": "SP",
    "codigoIbge": 3508801,
    "cidade": "Cafelândia"
  },
  {
    "prefixo": "16510",
    "uf": "SP",
    "codigoIbge": 3508801,
    "cidade": "Cafelândia"
  },
  {
    "prefixo": "16519",
    "uf": "SP",
    "codigoIbge": 3508801,
    "cidade": "Cafelândia"
  },
  {
    "prefixo": "16520",
    "uf": "SP",
    "codigoIbge": 3508801,
    "cidade": "Cafelândia"
  },
  {
    "prefixo": "16529",
    "uf": "SP",
    "codigoIbge": 3508801,
    "cidade": "Cafelândia"
  },
  {
    "prefixo": "16570",
    "uf": "SP",
    "codigoIbge": 3518107,
    "cidade": "Guarantã"
  },
  {
    "prefixo": "16571",
    "uf": "SP",
    "codigoIbge": 3518107,
    "cidade": "Guarantã"
  },
  {
    "prefixo": "16573",
    "uf": "SP",
    "codigoIbge": 3518107,
    "cidade": "Guarantã"
  },
  {
    "prefixo": "16574",
    "uf": "SP",
    "codigoIbge": 3518107,
    "cidade": "Guarantã"
  },
  {
    "prefixo": "16600",
    "uf": "SP",
    "codigoIbge": 3538907,
    "cidade": "Pirajuí"
  },
  {
    "prefixo": "16602",
    "uf": "SP",
    "codigoIbge": 3538907,
    "cidade": "Pirajuí"
  },
  {
    "prefixo": "16603",
    "uf": "SP",
    "codigoIbge": 3538907,
    "cidade": "Pirajuí"
  },
  {
    "prefixo": "16604",
    "uf": "SP",
    "codigoIbge": 3538907,
    "cidade": "Pirajuí"
  },
  {
    "prefixo": "16605",
    "uf": "SP",
    "codigoIbge": 3538907,
    "cidade": "Pirajuí"
  },
  {
    "prefixo": "16616",
    "uf": "SP",
    "codigoIbge": 3538907,
    "cidade": "Pirajuí"
  },
  {
    "prefixo": "16617",
    "uf": "SP",
    "codigoIbge": 3538907,
    "cidade": "Pirajuí"
  },
  {
    "prefixo": "16618",
    "uf": "SP",
    "codigoIbge": 3538907,
    "cidade": "Pirajuí"
  },
  {
    "prefixo": "16619",
    "uf": "SP",
    "codigoIbge": 3538907,
    "cidade": "Pirajuí"
  },
  {
    "prefixo": "16640",
    "uf": "SP",
    "codigoIbge": 3504701,
    "cidade": "Balbinos"
  },
  {
    "prefixo": "16649",
    "uf": "SP",
    "codigoIbge": 3504701,
    "cidade": "Balbinos"
  },
  {
    "prefixo": "16650",
    "uf": "SP",
    "codigoIbge": 3555901,
    "cidade": "Uru"
  },
  {
    "prefixo": "16659",
    "uf": "SP",
    "codigoIbge": 3555901,
    "cidade": "Uru"
  },
  {
    "prefixo": "16660",
    "uf": "SP",
    "codigoIbge": 3540101,
    "cidade": "Pongaí"
  },
  {
    "prefixo": "16665",
    "uf": "SP",
    "codigoIbge": 3540101,
    "cidade": "Pongaí"
  },
  {
    "prefixo": "16666",
    "uf": "SP",
    "codigoIbge": 3540101,
    "cidade": "Pongaí"
  },
  {
    "prefixo": "16669",
    "uf": "SP",
    "codigoIbge": 3540101,
    "cidade": "Pongaí"
  },
  {
    "prefixo": "16670",
    "uf": "SP",
    "codigoIbge": 3541109,
    "cidade": "Presidente Alves"
  },
  {
    "prefixo": "16673",
    "uf": "SP",
    "codigoIbge": 3541109,
    "cidade": "Presidente Alves"
  },
  {
    "prefixo": "16678",
    "uf": "SP",
    "codigoIbge": 3541109,
    "cidade": "Presidente Alves"
  },
  {
    "prefixo": "16679",
    "uf": "SP",
    "codigoIbge": 3541109,
    "cidade": "Presidente Alves"
  },
  {
    "prefixo": "16680",
    "uf": "SP",
    "codigoIbge": 3504305,
    "cidade": "Avaí"
  },
  {
    "prefixo": "16688",
    "uf": "SP",
    "codigoIbge": 3504305,
    "cidade": "Avaí"
  },
  {
    "prefixo": "16689",
    "uf": "SP",
    "codigoIbge": 3504305,
    "cidade": "Avaí"
  },
  {
    "prefixo": "16690",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "16694",
    "uf": "SP",
    "codigoIbge": 3555406,
    "cidade": "Ubatuba"
  },
  {
    "prefixo": "16700",
    "uf": "SP",
    "codigoIbge": 3518206,
    "cidade": "Guararapes"
  },
  {
    "prefixo": "16750",
    "uf": "SP",
    "codigoIbge": 3544400,
    "cidade": "Rubiácea"
  },
  {
    "prefixo": "16790",
    "uf": "SP",
    "codigoIbge": 3506201,
    "cidade": "Bento de Abreu"
  },
  {
    "prefixo": "16800",
    "uf": "SP",
    "codigoIbge": 3530102,
    "cidade": "Mirandópolis"
  },
  {
    "prefixo": "16820",
    "uf": "SP",
    "codigoIbge": 3530102,
    "cidade": "Mirandópolis"
  },
  {
    "prefixo": "16830",
    "uf": "SP",
    "codigoIbge": 3530102,
    "cidade": "Mirandópolis"
  },
  {
    "prefixo": "16850",
    "uf": "SP",
    "codigoIbge": 3526506,
    "cidade": "Lavínia"
  },
  {
    "prefixo": "16855",
    "uf": "SP",
    "codigoIbge": 3526506,
    "cidade": "Lavínia"
  },
  {
    "prefixo": "16880",
    "uf": "SP",
    "codigoIbge": 3556305,
    "cidade": "Valparaíso"
  },
  {
    "prefixo": "16900",
    "uf": "SP",
    "codigoIbge": 3502101,
    "cidade": "Andradina"
  },
  {
    "prefixo": "16901",
    "uf": "SP",
    "codigoIbge": 3502101,
    "cidade": "Andradina"
  },
  {
    "prefixo": "16902",
    "uf": "SP",
    "codigoIbge": 3502101,
    "cidade": "Andradina"
  },
  {
    "prefixo": "16903",
    "uf": "SP",
    "codigoIbge": 3502101,
    "cidade": "Andradina"
  },
  {
    "prefixo": "16904",
    "uf": "SP",
    "codigoIbge": 3502101,
    "cidade": "Andradina"
  },
  {
    "prefixo": "16905",
    "uf": "SP",
    "codigoIbge": 3502101,
    "cidade": "Andradina"
  },
  {
    "prefixo": "16914",
    "uf": "SP",
    "codigoIbge": 3502101,
    "cidade": "Andradina"
  },
  {
    "prefixo": "16920",
    "uf": "SP",
    "codigoIbge": 3511003,
    "cidade": "Castilho"
  },
  {
    "prefixo": "16940",
    "uf": "SP",
    "codigoIbge": 3533205,
    "cidade": "Nova Independência"
  },
  {
    "prefixo": "16950",
    "uf": "SP",
    "codigoIbge": 3532108,
    "cidade": "Murutinga do Sul"
  },
  {
    "prefixo": "16980",
    "uf": "SP",
    "codigoIbge": 3517802,
    "cidade": "Guaraçaí"
  },
  {
    "prefixo": "17010",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17011",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17012",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17013",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17014",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17015",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17016",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17017",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17018",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17019",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17020",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17021",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17022",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17023",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17024",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17025",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17026",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17027",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17030",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17031",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17032",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17033",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17034",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17035",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17036",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17037",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17039",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17047",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17048",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17050",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17051",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17052",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17053",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17054",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17055",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17056",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17057",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17058",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17060",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17063",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17064",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17065",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17066",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17067",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17100",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17109",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17110",
    "uf": "SP",
    "codigoIbge": 3506003,
    "cidade": "Bauru"
  },
  {
    "prefixo": "17120",
    "uf": "SP",
    "codigoIbge": 3500709,
    "cidade": "Agudos"
  },
  {
    "prefixo": "17123",
    "uf": "SP",
    "codigoIbge": 3500709,
    "cidade": "Agudos"
  },
  {
    "prefixo": "17125",
    "uf": "SP",
    "codigoIbge": 3500709,
    "cidade": "Agudos"
  },
  {
    "prefixo": "17128",
    "uf": "SP",
    "codigoIbge": 3500709,
    "cidade": "Agudos"
  },
  {
    "prefixo": "17129",
    "uf": "SP",
    "codigoIbge": 3500709,
    "cidade": "Agudos"
  },
  {
    "prefixo": "17132",
    "uf": "SP",
    "codigoIbge": 3500709,
    "cidade": "Agudos"
  },
  {
    "prefixo": "17135",
    "uf": "SP",
    "codigoIbge": 3500709,
    "cidade": "Agudos"
  },
  {
    "prefixo": "17139",
    "uf": "SP",
    "codigoIbge": 3500709,
    "cidade": "Agudos"
  },
  {
    "prefixo": "17150",
    "uf": "SP",
    "codigoIbge": 3536570,
    "cidade": "Paulistânia"
  },
  {
    "prefixo": "17153",
    "uf": "SP",
    "codigoIbge": 3536570,
    "cidade": "Paulistânia"
  },
  {
    "prefixo": "17154",
    "uf": "SP",
    "codigoIbge": 3536570,
    "cidade": "Paulistânia"
  },
  {
    "prefixo": "17160",
    "uf": "SP",
    "codigoIbge": 3503406,
    "cidade": "Arealva"
  },
  {
    "prefixo": "17162",
    "uf": "SP",
    "codigoIbge": 3503406,
    "cidade": "Arealva"
  },
  {
    "prefixo": "17163",
    "uf": "SP",
    "codigoIbge": 3503406,
    "cidade": "Arealva"
  },
  {
    "prefixo": "17165",
    "uf": "SP",
    "codigoIbge": 3503406,
    "cidade": "Arealva"
  },
  {
    "prefixo": "17166",
    "uf": "SP",
    "codigoIbge": 3503406,
    "cidade": "Arealva"
  },
  {
    "prefixo": "17167",
    "uf": "SP",
    "codigoIbge": 3503406,
    "cidade": "Arealva"
  },
  {
    "prefixo": "17168",
    "uf": "SP",
    "codigoIbge": 3503406,
    "cidade": "Arealva"
  },
  {
    "prefixo": "17169",
    "uf": "SP",
    "codigoIbge": 3503406,
    "cidade": "Arealva"
  },
  {
    "prefixo": "17180",
    "uf": "SP",
    "codigoIbge": 3519105,
    "cidade": "Iacanga"
  },
  {
    "prefixo": "17182",
    "uf": "SP",
    "codigoIbge": 3519105,
    "cidade": "Iacanga"
  },
  {
    "prefixo": "17183",
    "uf": "SP",
    "codigoIbge": 3519105,
    "cidade": "Iacanga"
  },
  {
    "prefixo": "17185",
    "uf": "SP",
    "codigoIbge": 3519105,
    "cidade": "Iacanga"
  },
  {
    "prefixo": "17187",
    "uf": "SP",
    "codigoIbge": 3519105,
    "cidade": "Iacanga"
  },
  {
    "prefixo": "17189",
    "uf": "SP",
    "codigoIbge": 3519105,
    "cidade": "Iacanga"
  },
  {
    "prefixo": "17190",
    "uf": "SP",
    "codigoIbge": 3542503,
    "cidade": "Reginópolis"
  },
  {
    "prefixo": "17192",
    "uf": "SP",
    "codigoIbge": 3542503,
    "cidade": "Reginópolis"
  },
  {
    "prefixo": "17196",
    "uf": "SP",
    "codigoIbge": 3542503,
    "cidade": "Reginópolis"
  },
  {
    "prefixo": "17199",
    "uf": "SP",
    "codigoIbge": 3542503,
    "cidade": "Reginópolis"
  },
  {
    "prefixo": "17201",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17202",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17203",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17204",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17205",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17206",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17207",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17208",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17209",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17210",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17211",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17212",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17213",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17214",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17215",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17219",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17220",
    "uf": "SP",
    "codigoIbge": 3525300,
    "cidade": "Jaú"
  },
  {
    "prefixo": "17230",
    "uf": "SP",
    "codigoIbge": 3522901,
    "cidade": "Itapuí"
  },
  {
    "prefixo": "17232",
    "uf": "SP",
    "codigoIbge": 3522901,
    "cidade": "Itapuí"
  },
  {
    "prefixo": "17235",
    "uf": "SP",
    "codigoIbge": 3522901,
    "cidade": "Itapuí"
  },
  {
    "prefixo": "17237",
    "uf": "SP",
    "codigoIbge": 3522901,
    "cidade": "Itapuí"
  },
  {
    "prefixo": "17239",
    "uf": "SP",
    "codigoIbge": 3522901,
    "cidade": "Itapuí"
  },
  {
    "prefixo": "17240",
    "uf": "SP",
    "codigoIbge": 3506805,
    "cidade": "Bocaina"
  },
  {
    "prefixo": "17242",
    "uf": "SP",
    "codigoIbge": 3506805,
    "cidade": "Bocaina"
  },
  {
    "prefixo": "17245",
    "uf": "SP",
    "codigoIbge": 3506805,
    "cidade": "Bocaina"
  },
  {
    "prefixo": "17247",
    "uf": "SP",
    "codigoIbge": 3506805,
    "cidade": "Bocaina"
  },
  {
    "prefixo": "17248",
    "uf": "SP",
    "codigoIbge": 3506805,
    "cidade": "Bocaina"
  },
  {
    "prefixo": "17249",
    "uf": "SP",
    "codigoIbge": 3506805,
    "cidade": "Bocaina"
  },
  {
    "prefixo": "17250",
    "uf": "SP",
    "codigoIbge": 3505203,
    "cidade": "Bariri"
  },
  {
    "prefixo": "17252",
    "uf": "SP",
    "codigoIbge": 3505203,
    "cidade": "Bariri"
  },
  {
    "prefixo": "17253",
    "uf": "SP",
    "codigoIbge": 3505203,
    "cidade": "Bariri"
  },
  {
    "prefixo": "17255",
    "uf": "SP",
    "codigoIbge": 3505203,
    "cidade": "Bariri"
  },
  {
    "prefixo": "17257",
    "uf": "SP",
    "codigoIbge": 3505203,
    "cidade": "Bariri"
  },
  {
    "prefixo": "17258",
    "uf": "SP",
    "codigoIbge": 3505203,
    "cidade": "Bariri"
  },
  {
    "prefixo": "17259",
    "uf": "SP",
    "codigoIbge": 3505203,
    "cidade": "Bariri"
  },
  {
    "prefixo": "17260",
    "uf": "SP",
    "codigoIbge": 3522000,
    "cidade": "Itaju"
  },
  {
    "prefixo": "17263",
    "uf": "SP",
    "codigoIbge": 3522000,
    "cidade": "Itaju"
  },
  {
    "prefixo": "17264",
    "uf": "SP",
    "codigoIbge": 3522000,
    "cidade": "Itaju"
  },
  {
    "prefixo": "17269",
    "uf": "SP",
    "codigoIbge": 3522000,
    "cidade": "Itaju"
  },
  {
    "prefixo": "17270",
    "uf": "SP",
    "codigoIbge": 3507308,
    "cidade": "Boracéia"
  },
  {
    "prefixo": "17273",
    "uf": "SP",
    "codigoIbge": 3507308,
    "cidade": "Boracéia"
  },
  {
    "prefixo": "17279",
    "uf": "SP",
    "codigoIbge": 3507308,
    "cidade": "Boracéia"
  },
  {
    "prefixo": "17280",
    "uf": "SP",
    "codigoIbge": 3536703,
    "cidade": "Pederneiras"
  },
  {
    "prefixo": "17282",
    "uf": "SP",
    "codigoIbge": 3536703,
    "cidade": "Pederneiras"
  },
  {
    "prefixo": "17283",
    "uf": "SP",
    "codigoIbge": 3536703,
    "cidade": "Pederneiras"
  },
  {
    "prefixo": "17284",
    "uf": "SP",
    "codigoIbge": 3536703,
    "cidade": "Pederneiras"
  },
  {
    "prefixo": "17285",
    "uf": "SP",
    "codigoIbge": 3536703,
    "cidade": "Pederneiras"
  },
  {
    "prefixo": "17286",
    "uf": "SP",
    "codigoIbge": 3536703,
    "cidade": "Pederneiras"
  },
  {
    "prefixo": "17287",
    "uf": "SP",
    "codigoIbge": 3536703,
    "cidade": "Pederneiras"
  },
  {
    "prefixo": "17288",
    "uf": "SP",
    "codigoIbge": 3536703,
    "cidade": "Pederneiras"
  },
  {
    "prefixo": "17289",
    "uf": "SP",
    "codigoIbge": 3536703,
    "cidade": "Pederneiras"
  },
  {
    "prefixo": "17290",
    "uf": "SP",
    "codigoIbge": 3528007,
    "cidade": "Macatuba"
  },
  {
    "prefixo": "17293",
    "uf": "SP",
    "codigoIbge": 3528007,
    "cidade": "Macatuba"
  },
  {
    "prefixo": "17299",
    "uf": "SP",
    "codigoIbge": 3528007,
    "cidade": "Macatuba"
  },
  {
    "prefixo": "17300",
    "uf": "SP",
    "codigoIbge": 3514106,
    "cidade": "Dois Córregos"
  },
  {
    "prefixo": "17302",
    "uf": "SP",
    "codigoIbge": 3514106,
    "cidade": "Dois Córregos"
  },
  {
    "prefixo": "17305",
    "uf": "SP",
    "codigoIbge": 3514106,
    "cidade": "Dois Córregos"
  },
  {
    "prefixo": "17307",
    "uf": "SP",
    "codigoIbge": 3514106,
    "cidade": "Dois Córregos"
  },
  {
    "prefixo": "17309",
    "uf": "SP",
    "codigoIbge": 3514106,
    "cidade": "Dois Córregos"
  },
  {
    "prefixo": "17310",
    "uf": "SP",
    "codigoIbge": 3514106,
    "cidade": "Dois Córregos"
  },
  {
    "prefixo": "17320",
    "uf": "SP",
    "codigoIbge": 3529807,
    "cidade": "Mineiros do Tietê"
  },
  {
    "prefixo": "17322",
    "uf": "SP",
    "codigoIbge": 3529807,
    "cidade": "Mineiros do Tietê"
  },
  {
    "prefixo": "17324",
    "uf": "SP",
    "codigoIbge": 3529807,
    "cidade": "Mineiros do Tietê"
  },
  {
    "prefixo": "17329",
    "uf": "SP",
    "codigoIbge": 3529807,
    "cidade": "Mineiros do Tietê"
  },
  {
    "prefixo": "17340",
    "uf": "SP",
    "codigoIbge": 3505302,
    "cidade": "Barra Bonita"
  },
  {
    "prefixo": "17342",
    "uf": "SP",
    "codigoIbge": 3505302,
    "cidade": "Barra Bonita"
  },
  {
    "prefixo": "17345",
    "uf": "SP",
    "codigoIbge": 3505302,
    "cidade": "Barra Bonita"
  },
  {
    "prefixo": "17347",
    "uf": "SP",
    "codigoIbge": 3505302,
    "cidade": "Barra Bonita"
  },
  {
    "prefixo": "17349",
    "uf": "SP",
    "codigoIbge": 3505302,
    "cidade": "Barra Bonita"
  },
  {
    "prefixo": "17350",
    "uf": "SP",
    "codigoIbge": 3520004,
    "cidade": "Igaraçu do Tietê"
  },
  {
    "prefixo": "17352",
    "uf": "SP",
    "codigoIbge": 3520004,
    "cidade": "Igaraçu do Tietê"
  },
  {
    "prefixo": "17354",
    "uf": "SP",
    "codigoIbge": 3520004,
    "cidade": "Igaraçu do Tietê"
  },
  {
    "prefixo": "17357",
    "uf": "SP",
    "codigoIbge": 3520004,
    "cidade": "Igaraçu do Tietê"
  },
  {
    "prefixo": "17359",
    "uf": "SP",
    "codigoIbge": 3520004,
    "cidade": "Igaraçu do Tietê"
  },
  {
    "prefixo": "17360",
    "uf": "SP",
    "codigoIbge": 3554706,
    "cidade": "Torrinha"
  },
  {
    "prefixo": "17362",
    "uf": "SP",
    "codigoIbge": 3554706,
    "cidade": "Torrinha"
  },
  {
    "prefixo": "17363",
    "uf": "SP",
    "codigoIbge": 3554706,
    "cidade": "Torrinha"
  },
  {
    "prefixo": "17369",
    "uf": "SP",
    "codigoIbge": 3554706,
    "cidade": "Torrinha"
  },
  {
    "prefixo": "17370",
    "uf": "SP",
    "codigoIbge": 3547007,
    "cidade": "Santa Maria da Serra"
  },
  {
    "prefixo": "17379",
    "uf": "SP",
    "codigoIbge": 3547007,
    "cidade": "Santa Maria da Serra"
  },
  {
    "prefixo": "17380",
    "uf": "SP",
    "codigoIbge": 3507902,
    "cidade": "Brotas"
  },
  {
    "prefixo": "17382",
    "uf": "SP",
    "codigoIbge": 3507902,
    "cidade": "Brotas"
  },
  {
    "prefixo": "17385",
    "uf": "SP",
    "codigoIbge": 3507902,
    "cidade": "Brotas"
  },
  {
    "prefixo": "17389",
    "uf": "SP",
    "codigoIbge": 3507902,
    "cidade": "Brotas"
  },
  {
    "prefixo": "17390",
    "uf": "SP",
    "codigoIbge": 3507902,
    "cidade": "Brotas"
  },
  {
    "prefixo": "17400",
    "uf": "SP",
    "codigoIbge": 3516705,
    "cidade": "Garça"
  },
  {
    "prefixo": "17401",
    "uf": "SP",
    "codigoIbge": 3516705,
    "cidade": "Garça"
  },
  {
    "prefixo": "17402",
    "uf": "SP",
    "codigoIbge": 3516705,
    "cidade": "Garça"
  },
  {
    "prefixo": "17404",
    "uf": "SP",
    "codigoIbge": 3516705,
    "cidade": "Garça"
  },
  {
    "prefixo": "17406",
    "uf": "SP",
    "codigoIbge": 3516705,
    "cidade": "Garça"
  },
  {
    "prefixo": "17408",
    "uf": "SP",
    "codigoIbge": 3516705,
    "cidade": "Garça"
  },
  {
    "prefixo": "17409",
    "uf": "SP",
    "codigoIbge": 3516705,
    "cidade": "Garça"
  },
  {
    "prefixo": "17410",
    "uf": "SP",
    "codigoIbge": 3501400,
    "cidade": "Álvaro de Carvalho"
  },
  {
    "prefixo": "17419",
    "uf": "SP",
    "codigoIbge": 3501400,
    "cidade": "Álvaro de Carvalho"
  },
  {
    "prefixo": "17420",
    "uf": "SP",
    "codigoIbge": 3527801,
    "cidade": "Lupércio"
  },
  {
    "prefixo": "17428",
    "uf": "SP",
    "codigoIbge": 3527801,
    "cidade": "Lupércio"
  },
  {
    "prefixo": "17429",
    "uf": "SP",
    "codigoIbge": 3527801,
    "cidade": "Lupércio"
  },
  {
    "prefixo": "17430",
    "uf": "SP",
    "codigoIbge": 3501509,
    "cidade": "Alvinlândia"
  },
  {
    "prefixo": "17439",
    "uf": "SP",
    "codigoIbge": 3501509,
    "cidade": "Alvinlândia"
  },
  {
    "prefixo": "17440",
    "uf": "SP",
    "codigoIbge": 3555505,
    "cidade": "Ubirajara"
  },
  {
    "prefixo": "17448",
    "uf": "SP",
    "codigoIbge": 3555505,
    "cidade": "Ubirajara"
  },
  {
    "prefixo": "17450",
    "uf": "SP",
    "codigoIbge": 3516606,
    "cidade": "Gália"
  },
  {
    "prefixo": "17459",
    "uf": "SP",
    "codigoIbge": 3516606,
    "cidade": "Gália"
  },
  {
    "prefixo": "17460",
    "uf": "SP",
    "codigoIbge": 3515657,
    "cidade": "Fernão"
  },
  {
    "prefixo": "17469",
    "uf": "SP",
    "codigoIbge": 3515657,
    "cidade": "Fernão"
  },
  {
    "prefixo": "17470",
    "uf": "SP",
    "codigoIbge": 3514502,
    "cidade": "Duartina"
  },
  {
    "prefixo": "17471",
    "uf": "SP",
    "codigoIbge": 3514502,
    "cidade": "Duartina"
  },
  {
    "prefixo": "17472",
    "uf": "SP",
    "codigoIbge": 3514502,
    "cidade": "Duartina"
  },
  {
    "prefixo": "17473",
    "uf": "SP",
    "codigoIbge": 3514502,
    "cidade": "Duartina"
  },
  {
    "prefixo": "17474",
    "uf": "SP",
    "codigoIbge": 3514502,
    "cidade": "Duartina"
  },
  {
    "prefixo": "17475",
    "uf": "SP",
    "codigoIbge": 3527504,
    "cidade": "Lucianópolis"
  },
  {
    "prefixo": "17479",
    "uf": "SP",
    "codigoIbge": 3527504,
    "cidade": "Lucianópolis"
  },
  {
    "prefixo": "17480",
    "uf": "SP",
    "codigoIbge": 3508306,
    "cidade": "Cabrália Paulista"
  },
  {
    "prefixo": "17481",
    "uf": "SP",
    "codigoIbge": 3508306,
    "cidade": "Cabrália Paulista"
  },
  {
    "prefixo": "17489",
    "uf": "SP",
    "codigoIbge": 3508306,
    "cidade": "Cabrália Paulista"
  },
  {
    "prefixo": "17490",
    "uf": "SP",
    "codigoIbge": 3539400,
    "cidade": "Piratininga"
  },
  {
    "prefixo": "17492",
    "uf": "SP",
    "codigoIbge": 3539400,
    "cidade": "Piratininga"
  },
  {
    "prefixo": "17495",
    "uf": "SP",
    "codigoIbge": 3539400,
    "cidade": "Piratininga"
  },
  {
    "prefixo": "17497",
    "uf": "SP",
    "codigoIbge": 3539400,
    "cidade": "Piratininga"
  },
  {
    "prefixo": "17498",
    "uf": "SP",
    "codigoIbge": 3539400,
    "cidade": "Piratininga"
  },
  {
    "prefixo": "17499",
    "uf": "SP",
    "codigoIbge": 3539400,
    "cidade": "Piratininga"
  },
  {
    "prefixo": "17500",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17501",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17502",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17503",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17504",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17505",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17506",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17507",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17509",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17510",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17511",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17512",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17513",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17514",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17515",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17516",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17519",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17520",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17521",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17522",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17523",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17524",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17525",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17526",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17527",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17530",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17532",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17533",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17535",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17537",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17539",
    "uf": "SP",
    "codigoIbge": 3529005,
    "cidade": "Marília"
  },
  {
    "prefixo": "17540",
    "uf": "SP",
    "codigoIbge": 3533700,
    "cidade": "Ocauçu"
  },
  {
    "prefixo": "17546",
    "uf": "SP",
    "codigoIbge": 3533700,
    "cidade": "Ocauçu"
  },
  {
    "prefixo": "17547",
    "uf": "SP",
    "codigoIbge": 3533700,
    "cidade": "Ocauçu"
  },
  {
    "prefixo": "17549",
    "uf": "SP",
    "codigoIbge": 3533700,
    "cidade": "Ocauçu"
  },
  {
    "prefixo": "17550",
    "uf": "SP",
    "codigoIbge": 3525805,
    "cidade": "Júlio Mesquita"
  },
  {
    "prefixo": "17559",
    "uf": "SP",
    "codigoIbge": 3525805,
    "cidade": "Júlio Mesquita"
  },
  {
    "prefixo": "17560",
    "uf": "SP",
    "codigoIbge": 3556602,
    "cidade": "Vera Cruz"
  },
  {
    "prefixo": "17562",
    "uf": "SP",
    "codigoIbge": 3556602,
    "cidade": "Vera Cruz"
  },
  {
    "prefixo": "17569",
    "uf": "SP",
    "codigoIbge": 3556602,
    "cidade": "Vera Cruz"
  },
  {
    "prefixo": "17570",
    "uf": "SP",
    "codigoIbge": 3534104,
    "cidade": "Oriente"
  },
  {
    "prefixo": "17572",
    "uf": "SP",
    "codigoIbge": 3534104,
    "cidade": "Oriente"
  },
  {
    "prefixo": "17580",
    "uf": "SP",
    "codigoIbge": 3540002,
    "cidade": "Pompéia"
  },
  {
    "prefixo": "17581",
    "uf": "SP",
    "codigoIbge": 3540002,
    "cidade": "Pompéia"
  },
  {
    "prefixo": "17582",
    "uf": "SP",
    "codigoIbge": 3540002,
    "cidade": "Pompéia"
  },
  {
    "prefixo": "17584",
    "uf": "SP",
    "codigoIbge": 3540002,
    "cidade": "Pompéia"
  },
  {
    "prefixo": "17586",
    "uf": "SP",
    "codigoIbge": 3540002,
    "cidade": "Pompéia"
  },
  {
    "prefixo": "17587",
    "uf": "SP",
    "codigoIbge": 3540002,
    "cidade": "Pompéia"
  },
  {
    "prefixo": "17588",
    "uf": "SP",
    "codigoIbge": 3540002,
    "cidade": "Pompéia"
  },
  {
    "prefixo": "17589",
    "uf": "SP",
    "codigoIbge": 3540002,
    "cidade": "Pompéia"
  },
  {
    "prefixo": "17590",
    "uf": "SP",
    "codigoIbge": 3541802,
    "cidade": "Queiroz"
  },
  {
    "prefixo": "17600",
    "uf": "SP",
    "codigoIbge": 3555000,
    "cidade": "Tupã"
  },
  {
    "prefixo": "17601",
    "uf": "SP",
    "codigoIbge": 3555000,
    "cidade": "Tupã"
  },
  {
    "prefixo": "17602",
    "uf": "SP",
    "codigoIbge": 3555000,
    "cidade": "Tupã"
  },
  {
    "prefixo": "17603",
    "uf": "SP",
    "codigoIbge": 3555000,
    "cidade": "Tupã"
  },
  {
    "prefixo": "17604",
    "uf": "SP",
    "codigoIbge": 3555000,
    "cidade": "Tupã"
  },
  {
    "prefixo": "17605",
    "uf": "SP",
    "codigoIbge": 3555000,
    "cidade": "Tupã"
  },
  {
    "prefixo": "17606",
    "uf": "SP",
    "codigoIbge": 3555000,
    "cidade": "Tupã"
  },
  {
    "prefixo": "17607",
    "uf": "SP",
    "codigoIbge": 3555000,
    "cidade": "Tupã"
  },
  {
    "prefixo": "17610",
    "uf": "SP",
    "codigoIbge": 3555000,
    "cidade": "Tupã"
  },
  {
    "prefixo": "17620",
    "uf": "SP",
    "codigoIbge": 3555000,
    "cidade": "Tupã"
  },
  {
    "prefixo": "17623",
    "uf": "SP",
    "codigoIbge": 3555000,
    "cidade": "Tupã"
  },
  {
    "prefixo": "17625",
    "uf": "SP",
    "codigoIbge": 3555000,
    "cidade": "Tupã"
  },
  {
    "prefixo": "17626",
    "uf": "SP",
    "codigoIbge": 3555000,
    "cidade": "Tupã"
  },
  {
    "prefixo": "17630",
    "uf": "SP",
    "codigoIbge": 3503356,
    "cidade": "Arco-Íris"
  },
  {
    "prefixo": "17650",
    "uf": "SP",
    "codigoIbge": 3519006,
    "cidade": "Herculândia"
  },
  {
    "prefixo": "17660",
    "uf": "SP",
    "codigoIbge": 3519006,
    "cidade": "Herculândia"
  },
  {
    "prefixo": "17670",
    "uf": "SP",
    "codigoIbge": 3542008,
    "cidade": "Quintana"
  },
  {
    "prefixo": "17680",
    "uf": "SP",
    "codigoIbge": 3519204,
    "cidade": "Iacri"
  },
  {
    "prefixo": "17685",
    "uf": "SP",
    "codigoIbge": 3519204,
    "cidade": "Iacri"
  },
  {
    "prefixo": "17690",
    "uf": "SP",
    "codigoIbge": 3505807,
    "cidade": "Bastos"
  },
  {
    "prefixo": "17700",
    "uf": "SP",
    "codigoIbge": 3534609,
    "cidade": "Osvaldo Cruz"
  },
  {
    "prefixo": "17710",
    "uf": "SP",
    "codigoIbge": 3544707,
    "cidade": "Sagres"
  },
  {
    "prefixo": "17720",
    "uf": "SP",
    "codigoIbge": 3545100,
    "cidade": "Salmourão"
  },
  {
    "prefixo": "17730",
    "uf": "SP",
    "codigoIbge": 3536000,
    "cidade": "Parapuã"
  },
  {
    "prefixo": "17740",
    "uf": "SP",
    "codigoIbge": 3543808,
    "cidade": "Rinópolis"
  },
  {
    "prefixo": "17760",
    "uf": "SP",
    "codigoIbge": 3520806,
    "cidade": "Inúbia Paulista"
  },
  {
    "prefixo": "17780",
    "uf": "SP",
    "codigoIbge": 3527405,
    "cidade": "Lucélia"
  },
  {
    "prefixo": "17790",
    "uf": "SP",
    "codigoIbge": 3540853,
    "cidade": "Pracinha"
  },
  {
    "prefixo": "17800",
    "uf": "SP",
    "codigoIbge": 3500105,
    "cidade": "Adamantina"
  },
  {
    "prefixo": "17802",
    "uf": "SP",
    "codigoIbge": 3500105,
    "cidade": "Adamantina"
  },
  {
    "prefixo": "17803",
    "uf": "SP",
    "codigoIbge": 3500105,
    "cidade": "Adamantina"
  },
  {
    "prefixo": "17805",
    "uf": "SP",
    "codigoIbge": 3500105,
    "cidade": "Adamantina"
  },
  {
    "prefixo": "17806",
    "uf": "SP",
    "codigoIbge": 3500105,
    "cidade": "Adamantina"
  },
  {
    "prefixo": "17808",
    "uf": "SP",
    "codigoIbge": 3500105,
    "cidade": "Adamantina"
  },
  {
    "prefixo": "17810",
    "uf": "SP",
    "codigoIbge": 3528908,
    "cidade": "Mariápolis"
  },
  {
    "prefixo": "17830",
    "uf": "SP",
    "codigoIbge": 3516002,
    "cidade": "Flórida Paulista"
  },
  {
    "prefixo": "17835",
    "uf": "SP",
    "codigoIbge": 3516002,
    "cidade": "Flórida Paulista"
  },
  {
    "prefixo": "17860",
    "uf": "SP",
    "codigoIbge": 3534906,
    "cidade": "Pacaembu"
  },
  {
    "prefixo": "17870",
    "uf": "SP",
    "codigoIbge": 3515806,
    "cidade": "Flora Rica"
  },
  {
    "prefixo": "17880",
    "uf": "SP",
    "codigoIbge": 3521606,
    "cidade": "Irapuru"
  },
  {
    "prefixo": "17890",
    "uf": "SP",
    "codigoIbge": 3526001,
    "cidade": "Junqueirópolis"
  },
  {
    "prefixo": "17900",
    "uf": "SP",
    "codigoIbge": 3514403,
    "cidade": "Dracena"
  },
  {
    "prefixo": "17902",
    "uf": "SP",
    "codigoIbge": 3514403,
    "cidade": "Dracena"
  },
  {
    "prefixo": "17904",
    "uf": "SP",
    "codigoIbge": 3514403,
    "cidade": "Dracena"
  },
  {
    "prefixo": "17906",
    "uf": "SP",
    "codigoIbge": 3514403,
    "cidade": "Dracena"
  },
  {
    "prefixo": "17908",
    "uf": "SP",
    "codigoIbge": 3514403,
    "cidade": "Dracena"
  },
  {
    "prefixo": "17910",
    "uf": "SP",
    "codigoIbge": 3514403,
    "cidade": "Dracena"
  },
  {
    "prefixo": "17911",
    "uf": "SP",
    "codigoIbge": 3514403,
    "cidade": "Dracena"
  },
  {
    "prefixo": "17915",
    "uf": "SP",
    "codigoIbge": 3514403,
    "cidade": "Dracena"
  },
  {
    "prefixo": "17916",
    "uf": "SP",
    "codigoIbge": 3514403,
    "cidade": "Dracena"
  },
  {
    "prefixo": "17918",
    "uf": "SP",
    "codigoIbge": 3514403,
    "cidade": "Dracena"
  },
  {
    "prefixo": "17920",
    "uf": "SP",
    "codigoIbge": 3534807,
    "cidade": "Ouro Verde"
  },
  {
    "prefixo": "17930",
    "uf": "SP",
    "codigoIbge": 3555109,
    "cidade": "Tupi Paulista"
  },
  {
    "prefixo": "17940",
    "uf": "SP",
    "codigoIbge": 3547106,
    "cidade": "Santa Mercedes"
  },
  {
    "prefixo": "17945",
    "uf": "SP",
    "codigoIbge": 3547106,
    "cidade": "Santa Mercedes"
  },
  {
    "prefixo": "17950",
    "uf": "SP",
    "codigoIbge": 3533106,
    "cidade": "Nova Guataporanga"
  },
  {
    "prefixo": "17960",
    "uf": "SP",
    "codigoIbge": 3531605,
    "cidade": "Monte Castelo"
  },
  {
    "prefixo": "17970",
    "uf": "SP",
    "codigoIbge": 3549300,
    "cidade": "São João do Pau d'Alho"
  },
  {
    "prefixo": "17980",
    "uf": "SP",
    "codigoIbge": 3535408,
    "cidade": "Panorama"
  },
  {
    "prefixo": "17990",
    "uf": "SP",
    "codigoIbge": 3536406,
    "cidade": "Paulicéia"
  },
  {
    "prefixo": "18010",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18013",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18015",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18016",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18017",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18020",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18021",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18022",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18023",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18025",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18030",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18031",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18035",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18040",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18043",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18044",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18045",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18046",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18047",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18048",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18050",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18051",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18052",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18053",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18054",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18055",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18056",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18057",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18060",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18061",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18065",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18066",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18070",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18071",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18072",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18073",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18074",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18075",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18076",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18077",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18078",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18079",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18080",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18081",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18085",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18086",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18087",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18090",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18095",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18103",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18104",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18105",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18108",
    "uf": "SP",
    "codigoIbge": 3552205,
    "cidade": "Sorocaba"
  },
  {
    "prefixo": "18110",
    "uf": "SP",
    "codigoIbge": 3557006,
    "cidade": "Votorantim"
  },
  {
    "prefixo": "18111",
    "uf": "SP",
    "codigoIbge": 3557006,
    "cidade": "Votorantim"
  },
  {
    "prefixo": "18112",
    "uf": "SP",
    "codigoIbge": 3557006,
    "cidade": "Votorantim"
  },
  {
    "prefixo": "18113",
    "uf": "SP",
    "codigoIbge": 3557006,
    "cidade": "Votorantim"
  },
  {
    "prefixo": "18114",
    "uf": "SP",
    "codigoIbge": 3557006,
    "cidade": "Votorantim"
  },
  {
    "prefixo": "18115",
    "uf": "SP",
    "codigoIbge": 3557006,
    "cidade": "Votorantim"
  },
  {
    "prefixo": "18116",
    "uf": "SP",
    "codigoIbge": 3557006,
    "cidade": "Votorantim"
  },
  {
    "prefixo": "18117",
    "uf": "SP",
    "codigoIbge": 3557006,
    "cidade": "Votorantim"
  },
  {
    "prefixo": "18118",
    "uf": "SP",
    "codigoIbge": 3557006,
    "cidade": "Votorantim"
  },
  {
    "prefixo": "18119",
    "uf": "SP",
    "codigoIbge": 3557006,
    "cidade": "Votorantim"
  },
  {
    "prefixo": "18120",
    "uf": "SP",
    "codigoIbge": 3528403,
    "cidade": "Mairinque"
  },
  {
    "prefixo": "18123",
    "uf": "SP",
    "codigoIbge": 3528403,
    "cidade": "Mairinque"
  },
  {
    "prefixo": "18125",
    "uf": "SP",
    "codigoIbge": 3501152,
    "cidade": "Alumínio"
  },
  {
    "prefixo": "18130",
    "uf": "SP",
    "codigoIbge": 3550605,
    "cidade": "São Roque"
  },
  {
    "prefixo": "18131",
    "uf": "SP",
    "codigoIbge": 3550605,
    "cidade": "São Roque"
  },
  {
    "prefixo": "18132",
    "uf": "SP",
    "codigoIbge": 3550605,
    "cidade": "São Roque"
  },
  {
    "prefixo": "18133",
    "uf": "SP",
    "codigoIbge": 3550605,
    "cidade": "São Roque"
  },
  {
    "prefixo": "18134",
    "uf": "SP",
    "codigoIbge": 3550605,
    "cidade": "São Roque"
  },
  {
    "prefixo": "18135",
    "uf": "SP",
    "codigoIbge": 3550605,
    "cidade": "São Roque"
  },
  {
    "prefixo": "18136",
    "uf": "SP",
    "codigoIbge": 3550605,
    "cidade": "São Roque"
  },
  {
    "prefixo": "18140",
    "uf": "SP",
    "codigoIbge": 3550605,
    "cidade": "São Roque"
  },
  {
    "prefixo": "18143",
    "uf": "SP",
    "codigoIbge": 3550605,
    "cidade": "São Roque"
  },
  {
    "prefixo": "18145",
    "uf": "SP",
    "codigoIbge": 3550605,
    "cidade": "São Roque"
  },
  {
    "prefixo": "18147",
    "uf": "SP",
    "codigoIbge": 3502754,
    "cidade": "Araçariguama"
  },
  {
    "prefixo": "18150",
    "uf": "SP",
    "codigoIbge": 3519709,
    "cidade": "Ibiúna"
  },
  {
    "prefixo": "18155",
    "uf": "SP",
    "codigoIbge": 3519709,
    "cidade": "Ibiúna"
  },
  {
    "prefixo": "18160",
    "uf": "SP",
    "codigoIbge": 3545308,
    "cidade": "Salto de Pirapora"
  },
  {
    "prefixo": "18170",
    "uf": "SP",
    "codigoIbge": 3537800,
    "cidade": "Piedade"
  },
  {
    "prefixo": "18180",
    "uf": "SP",
    "codigoIbge": 3553500,
    "cidade": "Tapiraí"
  },
  {
    "prefixo": "18185",
    "uf": "SP",
    "codigoIbge": 3537909,
    "cidade": "Pilar do Sul"
  },
  {
    "prefixo": "18190",
    "uf": "SP",
    "codigoIbge": 3502903,
    "cidade": "Araçoiaba da Serra"
  },
  {
    "prefixo": "18195",
    "uf": "SP",
    "codigoIbge": 3510302,
    "cidade": "Capela do Alto"
  },
  {
    "prefixo": "18200",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18201",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18202",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18203",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18204",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18205",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18206",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18207",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18208",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18209",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18210",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18211",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18212",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18213",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18214",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18215",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18216",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18217",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18218",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18219",
    "uf": "SP",
    "codigoIbge": 3522307,
    "cidade": "Itapetininga"
  },
  {
    "prefixo": "18220",
    "uf": "SP",
    "codigoIbge": 3500758,
    "cidade": "Alambari"
  },
  {
    "prefixo": "18225",
    "uf": "SP",
    "codigoIbge": 3551108,
    "cidade": "Sarapuí"
  },
  {
    "prefixo": "18227",
    "uf": "SP",
    "codigoIbge": 3551108,
    "cidade": "Sarapuí"
  },
  {
    "prefixo": "18230",
    "uf": "SP",
    "codigoIbge": 3550209,
    "cidade": "São Miguel Arcanjo"
  },
  {
    "prefixo": "18240",
    "uf": "SP",
    "codigoIbge": 3502200,
    "cidade": "Angatuba"
  },
  {
    "prefixo": "18245",
    "uf": "SP",
    "codigoIbge": 3509452,
    "cidade": "Campina do Monte Alegre"
  },
  {
    "prefixo": "18250",
    "uf": "SP",
    "codigoIbge": 3518503,
    "cidade": "Guareí"
  },
  {
    "prefixo": "18255",
    "uf": "SP",
    "codigoIbge": 3541653,
    "cidade": "Quadra"
  },
  {
    "prefixo": "18260",
    "uf": "SP",
    "codigoIbge": 3540507,
    "cidade": "Porangaba"
  },
  {
    "prefixo": "18265",
    "uf": "SP",
    "codigoIbge": 3554656,
    "cidade": "Torre de Pedra"
  },
  {
    "prefixo": "18270",
    "uf": "SP",
    "codigoIbge": 3554003,
    "cidade": "Tatuí"
  },
  {
    "prefixo": "18271",
    "uf": "SP",
    "codigoIbge": 3554003,
    "cidade": "Tatuí"
  },
  {
    "prefixo": "18272",
    "uf": "SP",
    "codigoIbge": 3554003,
    "cidade": "Tatuí"
  },
  {
    "prefixo": "18273",
    "uf": "SP",
    "codigoIbge": 3554003,
    "cidade": "Tatuí"
  },
  {
    "prefixo": "18274",
    "uf": "SP",
    "codigoIbge": 3554003,
    "cidade": "Tatuí"
  },
  {
    "prefixo": "18275",
    "uf": "SP",
    "codigoIbge": 3554003,
    "cidade": "Tatuí"
  },
  {
    "prefixo": "18276",
    "uf": "SP",
    "codigoIbge": 3554003,
    "cidade": "Tatuí"
  },
  {
    "prefixo": "18277",
    "uf": "SP",
    "codigoIbge": 3554003,
    "cidade": "Tatuí"
  },
  {
    "prefixo": "18278",
    "uf": "SP",
    "codigoIbge": 3554003,
    "cidade": "Tatuí"
  },
  {
    "prefixo": "18279",
    "uf": "SP",
    "codigoIbge": 3554003,
    "cidade": "Tatuí"
  },
  {
    "prefixo": "18280",
    "uf": "SP",
    "codigoIbge": 3554003,
    "cidade": "Tatuí"
  },
  {
    "prefixo": "18282",
    "uf": "SP",
    "codigoIbge": 3554003,
    "cidade": "Tatuí"
  },
  {
    "prefixo": "18285",
    "uf": "SP",
    "codigoIbge": 3511607,
    "cidade": "Cesário Lange"
  },
  {
    "prefixo": "18290",
    "uf": "SP",
    "codigoIbge": 3508009,
    "cidade": "Buri"
  },
  {
    "prefixo": "18295",
    "uf": "SP",
    "codigoIbge": 3508009,
    "cidade": "Buri"
  },
  {
    "prefixo": "18300",
    "uf": "SP",
    "codigoIbge": 3510203,
    "cidade": "Capão Bonito"
  },
  {
    "prefixo": "18301",
    "uf": "SP",
    "codigoIbge": 3510203,
    "cidade": "Capão Bonito"
  },
  {
    "prefixo": "18302",
    "uf": "SP",
    "codigoIbge": 3510203,
    "cidade": "Capão Bonito"
  },
  {
    "prefixo": "18303",
    "uf": "SP",
    "codigoIbge": 3510203,
    "cidade": "Capão Bonito"
  },
  {
    "prefixo": "18304",
    "uf": "SP",
    "codigoIbge": 3510203,
    "cidade": "Capão Bonito"
  },
  {
    "prefixo": "18305",
    "uf": "SP",
    "codigoIbge": 3510203,
    "cidade": "Capão Bonito"
  },
  {
    "prefixo": "18306",
    "uf": "SP",
    "codigoIbge": 3510203,
    "cidade": "Capão Bonito"
  },
  {
    "prefixo": "18307",
    "uf": "SP",
    "codigoIbge": 3510203,
    "cidade": "Capão Bonito"
  },
  {
    "prefixo": "18309",
    "uf": "SP",
    "codigoIbge": 3510203,
    "cidade": "Capão Bonito"
  },
  {
    "prefixo": "18310",
    "uf": "SP",
    "codigoIbge": 3517604,
    "cidade": "Guapiara"
  },
  {
    "prefixo": "18315",
    "uf": "SP",
    "codigoIbge": 3543253,
    "cidade": "Ribeirão Grande"
  },
  {
    "prefixo": "18320",
    "uf": "SP",
    "codigoIbge": 3502705,
    "cidade": "Apiaí"
  },
  {
    "prefixo": "18323",
    "uf": "SP",
    "codigoIbge": 3502705,
    "cidade": "Apiaí"
  },
  {
    "prefixo": "18324",
    "uf": "SP",
    "codigoIbge": 3502705,
    "cidade": "Apiaí"
  },
  {
    "prefixo": "18325",
    "uf": "SP",
    "codigoIbge": 3505351,
    "cidade": "Barra do Chapéu"
  },
  {
    "prefixo": "18326",
    "uf": "SP",
    "codigoIbge": 3505351,
    "cidade": "Barra do Chapéu"
  },
  {
    "prefixo": "18330",
    "uf": "SP",
    "codigoIbge": 3521200,
    "cidade": "Iporanga"
  },
  {
    "prefixo": "18360",
    "uf": "SP",
    "codigoIbge": 3522158,
    "cidade": "Itaoca"
  },
  {
    "prefixo": "18380",
    "uf": "SP",
    "codigoIbge": 3542800,
    "cidade": "Ribeira"
  },
  {
    "prefixo": "18385",
    "uf": "SP",
    "codigoIbge": 3522653,
    "cidade": "Itapirapuã Paulista"
  },
  {
    "prefixo": "18400",
    "uf": "SP",
    "codigoIbge": 3522406,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "18401",
    "uf": "SP",
    "codigoIbge": 3522406,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "18402",
    "uf": "SP",
    "codigoIbge": 3522406,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "18403",
    "uf": "SP",
    "codigoIbge": 3522406,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "18404",
    "uf": "SP",
    "codigoIbge": 3522406,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "18405",
    "uf": "SP",
    "codigoIbge": 3522406,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "18406",
    "uf": "SP",
    "codigoIbge": 3522406,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "18407",
    "uf": "SP",
    "codigoIbge": 3522406,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "18408",
    "uf": "SP",
    "codigoIbge": 3522406,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "18409",
    "uf": "SP",
    "codigoIbge": 3522406,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "18410",
    "uf": "SP",
    "codigoIbge": 3522406,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "18411",
    "uf": "SP",
    "codigoIbge": 3522406,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "18412",
    "uf": "SP",
    "codigoIbge": 3522406,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "18419",
    "uf": "SP",
    "codigoIbge": 3522406,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "18420",
    "uf": "SP",
    "codigoIbge": 3522406,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "18425",
    "uf": "SP",
    "codigoIbge": 3553856,
    "cidade": "Taquarivaí"
  },
  {
    "prefixo": "18430",
    "uf": "SP",
    "codigoIbge": 3543006,
    "cidade": "Ribeirão Branco"
  },
  {
    "prefixo": "18433",
    "uf": "SP",
    "codigoIbge": 3543006,
    "cidade": "Ribeirão Branco"
  },
  {
    "prefixo": "18434",
    "uf": "SP",
    "codigoIbge": 3543006,
    "cidade": "Ribeirão Branco"
  },
  {
    "prefixo": "18435",
    "uf": "SP",
    "codigoIbge": 3532827,
    "cidade": "Nova Campina"
  },
  {
    "prefixo": "18440",
    "uf": "SP",
    "codigoIbge": 3521705,
    "cidade": "Itaberá"
  },
  {
    "prefixo": "18445",
    "uf": "SP",
    "codigoIbge": 3521705,
    "cidade": "Itaberá"
  },
  {
    "prefixo": "18450",
    "uf": "SP",
    "codigoIbge": 3521705,
    "cidade": "Itaberá"
  },
  {
    "prefixo": "18460",
    "uf": "SP",
    "codigoIbge": 3523206,
    "cidade": "Itararé"
  },
  {
    "prefixo": "18462",
    "uf": "SP",
    "codigoIbge": 3523206,
    "cidade": "Itararé"
  },
  {
    "prefixo": "18463",
    "uf": "SP",
    "codigoIbge": 3523206,
    "cidade": "Itararé"
  },
  {
    "prefixo": "18464",
    "uf": "SP",
    "codigoIbge": 3523206,
    "cidade": "Itararé"
  },
  {
    "prefixo": "18466",
    "uf": "SP",
    "codigoIbge": 3523206,
    "cidade": "Itararé"
  },
  {
    "prefixo": "18467",
    "uf": "SP",
    "codigoIbge": 3523206,
    "cidade": "Itararé"
  },
  {
    "prefixo": "18468",
    "uf": "SP",
    "codigoIbge": 3523206,
    "cidade": "Itararé"
  },
  {
    "prefixo": "18469",
    "uf": "SP",
    "codigoIbge": 3523206,
    "cidade": "Itararé"
  },
  {
    "prefixo": "18470",
    "uf": "SP",
    "codigoIbge": 3543501,
    "cidade": "Riversul"
  },
  {
    "prefixo": "18475",
    "uf": "SP",
    "codigoIbge": 3507159,
    "cidade": "Bom Sucesso de Itararé"
  },
  {
    "prefixo": "18479",
    "uf": "SP",
    "codigoIbge": 3507159,
    "cidade": "Bom Sucesso de Itararé"
  },
  {
    "prefixo": "18480",
    "uf": "SP",
    "codigoIbge": 3522802,
    "cidade": "Itaporanga"
  },
  {
    "prefixo": "18490",
    "uf": "SP",
    "codigoIbge": 3505005,
    "cidade": "Barão de Antonina"
  },
  {
    "prefixo": "18500",
    "uf": "SP",
    "codigoIbge": 3526407,
    "cidade": "Laranjal Paulista"
  },
  {
    "prefixo": "18505",
    "uf": "SP",
    "codigoIbge": 3526407,
    "cidade": "Laranjal Paulista"
  },
  {
    "prefixo": "18510",
    "uf": "SP",
    "codigoIbge": 3526407,
    "cidade": "Laranjal Paulista"
  },
  {
    "prefixo": "18520",
    "uf": "SP",
    "codigoIbge": 3511508,
    "cidade": "Cerquilho"
  },
  {
    "prefixo": "18522",
    "uf": "SP",
    "codigoIbge": 3511508,
    "cidade": "Cerquilho"
  },
  {
    "prefixo": "18523",
    "uf": "SP",
    "codigoIbge": 3511508,
    "cidade": "Cerquilho"
  },
  {
    "prefixo": "18525",
    "uf": "SP",
    "codigoIbge": 3511508,
    "cidade": "Cerquilho"
  },
  {
    "prefixo": "18526",
    "uf": "SP",
    "codigoIbge": 3511508,
    "cidade": "Cerquilho"
  },
  {
    "prefixo": "18527",
    "uf": "SP",
    "codigoIbge": 3511508,
    "cidade": "Cerquilho"
  },
  {
    "prefixo": "18528",
    "uf": "SP",
    "codigoIbge": 3511508,
    "cidade": "Cerquilho"
  },
  {
    "prefixo": "18529",
    "uf": "SP",
    "codigoIbge": 3511508,
    "cidade": "Cerquilho"
  },
  {
    "prefixo": "18530",
    "uf": "SP",
    "codigoIbge": 3554508,
    "cidade": "Tietê"
  },
  {
    "prefixo": "18535",
    "uf": "SP",
    "codigoIbge": 3525854,
    "cidade": "Jumirim"
  },
  {
    "prefixo": "18540",
    "uf": "SP",
    "codigoIbge": 3540606,
    "cidade": "Porto Feliz"
  },
  {
    "prefixo": "18542",
    "uf": "SP",
    "codigoIbge": 3540606,
    "cidade": "Porto Feliz"
  },
  {
    "prefixo": "18543",
    "uf": "SP",
    "codigoIbge": 3540606,
    "cidade": "Porto Feliz"
  },
  {
    "prefixo": "18545",
    "uf": "SP",
    "codigoIbge": 3540606,
    "cidade": "Porto Feliz"
  },
  {
    "prefixo": "18546",
    "uf": "SP",
    "codigoIbge": 3540606,
    "cidade": "Porto Feliz"
  },
  {
    "prefixo": "18547",
    "uf": "SP",
    "codigoIbge": 3540606,
    "cidade": "Porto Feliz"
  },
  {
    "prefixo": "18548",
    "uf": "SP",
    "codigoIbge": 3540606,
    "cidade": "Porto Feliz"
  },
  {
    "prefixo": "18549",
    "uf": "SP",
    "codigoIbge": 3540606,
    "cidade": "Porto Feliz"
  },
  {
    "prefixo": "18550",
    "uf": "SP",
    "codigoIbge": 3507001,
    "cidade": "Boituva"
  },
  {
    "prefixo": "18552",
    "uf": "SP",
    "codigoIbge": 3507001,
    "cidade": "Boituva"
  },
  {
    "prefixo": "18553",
    "uf": "SP",
    "codigoIbge": 3507001,
    "cidade": "Boituva"
  },
  {
    "prefixo": "18555",
    "uf": "SP",
    "codigoIbge": 3507001,
    "cidade": "Boituva"
  },
  {
    "prefixo": "18556",
    "uf": "SP",
    "codigoIbge": 3507001,
    "cidade": "Boituva"
  },
  {
    "prefixo": "18557",
    "uf": "SP",
    "codigoIbge": 3507001,
    "cidade": "Boituva"
  },
  {
    "prefixo": "18558",
    "uf": "SP",
    "codigoIbge": 3507001,
    "cidade": "Boituva"
  },
  {
    "prefixo": "18559",
    "uf": "SP",
    "codigoIbge": 3507001,
    "cidade": "Boituva"
  },
  {
    "prefixo": "18560",
    "uf": "SP",
    "codigoIbge": 3521002,
    "cidade": "Iperó"
  },
  {
    "prefixo": "18565",
    "uf": "SP",
    "codigoIbge": 3521002,
    "cidade": "Iperó"
  },
  {
    "prefixo": "18570",
    "uf": "SP",
    "codigoIbge": 3512308,
    "cidade": "Conchas"
  },
  {
    "prefixo": "18575",
    "uf": "SP",
    "codigoIbge": 3512308,
    "cidade": "Conchas"
  },
  {
    "prefixo": "18580",
    "uf": "SP",
    "codigoIbge": 3537503,
    "cidade": "Pereiras"
  },
  {
    "prefixo": "18590",
    "uf": "SP",
    "codigoIbge": 3506904,
    "cidade": "Bofete"
  },
  {
    "prefixo": "18600",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18601",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18602",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18603",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18604",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18605",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18606",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18607",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18608",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18609",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18610",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18611",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18612",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18614",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18615",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18617",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18618",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18619",
    "uf": "SP",
    "codigoIbge": 3507506,
    "cidade": "Botucatu"
  },
  {
    "prefixo": "18620",
    "uf": "SP",
    "codigoIbge": 3502309,
    "cidade": "Anhembi"
  },
  {
    "prefixo": "18630",
    "uf": "SP",
    "codigoIbge": 3502309,
    "cidade": "Anhembi"
  },
  {
    "prefixo": "18633",
    "uf": "SP",
    "codigoIbge": 3502309,
    "cidade": "Anhembi"
  },
  {
    "prefixo": "18638",
    "uf": "SP",
    "codigoIbge": 3502309,
    "cidade": "Anhembi"
  },
  {
    "prefixo": "18639",
    "uf": "SP",
    "codigoIbge": 3502309,
    "cidade": "Anhembi"
  },
  {
    "prefixo": "18640",
    "uf": "SP",
    "codigoIbge": 3536109,
    "cidade": "Pardinho"
  },
  {
    "prefixo": "18642",
    "uf": "SP",
    "codigoIbge": 3536109,
    "cidade": "Pardinho"
  },
  {
    "prefixo": "18645",
    "uf": "SP",
    "codigoIbge": 3536109,
    "cidade": "Pardinho"
  },
  {
    "prefixo": "18650",
    "uf": "SP",
    "codigoIbge": 3550100,
    "cidade": "São Manuel"
  },
  {
    "prefixo": "18652",
    "uf": "SP",
    "codigoIbge": 3550100,
    "cidade": "São Manuel"
  },
  {
    "prefixo": "18654",
    "uf": "SP",
    "codigoIbge": 3550100,
    "cidade": "São Manuel"
  },
  {
    "prefixo": "18655",
    "uf": "SP",
    "codigoIbge": 3550100,
    "cidade": "São Manuel"
  },
  {
    "prefixo": "18656",
    "uf": "SP",
    "codigoIbge": 3550100,
    "cidade": "São Manuel"
  },
  {
    "prefixo": "18657",
    "uf": "SP",
    "codigoIbge": 3550100,
    "cidade": "São Manuel"
  },
  {
    "prefixo": "18658",
    "uf": "SP",
    "codigoIbge": 3550100,
    "cidade": "São Manuel"
  },
  {
    "prefixo": "18659",
    "uf": "SP",
    "codigoIbge": 3550100,
    "cidade": "São Manuel"
  },
  {
    "prefixo": "18660",
    "uf": "SP",
    "codigoIbge": 3541059,
    "cidade": "Pratânia"
  },
  {
    "prefixo": "18670",
    "uf": "SP",
    "codigoIbge": 3503604,
    "cidade": "Areiópolis"
  },
  {
    "prefixo": "18671",
    "uf": "SP",
    "codigoIbge": 3503604,
    "cidade": "Areiópolis"
  },
  {
    "prefixo": "18672",
    "uf": "SP",
    "codigoIbge": 3503604,
    "cidade": "Areiópolis"
  },
  {
    "prefixo": "18674",
    "uf": "SP",
    "codigoIbge": 3503604,
    "cidade": "Areiópolis"
  },
  {
    "prefixo": "18675",
    "uf": "SP",
    "codigoIbge": 3507456,
    "cidade": "Borebi"
  },
  {
    "prefixo": "18680",
    "uf": "SP",
    "codigoIbge": 3526803,
    "cidade": "Lençóis Paulista"
  },
  {
    "prefixo": "18681",
    "uf": "SP",
    "codigoIbge": 3526803,
    "cidade": "Lençóis Paulista"
  },
  {
    "prefixo": "18682",
    "uf": "SP",
    "codigoIbge": 3526803,
    "cidade": "Lençóis Paulista"
  },
  {
    "prefixo": "18683",
    "uf": "SP",
    "codigoIbge": 3526803,
    "cidade": "Lençóis Paulista"
  },
  {
    "prefixo": "18684",
    "uf": "SP",
    "codigoIbge": 3526803,
    "cidade": "Lençóis Paulista"
  },
  {
    "prefixo": "18685",
    "uf": "SP",
    "codigoIbge": 3526803,
    "cidade": "Lençóis Paulista"
  },
  {
    "prefixo": "18686",
    "uf": "SP",
    "codigoIbge": 3526803,
    "cidade": "Lençóis Paulista"
  },
  {
    "prefixo": "18687",
    "uf": "SP",
    "codigoIbge": 3526803,
    "cidade": "Lençóis Paulista"
  },
  {
    "prefixo": "18688",
    "uf": "SP",
    "codigoIbge": 3526803,
    "cidade": "Lençóis Paulista"
  },
  {
    "prefixo": "18690",
    "uf": "SP",
    "codigoIbge": 3523503,
    "cidade": "Itatinga"
  },
  {
    "prefixo": "18691",
    "uf": "SP",
    "codigoIbge": 3523503,
    "cidade": "Itatinga"
  },
  {
    "prefixo": "18692",
    "uf": "SP",
    "codigoIbge": 3523503,
    "cidade": "Itatinga"
  },
  {
    "prefixo": "18694",
    "uf": "SP",
    "codigoIbge": 3523503,
    "cidade": "Itatinga"
  },
  {
    "prefixo": "18699",
    "uf": "SP",
    "codigoIbge": 3523503,
    "cidade": "Itatinga"
  },
  {
    "prefixo": "18700",
    "uf": "SP",
    "codigoIbge": 3504503,
    "cidade": "Avaré"
  },
  {
    "prefixo": "18701",
    "uf": "SP",
    "codigoIbge": 3504503,
    "cidade": "Avaré"
  },
  {
    "prefixo": "18702",
    "uf": "SP",
    "codigoIbge": 3504503,
    "cidade": "Avaré"
  },
  {
    "prefixo": "18703",
    "uf": "SP",
    "codigoIbge": 3504503,
    "cidade": "Avaré"
  },
  {
    "prefixo": "18704",
    "uf": "SP",
    "codigoIbge": 3504503,
    "cidade": "Avaré"
  },
  {
    "prefixo": "18705",
    "uf": "SP",
    "codigoIbge": 3504503,
    "cidade": "Avaré"
  },
  {
    "prefixo": "18706",
    "uf": "SP",
    "codigoIbge": 3504503,
    "cidade": "Avaré"
  },
  {
    "prefixo": "18707",
    "uf": "SP",
    "codigoIbge": 3504503,
    "cidade": "Avaré"
  },
  {
    "prefixo": "18708",
    "uf": "SP",
    "codigoIbge": 3504503,
    "cidade": "Avaré"
  },
  {
    "prefixo": "18709",
    "uf": "SP",
    "codigoIbge": 3504503,
    "cidade": "Avaré"
  },
  {
    "prefixo": "18710",
    "uf": "SP",
    "codigoIbge": 3503109,
    "cidade": "Arandu"
  },
  {
    "prefixo": "18715",
    "uf": "SP",
    "codigoIbge": 3503109,
    "cidade": "Arandu"
  },
  {
    "prefixo": "18716",
    "uf": "SP",
    "codigoIbge": 3503109,
    "cidade": "Arandu"
  },
  {
    "prefixo": "18719",
    "uf": "SP",
    "codigoIbge": 3503109,
    "cidade": "Arandu"
  },
  {
    "prefixo": "18720",
    "uf": "SP",
    "codigoIbge": 3535804,
    "cidade": "Paranapanema"
  },
  {
    "prefixo": "18722",
    "uf": "SP",
    "codigoIbge": 3535804,
    "cidade": "Paranapanema"
  },
  {
    "prefixo": "18723",
    "uf": "SP",
    "codigoIbge": 3535804,
    "cidade": "Paranapanema"
  },
  {
    "prefixo": "18724",
    "uf": "SP",
    "codigoIbge": 3535804,
    "cidade": "Paranapanema"
  },
  {
    "prefixo": "18725",
    "uf": "SP",
    "codigoIbge": 3535804,
    "cidade": "Paranapanema"
  },
  {
    "prefixo": "18728",
    "uf": "SP",
    "codigoIbge": 3535804,
    "cidade": "Paranapanema"
  },
  {
    "prefixo": "18730",
    "uf": "SP",
    "codigoIbge": 3521804,
    "cidade": "Itaí"
  },
  {
    "prefixo": "18732",
    "uf": "SP",
    "codigoIbge": 3521804,
    "cidade": "Itaí"
  },
  {
    "prefixo": "18734",
    "uf": "SP",
    "codigoIbge": 3521804,
    "cidade": "Itaí"
  },
  {
    "prefixo": "18737",
    "uf": "SP",
    "codigoIbge": 3521804,
    "cidade": "Itaí"
  },
  {
    "prefixo": "18739",
    "uf": "SP",
    "codigoIbge": 3521804,
    "cidade": "Itaí"
  },
  {
    "prefixo": "18740",
    "uf": "SP",
    "codigoIbge": 3553807,
    "cidade": "Taquarituba"
  },
  {
    "prefixo": "18741",
    "uf": "SP",
    "codigoIbge": 3553807,
    "cidade": "Taquarituba"
  },
  {
    "prefixo": "18742",
    "uf": "SP",
    "codigoIbge": 3553807,
    "cidade": "Taquarituba"
  },
  {
    "prefixo": "18743",
    "uf": "SP",
    "codigoIbge": 3553807,
    "cidade": "Taquarituba"
  },
  {
    "prefixo": "18744",
    "uf": "SP",
    "codigoIbge": 3553807,
    "cidade": "Taquarituba"
  },
  {
    "prefixo": "18745",
    "uf": "SP",
    "codigoIbge": 3512605,
    "cidade": "Coronel Macedo"
  },
  {
    "prefixo": "18760",
    "uf": "SP",
    "codigoIbge": 3511409,
    "cidade": "Cerqueira César"
  },
  {
    "prefixo": "18762",
    "uf": "SP",
    "codigoIbge": 3511409,
    "cidade": "Cerqueira César"
  },
  {
    "prefixo": "18764",
    "uf": "SP",
    "codigoIbge": 3511409,
    "cidade": "Cerqueira César"
  },
  {
    "prefixo": "18767",
    "uf": "SP",
    "codigoIbge": 3511409,
    "cidade": "Cerqueira César"
  },
  {
    "prefixo": "18769",
    "uf": "SP",
    "codigoIbge": 3511409,
    "cidade": "Cerqueira César"
  },
  {
    "prefixo": "18770",
    "uf": "SP",
    "codigoIbge": 3500550,
    "cidade": "Águas de Santa Bárbara"
  },
  {
    "prefixo": "18772",
    "uf": "SP",
    "codigoIbge": 3500550,
    "cidade": "Águas de Santa Bárbara"
  },
  {
    "prefixo": "18774",
    "uf": "SP",
    "codigoIbge": 3500550,
    "cidade": "Águas de Santa Bárbara"
  },
  {
    "prefixo": "18775",
    "uf": "SP",
    "codigoIbge": 3519253,
    "cidade": "Iaras"
  },
  {
    "prefixo": "18779",
    "uf": "SP",
    "codigoIbge": 3519253,
    "cidade": "Iaras"
  },
  {
    "prefixo": "18780",
    "uf": "SP",
    "codigoIbge": 3528601,
    "cidade": "Manduri"
  },
  {
    "prefixo": "18782",
    "uf": "SP",
    "codigoIbge": 3528601,
    "cidade": "Manduri"
  },
  {
    "prefixo": "18784",
    "uf": "SP",
    "codigoIbge": 3528601,
    "cidade": "Manduri"
  },
  {
    "prefixo": "18785",
    "uf": "SP",
    "codigoIbge": 3528601,
    "cidade": "Manduri"
  },
  {
    "prefixo": "18787",
    "uf": "SP",
    "codigoIbge": 3528601,
    "cidade": "Manduri"
  },
  {
    "prefixo": "18788",
    "uf": "SP",
    "codigoIbge": 3528601,
    "cidade": "Manduri"
  },
  {
    "prefixo": "18790",
    "uf": "SP",
    "codigoIbge": 3533809,
    "cidade": "Óleo"
  },
  {
    "prefixo": "18792",
    "uf": "SP",
    "codigoIbge": 3533809,
    "cidade": "Óleo"
  },
  {
    "prefixo": "18794",
    "uf": "SP",
    "codigoIbge": 3533809,
    "cidade": "Óleo"
  },
  {
    "prefixo": "18795",
    "uf": "SP",
    "codigoIbge": 3533809,
    "cidade": "Óleo"
  },
  {
    "prefixo": "18799",
    "uf": "SP",
    "codigoIbge": 3533809,
    "cidade": "Óleo"
  },
  {
    "prefixo": "18800",
    "uf": "SP",
    "codigoIbge": 3538808,
    "cidade": "Piraju"
  },
  {
    "prefixo": "18802",
    "uf": "SP",
    "codigoIbge": 3538808,
    "cidade": "Piraju"
  },
  {
    "prefixo": "18803",
    "uf": "SP",
    "codigoIbge": 3538808,
    "cidade": "Piraju"
  },
  {
    "prefixo": "18805",
    "uf": "SP",
    "codigoIbge": 3538808,
    "cidade": "Piraju"
  },
  {
    "prefixo": "18807",
    "uf": "SP",
    "codigoIbge": 3538808,
    "cidade": "Piraju"
  },
  {
    "prefixo": "18808",
    "uf": "SP",
    "codigoIbge": 3538808,
    "cidade": "Piraju"
  },
  {
    "prefixo": "18809",
    "uf": "SP",
    "codigoIbge": 3538808,
    "cidade": "Piraju"
  },
  {
    "prefixo": "18810",
    "uf": "SP",
    "codigoIbge": 3538808,
    "cidade": "Piraju"
  },
  {
    "prefixo": "18812",
    "uf": "SP",
    "codigoIbge": 3538808,
    "cidade": "Piraju"
  },
  {
    "prefixo": "18819",
    "uf": "SP",
    "codigoIbge": 3538808,
    "cidade": "Piraju"
  },
  {
    "prefixo": "18830",
    "uf": "SP",
    "codigoIbge": 3554201,
    "cidade": "Tejupá"
  },
  {
    "prefixo": "18834",
    "uf": "SP",
    "codigoIbge": 3554201,
    "cidade": "Tejupá"
  },
  {
    "prefixo": "18835",
    "uf": "SP",
    "codigoIbge": 3554201,
    "cidade": "Tejupá"
  },
  {
    "prefixo": "18836",
    "uf": "SP",
    "codigoIbge": 3554201,
    "cidade": "Tejupá"
  },
  {
    "prefixo": "18837",
    "uf": "SP",
    "codigoIbge": 3554201,
    "cidade": "Tejupá"
  },
  {
    "prefixo": "18839",
    "uf": "SP",
    "codigoIbge": 3554201,
    "cidade": "Tejupá"
  },
  {
    "prefixo": "18840",
    "uf": "SP",
    "codigoIbge": 3551207,
    "cidade": "Sarutaiá"
  },
  {
    "prefixo": "18849",
    "uf": "SP",
    "codigoIbge": 3551207,
    "cidade": "Sarutaiá"
  },
  {
    "prefixo": "18860",
    "uf": "SP",
    "codigoIbge": 3554607,
    "cidade": "Timburi"
  },
  {
    "prefixo": "18869",
    "uf": "SP",
    "codigoIbge": 3554607,
    "cidade": "Timburi"
  },
  {
    "prefixo": "18870",
    "uf": "SP",
    "codigoIbge": 3515400,
    "cidade": "Fartura"
  },
  {
    "prefixo": "18873",
    "uf": "SP",
    "codigoIbge": 3515400,
    "cidade": "Fartura"
  },
  {
    "prefixo": "18879",
    "uf": "SP",
    "codigoIbge": 3515400,
    "cidade": "Fartura"
  },
  {
    "prefixo": "18890",
    "uf": "SP",
    "codigoIbge": 3553005,
    "cidade": "Taguaí"
  },
  {
    "prefixo": "18899",
    "uf": "SP",
    "codigoIbge": 3553005,
    "cidade": "Taguaí"
  },
  {
    "prefixo": "18900",
    "uf": "SP",
    "codigoIbge": 3546405,
    "cidade": "Santa Cruz do Rio Pardo"
  },
  {
    "prefixo": "18903",
    "uf": "SP",
    "codigoIbge": 3546405,
    "cidade": "Santa Cruz do Rio Pardo"
  },
  {
    "prefixo": "18906",
    "uf": "SP",
    "codigoIbge": 3546405,
    "cidade": "Santa Cruz do Rio Pardo"
  },
  {
    "prefixo": "18908",
    "uf": "SP",
    "codigoIbge": 3546405,
    "cidade": "Santa Cruz do Rio Pardo"
  },
  {
    "prefixo": "18910",
    "uf": "SP",
    "codigoIbge": 3546405,
    "cidade": "Santa Cruz do Rio Pardo"
  },
  {
    "prefixo": "18911",
    "uf": "SP",
    "codigoIbge": 3546405,
    "cidade": "Santa Cruz do Rio Pardo"
  },
  {
    "prefixo": "18913",
    "uf": "SP",
    "codigoIbge": 3546405,
    "cidade": "Santa Cruz do Rio Pardo"
  },
  {
    "prefixo": "18915",
    "uf": "SP",
    "codigoIbge": 3546405,
    "cidade": "Santa Cruz do Rio Pardo"
  },
  {
    "prefixo": "18918",
    "uf": "SP",
    "codigoIbge": 3546405,
    "cidade": "Santa Cruz do Rio Pardo"
  },
  {
    "prefixo": "18919",
    "uf": "SP",
    "codigoIbge": 3546405,
    "cidade": "Santa Cruz do Rio Pardo"
  },
  {
    "prefixo": "18920",
    "uf": "SP",
    "codigoIbge": 3546405,
    "cidade": "Santa Cruz do Rio Pardo"
  },
  {
    "prefixo": "18925",
    "uf": "SP",
    "codigoIbge": 3546405,
    "cidade": "Santa Cruz do Rio Pardo"
  },
  {
    "prefixo": "18928",
    "uf": "SP",
    "codigoIbge": 3546405,
    "cidade": "Santa Cruz do Rio Pardo"
  },
  {
    "prefixo": "18935",
    "uf": "SP",
    "codigoIbge": 3515194,
    "cidade": "Espírito Santo do Turvo"
  },
  {
    "prefixo": "18937",
    "uf": "SP",
    "codigoIbge": 3515194,
    "cidade": "Espírito Santo do Turvo"
  },
  {
    "prefixo": "18939",
    "uf": "SP",
    "codigoIbge": 3515194,
    "cidade": "Espírito Santo do Turvo"
  },
  {
    "prefixo": "18940",
    "uf": "SP",
    "codigoIbge": 3550506,
    "cidade": "São Pedro do Turvo"
  },
  {
    "prefixo": "18942",
    "uf": "SP",
    "codigoIbge": 3550506,
    "cidade": "São Pedro do Turvo"
  },
  {
    "prefixo": "18944",
    "uf": "SP",
    "codigoIbge": 3550506,
    "cidade": "São Pedro do Turvo"
  },
  {
    "prefixo": "18950",
    "uf": "SP",
    "codigoIbge": 3520905,
    "cidade": "Ipaussu"
  },
  {
    "prefixo": "18951",
    "uf": "SP",
    "codigoIbge": 3520905,
    "cidade": "Ipaussu"
  },
  {
    "prefixo": "18952",
    "uf": "SP",
    "codigoIbge": 3520905,
    "cidade": "Ipaussu"
  },
  {
    "prefixo": "18953",
    "uf": "SP",
    "codigoIbge": 3520905,
    "cidade": "Ipaussu"
  },
  {
    "prefixo": "18959",
    "uf": "SP",
    "codigoIbge": 3520905,
    "cidade": "Ipaussu"
  },
  {
    "prefixo": "18960",
    "uf": "SP",
    "codigoIbge": 3506300,
    "cidade": "Bernardino de Campos"
  },
  {
    "prefixo": "18962",
    "uf": "SP",
    "codigoIbge": 3506300,
    "cidade": "Bernardino de Campos"
  },
  {
    "prefixo": "18964",
    "uf": "SP",
    "codigoIbge": 3506300,
    "cidade": "Bernardino de Campos"
  },
  {
    "prefixo": "18965",
    "uf": "SP",
    "codigoIbge": 3506300,
    "cidade": "Bernardino de Campos"
  },
  {
    "prefixo": "18967",
    "uf": "SP",
    "codigoIbge": 3506300,
    "cidade": "Bernardino de Campos"
  },
  {
    "prefixo": "18969",
    "uf": "SP",
    "codigoIbge": 3506300,
    "cidade": "Bernardino de Campos"
  },
  {
    "prefixo": "18970",
    "uf": "SP",
    "codigoIbge": 3557204,
    "cidade": "Chavantes"
  },
  {
    "prefixo": "18972",
    "uf": "SP",
    "codigoIbge": 3557204,
    "cidade": "Chavantes"
  },
  {
    "prefixo": "18979",
    "uf": "SP",
    "codigoIbge": 3557204,
    "cidade": "Chavantes"
  },
  {
    "prefixo": "18980",
    "uf": "SP",
    "codigoIbge": 3557204,
    "cidade": "Chavantes"
  },
  {
    "prefixo": "18990",
    "uf": "SP",
    "codigoIbge": 3510153,
    "cidade": "Canitar"
  },
  {
    "prefixo": "19010",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19013",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19014",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19015",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19020",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19023",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19024",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19025",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19026",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19027",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19028",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19029",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19030",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19031",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19033",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19034",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19035",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19036",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19040",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19041",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19042",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19044",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19045",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19046",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19050",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19051",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19053",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19054",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19057",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19060",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19061",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19062",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19063",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19064",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19065",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19066",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19067",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19068",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19070",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19072",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19085",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19097",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19100",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19110",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19120",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19130",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19140",
    "uf": "SP",
    "codigoIbge": 3541406,
    "cidade": "Presidente Prudente"
  },
  {
    "prefixo": "19160",
    "uf": "SP",
    "codigoIbge": 3501301,
    "cidade": "Álvares Machado"
  },
  {
    "prefixo": "19165",
    "uf": "SP",
    "codigoIbge": 3501301,
    "cidade": "Álvares Machado"
  },
  {
    "prefixo": "19180",
    "uf": "SP",
    "codigoIbge": 3500808,
    "cidade": "Alfredo Marcondes"
  },
  {
    "prefixo": "19190",
    "uf": "SP",
    "codigoIbge": 3548302,
    "cidade": "Santo Expedito"
  },
  {
    "prefixo": "19200",
    "uf": "SP",
    "codigoIbge": 3539202,
    "cidade": "Pirapozinho"
  },
  {
    "prefixo": "19208",
    "uf": "SP",
    "codigoIbge": 3539202,
    "cidade": "Pirapozinho"
  },
  {
    "prefixo": "19210",
    "uf": "SP",
    "codigoIbge": 3553906,
    "cidade": "Tarabai"
  },
  {
    "prefixo": "19220",
    "uf": "SP",
    "codigoIbge": 3532207,
    "cidade": "Narandiba"
  },
  {
    "prefixo": "19230",
    "uf": "SP",
    "codigoIbge": 3515301,
    "cidade": "Estrela do Norte"
  },
  {
    "prefixo": "19250",
    "uf": "SP",
    "codigoIbge": 3545506,
    "cidade": "Sandovalina"
  },
  {
    "prefixo": "19260",
    "uf": "SP",
    "codigoIbge": 3530201,
    "cidade": "Mirante do Paranapanema"
  },
  {
    "prefixo": "19265",
    "uf": "SP",
    "codigoIbge": 3530201,
    "cidade": "Mirante do Paranapanema"
  },
  {
    "prefixo": "19270",
    "uf": "SP",
    "codigoIbge": 3530201,
    "cidade": "Mirante do Paranapanema"
  },
  {
    "prefixo": "19273",
    "uf": "SP",
    "codigoIbge": 3544251,
    "cidade": "Rosana"
  },
  {
    "prefixo": "19274",
    "uf": "SP",
    "codigoIbge": 3544251,
    "cidade": "Rosana"
  },
  {
    "prefixo": "19275",
    "uf": "SP",
    "codigoIbge": 3515350,
    "cidade": "Euclides da Cunha Paulista"
  },
  {
    "prefixo": "19280",
    "uf": "SP",
    "codigoIbge": 3554300,
    "cidade": "Teodoro Sampaio"
  },
  {
    "prefixo": "19295",
    "uf": "SP",
    "codigoIbge": 3554300,
    "cidade": "Teodoro Sampaio"
  },
  {
    "prefixo": "19300",
    "uf": "SP",
    "codigoIbge": 3541208,
    "cidade": "Presidente Bernardes"
  },
  {
    "prefixo": "19310",
    "uf": "SP",
    "codigoIbge": 3541208,
    "cidade": "Presidente Bernardes"
  },
  {
    "prefixo": "19330",
    "uf": "SP",
    "codigoIbge": 3541208,
    "cidade": "Presidente Bernardes"
  },
  {
    "prefixo": "19350",
    "uf": "SP",
    "codigoIbge": 3515129,
    "cidade": "Emilianópolis"
  },
  {
    "prefixo": "19360",
    "uf": "SP",
    "codigoIbge": 3547700,
    "cidade": "Santo Anastácio"
  },
  {
    "prefixo": "19380",
    "uf": "SP",
    "codigoIbge": 3543238,
    "cidade": "Ribeirão dos Índios"
  },
  {
    "prefixo": "19400",
    "uf": "SP",
    "codigoIbge": 3541505,
    "cidade": "Presidente Venceslau"
  },
  {
    "prefixo": "19402",
    "uf": "SP",
    "codigoIbge": 3541505,
    "cidade": "Presidente Venceslau"
  },
  {
    "prefixo": "19405",
    "uf": "SP",
    "codigoIbge": 3541505,
    "cidade": "Presidente Venceslau"
  },
  {
    "prefixo": "19406",
    "uf": "SP",
    "codigoIbge": 3541505,
    "cidade": "Presidente Venceslau"
  },
  {
    "prefixo": "19407",
    "uf": "SP",
    "codigoIbge": 3541505,
    "cidade": "Presidente Venceslau"
  },
  {
    "prefixo": "19409",
    "uf": "SP",
    "codigoIbge": 3541505,
    "cidade": "Presidente Venceslau"
  },
  {
    "prefixo": "19410",
    "uf": "SP",
    "codigoIbge": 3538303,
    "cidade": "Piquerobi"
  },
  {
    "prefixo": "19430",
    "uf": "SP",
    "codigoIbge": 3528700,
    "cidade": "Marabá Paulista"
  },
  {
    "prefixo": "19450",
    "uf": "SP",
    "codigoIbge": 3509106,
    "cidade": "Caiuá"
  },
  {
    "prefixo": "19470",
    "uf": "SP",
    "codigoIbge": 3541307,
    "cidade": "Presidente Epitácio"
  },
  {
    "prefixo": "19490",
    "uf": "SP",
    "codigoIbge": 3541307,
    "cidade": "Presidente Epitácio"
  },
  {
    "prefixo": "19500",
    "uf": "SP",
    "codigoIbge": 3529203,
    "cidade": "Martinópolis"
  },
  {
    "prefixo": "19505",
    "uf": "SP",
    "codigoIbge": 3529203,
    "cidade": "Martinópolis"
  },
  {
    "prefixo": "19510",
    "uf": "SP",
    "codigoIbge": 3529203,
    "cidade": "Martinópolis"
  },
  {
    "prefixo": "19530",
    "uf": "SP",
    "codigoIbge": 3508900,
    "cidade": "Caiabu"
  },
  {
    "prefixo": "19535",
    "uf": "SP",
    "codigoIbge": 3508900,
    "cidade": "Caiabu"
  },
  {
    "prefixo": "19540",
    "uf": "SP",
    "codigoIbge": 3508900,
    "cidade": "Caiabu"
  },
  {
    "prefixo": "19560",
    "uf": "SP",
    "codigoIbge": 3520608,
    "cidade": "Indiana"
  },
  {
    "prefixo": "19570",
    "uf": "SP",
    "codigoIbge": 3542404,
    "cidade": "Regente Feijó"
  },
  {
    "prefixo": "19575",
    "uf": "SP",
    "codigoIbge": 3542404,
    "cidade": "Regente Feijó"
  },
  {
    "prefixo": "19580",
    "uf": "SP",
    "codigoIbge": 3502408,
    "cidade": "Anhumas"
  },
  {
    "prefixo": "19590",
    "uf": "SP",
    "codigoIbge": 3552908,
    "cidade": "Taciba"
  },
  {
    "prefixo": "19600",
    "uf": "SP",
    "codigoIbge": 3542206,
    "cidade": "Rancharia"
  },
  {
    "prefixo": "19602",
    "uf": "SP",
    "codigoIbge": 3542206,
    "cidade": "Rancharia"
  },
  {
    "prefixo": "19605",
    "uf": "SP",
    "codigoIbge": 3542206,
    "cidade": "Rancharia"
  },
  {
    "prefixo": "19607",
    "uf": "SP",
    "codigoIbge": 3542206,
    "cidade": "Rancharia"
  },
  {
    "prefixo": "19610",
    "uf": "SP",
    "codigoIbge": 3542206,
    "cidade": "Rancharia"
  },
  {
    "prefixo": "19615",
    "uf": "SP",
    "codigoIbge": 3542206,
    "cidade": "Rancharia"
  },
  {
    "prefixo": "19618",
    "uf": "SP",
    "codigoIbge": 3542206,
    "cidade": "Rancharia"
  },
  {
    "prefixo": "19620",
    "uf": "SP",
    "codigoIbge": 3542206,
    "cidade": "Rancharia"
  },
  {
    "prefixo": "19640",
    "uf": "SP",
    "codigoIbge": 3519907,
    "cidade": "Iepê"
  },
  {
    "prefixo": "19645",
    "uf": "SP",
    "codigoIbge": 3532157,
    "cidade": "Nantes"
  },
  {
    "prefixo": "19649",
    "uf": "SP",
    "codigoIbge": 3519907,
    "cidade": "Iepê"
  },
  {
    "prefixo": "19650",
    "uf": "SP",
    "codigoIbge": 3532157,
    "cidade": "Nantes"
  },
  {
    "prefixo": "19659",
    "uf": "SP",
    "codigoIbge": 3532157,
    "cidade": "Nantes"
  },
  {
    "prefixo": "19680",
    "uf": "SP",
    "codigoIbge": 3525607,
    "cidade": "João Ramalho"
  },
  {
    "prefixo": "19689",
    "uf": "SP",
    "codigoIbge": 3525607,
    "cidade": "João Ramalho"
  },
  {
    "prefixo": "19700",
    "uf": "SP",
    "codigoIbge": 3535507,
    "cidade": "Paraguaçu Paulista"
  },
  {
    "prefixo": "19703",
    "uf": "SP",
    "codigoIbge": 3535507,
    "cidade": "Paraguaçu Paulista"
  },
  {
    "prefixo": "19705",
    "uf": "SP",
    "codigoIbge": 3535507,
    "cidade": "Paraguaçu Paulista"
  },
  {
    "prefixo": "19707",
    "uf": "SP",
    "codigoIbge": 3535507,
    "cidade": "Paraguaçu Paulista"
  },
  {
    "prefixo": "19714",
    "uf": "SP",
    "codigoIbge": 3535507,
    "cidade": "Paraguaçu Paulista"
  },
  {
    "prefixo": "19715",
    "uf": "SP",
    "codigoIbge": 3535507,
    "cidade": "Paraguaçu Paulista"
  },
  {
    "prefixo": "19719",
    "uf": "SP",
    "codigoIbge": 3535507,
    "cidade": "Paraguaçu Paulista"
  },
  {
    "prefixo": "19720",
    "uf": "SP",
    "codigoIbge": 3535507,
    "cidade": "Paraguaçu Paulista"
  },
  {
    "prefixo": "19724",
    "uf": "SP",
    "codigoIbge": 3535507,
    "cidade": "Paraguaçu Paulista"
  },
  {
    "prefixo": "19725",
    "uf": "SP",
    "codigoIbge": 3535507,
    "cidade": "Paraguaçu Paulista"
  },
  {
    "prefixo": "19729",
    "uf": "SP",
    "codigoIbge": 3535507,
    "cidade": "Paraguaçu Paulista"
  },
  {
    "prefixo": "19740",
    "uf": "SP",
    "codigoIbge": 3507209,
    "cidade": "Borá"
  },
  {
    "prefixo": "19750",
    "uf": "SP",
    "codigoIbge": 3527900,
    "cidade": "Lutécia"
  },
  {
    "prefixo": "19770",
    "uf": "SP",
    "codigoIbge": 3534500,
    "cidade": "Oscar Bressane"
  },
  {
    "prefixo": "19779",
    "uf": "SP",
    "codigoIbge": 3534500,
    "cidade": "Oscar Bressane"
  },
  {
    "prefixo": "19780",
    "uf": "SP",
    "codigoIbge": 3541703,
    "cidade": "Quatá"
  },
  {
    "prefixo": "19782",
    "uf": "SP",
    "codigoIbge": 3541703,
    "cidade": "Quatá"
  },
  {
    "prefixo": "19785",
    "uf": "SP",
    "codigoIbge": 3541703,
    "cidade": "Quatá"
  },
  {
    "prefixo": "19787",
    "uf": "SP",
    "codigoIbge": 3541703,
    "cidade": "Quatá"
  },
  {
    "prefixo": "19789",
    "uf": "SP",
    "codigoIbge": 3541703,
    "cidade": "Quatá"
  },
  {
    "prefixo": "19800",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19801",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19802",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19803",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19804",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19805",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19806",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19807",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19808",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19810",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19811",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19812",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19813",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19814",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19815",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19816",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19819",
    "uf": "SP",
    "codigoIbge": 3504008,
    "cidade": "Assis"
  },
  {
    "prefixo": "19820",
    "uf": "SP",
    "codigoIbge": 3553955,
    "cidade": "Tarumã"
  },
  {
    "prefixo": "19822",
    "uf": "SP",
    "codigoIbge": 3553955,
    "cidade": "Tarumã"
  },
  {
    "prefixo": "19824",
    "uf": "SP",
    "codigoIbge": 3553955,
    "cidade": "Tarumã"
  },
  {
    "prefixo": "19829",
    "uf": "SP",
    "codigoIbge": 3553955,
    "cidade": "Tarumã"
  },
  {
    "prefixo": "19830",
    "uf": "SP",
    "codigoIbge": 3514700,
    "cidade": "Echaporã"
  },
  {
    "prefixo": "19839",
    "uf": "SP",
    "codigoIbge": 3514700,
    "cidade": "Echaporã"
  },
  {
    "prefixo": "19840",
    "uf": "SP",
    "codigoIbge": 3528809,
    "cidade": "Maracaí"
  },
  {
    "prefixo": "19842",
    "uf": "SP",
    "codigoIbge": 3528809,
    "cidade": "Maracaí"
  },
  {
    "prefixo": "19844",
    "uf": "SP",
    "codigoIbge": 3528809,
    "cidade": "Maracaí"
  },
  {
    "prefixo": "19845",
    "uf": "SP",
    "codigoIbge": 3528809,
    "cidade": "Maracaí"
  },
  {
    "prefixo": "19849",
    "uf": "SP",
    "codigoIbge": 3528809,
    "cidade": "Maracaí"
  },
  {
    "prefixo": "19860",
    "uf": "SP",
    "codigoIbge": 3513306,
    "cidade": "Cruzália"
  },
  {
    "prefixo": "19864",
    "uf": "SP",
    "codigoIbge": 3513306,
    "cidade": "Cruzália"
  },
  {
    "prefixo": "19865",
    "uf": "SP",
    "codigoIbge": 3537156,
    "cidade": "Pedrinhas Paulista"
  },
  {
    "prefixo": "19870",
    "uf": "SP",
    "codigoIbge": 3516101,
    "cidade": "Florínea"
  },
  {
    "prefixo": "19872",
    "uf": "SP",
    "codigoIbge": 3516101,
    "cidade": "Florínea"
  },
  {
    "prefixo": "19879",
    "uf": "SP",
    "codigoIbge": 3516101,
    "cidade": "Florínea"
  },
  {
    "prefixo": "19880",
    "uf": "SP",
    "codigoIbge": 3510005,
    "cidade": "Cândido Mota"
  },
  {
    "prefixo": "19883",
    "uf": "SP",
    "codigoIbge": 3510005,
    "cidade": "Cândido Mota"
  },
  {
    "prefixo": "19885",
    "uf": "SP",
    "codigoIbge": 3510005,
    "cidade": "Cândido Mota"
  },
  {
    "prefixo": "19886",
    "uf": "SP",
    "codigoIbge": 3510005,
    "cidade": "Cândido Mota"
  },
  {
    "prefixo": "19887",
    "uf": "SP",
    "codigoIbge": 3510005,
    "cidade": "Cândido Mota"
  },
  {
    "prefixo": "19888",
    "uf": "SP",
    "codigoIbge": 3510005,
    "cidade": "Cândido Mota"
  },
  {
    "prefixo": "19889",
    "uf": "SP",
    "codigoIbge": 3510005,
    "cidade": "Cândido Mota"
  },
  {
    "prefixo": "19900",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19901",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19902",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19903",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19904",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19905",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19906",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19907",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19908",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19909",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19910",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19911",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19912",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19913",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19914",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19915",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19919",
    "uf": "SP",
    "codigoIbge": 3534708,
    "cidade": "Ourinhos"
  },
  {
    "prefixo": "19920",
    "uf": "SP",
    "codigoIbge": 3545407,
    "cidade": "Salto Grande"
  },
  {
    "prefixo": "19929",
    "uf": "SP",
    "codigoIbge": 3545407,
    "cidade": "Salto Grande"
  },
  {
    "prefixo": "19930",
    "uf": "SP",
    "codigoIbge": 3543204,
    "cidade": "Ribeirão do Sul"
  },
  {
    "prefixo": "19939",
    "uf": "SP",
    "codigoIbge": 3543204,
    "cidade": "Ribeirão do Sul"
  },
  {
    "prefixo": "19940",
    "uf": "SP",
    "codigoIbge": 3519501,
    "cidade": "Ibirarema"
  },
  {
    "prefixo": "19949",
    "uf": "SP",
    "codigoIbge": 3519501,
    "cidade": "Ibirarema"
  },
  {
    "prefixo": "19960",
    "uf": "SP",
    "codigoIbge": 3509809,
    "cidade": "Campos Novos Paulista"
  },
  {
    "prefixo": "19969",
    "uf": "SP",
    "codigoIbge": 3509809,
    "cidade": "Campos Novos Paulista"
  },
  {
    "prefixo": "19970",
    "uf": "SP",
    "codigoIbge": 3535309,
    "cidade": "Palmital"
  },
  {
    "prefixo": "19971",
    "uf": "SP",
    "codigoIbge": 3535309,
    "cidade": "Palmital"
  },
  {
    "prefixo": "19973",
    "uf": "SP",
    "codigoIbge": 3535309,
    "cidade": "Palmital"
  },
  {
    "prefixo": "19978",
    "uf": "SP",
    "codigoIbge": 3535309,
    "cidade": "Palmital"
  },
  {
    "prefixo": "19979",
    "uf": "SP",
    "codigoIbge": 3535309,
    "cidade": "Palmital"
  },
  {
    "prefixo": "19990",
    "uf": "SP",
    "codigoIbge": 3539707,
    "cidade": "Platina"
  },
  {
    "prefixo": "19999",
    "uf": "SP",
    "codigoIbge": 3539707,
    "cidade": "Platina"
  },
  {
    "prefixo": "20010",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20011",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20020",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20021",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20030",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20031",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20040",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20041",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20050",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20051",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20060",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20061",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20070",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20071",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20080",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20081",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20090",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20091",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20180",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20210",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20211",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20220",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20221",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20230",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20231",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20240",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20241",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20250",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20251",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20260",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20261",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20270",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20271",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20396",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20397",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20510",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20511",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20520",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20521",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20530",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20531",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20535",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20540",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20541",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20550",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20551",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20560",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20561",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20710",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20715",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20720",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20723",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20725",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20730",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20735",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20740",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20745",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20750",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20751",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20755",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20756",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20760",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20761",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20765",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20766",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20770",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20771",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20775",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20780",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20785",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20910",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20911",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20920",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20921",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20930",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20931",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20932",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20940",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20941",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20943",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20950",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20960",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20961",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20970",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20972",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20973",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "20975",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21010",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21011",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21012",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21020",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21021",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21030",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21031",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21032",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21040",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21041",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21042",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21043",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21044",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21046",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21050",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21051",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21060",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21061",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21062",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21070",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21071",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21072",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21073",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21210",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21211",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21215",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21220",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21221",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21230",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21231",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21235",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21236",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21240",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21241",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21250",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21310",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21311",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21320",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21321",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21330",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21331",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21340",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21341",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21350",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21351",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21360",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21361",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21362",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21370",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21371",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21380",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21381",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21510",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21511",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21512",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21515",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21520",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21521",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21525",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21530",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21531",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21532",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21535",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21540",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21545",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21550",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21555",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21557",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21610",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21611",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21615",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21616",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21620",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21625",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21630",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21635",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21640",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21645",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21650",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21655",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21660",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21665",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21670",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21675",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21710",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21715",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21720",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21721",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21725",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21730",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21735",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21740",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21741",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21745",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21746",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21750",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21755",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21760",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21765",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21770",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21775",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21810",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21815",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21820",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21825",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21830",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21831",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21832",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21833",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21840",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21842",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21843",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21844",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21850",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21852",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21853",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21854",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21860",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21862",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21863",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21864",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21865",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21866",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21870",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21875",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21910",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21911",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21920",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21921",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21922",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21930",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21931",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21932",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21940",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21941",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "21949",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22010",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22011",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22020",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22021",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22030",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22031",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22040",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22041",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22050",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22051",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22060",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22061",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22070",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22071",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22080",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22081",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22210",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22211",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22220",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22221",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22230",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22231",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22240",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22241",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22245",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22250",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22251",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22260",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22261",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22270",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22271",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22280",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22281",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22290",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22291",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22410",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22411",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22420",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22421",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22430",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22431",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22440",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22441",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22450",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22451",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22452",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22460",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22461",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22470",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22471",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22610",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22611",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22620",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22621",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22630",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22631",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22640",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22641",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22710",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22711",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22713",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22715",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22720",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22723",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22725",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22730",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22733",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22735",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22740",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22743",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22745",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22750",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22753",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22755",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22760",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22763",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22765",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22770",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22772",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22773",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22775",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22776",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22780",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22783",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22785",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22790",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22793",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "22795",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23010",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23012",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23013",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23015",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23016",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23017",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23020",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23025",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23026",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23027",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23028",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23030",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23031",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23032",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23033",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23035",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23036",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23040",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23042",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23045",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23047",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23050",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23052",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23055",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23056",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23057",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23058",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23059",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23060",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23061",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23062",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23063",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23064",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23065",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23066",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23067",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23068",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23069",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23070",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23071",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23073",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23075",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23076",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23078",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23080",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23081",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23082",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23085",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23087",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23088",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23090",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23092",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23093",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23094",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23095",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23097",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23098",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23510",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23515",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23520",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23525",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23530",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23535",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23540",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23545",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23547",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23548",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23550",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23555",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23560",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23565",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23570",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23573",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23575",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23580",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23585",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23586",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23587",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23590",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23591",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23595",
    "uf": "RJ",
    "codigoIbge": 3304557,
    "cidade": "Rio de Janeiro"
  },
  {
    "prefixo": "23810",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23811",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23812",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23815",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23819",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23820",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23821",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23822",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23823",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23825",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23826",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23830",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23831",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23832",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23835",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23840",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23850",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23855",
    "uf": "RJ",
    "codigoIbge": 3302007,
    "cidade": "Itaguaí"
  },
  {
    "prefixo": "23860",
    "uf": "RJ",
    "codigoIbge": 3302601,
    "cidade": "Mangaratiba"
  },
  {
    "prefixo": "23870",
    "uf": "RJ",
    "codigoIbge": 3302601,
    "cidade": "Mangaratiba"
  },
  {
    "prefixo": "23880",
    "uf": "RJ",
    "codigoIbge": 3302601,
    "cidade": "Mangaratiba"
  },
  {
    "prefixo": "23885",
    "uf": "RJ",
    "codigoIbge": 3302601,
    "cidade": "Mangaratiba"
  },
  {
    "prefixo": "23890",
    "uf": "RJ",
    "codigoIbge": 3305554,
    "cidade": "Seropédica"
  },
  {
    "prefixo": "23891",
    "uf": "RJ",
    "codigoIbge": 3305554,
    "cidade": "Seropédica"
  },
  {
    "prefixo": "23892",
    "uf": "RJ",
    "codigoIbge": 3305554,
    "cidade": "Seropédica"
  },
  {
    "prefixo": "23893",
    "uf": "RJ",
    "codigoIbge": 3305554,
    "cidade": "Seropédica"
  },
  {
    "prefixo": "23894",
    "uf": "RJ",
    "codigoIbge": 3305554,
    "cidade": "Seropédica"
  },
  {
    "prefixo": "23895",
    "uf": "RJ",
    "codigoIbge": 3305554,
    "cidade": "Seropédica"
  },
  {
    "prefixo": "23896",
    "uf": "RJ",
    "codigoIbge": 3305554,
    "cidade": "Seropédica"
  },
  {
    "prefixo": "23897",
    "uf": "RJ",
    "codigoIbge": 3305554,
    "cidade": "Seropédica"
  },
  {
    "prefixo": "23898",
    "uf": "RJ",
    "codigoIbge": 3305554,
    "cidade": "Seropédica"
  },
  {
    "prefixo": "23899",
    "uf": "RJ",
    "codigoIbge": 3305554,
    "cidade": "Seropédica"
  },
  {
    "prefixo": "23900",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23902",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23903",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23904",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23905",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23906",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23907",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23909",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23910",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23911",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23912",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23913",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23914",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23915",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23916",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23917",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23918",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23919",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23930",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23931",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23932",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23933",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23934",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23935",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23936",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23937",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23938",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23940",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23941",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23942",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23943",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23944",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23945",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23946",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23947",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23950",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23951",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23952",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23953",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23954",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23955",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23968",
    "uf": "RJ",
    "codigoIbge": 3300100,
    "cidade": "Angra dos Reis"
  },
  {
    "prefixo": "23970",
    "uf": "RJ",
    "codigoIbge": 3303807,
    "cidade": "Paraty"
  },
  {
    "prefixo": "23972",
    "uf": "RJ",
    "codigoIbge": 3303807,
    "cidade": "Paraty"
  },
  {
    "prefixo": "23975",
    "uf": "RJ",
    "codigoIbge": 3303807,
    "cidade": "Paraty"
  },
  {
    "prefixo": "24003",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24004",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24006",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24007",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24008",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24012",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24020",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24026",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24030",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24040",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24050",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24060",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24070",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24110",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24111",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24120",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24130",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24140",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24141",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24210",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24220",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24230",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24240",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24241",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24310",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24315",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24320",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24322",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24325",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24330",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24340",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24342",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24344",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24346",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24348",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24350",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24355",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24358",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24360",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24365",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24370",
    "uf": "RJ",
    "codigoIbge": 3303302,
    "cidade": "Niterói"
  },
  {
    "prefixo": "24410",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24411",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24412",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24415",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24416",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24417",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24420",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24421",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24422",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24425",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24426",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24430",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24431",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24435",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24436",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24440",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24445",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24450",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24451",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24452",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24455",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24456",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24457",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24460",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24461",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24465",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24466",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24467",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24470",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24471",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24472",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24473",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24474",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24475",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24476",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24493",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24630",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24710",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24711",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24715",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24716",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24717",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24720",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24721",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24722",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24723",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24724",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24725",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24726",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24727",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24730",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24731",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24732",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24733",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24734",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24735",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24736",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24737",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24738",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24740",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24741",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24742",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24743",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24744",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24745",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24746",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24750",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24751",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24752",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24753",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24754",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24755",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24756",
    "uf": "RJ",
    "codigoIbge": 3304904,
    "cidade": "São Gonçalo"
  },
  {
    "prefixo": "24800",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24801",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24802",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24803",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24804",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24805",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24806",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24808",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24809",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24810",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24812",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24813",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24815",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24830",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24840",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24841",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24842",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24843",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24845",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24846",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24847",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24850",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24851",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24852",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24855",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24856",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24857",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24858",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24859",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24860",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24861",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24865",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24866",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24867",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24868",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24875",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24876",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24877",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24878",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24889",
    "uf": "RJ",
    "codigoIbge": 3301900,
    "cidade": "Itaboraí"
  },
  {
    "prefixo": "24890",
    "uf": "RJ",
    "codigoIbge": 3305752,
    "cidade": "Tanguá"
  },
  {
    "prefixo": "24900",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24901",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24902",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24903",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24904",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24905",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24906",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24907",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24908",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24909",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24910",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24911",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24912",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24913",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24914",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24915",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24916",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24917",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24918",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24919",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24920",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24921",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24922",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24923",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24924",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24925",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24926",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24927",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24928",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24930",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24931",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24932",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24933",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24934",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24935",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24936",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24937",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24938",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24939",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24940",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24941",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24942",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24943",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "24944",
    "uf": "RJ",
    "codigoIbge": 3302700,
    "cidade": "Maricá"
  },
  {
    "prefixo": "25010",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25011",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25015",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25020",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25025",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25030",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25035",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25036",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25040",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25041",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25042",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25044",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25045",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25046",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25050",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25051",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25055",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25056",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25060",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25065",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25070",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25071",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25075",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25080",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25081",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25085",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25086",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25210",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25211",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25212",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25213",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25214",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25215",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25220",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25221",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25222",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25223",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25225",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25230",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25231",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25233",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25235",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25237",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25240",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25241",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25243",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25245",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25250",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25251",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25253",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25255",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25256",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25260",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25261",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25264",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25265",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25266",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25267",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25268",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25270",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25271",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25272",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25275",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25499",
    "uf": "RJ",
    "codigoIbge": 3301702,
    "cidade": "Duque de Caxias"
  },
  {
    "prefixo": "25510",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25515",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25520",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25525",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25530",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25535",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25540",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25545",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25550",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25555",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25560",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25561",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25565",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25570",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25571",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25575",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25576",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25580",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25581",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25585",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25586",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25599",
    "uf": "RJ",
    "codigoIbge": 3305109,
    "cidade": "São João de Meriti"
  },
  {
    "prefixo": "25610",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25615",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25620",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25625",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25630",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25635",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25640",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25645",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25650",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25651",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25655",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25660",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25665",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25670",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25675",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25680",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25685",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25710",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25715",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25716",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25720",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25725",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25730",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25740",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25745",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25750",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25755",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25770",
    "uf": "RJ",
    "codigoIbge": 3303906,
    "cidade": "Petrópolis"
  },
  {
    "prefixo": "25780",
    "uf": "RJ",
    "codigoIbge": 3305158,
    "cidade": "São José do Vale do Rio Preto"
  },
  {
    "prefixo": "25802",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25803",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25804",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25805",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25806",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25807",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25808",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25809",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25810",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25811",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25812",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25815",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25820",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25821",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25829",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25840",
    "uf": "RJ",
    "codigoIbge": 3306008,
    "cidade": "Três Rios"
  },
  {
    "prefixo": "25845",
    "uf": "RJ",
    "codigoIbge": 3300225,
    "cidade": "Areal"
  },
  {
    "prefixo": "25850",
    "uf": "RJ",
    "codigoIbge": 3303708,
    "cidade": "Paraíba do Sul"
  },
  {
    "prefixo": "25855",
    "uf": "RJ",
    "codigoIbge": 3303708,
    "cidade": "Paraíba do Sul"
  },
  {
    "prefixo": "25860",
    "uf": "RJ",
    "codigoIbge": 3303708,
    "cidade": "Paraíba do Sul"
  },
  {
    "prefixo": "25865",
    "uf": "RJ",
    "codigoIbge": 3303708,
    "cidade": "Paraíba do Sul"
  },
  {
    "prefixo": "25870",
    "uf": "RJ",
    "codigoIbge": 3300951,
    "cidade": "Comendador Levy Gasparian"
  },
  {
    "prefixo": "25875",
    "uf": "RJ",
    "codigoIbge": 3300951,
    "cidade": "Comendador Levy Gasparian"
  },
  {
    "prefixo": "25880",
    "uf": "RJ",
    "codigoIbge": 3305406,
    "cidade": "Sapucaia"
  },
  {
    "prefixo": "25882",
    "uf": "RJ",
    "codigoIbge": 3305406,
    "cidade": "Sapucaia"
  },
  {
    "prefixo": "25884",
    "uf": "RJ",
    "codigoIbge": 3305406,
    "cidade": "Sapucaia"
  },
  {
    "prefixo": "25886",
    "uf": "RJ",
    "codigoIbge": 3305406,
    "cidade": "Sapucaia"
  },
  {
    "prefixo": "25887",
    "uf": "RJ",
    "codigoIbge": 3305406,
    "cidade": "Sapucaia"
  },
  {
    "prefixo": "25900",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25901",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25902",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25903",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25904",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25905",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25906",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25907",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25908",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25910",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25911",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25912",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25914",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25916",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25917",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25918",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25919",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25920",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25921",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25922",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25924",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25925",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25926",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25927",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25928",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25930",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25931",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25932",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25933",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25935",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25936",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25937",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25938",
    "uf": "RJ",
    "codigoIbge": 3302502,
    "cidade": "Magé"
  },
  {
    "prefixo": "25940",
    "uf": "RJ",
    "codigoIbge": 3301850,
    "cidade": "Guapimirim"
  },
  {
    "prefixo": "25941",
    "uf": "RJ",
    "codigoIbge": 3301850,
    "cidade": "Guapimirim"
  },
  {
    "prefixo": "25942",
    "uf": "RJ",
    "codigoIbge": 3301850,
    "cidade": "Guapimirim"
  },
  {
    "prefixo": "25943",
    "uf": "RJ",
    "codigoIbge": 3301850,
    "cidade": "Guapimirim"
  },
  {
    "prefixo": "25944",
    "uf": "RJ",
    "codigoIbge": 3301850,
    "cidade": "Guapimirim"
  },
  {
    "prefixo": "25945",
    "uf": "RJ",
    "codigoIbge": 3301850,
    "cidade": "Guapimirim"
  },
  {
    "prefixo": "25946",
    "uf": "RJ",
    "codigoIbge": 3301850,
    "cidade": "Guapimirim"
  },
  {
    "prefixo": "25947",
    "uf": "RJ",
    "codigoIbge": 3301850,
    "cidade": "Guapimirim"
  },
  {
    "prefixo": "25948",
    "uf": "RJ",
    "codigoIbge": 3301850,
    "cidade": "Guapimirim"
  },
  {
    "prefixo": "25949",
    "uf": "RJ",
    "codigoIbge": 3301850,
    "cidade": "Guapimirim"
  },
  {
    "prefixo": "25953",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25954",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25955",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25956",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25957",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25958",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25959",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25960",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25961",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25963",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25964",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25965",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25966",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25970",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25973",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25974",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25975",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25976",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25977",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25978",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25980",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25985",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25990",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25995",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25996",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "25998",
    "uf": "RJ",
    "codigoIbge": 3305802,
    "cidade": "Teresópolis"
  },
  {
    "prefixo": "26010",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26011",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26012",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26013",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26015",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26020",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26021",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26022",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26023",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26025",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26030",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26031",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26032",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26033",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26035",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26040",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26041",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26042",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26043",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26045",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26050",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26051",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26052",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26053",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26055",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26060",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26061",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26062",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26063",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26064",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26065",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26070",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26080",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26082",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26083",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26084",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26085",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26086",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26087",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26088",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26089",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26090",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26092",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26099",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26110",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26112",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26113",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26115",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26116",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26120",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26123",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26125",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26127",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26130",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26131",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26135",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26140",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26143",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26150",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26153",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26155",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26157",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26160",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26163",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26165",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26167",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26170",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26171",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26172",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26173",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26175",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26176",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26177",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26178",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26180",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26181",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26182",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26183",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26185",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26186",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26187",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26190",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26193",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26195",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26196",
    "uf": "RJ",
    "codigoIbge": 3300456,
    "cidade": "Belford Roxo"
  },
  {
    "prefixo": "26210",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26214",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26215",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26216",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26220",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26221",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26225",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26230",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26231",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26250",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26255",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26256",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26260",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26261",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26262",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26263",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26265",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26266",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26270",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26271",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26272",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26275",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26276",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26277",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26278",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26279",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26280",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26281",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26282",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26285",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26286",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26290",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26291",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26292",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26293",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26294",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26295",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26296",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26297",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26298",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26299",
    "uf": "RJ",
    "codigoIbge": 3303500,
    "cidade": "Nova Iguaçu"
  },
  {
    "prefixo": "26310",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26311",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26313",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26315",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26316",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26317",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26320",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26321",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26323",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26325",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26327",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26330",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26340",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26343",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26361",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26373",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26375",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26376",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26377",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26379",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26380",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26381",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26382",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26383",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26385",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26387",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26393",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26397",
    "uf": "RJ",
    "codigoIbge": 3304144,
    "cidade": "Queimados"
  },
  {
    "prefixo": "26410",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26413",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26415",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26420",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26423",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26425",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26430",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26433",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26435",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26440",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26443",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26445",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26450",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26453",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26455",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26460",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26463",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26465",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26470",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26473",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26475",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26480",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26483",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26490",
    "uf": "RJ",
    "codigoIbge": 3302270,
    "cidade": "Japeri"
  },
  {
    "prefixo": "26510",
    "uf": "RJ",
    "codigoIbge": 3303203,
    "cidade": "Nilópolis"
  },
  {
    "prefixo": "26511",
    "uf": "RJ",
    "codigoIbge": 3303203,
    "cidade": "Nilópolis"
  },
  {
    "prefixo": "26515",
    "uf": "RJ",
    "codigoIbge": 3303203,
    "cidade": "Nilópolis"
  },
  {
    "prefixo": "26520",
    "uf": "RJ",
    "codigoIbge": 3303203,
    "cidade": "Nilópolis"
  },
  {
    "prefixo": "26521",
    "uf": "RJ",
    "codigoIbge": 3303203,
    "cidade": "Nilópolis"
  },
  {
    "prefixo": "26525",
    "uf": "RJ",
    "codigoIbge": 3303203,
    "cidade": "Nilópolis"
  },
  {
    "prefixo": "26526",
    "uf": "RJ",
    "codigoIbge": 3303203,
    "cidade": "Nilópolis"
  },
  {
    "prefixo": "26530",
    "uf": "RJ",
    "codigoIbge": 3303203,
    "cidade": "Nilópolis"
  },
  {
    "prefixo": "26535",
    "uf": "RJ",
    "codigoIbge": 3303203,
    "cidade": "Nilópolis"
  },
  {
    "prefixo": "26540",
    "uf": "RJ",
    "codigoIbge": 3303203,
    "cidade": "Nilópolis"
  },
  {
    "prefixo": "26545",
    "uf": "RJ",
    "codigoIbge": 3303203,
    "cidade": "Nilópolis"
  },
  {
    "prefixo": "26550",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26551",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26553",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26554",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26556",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26557",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26560",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26562",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26564",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26570",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26572",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26574",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26580",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26582",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26584",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26585",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26587",
    "uf": "RJ",
    "codigoIbge": 3302858,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "26600",
    "uf": "RJ",
    "codigoIbge": 3303609,
    "cidade": "Paracambi"
  },
  {
    "prefixo": "26650",
    "uf": "RJ",
    "codigoIbge": 3301801,
    "cidade": "Engenheiro Paulo de Frontin"
  },
  {
    "prefixo": "26660",
    "uf": "RJ",
    "codigoIbge": 3301801,
    "cidade": "Engenheiro Paulo de Frontin"
  },
  {
    "prefixo": "26700",
    "uf": "RJ",
    "codigoIbge": 3302809,
    "cidade": "Mendes"
  },
  {
    "prefixo": "26900",
    "uf": "RJ",
    "codigoIbge": 3302908,
    "cidade": "Miguel Pereira"
  },
  {
    "prefixo": "26910",
    "uf": "RJ",
    "codigoIbge": 3302908,
    "cidade": "Miguel Pereira"
  },
  {
    "prefixo": "26920",
    "uf": "RJ",
    "codigoIbge": 3302908,
    "cidade": "Miguel Pereira"
  },
  {
    "prefixo": "26950",
    "uf": "RJ",
    "codigoIbge": 3303856,
    "cidade": "Paty do Alferes"
  },
  {
    "prefixo": "26980",
    "uf": "RJ",
    "codigoIbge": 3303856,
    "cidade": "Paty do Alferes"
  },
  {
    "prefixo": "27110",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27113",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27115",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27120",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27123",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27130",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27135",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27140",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27143",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27145",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27150",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27155",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27160",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27163",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27164",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27165",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27170",
    "uf": "RJ",
    "codigoIbge": 3300308,
    "cidade": "Barra do Piraí"
  },
  {
    "prefixo": "27175",
    "uf": "RJ",
    "codigoIbge": 3304003,
    "cidade": "Piraí"
  },
  {
    "prefixo": "27185",
    "uf": "RJ",
    "codigoIbge": 3304003,
    "cidade": "Piraí"
  },
  {
    "prefixo": "27195",
    "uf": "RJ",
    "codigoIbge": 3304003,
    "cidade": "Piraí"
  },
  {
    "prefixo": "27197",
    "uf": "RJ",
    "codigoIbge": 3303955,
    "cidade": "Pinheiral"
  },
  {
    "prefixo": "27208",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27210",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27211",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27212",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27213",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27214",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27215",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27220",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27230",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27240",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27250",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27251",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27253",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27255",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27256",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27257",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27258",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27259",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27260",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27261",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27262",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27263",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27264",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27265",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27267",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27269",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27273",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27274",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27275",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27276",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27277",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27278",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27279",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27280",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27281",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27283",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27285",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27286",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27288",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27290",
    "uf": "RJ",
    "codigoIbge": 3306305,
    "cidade": "Volta Redonda"
  },
  {
    "prefixo": "27310",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27313",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27320",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27321",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27322",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27323",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27325",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27330",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27331",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27332",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27333",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27334",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27335",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27336",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27337",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27338",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27340",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27343",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27345",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27347",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27350",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27351",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27353",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27360",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27365",
    "uf": "RJ",
    "codigoIbge": 3300407,
    "cidade": "Barra Mansa"
  },
  {
    "prefixo": "27410",
    "uf": "RJ",
    "codigoIbge": 3304128,
    "cidade": "Quatis"
  },
  {
    "prefixo": "27420",
    "uf": "RJ",
    "codigoIbge": 3304128,
    "cidade": "Quatis"
  },
  {
    "prefixo": "27430",
    "uf": "RJ",
    "codigoIbge": 3304128,
    "cidade": "Quatis"
  },
  {
    "prefixo": "27440",
    "uf": "RJ",
    "codigoIbge": 3304128,
    "cidade": "Quatis"
  },
  {
    "prefixo": "27450",
    "uf": "RJ",
    "codigoIbge": 3304128,
    "cidade": "Quatis"
  },
  {
    "prefixo": "27459",
    "uf": "RJ",
    "codigoIbge": 3304128,
    "cidade": "Quatis"
  },
  {
    "prefixo": "27460",
    "uf": "RJ",
    "codigoIbge": 3304409,
    "cidade": "Rio Claro"
  },
  {
    "prefixo": "27465",
    "uf": "RJ",
    "codigoIbge": 3304409,
    "cidade": "Rio Claro"
  },
  {
    "prefixo": "27470",
    "uf": "RJ",
    "codigoIbge": 3304409,
    "cidade": "Rio Claro"
  },
  {
    "prefixo": "27472",
    "uf": "RJ",
    "codigoIbge": 3304409,
    "cidade": "Rio Claro"
  },
  {
    "prefixo": "27475",
    "uf": "RJ",
    "codigoIbge": 3304409,
    "cidade": "Rio Claro"
  },
  {
    "prefixo": "27510",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27511",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27512",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27513",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27514",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27515",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27516",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27520",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27521",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27522",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27523",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27524",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27525",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27530",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27532",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27533",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27534",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27535",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27536",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27537",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27540",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27541",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27542",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27549",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27550",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27553",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27555",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27560",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27565",
    "uf": "RJ",
    "codigoIbge": 3304201,
    "cidade": "Resende"
  },
  {
    "prefixo": "27570",
    "uf": "RJ",
    "codigoIbge": 3304110,
    "cidade": "Porto Real"
  },
  {
    "prefixo": "27580",
    "uf": "RJ",
    "codigoIbge": 3302254,
    "cidade": "Itatiaia"
  },
  {
    "prefixo": "27598",
    "uf": "RJ",
    "codigoIbge": 3302254,
    "cidade": "Itatiaia"
  },
  {
    "prefixo": "27600",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27601",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27602",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27603",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27604",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27605",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27606",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27607",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27608",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27610",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27611",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27640",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27645",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27650",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27655",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27657",
    "uf": "RJ",
    "codigoIbge": 3306107,
    "cidade": "Valença"
  },
  {
    "prefixo": "27660",
    "uf": "RJ",
    "codigoIbge": 3304508,
    "cidade": "Rio das Flores"
  },
  {
    "prefixo": "27665",
    "uf": "RJ",
    "codigoIbge": 3304508,
    "cidade": "Rio das Flores"
  },
  {
    "prefixo": "27670",
    "uf": "RJ",
    "codigoIbge": 3304508,
    "cidade": "Rio das Flores"
  },
  {
    "prefixo": "27690",
    "uf": "RJ",
    "codigoIbge": 3304508,
    "cidade": "Rio das Flores"
  },
  {
    "prefixo": "27700",
    "uf": "RJ",
    "codigoIbge": 3306206,
    "cidade": "Vassouras"
  },
  {
    "prefixo": "27705",
    "uf": "RJ",
    "codigoIbge": 3306206,
    "cidade": "Vassouras"
  },
  {
    "prefixo": "27720",
    "uf": "RJ",
    "codigoIbge": 3306206,
    "cidade": "Vassouras"
  },
  {
    "prefixo": "27770",
    "uf": "RJ",
    "codigoIbge": 3306206,
    "cidade": "Vassouras"
  },
  {
    "prefixo": "27910",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27913",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27915",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27916",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27920",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27923",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27925",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27930",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27931",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27932",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27933",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27935",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27936",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27937",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27940",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27943",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27944",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27945",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27946",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27947",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27948",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27949",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27959",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27960",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27961",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27963",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27964",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27965",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27966",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27970",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27971",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27972",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27973",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27975",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27977",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27979",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27980",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27985",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27987",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27990",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27995",
    "uf": "RJ",
    "codigoIbge": 3302403,
    "cidade": "Macaé"
  },
  {
    "prefixo": "27998",
    "uf": "RJ",
    "codigoIbge": 3300936,
    "cidade": "Carapebus"
  },
  {
    "prefixo": "28010",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28013",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28015",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28016",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28020",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28021",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28022",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28024",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28025",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28026",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28027",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28030",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28035",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28040",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28050",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28051",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28053",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28055",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28057",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28060",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28070",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28073",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28080",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28083",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28085",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28090",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28093",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28099",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28110",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28115",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28118",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28120",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28125",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28140",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28143",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28145",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28148",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28155",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28160",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28165",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28175",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28178",
    "uf": "RJ",
    "codigoIbge": 3301009,
    "cidade": "Campos dos Goytacazes"
  },
  {
    "prefixo": "28180",
    "uf": "RJ",
    "codigoIbge": 3301157,
    "cidade": "Cardoso Moreira"
  },
  {
    "prefixo": "28200",
    "uf": "RJ",
    "codigoIbge": 3305000,
    "cidade": "São João da Barra"
  },
  {
    "prefixo": "28220",
    "uf": "RJ",
    "codigoIbge": 3305000,
    "cidade": "São João da Barra"
  },
  {
    "prefixo": "28225",
    "uf": "RJ",
    "codigoIbge": 3305000,
    "cidade": "São João da Barra"
  },
  {
    "prefixo": "28230",
    "uf": "RJ",
    "codigoIbge": 3304755,
    "cidade": "São Francisco de Itabapoana"
  },
  {
    "prefixo": "28235",
    "uf": "RJ",
    "codigoIbge": 3304755,
    "cidade": "São Francisco de Itabapoana"
  },
  {
    "prefixo": "28240",
    "uf": "RJ",
    "codigoIbge": 3304755,
    "cidade": "São Francisco de Itabapoana"
  },
  {
    "prefixo": "28250",
    "uf": "RJ",
    "codigoIbge": 3302056,
    "cidade": "Italva"
  },
  {
    "prefixo": "28300",
    "uf": "RJ",
    "codigoIbge": 3302205,
    "cidade": "Itaperuna"
  },
  {
    "prefixo": "28330",
    "uf": "RJ",
    "codigoIbge": 3302205,
    "cidade": "Itaperuna"
  },
  {
    "prefixo": "28333",
    "uf": "RJ",
    "codigoIbge": 3302205,
    "cidade": "Itaperuna"
  },
  {
    "prefixo": "28340",
    "uf": "RJ",
    "codigoIbge": 3302205,
    "cidade": "Itaperuna"
  },
  {
    "prefixo": "28348",
    "uf": "RJ",
    "codigoIbge": 3302205,
    "cidade": "Itaperuna"
  },
  {
    "prefixo": "28350",
    "uf": "RJ",
    "codigoIbge": 3302304,
    "cidade": "Laje do Muriaé"
  },
  {
    "prefixo": "28360",
    "uf": "RJ",
    "codigoIbge": 3300605,
    "cidade": "Bom Jesus do Itabapoana"
  },
  {
    "prefixo": "28365",
    "uf": "RJ",
    "codigoIbge": 3300605,
    "cidade": "Bom Jesus do Itabapoana"
  },
  {
    "prefixo": "28368",
    "uf": "RJ",
    "codigoIbge": 3300605,
    "cidade": "Bom Jesus do Itabapoana"
  },
  {
    "prefixo": "28370",
    "uf": "RJ",
    "codigoIbge": 3300605,
    "cidade": "Bom Jesus do Itabapoana"
  },
  {
    "prefixo": "28372",
    "uf": "RJ",
    "codigoIbge": 3300605,
    "cidade": "Bom Jesus do Itabapoana"
  },
  {
    "prefixo": "28374",
    "uf": "RJ",
    "codigoIbge": 3300605,
    "cidade": "Bom Jesus do Itabapoana"
  },
  {
    "prefixo": "28375",
    "uf": "RJ",
    "codigoIbge": 3306156,
    "cidade": "Varre-Sai"
  },
  {
    "prefixo": "28380",
    "uf": "RJ",
    "codigoIbge": 3303104,
    "cidade": "Natividade"
  },
  {
    "prefixo": "28383",
    "uf": "RJ",
    "codigoIbge": 3303104,
    "cidade": "Natividade"
  },
  {
    "prefixo": "28388",
    "uf": "RJ",
    "codigoIbge": 3303104,
    "cidade": "Natividade"
  },
  {
    "prefixo": "28390",
    "uf": "RJ",
    "codigoIbge": 3304102,
    "cidade": "Porciúncula"
  },
  {
    "prefixo": "28396",
    "uf": "RJ",
    "codigoIbge": 3304102,
    "cidade": "Porciúncula"
  },
  {
    "prefixo": "28398",
    "uf": "RJ",
    "codigoIbge": 3304102,
    "cidade": "Porciúncula"
  },
  {
    "prefixo": "28400",
    "uf": "RJ",
    "codigoIbge": 3304805,
    "cidade": "São Fidélis"
  },
  {
    "prefixo": "28405",
    "uf": "RJ",
    "codigoIbge": 3304805,
    "cidade": "São Fidélis"
  },
  {
    "prefixo": "28415",
    "uf": "RJ",
    "codigoIbge": 3304805,
    "cidade": "São Fidélis"
  },
  {
    "prefixo": "28420",
    "uf": "RJ",
    "codigoIbge": 3304805,
    "cidade": "São Fidélis"
  },
  {
    "prefixo": "28425",
    "uf": "RJ",
    "codigoIbge": 3304805,
    "cidade": "São Fidélis"
  },
  {
    "prefixo": "28430",
    "uf": "RJ",
    "codigoIbge": 3300902,
    "cidade": "Cambuci"
  },
  {
    "prefixo": "28435",
    "uf": "RJ",
    "codigoIbge": 3300902,
    "cidade": "Cambuci"
  },
  {
    "prefixo": "28445",
    "uf": "RJ",
    "codigoIbge": 3300902,
    "cidade": "Cambuci"
  },
  {
    "prefixo": "28450",
    "uf": "RJ",
    "codigoIbge": 3300902,
    "cidade": "Cambuci"
  },
  {
    "prefixo": "28455",
    "uf": "RJ",
    "codigoIbge": 3305133,
    "cidade": "São José de Ubá"
  },
  {
    "prefixo": "28460",
    "uf": "RJ",
    "codigoIbge": 3303005,
    "cidade": "Miracema"
  },
  {
    "prefixo": "28463",
    "uf": "RJ",
    "codigoIbge": 3303005,
    "cidade": "Miracema"
  },
  {
    "prefixo": "28466",
    "uf": "RJ",
    "codigoIbge": 3303005,
    "cidade": "Miracema"
  },
  {
    "prefixo": "28470",
    "uf": "RJ",
    "codigoIbge": 3304706,
    "cidade": "Santo Antônio de Pádua"
  },
  {
    "prefixo": "28473",
    "uf": "RJ",
    "codigoIbge": 3304706,
    "cidade": "Santo Antônio de Pádua"
  },
  {
    "prefixo": "28476",
    "uf": "RJ",
    "codigoIbge": 3304706,
    "cidade": "Santo Antônio de Pádua"
  },
  {
    "prefixo": "28483",
    "uf": "RJ",
    "codigoIbge": 3304706,
    "cidade": "Santo Antônio de Pádua"
  },
  {
    "prefixo": "28490",
    "uf": "RJ",
    "codigoIbge": 3304706,
    "cidade": "Santo Antônio de Pádua"
  },
  {
    "prefixo": "28495",
    "uf": "RJ",
    "codigoIbge": 3300159,
    "cidade": "Aperibé"
  },
  {
    "prefixo": "28500",
    "uf": "RJ",
    "codigoIbge": 3301108,
    "cidade": "Cantagalo"
  },
  {
    "prefixo": "28510",
    "uf": "RJ",
    "codigoIbge": 3301108,
    "cidade": "Cantagalo"
  },
  {
    "prefixo": "28520",
    "uf": "RJ",
    "codigoIbge": 3301108,
    "cidade": "Cantagalo"
  },
  {
    "prefixo": "28525",
    "uf": "RJ",
    "codigoIbge": 3301108,
    "cidade": "Cantagalo"
  },
  {
    "prefixo": "28530",
    "uf": "RJ",
    "codigoIbge": 3301108,
    "cidade": "Cantagalo"
  },
  {
    "prefixo": "28540",
    "uf": "RJ",
    "codigoIbge": 3301504,
    "cidade": "Cordeiro"
  },
  {
    "prefixo": "28545",
    "uf": "RJ",
    "codigoIbge": 3302452,
    "cidade": "Macuco"
  },
  {
    "prefixo": "28550",
    "uf": "RJ",
    "codigoIbge": 3305307,
    "cidade": "São Sebastião do Alto"
  },
  {
    "prefixo": "28555",
    "uf": "RJ",
    "codigoIbge": 3305307,
    "cidade": "São Sebastião do Alto"
  },
  {
    "prefixo": "28557",
    "uf": "RJ",
    "codigoIbge": 3305307,
    "cidade": "São Sebastião do Alto"
  },
  {
    "prefixo": "28558",
    "uf": "RJ",
    "codigoIbge": 3305307,
    "cidade": "São Sebastião do Alto"
  },
  {
    "prefixo": "28570",
    "uf": "RJ",
    "codigoIbge": 3302106,
    "cidade": "Itaocara"
  },
  {
    "prefixo": "28575",
    "uf": "RJ",
    "codigoIbge": 3302106,
    "cidade": "Itaocara"
  },
  {
    "prefixo": "28580",
    "uf": "RJ",
    "codigoIbge": 3302106,
    "cidade": "Itaocara"
  },
  {
    "prefixo": "28585",
    "uf": "RJ",
    "codigoIbge": 3302106,
    "cidade": "Itaocara"
  },
  {
    "prefixo": "28590",
    "uf": "RJ",
    "codigoIbge": 3302106,
    "cidade": "Itaocara"
  },
  {
    "prefixo": "28595",
    "uf": "RJ",
    "codigoIbge": 3302106,
    "cidade": "Itaocara"
  },
  {
    "prefixo": "28600",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28605",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28610",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28611",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28613",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28614",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28615",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28616",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28617",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28620",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28621",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28623",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28625",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28626",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28630",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28633",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28634",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28635",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28636",
    "uf": "RJ",
    "codigoIbge": 3303401,
    "cidade": "Nova Friburgo"
  },
  {
    "prefixo": "28637",
    "uf": "RJ",
    "codigoIbge": 3305703,
    "cidade": "Sumidouro"
  },
  {
    "prefixo": "28640",
    "uf": "RJ",
    "codigoIbge": 3301207,
    "cidade": "Carmo"
  },
  {
    "prefixo": "28642",
    "uf": "RJ",
    "codigoIbge": 3301207,
    "cidade": "Carmo"
  },
  {
    "prefixo": "28644",
    "uf": "RJ",
    "codigoIbge": 3301207,
    "cidade": "Carmo"
  },
  {
    "prefixo": "28650",
    "uf": "RJ",
    "codigoIbge": 3301603,
    "cidade": "Duas Barras"
  },
  {
    "prefixo": "28655",
    "uf": "RJ",
    "codigoIbge": 3301603,
    "cidade": "Duas Barras"
  },
  {
    "prefixo": "28660",
    "uf": "RJ",
    "codigoIbge": 3300506,
    "cidade": "Bom Jardim"
  },
  {
    "prefixo": "28662",
    "uf": "RJ",
    "codigoIbge": 3300506,
    "cidade": "Bom Jardim"
  },
  {
    "prefixo": "28664",
    "uf": "RJ",
    "codigoIbge": 3300506,
    "cidade": "Bom Jardim"
  },
  {
    "prefixo": "28666",
    "uf": "RJ",
    "codigoIbge": 3300506,
    "cidade": "Bom Jardim"
  },
  {
    "prefixo": "28680",
    "uf": "RJ",
    "codigoIbge": 3300803,
    "cidade": "Cachoeiras de Macacu"
  },
  {
    "prefixo": "28681",
    "uf": "RJ",
    "codigoIbge": 3300803,
    "cidade": "Cachoeiras de Macacu"
  },
  {
    "prefixo": "28682",
    "uf": "RJ",
    "codigoIbge": 3300803,
    "cidade": "Cachoeiras de Macacu"
  },
  {
    "prefixo": "28683",
    "uf": "RJ",
    "codigoIbge": 3300803,
    "cidade": "Cachoeiras de Macacu"
  },
  {
    "prefixo": "28684",
    "uf": "RJ",
    "codigoIbge": 3300803,
    "cidade": "Cachoeiras de Macacu"
  },
  {
    "prefixo": "28685",
    "uf": "RJ",
    "codigoIbge": 3300803,
    "cidade": "Cachoeiras de Macacu"
  },
  {
    "prefixo": "28686",
    "uf": "RJ",
    "codigoIbge": 3300803,
    "cidade": "Cachoeiras de Macacu"
  },
  {
    "prefixo": "28687",
    "uf": "RJ",
    "codigoIbge": 3300803,
    "cidade": "Cachoeiras de Macacu"
  },
  {
    "prefixo": "28690",
    "uf": "RJ",
    "codigoIbge": 3300803,
    "cidade": "Cachoeiras de Macacu"
  },
  {
    "prefixo": "28691",
    "uf": "RJ",
    "codigoIbge": 3300803,
    "cidade": "Cachoeiras de Macacu"
  },
  {
    "prefixo": "28692",
    "uf": "RJ",
    "codigoIbge": 3300803,
    "cidade": "Cachoeiras de Macacu"
  },
  {
    "prefixo": "28694",
    "uf": "RJ",
    "codigoIbge": 3300803,
    "cidade": "Cachoeiras de Macacu"
  },
  {
    "prefixo": "28695",
    "uf": "RJ",
    "codigoIbge": 3300803,
    "cidade": "Cachoeiras de Macacu"
  },
  {
    "prefixo": "28696",
    "uf": "RJ",
    "codigoIbge": 3300803,
    "cidade": "Cachoeiras de Macacu"
  },
  {
    "prefixo": "28735",
    "uf": "RJ",
    "codigoIbge": 3304151,
    "cidade": "Quissamã"
  },
  {
    "prefixo": "28736",
    "uf": "RJ",
    "codigoIbge": 3304151,
    "cidade": "Quissamã"
  },
  {
    "prefixo": "28737",
    "uf": "RJ",
    "codigoIbge": 3304151,
    "cidade": "Quissamã"
  },
  {
    "prefixo": "28740",
    "uf": "RJ",
    "codigoIbge": 3301405,
    "cidade": "Conceição de Macabu"
  },
  {
    "prefixo": "28745",
    "uf": "RJ",
    "codigoIbge": 3301405,
    "cidade": "Conceição de Macabu"
  },
  {
    "prefixo": "28750",
    "uf": "RJ",
    "codigoIbge": 3305901,
    "cidade": "Trajano de Moraes"
  },
  {
    "prefixo": "28755",
    "uf": "RJ",
    "codigoIbge": 3305901,
    "cidade": "Trajano de Moraes"
  },
  {
    "prefixo": "28757",
    "uf": "RJ",
    "codigoIbge": 3305901,
    "cidade": "Trajano de Moraes"
  },
  {
    "prefixo": "28760",
    "uf": "RJ",
    "codigoIbge": 3305901,
    "cidade": "Trajano de Moraes"
  },
  {
    "prefixo": "28765",
    "uf": "RJ",
    "codigoIbge": 3305901,
    "cidade": "Trajano de Moraes"
  },
  {
    "prefixo": "28767",
    "uf": "RJ",
    "codigoIbge": 3305901,
    "cidade": "Trajano de Moraes"
  },
  {
    "prefixo": "28770",
    "uf": "RJ",
    "codigoIbge": 3304607,
    "cidade": "Santa Maria Madalena"
  },
  {
    "prefixo": "28772",
    "uf": "RJ",
    "codigoIbge": 3304607,
    "cidade": "Santa Maria Madalena"
  },
  {
    "prefixo": "28777",
    "uf": "RJ",
    "codigoIbge": 3304607,
    "cidade": "Santa Maria Madalena"
  },
  {
    "prefixo": "28778",
    "uf": "RJ",
    "codigoIbge": 3304607,
    "cidade": "Santa Maria Madalena"
  },
  {
    "prefixo": "28779",
    "uf": "RJ",
    "codigoIbge": 3304607,
    "cidade": "Santa Maria Madalena"
  },
  {
    "prefixo": "28800",
    "uf": "RJ",
    "codigoIbge": 3304300,
    "cidade": "Rio Bonito"
  },
  {
    "prefixo": "28810",
    "uf": "RJ",
    "codigoIbge": 3304300,
    "cidade": "Rio Bonito"
  },
  {
    "prefixo": "28820",
    "uf": "RJ",
    "codigoIbge": 3305604,
    "cidade": "Silva Jardim"
  },
  {
    "prefixo": "28830",
    "uf": "RJ",
    "codigoIbge": 3305604,
    "cidade": "Silva Jardim"
  },
  {
    "prefixo": "28860",
    "uf": "RJ",
    "codigoIbge": 3301306,
    "cidade": "Casimiro de Abreu"
  },
  {
    "prefixo": "28880",
    "uf": "RJ",
    "codigoIbge": 3301306,
    "cidade": "Casimiro de Abreu"
  },
  {
    "prefixo": "28890",
    "uf": "RJ",
    "codigoIbge": 3304524,
    "cidade": "Rio das Ostras"
  },
  {
    "prefixo": "28891",
    "uf": "RJ",
    "codigoIbge": 3304524,
    "cidade": "Rio das Ostras"
  },
  {
    "prefixo": "28892",
    "uf": "RJ",
    "codigoIbge": 3304524,
    "cidade": "Rio das Ostras"
  },
  {
    "prefixo": "28893",
    "uf": "RJ",
    "codigoIbge": 3304524,
    "cidade": "Rio das Ostras"
  },
  {
    "prefixo": "28894",
    "uf": "RJ",
    "codigoIbge": 3304524,
    "cidade": "Rio das Ostras"
  },
  {
    "prefixo": "28895",
    "uf": "RJ",
    "codigoIbge": 3304524,
    "cidade": "Rio das Ostras"
  },
  {
    "prefixo": "28896",
    "uf": "RJ",
    "codigoIbge": 3304524,
    "cidade": "Rio das Ostras"
  },
  {
    "prefixo": "28897",
    "uf": "RJ",
    "codigoIbge": 3304524,
    "cidade": "Rio das Ostras"
  },
  {
    "prefixo": "28898",
    "uf": "RJ",
    "codigoIbge": 3304524,
    "cidade": "Rio das Ostras"
  },
  {
    "prefixo": "28899",
    "uf": "RJ",
    "codigoIbge": 3304524,
    "cidade": "Rio das Ostras"
  },
  {
    "prefixo": "28905",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28906",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28907",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28908",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28909",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28910",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28911",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28912",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28913",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28915",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28920",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28921",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28922",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28923",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28924",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28925",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28926",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28927",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28928",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28929",
    "uf": "RJ",
    "codigoIbge": 3300704,
    "cidade": "Cabo Frio"
  },
  {
    "prefixo": "28930",
    "uf": "RJ",
    "codigoIbge": 3300258,
    "cidade": "Arraial do Cabo"
  },
  {
    "prefixo": "28940",
    "uf": "RJ",
    "codigoIbge": 3305208,
    "cidade": "São Pedro da Aldeia"
  },
  {
    "prefixo": "28941",
    "uf": "RJ",
    "codigoIbge": 3305208,
    "cidade": "São Pedro da Aldeia"
  },
  {
    "prefixo": "28942",
    "uf": "RJ",
    "codigoIbge": 3305208,
    "cidade": "São Pedro da Aldeia"
  },
  {
    "prefixo": "28943",
    "uf": "RJ",
    "codigoIbge": 3305208,
    "cidade": "São Pedro da Aldeia"
  },
  {
    "prefixo": "28944",
    "uf": "RJ",
    "codigoIbge": 3305208,
    "cidade": "São Pedro da Aldeia"
  },
  {
    "prefixo": "28945",
    "uf": "RJ",
    "codigoIbge": 3305208,
    "cidade": "São Pedro da Aldeia"
  },
  {
    "prefixo": "28946",
    "uf": "RJ",
    "codigoIbge": 3305208,
    "cidade": "São Pedro da Aldeia"
  },
  {
    "prefixo": "28947",
    "uf": "RJ",
    "codigoIbge": 3305208,
    "cidade": "São Pedro da Aldeia"
  },
  {
    "prefixo": "28948",
    "uf": "RJ",
    "codigoIbge": 3305208,
    "cidade": "São Pedro da Aldeia"
  },
  {
    "prefixo": "28949",
    "uf": "RJ",
    "codigoIbge": 3305208,
    "cidade": "São Pedro da Aldeia"
  },
  {
    "prefixo": "28950",
    "uf": "RJ",
    "codigoIbge": 3300233,
    "cidade": "Armação dos Búzios"
  },
  {
    "prefixo": "28951",
    "uf": "RJ",
    "codigoIbge": 3300233,
    "cidade": "Armação dos Búzios"
  },
  {
    "prefixo": "28952",
    "uf": "RJ",
    "codigoIbge": 3300233,
    "cidade": "Armação dos Búzios"
  },
  {
    "prefixo": "28953",
    "uf": "RJ",
    "codigoIbge": 3300233,
    "cidade": "Armação dos Búzios"
  },
  {
    "prefixo": "28954",
    "uf": "RJ",
    "codigoIbge": 3300233,
    "cidade": "Armação dos Búzios"
  },
  {
    "prefixo": "28955",
    "uf": "RJ",
    "codigoIbge": 3300233,
    "cidade": "Armação dos Búzios"
  },
  {
    "prefixo": "28956",
    "uf": "RJ",
    "codigoIbge": 3300233,
    "cidade": "Armação dos Búzios"
  },
  {
    "prefixo": "28957",
    "uf": "RJ",
    "codigoIbge": 3300233,
    "cidade": "Armação dos Búzios"
  },
  {
    "prefixo": "28958",
    "uf": "RJ",
    "codigoIbge": 3300233,
    "cidade": "Armação dos Búzios"
  },
  {
    "prefixo": "28959",
    "uf": "RJ",
    "codigoIbge": 3300233,
    "cidade": "Armação dos Búzios"
  },
  {
    "prefixo": "28960",
    "uf": "RJ",
    "codigoIbge": 3301876,
    "cidade": "Iguaba Grande"
  },
  {
    "prefixo": "28970",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28971",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28972",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28973",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28974",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28975",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28976",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28977",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28978",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28979",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28980",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28981",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28982",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28983",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28984",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28985",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28986",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28987",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28988",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28989",
    "uf": "RJ",
    "codigoIbge": 3300209,
    "cidade": "Araruama"
  },
  {
    "prefixo": "28990",
    "uf": "RJ",
    "codigoIbge": 3305505,
    "cidade": "Saquarema"
  },
  {
    "prefixo": "28991",
    "uf": "RJ",
    "codigoIbge": 3305505,
    "cidade": "Saquarema"
  },
  {
    "prefixo": "28992",
    "uf": "RJ",
    "codigoIbge": 3305505,
    "cidade": "Saquarema"
  },
  {
    "prefixo": "28993",
    "uf": "RJ",
    "codigoIbge": 3305505,
    "cidade": "Saquarema"
  },
  {
    "prefixo": "28994",
    "uf": "RJ",
    "codigoIbge": 3305505,
    "cidade": "Saquarema"
  },
  {
    "prefixo": "28995",
    "uf": "RJ",
    "codigoIbge": 3305505,
    "cidade": "Saquarema"
  },
  {
    "prefixo": "28996",
    "uf": "RJ",
    "codigoIbge": 3305505,
    "cidade": "Saquarema"
  },
  {
    "prefixo": "28997",
    "uf": "RJ",
    "codigoIbge": 3305505,
    "cidade": "Saquarema"
  },
  {
    "prefixo": "28998",
    "uf": "RJ",
    "codigoIbge": 3305505,
    "cidade": "Saquarema"
  },
  {
    "prefixo": "28999",
    "uf": "RJ",
    "codigoIbge": 3305505,
    "cidade": "Saquarema"
  },
  {
    "prefixo": "29010",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29015",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29016",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29017",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29018",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29020",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29023",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29024",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29025",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29026",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29027",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29030",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29031",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29032",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29033",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29040",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29041",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29042",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29043",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29045",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29046",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29047",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29048",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29050",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29051",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29052",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29053",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29055",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29056",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29057",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29060",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29062",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29065",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29066",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29070",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29072",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29075",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29090",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29092",
    "uf": "ES",
    "codigoIbge": 3205309,
    "cidade": "Vitória"
  },
  {
    "prefixo": "29100",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29101",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29102",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29103",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29104",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29105",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29106",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29107",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29108",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29109",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29110",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29111",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29112",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29113",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29114",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29115",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29116",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29117",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29118",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29119",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29120",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29121",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29122",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29124",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29125",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29126",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29127",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29128",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29129",
    "uf": "ES",
    "codigoIbge": 3205200,
    "cidade": "Vila Velha"
  },
  {
    "prefixo": "29130",
    "uf": "ES",
    "codigoIbge": 3205101,
    "cidade": "Viana"
  },
  {
    "prefixo": "29131",
    "uf": "ES",
    "codigoIbge": 3205101,
    "cidade": "Viana"
  },
  {
    "prefixo": "29132",
    "uf": "ES",
    "codigoIbge": 3205101,
    "cidade": "Viana"
  },
  {
    "prefixo": "29134",
    "uf": "ES",
    "codigoIbge": 3205101,
    "cidade": "Viana"
  },
  {
    "prefixo": "29135",
    "uf": "ES",
    "codigoIbge": 3205101,
    "cidade": "Viana"
  },
  {
    "prefixo": "29136",
    "uf": "ES",
    "codigoIbge": 3205101,
    "cidade": "Viana"
  },
  {
    "prefixo": "29137",
    "uf": "ES",
    "codigoIbge": 3205101,
    "cidade": "Viana"
  },
  {
    "prefixo": "29138",
    "uf": "ES",
    "codigoIbge": 3205101,
    "cidade": "Viana"
  },
  {
    "prefixo": "29139",
    "uf": "ES",
    "codigoIbge": 3205101,
    "cidade": "Viana"
  },
  {
    "prefixo": "29140",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29141",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29142",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29143",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29144",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29145",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29146",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29147",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29148",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29149",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29150",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29151",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29152",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29153",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29154",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29155",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29156",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29157",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29158",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29159",
    "uf": "ES",
    "codigoIbge": 3201308,
    "cidade": "Cariacica"
  },
  {
    "prefixo": "29160",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29161",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29162",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29163",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29164",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29165",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29166",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29167",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29168",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29169",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29170",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29171",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29172",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29173",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29175",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29176",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29177",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29178",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29179",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29180",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29182",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29184",
    "uf": "ES",
    "codigoIbge": 3205002,
    "cidade": "Serra"
  },
  {
    "prefixo": "29185",
    "uf": "ES",
    "codigoIbge": 3202207,
    "cidade": "Fundão"
  },
  {
    "prefixo": "29187",
    "uf": "ES",
    "codigoIbge": 3202207,
    "cidade": "Fundão"
  },
  {
    "prefixo": "29188",
    "uf": "ES",
    "codigoIbge": 3202207,
    "cidade": "Fundão"
  },
  {
    "prefixo": "29189",
    "uf": "ES",
    "codigoIbge": 3202207,
    "cidade": "Fundão"
  },
  {
    "prefixo": "29190",
    "uf": "ES",
    "codigoIbge": 3200607,
    "cidade": "Aracruz"
  },
  {
    "prefixo": "29192",
    "uf": "ES",
    "codigoIbge": 3200607,
    "cidade": "Aracruz"
  },
  {
    "prefixo": "29193",
    "uf": "ES",
    "codigoIbge": 3200607,
    "cidade": "Aracruz"
  },
  {
    "prefixo": "29194",
    "uf": "ES",
    "codigoIbge": 3200607,
    "cidade": "Aracruz"
  },
  {
    "prefixo": "29195",
    "uf": "ES",
    "codigoIbge": 3200607,
    "cidade": "Aracruz"
  },
  {
    "prefixo": "29196",
    "uf": "ES",
    "codigoIbge": 3200607,
    "cidade": "Aracruz"
  },
  {
    "prefixo": "29197",
    "uf": "ES",
    "codigoIbge": 3200607,
    "cidade": "Aracruz"
  },
  {
    "prefixo": "29198",
    "uf": "ES",
    "codigoIbge": 3200607,
    "cidade": "Aracruz"
  },
  {
    "prefixo": "29199",
    "uf": "ES",
    "codigoIbge": 3200607,
    "cidade": "Aracruz"
  },
  {
    "prefixo": "29200",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29201",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29202",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29203",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29206",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29208",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29209",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29210",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29211",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29212",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29213",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29214",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29215",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29216",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29217",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29220",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29221",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29222",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29223",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29226",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29227",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29228",
    "uf": "ES",
    "codigoIbge": 3202405,
    "cidade": "Guarapari"
  },
  {
    "prefixo": "29230",
    "uf": "ES",
    "codigoIbge": 3200409,
    "cidade": "Anchieta"
  },
  {
    "prefixo": "29236",
    "uf": "ES",
    "codigoIbge": 3200409,
    "cidade": "Anchieta"
  },
  {
    "prefixo": "29238",
    "uf": "ES",
    "codigoIbge": 3200409,
    "cidade": "Anchieta"
  },
  {
    "prefixo": "29240",
    "uf": "ES",
    "codigoIbge": 3200300,
    "cidade": "Alfredo Chaves"
  },
  {
    "prefixo": "29242",
    "uf": "ES",
    "codigoIbge": 3200300,
    "cidade": "Alfredo Chaves"
  },
  {
    "prefixo": "29244",
    "uf": "ES",
    "codigoIbge": 3200300,
    "cidade": "Alfredo Chaves"
  },
  {
    "prefixo": "29250",
    "uf": "ES",
    "codigoIbge": 3200300,
    "cidade": "Alfredo Chaves"
  },
  {
    "prefixo": "29255",
    "uf": "ES",
    "codigoIbge": 3203346,
    "cidade": "Marechal Floriano"
  },
  {
    "prefixo": "29258",
    "uf": "ES",
    "codigoIbge": 3203346,
    "cidade": "Marechal Floriano"
  },
  {
    "prefixo": "29259",
    "uf": "ES",
    "codigoIbge": 3203346,
    "cidade": "Marechal Floriano"
  },
  {
    "prefixo": "29260",
    "uf": "ES",
    "codigoIbge": 3201902,
    "cidade": "Domingos Martins"
  },
  {
    "prefixo": "29263",
    "uf": "ES",
    "codigoIbge": 3201902,
    "cidade": "Domingos Martins"
  },
  {
    "prefixo": "29273",
    "uf": "ES",
    "codigoIbge": 3201902,
    "cidade": "Domingos Martins"
  },
  {
    "prefixo": "29276",
    "uf": "ES",
    "codigoIbge": 3201902,
    "cidade": "Domingos Martins"
  },
  {
    "prefixo": "29278",
    "uf": "ES",
    "codigoIbge": 3201902,
    "cidade": "Domingos Martins"
  },
  {
    "prefixo": "29280",
    "uf": "ES",
    "codigoIbge": 3202603,
    "cidade": "Iconha"
  },
  {
    "prefixo": "29283",
    "uf": "ES",
    "codigoIbge": 3202603,
    "cidade": "Iconha"
  },
  {
    "prefixo": "29285",
    "uf": "ES",
    "codigoIbge": 3204203,
    "cidade": "Piúma"
  },
  {
    "prefixo": "29287",
    "uf": "ES",
    "codigoIbge": 3204203,
    "cidade": "Piúma"
  },
  {
    "prefixo": "29290",
    "uf": "ES",
    "codigoIbge": 3204401,
    "cidade": "Rio Novo do Sul"
  },
  {
    "prefixo": "29295",
    "uf": "ES",
    "codigoIbge": 3205036,
    "cidade": "Vargem Alta"
  },
  {
    "prefixo": "29296",
    "uf": "ES",
    "codigoIbge": 3205036,
    "cidade": "Vargem Alta"
  },
  {
    "prefixo": "29297",
    "uf": "ES",
    "codigoIbge": 3205036,
    "cidade": "Vargem Alta"
  },
  {
    "prefixo": "29298",
    "uf": "ES",
    "codigoIbge": 3205036,
    "cidade": "Vargem Alta"
  },
  {
    "prefixo": "29299",
    "uf": "ES",
    "codigoIbge": 3205036,
    "cidade": "Vargem Alta"
  },
  {
    "prefixo": "29300",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29301",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29302",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29303",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29304",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29305",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29306",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29307",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29308",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29309",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29310",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29311",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29312",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29313",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29314",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29315",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29316",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29317",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29320",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29321",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29322",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29323",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29324",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29325",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29326",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29327",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29328",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29329",
    "uf": "ES",
    "codigoIbge": 3201209,
    "cidade": "Cachoeiro de Itapemirim"
  },
  {
    "prefixo": "29330",
    "uf": "ES",
    "codigoIbge": 3202801,
    "cidade": "Itapemirim"
  },
  {
    "prefixo": "29335",
    "uf": "ES",
    "codigoIbge": 3202801,
    "cidade": "Itapemirim"
  },
  {
    "prefixo": "29338",
    "uf": "ES",
    "codigoIbge": 3202801,
    "cidade": "Itapemirim"
  },
  {
    "prefixo": "29340",
    "uf": "ES",
    "codigoIbge": 3202801,
    "cidade": "Itapemirim"
  },
  {
    "prefixo": "29345",
    "uf": "ES",
    "codigoIbge": 3203320,
    "cidade": "Marataízes"
  },
  {
    "prefixo": "29349",
    "uf": "ES",
    "codigoIbge": 3203320,
    "cidade": "Marataízes"
  },
  {
    "prefixo": "29350",
    "uf": "ES",
    "codigoIbge": 3204302,
    "cidade": "Presidente Kennedy"
  },
  {
    "prefixo": "29360",
    "uf": "ES",
    "codigoIbge": 3201407,
    "cidade": "Castelo"
  },
  {
    "prefixo": "29365",
    "uf": "ES",
    "codigoIbge": 3201407,
    "cidade": "Castelo"
  },
  {
    "prefixo": "29367",
    "uf": "ES",
    "codigoIbge": 3201407,
    "cidade": "Castelo"
  },
  {
    "prefixo": "29368",
    "uf": "ES",
    "codigoIbge": 3201407,
    "cidade": "Castelo"
  },
  {
    "prefixo": "29369",
    "uf": "ES",
    "codigoIbge": 3201407,
    "cidade": "Castelo"
  },
  {
    "prefixo": "29370",
    "uf": "ES",
    "codigoIbge": 3201704,
    "cidade": "Conceição do Castelo"
  },
  {
    "prefixo": "29375",
    "uf": "ES",
    "codigoIbge": 3205069,
    "cidade": "Venda Nova do Imigrante"
  },
  {
    "prefixo": "29378",
    "uf": "ES",
    "codigoIbge": 3205069,
    "cidade": "Venda Nova do Imigrante"
  },
  {
    "prefixo": "29380",
    "uf": "ES",
    "codigoIbge": 3203700,
    "cidade": "Muniz Freire"
  },
  {
    "prefixo": "29383",
    "uf": "ES",
    "codigoIbge": 3203700,
    "cidade": "Muniz Freire"
  },
  {
    "prefixo": "29384",
    "uf": "ES",
    "codigoIbge": 3203700,
    "cidade": "Muniz Freire"
  },
  {
    "prefixo": "29386",
    "uf": "ES",
    "codigoIbge": 3203700,
    "cidade": "Muniz Freire"
  },
  {
    "prefixo": "29388",
    "uf": "ES",
    "codigoIbge": 3203700,
    "cidade": "Muniz Freire"
  },
  {
    "prefixo": "29389",
    "uf": "ES",
    "codigoIbge": 3203700,
    "cidade": "Muniz Freire"
  },
  {
    "prefixo": "29390",
    "uf": "ES",
    "codigoIbge": 3203007,
    "cidade": "Iúna"
  },
  {
    "prefixo": "29392",
    "uf": "ES",
    "codigoIbge": 3203007,
    "cidade": "Iúna"
  },
  {
    "prefixo": "29393",
    "uf": "ES",
    "codigoIbge": 3203007,
    "cidade": "Iúna"
  },
  {
    "prefixo": "29394",
    "uf": "ES",
    "codigoIbge": 3203007,
    "cidade": "Iúna"
  },
  {
    "prefixo": "29395",
    "uf": "ES",
    "codigoIbge": 3202454,
    "cidade": "Ibatiba"
  },
  {
    "prefixo": "29398",
    "uf": "ES",
    "codigoIbge": 3202652,
    "cidade": "Irupi"
  },
  {
    "prefixo": "29399",
    "uf": "ES",
    "codigoIbge": 3202652,
    "cidade": "Irupi"
  },
  {
    "prefixo": "29400",
    "uf": "ES",
    "codigoIbge": 3203403,
    "cidade": "Mimoso do Sul"
  },
  {
    "prefixo": "29405",
    "uf": "ES",
    "codigoIbge": 3203403,
    "cidade": "Mimoso do Sul"
  },
  {
    "prefixo": "29410",
    "uf": "ES",
    "codigoIbge": 3203403,
    "cidade": "Mimoso do Sul"
  },
  {
    "prefixo": "29440",
    "uf": "ES",
    "codigoIbge": 3203403,
    "cidade": "Mimoso do Sul"
  },
  {
    "prefixo": "29450",
    "uf": "ES",
    "codigoIbge": 3200508,
    "cidade": "Apiacá"
  },
  {
    "prefixo": "29455",
    "uf": "ES",
    "codigoIbge": 3200508,
    "cidade": "Apiacá"
  },
  {
    "prefixo": "29458",
    "uf": "ES",
    "codigoIbge": 3200508,
    "cidade": "Apiacá"
  },
  {
    "prefixo": "29460",
    "uf": "ES",
    "codigoIbge": 3201100,
    "cidade": "Bom Jesus do Norte"
  },
  {
    "prefixo": "29470",
    "uf": "ES",
    "codigoIbge": 3204807,
    "cidade": "São José do Calçado"
  },
  {
    "prefixo": "29475",
    "uf": "ES",
    "codigoIbge": 3204807,
    "cidade": "São José do Calçado"
  },
  {
    "prefixo": "29477",
    "uf": "ES",
    "codigoIbge": 3204807,
    "cidade": "São José do Calçado"
  },
  {
    "prefixo": "29479",
    "uf": "ES",
    "codigoIbge": 3204807,
    "cidade": "São José do Calçado"
  },
  {
    "prefixo": "29480",
    "uf": "ES",
    "codigoIbge": 3203809,
    "cidade": "Muqui"
  },
  {
    "prefixo": "29485",
    "uf": "ES",
    "codigoIbge": 3203809,
    "cidade": "Muqui"
  },
  {
    "prefixo": "29490",
    "uf": "ES",
    "codigoIbge": 3200706,
    "cidade": "Atílio Vivácqua"
  },
  {
    "prefixo": "29500",
    "uf": "ES",
    "codigoIbge": 3200201,
    "cidade": "Alegre"
  },
  {
    "prefixo": "29510",
    "uf": "ES",
    "codigoIbge": 3200201,
    "cidade": "Alegre"
  },
  {
    "prefixo": "29515",
    "uf": "ES",
    "codigoIbge": 3200201,
    "cidade": "Alegre"
  },
  {
    "prefixo": "29520",
    "uf": "ES",
    "codigoIbge": 3200201,
    "cidade": "Alegre"
  },
  {
    "prefixo": "29525",
    "uf": "ES",
    "codigoIbge": 3200201,
    "cidade": "Alegre"
  },
  {
    "prefixo": "29530",
    "uf": "ES",
    "codigoIbge": 3200201,
    "cidade": "Alegre"
  },
  {
    "prefixo": "29535",
    "uf": "ES",
    "codigoIbge": 3200201,
    "cidade": "Alegre"
  },
  {
    "prefixo": "29540",
    "uf": "ES",
    "codigoIbge": 3202553,
    "cidade": "Ibitirama"
  },
  {
    "prefixo": "29545",
    "uf": "ES",
    "codigoIbge": 3202553,
    "cidade": "Ibitirama"
  },
  {
    "prefixo": "29550",
    "uf": "ES",
    "codigoIbge": 3203106,
    "cidade": "Jerônimo Monteiro"
  },
  {
    "prefixo": "29560",
    "uf": "ES",
    "codigoIbge": 3202306,
    "cidade": "Guaçuí"
  },
  {
    "prefixo": "29562",
    "uf": "ES",
    "codigoIbge": 3202306,
    "cidade": "Guaçuí"
  },
  {
    "prefixo": "29563",
    "uf": "ES",
    "codigoIbge": 3202306,
    "cidade": "Guaçuí"
  },
  {
    "prefixo": "29564",
    "uf": "ES",
    "codigoIbge": 3202306,
    "cidade": "Guaçuí"
  },
  {
    "prefixo": "29580",
    "uf": "ES",
    "codigoIbge": 3202009,
    "cidade": "Dores do Rio Preto"
  },
  {
    "prefixo": "29585",
    "uf": "ES",
    "codigoIbge": 3202009,
    "cidade": "Dores do Rio Preto"
  },
  {
    "prefixo": "29588",
    "uf": "ES",
    "codigoIbge": 3202009,
    "cidade": "Dores do Rio Preto"
  },
  {
    "prefixo": "29590",
    "uf": "ES",
    "codigoIbge": 3201803,
    "cidade": "Divino de São Lourenço"
  },
  {
    "prefixo": "29600",
    "uf": "ES",
    "codigoIbge": 3200102,
    "cidade": "Afonso Cláudio"
  },
  {
    "prefixo": "29603",
    "uf": "ES",
    "codigoIbge": 3200102,
    "cidade": "Afonso Cláudio"
  },
  {
    "prefixo": "29604",
    "uf": "ES",
    "codigoIbge": 3200102,
    "cidade": "Afonso Cláudio"
  },
  {
    "prefixo": "29607",
    "uf": "ES",
    "codigoIbge": 3200102,
    "cidade": "Afonso Cláudio"
  },
  {
    "prefixo": "29609",
    "uf": "ES",
    "codigoIbge": 3200102,
    "cidade": "Afonso Cláudio"
  },
  {
    "prefixo": "29613",
    "uf": "ES",
    "codigoIbge": 3200102,
    "cidade": "Afonso Cláudio"
  },
  {
    "prefixo": "29615",
    "uf": "ES",
    "codigoIbge": 3203163,
    "cidade": "Laranja da Terra"
  },
  {
    "prefixo": "29616",
    "uf": "ES",
    "codigoIbge": 3203163,
    "cidade": "Laranja da Terra"
  },
  {
    "prefixo": "29617",
    "uf": "ES",
    "codigoIbge": 3203163,
    "cidade": "Laranja da Terra"
  },
  {
    "prefixo": "29619",
    "uf": "ES",
    "codigoIbge": 3203163,
    "cidade": "Laranja da Terra"
  },
  {
    "prefixo": "29620",
    "uf": "ES",
    "codigoIbge": 3202900,
    "cidade": "Itarana"
  },
  {
    "prefixo": "29630",
    "uf": "ES",
    "codigoIbge": 3201159,
    "cidade": "Brejetuba"
  },
  {
    "prefixo": "29635",
    "uf": "ES",
    "codigoIbge": 3201159,
    "cidade": "Brejetuba"
  },
  {
    "prefixo": "29640",
    "uf": "ES",
    "codigoIbge": 3204500,
    "cidade": "Santa Leopoldina"
  },
  {
    "prefixo": "29642",
    "uf": "ES",
    "codigoIbge": 3204500,
    "cidade": "Santa Leopoldina"
  },
  {
    "prefixo": "29644",
    "uf": "ES",
    "codigoIbge": 3204500,
    "cidade": "Santa Leopoldina"
  },
  {
    "prefixo": "29645",
    "uf": "ES",
    "codigoIbge": 3204559,
    "cidade": "Santa Maria de Jetibá"
  },
  {
    "prefixo": "29649",
    "uf": "ES",
    "codigoIbge": 3204559,
    "cidade": "Santa Maria de Jetibá"
  },
  {
    "prefixo": "29650",
    "uf": "ES",
    "codigoIbge": 3204609,
    "cidade": "Santa Teresa"
  },
  {
    "prefixo": "29652",
    "uf": "ES",
    "codigoIbge": 3204609,
    "cidade": "Santa Teresa"
  },
  {
    "prefixo": "29654",
    "uf": "ES",
    "codigoIbge": 3204609,
    "cidade": "Santa Teresa"
  },
  {
    "prefixo": "29656",
    "uf": "ES",
    "codigoIbge": 3204609,
    "cidade": "Santa Teresa"
  },
  {
    "prefixo": "29660",
    "uf": "ES",
    "codigoIbge": 3204609,
    "cidade": "Santa Teresa"
  },
  {
    "prefixo": "29665",
    "uf": "ES",
    "codigoIbge": 3204955,
    "cidade": "São Roque do Canaã"
  },
  {
    "prefixo": "29667",
    "uf": "ES",
    "codigoIbge": 3204955,
    "cidade": "São Roque do Canaã"
  },
  {
    "prefixo": "29669",
    "uf": "ES",
    "codigoIbge": 3204955,
    "cidade": "São Roque do Canaã"
  },
  {
    "prefixo": "29670",
    "uf": "ES",
    "codigoIbge": 3202504,
    "cidade": "Ibiraçu"
  },
  {
    "prefixo": "29675",
    "uf": "ES",
    "codigoIbge": 3202504,
    "cidade": "Ibiraçu"
  },
  {
    "prefixo": "29680",
    "uf": "ES",
    "codigoIbge": 3203130,
    "cidade": "João Neiva"
  },
  {
    "prefixo": "29687",
    "uf": "ES",
    "codigoIbge": 3203130,
    "cidade": "João Neiva"
  },
  {
    "prefixo": "29690",
    "uf": "ES",
    "codigoIbge": 3202702,
    "cidade": "Itaguaçu"
  },
  {
    "prefixo": "29695",
    "uf": "ES",
    "codigoIbge": 3202702,
    "cidade": "Itaguaçu"
  },
  {
    "prefixo": "29697",
    "uf": "ES",
    "codigoIbge": 3202702,
    "cidade": "Itaguaçu"
  },
  {
    "prefixo": "29699",
    "uf": "ES",
    "codigoIbge": 3202702,
    "cidade": "Itaguaçu"
  },
  {
    "prefixo": "29700",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29701",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29702",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29703",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29704",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29705",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29706",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29707",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29708",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29709",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29712",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29714",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29715",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29716",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29717",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29718",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29719",
    "uf": "ES",
    "codigoIbge": 3201506,
    "cidade": "Colatina"
  },
  {
    "prefixo": "29720",
    "uf": "ES",
    "codigoIbge": 3202256,
    "cidade": "Governador Lindenberg"
  },
  {
    "prefixo": "29723",
    "uf": "ES",
    "codigoIbge": 3202256,
    "cidade": "Governador Lindenberg"
  },
  {
    "prefixo": "29724",
    "uf": "ES",
    "codigoIbge": 3202256,
    "cidade": "Governador Lindenberg"
  },
  {
    "prefixo": "29725",
    "uf": "ES",
    "codigoIbge": 3203353,
    "cidade": "Marilândia"
  },
  {
    "prefixo": "29728",
    "uf": "ES",
    "codigoIbge": 3203353,
    "cidade": "Marilândia"
  },
  {
    "prefixo": "29730",
    "uf": "ES",
    "codigoIbge": 3200805,
    "cidade": "Baixo Guandu"
  },
  {
    "prefixo": "29735",
    "uf": "ES",
    "codigoIbge": 3200805,
    "cidade": "Baixo Guandu"
  },
  {
    "prefixo": "29737",
    "uf": "ES",
    "codigoIbge": 3200805,
    "cidade": "Baixo Guandu"
  },
  {
    "prefixo": "29740",
    "uf": "ES",
    "codigoIbge": 3200805,
    "cidade": "Baixo Guandu"
  },
  {
    "prefixo": "29745",
    "uf": "ES",
    "codigoIbge": 3204658,
    "cidade": "São Domingos do Norte"
  },
  {
    "prefixo": "29750",
    "uf": "ES",
    "codigoIbge": 3204005,
    "cidade": "Pancas"
  },
  {
    "prefixo": "29752",
    "uf": "ES",
    "codigoIbge": 3204005,
    "cidade": "Pancas"
  },
  {
    "prefixo": "29755",
    "uf": "ES",
    "codigoIbge": 3204005,
    "cidade": "Pancas"
  },
  {
    "prefixo": "29760",
    "uf": "ES",
    "codigoIbge": 3200359,
    "cidade": "Alto Rio Novo"
  },
  {
    "prefixo": "29764",
    "uf": "ES",
    "codigoIbge": 3200359,
    "cidade": "Alto Rio Novo"
  },
  {
    "prefixo": "29767",
    "uf": "ES",
    "codigoIbge": 3200359,
    "cidade": "Alto Rio Novo"
  },
  {
    "prefixo": "29770",
    "uf": "ES",
    "codigoIbge": 3203304,
    "cidade": "Mantenópolis"
  },
  {
    "prefixo": "29772",
    "uf": "ES",
    "codigoIbge": 3203304,
    "cidade": "Mantenópolis"
  },
  {
    "prefixo": "29780",
    "uf": "ES",
    "codigoIbge": 3204708,
    "cidade": "São Gabriel da Palha"
  },
  {
    "prefixo": "29783",
    "uf": "ES",
    "codigoIbge": 3204708,
    "cidade": "São Gabriel da Palha"
  },
  {
    "prefixo": "29785",
    "uf": "ES",
    "codigoIbge": 3205176,
    "cidade": "Vila Valério"
  },
  {
    "prefixo": "29790",
    "uf": "ES",
    "codigoIbge": 3205176,
    "cidade": "Vila Valério"
  },
  {
    "prefixo": "29793",
    "uf": "ES",
    "codigoIbge": 3205176,
    "cidade": "Vila Valério"
  },
  {
    "prefixo": "29795",
    "uf": "ES",
    "codigoIbge": 3200136,
    "cidade": "Águia Branca"
  },
  {
    "prefixo": "29800",
    "uf": "ES",
    "codigoIbge": 3200904,
    "cidade": "Barra de São Francisco"
  },
  {
    "prefixo": "29805",
    "uf": "ES",
    "codigoIbge": 3200904,
    "cidade": "Barra de São Francisco"
  },
  {
    "prefixo": "29807",
    "uf": "ES",
    "codigoIbge": 3200904,
    "cidade": "Barra de São Francisco"
  },
  {
    "prefixo": "29810",
    "uf": "ES",
    "codigoIbge": 3200904,
    "cidade": "Barra de São Francisco"
  },
  {
    "prefixo": "29812",
    "uf": "ES",
    "codigoIbge": 3200904,
    "cidade": "Barra de São Francisco"
  },
  {
    "prefixo": "29815",
    "uf": "ES",
    "codigoIbge": 3200904,
    "cidade": "Barra de São Francisco"
  },
  {
    "prefixo": "29820",
    "uf": "ES",
    "codigoIbge": 3200169,
    "cidade": "Água Doce do Norte"
  },
  {
    "prefixo": "29822",
    "uf": "ES",
    "codigoIbge": 3200169,
    "cidade": "Água Doce do Norte"
  },
  {
    "prefixo": "29823",
    "uf": "ES",
    "codigoIbge": 3200169,
    "cidade": "Água Doce do Norte"
  },
  {
    "prefixo": "29824",
    "uf": "ES",
    "codigoIbge": 3200169,
    "cidade": "Água Doce do Norte"
  },
  {
    "prefixo": "29826",
    "uf": "ES",
    "codigoIbge": 3200169,
    "cidade": "Água Doce do Norte"
  },
  {
    "prefixo": "29830",
    "uf": "ES",
    "codigoIbge": 3203908,
    "cidade": "Nova Venécia"
  },
  {
    "prefixo": "29839",
    "uf": "ES",
    "codigoIbge": 3203908,
    "cidade": "Nova Venécia"
  },
  {
    "prefixo": "29841",
    "uf": "ES",
    "codigoIbge": 3203908,
    "cidade": "Nova Venécia"
  },
  {
    "prefixo": "29842",
    "uf": "ES",
    "codigoIbge": 3203908,
    "cidade": "Nova Venécia"
  },
  {
    "prefixo": "29843",
    "uf": "ES",
    "codigoIbge": 3205150,
    "cidade": "Vila Pavão"
  },
  {
    "prefixo": "29845",
    "uf": "ES",
    "codigoIbge": 3201001,
    "cidade": "Boa Esperança"
  },
  {
    "prefixo": "29847",
    "uf": "ES",
    "codigoIbge": 3201001,
    "cidade": "Boa Esperança"
  },
  {
    "prefixo": "29848",
    "uf": "ES",
    "codigoIbge": 3201001,
    "cidade": "Boa Esperança"
  },
  {
    "prefixo": "29850",
    "uf": "ES",
    "codigoIbge": 3202108,
    "cidade": "Ecoporanga"
  },
  {
    "prefixo": "29853",
    "uf": "ES",
    "codigoIbge": 3202108,
    "cidade": "Ecoporanga"
  },
  {
    "prefixo": "29855",
    "uf": "ES",
    "codigoIbge": 3202108,
    "cidade": "Ecoporanga"
  },
  {
    "prefixo": "29856",
    "uf": "ES",
    "codigoIbge": 3202108,
    "cidade": "Ecoporanga"
  },
  {
    "prefixo": "29860",
    "uf": "ES",
    "codigoIbge": 3202108,
    "cidade": "Ecoporanga"
  },
  {
    "prefixo": "29875",
    "uf": "ES",
    "codigoIbge": 3202108,
    "cidade": "Ecoporanga"
  },
  {
    "prefixo": "29880",
    "uf": "ES",
    "codigoIbge": 3203601,
    "cidade": "Mucurici"
  },
  {
    "prefixo": "29884",
    "uf": "ES",
    "codigoIbge": 3203601,
    "cidade": "Mucurici"
  },
  {
    "prefixo": "29885",
    "uf": "ES",
    "codigoIbge": 3204252,
    "cidade": "Ponto Belo"
  },
  {
    "prefixo": "29889",
    "uf": "ES",
    "codigoIbge": 3204252,
    "cidade": "Ponto Belo"
  },
  {
    "prefixo": "29890",
    "uf": "ES",
    "codigoIbge": 3203502,
    "cidade": "Montanha"
  },
  {
    "prefixo": "29894",
    "uf": "ES",
    "codigoIbge": 3203502,
    "cidade": "Montanha"
  },
  {
    "prefixo": "29900",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29901",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29902",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29903",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29904",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29905",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29906",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29907",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29908",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29909",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29911",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29913",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29914",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29916",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29918",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29919",
    "uf": "ES",
    "codigoIbge": 3203205,
    "cidade": "Linhares"
  },
  {
    "prefixo": "29920",
    "uf": "ES",
    "codigoIbge": 3204351,
    "cidade": "Rio Bananal"
  },
  {
    "prefixo": "29925",
    "uf": "ES",
    "codigoIbge": 3204351,
    "cidade": "Rio Bananal"
  },
  {
    "prefixo": "29927",
    "uf": "ES",
    "codigoIbge": 3205010,
    "cidade": "Sooretama"
  },
  {
    "prefixo": "29930",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29931",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29932",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29933",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29934",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29936",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29937",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29938",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29940",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29941",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29942",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29943",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29944",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29945",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29946",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29947",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29948",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29949",
    "uf": "ES",
    "codigoIbge": 3204906,
    "cidade": "São Mateus"
  },
  {
    "prefixo": "29950",
    "uf": "ES",
    "codigoIbge": 3203056,
    "cidade": "Jaguaré"
  },
  {
    "prefixo": "29954",
    "uf": "ES",
    "codigoIbge": 3203056,
    "cidade": "Jaguaré"
  },
  {
    "prefixo": "29957",
    "uf": "ES",
    "codigoIbge": 3203056,
    "cidade": "Jaguaré"
  },
  {
    "prefixo": "29960",
    "uf": "ES",
    "codigoIbge": 3201605,
    "cidade": "Conceição da Barra"
  },
  {
    "prefixo": "29965",
    "uf": "ES",
    "codigoIbge": 3201605,
    "cidade": "Conceição da Barra"
  },
  {
    "prefixo": "29967",
    "uf": "ES",
    "codigoIbge": 3201605,
    "cidade": "Conceição da Barra"
  },
  {
    "prefixo": "29970",
    "uf": "ES",
    "codigoIbge": 3204054,
    "cidade": "Pedro Canário"
  },
  {
    "prefixo": "29978",
    "uf": "ES",
    "codigoIbge": 3204054,
    "cidade": "Pedro Canário"
  },
  {
    "prefixo": "29980",
    "uf": "ES",
    "codigoIbge": 3204104,
    "cidade": "Pinheiros"
  },
  {
    "prefixo": "29985",
    "uf": "ES",
    "codigoIbge": 3204104,
    "cidade": "Pinheiros"
  },
  {
    "prefixo": "30100",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30110",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30111",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30112",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30120",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30130",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30140",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30150",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30160",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30170",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30180",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30190",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30210",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30220",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30230",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30240",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30250",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30260",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30270",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30280",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30285",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30286",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30290",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30295",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30310",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30315",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30320",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30330",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30335",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30350",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30360",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30380",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30390",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30410",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30411",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30421",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30431",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30440",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30441",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30450",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30451",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30455",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30480",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30490",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30492",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30493",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30494",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30510",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30512",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30514",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30516",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30518",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30520",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30521",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30525",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30530",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30532",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30535",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30550",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30555",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30570",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30575",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30580",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30590",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30610",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30620",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30622",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30624",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30626",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30627",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30628",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30640",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30642",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30644",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30660",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30662",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30664",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30666",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30668",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30670",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30671",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30672",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30673",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30690",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30692",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30710",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30720",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30730",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30750",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30760",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30770",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30775",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30810",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30820",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30830",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30840",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30850",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30855",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30860",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30865",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30870",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30880",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30881",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "30882",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31010",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31015",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31030",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31035",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31050",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31060",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31070",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31080",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31110",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31130",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31140",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31150",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31155",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31160",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31170",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31210",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31230",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31235",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31250",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31255",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31260",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31270",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31275",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31310",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31317",
    "uf": "SP",
    "codigoIbge": 3508405,
    "cidade": "Cabreúva"
  },
  {
    "prefixo": "31320",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31330",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31340",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31360",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31365",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31370",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31510",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31515",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31520",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31525",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31530",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31535",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31540",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31545",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31550",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31555",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31560",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31565",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31570",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31573",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31575",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31578",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31580",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31585",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31610",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31615",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31620",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31630",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31640",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31650",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31652",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31655",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31660",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31680",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31710",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31720",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31730",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31741",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31742",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31744",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31746",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31748",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31749",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31775",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31810",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31812",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31814",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31840",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31842",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31844",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31845",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31846",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31870",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31872",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31873",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31910",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31920",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31930",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31950",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31960",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31970",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31974",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31975",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31980",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31985",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31990",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31995",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31998",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "31999",
    "uf": "MG",
    "codigoIbge": 3106200,
    "cidade": "Belo Horizonte"
  },
  {
    "prefixo": "32000",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32010",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32013",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32015",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32016",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32017",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32020",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32025",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32040",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32041",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32042",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32043",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32044",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32046",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32050",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32051",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32052",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32055",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32056",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32060",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32062",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32064",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32065",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32070",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32071",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32072",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32073",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32110",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32113",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32115",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32140",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32141",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32143",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32145",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32146",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32150",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32152",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32180",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32181",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32183",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32184",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32185",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32186",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32187",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32210",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32215",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32220",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32223",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32230",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32235",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32240",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32241",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32242",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32250",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32260",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32265",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32280",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32285",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32310",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32315",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32340",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32341",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32342",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32370",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32371",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32372",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32399",
    "uf": "MG",
    "codigoIbge": 3118601,
    "cidade": "Contagem"
  },
  {
    "prefixo": "32400",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32404",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32405",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32407",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32410",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32412",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32415",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32417",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32419",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32420",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32421",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32422",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32423",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32424",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32425",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32430",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32431",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32432",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32433",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32439",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32440",
    "uf": "MG",
    "codigoIbge": 3129806,
    "cidade": "Ibirité"
  },
  {
    "prefixo": "32450",
    "uf": "MG",
    "codigoIbge": 3165537,
    "cidade": "Sarzedo"
  },
  {
    "prefixo": "32470",
    "uf": "MG",
    "codigoIbge": 3140159,
    "cidade": "Mário Campos"
  },
  {
    "prefixo": "32480",
    "uf": "MG",
    "codigoIbge": 3109006,
    "cidade": "Brumadinho"
  },
  {
    "prefixo": "32481",
    "uf": "MG",
    "codigoIbge": 3109006,
    "cidade": "Brumadinho"
  },
  {
    "prefixo": "32482",
    "uf": "MG",
    "codigoIbge": 3109006,
    "cidade": "Brumadinho"
  },
  {
    "prefixo": "32483",
    "uf": "MG",
    "codigoIbge": 3109006,
    "cidade": "Brumadinho"
  },
  {
    "prefixo": "32486",
    "uf": "MG",
    "codigoIbge": 3109006,
    "cidade": "Brumadinho"
  },
  {
    "prefixo": "32488",
    "uf": "MG",
    "codigoIbge": 3109006,
    "cidade": "Brumadinho"
  },
  {
    "prefixo": "32490",
    "uf": "MG",
    "codigoIbge": 3109006,
    "cidade": "Brumadinho"
  },
  {
    "prefixo": "32493",
    "uf": "MG",
    "codigoIbge": 3109006,
    "cidade": "Brumadinho"
  },
  {
    "prefixo": "32497",
    "uf": "MG",
    "codigoIbge": 3109006,
    "cidade": "Brumadinho"
  },
  {
    "prefixo": "32499",
    "uf": "MG",
    "codigoIbge": 3109006,
    "cidade": "Brumadinho"
  },
  {
    "prefixo": "32600",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32601",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32602",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32603",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32604",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32605",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32606",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32607",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32609",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32611",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32616",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32618",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32621",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32623",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32625",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32627",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32628",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32631",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32633",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32634",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32635",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32636",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32639",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32640",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32641",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32642",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32649",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32653",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32654",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32655",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32656",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32657",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32659",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32661",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32665",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32667",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32668",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32669",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32670",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32671",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32672",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32673",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32675",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32676",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32677",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32678",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32681",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32684",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32685",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32687",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32689",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32699",
    "uf": "MG",
    "codigoIbge": 3106705,
    "cidade": "Betim"
  },
  {
    "prefixo": "32800",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32802",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32803",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32806",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32807",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32808",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32809",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32810",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32811",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32812",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32813",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32816",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32817",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32818",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32819",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32820",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32824",
    "uf": "MG",
    "codigoIbge": 3124104,
    "cidade": "Esmeraldas"
  },
  {
    "prefixo": "32900",
    "uf": "MG",
    "codigoIbge": 3130101,
    "cidade": "Igarapé"
  },
  {
    "prefixo": "32920",
    "uf": "MG",
    "codigoIbge": 3162922,
    "cidade": "São Joaquim de Bicas"
  },
  {
    "prefixo": "33000",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33010",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33015",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33016",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33020",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33022",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33025",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33026",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33030",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33031",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33035",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33036",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33040",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33042",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33045",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33050",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33054",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33055",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33060",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33065",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33080",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33082",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33084",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33105",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33110",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33113",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33115",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33120",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33125",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33130",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33140",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33141",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33145",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33146",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33147",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33170",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33171",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33172",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33199",
    "uf": "MG",
    "codigoIbge": 3157807,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "33200",
    "uf": "MG",
    "codigoIbge": 3171204,
    "cidade": "Vespasiano"
  },
  {
    "prefixo": "33201",
    "uf": "MG",
    "codigoIbge": 3171204,
    "cidade": "Vespasiano"
  },
  {
    "prefixo": "33202",
    "uf": "MG",
    "codigoIbge": 3171204,
    "cidade": "Vespasiano"
  },
  {
    "prefixo": "33203",
    "uf": "MG",
    "codigoIbge": 3171204,
    "cidade": "Vespasiano"
  },
  {
    "prefixo": "33204",
    "uf": "MG",
    "codigoIbge": 3171204,
    "cidade": "Vespasiano"
  },
  {
    "prefixo": "33205",
    "uf": "MG",
    "codigoIbge": 3171204,
    "cidade": "Vespasiano"
  },
  {
    "prefixo": "33206",
    "uf": "MG",
    "codigoIbge": 3171204,
    "cidade": "Vespasiano"
  },
  {
    "prefixo": "33207",
    "uf": "MG",
    "codigoIbge": 3171204,
    "cidade": "Vespasiano"
  },
  {
    "prefixo": "33230",
    "uf": "MG",
    "codigoIbge": 3137601,
    "cidade": "Lagoa Santa"
  },
  {
    "prefixo": "33231",
    "uf": "MG",
    "codigoIbge": 3137601,
    "cidade": "Lagoa Santa"
  },
  {
    "prefixo": "33232",
    "uf": "MG",
    "codigoIbge": 3137601,
    "cidade": "Lagoa Santa"
  },
  {
    "prefixo": "33233",
    "uf": "MG",
    "codigoIbge": 3137601,
    "cidade": "Lagoa Santa"
  },
  {
    "prefixo": "33234",
    "uf": "MG",
    "codigoIbge": 3137601,
    "cidade": "Lagoa Santa"
  },
  {
    "prefixo": "33236",
    "uf": "MG",
    "codigoIbge": 3137601,
    "cidade": "Lagoa Santa"
  },
  {
    "prefixo": "33237",
    "uf": "MG",
    "codigoIbge": 3137601,
    "cidade": "Lagoa Santa"
  },
  {
    "prefixo": "33239",
    "uf": "MG",
    "codigoIbge": 3137601,
    "cidade": "Lagoa Santa"
  },
  {
    "prefixo": "33240",
    "uf": "MG",
    "codigoIbge": 3137601,
    "cidade": "Lagoa Santa"
  },
  {
    "prefixo": "33241",
    "uf": "MG",
    "codigoIbge": 3137601,
    "cidade": "Lagoa Santa"
  },
  {
    "prefixo": "33242",
    "uf": "MG",
    "codigoIbge": 3137601,
    "cidade": "Lagoa Santa"
  },
  {
    "prefixo": "33246",
    "uf": "MG",
    "codigoIbge": 3137601,
    "cidade": "Lagoa Santa"
  },
  {
    "prefixo": "33250",
    "uf": "MG",
    "codigoIbge": 3149309,
    "cidade": "Pedro Leopoldo"
  },
  {
    "prefixo": "33251",
    "uf": "MG",
    "codigoIbge": 3149309,
    "cidade": "Pedro Leopoldo"
  },
  {
    "prefixo": "33252",
    "uf": "MG",
    "codigoIbge": 3149309,
    "cidade": "Pedro Leopoldo"
  },
  {
    "prefixo": "33253",
    "uf": "MG",
    "codigoIbge": 3149309,
    "cidade": "Pedro Leopoldo"
  },
  {
    "prefixo": "33254",
    "uf": "MG",
    "codigoIbge": 3149309,
    "cidade": "Pedro Leopoldo"
  },
  {
    "prefixo": "33255",
    "uf": "MG",
    "codigoIbge": 3149309,
    "cidade": "Pedro Leopoldo"
  },
  {
    "prefixo": "33256",
    "uf": "MG",
    "codigoIbge": 3149309,
    "cidade": "Pedro Leopoldo"
  },
  {
    "prefixo": "33257",
    "uf": "MG",
    "codigoIbge": 3149309,
    "cidade": "Pedro Leopoldo"
  },
  {
    "prefixo": "33258",
    "uf": "MG",
    "codigoIbge": 3149309,
    "cidade": "Pedro Leopoldo"
  },
  {
    "prefixo": "33350",
    "uf": "MG",
    "codigoIbge": 3162955,
    "cidade": "São José da Lapa"
  },
  {
    "prefixo": "33500",
    "uf": "MG",
    "codigoIbge": 3117876,
    "cidade": "Confins"
  },
  {
    "prefixo": "33800",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33805",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33808",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33809",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33820",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33821",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33822",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33823",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33825",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33826",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33830",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33833",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33836",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33840",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33841",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33855",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33858",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33860",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33861",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33863",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33880",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33882",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33883",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33900",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33902",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33903",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33910",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33913",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33914",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33915",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33920",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33921",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33925",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33927",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33929",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33930",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33933",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33934",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33935",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33936",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33937",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33938",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33939",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33940",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33943",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33944",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33979",
    "uf": "MG",
    "codigoIbge": 3154606,
    "cidade": "Ribeirão das Neves"
  },
  {
    "prefixo": "33980",
    "uf": "MG",
    "codigoIbge": 3168309,
    "cidade": "Taquaraçu de Minas"
  },
  {
    "prefixo": "33999",
    "uf": "MG",
    "codigoIbge": 3168309,
    "cidade": "Taquaraçu de Minas"
  },
  {
    "prefixo": "34000",
    "uf": "MG",
    "codigoIbge": 3144805,
    "cidade": "Nova Lima"
  },
  {
    "prefixo": "34001",
    "uf": "MG",
    "codigoIbge": 3144805,
    "cidade": "Nova Lima"
  },
  {
    "prefixo": "34002",
    "uf": "MG",
    "codigoIbge": 3144805,
    "cidade": "Nova Lima"
  },
  {
    "prefixo": "34003",
    "uf": "MG",
    "codigoIbge": 3144805,
    "cidade": "Nova Lima"
  },
  {
    "prefixo": "34004",
    "uf": "MG",
    "codigoIbge": 3144805,
    "cidade": "Nova Lima"
  },
  {
    "prefixo": "34006",
    "uf": "MG",
    "codigoIbge": 3144805,
    "cidade": "Nova Lima"
  },
  {
    "prefixo": "34007",
    "uf": "MG",
    "codigoIbge": 3144805,
    "cidade": "Nova Lima"
  },
  {
    "prefixo": "34008",
    "uf": "MG",
    "codigoIbge": 3144805,
    "cidade": "Nova Lima"
  },
  {
    "prefixo": "34009",
    "uf": "MG",
    "codigoIbge": 3144805,
    "cidade": "Nova Lima"
  },
  {
    "prefixo": "34010",
    "uf": "MG",
    "codigoIbge": 3144805,
    "cidade": "Nova Lima"
  },
  {
    "prefixo": "34011",
    "uf": "MG",
    "codigoIbge": 3144805,
    "cidade": "Nova Lima"
  },
  {
    "prefixo": "34012",
    "uf": "MG",
    "codigoIbge": 3144805,
    "cidade": "Nova Lima"
  },
  {
    "prefixo": "34015",
    "uf": "MG",
    "codigoIbge": 3144805,
    "cidade": "Nova Lima"
  },
  {
    "prefixo": "34018",
    "uf": "MG",
    "codigoIbge": 3144805,
    "cidade": "Nova Lima"
  },
  {
    "prefixo": "34019",
    "uf": "MG",
    "codigoIbge": 3144805,
    "cidade": "Nova Lima"
  },
  {
    "prefixo": "34300",
    "uf": "MG",
    "codigoIbge": 3154804,
    "cidade": "Rio Acima"
  },
  {
    "prefixo": "34400",
    "uf": "MG",
    "codigoIbge": 3153905,
    "cidade": "Raposos"
  },
  {
    "prefixo": "34500",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34505",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34515",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34516",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34518",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34525",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34535",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34536",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34545",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34555",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34565",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34575",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34576",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34580",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34585",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34589",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34590",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34600",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34650",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34700",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34710",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34712",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34720",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34725",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34730",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34735",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34739",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34750",
    "uf": "MG",
    "codigoIbge": 3156700,
    "cidade": "Sabará"
  },
  {
    "prefixo": "34800",
    "uf": "MG",
    "codigoIbge": 3110004,
    "cidade": "Caeté"
  },
  {
    "prefixo": "34930",
    "uf": "MG",
    "codigoIbge": 3110004,
    "cidade": "Caeté"
  },
  {
    "prefixo": "34940",
    "uf": "MG",
    "codigoIbge": 3110004,
    "cidade": "Caeté"
  },
  {
    "prefixo": "34950",
    "uf": "MG",
    "codigoIbge": 3110004,
    "cidade": "Caeté"
  },
  {
    "prefixo": "34960",
    "uf": "MG",
    "codigoIbge": 3110004,
    "cidade": "Caeté"
  },
  {
    "prefixo": "34990",
    "uf": "MG",
    "codigoIbge": 3136603,
    "cidade": "Nova União"
  },
  {
    "prefixo": "35000",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35001",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35010",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35012",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35020",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35022",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35023",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35024",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35026",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35030",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35032",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35039",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35040",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35041",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35042",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35043",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35044",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35045",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35046",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35047",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35050",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35051",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35052",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35053",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35054",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35055",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35057",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35058",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35059",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35060",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35061",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35062",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35063",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35064",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35065",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35099",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35100",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35101",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35102",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35104",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35105",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35106",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35107",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35108",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35109",
    "uf": "MG",
    "codigoIbge": 3127701,
    "cidade": "Governador Valadares"
  },
  {
    "prefixo": "35110",
    "uf": "MG",
    "codigoIbge": 3171501,
    "cidade": "Mathias Lobato"
  },
  {
    "prefixo": "35112",
    "uf": "MG",
    "codigoIbge": 3126901,
    "cidade": "Frei Inocêncio"
  },
  {
    "prefixo": "35113",
    "uf": "MG",
    "codigoIbge": 3144904,
    "cidade": "Nova Módica"
  },
  {
    "prefixo": "35114",
    "uf": "MG",
    "codigoIbge": 3150000,
    "cidade": "Pescador"
  },
  {
    "prefixo": "35115",
    "uf": "MG",
    "codigoIbge": 3140100,
    "cidade": "Marilac"
  },
  {
    "prefixo": "35116",
    "uf": "MG",
    "codigoIbge": 3141702,
    "cidade": "Mesquita"
  },
  {
    "prefixo": "35117",
    "uf": "MG",
    "codigoIbge": 3144359,
    "cidade": "Naque"
  },
  {
    "prefixo": "35118",
    "uf": "MG",
    "codigoIbge": 3149952,
    "cidade": "Periquito"
  },
  {
    "prefixo": "35119",
    "uf": "MG",
    "codigoIbge": 3149952,
    "cidade": "Periquito"
  },
  {
    "prefixo": "35120",
    "uf": "MG",
    "codigoIbge": 3133204,
    "cidade": "Itanhomi"
  },
  {
    "prefixo": "35122",
    "uf": "MG",
    "codigoIbge": 3133204,
    "cidade": "Itanhomi"
  },
  {
    "prefixo": "35123",
    "uf": "MG",
    "codigoIbge": 3112653,
    "cidade": "Capitão Andrade"
  },
  {
    "prefixo": "35125",
    "uf": "MG",
    "codigoIbge": 3169505,
    "cidade": "Tumiritinga"
  },
  {
    "prefixo": "35126",
    "uf": "MG",
    "codigoIbge": 3169505,
    "cidade": "Tumiritinga"
  },
  {
    "prefixo": "35130",
    "uf": "MG",
    "codigoIbge": 3123700,
    "cidade": "Engenheiro Caldas"
  },
  {
    "prefixo": "35133",
    "uf": "MG",
    "codigoIbge": 3123700,
    "cidade": "Engenheiro Caldas"
  },
  {
    "prefixo": "35135",
    "uf": "MG",
    "codigoIbge": 3125804,
    "cidade": "Fernandes Tourinho"
  },
  {
    "prefixo": "35136",
    "uf": "MG",
    "codigoIbge": 3125804,
    "cidade": "Fernandes Tourinho"
  },
  {
    "prefixo": "35138",
    "uf": "MG",
    "codigoIbge": 3101805,
    "cidade": "Alpercata"
  },
  {
    "prefixo": "35139",
    "uf": "MG",
    "codigoIbge": 3101805,
    "cidade": "Alpercata"
  },
  {
    "prefixo": "35140",
    "uf": "MG",
    "codigoIbge": 3168408,
    "cidade": "Tarumirim"
  },
  {
    "prefixo": "35141",
    "uf": "MG",
    "codigoIbge": 3168408,
    "cidade": "Tarumirim"
  },
  {
    "prefixo": "35142",
    "uf": "MG",
    "codigoIbge": 3168408,
    "cidade": "Tarumirim"
  },
  {
    "prefixo": "35143",
    "uf": "MG",
    "codigoIbge": 3168408,
    "cidade": "Tarumirim"
  },
  {
    "prefixo": "35144",
    "uf": "MG",
    "codigoIbge": 3167707,
    "cidade": "Sobrália"
  },
  {
    "prefixo": "35145",
    "uf": "MG",
    "codigoIbge": 3167707,
    "cidade": "Sobrália"
  },
  {
    "prefixo": "35146",
    "uf": "MG",
    "codigoIbge": 3162609,
    "cidade": "São João do Oriente"
  },
  {
    "prefixo": "35147",
    "uf": "MG",
    "codigoIbge": 3100500,
    "cidade": "Açucena"
  },
  {
    "prefixo": "35148",
    "uf": "MG",
    "codigoIbge": 3122504,
    "cidade": "Dom Cavati"
  },
  {
    "prefixo": "35160",
    "uf": "MG",
    "codigoIbge": 3131307,
    "cidade": "Ipatinga"
  },
  {
    "prefixo": "35161",
    "uf": "MG",
    "codigoIbge": 3131307,
    "cidade": "Ipatinga"
  },
  {
    "prefixo": "35162",
    "uf": "MG",
    "codigoIbge": 3131307,
    "cidade": "Ipatinga"
  },
  {
    "prefixo": "35163",
    "uf": "MG",
    "codigoIbge": 3131307,
    "cidade": "Ipatinga"
  },
  {
    "prefixo": "35164",
    "uf": "MG",
    "codigoIbge": 3131307,
    "cidade": "Ipatinga"
  },
  {
    "prefixo": "35170",
    "uf": "MG",
    "codigoIbge": 3119401,
    "cidade": "Coronel Fabriciano"
  },
  {
    "prefixo": "35171",
    "uf": "MG",
    "codigoIbge": 3119401,
    "cidade": "Coronel Fabriciano"
  },
  {
    "prefixo": "35172",
    "uf": "MG",
    "codigoIbge": 3119401,
    "cidade": "Coronel Fabriciano"
  },
  {
    "prefixo": "35175",
    "uf": "MG",
    "codigoIbge": 3119401,
    "cidade": "Coronel Fabriciano"
  },
  {
    "prefixo": "35176",
    "uf": "MG",
    "codigoIbge": 3119401,
    "cidade": "Coronel Fabriciano"
  },
  {
    "prefixo": "35177",
    "uf": "MG",
    "codigoIbge": 3103009,
    "cidade": "Antônio Dias"
  },
  {
    "prefixo": "35178",
    "uf": "MG",
    "codigoIbge": 3103009,
    "cidade": "Antônio Dias"
  },
  {
    "prefixo": "35179",
    "uf": "MG",
    "codigoIbge": 3158953,
    "cidade": "Santana do Paraíso"
  },
  {
    "prefixo": "35180",
    "uf": "MG",
    "codigoIbge": 3168705,
    "cidade": "Timóteo"
  },
  {
    "prefixo": "35181",
    "uf": "MG",
    "codigoIbge": 3168705,
    "cidade": "Timóteo"
  },
  {
    "prefixo": "35182",
    "uf": "MG",
    "codigoIbge": 3168705,
    "cidade": "Timóteo"
  },
  {
    "prefixo": "35183",
    "uf": "MG",
    "codigoIbge": 3168705,
    "cidade": "Timóteo"
  },
  {
    "prefixo": "35184",
    "uf": "MG",
    "codigoIbge": 3168705,
    "cidade": "Timóteo"
  },
  {
    "prefixo": "35185",
    "uf": "MG",
    "codigoIbge": 3140308,
    "cidade": "Marliéria"
  },
  {
    "prefixo": "35188",
    "uf": "MG",
    "codigoIbge": 3135001,
    "cidade": "Jaguaraçu"
  },
  {
    "prefixo": "35189",
    "uf": "MG",
    "codigoIbge": 3108800,
    "cidade": "Braúnas"
  },
  {
    "prefixo": "35190",
    "uf": "MG",
    "codigoIbge": 3129301,
    "cidade": "Iapu"
  },
  {
    "prefixo": "35192",
    "uf": "MG",
    "codigoIbge": 3129301,
    "cidade": "Iapu"
  },
  {
    "prefixo": "35193",
    "uf": "MG",
    "codigoIbge": 3109253,
    "cidade": "Bugre"
  },
  {
    "prefixo": "35194",
    "uf": "MG",
    "codigoIbge": 3136108,
    "cidade": "Joanésia"
  },
  {
    "prefixo": "35195",
    "uf": "MG",
    "codigoIbge": 3106309,
    "cidade": "Belo Oriente"
  },
  {
    "prefixo": "35196",
    "uf": "MG",
    "codigoIbge": 3106309,
    "cidade": "Belo Oriente"
  },
  {
    "prefixo": "35197",
    "uf": "MG",
    "codigoIbge": 3106309,
    "cidade": "Belo Oriente"
  },
  {
    "prefixo": "35198",
    "uf": "MG",
    "codigoIbge": 3131158,
    "cidade": "Ipaba"
  },
  {
    "prefixo": "35199",
    "uf": "MG",
    "codigoIbge": 3170578,
    "cidade": "Vargem Alegre"
  },
  {
    "prefixo": "35200",
    "uf": "MG",
    "codigoIbge": 3101102,
    "cidade": "Aimorés"
  },
  {
    "prefixo": "35202",
    "uf": "MG",
    "codigoIbge": 3101102,
    "cidade": "Aimorés"
  },
  {
    "prefixo": "35204",
    "uf": "MG",
    "codigoIbge": 3101102,
    "cidade": "Aimorés"
  },
  {
    "prefixo": "35206",
    "uf": "MG",
    "codigoIbge": 3101102,
    "cidade": "Aimorés"
  },
  {
    "prefixo": "35208",
    "uf": "MG",
    "codigoIbge": 3101102,
    "cidade": "Aimorés"
  },
  {
    "prefixo": "35210",
    "uf": "MG",
    "codigoIbge": 3101102,
    "cidade": "Aimorés"
  },
  {
    "prefixo": "35212",
    "uf": "MG",
    "codigoIbge": 3101102,
    "cidade": "Aimorés"
  },
  {
    "prefixo": "35215",
    "uf": "MG",
    "codigoIbge": 3101102,
    "cidade": "Aimorés"
  },
  {
    "prefixo": "35220",
    "uf": "MG",
    "codigoIbge": 3134103,
    "cidade": "Itueta"
  },
  {
    "prefixo": "35222",
    "uf": "MG",
    "codigoIbge": 3134103,
    "cidade": "Itueta"
  },
  {
    "prefixo": "35225",
    "uf": "MG",
    "codigoIbge": 3159506,
    "cidade": "Santa Rita do Itueto"
  },
  {
    "prefixo": "35228",
    "uf": "MG",
    "codigoIbge": 3159506,
    "cidade": "Santa Rita do Itueto"
  },
  {
    "prefixo": "35230",
    "uf": "MG",
    "codigoIbge": 3154309,
    "cidade": "Resplendor"
  },
  {
    "prefixo": "35232",
    "uf": "MG",
    "codigoIbge": 3154309,
    "cidade": "Resplendor"
  },
  {
    "prefixo": "35233",
    "uf": "MG",
    "codigoIbge": 3154309,
    "cidade": "Resplendor"
  },
  {
    "prefixo": "35235",
    "uf": "MG",
    "codigoIbge": 3154309,
    "cidade": "Resplendor"
  },
  {
    "prefixo": "35236",
    "uf": "MG",
    "codigoIbge": 3154309,
    "cidade": "Resplendor"
  },
  {
    "prefixo": "35238",
    "uf": "MG",
    "codigoIbge": 3154309,
    "cidade": "Resplendor"
  },
  {
    "prefixo": "35240",
    "uf": "MG",
    "codigoIbge": 3118403,
    "cidade": "Conselheiro Pena"
  },
  {
    "prefixo": "35241",
    "uf": "MG",
    "codigoIbge": 3118403,
    "cidade": "Conselheiro Pena"
  },
  {
    "prefixo": "35242",
    "uf": "MG",
    "codigoIbge": 3118403,
    "cidade": "Conselheiro Pena"
  },
  {
    "prefixo": "35243",
    "uf": "MG",
    "codigoIbge": 3118403,
    "cidade": "Conselheiro Pena"
  },
  {
    "prefixo": "35244",
    "uf": "MG",
    "codigoIbge": 3118403,
    "cidade": "Conselheiro Pena"
  },
  {
    "prefixo": "35245",
    "uf": "MG",
    "codigoIbge": 3118403,
    "cidade": "Conselheiro Pena"
  },
  {
    "prefixo": "35246",
    "uf": "MG",
    "codigoIbge": 3120839,
    "cidade": "Cuparaque"
  },
  {
    "prefixo": "35247",
    "uf": "MG",
    "codigoIbge": 3120839,
    "cidade": "Cuparaque"
  },
  {
    "prefixo": "35248",
    "uf": "MG",
    "codigoIbge": 3127370,
    "cidade": "Goiabeira"
  },
  {
    "prefixo": "35249",
    "uf": "MG",
    "codigoIbge": 3102209,
    "cidade": "Alvarenga"
  },
  {
    "prefixo": "35250",
    "uf": "MG",
    "codigoIbge": 3127305,
    "cidade": "Galiléia"
  },
  {
    "prefixo": "35255",
    "uf": "MG",
    "codigoIbge": 3127305,
    "cidade": "Galiléia"
  },
  {
    "prefixo": "35258",
    "uf": "MG",
    "codigoIbge": 3161650,
    "cidade": "São Geraldo do Baixio"
  },
  {
    "prefixo": "35260",
    "uf": "MG",
    "codigoIbge": 3115706,
    "cidade": "Central de Minas"
  },
  {
    "prefixo": "35263",
    "uf": "MG",
    "codigoIbge": 3115706,
    "cidade": "Central de Minas"
  },
  {
    "prefixo": "35265",
    "uf": "MG",
    "codigoIbge": 3122108,
    "cidade": "Divino das Laranjeiras"
  },
  {
    "prefixo": "35267",
    "uf": "MG",
    "codigoIbge": 3122108,
    "cidade": "Divino das Laranjeiras"
  },
  {
    "prefixo": "35270",
    "uf": "MG",
    "codigoIbge": 3141504,
    "cidade": "Mendes Pimentel"
  },
  {
    "prefixo": "35275",
    "uf": "MG",
    "codigoIbge": 3161056,
    "cidade": "São Félix de Minas"
  },
  {
    "prefixo": "35277",
    "uf": "MG",
    "codigoIbge": 3162575,
    "cidade": "São João do Manteninha"
  },
  {
    "prefixo": "35280",
    "uf": "MG",
    "codigoIbge": 3131802,
    "cidade": "Itabirinha"
  },
  {
    "prefixo": "35285",
    "uf": "MG",
    "codigoIbge": 3131802,
    "cidade": "Itabirinha"
  },
  {
    "prefixo": "35290",
    "uf": "MG",
    "codigoIbge": 3139607,
    "cidade": "Mantena"
  },
  {
    "prefixo": "35295",
    "uf": "MG",
    "codigoIbge": 3139607,
    "cidade": "Mantena"
  },
  {
    "prefixo": "35296",
    "uf": "MG",
    "codigoIbge": 3139607,
    "cidade": "Mantena"
  },
  {
    "prefixo": "35298",
    "uf": "MG",
    "codigoIbge": 3144672,
    "cidade": "Nova Belém"
  },
  {
    "prefixo": "35300",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35301",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35302",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35303",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35304",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35305",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35309",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35311",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35313",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35314",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35315",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35316",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35317",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35318",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35319",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35320",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35321",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35322",
    "uf": "MG",
    "codigoIbge": 3113404,
    "cidade": "Caratinga"
  },
  {
    "prefixo": "35323",
    "uf": "MG",
    "codigoIbge": 3130556,
    "cidade": "Imbé de Minas"
  },
  {
    "prefixo": "35324",
    "uf": "MG",
    "codigoIbge": 3123858,
    "cidade": "Entre Folhas"
  },
  {
    "prefixo": "35325",
    "uf": "MG",
    "codigoIbge": 3150158,
    "cidade": "Piedade de Caratinga"
  },
  {
    "prefixo": "35326",
    "uf": "MG",
    "codigoIbge": 3159357,
    "cidade": "Santa Rita de Minas"
  },
  {
    "prefixo": "35328",
    "uf": "MG",
    "codigoIbge": 3157252,
    "cidade": "Santa Bárbara do Leste"
  },
  {
    "prefixo": "35330",
    "uf": "MG",
    "codigoIbge": 3130903,
    "cidade": "Inhapim"
  },
  {
    "prefixo": "35333",
    "uf": "MG",
    "codigoIbge": 3130903,
    "cidade": "Inhapim"
  },
  {
    "prefixo": "35334",
    "uf": "MG",
    "codigoIbge": 3164472,
    "cidade": "São Sebastião do Anta"
  },
  {
    "prefixo": "35335",
    "uf": "MG",
    "codigoIbge": 3160959,
    "cidade": "São Domingos das Dores"
  },
  {
    "prefixo": "35338",
    "uf": "MG",
    "codigoIbge": 3170057,
    "cidade": "Ubaporanga"
  },
  {
    "prefixo": "35339",
    "uf": "MG",
    "codigoIbge": 3170057,
    "cidade": "Ubaporanga"
  },
  {
    "prefixo": "35340",
    "uf": "MG",
    "codigoIbge": 3107802,
    "cidade": "Bom Jesus do Galho"
  },
  {
    "prefixo": "35342",
    "uf": "MG",
    "codigoIbge": 3107802,
    "cidade": "Bom Jesus do Galho"
  },
  {
    "prefixo": "35343",
    "uf": "MG",
    "codigoIbge": 3107802,
    "cidade": "Bom Jesus do Galho"
  },
  {
    "prefixo": "35345",
    "uf": "MG",
    "codigoIbge": 3120003,
    "cidade": "Córrego Novo"
  },
  {
    "prefixo": "35348",
    "uf": "MG",
    "codigoIbge": 3150539,
    "cidade": "Pingo-d'Água"
  },
  {
    "prefixo": "35350",
    "uf": "MG",
    "codigoIbge": 3154002,
    "cidade": "Raul Soares"
  },
  {
    "prefixo": "35352",
    "uf": "MG",
    "codigoIbge": 3154002,
    "cidade": "Raul Soares"
  },
  {
    "prefixo": "35354",
    "uf": "MG",
    "codigoIbge": 3154002,
    "cidade": "Raul Soares"
  },
  {
    "prefixo": "35355",
    "uf": "MG",
    "codigoIbge": 3154002,
    "cidade": "Raul Soares"
  },
  {
    "prefixo": "35356",
    "uf": "MG",
    "codigoIbge": 3154002,
    "cidade": "Raul Soares"
  },
  {
    "prefixo": "35358",
    "uf": "MG",
    "codigoIbge": 3154002,
    "cidade": "Raul Soares"
  },
  {
    "prefixo": "35359",
    "uf": "MG",
    "codigoIbge": 3171154,
    "cidade": "Vermelho Novo"
  },
  {
    "prefixo": "35360",
    "uf": "MG",
    "codigoIbge": 3164001,
    "cidade": "São Pedro dos Ferros"
  },
  {
    "prefixo": "35362",
    "uf": "MG",
    "codigoIbge": 3164001,
    "cidade": "São Pedro dos Ferros"
  },
  {
    "prefixo": "35364",
    "uf": "MG",
    "codigoIbge": 3148756,
    "cidade": "Pedra Bonita"
  },
  {
    "prefixo": "35365",
    "uf": "MG",
    "codigoIbge": 3100302,
    "cidade": "Abre Campo"
  },
  {
    "prefixo": "35367",
    "uf": "MG",
    "codigoIbge": 3140902,
    "cidade": "Matipó"
  },
  {
    "prefixo": "35368",
    "uf": "MG",
    "codigoIbge": 3166303,
    "cidade": "Sericita"
  },
  {
    "prefixo": "35370",
    "uf": "MG",
    "codigoIbge": 3154903,
    "cidade": "Rio Casca"
  },
  {
    "prefixo": "35375",
    "uf": "MG",
    "codigoIbge": 3154903,
    "cidade": "Rio Casca"
  },
  {
    "prefixo": "35380",
    "uf": "MG",
    "codigoIbge": 3170503,
    "cidade": "Urucânia"
  },
  {
    "prefixo": "35381",
    "uf": "MG",
    "codigoIbge": 3170503,
    "cidade": "Urucânia"
  },
  {
    "prefixo": "35382",
    "uf": "MG",
    "codigoIbge": 3150208,
    "cidade": "Piedade de Ponte Nova"
  },
  {
    "prefixo": "35383",
    "uf": "MG",
    "codigoIbge": 3157401,
    "cidade": "Santa Cruz do Escalvado"
  },
  {
    "prefixo": "35384",
    "uf": "MG",
    "codigoIbge": 3157401,
    "cidade": "Santa Cruz do Escalvado"
  },
  {
    "prefixo": "35387",
    "uf": "MG",
    "codigoIbge": 3157401,
    "cidade": "Santa Cruz do Escalvado"
  },
  {
    "prefixo": "35388",
    "uf": "MG",
    "codigoIbge": 3160108,
    "cidade": "Santo Antônio do Grama"
  },
  {
    "prefixo": "35390",
    "uf": "MG",
    "codigoIbge": 3135506,
    "cidade": "Jequeri"
  },
  {
    "prefixo": "35393",
    "uf": "MG",
    "codigoIbge": 3135506,
    "cidade": "Jequeri"
  },
  {
    "prefixo": "35395",
    "uf": "MG",
    "codigoIbge": 3135506,
    "cidade": "Jequeri"
  },
  {
    "prefixo": "35398",
    "uf": "MG",
    "codigoIbge": 3135506,
    "cidade": "Jequeri"
  },
  {
    "prefixo": "35400",
    "uf": "MG",
    "codigoIbge": 3146107,
    "cidade": "Ouro Preto"
  },
  {
    "prefixo": "35402",
    "uf": "MG",
    "codigoIbge": 3146107,
    "cidade": "Ouro Preto"
  },
  {
    "prefixo": "35404",
    "uf": "MG",
    "codigoIbge": 3146107,
    "cidade": "Ouro Preto"
  },
  {
    "prefixo": "35406",
    "uf": "MG",
    "codigoIbge": 3146107,
    "cidade": "Ouro Preto"
  },
  {
    "prefixo": "35407",
    "uf": "MG",
    "codigoIbge": 3146107,
    "cidade": "Ouro Preto"
  },
  {
    "prefixo": "35409",
    "uf": "MG",
    "codigoIbge": 3146107,
    "cidade": "Ouro Preto"
  },
  {
    "prefixo": "35410",
    "uf": "MG",
    "codigoIbge": 3146107,
    "cidade": "Ouro Preto"
  },
  {
    "prefixo": "35411",
    "uf": "MG",
    "codigoIbge": 3146107,
    "cidade": "Ouro Preto"
  },
  {
    "prefixo": "35412",
    "uf": "MG",
    "codigoIbge": 3146107,
    "cidade": "Ouro Preto"
  },
  {
    "prefixo": "35413",
    "uf": "MG",
    "codigoIbge": 3146107,
    "cidade": "Ouro Preto"
  },
  {
    "prefixo": "35414",
    "uf": "MG",
    "codigoIbge": 3146107,
    "cidade": "Ouro Preto"
  },
  {
    "prefixo": "35416",
    "uf": "MG",
    "codigoIbge": 3146107,
    "cidade": "Ouro Preto"
  },
  {
    "prefixo": "35420",
    "uf": "MG",
    "codigoIbge": 3140001,
    "cidade": "Mariana"
  },
  {
    "prefixo": "35421",
    "uf": "MG",
    "codigoIbge": 3140001,
    "cidade": "Mariana"
  },
  {
    "prefixo": "35422",
    "uf": "MG",
    "codigoIbge": 3140001,
    "cidade": "Mariana"
  },
  {
    "prefixo": "35423",
    "uf": "MG",
    "codigoIbge": 3140001,
    "cidade": "Mariana"
  },
  {
    "prefixo": "35424",
    "uf": "MG",
    "codigoIbge": 3140001,
    "cidade": "Mariana"
  },
  {
    "prefixo": "35425",
    "uf": "MG",
    "codigoIbge": 3140001,
    "cidade": "Mariana"
  },
  {
    "prefixo": "35426",
    "uf": "MG",
    "codigoIbge": 3140001,
    "cidade": "Mariana"
  },
  {
    "prefixo": "35427",
    "uf": "MG",
    "codigoIbge": 3140001,
    "cidade": "Mariana"
  },
  {
    "prefixo": "35428",
    "uf": "MG",
    "codigoIbge": 3140001,
    "cidade": "Mariana"
  },
  {
    "prefixo": "35429",
    "uf": "MG",
    "codigoIbge": 3140001,
    "cidade": "Mariana"
  },
  {
    "prefixo": "35430",
    "uf": "MG",
    "codigoIbge": 3152105,
    "cidade": "Ponte Nova"
  },
  {
    "prefixo": "35431",
    "uf": "MG",
    "codigoIbge": 3152105,
    "cidade": "Ponte Nova"
  },
  {
    "prefixo": "35432",
    "uf": "MG",
    "codigoIbge": 3152105,
    "cidade": "Ponte Nova"
  },
  {
    "prefixo": "35434",
    "uf": "MG",
    "codigoIbge": 3152105,
    "cidade": "Ponte Nova"
  },
  {
    "prefixo": "35435",
    "uf": "MG",
    "codigoIbge": 3152105,
    "cidade": "Ponte Nova"
  },
  {
    "prefixo": "35436",
    "uf": "MG",
    "codigoIbge": 3128204,
    "cidade": "Guaraciaba"
  },
  {
    "prefixo": "35437",
    "uf": "MG",
    "codigoIbge": 3121704,
    "cidade": "Diogo de Vasconcelos"
  },
  {
    "prefixo": "35438",
    "uf": "MG",
    "codigoIbge": 3100401,
    "cidade": "Acaiaca"
  },
  {
    "prefixo": "35439",
    "uf": "MG",
    "codigoIbge": 3145851,
    "cidade": "Oratórios"
  },
  {
    "prefixo": "35440",
    "uf": "MG",
    "codigoIbge": 3122702,
    "cidade": "Dom Silvério"
  },
  {
    "prefixo": "35441",
    "uf": "MG",
    "codigoIbge": 3165560,
    "cidade": "Sem-Peixe"
  },
  {
    "prefixo": "35442",
    "uf": "MG",
    "codigoIbge": 3155009,
    "cidade": "Rio Doce"
  },
  {
    "prefixo": "35444",
    "uf": "MG",
    "codigoIbge": 3102506,
    "cidade": "Amparo do Serra"
  },
  {
    "prefixo": "35445",
    "uf": "MG",
    "codigoIbge": 3102506,
    "cidade": "Amparo do Serra"
  },
  {
    "prefixo": "35447",
    "uf": "MG",
    "codigoIbge": 3105707,
    "cidade": "Barra Longa"
  },
  {
    "prefixo": "35449",
    "uf": "MG",
    "codigoIbge": 3105707,
    "cidade": "Barra Longa"
  },
  {
    "prefixo": "35450",
    "uf": "MG",
    "codigoIbge": 3131901,
    "cidade": "Itabirito"
  },
  {
    "prefixo": "35452",
    "uf": "MG",
    "codigoIbge": 3131901,
    "cidade": "Itabirito"
  },
  {
    "prefixo": "35453",
    "uf": "MG",
    "codigoIbge": 3131901,
    "cidade": "Itabirito"
  },
  {
    "prefixo": "35454",
    "uf": "MG",
    "codigoIbge": 3131901,
    "cidade": "Itabirito"
  },
  {
    "prefixo": "35455",
    "uf": "MG",
    "codigoIbge": 3131901,
    "cidade": "Itabirito"
  },
  {
    "prefixo": "35456",
    "uf": "MG",
    "codigoIbge": 3131901,
    "cidade": "Itabirito"
  },
  {
    "prefixo": "35457",
    "uf": "MG",
    "codigoIbge": 3131901,
    "cidade": "Itabirito"
  },
  {
    "prefixo": "35458",
    "uf": "MG",
    "codigoIbge": 3131901,
    "cidade": "Itabirito"
  },
  {
    "prefixo": "35459",
    "uf": "MG",
    "codigoIbge": 3131901,
    "cidade": "Itabirito"
  },
  {
    "prefixo": "35460",
    "uf": "MG",
    "codigoIbge": 3109006,
    "cidade": "Brumadinho"
  },
  {
    "prefixo": "35462",
    "uf": "MG",
    "codigoIbge": 3109006,
    "cidade": "Brumadinho"
  },
  {
    "prefixo": "35464",
    "uf": "MG",
    "codigoIbge": 3109006,
    "cidade": "Brumadinho"
  },
  {
    "prefixo": "35466",
    "uf": "MG",
    "codigoIbge": 3109006,
    "cidade": "Brumadinho"
  },
  {
    "prefixo": "35468",
    "uf": "MG",
    "codigoIbge": 3109006,
    "cidade": "Brumadinho"
  },
  {
    "prefixo": "35470",
    "uf": "MG",
    "codigoIbge": 3142304,
    "cidade": "Moeda"
  },
  {
    "prefixo": "35472",
    "uf": "MG",
    "codigoIbge": 3142304,
    "cidade": "Moeda"
  },
  {
    "prefixo": "35473",
    "uf": "MG",
    "codigoIbge": 3106408,
    "cidade": "Belo Vale"
  },
  {
    "prefixo": "35475",
    "uf": "MG",
    "codigoIbge": 3106408,
    "cidade": "Belo Vale"
  },
  {
    "prefixo": "35476",
    "uf": "MG",
    "codigoIbge": 3150406,
    "cidade": "Piedade dos Gerais"
  },
  {
    "prefixo": "35478",
    "uf": "MG",
    "codigoIbge": 3120607,
    "cidade": "Crucilândia"
  },
  {
    "prefixo": "35480",
    "uf": "MG",
    "codigoIbge": 3108107,
    "cidade": "Bonfim"
  },
  {
    "prefixo": "35482",
    "uf": "MG",
    "codigoIbge": 3108107,
    "cidade": "Bonfim"
  },
  {
    "prefixo": "35485",
    "uf": "MG",
    "codigoIbge": 3155306,
    "cidade": "Rio Manso"
  },
  {
    "prefixo": "35488",
    "uf": "MG",
    "codigoIbge": 3132206,
    "cidade": "Itaguara"
  },
  {
    "prefixo": "35490",
    "uf": "MG",
    "codigoIbge": 3123908,
    "cidade": "Entre Rios de Minas"
  },
  {
    "prefixo": "35491",
    "uf": "MG",
    "codigoIbge": 3123908,
    "cidade": "Entre Rios de Minas"
  },
  {
    "prefixo": "35492",
    "uf": "MG",
    "codigoIbge": 3121407,
    "cidade": "Desterro de Entre Rios"
  },
  {
    "prefixo": "35493",
    "uf": "MG",
    "codigoIbge": 3121407,
    "cidade": "Desterro de Entre Rios"
  },
  {
    "prefixo": "35494",
    "uf": "MG",
    "codigoIbge": 3121407,
    "cidade": "Desterro de Entre Rios"
  },
  {
    "prefixo": "35495",
    "uf": "MG",
    "codigoIbge": 3160900,
    "cidade": "São Brás do Suaçuí"
  },
  {
    "prefixo": "35497",
    "uf": "MG",
    "codigoIbge": 3135407,
    "cidade": "Jeceaba"
  },
  {
    "prefixo": "35498",
    "uf": "MG",
    "codigoIbge": 3135407,
    "cidade": "Jeceaba"
  },
  {
    "prefixo": "35500",
    "uf": "MG",
    "codigoIbge": 3122306,
    "cidade": "Divinópolis"
  },
  {
    "prefixo": "35501",
    "uf": "MG",
    "codigoIbge": 3122306,
    "cidade": "Divinópolis"
  },
  {
    "prefixo": "35502",
    "uf": "MG",
    "codigoIbge": 3122306,
    "cidade": "Divinópolis"
  },
  {
    "prefixo": "35503",
    "uf": "MG",
    "codigoIbge": 3122306,
    "cidade": "Divinópolis"
  },
  {
    "prefixo": "35504",
    "uf": "MG",
    "codigoIbge": 3122306,
    "cidade": "Divinópolis"
  },
  {
    "prefixo": "35505",
    "uf": "MG",
    "codigoIbge": 3122306,
    "cidade": "Divinópolis"
  },
  {
    "prefixo": "35520",
    "uf": "MG",
    "codigoIbge": 3145208,
    "cidade": "Nova Serrana"
  },
  {
    "prefixo": "35521",
    "uf": "MG",
    "codigoIbge": 3145208,
    "cidade": "Nova Serrana"
  },
  {
    "prefixo": "35522",
    "uf": "MG",
    "codigoIbge": 3145208,
    "cidade": "Nova Serrana"
  },
  {
    "prefixo": "35523",
    "uf": "MG",
    "codigoIbge": 3145208,
    "cidade": "Nova Serrana"
  },
  {
    "prefixo": "35524",
    "uf": "MG",
    "codigoIbge": 3145208,
    "cidade": "Nova Serrana"
  },
  {
    "prefixo": "35525",
    "uf": "MG",
    "codigoIbge": 3145208,
    "cidade": "Nova Serrana"
  },
  {
    "prefixo": "35526",
    "uf": "MG",
    "codigoIbge": 3145208,
    "cidade": "Nova Serrana"
  },
  {
    "prefixo": "35527",
    "uf": "MG",
    "codigoIbge": 3145208,
    "cidade": "Nova Serrana"
  },
  {
    "prefixo": "35528",
    "uf": "MG",
    "codigoIbge": 3145208,
    "cidade": "Nova Serrana"
  },
  {
    "prefixo": "35529",
    "uf": "MG",
    "codigoIbge": 3145208,
    "cidade": "Nova Serrana"
  },
  {
    "prefixo": "35530",
    "uf": "MG",
    "codigoIbge": 3116605,
    "cidade": "Cláudio"
  },
  {
    "prefixo": "35532",
    "uf": "MG",
    "codigoIbge": 3116605,
    "cidade": "Cláudio"
  },
  {
    "prefixo": "35534",
    "uf": "MG",
    "codigoIbge": 3114501,
    "cidade": "Carmópolis de Minas"
  },
  {
    "prefixo": "35535",
    "uf": "MG",
    "codigoIbge": 3114501,
    "cidade": "Carmópolis de Minas"
  },
  {
    "prefixo": "35536",
    "uf": "MG",
    "codigoIbge": 3150604,
    "cidade": "Piracema"
  },
  {
    "prefixo": "35537",
    "uf": "MG",
    "codigoIbge": 3147709,
    "cidade": "Passa Tempo"
  },
  {
    "prefixo": "35540",
    "uf": "MG",
    "codigoIbge": 3145604,
    "cidade": "Oliveira"
  },
  {
    "prefixo": "35541",
    "uf": "MG",
    "codigoIbge": 3145604,
    "cidade": "Oliveira"
  },
  {
    "prefixo": "35543",
    "uf": "MG",
    "codigoIbge": 3161205,
    "cidade": "São Francisco de Paula"
  },
  {
    "prefixo": "35544",
    "uf": "MG",
    "codigoIbge": 3161809,
    "cidade": "São Gonçalo do Pará"
  },
  {
    "prefixo": "35545",
    "uf": "MG",
    "codigoIbge": 3149705,
    "cidade": "Perdigão"
  },
  {
    "prefixo": "35547",
    "uf": "MG",
    "codigoIbge": 3114006,
    "cidade": "Carmo da Mata"
  },
  {
    "prefixo": "35550",
    "uf": "MG",
    "codigoIbge": 3133501,
    "cidade": "Itapecerica"
  },
  {
    "prefixo": "35551",
    "uf": "MG",
    "codigoIbge": 3133501,
    "cidade": "Itapecerica"
  },
  {
    "prefixo": "35552",
    "uf": "MG",
    "codigoIbge": 3133501,
    "cidade": "Itapecerica"
  },
  {
    "prefixo": "35553",
    "uf": "MG",
    "codigoIbge": 3133501,
    "cidade": "Itapecerica"
  },
  {
    "prefixo": "35555",
    "uf": "MG",
    "codigoIbge": 3110400,
    "cidade": "Camacho"
  },
  {
    "prefixo": "35557",
    "uf": "MG",
    "codigoIbge": 3114204,
    "cidade": "Carmo do Cajuru"
  },
  {
    "prefixo": "35558",
    "uf": "MG",
    "codigoIbge": 3114204,
    "cidade": "Carmo do Cajuru"
  },
  {
    "prefixo": "35559",
    "uf": "MG",
    "codigoIbge": 3114204,
    "cidade": "Carmo do Cajuru"
  },
  {
    "prefixo": "35560",
    "uf": "MG",
    "codigoIbge": 3160405,
    "cidade": "Santo Antônio do Monte"
  },
  {
    "prefixo": "35565",
    "uf": "MG",
    "codigoIbge": 3148905,
    "cidade": "Pedra do Indaiá"
  },
  {
    "prefixo": "35567",
    "uf": "MG",
    "codigoIbge": 3164605,
    "cidade": "São Sebastião do Oeste"
  },
  {
    "prefixo": "35568",
    "uf": "MG",
    "codigoIbge": 3119955,
    "cidade": "Córrego Fundo"
  },
  {
    "prefixo": "35570",
    "uf": "MG",
    "codigoIbge": 3126109,
    "cidade": "Formiga"
  },
  {
    "prefixo": "35572",
    "uf": "MG",
    "codigoIbge": 3126109,
    "cidade": "Formiga"
  },
  {
    "prefixo": "35573",
    "uf": "MG",
    "codigoIbge": 3126109,
    "cidade": "Formiga"
  },
  {
    "prefixo": "35574",
    "uf": "MG",
    "codigoIbge": 3126109,
    "cidade": "Formiga"
  },
  {
    "prefixo": "35576",
    "uf": "MG",
    "codigoIbge": 3126109,
    "cidade": "Formiga"
  },
  {
    "prefixo": "35577",
    "uf": "MG",
    "codigoIbge": 3126109,
    "cidade": "Formiga"
  },
  {
    "prefixo": "35578",
    "uf": "MG",
    "codigoIbge": 3126109,
    "cidade": "Formiga"
  },
  {
    "prefixo": "35579",
    "uf": "MG",
    "codigoIbge": 3126109,
    "cidade": "Formiga"
  },
  {
    "prefixo": "35580",
    "uf": "MG",
    "codigoIbge": 3135308,
    "cidade": "Japaraíba"
  },
  {
    "prefixo": "35582",
    "uf": "MG",
    "codigoIbge": 3146503,
    "cidade": "Pains"
  },
  {
    "prefixo": "35583",
    "uf": "MG",
    "codigoIbge": 3146503,
    "cidade": "Pains"
  },
  {
    "prefixo": "35585",
    "uf": "MG",
    "codigoIbge": 3150505,
    "cidade": "Pimenta"
  },
  {
    "prefixo": "35586",
    "uf": "MG",
    "codigoIbge": 3150505,
    "cidade": "Pimenta"
  },
  {
    "prefixo": "35588",
    "uf": "MG",
    "codigoIbge": 3104205,
    "cidade": "Arcos"
  },
  {
    "prefixo": "35590",
    "uf": "MG",
    "codigoIbge": 3137205,
    "cidade": "Lagoa da Prata"
  },
  {
    "prefixo": "35591",
    "uf": "MG",
    "codigoIbge": 3137205,
    "cidade": "Lagoa da Prata"
  },
  {
    "prefixo": "35592",
    "uf": "MG",
    "codigoIbge": 3137205,
    "cidade": "Lagoa da Prata"
  },
  {
    "prefixo": "35593",
    "uf": "MG",
    "codigoIbge": 3137205,
    "cidade": "Lagoa da Prata"
  },
  {
    "prefixo": "35594",
    "uf": "MG",
    "codigoIbge": 3137205,
    "cidade": "Lagoa da Prata"
  },
  {
    "prefixo": "35595",
    "uf": "MG",
    "codigoIbge": 3138807,
    "cidade": "Luz"
  },
  {
    "prefixo": "35596",
    "uf": "MG",
    "codigoIbge": 3138807,
    "cidade": "Luz"
  },
  {
    "prefixo": "35598",
    "uf": "MG",
    "codigoIbge": 3104205,
    "cidade": "Arcos"
  },
  {
    "prefixo": "35599",
    "uf": "MG",
    "codigoIbge": 3104205,
    "cidade": "Arcos"
  },
  {
    "prefixo": "35600",
    "uf": "MG",
    "codigoIbge": 3107406,
    "cidade": "Bom Despacho"
  },
  {
    "prefixo": "35601",
    "uf": "MG",
    "codigoIbge": 3104205,
    "cidade": "Arcos"
  },
  {
    "prefixo": "35602",
    "uf": "MG",
    "codigoIbge": 3107406,
    "cidade": "Bom Despacho"
  },
  {
    "prefixo": "35603",
    "uf": "MG",
    "codigoIbge": 3103900,
    "cidade": "Araújos"
  },
  {
    "prefixo": "35604",
    "uf": "MG",
    "codigoIbge": 3142403,
    "cidade": "Moema"
  },
  {
    "prefixo": "35606",
    "uf": "MG",
    "codigoIbge": 3140506,
    "cidade": "Martinho Campos"
  },
  {
    "prefixo": "35607",
    "uf": "MG",
    "codigoIbge": 3140506,
    "cidade": "Martinho Campos"
  },
  {
    "prefixo": "35608",
    "uf": "MG",
    "codigoIbge": 3140506,
    "cidade": "Martinho Campos"
  },
  {
    "prefixo": "35610",
    "uf": "MG",
    "codigoIbge": 3123205,
    "cidade": "Dores do Indaiá"
  },
  {
    "prefixo": "35613",
    "uf": "MG",
    "codigoIbge": 3124708,
    "cidade": "Estrela do Indaiá"
  },
  {
    "prefixo": "35615",
    "uf": "MG",
    "codigoIbge": 3124708,
    "cidade": "Estrela do Indaiá"
  },
  {
    "prefixo": "35617",
    "uf": "MG",
    "codigoIbge": 3166600,
    "cidade": "Serra da Saudade"
  },
  {
    "prefixo": "35620",
    "uf": "MG",
    "codigoIbge": 3100203,
    "cidade": "Abaeté"
  },
  {
    "prefixo": "35621",
    "uf": "MG",
    "codigoIbge": 3107000,
    "cidade": "Biquinhas"
  },
  {
    "prefixo": "35622",
    "uf": "MG",
    "codigoIbge": 3146404,
    "cidade": "Paineiras"
  },
  {
    "prefixo": "35623",
    "uf": "MG",
    "codigoIbge": 3146404,
    "cidade": "Paineiras"
  },
  {
    "prefixo": "35624",
    "uf": "MG",
    "codigoIbge": 3115607,
    "cidade": "Cedro do Abaeté"
  },
  {
    "prefixo": "35625",
    "uf": "MG",
    "codigoIbge": 3153707,
    "cidade": "Quartel Geral"
  },
  {
    "prefixo": "35626",
    "uf": "MG",
    "codigoIbge": 3153707,
    "cidade": "Quartel Geral"
  },
  {
    "prefixo": "35628",
    "uf": "MG",
    "codigoIbge": 3143500,
    "cidade": "Morada Nova de Minas"
  },
  {
    "prefixo": "35629",
    "uf": "MG",
    "codigoIbge": 3143500,
    "cidade": "Morada Nova de Minas"
  },
  {
    "prefixo": "35630",
    "uf": "MG",
    "codigoIbge": 3107406,
    "cidade": "Bom Despacho"
  },
  {
    "prefixo": "35632",
    "uf": "MG",
    "codigoIbge": 3107406,
    "cidade": "Bom Despacho"
  },
  {
    "prefixo": "35633",
    "uf": "MG",
    "codigoIbge": 3107406,
    "cidade": "Bom Despacho"
  },
  {
    "prefixo": "35634",
    "uf": "MG",
    "codigoIbge": 3107406,
    "cidade": "Bom Despacho"
  },
  {
    "prefixo": "35635",
    "uf": "MG",
    "codigoIbge": 3107406,
    "cidade": "Bom Despacho"
  },
  {
    "prefixo": "35636",
    "uf": "MG",
    "codigoIbge": 3107406,
    "cidade": "Bom Despacho"
  },
  {
    "prefixo": "35637",
    "uf": "MG",
    "codigoIbge": 3107406,
    "cidade": "Bom Despacho"
  },
  {
    "prefixo": "35640",
    "uf": "MG",
    "codigoIbge": 3152006,
    "cidade": "Pompéu"
  },
  {
    "prefixo": "35645",
    "uf": "MG",
    "codigoIbge": 3152006,
    "cidade": "Pompéu"
  },
  {
    "prefixo": "35650",
    "uf": "MG",
    "codigoIbge": 3151404,
    "cidade": "Pitangui"
  },
  {
    "prefixo": "35655",
    "uf": "MG",
    "codigoIbge": 3145802,
    "cidade": "Onça de Pitangui"
  },
  {
    "prefixo": "35656",
    "uf": "MG",
    "codigoIbge": 3145802,
    "cidade": "Onça de Pitangui"
  },
  {
    "prefixo": "35657",
    "uf": "MG",
    "codigoIbge": 3138302,
    "cidade": "Leandro Ferreira"
  },
  {
    "prefixo": "35660",
    "uf": "MG",
    "codigoIbge": 3147105,
    "cidade": "Pará de Minas"
  },
  {
    "prefixo": "35661",
    "uf": "MG",
    "codigoIbge": 3147105,
    "cidade": "Pará de Minas"
  },
  {
    "prefixo": "35662",
    "uf": "MG",
    "codigoIbge": 3147105,
    "cidade": "Pará de Minas"
  },
  {
    "prefixo": "35663",
    "uf": "MG",
    "codigoIbge": 3147105,
    "cidade": "Pará de Minas"
  },
  {
    "prefixo": "35664",
    "uf": "MG",
    "codigoIbge": 3147105,
    "cidade": "Pará de Minas"
  },
  {
    "prefixo": "35665",
    "uf": "MG",
    "codigoIbge": 3147105,
    "cidade": "Pará de Minas"
  },
  {
    "prefixo": "35666",
    "uf": "MG",
    "codigoIbge": 3139706,
    "cidade": "Maravilhas"
  },
  {
    "prefixo": "35667",
    "uf": "MG",
    "codigoIbge": 3149606,
    "cidade": "Pequi"
  },
  {
    "prefixo": "35668",
    "uf": "MG",
    "codigoIbge": 3117603,
    "cidade": "Conceição do Pará"
  },
  {
    "prefixo": "35669",
    "uf": "MG",
    "codigoIbge": 3146909,
    "cidade": "Papagaios"
  },
  {
    "prefixo": "35670",
    "uf": "MG",
    "codigoIbge": 3140704,
    "cidade": "Mateus Leme"
  },
  {
    "prefixo": "35672",
    "uf": "MG",
    "codigoIbge": 3140704,
    "cidade": "Mateus Leme"
  },
  {
    "prefixo": "35674",
    "uf": "MG",
    "codigoIbge": 3140704,
    "cidade": "Mateus Leme"
  },
  {
    "prefixo": "35675",
    "uf": "MG",
    "codigoIbge": 3136652,
    "cidade": "Juatuba"
  },
  {
    "prefixo": "35680",
    "uf": "MG",
    "codigoIbge": 3133808,
    "cidade": "Itaúna"
  },
  {
    "prefixo": "35681",
    "uf": "MG",
    "codigoIbge": 3133808,
    "cidade": "Itaúna"
  },
  {
    "prefixo": "35684",
    "uf": "MG",
    "codigoIbge": 3133808,
    "cidade": "Itaúna"
  },
  {
    "prefixo": "35685",
    "uf": "MG",
    "codigoIbge": 3133709,
    "cidade": "Itatiaiuçu"
  },
  {
    "prefixo": "35688",
    "uf": "MG",
    "codigoIbge": 3133709,
    "cidade": "Itatiaiuçu"
  },
  {
    "prefixo": "35690",
    "uf": "MG",
    "codigoIbge": 3126000,
    "cidade": "Florestal"
  },
  {
    "prefixo": "35694",
    "uf": "MG",
    "codigoIbge": 3163102,
    "cidade": "São José da Varginha"
  },
  {
    "prefixo": "35695",
    "uf": "MG",
    "codigoIbge": 3130200,
    "cidade": "Igaratinga"
  },
  {
    "prefixo": "35698",
    "uf": "MG",
    "codigoIbge": 3130200,
    "cidade": "Igaratinga"
  },
  {
    "prefixo": "35700",
    "uf": "MG",
    "codigoIbge": 3167202,
    "cidade": "Sete Lagoas"
  },
  {
    "prefixo": "35701",
    "uf": "MG",
    "codigoIbge": 3167202,
    "cidade": "Sete Lagoas"
  },
  {
    "prefixo": "35702",
    "uf": "MG",
    "codigoIbge": 3167202,
    "cidade": "Sete Lagoas"
  },
  {
    "prefixo": "35703",
    "uf": "MG",
    "codigoIbge": 3167202,
    "cidade": "Sete Lagoas"
  },
  {
    "prefixo": "35704",
    "uf": "MG",
    "codigoIbge": 3167202,
    "cidade": "Sete Lagoas"
  },
  {
    "prefixo": "35705",
    "uf": "MG",
    "codigoIbge": 3167202,
    "cidade": "Sete Lagoas"
  },
  {
    "prefixo": "35720",
    "uf": "MG",
    "codigoIbge": 3141108,
    "cidade": "Matozinhos"
  },
  {
    "prefixo": "35721",
    "uf": "MG",
    "codigoIbge": 3141108,
    "cidade": "Matozinhos"
  },
  {
    "prefixo": "35725",
    "uf": "MG",
    "codigoIbge": 3141108,
    "cidade": "Matozinhos"
  },
  {
    "prefixo": "35730",
    "uf": "MG",
    "codigoIbge": 3112505,
    "cidade": "Capim Branco"
  },
  {
    "prefixo": "35732",
    "uf": "MG",
    "codigoIbge": 3105004,
    "cidade": "Baldim"
  },
  {
    "prefixo": "35733",
    "uf": "MG",
    "codigoIbge": 3105004,
    "cidade": "Baldim"
  },
  {
    "prefixo": "35734",
    "uf": "MG",
    "codigoIbge": 3105004,
    "cidade": "Baldim"
  },
  {
    "prefixo": "35735",
    "uf": "MG",
    "codigoIbge": 3105004,
    "cidade": "Baldim"
  },
  {
    "prefixo": "35736",
    "uf": "MG",
    "codigoIbge": 3127206,
    "cidade": "Funilândia"
  },
  {
    "prefixo": "35738",
    "uf": "MG",
    "codigoIbge": 3153608,
    "cidade": "Prudente de Morais"
  },
  {
    "prefixo": "35760",
    "uf": "MG",
    "codigoIbge": 3126406,
    "cidade": "Fortuna de Minas"
  },
  {
    "prefixo": "35763",
    "uf": "MG",
    "codigoIbge": 3131000,
    "cidade": "Inhaúma"
  },
  {
    "prefixo": "35765",
    "uf": "MG",
    "codigoIbge": 3109600,
    "cidade": "Cachoeira da Prata"
  },
  {
    "prefixo": "35767",
    "uf": "MG",
    "codigoIbge": 3135704,
    "cidade": "Jequitibá"
  },
  {
    "prefixo": "35768",
    "uf": "MG",
    "codigoIbge": 3135704,
    "cidade": "Jequitibá"
  },
  {
    "prefixo": "35770",
    "uf": "MG",
    "codigoIbge": 3109907,
    "cidade": "Caetanópolis"
  },
  {
    "prefixo": "35774",
    "uf": "MG",
    "codigoIbge": 3147402,
    "cidade": "Paraopeba"
  },
  {
    "prefixo": "35777",
    "uf": "MG",
    "codigoIbge": 3103207,
    "cidade": "Araçaí"
  },
  {
    "prefixo": "35780",
    "uf": "MG",
    "codigoIbge": 3118908,
    "cidade": "Cordisburgo"
  },
  {
    "prefixo": "35782",
    "uf": "MG",
    "codigoIbge": 3118908,
    "cidade": "Cordisburgo"
  },
  {
    "prefixo": "35785",
    "uf": "MG",
    "codigoIbge": 3158508,
    "cidade": "Santana de Pirapama"
  },
  {
    "prefixo": "35788",
    "uf": "MG",
    "codigoIbge": 3158508,
    "cidade": "Santana de Pirapama"
  },
  {
    "prefixo": "35789",
    "uf": "MG",
    "codigoIbge": 3120904,
    "cidade": "Curvelo"
  },
  {
    "prefixo": "35790",
    "uf": "MG",
    "codigoIbge": 3120904,
    "cidade": "Curvelo"
  },
  {
    "prefixo": "35792",
    "uf": "MG",
    "codigoIbge": 3120904,
    "cidade": "Curvelo"
  },
  {
    "prefixo": "35794",
    "uf": "MG",
    "codigoIbge": 3120904,
    "cidade": "Curvelo"
  },
  {
    "prefixo": "35796",
    "uf": "MG",
    "codigoIbge": 3120904,
    "cidade": "Curvelo"
  },
  {
    "prefixo": "35797",
    "uf": "MG",
    "codigoIbge": 3120904,
    "cidade": "Curvelo"
  },
  {
    "prefixo": "35798",
    "uf": "MG",
    "codigoIbge": 3120904,
    "cidade": "Curvelo"
  },
  {
    "prefixo": "35800",
    "uf": "MG",
    "codigoIbge": 3125903,
    "cidade": "Ferros"
  },
  {
    "prefixo": "35801",
    "uf": "MG",
    "codigoIbge": 3125903,
    "cidade": "Ferros"
  },
  {
    "prefixo": "35802",
    "uf": "MG",
    "codigoIbge": 3125903,
    "cidade": "Ferros"
  },
  {
    "prefixo": "35803",
    "uf": "MG",
    "codigoIbge": 3125903,
    "cidade": "Ferros"
  },
  {
    "prefixo": "35806",
    "uf": "MG",
    "codigoIbge": 3125903,
    "cidade": "Ferros"
  },
  {
    "prefixo": "35807",
    "uf": "MG",
    "codigoIbge": 3125903,
    "cidade": "Ferros"
  },
  {
    "prefixo": "35810",
    "uf": "MG",
    "codigoIbge": 3147501,
    "cidade": "Passabém"
  },
  {
    "prefixo": "35815",
    "uf": "MG",
    "codigoIbge": 3164803,
    "cidade": "São Sebastião do Rio Preto"
  },
  {
    "prefixo": "35820",
    "uf": "MG",
    "codigoIbge": 3132800,
    "cidade": "Itambé do Mato Dentro"
  },
  {
    "prefixo": "35830",
    "uf": "MG",
    "codigoIbge": 3134608,
    "cidade": "Jaboticatubas"
  },
  {
    "prefixo": "35835",
    "uf": "MG",
    "codigoIbge": 3134608,
    "cidade": "Jaboticatubas"
  },
  {
    "prefixo": "35845",
    "uf": "MG",
    "codigoIbge": 3159001,
    "cidade": "Santana do Riacho"
  },
  {
    "prefixo": "35847",
    "uf": "MG",
    "codigoIbge": 3159001,
    "cidade": "Santana do Riacho"
  },
  {
    "prefixo": "35850",
    "uf": "MG",
    "codigoIbge": 3118106,
    "cidade": "Congonhas do Norte"
  },
  {
    "prefixo": "35858",
    "uf": "MG",
    "codigoIbge": 3117504,
    "cidade": "Conceição do Mato Dentro"
  },
  {
    "prefixo": "35859",
    "uf": "MG",
    "codigoIbge": 3117504,
    "cidade": "Conceição do Mato Dentro"
  },
  {
    "prefixo": "35860",
    "uf": "MG",
    "codigoIbge": 3117504,
    "cidade": "Conceição do Mato Dentro"
  },
  {
    "prefixo": "35861",
    "uf": "MG",
    "codigoIbge": 3117504,
    "cidade": "Conceição do Mato Dentro"
  },
  {
    "prefixo": "35862",
    "uf": "MG",
    "codigoIbge": 3117504,
    "cidade": "Conceição do Mato Dentro"
  },
  {
    "prefixo": "35863",
    "uf": "MG",
    "codigoIbge": 3117504,
    "cidade": "Conceição do Mato Dentro"
  },
  {
    "prefixo": "35864",
    "uf": "MG",
    "codigoIbge": 3117504,
    "cidade": "Conceição do Mato Dentro"
  },
  {
    "prefixo": "35865",
    "uf": "MG",
    "codigoIbge": 3122603,
    "cidade": "Dom Joaquim"
  },
  {
    "prefixo": "35868",
    "uf": "MG",
    "codigoIbge": 3122603,
    "cidade": "Dom Joaquim"
  },
  {
    "prefixo": "35875",
    "uf": "MG",
    "codigoIbge": 3143708,
    "cidade": "Morro do Pilar"
  },
  {
    "prefixo": "35878",
    "uf": "MG",
    "codigoIbge": 3113800,
    "cidade": "Carmésia"
  },
  {
    "prefixo": "35880",
    "uf": "MG",
    "codigoIbge": 3160504,
    "cidade": "Santo Antônio do Rio Abaixo"
  },
  {
    "prefixo": "35894",
    "uf": "MG",
    "codigoIbge": 3123106,
    "cidade": "Dores de Guanhães"
  },
  {
    "prefixo": "35900",
    "uf": "MG",
    "codigoIbge": 3131703,
    "cidade": "Itabira"
  },
  {
    "prefixo": "35901",
    "uf": "MG",
    "codigoIbge": 3131703,
    "cidade": "Itabira"
  },
  {
    "prefixo": "35902",
    "uf": "MG",
    "codigoIbge": 3131703,
    "cidade": "Itabira"
  },
  {
    "prefixo": "35903",
    "uf": "MG",
    "codigoIbge": 3131703,
    "cidade": "Itabira"
  },
  {
    "prefixo": "35904",
    "uf": "MG",
    "codigoIbge": 3131703,
    "cidade": "Itabira"
  },
  {
    "prefixo": "35905",
    "uf": "MG",
    "codigoIbge": 3131703,
    "cidade": "Itabira"
  },
  {
    "prefixo": "35907",
    "uf": "MG",
    "codigoIbge": 3131703,
    "cidade": "Itabira"
  },
  {
    "prefixo": "35908",
    "uf": "MG",
    "codigoIbge": 3107703,
    "cidade": "Bom Jesus do Amparo"
  },
  {
    "prefixo": "35910",
    "uf": "MG",
    "codigoIbge": 3158003,
    "cidade": "Santa Maria de Itabira"
  },
  {
    "prefixo": "35915",
    "uf": "MG",
    "codigoIbge": 3158003,
    "cidade": "Santa Maria de Itabira"
  },
  {
    "prefixo": "35920",
    "uf": "MG",
    "codigoIbge": 3144706,
    "cidade": "Nova Era"
  },
  {
    "prefixo": "35930",
    "uf": "MG",
    "codigoIbge": 3136207,
    "cidade": "João Monlevade"
  },
  {
    "prefixo": "35931",
    "uf": "MG",
    "codigoIbge": 3136207,
    "cidade": "João Monlevade"
  },
  {
    "prefixo": "35932",
    "uf": "MG",
    "codigoIbge": 3136207,
    "cidade": "João Monlevade"
  },
  {
    "prefixo": "35934",
    "uf": "MG",
    "codigoIbge": 3136207,
    "cidade": "João Monlevade"
  },
  {
    "prefixo": "35935",
    "uf": "MG",
    "codigoIbge": 3161908,
    "cidade": "São Gonçalo do Rio Abaixo"
  },
  {
    "prefixo": "35938",
    "uf": "MG",
    "codigoIbge": 3106002,
    "cidade": "Bela Vista de Minas"
  },
  {
    "prefixo": "35940",
    "uf": "MG",
    "codigoIbge": 3155702,
    "cidade": "Rio Piracicaba"
  },
  {
    "prefixo": "35943",
    "uf": "MG",
    "codigoIbge": 3155702,
    "cidade": "Rio Piracicaba"
  },
  {
    "prefixo": "35945",
    "uf": "MG",
    "codigoIbge": 3155702,
    "cidade": "Rio Piracicaba"
  },
  {
    "prefixo": "35950",
    "uf": "MG",
    "codigoIbge": 3102308,
    "cidade": "Alvinópolis"
  },
  {
    "prefixo": "35952",
    "uf": "MG",
    "codigoIbge": 3102308,
    "cidade": "Alvinópolis"
  },
  {
    "prefixo": "35953",
    "uf": "MG",
    "codigoIbge": 3102308,
    "cidade": "Alvinópolis"
  },
  {
    "prefixo": "35955",
    "uf": "MG",
    "codigoIbge": 3102308,
    "cidade": "Alvinópolis"
  },
  {
    "prefixo": "35960",
    "uf": "MG",
    "codigoIbge": 3157203,
    "cidade": "Santa Bárbara"
  },
  {
    "prefixo": "35961",
    "uf": "MG",
    "codigoIbge": 3157203,
    "cidade": "Santa Bárbara"
  },
  {
    "prefixo": "35966",
    "uf": "MG",
    "codigoIbge": 3157203,
    "cidade": "Santa Bárbara"
  },
  {
    "prefixo": "35968",
    "uf": "MG",
    "codigoIbge": 3157203,
    "cidade": "Santa Bárbara"
  },
  {
    "prefixo": "35969",
    "uf": "MG",
    "codigoIbge": 3115359,
    "cidade": "Catas Altas"
  },
  {
    "prefixo": "35970",
    "uf": "MG",
    "codigoIbge": 3105400,
    "cidade": "Barão de Cocais"
  },
  {
    "prefixo": "35975",
    "uf": "MG",
    "codigoIbge": 3105400,
    "cidade": "Barão de Cocais"
  },
  {
    "prefixo": "35984",
    "uf": "MG",
    "codigoIbge": 3121803,
    "cidade": "Dionísio"
  },
  {
    "prefixo": "35985",
    "uf": "MG",
    "codigoIbge": 3121803,
    "cidade": "Dionísio"
  },
  {
    "prefixo": "35986",
    "uf": "MG",
    "codigoIbge": 3163409,
    "cidade": "São José do Goiabal"
  },
  {
    "prefixo": "35993",
    "uf": "MG",
    "codigoIbge": 3161007,
    "cidade": "São Domingos do Prata"
  },
  {
    "prefixo": "35994",
    "uf": "MG",
    "codigoIbge": 3161007,
    "cidade": "São Domingos do Prata"
  },
  {
    "prefixo": "35995",
    "uf": "MG",
    "codigoIbge": 3161007,
    "cidade": "São Domingos do Prata"
  },
  {
    "prefixo": "35996",
    "uf": "MG",
    "codigoIbge": 3161007,
    "cidade": "São Domingos do Prata"
  },
  {
    "prefixo": "35997",
    "uf": "MG",
    "codigoIbge": 3161007,
    "cidade": "São Domingos do Prata"
  },
  {
    "prefixo": "35998",
    "uf": "MG",
    "codigoIbge": 3161007,
    "cidade": "São Domingos do Prata"
  },
  {
    "prefixo": "36000",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36001",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36010",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36013",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36015",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36016",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36020",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36021",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36025",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36026",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36030",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36031",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36032",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36033",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36034",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36035",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36036",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36037",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36038",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36039",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36045",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36046",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36047",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36048",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36050",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36051",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36052",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36060",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36061",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36062",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36070",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36071",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36072",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36073",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36080",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36081",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36083",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36084",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36085",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36087",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36088",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36090",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36091",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36092",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36094",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36099",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36101",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36102",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36103",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36104",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36105",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36106",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36107",
    "uf": "MG",
    "codigoIbge": 3136702,
    "cidade": "Juiz de Fora"
  },
  {
    "prefixo": "36108",
    "uf": "MG",
    "codigoIbge": 3125002,
    "cidade": "Ewbank da Câmara"
  },
  {
    "prefixo": "36110",
    "uf": "MG",
    "codigoIbge": 3115904,
    "cidade": "Chácara"
  },
  {
    "prefixo": "36120",
    "uf": "MG",
    "codigoIbge": 3140803,
    "cidade": "Matias Barbosa"
  },
  {
    "prefixo": "36123",
    "uf": "MG",
    "codigoIbge": 3167509,
    "cidade": "Simão Pereira"
  },
  {
    "prefixo": "36126",
    "uf": "MG",
    "codigoIbge": 3106101,
    "cidade": "Belmiro Braga"
  },
  {
    "prefixo": "36127",
    "uf": "MG",
    "codigoIbge": 3106101,
    "cidade": "Belmiro Braga"
  },
  {
    "prefixo": "36128",
    "uf": "MG",
    "codigoIbge": 3106101,
    "cidade": "Belmiro Braga"
  },
  {
    "prefixo": "36130",
    "uf": "MG",
    "codigoIbge": 3155900,
    "cidade": "Rio Preto"
  },
  {
    "prefixo": "36131",
    "uf": "MG",
    "codigoIbge": 3155900,
    "cidade": "Rio Preto"
  },
  {
    "prefixo": "36132",
    "uf": "MG",
    "codigoIbge": 3157278,
    "cidade": "Santa Bárbara do Monte Verde"
  },
  {
    "prefixo": "36135",
    "uf": "MG",
    "codigoIbge": 3159308,
    "cidade": "Santa Rita de Jacutinga"
  },
  {
    "prefixo": "36138",
    "uf": "MG",
    "codigoIbge": 3159308,
    "cidade": "Santa Rita de Jacutinga"
  },
  {
    "prefixo": "36140",
    "uf": "MG",
    "codigoIbge": 3138609,
    "cidade": "Lima Duarte"
  },
  {
    "prefixo": "36141",
    "uf": "MG",
    "codigoIbge": 3138609,
    "cidade": "Lima Duarte"
  },
  {
    "prefixo": "36142",
    "uf": "MG",
    "codigoIbge": 3138609,
    "cidade": "Lima Duarte"
  },
  {
    "prefixo": "36144",
    "uf": "MG",
    "codigoIbge": 3138609,
    "cidade": "Lima Duarte"
  },
  {
    "prefixo": "36145",
    "uf": "MG",
    "codigoIbge": 3145406,
    "cidade": "Olaria"
  },
  {
    "prefixo": "36146",
    "uf": "MG",
    "codigoIbge": 3158706,
    "cidade": "Santana do Garambéu"
  },
  {
    "prefixo": "36148",
    "uf": "MG",
    "codigoIbge": 3149408,
    "cidade": "Pedro Teixeira"
  },
  {
    "prefixo": "36150",
    "uf": "MG",
    "codigoIbge": 3155405,
    "cidade": "Rio Novo"
  },
  {
    "prefixo": "36152",
    "uf": "MG",
    "codigoIbge": 3127388,
    "cidade": "Goianá"
  },
  {
    "prefixo": "36155",
    "uf": "MG",
    "codigoIbge": 3119609,
    "cidade": "Coronel Pacheco"
  },
  {
    "prefixo": "36157",
    "uf": "MG",
    "codigoIbge": 3150109,
    "cidade": "Piau"
  },
  {
    "prefixo": "36160",
    "uf": "MG",
    "codigoIbge": 3128402,
    "cidade": "Guarani"
  },
  {
    "prefixo": "36165",
    "uf": "MG",
    "codigoIbge": 3167905,
    "cidade": "Tabuleiro"
  },
  {
    "prefixo": "36170",
    "uf": "MG",
    "codigoIbge": 3151305,
    "cidade": "Piraúba"
  },
  {
    "prefixo": "36180",
    "uf": "MG",
    "codigoIbge": 3155801,
    "cidade": "Rio Pomba"
  },
  {
    "prefixo": "36185",
    "uf": "MG",
    "codigoIbge": 3167301,
    "cidade": "Silveirânia"
  },
  {
    "prefixo": "36190",
    "uf": "MG",
    "codigoIbge": 3141603,
    "cidade": "Mercês"
  },
  {
    "prefixo": "36195",
    "uf": "MG",
    "codigoIbge": 3146602,
    "cidade": "Paiva"
  },
  {
    "prefixo": "36200",
    "uf": "MG",
    "codigoIbge": 3105608,
    "cidade": "Barbacena"
  },
  {
    "prefixo": "36201",
    "uf": "MG",
    "codigoIbge": 3105608,
    "cidade": "Barbacena"
  },
  {
    "prefixo": "36202",
    "uf": "MG",
    "codigoIbge": 3105608,
    "cidade": "Barbacena"
  },
  {
    "prefixo": "36204",
    "uf": "MG",
    "codigoIbge": 3105608,
    "cidade": "Barbacena"
  },
  {
    "prefixo": "36205",
    "uf": "MG",
    "codigoIbge": 3105608,
    "cidade": "Barbacena"
  },
  {
    "prefixo": "36206",
    "uf": "MG",
    "codigoIbge": 3105608,
    "cidade": "Barbacena"
  },
  {
    "prefixo": "36207",
    "uf": "MG",
    "codigoIbge": 3105608,
    "cidade": "Barbacena"
  },
  {
    "prefixo": "36208",
    "uf": "MG",
    "codigoIbge": 3105608,
    "cidade": "Barbacena"
  },
  {
    "prefixo": "36209",
    "uf": "MG",
    "codigoIbge": 3105608,
    "cidade": "Barbacena"
  },
  {
    "prefixo": "36210",
    "uf": "MG",
    "codigoIbge": 3121506,
    "cidade": "Desterro do Melo"
  },
  {
    "prefixo": "36212",
    "uf": "MG",
    "codigoIbge": 3105905,
    "cidade": "Barroso"
  },
  {
    "prefixo": "36213",
    "uf": "MG",
    "codigoIbge": 3123007,
    "cidade": "Dores de Campos"
  },
  {
    "prefixo": "36215",
    "uf": "MG",
    "codigoIbge": 3157302,
    "cidade": "Santa Bárbara do Tugúrio"
  },
  {
    "prefixo": "36218",
    "uf": "MG",
    "codigoIbge": 3157302,
    "cidade": "Santa Bárbara do Tugúrio"
  },
  {
    "prefixo": "36220",
    "uf": "MG",
    "codigoIbge": 3102902,
    "cidade": "Antônio Carlos"
  },
  {
    "prefixo": "36222",
    "uf": "MG",
    "codigoIbge": 3102902,
    "cidade": "Antônio Carlos"
  },
  {
    "prefixo": "36223",
    "uf": "MG",
    "codigoIbge": 3102902,
    "cidade": "Antônio Carlos"
  },
  {
    "prefixo": "36225",
    "uf": "MG",
    "codigoIbge": 3129400,
    "cidade": "Ibertioga"
  },
  {
    "prefixo": "36227",
    "uf": "MG",
    "codigoIbge": 3150307,
    "cidade": "Piedade do Rio Grande"
  },
  {
    "prefixo": "36230",
    "uf": "MG",
    "codigoIbge": 3106804,
    "cidade": "Bias Fortes"
  },
  {
    "prefixo": "36235",
    "uf": "MG",
    "codigoIbge": 3159407,
    "cidade": "Santa Rita de Ibitipoca"
  },
  {
    "prefixo": "36236",
    "uf": "MG",
    "codigoIbge": 3159407,
    "cidade": "Santa Rita de Ibitipoca"
  },
  {
    "prefixo": "36240",
    "uf": "MG",
    "codigoIbge": 3160702,
    "cidade": "Santos Dumont"
  },
  {
    "prefixo": "36242",
    "uf": "MG",
    "codigoIbge": 3160702,
    "cidade": "Santos Dumont"
  },
  {
    "prefixo": "36244",
    "uf": "MG",
    "codigoIbge": 3160702,
    "cidade": "Santos Dumont"
  },
  {
    "prefixo": "36246",
    "uf": "MG",
    "codigoIbge": 3160702,
    "cidade": "Santos Dumont"
  },
  {
    "prefixo": "36247",
    "uf": "MG",
    "codigoIbge": 3160702,
    "cidade": "Santos Dumont"
  },
  {
    "prefixo": "36248",
    "uf": "MG",
    "codigoIbge": 3160702,
    "cidade": "Santos Dumont"
  },
  {
    "prefixo": "36249",
    "uf": "MG",
    "codigoIbge": 3160702,
    "cidade": "Santos Dumont"
  },
  {
    "prefixo": "36250",
    "uf": "MG",
    "codigoIbge": 3145703,
    "cidade": "Oliveira Fortes"
  },
  {
    "prefixo": "36255",
    "uf": "MG",
    "codigoIbge": 3103306,
    "cidade": "Aracitaba"
  },
  {
    "prefixo": "36260",
    "uf": "MG",
    "codigoIbge": 3102100,
    "cidade": "Alto Rio Doce"
  },
  {
    "prefixo": "36262",
    "uf": "MG",
    "codigoIbge": 3102100,
    "cidade": "Alto Rio Doce"
  },
  {
    "prefixo": "36263",
    "uf": "MG",
    "codigoIbge": 3102100,
    "cidade": "Alto Rio Doce"
  },
  {
    "prefixo": "36264",
    "uf": "MG",
    "codigoIbge": 3102100,
    "cidade": "Alto Rio Doce"
  },
  {
    "prefixo": "36265",
    "uf": "MG",
    "codigoIbge": 3116308,
    "cidade": "Cipotânea"
  },
  {
    "prefixo": "36270",
    "uf": "MG",
    "codigoIbge": 3154408,
    "cidade": "Ressaquinha"
  },
  {
    "prefixo": "36272",
    "uf": "MG",
    "codigoIbge": 3101631,
    "cidade": "Alfredo Vasconcelos"
  },
  {
    "prefixo": "36275",
    "uf": "MG",
    "codigoIbge": 3166204,
    "cidade": "Senhora dos Remédios"
  },
  {
    "prefixo": "36278",
    "uf": "MG",
    "codigoIbge": 3166204,
    "cidade": "Senhora dos Remédios"
  },
  {
    "prefixo": "36280",
    "uf": "MG",
    "codigoIbge": 3113206,
    "cidade": "Carandaí"
  },
  {
    "prefixo": "36282",
    "uf": "MG",
    "codigoIbge": 3113206,
    "cidade": "Carandaí"
  },
  {
    "prefixo": "36284",
    "uf": "MG",
    "codigoIbge": 3113206,
    "cidade": "Carandaí"
  },
  {
    "prefixo": "36286",
    "uf": "MG",
    "codigoIbge": 3113206,
    "cidade": "Carandaí"
  },
  {
    "prefixo": "36287",
    "uf": "MG",
    "codigoIbge": 3113206,
    "cidade": "Carandaí"
  },
  {
    "prefixo": "36290",
    "uf": "MG",
    "codigoIbge": 3112208,
    "cidade": "Capela Nova"
  },
  {
    "prefixo": "36295",
    "uf": "MG",
    "codigoIbge": 3105905,
    "cidade": "Barroso"
  },
  {
    "prefixo": "36296",
    "uf": "MG",
    "codigoIbge": 3105905,
    "cidade": "Barroso"
  },
  {
    "prefixo": "36297",
    "uf": "MG",
    "codigoIbge": 3105905,
    "cidade": "Barroso"
  },
  {
    "prefixo": "36298",
    "uf": "MG",
    "codigoIbge": 3105905,
    "cidade": "Barroso"
  },
  {
    "prefixo": "36300",
    "uf": "MG",
    "codigoIbge": 3162500,
    "cidade": "São João del Rei"
  },
  {
    "prefixo": "36301",
    "uf": "MG",
    "codigoIbge": 3162500,
    "cidade": "São João del Rei"
  },
  {
    "prefixo": "36302",
    "uf": "MG",
    "codigoIbge": 3162500,
    "cidade": "São João del Rei"
  },
  {
    "prefixo": "36303",
    "uf": "MG",
    "codigoIbge": 3162500,
    "cidade": "São João del Rei"
  },
  {
    "prefixo": "36305",
    "uf": "MG",
    "codigoIbge": 3162500,
    "cidade": "São João del Rei"
  },
  {
    "prefixo": "36307",
    "uf": "MG",
    "codigoIbge": 3162500,
    "cidade": "São João del Rei"
  },
  {
    "prefixo": "36309",
    "uf": "MG",
    "codigoIbge": 3162500,
    "cidade": "São João del Rei"
  },
  {
    "prefixo": "36314",
    "uf": "MG",
    "codigoIbge": 3162500,
    "cidade": "São João del Rei"
  },
  {
    "prefixo": "36315",
    "uf": "MG",
    "codigoIbge": 3162500,
    "cidade": "São João del Rei"
  },
  {
    "prefixo": "36316",
    "uf": "MG",
    "codigoIbge": 3162500,
    "cidade": "São João del Rei"
  },
  {
    "prefixo": "36317",
    "uf": "MG",
    "codigoIbge": 3162500,
    "cidade": "São João del Rei"
  },
  {
    "prefixo": "36318",
    "uf": "MG",
    "codigoIbge": 3162500,
    "cidade": "São João del Rei"
  },
  {
    "prefixo": "36319",
    "uf": "MG",
    "codigoIbge": 3162500,
    "cidade": "São João del Rei"
  },
  {
    "prefixo": "36320",
    "uf": "MG",
    "codigoIbge": 3152709,
    "cidade": "Prados"
  },
  {
    "prefixo": "36325",
    "uf": "MG",
    "codigoIbge": 3168804,
    "cidade": "Tiradentes"
  },
  {
    "prefixo": "36328",
    "uf": "MG",
    "codigoIbge": 3157336,
    "cidade": "Santa Cruz de Minas"
  },
  {
    "prefixo": "36330",
    "uf": "MG",
    "codigoIbge": 3119708,
    "cidade": "Coronel Xavier Chaves"
  },
  {
    "prefixo": "36335",
    "uf": "MG",
    "codigoIbge": 3156106,
    "cidade": "Ritápolis"
  },
  {
    "prefixo": "36340",
    "uf": "MG",
    "codigoIbge": 3154200,
    "cidade": "Resende Costa"
  },
  {
    "prefixo": "36342",
    "uf": "MG",
    "codigoIbge": 3154200,
    "cidade": "Resende Costa"
  },
  {
    "prefixo": "36345",
    "uf": "MG",
    "codigoIbge": 3137403,
    "cidade": "Lagoa Dourada"
  },
  {
    "prefixo": "36350",
    "uf": "MG",
    "codigoIbge": 3165008,
    "cidade": "São Tiago"
  },
  {
    "prefixo": "36352",
    "uf": "MG",
    "codigoIbge": 3165008,
    "cidade": "São Tiago"
  },
  {
    "prefixo": "36360",
    "uf": "MG",
    "codigoIbge": 3115201,
    "cidade": "Conceição da Barra de Minas"
  },
  {
    "prefixo": "36370",
    "uf": "MG",
    "codigoIbge": 3144508,
    "cidade": "Nazareno"
  },
  {
    "prefixo": "36390",
    "uf": "MG",
    "codigoIbge": 3134509,
    "cidade": "Itutinga"
  },
  {
    "prefixo": "36400",
    "uf": "MG",
    "codigoIbge": 3118304,
    "cidade": "Conselheiro Lafaiete"
  },
  {
    "prefixo": "36401",
    "uf": "MG",
    "codigoIbge": 3118304,
    "cidade": "Conselheiro Lafaiete"
  },
  {
    "prefixo": "36402",
    "uf": "MG",
    "codigoIbge": 3118304,
    "cidade": "Conselheiro Lafaiete"
  },
  {
    "prefixo": "36404",
    "uf": "MG",
    "codigoIbge": 3118304,
    "cidade": "Conselheiro Lafaiete"
  },
  {
    "prefixo": "36405",
    "uf": "MG",
    "codigoIbge": 3118304,
    "cidade": "Conselheiro Lafaiete"
  },
  {
    "prefixo": "36406",
    "uf": "MG",
    "codigoIbge": 3118304,
    "cidade": "Conselheiro Lafaiete"
  },
  {
    "prefixo": "36407",
    "uf": "MG",
    "codigoIbge": 3118304,
    "cidade": "Conselheiro Lafaiete"
  },
  {
    "prefixo": "36408",
    "uf": "MG",
    "codigoIbge": 3118304,
    "cidade": "Conselheiro Lafaiete"
  },
  {
    "prefixo": "36409",
    "uf": "MG",
    "codigoIbge": 3118304,
    "cidade": "Conselheiro Lafaiete"
  },
  {
    "prefixo": "36410",
    "uf": "MG",
    "codigoIbge": 3118007,
    "cidade": "Congonhas"
  },
  {
    "prefixo": "36412",
    "uf": "MG",
    "codigoIbge": 3118007,
    "cidade": "Congonhas"
  },
  {
    "prefixo": "36414",
    "uf": "MG",
    "codigoIbge": 3118007,
    "cidade": "Congonhas"
  },
  {
    "prefixo": "36416",
    "uf": "MG",
    "codigoIbge": 3118007,
    "cidade": "Congonhas"
  },
  {
    "prefixo": "36417",
    "uf": "MG",
    "codigoIbge": 3118007,
    "cidade": "Congonhas"
  },
  {
    "prefixo": "36418",
    "uf": "MG",
    "codigoIbge": 3118007,
    "cidade": "Congonhas"
  },
  {
    "prefixo": "36419",
    "uf": "MG",
    "codigoIbge": 3118007,
    "cidade": "Congonhas"
  },
  {
    "prefixo": "36422",
    "uf": "MG",
    "codigoIbge": 3114907,
    "cidade": "Casa Grande"
  },
  {
    "prefixo": "36424",
    "uf": "MG",
    "codigoIbge": 3153806,
    "cidade": "Queluzito"
  },
  {
    "prefixo": "36426",
    "uf": "MG",
    "codigoIbge": 3120409,
    "cidade": "Cristiano Otoni"
  },
  {
    "prefixo": "36428",
    "uf": "MG",
    "codigoIbge": 3113107,
    "cidade": "Caranaíba"
  },
  {
    "prefixo": "36430",
    "uf": "MG",
    "codigoIbge": 3159100,
    "cidade": "Santana dos Montes"
  },
  {
    "prefixo": "36435",
    "uf": "MG",
    "codigoIbge": 3159100,
    "cidade": "Santana dos Montes"
  },
  {
    "prefixo": "36440",
    "uf": "MG",
    "codigoIbge": 3133907,
    "cidade": "Itaverava"
  },
  {
    "prefixo": "36445",
    "uf": "MG",
    "codigoIbge": 3133907,
    "cidade": "Itaverava"
  },
  {
    "prefixo": "36450",
    "uf": "MG",
    "codigoIbge": 3115409,
    "cidade": "Catas Altas da Noruega"
  },
  {
    "prefixo": "36455",
    "uf": "MG",
    "codigoIbge": 3137908,
    "cidade": "Lamim"
  },
  {
    "prefixo": "36460",
    "uf": "MG",
    "codigoIbge": 3155207,
    "cidade": "Rio Espera"
  },
  {
    "prefixo": "36462",
    "uf": "MG",
    "codigoIbge": 3155207,
    "cidade": "Rio Espera"
  },
  {
    "prefixo": "36465",
    "uf": "MG",
    "codigoIbge": 3155207,
    "cidade": "Rio Espera"
  },
  {
    "prefixo": "36470",
    "uf": "MG",
    "codigoIbge": 3166006,
    "cidade": "Senhora de Oliveira"
  },
  {
    "prefixo": "36475",
    "uf": "MG",
    "codigoIbge": 3153103,
    "cidade": "Presidente Bernardes"
  },
  {
    "prefixo": "36480",
    "uf": "MG",
    "codigoIbge": 3150802,
    "cidade": "Piranga"
  },
  {
    "prefixo": "36485",
    "uf": "MG",
    "codigoIbge": 3150802,
    "cidade": "Piranga"
  },
  {
    "prefixo": "36489",
    "uf": "MG",
    "codigoIbge": 3150802,
    "cidade": "Piranga"
  },
  {
    "prefixo": "36490",
    "uf": "MG",
    "codigoIbge": 3145901,
    "cidade": "Ouro Branco"
  },
  {
    "prefixo": "36492",
    "uf": "MG",
    "codigoIbge": 3145901,
    "cidade": "Ouro Branco"
  },
  {
    "prefixo": "36494",
    "uf": "MG",
    "codigoIbge": 3145901,
    "cidade": "Ouro Branco"
  },
  {
    "prefixo": "36495",
    "uf": "MG",
    "codigoIbge": 3145901,
    "cidade": "Ouro Branco"
  },
  {
    "prefixo": "36496",
    "uf": "MG",
    "codigoIbge": 3145901,
    "cidade": "Ouro Branco"
  },
  {
    "prefixo": "36497",
    "uf": "MG",
    "codigoIbge": 3145901,
    "cidade": "Ouro Branco"
  },
  {
    "prefixo": "36500",
    "uf": "MG",
    "codigoIbge": 3169901,
    "cidade": "Ubá"
  },
  {
    "prefixo": "36501",
    "uf": "MG",
    "codigoIbge": 3169901,
    "cidade": "Ubá"
  },
  {
    "prefixo": "36502",
    "uf": "MG",
    "codigoIbge": 3169901,
    "cidade": "Ubá"
  },
  {
    "prefixo": "36503",
    "uf": "MG",
    "codigoIbge": 3169901,
    "cidade": "Ubá"
  },
  {
    "prefixo": "36504",
    "uf": "MG",
    "codigoIbge": 3169901,
    "cidade": "Ubá"
  },
  {
    "prefixo": "36505",
    "uf": "MG",
    "codigoIbge": 3169901,
    "cidade": "Ubá"
  },
  {
    "prefixo": "36506",
    "uf": "MG",
    "codigoIbge": 3169901,
    "cidade": "Ubá"
  },
  {
    "prefixo": "36507",
    "uf": "MG",
    "codigoIbge": 3169901,
    "cidade": "Ubá"
  },
  {
    "prefixo": "36508",
    "uf": "MG",
    "codigoIbge": 3169901,
    "cidade": "Ubá"
  },
  {
    "prefixo": "36509",
    "uf": "MG",
    "codigoIbge": 3169901,
    "cidade": "Ubá"
  },
  {
    "prefixo": "36510",
    "uf": "MG",
    "codigoIbge": 3156304,
    "cidade": "Rodeiro"
  },
  {
    "prefixo": "36512",
    "uf": "MG",
    "codigoIbge": 3169000,
    "cidade": "Tocantins"
  },
  {
    "prefixo": "36513",
    "uf": "MG",
    "codigoIbge": 3123304,
    "cidade": "Dores do Turvo"
  },
  {
    "prefixo": "36515",
    "uf": "MG",
    "codigoIbge": 3128808,
    "cidade": "Guidoval"
  },
  {
    "prefixo": "36520",
    "uf": "MG",
    "codigoIbge": 3172004,
    "cidade": "Visconde do Rio Branco"
  },
  {
    "prefixo": "36525",
    "uf": "MG",
    "codigoIbge": 3129004,
    "cidade": "Guiricema"
  },
  {
    "prefixo": "36526",
    "uf": "MG",
    "codigoIbge": 3129004,
    "cidade": "Guiricema"
  },
  {
    "prefixo": "36528",
    "uf": "MG",
    "codigoIbge": 3129004,
    "cidade": "Guiricema"
  },
  {
    "prefixo": "36530",
    "uf": "MG",
    "codigoIbge": 3161502,
    "cidade": "São Geraldo"
  },
  {
    "prefixo": "36532",
    "uf": "MG",
    "codigoIbge": 3161502,
    "cidade": "São Geraldo"
  },
  {
    "prefixo": "36540",
    "uf": "MG",
    "codigoIbge": 3165701,
    "cidade": "Senador Firmino"
  },
  {
    "prefixo": "36542",
    "uf": "MG",
    "codigoIbge": 3108701,
    "cidade": "Brás Pires"
  },
  {
    "prefixo": "36544",
    "uf": "MG",
    "codigoIbge": 3148301,
    "cidade": "Paula Cândido"
  },
  {
    "prefixo": "36546",
    "uf": "MG",
    "codigoIbge": 3121902,
    "cidade": "Divinésia"
  },
  {
    "prefixo": "36550",
    "uf": "MG",
    "codigoIbge": 3116704,
    "cidade": "Coimbra"
  },
  {
    "prefixo": "36555",
    "uf": "MG",
    "codigoIbge": 3124005,
    "cidade": "Ervália"
  },
  {
    "prefixo": "36560",
    "uf": "MG",
    "codigoIbge": 3110202,
    "cidade": "Cajuri"
  },
  {
    "prefixo": "36565",
    "uf": "MG",
    "codigoIbge": 3110202,
    "cidade": "Cajuri"
  },
  {
    "prefixo": "36568",
    "uf": "MG",
    "codigoIbge": 3152303,
    "cidade": "Porto Firme"
  },
  {
    "prefixo": "36569",
    "uf": "MG",
    "codigoIbge": 3152303,
    "cidade": "Porto Firme"
  },
  {
    "prefixo": "36570",
    "uf": "MG",
    "codigoIbge": 3171303,
    "cidade": "Viçosa"
  },
  {
    "prefixo": "36572",
    "uf": "MG",
    "codigoIbge": 3171303,
    "cidade": "Viçosa"
  },
  {
    "prefixo": "36574",
    "uf": "MG",
    "codigoIbge": 3171303,
    "cidade": "Viçosa"
  },
  {
    "prefixo": "36576",
    "uf": "MG",
    "codigoIbge": 3171303,
    "cidade": "Viçosa"
  },
  {
    "prefixo": "36578",
    "uf": "MG",
    "codigoIbge": 3171303,
    "cidade": "Viçosa"
  },
  {
    "prefixo": "36579",
    "uf": "MG",
    "codigoIbge": 3171303,
    "cidade": "Viçosa"
  },
  {
    "prefixo": "36580",
    "uf": "MG",
    "codigoIbge": 3168507,
    "cidade": "Teixeiras"
  },
  {
    "prefixo": "36585",
    "uf": "MG",
    "codigoIbge": 3148806,
    "cidade": "Pedra do Anta"
  },
  {
    "prefixo": "36590",
    "uf": "MG",
    "codigoIbge": 3163805,
    "cidade": "São Miguel do Anta"
  },
  {
    "prefixo": "36592",
    "uf": "MG",
    "codigoIbge": 3111705,
    "cidade": "Canaã"
  },
  {
    "prefixo": "36594",
    "uf": "MG",
    "codigoIbge": 3103702,
    "cidade": "Araponga"
  },
  {
    "prefixo": "36596",
    "uf": "MG",
    "codigoIbge": 3103702,
    "cidade": "Araponga"
  },
  {
    "prefixo": "36600",
    "uf": "MG",
    "codigoIbge": 3106903,
    "cidade": "Bicas"
  },
  {
    "prefixo": "36601",
    "uf": "MG",
    "codigoIbge": 3106903,
    "cidade": "Bicas"
  },
  {
    "prefixo": "36604",
    "uf": "MG",
    "codigoIbge": 3156205,
    "cidade": "Rochedo de Minas"
  },
  {
    "prefixo": "36606",
    "uf": "MG",
    "codigoIbge": 3128501,
    "cidade": "Guarará"
  },
  {
    "prefixo": "36608",
    "uf": "MG",
    "codigoIbge": 3140209,
    "cidade": "Maripá de Minas"
  },
  {
    "prefixo": "36610",
    "uf": "MG",
    "codigoIbge": 3149507,
    "cidade": "Pequeri"
  },
  {
    "prefixo": "36620",
    "uf": "MG",
    "codigoIbge": 3158607,
    "cidade": "Santana do Deserto"
  },
  {
    "prefixo": "36630",
    "uf": "MG",
    "codigoIbge": 3116209,
    "cidade": "Chiador"
  },
  {
    "prefixo": "36635",
    "uf": "MG",
    "codigoIbge": 3116209,
    "cidade": "Chiador"
  },
  {
    "prefixo": "36640",
    "uf": "MG",
    "codigoIbge": 3139805,
    "cidade": "Mar de Espanha"
  },
  {
    "prefixo": "36643",
    "uf": "MG",
    "codigoIbge": 3139805,
    "cidade": "Mar de Espanha"
  },
  {
    "prefixo": "36650",
    "uf": "MG",
    "codigoIbge": 3165602,
    "cidade": "Senador Cortes"
  },
  {
    "prefixo": "36660",
    "uf": "MG",
    "codigoIbge": 3101508,
    "cidade": "Além Paraíba"
  },
  {
    "prefixo": "36664",
    "uf": "MG",
    "codigoIbge": 3101508,
    "cidade": "Além Paraíba"
  },
  {
    "prefixo": "36670",
    "uf": "MG",
    "codigoIbge": 3160009,
    "cidade": "Santo Antônio do Aventureiro"
  },
  {
    "prefixo": "36675",
    "uf": "MG",
    "codigoIbge": 3160009,
    "cidade": "Santo Antônio do Aventureiro"
  },
  {
    "prefixo": "36680",
    "uf": "MG",
    "codigoIbge": 3162906,
    "cidade": "São João Nepomuceno"
  },
  {
    "prefixo": "36682",
    "uf": "MG",
    "codigoIbge": 3162906,
    "cidade": "São João Nepomuceno"
  },
  {
    "prefixo": "36684",
    "uf": "MG",
    "codigoIbge": 3162906,
    "cidade": "São João Nepomuceno"
  },
  {
    "prefixo": "36686",
    "uf": "MG",
    "codigoIbge": 3162906,
    "cidade": "São João Nepomuceno"
  },
  {
    "prefixo": "36687",
    "uf": "MG",
    "codigoIbge": 3162906,
    "cidade": "São João Nepomuceno"
  },
  {
    "prefixo": "36688",
    "uf": "MG",
    "codigoIbge": 3162906,
    "cidade": "São João Nepomuceno"
  },
  {
    "prefixo": "36690",
    "uf": "MG",
    "codigoIbge": 3121308,
    "cidade": "Descoberto"
  },
  {
    "prefixo": "36700",
    "uf": "MG",
    "codigoIbge": 3138401,
    "cidade": "Leopoldina"
  },
  {
    "prefixo": "36702",
    "uf": "MG",
    "codigoIbge": 3138401,
    "cidade": "Leopoldina"
  },
  {
    "prefixo": "36703",
    "uf": "MG",
    "codigoIbge": 3138401,
    "cidade": "Leopoldina"
  },
  {
    "prefixo": "36704",
    "uf": "MG",
    "codigoIbge": 3138401,
    "cidade": "Leopoldina"
  },
  {
    "prefixo": "36705",
    "uf": "MG",
    "codigoIbge": 3138401,
    "cidade": "Leopoldina"
  },
  {
    "prefixo": "36706",
    "uf": "MG",
    "codigoIbge": 3138401,
    "cidade": "Leopoldina"
  },
  {
    "prefixo": "36707",
    "uf": "MG",
    "codigoIbge": 3138401,
    "cidade": "Leopoldina"
  },
  {
    "prefixo": "36708",
    "uf": "MG",
    "codigoIbge": 3138401,
    "cidade": "Leopoldina"
  },
  {
    "prefixo": "36710",
    "uf": "MG",
    "codigoIbge": 3104403,
    "cidade": "Argirita"
  },
  {
    "prefixo": "36720",
    "uf": "MG",
    "codigoIbge": 3172103,
    "cidade": "Volta Grande"
  },
  {
    "prefixo": "36723",
    "uf": "MG",
    "codigoIbge": 3172103,
    "cidade": "Volta Grande"
  },
  {
    "prefixo": "36725",
    "uf": "MG",
    "codigoIbge": 3124609,
    "cidade": "Estrela Dalva"
  },
  {
    "prefixo": "36728",
    "uf": "MG",
    "codigoIbge": 3124609,
    "cidade": "Estrela Dalva"
  },
  {
    "prefixo": "36730",
    "uf": "MG",
    "codigoIbge": 3151107,
    "cidade": "Pirapetinga"
  },
  {
    "prefixo": "36735",
    "uf": "MG",
    "codigoIbge": 3151107,
    "cidade": "Pirapetinga"
  },
  {
    "prefixo": "36740",
    "uf": "MG",
    "codigoIbge": 3154101,
    "cidade": "Recreio"
  },
  {
    "prefixo": "36743",
    "uf": "MG",
    "codigoIbge": 3154101,
    "cidade": "Recreio"
  },
  {
    "prefixo": "36746",
    "uf": "MG",
    "codigoIbge": 3154101,
    "cidade": "Recreio"
  },
  {
    "prefixo": "36750",
    "uf": "MG",
    "codigoIbge": 3146701,
    "cidade": "Palma"
  },
  {
    "prefixo": "36753",
    "uf": "MG",
    "codigoIbge": 3146701,
    "cidade": "Palma"
  },
  {
    "prefixo": "36756",
    "uf": "MG",
    "codigoIbge": 3146701,
    "cidade": "Palma"
  },
  {
    "prefixo": "36760",
    "uf": "MG",
    "codigoIbge": 3138005,
    "cidade": "Laranjal"
  },
  {
    "prefixo": "36765",
    "uf": "MG",
    "codigoIbge": 3138005,
    "cidade": "Laranjal"
  },
  {
    "prefixo": "36770",
    "uf": "MG",
    "codigoIbge": 3115300,
    "cidade": "Cataguases"
  },
  {
    "prefixo": "36771",
    "uf": "MG",
    "codigoIbge": 3115300,
    "cidade": "Cataguases"
  },
  {
    "prefixo": "36772",
    "uf": "MG",
    "codigoIbge": 3115300,
    "cidade": "Cataguases"
  },
  {
    "prefixo": "36773",
    "uf": "MG",
    "codigoIbge": 3115300,
    "cidade": "Cataguases"
  },
  {
    "prefixo": "36774",
    "uf": "MG",
    "codigoIbge": 3115300,
    "cidade": "Cataguases"
  },
  {
    "prefixo": "36775",
    "uf": "MG",
    "codigoIbge": 3115300,
    "cidade": "Cataguases"
  },
  {
    "prefixo": "36776",
    "uf": "MG",
    "codigoIbge": 3115300,
    "cidade": "Cataguases"
  },
  {
    "prefixo": "36777",
    "uf": "MG",
    "codigoIbge": 3115300,
    "cidade": "Cataguases"
  },
  {
    "prefixo": "36778",
    "uf": "MG",
    "codigoIbge": 3115300,
    "cidade": "Cataguases"
  },
  {
    "prefixo": "36779",
    "uf": "MG",
    "codigoIbge": 3115300,
    "cidade": "Cataguases"
  },
  {
    "prefixo": "36780",
    "uf": "MG",
    "codigoIbge": 3104601,
    "cidade": "Astolfo Dutra"
  },
  {
    "prefixo": "36782",
    "uf": "MG",
    "codigoIbge": 3104601,
    "cidade": "Astolfo Dutra"
  },
  {
    "prefixo": "36783",
    "uf": "MG",
    "codigoIbge": 3104601,
    "cidade": "Astolfo Dutra"
  },
  {
    "prefixo": "36784",
    "uf": "MG",
    "codigoIbge": 3122900,
    "cidade": "Dona Euzébia"
  },
  {
    "prefixo": "36787",
    "uf": "MG",
    "codigoIbge": 3122900,
    "cidade": "Dona Euzébia"
  },
  {
    "prefixo": "36788",
    "uf": "MG",
    "codigoIbge": 3132602,
    "cidade": "Itamarati de Minas"
  },
  {
    "prefixo": "36790",
    "uf": "MG",
    "codigoIbge": 3142205,
    "cidade": "Miraí"
  },
  {
    "prefixo": "36792",
    "uf": "MG",
    "codigoIbge": 3142205,
    "cidade": "Miraí"
  },
  {
    "prefixo": "36793",
    "uf": "MG",
    "codigoIbge": 3164431,
    "cidade": "São Sebastião da Vargem Alegre"
  },
  {
    "prefixo": "36795",
    "uf": "MG",
    "codigoIbge": 3158409,
    "cidade": "Santana de Cataguases"
  },
  {
    "prefixo": "36800",
    "uf": "MG",
    "codigoIbge": 3113305,
    "cidade": "Carangola"
  },
  {
    "prefixo": "36801",
    "uf": "MG",
    "codigoIbge": 3113305,
    "cidade": "Carangola"
  },
  {
    "prefixo": "36802",
    "uf": "MG",
    "codigoIbge": 3113305,
    "cidade": "Carangola"
  },
  {
    "prefixo": "36803",
    "uf": "MG",
    "codigoIbge": 3113305,
    "cidade": "Carangola"
  },
  {
    "prefixo": "36805",
    "uf": "MG",
    "codigoIbge": 3113305,
    "cidade": "Carangola"
  },
  {
    "prefixo": "36806",
    "uf": "MG",
    "codigoIbge": 3113305,
    "cidade": "Carangola"
  },
  {
    "prefixo": "36810",
    "uf": "MG",
    "codigoIbge": 3161403,
    "cidade": "São Francisco do Glória"
  },
  {
    "prefixo": "36815",
    "uf": "MG",
    "codigoIbge": 3125952,
    "cidade": "Fervedouro"
  },
  {
    "prefixo": "36817",
    "uf": "MG",
    "codigoIbge": 3125952,
    "cidade": "Fervedouro"
  },
  {
    "prefixo": "36819",
    "uf": "MG",
    "codigoIbge": 3125952,
    "cidade": "Fervedouro"
  },
  {
    "prefixo": "36820",
    "uf": "MG",
    "codigoIbge": 3122009,
    "cidade": "Divino"
  },
  {
    "prefixo": "36825",
    "uf": "MG",
    "codigoIbge": 3122009,
    "cidade": "Divino"
  },
  {
    "prefixo": "36828",
    "uf": "MG",
    "codigoIbge": 3145877,
    "cidade": "Orizânia"
  },
  {
    "prefixo": "36830",
    "uf": "MG",
    "codigoIbge": 3124203,
    "cidade": "Espera Feliz"
  },
  {
    "prefixo": "36831",
    "uf": "MG",
    "codigoIbge": 3124203,
    "cidade": "Espera Feliz"
  },
  {
    "prefixo": "36832",
    "uf": "MG",
    "codigoIbge": 3110103,
    "cidade": "Caiana"
  },
  {
    "prefixo": "36834",
    "uf": "MG",
    "codigoIbge": 3112109,
    "cidade": "Caparaó"
  },
  {
    "prefixo": "36840",
    "uf": "MG",
    "codigoIbge": 3125309,
    "cidade": "Faria Lemos"
  },
  {
    "prefixo": "36844",
    "uf": "MG",
    "codigoIbge": 3169208,
    "cidade": "Tombos"
  },
  {
    "prefixo": "36845",
    "uf": "MG",
    "codigoIbge": 3169208,
    "cidade": "Tombos"
  },
  {
    "prefixo": "36846",
    "uf": "MG",
    "codigoIbge": 3169208,
    "cidade": "Tombos"
  },
  {
    "prefixo": "36847",
    "uf": "MG",
    "codigoIbge": 3149002,
    "cidade": "Pedra Dourada"
  },
  {
    "prefixo": "36850",
    "uf": "MG",
    "codigoIbge": 3103108,
    "cidade": "Antônio Prado de Minas"
  },
  {
    "prefixo": "36855",
    "uf": "MG",
    "codigoIbge": 3124906,
    "cidade": "Eugenópolis"
  },
  {
    "prefixo": "36857",
    "uf": "MG",
    "codigoIbge": 3124906,
    "cidade": "Eugenópolis"
  },
  {
    "prefixo": "36858",
    "uf": "MG",
    "codigoIbge": 3124906,
    "cidade": "Eugenópolis"
  },
  {
    "prefixo": "36860",
    "uf": "MG",
    "codigoIbge": 3148202,
    "cidade": "Patrocínio do Muriaé"
  },
  {
    "prefixo": "36870",
    "uf": "MG",
    "codigoIbge": 3105509,
    "cidade": "Barão do Monte Alto"
  },
  {
    "prefixo": "36873",
    "uf": "MG",
    "codigoIbge": 3105509,
    "cidade": "Barão do Monte Alto"
  },
  {
    "prefixo": "36876",
    "uf": "MG",
    "codigoIbge": 3105509,
    "cidade": "Barão do Monte Alto"
  },
  {
    "prefixo": "36877",
    "uf": "MG",
    "codigoIbge": 3105509,
    "cidade": "Barão do Monte Alto"
  },
  {
    "prefixo": "36878",
    "uf": "MG",
    "codigoIbge": 3156452,
    "cidade": "Rosário da Limeira"
  },
  {
    "prefixo": "36880",
    "uf": "MG",
    "codigoIbge": 3143906,
    "cidade": "Muriaé"
  },
  {
    "prefixo": "36881",
    "uf": "MG",
    "codigoIbge": 3143906,
    "cidade": "Muriaé"
  },
  {
    "prefixo": "36883",
    "uf": "MG",
    "codigoIbge": 3143906,
    "cidade": "Muriaé"
  },
  {
    "prefixo": "36884",
    "uf": "MG",
    "codigoIbge": 3143906,
    "cidade": "Muriaé"
  },
  {
    "prefixo": "36886",
    "uf": "MG",
    "codigoIbge": 3143906,
    "cidade": "Muriaé"
  },
  {
    "prefixo": "36887",
    "uf": "MG",
    "codigoIbge": 3143906,
    "cidade": "Muriaé"
  },
  {
    "prefixo": "36888",
    "uf": "MG",
    "codigoIbge": 3143906,
    "cidade": "Muriaé"
  },
  {
    "prefixo": "36889",
    "uf": "MG",
    "codigoIbge": 3143906,
    "cidade": "Muriaé"
  },
  {
    "prefixo": "36891",
    "uf": "MG",
    "codigoIbge": 3143906,
    "cidade": "Muriaé"
  },
  {
    "prefixo": "36892",
    "uf": "MG",
    "codigoIbge": 3143906,
    "cidade": "Muriaé"
  },
  {
    "prefixo": "36893",
    "uf": "MG",
    "codigoIbge": 3142106,
    "cidade": "Miradouro"
  },
  {
    "prefixo": "36895",
    "uf": "MG",
    "codigoIbge": 3171402,
    "cidade": "Vieiras"
  },
  {
    "prefixo": "36897",
    "uf": "MG",
    "codigoIbge": 3171402,
    "cidade": "Vieiras"
  },
  {
    "prefixo": "36900",
    "uf": "MG",
    "codigoIbge": 3139409,
    "cidade": "Manhuaçu"
  },
  {
    "prefixo": "36902",
    "uf": "MG",
    "codigoIbge": 3139409,
    "cidade": "Manhuaçu"
  },
  {
    "prefixo": "36904",
    "uf": "MG",
    "codigoIbge": 3139409,
    "cidade": "Manhuaçu"
  },
  {
    "prefixo": "36906",
    "uf": "MG",
    "codigoIbge": 3139409,
    "cidade": "Manhuaçu"
  },
  {
    "prefixo": "36908",
    "uf": "MG",
    "codigoIbge": 3139409,
    "cidade": "Manhuaçu"
  },
  {
    "prefixo": "36909",
    "uf": "MG",
    "codigoIbge": 3139409,
    "cidade": "Manhuaçu"
  },
  {
    "prefixo": "36913",
    "uf": "MG",
    "codigoIbge": 3157906,
    "cidade": "Santa Margarida"
  },
  {
    "prefixo": "36915",
    "uf": "MG",
    "codigoIbge": 3157906,
    "cidade": "Santa Margarida"
  },
  {
    "prefixo": "36918",
    "uf": "MG",
    "codigoIbge": 3162559,
    "cidade": "São João do Manhuaçu"
  },
  {
    "prefixo": "36920",
    "uf": "MG",
    "codigoIbge": 3154150,
    "cidade": "Reduto"
  },
  {
    "prefixo": "36923",
    "uf": "MG",
    "codigoIbge": 3138674,
    "cidade": "Luisburgo"
  },
  {
    "prefixo": "36925",
    "uf": "MG",
    "codigoIbge": 3112901,
    "cidade": "Caputira"
  },
  {
    "prefixo": "36930",
    "uf": "MG",
    "codigoIbge": 3167608,
    "cidade": "Simonésia"
  },
  {
    "prefixo": "36935",
    "uf": "MG",
    "codigoIbge": 3167608,
    "cidade": "Simonésia"
  },
  {
    "prefixo": "36940",
    "uf": "MG",
    "codigoIbge": 3158904,
    "cidade": "Santana do Manhuaçu"
  },
  {
    "prefixo": "36945",
    "uf": "MG",
    "codigoIbge": 3158904,
    "cidade": "Santana do Manhuaçu"
  },
  {
    "prefixo": "36947",
    "uf": "MG",
    "codigoIbge": 3117405,
    "cidade": "Conceição de Ipanema"
  },
  {
    "prefixo": "36950",
    "uf": "MG",
    "codigoIbge": 3131208,
    "cidade": "Ipanema"
  },
  {
    "prefixo": "36953",
    "uf": "MG",
    "codigoIbge": 3168051,
    "cidade": "Taparuba"
  },
  {
    "prefixo": "36955",
    "uf": "MG",
    "codigoIbge": 3144003,
    "cidade": "Mutum"
  },
  {
    "prefixo": "36956",
    "uf": "MG",
    "codigoIbge": 3144003,
    "cidade": "Mutum"
  },
  {
    "prefixo": "36957",
    "uf": "MG",
    "codigoIbge": 3144003,
    "cidade": "Mutum"
  },
  {
    "prefixo": "36958",
    "uf": "MG",
    "codigoIbge": 3144003,
    "cidade": "Mutum"
  },
  {
    "prefixo": "36959",
    "uf": "MG",
    "codigoIbge": 3144003,
    "cidade": "Mutum"
  },
  {
    "prefixo": "36960",
    "uf": "MG",
    "codigoIbge": 3151909,
    "cidade": "Pocrane"
  },
  {
    "prefixo": "36963",
    "uf": "MG",
    "codigoIbge": 3151909,
    "cidade": "Pocrane"
  },
  {
    "prefixo": "36966",
    "uf": "MG",
    "codigoIbge": 3151909,
    "cidade": "Pocrane"
  },
  {
    "prefixo": "36970",
    "uf": "MG",
    "codigoIbge": 3139508,
    "cidade": "Manhumirim"
  },
  {
    "prefixo": "36972",
    "uf": "MG",
    "codigoIbge": 3140530,
    "cidade": "Martins Soares"
  },
  {
    "prefixo": "36973",
    "uf": "MG",
    "codigoIbge": 3140530,
    "cidade": "Martins Soares"
  },
  {
    "prefixo": "36974",
    "uf": "MG",
    "codigoIbge": 3123528,
    "cidade": "Durandé"
  },
  {
    "prefixo": "36975",
    "uf": "MG",
    "codigoIbge": 3123528,
    "cidade": "Durandé"
  },
  {
    "prefixo": "36976",
    "uf": "MG",
    "codigoIbge": 3153509,
    "cidade": "Alto Jequitibá"
  },
  {
    "prefixo": "36978",
    "uf": "MG",
    "codigoIbge": 3153509,
    "cidade": "Alto Jequitibá"
  },
  {
    "prefixo": "36979",
    "uf": "MG",
    "codigoIbge": 3102050,
    "cidade": "Alto Caparaó"
  },
  {
    "prefixo": "36980",
    "uf": "MG",
    "codigoIbge": 3137700,
    "cidade": "Lajinha"
  },
  {
    "prefixo": "36984",
    "uf": "MG",
    "codigoIbge": 3137700,
    "cidade": "Lajinha"
  },
  {
    "prefixo": "36985",
    "uf": "MG",
    "codigoIbge": 3116001,
    "cidade": "Chalé"
  },
  {
    "prefixo": "36988",
    "uf": "MG",
    "codigoIbge": 3116001,
    "cidade": "Chalé"
  },
  {
    "prefixo": "36990",
    "uf": "MG",
    "codigoIbge": 3163607,
    "cidade": "São José do Mantimento"
  },
  {
    "prefixo": "37000",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37002",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37004",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37005",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37006",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37007",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37010",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37011",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37012",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37014",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37018",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37022",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37026",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37030",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37031",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37033",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37034",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37036",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37037",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37038",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37044",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37045",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37048",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37056",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37060",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37062",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37063",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37064",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37066",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37068",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37070",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37072",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37074",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37076",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37077",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37109",
    "uf": "MG",
    "codigoIbge": 3170701,
    "cidade": "Varginha"
  },
  {
    "prefixo": "37110",
    "uf": "MG",
    "codigoIbge": 3123601,
    "cidade": "Elói Mendes"
  },
  {
    "prefixo": "37115",
    "uf": "MG",
    "codigoIbge": 3143005,
    "cidade": "Monte Belo"
  },
  {
    "prefixo": "37117",
    "uf": "MG",
    "codigoIbge": 3143005,
    "cidade": "Monte Belo"
  },
  {
    "prefixo": "37118",
    "uf": "MG",
    "codigoIbge": 3143005,
    "cidade": "Monte Belo"
  },
  {
    "prefixo": "37119",
    "uf": "MG",
    "codigoIbge": 3143005,
    "cidade": "Monte Belo"
  },
  {
    "prefixo": "37120",
    "uf": "MG",
    "codigoIbge": 3147204,
    "cidade": "Paraguaçu"
  },
  {
    "prefixo": "37125",
    "uf": "MG",
    "codigoIbge": 3147204,
    "cidade": "Paraguaçu"
  },
  {
    "prefixo": "37130",
    "uf": "MG",
    "codigoIbge": 3101607,
    "cidade": "Alfenas"
  },
  {
    "prefixo": "37131",
    "uf": "MG",
    "codigoIbge": 3101607,
    "cidade": "Alfenas"
  },
  {
    "prefixo": "37132",
    "uf": "MG",
    "codigoIbge": 3101607,
    "cidade": "Alfenas"
  },
  {
    "prefixo": "37133",
    "uf": "MG",
    "codigoIbge": 3101607,
    "cidade": "Alfenas"
  },
  {
    "prefixo": "37135",
    "uf": "MG",
    "codigoIbge": 3101607,
    "cidade": "Alfenas"
  },
  {
    "prefixo": "37136",
    "uf": "MG",
    "codigoIbge": 3101607,
    "cidade": "Alfenas"
  },
  {
    "prefixo": "37137",
    "uf": "MG",
    "codigoIbge": 3101607,
    "cidade": "Alfenas"
  },
  {
    "prefixo": "37138",
    "uf": "MG",
    "codigoIbge": 3101607,
    "cidade": "Alfenas"
  },
  {
    "prefixo": "37139",
    "uf": "MG",
    "codigoIbge": 3101607,
    "cidade": "Alfenas"
  },
  {
    "prefixo": "37140",
    "uf": "MG",
    "codigoIbge": 3104304,
    "cidade": "Areado"
  },
  {
    "prefixo": "37142",
    "uf": "MG",
    "codigoIbge": 3122405,
    "cidade": "Divisa Nova"
  },
  {
    "prefixo": "37143",
    "uf": "MG",
    "codigoIbge": 3166907,
    "cidade": "Serrania"
  },
  {
    "prefixo": "37144",
    "uf": "MG",
    "codigoIbge": 3125200,
    "cidade": "Fama"
  },
  {
    "prefixo": "37145",
    "uf": "MG",
    "codigoIbge": 3102001,
    "cidade": "Alterosa"
  },
  {
    "prefixo": "37147",
    "uf": "MG",
    "codigoIbge": 3102001,
    "cidade": "Alterosa"
  },
  {
    "prefixo": "37148",
    "uf": "MG",
    "codigoIbge": 3117108,
    "cidade": "Conceição da Aparecida"
  },
  {
    "prefixo": "37150",
    "uf": "MG",
    "codigoIbge": 3114402,
    "cidade": "Carmo do Rio Claro"
  },
  {
    "prefixo": "37155",
    "uf": "MG",
    "codigoIbge": 3114402,
    "cidade": "Carmo do Rio Claro"
  },
  {
    "prefixo": "37160",
    "uf": "MG",
    "codigoIbge": 3111606,
    "cidade": "Campos Gerais"
  },
  {
    "prefixo": "37163",
    "uf": "MG",
    "codigoIbge": 3111606,
    "cidade": "Campos Gerais"
  },
  {
    "prefixo": "37165",
    "uf": "MG",
    "codigoIbge": 3111309,
    "cidade": "Campo do Meio"
  },
  {
    "prefixo": "37170",
    "uf": "MG",
    "codigoIbge": 3107109,
    "cidade": "Boa Esperança"
  },
  {
    "prefixo": "37175",
    "uf": "MG",
    "codigoIbge": 3130507,
    "cidade": "Ilicínea"
  },
  {
    "prefixo": "37177",
    "uf": "MG",
    "codigoIbge": 3128105,
    "cidade": "Guapé"
  },
  {
    "prefixo": "37180",
    "uf": "MG",
    "codigoIbge": 3128105,
    "cidade": "Guapé"
  },
  {
    "prefixo": "37185",
    "uf": "MG",
    "codigoIbge": 3169406,
    "cidade": "Três Pontas"
  },
  {
    "prefixo": "37187",
    "uf": "MG",
    "codigoIbge": 3169406,
    "cidade": "Três Pontas"
  },
  {
    "prefixo": "37188",
    "uf": "MG",
    "codigoIbge": 3169406,
    "cidade": "Três Pontas"
  },
  {
    "prefixo": "37189",
    "uf": "MG",
    "codigoIbge": 3169406,
    "cidade": "Três Pontas"
  },
  {
    "prefixo": "37190",
    "uf": "MG",
    "codigoIbge": 3169406,
    "cidade": "Três Pontas"
  },
  {
    "prefixo": "37191",
    "uf": "MG",
    "codigoIbge": 3169406,
    "cidade": "Três Pontas"
  },
  {
    "prefixo": "37192",
    "uf": "MG",
    "codigoIbge": 3169406,
    "cidade": "Três Pontas"
  },
  {
    "prefixo": "37193",
    "uf": "MG",
    "codigoIbge": 3169406,
    "cidade": "Três Pontas"
  },
  {
    "prefixo": "37195",
    "uf": "MG",
    "codigoIbge": 3158300,
    "cidade": "Santana da Vargem"
  },
  {
    "prefixo": "37200",
    "uf": "MG",
    "codigoIbge": 3138203,
    "cidade": "Lavras"
  },
  {
    "prefixo": "37201",
    "uf": "MG",
    "codigoIbge": 3138203,
    "cidade": "Lavras"
  },
  {
    "prefixo": "37202",
    "uf": "MG",
    "codigoIbge": 3138203,
    "cidade": "Lavras"
  },
  {
    "prefixo": "37203",
    "uf": "MG",
    "codigoIbge": 3138203,
    "cidade": "Lavras"
  },
  {
    "prefixo": "37204",
    "uf": "MG",
    "codigoIbge": 3138203,
    "cidade": "Lavras"
  },
  {
    "prefixo": "37205",
    "uf": "MG",
    "codigoIbge": 3138203,
    "cidade": "Lavras"
  },
  {
    "prefixo": "37206",
    "uf": "MG",
    "codigoIbge": 3138203,
    "cidade": "Lavras"
  },
  {
    "prefixo": "37207",
    "uf": "MG",
    "codigoIbge": 3138203,
    "cidade": "Lavras"
  },
  {
    "prefixo": "37208",
    "uf": "MG",
    "codigoIbge": 3138203,
    "cidade": "Lavras"
  },
  {
    "prefixo": "37209",
    "uf": "MG",
    "codigoIbge": 3138203,
    "cidade": "Lavras"
  },
  {
    "prefixo": "37210",
    "uf": "MG",
    "codigoIbge": 3134301,
    "cidade": "Itumirim"
  },
  {
    "prefixo": "37212",
    "uf": "MG",
    "codigoIbge": 3134301,
    "cidade": "Itumirim"
  },
  {
    "prefixo": "37215",
    "uf": "MG",
    "codigoIbge": 3130804,
    "cidade": "Ingaí"
  },
  {
    "prefixo": "37218",
    "uf": "MG",
    "codigoIbge": 3130408,
    "cidade": "Ijaci"
  },
  {
    "prefixo": "37220",
    "uf": "MG",
    "codigoIbge": 3108008,
    "cidade": "Bom Sucesso"
  },
  {
    "prefixo": "37221",
    "uf": "MG",
    "codigoIbge": 3108008,
    "cidade": "Bom Sucesso"
  },
  {
    "prefixo": "37223",
    "uf": "MG",
    "codigoIbge": 3130002,
    "cidade": "Ibituruna"
  },
  {
    "prefixo": "37225",
    "uf": "MG",
    "codigoIbge": 3113909,
    "cidade": "Carmo da Cachoeira"
  },
  {
    "prefixo": "37235",
    "uf": "MG",
    "codigoIbge": 3118700,
    "cidade": "Coqueiral"
  },
  {
    "prefixo": "37237",
    "uf": "MG",
    "codigoIbge": 3118700,
    "cidade": "Coqueiral"
  },
  {
    "prefixo": "37240",
    "uf": "MG",
    "codigoIbge": 3138708,
    "cidade": "Luminárias"
  },
  {
    "prefixo": "37245",
    "uf": "MG",
    "codigoIbge": 3114600,
    "cidade": "Carrancas"
  },
  {
    "prefixo": "37250",
    "uf": "MG",
    "codigoIbge": 3144607,
    "cidade": "Nepomuceno"
  },
  {
    "prefixo": "37253",
    "uf": "MG",
    "codigoIbge": 3144607,
    "cidade": "Nepomuceno"
  },
  {
    "prefixo": "37255",
    "uf": "MG",
    "codigoIbge": 3144607,
    "cidade": "Nepomuceno"
  },
  {
    "prefixo": "37260",
    "uf": "MG",
    "codigoIbge": 3149903,
    "cidade": "Perdões"
  },
  {
    "prefixo": "37262",
    "uf": "MG",
    "codigoIbge": 3159902,
    "cidade": "Santo Antônio do Amparo"
  },
  {
    "prefixo": "37264",
    "uf": "MG",
    "codigoIbge": 3154705,
    "cidade": "Ribeirão Vermelho"
  },
  {
    "prefixo": "37267",
    "uf": "MG",
    "codigoIbge": 3111903,
    "cidade": "Cana Verde"
  },
  {
    "prefixo": "37270",
    "uf": "MG",
    "codigoIbge": 3111200,
    "cidade": "Campo Belo"
  },
  {
    "prefixo": "37271",
    "uf": "MG",
    "codigoIbge": 3111200,
    "cidade": "Campo Belo"
  },
  {
    "prefixo": "37273",
    "uf": "MG",
    "codigoIbge": 3100807,
    "cidade": "Aguanil"
  },
  {
    "prefixo": "37275",
    "uf": "MG",
    "codigoIbge": 3120201,
    "cidade": "Cristais"
  },
  {
    "prefixo": "37278",
    "uf": "MG",
    "codigoIbge": 3158805,
    "cidade": "Santana do Jacaré"
  },
  {
    "prefixo": "37280",
    "uf": "MG",
    "codigoIbge": 3112000,
    "cidade": "Candeias"
  },
  {
    "prefixo": "37300",
    "uf": "MG",
    "codigoIbge": 3102803,
    "cidade": "Andrelândia"
  },
  {
    "prefixo": "37305",
    "uf": "MG",
    "codigoIbge": 3139102,
    "cidade": "Madre de Deus de Minas"
  },
  {
    "prefixo": "37310",
    "uf": "MG",
    "codigoIbge": 3107505,
    "cidade": "Bom Jardim de Minas"
  },
  {
    "prefixo": "37315",
    "uf": "MG",
    "codigoIbge": 3107505,
    "cidade": "Bom Jardim de Minas"
  },
  {
    "prefixo": "37330",
    "uf": "MG",
    "codigoIbge": 3147808,
    "cidade": "Passa Vinte"
  },
  {
    "prefixo": "37340",
    "uf": "MG",
    "codigoIbge": 3107208,
    "cidade": "Bocaina de Minas"
  },
  {
    "prefixo": "37345",
    "uf": "MG",
    "codigoIbge": 3107208,
    "cidade": "Bocaina de Minas"
  },
  {
    "prefixo": "37350",
    "uf": "MG",
    "codigoIbge": 3138500,
    "cidade": "Liberdade"
  },
  {
    "prefixo": "37360",
    "uf": "MG",
    "codigoIbge": 3103603,
    "cidade": "Arantina"
  },
  {
    "prefixo": "37370",
    "uf": "MG",
    "codigoIbge": 3165305,
    "cidade": "São Vicente de Minas"
  },
  {
    "prefixo": "37400",
    "uf": "MG",
    "codigoIbge": 3110905,
    "cidade": "Campanha"
  },
  {
    "prefixo": "37405",
    "uf": "MG",
    "codigoIbge": 3142601,
    "cidade": "Monsenhor Paulo"
  },
  {
    "prefixo": "37407",
    "uf": "MG",
    "codigoIbge": 3160801,
    "cidade": "São Bento Abade"
  },
  {
    "prefixo": "37408",
    "uf": "MG",
    "codigoIbge": 3165206,
    "cidade": "São Tomé das Letras"
  },
  {
    "prefixo": "37410",
    "uf": "MG",
    "codigoIbge": 3169307,
    "cidade": "Três Corações"
  },
  {
    "prefixo": "37411",
    "uf": "MG",
    "codigoIbge": 3169307,
    "cidade": "Três Corações"
  },
  {
    "prefixo": "37412",
    "uf": "MG",
    "codigoIbge": 3169307,
    "cidade": "Três Corações"
  },
  {
    "prefixo": "37413",
    "uf": "MG",
    "codigoIbge": 3169307,
    "cidade": "Três Corações"
  },
  {
    "prefixo": "37414",
    "uf": "MG",
    "codigoIbge": 3169307,
    "cidade": "Três Corações"
  },
  {
    "prefixo": "37415",
    "uf": "MG",
    "codigoIbge": 3169307,
    "cidade": "Três Corações"
  },
  {
    "prefixo": "37416",
    "uf": "MG",
    "codigoIbge": 3169307,
    "cidade": "Três Corações"
  },
  {
    "prefixo": "37417",
    "uf": "MG",
    "codigoIbge": 3169307,
    "cidade": "Três Corações"
  },
  {
    "prefixo": "37418",
    "uf": "MG",
    "codigoIbge": 3169307,
    "cidade": "Três Corações"
  },
  {
    "prefixo": "37420",
    "uf": "MG",
    "codigoIbge": 3110707,
    "cidade": "Cambuquira"
  },
  {
    "prefixo": "37430",
    "uf": "MG",
    "codigoIbge": 3117702,
    "cidade": "Conceição do Rio Verde"
  },
  {
    "prefixo": "37435",
    "uf": "MG",
    "codigoIbge": 3117702,
    "cidade": "Conceição do Rio Verde"
  },
  {
    "prefixo": "37440",
    "uf": "MG",
    "codigoIbge": 3115508,
    "cidade": "Caxambu"
  },
  {
    "prefixo": "37443",
    "uf": "MG",
    "codigoIbge": 3104908,
    "cidade": "Baependi"
  },
  {
    "prefixo": "37445",
    "uf": "MG",
    "codigoIbge": 3120805,
    "cidade": "Cruzília"
  },
  {
    "prefixo": "37447",
    "uf": "MG",
    "codigoIbge": 3141900,
    "cidade": "Minduri"
  },
  {
    "prefixo": "37450",
    "uf": "MG",
    "codigoIbge": 3101201,
    "cidade": "Aiuruoca"
  },
  {
    "prefixo": "37452",
    "uf": "MG",
    "codigoIbge": 3167004,
    "cidade": "Serranos"
  },
  {
    "prefixo": "37454",
    "uf": "MG",
    "codigoIbge": 3166402,
    "cidade": "Seritinga"
  },
  {
    "prefixo": "37456",
    "uf": "MG",
    "codigoIbge": 3114808,
    "cidade": "Carvalhos"
  },
  {
    "prefixo": "37458",
    "uf": "MG",
    "codigoIbge": 3101300,
    "cidade": "Alagoa"
  },
  {
    "prefixo": "37460",
    "uf": "MG",
    "codigoIbge": 3147600,
    "cidade": "Passa Quatro"
  },
  {
    "prefixo": "37461",
    "uf": "MG",
    "codigoIbge": 3147600,
    "cidade": "Passa Quatro"
  },
  {
    "prefixo": "37462",
    "uf": "MG",
    "codigoIbge": 3147600,
    "cidade": "Passa Quatro"
  },
  {
    "prefixo": "37464",
    "uf": "MG",
    "codigoIbge": 3133105,
    "cidade": "Itanhandu"
  },
  {
    "prefixo": "37465",
    "uf": "MG",
    "codigoIbge": 3171709,
    "cidade": "Virgínia"
  },
  {
    "prefixo": "37466",
    "uf": "MG",
    "codigoIbge": 3133006,
    "cidade": "Itamonte"
  },
  {
    "prefixo": "37467",
    "uf": "MG",
    "codigoIbge": 3164902,
    "cidade": "São Sebastião do Rio Verde"
  },
  {
    "prefixo": "37468",
    "uf": "MG",
    "codigoIbge": 3152600,
    "cidade": "Pouso Alto"
  },
  {
    "prefixo": "37469",
    "uf": "MG",
    "codigoIbge": 3152600,
    "cidade": "Pouso Alto"
  },
  {
    "prefixo": "37470",
    "uf": "MG",
    "codigoIbge": 3163706,
    "cidade": "São Lourenço"
  },
  {
    "prefixo": "37472",
    "uf": "MG",
    "codigoIbge": 3114105,
    "cidade": "Carmo de Minas"
  },
  {
    "prefixo": "37474",
    "uf": "MG",
    "codigoIbge": 3122801,
    "cidade": "Dom Viçoso"
  },
  {
    "prefixo": "37476",
    "uf": "MG",
    "codigoIbge": 3120508,
    "cidade": "Cristina"
  },
  {
    "prefixo": "37478",
    "uf": "MG",
    "codigoIbge": 3167806,
    "cidade": "Soledade de Minas"
  },
  {
    "prefixo": "37480",
    "uf": "MG",
    "codigoIbge": 3137809,
    "cidade": "Lambari"
  },
  {
    "prefixo": "37484",
    "uf": "MG",
    "codigoIbge": 3129202,
    "cidade": "Heliodora"
  },
  {
    "prefixo": "37485",
    "uf": "MG",
    "codigoIbge": 3135902,
    "cidade": "Jesuânia"
  },
  {
    "prefixo": "37488",
    "uf": "MG",
    "codigoIbge": 3145505,
    "cidade": "Olímpio Noronha"
  },
  {
    "prefixo": "37490",
    "uf": "MG",
    "codigoIbge": 3162005,
    "cidade": "São Gonçalo do Sapucaí"
  },
  {
    "prefixo": "37492",
    "uf": "MG",
    "codigoIbge": 3162005,
    "cidade": "São Gonçalo do Sapucaí"
  },
  {
    "prefixo": "37493",
    "uf": "MG",
    "codigoIbge": 3162005,
    "cidade": "São Gonçalo do Sapucaí"
  },
  {
    "prefixo": "37496",
    "uf": "MG",
    "codigoIbge": 3169802,
    "cidade": "Turvolândia"
  },
  {
    "prefixo": "37498",
    "uf": "MG",
    "codigoIbge": 3119005,
    "cidade": "Cordislândia"
  },
  {
    "prefixo": "37500",
    "uf": "MG",
    "codigoIbge": 3132404,
    "cidade": "Itajubá"
  },
  {
    "prefixo": "37501",
    "uf": "MG",
    "codigoIbge": 3132404,
    "cidade": "Itajubá"
  },
  {
    "prefixo": "37502",
    "uf": "MG",
    "codigoIbge": 3132404,
    "cidade": "Itajubá"
  },
  {
    "prefixo": "37503",
    "uf": "MG",
    "codigoIbge": 3132404,
    "cidade": "Itajubá"
  },
  {
    "prefixo": "37504",
    "uf": "MG",
    "codigoIbge": 3132404,
    "cidade": "Itajubá"
  },
  {
    "prefixo": "37505",
    "uf": "MG",
    "codigoIbge": 3132404,
    "cidade": "Itajubá"
  },
  {
    "prefixo": "37506",
    "uf": "MG",
    "codigoIbge": 3132404,
    "cidade": "Itajubá"
  },
  {
    "prefixo": "37507",
    "uf": "MG",
    "codigoIbge": 3132404,
    "cidade": "Itajubá"
  },
  {
    "prefixo": "37508",
    "uf": "MG",
    "codigoIbge": 3151008,
    "cidade": "Piranguinho"
  },
  {
    "prefixo": "37509",
    "uf": "MG",
    "codigoIbge": 3151008,
    "cidade": "Piranguinho"
  },
  {
    "prefixo": "37510",
    "uf": "MG",
    "codigoIbge": 3163201,
    "cidade": "São José do Alegre"
  },
  {
    "prefixo": "37511",
    "uf": "MG",
    "codigoIbge": 3150901,
    "cidade": "Piranguçu"
  },
  {
    "prefixo": "37512",
    "uf": "MG",
    "codigoIbge": 3172202,
    "cidade": "Wenceslau Braz"
  },
  {
    "prefixo": "37513",
    "uf": "MG",
    "codigoIbge": 3172202,
    "cidade": "Wenceslau Braz"
  },
  {
    "prefixo": "37514",
    "uf": "MG",
    "codigoIbge": 3121100,
    "cidade": "Delfim Moreira"
  },
  {
    "prefixo": "37516",
    "uf": "MG",
    "codigoIbge": 3140407,
    "cidade": "Marmelópolis"
  },
  {
    "prefixo": "37517",
    "uf": "MG",
    "codigoIbge": 3139904,
    "cidade": "Maria da Fé"
  },
  {
    "prefixo": "37518",
    "uf": "MG",
    "codigoIbge": 3139904,
    "cidade": "Maria da Fé"
  },
  {
    "prefixo": "37520",
    "uf": "MG",
    "codigoIbge": 3149101,
    "cidade": "Pedralva"
  },
  {
    "prefixo": "37524",
    "uf": "MG",
    "codigoIbge": 3144409,
    "cidade": "Natércia"
  },
  {
    "prefixo": "37527",
    "uf": "MG",
    "codigoIbge": 3117207,
    "cidade": "Conceição das Pedras"
  },
  {
    "prefixo": "37530",
    "uf": "MG",
    "codigoIbge": 3108909,
    "cidade": "Brazópolis"
  },
  {
    "prefixo": "37532",
    "uf": "MG",
    "codigoIbge": 3108909,
    "cidade": "Brazópolis"
  },
  {
    "prefixo": "37535",
    "uf": "MG",
    "codigoIbge": 3108909,
    "cidade": "Brazópolis"
  },
  {
    "prefixo": "37536",
    "uf": "MG",
    "codigoIbge": 3159605,
    "cidade": "Santa Rita do Sapucaí"
  },
  {
    "prefixo": "37537",
    "uf": "MG",
    "codigoIbge": 3159605,
    "cidade": "Santa Rita do Sapucaí"
  },
  {
    "prefixo": "37538",
    "uf": "MG",
    "codigoIbge": 3159605,
    "cidade": "Santa Rita do Sapucaí"
  },
  {
    "prefixo": "37539",
    "uf": "MG",
    "codigoIbge": 3159605,
    "cidade": "Santa Rita do Sapucaí"
  },
  {
    "prefixo": "37540",
    "uf": "MG",
    "codigoIbge": 3159605,
    "cidade": "Santa Rita do Sapucaí"
  },
  {
    "prefixo": "37542",
    "uf": "MG",
    "codigoIbge": 3124500,
    "cidade": "Estiva"
  },
  {
    "prefixo": "37543",
    "uf": "MG",
    "codigoIbge": 3124500,
    "cidade": "Estiva"
  },
  {
    "prefixo": "37545",
    "uf": "MG",
    "codigoIbge": 3109709,
    "cidade": "Cachoeira de Minas"
  },
  {
    "prefixo": "37546",
    "uf": "MG",
    "codigoIbge": 3109709,
    "cidade": "Cachoeira de Minas"
  },
  {
    "prefixo": "37548",
    "uf": "MG",
    "codigoIbge": 3117801,
    "cidade": "Conceição dos Ouros"
  },
  {
    "prefixo": "37550",
    "uf": "MG",
    "codigoIbge": 3152501,
    "cidade": "Pouso Alegre"
  },
  {
    "prefixo": "37551",
    "uf": "MG",
    "codigoIbge": 3152501,
    "cidade": "Pouso Alegre"
  },
  {
    "prefixo": "37552",
    "uf": "MG",
    "codigoIbge": 3152501,
    "cidade": "Pouso Alegre"
  },
  {
    "prefixo": "37553",
    "uf": "MG",
    "codigoIbge": 3152501,
    "cidade": "Pouso Alegre"
  },
  {
    "prefixo": "37554",
    "uf": "MG",
    "codigoIbge": 3152501,
    "cidade": "Pouso Alegre"
  },
  {
    "prefixo": "37555",
    "uf": "MG",
    "codigoIbge": 3152501,
    "cidade": "Pouso Alegre"
  },
  {
    "prefixo": "37556",
    "uf": "MG",
    "codigoIbge": 3152501,
    "cidade": "Pouso Alegre"
  },
  {
    "prefixo": "37557",
    "uf": "MG",
    "codigoIbge": 3152501,
    "cidade": "Pouso Alegre"
  },
  {
    "prefixo": "37558",
    "uf": "MG",
    "codigoIbge": 3152501,
    "cidade": "Pouso Alegre"
  },
  {
    "prefixo": "37559",
    "uf": "MG",
    "codigoIbge": 3152501,
    "cidade": "Pouso Alegre"
  },
  {
    "prefixo": "37560",
    "uf": "MG",
    "codigoIbge": 3152501,
    "cidade": "Pouso Alegre"
  },
  {
    "prefixo": "37561",
    "uf": "MG",
    "codigoIbge": 3152501,
    "cidade": "Pouso Alegre"
  },
  {
    "prefixo": "37562",
    "uf": "MG",
    "codigoIbge": 3152501,
    "cidade": "Pouso Alegre"
  },
  {
    "prefixo": "37563",
    "uf": "MG",
    "codigoIbge": 3169059,
    "cidade": "Tocos do Moji"
  },
  {
    "prefixo": "37564",
    "uf": "MG",
    "codigoIbge": 3108305,
    "cidade": "Borda da Mata"
  },
  {
    "prefixo": "37565",
    "uf": "MG",
    "codigoIbge": 3108305,
    "cidade": "Borda da Mata"
  },
  {
    "prefixo": "37566",
    "uf": "MG",
    "codigoIbge": 3124401,
    "cidade": "Espírito Santo do Dourado"
  },
  {
    "prefixo": "37567",
    "uf": "MG",
    "codigoIbge": 3164407,
    "cidade": "São Sebastião da Bela Vista"
  },
  {
    "prefixo": "37568",
    "uf": "MG",
    "codigoIbge": 3162302,
    "cidade": "São João da Mata"
  },
  {
    "prefixo": "37570",
    "uf": "MG",
    "codigoIbge": 3146008,
    "cidade": "Ouro Fino"
  },
  {
    "prefixo": "37572",
    "uf": "MG",
    "codigoIbge": 3146008,
    "cidade": "Ouro Fino"
  },
  {
    "prefixo": "37574",
    "uf": "MG",
    "codigoIbge": 3146008,
    "cidade": "Ouro Fino"
  },
  {
    "prefixo": "37576",
    "uf": "MG",
    "codigoIbge": 3130606,
    "cidade": "Inconfidentes"
  },
  {
    "prefixo": "37578",
    "uf": "MG",
    "codigoIbge": 3109105,
    "cidade": "Bueno Brandão"
  },
  {
    "prefixo": "37580",
    "uf": "MG",
    "codigoIbge": 3143401,
    "cidade": "Monte Sião"
  },
  {
    "prefixo": "37582",
    "uf": "MG",
    "codigoIbge": 3113602,
    "cidade": "Careaçu"
  },
  {
    "prefixo": "37584",
    "uf": "MG",
    "codigoIbge": 3117900,
    "cidade": "Congonhal"
  },
  {
    "prefixo": "37586",
    "uf": "MG",
    "codigoIbge": 3165800,
    "cidade": "Senador José Bento"
  },
  {
    "prefixo": "37588",
    "uf": "MG",
    "codigoIbge": 3131505,
    "cidade": "Ipuiúna"
  },
  {
    "prefixo": "37589",
    "uf": "MG",
    "codigoIbge": 3167400,
    "cidade": "Silvianópolis"
  },
  {
    "prefixo": "37590",
    "uf": "MG",
    "codigoIbge": 3134905,
    "cidade": "Jacutinga"
  },
  {
    "prefixo": "37592",
    "uf": "MG",
    "codigoIbge": 3134905,
    "cidade": "Jacutinga"
  },
  {
    "prefixo": "37594",
    "uf": "MG",
    "codigoIbge": 3134905,
    "cidade": "Jacutinga"
  },
  {
    "prefixo": "37596",
    "uf": "MG",
    "codigoIbge": 3101409,
    "cidade": "Albertina"
  },
  {
    "prefixo": "37600",
    "uf": "MG",
    "codigoIbge": 3110608,
    "cidade": "Cambuí"
  },
  {
    "prefixo": "37605",
    "uf": "MG",
    "codigoIbge": 3119906,
    "cidade": "Córrego do Bom Jesus"
  },
  {
    "prefixo": "37610",
    "uf": "MG",
    "codigoIbge": 3107901,
    "cidade": "Bom Repouso"
  },
  {
    "prefixo": "37615",
    "uf": "MG",
    "codigoIbge": 3165578,
    "cidade": "Senador Amaral"
  },
  {
    "prefixo": "37618",
    "uf": "MG",
    "codigoIbge": 3165578,
    "cidade": "Senador Amaral"
  },
  {
    "prefixo": "37620",
    "uf": "MG",
    "codigoIbge": 3143807,
    "cidade": "Munhoz"
  },
  {
    "prefixo": "37630",
    "uf": "MG",
    "codigoIbge": 3169109,
    "cidade": "Toledo"
  },
  {
    "prefixo": "37640",
    "uf": "MG",
    "codigoIbge": 3125101,
    "cidade": "Extrema"
  },
  {
    "prefixo": "37642",
    "uf": "MG",
    "codigoIbge": 3125101,
    "cidade": "Extrema"
  },
  {
    "prefixo": "37644",
    "uf": "MG",
    "codigoIbge": 3125101,
    "cidade": "Extrema"
  },
  {
    "prefixo": "37645",
    "uf": "MG",
    "codigoIbge": 3125101,
    "cidade": "Extrema"
  },
  {
    "prefixo": "37646",
    "uf": "MG",
    "codigoIbge": 3125101,
    "cidade": "Extrema"
  },
  {
    "prefixo": "37647",
    "uf": "MG",
    "codigoIbge": 3125101,
    "cidade": "Extrema"
  },
  {
    "prefixo": "37650",
    "uf": "MG",
    "codigoIbge": 3110509,
    "cidade": "Camanducaia"
  },
  {
    "prefixo": "37652",
    "uf": "MG",
    "codigoIbge": 3110509,
    "cidade": "Camanducaia"
  },
  {
    "prefixo": "37653",
    "uf": "MG",
    "codigoIbge": 3110509,
    "cidade": "Camanducaia"
  },
  {
    "prefixo": "37655",
    "uf": "MG",
    "codigoIbge": 3133600,
    "cidade": "Itapeva"
  },
  {
    "prefixo": "37660",
    "uf": "MG",
    "codigoIbge": 3147303,
    "cidade": "Paraisópolis"
  },
  {
    "prefixo": "37665",
    "uf": "MG",
    "codigoIbge": 3147303,
    "cidade": "Paraisópolis"
  },
  {
    "prefixo": "37670",
    "uf": "MG",
    "codigoIbge": 3118502,
    "cidade": "Consolação"
  },
  {
    "prefixo": "37680",
    "uf": "MG",
    "codigoIbge": 3127404,
    "cidade": "Gonçalves"
  },
  {
    "prefixo": "37690",
    "uf": "MG",
    "codigoIbge": 3165404,
    "cidade": "Sapucaí-Mirim"
  },
  {
    "prefixo": "37700",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37701",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37702",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37703",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37704",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37705",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37706",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37708",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37709",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37710",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37713",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37714",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37715",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37716",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37718",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37719",
    "uf": "MG",
    "codigoIbge": 3151800,
    "cidade": "Poços de Caldas"
  },
  {
    "prefixo": "37720",
    "uf": "MG",
    "codigoIbge": 3108404,
    "cidade": "Botelhos"
  },
  {
    "prefixo": "37723",
    "uf": "MG",
    "codigoIbge": 3108404,
    "cidade": "Botelhos"
  },
  {
    "prefixo": "37725",
    "uf": "MG",
    "codigoIbge": 3108404,
    "cidade": "Botelhos"
  },
  {
    "prefixo": "37730",
    "uf": "MG",
    "codigoIbge": 3111002,
    "cidade": "Campestre"
  },
  {
    "prefixo": "37740",
    "uf": "MG",
    "codigoIbge": 3105301,
    "cidade": "Bandeira do Sul"
  },
  {
    "prefixo": "37750",
    "uf": "MG",
    "codigoIbge": 3139003,
    "cidade": "Machado"
  },
  {
    "prefixo": "37755",
    "uf": "MG",
    "codigoIbge": 3139003,
    "cidade": "Machado"
  },
  {
    "prefixo": "37757",
    "uf": "MG",
    "codigoIbge": 3151701,
    "cidade": "Poço Fundo"
  },
  {
    "prefixo": "37758",
    "uf": "MG",
    "codigoIbge": 3151701,
    "cidade": "Poço Fundo"
  },
  {
    "prefixo": "37760",
    "uf": "MG",
    "codigoIbge": 3114709,
    "cidade": "Carvalhópolis"
  },
  {
    "prefixo": "37775",
    "uf": "MG",
    "codigoIbge": 3159209,
    "cidade": "Santa Rita de Caldas"
  },
  {
    "prefixo": "37776",
    "uf": "MG",
    "codigoIbge": 3159209,
    "cidade": "Santa Rita de Caldas"
  },
  {
    "prefixo": "37778",
    "uf": "MG",
    "codigoIbge": 3159209,
    "cidade": "Santa Rita de Caldas"
  },
  {
    "prefixo": "37780",
    "uf": "MG",
    "codigoIbge": 3110301,
    "cidade": "Caldas"
  },
  {
    "prefixo": "37782",
    "uf": "MG",
    "codigoIbge": 3110301,
    "cidade": "Caldas"
  },
  {
    "prefixo": "37785",
    "uf": "MG",
    "codigoIbge": 3110301,
    "cidade": "Caldas"
  },
  {
    "prefixo": "37787",
    "uf": "MG",
    "codigoIbge": 3110301,
    "cidade": "Caldas"
  },
  {
    "prefixo": "37790",
    "uf": "MG",
    "codigoIbge": 3129905,
    "cidade": "Ibitiúra de Minas"
  },
  {
    "prefixo": "37795",
    "uf": "MG",
    "codigoIbge": 3102605,
    "cidade": "Andradas"
  },
  {
    "prefixo": "37797",
    "uf": "MG",
    "codigoIbge": 3102605,
    "cidade": "Andradas"
  },
  {
    "prefixo": "37800",
    "uf": "MG",
    "codigoIbge": 3128709,
    "cidade": "Guaxupé"
  },
  {
    "prefixo": "37805",
    "uf": "MG",
    "codigoIbge": 3136900,
    "cidade": "Juruaia"
  },
  {
    "prefixo": "37810",
    "uf": "MG",
    "codigoIbge": 3128303,
    "cidade": "Guaranésia"
  },
  {
    "prefixo": "37815",
    "uf": "MG",
    "codigoIbge": 3128303,
    "cidade": "Guaranésia"
  },
  {
    "prefixo": "37820",
    "uf": "MG",
    "codigoIbge": 3104106,
    "cidade": "Arceburgo"
  },
  {
    "prefixo": "37830",
    "uf": "MG",
    "codigoIbge": 3128709,
    "cidade": "Guaxupé"
  },
  {
    "prefixo": "37831",
    "uf": "MG",
    "codigoIbge": 3128709,
    "cidade": "Guaxupé"
  },
  {
    "prefixo": "37832",
    "uf": "MG",
    "codigoIbge": 3128709,
    "cidade": "Guaxupé"
  },
  {
    "prefixo": "37834",
    "uf": "MG",
    "codigoIbge": 3128709,
    "cidade": "Guaxupé"
  },
  {
    "prefixo": "37836",
    "uf": "MG",
    "codigoIbge": 3128709,
    "cidade": "Guaxupé"
  },
  {
    "prefixo": "37837",
    "uf": "MG",
    "codigoIbge": 3128709,
    "cidade": "Guaxupé"
  },
  {
    "prefixo": "37838",
    "uf": "MG",
    "codigoIbge": 3102605,
    "cidade": "Andradas"
  },
  {
    "prefixo": "37839",
    "uf": "MG",
    "codigoIbge": 3102605,
    "cidade": "Andradas"
  },
  {
    "prefixo": "37840",
    "uf": "MG",
    "codigoIbge": 3102605,
    "cidade": "Andradas"
  },
  {
    "prefixo": "37841",
    "uf": "MG",
    "codigoIbge": 3102605,
    "cidade": "Andradas"
  },
  {
    "prefixo": "37842",
    "uf": "MG",
    "codigoIbge": 3102605,
    "cidade": "Andradas"
  },
  {
    "prefixo": "37855",
    "uf": "MG",
    "codigoIbge": 3163904,
    "cidade": "São Pedro da União"
  },
  {
    "prefixo": "37860",
    "uf": "MG",
    "codigoIbge": 3145109,
    "cidade": "Nova Resende"
  },
  {
    "prefixo": "37865",
    "uf": "MG",
    "codigoIbge": 3145109,
    "cidade": "Nova Resende"
  },
  {
    "prefixo": "37880",
    "uf": "MG",
    "codigoIbge": 3109501,
    "cidade": "Cabo Verde"
  },
  {
    "prefixo": "37885",
    "uf": "MG",
    "codigoIbge": 3109501,
    "cidade": "Cabo Verde"
  },
  {
    "prefixo": "37889",
    "uf": "MG",
    "codigoIbge": 3109501,
    "cidade": "Cabo Verde"
  },
  {
    "prefixo": "37890",
    "uf": "MG",
    "codigoIbge": 3144102,
    "cidade": "Muzambinho"
  },
  {
    "prefixo": "37900",
    "uf": "MG",
    "codigoIbge": 3147907,
    "cidade": "Passos"
  },
  {
    "prefixo": "37901",
    "uf": "MG",
    "codigoIbge": 3147907,
    "cidade": "Passos"
  },
  {
    "prefixo": "37902",
    "uf": "MG",
    "codigoIbge": 3147907,
    "cidade": "Passos"
  },
  {
    "prefixo": "37903",
    "uf": "MG",
    "codigoIbge": 3147907,
    "cidade": "Passos"
  },
  {
    "prefixo": "37904",
    "uf": "MG",
    "codigoIbge": 3147907,
    "cidade": "Passos"
  },
  {
    "prefixo": "37905",
    "uf": "MG",
    "codigoIbge": 3126307,
    "cidade": "Fortaleza de Minas"
  },
  {
    "prefixo": "37910",
    "uf": "MG",
    "codigoIbge": 3121209,
    "cidade": "Delfinópolis"
  },
  {
    "prefixo": "37915",
    "uf": "MG",
    "codigoIbge": 3121209,
    "cidade": "Delfinópolis"
  },
  {
    "prefixo": "37920",
    "uf": "MG",
    "codigoIbge": 3162203,
    "cidade": "São João Batista do Glória"
  },
  {
    "prefixo": "37922",
    "uf": "MG",
    "codigoIbge": 3170602,
    "cidade": "Vargem Bonita"
  },
  {
    "prefixo": "37925",
    "uf": "MG",
    "codigoIbge": 3151503,
    "cidade": "Piumhi"
  },
  {
    "prefixo": "37926",
    "uf": "MG",
    "codigoIbge": 3123403,
    "cidade": "Doresópolis"
  },
  {
    "prefixo": "37927",
    "uf": "MG",
    "codigoIbge": 3164308,
    "cidade": "São Roque de Minas"
  },
  {
    "prefixo": "37928",
    "uf": "MG",
    "codigoIbge": 3164308,
    "cidade": "São Roque de Minas"
  },
  {
    "prefixo": "37929",
    "uf": "MG",
    "codigoIbge": 3164308,
    "cidade": "São Roque de Minas"
  },
  {
    "prefixo": "37930",
    "uf": "MG",
    "codigoIbge": 3112802,
    "cidade": "Capitólio"
  },
  {
    "prefixo": "37940",
    "uf": "MG",
    "codigoIbge": 3101904,
    "cidade": "Alpinópolis"
  },
  {
    "prefixo": "37945",
    "uf": "MG",
    "codigoIbge": 3162948,
    "cidade": "São José da Barra"
  },
  {
    "prefixo": "37948",
    "uf": "MG",
    "codigoIbge": 3107604,
    "cidade": "Bom Jesus da Penha"
  },
  {
    "prefixo": "37950",
    "uf": "MG",
    "codigoIbge": 3164704,
    "cidade": "São Sebastião do Paraíso"
  },
  {
    "prefixo": "37951",
    "uf": "MG",
    "codigoIbge": 3164704,
    "cidade": "São Sebastião do Paraíso"
  },
  {
    "prefixo": "37952",
    "uf": "MG",
    "codigoIbge": 3164704,
    "cidade": "São Sebastião do Paraíso"
  },
  {
    "prefixo": "37953",
    "uf": "MG",
    "codigoIbge": 3164704,
    "cidade": "São Sebastião do Paraíso"
  },
  {
    "prefixo": "37954",
    "uf": "MG",
    "codigoIbge": 3164704,
    "cidade": "São Sebastião do Paraíso"
  },
  {
    "prefixo": "37955",
    "uf": "MG",
    "codigoIbge": 3164704,
    "cidade": "São Sebastião do Paraíso"
  },
  {
    "prefixo": "37956",
    "uf": "MG",
    "codigoIbge": 3164704,
    "cidade": "São Sebastião do Paraíso"
  },
  {
    "prefixo": "37957",
    "uf": "MG",
    "codigoIbge": 3164704,
    "cidade": "São Sebastião do Paraíso"
  },
  {
    "prefixo": "37959",
    "uf": "MG",
    "codigoIbge": 3164704,
    "cidade": "São Sebastião do Paraíso"
  },
  {
    "prefixo": "37960",
    "uf": "MG",
    "codigoIbge": 3165107,
    "cidade": "São Tomás de Aquino"
  },
  {
    "prefixo": "37965",
    "uf": "MG",
    "codigoIbge": 3134806,
    "cidade": "Jacuí"
  },
  {
    "prefixo": "37968",
    "uf": "MG",
    "codigoIbge": 3143203,
    "cidade": "Monte Santo de Minas"
  },
  {
    "prefixo": "37969",
    "uf": "MG",
    "codigoIbge": 3143203,
    "cidade": "Monte Santo de Minas"
  },
  {
    "prefixo": "37970",
    "uf": "MG",
    "codigoIbge": 3152907,
    "cidade": "Pratápolis"
  },
  {
    "prefixo": "37973",
    "uf": "MG",
    "codigoIbge": 3132909,
    "cidade": "Itamogi"
  },
  {
    "prefixo": "37975",
    "uf": "MG",
    "codigoIbge": 3133758,
    "cidade": "Itaú de Minas"
  },
  {
    "prefixo": "37980",
    "uf": "MG",
    "codigoIbge": 3115102,
    "cidade": "Cássia"
  },
  {
    "prefixo": "37990",
    "uf": "MG",
    "codigoIbge": 3129707,
    "cidade": "Ibiraci"
  },
  {
    "prefixo": "37993",
    "uf": "MG",
    "codigoIbge": 3112406,
    "cidade": "Capetinga"
  },
  {
    "prefixo": "37994",
    "uf": "MG",
    "codigoIbge": 3112406,
    "cidade": "Capetinga"
  },
  {
    "prefixo": "37997",
    "uf": "MG",
    "codigoIbge": 3116407,
    "cidade": "Claraval"
  },
  {
    "prefixo": "38000",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38001",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38010",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38015",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38017",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38020",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38022",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38025",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38026",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38028",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38030",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38031",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38035",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38036",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38037",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38038",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38039",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38040",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38041",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38042",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38044",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38045",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38046",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38047",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38048",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38049",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38050",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38051",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38052",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38055",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38056",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38057",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38059",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38060",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38061",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38064",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38065",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38066",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38067",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38070",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38071",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38072",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38073",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38074",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38079",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38080",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38081",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38082",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38099",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38101",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38106",
    "uf": "MG",
    "codigoIbge": 3170107,
    "cidade": "Uberaba"
  },
  {
    "prefixo": "38108",
    "uf": "MG",
    "codigoIbge": 3121258,
    "cidade": "Delta"
  },
  {
    "prefixo": "38110",
    "uf": "MG",
    "codigoIbge": 3100708,
    "cidade": "Água Comprida"
  },
  {
    "prefixo": "38120",
    "uf": "MG",
    "codigoIbge": 3117306,
    "cidade": "Conceição das Alagoas"
  },
  {
    "prefixo": "38126",
    "uf": "MG",
    "codigoIbge": 3117306,
    "cidade": "Conceição das Alagoas"
  },
  {
    "prefixo": "38130",
    "uf": "MG",
    "codigoIbge": 3111408,
    "cidade": "Campo Florido"
  },
  {
    "prefixo": "38140",
    "uf": "MG",
    "codigoIbge": 3152808,
    "cidade": "Prata"
  },
  {
    "prefixo": "38142",
    "uf": "MG",
    "codigoIbge": 3152808,
    "cidade": "Prata"
  },
  {
    "prefixo": "38145",
    "uf": "MG",
    "codigoIbge": 3152808,
    "cidade": "Prata"
  },
  {
    "prefixo": "38150",
    "uf": "MG",
    "codigoIbge": 3171105,
    "cidade": "Veríssimo"
  },
  {
    "prefixo": "38160",
    "uf": "MG",
    "codigoIbge": 3145000,
    "cidade": "Nova Ponte"
  },
  {
    "prefixo": "38170",
    "uf": "MG",
    "codigoIbge": 3149804,
    "cidade": "Perdizes"
  },
  {
    "prefixo": "38175",
    "uf": "MG",
    "codigoIbge": 3157708,
    "cidade": "Santa Juliana"
  },
  {
    "prefixo": "38176",
    "uf": "MG",
    "codigoIbge": 3157708,
    "cidade": "Santa Juliana"
  },
  {
    "prefixo": "38178",
    "uf": "MG",
    "codigoIbge": 3149200,
    "cidade": "Pedrinópolis"
  },
  {
    "prefixo": "38180",
    "uf": "MG",
    "codigoIbge": 3104007,
    "cidade": "Araxá"
  },
  {
    "prefixo": "38181",
    "uf": "MG",
    "codigoIbge": 3104007,
    "cidade": "Araxá"
  },
  {
    "prefixo": "38182",
    "uf": "MG",
    "codigoIbge": 3104007,
    "cidade": "Araxá"
  },
  {
    "prefixo": "38183",
    "uf": "MG",
    "codigoIbge": 3104007,
    "cidade": "Araxá"
  },
  {
    "prefixo": "38184",
    "uf": "MG",
    "codigoIbge": 3104007,
    "cidade": "Araxá"
  },
  {
    "prefixo": "38185",
    "uf": "MG",
    "codigoIbge": 3168101,
    "cidade": "Tapira"
  },
  {
    "prefixo": "38190",
    "uf": "MG",
    "codigoIbge": 3156908,
    "cidade": "Sacramento"
  },
  {
    "prefixo": "38193",
    "uf": "MG",
    "codigoIbge": 3156908,
    "cidade": "Sacramento"
  },
  {
    "prefixo": "38195",
    "uf": "MG",
    "codigoIbge": 3118205,
    "cidade": "Conquista"
  },
  {
    "prefixo": "38196",
    "uf": "MG",
    "codigoIbge": 3118205,
    "cidade": "Conquista"
  },
  {
    "prefixo": "38198",
    "uf": "MG",
    "codigoIbge": 3118205,
    "cidade": "Conquista"
  },
  {
    "prefixo": "38200",
    "uf": "MG",
    "codigoIbge": 3127107,
    "cidade": "Frutal"
  },
  {
    "prefixo": "38202",
    "uf": "MG",
    "codigoIbge": 3127107,
    "cidade": "Frutal"
  },
  {
    "prefixo": "38203",
    "uf": "MG",
    "codigoIbge": 3127107,
    "cidade": "Frutal"
  },
  {
    "prefixo": "38204",
    "uf": "MG",
    "codigoIbge": 3127107,
    "cidade": "Frutal"
  },
  {
    "prefixo": "38206",
    "uf": "MG",
    "codigoIbge": 3127107,
    "cidade": "Frutal"
  },
  {
    "prefixo": "38207",
    "uf": "MG",
    "codigoIbge": 3127107,
    "cidade": "Frutal"
  },
  {
    "prefixo": "38208",
    "uf": "MG",
    "codigoIbge": 3127107,
    "cidade": "Frutal"
  },
  {
    "prefixo": "38210",
    "uf": "MG",
    "codigoIbge": 3150703,
    "cidade": "Pirajuba"
  },
  {
    "prefixo": "38220",
    "uf": "MG",
    "codigoIbge": 3151602,
    "cidade": "Planura"
  },
  {
    "prefixo": "38230",
    "uf": "MG",
    "codigoIbge": 3127008,
    "cidade": "Fronteira"
  },
  {
    "prefixo": "38239",
    "uf": "MG",
    "codigoIbge": 3127008,
    "cidade": "Fronteira"
  },
  {
    "prefixo": "38240",
    "uf": "MG",
    "codigoIbge": 3133402,
    "cidade": "Itapagipe"
  },
  {
    "prefixo": "38250",
    "uf": "MG",
    "codigoIbge": 3116902,
    "cidade": "Comendador Gomes"
  },
  {
    "prefixo": "38260",
    "uf": "MG",
    "codigoIbge": 3161304,
    "cidade": "São Francisco de Sales"
  },
  {
    "prefixo": "38270",
    "uf": "MG",
    "codigoIbge": 3111101,
    "cidade": "Campina Verde"
  },
  {
    "prefixo": "38272",
    "uf": "MG",
    "codigoIbge": 3111101,
    "cidade": "Campina Verde"
  },
  {
    "prefixo": "38280",
    "uf": "MG",
    "codigoIbge": 3134400,
    "cidade": "Iturama"
  },
  {
    "prefixo": "38282",
    "uf": "MG",
    "codigoIbge": 3134400,
    "cidade": "Iturama"
  },
  {
    "prefixo": "38288",
    "uf": "MG",
    "codigoIbge": 3170438,
    "cidade": "União de Minas"
  },
  {
    "prefixo": "38290",
    "uf": "MG",
    "codigoIbge": 3114550,
    "cidade": "Carneirinho"
  },
  {
    "prefixo": "38292",
    "uf": "MG",
    "codigoIbge": 3114550,
    "cidade": "Carneirinho"
  },
  {
    "prefixo": "38294",
    "uf": "MG",
    "codigoIbge": 3114550,
    "cidade": "Carneirinho"
  },
  {
    "prefixo": "38295",
    "uf": "MG",
    "codigoIbge": 3138625,
    "cidade": "Limeira do Oeste"
  },
  {
    "prefixo": "38300",
    "uf": "MG",
    "codigoIbge": 3134202,
    "cidade": "Ituiutaba"
  },
  {
    "prefixo": "38301",
    "uf": "MG",
    "codigoIbge": 3134202,
    "cidade": "Ituiutaba"
  },
  {
    "prefixo": "38302",
    "uf": "MG",
    "codigoIbge": 3134202,
    "cidade": "Ituiutaba"
  },
  {
    "prefixo": "38303",
    "uf": "MG",
    "codigoIbge": 3134202,
    "cidade": "Ituiutaba"
  },
  {
    "prefixo": "38304",
    "uf": "MG",
    "codigoIbge": 3134202,
    "cidade": "Ituiutaba"
  },
  {
    "prefixo": "38305",
    "uf": "MG",
    "codigoIbge": 3134202,
    "cidade": "Ituiutaba"
  },
  {
    "prefixo": "38307",
    "uf": "MG",
    "codigoIbge": 3134202,
    "cidade": "Ituiutaba"
  },
  {
    "prefixo": "38308",
    "uf": "MG",
    "codigoIbge": 3134202,
    "cidade": "Ituiutaba"
  },
  {
    "prefixo": "38309",
    "uf": "MG",
    "codigoIbge": 3134202,
    "cidade": "Ituiutaba"
  },
  {
    "prefixo": "38310",
    "uf": "MG",
    "codigoIbge": 3129103,
    "cidade": "Gurinhatã"
  },
  {
    "prefixo": "38315",
    "uf": "MG",
    "codigoIbge": 3129103,
    "cidade": "Gurinhatã"
  },
  {
    "prefixo": "38320",
    "uf": "MG",
    "codigoIbge": 3159803,
    "cidade": "Santa Vitória"
  },
  {
    "prefixo": "38325",
    "uf": "MG",
    "codigoIbge": 3159803,
    "cidade": "Santa Vitória"
  },
  {
    "prefixo": "38328",
    "uf": "MG",
    "codigoIbge": 3159803,
    "cidade": "Santa Vitória"
  },
  {
    "prefixo": "38350",
    "uf": "MG",
    "codigoIbge": 3131406,
    "cidade": "Ipiaçu"
  },
  {
    "prefixo": "38360",
    "uf": "MG",
    "codigoIbge": 3112604,
    "cidade": "Capinópolis"
  },
  {
    "prefixo": "38370",
    "uf": "MG",
    "codigoIbge": 3109808,
    "cidade": "Cachoeira Dourada"
  },
  {
    "prefixo": "38380",
    "uf": "MG",
    "codigoIbge": 3111804,
    "cidade": "Canápolis"
  },
  {
    "prefixo": "38390",
    "uf": "MG",
    "codigoIbge": 3115805,
    "cidade": "Centralina"
  },
  {
    "prefixo": "38400",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38401",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38402",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38404",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38405",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38406",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38407",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38408",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38409",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38410",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38411",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38412",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38413",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38414",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38415",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38418",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38419",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38421",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38425",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38433",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38436",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38438",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38439",
    "uf": "MG",
    "codigoIbge": 3170206,
    "cidade": "Uberlândia"
  },
  {
    "prefixo": "38440",
    "uf": "MG",
    "codigoIbge": 3103504,
    "cidade": "Araguari"
  },
  {
    "prefixo": "38441",
    "uf": "MG",
    "codigoIbge": 3103504,
    "cidade": "Araguari"
  },
  {
    "prefixo": "38442",
    "uf": "MG",
    "codigoIbge": 3103504,
    "cidade": "Araguari"
  },
  {
    "prefixo": "38443",
    "uf": "MG",
    "codigoIbge": 3103504,
    "cidade": "Araguari"
  },
  {
    "prefixo": "38444",
    "uf": "MG",
    "codigoIbge": 3103504,
    "cidade": "Araguari"
  },
  {
    "prefixo": "38445",
    "uf": "MG",
    "codigoIbge": 3103504,
    "cidade": "Araguari"
  },
  {
    "prefixo": "38446",
    "uf": "MG",
    "codigoIbge": 3103504,
    "cidade": "Araguari"
  },
  {
    "prefixo": "38447",
    "uf": "MG",
    "codigoIbge": 3103504,
    "cidade": "Araguari"
  },
  {
    "prefixo": "38449",
    "uf": "MG",
    "codigoIbge": 3103504,
    "cidade": "Araguari"
  },
  {
    "prefixo": "38450",
    "uf": "MG",
    "codigoIbge": 3103504,
    "cidade": "Araguari"
  },
  {
    "prefixo": "38452",
    "uf": "MG",
    "codigoIbge": 3103504,
    "cidade": "Araguari"
  },
  {
    "prefixo": "38455",
    "uf": "MG",
    "codigoIbge": 3103504,
    "cidade": "Araguari"
  },
  {
    "prefixo": "38460",
    "uf": "MG",
    "codigoIbge": 3115003,
    "cidade": "Cascalho Rico"
  },
  {
    "prefixo": "38465",
    "uf": "MG",
    "codigoIbge": 3103751,
    "cidade": "Araporã"
  },
  {
    "prefixo": "38470",
    "uf": "MG",
    "codigoIbge": 3127909,
    "cidade": "Grupiara"
  },
  {
    "prefixo": "38475",
    "uf": "MG",
    "codigoIbge": 3142809,
    "cidade": "Monte Alegre de Minas"
  },
  {
    "prefixo": "38480",
    "uf": "MG",
    "codigoIbge": 3169604,
    "cidade": "Tupaciguara"
  },
  {
    "prefixo": "38490",
    "uf": "MG",
    "codigoIbge": 3130705,
    "cidade": "Indianópolis"
  },
  {
    "prefixo": "38500",
    "uf": "MG",
    "codigoIbge": 3143104,
    "cidade": "Monte Carmelo"
  },
  {
    "prefixo": "38501",
    "uf": "MG",
    "codigoIbge": 3143104,
    "cidade": "Monte Carmelo"
  },
  {
    "prefixo": "38510",
    "uf": "MG",
    "codigoIbge": 3131604,
    "cidade": "Iraí de Minas"
  },
  {
    "prefixo": "38520",
    "uf": "MG",
    "codigoIbge": 3156403,
    "cidade": "Romaria"
  },
  {
    "prefixo": "38525",
    "uf": "MG",
    "codigoIbge": 3124807,
    "cidade": "Estrela do Sul"
  },
  {
    "prefixo": "38526",
    "uf": "MG",
    "codigoIbge": 3124807,
    "cidade": "Estrela do Sul"
  },
  {
    "prefixo": "38528",
    "uf": "MG",
    "codigoIbge": 3124807,
    "cidade": "Estrela do Sul"
  },
  {
    "prefixo": "38530",
    "uf": "MG",
    "codigoIbge": 3123502,
    "cidade": "Douradoquara"
  },
  {
    "prefixo": "38540",
    "uf": "MG",
    "codigoIbge": 3100104,
    "cidade": "Abadia dos Dourados"
  },
  {
    "prefixo": "38550",
    "uf": "MG",
    "codigoIbge": 3119302,
    "cidade": "Coromandel"
  },
  {
    "prefixo": "38551",
    "uf": "MG",
    "codigoIbge": 3119302,
    "cidade": "Coromandel"
  },
  {
    "prefixo": "38552",
    "uf": "MG",
    "codigoIbge": 3119302,
    "cidade": "Coromandel"
  },
  {
    "prefixo": "38553",
    "uf": "MG",
    "codigoIbge": 3119302,
    "cidade": "Coromandel"
  },
  {
    "prefixo": "38554",
    "uf": "MG",
    "codigoIbge": 3119302,
    "cidade": "Coromandel"
  },
  {
    "prefixo": "38555",
    "uf": "MG",
    "codigoIbge": 3119302,
    "cidade": "Coromandel"
  },
  {
    "prefixo": "38560",
    "uf": "MG",
    "codigoIbge": 3119302,
    "cidade": "Coromandel"
  },
  {
    "prefixo": "38570",
    "uf": "MG",
    "codigoIbge": 3128600,
    "cidade": "Guarda-Mor"
  },
  {
    "prefixo": "38600",
    "uf": "MG",
    "codigoIbge": 3147006,
    "cidade": "Paracatu"
  },
  {
    "prefixo": "38602",
    "uf": "MG",
    "codigoIbge": 3147006,
    "cidade": "Paracatu"
  },
  {
    "prefixo": "38603",
    "uf": "MG",
    "codigoIbge": 3147006,
    "cidade": "Paracatu"
  },
  {
    "prefixo": "38605",
    "uf": "MG",
    "codigoIbge": 3147006,
    "cidade": "Paracatu"
  },
  {
    "prefixo": "38606",
    "uf": "MG",
    "codigoIbge": 3147006,
    "cidade": "Paracatu"
  },
  {
    "prefixo": "38607",
    "uf": "MG",
    "codigoIbge": 3147006,
    "cidade": "Paracatu"
  },
  {
    "prefixo": "38608",
    "uf": "MG",
    "codigoIbge": 3147006,
    "cidade": "Paracatu"
  },
  {
    "prefixo": "38609",
    "uf": "MG",
    "codigoIbge": 3147006,
    "cidade": "Paracatu"
  },
  {
    "prefixo": "38610",
    "uf": "MG",
    "codigoIbge": 3170404,
    "cidade": "Unaí"
  },
  {
    "prefixo": "38612",
    "uf": "MG",
    "codigoIbge": 3170404,
    "cidade": "Unaí"
  },
  {
    "prefixo": "38613",
    "uf": "MG",
    "codigoIbge": 3170404,
    "cidade": "Unaí"
  },
  {
    "prefixo": "38615",
    "uf": "MG",
    "codigoIbge": 3170404,
    "cidade": "Unaí"
  },
  {
    "prefixo": "38616",
    "uf": "MG",
    "codigoIbge": 3170404,
    "cidade": "Unaí"
  },
  {
    "prefixo": "38617",
    "uf": "MG",
    "codigoIbge": 3170404,
    "cidade": "Unaí"
  },
  {
    "prefixo": "38618",
    "uf": "MG",
    "codigoIbge": 3170404,
    "cidade": "Unaí"
  },
  {
    "prefixo": "38619",
    "uf": "MG",
    "codigoIbge": 3170404,
    "cidade": "Unaí"
  },
  {
    "prefixo": "38620",
    "uf": "MG",
    "codigoIbge": 3170404,
    "cidade": "Unaí"
  },
  {
    "prefixo": "38621",
    "uf": "MG",
    "codigoIbge": 3170404,
    "cidade": "Unaí"
  },
  {
    "prefixo": "38623",
    "uf": "MG",
    "codigoIbge": 3170404,
    "cidade": "Unaí"
  },
  {
    "prefixo": "38624",
    "uf": "MG",
    "codigoIbge": 3170404,
    "cidade": "Unaí"
  },
  {
    "prefixo": "38625",
    "uf": "MG",
    "codigoIbge": 3109451,
    "cidade": "Cabeceira Grande"
  },
  {
    "prefixo": "38627",
    "uf": "MG",
    "codigoIbge": 3109451,
    "cidade": "Cabeceira Grande"
  },
  {
    "prefixo": "38630",
    "uf": "MG",
    "codigoIbge": 3170479,
    "cidade": "Uruana de Minas"
  },
  {
    "prefixo": "38640",
    "uf": "MG",
    "codigoIbge": 3154457,
    "cidade": "Riachinho"
  },
  {
    "prefixo": "38649",
    "uf": "MG",
    "codigoIbge": 3170529,
    "cidade": "Urucuia"
  },
  {
    "prefixo": "38650",
    "uf": "MG",
    "codigoIbge": 3108206,
    "cidade": "Bonfinópolis de Minas"
  },
  {
    "prefixo": "38654",
    "uf": "MG",
    "codigoIbge": 3122470,
    "cidade": "Dom Bosco"
  },
  {
    "prefixo": "38658",
    "uf": "MG",
    "codigoIbge": 3144375,
    "cidade": "Natalândia"
  },
  {
    "prefixo": "38660",
    "uf": "MG",
    "codigoIbge": 3109303,
    "cidade": "Buritis"
  },
  {
    "prefixo": "38664",
    "uf": "MG",
    "codigoIbge": 3109303,
    "cidade": "Buritis"
  },
  {
    "prefixo": "38665",
    "uf": "MG",
    "codigoIbge": 3109303,
    "cidade": "Buritis"
  },
  {
    "prefixo": "38680",
    "uf": "MG",
    "codigoIbge": 3104502,
    "cidade": "Arinos"
  },
  {
    "prefixo": "38686",
    "uf": "MG",
    "codigoIbge": 3104502,
    "cidade": "Arinos"
  },
  {
    "prefixo": "38688",
    "uf": "MG",
    "codigoIbge": 3104502,
    "cidade": "Arinos"
  },
  {
    "prefixo": "38689",
    "uf": "MG",
    "codigoIbge": 3116159,
    "cidade": "Chapada Gaúcha"
  },
  {
    "prefixo": "38690",
    "uf": "MG",
    "codigoIbge": 3126208,
    "cidade": "Formoso"
  },
  {
    "prefixo": "38693",
    "uf": "MG",
    "codigoIbge": 3126208,
    "cidade": "Formoso"
  },
  {
    "prefixo": "38700",
    "uf": "MG",
    "codigoIbge": 3148004,
    "cidade": "Patos de Minas"
  },
  {
    "prefixo": "38701",
    "uf": "MG",
    "codigoIbge": 3148004,
    "cidade": "Patos de Minas"
  },
  {
    "prefixo": "38702",
    "uf": "MG",
    "codigoIbge": 3148004,
    "cidade": "Patos de Minas"
  },
  {
    "prefixo": "38703",
    "uf": "MG",
    "codigoIbge": 3148004,
    "cidade": "Patos de Minas"
  },
  {
    "prefixo": "38704",
    "uf": "MG",
    "codigoIbge": 3148004,
    "cidade": "Patos de Minas"
  },
  {
    "prefixo": "38705",
    "uf": "MG",
    "codigoIbge": 3148004,
    "cidade": "Patos de Minas"
  },
  {
    "prefixo": "38706",
    "uf": "MG",
    "codigoIbge": 3148004,
    "cidade": "Patos de Minas"
  },
  {
    "prefixo": "38708",
    "uf": "MG",
    "codigoIbge": 3148004,
    "cidade": "Patos de Minas"
  },
  {
    "prefixo": "38709",
    "uf": "MG",
    "codigoIbge": 3148004,
    "cidade": "Patos de Minas"
  },
  {
    "prefixo": "38710",
    "uf": "MG",
    "codigoIbge": 3148004,
    "cidade": "Patos de Minas"
  },
  {
    "prefixo": "38711",
    "uf": "MG",
    "codigoIbge": 3148004,
    "cidade": "Patos de Minas"
  },
  {
    "prefixo": "38712",
    "uf": "MG",
    "codigoIbge": 3148004,
    "cidade": "Patos de Minas"
  },
  {
    "prefixo": "38713",
    "uf": "MG",
    "codigoIbge": 3148004,
    "cidade": "Patos de Minas"
  },
  {
    "prefixo": "38715",
    "uf": "MG",
    "codigoIbge": 3148004,
    "cidade": "Patos de Minas"
  },
  {
    "prefixo": "38717",
    "uf": "MG",
    "codigoIbge": 3148004,
    "cidade": "Patos de Minas"
  },
  {
    "prefixo": "38720",
    "uf": "MG",
    "codigoIbge": 3137502,
    "cidade": "Lagoa Formosa"
  },
  {
    "prefixo": "38722",
    "uf": "MG",
    "codigoIbge": 3137502,
    "cidade": "Lagoa Formosa"
  },
  {
    "prefixo": "38730",
    "uf": "MG",
    "codigoIbge": 3128907,
    "cidade": "Guimarânia"
  },
  {
    "prefixo": "38735",
    "uf": "MG",
    "codigoIbge": 3120706,
    "cidade": "Cruzeiro da Fortaleza"
  },
  {
    "prefixo": "38738",
    "uf": "MG",
    "codigoIbge": 3120706,
    "cidade": "Cruzeiro da Fortaleza"
  },
  {
    "prefixo": "38740",
    "uf": "MG",
    "codigoIbge": 3148103,
    "cidade": "Patrocínio"
  },
  {
    "prefixo": "38741",
    "uf": "MG",
    "codigoIbge": 3148103,
    "cidade": "Patrocínio"
  },
  {
    "prefixo": "38742",
    "uf": "MG",
    "codigoIbge": 3148103,
    "cidade": "Patrocínio"
  },
  {
    "prefixo": "38743",
    "uf": "MG",
    "codigoIbge": 3148103,
    "cidade": "Patrocínio"
  },
  {
    "prefixo": "38744",
    "uf": "MG",
    "codigoIbge": 3148103,
    "cidade": "Patrocínio"
  },
  {
    "prefixo": "38745",
    "uf": "MG",
    "codigoIbge": 3148103,
    "cidade": "Patrocínio"
  },
  {
    "prefixo": "38747",
    "uf": "MG",
    "codigoIbge": 3148103,
    "cidade": "Patrocínio"
  },
  {
    "prefixo": "38748",
    "uf": "MG",
    "codigoIbge": 3148103,
    "cidade": "Patrocínio"
  },
  {
    "prefixo": "38749",
    "uf": "MG",
    "codigoIbge": 3148103,
    "cidade": "Patrocínio"
  },
  {
    "prefixo": "38750",
    "uf": "MG",
    "codigoIbge": 3153400,
    "cidade": "Presidente Olegário"
  },
  {
    "prefixo": "38753",
    "uf": "MG",
    "codigoIbge": 3153400,
    "cidade": "Presidente Olegário"
  },
  {
    "prefixo": "38754",
    "uf": "MG",
    "codigoIbge": 3153400,
    "cidade": "Presidente Olegário"
  },
  {
    "prefixo": "38755",
    "uf": "MG",
    "codigoIbge": 3137536,
    "cidade": "Lagoa Grande"
  },
  {
    "prefixo": "38760",
    "uf": "MG",
    "codigoIbge": 3166808,
    "cidade": "Serra do Salitre"
  },
  {
    "prefixo": "38762",
    "uf": "MG",
    "codigoIbge": 3166808,
    "cidade": "Serra do Salitre"
  },
  {
    "prefixo": "38770",
    "uf": "MG",
    "codigoIbge": 3136306,
    "cidade": "João Pinheiro"
  },
  {
    "prefixo": "38772",
    "uf": "MG",
    "codigoIbge": 3136306,
    "cidade": "João Pinheiro"
  },
  {
    "prefixo": "38773",
    "uf": "MG",
    "codigoIbge": 3136306,
    "cidade": "João Pinheiro"
  },
  {
    "prefixo": "38774",
    "uf": "MG",
    "codigoIbge": 3136306,
    "cidade": "João Pinheiro"
  },
  {
    "prefixo": "38775",
    "uf": "MG",
    "codigoIbge": 3136306,
    "cidade": "João Pinheiro"
  },
  {
    "prefixo": "38776",
    "uf": "MG",
    "codigoIbge": 3136306,
    "cidade": "João Pinheiro"
  },
  {
    "prefixo": "38777",
    "uf": "MG",
    "codigoIbge": 3136306,
    "cidade": "João Pinheiro"
  },
  {
    "prefixo": "38778",
    "uf": "MG",
    "codigoIbge": 3136306,
    "cidade": "João Pinheiro"
  },
  {
    "prefixo": "38779",
    "uf": "MG",
    "codigoIbge": 3108552,
    "cidade": "Brasilândia de Minas"
  },
  {
    "prefixo": "38780",
    "uf": "MG",
    "codigoIbge": 3171006,
    "cidade": "Vazante"
  },
  {
    "prefixo": "38782",
    "uf": "MG",
    "codigoIbge": 3171006,
    "cidade": "Vazante"
  },
  {
    "prefixo": "38785",
    "uf": "MG",
    "codigoIbge": 3137106,
    "cidade": "Lagamar"
  },
  {
    "prefixo": "38788",
    "uf": "MG",
    "codigoIbge": 3137106,
    "cidade": "Lagamar"
  },
  {
    "prefixo": "38790",
    "uf": "MG",
    "codigoIbge": 3161700,
    "cidade": "São Gonçalo do Abaeté"
  },
  {
    "prefixo": "38792",
    "uf": "MG",
    "codigoIbge": 3161700,
    "cidade": "São Gonçalo do Abaeté"
  },
  {
    "prefixo": "38794",
    "uf": "MG",
    "codigoIbge": 3170750,
    "cidade": "Varjão de Minas"
  },
  {
    "prefixo": "38800",
    "uf": "MG",
    "codigoIbge": 3162104,
    "cidade": "São Gotardo"
  },
  {
    "prefixo": "38802",
    "uf": "MG",
    "codigoIbge": 3162104,
    "cidade": "São Gotardo"
  },
  {
    "prefixo": "38803",
    "uf": "MG",
    "codigoIbge": 3162104,
    "cidade": "São Gotardo"
  },
  {
    "prefixo": "38804",
    "uf": "MG",
    "codigoIbge": 3162104,
    "cidade": "São Gotardo"
  },
  {
    "prefixo": "38805",
    "uf": "MG",
    "codigoIbge": 3159704,
    "cidade": "Santa Rosa da Serra"
  },
  {
    "prefixo": "38810",
    "uf": "MG",
    "codigoIbge": 3155504,
    "cidade": "Rio Paranaíba"
  },
  {
    "prefixo": "38812",
    "uf": "MG",
    "codigoIbge": 3155504,
    "cidade": "Rio Paranaíba"
  },
  {
    "prefixo": "38819",
    "uf": "MG",
    "codigoIbge": 3155504,
    "cidade": "Rio Paranaíba"
  },
  {
    "prefixo": "38840",
    "uf": "MG",
    "codigoIbge": 3114303,
    "cidade": "Carmo do Paranaíba"
  },
  {
    "prefixo": "38842",
    "uf": "MG",
    "codigoIbge": 3114303,
    "cidade": "Carmo do Paranaíba"
  },
  {
    "prefixo": "38844",
    "uf": "MG",
    "codigoIbge": 3114303,
    "cidade": "Carmo do Paranaíba"
  },
  {
    "prefixo": "38846",
    "uf": "MG",
    "codigoIbge": 3114303,
    "cidade": "Carmo do Paranaíba"
  },
  {
    "prefixo": "38847",
    "uf": "MG",
    "codigoIbge": 3114303,
    "cidade": "Carmo do Paranaíba"
  },
  {
    "prefixo": "38860",
    "uf": "MG",
    "codigoIbge": 3103801,
    "cidade": "Arapuá"
  },
  {
    "prefixo": "38870",
    "uf": "MG",
    "codigoIbge": 3141207,
    "cidade": "Matutina"
  },
  {
    "prefixo": "38880",
    "uf": "MG",
    "codigoIbge": 3168903,
    "cidade": "Tiros"
  },
  {
    "prefixo": "38890",
    "uf": "MG",
    "codigoIbge": 3168903,
    "cidade": "Tiros"
  },
  {
    "prefixo": "38900",
    "uf": "MG",
    "codigoIbge": 3105103,
    "cidade": "Bambuí"
  },
  {
    "prefixo": "38901",
    "uf": "MG",
    "codigoIbge": 3105103,
    "cidade": "Bambuí"
  },
  {
    "prefixo": "38910",
    "uf": "MG",
    "codigoIbge": 3130309,
    "cidade": "Iguatama"
  },
  {
    "prefixo": "38930",
    "uf": "MG",
    "codigoIbge": 3141306,
    "cidade": "Medeiros"
  },
  {
    "prefixo": "38950",
    "uf": "MG",
    "codigoIbge": 3129509,
    "cidade": "Ibiá"
  },
  {
    "prefixo": "38953",
    "uf": "MG",
    "codigoIbge": 3129509,
    "cidade": "Ibiá"
  },
  {
    "prefixo": "38955",
    "uf": "MG",
    "codigoIbge": 3129509,
    "cidade": "Ibiá"
  },
  {
    "prefixo": "38960",
    "uf": "MG",
    "codigoIbge": 3153004,
    "cidade": "Pratinha"
  },
  {
    "prefixo": "38970",
    "uf": "MG",
    "codigoIbge": 3111507,
    "cidade": "Campos Altos"
  },
  {
    "prefixo": "38975",
    "uf": "MG",
    "codigoIbge": 3111507,
    "cidade": "Campos Altos"
  },
  {
    "prefixo": "38980",
    "uf": "MG",
    "codigoIbge": 3168200,
    "cidade": "Tapiraí"
  },
  {
    "prefixo": "38985",
    "uf": "MG",
    "codigoIbge": 3168200,
    "cidade": "Tapiraí"
  },
  {
    "prefixo": "38990",
    "uf": "MG",
    "codigoIbge": 3119807,
    "cidade": "Córrego Danta"
  },
  {
    "prefixo": "38995",
    "uf": "MG",
    "codigoIbge": 3119807,
    "cidade": "Córrego Danta"
  },
  {
    "prefixo": "39100",
    "uf": "MG",
    "codigoIbge": 3121605,
    "cidade": "Diamantina"
  },
  {
    "prefixo": "39101",
    "uf": "MG",
    "codigoIbge": 3121605,
    "cidade": "Diamantina"
  },
  {
    "prefixo": "39102",
    "uf": "MG",
    "codigoIbge": 3121605,
    "cidade": "Diamantina"
  },
  {
    "prefixo": "39103",
    "uf": "MG",
    "codigoIbge": 3121605,
    "cidade": "Diamantina"
  },
  {
    "prefixo": "39105",
    "uf": "MG",
    "codigoIbge": 3121605,
    "cidade": "Diamantina"
  },
  {
    "prefixo": "39106",
    "uf": "MG",
    "codigoIbge": 3121605,
    "cidade": "Diamantina"
  },
  {
    "prefixo": "39110",
    "uf": "MG",
    "codigoIbge": 3121605,
    "cidade": "Diamantina"
  },
  {
    "prefixo": "39111",
    "uf": "MG",
    "codigoIbge": 3121605,
    "cidade": "Diamantina"
  },
  {
    "prefixo": "39112",
    "uf": "MG",
    "codigoIbge": 3121605,
    "cidade": "Diamantina"
  },
  {
    "prefixo": "39113",
    "uf": "MG",
    "codigoIbge": 3121605,
    "cidade": "Diamantina"
  },
  {
    "prefixo": "39114",
    "uf": "MG",
    "codigoIbge": 3121605,
    "cidade": "Diamantina"
  },
  {
    "prefixo": "39120",
    "uf": "MG",
    "codigoIbge": 3127602,
    "cidade": "Gouveia"
  },
  {
    "prefixo": "39130",
    "uf": "MG",
    "codigoIbge": 3121001,
    "cidade": "Datas"
  },
  {
    "prefixo": "39135",
    "uf": "MG",
    "codigoIbge": 3153301,
    "cidade": "Presidente Kubitschek"
  },
  {
    "prefixo": "39140",
    "uf": "MG",
    "codigoIbge": 3102407,
    "cidade": "Alvorada de Minas"
  },
  {
    "prefixo": "39145",
    "uf": "MG",
    "codigoIbge": 3102407,
    "cidade": "Alvorada de Minas"
  },
  {
    "prefixo": "39150",
    "uf": "MG",
    "codigoIbge": 3167103,
    "cidade": "Serro"
  },
  {
    "prefixo": "39152",
    "uf": "MG",
    "codigoIbge": 3167103,
    "cidade": "Serro"
  },
  {
    "prefixo": "39153",
    "uf": "MG",
    "codigoIbge": 3167103,
    "cidade": "Serro"
  },
  {
    "prefixo": "39155",
    "uf": "MG",
    "codigoIbge": 3167103,
    "cidade": "Serro"
  },
  {
    "prefixo": "39158",
    "uf": "MG",
    "codigoIbge": 3167103,
    "cidade": "Serro"
  },
  {
    "prefixo": "39159",
    "uf": "MG",
    "codigoIbge": 3167103,
    "cidade": "Serro"
  },
  {
    "prefixo": "39160",
    "uf": "MG",
    "codigoIbge": 3160207,
    "cidade": "Santo Antônio do Itambé"
  },
  {
    "prefixo": "39165",
    "uf": "MG",
    "codigoIbge": 3166501,
    "cidade": "Serra Azul de Minas"
  },
  {
    "prefixo": "39170",
    "uf": "MG",
    "codigoIbge": 3156007,
    "cidade": "Rio Vermelho"
  },
  {
    "prefixo": "39175",
    "uf": "MG",
    "codigoIbge": 3156007,
    "cidade": "Rio Vermelho"
  },
  {
    "prefixo": "39180",
    "uf": "MG",
    "codigoIbge": 3125408,
    "cidade": "Felício dos Santos"
  },
  {
    "prefixo": "39185",
    "uf": "MG",
    "codigoIbge": 3125507,
    "cidade": "São Gonçalo do Rio Preto"
  },
  {
    "prefixo": "39188",
    "uf": "MG",
    "codigoIbge": 3120102,
    "cidade": "Couto de Magalhães de Minas"
  },
  {
    "prefixo": "39190",
    "uf": "MG",
    "codigoIbge": 3165909,
    "cidade": "Senador Modestino Gonçalves"
  },
  {
    "prefixo": "39200",
    "uf": "MG",
    "codigoIbge": 3119104,
    "cidade": "Corinto"
  },
  {
    "prefixo": "39202",
    "uf": "MG",
    "codigoIbge": 3119104,
    "cidade": "Corinto"
  },
  {
    "prefixo": "39203",
    "uf": "MG",
    "codigoIbge": 3119104,
    "cidade": "Corinto"
  },
  {
    "prefixo": "39205",
    "uf": "MG",
    "codigoIbge": 3169356,
    "cidade": "Três Marias"
  },
  {
    "prefixo": "39207",
    "uf": "MG",
    "codigoIbge": 3169356,
    "cidade": "Três Marias"
  },
  {
    "prefixo": "39210",
    "uf": "MG",
    "codigoIbge": 3160603,
    "cidade": "Santo Hipólito"
  },
  {
    "prefixo": "39212",
    "uf": "MG",
    "codigoIbge": 3160603,
    "cidade": "Santo Hipólito"
  },
  {
    "prefixo": "39213",
    "uf": "MG",
    "codigoIbge": 3160603,
    "cidade": "Santo Hipólito"
  },
  {
    "prefixo": "39215",
    "uf": "MG",
    "codigoIbge": 3142502,
    "cidade": "Monjolos"
  },
  {
    "prefixo": "39218",
    "uf": "MG",
    "codigoIbge": 3142502,
    "cidade": "Monjolos"
  },
  {
    "prefixo": "39219",
    "uf": "MG",
    "codigoIbge": 3104809,
    "cidade": "Augusto de Lima"
  },
  {
    "prefixo": "39230",
    "uf": "MG",
    "codigoIbge": 3109204,
    "cidade": "Buenópolis"
  },
  {
    "prefixo": "39235",
    "uf": "MG",
    "codigoIbge": 3109204,
    "cidade": "Buenópolis"
  },
  {
    "prefixo": "39237",
    "uf": "MG",
    "codigoIbge": 3125705,
    "cidade": "Felixlândia"
  },
  {
    "prefixo": "39238",
    "uf": "MG",
    "codigoIbge": 3125705,
    "cidade": "Felixlândia"
  },
  {
    "prefixo": "39240",
    "uf": "MG",
    "codigoIbge": 3136405,
    "cidade": "Joaquim Felício"
  },
  {
    "prefixo": "39243",
    "uf": "MG",
    "codigoIbge": 3131109,
    "cidade": "Inimutaba"
  },
  {
    "prefixo": "39245",
    "uf": "MG",
    "codigoIbge": 3153202,
    "cidade": "Presidente Juscelino"
  },
  {
    "prefixo": "39248",
    "uf": "MG",
    "codigoIbge": 3143609,
    "cidade": "Morro da Garça"
  },
  {
    "prefixo": "39250",
    "uf": "MG",
    "codigoIbge": 3138104,
    "cidade": "Lassance"
  },
  {
    "prefixo": "39260",
    "uf": "MG",
    "codigoIbge": 3170800,
    "cidade": "Várzea da Palma"
  },
  {
    "prefixo": "39265",
    "uf": "MG",
    "codigoIbge": 3170800,
    "cidade": "Várzea da Palma"
  },
  {
    "prefixo": "39270",
    "uf": "MG",
    "codigoIbge": 3151206,
    "cidade": "Pirapora"
  },
  {
    "prefixo": "39272",
    "uf": "MG",
    "codigoIbge": 3151206,
    "cidade": "Pirapora"
  },
  {
    "prefixo": "39274",
    "uf": "MG",
    "codigoIbge": 3151206,
    "cidade": "Pirapora"
  },
  {
    "prefixo": "39276",
    "uf": "MG",
    "codigoIbge": 3151206,
    "cidade": "Pirapora"
  },
  {
    "prefixo": "39277",
    "uf": "MG",
    "codigoIbge": 3151206,
    "cidade": "Pirapora"
  },
  {
    "prefixo": "39280",
    "uf": "MG",
    "codigoIbge": 3109402,
    "cidade": "Buritizeiro"
  },
  {
    "prefixo": "39285",
    "uf": "MG",
    "codigoIbge": 3109402,
    "cidade": "Buritizeiro"
  },
  {
    "prefixo": "39288",
    "uf": "MG",
    "codigoIbge": 3109402,
    "cidade": "Buritizeiro"
  },
  {
    "prefixo": "39290",
    "uf": "MG",
    "codigoIbge": 3164209,
    "cidade": "São Romão"
  },
  {
    "prefixo": "39295",
    "uf": "MG",
    "codigoIbge": 3157609,
    "cidade": "Santa Fé de Minas"
  },
  {
    "prefixo": "39300",
    "uf": "MG",
    "codigoIbge": 3161106,
    "cidade": "São Francisco"
  },
  {
    "prefixo": "39310",
    "uf": "MG",
    "codigoIbge": 3161106,
    "cidade": "São Francisco"
  },
  {
    "prefixo": "39313",
    "uf": "MG",
    "codigoIbge": 3161106,
    "cidade": "São Francisco"
  },
  {
    "prefixo": "39317",
    "uf": "MG",
    "codigoIbge": 3150570,
    "cidade": "Pintópolis"
  },
  {
    "prefixo": "39318",
    "uf": "MG",
    "codigoIbge": 3130051,
    "cidade": "Icaraí de Minas"
  },
  {
    "prefixo": "39320",
    "uf": "MG",
    "codigoIbge": 3170008,
    "cidade": "Ubaí"
  },
  {
    "prefixo": "39325",
    "uf": "MG",
    "codigoIbge": 3170008,
    "cidade": "Ubaí"
  },
  {
    "prefixo": "39328",
    "uf": "MG",
    "codigoIbge": 3152131,
    "cidade": "Ponto Chique"
  },
  {
    "prefixo": "39330",
    "uf": "MG",
    "codigoIbge": 3108602,
    "cidade": "Brasília de Minas"
  },
  {
    "prefixo": "39332",
    "uf": "MG",
    "codigoIbge": 3108602,
    "cidade": "Brasília de Minas"
  },
  {
    "prefixo": "39334",
    "uf": "MG",
    "codigoIbge": 3108602,
    "cidade": "Brasília de Minas"
  },
  {
    "prefixo": "39335",
    "uf": "MG",
    "codigoIbge": 3135357,
    "cidade": "Japonvar"
  },
  {
    "prefixo": "39336",
    "uf": "MG",
    "codigoIbge": 3138682,
    "cidade": "Luislândia"
  },
  {
    "prefixo": "39337",
    "uf": "MG",
    "codigoIbge": 3138682,
    "cidade": "Luislândia"
  },
  {
    "prefixo": "39338",
    "uf": "MG",
    "codigoIbge": 3111150,
    "cidade": "Campo Azul"
  },
  {
    "prefixo": "39340",
    "uf": "MG",
    "codigoIbge": 3118809,
    "cidade": "Coração de Jesus"
  },
  {
    "prefixo": "39341",
    "uf": "MG",
    "codigoIbge": 3118809,
    "cidade": "Coração de Jesus"
  },
  {
    "prefixo": "39342",
    "uf": "MG",
    "codigoIbge": 3118809,
    "cidade": "Coração de Jesus"
  },
  {
    "prefixo": "39343",
    "uf": "MG",
    "codigoIbge": 3118809,
    "cidade": "Coração de Jesus"
  },
  {
    "prefixo": "39344",
    "uf": "MG",
    "codigoIbge": 3118809,
    "cidade": "Coração de Jesus"
  },
  {
    "prefixo": "39347",
    "uf": "MG",
    "codigoIbge": 3118809,
    "cidade": "Coração de Jesus"
  },
  {
    "prefixo": "39348",
    "uf": "MG",
    "codigoIbge": 3118809,
    "cidade": "Coração de Jesus"
  },
  {
    "prefixo": "39350",
    "uf": "MG",
    "codigoIbge": 3129608,
    "cidade": "Ibiaí"
  },
  {
    "prefixo": "39355",
    "uf": "MG",
    "codigoIbge": 3162252,
    "cidade": "São João da Lagoa"
  },
  {
    "prefixo": "39358",
    "uf": "MG",
    "codigoIbge": 3162252,
    "cidade": "São João da Lagoa"
  },
  {
    "prefixo": "39360",
    "uf": "MG",
    "codigoIbge": 3137304,
    "cidade": "Lagoa dos Patos"
  },
  {
    "prefixo": "39363",
    "uf": "MG",
    "codigoIbge": 3123809,
    "cidade": "Engenheiro Navarro"
  },
  {
    "prefixo": "39365",
    "uf": "MG",
    "codigoIbge": 3162658,
    "cidade": "São João do Pacuí"
  },
  {
    "prefixo": "39368",
    "uf": "MG",
    "codigoIbge": 3162658,
    "cidade": "São João do Pacuí"
  },
  {
    "prefixo": "39370",
    "uf": "MG",
    "codigoIbge": 3135605,
    "cidade": "Jequitaí"
  },
  {
    "prefixo": "39373",
    "uf": "MG",
    "codigoIbge": 3142007,
    "cidade": "Mirabela"
  },
  {
    "prefixo": "39375",
    "uf": "MG",
    "codigoIbge": 3142007,
    "cidade": "Mirabela"
  },
  {
    "prefixo": "39378",
    "uf": "MG",
    "codigoIbge": 3147956,
    "cidade": "Patis"
  },
  {
    "prefixo": "39380",
    "uf": "MG",
    "codigoIbge": 3116506,
    "cidade": "Claro dos Poções"
  },
  {
    "prefixo": "39385",
    "uf": "MG",
    "codigoIbge": 3116506,
    "cidade": "Claro dos Poções"
  },
  {
    "prefixo": "39387",
    "uf": "MG",
    "codigoIbge": 3126604,
    "cidade": "Francisco Dumont"
  },
  {
    "prefixo": "39390",
    "uf": "MG",
    "codigoIbge": 3107307,
    "cidade": "Bocaiúva"
  },
  {
    "prefixo": "39393",
    "uf": "MG",
    "codigoIbge": 3107307,
    "cidade": "Bocaiúva"
  },
  {
    "prefixo": "39394",
    "uf": "MG",
    "codigoIbge": 3107307,
    "cidade": "Bocaiúva"
  },
  {
    "prefixo": "39395",
    "uf": "MG",
    "codigoIbge": 3107307,
    "cidade": "Bocaiúva"
  },
  {
    "prefixo": "39397",
    "uf": "MG",
    "codigoIbge": 3128253,
    "cidade": "Guaraciama"
  },
  {
    "prefixo": "39398",
    "uf": "MG",
    "codigoIbge": 3145455,
    "cidade": "Olhos-d'Água"
  },
  {
    "prefixo": "39400",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39401",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39402",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39403",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39404",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39405",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39406",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39407",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39408",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39409",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39410",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39411",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39412",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39413",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39414",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39415",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39416",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39429",
    "uf": "MG",
    "codigoIbge": 3143302,
    "cidade": "Montes Claros"
  },
  {
    "prefixo": "39430",
    "uf": "MG",
    "codigoIbge": 3162401,
    "cidade": "São João da Ponte"
  },
  {
    "prefixo": "39432",
    "uf": "MG",
    "codigoIbge": 3162401,
    "cidade": "São João da Ponte"
  },
  {
    "prefixo": "39433",
    "uf": "MG",
    "codigoIbge": 3162401,
    "cidade": "São João da Ponte"
  },
  {
    "prefixo": "39434",
    "uf": "MG",
    "codigoIbge": 3162401,
    "cidade": "São João da Ponte"
  },
  {
    "prefixo": "39435",
    "uf": "MG",
    "codigoIbge": 3162401,
    "cidade": "São João da Ponte"
  },
  {
    "prefixo": "39437",
    "uf": "MG",
    "codigoIbge": 3138658,
    "cidade": "Lontra"
  },
  {
    "prefixo": "39439",
    "uf": "MG",
    "codigoIbge": 3138658,
    "cidade": "Lontra"
  },
  {
    "prefixo": "39440",
    "uf": "MG",
    "codigoIbge": 3135100,
    "cidade": "Janaúba"
  },
  {
    "prefixo": "39442",
    "uf": "MG",
    "codigoIbge": 3135100,
    "cidade": "Janaúba"
  },
  {
    "prefixo": "39444",
    "uf": "MG",
    "codigoIbge": 3135100,
    "cidade": "Janaúba"
  },
  {
    "prefixo": "39445",
    "uf": "MG",
    "codigoIbge": 3135100,
    "cidade": "Janaúba"
  },
  {
    "prefixo": "39447",
    "uf": "MG",
    "codigoIbge": 3135100,
    "cidade": "Janaúba"
  },
  {
    "prefixo": "39448",
    "uf": "MG",
    "codigoIbge": 3135100,
    "cidade": "Janaúba"
  },
  {
    "prefixo": "39449",
    "uf": "MG",
    "codigoIbge": 3135100,
    "cidade": "Janaúba"
  },
  {
    "prefixo": "39450",
    "uf": "MG",
    "codigoIbge": 3170909,
    "cidade": "Varzelândia"
  },
  {
    "prefixo": "39452",
    "uf": "MG",
    "codigoIbge": 3170909,
    "cidade": "Varzelândia"
  },
  {
    "prefixo": "39455",
    "uf": "MG",
    "codigoIbge": 3129657,
    "cidade": "Ibiracatu"
  },
  {
    "prefixo": "39456",
    "uf": "MG",
    "codigoIbge": 3129657,
    "cidade": "Ibiracatu"
  },
  {
    "prefixo": "39457",
    "uf": "MG",
    "codigoIbge": 3129657,
    "cidade": "Ibiracatu"
  },
  {
    "prefixo": "39458",
    "uf": "MG",
    "codigoIbge": 3171030,
    "cidade": "Verdelândia"
  },
  {
    "prefixo": "39460",
    "uf": "MG",
    "codigoIbge": 3139300,
    "cidade": "Manga"
  },
  {
    "prefixo": "39463",
    "uf": "MG",
    "codigoIbge": 3139300,
    "cidade": "Manga"
  },
  {
    "prefixo": "39465",
    "uf": "MG",
    "codigoIbge": 3142254,
    "cidade": "Miravânia"
  },
  {
    "prefixo": "39467",
    "uf": "MG",
    "codigoIbge": 3136959,
    "cidade": "Juvenília"
  },
  {
    "prefixo": "39468",
    "uf": "MG",
    "codigoIbge": 3136959,
    "cidade": "Juvenília"
  },
  {
    "prefixo": "39469",
    "uf": "MG",
    "codigoIbge": 3136959,
    "cidade": "Juvenília"
  },
  {
    "prefixo": "39470",
    "uf": "MG",
    "codigoIbge": 3132107,
    "cidade": "Itacarambi"
  },
  {
    "prefixo": "39472",
    "uf": "MG",
    "codigoIbge": 3112703,
    "cidade": "Capitão Enéas"
  },
  {
    "prefixo": "39473",
    "uf": "MG",
    "codigoIbge": 3112703,
    "cidade": "Capitão Enéas"
  },
  {
    "prefixo": "39474",
    "uf": "MG",
    "codigoIbge": 3112703,
    "cidade": "Capitão Enéas"
  },
  {
    "prefixo": "39475",
    "uf": "MG",
    "codigoIbge": 3162450,
    "cidade": "São João das Missões"
  },
  {
    "prefixo": "39477",
    "uf": "MG",
    "codigoIbge": 3162450,
    "cidade": "São João das Missões"
  },
  {
    "prefixo": "39478",
    "uf": "MG",
    "codigoIbge": 3140852,
    "cidade": "Matias Cardoso"
  },
  {
    "prefixo": "39480",
    "uf": "MG",
    "codigoIbge": 3135209,
    "cidade": "Januária"
  },
  {
    "prefixo": "39482",
    "uf": "MG",
    "codigoIbge": 3135209,
    "cidade": "Januária"
  },
  {
    "prefixo": "39483",
    "uf": "MG",
    "codigoIbge": 3135209,
    "cidade": "Januária"
  },
  {
    "prefixo": "39484",
    "uf": "MG",
    "codigoIbge": 3135209,
    "cidade": "Januária"
  },
  {
    "prefixo": "39485",
    "uf": "MG",
    "codigoIbge": 3135209,
    "cidade": "Januária"
  },
  {
    "prefixo": "39488",
    "uf": "MG",
    "codigoIbge": 3135209,
    "cidade": "Januária"
  },
  {
    "prefixo": "39489",
    "uf": "MG",
    "codigoIbge": 3117836,
    "cidade": "Cônego Marinho"
  },
  {
    "prefixo": "39490",
    "uf": "MG",
    "codigoIbge": 3108255,
    "cidade": "Bonito de Minas"
  },
  {
    "prefixo": "39492",
    "uf": "MG",
    "codigoIbge": 3149150,
    "cidade": "Pedras de Maria da Cruz"
  },
  {
    "prefixo": "39494",
    "uf": "MG",
    "codigoIbge": 3149150,
    "cidade": "Pedras de Maria da Cruz"
  },
  {
    "prefixo": "39495",
    "uf": "MG",
    "codigoIbge": 3142700,
    "cidade": "Montalvânia"
  },
  {
    "prefixo": "39497",
    "uf": "MG",
    "codigoIbge": 3142700,
    "cidade": "Montalvânia"
  },
  {
    "prefixo": "39499",
    "uf": "MG",
    "codigoIbge": 3142700,
    "cidade": "Montalvânia"
  },
  {
    "prefixo": "39500",
    "uf": "MG",
    "codigoIbge": 3142908,
    "cidade": "Monte Azul"
  },
  {
    "prefixo": "39505",
    "uf": "MG",
    "codigoIbge": 3127339,
    "cidade": "Gameleiras"
  },
  {
    "prefixo": "39507",
    "uf": "MG",
    "codigoIbge": 3127339,
    "cidade": "Gameleiras"
  },
  {
    "prefixo": "39508",
    "uf": "MG",
    "codigoIbge": 3135050,
    "cidade": "Jaíba"
  },
  {
    "prefixo": "39510",
    "uf": "MG",
    "codigoIbge": 3124302,
    "cidade": "Espinosa"
  },
  {
    "prefixo": "39515",
    "uf": "MG",
    "codigoIbge": 3124302,
    "cidade": "Espinosa"
  },
  {
    "prefixo": "39516",
    "uf": "MG",
    "codigoIbge": 3139250,
    "cidade": "Mamonas"
  },
  {
    "prefixo": "39517",
    "uf": "MG",
    "codigoIbge": 3146552,
    "cidade": "Pai Pedro"
  },
  {
    "prefixo": "39518",
    "uf": "MG",
    "codigoIbge": 3166956,
    "cidade": "Serranópolis de Minas"
  },
  {
    "prefixo": "39520",
    "uf": "MG",
    "codigoIbge": 3152204,
    "cidade": "Porteirinha"
  },
  {
    "prefixo": "39522",
    "uf": "MG",
    "codigoIbge": 3152204,
    "cidade": "Porteirinha"
  },
  {
    "prefixo": "39523",
    "uf": "MG",
    "codigoIbge": 3152204,
    "cidade": "Porteirinha"
  },
  {
    "prefixo": "39524",
    "uf": "MG",
    "codigoIbge": 3152204,
    "cidade": "Porteirinha"
  },
  {
    "prefixo": "39525",
    "uf": "MG",
    "codigoIbge": 3145059,
    "cidade": "Nova Porteirinha"
  },
  {
    "prefixo": "39526",
    "uf": "MG",
    "codigoIbge": 3115474,
    "cidade": "Catuti"
  },
  {
    "prefixo": "39527",
    "uf": "MG",
    "codigoIbge": 3141009,
    "cidade": "Mato Verde"
  },
  {
    "prefixo": "39528",
    "uf": "MG",
    "codigoIbge": 3141009,
    "cidade": "Mato Verde"
  },
  {
    "prefixo": "39529",
    "uf": "MG",
    "codigoIbge": 3154507,
    "cidade": "Riacho dos Machados"
  },
  {
    "prefixo": "39530",
    "uf": "MG",
    "codigoIbge": 3155603,
    "cidade": "Rio Pardo de Minas"
  },
  {
    "prefixo": "39532",
    "uf": "MG",
    "codigoIbge": 3155603,
    "cidade": "Rio Pardo de Minas"
  },
  {
    "prefixo": "39535",
    "uf": "MG",
    "codigoIbge": 3170651,
    "cidade": "Vargem Grande do Rio Pardo"
  },
  {
    "prefixo": "39536",
    "uf": "MG",
    "codigoIbge": 3130655,
    "cidade": "Indaiabira"
  },
  {
    "prefixo": "39538",
    "uf": "MG",
    "codigoIbge": 3160454,
    "cidade": "Santo Antônio do Retiro"
  },
  {
    "prefixo": "39540",
    "uf": "MG",
    "codigoIbge": 3162708,
    "cidade": "São João do Paraíso"
  },
  {
    "prefixo": "39545",
    "uf": "MG",
    "codigoIbge": 3162708,
    "cidade": "São João do Paraíso"
  },
  {
    "prefixo": "39547",
    "uf": "MG",
    "codigoIbge": 3143450,
    "cidade": "Montezuma"
  },
  {
    "prefixo": "39550",
    "uf": "MG",
    "codigoIbge": 3168002,
    "cidade": "Taiobeiras"
  },
  {
    "prefixo": "39553",
    "uf": "MG",
    "codigoIbge": 3144656,
    "cidade": "Ninheira"
  },
  {
    "prefixo": "39555",
    "uf": "MG",
    "codigoIbge": 3106655,
    "cidade": "Berizal"
  },
  {
    "prefixo": "39558",
    "uf": "MG",
    "codigoIbge": 3127073,
    "cidade": "Fruta de Leite"
  },
  {
    "prefixo": "39560",
    "uf": "MG",
    "codigoIbge": 3157005,
    "cidade": "Salinas"
  },
  {
    "prefixo": "39562",
    "uf": "MG",
    "codigoIbge": 3157005,
    "cidade": "Salinas"
  },
  {
    "prefixo": "39563",
    "uf": "MG",
    "codigoIbge": 3157377,
    "cidade": "Santa Cruz de Salinas"
  },
  {
    "prefixo": "39565",
    "uf": "MG",
    "codigoIbge": 3156502,
    "cidade": "Rubelita"
  },
  {
    "prefixo": "39568",
    "uf": "MG",
    "codigoIbge": 3145372,
    "cidade": "Novorizonte"
  },
  {
    "prefixo": "39569",
    "uf": "MG",
    "codigoIbge": 3120870,
    "cidade": "Curral de Dentro"
  },
  {
    "prefixo": "39570",
    "uf": "MG",
    "codigoIbge": 3127800,
    "cidade": "Grão Mogol"
  },
  {
    "prefixo": "39572",
    "uf": "MG",
    "codigoIbge": 3127800,
    "cidade": "Grão Mogol"
  },
  {
    "prefixo": "39573",
    "uf": "MG",
    "codigoIbge": 3146255,
    "cidade": "Padre Carvalho"
  },
  {
    "prefixo": "39575",
    "uf": "MG",
    "codigoIbge": 3136579,
    "cidade": "Josenópolis"
  },
  {
    "prefixo": "39580",
    "uf": "MG",
    "codigoIbge": 3126703,
    "cidade": "Francisco Sá"
  },
  {
    "prefixo": "39581",
    "uf": "MG",
    "codigoIbge": 3126703,
    "cidade": "Francisco Sá"
  },
  {
    "prefixo": "39585",
    "uf": "MG",
    "codigoIbge": 3126703,
    "cidade": "Francisco Sá"
  },
  {
    "prefixo": "39590",
    "uf": "MG",
    "codigoIbge": 3136801,
    "cidade": "Juramento"
  },
  {
    "prefixo": "39592",
    "uf": "MG",
    "codigoIbge": 3127354,
    "cidade": "Glaucilândia"
  },
  {
    "prefixo": "39594",
    "uf": "MG",
    "codigoIbge": 3132008,
    "cidade": "Itacambira"
  },
  {
    "prefixo": "39595",
    "uf": "MG",
    "codigoIbge": 3108503,
    "cidade": "Botumirim"
  },
  {
    "prefixo": "39596",
    "uf": "MG",
    "codigoIbge": 3108503,
    "cidade": "Botumirim"
  },
  {
    "prefixo": "39597",
    "uf": "MG",
    "codigoIbge": 3108503,
    "cidade": "Botumirim"
  },
  {
    "prefixo": "39598",
    "uf": "MG",
    "codigoIbge": 3120300,
    "cidade": "Cristália"
  },
  {
    "prefixo": "39600",
    "uf": "MG",
    "codigoIbge": 3103405,
    "cidade": "Araçuaí"
  },
  {
    "prefixo": "39602",
    "uf": "MG",
    "codigoIbge": 3103405,
    "cidade": "Araçuaí"
  },
  {
    "prefixo": "39605",
    "uf": "MG",
    "codigoIbge": 3103405,
    "cidade": "Araçuaí"
  },
  {
    "prefixo": "39610",
    "uf": "MG",
    "codigoIbge": 3134004,
    "cidade": "Itinga"
  },
  {
    "prefixo": "39613",
    "uf": "MG",
    "codigoIbge": 3134004,
    "cidade": "Itinga"
  },
  {
    "prefixo": "39615",
    "uf": "MG",
    "codigoIbge": 3152170,
    "cidade": "Ponto dos Volantes"
  },
  {
    "prefixo": "39618",
    "uf": "MG",
    "codigoIbge": 3152170,
    "cidade": "Ponto dos Volantes"
  },
  {
    "prefixo": "39620",
    "uf": "MG",
    "codigoIbge": 3141405,
    "cidade": "Medina"
  },
  {
    "prefixo": "39623",
    "uf": "MG",
    "codigoIbge": 3141405,
    "cidade": "Medina"
  },
  {
    "prefixo": "39625",
    "uf": "MG",
    "codigoIbge": 3133303,
    "cidade": "Itaobim"
  },
  {
    "prefixo": "39628",
    "uf": "MG",
    "codigoIbge": 3117009,
    "cidade": "Comercinho"
  },
  {
    "prefixo": "39629",
    "uf": "MG",
    "codigoIbge": 3117009,
    "cidade": "Comercinho"
  },
  {
    "prefixo": "39630",
    "uf": "MG",
    "codigoIbge": 3171600,
    "cidade": "Virgem da Lapa"
  },
  {
    "prefixo": "39634",
    "uf": "MG",
    "codigoIbge": 3171600,
    "cidade": "Virgem da Lapa"
  },
  {
    "prefixo": "39635",
    "uf": "MG",
    "codigoIbge": 3119500,
    "cidade": "Coronel Murta"
  },
  {
    "prefixo": "39637",
    "uf": "MG",
    "codigoIbge": 3119500,
    "cidade": "Coronel Murta"
  },
  {
    "prefixo": "39640",
    "uf": "MG",
    "codigoIbge": 3106507,
    "cidade": "Berilo"
  },
  {
    "prefixo": "39642",
    "uf": "MG",
    "codigoIbge": 3136520,
    "cidade": "José Gonçalves de Minas"
  },
  {
    "prefixo": "39644",
    "uf": "MG",
    "codigoIbge": 3126505,
    "cidade": "Francisco Badaró"
  },
  {
    "prefixo": "39645",
    "uf": "MG",
    "codigoIbge": 3135456,
    "cidade": "Jenipapo de Minas"
  },
  {
    "prefixo": "39648",
    "uf": "MG",
    "codigoIbge": 3116100,
    "cidade": "Chapada do Norte"
  },
  {
    "prefixo": "39650",
    "uf": "MG",
    "codigoIbge": 3141801,
    "cidade": "Minas Novas"
  },
  {
    "prefixo": "39651",
    "uf": "MG",
    "codigoIbge": 3141801,
    "cidade": "Minas Novas"
  },
  {
    "prefixo": "39652",
    "uf": "MG",
    "codigoIbge": 3141801,
    "cidade": "Minas Novas"
  },
  {
    "prefixo": "39653",
    "uf": "MG",
    "codigoIbge": 3141801,
    "cidade": "Minas Novas"
  },
  {
    "prefixo": "39654",
    "uf": "MG",
    "codigoIbge": 3141801,
    "cidade": "Minas Novas"
  },
  {
    "prefixo": "39655",
    "uf": "MG",
    "codigoIbge": 3138351,
    "cidade": "Leme do Prado"
  },
  {
    "prefixo": "39660",
    "uf": "MG",
    "codigoIbge": 3169703,
    "cidade": "Turmalina"
  },
  {
    "prefixo": "39662",
    "uf": "MG",
    "codigoIbge": 3169703,
    "cidade": "Turmalina"
  },
  {
    "prefixo": "39663",
    "uf": "MG",
    "codigoIbge": 3171071,
    "cidade": "Veredinha"
  },
  {
    "prefixo": "39664",
    "uf": "MG",
    "codigoIbge": 3171071,
    "cidade": "Veredinha"
  },
  {
    "prefixo": "39665",
    "uf": "MG",
    "codigoIbge": 3113503,
    "cidade": "Carbonita"
  },
  {
    "prefixo": "39670",
    "uf": "MG",
    "codigoIbge": 3132503,
    "cidade": "Itamarandiba"
  },
  {
    "prefixo": "39672",
    "uf": "MG",
    "codigoIbge": 3132503,
    "cidade": "Itamarandiba"
  },
  {
    "prefixo": "39675",
    "uf": "MG",
    "codigoIbge": 3132503,
    "cidade": "Itamarandiba"
  },
  {
    "prefixo": "39676",
    "uf": "MG",
    "codigoIbge": 3132503,
    "cidade": "Itamarandiba"
  },
  {
    "prefixo": "39678",
    "uf": "MG",
    "codigoIbge": 3104452,
    "cidade": "Aricanduva"
  },
  {
    "prefixo": "39680",
    "uf": "MG",
    "codigoIbge": 3112307,
    "cidade": "Capelinha"
  },
  {
    "prefixo": "39685",
    "uf": "MG",
    "codigoIbge": 3102852,
    "cidade": "Angelândia"
  },
  {
    "prefixo": "39688",
    "uf": "MG",
    "codigoIbge": 3165552,
    "cidade": "Setubinha"
  },
  {
    "prefixo": "39690",
    "uf": "MG",
    "codigoIbge": 3139201,
    "cidade": "Malacacheta"
  },
  {
    "prefixo": "39691",
    "uf": "MG",
    "codigoIbge": 3139201,
    "cidade": "Malacacheta"
  },
  {
    "prefixo": "39692",
    "uf": "MG",
    "codigoIbge": 3139201,
    "cidade": "Malacacheta"
  },
  {
    "prefixo": "39693",
    "uf": "MG",
    "codigoIbge": 3139201,
    "cidade": "Malacacheta"
  },
  {
    "prefixo": "39695",
    "uf": "MG",
    "codigoIbge": 3126752,
    "cidade": "Franciscópolis"
  },
  {
    "prefixo": "39697",
    "uf": "MG",
    "codigoIbge": 3126752,
    "cidade": "Franciscópolis"
  },
  {
    "prefixo": "39700",
    "uf": "MG",
    "codigoIbge": 3148608,
    "cidade": "Peçanha"
  },
  {
    "prefixo": "39702",
    "uf": "MG",
    "codigoIbge": 3148608,
    "cidade": "Peçanha"
  },
  {
    "prefixo": "39703",
    "uf": "MG",
    "codigoIbge": 3112059,
    "cidade": "Cantagalo"
  },
  {
    "prefixo": "39704",
    "uf": "MG",
    "codigoIbge": 3162807,
    "cidade": "São João Evangelista"
  },
  {
    "prefixo": "39705",
    "uf": "MG",
    "codigoIbge": 3162807,
    "cidade": "São João Evangelista"
  },
  {
    "prefixo": "39706",
    "uf": "MG",
    "codigoIbge": 3162807,
    "cidade": "São João Evangelista"
  },
  {
    "prefixo": "39707",
    "uf": "MG",
    "codigoIbge": 3163508,
    "cidade": "São José do Jacuri"
  },
  {
    "prefixo": "39708",
    "uf": "MG",
    "codigoIbge": 3126950,
    "cidade": "Frei Lagonegro"
  },
  {
    "prefixo": "39710",
    "uf": "MG",
    "codigoIbge": 3119203,
    "cidade": "Coroaci"
  },
  {
    "prefixo": "39711",
    "uf": "MG",
    "codigoIbge": 3119203,
    "cidade": "Coroaci"
  },
  {
    "prefixo": "39712",
    "uf": "MG",
    "codigoIbge": 3119203,
    "cidade": "Coroaci"
  },
  {
    "prefixo": "39715",
    "uf": "MG",
    "codigoIbge": 3171907,
    "cidade": "Virgolândia"
  },
  {
    "prefixo": "39716",
    "uf": "MG",
    "codigoIbge": 3171907,
    "cidade": "Virgolândia"
  },
  {
    "prefixo": "39718",
    "uf": "MG",
    "codigoIbge": 3144201,
    "cidade": "Nacip Raydan"
  },
  {
    "prefixo": "39720",
    "uf": "MG",
    "codigoIbge": 3127503,
    "cidade": "Gonzaga"
  },
  {
    "prefixo": "39721",
    "uf": "MG",
    "codigoIbge": 3127503,
    "cidade": "Gonzaga"
  },
  {
    "prefixo": "39723",
    "uf": "MG",
    "codigoIbge": 3161601,
    "cidade": "São Geraldo da Piedade"
  },
  {
    "prefixo": "39725",
    "uf": "MG",
    "codigoIbge": 3157500,
    "cidade": "Santa Efigênia de Minas"
  },
  {
    "prefixo": "39728",
    "uf": "MG",
    "codigoIbge": 3165503,
    "cidade": "Sardoá"
  },
  {
    "prefixo": "39730",
    "uf": "MG",
    "codigoIbge": 3171808,
    "cidade": "Virginópolis"
  },
  {
    "prefixo": "39735",
    "uf": "MG",
    "codigoIbge": 3122207,
    "cidade": "Divinolândia de Minas"
  },
  {
    "prefixo": "39740",
    "uf": "MG",
    "codigoIbge": 3128006,
    "cidade": "Guanhães"
  },
  {
    "prefixo": "39741",
    "uf": "MG",
    "codigoIbge": 3128006,
    "cidade": "Guanhães"
  },
  {
    "prefixo": "39742",
    "uf": "MG",
    "codigoIbge": 3128006,
    "cidade": "Guanhães"
  },
  {
    "prefixo": "39743",
    "uf": "MG",
    "codigoIbge": 3128006,
    "cidade": "Guanhães"
  },
  {
    "prefixo": "39744",
    "uf": "MG",
    "codigoIbge": 3128006,
    "cidade": "Guanhães"
  },
  {
    "prefixo": "39745",
    "uf": "MG",
    "codigoIbge": 3166105,
    "cidade": "Senhora do Porto"
  },
  {
    "prefixo": "39748",
    "uf": "MG",
    "codigoIbge": 3166105,
    "cidade": "Senhora do Porto"
  },
  {
    "prefixo": "39750",
    "uf": "MG",
    "codigoIbge": 3156809,
    "cidade": "Sabinópolis"
  },
  {
    "prefixo": "39751",
    "uf": "MG",
    "codigoIbge": 3156809,
    "cidade": "Sabinópolis"
  },
  {
    "prefixo": "39753",
    "uf": "MG",
    "codigoIbge": 3156809,
    "cidade": "Sabinópolis"
  },
  {
    "prefixo": "39755",
    "uf": "MG",
    "codigoIbge": 3140605,
    "cidade": "Materlândia"
  },
  {
    "prefixo": "39765",
    "uf": "MG",
    "codigoIbge": 3148400,
    "cidade": "Paulistas"
  },
  {
    "prefixo": "39770",
    "uf": "MG",
    "codigoIbge": 3116803,
    "cidade": "Coluna"
  },
  {
    "prefixo": "39775",
    "uf": "MG",
    "codigoIbge": 3136553,
    "cidade": "José Raydan"
  },
  {
    "prefixo": "39780",
    "uf": "MG",
    "codigoIbge": 3158201,
    "cidade": "Santa Maria do Suaçuí"
  },
  {
    "prefixo": "39782",
    "uf": "MG",
    "codigoIbge": 3158201,
    "cidade": "Santa Maria do Suaçuí"
  },
  {
    "prefixo": "39783",
    "uf": "MG",
    "codigoIbge": 3158201,
    "cidade": "Santa Maria do Suaçuí"
  },
  {
    "prefixo": "39784",
    "uf": "MG",
    "codigoIbge": 3164100,
    "cidade": "São Pedro do Suaçuí"
  },
  {
    "prefixo": "39785",
    "uf": "MG",
    "codigoIbge": 3163003,
    "cidade": "São José da Safira"
  },
  {
    "prefixo": "39790",
    "uf": "MG",
    "codigoIbge": 3100609,
    "cidade": "Água Boa"
  },
  {
    "prefixo": "39795",
    "uf": "MG",
    "codigoIbge": 3164506,
    "cidade": "São Sebastião do Maranhão"
  },
  {
    "prefixo": "39796",
    "uf": "MG",
    "codigoIbge": 3164506,
    "cidade": "São Sebastião do Maranhão"
  },
  {
    "prefixo": "39797",
    "uf": "MG",
    "codigoIbge": 3164506,
    "cidade": "São Sebastião do Maranhão"
  },
  {
    "prefixo": "39800",
    "uf": "MG",
    "codigoIbge": 3168606,
    "cidade": "Teófilo Otoni"
  },
  {
    "prefixo": "39801",
    "uf": "MG",
    "codigoIbge": 3168606,
    "cidade": "Teófilo Otoni"
  },
  {
    "prefixo": "39802",
    "uf": "MG",
    "codigoIbge": 3168606,
    "cidade": "Teófilo Otoni"
  },
  {
    "prefixo": "39803",
    "uf": "MG",
    "codigoIbge": 3168606,
    "cidade": "Teófilo Otoni"
  },
  {
    "prefixo": "39804",
    "uf": "MG",
    "codigoIbge": 3168606,
    "cidade": "Teófilo Otoni"
  },
  {
    "prefixo": "39805",
    "uf": "MG",
    "codigoIbge": 3168606,
    "cidade": "Teófilo Otoni"
  },
  {
    "prefixo": "39807",
    "uf": "MG",
    "codigoIbge": 3168606,
    "cidade": "Teófilo Otoni"
  },
  {
    "prefixo": "39808",
    "uf": "MG",
    "codigoIbge": 3168606,
    "cidade": "Teófilo Otoni"
  },
  {
    "prefixo": "39809",
    "uf": "MG",
    "codigoIbge": 3168606,
    "cidade": "Teófilo Otoni"
  },
  {
    "prefixo": "39810",
    "uf": "MG",
    "codigoIbge": 3113008,
    "cidade": "Caraí"
  },
  {
    "prefixo": "39812",
    "uf": "MG",
    "codigoIbge": 3113008,
    "cidade": "Caraí"
  },
  {
    "prefixo": "39813",
    "uf": "MG",
    "codigoIbge": 3113008,
    "cidade": "Caraí"
  },
  {
    "prefixo": "39814",
    "uf": "MG",
    "codigoIbge": 3148509,
    "cidade": "Pavão"
  },
  {
    "prefixo": "39815",
    "uf": "MG",
    "codigoIbge": 3132305,
    "cidade": "Itaipé"
  },
  {
    "prefixo": "39816",
    "uf": "MG",
    "codigoIbge": 3115458,
    "cidade": "Catuji"
  },
  {
    "prefixo": "39817",
    "uf": "MG",
    "codigoIbge": 3145356,
    "cidade": "Novo Oriente de Minas"
  },
  {
    "prefixo": "39818",
    "uf": "MG",
    "codigoIbge": 3146305,
    "cidade": "Padre Paraíso"
  },
  {
    "prefixo": "39820",
    "uf": "MG",
    "codigoIbge": 3145307,
    "cidade": "Novo Cruzeiro"
  },
  {
    "prefixo": "39821",
    "uf": "MG",
    "codigoIbge": 3145307,
    "cidade": "Novo Cruzeiro"
  },
  {
    "prefixo": "39823",
    "uf": "MG",
    "codigoIbge": 3145307,
    "cidade": "Novo Cruzeiro"
  },
  {
    "prefixo": "39824",
    "uf": "MG",
    "codigoIbge": 3145307,
    "cidade": "Novo Cruzeiro"
  },
  {
    "prefixo": "39825",
    "uf": "MG",
    "codigoIbge": 3137007,
    "cidade": "Ladainha"
  },
  {
    "prefixo": "39826",
    "uf": "MG",
    "codigoIbge": 3137007,
    "cidade": "Ladainha"
  },
  {
    "prefixo": "39827",
    "uf": "MG",
    "codigoIbge": 3152402,
    "cidade": "Poté"
  },
  {
    "prefixo": "39828",
    "uf": "MG",
    "codigoIbge": 3152402,
    "cidade": "Poté"
  },
  {
    "prefixo": "39829",
    "uf": "MG",
    "codigoIbge": 3152402,
    "cidade": "Poté"
  },
  {
    "prefixo": "39830",
    "uf": "MG",
    "codigoIbge": 3132701,
    "cidade": "Itambacuri"
  },
  {
    "prefixo": "39832",
    "uf": "MG",
    "codigoIbge": 3132701,
    "cidade": "Itambacuri"
  },
  {
    "prefixo": "39833",
    "uf": "MG",
    "codigoIbge": 3132701,
    "cidade": "Itambacuri"
  },
  {
    "prefixo": "39835",
    "uf": "MG",
    "codigoIbge": 3110806,
    "cidade": "Campanário"
  },
  {
    "prefixo": "39837",
    "uf": "MG",
    "codigoIbge": 3135076,
    "cidade": "Jampruca"
  },
  {
    "prefixo": "39839",
    "uf": "MG",
    "codigoIbge": 3135076,
    "cidade": "Jampruca"
  },
  {
    "prefixo": "39840",
    "uf": "MG",
    "codigoIbge": 3126802,
    "cidade": "Frei Gaspar"
  },
  {
    "prefixo": "39842",
    "uf": "MG",
    "codigoIbge": 3126802,
    "cidade": "Frei Gaspar"
  },
  {
    "prefixo": "39848",
    "uf": "MG",
    "codigoIbge": 3163300,
    "cidade": "São José do Divino"
  },
  {
    "prefixo": "39850",
    "uf": "MG",
    "codigoIbge": 3104700,
    "cidade": "Ataléia"
  },
  {
    "prefixo": "39851",
    "uf": "MG",
    "codigoIbge": 3104700,
    "cidade": "Ataléia"
  },
  {
    "prefixo": "39853",
    "uf": "MG",
    "codigoIbge": 3104700,
    "cidade": "Ataléia"
  },
  {
    "prefixo": "39855",
    "uf": "MG",
    "codigoIbge": 3146206,
    "cidade": "Ouro Verde de Minas"
  },
  {
    "prefixo": "39860",
    "uf": "MG",
    "codigoIbge": 3144300,
    "cidade": "Nanuque"
  },
  {
    "prefixo": "39862",
    "uf": "MG",
    "codigoIbge": 3144300,
    "cidade": "Nanuque"
  },
  {
    "prefixo": "39864",
    "uf": "MG",
    "codigoIbge": 3113701,
    "cidade": "Carlos Chagas"
  },
  {
    "prefixo": "39865",
    "uf": "MG",
    "codigoIbge": 3113701,
    "cidade": "Carlos Chagas"
  },
  {
    "prefixo": "39866",
    "uf": "MG",
    "codigoIbge": 3113701,
    "cidade": "Carlos Chagas"
  },
  {
    "prefixo": "39868",
    "uf": "MG",
    "codigoIbge": 3166709,
    "cidade": "Serra dos Aimorés"
  },
  {
    "prefixo": "39870",
    "uf": "MG",
    "codigoIbge": 3127057,
    "cidade": "Fronteira dos Vales"
  },
  {
    "prefixo": "39873",
    "uf": "MG",
    "codigoIbge": 3138906,
    "cidade": "Machacalis"
  },
  {
    "prefixo": "39874",
    "uf": "MG",
    "codigoIbge": 3157658,
    "cidade": "Santa Helena de Minas"
  },
  {
    "prefixo": "39875",
    "uf": "MG",
    "codigoIbge": 3106606,
    "cidade": "Bertópolis"
  },
  {
    "prefixo": "39878",
    "uf": "MG",
    "codigoIbge": 3170305,
    "cidade": "Umburatiba"
  },
  {
    "prefixo": "39880",
    "uf": "MG",
    "codigoIbge": 3100906,
    "cidade": "Águas Formosas"
  },
  {
    "prefixo": "39885",
    "uf": "MG",
    "codigoIbge": 3120151,
    "cidade": "Crisólita"
  },
  {
    "prefixo": "39888",
    "uf": "MG",
    "codigoIbge": 3120151,
    "cidade": "Crisólita"
  },
  {
    "prefixo": "39890",
    "uf": "MG",
    "codigoIbge": 3136009,
    "cidade": "Joaíma"
  },
  {
    "prefixo": "39893",
    "uf": "MG",
    "codigoIbge": 3143153,
    "cidade": "Monte Formoso"
  },
  {
    "prefixo": "39895",
    "uf": "MG",
    "codigoIbge": 3125606,
    "cidade": "Felisburgo"
  },
  {
    "prefixo": "39900",
    "uf": "MG",
    "codigoIbge": 3101706,
    "cidade": "Almenara"
  },
  {
    "prefixo": "39910",
    "uf": "MG",
    "codigoIbge": 3101706,
    "cidade": "Almenara"
  },
  {
    "prefixo": "39912",
    "uf": "MG",
    "codigoIbge": 3122454,
    "cidade": "Divisópolis"
  },
  {
    "prefixo": "39915",
    "uf": "MG",
    "codigoIbge": 3140555,
    "cidade": "Mata Verde"
  },
  {
    "prefixo": "39917",
    "uf": "MG",
    "codigoIbge": 3105202,
    "cidade": "Bandeira"
  },
  {
    "prefixo": "39920",
    "uf": "MG",
    "codigoIbge": 3136504,
    "cidade": "Jordânia"
  },
  {
    "prefixo": "39923",
    "uf": "MG",
    "codigoIbge": 3136504,
    "cidade": "Jordânia"
  },
  {
    "prefixo": "39925",
    "uf": "MG",
    "codigoIbge": 3157104,
    "cidade": "Salto da Divisa"
  },
  {
    "prefixo": "39928",
    "uf": "MG",
    "codigoIbge": 3158102,
    "cidade": "Santa Maria do Salto"
  },
  {
    "prefixo": "39930",
    "uf": "MG",
    "codigoIbge": 3134707,
    "cidade": "Jacinto"
  },
  {
    "prefixo": "39931",
    "uf": "MG",
    "codigoIbge": 3134707,
    "cidade": "Jacinto"
  },
  {
    "prefixo": "39933",
    "uf": "MG",
    "codigoIbge": 3134707,
    "cidade": "Jacinto"
  },
  {
    "prefixo": "39935",
    "uf": "MG",
    "codigoIbge": 3160306,
    "cidade": "Santo Antônio do Jacinto"
  },
  {
    "prefixo": "39937",
    "uf": "MG",
    "codigoIbge": 3160306,
    "cidade": "Santo Antônio do Jacinto"
  },
  {
    "prefixo": "39940",
    "uf": "MG",
    "codigoIbge": 3155108,
    "cidade": "Rio do Prado"
  },
  {
    "prefixo": "39945",
    "uf": "MG",
    "codigoIbge": 3146750,
    "cidade": "Palmópolis"
  },
  {
    "prefixo": "39948",
    "uf": "MG",
    "codigoIbge": 3146750,
    "cidade": "Palmópolis"
  },
  {
    "prefixo": "39950",
    "uf": "MG",
    "codigoIbge": 3156601,
    "cidade": "Rubim"
  },
  {
    "prefixo": "39955",
    "uf": "MG",
    "codigoIbge": 3156601,
    "cidade": "Rubim"
  },
  {
    "prefixo": "39960",
    "uf": "MG",
    "codigoIbge": 3135803,
    "cidade": "Jequitinhonha"
  },
  {
    "prefixo": "39961",
    "uf": "MG",
    "codigoIbge": 3135803,
    "cidade": "Jequitinhonha"
  },
  {
    "prefixo": "39965",
    "uf": "MG",
    "codigoIbge": 3135803,
    "cidade": "Jequitinhonha"
  },
  {
    "prefixo": "39970",
    "uf": "MG",
    "codigoIbge": 3148707,
    "cidade": "Pedra Azul"
  },
  {
    "prefixo": "39976",
    "uf": "MG",
    "codigoIbge": 3148707,
    "cidade": "Pedra Azul"
  },
  {
    "prefixo": "39980",
    "uf": "MG",
    "codigoIbge": 3102704,
    "cidade": "Cachoeira de Pajeú"
  },
  {
    "prefixo": "39990",
    "uf": "MG",
    "codigoIbge": 3101003,
    "cidade": "Águas Vermelhas"
  },
  {
    "prefixo": "39993",
    "uf": "MG",
    "codigoIbge": 3101003,
    "cidade": "Águas Vermelhas"
  },
  {
    "prefixo": "39995",
    "uf": "MG",
    "codigoIbge": 3122355,
    "cidade": "Divisa Alegre"
  },
  {
    "prefixo": "40000",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40010",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40015",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40020",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40024",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40025",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40026",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40040",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40045",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40050",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40055",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40060",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40070",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40080",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40081",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40100",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40105",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40110",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40130",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40140",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40150",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40155",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40157",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40170",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40210",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40213",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40215",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40220",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40221",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40223",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40225",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40226",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40230",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40231",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40240",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40241",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40243",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40245",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40250",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40251",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40252",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40253",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40254",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40255",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40260",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40261",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40262",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40270",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40275",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40276",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40279",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40280",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40283",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40284",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40285",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40286",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40290",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40295",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40296",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40300",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40301",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40302",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40303",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40310",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40313",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40314",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40315",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40317",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40318",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40320",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40321",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40323",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40325",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40327",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40328",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40330",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40335",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40340",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40342",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40349",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40350",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40352",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40353",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40354",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40355",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40357",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40365",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40366",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40367",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40368",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40370",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40375",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40385",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40386",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40387",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40390",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40391",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40393",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40394",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40395",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40410",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40411",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40414",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40415",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40420",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40421",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40425",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40430",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40433",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40434",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40435",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40436",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40440",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40444",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40445",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40450",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40451",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40454",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40455",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40460",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40470",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40471",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40480",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40483",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40484",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40485",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40486",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40487",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40490",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40710",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40711",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40713",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40714",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40715",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40717",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40718",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40719",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40720",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40725",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40726",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40730",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40731",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40735",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40740",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40748",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40750",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40760",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40800",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40810",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40820",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40830",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "40840",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41098",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41099",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41100",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41110",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41120",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41130",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41150",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41151",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41152",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41180",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41181",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41185",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41190",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41192",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41194",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41195",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41197",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41200",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41204",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41205",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41207",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41210",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41211",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41213",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41214",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41215",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41216",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41217",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41218",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41219",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41220",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41221",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41225",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41227",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41230",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41231",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41233",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41235",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41245",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41247",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41250",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41253",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41254",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41255",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41256",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41260",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41262",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41270",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41275",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41280",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41281",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41285",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41290",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41291",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41295",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41297",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41298",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41299",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41300",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41301",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41302",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41305",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41306",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41307",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41308",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41310",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41311",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41315",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41320",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41321",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41322",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41330",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41332",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41334",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41335",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41336",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41337",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41338",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41339",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41340",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41341",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41342",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41343",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41345",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41347",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41349",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41350",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41351",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41370",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41385",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41386",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41387",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41388",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41390",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41395",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41400",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41402",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41403",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41404",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41410",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41411",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41412",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41480",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41481",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41483",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41490",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41500",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41502",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41503",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41504",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41505",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41507",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41510",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41515",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41600",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41601",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41603",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41610",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41611",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41612",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41613",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41615",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41620",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41630",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41635",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41640",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41650",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41651",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41680",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41701",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41705",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41706",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41710",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41720",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41730",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41740",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41741",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41745",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41750",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41760",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41770",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41800",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41810",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41815",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41820",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41825",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41830",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41899",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41900",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41905",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41906",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41915",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41920",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41925",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41926",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41927",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41928",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41930",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41940",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41941",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "41950",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "42500",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "42505",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "42510",
    "uf": "BA",
    "codigoIbge": 2927408,
    "cidade": "Salvador"
  },
  {
    "prefixo": "42600",
    "uf": "BA",
    "codigoIbge": 2919926,
    "cidade": "Madre de Deus"
  },
  {
    "prefixo": "42700",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42701",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42702",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42703",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42704",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42705",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42706",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42707",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42708",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42709",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42710",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42711",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42712",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42713",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42714",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42716",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42717",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42718",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42719",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42720",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42721",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42722",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42723",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42724",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42725",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42726",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42728",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42729",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42730",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42732",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42733",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42734",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42735",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42738",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42739",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42740",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42741",
    "uf": "BA",
    "codigoIbge": 2919207,
    "cidade": "Lauro de Freitas"
  },
  {
    "prefixo": "42800",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42801",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42802",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42803",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42804",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42805",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42807",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42808",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42809",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42810",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42811",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42812",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42813",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42816",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42819",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42820",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42821",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42822",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42823",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42825",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42826",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42827",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42828",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42829",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42830",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42831",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42833",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42835",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42836",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42837",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42838",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42839",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42840",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42841",
    "uf": "BA",
    "codigoIbge": 2905701,
    "cidade": "Camaçari"
  },
  {
    "prefixo": "42850",
    "uf": "BA",
    "codigoIbge": 2910057,
    "cidade": "Dias d'Ávila"
  },
  {
    "prefixo": "43700",
    "uf": "BA",
    "codigoIbge": 2930709,
    "cidade": "Simões Filho"
  },
  {
    "prefixo": "43701",
    "uf": "BA",
    "codigoIbge": 2930709,
    "cidade": "Simões Filho"
  },
  {
    "prefixo": "43800",
    "uf": "BA",
    "codigoIbge": 2906501,
    "cidade": "Candeias"
  },
  {
    "prefixo": "43805",
    "uf": "BA",
    "codigoIbge": 2906501,
    "cidade": "Candeias"
  },
  {
    "prefixo": "43806",
    "uf": "BA",
    "codigoIbge": 2906501,
    "cidade": "Candeias"
  },
  {
    "prefixo": "43810",
    "uf": "BA",
    "codigoIbge": 2906501,
    "cidade": "Candeias"
  },
  {
    "prefixo": "43813",
    "uf": "BA",
    "codigoIbge": 2906501,
    "cidade": "Candeias"
  },
  {
    "prefixo": "43815",
    "uf": "BA",
    "codigoIbge": 2906501,
    "cidade": "Candeias"
  },
  {
    "prefixo": "43820",
    "uf": "BA",
    "codigoIbge": 2906501,
    "cidade": "Candeias"
  },
  {
    "prefixo": "43825",
    "uf": "BA",
    "codigoIbge": 2906501,
    "cidade": "Candeias"
  },
  {
    "prefixo": "43839",
    "uf": "BA",
    "codigoIbge": 2906501,
    "cidade": "Candeias"
  },
  {
    "prefixo": "43840",
    "uf": "BA",
    "codigoIbge": 2906501,
    "cidade": "Candeias"
  },
  {
    "prefixo": "43841",
    "uf": "BA",
    "codigoIbge": 2906501,
    "cidade": "Candeias"
  },
  {
    "prefixo": "43843",
    "uf": "BA",
    "codigoIbge": 2906501,
    "cidade": "Candeias"
  },
  {
    "prefixo": "43845",
    "uf": "BA",
    "codigoIbge": 2906501,
    "cidade": "Candeias"
  },
  {
    "prefixo": "43846",
    "uf": "BA",
    "codigoIbge": 2906501,
    "cidade": "Candeias"
  },
  {
    "prefixo": "43850",
    "uf": "BA",
    "codigoIbge": 2929503,
    "cidade": "São Sebastião do Passé"
  },
  {
    "prefixo": "43860",
    "uf": "BA",
    "codigoIbge": 2929503,
    "cidade": "São Sebastião do Passé"
  },
  {
    "prefixo": "43870",
    "uf": "BA",
    "codigoIbge": 2929503,
    "cidade": "São Sebastião do Passé"
  },
  {
    "prefixo": "43900",
    "uf": "BA",
    "codigoIbge": 2929206,
    "cidade": "São Francisco do Conde"
  },
  {
    "prefixo": "43980",
    "uf": "BA",
    "codigoIbge": 2929206,
    "cidade": "São Francisco do Conde"
  },
  {
    "prefixo": "44001",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44002",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44003",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44004",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44005",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44006",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44007",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44008",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44009",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44010",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44013",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44016",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44019",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44020",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44021",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44022",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44023",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44024",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44025",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44028",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44030",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44031",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44032",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44033",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44034",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44035",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44036",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44037",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44038",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44042",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44044",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44046",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44050",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44051",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44052",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44053",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44054",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44055",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44056",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44057",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44059",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44060",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44061",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44062",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44065",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44066",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44067",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44068",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44069",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44071",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44072",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44073",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44075",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44076",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44077",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44078",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44079",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44080",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44082",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44083",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44085",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44086",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44088",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44089",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44090",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44091",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44092",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44094",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44095",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44096",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44097",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44099",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44110",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44115",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44118",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44120",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44125",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44130",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44135",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44137",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44140",
    "uf": "BA",
    "codigoIbge": 2910800,
    "cidade": "Feira de Santana"
  },
  {
    "prefixo": "44150",
    "uf": "BA",
    "codigoIbge": 2927507,
    "cidade": "Santa Bárbara"
  },
  {
    "prefixo": "44160",
    "uf": "BA",
    "codigoIbge": 2931103,
    "cidade": "Tanquinho"
  },
  {
    "prefixo": "44180",
    "uf": "BA",
    "codigoIbge": 2901700,
    "cidade": "Antônio Cardoso"
  },
  {
    "prefixo": "44190",
    "uf": "BA",
    "codigoIbge": 2928802,
    "cidade": "Santo Estêvão"
  },
  {
    "prefixo": "44200",
    "uf": "BA",
    "codigoIbge": 2928604,
    "cidade": "Santo Amaro"
  },
  {
    "prefixo": "44211",
    "uf": "BA",
    "codigoIbge": 2928604,
    "cidade": "Santo Amaro"
  },
  {
    "prefixo": "44215",
    "uf": "BA",
    "codigoIbge": 2928604,
    "cidade": "Santo Amaro"
  },
  {
    "prefixo": "44218",
    "uf": "BA",
    "codigoIbge": 2928604,
    "cidade": "Santo Amaro"
  },
  {
    "prefixo": "44220",
    "uf": "BA",
    "codigoIbge": 2929750,
    "cidade": "Saubara"
  },
  {
    "prefixo": "44230",
    "uf": "BA",
    "codigoIbge": 2901106,
    "cidade": "Amélia Rodrigues"
  },
  {
    "prefixo": "44235",
    "uf": "BA",
    "codigoIbge": 2901106,
    "cidade": "Amélia Rodrigues"
  },
  {
    "prefixo": "44240",
    "uf": "BA",
    "codigoIbge": 2901106,
    "cidade": "Amélia Rodrigues"
  },
  {
    "prefixo": "44245",
    "uf": "BA",
    "codigoIbge": 2908507,
    "cidade": "Conceição do Jacuípe"
  },
  {
    "prefixo": "44250",
    "uf": "BA",
    "codigoIbge": 2908903,
    "cidade": "Coração de Maria"
  },
  {
    "prefixo": "44253",
    "uf": "BA",
    "codigoIbge": 2908903,
    "cidade": "Coração de Maria"
  },
  {
    "prefixo": "44255",
    "uf": "BA",
    "codigoIbge": 2914505,
    "cidade": "Irará"
  },
  {
    "prefixo": "44258",
    "uf": "BA",
    "codigoIbge": 2914505,
    "cidade": "Irará"
  },
  {
    "prefixo": "44260",
    "uf": "BA",
    "codigoIbge": 2928307,
    "cidade": "Santanópolis"
  },
  {
    "prefixo": "44265",
    "uf": "BA",
    "codigoIbge": 2928307,
    "cidade": "Santanópolis"
  },
  {
    "prefixo": "44270",
    "uf": "BA",
    "codigoIbge": 2931707,
    "cidade": "Terra Nova"
  },
  {
    "prefixo": "44275",
    "uf": "BA",
    "codigoIbge": 2931707,
    "cidade": "Terra Nova"
  },
  {
    "prefixo": "44280",
    "uf": "BA",
    "codigoIbge": 2931400,
    "cidade": "Teodoro Sampaio"
  },
  {
    "prefixo": "44283",
    "uf": "BA",
    "codigoIbge": 2931400,
    "cidade": "Teodoro Sampaio"
  },
  {
    "prefixo": "44285",
    "uf": "BA",
    "codigoIbge": 2931400,
    "cidade": "Teodoro Sampaio"
  },
  {
    "prefixo": "44300",
    "uf": "BA",
    "codigoIbge": 2904902,
    "cidade": "Cachoeira"
  },
  {
    "prefixo": "44310",
    "uf": "BA",
    "codigoIbge": 2904902,
    "cidade": "Cachoeira"
  },
  {
    "prefixo": "44315",
    "uf": "BA",
    "codigoIbge": 2904902,
    "cidade": "Cachoeira"
  },
  {
    "prefixo": "44320",
    "uf": "BA",
    "codigoIbge": 2908200,
    "cidade": "Conceição da Feira"
  },
  {
    "prefixo": "44330",
    "uf": "BA",
    "codigoIbge": 2929305,
    "cidade": "São Gonçalo dos Campos"
  },
  {
    "prefixo": "44335",
    "uf": "BA",
    "codigoIbge": 2929305,
    "cidade": "São Gonçalo dos Campos"
  },
  {
    "prefixo": "44338",
    "uf": "BA",
    "codigoIbge": 2929305,
    "cidade": "São Gonçalo dos Campos"
  },
  {
    "prefixo": "44340",
    "uf": "BA",
    "codigoIbge": 2922300,
    "cidade": "Muritiba"
  },
  {
    "prefixo": "44343",
    "uf": "BA",
    "codigoIbge": 2922300,
    "cidade": "Muritiba"
  },
  {
    "prefixo": "44345",
    "uf": "BA",
    "codigoIbge": 2904852,
    "cidade": "Cabaceiras do Paraguaçu"
  },
  {
    "prefixo": "44349",
    "uf": "BA",
    "codigoIbge": 2904852,
    "cidade": "Cabaceiras do Paraguaçu"
  },
  {
    "prefixo": "44350",
    "uf": "BA",
    "codigoIbge": 2911600,
    "cidade": "Governador Mangabeira"
  },
  {
    "prefixo": "44359",
    "uf": "BA",
    "codigoIbge": 2911600,
    "cidade": "Governador Mangabeira"
  },
  {
    "prefixo": "44360",
    "uf": "BA",
    "codigoIbge": 2929008,
    "cidade": "São Félix"
  },
  {
    "prefixo": "44380",
    "uf": "BA",
    "codigoIbge": 2909802,
    "cidade": "Cruz das Almas"
  },
  {
    "prefixo": "44400",
    "uf": "BA",
    "codigoIbge": 2922508,
    "cidade": "Nazaré"
  },
  {
    "prefixo": "44420",
    "uf": "BA",
    "codigoIbge": 2920601,
    "cidade": "Maragogipe"
  },
  {
    "prefixo": "44423",
    "uf": "BA",
    "codigoIbge": 2920601,
    "cidade": "Maragogipe"
  },
  {
    "prefixo": "44426",
    "uf": "BA",
    "codigoIbge": 2920601,
    "cidade": "Maragogipe"
  },
  {
    "prefixo": "44427",
    "uf": "BA",
    "codigoIbge": 2920601,
    "cidade": "Maragogipe"
  },
  {
    "prefixo": "44428",
    "uf": "BA",
    "codigoIbge": 2920601,
    "cidade": "Maragogipe"
  },
  {
    "prefixo": "44430",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44431",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44432",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44434",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44435",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44436",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44437",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44438",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44440",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44441",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44442",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44444",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44445",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44447",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44448",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44449",
    "uf": "BA",
    "codigoIbge": 2928703,
    "cidade": "Santo Antônio de Jesus"
  },
  {
    "prefixo": "44450",
    "uf": "BA",
    "codigoIbge": 2927309,
    "cidade": "Salinas da Margarida"
  },
  {
    "prefixo": "44460",
    "uf": "BA",
    "codigoIbge": 2916104,
    "cidade": "Itaparica"
  },
  {
    "prefixo": "44470",
    "uf": "BA",
    "codigoIbge": 2933208,
    "cidade": "Vera Cruz"
  },
  {
    "prefixo": "44473",
    "uf": "BA",
    "codigoIbge": 2933208,
    "cidade": "Vera Cruz"
  },
  {
    "prefixo": "44474",
    "uf": "BA",
    "codigoIbge": 2933208,
    "cidade": "Vera Cruz"
  },
  {
    "prefixo": "44475",
    "uf": "BA",
    "codigoIbge": 2933208,
    "cidade": "Vera Cruz"
  },
  {
    "prefixo": "44478",
    "uf": "BA",
    "codigoIbge": 2933208,
    "cidade": "Vera Cruz"
  },
  {
    "prefixo": "44480",
    "uf": "BA",
    "codigoIbge": 2917805,
    "cidade": "Jaguaripe"
  },
  {
    "prefixo": "44482",
    "uf": "BA",
    "codigoIbge": 2917805,
    "cidade": "Jaguaripe"
  },
  {
    "prefixo": "44486",
    "uf": "BA",
    "codigoIbge": 2917805,
    "cidade": "Jaguaripe"
  },
  {
    "prefixo": "44488",
    "uf": "BA",
    "codigoIbge": 2917805,
    "cidade": "Jaguaripe"
  },
  {
    "prefixo": "44490",
    "uf": "BA",
    "codigoIbge": 2902302,
    "cidade": "Aratuípe"
  },
  {
    "prefixo": "44495",
    "uf": "BA",
    "codigoIbge": 2902302,
    "cidade": "Aratuípe"
  },
  {
    "prefixo": "44500",
    "uf": "BA",
    "codigoIbge": 2907301,
    "cidade": "Castro Alves"
  },
  {
    "prefixo": "44505",
    "uf": "BA",
    "codigoIbge": 2907301,
    "cidade": "Castro Alves"
  },
  {
    "prefixo": "44510",
    "uf": "BA",
    "codigoIbge": 2907301,
    "cidade": "Castro Alves"
  },
  {
    "prefixo": "44520",
    "uf": "BA",
    "codigoIbge": 2925956,
    "cidade": "Rafael Jambeiro"
  },
  {
    "prefixo": "44525",
    "uf": "BA",
    "codigoIbge": 2925956,
    "cidade": "Rafael Jambeiro"
  },
  {
    "prefixo": "44530",
    "uf": "BA",
    "codigoIbge": 2929602,
    "cidade": "Sapeaçu"
  },
  {
    "prefixo": "44535",
    "uf": "BA",
    "codigoIbge": 2929602,
    "cidade": "Sapeaçu"
  },
  {
    "prefixo": "44540",
    "uf": "BA",
    "codigoIbge": 2908309,
    "cidade": "Conceição do Almeida"
  },
  {
    "prefixo": "44545",
    "uf": "BA",
    "codigoIbge": 2908309,
    "cidade": "Conceição do Almeida"
  },
  {
    "prefixo": "44548",
    "uf": "BA",
    "codigoIbge": 2908309,
    "cidade": "Conceição do Almeida"
  },
  {
    "prefixo": "44550",
    "uf": "BA",
    "codigoIbge": 2929107,
    "cidade": "São Felipe"
  },
  {
    "prefixo": "44555",
    "uf": "BA",
    "codigoIbge": 2929107,
    "cidade": "São Felipe"
  },
  {
    "prefixo": "44560",
    "uf": "BA",
    "codigoIbge": 2910206,
    "cidade": "Dom Macedo Costa"
  },
  {
    "prefixo": "44565",
    "uf": "BA",
    "codigoIbge": 2933174,
    "cidade": "Varzedo"
  },
  {
    "prefixo": "44568",
    "uf": "BA",
    "codigoIbge": 2933174,
    "cidade": "Varzedo"
  },
  {
    "prefixo": "44575",
    "uf": "BA",
    "codigoIbge": 2922201,
    "cidade": "Muniz Ferreira"
  },
  {
    "prefixo": "44578",
    "uf": "BA",
    "codigoIbge": 2922201,
    "cidade": "Muniz Ferreira"
  },
  {
    "prefixo": "44580",
    "uf": "BA",
    "codigoIbge": 2929404,
    "cidade": "São Miguel das Matas"
  },
  {
    "prefixo": "44590",
    "uf": "BA",
    "codigoIbge": 2928505,
    "cidade": "Santa Terezinha"
  },
  {
    "prefixo": "44600",
    "uf": "BA",
    "codigoIbge": 2914000,
    "cidade": "Ipirá"
  },
  {
    "prefixo": "44610",
    "uf": "BA",
    "codigoIbge": 2924652,
    "cidade": "Pintadas"
  },
  {
    "prefixo": "44620",
    "uf": "BA",
    "codigoIbge": 2902609,
    "cidade": "Baixa Grande"
  },
  {
    "prefixo": "44630",
    "uf": "BA",
    "codigoIbge": 2920106,
    "cidade": "Mairi"
  },
  {
    "prefixo": "44633",
    "uf": "BA",
    "codigoIbge": 2920106,
    "cidade": "Mairi"
  },
  {
    "prefixo": "44635",
    "uf": "BA",
    "codigoIbge": 2933059,
    "cidade": "Várzea da Roça"
  },
  {
    "prefixo": "44640",
    "uf": "BA",
    "codigoIbge": 2926301,
    "cidade": "Riachão do Jacuípe"
  },
  {
    "prefixo": "44641",
    "uf": "BA",
    "codigoIbge": 2926301,
    "cidade": "Riachão do Jacuípe"
  },
  {
    "prefixo": "44642",
    "uf": "BA",
    "codigoIbge": 2922730,
    "cidade": "Nova Fátima"
  },
  {
    "prefixo": "44645",
    "uf": "BA",
    "codigoIbge": 2906857,
    "cidade": "Capela do Alto Alegre"
  },
  {
    "prefixo": "44650",
    "uf": "BA",
    "codigoIbge": 2911253,
    "cidade": "Gavião"
  },
  {
    "prefixo": "44655",
    "uf": "BA",
    "codigoIbge": 2924058,
    "cidade": "Pé de Serra"
  },
  {
    "prefixo": "44660",
    "uf": "BA",
    "codigoIbge": 2930402,
    "cidade": "Serra Preta"
  },
  {
    "prefixo": "44670",
    "uf": "BA",
    "codigoIbge": 2901502,
    "cidade": "Anguera"
  },
  {
    "prefixo": "44672",
    "uf": "BA",
    "codigoIbge": 2901502,
    "cidade": "Anguera"
  },
  {
    "prefixo": "44673",
    "uf": "BA",
    "codigoIbge": 2901502,
    "cidade": "Anguera"
  },
  {
    "prefixo": "44680",
    "uf": "BA",
    "codigoIbge": 2913804,
    "cidade": "Ipecaetá"
  },
  {
    "prefixo": "44685",
    "uf": "BA",
    "codigoIbge": 2913804,
    "cidade": "Ipecaetá"
  },
  {
    "prefixo": "44690",
    "uf": "BA",
    "codigoIbge": 2933158,
    "cidade": "Várzea Nova"
  },
  {
    "prefixo": "44695",
    "uf": "BA",
    "codigoIbge": 2906873,
    "cidade": "Capim Grosso"
  },
  {
    "prefixo": "44697",
    "uf": "BA",
    "codigoIbge": 2906873,
    "cidade": "Capim Grosso"
  },
  {
    "prefixo": "44698",
    "uf": "BA",
    "codigoIbge": 2929370,
    "cidade": "São José do Jacuípe"
  },
  {
    "prefixo": "44699",
    "uf": "BA",
    "codigoIbge": 2929370,
    "cidade": "São José do Jacuípe"
  },
  {
    "prefixo": "44700",
    "uf": "BA",
    "codigoIbge": 2917508,
    "cidade": "Jacobina"
  },
  {
    "prefixo": "44702",
    "uf": "BA",
    "codigoIbge": 2917508,
    "cidade": "Jacobina"
  },
  {
    "prefixo": "44704",
    "uf": "BA",
    "codigoIbge": 2917508,
    "cidade": "Jacobina"
  },
  {
    "prefixo": "44708",
    "uf": "BA",
    "codigoIbge": 2917508,
    "cidade": "Jacobina"
  },
  {
    "prefixo": "44710",
    "uf": "BA",
    "codigoIbge": 2930600,
    "cidade": "Serrolândia"
  },
  {
    "prefixo": "44713",
    "uf": "BA",
    "codigoIbge": 2925931,
    "cidade": "Quixabeira"
  },
  {
    "prefixo": "44715",
    "uf": "BA",
    "codigoIbge": 2933109,
    "cidade": "Várzea do Poço"
  },
  {
    "prefixo": "44718",
    "uf": "BA",
    "codigoIbge": 2923357,
    "cidade": "Ourolândia"
  },
  {
    "prefixo": "44720",
    "uf": "BA",
    "codigoIbge": 2921203,
    "cidade": "Miguel Calmon"
  },
  {
    "prefixo": "44723",
    "uf": "BA",
    "codigoIbge": 2921203,
    "cidade": "Miguel Calmon"
  },
  {
    "prefixo": "44727",
    "uf": "BA",
    "codigoIbge": 2921203,
    "cidade": "Miguel Calmon"
  },
  {
    "prefixo": "44730",
    "uf": "BA",
    "codigoIbge": 2905107,
    "cidade": "Caém"
  },
  {
    "prefixo": "44740",
    "uf": "BA",
    "codigoIbge": 2929800,
    "cidade": "Saúde"
  },
  {
    "prefixo": "44745",
    "uf": "BA",
    "codigoIbge": 2921401,
    "cidade": "Mirangaba"
  },
  {
    "prefixo": "44747",
    "uf": "BA",
    "codigoIbge": 2921401,
    "cidade": "Mirangaba"
  },
  {
    "prefixo": "44748",
    "uf": "BA",
    "codigoIbge": 2921401,
    "cidade": "Mirangaba"
  },
  {
    "prefixo": "44750",
    "uf": "BA",
    "codigoIbge": 2905503,
    "cidade": "Caldeirão Grande"
  },
  {
    "prefixo": "44755",
    "uf": "BA",
    "codigoIbge": 2925253,
    "cidade": "Ponto Novo"
  },
  {
    "prefixo": "44757",
    "uf": "BA",
    "codigoIbge": 2925253,
    "cidade": "Ponto Novo"
  },
  {
    "prefixo": "44770",
    "uf": "BA",
    "codigoIbge": 2924603,
    "cidade": "Pindobaçu"
  },
  {
    "prefixo": "44771",
    "uf": "BA",
    "codigoIbge": 2924603,
    "cidade": "Pindobaçu"
  },
  {
    "prefixo": "44772",
    "uf": "BA",
    "codigoIbge": 2924603,
    "cidade": "Pindobaçu"
  },
  {
    "prefixo": "44774",
    "uf": "BA",
    "codigoIbge": 2924603,
    "cidade": "Pindobaçu"
  },
  {
    "prefixo": "44775",
    "uf": "BA",
    "codigoIbge": 2910859,
    "cidade": "Filadélfia"
  },
  {
    "prefixo": "44780",
    "uf": "BA",
    "codigoIbge": 2901809,
    "cidade": "Antônio Gonçalves"
  },
  {
    "prefixo": "44790",
    "uf": "BA",
    "codigoIbge": 2906006,
    "cidade": "Campo Formoso"
  },
  {
    "prefixo": "44795",
    "uf": "BA",
    "codigoIbge": 2906006,
    "cidade": "Campo Formoso"
  },
  {
    "prefixo": "44798",
    "uf": "BA",
    "codigoIbge": 2932457,
    "cidade": "Umburanas"
  },
  {
    "prefixo": "44800",
    "uf": "BA",
    "codigoIbge": 2922102,
    "cidade": "Mundo Novo"
  },
  {
    "prefixo": "44806",
    "uf": "BA",
    "codigoIbge": 2922102,
    "cidade": "Mundo Novo"
  },
  {
    "prefixo": "44820",
    "uf": "BA",
    "codigoIbge": 2906873,
    "cidade": "Capim Grosso"
  },
  {
    "prefixo": "44821",
    "uf": "BA",
    "codigoIbge": 2906873,
    "cidade": "Capim Grosso"
  },
  {
    "prefixo": "44822",
    "uf": "BA",
    "codigoIbge": 2906873,
    "cidade": "Capim Grosso"
  },
  {
    "prefixo": "44823",
    "uf": "BA",
    "codigoIbge": 2906873,
    "cidade": "Capim Grosso"
  },
  {
    "prefixo": "44824",
    "uf": "BA",
    "codigoIbge": 2906873,
    "cidade": "Capim Grosso"
  },
  {
    "prefixo": "44825",
    "uf": "BA",
    "codigoIbge": 2922102,
    "cidade": "Mundo Novo"
  },
  {
    "prefixo": "44830",
    "uf": "BA",
    "codigoIbge": 2924801,
    "cidade": "Piritiba"
  },
  {
    "prefixo": "44835",
    "uf": "BA",
    "codigoIbge": 2924801,
    "cidade": "Piritiba"
  },
  {
    "prefixo": "44837",
    "uf": "BA",
    "codigoIbge": 2924801,
    "cidade": "Piritiba"
  },
  {
    "prefixo": "44840",
    "uf": "BA",
    "codigoIbge": 2931301,
    "cidade": "Tapiramutá"
  },
  {
    "prefixo": "44841",
    "uf": "BA",
    "codigoIbge": 2931301,
    "cidade": "Tapiramutá"
  },
  {
    "prefixo": "44843",
    "uf": "BA",
    "codigoIbge": 2931301,
    "cidade": "Tapiramutá"
  },
  {
    "prefixo": "44844",
    "uf": "BA",
    "codigoIbge": 2931301,
    "cidade": "Tapiramutá"
  },
  {
    "prefixo": "44845",
    "uf": "BA",
    "codigoIbge": 2931301,
    "cidade": "Tapiramutá"
  },
  {
    "prefixo": "44850",
    "uf": "BA",
    "codigoIbge": 2921708,
    "cidade": "Morro do Chapéu"
  },
  {
    "prefixo": "44857",
    "uf": "BA",
    "codigoIbge": 2921708,
    "cidade": "Morro do Chapéu"
  },
  {
    "prefixo": "44858",
    "uf": "BA",
    "codigoIbge": 2921708,
    "cidade": "Morro do Chapéu"
  },
  {
    "prefixo": "44859",
    "uf": "BA",
    "codigoIbge": 2921708,
    "cidade": "Morro do Chapéu"
  },
  {
    "prefixo": "44860",
    "uf": "BA",
    "codigoIbge": 2914604,
    "cidade": "Irecê"
  },
  {
    "prefixo": "44861",
    "uf": "BA",
    "codigoIbge": 2914604,
    "cidade": "Irecê"
  },
  {
    "prefixo": "44862",
    "uf": "BA",
    "codigoIbge": 2914604,
    "cidade": "Irecê"
  },
  {
    "prefixo": "44863",
    "uf": "BA",
    "codigoIbge": 2914604,
    "cidade": "Irecê"
  },
  {
    "prefixo": "44864",
    "uf": "BA",
    "codigoIbge": 2914604,
    "cidade": "Irecê"
  },
  {
    "prefixo": "44865",
    "uf": "BA",
    "codigoIbge": 2914604,
    "cidade": "Irecê"
  },
  {
    "prefixo": "44867",
    "uf": "BA",
    "codigoIbge": 2914604,
    "cidade": "Irecê"
  },
  {
    "prefixo": "44873",
    "uf": "BA",
    "codigoIbge": 2914604,
    "cidade": "Irecê"
  },
  {
    "prefixo": "44874",
    "uf": "BA",
    "codigoIbge": 2914604,
    "cidade": "Irecê"
  },
  {
    "prefixo": "44875",
    "uf": "BA",
    "codigoIbge": 2914604,
    "cidade": "Irecê"
  },
  {
    "prefixo": "44876",
    "uf": "BA",
    "codigoIbge": 2914604,
    "cidade": "Irecê"
  },
  {
    "prefixo": "44880",
    "uf": "BA",
    "codigoIbge": 2905305,
    "cidade": "Cafarnaum"
  },
  {
    "prefixo": "44881",
    "uf": "BA",
    "codigoIbge": 2905305,
    "cidade": "Cafarnaum"
  },
  {
    "prefixo": "44882",
    "uf": "BA",
    "codigoIbge": 2905305,
    "cidade": "Cafarnaum"
  },
  {
    "prefixo": "44885",
    "uf": "BA",
    "codigoIbge": 2922052,
    "cidade": "Mulungu do Morro"
  },
  {
    "prefixo": "44888",
    "uf": "BA",
    "codigoIbge": 2922052,
    "cidade": "Mulungu do Morro"
  },
  {
    "prefixo": "44889",
    "uf": "BA",
    "codigoIbge": 2922052,
    "cidade": "Mulungu do Morro"
  },
  {
    "prefixo": "44890",
    "uf": "BA",
    "codigoIbge": 2906204,
    "cidade": "Canarana"
  },
  {
    "prefixo": "44892",
    "uf": "BA",
    "codigoIbge": 2906204,
    "cidade": "Canarana"
  },
  {
    "prefixo": "44895",
    "uf": "BA",
    "codigoIbge": 2903235,
    "cidade": "Barro Alto"
  },
  {
    "prefixo": "44898",
    "uf": "BA",
    "codigoIbge": 2903235,
    "cidade": "Barro Alto"
  },
  {
    "prefixo": "44900",
    "uf": "BA",
    "codigoIbge": 2914604,
    "cidade": "Irecê"
  },
  {
    "prefixo": "44905",
    "uf": "BA",
    "codigoIbge": 2919157,
    "cidade": "Lapão"
  },
  {
    "prefixo": "44910",
    "uf": "BA",
    "codigoIbge": 2901155,
    "cidade": "América Dourada"
  },
  {
    "prefixo": "44911",
    "uf": "BA",
    "codigoIbge": 2901155,
    "cidade": "América Dourada"
  },
  {
    "prefixo": "44912",
    "uf": "BA",
    "codigoIbge": 2901155,
    "cidade": "América Dourada"
  },
  {
    "prefixo": "44915",
    "uf": "BA",
    "codigoIbge": 2929255,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "44920",
    "uf": "BA",
    "codigoIbge": 2918357,
    "cidade": "João Dourado"
  },
  {
    "prefixo": "44925",
    "uf": "BA",
    "codigoIbge": 2918506,
    "cidade": "Jussara"
  },
  {
    "prefixo": "44927",
    "uf": "BA",
    "codigoIbge": 2918506,
    "cidade": "Jussara"
  },
  {
    "prefixo": "44930",
    "uf": "BA",
    "codigoIbge": 2925600,
    "cidade": "Presidente Dutra"
  },
  {
    "prefixo": "44940",
    "uf": "BA",
    "codigoIbge": 2907608,
    "cidade": "Central"
  },
  {
    "prefixo": "44950",
    "uf": "BA",
    "codigoIbge": 2932408,
    "cidade": "Uibaí"
  },
  {
    "prefixo": "44955",
    "uf": "BA",
    "codigoIbge": 2932408,
    "cidade": "Uibaí"
  },
  {
    "prefixo": "44960",
    "uf": "BA",
    "codigoIbge": 2913101,
    "cidade": "Ibititá"
  },
  {
    "prefixo": "44965",
    "uf": "BA",
    "codigoIbge": 2913101,
    "cidade": "Ibititá"
  },
  {
    "prefixo": "44970",
    "uf": "BA",
    "codigoIbge": 2912400,
    "cidade": "Ibipeba"
  },
  {
    "prefixo": "44972",
    "uf": "BA",
    "codigoIbge": 2912400,
    "cidade": "Ibipeba"
  },
  {
    "prefixo": "44975",
    "uf": "BA",
    "codigoIbge": 2912400,
    "cidade": "Ibipeba"
  },
  {
    "prefixo": "44990",
    "uf": "BA",
    "codigoIbge": 2903003,
    "cidade": "Barra do Mendes"
  },
  {
    "prefixo": "44995",
    "uf": "BA",
    "codigoIbge": 2903003,
    "cidade": "Barra do Mendes"
  },
  {
    "prefixo": "44996",
    "uf": "BA",
    "codigoIbge": 2903003,
    "cidade": "Barra do Mendes"
  },
  {
    "prefixo": "45000",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45002",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45003",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45005",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45007",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45008",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45009",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45012",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45020",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45023",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45026",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45027",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45028",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45029",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45031",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45032",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45037",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45038",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45051",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45052",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45053",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45055",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45057",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45058",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45061",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45065",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45066",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45070",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45075",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45077",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45078",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45079",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45085",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45089",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45099",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45102",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45103",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45104",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45105",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45106",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45107",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45108",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45109",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45110",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45111",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45112",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45114",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45115",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45116",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45117",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45118",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45119",
    "uf": "BA",
    "codigoIbge": 2933307,
    "cidade": "Vitória da Conquista"
  },
  {
    "prefixo": "45120",
    "uf": "BA",
    "codigoIbge": 2902906,
    "cidade": "Barra do Choça"
  },
  {
    "prefixo": "45121",
    "uf": "BA",
    "codigoIbge": 2902906,
    "cidade": "Barra do Choça"
  },
  {
    "prefixo": "45122",
    "uf": "BA",
    "codigoIbge": 2902906,
    "cidade": "Barra do Choça"
  },
  {
    "prefixo": "45123",
    "uf": "BA",
    "codigoIbge": 2902906,
    "cidade": "Barra do Choça"
  },
  {
    "prefixo": "45130",
    "uf": "BA",
    "codigoIbge": 2904803,
    "cidade": "Caatiba"
  },
  {
    "prefixo": "45140",
    "uf": "BA",
    "codigoIbge": 2915809,
    "cidade": "Itambé"
  },
  {
    "prefixo": "45142",
    "uf": "BA",
    "codigoIbge": 2915809,
    "cidade": "Itambé"
  },
  {
    "prefixo": "45145",
    "uf": "BA",
    "codigoIbge": 2915809,
    "cidade": "Itambé"
  },
  {
    "prefixo": "45150",
    "uf": "BA",
    "codigoIbge": 2910404,
    "cidade": "Encruzilhada"
  },
  {
    "prefixo": "45153",
    "uf": "BA",
    "codigoIbge": 2910404,
    "cidade": "Encruzilhada"
  },
  {
    "prefixo": "45155",
    "uf": "BA",
    "codigoIbge": 2926657,
    "cidade": "Ribeirão do Largo"
  },
  {
    "prefixo": "45156",
    "uf": "BA",
    "codigoIbge": 2926657,
    "cidade": "Ribeirão do Largo"
  },
  {
    "prefixo": "45157",
    "uf": "BA",
    "codigoIbge": 2906709,
    "cidade": "Cândido Sales"
  },
  {
    "prefixo": "45158",
    "uf": "BA",
    "codigoIbge": 2906709,
    "cidade": "Cândido Sales"
  },
  {
    "prefixo": "45159",
    "uf": "BA",
    "codigoIbge": 2906709,
    "cidade": "Cândido Sales"
  },
  {
    "prefixo": "45160",
    "uf": "BA",
    "codigoIbge": 2903508,
    "cidade": "Belo Campo"
  },
  {
    "prefixo": "45170",
    "uf": "BA",
    "codigoIbge": 2931806,
    "cidade": "Tremedal"
  },
  {
    "prefixo": "45175",
    "uf": "BA",
    "codigoIbge": 2931806,
    "cidade": "Tremedal"
  },
  {
    "prefixo": "45177",
    "uf": "BA",
    "codigoIbge": 2906899,
    "cidade": "Caraíbas"
  },
  {
    "prefixo": "45178",
    "uf": "BA",
    "codigoIbge": 2906899,
    "cidade": "Caraíbas"
  },
  {
    "prefixo": "45180",
    "uf": "BA",
    "codigoIbge": 2901205,
    "cidade": "Anagé"
  },
  {
    "prefixo": "45185",
    "uf": "BA",
    "codigoIbge": 2901205,
    "cidade": "Anagé"
  },
  {
    "prefixo": "45190",
    "uf": "BA",
    "codigoIbge": 2925006,
    "cidade": "Planalto"
  },
  {
    "prefixo": "45195",
    "uf": "BA",
    "codigoIbge": 2925006,
    "cidade": "Planalto"
  },
  {
    "prefixo": "45200",
    "uf": "BA",
    "codigoIbge": 2918001,
    "cidade": "Jequié"
  },
  {
    "prefixo": "45201",
    "uf": "BA",
    "codigoIbge": 2918001,
    "cidade": "Jequié"
  },
  {
    "prefixo": "45202",
    "uf": "BA",
    "codigoIbge": 2918001,
    "cidade": "Jequié"
  },
  {
    "prefixo": "45203",
    "uf": "BA",
    "codigoIbge": 2918001,
    "cidade": "Jequié"
  },
  {
    "prefixo": "45204",
    "uf": "BA",
    "codigoIbge": 2918001,
    "cidade": "Jequié"
  },
  {
    "prefixo": "45205",
    "uf": "BA",
    "codigoIbge": 2918001,
    "cidade": "Jequié"
  },
  {
    "prefixo": "45206",
    "uf": "BA",
    "codigoIbge": 2918001,
    "cidade": "Jequié"
  },
  {
    "prefixo": "45207",
    "uf": "BA",
    "codigoIbge": 2918001,
    "cidade": "Jequié"
  },
  {
    "prefixo": "45208",
    "uf": "BA",
    "codigoIbge": 2918001,
    "cidade": "Jequié"
  },
  {
    "prefixo": "45209",
    "uf": "BA",
    "codigoIbge": 2918001,
    "cidade": "Jequié"
  },
  {
    "prefixo": "45210",
    "uf": "BA",
    "codigoIbge": 2918001,
    "cidade": "Jequié"
  },
  {
    "prefixo": "45211",
    "uf": "BA",
    "codigoIbge": 2918001,
    "cidade": "Jequié"
  },
  {
    "prefixo": "45213",
    "uf": "BA",
    "codigoIbge": 2918001,
    "cidade": "Jequié"
  },
  {
    "prefixo": "45214",
    "uf": "BA",
    "codigoIbge": 2918001,
    "cidade": "Jequié"
  },
  {
    "prefixo": "45215",
    "uf": "BA",
    "codigoIbge": 2918704,
    "cidade": "Lafaiete Coutinho"
  },
  {
    "prefixo": "45220",
    "uf": "BA",
    "codigoIbge": 2900603,
    "cidade": "Aiquara"
  },
  {
    "prefixo": "45225",
    "uf": "BA",
    "codigoIbge": 2918308,
    "cidade": "Jitaúna"
  },
  {
    "prefixo": "45230",
    "uf": "BA",
    "codigoIbge": 2915106,
    "cidade": "Itagi"
  },
  {
    "prefixo": "45240",
    "uf": "BA",
    "codigoIbge": 2920403,
    "cidade": "Manoel Vitorino"
  },
  {
    "prefixo": "45245",
    "uf": "BA",
    "codigoIbge": 2920403,
    "cidade": "Manoel Vitorino"
  },
  {
    "prefixo": "45250",
    "uf": "BA",
    "codigoIbge": 2903706,
    "cidade": "Boa Nova"
  },
  {
    "prefixo": "45255",
    "uf": "BA",
    "codigoIbge": 2921450,
    "cidade": "Mirante"
  },
  {
    "prefixo": "45258",
    "uf": "BA",
    "codigoIbge": 2903953,
    "cidade": "Bom Jesus da Serra"
  },
  {
    "prefixo": "45260",
    "uf": "BA",
    "codigoIbge": 2925105,
    "cidade": "Poções"
  },
  {
    "prefixo": "45262",
    "uf": "BA",
    "codigoIbge": 2925105,
    "cidade": "Poções"
  },
  {
    "prefixo": "45263",
    "uf": "BA",
    "codigoIbge": 2903953,
    "cidade": "Bom Jesus da Serra"
  },
  {
    "prefixo": "45264",
    "uf": "BA",
    "codigoIbge": 2925105,
    "cidade": "Poções"
  },
  {
    "prefixo": "45265",
    "uf": "BA",
    "codigoIbge": 2905156,
    "cidade": "Caetanos"
  },
  {
    "prefixo": "45270",
    "uf": "BA",
    "codigoIbge": 2922706,
    "cidade": "Nova Canaã"
  },
  {
    "prefixo": "45275",
    "uf": "BA",
    "codigoIbge": 2922706,
    "cidade": "Nova Canaã"
  },
  {
    "prefixo": "45280",
    "uf": "BA",
    "codigoIbge": 2913507,
    "cidade": "Iguaí"
  },
  {
    "prefixo": "45285",
    "uf": "BA",
    "codigoIbge": 2913507,
    "cidade": "Iguaí"
  },
  {
    "prefixo": "45290",
    "uf": "BA",
    "codigoIbge": 2912301,
    "cidade": "Ibicuí"
  },
  {
    "prefixo": "45295",
    "uf": "BA",
    "codigoIbge": 2912301,
    "cidade": "Ibicuí"
  },
  {
    "prefixo": "45298",
    "uf": "BA",
    "codigoIbge": 2912301,
    "cidade": "Ibicuí"
  },
  {
    "prefixo": "45300",
    "uf": "BA",
    "codigoIbge": 2901007,
    "cidade": "Amargosa"
  },
  {
    "prefixo": "45301",
    "uf": "BA",
    "codigoIbge": 2901007,
    "cidade": "Amargosa"
  },
  {
    "prefixo": "45302",
    "uf": "BA",
    "codigoIbge": 2901007,
    "cidade": "Amargosa"
  },
  {
    "prefixo": "45303",
    "uf": "BA",
    "codigoIbge": 2901007,
    "cidade": "Amargosa"
  },
  {
    "prefixo": "45305",
    "uf": "BA",
    "codigoIbge": 2910305,
    "cidade": "Elísio Medrado"
  },
  {
    "prefixo": "45310",
    "uf": "BA",
    "codigoIbge": 2932101,
    "cidade": "Ubaíra"
  },
  {
    "prefixo": "45312",
    "uf": "BA",
    "codigoIbge": 2932101,
    "cidade": "Ubaíra"
  },
  {
    "prefixo": "45313",
    "uf": "BA",
    "codigoIbge": 2932101,
    "cidade": "Ubaíra"
  },
  {
    "prefixo": "45315",
    "uf": "BA",
    "codigoIbge": 2921302,
    "cidade": "Milagres"
  },
  {
    "prefixo": "45318",
    "uf": "BA",
    "codigoIbge": 2921302,
    "cidade": "Milagres"
  },
  {
    "prefixo": "45320",
    "uf": "BA",
    "codigoIbge": 2927903,
    "cidade": "Santa Inês"
  },
  {
    "prefixo": "45325",
    "uf": "BA",
    "codigoIbge": 2904308,
    "cidade": "Brejões"
  },
  {
    "prefixo": "45328",
    "uf": "BA",
    "codigoIbge": 2904308,
    "cidade": "Brejões"
  },
  {
    "prefixo": "45330",
    "uf": "BA",
    "codigoIbge": 2909505,
    "cidade": "Cravolândia"
  },
  {
    "prefixo": "45340",
    "uf": "BA",
    "codigoIbge": 2916708,
    "cidade": "Itaquara"
  },
  {
    "prefixo": "45345",
    "uf": "BA",
    "codigoIbge": 2917607,
    "cidade": "Jaguaquara"
  },
  {
    "prefixo": "45347",
    "uf": "BA",
    "codigoIbge": 2917607,
    "cidade": "Jaguaquara"
  },
  {
    "prefixo": "45350",
    "uf": "BA",
    "codigoIbge": 2916906,
    "cidade": "Itiruçu"
  },
  {
    "prefixo": "45355",
    "uf": "BA",
    "codigoIbge": 2901957,
    "cidade": "Apuarema"
  },
  {
    "prefixo": "45358",
    "uf": "BA",
    "codigoIbge": 2901957,
    "cidade": "Apuarema"
  },
  {
    "prefixo": "45360",
    "uf": "BA",
    "codigoIbge": 2920502,
    "cidade": "Maracás"
  },
  {
    "prefixo": "45365",
    "uf": "BA",
    "codigoIbge": 2919058,
    "cidade": "Lajedo do Tabocal"
  },
  {
    "prefixo": "45370",
    "uf": "BA",
    "codigoIbge": 2914208,
    "cidade": "Irajuba"
  },
  {
    "prefixo": "45375",
    "uf": "BA",
    "codigoIbge": 2924900,
    "cidade": "Planaltino"
  },
  {
    "prefixo": "45378",
    "uf": "BA",
    "codigoIbge": 2924900,
    "cidade": "Planaltino"
  },
  {
    "prefixo": "45380",
    "uf": "BA",
    "codigoIbge": 2924900,
    "cidade": "Planaltino"
  },
  {
    "prefixo": "45390",
    "uf": "BA",
    "codigoIbge": 2922805,
    "cidade": "Nova Itarana"
  },
  {
    "prefixo": "45398",
    "uf": "BA",
    "codigoIbge": 2922805,
    "cidade": "Nova Itarana"
  },
  {
    "prefixo": "45400",
    "uf": "BA",
    "codigoIbge": 2932903,
    "cidade": "Valença"
  },
  {
    "prefixo": "45412",
    "uf": "BA",
    "codigoIbge": 2932903,
    "cidade": "Valença"
  },
  {
    "prefixo": "45414",
    "uf": "BA",
    "codigoIbge": 2932903,
    "cidade": "Valença"
  },
  {
    "prefixo": "45416",
    "uf": "BA",
    "codigoIbge": 2925758,
    "cidade": "Presidente Tancredo Neves"
  },
  {
    "prefixo": "45420",
    "uf": "BA",
    "codigoIbge": 2905404,
    "cidade": "Cairu"
  },
  {
    "prefixo": "45422",
    "uf": "BA",
    "codigoIbge": 2905404,
    "cidade": "Cairu"
  },
  {
    "prefixo": "45424",
    "uf": "BA",
    "codigoIbge": 2905404,
    "cidade": "Cairu"
  },
  {
    "prefixo": "45426",
    "uf": "BA",
    "codigoIbge": 2905404,
    "cidade": "Cairu"
  },
  {
    "prefixo": "45428",
    "uf": "BA",
    "codigoIbge": 2905404,
    "cidade": "Cairu"
  },
  {
    "prefixo": "45430",
    "uf": "BA",
    "codigoIbge": 2931202,
    "cidade": "Taperoá"
  },
  {
    "prefixo": "45434",
    "uf": "BA",
    "codigoIbge": 2931202,
    "cidade": "Taperoá"
  },
  {
    "prefixo": "45435",
    "uf": "BA",
    "codigoIbge": 2917300,
    "cidade": "Ituberá"
  },
  {
    "prefixo": "45436",
    "uf": "BA",
    "codigoIbge": 2924678,
    "cidade": "Piraí do Norte"
  },
  {
    "prefixo": "45440",
    "uf": "BA",
    "codigoIbge": 2922607,
    "cidade": "Nilo Peçanha"
  },
  {
    "prefixo": "45443",
    "uf": "BA",
    "codigoIbge": 2913457,
    "cidade": "Igrapiúna"
  },
  {
    "prefixo": "45445",
    "uf": "BA",
    "codigoIbge": 2905800,
    "cidade": "Camamu"
  },
  {
    "prefixo": "45448",
    "uf": "BA",
    "codigoIbge": 2905800,
    "cidade": "Camamu"
  },
  {
    "prefixo": "45449",
    "uf": "BA",
    "codigoIbge": 2905800,
    "cidade": "Camamu"
  },
  {
    "prefixo": "45450",
    "uf": "BA",
    "codigoIbge": 2911204,
    "cidade": "Gandu"
  },
  {
    "prefixo": "45452",
    "uf": "BA",
    "codigoIbge": 2922755,
    "cidade": "Nova Ibiá"
  },
  {
    "prefixo": "45455",
    "uf": "BA",
    "codigoIbge": 2915700,
    "cidade": "Itamari"
  },
  {
    "prefixo": "45460",
    "uf": "BA",
    "codigoIbge": 2933505,
    "cidade": "Wenceslau Guimarães"
  },
  {
    "prefixo": "45465",
    "uf": "BA",
    "codigoIbge": 2931608,
    "cidade": "Teolândia"
  },
  {
    "prefixo": "45470",
    "uf": "BA",
    "codigoIbge": 2918209,
    "cidade": "Jiquiriçá"
  },
  {
    "prefixo": "45480",
    "uf": "BA",
    "codigoIbge": 2922409,
    "cidade": "Mutuípe"
  },
  {
    "prefixo": "45490",
    "uf": "BA",
    "codigoIbge": 2918803,
    "cidade": "Laje"
  },
  {
    "prefixo": "45495",
    "uf": "BA",
    "codigoIbge": 2918803,
    "cidade": "Laje"
  },
  {
    "prefixo": "45498",
    "uf": "BA",
    "codigoIbge": 2918803,
    "cidade": "Laje"
  },
  {
    "prefixo": "45500",
    "uf": "BA",
    "codigoIbge": 2912707,
    "cidade": "Ibirapitanga"
  },
  {
    "prefixo": "45520",
    "uf": "BA",
    "codigoIbge": 2920700,
    "cidade": "Maraú"
  },
  {
    "prefixo": "45523",
    "uf": "BA",
    "codigoIbge": 2920700,
    "cidade": "Maraú"
  },
  {
    "prefixo": "45525",
    "uf": "BA",
    "codigoIbge": 2920700,
    "cidade": "Maraú"
  },
  {
    "prefixo": "45530",
    "uf": "BA",
    "codigoIbge": 2914901,
    "cidade": "Itacaré"
  },
  {
    "prefixo": "45534",
    "uf": "BA",
    "codigoIbge": 2914901,
    "cidade": "Itacaré"
  },
  {
    "prefixo": "45540",
    "uf": "BA",
    "codigoIbge": 2911501,
    "cidade": "Gongogi"
  },
  {
    "prefixo": "45543",
    "uf": "BA",
    "codigoIbge": 2911501,
    "cidade": "Gongogi"
  },
  {
    "prefixo": "45545",
    "uf": "BA",
    "codigoIbge": 2932200,
    "cidade": "Ubaitaba"
  },
  {
    "prefixo": "45546",
    "uf": "BA",
    "codigoIbge": 2932200,
    "cidade": "Ubaitaba"
  },
  {
    "prefixo": "45550",
    "uf": "BA",
    "codigoIbge": 2932309,
    "cidade": "Ubatã"
  },
  {
    "prefixo": "45560",
    "uf": "BA",
    "codigoIbge": 2903102,
    "cidade": "Barra do Rocha"
  },
  {
    "prefixo": "45570",
    "uf": "BA",
    "codigoIbge": 2913903,
    "cidade": "Ipiaú"
  },
  {
    "prefixo": "45580",
    "uf": "BA",
    "codigoIbge": 2912905,
    "cidade": "Ibirataia"
  },
  {
    "prefixo": "45582",
    "uf": "BA",
    "codigoIbge": 2912905,
    "cidade": "Ibirataia"
  },
  {
    "prefixo": "45585",
    "uf": "BA",
    "codigoIbge": 2915205,
    "cidade": "Itagibá"
  },
  {
    "prefixo": "45588",
    "uf": "BA",
    "codigoIbge": 2915205,
    "cidade": "Itagibá"
  },
  {
    "prefixo": "45590",
    "uf": "BA",
    "codigoIbge": 2910008,
    "cidade": "Dário Meira"
  },
  {
    "prefixo": "45600",
    "uf": "BA",
    "codigoIbge": 2914802,
    "cidade": "Itabuna"
  },
  {
    "prefixo": "45601",
    "uf": "BA",
    "codigoIbge": 2914802,
    "cidade": "Itabuna"
  },
  {
    "prefixo": "45602",
    "uf": "BA",
    "codigoIbge": 2914802,
    "cidade": "Itabuna"
  },
  {
    "prefixo": "45603",
    "uf": "BA",
    "codigoIbge": 2914802,
    "cidade": "Itabuna"
  },
  {
    "prefixo": "45604",
    "uf": "BA",
    "codigoIbge": 2914802,
    "cidade": "Itabuna"
  },
  {
    "prefixo": "45605",
    "uf": "BA",
    "codigoIbge": 2914802,
    "cidade": "Itabuna"
  },
  {
    "prefixo": "45606",
    "uf": "BA",
    "codigoIbge": 2914802,
    "cidade": "Itabuna"
  },
  {
    "prefixo": "45607",
    "uf": "BA",
    "codigoIbge": 2914802,
    "cidade": "Itabuna"
  },
  {
    "prefixo": "45608",
    "uf": "BA",
    "codigoIbge": 2914802,
    "cidade": "Itabuna"
  },
  {
    "prefixo": "45610",
    "uf": "BA",
    "codigoIbge": 2914802,
    "cidade": "Itabuna"
  },
  {
    "prefixo": "45611",
    "uf": "BA",
    "codigoIbge": 2914802,
    "cidade": "Itabuna"
  },
  {
    "prefixo": "45613",
    "uf": "BA",
    "codigoIbge": 2914802,
    "cidade": "Itabuna"
  },
  {
    "prefixo": "45614",
    "uf": "BA",
    "codigoIbge": 2914802,
    "cidade": "Itabuna"
  },
  {
    "prefixo": "45615",
    "uf": "BA",
    "codigoIbge": 2904704,
    "cidade": "Buerarema"
  },
  {
    "prefixo": "45620",
    "uf": "BA",
    "codigoIbge": 2929354,
    "cidade": "São José da Vitória"
  },
  {
    "prefixo": "45622",
    "uf": "BA",
    "codigoIbge": 2918555,
    "cidade": "Jussari"
  },
  {
    "prefixo": "45624",
    "uf": "BA",
    "codigoIbge": 2918555,
    "cidade": "Jussari"
  },
  {
    "prefixo": "45625",
    "uf": "BA",
    "codigoIbge": 2903300,
    "cidade": "Barro Preto"
  },
  {
    "prefixo": "45630",
    "uf": "BA",
    "codigoIbge": 2915502,
    "cidade": "Itajuípe"
  },
  {
    "prefixo": "45635",
    "uf": "BA",
    "codigoIbge": 2915502,
    "cidade": "Itajuípe"
  },
  {
    "prefixo": "45638",
    "uf": "BA",
    "codigoIbge": 2908002,
    "cidade": "Coaraci"
  },
  {
    "prefixo": "45640",
    "uf": "BA",
    "codigoIbge": 2900900,
    "cidade": "Almadina"
  },
  {
    "prefixo": "45645",
    "uf": "BA",
    "codigoIbge": 2916609,
    "cidade": "Itapitanga"
  },
  {
    "prefixo": "45650",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45651",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45652",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45653",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45654",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45655",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45656",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45657",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45658",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45659",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45660",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45661",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45662",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45663",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45664",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45665",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45666",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45667",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45669",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45670",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45672",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45673",
    "uf": "BA",
    "codigoIbge": 2913606,
    "cidade": "Ilhéus"
  },
  {
    "prefixo": "45675",
    "uf": "BA",
    "codigoIbge": 2902401,
    "cidade": "Aurelino Leal"
  },
  {
    "prefixo": "45676",
    "uf": "BA",
    "codigoIbge": 2902401,
    "cidade": "Aurelino Leal"
  },
  {
    "prefixo": "45678",
    "uf": "BA",
    "codigoIbge": 2902401,
    "cidade": "Aurelino Leal"
  },
  {
    "prefixo": "45680",
    "uf": "BA",
    "codigoIbge": 2932705,
    "cidade": "Uruçuca"
  },
  {
    "prefixo": "45690",
    "uf": "BA",
    "codigoIbge": 2932507,
    "cidade": "Una"
  },
  {
    "prefixo": "45695",
    "uf": "BA",
    "codigoIbge": 2902252,
    "cidade": "Arataca"
  },
  {
    "prefixo": "45698",
    "uf": "BA",
    "codigoIbge": 2902252,
    "cidade": "Arataca"
  },
  {
    "prefixo": "45700",
    "uf": "BA",
    "codigoIbge": 2916401,
    "cidade": "Itapetinga"
  },
  {
    "prefixo": "45705",
    "uf": "BA",
    "codigoIbge": 2916401,
    "cidade": "Itapetinga"
  },
  {
    "prefixo": "45709",
    "uf": "BA",
    "codigoIbge": 2916401,
    "cidade": "Itapetinga"
  },
  {
    "prefixo": "45710",
    "uf": "BA",
    "codigoIbge": 2917102,
    "cidade": "Itororó"
  },
  {
    "prefixo": "45712",
    "uf": "BA",
    "codigoIbge": 2917102,
    "cidade": "Itororó"
  },
  {
    "prefixo": "45714",
    "uf": "BA",
    "codigoIbge": 2917102,
    "cidade": "Itororó"
  },
  {
    "prefixo": "45720",
    "uf": "BA",
    "codigoIbge": 2910909,
    "cidade": "Firmino Alves"
  },
  {
    "prefixo": "45725",
    "uf": "BA",
    "codigoIbge": 2927804,
    "cidade": "Santa Cruz da Vitória"
  },
  {
    "prefixo": "45730",
    "uf": "BA",
    "codigoIbge": 2915403,
    "cidade": "Itaju do Colônia"
  },
  {
    "prefixo": "45740",
    "uf": "BA",
    "codigoIbge": 2911006,
    "cidade": "Floresta Azul"
  },
  {
    "prefixo": "45745",
    "uf": "BA",
    "codigoIbge": 2912103,
    "cidade": "Ibicaraí"
  },
  {
    "prefixo": "45750",
    "uf": "BA",
    "codigoIbge": 2916203,
    "cidade": "Itapé"
  },
  {
    "prefixo": "45760",
    "uf": "BA",
    "codigoIbge": 2919702,
    "cidade": "Macarani"
  },
  {
    "prefixo": "45770",
    "uf": "BA",
    "codigoIbge": 2920007,
    "cidade": "Maiquinique"
  },
  {
    "prefixo": "45780",
    "uf": "BA",
    "codigoIbge": 2916807,
    "cidade": "Itarantim"
  },
  {
    "prefixo": "45785",
    "uf": "BA",
    "codigoIbge": 2916807,
    "cidade": "Itarantim"
  },
  {
    "prefixo": "45790",
    "uf": "BA",
    "codigoIbge": 2925402,
    "cidade": "Potiraguá"
  },
  {
    "prefixo": "45795",
    "uf": "BA",
    "codigoIbge": 2925402,
    "cidade": "Potiraguá"
  },
  {
    "prefixo": "45800",
    "uf": "BA",
    "codigoIbge": 2903409,
    "cidade": "Belmonte"
  },
  {
    "prefixo": "45804",
    "uf": "BA",
    "codigoIbge": 2903409,
    "cidade": "Belmonte"
  },
  {
    "prefixo": "45805",
    "uf": "BA",
    "codigoIbge": 2903409,
    "cidade": "Belmonte"
  },
  {
    "prefixo": "45806",
    "uf": "BA",
    "codigoIbge": 2903409,
    "cidade": "Belmonte"
  },
  {
    "prefixo": "45807",
    "uf": "BA",
    "codigoIbge": 2927705,
    "cidade": "Santa Cruz Cabrália"
  },
  {
    "prefixo": "45810",
    "uf": "BA",
    "codigoIbge": 2925303,
    "cidade": "Porto Seguro"
  },
  {
    "prefixo": "45815",
    "uf": "BA",
    "codigoIbge": 2925303,
    "cidade": "Porto Seguro"
  },
  {
    "prefixo": "45816",
    "uf": "BA",
    "codigoIbge": 2925303,
    "cidade": "Porto Seguro"
  },
  {
    "prefixo": "45817",
    "uf": "BA",
    "codigoIbge": 2925303,
    "cidade": "Porto Seguro"
  },
  {
    "prefixo": "45818",
    "uf": "BA",
    "codigoIbge": 2925303,
    "cidade": "Porto Seguro"
  },
  {
    "prefixo": "45819",
    "uf": "BA",
    "codigoIbge": 2925303,
    "cidade": "Porto Seguro"
  },
  {
    "prefixo": "45820",
    "uf": "BA",
    "codigoIbge": 2910727,
    "cidade": "Eunápolis"
  },
  {
    "prefixo": "45821",
    "uf": "BA",
    "codigoIbge": 2910727,
    "cidade": "Eunápolis"
  },
  {
    "prefixo": "45822",
    "uf": "BA",
    "codigoIbge": 2910727,
    "cidade": "Eunápolis"
  },
  {
    "prefixo": "45823",
    "uf": "BA",
    "codigoIbge": 2910727,
    "cidade": "Eunápolis"
  },
  {
    "prefixo": "45824",
    "uf": "BA",
    "codigoIbge": 2910727,
    "cidade": "Eunápolis"
  },
  {
    "prefixo": "45825",
    "uf": "BA",
    "codigoIbge": 2910727,
    "cidade": "Eunápolis"
  },
  {
    "prefixo": "45826",
    "uf": "BA",
    "codigoIbge": 2910727,
    "cidade": "Eunápolis"
  },
  {
    "prefixo": "45828",
    "uf": "BA",
    "codigoIbge": 2910727,
    "cidade": "Eunápolis"
  },
  {
    "prefixo": "45829",
    "uf": "BA",
    "codigoIbge": 2910727,
    "cidade": "Eunápolis"
  },
  {
    "prefixo": "45830",
    "uf": "BA",
    "codigoIbge": 2910727,
    "cidade": "Eunápolis"
  },
  {
    "prefixo": "45831",
    "uf": "BA",
    "codigoIbge": 2910727,
    "cidade": "Eunápolis"
  },
  {
    "prefixo": "45832",
    "uf": "BA",
    "codigoIbge": 2910727,
    "cidade": "Eunápolis"
  },
  {
    "prefixo": "45833",
    "uf": "BA",
    "codigoIbge": 2910727,
    "cidade": "Eunápolis"
  },
  {
    "prefixo": "45834",
    "uf": "BA",
    "codigoIbge": 2918456,
    "cidade": "Jucuruçu"
  },
  {
    "prefixo": "45836",
    "uf": "BA",
    "codigoIbge": 2915601,
    "cidade": "Itamaraju"
  },
  {
    "prefixo": "45837",
    "uf": "BA",
    "codigoIbge": 2915601,
    "cidade": "Itamaraju"
  },
  {
    "prefixo": "45838",
    "uf": "BA",
    "codigoIbge": 2915601,
    "cidade": "Itamaraju"
  },
  {
    "prefixo": "45839",
    "uf": "BA",
    "codigoIbge": 2915601,
    "cidade": "Itamaraju"
  },
  {
    "prefixo": "45840",
    "uf": "BA",
    "codigoIbge": 2911808,
    "cidade": "Guaratinga"
  },
  {
    "prefixo": "45845",
    "uf": "BA",
    "codigoIbge": 2911808,
    "cidade": "Guaratinga"
  },
  {
    "prefixo": "45848",
    "uf": "BA",
    "codigoIbge": 2914653,
    "cidade": "Itabela"
  },
  {
    "prefixo": "45850",
    "uf": "BA",
    "codigoIbge": 2915304,
    "cidade": "Itagimirim"
  },
  {
    "prefixo": "45855",
    "uf": "BA",
    "codigoIbge": 2916302,
    "cidade": "Itapebi"
  },
  {
    "prefixo": "45858",
    "uf": "BA",
    "codigoIbge": 2916302,
    "cidade": "Itapebi"
  },
  {
    "prefixo": "45860",
    "uf": "BA",
    "codigoIbge": 2906303,
    "cidade": "Canavieiras"
  },
  {
    "prefixo": "45862",
    "uf": "BA",
    "codigoIbge": 2906303,
    "cidade": "Canavieiras"
  },
  {
    "prefixo": "45863",
    "uf": "BA",
    "codigoIbge": 2906303,
    "cidade": "Canavieiras"
  },
  {
    "prefixo": "45865",
    "uf": "BA",
    "codigoIbge": 2928059,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "45870",
    "uf": "BA",
    "codigoIbge": 2920908,
    "cidade": "Mascote"
  },
  {
    "prefixo": "45876",
    "uf": "BA",
    "codigoIbge": 2920908,
    "cidade": "Mascote"
  },
  {
    "prefixo": "45880",
    "uf": "BA",
    "codigoIbge": 2905602,
    "cidade": "Camacan"
  },
  {
    "prefixo": "45890",
    "uf": "BA",
    "codigoIbge": 2923902,
    "cidade": "Pau Brasil"
  },
  {
    "prefixo": "45900",
    "uf": "BA",
    "codigoIbge": 2906907,
    "cidade": "Caravelas"
  },
  {
    "prefixo": "45905",
    "uf": "BA",
    "codigoIbge": 2906907,
    "cidade": "Caravelas"
  },
  {
    "prefixo": "45908",
    "uf": "BA",
    "codigoIbge": 2906907,
    "cidade": "Caravelas"
  },
  {
    "prefixo": "45909",
    "uf": "BA",
    "codigoIbge": 2906907,
    "cidade": "Caravelas"
  },
  {
    "prefixo": "45910",
    "uf": "BA",
    "codigoIbge": 2900801,
    "cidade": "Alcobaça"
  },
  {
    "prefixo": "45920",
    "uf": "BA",
    "codigoIbge": 2923001,
    "cidade": "Nova Viçosa"
  },
  {
    "prefixo": "45923",
    "uf": "BA",
    "codigoIbge": 2923001,
    "cidade": "Nova Viçosa"
  },
  {
    "prefixo": "45925",
    "uf": "BA",
    "codigoIbge": 2923001,
    "cidade": "Nova Viçosa"
  },
  {
    "prefixo": "45928",
    "uf": "BA",
    "codigoIbge": 2923001,
    "cidade": "Nova Viçosa"
  },
  {
    "prefixo": "45930",
    "uf": "BA",
    "codigoIbge": 2922003,
    "cidade": "Mucuri"
  },
  {
    "prefixo": "45935",
    "uf": "BA",
    "codigoIbge": 2922003,
    "cidade": "Mucuri"
  },
  {
    "prefixo": "45936",
    "uf": "BA",
    "codigoIbge": 2922003,
    "cidade": "Mucuri"
  },
  {
    "prefixo": "45938",
    "uf": "BA",
    "codigoIbge": 2922003,
    "cidade": "Mucuri"
  },
  {
    "prefixo": "45940",
    "uf": "BA",
    "codigoIbge": 2912806,
    "cidade": "Ibirapuã"
  },
  {
    "prefixo": "45950",
    "uf": "BA",
    "codigoIbge": 2918902,
    "cidade": "Lajedão"
  },
  {
    "prefixo": "45955",
    "uf": "BA",
    "codigoIbge": 2933257,
    "cidade": "Vereda"
  },
  {
    "prefixo": "45958",
    "uf": "BA",
    "codigoIbge": 2933257,
    "cidade": "Vereda"
  },
  {
    "prefixo": "45960",
    "uf": "BA",
    "codigoIbge": 2921104,
    "cidade": "Medeiros Neto"
  },
  {
    "prefixo": "45965",
    "uf": "BA",
    "codigoIbge": 2921104,
    "cidade": "Medeiros Neto"
  },
  {
    "prefixo": "45968",
    "uf": "BA",
    "codigoIbge": 2921104,
    "cidade": "Medeiros Neto"
  },
  {
    "prefixo": "45970",
    "uf": "BA",
    "codigoIbge": 2916005,
    "cidade": "Itanhém"
  },
  {
    "prefixo": "45972",
    "uf": "BA",
    "codigoIbge": 2916005,
    "cidade": "Itanhém"
  },
  {
    "prefixo": "45975",
    "uf": "BA",
    "codigoIbge": 2916005,
    "cidade": "Itanhém"
  },
  {
    "prefixo": "45980",
    "uf": "BA",
    "codigoIbge": 2925501,
    "cidade": "Prado"
  },
  {
    "prefixo": "45983",
    "uf": "BA",
    "codigoIbge": 2925501,
    "cidade": "Prado"
  },
  {
    "prefixo": "45985",
    "uf": "BA",
    "codigoIbge": 2931350,
    "cidade": "Teixeira de Freitas"
  },
  {
    "prefixo": "45986",
    "uf": "BA",
    "codigoIbge": 2931350,
    "cidade": "Teixeira de Freitas"
  },
  {
    "prefixo": "45987",
    "uf": "BA",
    "codigoIbge": 2931350,
    "cidade": "Teixeira de Freitas"
  },
  {
    "prefixo": "45988",
    "uf": "BA",
    "codigoIbge": 2931350,
    "cidade": "Teixeira de Freitas"
  },
  {
    "prefixo": "45989",
    "uf": "BA",
    "codigoIbge": 2931350,
    "cidade": "Teixeira de Freitas"
  },
  {
    "prefixo": "45990",
    "uf": "BA",
    "codigoIbge": 2931350,
    "cidade": "Teixeira de Freitas"
  },
  {
    "prefixo": "45991",
    "uf": "BA",
    "codigoIbge": 2931350,
    "cidade": "Teixeira de Freitas"
  },
  {
    "prefixo": "45992",
    "uf": "BA",
    "codigoIbge": 2931350,
    "cidade": "Teixeira de Freitas"
  },
  {
    "prefixo": "45993",
    "uf": "BA",
    "codigoIbge": 2931350,
    "cidade": "Teixeira de Freitas"
  },
  {
    "prefixo": "45994",
    "uf": "BA",
    "codigoIbge": 2931350,
    "cidade": "Teixeira de Freitas"
  },
  {
    "prefixo": "45995",
    "uf": "BA",
    "codigoIbge": 2931350,
    "cidade": "Teixeira de Freitas"
  },
  {
    "prefixo": "45996",
    "uf": "BA",
    "codigoIbge": 2931350,
    "cidade": "Teixeira de Freitas"
  },
  {
    "prefixo": "45998",
    "uf": "BA",
    "codigoIbge": 2931350,
    "cidade": "Teixeira de Freitas"
  },
  {
    "prefixo": "45999",
    "uf": "BA",
    "codigoIbge": 2931350,
    "cidade": "Teixeira de Freitas"
  },
  {
    "prefixo": "46100",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46101",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46103",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46104",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46107",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46108",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46110",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46111",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46114",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46115",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46117",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46118",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46120",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46121",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46122",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46123",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46125",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "46127",
    "uf": "BA",
    "codigoIbge": 2920304,
    "cidade": "Malhada de Pedras"
  },
  {
    "prefixo": "46130",
    "uf": "BA",
    "codigoIbge": 2902005,
    "cidade": "Aracatu"
  },
  {
    "prefixo": "46134",
    "uf": "BA",
    "codigoIbge": 2902005,
    "cidade": "Aracatu"
  },
  {
    "prefixo": "46140",
    "uf": "BA",
    "codigoIbge": 2919504,
    "cidade": "Livramento de Nossa Senhora"
  },
  {
    "prefixo": "46143",
    "uf": "BA",
    "codigoIbge": 2919504,
    "cidade": "Livramento de Nossa Senhora"
  },
  {
    "prefixo": "46145",
    "uf": "BA",
    "codigoIbge": 2919504,
    "cidade": "Livramento de Nossa Senhora"
  },
  {
    "prefixo": "46150",
    "uf": "BA",
    "codigoIbge": 2919504,
    "cidade": "Livramento de Nossa Senhora"
  },
  {
    "prefixo": "46165",
    "uf": "BA",
    "codigoIbge": 2910107,
    "cidade": "Dom Basílio"
  },
  {
    "prefixo": "46170",
    "uf": "BA",
    "codigoIbge": 2926707,
    "cidade": "Rio de Contas"
  },
  {
    "prefixo": "46175",
    "uf": "BA",
    "codigoIbge": 2926707,
    "cidade": "Rio de Contas"
  },
  {
    "prefixo": "46176",
    "uf": "BA",
    "codigoIbge": 2926707,
    "cidade": "Rio de Contas"
  },
  {
    "prefixo": "46177",
    "uf": "BA",
    "codigoIbge": 2926707,
    "cidade": "Rio de Contas"
  },
  {
    "prefixo": "46180",
    "uf": "BA",
    "codigoIbge": 2900504,
    "cidade": "Érico Cardoso"
  },
  {
    "prefixo": "46190",
    "uf": "BA",
    "codigoIbge": 2923605,
    "cidade": "Paramirim"
  },
  {
    "prefixo": "46195",
    "uf": "BA",
    "codigoIbge": 2923605,
    "cidade": "Paramirim"
  },
  {
    "prefixo": "46197",
    "uf": "BA",
    "codigoIbge": 2923605,
    "cidade": "Paramirim"
  },
  {
    "prefixo": "46200",
    "uf": "BA",
    "codigoIbge": 2908705,
    "cidade": "Condeúba"
  },
  {
    "prefixo": "46203",
    "uf": "BA",
    "codigoIbge": 2908705,
    "cidade": "Condeúba"
  },
  {
    "prefixo": "46205",
    "uf": "BA",
    "codigoIbge": 2911659,
    "cidade": "Guajeru"
  },
  {
    "prefixo": "46220",
    "uf": "BA",
    "codigoIbge": 2926806,
    "cidade": "Rio do Antônio"
  },
  {
    "prefixo": "46225",
    "uf": "BA",
    "codigoIbge": 2926806,
    "cidade": "Rio do Antônio"
  },
  {
    "prefixo": "46250",
    "uf": "BA",
    "codigoIbge": 2925709,
    "cidade": "Presidente Jânio Quadros"
  },
  {
    "prefixo": "46251",
    "uf": "BA",
    "codigoIbge": 2925709,
    "cidade": "Presidente Jânio Quadros"
  },
  {
    "prefixo": "46252",
    "uf": "BA",
    "codigoIbge": 2925709,
    "cidade": "Presidente Jânio Quadros"
  },
  {
    "prefixo": "46253",
    "uf": "BA",
    "codigoIbge": 2925709,
    "cidade": "Presidente Jânio Quadros"
  },
  {
    "prefixo": "46255",
    "uf": "BA",
    "codigoIbge": 2919959,
    "cidade": "Maetinga"
  },
  {
    "prefixo": "46270",
    "uf": "BA",
    "codigoIbge": 2924702,
    "cidade": "Piripá"
  },
  {
    "prefixo": "46280",
    "uf": "BA",
    "codigoIbge": 2909000,
    "cidade": "Cordeiros"
  },
  {
    "prefixo": "46290",
    "uf": "BA",
    "codigoIbge": 2921807,
    "cidade": "Mortugaba"
  },
  {
    "prefixo": "46300",
    "uf": "BA",
    "codigoIbge": 2905008,
    "cidade": "Caculé"
  },
  {
    "prefixo": "46310",
    "uf": "BA",
    "codigoIbge": 2917409,
    "cidade": "Jacaraci"
  },
  {
    "prefixo": "46315",
    "uf": "BA",
    "codigoIbge": 2917409,
    "cidade": "Jacaraci"
  },
  {
    "prefixo": "46320",
    "uf": "BA",
    "codigoIbge": 2917409,
    "cidade": "Jacaraci"
  },
  {
    "prefixo": "46330",
    "uf": "BA",
    "codigoIbge": 2919405,
    "cidade": "Licínio de Almeida"
  },
  {
    "prefixo": "46335",
    "uf": "BA",
    "codigoIbge": 2919405,
    "cidade": "Licínio de Almeida"
  },
  {
    "prefixo": "46350",
    "uf": "BA",
    "codigoIbge": 2932606,
    "cidade": "Urandi"
  },
  {
    "prefixo": "46360",
    "uf": "BA",
    "codigoIbge": 2924504,
    "cidade": "Pindaí"
  },
  {
    "prefixo": "46370",
    "uf": "BA",
    "codigoIbge": 2924504,
    "cidade": "Pindaí"
  },
  {
    "prefixo": "46380",
    "uf": "BA",
    "codigoIbge": 2906600,
    "cidade": "Candiba"
  },
  {
    "prefixo": "46388",
    "uf": "BA",
    "codigoIbge": 2906600,
    "cidade": "Candiba"
  },
  {
    "prefixo": "46390",
    "uf": "BA",
    "codigoIbge": 2912004,
    "cidade": "Ibiassucê"
  },
  {
    "prefixo": "46400",
    "uf": "BA",
    "codigoIbge": 2905206,
    "cidade": "Caetité"
  },
  {
    "prefixo": "46402",
    "uf": "BA",
    "codigoIbge": 2905206,
    "cidade": "Caetité"
  },
  {
    "prefixo": "46405",
    "uf": "BA",
    "codigoIbge": 2905206,
    "cidade": "Caetité"
  },
  {
    "prefixo": "46410",
    "uf": "BA",
    "codigoIbge": 2905206,
    "cidade": "Caetité"
  },
  {
    "prefixo": "46420",
    "uf": "BA",
    "codigoIbge": 2905206,
    "cidade": "Caetité"
  },
  {
    "prefixo": "46425",
    "uf": "BA",
    "codigoIbge": 2918753,
    "cidade": "Lagoa Real"
  },
  {
    "prefixo": "46430",
    "uf": "BA",
    "codigoIbge": 2911709,
    "cidade": "Guanambi"
  },
  {
    "prefixo": "46433",
    "uf": "BA",
    "codigoIbge": 2911709,
    "cidade": "Guanambi"
  },
  {
    "prefixo": "46436",
    "uf": "BA",
    "codigoIbge": 2911709,
    "cidade": "Guanambi"
  },
  {
    "prefixo": "46438",
    "uf": "BA",
    "codigoIbge": 2917334,
    "cidade": "Iuiu"
  },
  {
    "prefixo": "46439",
    "uf": "BA",
    "codigoIbge": 2917334,
    "cidade": "Iuiu"
  },
  {
    "prefixo": "46440",
    "uf": "BA",
    "codigoIbge": 2920205,
    "cidade": "Malhada"
  },
  {
    "prefixo": "46443",
    "uf": "BA",
    "codigoIbge": 2920205,
    "cidade": "Malhada"
  },
  {
    "prefixo": "46444",
    "uf": "BA",
    "codigoIbge": 2920205,
    "cidade": "Malhada"
  },
  {
    "prefixo": "46445",
    "uf": "BA",
    "codigoIbge": 2907103,
    "cidade": "Carinhanha"
  },
  {
    "prefixo": "46446",
    "uf": "BA",
    "codigoIbge": 2910776,
    "cidade": "Feira da Mata"
  },
  {
    "prefixo": "46450",
    "uf": "BA",
    "codigoIbge": 2930006,
    "cidade": "Sebastião Laranjeiras"
  },
  {
    "prefixo": "46455",
    "uf": "BA",
    "codigoIbge": 2930006,
    "cidade": "Sebastião Laranjeiras"
  },
  {
    "prefixo": "46460",
    "uf": "BA",
    "codigoIbge": 2923407,
    "cidade": "Palmas de Monte Alto"
  },
  {
    "prefixo": "46469",
    "uf": "BA",
    "codigoIbge": 2923407,
    "cidade": "Palmas de Monte Alto"
  },
  {
    "prefixo": "46470",
    "uf": "BA",
    "codigoIbge": 2926400,
    "cidade": "Riacho de Santana"
  },
  {
    "prefixo": "46475",
    "uf": "BA",
    "codigoIbge": 2926400,
    "cidade": "Riacho de Santana"
  },
  {
    "prefixo": "46480",
    "uf": "BA",
    "codigoIbge": 2921054,
    "cidade": "Matina"
  },
  {
    "prefixo": "46490",
    "uf": "BA",
    "codigoIbge": 2913408,
    "cidade": "Igaporã"
  },
  {
    "prefixo": "46500",
    "uf": "BA",
    "codigoIbge": 2919801,
    "cidade": "Macaúbas"
  },
  {
    "prefixo": "46510",
    "uf": "BA",
    "codigoIbge": 2919801,
    "cidade": "Macaúbas"
  },
  {
    "prefixo": "46520",
    "uf": "BA",
    "codigoIbge": 2919801,
    "cidade": "Macaúbas"
  },
  {
    "prefixo": "46530",
    "uf": "BA",
    "codigoIbge": 2904100,
    "cidade": "Boquira"
  },
  {
    "prefixo": "46531",
    "uf": "BA",
    "codigoIbge": 2904100,
    "cidade": "Boquira"
  },
  {
    "prefixo": "46532",
    "uf": "BA",
    "codigoIbge": 2904100,
    "cidade": "Boquira"
  },
  {
    "prefixo": "46534",
    "uf": "BA",
    "codigoIbge": 2904100,
    "cidade": "Boquira"
  },
  {
    "prefixo": "46535",
    "uf": "BA",
    "codigoIbge": 2904100,
    "cidade": "Boquira"
  },
  {
    "prefixo": "46540",
    "uf": "BA",
    "codigoIbge": 2912509,
    "cidade": "Ibipitanga"
  },
  {
    "prefixo": "46550",
    "uf": "BA",
    "codigoIbge": 2926905,
    "cidade": "Rio do Pires"
  },
  {
    "prefixo": "46560",
    "uf": "BA",
    "codigoIbge": 2926905,
    "cidade": "Rio do Pires"
  },
  {
    "prefixo": "46570",
    "uf": "BA",
    "codigoIbge": 2904209,
    "cidade": "Botuporã"
  },
  {
    "prefixo": "46572",
    "uf": "BA",
    "codigoIbge": 2904209,
    "cidade": "Botuporã"
  },
  {
    "prefixo": "46573",
    "uf": "BA",
    "codigoIbge": 2904209,
    "cidade": "Botuporã"
  },
  {
    "prefixo": "46575",
    "uf": "BA",
    "codigoIbge": 2907558,
    "cidade": "Caturama"
  },
  {
    "prefixo": "46580",
    "uf": "BA",
    "codigoIbge": 2931053,
    "cidade": "Tanque Novo"
  },
  {
    "prefixo": "46600",
    "uf": "BA",
    "codigoIbge": 2931004,
    "cidade": "Tanhaçu"
  },
  {
    "prefixo": "46605",
    "uf": "BA",
    "codigoIbge": 2931004,
    "cidade": "Tanhaçu"
  },
  {
    "prefixo": "46620",
    "uf": "BA",
    "codigoIbge": 2908804,
    "cidade": "Contendas do Sincorá"
  },
  {
    "prefixo": "46630",
    "uf": "BA",
    "codigoIbge": 2908804,
    "cidade": "Contendas do Sincorá"
  },
  {
    "prefixo": "46640",
    "uf": "BA",
    "codigoIbge": 2917201,
    "cidade": "Ituaçu"
  },
  {
    "prefixo": "46650",
    "uf": "BA",
    "codigoIbge": 2902807,
    "cidade": "Barra da Estiva"
  },
  {
    "prefixo": "46660",
    "uf": "BA",
    "codigoIbge": 2902807,
    "cidade": "Barra da Estiva"
  },
  {
    "prefixo": "46670",
    "uf": "BA",
    "codigoIbge": 2918605,
    "cidade": "Jussiape"
  },
  {
    "prefixo": "46680",
    "uf": "BA",
    "codigoIbge": 2918605,
    "cidade": "Jussiape"
  },
  {
    "prefixo": "46690",
    "uf": "BA",
    "codigoIbge": 2900108,
    "cidade": "Abaíra"
  },
  {
    "prefixo": "46695",
    "uf": "BA",
    "codigoIbge": 2900108,
    "cidade": "Abaíra"
  },
  {
    "prefixo": "46700",
    "uf": "BA",
    "codigoIbge": 2913002,
    "cidade": "Ibitiara"
  },
  {
    "prefixo": "46720",
    "uf": "BA",
    "codigoIbge": 2913002,
    "cidade": "Ibitiara"
  },
  {
    "prefixo": "46730",
    "uf": "BA",
    "codigoIbge": 2923035,
    "cidade": "Novo Horizonte"
  },
  {
    "prefixo": "46733",
    "uf": "BA",
    "codigoIbge": 2923035,
    "cidade": "Novo Horizonte"
  },
  {
    "prefixo": "46740",
    "uf": "BA",
    "codigoIbge": 2904001,
    "cidade": "Boninal"
  },
  {
    "prefixo": "46750",
    "uf": "BA",
    "codigoIbge": 2921906,
    "cidade": "Mucugê"
  },
  {
    "prefixo": "46753",
    "uf": "BA",
    "codigoIbge": 2921906,
    "cidade": "Mucugê"
  },
  {
    "prefixo": "46755",
    "uf": "BA",
    "codigoIbge": 2921906,
    "cidade": "Mucugê"
  },
  {
    "prefixo": "46760",
    "uf": "BA",
    "codigoIbge": 2912202,
    "cidade": "Ibicoara"
  },
  {
    "prefixo": "46765",
    "uf": "BA",
    "codigoIbge": 2924306,
    "cidade": "Piatã"
  },
  {
    "prefixo": "46766",
    "uf": "BA",
    "codigoIbge": 2924306,
    "cidade": "Piatã"
  },
  {
    "prefixo": "46768",
    "uf": "BA",
    "codigoIbge": 2924306,
    "cidade": "Piatã"
  },
  {
    "prefixo": "46770",
    "uf": "BA",
    "codigoIbge": 2914307,
    "cidade": "Iramaia"
  },
  {
    "prefixo": "46775",
    "uf": "BA",
    "codigoIbge": 2914307,
    "cidade": "Iramaia"
  },
  {
    "prefixo": "46780",
    "uf": "BA",
    "codigoIbge": 2920809,
    "cidade": "Marcionílio Souza"
  },
  {
    "prefixo": "46790",
    "uf": "BA",
    "codigoIbge": 2915007,
    "cidade": "Itaeté"
  },
  {
    "prefixo": "46800",
    "uf": "BA",
    "codigoIbge": 2927200,
    "cidade": "Ruy Barbosa"
  },
  {
    "prefixo": "46802",
    "uf": "BA",
    "codigoIbge": 2927200,
    "cidade": "Ruy Barbosa"
  },
  {
    "prefixo": "46804",
    "uf": "BA",
    "codigoIbge": 2927200,
    "cidade": "Ruy Barbosa"
  },
  {
    "prefixo": "46805",
    "uf": "BA",
    "codigoIbge": 2919603,
    "cidade": "Macajuba"
  },
  {
    "prefixo": "46810",
    "uf": "BA",
    "codigoIbge": 2932804,
    "cidade": "Utinga"
  },
  {
    "prefixo": "46820",
    "uf": "BA",
    "codigoIbge": 2904050,
    "cidade": "Bonito"
  },
  {
    "prefixo": "46825",
    "uf": "BA",
    "codigoIbge": 2919009,
    "cidade": "Lajedinho"
  },
  {
    "prefixo": "46830",
    "uf": "BA",
    "codigoIbge": 2901304,
    "cidade": "Andaraí"
  },
  {
    "prefixo": "46833",
    "uf": "BA",
    "codigoIbge": 2901304,
    "cidade": "Andaraí"
  },
  {
    "prefixo": "46834",
    "uf": "BA",
    "codigoIbge": 2901304,
    "cidade": "Andaraí"
  },
  {
    "prefixo": "46835",
    "uf": "BA",
    "codigoIbge": 2922854,
    "cidade": "Nova Redenção"
  },
  {
    "prefixo": "46840",
    "uf": "BA",
    "codigoIbge": 2912608,
    "cidade": "Ibiquera"
  },
  {
    "prefixo": "46850",
    "uf": "BA",
    "codigoIbge": 2903805,
    "cidade": "Boa Vista do Tupim"
  },
  {
    "prefixo": "46855",
    "uf": "BA",
    "codigoIbge": 2903805,
    "cidade": "Boa Vista do Tupim"
  },
  {
    "prefixo": "46860",
    "uf": "BA",
    "codigoIbge": 2911907,
    "cidade": "Iaçu"
  },
  {
    "prefixo": "46865",
    "uf": "BA",
    "codigoIbge": 2911907,
    "cidade": "Iaçu"
  },
  {
    "prefixo": "46868",
    "uf": "BA",
    "codigoIbge": 2911907,
    "cidade": "Iaçu"
  },
  {
    "prefixo": "46875",
    "uf": "BA",
    "codigoIbge": 2916856,
    "cidade": "Itatim"
  },
  {
    "prefixo": "46880",
    "uf": "BA",
    "codigoIbge": 2914703,
    "cidade": "Itaberaba"
  },
  {
    "prefixo": "46900",
    "uf": "BA",
    "codigoIbge": 2929909,
    "cidade": "Seabra"
  },
  {
    "prefixo": "46920",
    "uf": "BA",
    "codigoIbge": 2929909,
    "cidade": "Seabra"
  },
  {
    "prefixo": "46930",
    "uf": "BA",
    "codigoIbge": 2923506,
    "cidade": "Palmeiras"
  },
  {
    "prefixo": "46940",
    "uf": "BA",
    "codigoIbge": 2923506,
    "cidade": "Palmeiras"
  },
  {
    "prefixo": "46960",
    "uf": "BA",
    "codigoIbge": 2919306,
    "cidade": "Lençóis"
  },
  {
    "prefixo": "46965",
    "uf": "BA",
    "codigoIbge": 2919306,
    "cidade": "Lençóis"
  },
  {
    "prefixo": "46970",
    "uf": "BA",
    "codigoIbge": 2933406,
    "cidade": "Wagner"
  },
  {
    "prefixo": "46980",
    "uf": "BA",
    "codigoIbge": 2914406,
    "cidade": "Iraquara"
  },
  {
    "prefixo": "46985",
    "uf": "BA",
    "codigoIbge": 2914406,
    "cidade": "Iraquara"
  },
  {
    "prefixo": "46990",
    "uf": "BA",
    "codigoIbge": 2930808,
    "cidade": "Souto Soares"
  },
  {
    "prefixo": "47100",
    "uf": "BA",
    "codigoIbge": 2902708,
    "cidade": "Barra"
  },
  {
    "prefixo": "47105",
    "uf": "BA",
    "codigoIbge": 2902708,
    "cidade": "Barra"
  },
  {
    "prefixo": "47110",
    "uf": "BA",
    "codigoIbge": 2902708,
    "cidade": "Barra"
  },
  {
    "prefixo": "47115",
    "uf": "BA",
    "codigoIbge": 2922250,
    "cidade": "Muquém do São Francisco"
  },
  {
    "prefixo": "47120",
    "uf": "BA",
    "codigoIbge": 2904753,
    "cidade": "Buritirama"
  },
  {
    "prefixo": "47150",
    "uf": "BA",
    "codigoIbge": 2928406,
    "cidade": "Santa Rita de Cássia"
  },
  {
    "prefixo": "47152",
    "uf": "BA",
    "codigoIbge": 2928406,
    "cidade": "Santa Rita de Cássia"
  },
  {
    "prefixo": "47153",
    "uf": "BA",
    "codigoIbge": 2928406,
    "cidade": "Santa Rita de Cássia"
  },
  {
    "prefixo": "47160",
    "uf": "BA",
    "codigoIbge": 2920452,
    "cidade": "Mansidão"
  },
  {
    "prefixo": "47165",
    "uf": "BA",
    "codigoIbge": 2920452,
    "cidade": "Mansidão"
  },
  {
    "prefixo": "47200",
    "uf": "BA",
    "codigoIbge": 2926004,
    "cidade": "Remanso"
  },
  {
    "prefixo": "47210",
    "uf": "BA",
    "codigoIbge": 2926004,
    "cidade": "Remanso"
  },
  {
    "prefixo": "47220",
    "uf": "BA",
    "codigoIbge": 2905909,
    "cidade": "Campo Alegre de Lourdes"
  },
  {
    "prefixo": "47230",
    "uf": "BA",
    "codigoIbge": 2905909,
    "cidade": "Campo Alegre de Lourdes"
  },
  {
    "prefixo": "47240",
    "uf": "BA",
    "codigoIbge": 2924405,
    "cidade": "Pilão Arcado"
  },
  {
    "prefixo": "47260",
    "uf": "BA",
    "codigoIbge": 2924405,
    "cidade": "Pilão Arcado"
  },
  {
    "prefixo": "47270",
    "uf": "BA",
    "codigoIbge": 2924405,
    "cidade": "Pilão Arcado"
  },
  {
    "prefixo": "47300",
    "uf": "BA",
    "codigoIbge": 2907202,
    "cidade": "Casa Nova"
  },
  {
    "prefixo": "47310",
    "uf": "BA",
    "codigoIbge": 2907202,
    "cidade": "Casa Nova"
  },
  {
    "prefixo": "47320",
    "uf": "BA",
    "codigoIbge": 2907202,
    "cidade": "Casa Nova"
  },
  {
    "prefixo": "47330",
    "uf": "BA",
    "codigoIbge": 2907202,
    "cidade": "Casa Nova"
  },
  {
    "prefixo": "47340",
    "uf": "BA",
    "codigoIbge": 2907202,
    "cidade": "Casa Nova"
  },
  {
    "prefixo": "47350",
    "uf": "BA",
    "codigoIbge": 2930204,
    "cidade": "Sento Sé"
  },
  {
    "prefixo": "47355",
    "uf": "BA",
    "codigoIbge": 2930204,
    "cidade": "Sento Sé"
  },
  {
    "prefixo": "47360",
    "uf": "BA",
    "codigoIbge": 2930204,
    "cidade": "Sento Sé"
  },
  {
    "prefixo": "47370",
    "uf": "BA",
    "codigoIbge": 2930204,
    "cidade": "Sento Sé"
  },
  {
    "prefixo": "47380",
    "uf": "BA",
    "codigoIbge": 2930204,
    "cidade": "Sento Sé"
  },
  {
    "prefixo": "47390",
    "uf": "BA",
    "codigoIbge": 2930204,
    "cidade": "Sento Sé"
  },
  {
    "prefixo": "47400",
    "uf": "BA",
    "codigoIbge": 2933604,
    "cidade": "Xique-Xique"
  },
  {
    "prefixo": "47402",
    "uf": "BA",
    "codigoIbge": 2933604,
    "cidade": "Xique-Xique"
  },
  {
    "prefixo": "47403",
    "uf": "BA",
    "codigoIbge": 2933604,
    "cidade": "Xique-Xique"
  },
  {
    "prefixo": "47404",
    "uf": "BA",
    "codigoIbge": 2933604,
    "cidade": "Xique-Xique"
  },
  {
    "prefixo": "47410",
    "uf": "BA",
    "codigoIbge": 2933604,
    "cidade": "Xique-Xique"
  },
  {
    "prefixo": "47440",
    "uf": "BA",
    "codigoIbge": 2915353,
    "cidade": "Itaguaçu da Bahia"
  },
  {
    "prefixo": "47450",
    "uf": "BA",
    "codigoIbge": 2911303,
    "cidade": "Gentio do Ouro"
  },
  {
    "prefixo": "47451",
    "uf": "BA",
    "codigoIbge": 2911303,
    "cidade": "Gentio do Ouro"
  },
  {
    "prefixo": "47453",
    "uf": "BA",
    "codigoIbge": 2911303,
    "cidade": "Gentio do Ouro"
  },
  {
    "prefixo": "47454",
    "uf": "BA",
    "codigoIbge": 2911303,
    "cidade": "Gentio do Ouro"
  },
  {
    "prefixo": "47460",
    "uf": "BA",
    "codigoIbge": 2911303,
    "cidade": "Gentio do Ouro"
  },
  {
    "prefixo": "47470",
    "uf": "BA",
    "codigoIbge": 2911303,
    "cidade": "Gentio do Ouro"
  },
  {
    "prefixo": "47490",
    "uf": "BA",
    "codigoIbge": 2911303,
    "cidade": "Gentio do Ouro"
  },
  {
    "prefixo": "47500",
    "uf": "BA",
    "codigoIbge": 2923704,
    "cidade": "Paratinga"
  },
  {
    "prefixo": "47505",
    "uf": "BA",
    "codigoIbge": 2923704,
    "cidade": "Paratinga"
  },
  {
    "prefixo": "47520",
    "uf": "BA",
    "codigoIbge": 2913200,
    "cidade": "Ibotirama"
  },
  {
    "prefixo": "47525",
    "uf": "BA",
    "codigoIbge": 2913200,
    "cidade": "Ibotirama"
  },
  {
    "prefixo": "47530",
    "uf": "BA",
    "codigoIbge": 2923209,
    "cidade": "Oliveira dos Brejinhos"
  },
  {
    "prefixo": "47540",
    "uf": "BA",
    "codigoIbge": 2923209,
    "cidade": "Oliveira dos Brejinhos"
  },
  {
    "prefixo": "47550",
    "uf": "BA",
    "codigoIbge": 2923209,
    "cidade": "Oliveira dos Brejinhos"
  },
  {
    "prefixo": "47560",
    "uf": "BA",
    "codigoIbge": 2904506,
    "cidade": "Brotas de Macaúbas"
  },
  {
    "prefixo": "47570",
    "uf": "BA",
    "codigoIbge": 2904506,
    "cidade": "Brotas de Macaúbas"
  },
  {
    "prefixo": "47580",
    "uf": "BA",
    "codigoIbge": 2921609,
    "cidade": "Morpará"
  },
  {
    "prefixo": "47585",
    "uf": "BA",
    "codigoIbge": 2921609,
    "cidade": "Morpará"
  },
  {
    "prefixo": "47590",
    "uf": "BA",
    "codigoIbge": 2914109,
    "cidade": "Ipupiara"
  },
  {
    "prefixo": "47595",
    "uf": "BA",
    "codigoIbge": 2914109,
    "cidade": "Ipupiara"
  },
  {
    "prefixo": "47600",
    "uf": "BA",
    "codigoIbge": 2903904,
    "cidade": "Bom Jesus da Lapa"
  },
  {
    "prefixo": "47610",
    "uf": "BA",
    "codigoIbge": 2930758,
    "cidade": "Sítio do Mato"
  },
  {
    "prefixo": "47620",
    "uf": "BA",
    "codigoIbge": 2930758,
    "cidade": "Sítio do Mato"
  },
  {
    "prefixo": "47630",
    "uf": "BA",
    "codigoIbge": 2930154,
    "cidade": "Serra do Ramalho"
  },
  {
    "prefixo": "47631",
    "uf": "BA",
    "codigoIbge": 2930154,
    "cidade": "Serra do Ramalho"
  },
  {
    "prefixo": "47632",
    "uf": "BA",
    "codigoIbge": 2930154,
    "cidade": "Serra do Ramalho"
  },
  {
    "prefixo": "47634",
    "uf": "BA",
    "codigoIbge": 2930154,
    "cidade": "Serra do Ramalho"
  },
  {
    "prefixo": "47640",
    "uf": "BA",
    "codigoIbge": 2928109,
    "cidade": "Santa Maria da Vitória"
  },
  {
    "prefixo": "47645",
    "uf": "BA",
    "codigoIbge": 2928109,
    "cidade": "Santa Maria da Vitória"
  },
  {
    "prefixo": "47648",
    "uf": "BA",
    "codigoIbge": 2928109,
    "cidade": "Santa Maria da Vitória"
  },
  {
    "prefixo": "47650",
    "uf": "BA",
    "codigoIbge": 2909307,
    "cidade": "Correntina"
  },
  {
    "prefixo": "47654",
    "uf": "BA",
    "codigoIbge": 2909307,
    "cidade": "Correntina"
  },
  {
    "prefixo": "47655",
    "uf": "BA",
    "codigoIbge": 2917359,
    "cidade": "Jaborandi"
  },
  {
    "prefixo": "47665",
    "uf": "BA",
    "codigoIbge": 2929057,
    "cidade": "São Félix do Coribe"
  },
  {
    "prefixo": "47670",
    "uf": "BA",
    "codigoIbge": 2929057,
    "cidade": "São Félix do Coribe"
  },
  {
    "prefixo": "47671",
    "uf": "BA",
    "codigoIbge": 2929057,
    "cidade": "São Félix do Coribe"
  },
  {
    "prefixo": "47672",
    "uf": "BA",
    "codigoIbge": 2929057,
    "cidade": "São Félix do Coribe"
  },
  {
    "prefixo": "47680",
    "uf": "BA",
    "codigoIbge": 2908101,
    "cidade": "Cocos"
  },
  {
    "prefixo": "47690",
    "uf": "BA",
    "codigoIbge": 2909109,
    "cidade": "Coribe"
  },
  {
    "prefixo": "47695",
    "uf": "BA",
    "codigoIbge": 2909109,
    "cidade": "Coribe"
  },
  {
    "prefixo": "47699",
    "uf": "BA",
    "codigoIbge": 2909109,
    "cidade": "Coribe"
  },
  {
    "prefixo": "47700",
    "uf": "BA",
    "codigoIbge": 2928208,
    "cidade": "Santana"
  },
  {
    "prefixo": "47710",
    "uf": "BA",
    "codigoIbge": 2928208,
    "cidade": "Santana"
  },
  {
    "prefixo": "47730",
    "uf": "BA",
    "codigoIbge": 2906105,
    "cidade": "Canápolis"
  },
  {
    "prefixo": "47740",
    "uf": "BA",
    "codigoIbge": 2930303,
    "cidade": "Serra Dourada"
  },
  {
    "prefixo": "47741",
    "uf": "BA",
    "codigoIbge": 2930303,
    "cidade": "Serra Dourada"
  },
  {
    "prefixo": "47742",
    "uf": "BA",
    "codigoIbge": 2930303,
    "cidade": "Serra Dourada"
  },
  {
    "prefixo": "47743",
    "uf": "BA",
    "codigoIbge": 2930303,
    "cidade": "Serra Dourada"
  },
  {
    "prefixo": "47744",
    "uf": "BA",
    "codigoIbge": 2930303,
    "cidade": "Serra Dourada"
  },
  {
    "prefixo": "47750",
    "uf": "BA",
    "codigoIbge": 2904407,
    "cidade": "Brejolândia"
  },
  {
    "prefixo": "47760",
    "uf": "BA",
    "codigoIbge": 2930907,
    "cidade": "Tabocas do Brejo Velho"
  },
  {
    "prefixo": "47770",
    "uf": "BA",
    "codigoIbge": 2930907,
    "cidade": "Tabocas do Brejo Velho"
  },
  {
    "prefixo": "47800",
    "uf": "BA",
    "codigoIbge": 2903201,
    "cidade": "Barreiras"
  },
  {
    "prefixo": "47801",
    "uf": "BA",
    "codigoIbge": 2903201,
    "cidade": "Barreiras"
  },
  {
    "prefixo": "47802",
    "uf": "BA",
    "codigoIbge": 2903201,
    "cidade": "Barreiras"
  },
  {
    "prefixo": "47803",
    "uf": "BA",
    "codigoIbge": 2903201,
    "cidade": "Barreiras"
  },
  {
    "prefixo": "47804",
    "uf": "BA",
    "codigoIbge": 2903201,
    "cidade": "Barreiras"
  },
  {
    "prefixo": "47806",
    "uf": "BA",
    "codigoIbge": 2903201,
    "cidade": "Barreiras"
  },
  {
    "prefixo": "47807",
    "uf": "BA",
    "codigoIbge": 2903201,
    "cidade": "Barreiras"
  },
  {
    "prefixo": "47808",
    "uf": "BA",
    "codigoIbge": 2903201,
    "cidade": "Barreiras"
  },
  {
    "prefixo": "47809",
    "uf": "BA",
    "codigoIbge": 2903201,
    "cidade": "Barreiras"
  },
  {
    "prefixo": "47810",
    "uf": "BA",
    "codigoIbge": 2903201,
    "cidade": "Barreiras"
  },
  {
    "prefixo": "47811",
    "uf": "BA",
    "codigoIbge": 2903201,
    "cidade": "Barreiras"
  },
  {
    "prefixo": "47813",
    "uf": "BA",
    "codigoIbge": 2903201,
    "cidade": "Barreiras"
  },
  {
    "prefixo": "47814",
    "uf": "BA",
    "codigoIbge": 2903201,
    "cidade": "Barreiras"
  },
  {
    "prefixo": "47815",
    "uf": "BA",
    "codigoIbge": 2903201,
    "cidade": "Barreiras"
  },
  {
    "prefixo": "47819",
    "uf": "BA",
    "codigoIbge": 2903201,
    "cidade": "Barreiras"
  },
  {
    "prefixo": "47820",
    "uf": "BA",
    "codigoIbge": 2928901,
    "cidade": "São Desidério"
  },
  {
    "prefixo": "47821",
    "uf": "BA",
    "codigoIbge": 2928901,
    "cidade": "São Desidério"
  },
  {
    "prefixo": "47822",
    "uf": "BA",
    "codigoIbge": 2928901,
    "cidade": "São Desidério"
  },
  {
    "prefixo": "47825",
    "uf": "BA",
    "codigoIbge": 2928901,
    "cidade": "São Desidério"
  },
  {
    "prefixo": "47827",
    "uf": "BA",
    "codigoIbge": 2928901,
    "cidade": "São Desidério"
  },
  {
    "prefixo": "47830",
    "uf": "BA",
    "codigoIbge": 2902500,
    "cidade": "Baianópolis"
  },
  {
    "prefixo": "47831",
    "uf": "BA",
    "codigoIbge": 2902500,
    "cidade": "Baianópolis"
  },
  {
    "prefixo": "47840",
    "uf": "BA",
    "codigoIbge": 2902500,
    "cidade": "Baianópolis"
  },
  {
    "prefixo": "47845",
    "uf": "BA",
    "codigoIbge": 2907400,
    "cidade": "Catolândia"
  },
  {
    "prefixo": "47846",
    "uf": "BA",
    "codigoIbge": 2907400,
    "cidade": "Catolândia"
  },
  {
    "prefixo": "47850",
    "uf": "BA",
    "codigoIbge": 2919553,
    "cidade": "Luís Eduardo Magalhães"
  },
  {
    "prefixo": "47851",
    "uf": "BA",
    "codigoIbge": 2919553,
    "cidade": "Luís Eduardo Magalhães"
  },
  {
    "prefixo": "47852",
    "uf": "BA",
    "codigoIbge": 2919553,
    "cidade": "Luís Eduardo Magalhães"
  },
  {
    "prefixo": "47853",
    "uf": "BA",
    "codigoIbge": 2919553,
    "cidade": "Luís Eduardo Magalhães"
  },
  {
    "prefixo": "47855",
    "uf": "BA",
    "codigoIbge": 2919553,
    "cidade": "Luís Eduardo Magalhães"
  },
  {
    "prefixo": "47858",
    "uf": "BA",
    "codigoIbge": 2919553,
    "cidade": "Luís Eduardo Magalhães"
  },
  {
    "prefixo": "47861",
    "uf": "BA",
    "codigoIbge": 2919553,
    "cidade": "Luís Eduardo Magalhães"
  },
  {
    "prefixo": "47862",
    "uf": "BA",
    "codigoIbge": 2919553,
    "cidade": "Luís Eduardo Magalhães"
  },
  {
    "prefixo": "47864",
    "uf": "BA",
    "codigoIbge": 2919553,
    "cidade": "Luís Eduardo Magalhães"
  },
  {
    "prefixo": "47865",
    "uf": "BA",
    "codigoIbge": 2919553,
    "cidade": "Luís Eduardo Magalhães"
  },
  {
    "prefixo": "47900",
    "uf": "BA",
    "codigoIbge": 2909406,
    "cidade": "Cotegipe"
  },
  {
    "prefixo": "47902",
    "uf": "BA",
    "codigoIbge": 2909406,
    "cidade": "Cotegipe"
  },
  {
    "prefixo": "47903",
    "uf": "BA",
    "codigoIbge": 2909406,
    "cidade": "Cotegipe"
  },
  {
    "prefixo": "47940",
    "uf": "BA",
    "codigoIbge": 2933455,
    "cidade": "Wanderley"
  },
  {
    "prefixo": "47950",
    "uf": "BA",
    "codigoIbge": 2909703,
    "cidade": "Cristópolis"
  },
  {
    "prefixo": "47960",
    "uf": "BA",
    "codigoIbge": 2901403,
    "cidade": "Angical"
  },
  {
    "prefixo": "47966",
    "uf": "BA",
    "codigoIbge": 2901403,
    "cidade": "Angical"
  },
  {
    "prefixo": "47970",
    "uf": "BA",
    "codigoIbge": 2926202,
    "cidade": "Riachão das Neves"
  },
  {
    "prefixo": "47975",
    "uf": "BA",
    "codigoIbge": 2926202,
    "cidade": "Riachão das Neves"
  },
  {
    "prefixo": "47980",
    "uf": "BA",
    "codigoIbge": 2926202,
    "cidade": "Riachão das Neves"
  },
  {
    "prefixo": "47990",
    "uf": "BA",
    "codigoIbge": 2911105,
    "cidade": "Formosa do Rio Preto"
  },
  {
    "prefixo": "48000",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48001",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48002",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48005",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48006",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48007",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48008",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48009",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48010",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48011",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48012",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48013",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48015",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48016",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48018",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48019",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48020",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48021",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48022",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48023",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48024",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48030",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48031",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48050",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48070",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48080",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48090",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48103",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48105",
    "uf": "BA",
    "codigoIbge": 2900702,
    "cidade": "Alagoinhas"
  },
  {
    "prefixo": "48108",
    "uf": "BA",
    "codigoIbge": 2902054,
    "cidade": "Araçás"
  },
  {
    "prefixo": "48110",
    "uf": "BA",
    "codigoIbge": 2907509,
    "cidade": "Catu"
  },
  {
    "prefixo": "48113",
    "uf": "BA",
    "codigoIbge": 2907509,
    "cidade": "Catu"
  },
  {
    "prefixo": "48118",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "48120",
    "uf": "BA",
    "codigoIbge": 2925204,
    "cidade": "Pojuca"
  },
  {
    "prefixo": "48130",
    "uf": "BA",
    "codigoIbge": 2902203,
    "cidade": "Aramari"
  },
  {
    "prefixo": "48140",
    "uf": "BA",
    "codigoIbge": 2924108,
    "cidade": "Pedrão"
  },
  {
    "prefixo": "48150",
    "uf": "BA",
    "codigoIbge": 2923308,
    "cidade": "Ouriçangas"
  },
  {
    "prefixo": "48170",
    "uf": "BA",
    "codigoIbge": 2900405,
    "cidade": "Água Fria"
  },
  {
    "prefixo": "48175",
    "uf": "BA",
    "codigoIbge": 2900405,
    "cidade": "Água Fria"
  },
  {
    "prefixo": "48180",
    "uf": "BA",
    "codigoIbge": 2910503,
    "cidade": "Entre Rios"
  },
  {
    "prefixo": "48190",
    "uf": "BA",
    "codigoIbge": 2910503,
    "cidade": "Entre Rios"
  },
  {
    "prefixo": "48280",
    "uf": "BA",
    "codigoIbge": 2921005,
    "cidade": "Mata de São João"
  },
  {
    "prefixo": "48282",
    "uf": "BA",
    "codigoIbge": 2921005,
    "cidade": "Mata de São João"
  },
  {
    "prefixo": "48287",
    "uf": "BA",
    "codigoIbge": 2921005,
    "cidade": "Mata de São João"
  },
  {
    "prefixo": "48288",
    "uf": "BA",
    "codigoIbge": 2921005,
    "cidade": "Mata de São João"
  },
  {
    "prefixo": "48289",
    "uf": "BA",
    "codigoIbge": 2921005,
    "cidade": "Mata de São João"
  },
  {
    "prefixo": "48290",
    "uf": "BA",
    "codigoIbge": 2915908,
    "cidade": "Itanagra"
  },
  {
    "prefixo": "48300",
    "uf": "BA",
    "codigoIbge": 2908606,
    "cidade": "Conde"
  },
  {
    "prefixo": "48310",
    "uf": "BA",
    "codigoIbge": 2917904,
    "cidade": "Jandaíra"
  },
  {
    "prefixo": "48325",
    "uf": "BA",
    "codigoIbge": 2917904,
    "cidade": "Jandaíra"
  },
  {
    "prefixo": "48330",
    "uf": "BA",
    "codigoIbge": 2927002,
    "cidade": "Rio Real"
  },
  {
    "prefixo": "48350",
    "uf": "BA",
    "codigoIbge": 2901908,
    "cidade": "Aporá"
  },
  {
    "prefixo": "48355",
    "uf": "BA",
    "codigoIbge": 2901908,
    "cidade": "Aporá"
  },
  {
    "prefixo": "48360",
    "uf": "BA",
    "codigoIbge": 2900306,
    "cidade": "Acajutiba"
  },
  {
    "prefixo": "48370",
    "uf": "BA",
    "codigoIbge": 2910602,
    "cidade": "Esplanada"
  },
  {
    "prefixo": "48380",
    "uf": "BA",
    "codigoIbge": 2910602,
    "cidade": "Esplanada"
  },
  {
    "prefixo": "48390",
    "uf": "BA",
    "codigoIbge": 2907004,
    "cidade": "Cardeal da Silva"
  },
  {
    "prefixo": "48400",
    "uf": "BA",
    "codigoIbge": 2926608,
    "cidade": "Ribeira do Pombal"
  },
  {
    "prefixo": "48403",
    "uf": "BA",
    "codigoIbge": 2926608,
    "cidade": "Ribeira do Pombal"
  },
  {
    "prefixo": "48404",
    "uf": "BA",
    "codigoIbge": 2926608,
    "cidade": "Ribeira do Pombal"
  },
  {
    "prefixo": "48405",
    "uf": "BA",
    "codigoIbge": 2902658,
    "cidade": "Banzaê"
  },
  {
    "prefixo": "48409",
    "uf": "BA",
    "codigoIbge": 2902658,
    "cidade": "Banzaê"
  },
  {
    "prefixo": "48410",
    "uf": "BA",
    "codigoIbge": 2907806,
    "cidade": "Cícero Dantas"
  },
  {
    "prefixo": "48413",
    "uf": "BA",
    "codigoIbge": 2907806,
    "cidade": "Cícero Dantas"
  },
  {
    "prefixo": "48414",
    "uf": "BA",
    "codigoIbge": 2907806,
    "cidade": "Cícero Dantas"
  },
  {
    "prefixo": "48415",
    "uf": "BA",
    "codigoIbge": 2910750,
    "cidade": "Fátima"
  },
  {
    "prefixo": "48420",
    "uf": "BA",
    "codigoIbge": 2901601,
    "cidade": "Antas"
  },
  {
    "prefixo": "48430",
    "uf": "BA",
    "codigoIbge": 2923803,
    "cidade": "Paripiranga"
  },
  {
    "prefixo": "48435",
    "uf": "BA",
    "codigoIbge": 2900355,
    "cidade": "Adustina"
  },
  {
    "prefixo": "48440",
    "uf": "BA",
    "codigoIbge": 2926509,
    "cidade": "Ribeira do Amparo"
  },
  {
    "prefixo": "48443",
    "uf": "BA",
    "codigoIbge": 2926509,
    "cidade": "Ribeira do Amparo"
  },
  {
    "prefixo": "48445",
    "uf": "BA",
    "codigoIbge": 2911857,
    "cidade": "Heliópolis"
  },
  {
    "prefixo": "48450",
    "uf": "BA",
    "codigoIbge": 2907905,
    "cidade": "Cipó"
  },
  {
    "prefixo": "48455",
    "uf": "BA",
    "codigoIbge": 2923050,
    "cidade": "Novo Triunfo"
  },
  {
    "prefixo": "48460",
    "uf": "BA",
    "codigoIbge": 2922904,
    "cidade": "Nova Soure"
  },
  {
    "prefixo": "48470",
    "uf": "BA",
    "codigoIbge": 2923100,
    "cidade": "Olindina"
  },
  {
    "prefixo": "48473",
    "uf": "BA",
    "codigoIbge": 2923100,
    "cidade": "Olindina"
  },
  {
    "prefixo": "48474",
    "uf": "BA",
    "codigoIbge": 2923100,
    "cidade": "Olindina"
  },
  {
    "prefixo": "48475",
    "uf": "BA",
    "codigoIbge": 2916500,
    "cidade": "Itapicuru"
  },
  {
    "prefixo": "48476",
    "uf": "BA",
    "codigoIbge": 2916500,
    "cidade": "Itapicuru"
  },
  {
    "prefixo": "48480",
    "uf": "BA",
    "codigoIbge": 2909604,
    "cidade": "Crisópolis"
  },
  {
    "prefixo": "48485",
    "uf": "BA",
    "codigoIbge": 2929701,
    "cidade": "Sátiro Dias"
  },
  {
    "prefixo": "48488",
    "uf": "BA",
    "codigoIbge": 2929701,
    "cidade": "Sátiro Dias"
  },
  {
    "prefixo": "48489",
    "uf": "BA",
    "codigoIbge": 2929701,
    "cidade": "Sátiro Dias"
  },
  {
    "prefixo": "48490",
    "uf": "BA",
    "codigoIbge": 2913705,
    "cidade": "Inhambupe"
  },
  {
    "prefixo": "48500",
    "uf": "BA",
    "codigoIbge": 2910701,
    "cidade": "Euclides da Cunha"
  },
  {
    "prefixo": "48504",
    "uf": "BA",
    "codigoIbge": 2910701,
    "cidade": "Euclides da Cunha"
  },
  {
    "prefixo": "48506",
    "uf": "BA",
    "codigoIbge": 2910701,
    "cidade": "Euclides da Cunha"
  },
  {
    "prefixo": "48520",
    "uf": "BA",
    "codigoIbge": 2906824,
    "cidade": "Canudos"
  },
  {
    "prefixo": "48524",
    "uf": "BA",
    "codigoIbge": 2906824,
    "cidade": "Canudos"
  },
  {
    "prefixo": "48540",
    "uf": "BA",
    "codigoIbge": 2918100,
    "cidade": "Jeremoabo"
  },
  {
    "prefixo": "48560",
    "uf": "BA",
    "codigoIbge": 2918100,
    "cidade": "Jeremoabo"
  },
  {
    "prefixo": "48565",
    "uf": "BA",
    "codigoIbge": 2930766,
    "cidade": "Sítio do Quinto"
  },
  {
    "prefixo": "48570",
    "uf": "BA",
    "codigoIbge": 2927606,
    "cidade": "Santa Brígida"
  },
  {
    "prefixo": "48580",
    "uf": "BA",
    "codigoIbge": 2924207,
    "cidade": "Pedro Alexandre"
  },
  {
    "prefixo": "48590",
    "uf": "BA",
    "codigoIbge": 2909208,
    "cidade": "Coronel João Sá"
  },
  {
    "prefixo": "48601",
    "uf": "BA",
    "codigoIbge": 2924009,
    "cidade": "Paulo Afonso"
  },
  {
    "prefixo": "48602",
    "uf": "BA",
    "codigoIbge": 2924009,
    "cidade": "Paulo Afonso"
  },
  {
    "prefixo": "48603",
    "uf": "BA",
    "codigoIbge": 2924009,
    "cidade": "Paulo Afonso"
  },
  {
    "prefixo": "48604",
    "uf": "BA",
    "codigoIbge": 2924009,
    "cidade": "Paulo Afonso"
  },
  {
    "prefixo": "48605",
    "uf": "BA",
    "codigoIbge": 2924009,
    "cidade": "Paulo Afonso"
  },
  {
    "prefixo": "48606",
    "uf": "BA",
    "codigoIbge": 2924009,
    "cidade": "Paulo Afonso"
  },
  {
    "prefixo": "48607",
    "uf": "BA",
    "codigoIbge": 2924009,
    "cidade": "Paulo Afonso"
  },
  {
    "prefixo": "48608",
    "uf": "BA",
    "codigoIbge": 2924009,
    "cidade": "Paulo Afonso"
  },
  {
    "prefixo": "48609",
    "uf": "BA",
    "codigoIbge": 2924009,
    "cidade": "Paulo Afonso"
  },
  {
    "prefixo": "48610",
    "uf": "BA",
    "codigoIbge": 2924009,
    "cidade": "Paulo Afonso"
  },
  {
    "prefixo": "48611",
    "uf": "BA",
    "codigoIbge": 2924009,
    "cidade": "Paulo Afonso"
  },
  {
    "prefixo": "48619",
    "uf": "BA",
    "codigoIbge": 2924009,
    "cidade": "Paulo Afonso"
  },
  {
    "prefixo": "48620",
    "uf": "BA",
    "codigoIbge": 2911402,
    "cidade": "Glória"
  },
  {
    "prefixo": "48630",
    "uf": "BA",
    "codigoIbge": 2927101,
    "cidade": "Rodelas"
  },
  {
    "prefixo": "48650",
    "uf": "BA",
    "codigoIbge": 2919900,
    "cidade": "Macururé"
  },
  {
    "prefixo": "48660",
    "uf": "BA",
    "codigoIbge": 2907707,
    "cidade": "Chorrochó"
  },
  {
    "prefixo": "48668",
    "uf": "BA",
    "codigoIbge": 2907707,
    "cidade": "Chorrochó"
  },
  {
    "prefixo": "48680",
    "uf": "BA",
    "codigoIbge": 2900207,
    "cidade": "Abaré"
  },
  {
    "prefixo": "48700",
    "uf": "BA",
    "codigoIbge": 2930501,
    "cidade": "Serrinha"
  },
  {
    "prefixo": "48705",
    "uf": "BA",
    "codigoIbge": 2903276,
    "cidade": "Barrocas"
  },
  {
    "prefixo": "48710",
    "uf": "BA",
    "codigoIbge": 2906402,
    "cidade": "Candeal"
  },
  {
    "prefixo": "48720",
    "uf": "BA",
    "codigoIbge": 2919108,
    "cidade": "Lamarão"
  },
  {
    "prefixo": "48725",
    "uf": "BA",
    "codigoIbge": 2913309,
    "cidade": "Ichu"
  },
  {
    "prefixo": "48730",
    "uf": "BA",
    "codigoIbge": 2908408,
    "cidade": "Conceição do Coité"
  },
  {
    "prefixo": "48740",
    "uf": "BA",
    "codigoIbge": 2908408,
    "cidade": "Conceição do Coité"
  },
  {
    "prefixo": "48745",
    "uf": "BA",
    "codigoIbge": 2908408,
    "cidade": "Conceição do Coité"
  },
  {
    "prefixo": "48747",
    "uf": "BA",
    "codigoIbge": 2908408,
    "cidade": "Conceição do Coité"
  },
  {
    "prefixo": "48750",
    "uf": "BA",
    "codigoIbge": 2926103,
    "cidade": "Retirolândia"
  },
  {
    "prefixo": "48760",
    "uf": "BA",
    "codigoIbge": 2902104,
    "cidade": "Araci"
  },
  {
    "prefixo": "48767",
    "uf": "BA",
    "codigoIbge": 2902104,
    "cidade": "Araci"
  },
  {
    "prefixo": "48770",
    "uf": "BA",
    "codigoIbge": 2931509,
    "cidade": "Teofilândia"
  },
  {
    "prefixo": "48780",
    "uf": "BA",
    "codigoIbge": 2903607,
    "cidade": "Biritinga"
  },
  {
    "prefixo": "48790",
    "uf": "BA",
    "codigoIbge": 2931905,
    "cidade": "Tucano"
  },
  {
    "prefixo": "48793",
    "uf": "BA",
    "codigoIbge": 2931905,
    "cidade": "Tucano"
  },
  {
    "prefixo": "48794",
    "uf": "BA",
    "codigoIbge": 2931905,
    "cidade": "Tucano"
  },
  {
    "prefixo": "48800",
    "uf": "BA",
    "codigoIbge": 2921500,
    "cidade": "Monte Santo"
  },
  {
    "prefixo": "48830",
    "uf": "BA",
    "codigoIbge": 2925907,
    "cidade": "Quijingue"
  },
  {
    "prefixo": "48832",
    "uf": "BA",
    "codigoIbge": 2925907,
    "cidade": "Quijingue"
  },
  {
    "prefixo": "48840",
    "uf": "BA",
    "codigoIbge": 2906808,
    "cidade": "Cansanção"
  },
  {
    "prefixo": "48850",
    "uf": "BA",
    "codigoIbge": 2917003,
    "cidade": "Itiúba"
  },
  {
    "prefixo": "48859",
    "uf": "BA",
    "codigoIbge": 2917003,
    "cidade": "Itiúba"
  },
  {
    "prefixo": "48860",
    "uf": "BA",
    "codigoIbge": 2925808,
    "cidade": "Queimadas"
  },
  {
    "prefixo": "48870",
    "uf": "BA",
    "codigoIbge": 2922656,
    "cidade": "Nordestina"
  },
  {
    "prefixo": "48880",
    "uf": "BA",
    "codigoIbge": 2928000,
    "cidade": "Santaluz"
  },
  {
    "prefixo": "48890",
    "uf": "BA",
    "codigoIbge": 2933000,
    "cidade": "Valente"
  },
  {
    "prefixo": "48895",
    "uf": "BA",
    "codigoIbge": 2928950,
    "cidade": "São Domingos"
  },
  {
    "prefixo": "48900",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48901",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48902",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48903",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48904",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48905",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48906",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48907",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48908",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48909",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48913",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48914",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48916",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48917",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48918",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48920",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48921",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48922",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48923",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48924",
    "uf": "BA",
    "codigoIbge": 2918407,
    "cidade": "Juazeiro"
  },
  {
    "prefixo": "48925",
    "uf": "BA",
    "codigoIbge": 2930774,
    "cidade": "Sobradinho"
  },
  {
    "prefixo": "48930",
    "uf": "BA",
    "codigoIbge": 2909901,
    "cidade": "Curaçá"
  },
  {
    "prefixo": "48933",
    "uf": "BA",
    "codigoIbge": 2909901,
    "cidade": "Curaçá"
  },
  {
    "prefixo": "48935",
    "uf": "BA",
    "codigoIbge": 2909901,
    "cidade": "Curaçá"
  },
  {
    "prefixo": "48940",
    "uf": "BA",
    "codigoIbge": 2909901,
    "cidade": "Curaçá"
  },
  {
    "prefixo": "48945",
    "uf": "BA",
    "codigoIbge": 2909901,
    "cidade": "Curaçá"
  },
  {
    "prefixo": "48950",
    "uf": "BA",
    "codigoIbge": 2932002,
    "cidade": "Uauá"
  },
  {
    "prefixo": "48953",
    "uf": "BA",
    "codigoIbge": 2932002,
    "cidade": "Uauá"
  },
  {
    "prefixo": "48955",
    "uf": "BA",
    "codigoIbge": 2932002,
    "cidade": "Uauá"
  },
  {
    "prefixo": "48960",
    "uf": "BA",
    "codigoIbge": 2917706,
    "cidade": "Jaguarari"
  },
  {
    "prefixo": "48965",
    "uf": "BA",
    "codigoIbge": 2917706,
    "cidade": "Jaguarari"
  },
  {
    "prefixo": "48967",
    "uf": "BA",
    "codigoIbge": 2917706,
    "cidade": "Jaguarari"
  },
  {
    "prefixo": "48970",
    "uf": "BA",
    "codigoIbge": 2930105,
    "cidade": "Senhor do Bonfim"
  },
  {
    "prefixo": "48975",
    "uf": "BA",
    "codigoIbge": 2930105,
    "cidade": "Senhor do Bonfim"
  },
  {
    "prefixo": "48980",
    "uf": "BA",
    "codigoIbge": 2930105,
    "cidade": "Senhor do Bonfim"
  },
  {
    "prefixo": "48985",
    "uf": "BA",
    "codigoIbge": 2930105,
    "cidade": "Senhor do Bonfim"
  },
  {
    "prefixo": "48990",
    "uf": "BA",
    "codigoIbge": 2901353,
    "cidade": "Andorinha"
  },
  {
    "prefixo": "48993",
    "uf": "BA",
    "codigoIbge": 2901353,
    "cidade": "Andorinha"
  },
  {
    "prefixo": "49000",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49001",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49003",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49004",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49005",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49006",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49007",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49008",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49009",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49010",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49015",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49020",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49025",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49026",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49027",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49030",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49031",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49032",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49033",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49034",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49035",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49036",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49037",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49038",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49039",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49040",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49041",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49042",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49043",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49044",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49045",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49046",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49047",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49048",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49050",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49051",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49052",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49055",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49060",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49061",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49063",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49065",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49066",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49067",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49069",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49070",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49071",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49072",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49075",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49080",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49081",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49082",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49085",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49087",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49088",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49089",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49090",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49091",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49092",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49094",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49095",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49096",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49097",
    "uf": "SE",
    "codigoIbge": 2800308,
    "cidade": "Aracaju"
  },
  {
    "prefixo": "49100",
    "uf": "SE",
    "codigoIbge": 2806701,
    "cidade": "São Cristóvão"
  },
  {
    "prefixo": "49101",
    "uf": "SE",
    "codigoIbge": 2806701,
    "cidade": "São Cristóvão"
  },
  {
    "prefixo": "49105",
    "uf": "SE",
    "codigoIbge": 2806701,
    "cidade": "São Cristóvão"
  },
  {
    "prefixo": "49107",
    "uf": "SE",
    "codigoIbge": 2806701,
    "cidade": "São Cristóvão"
  },
  {
    "prefixo": "49108",
    "uf": "SE",
    "codigoIbge": 2806701,
    "cidade": "São Cristóvão"
  },
  {
    "prefixo": "49117",
    "uf": "BA",
    "codigoIbge": 2904605,
    "cidade": "Brumado"
  },
  {
    "prefixo": "49120",
    "uf": "SE",
    "codigoIbge": 2803203,
    "cidade": "Itaporanga d'Ajuda"
  },
  {
    "prefixo": "49130",
    "uf": "SE",
    "codigoIbge": 2805901,
    "cidade": "Riachuelo"
  },
  {
    "prefixo": "49140",
    "uf": "SE",
    "codigoIbge": 2800605,
    "cidade": "Barra dos Coqueiros"
  },
  {
    "prefixo": "49141",
    "uf": "SE",
    "codigoIbge": 2800605,
    "cidade": "Barra dos Coqueiros"
  },
  {
    "prefixo": "49142",
    "uf": "SE",
    "codigoIbge": 2800605,
    "cidade": "Barra dos Coqueiros"
  },
  {
    "prefixo": "49143",
    "uf": "SE",
    "codigoIbge": 2800605,
    "cidade": "Barra dos Coqueiros"
  },
  {
    "prefixo": "49150",
    "uf": "SE",
    "codigoIbge": 2804805,
    "cidade": "Nossa Senhora do Socorro"
  },
  {
    "prefixo": "49152",
    "uf": "SE",
    "codigoIbge": 2804805,
    "cidade": "Nossa Senhora do Socorro"
  },
  {
    "prefixo": "49153",
    "uf": "SE",
    "codigoIbge": 2804805,
    "cidade": "Nossa Senhora do Socorro"
  },
  {
    "prefixo": "49155",
    "uf": "SE",
    "codigoIbge": 2804805,
    "cidade": "Nossa Senhora do Socorro"
  },
  {
    "prefixo": "49156",
    "uf": "SE",
    "codigoIbge": 2804805,
    "cidade": "Nossa Senhora do Socorro"
  },
  {
    "prefixo": "49157",
    "uf": "SE",
    "codigoIbge": 2804805,
    "cidade": "Nossa Senhora do Socorro"
  },
  {
    "prefixo": "49158",
    "uf": "SE",
    "codigoIbge": 2804805,
    "cidade": "Nossa Senhora do Socorro"
  },
  {
    "prefixo": "49159",
    "uf": "SE",
    "codigoIbge": 2804805,
    "cidade": "Nossa Senhora do Socorro"
  },
  {
    "prefixo": "49160",
    "uf": "SE",
    "codigoIbge": 2804805,
    "cidade": "Nossa Senhora do Socorro"
  },
  {
    "prefixo": "49162",
    "uf": "SE",
    "codigoIbge": 2804805,
    "cidade": "Nossa Senhora do Socorro"
  },
  {
    "prefixo": "49163",
    "uf": "SE",
    "codigoIbge": 2804805,
    "cidade": "Nossa Senhora do Socorro"
  },
  {
    "prefixo": "49164",
    "uf": "SE",
    "codigoIbge": 2804805,
    "cidade": "Nossa Senhora do Socorro"
  },
  {
    "prefixo": "49170",
    "uf": "SE",
    "codigoIbge": 2803609,
    "cidade": "Laranjeiras"
  },
  {
    "prefixo": "49180",
    "uf": "SE",
    "codigoIbge": 2806602,
    "cidade": "Santo Amaro das Brotas"
  },
  {
    "prefixo": "49190",
    "uf": "SE",
    "codigoIbge": 2805307,
    "cidade": "Pirambu"
  },
  {
    "prefixo": "49200",
    "uf": "SE",
    "codigoIbge": 2802106,
    "cidade": "Estância"
  },
  {
    "prefixo": "49220",
    "uf": "SE",
    "codigoIbge": 2800407,
    "cidade": "Arauá"
  },
  {
    "prefixo": "49230",
    "uf": "SE",
    "codigoIbge": 2806305,
    "cidade": "Santa Luzia do Itanhy"
  },
  {
    "prefixo": "49250",
    "uf": "SE",
    "codigoIbge": 2802809,
    "cidade": "Indiaroba"
  },
  {
    "prefixo": "49260",
    "uf": "SE",
    "codigoIbge": 2807600,
    "cidade": "Umbaúba"
  },
  {
    "prefixo": "49270",
    "uf": "SE",
    "codigoIbge": 2801702,
    "cidade": "Cristinápolis"
  },
  {
    "prefixo": "49280",
    "uf": "SE",
    "codigoIbge": 2807501,
    "cidade": "Tomar do Geru"
  },
  {
    "prefixo": "49290",
    "uf": "SE",
    "codigoIbge": 2803005,
    "cidade": "Itabaianinha"
  },
  {
    "prefixo": "49300",
    "uf": "SE",
    "codigoIbge": 2807402,
    "cidade": "Tobias Barreto"
  },
  {
    "prefixo": "49310",
    "uf": "SE",
    "codigoIbge": 2807402,
    "cidade": "Tobias Barreto"
  },
  {
    "prefixo": "49320",
    "uf": "SE",
    "codigoIbge": 2805802,
    "cidade": "Riachão do Dantas"
  },
  {
    "prefixo": "49325",
    "uf": "SE",
    "codigoIbge": 2805802,
    "cidade": "Riachão do Dantas"
  },
  {
    "prefixo": "49350",
    "uf": "SE",
    "codigoIbge": 2805109,
    "cidade": "Pedrinhas"
  },
  {
    "prefixo": "49360",
    "uf": "SE",
    "codigoIbge": 2800670,
    "cidade": "Boquim"
  },
  {
    "prefixo": "49390",
    "uf": "SE",
    "codigoIbge": 2806206,
    "cidade": "Salgado"
  },
  {
    "prefixo": "49400",
    "uf": "SE",
    "codigoIbge": 2803500,
    "cidade": "Lagarto"
  },
  {
    "prefixo": "49480",
    "uf": "SE",
    "codigoIbge": 2807105,
    "cidade": "Simão Dias"
  },
  {
    "prefixo": "49490",
    "uf": "SE",
    "codigoIbge": 2805505,
    "cidade": "Poço Verde"
  },
  {
    "prefixo": "49500",
    "uf": "SE",
    "codigoIbge": 2802908,
    "cidade": "Itabaiana"
  },
  {
    "prefixo": "49501",
    "uf": "SE",
    "codigoIbge": 2802908,
    "cidade": "Itabaiana"
  },
  {
    "prefixo": "49502",
    "uf": "SE",
    "codigoIbge": 2802908,
    "cidade": "Itabaiana"
  },
  {
    "prefixo": "49503",
    "uf": "SE",
    "codigoIbge": 2802908,
    "cidade": "Itabaiana"
  },
  {
    "prefixo": "49504",
    "uf": "SE",
    "codigoIbge": 2802908,
    "cidade": "Itabaiana"
  },
  {
    "prefixo": "49505",
    "uf": "SE",
    "codigoIbge": 2802908,
    "cidade": "Itabaiana"
  },
  {
    "prefixo": "49506",
    "uf": "SE",
    "codigoIbge": 2802908,
    "cidade": "Itabaiana"
  },
  {
    "prefixo": "49507",
    "uf": "SE",
    "codigoIbge": 2802908,
    "cidade": "Itabaiana"
  },
  {
    "prefixo": "49508",
    "uf": "SE",
    "codigoIbge": 2802908,
    "cidade": "Itabaiana"
  },
  {
    "prefixo": "49509",
    "uf": "SE",
    "codigoIbge": 2802908,
    "cidade": "Itabaiana"
  },
  {
    "prefixo": "49510",
    "uf": "SE",
    "codigoIbge": 2802908,
    "cidade": "Itabaiana"
  },
  {
    "prefixo": "49511",
    "uf": "SE",
    "codigoIbge": 2802908,
    "cidade": "Itabaiana"
  },
  {
    "prefixo": "49512",
    "uf": "SE",
    "codigoIbge": 2805000,
    "cidade": "Pedra Mole"
  },
  {
    "prefixo": "49514",
    "uf": "SE",
    "codigoIbge": 2802304,
    "cidade": "Frei Paulo"
  },
  {
    "prefixo": "49517",
    "uf": "SE",
    "codigoIbge": 2805208,
    "cidade": "Pinhão"
  },
  {
    "prefixo": "49520",
    "uf": "SE",
    "codigoIbge": 2801009,
    "cidade": "Campo do Brito"
  },
  {
    "prefixo": "49525",
    "uf": "SE",
    "codigoIbge": 2806800,
    "cidade": "São Domingos"
  },
  {
    "prefixo": "49530",
    "uf": "SE",
    "codigoIbge": 2806008,
    "cidade": "Ribeirópolis"
  },
  {
    "prefixo": "49535",
    "uf": "SE",
    "codigoIbge": 2807006,
    "cidade": "São Miguel do Aleixo"
  },
  {
    "prefixo": "49540",
    "uf": "SE",
    "codigoIbge": 2804458,
    "cidade": "Nossa Senhora Aparecida"
  },
  {
    "prefixo": "49550",
    "uf": "SE",
    "codigoIbge": 2801405,
    "cidade": "Carira"
  },
  {
    "prefixo": "49555",
    "uf": "SE",
    "codigoIbge": 2801405,
    "cidade": "Carira"
  },
  {
    "prefixo": "49560",
    "uf": "SE",
    "codigoIbge": 2804102,
    "cidade": "Moita Bonita"
  },
  {
    "prefixo": "49565",
    "uf": "SE",
    "codigoIbge": 2803708,
    "cidade": "Macambira"
  },
  {
    "prefixo": "49570",
    "uf": "SE",
    "codigoIbge": 2803906,
    "cidade": "Malhador"
  },
  {
    "prefixo": "49580",
    "uf": "SE",
    "codigoIbge": 2800506,
    "cidade": "Areia Branca"
  },
  {
    "prefixo": "49600",
    "uf": "SE",
    "codigoIbge": 2804607,
    "cidade": "Nossa Senhora das Dores"
  },
  {
    "prefixo": "49630",
    "uf": "SE",
    "codigoIbge": 2807204,
    "cidade": "Siriri"
  },
  {
    "prefixo": "49640",
    "uf": "SE",
    "codigoIbge": 2806503,
    "cidade": "Santa Rosa de Lima"
  },
  {
    "prefixo": "49650",
    "uf": "SE",
    "codigoIbge": 2802007,
    "cidade": "Divina Pastora"
  },
  {
    "prefixo": "49660",
    "uf": "SE",
    "codigoIbge": 2801900,
    "cidade": "Cumbe"
  },
  {
    "prefixo": "49670",
    "uf": "SE",
    "codigoIbge": 2802205,
    "cidade": "Feira Nova"
  },
  {
    "prefixo": "49680",
    "uf": "SE",
    "codigoIbge": 2804508,
    "cidade": "Nossa Senhora da Glória"
  },
  {
    "prefixo": "49690",
    "uf": "SE",
    "codigoIbge": 2804201,
    "cidade": "Monte Alegre de Sergipe"
  },
  {
    "prefixo": "49700",
    "uf": "SE",
    "codigoIbge": 2801306,
    "cidade": "Capela"
  },
  {
    "prefixo": "49702",
    "uf": "SE",
    "codigoIbge": 2801306,
    "cidade": "Capela"
  },
  {
    "prefixo": "49704",
    "uf": "SE",
    "codigoIbge": 2801306,
    "cidade": "Capela"
  },
  {
    "prefixo": "49710",
    "uf": "SE",
    "codigoIbge": 2801306,
    "cidade": "Capela"
  },
  {
    "prefixo": "49740",
    "uf": "SE",
    "codigoIbge": 2801504,
    "cidade": "Carmópolis"
  },
  {
    "prefixo": "49750",
    "uf": "SE",
    "codigoIbge": 2802502,
    "cidade": "General Maynard"
  },
  {
    "prefixo": "49760",
    "uf": "SE",
    "codigoIbge": 2806107,
    "cidade": "Rosário do Catete"
  },
  {
    "prefixo": "49770",
    "uf": "SE",
    "codigoIbge": 2804003,
    "cidade": "Maruim"
  },
  {
    "prefixo": "49780",
    "uf": "SE",
    "codigoIbge": 2804300,
    "cidade": "Muribeca"
  },
  {
    "prefixo": "49790",
    "uf": "SE",
    "codigoIbge": 2800209,
    "cidade": "Aquidabã"
  },
  {
    "prefixo": "49800",
    "uf": "SE",
    "codigoIbge": 2805604,
    "cidade": "Porto da Folha"
  },
  {
    "prefixo": "49810",
    "uf": "SE",
    "codigoIbge": 2805406,
    "cidade": "Poço Redondo"
  },
  {
    "prefixo": "49820",
    "uf": "SE",
    "codigoIbge": 2801207,
    "cidade": "Canindé de São Francisco"
  },
  {
    "prefixo": "49830",
    "uf": "SE",
    "codigoIbge": 2802403,
    "cidade": "Gararu"
  },
  {
    "prefixo": "49835",
    "uf": "SE",
    "codigoIbge": 2802403,
    "cidade": "Gararu"
  },
  {
    "prefixo": "49860",
    "uf": "SE",
    "codigoIbge": 2802601,
    "cidade": "Graccho Cardoso"
  },
  {
    "prefixo": "49870",
    "uf": "SE",
    "codigoIbge": 2803104,
    "cidade": "Itabi"
  },
  {
    "prefixo": "49880",
    "uf": "SE",
    "codigoIbge": 2801108,
    "cidade": "Canhoba"
  },
  {
    "prefixo": "49890",
    "uf": "SE",
    "codigoIbge": 2804706,
    "cidade": "Nossa Senhora de Lourdes"
  },
  {
    "prefixo": "49900",
    "uf": "SE",
    "codigoIbge": 2805703,
    "cidade": "Propriá"
  },
  {
    "prefixo": "49910",
    "uf": "SE",
    "codigoIbge": 2807303,
    "cidade": "Telha"
  },
  {
    "prefixo": "49920",
    "uf": "SE",
    "codigoIbge": 2800100,
    "cidade": "Amparo do São Francisco"
  },
  {
    "prefixo": "49930",
    "uf": "SE",
    "codigoIbge": 2801603,
    "cidade": "Cedro de São João"
  },
  {
    "prefixo": "49940",
    "uf": "SE",
    "codigoIbge": 2803807,
    "cidade": "Malhada dos Bois"
  },
  {
    "prefixo": "49945",
    "uf": "SE",
    "codigoIbge": 2806909,
    "cidade": "São Francisco"
  },
  {
    "prefixo": "49950",
    "uf": "SE",
    "codigoIbge": 2803401,
    "cidade": "Japoatã"
  },
  {
    "prefixo": "49960",
    "uf": "SE",
    "codigoIbge": 2803302,
    "cidade": "Japaratuba"
  },
  {
    "prefixo": "49970",
    "uf": "SE",
    "codigoIbge": 2804904,
    "cidade": "Pacatuba"
  },
  {
    "prefixo": "49980",
    "uf": "SE",
    "codigoIbge": 2804409,
    "cidade": "Neópolis"
  },
  {
    "prefixo": "49985",
    "uf": "SE",
    "codigoIbge": 2806404,
    "cidade": "Santana do São Francisco"
  },
  {
    "prefixo": "49990",
    "uf": "SE",
    "codigoIbge": 2802700,
    "cidade": "Ilha das Flores"
  },
  {
    "prefixo": "49995",
    "uf": "SE",
    "codigoIbge": 2800704,
    "cidade": "Brejo Grande"
  },
  {
    "prefixo": "50010",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50020",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50030",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50040",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50050",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50060",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50070",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50080",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50090",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50100",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50110",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50610",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50620",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50630",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50640",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50650",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50660",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50670",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50680",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50690",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50710",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50711",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50720",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50721",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50730",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50731",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50740",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50741",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50750",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50751",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50760",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50761",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50770",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50771",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50780",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50781",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50790",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50791",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50800",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50810",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50820",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50830",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50850",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50860",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50865",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50870",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50875",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50900",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50910",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50920",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50930",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50940",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50950",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50960",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50970",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "50980",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51010",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51011",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51020",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51021",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51030",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51110",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51111",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51130",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51150",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51160",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51170",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51180",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51190",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51200",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51210",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51220",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51230",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51240",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51250",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51260",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51270",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51275",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51280",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51290",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51300",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51310",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51320",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51330",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51335",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51340",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51345",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51346",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "51350",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52010",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52011",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52020",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52021",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52030",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52031",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52040",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52041",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52050",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52051",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52060",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52061",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52070",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52071",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52080",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52081",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52090",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52091",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52110",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52111",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52120",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52121",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52125",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52130",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52131",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52140",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52150",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52160",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52165",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52170",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52171",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52190",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52191",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52210",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52211",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52221",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52280",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52288",
    "uf": "RN",
    "codigoIbge": 2407104,
    "cidade": "Macaíba"
  },
  {
    "prefixo": "52291",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52390",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52490",
    "uf": "PE",
    "codigoIbge": 2611606,
    "cidade": "Recife"
  },
  {
    "prefixo": "52540",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53010",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53020",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53025",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53030",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53040",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53050",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53060",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53070",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53080",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53090",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53110",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53120",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53130",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53140",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53150",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53160",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53170",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53180",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53190",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53200",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53210",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53220",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53230",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53240",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53250",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53260",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53270",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53280",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53290",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53300",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53320",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53330",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53350",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53360",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53370",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53399",
    "uf": "PE",
    "codigoIbge": 2609600,
    "cidade": "Olinda"
  },
  {
    "prefixo": "53401",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53402",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53403",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53404",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53405",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53407",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53409",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53413",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53415",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53416",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53417",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53419",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53420",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53421",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53422",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53423",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53425",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53427",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53429",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53431",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53433",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53435",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53437",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53439",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53441",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53442",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53443",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53444",
    "uf": "PE",
    "codigoIbge": 2610707,
    "cidade": "Paulista"
  },
  {
    "prefixo": "53500",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53510",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53515",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53520",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53525",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53530",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53540",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53545",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53550",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53560",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53565",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53570",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53575",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53580",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53585",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53589",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53590",
    "uf": "PE",
    "codigoIbge": 2600054,
    "cidade": "Abreu e Lima"
  },
  {
    "prefixo": "53605",
    "uf": "PE",
    "codigoIbge": 2606804,
    "cidade": "Igarassu"
  },
  {
    "prefixo": "53610",
    "uf": "PE",
    "codigoIbge": 2606804,
    "cidade": "Igarassu"
  },
  {
    "prefixo": "53615",
    "uf": "PE",
    "codigoIbge": 2606804,
    "cidade": "Igarassu"
  },
  {
    "prefixo": "53620",
    "uf": "PE",
    "codigoIbge": 2606804,
    "cidade": "Igarassu"
  },
  {
    "prefixo": "53625",
    "uf": "PE",
    "codigoIbge": 2606804,
    "cidade": "Igarassu"
  },
  {
    "prefixo": "53630",
    "uf": "PE",
    "codigoIbge": 2606804,
    "cidade": "Igarassu"
  },
  {
    "prefixo": "53635",
    "uf": "PE",
    "codigoIbge": 2606804,
    "cidade": "Igarassu"
  },
  {
    "prefixo": "53637",
    "uf": "PE",
    "codigoIbge": 2606804,
    "cidade": "Igarassu"
  },
  {
    "prefixo": "53640",
    "uf": "PE",
    "codigoIbge": 2606804,
    "cidade": "Igarassu"
  },
  {
    "prefixo": "53645",
    "uf": "PE",
    "codigoIbge": 2606804,
    "cidade": "Igarassu"
  },
  {
    "prefixo": "53647",
    "uf": "PE",
    "codigoIbge": 2606804,
    "cidade": "Igarassu"
  },
  {
    "prefixo": "53650",
    "uf": "PE",
    "codigoIbge": 2606804,
    "cidade": "Igarassu"
  },
  {
    "prefixo": "53660",
    "uf": "PE",
    "codigoIbge": 2606804,
    "cidade": "Igarassu"
  },
  {
    "prefixo": "53670",
    "uf": "PE",
    "codigoIbge": 2606804,
    "cidade": "Igarassu"
  },
  {
    "prefixo": "53690",
    "uf": "PE",
    "codigoIbge": 2601052,
    "cidade": "Araçoiaba"
  },
  {
    "prefixo": "53700",
    "uf": "PE",
    "codigoIbge": 2607752,
    "cidade": "Itapissuma"
  },
  {
    "prefixo": "53900",
    "uf": "PE",
    "codigoIbge": 2607604,
    "cidade": "Ilha de Itamaracá"
  },
  {
    "prefixo": "53990",
    "uf": "PE",
    "codigoIbge": 2605459,
    "cidade": "Fernando de Noronha"
  },
  {
    "prefixo": "54070",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54080",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54090",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54100",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54110",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54120",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54125",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54130",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54140",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54150",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54160",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54170",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54210",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54220",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54230",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54240",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54245",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54250",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54260",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54270",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54275",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54280",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54290",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54300",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54310",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54315",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54320",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54325",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54330",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54335",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54340",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54345",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54350",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54352",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54353",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54355",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54360",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54365",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54368",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54370",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54380",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54400",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54410",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54420",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54430",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54440",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54450",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54460",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54470",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54480",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54490",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54495",
    "uf": "PE",
    "codigoIbge": 2607901,
    "cidade": "Jaboatão dos Guararapes"
  },
  {
    "prefixo": "54500",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54503",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54505",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54510",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54515",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54517",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54518",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54519",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54520",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54522",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54523",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54524",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54525",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54526",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54530",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54535",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54540",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54570",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54580",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54589",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54590",
    "uf": "PE",
    "codigoIbge": 2602902,
    "cidade": "Cabo de Santo Agostinho"
  },
  {
    "prefixo": "54705",
    "uf": "PE",
    "codigoIbge": 2613701,
    "cidade": "São Lourenço da Mata"
  },
  {
    "prefixo": "54710",
    "uf": "PE",
    "codigoIbge": 2613701,
    "cidade": "São Lourenço da Mata"
  },
  {
    "prefixo": "54715",
    "uf": "PE",
    "codigoIbge": 2613701,
    "cidade": "São Lourenço da Mata"
  },
  {
    "prefixo": "54720",
    "uf": "PE",
    "codigoIbge": 2613701,
    "cidade": "São Lourenço da Mata"
  },
  {
    "prefixo": "54723",
    "uf": "PE",
    "codigoIbge": 2613701,
    "cidade": "São Lourenço da Mata"
  },
  {
    "prefixo": "54725",
    "uf": "PE",
    "codigoIbge": 2613701,
    "cidade": "São Lourenço da Mata"
  },
  {
    "prefixo": "54727",
    "uf": "PE",
    "codigoIbge": 2613701,
    "cidade": "São Lourenço da Mata"
  },
  {
    "prefixo": "54730",
    "uf": "PE",
    "codigoIbge": 2613701,
    "cidade": "São Lourenço da Mata"
  },
  {
    "prefixo": "54733",
    "uf": "PE",
    "codigoIbge": 2613701,
    "cidade": "São Lourenço da Mata"
  },
  {
    "prefixo": "54735",
    "uf": "PE",
    "codigoIbge": 2613701,
    "cidade": "São Lourenço da Mata"
  },
  {
    "prefixo": "54737",
    "uf": "PE",
    "codigoIbge": 2613701,
    "cidade": "São Lourenço da Mata"
  },
  {
    "prefixo": "54740",
    "uf": "PE",
    "codigoIbge": 2613701,
    "cidade": "São Lourenço da Mata"
  },
  {
    "prefixo": "54745",
    "uf": "PE",
    "codigoIbge": 2613701,
    "cidade": "São Lourenço da Mata"
  },
  {
    "prefixo": "54748",
    "uf": "PE",
    "codigoIbge": 2613701,
    "cidade": "São Lourenço da Mata"
  },
  {
    "prefixo": "54749",
    "uf": "PE",
    "codigoIbge": 2613701,
    "cidade": "São Lourenço da Mata"
  },
  {
    "prefixo": "54753",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54756",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54759",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54762",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54765",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54766",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54767",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54768",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54771",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54774",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54777",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54780",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54783",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54786",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54789",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54792",
    "uf": "PE",
    "codigoIbge": 2603454,
    "cidade": "Camaragibe"
  },
  {
    "prefixo": "54800",
    "uf": "PE",
    "codigoIbge": 2609402,
    "cidade": "Moreno"
  },
  {
    "prefixo": "55000",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55002",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55004",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55006",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55008",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55010",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55012",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55014",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55015",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55016",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55018",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55019",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55020",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55021",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55022",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55023",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55024",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55025",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55026",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55027",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55028",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55030",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55031",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55032",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55034",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55036",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55037",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55038",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55039",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55040",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55041",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55042",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55043",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55044",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55045",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55046",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55047",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55099",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55100",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55102",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55103",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55105",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55108",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55111",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55112",
    "uf": "PE",
    "codigoIbge": 2604106,
    "cidade": "Caruaru"
  },
  {
    "prefixo": "55120",
    "uf": "PE",
    "codigoIbge": 2611705,
    "cidade": "Riacho das Almas"
  },
  {
    "prefixo": "55121",
    "uf": "PE",
    "codigoIbge": 2611705,
    "cidade": "Riacho das Almas"
  },
  {
    "prefixo": "55122",
    "uf": "PE",
    "codigoIbge": 2611705,
    "cidade": "Riacho das Almas"
  },
  {
    "prefixo": "55123",
    "uf": "PE",
    "codigoIbge": 2611705,
    "cidade": "Riacho das Almas"
  },
  {
    "prefixo": "55125",
    "uf": "PE",
    "codigoIbge": 2615409,
    "cidade": "Toritama"
  },
  {
    "prefixo": "55130",
    "uf": "PE",
    "codigoIbge": 2613107,
    "cidade": "São Caitano"
  },
  {
    "prefixo": "55135",
    "uf": "PE",
    "codigoIbge": 2613107,
    "cidade": "São Caitano"
  },
  {
    "prefixo": "55138",
    "uf": "PE",
    "codigoIbge": 2613107,
    "cidade": "São Caitano"
  },
  {
    "prefixo": "55140",
    "uf": "PE",
    "codigoIbge": 2614709,
    "cidade": "Tacaimbó"
  },
  {
    "prefixo": "55145",
    "uf": "PE",
    "codigoIbge": 2614709,
    "cidade": "Tacaimbó"
  },
  {
    "prefixo": "55150",
    "uf": "PE",
    "codigoIbge": 2601706,
    "cidade": "Belo Jardim"
  },
  {
    "prefixo": "55151",
    "uf": "PE",
    "codigoIbge": 2601706,
    "cidade": "Belo Jardim"
  },
  {
    "prefixo": "55152",
    "uf": "PE",
    "codigoIbge": 2601706,
    "cidade": "Belo Jardim"
  },
  {
    "prefixo": "55153",
    "uf": "PE",
    "codigoIbge": 2601706,
    "cidade": "Belo Jardim"
  },
  {
    "prefixo": "55154",
    "uf": "PE",
    "codigoIbge": 2601706,
    "cidade": "Belo Jardim"
  },
  {
    "prefixo": "55155",
    "uf": "PE",
    "codigoIbge": 2601706,
    "cidade": "Belo Jardim"
  },
  {
    "prefixo": "55156",
    "uf": "PE",
    "codigoIbge": 2601706,
    "cidade": "Belo Jardim"
  },
  {
    "prefixo": "55157",
    "uf": "PE",
    "codigoIbge": 2601706,
    "cidade": "Belo Jardim"
  },
  {
    "prefixo": "55158",
    "uf": "PE",
    "codigoIbge": 2601706,
    "cidade": "Belo Jardim"
  },
  {
    "prefixo": "55159",
    "uf": "PE",
    "codigoIbge": 2601706,
    "cidade": "Belo Jardim"
  },
  {
    "prefixo": "55160",
    "uf": "PE",
    "codigoIbge": 2601706,
    "cidade": "Belo Jardim"
  },
  {
    "prefixo": "55162",
    "uf": "PE",
    "codigoIbge": 2601706,
    "cidade": "Belo Jardim"
  },
  {
    "prefixo": "55163",
    "uf": "PE",
    "codigoIbge": 2601706,
    "cidade": "Belo Jardim"
  },
  {
    "prefixo": "55165",
    "uf": "PE",
    "codigoIbge": 2601706,
    "cidade": "Belo Jardim"
  },
  {
    "prefixo": "55168",
    "uf": "PE",
    "codigoIbge": 2601706,
    "cidade": "Belo Jardim"
  },
  {
    "prefixo": "55170",
    "uf": "PE",
    "codigoIbge": 2602605,
    "cidade": "Brejo da Madre de Deus"
  },
  {
    "prefixo": "55171",
    "uf": "PE",
    "codigoIbge": 2602605,
    "cidade": "Brejo da Madre de Deus"
  },
  {
    "prefixo": "55172",
    "uf": "PE",
    "codigoIbge": 2602605,
    "cidade": "Brejo da Madre de Deus"
  },
  {
    "prefixo": "55174",
    "uf": "PE",
    "codigoIbge": 2602605,
    "cidade": "Brejo da Madre de Deus"
  },
  {
    "prefixo": "55175",
    "uf": "PE",
    "codigoIbge": 2602605,
    "cidade": "Brejo da Madre de Deus"
  },
  {
    "prefixo": "55178",
    "uf": "PE",
    "codigoIbge": 2602605,
    "cidade": "Brejo da Madre de Deus"
  },
  {
    "prefixo": "55180",
    "uf": "PE",
    "codigoIbge": 2608008,
    "cidade": "Jataúba"
  },
  {
    "prefixo": "55185",
    "uf": "PE",
    "codigoIbge": 2608008,
    "cidade": "Jataúba"
  },
  {
    "prefixo": "55190",
    "uf": "PE",
    "codigoIbge": 2612505,
    "cidade": "Santa Cruz do Capibaribe"
  },
  {
    "prefixo": "55191",
    "uf": "PE",
    "codigoIbge": 2612505,
    "cidade": "Santa Cruz do Capibaribe"
  },
  {
    "prefixo": "55192",
    "uf": "PE",
    "codigoIbge": 2612505,
    "cidade": "Santa Cruz do Capibaribe"
  },
  {
    "prefixo": "55193",
    "uf": "PE",
    "codigoIbge": 2612505,
    "cidade": "Santa Cruz do Capibaribe"
  },
  {
    "prefixo": "55194",
    "uf": "PE",
    "codigoIbge": 2612505,
    "cidade": "Santa Cruz do Capibaribe"
  },
  {
    "prefixo": "55195",
    "uf": "PE",
    "codigoIbge": 2612505,
    "cidade": "Santa Cruz do Capibaribe"
  },
  {
    "prefixo": "55196",
    "uf": "PE",
    "codigoIbge": 2612505,
    "cidade": "Santa Cruz do Capibaribe"
  },
  {
    "prefixo": "55197",
    "uf": "PE",
    "codigoIbge": 2612505,
    "cidade": "Santa Cruz do Capibaribe"
  },
  {
    "prefixo": "55198",
    "uf": "PE",
    "codigoIbge": 2612505,
    "cidade": "Santa Cruz do Capibaribe"
  },
  {
    "prefixo": "55199",
    "uf": "PE",
    "codigoIbge": 2612505,
    "cidade": "Santa Cruz do Capibaribe"
  },
  {
    "prefixo": "55200",
    "uf": "PE",
    "codigoIbge": 2610905,
    "cidade": "Pesqueira"
  },
  {
    "prefixo": "55205",
    "uf": "PE",
    "codigoIbge": 2610905,
    "cidade": "Pesqueira"
  },
  {
    "prefixo": "55210",
    "uf": "PE",
    "codigoIbge": 2610905,
    "cidade": "Pesqueira"
  },
  {
    "prefixo": "55215",
    "uf": "PE",
    "codigoIbge": 2610905,
    "cidade": "Pesqueira"
  },
  {
    "prefixo": "55220",
    "uf": "PE",
    "codigoIbge": 2610905,
    "cidade": "Pesqueira"
  },
  {
    "prefixo": "55225",
    "uf": "PE",
    "codigoIbge": 2610905,
    "cidade": "Pesqueira"
  },
  {
    "prefixo": "55240",
    "uf": "PE",
    "codigoIbge": 2611200,
    "cidade": "Poção"
  },
  {
    "prefixo": "55245",
    "uf": "PE",
    "codigoIbge": 2611200,
    "cidade": "Poção"
  },
  {
    "prefixo": "55250",
    "uf": "PE",
    "codigoIbge": 2612406,
    "cidade": "Sanharó"
  },
  {
    "prefixo": "55255",
    "uf": "PE",
    "codigoIbge": 2612406,
    "cidade": "Sanharó"
  },
  {
    "prefixo": "55260",
    "uf": "PE",
    "codigoIbge": 2600609,
    "cidade": "Alagoinha"
  },
  {
    "prefixo": "55265",
    "uf": "PE",
    "codigoIbge": 2600609,
    "cidade": "Alagoinha"
  },
  {
    "prefixo": "55270",
    "uf": "PE",
    "codigoIbge": 2616001,
    "cidade": "Venturosa"
  },
  {
    "prefixo": "55275",
    "uf": "PE",
    "codigoIbge": 2616001,
    "cidade": "Venturosa"
  },
  {
    "prefixo": "55280",
    "uf": "PE",
    "codigoIbge": 2610806,
    "cidade": "Pedra"
  },
  {
    "prefixo": "55284",
    "uf": "PE",
    "codigoIbge": 2610806,
    "cidade": "Pedra"
  },
  {
    "prefixo": "55285",
    "uf": "PE",
    "codigoIbge": 2610806,
    "cidade": "Pedra"
  },
  {
    "prefixo": "55291",
    "uf": "PE",
    "codigoIbge": 2606002,
    "cidade": "Garanhuns"
  },
  {
    "prefixo": "55292",
    "uf": "PE",
    "codigoIbge": 2606002,
    "cidade": "Garanhuns"
  },
  {
    "prefixo": "55293",
    "uf": "PE",
    "codigoIbge": 2606002,
    "cidade": "Garanhuns"
  },
  {
    "prefixo": "55294",
    "uf": "PE",
    "codigoIbge": 2606002,
    "cidade": "Garanhuns"
  },
  {
    "prefixo": "55295",
    "uf": "PE",
    "codigoIbge": 2606002,
    "cidade": "Garanhuns"
  },
  {
    "prefixo": "55296",
    "uf": "PE",
    "codigoIbge": 2606002,
    "cidade": "Garanhuns"
  },
  {
    "prefixo": "55297",
    "uf": "PE",
    "codigoIbge": 2606002,
    "cidade": "Garanhuns"
  },
  {
    "prefixo": "55298",
    "uf": "PE",
    "codigoIbge": 2606002,
    "cidade": "Garanhuns"
  },
  {
    "prefixo": "55299",
    "uf": "PE",
    "codigoIbge": 2606002,
    "cidade": "Garanhuns"
  },
  {
    "prefixo": "55302",
    "uf": "PE",
    "codigoIbge": 2606002,
    "cidade": "Garanhuns"
  },
  {
    "prefixo": "55303",
    "uf": "PE",
    "codigoIbge": 2606002,
    "cidade": "Garanhuns"
  },
  {
    "prefixo": "55304",
    "uf": "PE",
    "codigoIbge": 2606002,
    "cidade": "Garanhuns"
  },
  {
    "prefixo": "55305",
    "uf": "PE",
    "codigoIbge": 2615102,
    "cidade": "Terezinha"
  },
  {
    "prefixo": "55310",
    "uf": "PE",
    "codigoIbge": 2610103,
    "cidade": "Palmeirina"
  },
  {
    "prefixo": "55315",
    "uf": "PE",
    "codigoIbge": 2604700,
    "cidade": "Correntes"
  },
  {
    "prefixo": "55317",
    "uf": "PE",
    "codigoIbge": 2604700,
    "cidade": "Correntes"
  },
  {
    "prefixo": "55320",
    "uf": "PE",
    "codigoIbge": 2608602,
    "cidade": "Lagoa do Ouro"
  },
  {
    "prefixo": "55322",
    "uf": "PE",
    "codigoIbge": 2608602,
    "cidade": "Lagoa do Ouro"
  },
  {
    "prefixo": "55323",
    "uf": "PE",
    "codigoIbge": 2608602,
    "cidade": "Lagoa do Ouro"
  },
  {
    "prefixo": "55325",
    "uf": "PE",
    "codigoIbge": 2602407,
    "cidade": "Brejão"
  },
  {
    "prefixo": "55330",
    "uf": "PE",
    "codigoIbge": 2602100,
    "cidade": "Bom Conselho"
  },
  {
    "prefixo": "55334",
    "uf": "PE",
    "codigoIbge": 2602100,
    "cidade": "Bom Conselho"
  },
  {
    "prefixo": "55335",
    "uf": "PE",
    "codigoIbge": 2602100,
    "cidade": "Bom Conselho"
  },
  {
    "prefixo": "55337",
    "uf": "PE",
    "codigoIbge": 2602100,
    "cidade": "Bom Conselho"
  },
  {
    "prefixo": "55340",
    "uf": "PE",
    "codigoIbge": 2600500,
    "cidade": "Águas Belas"
  },
  {
    "prefixo": "55343",
    "uf": "PE",
    "codigoIbge": 2600500,
    "cidade": "Águas Belas"
  },
  {
    "prefixo": "55345",
    "uf": "PE",
    "codigoIbge": 2606507,
    "cidade": "Iati"
  },
  {
    "prefixo": "55347",
    "uf": "PE",
    "codigoIbge": 2606507,
    "cidade": "Iati"
  },
  {
    "prefixo": "55350",
    "uf": "PE",
    "codigoIbge": 2612307,
    "cidade": "Saloá"
  },
  {
    "prefixo": "55353",
    "uf": "PE",
    "codigoIbge": 2612307,
    "cidade": "Saloá"
  },
  {
    "prefixo": "55355",
    "uf": "PE",
    "codigoIbge": 2610301,
    "cidade": "Paranatama"
  },
  {
    "prefixo": "55360",
    "uf": "PE",
    "codigoIbge": 2603207,
    "cidade": "Caetés"
  },
  {
    "prefixo": "55365",
    "uf": "PE",
    "codigoIbge": 2603801,
    "cidade": "Capoeiras"
  },
  {
    "prefixo": "55370",
    "uf": "PE",
    "codigoIbge": 2613008,
    "cidade": "São Bento do Una"
  },
  {
    "prefixo": "55374",
    "uf": "PE",
    "codigoIbge": 2613008,
    "cidade": "São Bento do Una"
  },
  {
    "prefixo": "55375",
    "uf": "PE",
    "codigoIbge": 2603306,
    "cidade": "Calçado"
  },
  {
    "prefixo": "55380",
    "uf": "PE",
    "codigoIbge": 2603108,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "55383",
    "uf": "PE",
    "codigoIbge": 2603108,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "55385",
    "uf": "PE",
    "codigoIbge": 2608800,
    "cidade": "Lajedo"
  },
  {
    "prefixo": "55390",
    "uf": "PE",
    "codigoIbge": 2606705,
    "cidade": "Ibirajuba"
  },
  {
    "prefixo": "55395",
    "uf": "PE",
    "codigoIbge": 2608305,
    "cidade": "Jupi"
  },
  {
    "prefixo": "55398",
    "uf": "PE",
    "codigoIbge": 2608255,
    "cidade": "Jucati"
  },
  {
    "prefixo": "55399",
    "uf": "PE",
    "codigoIbge": 2608255,
    "cidade": "Jucati"
  },
  {
    "prefixo": "55400",
    "uf": "PE",
    "codigoIbge": 2604205,
    "cidade": "Catende"
  },
  {
    "prefixo": "55401",
    "uf": "PE",
    "codigoIbge": 2604205,
    "cidade": "Catende"
  },
  {
    "prefixo": "55402",
    "uf": "PE",
    "codigoIbge": 2604205,
    "cidade": "Catende"
  },
  {
    "prefixo": "55405",
    "uf": "PE",
    "codigoIbge": 2609204,
    "cidade": "Maraial"
  },
  {
    "prefixo": "55409",
    "uf": "PE",
    "codigoIbge": 2607950,
    "cidade": "Jaqueira"
  },
  {
    "prefixo": "55410",
    "uf": "PE",
    "codigoIbge": 2612901,
    "cidade": "São Benedito do Sul"
  },
  {
    "prefixo": "55412",
    "uf": "PE",
    "codigoIbge": 2612901,
    "cidade": "São Benedito do Sul"
  },
  {
    "prefixo": "55415",
    "uf": "PE",
    "codigoIbge": 2611507,
    "cidade": "Quipapá"
  },
  {
    "prefixo": "55418",
    "uf": "PE",
    "codigoIbge": 2611507,
    "cidade": "Quipapá"
  },
  {
    "prefixo": "55420",
    "uf": "PE",
    "codigoIbge": 2603702,
    "cidade": "Canhotinho"
  },
  {
    "prefixo": "55425",
    "uf": "PE",
    "codigoIbge": 2603702,
    "cidade": "Canhotinho"
  },
  {
    "prefixo": "55430",
    "uf": "PE",
    "codigoIbge": 2601003,
    "cidade": "Angelim"
  },
  {
    "prefixo": "55435",
    "uf": "PE",
    "codigoIbge": 2613206,
    "cidade": "São João"
  },
  {
    "prefixo": "55440",
    "uf": "PE",
    "codigoIbge": 2601508,
    "cidade": "Belém de Maria"
  },
  {
    "prefixo": "55445",
    "uf": "PE",
    "codigoIbge": 2601508,
    "cidade": "Belém de Maria"
  },
  {
    "prefixo": "55450",
    "uf": "PE",
    "codigoIbge": 2608701,
    "cidade": "Lagoa dos Gatos"
  },
  {
    "prefixo": "55453",
    "uf": "PE",
    "codigoIbge": 2608701,
    "cidade": "Lagoa dos Gatos"
  },
  {
    "prefixo": "55455",
    "uf": "PE",
    "codigoIbge": 2608701,
    "cidade": "Lagoa dos Gatos"
  },
  {
    "prefixo": "55458",
    "uf": "PE",
    "codigoIbge": 2608701,
    "cidade": "Lagoa dos Gatos"
  },
  {
    "prefixo": "55460",
    "uf": "PE",
    "codigoIbge": 2605004,
    "cidade": "Cupira"
  },
  {
    "prefixo": "55465",
    "uf": "PE",
    "codigoIbge": 2605004,
    "cidade": "Cupira"
  },
  {
    "prefixo": "55470",
    "uf": "PE",
    "codigoIbge": 2610202,
    "cidade": "Panelas"
  },
  {
    "prefixo": "55473",
    "uf": "PE",
    "codigoIbge": 2610202,
    "cidade": "Panelas"
  },
  {
    "prefixo": "55475",
    "uf": "PE",
    "codigoIbge": 2610202,
    "cidade": "Panelas"
  },
  {
    "prefixo": "55478",
    "uf": "PE",
    "codigoIbge": 2610202,
    "cidade": "Panelas"
  },
  {
    "prefixo": "55480",
    "uf": "PE",
    "codigoIbge": 2608404,
    "cidade": "Jurema"
  },
  {
    "prefixo": "55485",
    "uf": "PE",
    "codigoIbge": 2608404,
    "cidade": "Jurema"
  },
  {
    "prefixo": "55490",
    "uf": "PE",
    "codigoIbge": 2600807,
    "cidade": "Altinho"
  },
  {
    "prefixo": "55493",
    "uf": "PE",
    "codigoIbge": 2600807,
    "cidade": "Altinho"
  },
  {
    "prefixo": "55495",
    "uf": "PE",
    "codigoIbge": 2600302,
    "cidade": "Agrestina"
  },
  {
    "prefixo": "55496",
    "uf": "PE",
    "codigoIbge": 2600302,
    "cidade": "Agrestina"
  },
  {
    "prefixo": "55497",
    "uf": "PE",
    "codigoIbge": 2600302,
    "cidade": "Agrestina"
  },
  {
    "prefixo": "55500",
    "uf": "PE",
    "codigoIbge": 2605202,
    "cidade": "Escada"
  },
  {
    "prefixo": "55505",
    "uf": "PE",
    "codigoIbge": 2605202,
    "cidade": "Escada"
  },
  {
    "prefixo": "55510",
    "uf": "PE",
    "codigoIbge": 2611408,
    "cidade": "Primavera"
  },
  {
    "prefixo": "55515",
    "uf": "PE",
    "codigoIbge": 2600906,
    "cidade": "Amaraji"
  },
  {
    "prefixo": "55520",
    "uf": "PE",
    "codigoIbge": 2611804,
    "cidade": "Ribeirão"
  },
  {
    "prefixo": "55522",
    "uf": "PE",
    "codigoIbge": 2611804,
    "cidade": "Ribeirão"
  },
  {
    "prefixo": "55525",
    "uf": "PE",
    "codigoIbge": 2604809,
    "cidade": "Cortês"
  },
  {
    "prefixo": "55530",
    "uf": "PE",
    "codigoIbge": 2605905,
    "cidade": "Gameleira"
  },
  {
    "prefixo": "55533",
    "uf": "PE",
    "codigoIbge": 2605905,
    "cidade": "Gameleira"
  },
  {
    "prefixo": "55535",
    "uf": "PE",
    "codigoIbge": 2608206,
    "cidade": "Joaquim Nabuco"
  },
  {
    "prefixo": "55540",
    "uf": "PE",
    "codigoIbge": 2610004,
    "cidade": "Palmares"
  },
  {
    "prefixo": "55548",
    "uf": "PE",
    "codigoIbge": 2610004,
    "cidade": "Palmares"
  },
  {
    "prefixo": "55550",
    "uf": "PE",
    "codigoIbge": 2600401,
    "cidade": "Água Preta"
  },
  {
    "prefixo": "55552",
    "uf": "PE",
    "codigoIbge": 2600401,
    "cidade": "Água Preta"
  },
  {
    "prefixo": "55555",
    "uf": "PE",
    "codigoIbge": 2616506,
    "cidade": "Xexéu"
  },
  {
    "prefixo": "55560",
    "uf": "PE",
    "codigoIbge": 2601409,
    "cidade": "Barreiros"
  },
  {
    "prefixo": "55564",
    "uf": "PE",
    "codigoIbge": 2601409,
    "cidade": "Barreiros"
  },
  {
    "prefixo": "55565",
    "uf": "PE",
    "codigoIbge": 2613404,
    "cidade": "São José da Coroa Grande"
  },
  {
    "prefixo": "55570",
    "uf": "PE",
    "codigoIbge": 2611903,
    "cidade": "Rio Formoso"
  },
  {
    "prefixo": "55572",
    "uf": "PE",
    "codigoIbge": 2611903,
    "cidade": "Rio Formoso"
  },
  {
    "prefixo": "55575",
    "uf": "PE",
    "codigoIbge": 2611903,
    "cidade": "Rio Formoso"
  },
  {
    "prefixo": "55578",
    "uf": "PE",
    "codigoIbge": 2614857,
    "cidade": "Tamandaré"
  },
  {
    "prefixo": "55580",
    "uf": "PE",
    "codigoIbge": 2614204,
    "cidade": "Sirinhaém"
  },
  {
    "prefixo": "55585",
    "uf": "PE",
    "codigoIbge": 2614204,
    "cidade": "Sirinhaém"
  },
  {
    "prefixo": "55586",
    "uf": "PE",
    "codigoIbge": 2614204,
    "cidade": "Sirinhaém"
  },
  {
    "prefixo": "55588",
    "uf": "PE",
    "codigoIbge": 2614204,
    "cidade": "Sirinhaém"
  },
  {
    "prefixo": "55590",
    "uf": "PE",
    "codigoIbge": 2607208,
    "cidade": "Ipojuca"
  },
  {
    "prefixo": "55591",
    "uf": "PE",
    "codigoIbge": 2607208,
    "cidade": "Ipojuca"
  },
  {
    "prefixo": "55592",
    "uf": "PE",
    "codigoIbge": 2607208,
    "cidade": "Ipojuca"
  },
  {
    "prefixo": "55593",
    "uf": "PE",
    "codigoIbge": 2607208,
    "cidade": "Ipojuca"
  },
  {
    "prefixo": "55594",
    "uf": "PE",
    "codigoIbge": 2607208,
    "cidade": "Ipojuca"
  },
  {
    "prefixo": "55595",
    "uf": "PE",
    "codigoIbge": 2607208,
    "cidade": "Ipojuca"
  },
  {
    "prefixo": "55598",
    "uf": "PE",
    "codigoIbge": 2607208,
    "cidade": "Ipojuca"
  },
  {
    "prefixo": "55602",
    "uf": "PE",
    "codigoIbge": 2616407,
    "cidade": "Vitória de Santo Antão"
  },
  {
    "prefixo": "55604",
    "uf": "PE",
    "codigoIbge": 2616407,
    "cidade": "Vitória de Santo Antão"
  },
  {
    "prefixo": "55605",
    "uf": "PE",
    "codigoIbge": 2616407,
    "cidade": "Vitória de Santo Antão"
  },
  {
    "prefixo": "55606",
    "uf": "PE",
    "codigoIbge": 2616407,
    "cidade": "Vitória de Santo Antão"
  },
  {
    "prefixo": "55607",
    "uf": "PE",
    "codigoIbge": 2616407,
    "cidade": "Vitória de Santo Antão"
  },
  {
    "prefixo": "55608",
    "uf": "PE",
    "codigoIbge": 2616407,
    "cidade": "Vitória de Santo Antão"
  },
  {
    "prefixo": "55609",
    "uf": "PE",
    "codigoIbge": 2616407,
    "cidade": "Vitória de Santo Antão"
  },
  {
    "prefixo": "55610",
    "uf": "PE",
    "codigoIbge": 2616407,
    "cidade": "Vitória de Santo Antão"
  },
  {
    "prefixo": "55611",
    "uf": "PE",
    "codigoIbge": 2616407,
    "cidade": "Vitória de Santo Antão"
  },
  {
    "prefixo": "55612",
    "uf": "PE",
    "codigoIbge": 2616407,
    "cidade": "Vitória de Santo Antão"
  },
  {
    "prefixo": "55613",
    "uf": "PE",
    "codigoIbge": 2616407,
    "cidade": "Vitória de Santo Antão"
  },
  {
    "prefixo": "55614",
    "uf": "PE",
    "codigoIbge": 2616407,
    "cidade": "Vitória de Santo Antão"
  },
  {
    "prefixo": "55615",
    "uf": "PE",
    "codigoIbge": 2616407,
    "cidade": "Vitória de Santo Antão"
  },
  {
    "prefixo": "55616",
    "uf": "PE",
    "codigoIbge": 2616407,
    "cidade": "Vitória de Santo Antão"
  },
  {
    "prefixo": "55618",
    "uf": "PE",
    "codigoIbge": 2616407,
    "cidade": "Vitória de Santo Antão"
  },
  {
    "prefixo": "55620",
    "uf": "PE",
    "codigoIbge": 2606101,
    "cidade": "Glória do Goitá"
  },
  {
    "prefixo": "55625",
    "uf": "PE",
    "codigoIbge": 2606101,
    "cidade": "Glória do Goitá"
  },
  {
    "prefixo": "55630",
    "uf": "PE",
    "codigoIbge": 2611309,
    "cidade": "Pombos"
  },
  {
    "prefixo": "55633",
    "uf": "PE",
    "codigoIbge": 2611309,
    "cidade": "Pombos"
  },
  {
    "prefixo": "55634",
    "uf": "PE",
    "codigoIbge": 2611309,
    "cidade": "Pombos"
  },
  {
    "prefixo": "55636",
    "uf": "PE",
    "codigoIbge": 2604502,
    "cidade": "Chã Grande"
  },
  {
    "prefixo": "55640",
    "uf": "PE",
    "codigoIbge": 2606408,
    "cidade": "Gravatá"
  },
  {
    "prefixo": "55641",
    "uf": "PE",
    "codigoIbge": 2606408,
    "cidade": "Gravatá"
  },
  {
    "prefixo": "55642",
    "uf": "PE",
    "codigoIbge": 2606408,
    "cidade": "Gravatá"
  },
  {
    "prefixo": "55643",
    "uf": "PE",
    "codigoIbge": 2606408,
    "cidade": "Gravatá"
  },
  {
    "prefixo": "55644",
    "uf": "PE",
    "codigoIbge": 2606408,
    "cidade": "Gravatá"
  },
  {
    "prefixo": "55645",
    "uf": "PE",
    "codigoIbge": 2606408,
    "cidade": "Gravatá"
  },
  {
    "prefixo": "55646",
    "uf": "PE",
    "codigoIbge": 2606408,
    "cidade": "Gravatá"
  },
  {
    "prefixo": "55648",
    "uf": "PE",
    "codigoIbge": 2606408,
    "cidade": "Gravatá"
  },
  {
    "prefixo": "55650",
    "uf": "PE",
    "codigoIbge": 2610509,
    "cidade": "Passira"
  },
  {
    "prefixo": "55652",
    "uf": "PE",
    "codigoIbge": 2610509,
    "cidade": "Passira"
  },
  {
    "prefixo": "55655",
    "uf": "PE",
    "codigoIbge": 2604908,
    "cidade": "Cumaru"
  },
  {
    "prefixo": "55658",
    "uf": "PE",
    "codigoIbge": 2604908,
    "cidade": "Cumaru"
  },
  {
    "prefixo": "55660",
    "uf": "PE",
    "codigoIbge": 2601904,
    "cidade": "Bezerros"
  },
  {
    "prefixo": "55661",
    "uf": "PE",
    "codigoIbge": 2601904,
    "cidade": "Bezerros"
  },
  {
    "prefixo": "55662",
    "uf": "PE",
    "codigoIbge": 2601904,
    "cidade": "Bezerros"
  },
  {
    "prefixo": "55663",
    "uf": "PE",
    "codigoIbge": 2601904,
    "cidade": "Bezerros"
  },
  {
    "prefixo": "55664",
    "uf": "PE",
    "codigoIbge": 2601904,
    "cidade": "Bezerros"
  },
  {
    "prefixo": "55665",
    "uf": "PE",
    "codigoIbge": 2603504,
    "cidade": "Camocim de São Félix"
  },
  {
    "prefixo": "55670",
    "uf": "PE",
    "codigoIbge": 2613305,
    "cidade": "São Joaquim do Monte"
  },
  {
    "prefixo": "55672",
    "uf": "PE",
    "codigoIbge": 2613305,
    "cidade": "São Joaquim do Monte"
  },
  {
    "prefixo": "55673",
    "uf": "PE",
    "codigoIbge": 2613305,
    "cidade": "São Joaquim do Monte"
  },
  {
    "prefixo": "55674",
    "uf": "PE",
    "codigoIbge": 2613305,
    "cidade": "São Joaquim do Monte"
  },
  {
    "prefixo": "55675",
    "uf": "PE",
    "codigoIbge": 2612109,
    "cidade": "Salgadinho"
  },
  {
    "prefixo": "55680",
    "uf": "PE",
    "codigoIbge": 2602308,
    "cidade": "Bonito"
  },
  {
    "prefixo": "55682",
    "uf": "PE",
    "codigoIbge": 2602308,
    "cidade": "Bonito"
  },
  {
    "prefixo": "55685",
    "uf": "PE",
    "codigoIbge": 2602308,
    "cidade": "Bonito"
  },
  {
    "prefixo": "55690",
    "uf": "PE",
    "codigoIbge": 2601300,
    "cidade": "Barra de Guabiraba"
  },
  {
    "prefixo": "55695",
    "uf": "PE",
    "codigoIbge": 2612000,
    "cidade": "Sairé"
  },
  {
    "prefixo": "55700",
    "uf": "PE",
    "codigoIbge": 2608909,
    "cidade": "Limoeiro"
  },
  {
    "prefixo": "55705",
    "uf": "PE",
    "codigoIbge": 2608909,
    "cidade": "Limoeiro"
  },
  {
    "prefixo": "55715",
    "uf": "PE",
    "codigoIbge": 2605400,
    "cidade": "Feira Nova"
  },
  {
    "prefixo": "55720",
    "uf": "PE",
    "codigoIbge": 2608107,
    "cidade": "João Alfredo"
  },
  {
    "prefixo": "55730",
    "uf": "PE",
    "codigoIbge": 2602209,
    "cidade": "Bom Jardim"
  },
  {
    "prefixo": "55733",
    "uf": "PE",
    "codigoIbge": 2602209,
    "cidade": "Bom Jardim"
  },
  {
    "prefixo": "55735",
    "uf": "PE",
    "codigoIbge": 2602209,
    "cidade": "Bom Jardim"
  },
  {
    "prefixo": "55740",
    "uf": "PE",
    "codigoIbge": 2609105,
    "cidade": "Machados"
  },
  {
    "prefixo": "55745",
    "uf": "PE",
    "codigoIbge": 2609709,
    "cidade": "Orobó"
  },
  {
    "prefixo": "55747",
    "uf": "PE",
    "codigoIbge": 2609709,
    "cidade": "Orobó"
  },
  {
    "prefixo": "55748",
    "uf": "PE",
    "codigoIbge": 2609709,
    "cidade": "Orobó"
  },
  {
    "prefixo": "55750",
    "uf": "PE",
    "codigoIbge": 2614501,
    "cidade": "Surubim"
  },
  {
    "prefixo": "55752",
    "uf": "PE",
    "codigoIbge": 2614501,
    "cidade": "Surubim"
  },
  {
    "prefixo": "55753",
    "uf": "PE",
    "codigoIbge": 2614501,
    "cidade": "Surubim"
  },
  {
    "prefixo": "55755",
    "uf": "PE",
    "codigoIbge": 2604155,
    "cidade": "Casinhas"
  },
  {
    "prefixo": "55757",
    "uf": "PE",
    "codigoIbge": 2604155,
    "cidade": "Casinhas"
  },
  {
    "prefixo": "55760",
    "uf": "PE",
    "codigoIbge": 2616183,
    "cidade": "Vertente do Lério"
  },
  {
    "prefixo": "55765",
    "uf": "PE",
    "codigoIbge": 2612703,
    "cidade": "Santa Maria do Cambucá"
  },
  {
    "prefixo": "55767",
    "uf": "PE",
    "codigoIbge": 2612703,
    "cidade": "Santa Maria do Cambucá"
  },
  {
    "prefixo": "55770",
    "uf": "PE",
    "codigoIbge": 2616209,
    "cidade": "Vertentes"
  },
  {
    "prefixo": "55775",
    "uf": "PE",
    "codigoIbge": 2616209,
    "cidade": "Vertentes"
  },
  {
    "prefixo": "55776",
    "uf": "PE",
    "codigoIbge": 2616209,
    "cidade": "Vertentes"
  },
  {
    "prefixo": "55780",
    "uf": "PE",
    "codigoIbge": 2605806,
    "cidade": "Frei Miguelinho"
  },
  {
    "prefixo": "55790",
    "uf": "PE",
    "codigoIbge": 2615003,
    "cidade": "Taquaritinga do Norte"
  },
  {
    "prefixo": "55795",
    "uf": "PE",
    "codigoIbge": 2615003,
    "cidade": "Taquaritinga do Norte"
  },
  {
    "prefixo": "55798",
    "uf": "PE",
    "codigoIbge": 2615003,
    "cidade": "Taquaritinga do Norte"
  },
  {
    "prefixo": "55800",
    "uf": "PE",
    "codigoIbge": 2609501,
    "cidade": "Nazaré da Mata"
  },
  {
    "prefixo": "55805",
    "uf": "PE",
    "codigoIbge": 2615508,
    "cidade": "Tracunhaém"
  },
  {
    "prefixo": "55811",
    "uf": "PE",
    "codigoIbge": 2604007,
    "cidade": "Carpina"
  },
  {
    "prefixo": "55812",
    "uf": "PE",
    "codigoIbge": 2604007,
    "cidade": "Carpina"
  },
  {
    "prefixo": "55813",
    "uf": "PE",
    "codigoIbge": 2604007,
    "cidade": "Carpina"
  },
  {
    "prefixo": "55814",
    "uf": "PE",
    "codigoIbge": 2604007,
    "cidade": "Carpina"
  },
  {
    "prefixo": "55815",
    "uf": "PE",
    "codigoIbge": 2604007,
    "cidade": "Carpina"
  },
  {
    "prefixo": "55816",
    "uf": "PE",
    "codigoIbge": 2604007,
    "cidade": "Carpina"
  },
  {
    "prefixo": "55817",
    "uf": "PE",
    "codigoIbge": 2604007,
    "cidade": "Carpina"
  },
  {
    "prefixo": "55818",
    "uf": "PE",
    "codigoIbge": 2604007,
    "cidade": "Carpina"
  },
  {
    "prefixo": "55819",
    "uf": "PE",
    "codigoIbge": 2604007,
    "cidade": "Carpina"
  },
  {
    "prefixo": "55820",
    "uf": "PE",
    "codigoIbge": 2608453,
    "cidade": "Lagoa do Carro"
  },
  {
    "prefixo": "55825",
    "uf": "PE",
    "codigoIbge": 2610608,
    "cidade": "Paudalho"
  },
  {
    "prefixo": "55835",
    "uf": "PE",
    "codigoIbge": 2604403,
    "cidade": "Chã de Alegria"
  },
  {
    "prefixo": "55840",
    "uf": "PE",
    "codigoIbge": 2608503,
    "cidade": "Lagoa de Itaenga"
  },
  {
    "prefixo": "55845",
    "uf": "PE",
    "codigoIbge": 2602704,
    "cidade": "Buenos Aires"
  },
  {
    "prefixo": "55850",
    "uf": "PE",
    "codigoIbge": 2616308,
    "cidade": "Vicência"
  },
  {
    "prefixo": "55855",
    "uf": "PE",
    "codigoIbge": 2616308,
    "cidade": "Vicência"
  },
  {
    "prefixo": "55860",
    "uf": "PE",
    "codigoIbge": 2613800,
    "cidade": "São Vicente Férrer"
  },
  {
    "prefixo": "55863",
    "uf": "PE",
    "codigoIbge": 2613800,
    "cidade": "São Vicente Férrer"
  },
  {
    "prefixo": "55865",
    "uf": "PE",
    "codigoIbge": 2609006,
    "cidade": "Macaparana"
  },
  {
    "prefixo": "55870",
    "uf": "PE",
    "codigoIbge": 2615300,
    "cidade": "Timbaúba"
  },
  {
    "prefixo": "55875",
    "uf": "PE",
    "codigoIbge": 2615300,
    "cidade": "Timbaúba"
  },
  {
    "prefixo": "55878",
    "uf": "PE",
    "codigoIbge": 2615300,
    "cidade": "Timbaúba"
  },
  {
    "prefixo": "55880",
    "uf": "PE",
    "codigoIbge": 2605509,
    "cidade": "Ferreiros"
  },
  {
    "prefixo": "55890",
    "uf": "PE",
    "codigoIbge": 2600708,
    "cidade": "Aliança"
  },
  {
    "prefixo": "55895",
    "uf": "PE",
    "codigoIbge": 2600708,
    "cidade": "Aliança"
  },
  {
    "prefixo": "55896",
    "uf": "PE",
    "codigoIbge": 2600708,
    "cidade": "Aliança"
  },
  {
    "prefixo": "55898",
    "uf": "PE",
    "codigoIbge": 2600708,
    "cidade": "Aliança"
  },
  {
    "prefixo": "55900",
    "uf": "PE",
    "codigoIbge": 2606200,
    "cidade": "Goiana"
  },
  {
    "prefixo": "55901",
    "uf": "PE",
    "codigoIbge": 2606200,
    "cidade": "Goiana"
  },
  {
    "prefixo": "55905",
    "uf": "PE",
    "codigoIbge": 2606200,
    "cidade": "Goiana"
  },
  {
    "prefixo": "55908",
    "uf": "PE",
    "codigoIbge": 2606200,
    "cidade": "Goiana"
  },
  {
    "prefixo": "55909",
    "uf": "PE",
    "codigoIbge": 2606200,
    "cidade": "Goiana"
  },
  {
    "prefixo": "55920",
    "uf": "PE",
    "codigoIbge": 2607653,
    "cidade": "Itambé"
  },
  {
    "prefixo": "55928",
    "uf": "PE",
    "codigoIbge": 2607653,
    "cidade": "Itambé"
  },
  {
    "prefixo": "55929",
    "uf": "PE",
    "codigoIbge": 2607653,
    "cidade": "Itambé"
  },
  {
    "prefixo": "55930",
    "uf": "PE",
    "codigoIbge": 2603603,
    "cidade": "Camutanga"
  },
  {
    "prefixo": "55940",
    "uf": "PE",
    "codigoIbge": 2604601,
    "cidade": "Condado"
  },
  {
    "prefixo": "55950",
    "uf": "PE",
    "codigoIbge": 2607802,
    "cidade": "Itaquitinga"
  },
  {
    "prefixo": "56000",
    "uf": "PE",
    "codigoIbge": 2612208,
    "cidade": "Salgueiro"
  },
  {
    "prefixo": "56060",
    "uf": "PE",
    "codigoIbge": 2612208,
    "cidade": "Salgueiro"
  },
  {
    "prefixo": "56105",
    "uf": "PE",
    "codigoIbge": 2612208,
    "cidade": "Salgueiro"
  },
  {
    "prefixo": "56110",
    "uf": "PE",
    "codigoIbge": 2612208,
    "cidade": "Salgueiro"
  },
  {
    "prefixo": "56115",
    "uf": "PE",
    "codigoIbge": 2612208,
    "cidade": "Salgueiro"
  },
  {
    "prefixo": "56120",
    "uf": "PE",
    "codigoIbge": 2616100,
    "cidade": "Verdejante"
  },
  {
    "prefixo": "56125",
    "uf": "PE",
    "codigoIbge": 2616100,
    "cidade": "Verdejante"
  },
  {
    "prefixo": "56130",
    "uf": "PE",
    "codigoIbge": 2604304,
    "cidade": "Cedro"
  },
  {
    "prefixo": "56140",
    "uf": "PE",
    "codigoIbge": 2614006,
    "cidade": "Serrita"
  },
  {
    "prefixo": "56145",
    "uf": "PE",
    "codigoIbge": 2614006,
    "cidade": "Serrita"
  },
  {
    "prefixo": "56146",
    "uf": "PE",
    "codigoIbge": 2614006,
    "cidade": "Serrita"
  },
  {
    "prefixo": "56150",
    "uf": "PE",
    "codigoIbge": 2614303,
    "cidade": "Moreilândia"
  },
  {
    "prefixo": "56155",
    "uf": "PE",
    "codigoIbge": 2614303,
    "cidade": "Moreilândia"
  },
  {
    "prefixo": "56160",
    "uf": "PE",
    "codigoIbge": 2606309,
    "cidade": "Granito"
  },
  {
    "prefixo": "56163",
    "uf": "PE",
    "codigoIbge": 2610400,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "56165",
    "uf": "PE",
    "codigoIbge": 2610400,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "56168",
    "uf": "PE",
    "codigoIbge": 2610400,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "56170",
    "uf": "PE",
    "codigoIbge": 2609808,
    "cidade": "Orocó"
  },
  {
    "prefixo": "56180",
    "uf": "PE",
    "codigoIbge": 2603009,
    "cidade": "Cabrobó"
  },
  {
    "prefixo": "56190",
    "uf": "PE",
    "codigoIbge": 2615201,
    "cidade": "Terra Nova"
  },
  {
    "prefixo": "56200",
    "uf": "PE",
    "codigoIbge": 2609907,
    "cidade": "Ouricuri"
  },
  {
    "prefixo": "56203",
    "uf": "PE",
    "codigoIbge": 2609907,
    "cidade": "Ouricuri"
  },
  {
    "prefixo": "56205",
    "uf": "PE",
    "codigoIbge": 2609907,
    "cidade": "Ouricuri"
  },
  {
    "prefixo": "56210",
    "uf": "PE",
    "codigoIbge": 2612554,
    "cidade": "Santa Filomena"
  },
  {
    "prefixo": "56215",
    "uf": "PE",
    "codigoIbge": 2612455,
    "cidade": "Santa Cruz"
  },
  {
    "prefixo": "56220",
    "uf": "PE",
    "codigoIbge": 2602001,
    "cidade": "Bodocó"
  },
  {
    "prefixo": "56223",
    "uf": "PE",
    "codigoIbge": 2602001,
    "cidade": "Bodocó"
  },
  {
    "prefixo": "56227",
    "uf": "PE",
    "codigoIbge": 2602001,
    "cidade": "Bodocó"
  },
  {
    "prefixo": "56228",
    "uf": "PE",
    "codigoIbge": 2602001,
    "cidade": "Bodocó"
  },
  {
    "prefixo": "56230",
    "uf": "PE",
    "codigoIbge": 2605301,
    "cidade": "Exu"
  },
  {
    "prefixo": "56234",
    "uf": "PE",
    "codigoIbge": 2605301,
    "cidade": "Exu"
  },
  {
    "prefixo": "56236",
    "uf": "PE",
    "codigoIbge": 2605301,
    "cidade": "Exu"
  },
  {
    "prefixo": "56240",
    "uf": "PE",
    "codigoIbge": 2605301,
    "cidade": "Exu"
  },
  {
    "prefixo": "56245",
    "uf": "PE",
    "codigoIbge": 2605301,
    "cidade": "Exu"
  },
  {
    "prefixo": "56250",
    "uf": "PE",
    "codigoIbge": 2615607,
    "cidade": "Trindade"
  },
  {
    "prefixo": "56260",
    "uf": "PE",
    "codigoIbge": 2607307,
    "cidade": "Ipubi"
  },
  {
    "prefixo": "56265",
    "uf": "PE",
    "codigoIbge": 2607307,
    "cidade": "Ipubi"
  },
  {
    "prefixo": "56280",
    "uf": "PE",
    "codigoIbge": 2601102,
    "cidade": "Araripina"
  },
  {
    "prefixo": "56282",
    "uf": "PE",
    "codigoIbge": 2601102,
    "cidade": "Araripina"
  },
  {
    "prefixo": "56284",
    "uf": "PE",
    "codigoIbge": 2601102,
    "cidade": "Araripina"
  },
  {
    "prefixo": "56285",
    "uf": "PE",
    "codigoIbge": 2601102,
    "cidade": "Araripina"
  },
  {
    "prefixo": "56287",
    "uf": "PE",
    "codigoIbge": 2601102,
    "cidade": "Araripina"
  },
  {
    "prefixo": "56300",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56301",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56302",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56303",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56304",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56306",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56307",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56308",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56309",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56310",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56312",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56313",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56314",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56315",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56316",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56317",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56318",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56319",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56320",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56321",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56322",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56323",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56324",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56325",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56326",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56327",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56328",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56330",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56331",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56332",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56333",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56334",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56335",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56337",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56339",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56340",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56343",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56345",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56346",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56347",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56350",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56353",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56354",
    "uf": "PE",
    "codigoIbge": 2611101,
    "cidade": "Petrolina"
  },
  {
    "prefixo": "56355",
    "uf": "PE",
    "codigoIbge": 2605152,
    "cidade": "Dormentes"
  },
  {
    "prefixo": "56360",
    "uf": "PE",
    "codigoIbge": 2600203,
    "cidade": "Afrânio"
  },
  {
    "prefixo": "56380",
    "uf": "PE",
    "codigoIbge": 2612604,
    "cidade": "Santa Maria da Boa Vista"
  },
  {
    "prefixo": "56386",
    "uf": "PE",
    "codigoIbge": 2612604,
    "cidade": "Santa Maria da Boa Vista"
  },
  {
    "prefixo": "56395",
    "uf": "PE",
    "codigoIbge": 2608750,
    "cidade": "Lagoa Grande"
  },
  {
    "prefixo": "56396",
    "uf": "PE",
    "codigoIbge": 2608750,
    "cidade": "Lagoa Grande"
  },
  {
    "prefixo": "56400",
    "uf": "PE",
    "codigoIbge": 2605707,
    "cidade": "Floresta"
  },
  {
    "prefixo": "56410",
    "uf": "PE",
    "codigoIbge": 2605707,
    "cidade": "Floresta"
  },
  {
    "prefixo": "56420",
    "uf": "PE",
    "codigoIbge": 2603926,
    "cidade": "Carnaubeira da Penha"
  },
  {
    "prefixo": "56430",
    "uf": "PE",
    "codigoIbge": 2607406,
    "cidade": "Itacuruba"
  },
  {
    "prefixo": "56440",
    "uf": "PE",
    "codigoIbge": 2601607,
    "cidade": "Belém do São Francisco"
  },
  {
    "prefixo": "56445",
    "uf": "PE",
    "codigoIbge": 2601607,
    "cidade": "Belém do São Francisco"
  },
  {
    "prefixo": "56450",
    "uf": "PE",
    "codigoIbge": 2601607,
    "cidade": "Belém do São Francisco"
  },
  {
    "prefixo": "56460",
    "uf": "PE",
    "codigoIbge": 2611002,
    "cidade": "Petrolândia"
  },
  {
    "prefixo": "56470",
    "uf": "PE",
    "codigoIbge": 2608057,
    "cidade": "Jatobá"
  },
  {
    "prefixo": "56475",
    "uf": "PE",
    "codigoIbge": 2608057,
    "cidade": "Jatobá"
  },
  {
    "prefixo": "56480",
    "uf": "PE",
    "codigoIbge": 2614808,
    "cidade": "Tacaratu"
  },
  {
    "prefixo": "56485",
    "uf": "PE",
    "codigoIbge": 2614808,
    "cidade": "Tacaratu"
  },
  {
    "prefixo": "56501",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56502",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56503",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56504",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56505",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56506",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56507",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56508",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56509",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56510",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56511",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56512",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56513",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56515",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56516",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56517",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56518",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56519",
    "uf": "PE",
    "codigoIbge": 2601201,
    "cidade": "Arcoverde"
  },
  {
    "prefixo": "56520",
    "uf": "PE",
    "codigoIbge": 2602803,
    "cidade": "Buíque"
  },
  {
    "prefixo": "56526",
    "uf": "PE",
    "codigoIbge": 2607307,
    "cidade": "Ipubi"
  },
  {
    "prefixo": "56533",
    "uf": "PE",
    "codigoIbge": 2602803,
    "cidade": "Buíque"
  },
  {
    "prefixo": "56535",
    "uf": "PE",
    "codigoIbge": 2602803,
    "cidade": "Buíque"
  },
  {
    "prefixo": "56537",
    "uf": "PE",
    "codigoIbge": 2602803,
    "cidade": "Buíque"
  },
  {
    "prefixo": "56540",
    "uf": "PE",
    "codigoIbge": 2615805,
    "cidade": "Tupanatinga"
  },
  {
    "prefixo": "56550",
    "uf": "PE",
    "codigoIbge": 2607505,
    "cidade": "Itaíba"
  },
  {
    "prefixo": "56555",
    "uf": "PE",
    "codigoIbge": 2607505,
    "cidade": "Itaíba"
  },
  {
    "prefixo": "56557",
    "uf": "PE",
    "codigoIbge": 2607505,
    "cidade": "Itaíba"
  },
  {
    "prefixo": "56560",
    "uf": "PE",
    "codigoIbge": 2607000,
    "cidade": "Inajá"
  },
  {
    "prefixo": "56565",
    "uf": "PE",
    "codigoIbge": 2609154,
    "cidade": "Manari"
  },
  {
    "prefixo": "56580",
    "uf": "PE",
    "codigoIbge": 2606606,
    "cidade": "Ibimirim"
  },
  {
    "prefixo": "56585",
    "uf": "PE",
    "codigoIbge": 2606606,
    "cidade": "Ibimirim"
  },
  {
    "prefixo": "56600",
    "uf": "PE",
    "codigoIbge": 2614105,
    "cidade": "Sertânia"
  },
  {
    "prefixo": "56615",
    "uf": "PE",
    "codigoIbge": 2614105,
    "cidade": "Sertânia"
  },
  {
    "prefixo": "56620",
    "uf": "PE",
    "codigoIbge": 2614105,
    "cidade": "Sertânia"
  },
  {
    "prefixo": "56625",
    "uf": "PE",
    "codigoIbge": 2614105,
    "cidade": "Sertânia"
  },
  {
    "prefixo": "56626",
    "uf": "PE",
    "codigoIbge": 2614105,
    "cidade": "Sertânia"
  },
  {
    "prefixo": "56627",
    "uf": "PE",
    "codigoIbge": 2614105,
    "cidade": "Sertânia"
  },
  {
    "prefixo": "56640",
    "uf": "PE",
    "codigoIbge": 2605103,
    "cidade": "Custódia"
  },
  {
    "prefixo": "56650",
    "uf": "PE",
    "codigoIbge": 2605103,
    "cidade": "Custódia"
  },
  {
    "prefixo": "56660",
    "uf": "PE",
    "codigoIbge": 2605103,
    "cidade": "Custódia"
  },
  {
    "prefixo": "56670",
    "uf": "PE",
    "codigoIbge": 2601805,
    "cidade": "Betânia"
  },
  {
    "prefixo": "56680",
    "uf": "PE",
    "codigoIbge": 2601805,
    "cidade": "Betânia"
  },
  {
    "prefixo": "56700",
    "uf": "PE",
    "codigoIbge": 2613602,
    "cidade": "São José do Egito"
  },
  {
    "prefixo": "56705",
    "uf": "PE",
    "codigoIbge": 2613602,
    "cidade": "São José do Egito"
  },
  {
    "prefixo": "56720",
    "uf": "PE",
    "codigoIbge": 2607703,
    "cidade": "Itapetim"
  },
  {
    "prefixo": "56730",
    "uf": "PE",
    "codigoIbge": 2607703,
    "cidade": "Itapetim"
  },
  {
    "prefixo": "56740",
    "uf": "PE",
    "codigoIbge": 2602506,
    "cidade": "Brejinho"
  },
  {
    "prefixo": "56750",
    "uf": "PE",
    "codigoIbge": 2612802,
    "cidade": "Santa Terezinha"
  },
  {
    "prefixo": "56760",
    "uf": "PE",
    "codigoIbge": 2615904,
    "cidade": "Tuparetama"
  },
  {
    "prefixo": "56780",
    "uf": "PE",
    "codigoIbge": 2614600,
    "cidade": "Tabira"
  },
  {
    "prefixo": "56795",
    "uf": "PE",
    "codigoIbge": 2614402,
    "cidade": "Solidão"
  },
  {
    "prefixo": "56800",
    "uf": "PE",
    "codigoIbge": 2600104,
    "cidade": "Afogados da Ingazeira"
  },
  {
    "prefixo": "56820",
    "uf": "PE",
    "codigoIbge": 2603900,
    "cidade": "Carnaíba"
  },
  {
    "prefixo": "56825",
    "uf": "PE",
    "codigoIbge": 2603900,
    "cidade": "Carnaíba"
  },
  {
    "prefixo": "56828",
    "uf": "PE",
    "codigoIbge": 2611533,
    "cidade": "Quixaba"
  },
  {
    "prefixo": "56830",
    "uf": "PE",
    "codigoIbge": 2607109,
    "cidade": "Ingazeira"
  },
  {
    "prefixo": "56840",
    "uf": "PE",
    "codigoIbge": 2606903,
    "cidade": "Iguaracy"
  },
  {
    "prefixo": "56845",
    "uf": "PE",
    "codigoIbge": 2606903,
    "cidade": "Iguaracy"
  },
  {
    "prefixo": "56848",
    "uf": "PE",
    "codigoIbge": 2606903,
    "cidade": "Iguaracy"
  },
  {
    "prefixo": "56850",
    "uf": "PE",
    "codigoIbge": 2605608,
    "cidade": "Flores"
  },
  {
    "prefixo": "56860",
    "uf": "PE",
    "codigoIbge": 2605608,
    "cidade": "Flores"
  },
  {
    "prefixo": "56870",
    "uf": "PE",
    "codigoIbge": 2615706,
    "cidade": "Triunfo"
  },
  {
    "prefixo": "56880",
    "uf": "PE",
    "codigoIbge": 2615706,
    "cidade": "Triunfo"
  },
  {
    "prefixo": "56885",
    "uf": "PE",
    "codigoIbge": 2615706,
    "cidade": "Triunfo"
  },
  {
    "prefixo": "56890",
    "uf": "PE",
    "codigoIbge": 2615706,
    "cidade": "Triunfo"
  },
  {
    "prefixo": "56895",
    "uf": "PE",
    "codigoIbge": 2612471,
    "cidade": "Santa Cruz da Baixa Verde"
  },
  {
    "prefixo": "56903",
    "uf": "PE",
    "codigoIbge": 2613909,
    "cidade": "Serra Talhada"
  },
  {
    "prefixo": "56904",
    "uf": "PE",
    "codigoIbge": 2613909,
    "cidade": "Serra Talhada"
  },
  {
    "prefixo": "56906",
    "uf": "PE",
    "codigoIbge": 2613909,
    "cidade": "Serra Talhada"
  },
  {
    "prefixo": "56907",
    "uf": "PE",
    "codigoIbge": 2613909,
    "cidade": "Serra Talhada"
  },
  {
    "prefixo": "56909",
    "uf": "PE",
    "codigoIbge": 2613909,
    "cidade": "Serra Talhada"
  },
  {
    "prefixo": "56912",
    "uf": "PE",
    "codigoIbge": 2613909,
    "cidade": "Serra Talhada"
  },
  {
    "prefixo": "56915",
    "uf": "PE",
    "codigoIbge": 2613909,
    "cidade": "Serra Talhada"
  },
  {
    "prefixo": "56916",
    "uf": "PE",
    "codigoIbge": 2613909,
    "cidade": "Serra Talhada"
  },
  {
    "prefixo": "56918",
    "uf": "PE",
    "codigoIbge": 2613909,
    "cidade": "Serra Talhada"
  },
  {
    "prefixo": "56920",
    "uf": "PE",
    "codigoIbge": 2613909,
    "cidade": "Serra Talhada"
  },
  {
    "prefixo": "56921",
    "uf": "PE",
    "codigoIbge": 2613909,
    "cidade": "Serra Talhada"
  },
  {
    "prefixo": "56922",
    "uf": "PE",
    "codigoIbge": 2613909,
    "cidade": "Serra Talhada"
  },
  {
    "prefixo": "56923",
    "uf": "PE",
    "codigoIbge": 2613909,
    "cidade": "Serra Talhada"
  },
  {
    "prefixo": "56924",
    "uf": "PE",
    "codigoIbge": 2613909,
    "cidade": "Serra Talhada"
  },
  {
    "prefixo": "56925",
    "uf": "PE",
    "codigoIbge": 2613909,
    "cidade": "Serra Talhada"
  },
  {
    "prefixo": "56930",
    "uf": "PE",
    "codigoIbge": 2603405,
    "cidade": "Calumbi"
  },
  {
    "prefixo": "56950",
    "uf": "PE",
    "codigoIbge": 2613503,
    "cidade": "São José do Belmonte"
  },
  {
    "prefixo": "56970",
    "uf": "PE",
    "codigoIbge": 2613503,
    "cidade": "São José do Belmonte"
  },
  {
    "prefixo": "56980",
    "uf": "PE",
    "codigoIbge": 2609303,
    "cidade": "Mirandiba"
  },
  {
    "prefixo": "56990",
    "uf": "PE",
    "codigoIbge": 2609303,
    "cidade": "Mirandiba"
  },
  {
    "prefixo": "57010",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57014",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57015",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57017",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57018",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57020",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57022",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57025",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57030",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57032",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57035",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57036",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57037",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57038",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57039",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57040",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57041",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57042",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57043",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57044",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57045",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57046",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57048",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57050",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57051",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57052",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57055",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57057",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57060",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57061",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57062",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57063",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57070",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57071",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57072",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57073",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57074",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57075",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57080",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57081",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57082",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57083",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57084",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57085",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57086",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57099",
    "uf": "AL",
    "codigoIbge": 2704302,
    "cidade": "Maceió"
  },
  {
    "prefixo": "57100",
    "uf": "AL",
    "codigoIbge": 2707701,
    "cidade": "Rio Largo"
  },
  {
    "prefixo": "57120",
    "uf": "AL",
    "codigoIbge": 2708907,
    "cidade": "Satuba"
  },
  {
    "prefixo": "57130",
    "uf": "AL",
    "codigoIbge": 2707909,
    "cidade": "Santa Luzia do Norte"
  },
  {
    "prefixo": "57140",
    "uf": "AL",
    "codigoIbge": 2702207,
    "cidade": "Coqueiro Seco"
  },
  {
    "prefixo": "57150",
    "uf": "AL",
    "codigoIbge": 2706901,
    "cidade": "Pilar"
  },
  {
    "prefixo": "57160",
    "uf": "AL",
    "codigoIbge": 2704708,
    "cidade": "Marechal Deodoro"
  },
  {
    "prefixo": "57180",
    "uf": "AL",
    "codigoIbge": 2700607,
    "cidade": "Barra de São Miguel"
  },
  {
    "prefixo": "57200",
    "uf": "AL",
    "codigoIbge": 2706703,
    "cidade": "Penedo"
  },
  {
    "prefixo": "57210",
    "uf": "AL",
    "codigoIbge": 2706802,
    "cidade": "Piaçabuçu"
  },
  {
    "prefixo": "57220",
    "uf": "AL",
    "codigoIbge": 2702702,
    "cidade": "Feliz Deserto"
  },
  {
    "prefixo": "57230",
    "uf": "AL",
    "codigoIbge": 2702306,
    "cidade": "Coruripe"
  },
  {
    "prefixo": "57235",
    "uf": "AL",
    "codigoIbge": 2702306,
    "cidade": "Coruripe"
  },
  {
    "prefixo": "57236",
    "uf": "AL",
    "codigoIbge": 2702306,
    "cidade": "Coruripe"
  },
  {
    "prefixo": "57240",
    "uf": "AL",
    "codigoIbge": 2708600,
    "cidade": "São Miguel dos Campos"
  },
  {
    "prefixo": "57241",
    "uf": "AL",
    "codigoIbge": 2708600,
    "cidade": "São Miguel dos Campos"
  },
  {
    "prefixo": "57242",
    "uf": "AL",
    "codigoIbge": 2708600,
    "cidade": "São Miguel dos Campos"
  },
  {
    "prefixo": "57245",
    "uf": "AL",
    "codigoIbge": 2708600,
    "cidade": "São Miguel dos Campos"
  },
  {
    "prefixo": "57246",
    "uf": "AL",
    "codigoIbge": 2708600,
    "cidade": "São Miguel dos Campos"
  },
  {
    "prefixo": "57249",
    "uf": "AL",
    "codigoIbge": 2708600,
    "cidade": "São Miguel dos Campos"
  },
  {
    "prefixo": "57250",
    "uf": "AL",
    "codigoIbge": 2701407,
    "cidade": "Campo Alegre"
  },
  {
    "prefixo": "57251",
    "uf": "AL",
    "codigoIbge": 2701407,
    "cidade": "Campo Alegre"
  },
  {
    "prefixo": "57252",
    "uf": "AL",
    "codigoIbge": 2701407,
    "cidade": "Campo Alegre"
  },
  {
    "prefixo": "57253",
    "uf": "AL",
    "codigoIbge": 2701407,
    "cidade": "Campo Alegre"
  },
  {
    "prefixo": "57254",
    "uf": "AL",
    "codigoIbge": 2701407,
    "cidade": "Campo Alegre"
  },
  {
    "prefixo": "57255",
    "uf": "AL",
    "codigoIbge": 2703759,
    "cidade": "Jequiá da Praia"
  },
  {
    "prefixo": "57257",
    "uf": "AL",
    "codigoIbge": 2707800,
    "cidade": "Roteiro"
  },
  {
    "prefixo": "57260",
    "uf": "AL",
    "codigoIbge": 2704203,
    "cidade": "Limoeiro de Anadia"
  },
  {
    "prefixo": "57265",
    "uf": "AL",
    "codigoIbge": 2709152,
    "cidade": "Teotônio Vilela"
  },
  {
    "prefixo": "57266",
    "uf": "AL",
    "codigoIbge": 2709152,
    "cidade": "Teotônio Vilela"
  },
  {
    "prefixo": "57267",
    "uf": "AL",
    "codigoIbge": 2709152,
    "cidade": "Teotônio Vilela"
  },
  {
    "prefixo": "57268",
    "uf": "AL",
    "codigoIbge": 2709152,
    "cidade": "Teotônio Vilela"
  },
  {
    "prefixo": "57269",
    "uf": "AL",
    "codigoIbge": 2709152,
    "cidade": "Teotônio Vilela"
  },
  {
    "prefixo": "57270",
    "uf": "AL",
    "codigoIbge": 2704005,
    "cidade": "Junqueiro"
  },
  {
    "prefixo": "57272",
    "uf": "AL",
    "codigoIbge": 2704005,
    "cidade": "Junqueiro"
  },
  {
    "prefixo": "57275",
    "uf": "AL",
    "codigoIbge": 2708808,
    "cidade": "São Sebastião"
  },
  {
    "prefixo": "57280",
    "uf": "AL",
    "codigoIbge": 2703205,
    "cidade": "Igreja Nova"
  },
  {
    "prefixo": "57290",
    "uf": "AL",
    "codigoIbge": 2707503,
    "cidade": "Porto Real do Colégio"
  },
  {
    "prefixo": "57300",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57301",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57302",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57303",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57304",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57305",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57306",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57307",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57308",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57309",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57310",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57311",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57312",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57313",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57314",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57315",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57316",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57317",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57318",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57319",
    "uf": "AL",
    "codigoIbge": 2700300,
    "cidade": "Arapiraca"
  },
  {
    "prefixo": "57320",
    "uf": "AL",
    "codigoIbge": 2702355,
    "cidade": "Craíbas"
  },
  {
    "prefixo": "57325",
    "uf": "AL",
    "codigoIbge": 2702009,
    "cidade": "Coité do Nóia"
  },
  {
    "prefixo": "57330",
    "uf": "AL",
    "codigoIbge": 2704104,
    "cidade": "Lagoa da Canoa"
  },
  {
    "prefixo": "57340",
    "uf": "AL",
    "codigoIbge": 2702603,
    "cidade": "Feira Grande"
  },
  {
    "prefixo": "57350",
    "uf": "AL",
    "codigoIbge": 2701506,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "57360",
    "uf": "AL",
    "codigoIbge": 2702900,
    "cidade": "Girau do Ponciano"
  },
  {
    "prefixo": "57370",
    "uf": "AL",
    "codigoIbge": 2709202,
    "cidade": "Traipu"
  },
  {
    "prefixo": "57380",
    "uf": "AL",
    "codigoIbge": 2708204,
    "cidade": "São Brás"
  },
  {
    "prefixo": "57390",
    "uf": "AL",
    "codigoIbge": 2705903,
    "cidade": "Olho d'Água Grande"
  },
  {
    "prefixo": "57400",
    "uf": "AL",
    "codigoIbge": 2706406,
    "cidade": "Pão de Açúcar"
  },
  {
    "prefixo": "57405",
    "uf": "AL",
    "codigoIbge": 2706406,
    "cidade": "Pão de Açúcar"
  },
  {
    "prefixo": "57410",
    "uf": "AL",
    "codigoIbge": 2706208,
    "cidade": "Palestina"
  },
  {
    "prefixo": "57420",
    "uf": "AL",
    "codigoIbge": 2700706,
    "cidade": "Batalha"
  },
  {
    "prefixo": "57425",
    "uf": "AL",
    "codigoIbge": 2703700,
    "cidade": "Jaramataia"
  },
  {
    "prefixo": "57430",
    "uf": "AL",
    "codigoIbge": 2703403,
    "cidade": "Jacaré dos Homens"
  },
  {
    "prefixo": "57435",
    "uf": "AL",
    "codigoIbge": 2700904,
    "cidade": "Belo Monte"
  },
  {
    "prefixo": "57440",
    "uf": "AL",
    "codigoIbge": 2705408,
    "cidade": "Monteirópolis"
  },
  {
    "prefixo": "57442",
    "uf": "AL",
    "codigoIbge": 2705705,
    "cidade": "Olho d'Água das Flores"
  },
  {
    "prefixo": "57445",
    "uf": "AL",
    "codigoIbge": 2708402,
    "cidade": "São José da Tapera"
  },
  {
    "prefixo": "57460",
    "uf": "AL",
    "codigoIbge": 2707107,
    "cidade": "Piranhas"
  },
  {
    "prefixo": "57462",
    "uf": "AL",
    "codigoIbge": 2707107,
    "cidade": "Piranhas"
  },
  {
    "prefixo": "57465",
    "uf": "AL",
    "codigoIbge": 2707107,
    "cidade": "Piranhas"
  },
  {
    "prefixo": "57466",
    "uf": "AL",
    "codigoIbge": 2707107,
    "cidade": "Piranhas"
  },
  {
    "prefixo": "57467",
    "uf": "AL",
    "codigoIbge": 2707107,
    "cidade": "Piranhas"
  },
  {
    "prefixo": "57470",
    "uf": "AL",
    "codigoIbge": 2705804,
    "cidade": "Olho d'Água do Casado"
  },
  {
    "prefixo": "57475",
    "uf": "AL",
    "codigoIbge": 2706422,
    "cidade": "Pariconha"
  },
  {
    "prefixo": "57480",
    "uf": "AL",
    "codigoIbge": 2702405,
    "cidade": "Delmiro Gouveia"
  },
  {
    "prefixo": "57490",
    "uf": "AL",
    "codigoIbge": 2700102,
    "cidade": "Água Branca"
  },
  {
    "prefixo": "57500",
    "uf": "AL",
    "codigoIbge": 2708006,
    "cidade": "Santana do Ipanema"
  },
  {
    "prefixo": "57510",
    "uf": "AL",
    "codigoIbge": 2707206,
    "cidade": "Poço das Trincheiras"
  },
  {
    "prefixo": "57515",
    "uf": "AL",
    "codigoIbge": 2708956,
    "cidade": "Senador Rui Palmeira"
  },
  {
    "prefixo": "57520",
    "uf": "AL",
    "codigoIbge": 2704609,
    "cidade": "Maravilha"
  },
  {
    "prefixo": "57525",
    "uf": "AL",
    "codigoIbge": 2706109,
    "cidade": "Ouro Branco"
  },
  {
    "prefixo": "57530",
    "uf": "AL",
    "codigoIbge": 2701605,
    "cidade": "Canapi"
  },
  {
    "prefixo": "57535",
    "uf": "AL",
    "codigoIbge": 2701803,
    "cidade": "Carneiros"
  },
  {
    "prefixo": "57540",
    "uf": "AL",
    "codigoIbge": 2705002,
    "cidade": "Mata Grande"
  },
  {
    "prefixo": "57545",
    "uf": "AL",
    "codigoIbge": 2703304,
    "cidade": "Inhapi"
  },
  {
    "prefixo": "57550",
    "uf": "AL",
    "codigoIbge": 2706000,
    "cidade": "Olivença"
  },
  {
    "prefixo": "57560",
    "uf": "AL",
    "codigoIbge": 2702504,
    "cidade": "Dois Riachos"
  },
  {
    "prefixo": "57570",
    "uf": "AL",
    "codigoIbge": 2701209,
    "cidade": "Cacimbinhas"
  },
  {
    "prefixo": "57580",
    "uf": "AL",
    "codigoIbge": 2704401,
    "cidade": "Major Isidoro"
  },
  {
    "prefixo": "57585",
    "uf": "AL",
    "codigoIbge": 2704401,
    "cidade": "Major Isidoro"
  },
  {
    "prefixo": "57600",
    "uf": "AL",
    "codigoIbge": 2706307,
    "cidade": "Palmeira dos Índios"
  },
  {
    "prefixo": "57601",
    "uf": "AL",
    "codigoIbge": 2706307,
    "cidade": "Palmeira dos Índios"
  },
  {
    "prefixo": "57602",
    "uf": "AL",
    "codigoIbge": 2706307,
    "cidade": "Palmeira dos Índios"
  },
  {
    "prefixo": "57603",
    "uf": "AL",
    "codigoIbge": 2706307,
    "cidade": "Palmeira dos Índios"
  },
  {
    "prefixo": "57604",
    "uf": "AL",
    "codigoIbge": 2706307,
    "cidade": "Palmeira dos Índios"
  },
  {
    "prefixo": "57605",
    "uf": "AL",
    "codigoIbge": 2706307,
    "cidade": "Palmeira dos Índios"
  },
  {
    "prefixo": "57606",
    "uf": "AL",
    "codigoIbge": 2706307,
    "cidade": "Palmeira dos Índios"
  },
  {
    "prefixo": "57607",
    "uf": "AL",
    "codigoIbge": 2706307,
    "cidade": "Palmeira dos Índios"
  },
  {
    "prefixo": "57608",
    "uf": "AL",
    "codigoIbge": 2706307,
    "cidade": "Palmeira dos Índios"
  },
  {
    "prefixo": "57609",
    "uf": "AL",
    "codigoIbge": 2706307,
    "cidade": "Palmeira dos Índios"
  },
  {
    "prefixo": "57610",
    "uf": "AL",
    "codigoIbge": 2706307,
    "cidade": "Palmeira dos Índios"
  },
  {
    "prefixo": "57611",
    "uf": "AL",
    "codigoIbge": 2706307,
    "cidade": "Palmeira dos Índios"
  },
  {
    "prefixo": "57612",
    "uf": "AL",
    "codigoIbge": 2706307,
    "cidade": "Palmeira dos Índios"
  },
  {
    "prefixo": "57613",
    "uf": "AL",
    "codigoIbge": 2706307,
    "cidade": "Palmeira dos Índios"
  },
  {
    "prefixo": "57615",
    "uf": "AL",
    "codigoIbge": 2705309,
    "cidade": "Minador do Negrão"
  },
  {
    "prefixo": "57620",
    "uf": "AL",
    "codigoIbge": 2703106,
    "cidade": "Igaci"
  },
  {
    "prefixo": "57625",
    "uf": "AL",
    "codigoIbge": 2702553,
    "cidade": "Estrela de Alagoas"
  },
  {
    "prefixo": "57630",
    "uf": "AL",
    "codigoIbge": 2700805,
    "cidade": "Belém"
  },
  {
    "prefixo": "57635",
    "uf": "AL",
    "codigoIbge": 2709004,
    "cidade": "Tanque d'Arca"
  },
  {
    "prefixo": "57640",
    "uf": "AL",
    "codigoIbge": 2709103,
    "cidade": "Taquarana"
  },
  {
    "prefixo": "57658",
    "uf": "AL",
    "codigoIbge": 2709103,
    "cidade": "Taquarana"
  },
  {
    "prefixo": "57660",
    "uf": "AL",
    "codigoIbge": 2700201,
    "cidade": "Anadia"
  },
  {
    "prefixo": "57670",
    "uf": "AL",
    "codigoIbge": 2704807,
    "cidade": "Maribondo"
  },
  {
    "prefixo": "57680",
    "uf": "AL",
    "codigoIbge": 2701001,
    "cidade": "Boca da Mata"
  },
  {
    "prefixo": "57690",
    "uf": "AL",
    "codigoIbge": 2700409,
    "cidade": "Atalaia"
  },
  {
    "prefixo": "57693",
    "uf": "AL",
    "codigoIbge": 2700409,
    "cidade": "Atalaia"
  },
  {
    "prefixo": "57700",
    "uf": "AL",
    "codigoIbge": 2709400,
    "cidade": "Viçosa"
  },
  {
    "prefixo": "57710",
    "uf": "AL",
    "codigoIbge": 2709400,
    "cidade": "Viçosa"
  },
  {
    "prefixo": "57720",
    "uf": "AL",
    "codigoIbge": 2707008,
    "cidade": "Pindoba"
  },
  {
    "prefixo": "57730",
    "uf": "AL",
    "codigoIbge": 2704906,
    "cidade": "Mar Vermelho"
  },
  {
    "prefixo": "57740",
    "uf": "AL",
    "codigoIbge": 2706604,
    "cidade": "Paulo Jacinto"
  },
  {
    "prefixo": "57750",
    "uf": "AL",
    "codigoIbge": 2707602,
    "cidade": "Quebrangulo"
  },
  {
    "prefixo": "57760",
    "uf": "AL",
    "codigoIbge": 2701902,
    "cidade": "Chã Preta"
  },
  {
    "prefixo": "57770",
    "uf": "AL",
    "codigoIbge": 2701308,
    "cidade": "Cajueiro"
  },
  {
    "prefixo": "57780",
    "uf": "AL",
    "codigoIbge": 2701704,
    "cidade": "Capela"
  },
  {
    "prefixo": "57800",
    "uf": "AL",
    "codigoIbge": 2709301,
    "cidade": "União dos Palmares"
  },
  {
    "prefixo": "57810",
    "uf": "AL",
    "codigoIbge": 2709301,
    "cidade": "União dos Palmares"
  },
  {
    "prefixo": "57820",
    "uf": "AL",
    "codigoIbge": 2705507,
    "cidade": "Murici"
  },
  {
    "prefixo": "57830",
    "uf": "AL",
    "codigoIbge": 2701100,
    "cidade": "Branquinha"
  },
  {
    "prefixo": "57840",
    "uf": "AL",
    "codigoIbge": 2708105,
    "cidade": "Santana do Mundaú"
  },
  {
    "prefixo": "57850",
    "uf": "AL",
    "codigoIbge": 2708105,
    "cidade": "Santana do Mundaú"
  },
  {
    "prefixo": "57860",
    "uf": "AL",
    "codigoIbge": 2708303,
    "cidade": "São José da Laje"
  },
  {
    "prefixo": "57890",
    "uf": "AL",
    "codigoIbge": 2703007,
    "cidade": "Ibateguara"
  },
  {
    "prefixo": "57895",
    "uf": "AL",
    "codigoIbge": 2703007,
    "cidade": "Ibateguara"
  },
  {
    "prefixo": "57900",
    "uf": "AL",
    "codigoIbge": 2707305,
    "cidade": "Porto Calvo"
  },
  {
    "prefixo": "57910",
    "uf": "AL",
    "codigoIbge": 2705101,
    "cidade": "Matriz de Camaragibe"
  },
  {
    "prefixo": "57920",
    "uf": "AL",
    "codigoIbge": 2708501,
    "cidade": "São Luís do Quitunde"
  },
  {
    "prefixo": "57925",
    "uf": "AL",
    "codigoIbge": 2700508,
    "cidade": "Barra de Santo Antônio"
  },
  {
    "prefixo": "57930",
    "uf": "AL",
    "codigoIbge": 2706505,
    "cidade": "Passo de Camaragibe"
  },
  {
    "prefixo": "57935",
    "uf": "AL",
    "codigoIbge": 2706448,
    "cidade": "Paripueira"
  },
  {
    "prefixo": "57940",
    "uf": "AL",
    "codigoIbge": 2708709,
    "cidade": "São Miguel dos Milagres"
  },
  {
    "prefixo": "57945",
    "uf": "AL",
    "codigoIbge": 2707404,
    "cidade": "Porto de Pedras"
  },
  {
    "prefixo": "57950",
    "uf": "AL",
    "codigoIbge": 2703601,
    "cidade": "Japaratinga"
  },
  {
    "prefixo": "57955",
    "uf": "AL",
    "codigoIbge": 2704500,
    "cidade": "Maragogi"
  },
  {
    "prefixo": "57958",
    "uf": "AL",
    "codigoIbge": 2704500,
    "cidade": "Maragogi"
  },
  {
    "prefixo": "57960",
    "uf": "AL",
    "codigoIbge": 2703502,
    "cidade": "Jacuípe"
  },
  {
    "prefixo": "57965",
    "uf": "AL",
    "codigoIbge": 2703908,
    "cidade": "Jundiá"
  },
  {
    "prefixo": "57968",
    "uf": "AL",
    "codigoIbge": 2701357,
    "cidade": "Campestre"
  },
  {
    "prefixo": "57970",
    "uf": "AL",
    "codigoIbge": 2705606,
    "cidade": "Novo Lino"
  },
  {
    "prefixo": "57975",
    "uf": "AL",
    "codigoIbge": 2702108,
    "cidade": "Colônia Leopoldina"
  },
  {
    "prefixo": "57980",
    "uf": "AL",
    "codigoIbge": 2703809,
    "cidade": "Joaquim Gomes"
  },
  {
    "prefixo": "57990",
    "uf": "AL",
    "codigoIbge": 2705200,
    "cidade": "Messias"
  },
  {
    "prefixo": "57995",
    "uf": "AL",
    "codigoIbge": 2702801,
    "cidade": "Flexeiras"
  },
  {
    "prefixo": "58010",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58011",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58013",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58015",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58020",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58025",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58026",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58027",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58028",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58030",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58031",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58032",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58033",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58034",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58035",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58036",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58037",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58038",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58039",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58040",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58041",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58042",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58043",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58045",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58046",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58047",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58048",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58050",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58051",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58052",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58053",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58055",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58056",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58057",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58058",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58059",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58060",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58062",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58063",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58064",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58065",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58066",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58067",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58068",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58069",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58070",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58071",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58073",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58074",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58075",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58076",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58077",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58078",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58079",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58080",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58081",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58082",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58083",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58084",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58085",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58086",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58087",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58088",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58090",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58091",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58095",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58099",
    "uf": "PB",
    "codigoIbge": 2507507,
    "cidade": "João Pessoa"
  },
  {
    "prefixo": "58100",
    "uf": "PB",
    "codigoIbge": 2503209,
    "cidade": "Cabedelo"
  },
  {
    "prefixo": "58101",
    "uf": "PB",
    "codigoIbge": 2503209,
    "cidade": "Cabedelo"
  },
  {
    "prefixo": "58102",
    "uf": "PB",
    "codigoIbge": 2503209,
    "cidade": "Cabedelo"
  },
  {
    "prefixo": "58103",
    "uf": "PB",
    "codigoIbge": 2503209,
    "cidade": "Cabedelo"
  },
  {
    "prefixo": "58105",
    "uf": "PB",
    "codigoIbge": 2503209,
    "cidade": "Cabedelo"
  },
  {
    "prefixo": "58106",
    "uf": "PB",
    "codigoIbge": 2503209,
    "cidade": "Cabedelo"
  },
  {
    "prefixo": "58108",
    "uf": "PB",
    "codigoIbge": 2503209,
    "cidade": "Cabedelo"
  },
  {
    "prefixo": "58109",
    "uf": "PB",
    "codigoIbge": 2503209,
    "cidade": "Cabedelo"
  },
  {
    "prefixo": "58110",
    "uf": "PB",
    "codigoIbge": 2501807,
    "cidade": "Bayeux"
  },
  {
    "prefixo": "58111",
    "uf": "PB",
    "codigoIbge": 2501807,
    "cidade": "Bayeux"
  },
  {
    "prefixo": "58112",
    "uf": "PB",
    "codigoIbge": 2501807,
    "cidade": "Bayeux"
  },
  {
    "prefixo": "58113",
    "uf": "PB",
    "codigoIbge": 2501807,
    "cidade": "Bayeux"
  },
  {
    "prefixo": "58115",
    "uf": "PB",
    "codigoIbge": 2512408,
    "cidade": "Puxinanã"
  },
  {
    "prefixo": "58117",
    "uf": "PB",
    "codigoIbge": 2508307,
    "cidade": "Lagoa Seca"
  },
  {
    "prefixo": "58119",
    "uf": "PB",
    "codigoIbge": 2515104,
    "cidade": "São Sebastião de Lagoa de Roça"
  },
  {
    "prefixo": "58120",
    "uf": "PB",
    "codigoIbge": 2509206,
    "cidade": "Massaranduba"
  },
  {
    "prefixo": "58123",
    "uf": "PB",
    "codigoIbge": 2502151,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "58125",
    "uf": "PB",
    "codigoIbge": 2500403,
    "cidade": "Alagoa Nova"
  },
  {
    "prefixo": "58128",
    "uf": "PB",
    "codigoIbge": 2509339,
    "cidade": "Matinhas"
  },
  {
    "prefixo": "58135",
    "uf": "PB",
    "codigoIbge": 2506004,
    "cidade": "Esperança"
  },
  {
    "prefixo": "58140",
    "uf": "PB",
    "codigoIbge": 2501203,
    "cidade": "Areial"
  },
  {
    "prefixo": "58145",
    "uf": "PB",
    "codigoIbge": 2509503,
    "cidade": "Montadas"
  },
  {
    "prefixo": "58150",
    "uf": "PB",
    "codigoIbge": 2512002,
    "cidade": "Pocinhos"
  },
  {
    "prefixo": "58152",
    "uf": "PB",
    "codigoIbge": 2512002,
    "cidade": "Pocinhos"
  },
  {
    "prefixo": "58155",
    "uf": "PB",
    "codigoIbge": 2516102,
    "cidade": "Soledade"
  },
  {
    "prefixo": "58156",
    "uf": "PB",
    "codigoIbge": 2516102,
    "cidade": "Soledade"
  },
  {
    "prefixo": "58158",
    "uf": "PB",
    "codigoIbge": 2515401,
    "cidade": "São Vicente do Seridó"
  },
  {
    "prefixo": "58159",
    "uf": "PB",
    "codigoIbge": 2515401,
    "cidade": "São Vicente do Seridó"
  },
  {
    "prefixo": "58160",
    "uf": "PB",
    "codigoIbge": 2510501,
    "cidade": "Olivedos"
  },
  {
    "prefixo": "58167",
    "uf": "PB",
    "codigoIbge": 2505006,
    "cidade": "Cubati"
  },
  {
    "prefixo": "58170",
    "uf": "PB",
    "codigoIbge": 2501609,
    "cidade": "Barra de Santa Rosa"
  },
  {
    "prefixo": "58173",
    "uf": "PB",
    "codigoIbge": 2505352,
    "cidade": "Damião"
  },
  {
    "prefixo": "58175",
    "uf": "PB",
    "codigoIbge": 2505105,
    "cidade": "Cuité"
  },
  {
    "prefixo": "58176",
    "uf": "PB",
    "codigoIbge": 2505105,
    "cidade": "Cuité"
  },
  {
    "prefixo": "58177",
    "uf": "PB",
    "codigoIbge": 2516151,
    "cidade": "Sossêgo"
  },
  {
    "prefixo": "58178",
    "uf": "PB",
    "codigoIbge": 2510105,
    "cidade": "Nova Floresta"
  },
  {
    "prefixo": "58180",
    "uf": "PB",
    "codigoIbge": 2511103,
    "cidade": "Pedra Lavrada"
  },
  {
    "prefixo": "58184",
    "uf": "PB",
    "codigoIbge": 2510303,
    "cidade": "Nova Palmeira"
  },
  {
    "prefixo": "58187",
    "uf": "PB",
    "codigoIbge": 2511400,
    "cidade": "Picuí"
  },
  {
    "prefixo": "58188",
    "uf": "PB",
    "codigoIbge": 2501534,
    "cidade": "Baraúna"
  },
  {
    "prefixo": "58195",
    "uf": "PB",
    "codigoIbge": 2506202,
    "cidade": "Frei Martinho"
  },
  {
    "prefixo": "58200",
    "uf": "PB",
    "codigoIbge": 2506301,
    "cidade": "Guarabira"
  },
  {
    "prefixo": "58205",
    "uf": "PB",
    "codigoIbge": 2506301,
    "cidade": "Guarabira"
  },
  {
    "prefixo": "58208",
    "uf": "PB",
    "codigoIbge": 2505204,
    "cidade": "Cuitegi"
  },
  {
    "prefixo": "58210",
    "uf": "PB",
    "codigoIbge": 2511707,
    "cidade": "Pilõezinhos"
  },
  {
    "prefixo": "58213",
    "uf": "PB",
    "codigoIbge": 2511806,
    "cidade": "Pirpirituba"
  },
  {
    "prefixo": "58220",
    "uf": "PB",
    "codigoIbge": 2501500,
    "cidade": "Bananeiras"
  },
  {
    "prefixo": "58222",
    "uf": "PB",
    "codigoIbge": 2501500,
    "cidade": "Bananeiras"
  },
  {
    "prefixo": "58225",
    "uf": "PB",
    "codigoIbge": 2516003,
    "cidade": "Solânea"
  },
  {
    "prefixo": "58228",
    "uf": "PB",
    "codigoIbge": 2505709,
    "cidade": "Dona Inês"
  },
  {
    "prefixo": "58230",
    "uf": "PB",
    "codigoIbge": 2503506,
    "cidade": "Cacimba de Dentro"
  },
  {
    "prefixo": "58233",
    "uf": "PB",
    "codigoIbge": 2501005,
    "cidade": "Araruna"
  },
  {
    "prefixo": "58235",
    "uf": "PB",
    "codigoIbge": 2512747,
    "cidade": "Riachão"
  },
  {
    "prefixo": "58238",
    "uf": "PB",
    "codigoIbge": 2504157,
    "cidade": "Casserengue"
  },
  {
    "prefixo": "58240",
    "uf": "PB",
    "codigoIbge": 2516409,
    "cidade": "Tacima"
  },
  {
    "prefixo": "58250",
    "uf": "PB",
    "codigoIbge": 2508208,
    "cidade": "Lagoa de Dentro"
  },
  {
    "prefixo": "58253",
    "uf": "PB",
    "codigoIbge": 2503605,
    "cidade": "Caiçara"
  },
  {
    "prefixo": "58254",
    "uf": "PB",
    "codigoIbge": 2508554,
    "cidade": "Logradouro"
  },
  {
    "prefixo": "58255",
    "uf": "PB",
    "codigoIbge": 2501906,
    "cidade": "Belém"
  },
  {
    "prefixo": "58257",
    "uf": "PB",
    "codigoIbge": 2501906,
    "cidade": "Belém"
  },
  {
    "prefixo": "58260",
    "uf": "PB",
    "codigoIbge": 2515609,
    "cidade": "Serra da Raiz"
  },
  {
    "prefixo": "58265",
    "uf": "PB",
    "codigoIbge": 2505808,
    "cidade": "Duas Estradas"
  },
  {
    "prefixo": "58268",
    "uf": "PB",
    "codigoIbge": 2515930,
    "cidade": "Sertãozinho"
  },
  {
    "prefixo": "58270",
    "uf": "PB",
    "codigoIbge": 2500809,
    "cidade": "Araçagi"
  },
  {
    "prefixo": "58273",
    "uf": "PB",
    "codigoIbge": 2512721,
    "cidade": "Pedro Régis"
  },
  {
    "prefixo": "58275",
    "uf": "PB",
    "codigoIbge": 2507101,
    "cidade": "Itapororoca"
  },
  {
    "prefixo": "58278",
    "uf": "PB",
    "codigoIbge": 2507309,
    "cidade": "Jacaraú"
  },
  {
    "prefixo": "58280",
    "uf": "PB",
    "codigoIbge": 2508901,
    "cidade": "Mamanguape"
  },
  {
    "prefixo": "58286",
    "uf": "PB",
    "codigoIbge": 2508901,
    "cidade": "Mamanguape"
  },
  {
    "prefixo": "58287",
    "uf": "PB",
    "codigoIbge": 2504033,
    "cidade": "Capim"
  },
  {
    "prefixo": "58288",
    "uf": "RN",
    "codigoIbge": 2407104,
    "cidade": "Macaíba"
  },
  {
    "prefixo": "58289",
    "uf": "PB",
    "codigoIbge": 2505238,
    "cidade": "Cuité de Mamanguape"
  },
  {
    "prefixo": "58291",
    "uf": "PB",
    "codigoIbge": 2505279,
    "cidade": "Curral de Cima"
  },
  {
    "prefixo": "58292",
    "uf": "PB",
    "codigoIbge": 2509305,
    "cidade": "Mataraca"
  },
  {
    "prefixo": "58293",
    "uf": "PB",
    "codigoIbge": 2509305,
    "cidade": "Mataraca"
  },
  {
    "prefixo": "58294",
    "uf": "PB",
    "codigoIbge": 2509057,
    "cidade": "Marcação"
  },
  {
    "prefixo": "58295",
    "uf": "PB",
    "codigoIbge": 2501401,
    "cidade": "Baía da Traição"
  },
  {
    "prefixo": "58297",
    "uf": "PB",
    "codigoIbge": 2512903,
    "cidade": "Rio Tinto"
  },
  {
    "prefixo": "58298",
    "uf": "PB",
    "codigoIbge": 2512903,
    "cidade": "Rio Tinto"
  },
  {
    "prefixo": "58300",
    "uf": "PB",
    "codigoIbge": 2513703,
    "cidade": "Santa Rita"
  },
  {
    "prefixo": "58301",
    "uf": "PB",
    "codigoIbge": 2513703,
    "cidade": "Santa Rita"
  },
  {
    "prefixo": "58302",
    "uf": "PB",
    "codigoIbge": 2513703,
    "cidade": "Santa Rita"
  },
  {
    "prefixo": "58303",
    "uf": "PB",
    "codigoIbge": 2513703,
    "cidade": "Santa Rita"
  },
  {
    "prefixo": "58304",
    "uf": "PB",
    "codigoIbge": 2513703,
    "cidade": "Santa Rita"
  },
  {
    "prefixo": "58315",
    "uf": "PB",
    "codigoIbge": 2508604,
    "cidade": "Lucena"
  },
  {
    "prefixo": "58320",
    "uf": "PB",
    "codigoIbge": 2500601,
    "cidade": "Alhandra"
  },
  {
    "prefixo": "58322",
    "uf": "PB",
    "codigoIbge": 2504603,
    "cidade": "Conde"
  },
  {
    "prefixo": "58323",
    "uf": "PB",
    "codigoIbge": 2504603,
    "cidade": "Conde"
  },
  {
    "prefixo": "58324",
    "uf": "PB",
    "codigoIbge": 2511905,
    "cidade": "Pitimbu"
  },
  {
    "prefixo": "58326",
    "uf": "PB",
    "codigoIbge": 2503001,
    "cidade": "Caaporã"
  },
  {
    "prefixo": "58327",
    "uf": "PB",
    "codigoIbge": 2503001,
    "cidade": "Caaporã"
  },
  {
    "prefixo": "58328",
    "uf": "PB",
    "codigoIbge": 2511202,
    "cidade": "Pedras de Fogo"
  },
  {
    "prefixo": "58330",
    "uf": "PB",
    "codigoIbge": 2507903,
    "cidade": "Juripiranga"
  },
  {
    "prefixo": "58334",
    "uf": "PB",
    "codigoIbge": 2515005,
    "cidade": "São Miguel de Taipu"
  },
  {
    "prefixo": "58337",
    "uf": "PB",
    "codigoIbge": 2504900,
    "cidade": "Cruz do Espírito Santo"
  },
  {
    "prefixo": "58338",
    "uf": "PB",
    "codigoIbge": 2511509,
    "cidade": "Pilar"
  },
  {
    "prefixo": "58339",
    "uf": "PB",
    "codigoIbge": 2514453,
    "cidade": "São José dos Ramos"
  },
  {
    "prefixo": "58340",
    "uf": "PB",
    "codigoIbge": 2515302,
    "cidade": "Sapé"
  },
  {
    "prefixo": "58342",
    "uf": "PB",
    "codigoIbge": 2515971,
    "cidade": "Sobrado"
  },
  {
    "prefixo": "58345",
    "uf": "PB",
    "codigoIbge": 2509107,
    "cidade": "Mari"
  },
  {
    "prefixo": "58348",
    "uf": "PB",
    "codigoIbge": 2512762,
    "cidade": "Riachão do Poço"
  },
  {
    "prefixo": "58350",
    "uf": "PB",
    "codigoIbge": 2503803,
    "cidade": "Caldas Brandão"
  },
  {
    "prefixo": "58354",
    "uf": "PB",
    "codigoIbge": 2509800,
    "cidade": "Mulungu"
  },
  {
    "prefixo": "58356",
    "uf": "PB",
    "codigoIbge": 2506400,
    "cidade": "Gurinhém"
  },
  {
    "prefixo": "58360",
    "uf": "PB",
    "codigoIbge": 2506905,
    "cidade": "Itabaiana"
  },
  {
    "prefixo": "58362",
    "uf": "PB",
    "codigoIbge": 2506905,
    "cidade": "Itabaiana"
  },
  {
    "prefixo": "58364",
    "uf": "PB",
    "codigoIbge": 2506905,
    "cidade": "Itabaiana"
  },
  {
    "prefixo": "58370",
    "uf": "PB",
    "codigoIbge": 2513109,
    "cidade": "Salgado de São Félix"
  },
  {
    "prefixo": "58375",
    "uf": "PB",
    "codigoIbge": 2509404,
    "cidade": "Mogeiro"
  },
  {
    "prefixo": "58378",
    "uf": "PB",
    "codigoIbge": 2507200,
    "cidade": "Itatuba"
  },
  {
    "prefixo": "58380",
    "uf": "PB",
    "codigoIbge": 2506806,
    "cidade": "Ingá"
  },
  {
    "prefixo": "58382",
    "uf": "PB",
    "codigoIbge": 2512754,
    "cidade": "Riachão do Bacamarte"
  },
  {
    "prefixo": "58385",
    "uf": "PB",
    "codigoIbge": 2515807,
    "cidade": "Serra Redonda"
  },
  {
    "prefixo": "58387",
    "uf": "PB",
    "codigoIbge": 2507606,
    "cidade": "Juarez Távora"
  },
  {
    "prefixo": "58388",
    "uf": "PB",
    "codigoIbge": 2500304,
    "cidade": "Alagoa Grande"
  },
  {
    "prefixo": "58390",
    "uf": "PB",
    "codigoIbge": 2500502,
    "cidade": "Alagoinha"
  },
  {
    "prefixo": "58393",
    "uf": "PB",
    "codigoIbge": 2511608,
    "cidade": "Pilões"
  },
  {
    "prefixo": "58394",
    "uf": "PB",
    "codigoIbge": 2502706,
    "cidade": "Borborema"
  },
  {
    "prefixo": "58395",
    "uf": "PB",
    "codigoIbge": 2515906,
    "cidade": "Serraria"
  },
  {
    "prefixo": "58396",
    "uf": "PB",
    "codigoIbge": 2500908,
    "cidade": "Arara"
  },
  {
    "prefixo": "58397",
    "uf": "PB",
    "codigoIbge": 2501104,
    "cidade": "Areia"
  },
  {
    "prefixo": "58398",
    "uf": "PB",
    "codigoIbge": 2512705,
    "cidade": "Remígio"
  },
  {
    "prefixo": "58399",
    "uf": "PB",
    "codigoIbge": 2500577,
    "cidade": "Algodão de Jandaíra"
  },
  {
    "prefixo": "58400",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58401",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58402",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58403",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58404",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58406",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58407",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58408",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58410",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58411",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58412",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58414",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58415",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58416",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58417",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58418",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58419",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58420",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58421",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58422",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58423",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58424",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58425",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58428",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58429",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58430",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58431",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58432",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58433",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58434",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58436",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58437",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58439",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58441",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58443",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58444",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58446",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58449",
    "uf": "PB",
    "codigoIbge": 2504009,
    "cidade": "Campina Grande"
  },
  {
    "prefixo": "58450",
    "uf": "PB",
    "codigoIbge": 2502508,
    "cidade": "Boqueirão"
  },
  {
    "prefixo": "58455",
    "uf": "PB",
    "codigoIbge": 2504355,
    "cidade": "Caturité"
  },
  {
    "prefixo": "58458",
    "uf": "PB",
    "codigoIbge": 2501575,
    "cidade": "Barra de Santana"
  },
  {
    "prefixo": "58460",
    "uf": "PB",
    "codigoIbge": 2500536,
    "cidade": "Alcantil"
  },
  {
    "prefixo": "58463",
    "uf": "PB",
    "codigoIbge": 2513158,
    "cidade": "Santa Cecília"
  },
  {
    "prefixo": "58465",
    "uf": "PB",
    "codigoIbge": 2512788,
    "cidade": "Riacho de Santo Antônio"
  },
  {
    "prefixo": "58475",
    "uf": "PB",
    "codigoIbge": 2512507,
    "cidade": "Queimadas"
  },
  {
    "prefixo": "58476",
    "uf": "PB",
    "codigoIbge": 2512507,
    "cidade": "Queimadas"
  },
  {
    "prefixo": "58480",
    "uf": "PB",
    "codigoIbge": 2503100,
    "cidade": "Cabaceiras"
  },
  {
    "prefixo": "58483",
    "uf": "PB",
    "codigoIbge": 2501708,
    "cidade": "Barra de São Miguel"
  },
  {
    "prefixo": "58485",
    "uf": "PB",
    "codigoIbge": 2513943,
    "cidade": "São Domingos do Cariri"
  },
  {
    "prefixo": "58487",
    "uf": "PB",
    "codigoIbge": 2506103,
    "cidade": "Fagundes"
  },
  {
    "prefixo": "58489",
    "uf": "PB",
    "codigoIbge": 2501302,
    "cidade": "Aroeiras"
  },
  {
    "prefixo": "58492",
    "uf": "PB",
    "codigoIbge": 2506251,
    "cidade": "Gado Bravo"
  },
  {
    "prefixo": "58494",
    "uf": "PB",
    "codigoIbge": 2509909,
    "cidade": "Natuba"
  },
  {
    "prefixo": "58496",
    "uf": "PB",
    "codigoIbge": 2509909,
    "cidade": "Natuba"
  },
  {
    "prefixo": "58497",
    "uf": "PB",
    "codigoIbge": 2517001,
    "cidade": "Umbuzeiro"
  },
  {
    "prefixo": "58499",
    "uf": "PB",
    "codigoIbge": 2517001,
    "cidade": "Umbuzeiro"
  },
  {
    "prefixo": "58500",
    "uf": "PB",
    "codigoIbge": 2509701,
    "cidade": "Monteiro"
  },
  {
    "prefixo": "58510",
    "uf": "PB",
    "codigoIbge": 2515203,
    "cidade": "São Sebastião do Umbuzeiro"
  },
  {
    "prefixo": "58515",
    "uf": "PB",
    "codigoIbge": 2517407,
    "cidade": "Zabelê"
  },
  {
    "prefixo": "58520",
    "uf": "PB",
    "codigoIbge": 2514107,
    "cidade": "São João do Tigre"
  },
  {
    "prefixo": "58525",
    "uf": "PB",
    "codigoIbge": 2514107,
    "cidade": "São João do Tigre"
  },
  {
    "prefixo": "58530",
    "uf": "PB",
    "codigoIbge": 2503902,
    "cidade": "Camalaú"
  },
  {
    "prefixo": "58533",
    "uf": "PB",
    "codigoIbge": 2503902,
    "cidade": "Camalaú"
  },
  {
    "prefixo": "58535",
    "uf": "PB",
    "codigoIbge": 2504702,
    "cidade": "Congo"
  },
  {
    "prefixo": "58540",
    "uf": "PB",
    "codigoIbge": 2516300,
    "cidade": "Sumé"
  },
  {
    "prefixo": "58545",
    "uf": "PB",
    "codigoIbge": 2516300,
    "cidade": "Sumé"
  },
  {
    "prefixo": "58548",
    "uf": "PB",
    "codigoIbge": 2500734,
    "cidade": "Amparo"
  },
  {
    "prefixo": "58550",
    "uf": "PB",
    "codigoIbge": 2512200,
    "cidade": "Prata"
  },
  {
    "prefixo": "58560",
    "uf": "PB",
    "codigoIbge": 2510600,
    "cidade": "Ouro Velho"
  },
  {
    "prefixo": "58570",
    "uf": "PB",
    "codigoIbge": 2514800,
    "cidade": "São José dos Cordeiros"
  },
  {
    "prefixo": "58575",
    "uf": "PB",
    "codigoIbge": 2510659,
    "cidade": "Parari"
  },
  {
    "prefixo": "58580",
    "uf": "PB",
    "codigoIbge": 2515500,
    "cidade": "Serra Branca"
  },
  {
    "prefixo": "58582",
    "uf": "PB",
    "codigoIbge": 2515500,
    "cidade": "Serra Branca"
  },
  {
    "prefixo": "58588",
    "uf": "PB",
    "codigoIbge": 2504850,
    "cidade": "Coxixola"
  },
  {
    "prefixo": "58590",
    "uf": "PB",
    "codigoIbge": 2514008,
    "cidade": "São João do Cariri"
  },
  {
    "prefixo": "58595",
    "uf": "PB",
    "codigoIbge": 2504074,
    "cidade": "Caraúbas"
  },
  {
    "prefixo": "58600",
    "uf": "PB",
    "codigoIbge": 2513406,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "58610",
    "uf": "PB",
    "codigoIbge": 2514701,
    "cidade": "São José do Sabugi"
  },
  {
    "prefixo": "58620",
    "uf": "PB",
    "codigoIbge": 2517100,
    "cidade": "Várzea"
  },
  {
    "prefixo": "58625",
    "uf": "PB",
    "codigoIbge": 2514909,
    "cidade": "São Mamede"
  },
  {
    "prefixo": "58640",
    "uf": "PB",
    "codigoIbge": 2507804,
    "cidade": "Junco do Seridó"
  },
  {
    "prefixo": "58650",
    "uf": "PB",
    "codigoIbge": 2513000,
    "cidade": "Salgadinho"
  },
  {
    "prefixo": "58660",
    "uf": "PB",
    "codigoIbge": 2507705,
    "cidade": "Juazeirinho"
  },
  {
    "prefixo": "58665",
    "uf": "PB",
    "codigoIbge": 2516755,
    "cidade": "Tenório"
  },
  {
    "prefixo": "58670",
    "uf": "PB",
    "codigoIbge": 2506509,
    "cidade": "Gurjão"
  },
  {
    "prefixo": "58675",
    "uf": "PB",
    "codigoIbge": 2513851,
    "cidade": "Santo André"
  },
  {
    "prefixo": "58680",
    "uf": "PB",
    "codigoIbge": 2516508,
    "cidade": "Taperoá"
  },
  {
    "prefixo": "58685",
    "uf": "PB",
    "codigoIbge": 2501351,
    "cidade": "Assunção"
  },
  {
    "prefixo": "58690",
    "uf": "PB",
    "codigoIbge": 2508505,
    "cidade": "Livramento"
  },
  {
    "prefixo": "58695",
    "uf": "PB",
    "codigoIbge": 2505402,
    "cidade": "Desterro"
  },
  {
    "prefixo": "58698",
    "uf": "PB",
    "codigoIbge": 2503555,
    "cidade": "Cacimbas"
  },
  {
    "prefixo": "58700",
    "uf": "PB",
    "codigoIbge": 2510808,
    "cidade": "Patos"
  },
  {
    "prefixo": "58701",
    "uf": "PB",
    "codigoIbge": 2510808,
    "cidade": "Patos"
  },
  {
    "prefixo": "58703",
    "uf": "PB",
    "codigoIbge": 2510808,
    "cidade": "Patos"
  },
  {
    "prefixo": "58704",
    "uf": "PB",
    "codigoIbge": 2510808,
    "cidade": "Patos"
  },
  {
    "prefixo": "58705",
    "uf": "PB",
    "codigoIbge": 2510808,
    "cidade": "Patos"
  },
  {
    "prefixo": "58706",
    "uf": "PB",
    "codigoIbge": 2510808,
    "cidade": "Patos"
  },
  {
    "prefixo": "58707",
    "uf": "PB",
    "codigoIbge": 2510808,
    "cidade": "Patos"
  },
  {
    "prefixo": "58708",
    "uf": "PB",
    "codigoIbge": 2510808,
    "cidade": "Patos"
  },
  {
    "prefixo": "58709",
    "uf": "PB",
    "codigoIbge": 2510808,
    "cidade": "Patos"
  },
  {
    "prefixo": "58710",
    "uf": "PB",
    "codigoIbge": 2505501,
    "cidade": "Vista Serrana"
  },
  {
    "prefixo": "58713",
    "uf": "PB",
    "codigoIbge": 2508802,
    "cidade": "Malta"
  },
  {
    "prefixo": "58714",
    "uf": "PB",
    "codigoIbge": 2504504,
    "cidade": "Condado"
  },
  {
    "prefixo": "58715",
    "uf": "PB",
    "codigoIbge": 2504207,
    "cidade": "Catingueira"
  },
  {
    "prefixo": "58718",
    "uf": "PB",
    "codigoIbge": 2504207,
    "cidade": "Catingueira"
  },
  {
    "prefixo": "58720",
    "uf": "PB",
    "codigoIbge": 2513802,
    "cidade": "Santa Teresinha"
  },
  {
    "prefixo": "58723",
    "uf": "PB",
    "codigoIbge": 2514404,
    "cidade": "São José de Espinharas"
  },
  {
    "prefixo": "58725",
    "uf": "PB",
    "codigoIbge": 2514602,
    "cidade": "São José do Bonfim"
  },
  {
    "prefixo": "58730",
    "uf": "PB",
    "codigoIbge": 2503407,
    "cidade": "Cacimba de Areia"
  },
  {
    "prefixo": "58732",
    "uf": "PB",
    "codigoIbge": 2501153,
    "cidade": "Areia de Baraúnas"
  },
  {
    "prefixo": "58733",
    "uf": "PB",
    "codigoIbge": 2512606,
    "cidade": "Quixaba"
  },
  {
    "prefixo": "58734",
    "uf": "PB",
    "codigoIbge": 2510709,
    "cidade": "Passagem"
  },
  {
    "prefixo": "58735",
    "uf": "PB",
    "codigoIbge": 2516706,
    "cidade": "Teixeira"
  },
  {
    "prefixo": "58737",
    "uf": "PB",
    "codigoIbge": 2509396,
    "cidade": "Maturéia"
  },
  {
    "prefixo": "58740",
    "uf": "PB",
    "codigoIbge": 2508703,
    "cidade": "Mãe d'Água"
  },
  {
    "prefixo": "58745",
    "uf": "PB",
    "codigoIbge": 2506707,
    "cidade": "Imaculada"
  },
  {
    "prefixo": "58748",
    "uf": "PB",
    "codigoIbge": 2500106,
    "cidade": "Água Branca"
  },
  {
    "prefixo": "58750",
    "uf": "PB",
    "codigoIbge": 2508000,
    "cidade": "Juru"
  },
  {
    "prefixo": "58753",
    "uf": "PB",
    "codigoIbge": 2516607,
    "cidade": "Tavares"
  },
  {
    "prefixo": "58755",
    "uf": "PB",
    "codigoIbge": 2512309,
    "cidade": "Princesa Isabel"
  },
  {
    "prefixo": "58758",
    "uf": "PB",
    "codigoIbge": 2514552,
    "cidade": "São José de Princesa"
  },
  {
    "prefixo": "58760",
    "uf": "PB",
    "codigoIbge": 2510402,
    "cidade": "Olho d'Água"
  },
  {
    "prefixo": "58763",
    "uf": "PB",
    "codigoIbge": 2505907,
    "cidade": "Emas"
  },
  {
    "prefixo": "58765",
    "uf": "PB",
    "codigoIbge": 2511301,
    "cidade": "Piancó"
  },
  {
    "prefixo": "58770",
    "uf": "PB",
    "codigoIbge": 2504801,
    "cidade": "Coremas"
  },
  {
    "prefixo": "58775",
    "uf": "PB",
    "codigoIbge": 2502607,
    "cidade": "Igaracy"
  },
  {
    "prefixo": "58778",
    "uf": "PB",
    "codigoIbge": 2500205,
    "cidade": "Aguiar"
  },
  {
    "prefixo": "58780",
    "uf": "PB",
    "codigoIbge": 2507002,
    "cidade": "Itaporanga"
  },
  {
    "prefixo": "58784",
    "uf": "PB",
    "codigoIbge": 2514305,
    "cidade": "São José de Caiana"
  },
  {
    "prefixo": "58790",
    "uf": "PB",
    "codigoIbge": 2511004,
    "cidade": "Pedra Branca"
  },
  {
    "prefixo": "58795",
    "uf": "PB",
    "codigoIbge": 2513604,
    "cidade": "Santana dos Garrotes"
  },
  {
    "prefixo": "58798",
    "uf": "PB",
    "codigoIbge": 2510204,
    "cidade": "Nova Olinda"
  },
  {
    "prefixo": "58800",
    "uf": "PB",
    "codigoIbge": 2516201,
    "cidade": "Sousa"
  },
  {
    "prefixo": "58801",
    "uf": "PB",
    "codigoIbge": 2516201,
    "cidade": "Sousa"
  },
  {
    "prefixo": "58802",
    "uf": "PB",
    "codigoIbge": 2516201,
    "cidade": "Sousa"
  },
  {
    "prefixo": "58804",
    "uf": "PB",
    "codigoIbge": 2516201,
    "cidade": "Sousa"
  },
  {
    "prefixo": "58805",
    "uf": "PB",
    "codigoIbge": 2516201,
    "cidade": "Sousa"
  },
  {
    "prefixo": "58806",
    "uf": "PB",
    "codigoIbge": 2516201,
    "cidade": "Sousa"
  },
  {
    "prefixo": "58807",
    "uf": "PB",
    "codigoIbge": 2516201,
    "cidade": "Sousa"
  },
  {
    "prefixo": "58808",
    "uf": "PB",
    "codigoIbge": 2516201,
    "cidade": "Sousa"
  },
  {
    "prefixo": "58809",
    "uf": "PB",
    "codigoIbge": 2516201,
    "cidade": "Sousa"
  },
  {
    "prefixo": "58814",
    "uf": "PB",
    "codigoIbge": 2516201,
    "cidade": "Sousa"
  },
  {
    "prefixo": "58815",
    "uf": "PB",
    "codigoIbge": 2514206,
    "cidade": "São José da Lagoa Tapada"
  },
  {
    "prefixo": "58817",
    "uf": "PB",
    "codigoIbge": 2510006,
    "cidade": "Nazarezinho"
  },
  {
    "prefixo": "58818",
    "uf": "PB",
    "codigoIbge": 2513984,
    "cidade": "São Francisco"
  },
  {
    "prefixo": "58819",
    "uf": "PB",
    "codigoIbge": 2509156,
    "cidade": "Marizópolis"
  },
  {
    "prefixo": "58820",
    "uf": "PB",
    "codigoIbge": 2508406,
    "cidade": "Lastro"
  },
  {
    "prefixo": "58822",
    "uf": "PB",
    "codigoIbge": 2517209,
    "cidade": "Vieirópolis"
  },
  {
    "prefixo": "58823",
    "uf": "PB",
    "codigoIbge": 2500775,
    "cidade": "Aparecida"
  },
  {
    "prefixo": "58824",
    "uf": "PB",
    "codigoIbge": 2513208,
    "cidade": "Santa Cruz"
  },
  {
    "prefixo": "58830",
    "uf": "PB",
    "codigoIbge": 2507408,
    "cidade": "Jericó"
  },
  {
    "prefixo": "58832",
    "uf": "PB",
    "codigoIbge": 2509370,
    "cidade": "Mato Grosso"
  },
  {
    "prefixo": "58835",
    "uf": "PB",
    "codigoIbge": 2508109,
    "cidade": "Lagoa"
  },
  {
    "prefixo": "58840",
    "uf": "PB",
    "codigoIbge": 2512101,
    "cidade": "Pombal"
  },
  {
    "prefixo": "58850",
    "uf": "PB",
    "codigoIbge": 2512101,
    "cidade": "Pombal"
  },
  {
    "prefixo": "58853",
    "uf": "PB",
    "codigoIbge": 2513968,
    "cidade": "São Domingos"
  },
  {
    "prefixo": "58855",
    "uf": "PB",
    "codigoIbge": 2503753,
    "cidade": "Cajazeirinhas"
  },
  {
    "prefixo": "58857",
    "uf": "PB",
    "codigoIbge": 2513927,
    "cidade": "São Bentinho"
  },
  {
    "prefixo": "58860",
    "uf": "PB",
    "codigoIbge": 2510907,
    "cidade": "Paulista"
  },
  {
    "prefixo": "58865",
    "uf": "PB",
    "codigoIbge": 2513901,
    "cidade": "São Bento"
  },
  {
    "prefixo": "58870",
    "uf": "PB",
    "codigoIbge": 2512804,
    "cidade": "Riacho dos Cavalos"
  },
  {
    "prefixo": "58880",
    "uf": "PB",
    "codigoIbge": 2502904,
    "cidade": "Brejo dos Santos"
  },
  {
    "prefixo": "58884",
    "uf": "PB",
    "codigoIbge": 2504306,
    "cidade": "Catolé do Rocha"
  },
  {
    "prefixo": "58885",
    "uf": "PB",
    "codigoIbge": 2504306,
    "cidade": "Catolé do Rocha"
  },
  {
    "prefixo": "58887",
    "uf": "PB",
    "codigoIbge": 2502300,
    "cidade": "Bom Sucesso"
  },
  {
    "prefixo": "58890",
    "uf": "PB",
    "codigoIbge": 2502805,
    "cidade": "Brejo do Cruz"
  },
  {
    "prefixo": "58893",
    "uf": "PB",
    "codigoIbge": 2514651,
    "cidade": "São José do Brejo do Cruz"
  },
  {
    "prefixo": "58895",
    "uf": "PB",
    "codigoIbge": 2502003,
    "cidade": "Belém do Brejo do Cruz"
  },
  {
    "prefixo": "58900",
    "uf": "PB",
    "codigoIbge": 2503704,
    "cidade": "Cajazeiras"
  },
  {
    "prefixo": "58905",
    "uf": "PB",
    "codigoIbge": 2503704,
    "cidade": "Cajazeiras"
  },
  {
    "prefixo": "58908",
    "uf": "PB",
    "codigoIbge": 2512077,
    "cidade": "Poço de José de Moura"
  },
  {
    "prefixo": "58910",
    "uf": "PB",
    "codigoIbge": 2500700,
    "cidade": "São João do Rio do Peixe"
  },
  {
    "prefixo": "58913",
    "uf": "PB",
    "codigoIbge": 2500700,
    "cidade": "São João do Rio do Peixe"
  },
  {
    "prefixo": "58915",
    "uf": "PB",
    "codigoIbge": 2516904,
    "cidade": "Uiraúna"
  },
  {
    "prefixo": "58918",
    "uf": "PB",
    "codigoIbge": 2516904,
    "cidade": "Uiraúna"
  },
  {
    "prefixo": "58920",
    "uf": "PB",
    "codigoIbge": 2516805,
    "cidade": "Triunfo"
  },
  {
    "prefixo": "58922",
    "uf": "PB",
    "codigoIbge": 2502052,
    "cidade": "Bernardino Batista"
  },
  {
    "prefixo": "58925",
    "uf": "PB",
    "codigoIbge": 2513307,
    "cidade": "Santa Helena"
  },
  {
    "prefixo": "58928",
    "uf": "PB",
    "codigoIbge": 2513653,
    "cidade": "Joca Claudino"
  },
  {
    "prefixo": "58930",
    "uf": "PB",
    "codigoIbge": 2502201,
    "cidade": "Bom Jesus"
  },
  {
    "prefixo": "58933",
    "uf": "PB",
    "codigoIbge": 2512036,
    "cidade": "Poço Dantas"
  },
  {
    "prefixo": "58935",
    "uf": "PB",
    "codigoIbge": 2503308,
    "cidade": "Cachoeira dos Índios"
  },
  {
    "prefixo": "58938",
    "uf": "PB",
    "codigoIbge": 2503308,
    "cidade": "Cachoeira dos Índios"
  },
  {
    "prefixo": "58940",
    "uf": "PB",
    "codigoIbge": 2514503,
    "cidade": "São José de Piranhas"
  },
  {
    "prefixo": "58945",
    "uf": "PB",
    "codigoIbge": 2504108,
    "cidade": "Carrapateira"
  },
  {
    "prefixo": "58950",
    "uf": "PB",
    "codigoIbge": 2509602,
    "cidade": "Monte Horebe"
  },
  {
    "prefixo": "58955",
    "uf": "PB",
    "codigoIbge": 2515708,
    "cidade": "Serra Grande"
  },
  {
    "prefixo": "58960",
    "uf": "PB",
    "codigoIbge": 2502409,
    "cidade": "Bonito de Santa Fé"
  },
  {
    "prefixo": "58970",
    "uf": "PB",
    "codigoIbge": 2504405,
    "cidade": "Conceição"
  },
  {
    "prefixo": "58973",
    "uf": "PB",
    "codigoIbge": 2504405,
    "cidade": "Conceição"
  },
  {
    "prefixo": "58975",
    "uf": "PB",
    "codigoIbge": 2504405,
    "cidade": "Conceição"
  },
  {
    "prefixo": "58978",
    "uf": "PB",
    "codigoIbge": 2513356,
    "cidade": "Santa Inês"
  },
  {
    "prefixo": "58980",
    "uf": "PB",
    "codigoIbge": 2506608,
    "cidade": "Ibiara"
  },
  {
    "prefixo": "58983",
    "uf": "PB",
    "codigoIbge": 2506608,
    "cidade": "Ibiara"
  },
  {
    "prefixo": "58985",
    "uf": "PB",
    "codigoIbge": 2513505,
    "cidade": "Santana de Mangueira"
  },
  {
    "prefixo": "58990",
    "uf": "PB",
    "codigoIbge": 2505303,
    "cidade": "Curral Velho"
  },
  {
    "prefixo": "58993",
    "uf": "PB",
    "codigoIbge": 2502102,
    "cidade": "Boa Ventura"
  },
  {
    "prefixo": "58994",
    "uf": "PB",
    "codigoIbge": 2505600,
    "cidade": "Diamante"
  },
  {
    "prefixo": "58995",
    "uf": "PB",
    "codigoIbge": 2509008,
    "cidade": "Manaíra"
  },
  {
    "prefixo": "58996",
    "uf": "PB",
    "codigoIbge": 2509008,
    "cidade": "Manaíra"
  },
  {
    "prefixo": "59010",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59012",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59014",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59015",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59020",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59022",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59025",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59030",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59031",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59032",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59035",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59037",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59040",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59042",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59050",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59051",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59052",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59053",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59054",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59056",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59060",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59062",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59063",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59064",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59065",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59066",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59067",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59068",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59069",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59070",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59071",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59072",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59073",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59074",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59075",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59076",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59077",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59078",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59080",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59082",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59084",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59086",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59088",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59090",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59091",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59092",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59094",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59101",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59104",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59106",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59107",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59108",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59110",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59112",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59114",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59115",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59117",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59120",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59122",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59123",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59124",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59125",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59127",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59129",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59131",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59132",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59133",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59134",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59135",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59136",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59138",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59139",
    "uf": "RN",
    "codigoIbge": 2408102,
    "cidade": "Natal"
  },
  {
    "prefixo": "59140",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59141",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59142",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59143",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59144",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59145",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59146",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59147",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59148",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59149",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59150",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59151",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59152",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59153",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59154",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59155",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59156",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59157",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59158",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59159",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59160",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59161",
    "uf": "RN",
    "codigoIbge": 2403251,
    "cidade": "Parnamirim"
  },
  {
    "prefixo": "59162",
    "uf": "RN",
    "codigoIbge": 2412203,
    "cidade": "São José de Mipibu"
  },
  {
    "prefixo": "59163",
    "uf": "RN",
    "codigoIbge": 2412203,
    "cidade": "São José de Mipibu"
  },
  {
    "prefixo": "59164",
    "uf": "RN",
    "codigoIbge": 2408201,
    "cidade": "Nísia Floresta"
  },
  {
    "prefixo": "59168",
    "uf": "RN",
    "codigoIbge": 2413201,
    "cidade": "Senador Georgino Avelino"
  },
  {
    "prefixo": "59170",
    "uf": "RN",
    "codigoIbge": 2401206,
    "cidade": "Arez"
  },
  {
    "prefixo": "59173",
    "uf": "RN",
    "codigoIbge": 2404200,
    "cidade": "Goianinha"
  },
  {
    "prefixo": "59178",
    "uf": "RN",
    "codigoIbge": 2414209,
    "cidade": "Tibau do Sul"
  },
  {
    "prefixo": "59179",
    "uf": "RN",
    "codigoIbge": 2414209,
    "cidade": "Tibau do Sul"
  },
  {
    "prefixo": "59180",
    "uf": "RN",
    "codigoIbge": 2403509,
    "cidade": "Espírito Santo"
  },
  {
    "prefixo": "59182",
    "uf": "RN",
    "codigoIbge": 2407807,
    "cidade": "Monte Alegre"
  },
  {
    "prefixo": "59184",
    "uf": "RN",
    "codigoIbge": 2414803,
    "cidade": "Vera Cruz"
  },
  {
    "prefixo": "59185",
    "uf": "RN",
    "codigoIbge": 2414704,
    "cidade": "Várzea"
  },
  {
    "prefixo": "59188",
    "uf": "RN",
    "codigoIbge": 2406155,
    "cidade": "Jundiá"
  },
  {
    "prefixo": "59189",
    "uf": "RN",
    "codigoIbge": 2406155,
    "cidade": "Jundiá"
  },
  {
    "prefixo": "59190",
    "uf": "RN",
    "codigoIbge": 2402204,
    "cidade": "Canguaretama"
  },
  {
    "prefixo": "59192",
    "uf": "RN",
    "codigoIbge": 2415008,
    "cidade": "Vila Flor"
  },
  {
    "prefixo": "59194",
    "uf": "RN",
    "codigoIbge": 2401404,
    "cidade": "Baía Formosa"
  },
  {
    "prefixo": "59196",
    "uf": "RN",
    "codigoIbge": 2409803,
    "cidade": "Pedro Velho"
  },
  {
    "prefixo": "59198",
    "uf": "RN",
    "codigoIbge": 2407708,
    "cidade": "Montanhas"
  },
  {
    "prefixo": "59200",
    "uf": "RN",
    "codigoIbge": 2411205,
    "cidade": "Santa Cruz"
  },
  {
    "prefixo": "59210",
    "uf": "RN",
    "codigoIbge": 2411700,
    "cidade": "São Bento do Trairí"
  },
  {
    "prefixo": "59213",
    "uf": "RN",
    "codigoIbge": 2405405,
    "cidade": "Japi"
  },
  {
    "prefixo": "59214",
    "uf": "RN",
    "codigoIbge": 2413300,
    "cidade": "Serra de São Bento"
  },
  {
    "prefixo": "59215",
    "uf": "RN",
    "codigoIbge": 2408300,
    "cidade": "Nova Cruz"
  },
  {
    "prefixo": "59217",
    "uf": "RN",
    "codigoIbge": 2407906,
    "cidade": "Monte das Gameleiras"
  },
  {
    "prefixo": "59218",
    "uf": "RN",
    "codigoIbge": 2409100,
    "cidade": "Passa e Fica"
  },
  {
    "prefixo": "59219",
    "uf": "RN",
    "codigoIbge": 2401800,
    "cidade": "Brejinho"
  },
  {
    "prefixo": "59220",
    "uf": "RN",
    "codigoIbge": 2402808,
    "cidade": "Coronel Ezequiel"
  },
  {
    "prefixo": "59225",
    "uf": "RN",
    "codigoIbge": 2405009,
    "cidade": "Jaçanã"
  },
  {
    "prefixo": "59227",
    "uf": "RN",
    "codigoIbge": 2406205,
    "cidade": "Lagoa d'Anta"
  },
  {
    "prefixo": "59230",
    "uf": "RN",
    "codigoIbge": 2402105,
    "cidade": "Campo Redondo"
  },
  {
    "prefixo": "59235",
    "uf": "RN",
    "codigoIbge": 2406809,
    "cidade": "Lajes Pintadas"
  },
  {
    "prefixo": "59240",
    "uf": "RN",
    "codigoIbge": 2414001,
    "cidade": "Tangará"
  },
  {
    "prefixo": "59242",
    "uf": "RN",
    "codigoIbge": 2414001,
    "cidade": "Tangará"
  },
  {
    "prefixo": "59244",
    "uf": "RN",
    "codigoIbge": 2406304,
    "cidade": "Lagoa de Pedras"
  },
  {
    "prefixo": "59245",
    "uf": "RN",
    "codigoIbge": 2410306,
    "cidade": "Serra Caiada"
  },
  {
    "prefixo": "59247",
    "uf": "RN",
    "codigoIbge": 2406601,
    "cidade": "Lagoa Salgada"
  },
  {
    "prefixo": "59250",
    "uf": "RN",
    "codigoIbge": 2413102,
    "cidade": "Senador Elói de Souza"
  },
  {
    "prefixo": "59255",
    "uf": "RN",
    "codigoIbge": 2411502,
    "cidade": "Santo Antônio"
  },
  {
    "prefixo": "59258",
    "uf": "RN",
    "codigoIbge": 2413508,
    "cidade": "Serrinha"
  },
  {
    "prefixo": "59259",
    "uf": "RN",
    "codigoIbge": 2409209,
    "cidade": "Passagem"
  },
  {
    "prefixo": "59260",
    "uf": "RN",
    "codigoIbge": 2405306,
    "cidade": "Januário Cicco"
  },
  {
    "prefixo": "59265",
    "uf": "RN",
    "codigoIbge": 2405306,
    "cidade": "Januário Cicco"
  },
  {
    "prefixo": "59270",
    "uf": "RN",
    "codigoIbge": 2401701,
    "cidade": "Bom Jesus"
  },
  {
    "prefixo": "59275",
    "uf": "RN",
    "codigoIbge": 2412302,
    "cidade": "São José do Campestre"
  },
  {
    "prefixo": "59280",
    "uf": "RN",
    "codigoIbge": 2407104,
    "cidade": "Macaíba"
  },
  {
    "prefixo": "59281",
    "uf": "RN",
    "codigoIbge": 2407104,
    "cidade": "Macaíba"
  },
  {
    "prefixo": "59282",
    "uf": "RN",
    "codigoIbge": 2407104,
    "cidade": "Macaíba"
  },
  {
    "prefixo": "59283",
    "uf": "RN",
    "codigoIbge": 2407104,
    "cidade": "Macaíba"
  },
  {
    "prefixo": "59284",
    "uf": "RN",
    "codigoIbge": 2407104,
    "cidade": "Macaíba"
  },
  {
    "prefixo": "59285",
    "uf": "RN",
    "codigoIbge": 2407104,
    "cidade": "Macaíba"
  },
  {
    "prefixo": "59286",
    "uf": "RN",
    "codigoIbge": 2407104,
    "cidade": "Macaíba"
  },
  {
    "prefixo": "59288",
    "uf": "RN",
    "codigoIbge": 2407104,
    "cidade": "Macaíba"
  },
  {
    "prefixo": "59289",
    "uf": "RN",
    "codigoIbge": 2407104,
    "cidade": "Macaíba"
  },
  {
    "prefixo": "59290",
    "uf": "RN",
    "codigoIbge": 2412005,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "59291",
    "uf": "RN",
    "codigoIbge": 2412005,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "59292",
    "uf": "RN",
    "codigoIbge": 2412005,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "59293",
    "uf": "RN",
    "codigoIbge": 2412005,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "59294",
    "uf": "RN",
    "codigoIbge": 2412005,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "59295",
    "uf": "RN",
    "codigoIbge": 2412005,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "59296",
    "uf": "RN",
    "codigoIbge": 2412005,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "59297",
    "uf": "RN",
    "codigoIbge": 2412005,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "59298",
    "uf": "RN",
    "codigoIbge": 2412005,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "59299",
    "uf": "RN",
    "codigoIbge": 2412005,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "59300",
    "uf": "RN",
    "codigoIbge": 2402006,
    "cidade": "Caicó"
  },
  {
    "prefixo": "59310",
    "uf": "RN",
    "codigoIbge": 2412104,
    "cidade": "São João do Sabugi"
  },
  {
    "prefixo": "59315",
    "uf": "RN",
    "codigoIbge": 2404804,
    "cidade": "Ipueira"
  },
  {
    "prefixo": "59318",
    "uf": "RN",
    "codigoIbge": 2413409,
    "cidade": "Serra Negra do Norte"
  },
  {
    "prefixo": "59320",
    "uf": "RN",
    "codigoIbge": 2414308,
    "cidade": "Timbaúba dos Batistas"
  },
  {
    "prefixo": "59324",
    "uf": "RN",
    "codigoIbge": 2405603,
    "cidade": "Jardim de Piranhas"
  },
  {
    "prefixo": "59327",
    "uf": "RN",
    "codigoIbge": 2411809,
    "cidade": "São Fernando"
  },
  {
    "prefixo": "59330",
    "uf": "RN",
    "codigoIbge": 2406106,
    "cidade": "Jucurutu"
  },
  {
    "prefixo": "59335",
    "uf": "RN",
    "codigoIbge": 2403806,
    "cidade": "Florânia"
  },
  {
    "prefixo": "59338",
    "uf": "RN",
    "codigoIbge": 2414159,
    "cidade": "Tenente Laurentino Cruz"
  },
  {
    "prefixo": "59340",
    "uf": "RN",
    "codigoIbge": 2413003,
    "cidade": "São Vicente"
  },
  {
    "prefixo": "59343",
    "uf": "RN",
    "codigoIbge": 2405702,
    "cidade": "Jardim do Seridó"
  },
  {
    "prefixo": "59347",
    "uf": "RN",
    "codigoIbge": 2408508,
    "cidade": "Ouro Branco"
  },
  {
    "prefixo": "59350",
    "uf": "RN",
    "codigoIbge": 2411429,
    "cidade": "Santana do Seridó"
  },
  {
    "prefixo": "59355",
    "uf": "RN",
    "codigoIbge": 2403400,
    "cidade": "Equador"
  },
  {
    "prefixo": "59360",
    "uf": "RN",
    "codigoIbge": 2408904,
    "cidade": "Parelhas"
  },
  {
    "prefixo": "59370",
    "uf": "RN",
    "codigoIbge": 2400109,
    "cidade": "Acari"
  },
  {
    "prefixo": "59374",
    "uf": "RN",
    "codigoIbge": 2402402,
    "cidade": "Carnaúba dos Dantas"
  },
  {
    "prefixo": "59375",
    "uf": "RN",
    "codigoIbge": 2403004,
    "cidade": "Cruzeta"
  },
  {
    "prefixo": "59378",
    "uf": "RN",
    "codigoIbge": 2412401,
    "cidade": "São José do Seridó"
  },
  {
    "prefixo": "59380",
    "uf": "RN",
    "codigoIbge": 2403103,
    "cidade": "Currais Novos"
  },
  {
    "prefixo": "59390",
    "uf": "RN",
    "codigoIbge": 2406502,
    "cidade": "Lagoa Nova"
  },
  {
    "prefixo": "59395",
    "uf": "RN",
    "codigoIbge": 2402709,
    "cidade": "Cerro Corá"
  },
  {
    "prefixo": "59400",
    "uf": "RN",
    "codigoIbge": 2412906,
    "cidade": "São Tomé"
  },
  {
    "prefixo": "59410",
    "uf": "RN",
    "codigoIbge": 2401503,
    "cidade": "Barcelona"
  },
  {
    "prefixo": "59420",
    "uf": "RN",
    "codigoIbge": 2411106,
    "cidade": "Ruy Barbosa"
  },
  {
    "prefixo": "59430",
    "uf": "RN",
    "codigoIbge": 2406403,
    "cidade": "Lagoa de Velhos"
  },
  {
    "prefixo": "59440",
    "uf": "RN",
    "codigoIbge": 2413706,
    "cidade": "Sítio Novo"
  },
  {
    "prefixo": "59445",
    "uf": "RN",
    "codigoIbge": 2413706,
    "cidade": "Sítio Novo"
  },
  {
    "prefixo": "59460",
    "uf": "RN",
    "codigoIbge": 2412609,
    "cidade": "São Paulo do Potengi"
  },
  {
    "prefixo": "59464",
    "uf": "RN",
    "codigoIbge": 2409332,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "59470",
    "uf": "RN",
    "codigoIbge": 2410900,
    "cidade": "Riachuelo"
  },
  {
    "prefixo": "59480",
    "uf": "RN",
    "codigoIbge": 2412708,
    "cidade": "São Pedro"
  },
  {
    "prefixo": "59490",
    "uf": "RN",
    "codigoIbge": 2404606,
    "cidade": "Ielmo Marinho"
  },
  {
    "prefixo": "59500",
    "uf": "RN",
    "codigoIbge": 2407203,
    "cidade": "Macau"
  },
  {
    "prefixo": "59504",
    "uf": "RN",
    "codigoIbge": 2409902,
    "cidade": "Pendências"
  },
  {
    "prefixo": "59507",
    "uf": "RN",
    "codigoIbge": 2400703,
    "cidade": "Alto do Rodrigues"
  },
  {
    "prefixo": "59508",
    "uf": "RN",
    "codigoIbge": 2404705,
    "cidade": "Ipanguaçu"
  },
  {
    "prefixo": "59510",
    "uf": "RN",
    "codigoIbge": 2400307,
    "cidade": "Afonso Bezerra"
  },
  {
    "prefixo": "59513",
    "uf": "RN",
    "codigoIbge": 2404853,
    "cidade": "Itajá"
  },
  {
    "prefixo": "59515",
    "uf": "RN",
    "codigoIbge": 2400802,
    "cidade": "Angicos"
  },
  {
    "prefixo": "59517",
    "uf": "RN",
    "codigoIbge": 2403756,
    "cidade": "Fernando Pedroza"
  },
  {
    "prefixo": "59518",
    "uf": "RN",
    "codigoIbge": 2412807,
    "cidade": "São Rafael"
  },
  {
    "prefixo": "59520",
    "uf": "RN",
    "codigoIbge": 2411403,
    "cidade": "Santana do Matos"
  },
  {
    "prefixo": "59522",
    "uf": "RN",
    "codigoIbge": 2411403,
    "cidade": "Santana do Matos"
  },
  {
    "prefixo": "59528",
    "uf": "RN",
    "codigoIbge": 2401651,
    "cidade": "Bodó"
  },
  {
    "prefixo": "59530",
    "uf": "RN",
    "codigoIbge": 2409704,
    "cidade": "Pedro Avelino"
  },
  {
    "prefixo": "59535",
    "uf": "RN",
    "codigoIbge": 2406700,
    "cidade": "Lajes"
  },
  {
    "prefixo": "59538",
    "uf": "RN",
    "codigoIbge": 2406700,
    "cidade": "Lajes"
  },
  {
    "prefixo": "59540",
    "uf": "RN",
    "codigoIbge": 2401909,
    "cidade": "Caiçara do Rio do Vento"
  },
  {
    "prefixo": "59544",
    "uf": "RN",
    "codigoIbge": 2405504,
    "cidade": "Jardim de Angicos"
  },
  {
    "prefixo": "59547",
    "uf": "RN",
    "codigoIbge": 2409605,
    "cidade": "Pedra Preta"
  },
  {
    "prefixo": "59550",
    "uf": "RN",
    "codigoIbge": 2405801,
    "cidade": "João Câmara"
  },
  {
    "prefixo": "59555",
    "uf": "RN",
    "codigoIbge": 2401602,
    "cidade": "Bento Fernandes"
  },
  {
    "prefixo": "59558",
    "uf": "RN",
    "codigoIbge": 2401602,
    "cidade": "Bento Fernandes"
  },
  {
    "prefixo": "59560",
    "uf": "RN",
    "codigoIbge": 2410108,
    "cidade": "Poço Branco"
  },
  {
    "prefixo": "59565",
    "uf": "RN",
    "codigoIbge": 2413904,
    "cidade": "Taipu"
  },
  {
    "prefixo": "59570",
    "uf": "RN",
    "codigoIbge": 2402600,
    "cidade": "Ceará-Mirim"
  },
  {
    "prefixo": "59575",
    "uf": "RN",
    "codigoIbge": 2403608,
    "cidade": "Extremoz"
  },
  {
    "prefixo": "59578",
    "uf": "RN",
    "codigoIbge": 2408953,
    "cidade": "Rio do Fogo"
  },
  {
    "prefixo": "59580",
    "uf": "RN",
    "codigoIbge": 2407500,
    "cidade": "Maxaranguape"
  },
  {
    "prefixo": "59582",
    "uf": "RN",
    "codigoIbge": 2410405,
    "cidade": "Pureza"
  },
  {
    "prefixo": "59583",
    "uf": "RN",
    "codigoIbge": 2410405,
    "cidade": "Pureza"
  },
  {
    "prefixo": "59584",
    "uf": "RN",
    "codigoIbge": 2414407,
    "cidade": "Touros"
  },
  {
    "prefixo": "59585",
    "uf": "RN",
    "codigoIbge": 2412559,
    "cidade": "São Miguel do Gostoso"
  },
  {
    "prefixo": "59586",
    "uf": "RN",
    "codigoIbge": 2408805,
    "cidade": "Parazinho"
  },
  {
    "prefixo": "59588",
    "uf": "RN",
    "codigoIbge": 2409506,
    "cidade": "Pedra Grande"
  },
  {
    "prefixo": "59589",
    "uf": "RN",
    "codigoIbge": 2407104,
    "cidade": "Macaíba"
  },
  {
    "prefixo": "59590",
    "uf": "RN",
    "codigoIbge": 2411601,
    "cidade": "São Bento do Norte"
  },
  {
    "prefixo": "59592",
    "uf": "RN",
    "codigoIbge": 2401859,
    "cidade": "Caiçara do Norte"
  },
  {
    "prefixo": "59594",
    "uf": "RN",
    "codigoIbge": 2405108,
    "cidade": "Jandaíra"
  },
  {
    "prefixo": "59596",
    "uf": "RN",
    "codigoIbge": 2404101,
    "cidade": "Galinhos"
  },
  {
    "prefixo": "59598",
    "uf": "RN",
    "codigoIbge": 2404507,
    "cidade": "Guamaré"
  },
  {
    "prefixo": "59600",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59603",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59604",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59605",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59607",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59608",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59609",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59610",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59611",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59612",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59613",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59614",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59615",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59616",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59617",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59618",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59619",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59620",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59621",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59622",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59623",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59625",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59626",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59627",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59628",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59630",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59631",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59632",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59633",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59634",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59635",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59640",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59642",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59643",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59645",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59646",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59649",
    "uf": "RN",
    "codigoIbge": 2408003,
    "cidade": "Mossoró"
  },
  {
    "prefixo": "59650",
    "uf": "RN",
    "codigoIbge": 2400208,
    "cidade": "Assú"
  },
  {
    "prefixo": "59655",
    "uf": "RN",
    "codigoIbge": 2401107,
    "cidade": "Areia Branca"
  },
  {
    "prefixo": "59660",
    "uf": "RN",
    "codigoIbge": 2408706,
    "cidade": "Paraú"
  },
  {
    "prefixo": "59663",
    "uf": "RN",
    "codigoIbge": 2413359,
    "cidade": "Serra do Mel"
  },
  {
    "prefixo": "59665",
    "uf": "RN",
    "codigoIbge": 2402501,
    "cidade": "Carnaubais"
  },
  {
    "prefixo": "59668",
    "uf": "RN",
    "codigoIbge": 2410256,
    "cidade": "Porto do Mangue"
  },
  {
    "prefixo": "59670",
    "uf": "RN",
    "codigoIbge": 2414605,
    "cidade": "Upanema"
  },
  {
    "prefixo": "59675",
    "uf": "RN",
    "codigoIbge": 2404408,
    "cidade": "Grossos"
  },
  {
    "prefixo": "59678",
    "uf": "RN",
    "codigoIbge": 2411056,
    "cidade": "Tibau"
  },
  {
    "prefixo": "59680",
    "uf": "RN",
    "codigoIbge": 2401305,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "59685",
    "uf": "RN",
    "codigoIbge": 2414456,
    "cidade": "Triunfo Potiguar"
  },
  {
    "prefixo": "59690",
    "uf": "RN",
    "codigoIbge": 2405207,
    "cidade": "Janduís"
  },
  {
    "prefixo": "59695",
    "uf": "RN",
    "codigoIbge": 2401453,
    "cidade": "Baraúna"
  },
  {
    "prefixo": "59700",
    "uf": "RN",
    "codigoIbge": 2401008,
    "cidade": "Apodi"
  },
  {
    "prefixo": "59730",
    "uf": "RN",
    "codigoIbge": 2408409,
    "cidade": "Olho d'Água do Borges"
  },
  {
    "prefixo": "59740",
    "uf": "RN",
    "codigoIbge": 2410603,
    "cidade": "Rafael Godeiro"
  },
  {
    "prefixo": "59760",
    "uf": "RN",
    "codigoIbge": 2400604,
    "cidade": "Almino Afonso"
  },
  {
    "prefixo": "59770",
    "uf": "RN",
    "codigoIbge": 2409308,
    "cidade": "Patu"
  },
  {
    "prefixo": "59775",
    "uf": "RN",
    "codigoIbge": 2407609,
    "cidade": "Messias Targino"
  },
  {
    "prefixo": "59780",
    "uf": "RN",
    "codigoIbge": 2402303,
    "cidade": "Caraúbas"
  },
  {
    "prefixo": "59785",
    "uf": "RN",
    "codigoIbge": 2402303,
    "cidade": "Caraúbas"
  },
  {
    "prefixo": "59790",
    "uf": "RN",
    "codigoIbge": 2404309,
    "cidade": "Governador Dix-Sept Rosado"
  },
  {
    "prefixo": "59795",
    "uf": "RN",
    "codigoIbge": 2403707,
    "cidade": "Felipe Guerra"
  },
  {
    "prefixo": "59800",
    "uf": "RN",
    "codigoIbge": 2407401,
    "cidade": "Martins"
  },
  {
    "prefixo": "59805",
    "uf": "RN",
    "codigoIbge": 2406908,
    "cidade": "Lucrécia"
  },
  {
    "prefixo": "59808",
    "uf": "RN",
    "codigoIbge": 2413557,
    "cidade": "Serrinha dos Pintos"
  },
  {
    "prefixo": "59810",
    "uf": "RN",
    "codigoIbge": 2410207,
    "cidade": "Portalegre"
  },
  {
    "prefixo": "59815",
    "uf": "RN",
    "codigoIbge": 2414902,
    "cidade": "Viçosa"
  },
  {
    "prefixo": "59820",
    "uf": "RN",
    "codigoIbge": 2410702,
    "cidade": "Riacho da Cruz"
  },
  {
    "prefixo": "59830",
    "uf": "RN",
    "codigoIbge": 2411007,
    "cidade": "Rodolfo Fernandes"
  },
  {
    "prefixo": "59840",
    "uf": "RN",
    "codigoIbge": 2413805,
    "cidade": "Taboleiro Grande"
  },
  {
    "prefixo": "59855",
    "uf": "RN",
    "codigoIbge": 2404903,
    "cidade": "Itaú"
  },
  {
    "prefixo": "59856",
    "uf": "RN",
    "codigoIbge": 2413607,
    "cidade": "Severiano Melo"
  },
  {
    "prefixo": "59865",
    "uf": "RN",
    "codigoIbge": 2414506,
    "cidade": "Umarizal"
  },
  {
    "prefixo": "59870",
    "uf": "RN",
    "codigoIbge": 2400901,
    "cidade": "Antônio Martins"
  },
  {
    "prefixo": "59880",
    "uf": "RN",
    "codigoIbge": 2405900,
    "cidade": "João Dias"
  },
  {
    "prefixo": "59885",
    "uf": "RN",
    "codigoIbge": 2405900,
    "cidade": "João Dias"
  },
  {
    "prefixo": "59890",
    "uf": "RN",
    "codigoIbge": 2404002,
    "cidade": "Frutuoso Gomes"
  },
  {
    "prefixo": "59900",
    "uf": "RN",
    "codigoIbge": 2409407,
    "cidade": "Pau dos Ferros"
  },
  {
    "prefixo": "59902",
    "uf": "RN",
    "codigoIbge": 2403905,
    "cidade": "Francisco Dantas"
  },
  {
    "prefixo": "59905",
    "uf": "RN",
    "codigoIbge": 2403301,
    "cidade": "Encanto"
  },
  {
    "prefixo": "59908",
    "uf": "RN",
    "codigoIbge": 2411908,
    "cidade": "São Francisco do Oeste"
  },
  {
    "prefixo": "59910",
    "uf": "RN",
    "codigoIbge": 2403202,
    "cidade": "Doutor Severiano"
  },
  {
    "prefixo": "59920",
    "uf": "RN",
    "codigoIbge": 2412500,
    "cidade": "São Miguel"
  },
  {
    "prefixo": "59925",
    "uf": "RN",
    "codigoIbge": 2414753,
    "cidade": "Venha-Ver"
  },
  {
    "prefixo": "59930",
    "uf": "RN",
    "codigoIbge": 2402907,
    "cidade": "Coronel João Pessoa"
  },
  {
    "prefixo": "59940",
    "uf": "RN",
    "codigoIbge": 2407005,
    "cidade": "Luís Gomes"
  },
  {
    "prefixo": "59945",
    "uf": "RN",
    "codigoIbge": 2407252,
    "cidade": "Major Sales"
  },
  {
    "prefixo": "59950",
    "uf": "RN",
    "codigoIbge": 2408607,
    "cidade": "Paraná"
  },
  {
    "prefixo": "59955",
    "uf": "RN",
    "codigoIbge": 2414100,
    "cidade": "Tenente Ananias"
  },
  {
    "prefixo": "59960",
    "uf": "RN",
    "codigoIbge": 2410009,
    "cidade": "Pilões"
  },
  {
    "prefixo": "59965",
    "uf": "RN",
    "codigoIbge": 2400505,
    "cidade": "Alexandria"
  },
  {
    "prefixo": "59970",
    "uf": "RN",
    "codigoIbge": 2407302,
    "cidade": "Marcelino Vieira"
  },
  {
    "prefixo": "59980",
    "uf": "RN",
    "codigoIbge": 2406007,
    "cidade": "José da Penha"
  },
  {
    "prefixo": "59985",
    "uf": "RN",
    "codigoIbge": 2406007,
    "cidade": "José da Penha"
  },
  {
    "prefixo": "59987",
    "uf": "RN",
    "codigoIbge": 2410801,
    "cidade": "Riacho de Santana"
  },
  {
    "prefixo": "59990",
    "uf": "RN",
    "codigoIbge": 2410504,
    "cidade": "Rafael Fernandes"
  },
  {
    "prefixo": "59995",
    "uf": "RN",
    "codigoIbge": 2400406,
    "cidade": "Água Nova"
  },
  {
    "prefixo": "60010",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60011",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60015",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60020",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60025",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60030",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60035",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60040",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60050",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60055",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60060",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60110",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60115",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60120",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60125",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60130",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60131",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60135",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60140",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60150",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60160",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60165",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60170",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60175",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60176",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60177",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60180",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60181",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60182",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60183",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60184",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60190",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60191",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60192",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60310",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60311",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60312",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60320",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60321",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60325",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60326",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60330",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60331",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60332",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60333",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60334",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60335",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60336",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60337",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60340",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60341",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60342",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60345",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60346",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60347",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60348",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60349",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60350",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60351",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60352",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60353",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60355",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60356",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60357",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60360",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60361",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60410",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60411",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60415",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60416",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60420",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60421",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60422",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60425",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60426",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60430",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60431",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60440",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60441",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60442",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60450",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60455",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60510",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60511",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60512",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60520",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60521",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60525",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60526",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60527",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60530",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60531",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60532",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60533",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60534",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60535",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60540",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60541",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60542",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60543",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60544",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60545",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60546",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60710",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60711",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60712",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60713",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60714",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60720",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60721",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60730",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60731",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60732",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60733",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60734",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60736",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60740",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60741",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60742",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60743",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60744",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60745",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60748",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60749",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60750",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60751",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60752",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60760",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60761",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60762",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60763",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60764",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60765",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60766",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60767",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60768",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60810",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60811",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60812",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60813",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60820",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60821",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60822",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60823",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60824",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60830",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60831",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60832",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60833",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60834",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60835",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60836",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60840",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60841",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60842",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60843",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60844",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60850",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60851",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60860",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60861",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60862",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60863",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60864",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60865",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60866",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60867",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60868",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60870",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60871",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60872",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60873",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60874",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60875",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60876",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60877",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "60878",
    "uf": "CE",
    "codigoIbge": 2304400,
    "cidade": "Fortaleza"
  },
  {
    "prefixo": "61600",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61601",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61602",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61603",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61604",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61605",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61606",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61607",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61608",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61609",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61610",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61611",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61614",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61615",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61616",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61617",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61618",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61619",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61620",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61621",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61622",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61623",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61624",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61625",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61626",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61627",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61628",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61629",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61631",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61634",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61635",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61636",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61637",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61638",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61640",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61642",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61645",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61648",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61650",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61651",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61652",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61654",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61655",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61656",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61658",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61659",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61660",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61661",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61663",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61673",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61676",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61677",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61680",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61685",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61688",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61690",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61695",
    "uf": "CE",
    "codigoIbge": 2303709,
    "cidade": "Caucaia"
  },
  {
    "prefixo": "61700",
    "uf": "CE",
    "codigoIbge": 2301000,
    "cidade": "Aquiraz"
  },
  {
    "prefixo": "61751",
    "uf": "CE",
    "codigoIbge": 2301000,
    "cidade": "Aquiraz"
  },
  {
    "prefixo": "61752",
    "uf": "CE",
    "codigoIbge": 2301000,
    "cidade": "Aquiraz"
  },
  {
    "prefixo": "61753",
    "uf": "CE",
    "codigoIbge": 2301000,
    "cidade": "Aquiraz"
  },
  {
    "prefixo": "61754",
    "uf": "CE",
    "codigoIbge": 2301000,
    "cidade": "Aquiraz"
  },
  {
    "prefixo": "61755",
    "uf": "CE",
    "codigoIbge": 2301000,
    "cidade": "Aquiraz"
  },
  {
    "prefixo": "61756",
    "uf": "CE",
    "codigoIbge": 2301000,
    "cidade": "Aquiraz"
  },
  {
    "prefixo": "61758",
    "uf": "CE",
    "codigoIbge": 2301000,
    "cidade": "Aquiraz"
  },
  {
    "prefixo": "61760",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61761",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61762",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61763",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61765",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61766",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61767",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61768",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61769",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61770",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61771",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61772",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61773",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61774",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61775",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61776",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61777",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61778",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61779",
    "uf": "CE",
    "codigoIbge": 2304285,
    "cidade": "Eusébio"
  },
  {
    "prefixo": "61800",
    "uf": "CE",
    "codigoIbge": 2309706,
    "cidade": "Pacatuba"
  },
  {
    "prefixo": "61801",
    "uf": "CE",
    "codigoIbge": 2309706,
    "cidade": "Pacatuba"
  },
  {
    "prefixo": "61802",
    "uf": "CE",
    "codigoIbge": 2309706,
    "cidade": "Pacatuba"
  },
  {
    "prefixo": "61803",
    "uf": "CE",
    "codigoIbge": 2309706,
    "cidade": "Pacatuba"
  },
  {
    "prefixo": "61805",
    "uf": "CE",
    "codigoIbge": 2309706,
    "cidade": "Pacatuba"
  },
  {
    "prefixo": "61808",
    "uf": "CE",
    "codigoIbge": 2309706,
    "cidade": "Pacatuba"
  },
  {
    "prefixo": "61809",
    "uf": "CE",
    "codigoIbge": 2309706,
    "cidade": "Pacatuba"
  },
  {
    "prefixo": "61810",
    "uf": "CE",
    "codigoIbge": 2309706,
    "cidade": "Pacatuba"
  },
  {
    "prefixo": "61813",
    "uf": "CE",
    "codigoIbge": 2309706,
    "cidade": "Pacatuba"
  },
  {
    "prefixo": "61814",
    "uf": "CE",
    "codigoIbge": 2309706,
    "cidade": "Pacatuba"
  },
  {
    "prefixo": "61860",
    "uf": "CE",
    "codigoIbge": 2309706,
    "cidade": "Pacatuba"
  },
  {
    "prefixo": "61870",
    "uf": "CE",
    "codigoIbge": 2309706,
    "cidade": "Pacatuba"
  },
  {
    "prefixo": "61880",
    "uf": "CE",
    "codigoIbge": 2306256,
    "cidade": "Itaitinga"
  },
  {
    "prefixo": "61881",
    "uf": "CE",
    "codigoIbge": 2306256,
    "cidade": "Itaitinga"
  },
  {
    "prefixo": "61882",
    "uf": "CE",
    "codigoIbge": 2306256,
    "cidade": "Itaitinga"
  },
  {
    "prefixo": "61883",
    "uf": "CE",
    "codigoIbge": 2306256,
    "cidade": "Itaitinga"
  },
  {
    "prefixo": "61884",
    "uf": "CE",
    "codigoIbge": 2306256,
    "cidade": "Itaitinga"
  },
  {
    "prefixo": "61885",
    "uf": "CE",
    "codigoIbge": 2306256,
    "cidade": "Itaitinga"
  },
  {
    "prefixo": "61887",
    "uf": "CE",
    "codigoIbge": 2306256,
    "cidade": "Itaitinga"
  },
  {
    "prefixo": "61888",
    "uf": "CE",
    "codigoIbge": 2306256,
    "cidade": "Itaitinga"
  },
  {
    "prefixo": "61890",
    "uf": "CE",
    "codigoIbge": 2304954,
    "cidade": "Guaiúba"
  },
  {
    "prefixo": "61893",
    "uf": "CE",
    "codigoIbge": 2304954,
    "cidade": "Guaiúba"
  },
  {
    "prefixo": "61895",
    "uf": "CE",
    "codigoIbge": 2304954,
    "cidade": "Guaiúba"
  },
  {
    "prefixo": "61896",
    "uf": "CE",
    "codigoIbge": 2304954,
    "cidade": "Guaiúba"
  },
  {
    "prefixo": "61897",
    "uf": "CE",
    "codigoIbge": 2304954,
    "cidade": "Guaiúba"
  },
  {
    "prefixo": "61900",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61901",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61902",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61903",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61904",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61905",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61906",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61907",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61908",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61909",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61910",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61911",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61912",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61913",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61914",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61915",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61916",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61917",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61919",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61920",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61921",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61922",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61923",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61924",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61925",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61930",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61931",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61932",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61933",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61934",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61935",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61936",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61939",
    "uf": "CE",
    "codigoIbge": 2307650,
    "cidade": "Maracanaú"
  },
  {
    "prefixo": "61940",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61941",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61942",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61943",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61944",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61945",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61946",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61948",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61949",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61950",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61953",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61955",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61956",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61959",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61962",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61967",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61973",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61976",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61977",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61979",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61982",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61984",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61988",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61991",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "61994",
    "uf": "CE",
    "codigoIbge": 2307700,
    "cidade": "Maranguape"
  },
  {
    "prefixo": "62000",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62010",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62011",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62014",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62015",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62016",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62020",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62021",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62022",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62023",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62030",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62031",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62032",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62033",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62034",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62038",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62039",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62040",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62041",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62042",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62043",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62044",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62045",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62050",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62051",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62052",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62053",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62055",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62099",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62102",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62103",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62104",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62105",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62106",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62107",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62108",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62109",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62110",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62111",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62112",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62113",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62114",
    "uf": "CE",
    "codigoIbge": 2312908,
    "cidade": "Sobral"
  },
  {
    "prefixo": "62115",
    "uf": "CE",
    "codigoIbge": 2304350,
    "cidade": "Forquilha"
  },
  {
    "prefixo": "62118",
    "uf": "CE",
    "codigoIbge": 2304350,
    "cidade": "Forquilha"
  },
  {
    "prefixo": "62119",
    "uf": "CE",
    "codigoIbge": 2304350,
    "cidade": "Forquilha"
  },
  {
    "prefixo": "62120",
    "uf": "CE",
    "codigoIbge": 2300507,
    "cidade": "Alcântaras"
  },
  {
    "prefixo": "62125",
    "uf": "CE",
    "codigoIbge": 2300507,
    "cidade": "Alcântaras"
  },
  {
    "prefixo": "62130",
    "uf": "CE",
    "codigoIbge": 2308203,
    "cidade": "Meruoca"
  },
  {
    "prefixo": "62132",
    "uf": "CE",
    "codigoIbge": 2308203,
    "cidade": "Meruoca"
  },
  {
    "prefixo": "62134",
    "uf": "CE",
    "codigoIbge": 2308203,
    "cidade": "Meruoca"
  },
  {
    "prefixo": "62136",
    "uf": "CE",
    "codigoIbge": 2308203,
    "cidade": "Meruoca"
  },
  {
    "prefixo": "62137",
    "uf": "CE",
    "codigoIbge": 2308203,
    "cidade": "Meruoca"
  },
  {
    "prefixo": "62140",
    "uf": "CE",
    "codigoIbge": 2308005,
    "cidade": "Massapê"
  },
  {
    "prefixo": "62141",
    "uf": "CE",
    "codigoIbge": 2308005,
    "cidade": "Massapê"
  },
  {
    "prefixo": "62143",
    "uf": "CE",
    "codigoIbge": 2308005,
    "cidade": "Massapê"
  },
  {
    "prefixo": "62144",
    "uf": "CE",
    "codigoIbge": 2308005,
    "cidade": "Massapê"
  },
  {
    "prefixo": "62146",
    "uf": "CE",
    "codigoIbge": 2308005,
    "cidade": "Massapê"
  },
  {
    "prefixo": "62150",
    "uf": "CE",
    "codigoIbge": 2312007,
    "cidade": "Santana do Acaraú"
  },
  {
    "prefixo": "62158",
    "uf": "CE",
    "codigoIbge": 2312007,
    "cidade": "Santana do Acaraú"
  },
  {
    "prefixo": "62159",
    "uf": "CE",
    "codigoIbge": 2312007,
    "cidade": "Santana do Acaraú"
  },
  {
    "prefixo": "62160",
    "uf": "CE",
    "codigoIbge": 2304004,
    "cidade": "Coreaú"
  },
  {
    "prefixo": "62163",
    "uf": "CE",
    "codigoIbge": 2304004,
    "cidade": "Coreaú"
  },
  {
    "prefixo": "62165",
    "uf": "CE",
    "codigoIbge": 2304004,
    "cidade": "Coreaú"
  },
  {
    "prefixo": "62168",
    "uf": "CE",
    "codigoIbge": 2304004,
    "cidade": "Coreaú"
  },
  {
    "prefixo": "62170",
    "uf": "CE",
    "codigoIbge": 2309003,
    "cidade": "Mucambo"
  },
  {
    "prefixo": "62178",
    "uf": "CE",
    "codigoIbge": 2309003,
    "cidade": "Mucambo"
  },
  {
    "prefixo": "62180",
    "uf": "CE",
    "codigoIbge": 2309904,
    "cidade": "Pacujá"
  },
  {
    "prefixo": "62184",
    "uf": "CE",
    "codigoIbge": 2303105,
    "cidade": "Cariré"
  },
  {
    "prefixo": "62188",
    "uf": "CE",
    "codigoIbge": 2303105,
    "cidade": "Cariré"
  },
  {
    "prefixo": "62190",
    "uf": "CE",
    "codigoIbge": 2304905,
    "cidade": "Groaíras"
  },
  {
    "prefixo": "62199",
    "uf": "CE",
    "codigoIbge": 2304905,
    "cidade": "Groaíras"
  },
  {
    "prefixo": "62200",
    "uf": "CE",
    "codigoIbge": 2309300,
    "cidade": "Nova Russas"
  },
  {
    "prefixo": "62203",
    "uf": "CE",
    "codigoIbge": 2309300,
    "cidade": "Nova Russas"
  },
  {
    "prefixo": "62205",
    "uf": "CE",
    "codigoIbge": 2309300,
    "cidade": "Nova Russas"
  },
  {
    "prefixo": "62207",
    "uf": "CE",
    "codigoIbge": 2309300,
    "cidade": "Nova Russas"
  },
  {
    "prefixo": "62208",
    "uf": "CE",
    "codigoIbge": 2309300,
    "cidade": "Nova Russas"
  },
  {
    "prefixo": "62209",
    "uf": "CE",
    "codigoIbge": 2309300,
    "cidade": "Nova Russas"
  },
  {
    "prefixo": "62210",
    "uf": "CE",
    "codigoIbge": 2301257,
    "cidade": "Ararendá"
  },
  {
    "prefixo": "62213",
    "uf": "CE",
    "codigoIbge": 2301257,
    "cidade": "Ararendá"
  },
  {
    "prefixo": "62215",
    "uf": "CE",
    "codigoIbge": 2305654,
    "cidade": "Ipaporanga"
  },
  {
    "prefixo": "62218",
    "uf": "CE",
    "codigoIbge": 2305654,
    "cidade": "Ipaporanga"
  },
  {
    "prefixo": "62220",
    "uf": "CE",
    "codigoIbge": 2311009,
    "cidade": "Poranga"
  },
  {
    "prefixo": "62225",
    "uf": "CE",
    "codigoIbge": 2311009,
    "cidade": "Poranga"
  },
  {
    "prefixo": "62227",
    "uf": "CE",
    "codigoIbge": 2311009,
    "cidade": "Poranga"
  },
  {
    "prefixo": "62228",
    "uf": "CE",
    "codigoIbge": 2311009,
    "cidade": "Poranga"
  },
  {
    "prefixo": "62230",
    "uf": "CE",
    "codigoIbge": 2305902,
    "cidade": "Ipueiras"
  },
  {
    "prefixo": "62232",
    "uf": "CE",
    "codigoIbge": 2305902,
    "cidade": "Ipueiras"
  },
  {
    "prefixo": "62233",
    "uf": "CE",
    "codigoIbge": 2305902,
    "cidade": "Ipueiras"
  },
  {
    "prefixo": "62235",
    "uf": "CE",
    "codigoIbge": 2305902,
    "cidade": "Ipueiras"
  },
  {
    "prefixo": "62236",
    "uf": "CE",
    "codigoIbge": 2305902,
    "cidade": "Ipueiras"
  },
  {
    "prefixo": "62237",
    "uf": "CE",
    "codigoIbge": 2305902,
    "cidade": "Ipueiras"
  },
  {
    "prefixo": "62238",
    "uf": "CE",
    "codigoIbge": 2305902,
    "cidade": "Ipueiras"
  },
  {
    "prefixo": "62240",
    "uf": "CE",
    "codigoIbge": 2305902,
    "cidade": "Ipueiras"
  },
  {
    "prefixo": "62245",
    "uf": "CE",
    "codigoIbge": 2305902,
    "cidade": "Ipueiras"
  },
  {
    "prefixo": "62249",
    "uf": "CE",
    "codigoIbge": 2305902,
    "cidade": "Ipueiras"
  },
  {
    "prefixo": "62250",
    "uf": "CE",
    "codigoIbge": 2305803,
    "cidade": "Ipu"
  },
  {
    "prefixo": "62251",
    "uf": "CE",
    "codigoIbge": 2305803,
    "cidade": "Ipu"
  },
  {
    "prefixo": "62252",
    "uf": "CE",
    "codigoIbge": 2305803,
    "cidade": "Ipu"
  },
  {
    "prefixo": "62254",
    "uf": "CE",
    "codigoIbge": 2305803,
    "cidade": "Ipu"
  },
  {
    "prefixo": "62255",
    "uf": "CE",
    "codigoIbge": 2310951,
    "cidade": "Pires Ferreira"
  },
  {
    "prefixo": "62259",
    "uf": "CE",
    "codigoIbge": 2310951,
    "cidade": "Pires Ferreira"
  },
  {
    "prefixo": "62260",
    "uf": "CE",
    "codigoIbge": 2311702,
    "cidade": "Reriutaba"
  },
  {
    "prefixo": "62263",
    "uf": "CE",
    "codigoIbge": 2311702,
    "cidade": "Reriutaba"
  },
  {
    "prefixo": "62265",
    "uf": "CE",
    "codigoIbge": 2313955,
    "cidade": "Varjota"
  },
  {
    "prefixo": "62269",
    "uf": "CE",
    "codigoIbge": 2313955,
    "cidade": "Varjota"
  },
  {
    "prefixo": "62270",
    "uf": "CE",
    "codigoIbge": 2305209,
    "cidade": "Hidrolândia"
  },
  {
    "prefixo": "62273",
    "uf": "CE",
    "codigoIbge": 2305209,
    "cidade": "Hidrolândia"
  },
  {
    "prefixo": "62275",
    "uf": "CE",
    "codigoIbge": 2305209,
    "cidade": "Hidrolândia"
  },
  {
    "prefixo": "62280",
    "uf": "CE",
    "codigoIbge": 2312205,
    "cidade": "Santa Quitéria"
  },
  {
    "prefixo": "62283",
    "uf": "CE",
    "codigoIbge": 2312205,
    "cidade": "Santa Quitéria"
  },
  {
    "prefixo": "62285",
    "uf": "CE",
    "codigoIbge": 2312205,
    "cidade": "Santa Quitéria"
  },
  {
    "prefixo": "62290",
    "uf": "CE",
    "codigoIbge": 2312205,
    "cidade": "Santa Quitéria"
  },
  {
    "prefixo": "62292",
    "uf": "CE",
    "codigoIbge": 2312205,
    "cidade": "Santa Quitéria"
  },
  {
    "prefixo": "62293",
    "uf": "CE",
    "codigoIbge": 2312205,
    "cidade": "Santa Quitéria"
  },
  {
    "prefixo": "62294",
    "uf": "CE",
    "codigoIbge": 2312205,
    "cidade": "Santa Quitéria"
  },
  {
    "prefixo": "62296",
    "uf": "CE",
    "codigoIbge": 2312205,
    "cidade": "Santa Quitéria"
  },
  {
    "prefixo": "62297",
    "uf": "CE",
    "codigoIbge": 2303659,
    "cidade": "Catunda"
  },
  {
    "prefixo": "62298",
    "uf": "CE",
    "codigoIbge": 2303659,
    "cidade": "Catunda"
  },
  {
    "prefixo": "62300",
    "uf": "CE",
    "codigoIbge": 2314102,
    "cidade": "Viçosa do Ceará"
  },
  {
    "prefixo": "62303",
    "uf": "CE",
    "codigoIbge": 2314102,
    "cidade": "Viçosa do Ceará"
  },
  {
    "prefixo": "62306",
    "uf": "CE",
    "codigoIbge": 2314102,
    "cidade": "Viçosa do Ceará"
  },
  {
    "prefixo": "62308",
    "uf": "CE",
    "codigoIbge": 2314102,
    "cidade": "Viçosa do Ceará"
  },
  {
    "prefixo": "62310",
    "uf": "CE",
    "codigoIbge": 2314102,
    "cidade": "Viçosa do Ceará"
  },
  {
    "prefixo": "62315",
    "uf": "CE",
    "codigoIbge": 2314102,
    "cidade": "Viçosa do Ceará"
  },
  {
    "prefixo": "62316",
    "uf": "CE",
    "codigoIbge": 2314102,
    "cidade": "Viçosa do Ceará"
  },
  {
    "prefixo": "62320",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62321",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62322",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62323",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62324",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62325",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62326",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62327",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62328",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62329",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62330",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62331",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62334",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62335",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62337",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62338",
    "uf": "CE",
    "codigoIbge": 2313401,
    "cidade": "Tianguá"
  },
  {
    "prefixo": "62340",
    "uf": "CE",
    "codigoIbge": 2304509,
    "cidade": "Frecheirinha"
  },
  {
    "prefixo": "62350",
    "uf": "CE",
    "codigoIbge": 2313609,
    "cidade": "Ubajara"
  },
  {
    "prefixo": "62352",
    "uf": "CE",
    "codigoIbge": 2313609,
    "cidade": "Ubajara"
  },
  {
    "prefixo": "62354",
    "uf": "CE",
    "codigoIbge": 2313609,
    "cidade": "Ubajara"
  },
  {
    "prefixo": "62360",
    "uf": "CE",
    "codigoIbge": 2305308,
    "cidade": "Ibiapina"
  },
  {
    "prefixo": "62362",
    "uf": "CE",
    "codigoIbge": 2305308,
    "cidade": "Ibiapina"
  },
  {
    "prefixo": "62363",
    "uf": "CE",
    "codigoIbge": 2305308,
    "cidade": "Ibiapina"
  },
  {
    "prefixo": "62364",
    "uf": "CE",
    "codigoIbge": 2305308,
    "cidade": "Ibiapina"
  },
  {
    "prefixo": "62365",
    "uf": "CE",
    "codigoIbge": 2304657,
    "cidade": "Graça"
  },
  {
    "prefixo": "62370",
    "uf": "CE",
    "codigoIbge": 2312304,
    "cidade": "São Benedito"
  },
  {
    "prefixo": "62373",
    "uf": "CE",
    "codigoIbge": 2312304,
    "cidade": "São Benedito"
  },
  {
    "prefixo": "62374",
    "uf": "CE",
    "codigoIbge": 2312304,
    "cidade": "São Benedito"
  },
  {
    "prefixo": "62375",
    "uf": "CE",
    "codigoIbge": 2303402,
    "cidade": "Carnaubal"
  },
  {
    "prefixo": "62377",
    "uf": "CE",
    "codigoIbge": 2303402,
    "cidade": "Carnaubal"
  },
  {
    "prefixo": "62380",
    "uf": "CE",
    "codigoIbge": 2305001,
    "cidade": "Guaraciaba do Norte"
  },
  {
    "prefixo": "62385",
    "uf": "CE",
    "codigoIbge": 2305001,
    "cidade": "Guaraciaba do Norte"
  },
  {
    "prefixo": "62386",
    "uf": "CE",
    "codigoIbge": 2305001,
    "cidade": "Guaraciaba do Norte"
  },
  {
    "prefixo": "62388",
    "uf": "CE",
    "codigoIbge": 2305001,
    "cidade": "Guaraciaba do Norte"
  },
  {
    "prefixo": "62390",
    "uf": "CE",
    "codigoIbge": 2304236,
    "cidade": "Croatá"
  },
  {
    "prefixo": "62393",
    "uf": "CE",
    "codigoIbge": 2304236,
    "cidade": "Croatá"
  },
  {
    "prefixo": "62395",
    "uf": "CE",
    "codigoIbge": 2304236,
    "cidade": "Croatá"
  },
  {
    "prefixo": "62396",
    "uf": "CE",
    "codigoIbge": 2304236,
    "cidade": "Croatá"
  },
  {
    "prefixo": "62399",
    "uf": "CE",
    "codigoIbge": 2304236,
    "cidade": "Croatá"
  },
  {
    "prefixo": "62400",
    "uf": "CE",
    "codigoIbge": 2302602,
    "cidade": "Camocim"
  },
  {
    "prefixo": "62405",
    "uf": "CE",
    "codigoIbge": 2302602,
    "cidade": "Camocim"
  },
  {
    "prefixo": "62410",
    "uf": "CE",
    "codigoIbge": 2302057,
    "cidade": "Barroquinha"
  },
  {
    "prefixo": "62414",
    "uf": "CE",
    "codigoIbge": 2302057,
    "cidade": "Barroquinha"
  },
  {
    "prefixo": "62420",
    "uf": "CE",
    "codigoIbge": 2303907,
    "cidade": "Chaval"
  },
  {
    "prefixo": "62425",
    "uf": "CE",
    "codigoIbge": 2303907,
    "cidade": "Chaval"
  },
  {
    "prefixo": "62430",
    "uf": "CE",
    "codigoIbge": 2304707,
    "cidade": "Granja"
  },
  {
    "prefixo": "62433",
    "uf": "CE",
    "codigoIbge": 2304707,
    "cidade": "Granja"
  },
  {
    "prefixo": "62435",
    "uf": "CE",
    "codigoIbge": 2304707,
    "cidade": "Granja"
  },
  {
    "prefixo": "62437",
    "uf": "CE",
    "codigoIbge": 2304707,
    "cidade": "Granja"
  },
  {
    "prefixo": "62440",
    "uf": "CE",
    "codigoIbge": 2304707,
    "cidade": "Granja"
  },
  {
    "prefixo": "62445",
    "uf": "CE",
    "codigoIbge": 2304707,
    "cidade": "Granja"
  },
  {
    "prefixo": "62448",
    "uf": "CE",
    "codigoIbge": 2304707,
    "cidade": "Granja"
  },
  {
    "prefixo": "62450",
    "uf": "CE",
    "codigoIbge": 2307908,
    "cidade": "Martinópole"
  },
  {
    "prefixo": "62460",
    "uf": "CE",
    "codigoIbge": 2313906,
    "cidade": "Uruoca"
  },
  {
    "prefixo": "62465",
    "uf": "CE",
    "codigoIbge": 2313906,
    "cidade": "Uruoca"
  },
  {
    "prefixo": "62468",
    "uf": "CE",
    "codigoIbge": 2313906,
    "cidade": "Uruoca"
  },
  {
    "prefixo": "62470",
    "uf": "CE",
    "codigoIbge": 2312809,
    "cidade": "Senador Sá"
  },
  {
    "prefixo": "62475",
    "uf": "CE",
    "codigoIbge": 2312809,
    "cidade": "Senador Sá"
  },
  {
    "prefixo": "62477",
    "uf": "CE",
    "codigoIbge": 2312809,
    "cidade": "Senador Sá"
  },
  {
    "prefixo": "62480",
    "uf": "CE",
    "codigoIbge": 2308807,
    "cidade": "Moraújo"
  },
  {
    "prefixo": "62485",
    "uf": "CE",
    "codigoIbge": 2308807,
    "cidade": "Moraújo"
  },
  {
    "prefixo": "62500",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62501",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62502",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62503",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62504",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62505",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62507",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62508",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62509",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62510",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62511",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62512",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62514",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62515",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62518",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62520",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62525",
    "uf": "CE",
    "codigoIbge": 2306405,
    "cidade": "Itapipoca"
  },
  {
    "prefixo": "62530",
    "uf": "CE",
    "codigoIbge": 2308377,
    "cidade": "Miraíma"
  },
  {
    "prefixo": "62533",
    "uf": "CE",
    "codigoIbge": 2308377,
    "cidade": "Miraíma"
  },
  {
    "prefixo": "62534",
    "uf": "CE",
    "codigoIbge": 2308377,
    "cidade": "Miraíma"
  },
  {
    "prefixo": "62535",
    "uf": "CE",
    "codigoIbge": 2308377,
    "cidade": "Miraíma"
  },
  {
    "prefixo": "62540",
    "uf": "CE",
    "codigoIbge": 2300754,
    "cidade": "Amontada"
  },
  {
    "prefixo": "62543",
    "uf": "CE",
    "codigoIbge": 2300754,
    "cidade": "Amontada"
  },
  {
    "prefixo": "62544",
    "uf": "CE",
    "codigoIbge": 2300754,
    "cidade": "Amontada"
  },
  {
    "prefixo": "62547",
    "uf": "CE",
    "codigoIbge": 2300754,
    "cidade": "Amontada"
  },
  {
    "prefixo": "62548",
    "uf": "CE",
    "codigoIbge": 2300754,
    "cidade": "Amontada"
  },
  {
    "prefixo": "62549",
    "uf": "CE",
    "codigoIbge": 2300754,
    "cidade": "Amontada"
  },
  {
    "prefixo": "62550",
    "uf": "CE",
    "codigoIbge": 2308906,
    "cidade": "Morrinhos"
  },
  {
    "prefixo": "62559",
    "uf": "CE",
    "codigoIbge": 2308906,
    "cidade": "Morrinhos"
  },
  {
    "prefixo": "62560",
    "uf": "CE",
    "codigoIbge": 2307809,
    "cidade": "Marco"
  },
  {
    "prefixo": "62564",
    "uf": "CE",
    "codigoIbge": 2307809,
    "cidade": "Marco"
  },
  {
    "prefixo": "62565",
    "uf": "CE",
    "codigoIbge": 2307809,
    "cidade": "Marco"
  },
  {
    "prefixo": "62570",
    "uf": "CE",
    "codigoIbge": 2302305,
    "cidade": "Bela Cruz"
  },
  {
    "prefixo": "62575",
    "uf": "CE",
    "codigoIbge": 2302305,
    "cidade": "Bela Cruz"
  },
  {
    "prefixo": "62580",
    "uf": "CE",
    "codigoIbge": 2300200,
    "cidade": "Acaraú"
  },
  {
    "prefixo": "62583",
    "uf": "CE",
    "codigoIbge": 2300200,
    "cidade": "Acaraú"
  },
  {
    "prefixo": "62584",
    "uf": "CE",
    "codigoIbge": 2300200,
    "cidade": "Acaraú"
  },
  {
    "prefixo": "62585",
    "uf": "CE",
    "codigoIbge": 2300200,
    "cidade": "Acaraú"
  },
  {
    "prefixo": "62586",
    "uf": "CE",
    "codigoIbge": 2300200,
    "cidade": "Acaraú"
  },
  {
    "prefixo": "62590",
    "uf": "CE",
    "codigoIbge": 2306553,
    "cidade": "Itarema"
  },
  {
    "prefixo": "62592",
    "uf": "CE",
    "codigoIbge": 2306553,
    "cidade": "Itarema"
  },
  {
    "prefixo": "62595",
    "uf": "CE",
    "codigoIbge": 2304251,
    "cidade": "Cruz"
  },
  {
    "prefixo": "62597",
    "uf": "CE",
    "codigoIbge": 2304251,
    "cidade": "Cruz"
  },
  {
    "prefixo": "62598",
    "uf": "CE",
    "codigoIbge": 2307254,
    "cidade": "Jijoca de Jericoacoara"
  },
  {
    "prefixo": "62600",
    "uf": "CE",
    "codigoIbge": 2306306,
    "cidade": "Itapajé"
  },
  {
    "prefixo": "62603",
    "uf": "CE",
    "codigoIbge": 2306306,
    "cidade": "Itapajé"
  },
  {
    "prefixo": "62606",
    "uf": "CE",
    "codigoIbge": 2306306,
    "cidade": "Itapajé"
  },
  {
    "prefixo": "62608",
    "uf": "CE",
    "codigoIbge": 2306306,
    "cidade": "Itapajé"
  },
  {
    "prefixo": "62610",
    "uf": "CE",
    "codigoIbge": 2313351,
    "cidade": "Tejuçuoca"
  },
  {
    "prefixo": "62614",
    "uf": "CE",
    "codigoIbge": 2313351,
    "cidade": "Tejuçuoca"
  },
  {
    "prefixo": "62620",
    "uf": "CE",
    "codigoIbge": 2306108,
    "cidade": "Irauçuba"
  },
  {
    "prefixo": "62623",
    "uf": "CE",
    "codigoIbge": 2306108,
    "cidade": "Irauçuba"
  },
  {
    "prefixo": "62625",
    "uf": "CE",
    "codigoIbge": 2306108,
    "cidade": "Irauçuba"
  },
  {
    "prefixo": "62628",
    "uf": "CE",
    "codigoIbge": 2306108,
    "cidade": "Irauçuba"
  },
  {
    "prefixo": "62630",
    "uf": "CE",
    "codigoIbge": 2300903,
    "cidade": "Apuiarés"
  },
  {
    "prefixo": "62635",
    "uf": "CE",
    "codigoIbge": 2300903,
    "cidade": "Apuiarés"
  },
  {
    "prefixo": "62638",
    "uf": "CE",
    "codigoIbge": 2300903,
    "cidade": "Apuiarés"
  },
  {
    "prefixo": "62640",
    "uf": "CE",
    "codigoIbge": 2310704,
    "cidade": "Pentecoste"
  },
  {
    "prefixo": "62642",
    "uf": "CE",
    "codigoIbge": 2310704,
    "cidade": "Pentecoste"
  },
  {
    "prefixo": "62645",
    "uf": "CE",
    "codigoIbge": 2310704,
    "cidade": "Pentecoste"
  },
  {
    "prefixo": "62648",
    "uf": "CE",
    "codigoIbge": 2310704,
    "cidade": "Pentecoste"
  },
  {
    "prefixo": "62650",
    "uf": "CE",
    "codigoIbge": 2313807,
    "cidade": "Uruburetama"
  },
  {
    "prefixo": "62652",
    "uf": "CE",
    "codigoIbge": 2313807,
    "cidade": "Uruburetama"
  },
  {
    "prefixo": "62654",
    "uf": "CE",
    "codigoIbge": 2313807,
    "cidade": "Uruburetama"
  },
  {
    "prefixo": "62655",
    "uf": "CE",
    "codigoIbge": 2313559,
    "cidade": "Tururu"
  },
  {
    "prefixo": "62656",
    "uf": "CE",
    "codigoIbge": 2313559,
    "cidade": "Tururu"
  },
  {
    "prefixo": "62657",
    "uf": "CE",
    "codigoIbge": 2313559,
    "cidade": "Tururu"
  },
  {
    "prefixo": "62660",
    "uf": "CE",
    "codigoIbge": 2313757,
    "cidade": "Umirim"
  },
  {
    "prefixo": "62663",
    "uf": "CE",
    "codigoIbge": 2313757,
    "cidade": "Umirim"
  },
  {
    "prefixo": "62665",
    "uf": "CE",
    "codigoIbge": 2312601,
    "cidade": "São Luís do Curu"
  },
  {
    "prefixo": "62670",
    "uf": "CE",
    "codigoIbge": 2312403,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "62672",
    "uf": "CE",
    "codigoIbge": 2312403,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "62674",
    "uf": "CE",
    "codigoIbge": 2312403,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "62675",
    "uf": "CE",
    "codigoIbge": 2312403,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "62676",
    "uf": "CE",
    "codigoIbge": 2312403,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "62677",
    "uf": "CE",
    "codigoIbge": 2312403,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "62678",
    "uf": "CE",
    "codigoIbge": 2312403,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "62679",
    "uf": "CE",
    "codigoIbge": 2312403,
    "cidade": "São Gonçalo do Amarante"
  },
  {
    "prefixo": "62680",
    "uf": "CE",
    "codigoIbge": 2310209,
    "cidade": "Paracuru"
  },
  {
    "prefixo": "62682",
    "uf": "CE",
    "codigoIbge": 2310209,
    "cidade": "Paracuru"
  },
  {
    "prefixo": "62683",
    "uf": "CE",
    "codigoIbge": 2310209,
    "cidade": "Paracuru"
  },
  {
    "prefixo": "62684",
    "uf": "CE",
    "codigoIbge": 2310209,
    "cidade": "Paracuru"
  },
  {
    "prefixo": "62685",
    "uf": "CE",
    "codigoIbge": 2310258,
    "cidade": "Paraipaba"
  },
  {
    "prefixo": "62686",
    "uf": "CE",
    "codigoIbge": 2310258,
    "cidade": "Paraipaba"
  },
  {
    "prefixo": "62690",
    "uf": "CE",
    "codigoIbge": 2313500,
    "cidade": "Trairi"
  },
  {
    "prefixo": "62692",
    "uf": "CE",
    "codigoIbge": 2313500,
    "cidade": "Trairi"
  },
  {
    "prefixo": "62693",
    "uf": "CE",
    "codigoIbge": 2313500,
    "cidade": "Trairi"
  },
  {
    "prefixo": "62694",
    "uf": "CE",
    "codigoIbge": 2313500,
    "cidade": "Trairi"
  },
  {
    "prefixo": "62695",
    "uf": "CE",
    "codigoIbge": 2313500,
    "cidade": "Trairi"
  },
  {
    "prefixo": "62696",
    "uf": "CE",
    "codigoIbge": 2313500,
    "cidade": "Trairi"
  },
  {
    "prefixo": "62698",
    "uf": "CE",
    "codigoIbge": 2313500,
    "cidade": "Trairi"
  },
  {
    "prefixo": "62700",
    "uf": "CE",
    "codigoIbge": 2302800,
    "cidade": "Canindé"
  },
  {
    "prefixo": "62703",
    "uf": "CE",
    "codigoIbge": 2302800,
    "cidade": "Canindé"
  },
  {
    "prefixo": "62704",
    "uf": "CE",
    "codigoIbge": 2302800,
    "cidade": "Canindé"
  },
  {
    "prefixo": "62705",
    "uf": "CE",
    "codigoIbge": 2302800,
    "cidade": "Canindé"
  },
  {
    "prefixo": "62706",
    "uf": "CE",
    "codigoIbge": 2302800,
    "cidade": "Canindé"
  },
  {
    "prefixo": "62708",
    "uf": "CE",
    "codigoIbge": 2302800,
    "cidade": "Canindé"
  },
  {
    "prefixo": "62709",
    "uf": "CE",
    "codigoIbge": 2302800,
    "cidade": "Canindé"
  },
  {
    "prefixo": "62710",
    "uf": "CE",
    "codigoIbge": 2302800,
    "cidade": "Canindé"
  },
  {
    "prefixo": "62713",
    "uf": "CE",
    "codigoIbge": 2302800,
    "cidade": "Canindé"
  },
  {
    "prefixo": "62715",
    "uf": "CE",
    "codigoIbge": 2302800,
    "cidade": "Canindé"
  },
  {
    "prefixo": "62719",
    "uf": "CE",
    "codigoIbge": 2302800,
    "cidade": "Canindé"
  },
  {
    "prefixo": "62720",
    "uf": "CE",
    "codigoIbge": 2306603,
    "cidade": "Itatira"
  },
  {
    "prefixo": "62723",
    "uf": "CE",
    "codigoIbge": 2306603,
    "cidade": "Itatira"
  },
  {
    "prefixo": "62725",
    "uf": "CE",
    "codigoIbge": 2306603,
    "cidade": "Itatira"
  },
  {
    "prefixo": "62727",
    "uf": "CE",
    "codigoIbge": 2306603,
    "cidade": "Itatira"
  },
  {
    "prefixo": "62728",
    "uf": "CE",
    "codigoIbge": 2306603,
    "cidade": "Itatira"
  },
  {
    "prefixo": "62730",
    "uf": "CE",
    "codigoIbge": 2303006,
    "cidade": "Caridade"
  },
  {
    "prefixo": "62732",
    "uf": "CE",
    "codigoIbge": 2303006,
    "cidade": "Caridade"
  },
  {
    "prefixo": "62734",
    "uf": "CE",
    "codigoIbge": 2303006,
    "cidade": "Caridade"
  },
  {
    "prefixo": "62736",
    "uf": "CE",
    "codigoIbge": 2310407,
    "cidade": "Paramoti"
  },
  {
    "prefixo": "62738",
    "uf": "CE",
    "codigoIbge": 2304608,
    "cidade": "General Sampaio"
  },
  {
    "prefixo": "62740",
    "uf": "CE",
    "codigoIbge": 2306504,
    "cidade": "Itapiúna"
  },
  {
    "prefixo": "62742",
    "uf": "CE",
    "codigoIbge": 2306504,
    "cidade": "Itapiúna"
  },
  {
    "prefixo": "62744",
    "uf": "CE",
    "codigoIbge": 2306504,
    "cidade": "Itapiúna"
  },
  {
    "prefixo": "62746",
    "uf": "CE",
    "codigoIbge": 2306504,
    "cidade": "Itapiúna"
  },
  {
    "prefixo": "62748",
    "uf": "CE",
    "codigoIbge": 2302909,
    "cidade": "Capistrano"
  },
  {
    "prefixo": "62750",
    "uf": "CE",
    "codigoIbge": 2301208,
    "cidade": "Aracoiaba"
  },
  {
    "prefixo": "62752",
    "uf": "CE",
    "codigoIbge": 2301208,
    "cidade": "Aracoiaba"
  },
  {
    "prefixo": "62754",
    "uf": "CE",
    "codigoIbge": 2301208,
    "cidade": "Aracoiaba"
  },
  {
    "prefixo": "62755",
    "uf": "CE",
    "codigoIbge": 2309458,
    "cidade": "Ocara"
  },
  {
    "prefixo": "62758",
    "uf": "CE",
    "codigoIbge": 2309458,
    "cidade": "Ocara"
  },
  {
    "prefixo": "62759",
    "uf": "CE",
    "codigoIbge": 2309458,
    "cidade": "Ocara"
  },
  {
    "prefixo": "62760",
    "uf": "CE",
    "codigoIbge": 2302107,
    "cidade": "Baturité"
  },
  {
    "prefixo": "62761",
    "uf": "CE",
    "codigoIbge": 2302107,
    "cidade": "Baturité"
  },
  {
    "prefixo": "62762",
    "uf": "CE",
    "codigoIbge": 2301406,
    "cidade": "Aratuba"
  },
  {
    "prefixo": "62763",
    "uf": "CE",
    "codigoIbge": 2301406,
    "cidade": "Aratuba"
  },
  {
    "prefixo": "62764",
    "uf": "CE",
    "codigoIbge": 2309102,
    "cidade": "Mulungu"
  },
  {
    "prefixo": "62766",
    "uf": "CE",
    "codigoIbge": 2305100,
    "cidade": "Guaramiranga"
  },
  {
    "prefixo": "62768",
    "uf": "CE",
    "codigoIbge": 2305100,
    "cidade": "Guaramiranga"
  },
  {
    "prefixo": "62770",
    "uf": "CE",
    "codigoIbge": 2309805,
    "cidade": "Pacoti"
  },
  {
    "prefixo": "62772",
    "uf": "CE",
    "codigoIbge": 2309805,
    "cidade": "Pacoti"
  },
  {
    "prefixo": "62774",
    "uf": "CE",
    "codigoIbge": 2309805,
    "cidade": "Pacoti"
  },
  {
    "prefixo": "62780",
    "uf": "CE",
    "codigoIbge": 2310100,
    "cidade": "Palmácia"
  },
  {
    "prefixo": "62782",
    "uf": "CE",
    "codigoIbge": 2310100,
    "cidade": "Palmácia"
  },
  {
    "prefixo": "62784",
    "uf": "CE",
    "codigoIbge": 2310100,
    "cidade": "Palmácia"
  },
  {
    "prefixo": "62785",
    "uf": "CE",
    "codigoIbge": 2300150,
    "cidade": "Acarape"
  },
  {
    "prefixo": "62787",
    "uf": "CE",
    "codigoIbge": 2300150,
    "cidade": "Acarape"
  },
  {
    "prefixo": "62790",
    "uf": "CE",
    "codigoIbge": 2311603,
    "cidade": "Redenção"
  },
  {
    "prefixo": "62791",
    "uf": "CE",
    "codigoIbge": 2311603,
    "cidade": "Redenção"
  },
  {
    "prefixo": "62792",
    "uf": "CE",
    "codigoIbge": 2311603,
    "cidade": "Redenção"
  },
  {
    "prefixo": "62794",
    "uf": "CE",
    "codigoIbge": 2311603,
    "cidade": "Redenção"
  },
  {
    "prefixo": "62795",
    "uf": "CE",
    "codigoIbge": 2301950,
    "cidade": "Barreira"
  },
  {
    "prefixo": "62797",
    "uf": "CE",
    "codigoIbge": 2301950,
    "cidade": "Barreira"
  },
  {
    "prefixo": "62799",
    "uf": "CE",
    "codigoIbge": 2301950,
    "cidade": "Barreira"
  },
  {
    "prefixo": "62800",
    "uf": "CE",
    "codigoIbge": 2301109,
    "cidade": "Aracati"
  },
  {
    "prefixo": "62801",
    "uf": "CE",
    "codigoIbge": 2301109,
    "cidade": "Aracati"
  },
  {
    "prefixo": "62802",
    "uf": "CE",
    "codigoIbge": 2301109,
    "cidade": "Aracati"
  },
  {
    "prefixo": "62803",
    "uf": "CE",
    "codigoIbge": 2301109,
    "cidade": "Aracati"
  },
  {
    "prefixo": "62804",
    "uf": "CE",
    "codigoIbge": 2301109,
    "cidade": "Aracati"
  },
  {
    "prefixo": "62805",
    "uf": "CE",
    "codigoIbge": 2301109,
    "cidade": "Aracati"
  },
  {
    "prefixo": "62806",
    "uf": "CE",
    "codigoIbge": 2301109,
    "cidade": "Aracati"
  },
  {
    "prefixo": "62807",
    "uf": "CE",
    "codigoIbge": 2301109,
    "cidade": "Aracati"
  },
  {
    "prefixo": "62808",
    "uf": "CE",
    "codigoIbge": 2301109,
    "cidade": "Aracati"
  },
  {
    "prefixo": "62809",
    "uf": "CE",
    "codigoIbge": 2301109,
    "cidade": "Aracati"
  },
  {
    "prefixo": "62810",
    "uf": "CE",
    "codigoIbge": 2305357,
    "cidade": "Icapuí"
  },
  {
    "prefixo": "62813",
    "uf": "CE",
    "codigoIbge": 2305357,
    "cidade": "Icapuí"
  },
  {
    "prefixo": "62814",
    "uf": "CE",
    "codigoIbge": 2305357,
    "cidade": "Icapuí"
  },
  {
    "prefixo": "62815",
    "uf": "CE",
    "codigoIbge": 2304459,
    "cidade": "Fortim"
  },
  {
    "prefixo": "62816",
    "uf": "CE",
    "codigoIbge": 2304459,
    "cidade": "Fortim"
  },
  {
    "prefixo": "62817",
    "uf": "CE",
    "codigoIbge": 2304459,
    "cidade": "Fortim"
  },
  {
    "prefixo": "62819",
    "uf": "CE",
    "codigoIbge": 2304459,
    "cidade": "Fortim"
  },
  {
    "prefixo": "62820",
    "uf": "CE",
    "codigoIbge": 2306207,
    "cidade": "Itaiçaba"
  },
  {
    "prefixo": "62823",
    "uf": "CE",
    "codigoIbge": 2307007,
    "cidade": "Jaguaruana"
  },
  {
    "prefixo": "62825",
    "uf": "CE",
    "codigoIbge": 2307007,
    "cidade": "Jaguaruana"
  },
  {
    "prefixo": "62828",
    "uf": "CE",
    "codigoIbge": 2307007,
    "cidade": "Jaguaruana"
  },
  {
    "prefixo": "62830",
    "uf": "CE",
    "codigoIbge": 2307007,
    "cidade": "Jaguaruana"
  },
  {
    "prefixo": "62832",
    "uf": "CE",
    "codigoIbge": 2307007,
    "cidade": "Jaguaruana"
  },
  {
    "prefixo": "62835",
    "uf": "CE",
    "codigoIbge": 2307007,
    "cidade": "Jaguaruana"
  },
  {
    "prefixo": "62840",
    "uf": "CE",
    "codigoIbge": 2302206,
    "cidade": "Beberibe"
  },
  {
    "prefixo": "62842",
    "uf": "CE",
    "codigoIbge": 2302206,
    "cidade": "Beberibe"
  },
  {
    "prefixo": "62843",
    "uf": "CE",
    "codigoIbge": 2302206,
    "cidade": "Beberibe"
  },
  {
    "prefixo": "62844",
    "uf": "CE",
    "codigoIbge": 2302206,
    "cidade": "Beberibe"
  },
  {
    "prefixo": "62846",
    "uf": "CE",
    "codigoIbge": 2302206,
    "cidade": "Beberibe"
  },
  {
    "prefixo": "62847",
    "uf": "CE",
    "codigoIbge": 2302206,
    "cidade": "Beberibe"
  },
  {
    "prefixo": "62848",
    "uf": "CE",
    "codigoIbge": 2302206,
    "cidade": "Beberibe"
  },
  {
    "prefixo": "62850",
    "uf": "CE",
    "codigoIbge": 2303501,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "62852",
    "uf": "CE",
    "codigoIbge": 2303501,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "62855",
    "uf": "CE",
    "codigoIbge": 2303501,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "62856",
    "uf": "CE",
    "codigoIbge": 2303501,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "62858",
    "uf": "CE",
    "codigoIbge": 2303501,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "62859",
    "uf": "CE",
    "codigoIbge": 2303501,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "62860",
    "uf": "CE",
    "codigoIbge": 2310852,
    "cidade": "Pindoretama"
  },
  {
    "prefixo": "62863",
    "uf": "CE",
    "codigoIbge": 2310852,
    "cidade": "Pindoretama"
  },
  {
    "prefixo": "62864",
    "uf": "CE",
    "codigoIbge": 2310852,
    "cidade": "Pindoretama"
  },
  {
    "prefixo": "62866",
    "uf": "CE",
    "codigoIbge": 2310852,
    "cidade": "Pindoretama"
  },
  {
    "prefixo": "62870",
    "uf": "CE",
    "codigoIbge": 2309607,
    "cidade": "Pacajus"
  },
  {
    "prefixo": "62872",
    "uf": "CE",
    "codigoIbge": 2309607,
    "cidade": "Pacajus"
  },
  {
    "prefixo": "62874",
    "uf": "CE",
    "codigoIbge": 2309607,
    "cidade": "Pacajus"
  },
  {
    "prefixo": "62875",
    "uf": "CE",
    "codigoIbge": 2303956,
    "cidade": "Chorozinho"
  },
  {
    "prefixo": "62877",
    "uf": "CE",
    "codigoIbge": 2303956,
    "cidade": "Chorozinho"
  },
  {
    "prefixo": "62878",
    "uf": "CE",
    "codigoIbge": 2303956,
    "cidade": "Chorozinho"
  },
  {
    "prefixo": "62879",
    "uf": "CE",
    "codigoIbge": 2303956,
    "cidade": "Chorozinho"
  },
  {
    "prefixo": "62880",
    "uf": "CE",
    "codigoIbge": 2305233,
    "cidade": "Horizonte"
  },
  {
    "prefixo": "62881",
    "uf": "CE",
    "codigoIbge": 2305233,
    "cidade": "Horizonte"
  },
  {
    "prefixo": "62882",
    "uf": "CE",
    "codigoIbge": 2305233,
    "cidade": "Horizonte"
  },
  {
    "prefixo": "62883",
    "uf": "CE",
    "codigoIbge": 2305233,
    "cidade": "Horizonte"
  },
  {
    "prefixo": "62884",
    "uf": "CE",
    "codigoIbge": 2305233,
    "cidade": "Horizonte"
  },
  {
    "prefixo": "62885",
    "uf": "CE",
    "codigoIbge": 2305233,
    "cidade": "Horizonte"
  },
  {
    "prefixo": "62886",
    "uf": "CE",
    "codigoIbge": 2305233,
    "cidade": "Horizonte"
  },
  {
    "prefixo": "62887",
    "uf": "CE",
    "codigoIbge": 2305233,
    "cidade": "Horizonte"
  },
  {
    "prefixo": "62897",
    "uf": "CE",
    "codigoIbge": 2305233,
    "cidade": "Horizonte"
  },
  {
    "prefixo": "62898",
    "uf": "CE",
    "codigoIbge": 2305233,
    "cidade": "Horizonte"
  },
  {
    "prefixo": "62899",
    "uf": "CE",
    "codigoIbge": 2305233,
    "cidade": "Horizonte"
  },
  {
    "prefixo": "62900",
    "uf": "CE",
    "codigoIbge": 2311801,
    "cidade": "Russas"
  },
  {
    "prefixo": "62901",
    "uf": "CE",
    "codigoIbge": 2311801,
    "cidade": "Russas"
  },
  {
    "prefixo": "62903",
    "uf": "CE",
    "codigoIbge": 2311801,
    "cidade": "Russas"
  },
  {
    "prefixo": "62904",
    "uf": "CE",
    "codigoIbge": 2311801,
    "cidade": "Russas"
  },
  {
    "prefixo": "62905",
    "uf": "CE",
    "codigoIbge": 2311801,
    "cidade": "Russas"
  },
  {
    "prefixo": "62906",
    "uf": "CE",
    "codigoIbge": 2311801,
    "cidade": "Russas"
  },
  {
    "prefixo": "62907",
    "uf": "CE",
    "codigoIbge": 2311801,
    "cidade": "Russas"
  },
  {
    "prefixo": "62908",
    "uf": "CE",
    "codigoIbge": 2311801,
    "cidade": "Russas"
  },
  {
    "prefixo": "62910",
    "uf": "CE",
    "codigoIbge": 2310001,
    "cidade": "Palhano"
  },
  {
    "prefixo": "62913",
    "uf": "CE",
    "codigoIbge": 2310001,
    "cidade": "Palhano"
  },
  {
    "prefixo": "62920",
    "uf": "CE",
    "codigoIbge": 2311504,
    "cidade": "Quixeré"
  },
  {
    "prefixo": "62922",
    "uf": "CE",
    "codigoIbge": 2311504,
    "cidade": "Quixeré"
  },
  {
    "prefixo": "62924",
    "uf": "CE",
    "codigoIbge": 2311504,
    "cidade": "Quixeré"
  },
  {
    "prefixo": "62929",
    "uf": "CE",
    "codigoIbge": 2311504,
    "cidade": "Quixeré"
  },
  {
    "prefixo": "62930",
    "uf": "CE",
    "codigoIbge": 2307601,
    "cidade": "Limoeiro do Norte"
  },
  {
    "prefixo": "62935",
    "uf": "CE",
    "codigoIbge": 2307601,
    "cidade": "Limoeiro do Norte"
  },
  {
    "prefixo": "62940",
    "uf": "CE",
    "codigoIbge": 2308708,
    "cidade": "Morada Nova"
  },
  {
    "prefixo": "62942",
    "uf": "CE",
    "codigoIbge": 2308708,
    "cidade": "Morada Nova"
  },
  {
    "prefixo": "62943",
    "uf": "CE",
    "codigoIbge": 2308708,
    "cidade": "Morada Nova"
  },
  {
    "prefixo": "62945",
    "uf": "CE",
    "codigoIbge": 2308708,
    "cidade": "Morada Nova"
  },
  {
    "prefixo": "62948",
    "uf": "CE",
    "codigoIbge": 2308708,
    "cidade": "Morada Nova"
  },
  {
    "prefixo": "62950",
    "uf": "CE",
    "codigoIbge": 2308708,
    "cidade": "Morada Nova"
  },
  {
    "prefixo": "62951",
    "uf": "CE",
    "codigoIbge": 2308708,
    "cidade": "Morada Nova"
  },
  {
    "prefixo": "62953",
    "uf": "CE",
    "codigoIbge": 2308708,
    "cidade": "Morada Nova"
  },
  {
    "prefixo": "62955",
    "uf": "CE",
    "codigoIbge": 2305332,
    "cidade": "Ibicuitinga"
  },
  {
    "prefixo": "62959",
    "uf": "CE",
    "codigoIbge": 2305332,
    "cidade": "Ibicuitinga"
  },
  {
    "prefixo": "62960",
    "uf": "CE",
    "codigoIbge": 2313104,
    "cidade": "Tabuleiro do Norte"
  },
  {
    "prefixo": "62962",
    "uf": "CE",
    "codigoIbge": 2313104,
    "cidade": "Tabuleiro do Norte"
  },
  {
    "prefixo": "62965",
    "uf": "CE",
    "codigoIbge": 2312502,
    "cidade": "São João do Jaguaribe"
  },
  {
    "prefixo": "62970",
    "uf": "CE",
    "codigoIbge": 2300705,
    "cidade": "Alto Santo"
  },
  {
    "prefixo": "62975",
    "uf": "CE",
    "codigoIbge": 2300705,
    "cidade": "Alto Santo"
  },
  {
    "prefixo": "62980",
    "uf": "CE",
    "codigoIbge": 2306009,
    "cidade": "Iracema"
  },
  {
    "prefixo": "62984",
    "uf": "CE",
    "codigoIbge": 2306009,
    "cidade": "Iracema"
  },
  {
    "prefixo": "62989",
    "uf": "CE",
    "codigoIbge": 2306009,
    "cidade": "Iracema"
  },
  {
    "prefixo": "62990",
    "uf": "CE",
    "codigoIbge": 2311231,
    "cidade": "Potiretama"
  },
  {
    "prefixo": "63010",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63011",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63012",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63013",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63015",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63016",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63017",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63018",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63020",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63021",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63022",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63024",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63028",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63030",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63031",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63033",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63034",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63035",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63036",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63038",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63040",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63041",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63042",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63043",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63044",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63045",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63046",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63047",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63048",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63049",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63050",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63051",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63079",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63082",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63084",
    "uf": "CE",
    "codigoIbge": 2307304,
    "cidade": "Juazeiro do Norte"
  },
  {
    "prefixo": "63090",
    "uf": "CE",
    "codigoIbge": 2301901,
    "cidade": "Barbalha"
  },
  {
    "prefixo": "63091",
    "uf": "CE",
    "codigoIbge": 2301901,
    "cidade": "Barbalha"
  },
  {
    "prefixo": "63092",
    "uf": "CE",
    "codigoIbge": 2301901,
    "cidade": "Barbalha"
  },
  {
    "prefixo": "63093",
    "uf": "CE",
    "codigoIbge": 2301901,
    "cidade": "Barbalha"
  },
  {
    "prefixo": "63094",
    "uf": "CE",
    "codigoIbge": 2301901,
    "cidade": "Barbalha"
  },
  {
    "prefixo": "63095",
    "uf": "CE",
    "codigoIbge": 2301901,
    "cidade": "Barbalha"
  },
  {
    "prefixo": "63100",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63101",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63102",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63103",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63104",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63105",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63106",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63107",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63108",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63109",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63110",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63111",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63112",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63113",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63114",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63115",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63116",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63118",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63119",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63122",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63123",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63125",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63130",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63132",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63133",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63135",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63136",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63137",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63138",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63139",
    "uf": "CE",
    "codigoIbge": 2304202,
    "cidade": "Crato"
  },
  {
    "prefixo": "63140",
    "uf": "CE",
    "codigoIbge": 2301604,
    "cidade": "Assaré"
  },
  {
    "prefixo": "63143",
    "uf": "CE",
    "codigoIbge": 2301604,
    "cidade": "Assaré"
  },
  {
    "prefixo": "63144",
    "uf": "CE",
    "codigoIbge": 2301604,
    "cidade": "Assaré"
  },
  {
    "prefixo": "63145",
    "uf": "CE",
    "codigoIbge": 2313252,
    "cidade": "Tarrafas"
  },
  {
    "prefixo": "63150",
    "uf": "CE",
    "codigoIbge": 2302701,
    "cidade": "Campos Sales"
  },
  {
    "prefixo": "63151",
    "uf": "CE",
    "codigoIbge": 2302701,
    "cidade": "Campos Sales"
  },
  {
    "prefixo": "63152",
    "uf": "CE",
    "codigoIbge": 2302701,
    "cidade": "Campos Sales"
  },
  {
    "prefixo": "63154",
    "uf": "CE",
    "codigoIbge": 2302701,
    "cidade": "Campos Sales"
  },
  {
    "prefixo": "63155",
    "uf": "CE",
    "codigoIbge": 2311959,
    "cidade": "Salitre"
  },
  {
    "prefixo": "63158",
    "uf": "CE",
    "codigoIbge": 2311959,
    "cidade": "Salitre"
  },
  {
    "prefixo": "63160",
    "uf": "CE",
    "codigoIbge": 2311207,
    "cidade": "Potengi"
  },
  {
    "prefixo": "63163",
    "uf": "CE",
    "codigoIbge": 2311207,
    "cidade": "Potengi"
  },
  {
    "prefixo": "63165",
    "uf": "CE",
    "codigoIbge": 2309201,
    "cidade": "Nova Olinda"
  },
  {
    "prefixo": "63168",
    "uf": "CE",
    "codigoIbge": 2309201,
    "cidade": "Nova Olinda"
  },
  {
    "prefixo": "63170",
    "uf": "CE",
    "codigoIbge": 2301307,
    "cidade": "Araripe"
  },
  {
    "prefixo": "63172",
    "uf": "CE",
    "codigoIbge": 2301307,
    "cidade": "Araripe"
  },
  {
    "prefixo": "63174",
    "uf": "CE",
    "codigoIbge": 2301307,
    "cidade": "Araripe"
  },
  {
    "prefixo": "63176",
    "uf": "CE",
    "codigoIbge": 2301307,
    "cidade": "Araripe"
  },
  {
    "prefixo": "63178",
    "uf": "CE",
    "codigoIbge": 2301307,
    "cidade": "Araripe"
  },
  {
    "prefixo": "63180",
    "uf": "CE",
    "codigoIbge": 2301901,
    "cidade": "Barbalha"
  },
  {
    "prefixo": "63182",
    "uf": "CE",
    "codigoIbge": 2301901,
    "cidade": "Barbalha"
  },
  {
    "prefixo": "63183",
    "uf": "CE",
    "codigoIbge": 2301901,
    "cidade": "Barbalha"
  },
  {
    "prefixo": "63184",
    "uf": "CE",
    "codigoIbge": 2301901,
    "cidade": "Barbalha"
  },
  {
    "prefixo": "63185",
    "uf": "CE",
    "codigoIbge": 2304301,
    "cidade": "Farias Brito"
  },
  {
    "prefixo": "63187",
    "uf": "CE",
    "codigoIbge": 2304301,
    "cidade": "Farias Brito"
  },
  {
    "prefixo": "63188",
    "uf": "CE",
    "codigoIbge": 2304301,
    "cidade": "Farias Brito"
  },
  {
    "prefixo": "63189",
    "uf": "CE",
    "codigoIbge": 2304301,
    "cidade": "Farias Brito"
  },
  {
    "prefixo": "63190",
    "uf": "CE",
    "codigoIbge": 2312106,
    "cidade": "Santana do Cariri"
  },
  {
    "prefixo": "63191",
    "uf": "CE",
    "codigoIbge": 2312106,
    "cidade": "Santana do Cariri"
  },
  {
    "prefixo": "63192",
    "uf": "CE",
    "codigoIbge": 2312106,
    "cidade": "Santana do Cariri"
  },
  {
    "prefixo": "63193",
    "uf": "CE",
    "codigoIbge": 2312106,
    "cidade": "Santana do Cariri"
  },
  {
    "prefixo": "63195",
    "uf": "CE",
    "codigoIbge": 2300606,
    "cidade": "Altaneira"
  },
  {
    "prefixo": "63200",
    "uf": "CE",
    "codigoIbge": 2308401,
    "cidade": "Missão Velha"
  },
  {
    "prefixo": "63203",
    "uf": "CE",
    "codigoIbge": 2308401,
    "cidade": "Missão Velha"
  },
  {
    "prefixo": "63205",
    "uf": "CE",
    "codigoIbge": 2308401,
    "cidade": "Missão Velha"
  },
  {
    "prefixo": "63207",
    "uf": "CE",
    "codigoIbge": 2308401,
    "cidade": "Missão Velha"
  },
  {
    "prefixo": "63208",
    "uf": "CE",
    "codigoIbge": 2308401,
    "cidade": "Missão Velha"
  },
  {
    "prefixo": "63210",
    "uf": "CE",
    "codigoIbge": 2308104,
    "cidade": "Mauriti"
  },
  {
    "prefixo": "63211",
    "uf": "CE",
    "codigoIbge": 2308104,
    "cidade": "Mauriti"
  },
  {
    "prefixo": "63212",
    "uf": "CE",
    "codigoIbge": 2308104,
    "cidade": "Mauriti"
  },
  {
    "prefixo": "63213",
    "uf": "CE",
    "codigoIbge": 2308104,
    "cidade": "Mauriti"
  },
  {
    "prefixo": "63215",
    "uf": "CE",
    "codigoIbge": 2308104,
    "cidade": "Mauriti"
  },
  {
    "prefixo": "63219",
    "uf": "CE",
    "codigoIbge": 2308104,
    "cidade": "Mauriti"
  },
  {
    "prefixo": "63220",
    "uf": "CE",
    "codigoIbge": 2303204,
    "cidade": "Caririaçu"
  },
  {
    "prefixo": "63223",
    "uf": "CE",
    "codigoIbge": 2303204,
    "cidade": "Caririaçu"
  },
  {
    "prefixo": "63225",
    "uf": "CE",
    "codigoIbge": 2303204,
    "cidade": "Caririaçu"
  },
  {
    "prefixo": "63228",
    "uf": "CE",
    "codigoIbge": 2303204,
    "cidade": "Caririaçu"
  },
  {
    "prefixo": "63230",
    "uf": "CE",
    "codigoIbge": 2304806,
    "cidade": "Granjeiro"
  },
  {
    "prefixo": "63240",
    "uf": "CE",
    "codigoIbge": 2300101,
    "cidade": "Abaiara"
  },
  {
    "prefixo": "63245",
    "uf": "CE",
    "codigoIbge": 2300101,
    "cidade": "Abaiara"
  },
  {
    "prefixo": "63250",
    "uf": "CE",
    "codigoIbge": 2308302,
    "cidade": "Milagres"
  },
  {
    "prefixo": "63255",
    "uf": "CE",
    "codigoIbge": 2308302,
    "cidade": "Milagres"
  },
  {
    "prefixo": "63260",
    "uf": "CE",
    "codigoIbge": 2302503,
    "cidade": "Brejo Santo"
  },
  {
    "prefixo": "63265",
    "uf": "CE",
    "codigoIbge": 2302503,
    "cidade": "Brejo Santo"
  },
  {
    "prefixo": "63268",
    "uf": "CE",
    "codigoIbge": 2302503,
    "cidade": "Brejo Santo"
  },
  {
    "prefixo": "63270",
    "uf": "CE",
    "codigoIbge": 2311108,
    "cidade": "Porteiras"
  },
  {
    "prefixo": "63273",
    "uf": "CE",
    "codigoIbge": 2311108,
    "cidade": "Porteiras"
  },
  {
    "prefixo": "63275",
    "uf": "CE",
    "codigoIbge": 2307205,
    "cidade": "Jati"
  },
  {
    "prefixo": "63277",
    "uf": "CE",
    "codigoIbge": 2307205,
    "cidade": "Jati"
  },
  {
    "prefixo": "63280",
    "uf": "CE",
    "codigoIbge": 2310605,
    "cidade": "Penaforte"
  },
  {
    "prefixo": "63286",
    "uf": "CE",
    "codigoIbge": 2310605,
    "cidade": "Penaforte"
  },
  {
    "prefixo": "63290",
    "uf": "CE",
    "codigoIbge": 2307106,
    "cidade": "Jardim"
  },
  {
    "prefixo": "63295",
    "uf": "CE",
    "codigoIbge": 2307106,
    "cidade": "Jardim"
  },
  {
    "prefixo": "63297",
    "uf": "CE",
    "codigoIbge": 2307106,
    "cidade": "Jardim"
  },
  {
    "prefixo": "63300",
    "uf": "CE",
    "codigoIbge": 2307502,
    "cidade": "Lavras da Mangabeira"
  },
  {
    "prefixo": "63303",
    "uf": "CE",
    "codigoIbge": 2307502,
    "cidade": "Lavras da Mangabeira"
  },
  {
    "prefixo": "63305",
    "uf": "CE",
    "codigoIbge": 2307502,
    "cidade": "Lavras da Mangabeira"
  },
  {
    "prefixo": "63307",
    "uf": "CE",
    "codigoIbge": 2307502,
    "cidade": "Lavras da Mangabeira"
  },
  {
    "prefixo": "63308",
    "uf": "CE",
    "codigoIbge": 2307502,
    "cidade": "Lavras da Mangabeira"
  },
  {
    "prefixo": "63310",
    "uf": "CE",
    "codigoIbge": 2313708,
    "cidade": "Umari"
  },
  {
    "prefixo": "63315",
    "uf": "CE",
    "codigoIbge": 2313708,
    "cidade": "Umari"
  },
  {
    "prefixo": "63320",
    "uf": "CE",
    "codigoIbge": 2301802,
    "cidade": "Baixio"
  },
  {
    "prefixo": "63340",
    "uf": "CE",
    "codigoIbge": 2305704,
    "cidade": "Ipaumirim"
  },
  {
    "prefixo": "63342",
    "uf": "CE",
    "codigoIbge": 2305704,
    "cidade": "Ipaumirim"
  },
  {
    "prefixo": "63345",
    "uf": "CE",
    "codigoIbge": 2305704,
    "cidade": "Ipaumirim"
  },
  {
    "prefixo": "63360",
    "uf": "CE",
    "codigoIbge": 2301703,
    "cidade": "Aurora"
  },
  {
    "prefixo": "63365",
    "uf": "CE",
    "codigoIbge": 2301703,
    "cidade": "Aurora"
  },
  {
    "prefixo": "63370",
    "uf": "CE",
    "codigoIbge": 2301703,
    "cidade": "Aurora"
  },
  {
    "prefixo": "63380",
    "uf": "CE",
    "codigoIbge": 2302008,
    "cidade": "Barro"
  },
  {
    "prefixo": "63383",
    "uf": "CE",
    "codigoIbge": 2302008,
    "cidade": "Barro"
  },
  {
    "prefixo": "63389",
    "uf": "CE",
    "codigoIbge": 2302008,
    "cidade": "Barro"
  },
  {
    "prefixo": "63400",
    "uf": "CE",
    "codigoIbge": 2303808,
    "cidade": "Cedro"
  },
  {
    "prefixo": "63405",
    "uf": "CE",
    "codigoIbge": 2303808,
    "cidade": "Cedro"
  },
  {
    "prefixo": "63430",
    "uf": "CE",
    "codigoIbge": 2305407,
    "cidade": "Icó"
  },
  {
    "prefixo": "63435",
    "uf": "CE",
    "codigoIbge": 2305407,
    "cidade": "Icó"
  },
  {
    "prefixo": "63440",
    "uf": "CE",
    "codigoIbge": 2305407,
    "cidade": "Icó"
  },
  {
    "prefixo": "63445",
    "uf": "CE",
    "codigoIbge": 2305407,
    "cidade": "Icó"
  },
  {
    "prefixo": "63450",
    "uf": "CE",
    "codigoIbge": 2305407,
    "cidade": "Icó"
  },
  {
    "prefixo": "63455",
    "uf": "CE",
    "codigoIbge": 2305407,
    "cidade": "Icó"
  },
  {
    "prefixo": "63460",
    "uf": "CE",
    "codigoIbge": 2310803,
    "cidade": "Pereiro"
  },
  {
    "prefixo": "63465",
    "uf": "CE",
    "codigoIbge": 2310803,
    "cidade": "Pereiro"
  },
  {
    "prefixo": "63470",
    "uf": "CE",
    "codigoIbge": 2304277,
    "cidade": "Ereré"
  },
  {
    "prefixo": "63473",
    "uf": "CE",
    "codigoIbge": 2304277,
    "cidade": "Ereré"
  },
  {
    "prefixo": "63475",
    "uf": "CE",
    "codigoIbge": 2306900,
    "cidade": "Jaguaribe"
  },
  {
    "prefixo": "63476",
    "uf": "CE",
    "codigoIbge": 2306900,
    "cidade": "Jaguaribe"
  },
  {
    "prefixo": "63477",
    "uf": "CE",
    "codigoIbge": 2306900,
    "cidade": "Jaguaribe"
  },
  {
    "prefixo": "63479",
    "uf": "CE",
    "codigoIbge": 2306900,
    "cidade": "Jaguaribe"
  },
  {
    "prefixo": "63480",
    "uf": "CE",
    "codigoIbge": 2306702,
    "cidade": "Jaguaretama"
  },
  {
    "prefixo": "63490",
    "uf": "CE",
    "codigoIbge": 2306801,
    "cidade": "Jaguaribara"
  },
  {
    "prefixo": "63495",
    "uf": "CE",
    "codigoIbge": 2306801,
    "cidade": "Jaguaribara"
  },
  {
    "prefixo": "63500",
    "uf": "CE",
    "codigoIbge": 2305506,
    "cidade": "Iguatu"
  },
  {
    "prefixo": "63501",
    "uf": "CE",
    "codigoIbge": 2305506,
    "cidade": "Iguatu"
  },
  {
    "prefixo": "63502",
    "uf": "CE",
    "codigoIbge": 2305506,
    "cidade": "Iguatu"
  },
  {
    "prefixo": "63503",
    "uf": "CE",
    "codigoIbge": 2305506,
    "cidade": "Iguatu"
  },
  {
    "prefixo": "63504",
    "uf": "CE",
    "codigoIbge": 2305506,
    "cidade": "Iguatu"
  },
  {
    "prefixo": "63505",
    "uf": "CE",
    "codigoIbge": 2305506,
    "cidade": "Iguatu"
  },
  {
    "prefixo": "63506",
    "uf": "CE",
    "codigoIbge": 2305506,
    "cidade": "Iguatu"
  },
  {
    "prefixo": "63507",
    "uf": "CE",
    "codigoIbge": 2305506,
    "cidade": "Iguatu"
  },
  {
    "prefixo": "63508",
    "uf": "CE",
    "codigoIbge": 2305506,
    "cidade": "Iguatu"
  },
  {
    "prefixo": "63509",
    "uf": "CE",
    "codigoIbge": 2305506,
    "cidade": "Iguatu"
  },
  {
    "prefixo": "63510",
    "uf": "CE",
    "codigoIbge": 2305506,
    "cidade": "Iguatu"
  },
  {
    "prefixo": "63511",
    "uf": "CE",
    "codigoIbge": 2305506,
    "cidade": "Iguatu"
  },
  {
    "prefixo": "63512",
    "uf": "CE",
    "codigoIbge": 2305506,
    "cidade": "Iguatu"
  },
  {
    "prefixo": "63514",
    "uf": "CE",
    "codigoIbge": 2305506,
    "cidade": "Iguatu"
  },
  {
    "prefixo": "63515",
    "uf": "CE",
    "codigoIbge": 2311355,
    "cidade": "Quixelô"
  },
  {
    "prefixo": "63520",
    "uf": "CE",
    "codigoIbge": 2309508,
    "cidade": "Orós"
  },
  {
    "prefixo": "63525",
    "uf": "CE",
    "codigoIbge": 2309508,
    "cidade": "Orós"
  },
  {
    "prefixo": "63527",
    "uf": "CE",
    "codigoIbge": 2309508,
    "cidade": "Orós"
  },
  {
    "prefixo": "63530",
    "uf": "CE",
    "codigoIbge": 2303303,
    "cidade": "Cariús"
  },
  {
    "prefixo": "63533",
    "uf": "CE",
    "codigoIbge": 2303303,
    "cidade": "Cariús"
  },
  {
    "prefixo": "63535",
    "uf": "CE",
    "codigoIbge": 2303303,
    "cidade": "Cariús"
  },
  {
    "prefixo": "63538",
    "uf": "CE",
    "codigoIbge": 2303303,
    "cidade": "Cariús"
  },
  {
    "prefixo": "63539",
    "uf": "CE",
    "codigoIbge": 2303303,
    "cidade": "Cariús"
  },
  {
    "prefixo": "63540",
    "uf": "CE",
    "codigoIbge": 2314003,
    "cidade": "Várzea Alegre"
  },
  {
    "prefixo": "63545",
    "uf": "CE",
    "codigoIbge": 2314003,
    "cidade": "Várzea Alegre"
  },
  {
    "prefixo": "63548",
    "uf": "CE",
    "codigoIbge": 2314003,
    "cidade": "Várzea Alegre"
  },
  {
    "prefixo": "63550",
    "uf": "CE",
    "codigoIbge": 2314003,
    "cidade": "Várzea Alegre"
  },
  {
    "prefixo": "63555",
    "uf": "CE",
    "codigoIbge": 2314003,
    "cidade": "Várzea Alegre"
  },
  {
    "prefixo": "63558",
    "uf": "CE",
    "codigoIbge": 2314003,
    "cidade": "Várzea Alegre"
  },
  {
    "prefixo": "63560",
    "uf": "CE",
    "codigoIbge": 2300309,
    "cidade": "Acopiara"
  },
  {
    "prefixo": "63564",
    "uf": "CE",
    "codigoIbge": 2300309,
    "cidade": "Acopiara"
  },
  {
    "prefixo": "63565",
    "uf": "CE",
    "codigoIbge": 2300309,
    "cidade": "Acopiara"
  },
  {
    "prefixo": "63566",
    "uf": "CE",
    "codigoIbge": 2300309,
    "cidade": "Acopiara"
  },
  {
    "prefixo": "63568",
    "uf": "CE",
    "codigoIbge": 2300309,
    "cidade": "Acopiara"
  },
  {
    "prefixo": "63570",
    "uf": "CE",
    "codigoIbge": 2300804,
    "cidade": "Antonina do Norte"
  },
  {
    "prefixo": "63573",
    "uf": "CE",
    "codigoIbge": 2300804,
    "cidade": "Antonina do Norte"
  },
  {
    "prefixo": "63575",
    "uf": "CE",
    "codigoIbge": 2300408,
    "cidade": "Aiuaba"
  },
  {
    "prefixo": "63578",
    "uf": "CE",
    "codigoIbge": 2300408,
    "cidade": "Aiuaba"
  },
  {
    "prefixo": "63580",
    "uf": "CE",
    "codigoIbge": 2307403,
    "cidade": "Jucás"
  },
  {
    "prefixo": "63582",
    "uf": "CE",
    "codigoIbge": 2307403,
    "cidade": "Jucás"
  },
  {
    "prefixo": "63583",
    "uf": "CE",
    "codigoIbge": 2307403,
    "cidade": "Jucás"
  },
  {
    "prefixo": "63585",
    "uf": "CE",
    "codigoIbge": 2307403,
    "cidade": "Jucás"
  },
  {
    "prefixo": "63587",
    "uf": "CE",
    "codigoIbge": 2307403,
    "cidade": "Jucás"
  },
  {
    "prefixo": "63588",
    "uf": "CE",
    "codigoIbge": 2307403,
    "cidade": "Jucás"
  },
  {
    "prefixo": "63590",
    "uf": "CE",
    "codigoIbge": 2311900,
    "cidade": "Saboeiro"
  },
  {
    "prefixo": "63595",
    "uf": "CE",
    "codigoIbge": 2303600,
    "cidade": "Catarina"
  },
  {
    "prefixo": "63600",
    "uf": "CE",
    "codigoIbge": 2312700,
    "cidade": "Senador Pompeu"
  },
  {
    "prefixo": "63601",
    "uf": "CE",
    "codigoIbge": 2312700,
    "cidade": "Senador Pompeu"
  },
  {
    "prefixo": "63602",
    "uf": "CE",
    "codigoIbge": 2312700,
    "cidade": "Senador Pompeu"
  },
  {
    "prefixo": "63603",
    "uf": "CE",
    "codigoIbge": 2312700,
    "cidade": "Senador Pompeu"
  },
  {
    "prefixo": "63605",
    "uf": "CE",
    "codigoIbge": 2310902,
    "cidade": "Piquet Carneiro"
  },
  {
    "prefixo": "63606",
    "uf": "CE",
    "codigoIbge": 2310902,
    "cidade": "Piquet Carneiro"
  },
  {
    "prefixo": "63610",
    "uf": "CE",
    "codigoIbge": 2308500,
    "cidade": "Mombaça"
  },
  {
    "prefixo": "63613",
    "uf": "CE",
    "codigoIbge": 2308500,
    "cidade": "Mombaça"
  },
  {
    "prefixo": "63614",
    "uf": "CE",
    "codigoIbge": 2308500,
    "cidade": "Mombaça"
  },
  {
    "prefixo": "63616",
    "uf": "CE",
    "codigoIbge": 2308500,
    "cidade": "Mombaça"
  },
  {
    "prefixo": "63619",
    "uf": "CE",
    "codigoIbge": 2308500,
    "cidade": "Mombaça"
  },
  {
    "prefixo": "63620",
    "uf": "CE",
    "codigoIbge": 2313005,
    "cidade": "Solonópole"
  },
  {
    "prefixo": "63621",
    "uf": "CE",
    "codigoIbge": 2313005,
    "cidade": "Solonópole"
  },
  {
    "prefixo": "63625",
    "uf": "CE",
    "codigoIbge": 2313005,
    "cidade": "Solonópole"
  },
  {
    "prefixo": "63626",
    "uf": "CE",
    "codigoIbge": 2313005,
    "cidade": "Solonópole"
  },
  {
    "prefixo": "63630",
    "uf": "CE",
    "codigoIbge": 2310506,
    "cidade": "Pedra Branca"
  },
  {
    "prefixo": "63631",
    "uf": "CE",
    "codigoIbge": 2310506,
    "cidade": "Pedra Branca"
  },
  {
    "prefixo": "63632",
    "uf": "CE",
    "codigoIbge": 2310506,
    "cidade": "Pedra Branca"
  },
  {
    "prefixo": "63633",
    "uf": "CE",
    "codigoIbge": 2310506,
    "cidade": "Pedra Branca"
  },
  {
    "prefixo": "63634",
    "uf": "CE",
    "codigoIbge": 2310506,
    "cidade": "Pedra Branca"
  },
  {
    "prefixo": "63635",
    "uf": "CE",
    "codigoIbge": 2308351,
    "cidade": "Milhã"
  },
  {
    "prefixo": "63639",
    "uf": "CE",
    "codigoIbge": 2308351,
    "cidade": "Milhã"
  },
  {
    "prefixo": "63640",
    "uf": "CE",
    "codigoIbge": 2305605,
    "cidade": "Independência"
  },
  {
    "prefixo": "63642",
    "uf": "CE",
    "codigoIbge": 2305605,
    "cidade": "Independência"
  },
  {
    "prefixo": "63643",
    "uf": "CE",
    "codigoIbge": 2305605,
    "cidade": "Independência"
  },
  {
    "prefixo": "63645",
    "uf": "CE",
    "codigoIbge": 2304269,
    "cidade": "Deputado Irapuan Pinheiro"
  },
  {
    "prefixo": "63647",
    "uf": "CE",
    "codigoIbge": 2304269,
    "cidade": "Deputado Irapuan Pinheiro"
  },
  {
    "prefixo": "63648",
    "uf": "CE",
    "codigoIbge": 2304269,
    "cidade": "Deputado Irapuan Pinheiro"
  },
  {
    "prefixo": "63650",
    "uf": "CE",
    "codigoIbge": 2311264,
    "cidade": "Quiterianópolis"
  },
  {
    "prefixo": "63655",
    "uf": "CE",
    "codigoIbge": 2311264,
    "cidade": "Quiterianópolis"
  },
  {
    "prefixo": "63660",
    "uf": "CE",
    "codigoIbge": 2313302,
    "cidade": "Tauá"
  },
  {
    "prefixo": "63662",
    "uf": "CE",
    "codigoIbge": 2313302,
    "cidade": "Tauá"
  },
  {
    "prefixo": "63663",
    "uf": "CE",
    "codigoIbge": 2313302,
    "cidade": "Tauá"
  },
  {
    "prefixo": "63664",
    "uf": "CE",
    "codigoIbge": 2313302,
    "cidade": "Tauá"
  },
  {
    "prefixo": "63666",
    "uf": "CE",
    "codigoIbge": 2313302,
    "cidade": "Tauá"
  },
  {
    "prefixo": "63667",
    "uf": "CE",
    "codigoIbge": 2313302,
    "cidade": "Tauá"
  },
  {
    "prefixo": "63668",
    "uf": "CE",
    "codigoIbge": 2313302,
    "cidade": "Tauá"
  },
  {
    "prefixo": "63670",
    "uf": "CE",
    "codigoIbge": 2301505,
    "cidade": "Arneiroz"
  },
  {
    "prefixo": "63674",
    "uf": "CE",
    "codigoIbge": 2301505,
    "cidade": "Arneiroz"
  },
  {
    "prefixo": "63676",
    "uf": "CE",
    "codigoIbge": 2301505,
    "cidade": "Arneiroz"
  },
  {
    "prefixo": "63680",
    "uf": "CE",
    "codigoIbge": 2310308,
    "cidade": "Parambu"
  },
  {
    "prefixo": "63689",
    "uf": "CE",
    "codigoIbge": 2310308,
    "cidade": "Parambu"
  },
  {
    "prefixo": "63697",
    "uf": "CE",
    "codigoIbge": 2310308,
    "cidade": "Parambu"
  },
  {
    "prefixo": "63700",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63701",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63702",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63703",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63704",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63705",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63706",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63707",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63708",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63709",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63710",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63712",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63714",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63715",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63716",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63720",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63723",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63725",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63728",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63730",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63735",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63736",
    "uf": "CE",
    "codigoIbge": 2304103,
    "cidade": "Crateús"
  },
  {
    "prefixo": "63740",
    "uf": "CE",
    "codigoIbge": 2309409,
    "cidade": "Novo Oriente"
  },
  {
    "prefixo": "63744",
    "uf": "CE",
    "codigoIbge": 2309409,
    "cidade": "Novo Oriente"
  },
  {
    "prefixo": "63746",
    "uf": "CE",
    "codigoIbge": 2309409,
    "cidade": "Novo Oriente"
  },
  {
    "prefixo": "63750",
    "uf": "CE",
    "codigoIbge": 2313203,
    "cidade": "Tamboril"
  },
  {
    "prefixo": "63755",
    "uf": "CE",
    "codigoIbge": 2313203,
    "cidade": "Tamboril"
  },
  {
    "prefixo": "63760",
    "uf": "CE",
    "codigoIbge": 2313203,
    "cidade": "Tamboril"
  },
  {
    "prefixo": "63765",
    "uf": "CE",
    "codigoIbge": 2313203,
    "cidade": "Tamboril"
  },
  {
    "prefixo": "63768",
    "uf": "CE",
    "codigoIbge": 2313203,
    "cidade": "Tamboril"
  },
  {
    "prefixo": "63770",
    "uf": "CE",
    "codigoIbge": 2313203,
    "cidade": "Tamboril"
  },
  {
    "prefixo": "63775",
    "uf": "CE",
    "codigoIbge": 2313203,
    "cidade": "Tamboril"
  },
  {
    "prefixo": "63779",
    "uf": "CE",
    "codigoIbge": 2313203,
    "cidade": "Tamboril"
  },
  {
    "prefixo": "63780",
    "uf": "CE",
    "codigoIbge": 2308609,
    "cidade": "Monsenhor Tabosa"
  },
  {
    "prefixo": "63785",
    "uf": "CE",
    "codigoIbge": 2308609,
    "cidade": "Monsenhor Tabosa"
  },
  {
    "prefixo": "63790",
    "uf": "CE",
    "codigoIbge": 2308609,
    "cidade": "Monsenhor Tabosa"
  },
  {
    "prefixo": "63800",
    "uf": "CE",
    "codigoIbge": 2311405,
    "cidade": "Quixeramobim"
  },
  {
    "prefixo": "63816",
    "uf": "CE",
    "codigoIbge": 2311405,
    "cidade": "Quixeramobim"
  },
  {
    "prefixo": "63823",
    "uf": "CE",
    "codigoIbge": 2311405,
    "cidade": "Quixeramobim"
  },
  {
    "prefixo": "63825",
    "uf": "CE",
    "codigoIbge": 2311405,
    "cidade": "Quixeramobim"
  },
  {
    "prefixo": "63830",
    "uf": "CE",
    "codigoIbge": 2311405,
    "cidade": "Quixeramobim"
  },
  {
    "prefixo": "63860",
    "uf": "CE",
    "codigoIbge": 2307635,
    "cidade": "Madalena"
  },
  {
    "prefixo": "63865",
    "uf": "CE",
    "codigoIbge": 2307635,
    "cidade": "Madalena"
  },
  {
    "prefixo": "63866",
    "uf": "CE",
    "codigoIbge": 2307635,
    "cidade": "Madalena"
  },
  {
    "prefixo": "63867",
    "uf": "CE",
    "codigoIbge": 2307635,
    "cidade": "Madalena"
  },
  {
    "prefixo": "63868",
    "uf": "CE",
    "codigoIbge": 2307635,
    "cidade": "Madalena"
  },
  {
    "prefixo": "63870",
    "uf": "CE",
    "codigoIbge": 2302404,
    "cidade": "Boa Viagem"
  },
  {
    "prefixo": "63883",
    "uf": "CE",
    "codigoIbge": 2302404,
    "cidade": "Boa Viagem"
  },
  {
    "prefixo": "63885",
    "uf": "CE",
    "codigoIbge": 2302404,
    "cidade": "Boa Viagem"
  },
  {
    "prefixo": "63887",
    "uf": "CE",
    "codigoIbge": 2302404,
    "cidade": "Boa Viagem"
  },
  {
    "prefixo": "63890",
    "uf": "CE",
    "codigoIbge": 2302404,
    "cidade": "Boa Viagem"
  },
  {
    "prefixo": "63891",
    "uf": "CE",
    "codigoIbge": 2302404,
    "cidade": "Boa Viagem"
  },
  {
    "prefixo": "63893",
    "uf": "CE",
    "codigoIbge": 2302404,
    "cidade": "Boa Viagem"
  },
  {
    "prefixo": "63900",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63901",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63902",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63903",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63905",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63906",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63907",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63908",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63909",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63910",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63915",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63917",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63920",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63925",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63927",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63930",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63932",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63935",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63940",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63945",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63948",
    "uf": "CE",
    "codigoIbge": 2311306,
    "cidade": "Quixadá"
  },
  {
    "prefixo": "63950",
    "uf": "CE",
    "codigoIbge": 2303931,
    "cidade": "Choró"
  },
  {
    "prefixo": "63952",
    "uf": "CE",
    "codigoIbge": 2303931,
    "cidade": "Choró"
  },
  {
    "prefixo": "63955",
    "uf": "CE",
    "codigoIbge": 2303931,
    "cidade": "Choró"
  },
  {
    "prefixo": "63957",
    "uf": "CE",
    "codigoIbge": 2303931,
    "cidade": "Choró"
  },
  {
    "prefixo": "63958",
    "uf": "CE",
    "codigoIbge": 2303931,
    "cidade": "Choró"
  },
  {
    "prefixo": "63960",
    "uf": "CE",
    "codigoIbge": 2301851,
    "cidade": "Banabuiú"
  },
  {
    "prefixo": "63962",
    "uf": "CE",
    "codigoIbge": 2301851,
    "cidade": "Banabuiú"
  },
  {
    "prefixo": "63965",
    "uf": "CE",
    "codigoIbge": 2301851,
    "cidade": "Banabuiú"
  },
  {
    "prefixo": "63966",
    "uf": "CE",
    "codigoIbge": 2301851,
    "cidade": "Banabuiú"
  },
  {
    "prefixo": "63967",
    "uf": "CE",
    "codigoIbge": 2301851,
    "cidade": "Banabuiú"
  },
  {
    "prefixo": "63970",
    "uf": "CE",
    "codigoIbge": 2305266,
    "cidade": "Ibaretama"
  },
  {
    "prefixo": "63980",
    "uf": "CE",
    "codigoIbge": 2305266,
    "cidade": "Ibaretama"
  },
  {
    "prefixo": "63982",
    "uf": "CE",
    "codigoIbge": 2305266,
    "cidade": "Ibaretama"
  },
  {
    "prefixo": "63984",
    "uf": "CE",
    "codigoIbge": 2305266,
    "cidade": "Ibaretama"
  },
  {
    "prefixo": "63990",
    "uf": "CE",
    "codigoIbge": 2305266,
    "cidade": "Ibaretama"
  },
  {
    "prefixo": "64000",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64001",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64002",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64003",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64004",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64005",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64006",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64007",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64008",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64009",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64010",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64011",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64012",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64013",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64014",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64015",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64016",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64017",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64018",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64019",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64020",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64022",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64023",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64024",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64025",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64027",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64028",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64029",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64030",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64031",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64032",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64033",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64034",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64035",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64036",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64037",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64038",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64039",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64040",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64041",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64042",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64045",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64046",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64047",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64048",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64049",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64050",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64051",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64052",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64053",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64055",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64056",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64057",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64058",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64059",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64060",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64062",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64063",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64064",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64065",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64066",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64067",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64069",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64071",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64072",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64073",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64074",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64075",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64076",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64077",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64078",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64079",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64080",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64081",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64082",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64083",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64084",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64085",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64086",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64088",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64089",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64090",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64091",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64093",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64095",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64097",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64099",
    "uf": "PI",
    "codigoIbge": 2211001,
    "cidade": "Teresina"
  },
  {
    "prefixo": "64100",
    "uf": "PI",
    "codigoIbge": 2201200,
    "cidade": "Barras"
  },
  {
    "prefixo": "64105",
    "uf": "PI",
    "codigoIbge": 2202059,
    "cidade": "Cabeceiras do Piauí"
  },
  {
    "prefixo": "64108",
    "uf": "PI",
    "codigoIbge": 2201770,
    "cidade": "Boa Hora"
  },
  {
    "prefixo": "64110",
    "uf": "PI",
    "codigoIbge": 2205508,
    "cidade": "José de Freitas"
  },
  {
    "prefixo": "64120",
    "uf": "PI",
    "codigoIbge": 2211100,
    "cidade": "União"
  },
  {
    "prefixo": "64125",
    "uf": "PI",
    "codigoIbge": 2211100,
    "cidade": "União"
  },
  {
    "prefixo": "64130",
    "uf": "PI",
    "codigoIbge": 2206209,
    "cidade": "Miguel Alves"
  },
  {
    "prefixo": "64138",
    "uf": "PI",
    "codigoIbge": 2205557,
    "cidade": "Lagoa Alegre"
  },
  {
    "prefixo": "64140",
    "uf": "PI",
    "codigoIbge": 2206803,
    "cidade": "Nossa Senhora dos Remédios"
  },
  {
    "prefixo": "64145",
    "uf": "PI",
    "codigoIbge": 2208502,
    "cidade": "Porto"
  },
  {
    "prefixo": "64148",
    "uf": "PI",
    "codigoIbge": 2202174,
    "cidade": "Campo Largo do Piauí"
  },
  {
    "prefixo": "64150",
    "uf": "PI",
    "codigoIbge": 2206100,
    "cidade": "Matias Olímpio"
  },
  {
    "prefixo": "64155",
    "uf": "PI",
    "codigoIbge": 2209971,
    "cidade": "São João do Arraial"
  },
  {
    "prefixo": "64160",
    "uf": "PI",
    "codigoIbge": 2205805,
    "cidade": "Luzilândia"
  },
  {
    "prefixo": "64165",
    "uf": "PI",
    "codigoIbge": 2205458,
    "cidade": "Joca Marques"
  },
  {
    "prefixo": "64168",
    "uf": "PI",
    "codigoIbge": 2205854,
    "cidade": "Madeiro"
  },
  {
    "prefixo": "64170",
    "uf": "PI",
    "codigoIbge": 2205409,
    "cidade": "Joaquim Pires"
  },
  {
    "prefixo": "64175",
    "uf": "PI",
    "codigoIbge": 2206696,
    "cidade": "Murici dos Portelas"
  },
  {
    "prefixo": "64178",
    "uf": "PI",
    "codigoIbge": 2206670,
    "cidade": "Morro do Chapéu do Piauí"
  },
  {
    "prefixo": "64180",
    "uf": "PI",
    "codigoIbge": 2203701,
    "cidade": "Esperantina"
  },
  {
    "prefixo": "64190",
    "uf": "PI",
    "codigoIbge": 2201507,
    "cidade": "Batalha"
  },
  {
    "prefixo": "64200",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64201",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64202",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64204",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64205",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64206",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64207",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64208",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64209",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64210",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64211",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64212",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64213",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64215",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64216",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64217",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64218",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64219",
    "uf": "PI",
    "codigoIbge": 2207702,
    "cidade": "Parnaíba"
  },
  {
    "prefixo": "64220",
    "uf": "PI",
    "codigoIbge": 2205706,
    "cidade": "Luís Correia"
  },
  {
    "prefixo": "64222",
    "uf": "PI",
    "codigoIbge": 2202083,
    "cidade": "Cajueiro da Praia"
  },
  {
    "prefixo": "64224",
    "uf": "PI",
    "codigoIbge": 2204659,
    "cidade": "Ilha Grande"
  },
  {
    "prefixo": "64225",
    "uf": "PI",
    "codigoIbge": 2201919,
    "cidade": "Bom Princípio do Piauí"
  },
  {
    "prefixo": "64228",
    "uf": "PI",
    "codigoIbge": 2202653,
    "cidade": "Caxingó"
  },
  {
    "prefixo": "64230",
    "uf": "PI",
    "codigoIbge": 2202000,
    "cidade": "Buriti dos Lopes"
  },
  {
    "prefixo": "64233",
    "uf": "PI",
    "codigoIbge": 2202539,
    "cidade": "Caraúbas do Piauí"
  },
  {
    "prefixo": "64235",
    "uf": "PI",
    "codigoIbge": 2202703,
    "cidade": "Cocal"
  },
  {
    "prefixo": "64238",
    "uf": "PI",
    "codigoIbge": 2202729,
    "cidade": "Cocal dos Alves"
  },
  {
    "prefixo": "64240",
    "uf": "PI",
    "codigoIbge": 2208304,
    "cidade": "Piracuruca"
  },
  {
    "prefixo": "64243",
    "uf": "PI",
    "codigoIbge": 2209872,
    "cidade": "São João da Fronteira"
  },
  {
    "prefixo": "64245",
    "uf": "PI",
    "codigoIbge": 2210052,
    "cidade": "São José do Divino"
  },
  {
    "prefixo": "64250",
    "uf": "PI",
    "codigoIbge": 2203420,
    "cidade": "Domingos Mourão"
  },
  {
    "prefixo": "64253",
    "uf": "PI",
    "codigoIbge": 2206357,
    "cidade": "Milton Brandão"
  },
  {
    "prefixo": "64255",
    "uf": "PI",
    "codigoIbge": 2207900,
    "cidade": "Pedro II"
  },
  {
    "prefixo": "64258",
    "uf": "PI",
    "codigoIbge": 2205573,
    "cidade": "Lagoa de São Francisco"
  },
  {
    "prefixo": "64260",
    "uf": "PI",
    "codigoIbge": 2208403,
    "cidade": "Piripiri"
  },
  {
    "prefixo": "64265",
    "uf": "PI",
    "codigoIbge": 2201960,
    "cidade": "Brasileira"
  },
  {
    "prefixo": "64270",
    "uf": "PI",
    "codigoIbge": 2202406,
    "cidade": "Capitão de Campos"
  },
  {
    "prefixo": "64275",
    "uf": "PI",
    "codigoIbge": 2205276,
    "cidade": "Jatobá do Piauí"
  },
  {
    "prefixo": "64278",
    "uf": "PI",
    "codigoIbge": 2202711,
    "cidade": "Cocal de Telha"
  },
  {
    "prefixo": "64280",
    "uf": "PI",
    "codigoIbge": 2202208,
    "cidade": "Campo Maior"
  },
  {
    "prefixo": "64283",
    "uf": "PI",
    "codigoIbge": 2201945,
    "cidade": "Boqueirão do Piauí"
  },
  {
    "prefixo": "64285",
    "uf": "PI",
    "codigoIbge": 2210656,
    "cidade": "Sigefredo Pacheco"
  },
  {
    "prefixo": "64288",
    "uf": "PI",
    "codigoIbge": 2206753,
    "cidade": "Nossa Senhora de Nazaré"
  },
  {
    "prefixo": "64290",
    "uf": "PI",
    "codigoIbge": 2200400,
    "cidade": "Altos"
  },
  {
    "prefixo": "64295",
    "uf": "PI",
    "codigoIbge": 2207793,
    "cidade": "Pau D'Arco do Piauí"
  },
  {
    "prefixo": "64300",
    "uf": "PI",
    "codigoIbge": 2211308,
    "cidade": "Valença do Piauí"
  },
  {
    "prefixo": "64308",
    "uf": "PI",
    "codigoIbge": 2205599,
    "cidade": "Lagoa do Sítio"
  },
  {
    "prefixo": "64310",
    "uf": "PI",
    "codigoIbge": 2200905,
    "cidade": "Aroazes"
  },
  {
    "prefixo": "64315",
    "uf": "PI",
    "codigoIbge": 2209153,
    "cidade": "Santa Cruz dos Milagres"
  },
  {
    "prefixo": "64320",
    "uf": "PI",
    "codigoIbge": 2208106,
    "cidade": "Pimenteiras"
  },
  {
    "prefixo": "64325",
    "uf": "PI",
    "codigoIbge": 2203503,
    "cidade": "Elesbão Veloso"
  },
  {
    "prefixo": "64330",
    "uf": "PI",
    "codigoIbge": 2210409,
    "cidade": "São Miguel do Tapuio"
  },
  {
    "prefixo": "64333",
    "uf": "PI",
    "codigoIbge": 2201051,
    "cidade": "Assunção do Piauí"
  },
  {
    "prefixo": "64335",
    "uf": "PI",
    "codigoIbge": 2202737,
    "cidade": "Coivaras"
  },
  {
    "prefixo": "64340",
    "uf": "PI",
    "codigoIbge": 2202604,
    "cidade": "Castelo do Piauí"
  },
  {
    "prefixo": "64343",
    "uf": "PI",
    "codigoIbge": 2205516,
    "cidade": "Juazeiro do Piauí"
  },
  {
    "prefixo": "64345",
    "uf": "PI",
    "codigoIbge": 2202026,
    "cidade": "Buriti dos Montes"
  },
  {
    "prefixo": "64350",
    "uf": "PI",
    "codigoIbge": 2209906,
    "cidade": "São João da Serra"
  },
  {
    "prefixo": "64360",
    "uf": "PI",
    "codigoIbge": 2200301,
    "cidade": "Alto Longá"
  },
  {
    "prefixo": "64365",
    "uf": "PI",
    "codigoIbge": 2206951,
    "cidade": "Novo Santo Antônio"
  },
  {
    "prefixo": "64370",
    "uf": "PI",
    "codigoIbge": 2208601,
    "cidade": "Prata do Piauí"
  },
  {
    "prefixo": "64375",
    "uf": "PI",
    "codigoIbge": 2209609,
    "cidade": "São Félix do Piauí"
  },
  {
    "prefixo": "64378",
    "uf": "PI",
    "codigoIbge": 2210383,
    "cidade": "São Miguel da Baixa Grande"
  },
  {
    "prefixo": "64380",
    "uf": "PI",
    "codigoIbge": 2201606,
    "cidade": "Beneditinos"
  },
  {
    "prefixo": "64388",
    "uf": "PI",
    "codigoIbge": 2205581,
    "cidade": "Lagoa do Piauí"
  },
  {
    "prefixo": "64390",
    "uf": "PI",
    "codigoIbge": 2203305,
    "cidade": "Demerval Lobão"
  },
  {
    "prefixo": "64395",
    "uf": "PI",
    "codigoIbge": 2207751,
    "cidade": "Passagem Franca do Piauí"
  },
  {
    "prefixo": "64400",
    "uf": "PI",
    "codigoIbge": 2200509,
    "cidade": "Amarante"
  },
  {
    "prefixo": "64410",
    "uf": "PI",
    "codigoIbge": 2200608,
    "cidade": "Angical do Piauí"
  },
  {
    "prefixo": "64415",
    "uf": "PI",
    "codigoIbge": 2206720,
    "cidade": "Nazária"
  },
  {
    "prefixo": "64420",
    "uf": "PI",
    "codigoIbge": 2207504,
    "cidade": "Palmeirais"
  },
  {
    "prefixo": "64430",
    "uf": "PI",
    "codigoIbge": 2210508,
    "cidade": "São Pedro do Piauí"
  },
  {
    "prefixo": "64435",
    "uf": "PI",
    "codigoIbge": 2209807,
    "cidade": "São Gonçalo do Piauí"
  },
  {
    "prefixo": "64438",
    "uf": "PI",
    "codigoIbge": 2209450,
    "cidade": "Santo Antônio dos Milagres"
  },
  {
    "prefixo": "64440",
    "uf": "PI",
    "codigoIbge": 2200103,
    "cidade": "Agricolândia"
  },
  {
    "prefixo": "64445",
    "uf": "PI",
    "codigoIbge": 2206308,
    "cidade": "Miguel Leão"
  },
  {
    "prefixo": "64450",
    "uf": "PI",
    "codigoIbge": 2206407,
    "cidade": "Monsenhor Gil"
  },
  {
    "prefixo": "64453",
    "uf": "PI",
    "codigoIbge": 2203255,
    "cidade": "Curralinhos"
  },
  {
    "prefixo": "64455",
    "uf": "PI",
    "codigoIbge": 2201408,
    "cidade": "Barro Duro"
  },
  {
    "prefixo": "64460",
    "uf": "PI",
    "codigoIbge": 2200202,
    "cidade": "Água Branca"
  },
  {
    "prefixo": "64464",
    "uf": "PA",
    "codigoIbge": 1508100,
    "cidade": "Tucuruí"
  },
  {
    "prefixo": "64465",
    "uf": "PI",
    "codigoIbge": 2205540,
    "cidade": "Lagoinha do Piauí"
  },
  {
    "prefixo": "64468",
    "uf": "PI",
    "codigoIbge": 2207108,
    "cidade": "Olho D'Água do Piauí"
  },
  {
    "prefixo": "64470",
    "uf": "PI",
    "codigoIbge": 2204600,
    "cidade": "Hugo Napoleão"
  },
  {
    "prefixo": "64475",
    "uf": "PI",
    "codigoIbge": 2204105,
    "cidade": "Francisco Ayres"
  },
  {
    "prefixo": "64480",
    "uf": "PI",
    "codigoIbge": 2201002,
    "cidade": "Arraial"
  },
  {
    "prefixo": "64490",
    "uf": "PI",
    "codigoIbge": 2208809,
    "cidade": "Regeneração"
  },
  {
    "prefixo": "64495",
    "uf": "PI",
    "codigoIbge": 2205250,
    "cidade": "Jardim do Mulato"
  },
  {
    "prefixo": "64500",
    "uf": "PI",
    "codigoIbge": 2207009,
    "cidade": "Oeiras"
  },
  {
    "prefixo": "64510",
    "uf": "PI",
    "codigoIbge": 2209955,
    "cidade": "São João da Varjota"
  },
  {
    "prefixo": "64512",
    "uf": "PI",
    "codigoIbge": 2210979,
    "cidade": "Tanque do Piauí"
  },
  {
    "prefixo": "64514",
    "uf": "PI",
    "codigoIbge": 2202075,
    "cidade": "Cajazeiras do Piauí"
  },
  {
    "prefixo": "64516",
    "uf": "PI",
    "codigoIbge": 2202778,
    "cidade": "Colônia do Piauí"
  },
  {
    "prefixo": "64518",
    "uf": "PI",
    "codigoIbge": 2209377,
    "cidade": "Santa Rosa do Piauí"
  },
  {
    "prefixo": "64520",
    "uf": "PI",
    "codigoIbge": 2204006,
    "cidade": "Francinópolis"
  },
  {
    "prefixo": "64525",
    "uf": "PI",
    "codigoIbge": 2211407,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "64528",
    "uf": "PI",
    "codigoIbge": 2201176,
    "cidade": "Barra D'Alcântara"
  },
  {
    "prefixo": "64530",
    "uf": "PI",
    "codigoIbge": 2206902,
    "cidade": "Novo Oriente do Piauí"
  },
  {
    "prefixo": "64535",
    "uf": "PI",
    "codigoIbge": 2204709,
    "cidade": "Inhuma"
  },
  {
    "prefixo": "64540",
    "uf": "PI",
    "codigoIbge": 2204808,
    "cidade": "Ipiranga do Piauí"
  },
  {
    "prefixo": "64545",
    "uf": "PI",
    "codigoIbge": 2209104,
    "cidade": "Santa Cruz do Piauí"
  },
  {
    "prefixo": "64548",
    "uf": "PI",
    "codigoIbge": 2211704,
    "cidade": "Wall Ferraz"
  },
  {
    "prefixo": "64550",
    "uf": "PI",
    "codigoIbge": 2209708,
    "cidade": "São Francisco do Piauí"
  },
  {
    "prefixo": "64555",
    "uf": "PI",
    "codigoIbge": 2210102,
    "cidade": "São José do Peixe"
  },
  {
    "prefixo": "64558",
    "uf": "PI",
    "codigoIbge": 2210391,
    "cidade": "São Miguel do Fidalgo"
  },
  {
    "prefixo": "64560",
    "uf": "PI",
    "codigoIbge": 2209500,
    "cidade": "Santo Inácio do Piauí"
  },
  {
    "prefixo": "64563",
    "uf": "PI",
    "codigoIbge": 2203859,
    "cidade": "Floresta do Piauí"
  },
  {
    "prefixo": "64565",
    "uf": "PI",
    "codigoIbge": 2205003,
    "cidade": "Itainópolis"
  },
  {
    "prefixo": "64568",
    "uf": "PI",
    "codigoIbge": 2211506,
    "cidade": "Vera Mendes"
  },
  {
    "prefixo": "64570",
    "uf": "PI",
    "codigoIbge": 2204907,
    "cidade": "Isaías Coelho"
  },
  {
    "prefixo": "64573",
    "uf": "PI",
    "codigoIbge": 2206050,
    "cidade": "Massapê do Piauí"
  },
  {
    "prefixo": "64575",
    "uf": "PI",
    "codigoIbge": 2205201,
    "cidade": "Jaicós"
  },
  {
    "prefixo": "64578",
    "uf": "PI",
    "codigoIbge": 2202133,
    "cidade": "Campo Grande do Piauí"
  },
  {
    "prefixo": "64580",
    "uf": "PI",
    "codigoIbge": 2207777,
    "cidade": "Patos do Piauí"
  },
  {
    "prefixo": "64585",
    "uf": "PI",
    "codigoIbge": 2210706,
    "cidade": "Simões"
  },
  {
    "prefixo": "64590",
    "uf": "PI",
    "codigoIbge": 2202554,
    "cidade": "Caridade do Piauí"
  },
  {
    "prefixo": "64595",
    "uf": "PI",
    "codigoIbge": 2203271,
    "cidade": "Curral Novo do Piauí"
  },
  {
    "prefixo": "64600",
    "uf": "PI",
    "codigoIbge": 2208007,
    "cidade": "Picos"
  },
  {
    "prefixo": "64601",
    "uf": "PI",
    "codigoIbge": 2208007,
    "cidade": "Picos"
  },
  {
    "prefixo": "64602",
    "uf": "PI",
    "codigoIbge": 2208007,
    "cidade": "Picos"
  },
  {
    "prefixo": "64603",
    "uf": "PI",
    "codigoIbge": 2208007,
    "cidade": "Picos"
  },
  {
    "prefixo": "64604",
    "uf": "PI",
    "codigoIbge": 2208007,
    "cidade": "Picos"
  },
  {
    "prefixo": "64605",
    "uf": "PI",
    "codigoIbge": 2208007,
    "cidade": "Picos"
  },
  {
    "prefixo": "64606",
    "uf": "PI",
    "codigoIbge": 2208007,
    "cidade": "Picos"
  },
  {
    "prefixo": "64607",
    "uf": "PI",
    "codigoIbge": 2208007,
    "cidade": "Picos"
  },
  {
    "prefixo": "64608",
    "uf": "PI",
    "codigoIbge": 2208007,
    "cidade": "Picos"
  },
  {
    "prefixo": "64610",
    "uf": "PI",
    "codigoIbge": 2210938,
    "cidade": "Sussuapara"
  },
  {
    "prefixo": "64612",
    "uf": "PI",
    "codigoIbge": 2200954,
    "cidade": "Aroeiras do Itaim"
  },
  {
    "prefixo": "64613",
    "uf": "PI",
    "codigoIbge": 2204352,
    "cidade": "Geminiano"
  },
  {
    "prefixo": "64615",
    "uf": "PI",
    "codigoIbge": 2209351,
    "cidade": "Santana do Piauí"
  },
  {
    "prefixo": "64618",
    "uf": "PI",
    "codigoIbge": 2207553,
    "cidade": "Paquetá"
  },
  {
    "prefixo": "64620",
    "uf": "PI",
    "codigoIbge": 2203404,
    "cidade": "Dom Expedito Lopes"
  },
  {
    "prefixo": "64625",
    "uf": "PI",
    "codigoIbge": 2210201,
    "cidade": "São José do Piauí"
  },
  {
    "prefixo": "64630",
    "uf": "PI",
    "codigoIbge": 2201804,
    "cidade": "Bocaina"
  },
  {
    "prefixo": "64635",
    "uf": "PI",
    "codigoIbge": 2209856,
    "cidade": "São João da Canabrava"
  },
  {
    "prefixo": "64638",
    "uf": "PI",
    "codigoIbge": 2210375,
    "cidade": "São Luis do Piauí"
  },
  {
    "prefixo": "64640",
    "uf": "PI",
    "codigoIbge": 2209401,
    "cidade": "Santo Antônio de Lisboa"
  },
  {
    "prefixo": "64645",
    "uf": "PI",
    "codigoIbge": 2204204,
    "cidade": "Francisco Santos"
  },
  {
    "prefixo": "64650",
    "uf": "PI",
    "codigoIbge": 2206506,
    "cidade": "Monsenhor Hipólito"
  },
  {
    "prefixo": "64655",
    "uf": "PI",
    "codigoIbge": 2200251,
    "cidade": "Alagoinha do Piauí"
  },
  {
    "prefixo": "64660",
    "uf": "PI",
    "codigoIbge": 2208205,
    "cidade": "Pio IX"
  },
  {
    "prefixo": "64670",
    "uf": "PI",
    "codigoIbge": 2210300,
    "cidade": "São Julião"
  },
  {
    "prefixo": "64675",
    "uf": "PI",
    "codigoIbge": 2200277,
    "cidade": "Alegrete do Piauí"
  },
  {
    "prefixo": "64678",
    "uf": "PI",
    "codigoIbge": 2201572,
    "cidade": "Belém do Piauí"
  },
  {
    "prefixo": "64680",
    "uf": "PI",
    "codigoIbge": 2207207,
    "cidade": "Padre Marcos"
  },
  {
    "prefixo": "64683",
    "uf": "PI",
    "codigoIbge": 2204154,
    "cidade": "Francisco Macedo"
  },
  {
    "prefixo": "64685",
    "uf": "PI",
    "codigoIbge": 2205953,
    "cidade": "Marcolândia"
  },
  {
    "prefixo": "64688",
    "uf": "PI",
    "codigoIbge": 2211605,
    "cidade": "Vila Nova do Piauí"
  },
  {
    "prefixo": "64690",
    "uf": "PI",
    "codigoIbge": 2204303,
    "cidade": "Fronteiras"
  },
  {
    "prefixo": "64695",
    "uf": "PI",
    "codigoIbge": 2202091,
    "cidade": "Caldeirão Grande do Piauí"
  },
  {
    "prefixo": "64700",
    "uf": "PI",
    "codigoIbge": 2210805,
    "cidade": "Simplício Mendes"
  },
  {
    "prefixo": "64705",
    "uf": "PI",
    "codigoIbge": 2201556,
    "cidade": "Bela Vista do Piauí"
  },
  {
    "prefixo": "64710",
    "uf": "PI",
    "codigoIbge": 2207306,
    "cidade": "Paes Landim"
  },
  {
    "prefixo": "64720",
    "uf": "PI",
    "codigoIbge": 2210904,
    "cidade": "Socorro do Piauí"
  },
  {
    "prefixo": "64725",
    "uf": "PI",
    "codigoIbge": 2208874,
    "cidade": "Ribeira do Piauí"
  },
  {
    "prefixo": "64728",
    "uf": "PI",
    "codigoIbge": 2207934,
    "cidade": "Pedro Laurentino"
  },
  {
    "prefixo": "64730",
    "uf": "PI",
    "codigoIbge": 2202109,
    "cidade": "Campinas do Piauí"
  },
  {
    "prefixo": "64740",
    "uf": "PI",
    "codigoIbge": 2202802,
    "cidade": "Conceição do Canindé"
  },
  {
    "prefixo": "64745",
    "uf": "PI",
    "codigoIbge": 2209658,
    "cidade": "São Francisco de Assis do Piauí"
  },
  {
    "prefixo": "64748",
    "uf": "PI",
    "codigoIbge": 2200053,
    "cidade": "Acauã"
  },
  {
    "prefixo": "64750",
    "uf": "PI",
    "codigoIbge": 2207801,
    "cidade": "Paulistana"
  },
  {
    "prefixo": "64753",
    "uf": "PI",
    "codigoIbge": 2201739,
    "cidade": "Betânia do Piauí"
  },
  {
    "prefixo": "64755",
    "uf": "PI",
    "codigoIbge": 2205151,
    "cidade": "Jacobina do Piauí"
  },
  {
    "prefixo": "64758",
    "uf": "PI",
    "codigoIbge": 2208650,
    "cidade": "Queimada Nova"
  },
  {
    "prefixo": "64760",
    "uf": "PI",
    "codigoIbge": 2210003,
    "cidade": "São João do Piauí"
  },
  {
    "prefixo": "64763",
    "uf": "PI",
    "codigoIbge": 2202455,
    "cidade": "Capitão Gervásio Oliveira"
  },
  {
    "prefixo": "64764",
    "uf": "PI",
    "codigoIbge": 2207959,
    "cidade": "Nova Santa Rita"
  },
  {
    "prefixo": "64765",
    "uf": "PI",
    "codigoIbge": 2205359,
    "cidade": "João Costa"
  },
  {
    "prefixo": "64767",
    "uf": "PI",
    "codigoIbge": 2202117,
    "cidade": "Campo Alegre do Fidalgo"
  },
  {
    "prefixo": "64768",
    "uf": "PI",
    "codigoIbge": 2205565,
    "cidade": "Lagoa do Barro do Piauí"
  },
  {
    "prefixo": "64770",
    "uf": "PI",
    "codigoIbge": 2210607,
    "cidade": "São Raimundo Nonato"
  },
  {
    "prefixo": "64773",
    "uf": "PI",
    "codigoIbge": 2211357,
    "cidade": "Várzea Branca"
  },
  {
    "prefixo": "64775",
    "uf": "PI",
    "codigoIbge": 2201929,
    "cidade": "Bonfim do Piauí"
  },
  {
    "prefixo": "64778",
    "uf": "PI",
    "codigoIbge": 2210359,
    "cidade": "São Lourenço do Piauí"
  },
  {
    "prefixo": "64780",
    "uf": "PI",
    "codigoIbge": 2200707,
    "cidade": "Anísio de Abreu"
  },
  {
    "prefixo": "64782",
    "uf": "PI",
    "codigoIbge": 2205532,
    "cidade": "Jurema"
  },
  {
    "prefixo": "64783",
    "uf": "PI",
    "codigoIbge": 2209559,
    "cidade": "São Braz do Piauí"
  },
  {
    "prefixo": "64785",
    "uf": "PI",
    "codigoIbge": 2203354,
    "cidade": "Dirceu Arcoverde"
  },
  {
    "prefixo": "64788",
    "uf": "PI",
    "codigoIbge": 2203750,
    "cidade": "Fartura do Piauí"
  },
  {
    "prefixo": "64790",
    "uf": "PI",
    "codigoIbge": 2203453,
    "cidade": "Dom Inocêncio"
  },
  {
    "prefixo": "64793",
    "uf": "PI",
    "codigoIbge": 2202851,
    "cidade": "Coronel José Dias"
  },
  {
    "prefixo": "64795",
    "uf": "PI",
    "codigoIbge": 2202505,
    "cidade": "Caracol"
  },
  {
    "prefixo": "64798",
    "uf": "PI",
    "codigoIbge": 2204550,
    "cidade": "Guaribas"
  },
  {
    "prefixo": "64800",
    "uf": "PI",
    "codigoIbge": 2203909,
    "cidade": "Floriano"
  },
  {
    "prefixo": "64801",
    "uf": "PI",
    "codigoIbge": 2203909,
    "cidade": "Floriano"
  },
  {
    "prefixo": "64803",
    "uf": "PI",
    "codigoIbge": 2203909,
    "cidade": "Floriano"
  },
  {
    "prefixo": "64804",
    "uf": "PI",
    "codigoIbge": 2203909,
    "cidade": "Floriano"
  },
  {
    "prefixo": "64806",
    "uf": "PI",
    "codigoIbge": 2203909,
    "cidade": "Floriano"
  },
  {
    "prefixo": "64807",
    "uf": "PI",
    "codigoIbge": 2203909,
    "cidade": "Floriano"
  },
  {
    "prefixo": "64808",
    "uf": "PI",
    "codigoIbge": 2203909,
    "cidade": "Floriano"
  },
  {
    "prefixo": "64809",
    "uf": "PI",
    "codigoIbge": 2203909,
    "cidade": "Floriano"
  },
  {
    "prefixo": "64815",
    "uf": "PI",
    "codigoIbge": 2203800,
    "cidade": "Flores do Piauí"
  },
  {
    "prefixo": "64820",
    "uf": "PI",
    "codigoIbge": 2205102,
    "cidade": "Itaueira"
  },
  {
    "prefixo": "64825",
    "uf": "PI",
    "codigoIbge": 2206704,
    "cidade": "Nazaré do Piauí"
  },
  {
    "prefixo": "64830",
    "uf": "PI",
    "codigoIbge": 2205300,
    "cidade": "Jerumenha"
  },
  {
    "prefixo": "64833",
    "uf": "PI",
    "codigoIbge": 2202251,
    "cidade": "Canavieira"
  },
  {
    "prefixo": "64835",
    "uf": "PI",
    "codigoIbge": 2209005,
    "cidade": "Rio Grande do Piauí"
  },
  {
    "prefixo": "64838",
    "uf": "PI",
    "codigoIbge": 2207850,
    "cidade": "Pavussu"
  },
  {
    "prefixo": "64840",
    "uf": "PI",
    "codigoIbge": 2204501,
    "cidade": "Guadalupe"
  },
  {
    "prefixo": "64845",
    "uf": "PI",
    "codigoIbge": 2206001,
    "cidade": "Marcos Parente"
  },
  {
    "prefixo": "64850",
    "uf": "PI",
    "codigoIbge": 2205607,
    "cidade": "Landri Sales"
  },
  {
    "prefixo": "64855",
    "uf": "PI",
    "codigoIbge": 2200806,
    "cidade": "Antônio Almeida"
  },
  {
    "prefixo": "64858",
    "uf": "PI",
    "codigoIbge": 2208551,
    "cidade": "Porto Alegre do Piauí"
  },
  {
    "prefixo": "64860",
    "uf": "PI",
    "codigoIbge": 2211209,
    "cidade": "Uruçuí"
  },
  {
    "prefixo": "64865",
    "uf": "PI",
    "codigoIbge": 2208908,
    "cidade": "Ribeiro Gonçalves"
  },
  {
    "prefixo": "64868",
    "uf": "PI",
    "codigoIbge": 2201150,
    "cidade": "Baixa Grande do Ribeiro"
  },
  {
    "prefixo": "64870",
    "uf": "PI",
    "codigoIbge": 2201705,
    "cidade": "Bertolínia"
  },
  {
    "prefixo": "64873",
    "uf": "PI",
    "codigoIbge": 2210631,
    "cidade": "Sebastião Leal"
  },
  {
    "prefixo": "64875",
    "uf": "PI",
    "codigoIbge": 2205904,
    "cidade": "Manoel Emídio"
  },
  {
    "prefixo": "64880",
    "uf": "PI",
    "codigoIbge": 2203602,
    "cidade": "Eliseu Martins"
  },
  {
    "prefixo": "64885",
    "uf": "PI",
    "codigoIbge": 2202752,
    "cidade": "Colônia do Gurguéia"
  },
  {
    "prefixo": "64890",
    "uf": "PI",
    "codigoIbge": 2202307,
    "cidade": "Canto do Buriti"
  },
  {
    "prefixo": "64893",
    "uf": "PI",
    "codigoIbge": 2210953,
    "cidade": "Tamboril do Piauí"
  },
  {
    "prefixo": "64895",
    "uf": "PI",
    "codigoIbge": 2201988,
    "cidade": "Brejo do Piauí"
  },
  {
    "prefixo": "64898",
    "uf": "PI",
    "codigoIbge": 2207355,
    "cidade": "Pajeú do Piauí"
  },
  {
    "prefixo": "64900",
    "uf": "PI",
    "codigoIbge": 2201903,
    "cidade": "Bom Jesus"
  },
  {
    "prefixo": "64905",
    "uf": "PI",
    "codigoIbge": 2203230,
    "cidade": "Currais"
  },
  {
    "prefixo": "64910",
    "uf": "PI",
    "codigoIbge": 2209302,
    "cidade": "Santa Luz"
  },
  {
    "prefixo": "64915",
    "uf": "PI",
    "codigoIbge": 2208700,
    "cidade": "Redenção do Gurguéia"
  },
  {
    "prefixo": "64920",
    "uf": "PI",
    "codigoIbge": 2203107,
    "cidade": "Cristino Castro"
  },
  {
    "prefixo": "64923",
    "uf": "PI",
    "codigoIbge": 2200459,
    "cidade": "Alvorada do Gurguéia"
  },
  {
    "prefixo": "64925",
    "uf": "PI",
    "codigoIbge": 2207405,
    "cidade": "Palmeira do Piauí"
  },
  {
    "prefixo": "64930",
    "uf": "PI",
    "codigoIbge": 2204402,
    "cidade": "Gilbués"
  },
  {
    "prefixo": "64940",
    "uf": "PI",
    "codigoIbge": 2206605,
    "cidade": "Monte Alegre do Piauí"
  },
  {
    "prefixo": "64945",
    "uf": "PI",
    "codigoIbge": 2209203,
    "cidade": "Santa Filomena"
  },
  {
    "prefixo": "64960",
    "uf": "PI",
    "codigoIbge": 2203206,
    "cidade": "Curimatá"
  },
  {
    "prefixo": "64963",
    "uf": "PI",
    "codigoIbge": 2205524,
    "cidade": "Júlio Borges"
  },
  {
    "prefixo": "64965",
    "uf": "PI",
    "codigoIbge": 2201101,
    "cidade": "Avelino Lopes"
  },
  {
    "prefixo": "64968",
    "uf": "PI",
    "codigoIbge": 2206654,
    "cidade": "Morro Cabeça no Tempo"
  },
  {
    "prefixo": "64970",
    "uf": "PI",
    "codigoIbge": 2207603,
    "cidade": "Parnaguá"
  },
  {
    "prefixo": "64975",
    "uf": "PI",
    "codigoIbge": 2208858,
    "cidade": "Riacho Frio"
  },
  {
    "prefixo": "64980",
    "uf": "PI",
    "codigoIbge": 2202901,
    "cidade": "Corrente"
  },
  {
    "prefixo": "64985",
    "uf": "PI",
    "codigoIbge": 2210623,
    "cidade": "Sebastião Barros"
  },
  {
    "prefixo": "64990",
    "uf": "PI",
    "codigoIbge": 2201309,
    "cidade": "Barreiras do Piauí"
  },
  {
    "prefixo": "64993",
    "uf": "PI",
    "codigoIbge": 2209757,
    "cidade": "São Gonçalo do Gurguéia"
  },
  {
    "prefixo": "64995",
    "uf": "PI",
    "codigoIbge": 2203008,
    "cidade": "Cristalândia do Piauí"
  },
  {
    "prefixo": "65010",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65011",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65015",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65020",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65021",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65025",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65026",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65030",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65031",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65032",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65033",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65035",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65036",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65037",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65040",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65041",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65042",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65043",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65044",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65045",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65046",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65047",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65048",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65049",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65050",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65051",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65052",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65053",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65054",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65055",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65056",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65057",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65058",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65059",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65060",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65061",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65062",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65063",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65064",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65065",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65066",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65067",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65068",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65070",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65071",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65072",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65073",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65074",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65075",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65076",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65077",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65078",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65080",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65081",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65082",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65083",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65085",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65086",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65090",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65091",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65092",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65093",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65094",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65095",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65096",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65099",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65109",
    "uf": "MA",
    "codigoIbge": 2111300,
    "cidade": "São Luís"
  },
  {
    "prefixo": "65110",
    "uf": "MA",
    "codigoIbge": 2111201,
    "cidade": "São José de Ribamar"
  },
  {
    "prefixo": "65115",
    "uf": "MA",
    "codigoIbge": 2111201,
    "cidade": "São José de Ribamar"
  },
  {
    "prefixo": "65130",
    "uf": "MA",
    "codigoIbge": 2107506,
    "cidade": "Paço do Lumiar"
  },
  {
    "prefixo": "65137",
    "uf": "MA",
    "codigoIbge": 2107506,
    "cidade": "Paço do Lumiar"
  },
  {
    "prefixo": "65138",
    "uf": "MA",
    "codigoIbge": 2109452,
    "cidade": "Raposa"
  },
  {
    "prefixo": "65140",
    "uf": "MA",
    "codigoIbge": 2109205,
    "cidade": "Presidente Juscelino"
  },
  {
    "prefixo": "65143",
    "uf": "MA",
    "codigoIbge": 2101251,
    "cidade": "Bacabeira"
  },
  {
    "prefixo": "65145",
    "uf": "MA",
    "codigoIbge": 2110203,
    "cidade": "Santa Rita"
  },
  {
    "prefixo": "65148",
    "uf": "MA",
    "codigoIbge": 2101103,
    "cidade": "Axixá"
  },
  {
    "prefixo": "65150",
    "uf": "MA",
    "codigoIbge": 2109601,
    "cidade": "Rosário"
  },
  {
    "prefixo": "65160",
    "uf": "MA",
    "codigoIbge": 2107100,
    "cidade": "Morros"
  },
  {
    "prefixo": "65165",
    "uf": "MA",
    "codigoIbge": 2102374,
    "cidade": "Cachoeira Grande"
  },
  {
    "prefixo": "65170",
    "uf": "MA",
    "codigoIbge": 2105104,
    "cidade": "Icatu"
  },
  {
    "prefixo": "65175",
    "uf": "MA",
    "codigoIbge": 2105104,
    "cidade": "Icatu"
  },
  {
    "prefixo": "65180",
    "uf": "MA",
    "codigoIbge": 2105005,
    "cidade": "Humberto de Campos"
  },
  {
    "prefixo": "65190",
    "uf": "MA",
    "codigoIbge": 2109403,
    "cidade": "Primeira Cruz"
  },
  {
    "prefixo": "65195",
    "uf": "MA",
    "codigoIbge": 2110278,
    "cidade": "Santo Amaro do Maranhão"
  },
  {
    "prefixo": "65200",
    "uf": "MA",
    "codigoIbge": 2108603,
    "cidade": "Pinheiro"
  },
  {
    "prefixo": "65202",
    "uf": "MA",
    "codigoIbge": 2108603,
    "cidade": "Pinheiro"
  },
  {
    "prefixo": "65204",
    "uf": "MA",
    "codigoIbge": 2109270,
    "cidade": "Presidente Sarney"
  },
  {
    "prefixo": "65206",
    "uf": "MA",
    "codigoIbge": 2108256,
    "cidade": "Pedro do Rosário"
  },
  {
    "prefixo": "65208",
    "uf": "MA",
    "codigoIbge": 2109809,
    "cidade": "Santa Helena"
  },
  {
    "prefixo": "65209",
    "uf": "MA",
    "codigoIbge": 2109809,
    "cidade": "Santa Helena"
  },
  {
    "prefixo": "65210",
    "uf": "MA",
    "codigoIbge": 2102507,
    "cidade": "Cajari"
  },
  {
    "prefixo": "65211",
    "uf": "MA",
    "codigoIbge": 2102507,
    "cidade": "Cajari"
  },
  {
    "prefixo": "65213",
    "uf": "MA",
    "codigoIbge": 2108306,
    "cidade": "Penalva"
  },
  {
    "prefixo": "65215",
    "uf": "MA",
    "codigoIbge": 2112803,
    "cidade": "Viana"
  },
  {
    "prefixo": "65218",
    "uf": "MA",
    "codigoIbge": 2106508,
    "cidade": "Matinha"
  },
  {
    "prefixo": "65220",
    "uf": "MA",
    "codigoIbge": 2111706,
    "cidade": "São Vicente Ferrer"
  },
  {
    "prefixo": "65223",
    "uf": "MA",
    "codigoIbge": 2107456,
    "cidade": "Olinda Nova do Maranhão"
  },
  {
    "prefixo": "65225",
    "uf": "MA",
    "codigoIbge": 2111003,
    "cidade": "São João Batista"
  },
  {
    "prefixo": "65230",
    "uf": "MA",
    "codigoIbge": 2102408,
    "cidade": "Cajapió"
  },
  {
    "prefixo": "65233",
    "uf": "MA",
    "codigoIbge": 2101350,
    "cidade": "Bacurituba"
  },
  {
    "prefixo": "65235",
    "uf": "MA",
    "codigoIbge": 2110500,
    "cidade": "São Bento"
  },
  {
    "prefixo": "65238",
    "uf": "MA",
    "codigoIbge": 2107605,
    "cidade": "Palmeirândia"
  },
  {
    "prefixo": "65245",
    "uf": "MA",
    "codigoIbge": 2108405,
    "cidade": "Peri Mirim"
  },
  {
    "prefixo": "65248",
    "uf": "MA",
    "codigoIbge": 2101905,
    "cidade": "Bequimão"
  },
  {
    "prefixo": "65250",
    "uf": "MA",
    "codigoIbge": 2100204,
    "cidade": "Alcântara"
  },
  {
    "prefixo": "65255",
    "uf": "MA",
    "codigoIbge": 2104909,
    "cidade": "Guimarães"
  },
  {
    "prefixo": "65260",
    "uf": "MA",
    "codigoIbge": 2103109,
    "cidade": "Cedral"
  },
  {
    "prefixo": "65263",
    "uf": "MA",
    "codigoIbge": 2109056,
    "cidade": "Porto Rico do Maranhão"
  },
  {
    "prefixo": "65265",
    "uf": "MA",
    "codigoIbge": 2106805,
    "cidade": "Mirinzal"
  },
  {
    "prefixo": "65267",
    "uf": "MA",
    "codigoIbge": 2103125,
    "cidade": "Central do Maranhão"
  },
  {
    "prefixo": "65268",
    "uf": "MA",
    "codigoIbge": 2103703,
    "cidade": "Cururupu"
  },
  {
    "prefixo": "65269",
    "uf": "MA",
    "codigoIbge": 2111789,
    "cidade": "Serrano do Maranhão"
  },
  {
    "prefixo": "65270",
    "uf": "MA",
    "codigoIbge": 2101301,
    "cidade": "Bacuri"
  },
  {
    "prefixo": "65272",
    "uf": "MA",
    "codigoIbge": 2110039,
    "cidade": "Santa Luzia do Paruá"
  },
  {
    "prefixo": "65274",
    "uf": "MA",
    "codigoIbge": 2107357,
    "cidade": "Nova Olinda do Maranhão"
  },
  {
    "prefixo": "65275",
    "uf": "MA",
    "codigoIbge": 2100832,
    "cidade": "Apicum-Açu"
  },
  {
    "prefixo": "65276",
    "uf": "MA",
    "codigoIbge": 2112456,
    "cidade": "Turilândia"
  },
  {
    "prefixo": "65278",
    "uf": "MA",
    "codigoIbge": 2112407,
    "cidade": "Turiaçu"
  },
  {
    "prefixo": "65279",
    "uf": "MA",
    "codigoIbge": 2109239,
    "cidade": "Presidente Médici"
  },
  {
    "prefixo": "65280",
    "uf": "MA",
    "codigoIbge": 2102606,
    "cidade": "Cândido Mendes"
  },
  {
    "prefixo": "65281",
    "uf": "MA",
    "codigoIbge": 2102606,
    "cidade": "Cândido Mendes"
  },
  {
    "prefixo": "65282",
    "uf": "MA",
    "codigoIbge": 2102606,
    "cidade": "Cândido Mendes"
  },
  {
    "prefixo": "65283",
    "uf": "MA",
    "codigoIbge": 2106375,
    "cidade": "Maranhãozinho"
  },
  {
    "prefixo": "65284",
    "uf": "MA",
    "codigoIbge": 2104677,
    "cidade": "Governador Nunes Freire"
  },
  {
    "prefixo": "65285",
    "uf": "MA",
    "codigoIbge": 2104305,
    "cidade": "Godofredo Viana"
  },
  {
    "prefixo": "65288",
    "uf": "MA",
    "codigoIbge": 2103158,
    "cidade": "Centro do Guilherme"
  },
  {
    "prefixo": "65289",
    "uf": "MA",
    "codigoIbge": 2106326,
    "cidade": "Maracaçumé"
  },
  {
    "prefixo": "65290",
    "uf": "MA",
    "codigoIbge": 2106201,
    "cidade": "Luís Domingues"
  },
  {
    "prefixo": "65292",
    "uf": "MA",
    "codigoIbge": 2101970,
    "cidade": "Boa Vista do Gurupi"
  },
  {
    "prefixo": "65293",
    "uf": "MA",
    "codigoIbge": 2100550,
    "cidade": "Amapá do Maranhão"
  },
  {
    "prefixo": "65294",
    "uf": "MA",
    "codigoIbge": 2105658,
    "cidade": "Junco do Maranhão"
  },
  {
    "prefixo": "65295",
    "uf": "MA",
    "codigoIbge": 2102903,
    "cidade": "Carutapera"
  },
  {
    "prefixo": "65298",
    "uf": "MA",
    "codigoIbge": 2102903,
    "cidade": "Carutapera"
  },
  {
    "prefixo": "65299",
    "uf": "MA",
    "codigoIbge": 2103174,
    "cidade": "Centro Novo do Maranhão"
  },
  {
    "prefixo": "65300",
    "uf": "MA",
    "codigoIbge": 2109908,
    "cidade": "Santa Inês"
  },
  {
    "prefixo": "65301",
    "uf": "MA",
    "codigoIbge": 2109908,
    "cidade": "Santa Inês"
  },
  {
    "prefixo": "65302",
    "uf": "MA",
    "codigoIbge": 2109908,
    "cidade": "Santa Inês"
  },
  {
    "prefixo": "65303",
    "uf": "MA",
    "codigoIbge": 2109908,
    "cidade": "Santa Inês"
  },
  {
    "prefixo": "65304",
    "uf": "MA",
    "codigoIbge": 2109908,
    "cidade": "Santa Inês"
  },
  {
    "prefixo": "65306",
    "uf": "MA",
    "codigoIbge": 2109908,
    "cidade": "Santa Inês"
  },
  {
    "prefixo": "65307",
    "uf": "MA",
    "codigoIbge": 2109908,
    "cidade": "Santa Inês"
  },
  {
    "prefixo": "65309",
    "uf": "MA",
    "codigoIbge": 2109908,
    "cidade": "Santa Inês"
  },
  {
    "prefixo": "65310",
    "uf": "MA",
    "codigoIbge": 2100402,
    "cidade": "Altamira do Maranhão"
  },
  {
    "prefixo": "65315",
    "uf": "MA",
    "codigoIbge": 2102150,
    "cidade": "Brejo de Areia"
  },
  {
    "prefixo": "65320",
    "uf": "MA",
    "codigoIbge": 2113009,
    "cidade": "Vitorino Freire"
  },
  {
    "prefixo": "65335",
    "uf": "MA",
    "codigoIbge": 2101772,
    "cidade": "Bela Vista do Maranhão"
  },
  {
    "prefixo": "65340",
    "uf": "MA",
    "codigoIbge": 2103554,
    "cidade": "Conceição do Lago-Açu"
  },
  {
    "prefixo": "65345",
    "uf": "MA",
    "codigoIbge": 2105153,
    "cidade": "Igarapé do Meio"
  },
  {
    "prefixo": "65350",
    "uf": "MA",
    "codigoIbge": 2112902,
    "cidade": "Vitória do Mearim"
  },
  {
    "prefixo": "65355",
    "uf": "MA",
    "codigoIbge": 2112902,
    "cidade": "Vitória do Mearim"
  },
  {
    "prefixo": "65360",
    "uf": "MA",
    "codigoIbge": 2106904,
    "cidade": "Monção"
  },
  {
    "prefixo": "65363",
    "uf": "MA",
    "codigoIbge": 2104651,
    "cidade": "Governador Newton Bello"
  },
  {
    "prefixo": "65364",
    "uf": "MA",
    "codigoIbge": 2104651,
    "cidade": "Governador Newton Bello"
  },
  {
    "prefixo": "65365",
    "uf": "MA",
    "codigoIbge": 2114007,
    "cidade": "Zé Doca"
  },
  {
    "prefixo": "65367",
    "uf": "MA",
    "codigoIbge": 2114007,
    "cidade": "Zé Doca"
  },
  {
    "prefixo": "65368",
    "uf": "MA",
    "codigoIbge": 2100873,
    "cidade": "Araguanã"
  },
  {
    "prefixo": "65369",
    "uf": "MA",
    "codigoIbge": 2100873,
    "cidade": "Araguanã"
  },
  {
    "prefixo": "65370",
    "uf": "MA",
    "codigoIbge": 2108504,
    "cidade": "Pindaré-Mirim"
  },
  {
    "prefixo": "65375",
    "uf": "MA",
    "codigoIbge": 2108504,
    "cidade": "Pindaré-Mirim"
  },
  {
    "prefixo": "65378",
    "uf": "MA",
    "codigoIbge": 2112274,
    "cidade": "Tufilândia"
  },
  {
    "prefixo": "65380",
    "uf": "MA",
    "codigoIbge": 2102002,
    "cidade": "Bom Jardim"
  },
  {
    "prefixo": "65385",
    "uf": "MA",
    "codigoIbge": 2111029,
    "cidade": "São João do Carú"
  },
  {
    "prefixo": "65390",
    "uf": "MA",
    "codigoIbge": 2110005,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "65392",
    "uf": "MA",
    "codigoIbge": 2110005,
    "cidade": "Santa Luzia"
  },
  {
    "prefixo": "65393",
    "uf": "MA",
    "codigoIbge": 2102325,
    "cidade": "Buriticupu"
  },
  {
    "prefixo": "65394",
    "uf": "MA",
    "codigoIbge": 2102325,
    "cidade": "Buriticupu"
  },
  {
    "prefixo": "65395",
    "uf": "MA",
    "codigoIbge": 2102036,
    "cidade": "Bom Jesus das Selvas"
  },
  {
    "prefixo": "65397",
    "uf": "MA",
    "codigoIbge": 2102036,
    "cidade": "Bom Jesus das Selvas"
  },
  {
    "prefixo": "65398",
    "uf": "MA",
    "codigoIbge": 2100477,
    "cidade": "Alto Alegre do Pindaré"
  },
  {
    "prefixo": "65400",
    "uf": "MA",
    "codigoIbge": 2103307,
    "cidade": "Codó"
  },
  {
    "prefixo": "65405",
    "uf": "MA",
    "codigoIbge": 2103307,
    "cidade": "Codó"
  },
  {
    "prefixo": "65413",
    "uf": "MA",
    "codigoIbge": 2100436,
    "cidade": "Alto Alegre do Maranhão"
  },
  {
    "prefixo": "65415",
    "uf": "MA",
    "codigoIbge": 2103604,
    "cidade": "Coroatá"
  },
  {
    "prefixo": "65418",
    "uf": "MA",
    "codigoIbge": 2108454,
    "cidade": "Peritoró"
  },
  {
    "prefixo": "65420",
    "uf": "MA",
    "codigoIbge": 2112100,
    "cidade": "Timbiras"
  },
  {
    "prefixo": "65430",
    "uf": "MA",
    "codigoIbge": 2112704,
    "cidade": "Vargem Grande"
  },
  {
    "prefixo": "65440",
    "uf": "MA",
    "codigoIbge": 2110401,
    "cidade": "São Benedito do Rio Preto"
  },
  {
    "prefixo": "65450",
    "uf": "MA",
    "codigoIbge": 2107209,
    "cidade": "Nina Rodrigues"
  },
  {
    "prefixo": "65455",
    "uf": "MA",
    "codigoIbge": 2109304,
    "cidade": "Presidente Vargas"
  },
  {
    "prefixo": "65460",
    "uf": "MA",
    "codigoIbge": 2108801,
    "cidade": "Pirapemas"
  },
  {
    "prefixo": "65465",
    "uf": "MA",
    "codigoIbge": 2102705,
    "cidade": "Cantanhede"
  },
  {
    "prefixo": "65468",
    "uf": "MA",
    "codigoIbge": 2106631,
    "cidade": "Matões do Norte"
  },
  {
    "prefixo": "65470",
    "uf": "MA",
    "codigoIbge": 2111508,
    "cidade": "São Mateus do Maranhão"
  },
  {
    "prefixo": "65480",
    "uf": "MA",
    "codigoIbge": 2101004,
    "cidade": "Arari"
  },
  {
    "prefixo": "65483",
    "uf": "MA",
    "codigoIbge": 2101004,
    "cidade": "Arari"
  },
  {
    "prefixo": "65485",
    "uf": "MA",
    "codigoIbge": 2105401,
    "cidade": "Itapecuru Mirim"
  },
  {
    "prefixo": "65490",
    "uf": "MA",
    "codigoIbge": 2100709,
    "cidade": "Anajatuba"
  },
  {
    "prefixo": "65493",
    "uf": "MA",
    "codigoIbge": 2100709,
    "cidade": "Anajatuba"
  },
  {
    "prefixo": "65495",
    "uf": "MA",
    "codigoIbge": 2106755,
    "cidade": "Miranda do Norte"
  },
  {
    "prefixo": "65500",
    "uf": "MA",
    "codigoIbge": 2103208,
    "cidade": "Chapadinha"
  },
  {
    "prefixo": "65505",
    "uf": "MA",
    "codigoIbge": 2100105,
    "cidade": "Afonso Cunha"
  },
  {
    "prefixo": "65510",
    "uf": "MA",
    "codigoIbge": 2106409,
    "cidade": "Mata Roma"
  },
  {
    "prefixo": "65515",
    "uf": "MA",
    "codigoIbge": 2102200,
    "cidade": "Buriti"
  },
  {
    "prefixo": "65520",
    "uf": "MA",
    "codigoIbge": 2102101,
    "cidade": "Brejo"
  },
  {
    "prefixo": "65525",
    "uf": "MA",
    "codigoIbge": 2100808,
    "cidade": "Anapurus"
  },
  {
    "prefixo": "65530",
    "uf": "MA",
    "codigoIbge": 2112605,
    "cidade": "Urbano Santos"
  },
  {
    "prefixo": "65535",
    "uf": "MA",
    "codigoIbge": 2101731,
    "cidade": "Belágua"
  },
  {
    "prefixo": "65540",
    "uf": "MA",
    "codigoIbge": 2110104,
    "cidade": "Santa Quitéria do Maranhão"
  },
  {
    "prefixo": "65545",
    "uf": "MA",
    "codigoIbge": 2106672,
    "cidade": "Milagres do Maranhão"
  },
  {
    "prefixo": "65550",
    "uf": "MA",
    "codigoIbge": 2110609,
    "cidade": "São Bernardo"
  },
  {
    "prefixo": "65555",
    "uf": "MA",
    "codigoIbge": 2110237,
    "cidade": "Santana do Maranhão"
  },
  {
    "prefixo": "65560",
    "uf": "MA",
    "codigoIbge": 2106300,
    "cidade": "Magalhães de Almeida"
  },
  {
    "prefixo": "65565",
    "uf": "MA",
    "codigoIbge": 2106300,
    "cidade": "Magalhães de Almeida"
  },
  {
    "prefixo": "65570",
    "uf": "MA",
    "codigoIbge": 2100907,
    "cidade": "Araioses"
  },
  {
    "prefixo": "65575",
    "uf": "MA",
    "codigoIbge": 2100907,
    "cidade": "Araioses"
  },
  {
    "prefixo": "65578",
    "uf": "MA",
    "codigoIbge": 2100154,
    "cidade": "Água Doce do Maranhão"
  },
  {
    "prefixo": "65580",
    "uf": "MA",
    "codigoIbge": 2112506,
    "cidade": "Tutóia"
  },
  {
    "prefixo": "65582",
    "uf": "MA",
    "codigoIbge": 2112506,
    "cidade": "Tutóia"
  },
  {
    "prefixo": "65585",
    "uf": "MA",
    "codigoIbge": 2108058,
    "cidade": "Paulino Neves"
  },
  {
    "prefixo": "65590",
    "uf": "MA",
    "codigoIbge": 2101707,
    "cidade": "Barreirinhas"
  },
  {
    "prefixo": "65600",
    "uf": "MA",
    "codigoIbge": 2103000,
    "cidade": "Caxias"
  },
  {
    "prefixo": "65602",
    "uf": "MA",
    "codigoIbge": 2103000,
    "cidade": "Caxias"
  },
  {
    "prefixo": "65603",
    "uf": "MA",
    "codigoIbge": 2103000,
    "cidade": "Caxias"
  },
  {
    "prefixo": "65604",
    "uf": "MA",
    "codigoIbge": 2103000,
    "cidade": "Caxias"
  },
  {
    "prefixo": "65605",
    "uf": "MA",
    "codigoIbge": 2103000,
    "cidade": "Caxias"
  },
  {
    "prefixo": "65606",
    "uf": "MA",
    "codigoIbge": 2103000,
    "cidade": "Caxias"
  },
  {
    "prefixo": "65607",
    "uf": "MA",
    "codigoIbge": 2103000,
    "cidade": "Caxias"
  },
  {
    "prefixo": "65608",
    "uf": "MA",
    "codigoIbge": 2103000,
    "cidade": "Caxias"
  },
  {
    "prefixo": "65609",
    "uf": "MA",
    "codigoIbge": 2103000,
    "cidade": "Caxias"
  },
  {
    "prefixo": "65610",
    "uf": "MA",
    "codigoIbge": 2100303,
    "cidade": "Aldeias Altas"
  },
  {
    "prefixo": "65615",
    "uf": "MA",
    "codigoIbge": 2111078,
    "cidade": "São João do Soter"
  },
  {
    "prefixo": "65620",
    "uf": "MA",
    "codigoIbge": 2103406,
    "cidade": "Coelho Neto"
  },
  {
    "prefixo": "65625",
    "uf": "MA",
    "codigoIbge": 2103901,
    "cidade": "Duque Bacelar"
  },
  {
    "prefixo": "65630",
    "uf": "MA",
    "codigoIbge": 2112209,
    "cidade": "Timon"
  },
  {
    "prefixo": "65631",
    "uf": "MA",
    "codigoIbge": 2112209,
    "cidade": "Timon"
  },
  {
    "prefixo": "65632",
    "uf": "MA",
    "codigoIbge": 2112209,
    "cidade": "Timon"
  },
  {
    "prefixo": "65633",
    "uf": "MA",
    "codigoIbge": 2112209,
    "cidade": "Timon"
  },
  {
    "prefixo": "65634",
    "uf": "MA",
    "codigoIbge": 2112209,
    "cidade": "Timon"
  },
  {
    "prefixo": "65635",
    "uf": "MA",
    "codigoIbge": 2112209,
    "cidade": "Timon"
  },
  {
    "prefixo": "65636",
    "uf": "MA",
    "codigoIbge": 2112209,
    "cidade": "Timon"
  },
  {
    "prefixo": "65637",
    "uf": "MA",
    "codigoIbge": 2112209,
    "cidade": "Timon"
  },
  {
    "prefixo": "65638",
    "uf": "MA",
    "codigoIbge": 2112209,
    "cidade": "Timon"
  },
  {
    "prefixo": "65639",
    "uf": "MA",
    "codigoIbge": 2112209,
    "cidade": "Timon"
  },
  {
    "prefixo": "65640",
    "uf": "MA",
    "codigoIbge": 2107803,
    "cidade": "Parnarama"
  },
  {
    "prefixo": "65643",
    "uf": "MA",
    "codigoIbge": 2107803,
    "cidade": "Parnarama"
  },
  {
    "prefixo": "65645",
    "uf": "MA",
    "codigoIbge": 2106607,
    "cidade": "Matões"
  },
  {
    "prefixo": "65650",
    "uf": "MA",
    "codigoIbge": 2110906,
    "cidade": "São Francisco do Maranhão"
  },
  {
    "prefixo": "65655",
    "uf": "MA",
    "codigoIbge": 2110906,
    "cidade": "São Francisco do Maranhão"
  },
  {
    "prefixo": "65660",
    "uf": "MA",
    "codigoIbge": 2101509,
    "cidade": "Barão de Grajaú"
  },
  {
    "prefixo": "65665",
    "uf": "MA",
    "codigoIbge": 2111102,
    "cidade": "São João dos Patos"
  },
  {
    "prefixo": "65668",
    "uf": "MA",
    "codigoIbge": 2111953,
    "cidade": "Sucupira do Riachão"
  },
  {
    "prefixo": "65670",
    "uf": "MA",
    "codigoIbge": 2107704,
    "cidade": "Paraibano"
  },
  {
    "prefixo": "65680",
    "uf": "MA",
    "codigoIbge": 2107902,
    "cidade": "Passagem Franca"
  },
  {
    "prefixo": "65683",
    "uf": "MA",
    "codigoIbge": 2105922,
    "cidade": "Lagoa do Mato"
  },
  {
    "prefixo": "65685",
    "uf": "MA",
    "codigoIbge": 2102309,
    "cidade": "Buriti Bravo"
  },
  {
    "prefixo": "65688",
    "uf": "MA",
    "codigoIbge": 2102309,
    "cidade": "Buriti Bravo"
  },
  {
    "prefixo": "65690",
    "uf": "MA",
    "codigoIbge": 2103505,
    "cidade": "Colinas"
  },
  {
    "prefixo": "65693",
    "uf": "MA",
    "codigoIbge": 2105450,
    "cidade": "Jatobá"
  },
  {
    "prefixo": "65695",
    "uf": "MA",
    "codigoIbge": 2104206,
    "cidade": "Fortuna"
  },
  {
    "prefixo": "65700",
    "uf": "MA",
    "codigoIbge": 2101202,
    "cidade": "Bacabal"
  },
  {
    "prefixo": "65704",
    "uf": "MA",
    "codigoIbge": 2102077,
    "cidade": "Bom Lugar"
  },
  {
    "prefixo": "65705",
    "uf": "MA",
    "codigoIbge": 2105906,
    "cidade": "Lago Verde"
  },
  {
    "prefixo": "65706",
    "uf": "MA",
    "codigoIbge": 2107407,
    "cidade": "Olho d'Água das Cunhãs"
  },
  {
    "prefixo": "65707",
    "uf": "MA",
    "codigoIbge": 2108702,
    "cidade": "Pio XII"
  },
  {
    "prefixo": "65708",
    "uf": "MA",
    "codigoIbge": 2111409,
    "cidade": "São Luís Gonzaga do Maranhão"
  },
  {
    "prefixo": "65709",
    "uf": "MA",
    "codigoIbge": 2111722,
    "cidade": "Satubinha"
  },
  {
    "prefixo": "65710",
    "uf": "MA",
    "codigoIbge": 2105807,
    "cidade": "Lago do Junco"
  },
  {
    "prefixo": "65712",
    "uf": "MA",
    "codigoIbge": 2105948,
    "cidade": "Lago dos Rodrigues"
  },
  {
    "prefixo": "65714",
    "uf": "MA",
    "codigoIbge": 2106359,
    "cidade": "Marajá do Sena"
  },
  {
    "prefixo": "65715",
    "uf": "MA",
    "codigoIbge": 2105708,
    "cidade": "Lago da Pedra"
  },
  {
    "prefixo": "65716",
    "uf": "MA",
    "codigoIbge": 2108108,
    "cidade": "Paulo Ramos"
  },
  {
    "prefixo": "65718",
    "uf": "MA",
    "codigoIbge": 2105963,
    "cidade": "Lagoa Grande do Maranhão"
  },
  {
    "prefixo": "65720",
    "uf": "MA",
    "codigoIbge": 2105203,
    "cidade": "Igarapé Grande"
  },
  {
    "prefixo": "65723",
    "uf": "MA",
    "codigoIbge": 2101939,
    "cidade": "Bernardo do Mearim"
  },
  {
    "prefixo": "65725",
    "uf": "MA",
    "codigoIbge": 2108207,
    "cidade": "Pedreiras"
  },
  {
    "prefixo": "65727",
    "uf": "MA",
    "codigoIbge": 2112233,
    "cidade": "Trizidela do Vale"
  },
  {
    "prefixo": "65728",
    "uf": "MA",
    "codigoIbge": 2106003,
    "cidade": "Lima Campos"
  },
  {
    "prefixo": "65730",
    "uf": "MA",
    "codigoIbge": 2110302,
    "cidade": "Santo Antônio dos Lopes"
  },
  {
    "prefixo": "65735",
    "uf": "MA",
    "codigoIbge": 2102754,
    "cidade": "Capinzal do Norte"
  },
  {
    "prefixo": "65740",
    "uf": "MA",
    "codigoIbge": 2108900,
    "cidade": "Poção de Pedras"
  },
  {
    "prefixo": "65750",
    "uf": "MA",
    "codigoIbge": 2104008,
    "cidade": "Esperantinópolis"
  },
  {
    "prefixo": "65753",
    "uf": "MA",
    "codigoIbge": 2111631,
    "cidade": "São Raimundo do Doca Bezerra"
  },
  {
    "prefixo": "65755",
    "uf": "MA",
    "codigoIbge": 2105609,
    "cidade": "Joselândia"
  },
  {
    "prefixo": "65758",
    "uf": "MA",
    "codigoIbge": 2111672,
    "cidade": "São Roberto"
  },
  {
    "prefixo": "65760",
    "uf": "MA",
    "codigoIbge": 2109106,
    "cidade": "Presidente Dutra"
  },
  {
    "prefixo": "65762",
    "uf": "MA",
    "codigoIbge": 2111250,
    "cidade": "São José dos Basílios"
  },
  {
    "prefixo": "65763",
    "uf": "MA",
    "codigoIbge": 2112308,
    "cidade": "Tuntum"
  },
  {
    "prefixo": "65764",
    "uf": "MA",
    "codigoIbge": 2112308,
    "cidade": "Tuntum"
  },
  {
    "prefixo": "65765",
    "uf": "MA",
    "codigoIbge": 2103802,
    "cidade": "Dom Pedro"
  },
  {
    "prefixo": "65768",
    "uf": "MA",
    "codigoIbge": 2109759,
    "cidade": "Santa Filomena do Maranhão"
  },
  {
    "prefixo": "65770",
    "uf": "MA",
    "codigoIbge": 2104503,
    "cidade": "Governador Archer"
  },
  {
    "prefixo": "65775",
    "uf": "MA",
    "codigoIbge": 2104404,
    "cidade": "Gonçalves Dias"
  },
  {
    "prefixo": "65780",
    "uf": "MA",
    "codigoIbge": 2104602,
    "cidade": "Governador Eugênio Barros"
  },
  {
    "prefixo": "65783",
    "uf": "MA",
    "codigoIbge": 2111748,
    "cidade": "Senador Alexandre Costa"
  },
  {
    "prefixo": "65785",
    "uf": "MA",
    "codigoIbge": 2104701,
    "cidade": "Graça Aranha"
  },
  {
    "prefixo": "65790",
    "uf": "MA",
    "codigoIbge": 2110708,
    "cidade": "São Domingos do Maranhão"
  },
  {
    "prefixo": "65795",
    "uf": "MA",
    "codigoIbge": 2104628,
    "cidade": "Governador Luiz Rocha"
  },
  {
    "prefixo": "65800",
    "uf": "MA",
    "codigoIbge": 2101400,
    "cidade": "Balsas"
  },
  {
    "prefixo": "65805",
    "uf": "MA",
    "codigoIbge": 2104107,
    "cidade": "Fortaleza dos Nogueiras"
  },
  {
    "prefixo": "65808",
    "uf": "MA",
    "codigoIbge": 2107258,
    "cidade": "Nova Colinas"
  },
  {
    "prefixo": "65810",
    "uf": "MA",
    "codigoIbge": 2100501,
    "cidade": "Alto Parnaíba"
  },
  {
    "prefixo": "65815",
    "uf": "MA",
    "codigoIbge": 2100501,
    "cidade": "Alto Parnaíba"
  },
  {
    "prefixo": "65820",
    "uf": "MA",
    "codigoIbge": 2112001,
    "cidade": "Tasso Fragoso"
  },
  {
    "prefixo": "65830",
    "uf": "MA",
    "codigoIbge": 2109700,
    "cidade": "Sambaíba"
  },
  {
    "prefixo": "65840",
    "uf": "MA",
    "codigoIbge": 2111607,
    "cidade": "São Raimundo das Mangabeiras"
  },
  {
    "prefixo": "65850",
    "uf": "MA",
    "codigoIbge": 2106706,
    "cidade": "Mirador"
  },
  {
    "prefixo": "65855",
    "uf": "MA",
    "codigoIbge": 2106706,
    "cidade": "Mirador"
  },
  {
    "prefixo": "65860",
    "uf": "MA",
    "codigoIbge": 2111904,
    "cidade": "Sucupira do Norte"
  },
  {
    "prefixo": "65870",
    "uf": "MA",
    "codigoIbge": 2108009,
    "cidade": "Pastos Bons"
  },
  {
    "prefixo": "65875",
    "uf": "MA",
    "codigoIbge": 2108009,
    "cidade": "Pastos Bons"
  },
  {
    "prefixo": "65880",
    "uf": "MA",
    "codigoIbge": 2107308,
    "cidade": "Nova Iorque"
  },
  {
    "prefixo": "65885",
    "uf": "MA",
    "codigoIbge": 2101806,
    "cidade": "Benedito Leite"
  },
  {
    "prefixo": "65888",
    "uf": "MA",
    "codigoIbge": 2110658,
    "cidade": "São Domingos do Azeitão"
  },
  {
    "prefixo": "65890",
    "uf": "MA",
    "codigoIbge": 2110807,
    "cidade": "São Félix de Balsas"
  },
  {
    "prefixo": "65895",
    "uf": "MA",
    "codigoIbge": 2106102,
    "cidade": "Loreto"
  },
  {
    "prefixo": "65900",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65901",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65902",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65903",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65904",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65905",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65906",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65907",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65908",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65909",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65910",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65911",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65912",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65913",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65914",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65915",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65916",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65917",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65918",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65919",
    "uf": "MA",
    "codigoIbge": 2105302,
    "cidade": "Imperatriz"
  },
  {
    "prefixo": "65920",
    "uf": "MA",
    "codigoIbge": 2111532,
    "cidade": "São Pedro da Água Branca"
  },
  {
    "prefixo": "65921",
    "uf": "MA",
    "codigoIbge": 2103257,
    "cidade": "Cidelândia"
  },
  {
    "prefixo": "65922",
    "uf": "MA",
    "codigoIbge": 2105500,
    "cidade": "João Lisboa"
  },
  {
    "prefixo": "65923",
    "uf": "MA",
    "codigoIbge": 2100600,
    "cidade": "Amarante do Maranhão"
  },
  {
    "prefixo": "65924",
    "uf": "MA",
    "codigoIbge": 2112852,
    "cidade": "Vila Nova dos Martírios"
  },
  {
    "prefixo": "65925",
    "uf": "MA",
    "codigoIbge": 2111805,
    "cidade": "Sítio Novo"
  },
  {
    "prefixo": "65927",
    "uf": "MA",
    "codigoIbge": 2103752,
    "cidade": "Davinópolis"
  },
  {
    "prefixo": "65928",
    "uf": "MA",
    "codigoIbge": 2104552,
    "cidade": "Governador Edison Lobão"
  },
  {
    "prefixo": "65929",
    "uf": "MA",
    "codigoIbge": 2110856,
    "cidade": "São Francisco do Brejão"
  },
  {
    "prefixo": "65930",
    "uf": "MA",
    "codigoIbge": 2100055,
    "cidade": "Açailândia"
  },
  {
    "prefixo": "65935",
    "uf": "MA",
    "codigoIbge": 2111763,
    "cidade": "Senador La Rocque"
  },
  {
    "prefixo": "65936",
    "uf": "MA",
    "codigoIbge": 2107001,
    "cidade": "Montes Altos"
  },
  {
    "prefixo": "65937",
    "uf": "MA",
    "codigoIbge": 2105989,
    "cidade": "Lajeado Novo"
  },
  {
    "prefixo": "65938",
    "uf": "MA",
    "codigoIbge": 2109551,
    "cidade": "Ribamar Fiquene"
  },
  {
    "prefixo": "65939",
    "uf": "MA",
    "codigoIbge": 2105427,
    "cidade": "Itinga do Maranhão"
  },
  {
    "prefixo": "65940",
    "uf": "MA",
    "codigoIbge": 2104800,
    "cidade": "Grajaú"
  },
  {
    "prefixo": "65942",
    "uf": "MA",
    "codigoIbge": 2104800,
    "cidade": "Grajaú"
  },
  {
    "prefixo": "65943",
    "uf": "MA",
    "codigoIbge": 2104099,
    "cidade": "Formosa da Serra Negra"
  },
  {
    "prefixo": "65945",
    "uf": "MA",
    "codigoIbge": 2100956,
    "cidade": "Arame"
  },
  {
    "prefixo": "65947",
    "uf": "MA",
    "codigoIbge": 2100956,
    "cidade": "Arame"
  },
  {
    "prefixo": "65948",
    "uf": "MA",
    "codigoIbge": 2105351,
    "cidade": "Itaipava do Grajaú"
  },
  {
    "prefixo": "65950",
    "uf": "MA",
    "codigoIbge": 2101608,
    "cidade": "Barra do Corda"
  },
  {
    "prefixo": "65955",
    "uf": "MA",
    "codigoIbge": 2101608,
    "cidade": "Barra do Corda"
  },
  {
    "prefixo": "65957",
    "uf": "MA",
    "codigoIbge": 2101608,
    "cidade": "Barra do Corda"
  },
  {
    "prefixo": "65959",
    "uf": "MA",
    "codigoIbge": 2101608,
    "cidade": "Barra do Corda"
  },
  {
    "prefixo": "65962",
    "uf": "MA",
    "codigoIbge": 2105476,
    "cidade": "Jenipapo dos Vieiras"
  },
  {
    "prefixo": "65964",
    "uf": "MA",
    "codigoIbge": 2104081,
    "cidade": "Fernando Falcão"
  },
  {
    "prefixo": "65968",
    "uf": "MA",
    "codigoIbge": 2102556,
    "cidade": "Campestre do Maranhão"
  },
  {
    "prefixo": "65970",
    "uf": "MA",
    "codigoIbge": 2109007,
    "cidade": "Porto Franco"
  },
  {
    "prefixo": "65973",
    "uf": "MA",
    "codigoIbge": 2111052,
    "cidade": "São João do Paraíso"
  },
  {
    "prefixo": "65975",
    "uf": "MA",
    "codigoIbge": 2104057,
    "cidade": "Estreito"
  },
  {
    "prefixo": "65978",
    "uf": "MA",
    "codigoIbge": 2111573,
    "cidade": "São Pedro dos Crentes"
  },
  {
    "prefixo": "65980",
    "uf": "MA",
    "codigoIbge": 2102804,
    "cidade": "Carolina"
  },
  {
    "prefixo": "65990",
    "uf": "MA",
    "codigoIbge": 2109502,
    "cidade": "Riachão"
  },
  {
    "prefixo": "65995",
    "uf": "MA",
    "codigoIbge": 2104073,
    "cidade": "Feira Nova do Maranhão"
  },
  {
    "prefixo": "66010",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66013",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66015",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66017",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66019",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66020",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66023",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66025",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66026",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66030",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66033",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66035",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66040",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66045",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66050",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66053",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66055",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66060",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66063",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66065",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66070",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66073",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66075",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66077",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66079",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66080",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66083",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66085",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66087",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66090",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66093",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66095",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66110",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66113",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66115",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66117",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66119",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66120",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66123",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66610",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66613",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66615",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66617",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66620",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66623",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66625",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66630",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66633",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66635",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66640",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66643",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66645",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66650",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66652",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66670",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66690",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66691",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66810",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66811",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66812",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66813",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66814",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66815",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66816",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66820",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66821",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66822",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66823",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66825",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66830",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66831",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66833",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66840",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66842",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66843",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66845",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66846",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66910",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66911",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66912",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66913",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66914",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66915",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66916",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66917",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66918",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66919",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66920",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66921",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66923",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66925",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66927",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66929",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66931",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66933",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "66999",
    "uf": "PA",
    "codigoIbge": 1501402,
    "cidade": "Belém"
  },
  {
    "prefixo": "67010",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67013",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67015",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67020",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67030",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67032",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67033",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67035",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67040",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67100",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67103",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67105",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67110",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67113",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67115",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67118",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67120",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67124",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67125",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67130",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67133",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67140",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67143",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67145",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67146",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67190",
    "uf": "PA",
    "codigoIbge": 1500800,
    "cidade": "Ananindeua"
  },
  {
    "prefixo": "67200",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67201",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67202",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67203",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67204",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67205",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67206",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67207",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67208",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67209",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67210",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67211",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67212",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67213",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67214",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67215",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "67216",
    "uf": "PA",
    "codigoIbge": 1504422,
    "cidade": "Marituba"
  },
  {
    "prefixo": "68005",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68010",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68015",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68017",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68020",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68022",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68025",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68026",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68027",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68030",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68033",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68035",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68037",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68038",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68040",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68041",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68042",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68043",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68045",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68046",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68047",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68049",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68050",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68060",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68099",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68107",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68109",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68113",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68115",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68116",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68120",
    "uf": "PA",
    "codigoIbge": 1504752,
    "cidade": "Mojuí dos Campos"
  },
  {
    "prefixo": "68122",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68123",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68124",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68125",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68126",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68128",
    "uf": "PA",
    "codigoIbge": 1506807,
    "cidade": "Santarém"
  },
  {
    "prefixo": "68129",
    "uf": "PA",
    "codigoIbge": 1504752,
    "cidade": "Mojuí dos Campos"
  },
  {
    "prefixo": "68130",
    "uf": "PA",
    "codigoIbge": 1506005,
    "cidade": "Prainha"
  },
  {
    "prefixo": "68135",
    "uf": "PA",
    "codigoIbge": 1506005,
    "cidade": "Prainha"
  },
  {
    "prefixo": "68138",
    "uf": "PA",
    "codigoIbge": 1505650,
    "cidade": "Placas"
  },
  {
    "prefixo": "68139",
    "uf": "PA",
    "codigoIbge": 1505650,
    "cidade": "Placas"
  },
  {
    "prefixo": "68140",
    "uf": "PA",
    "codigoIbge": 1508159,
    "cidade": "Uruará"
  },
  {
    "prefixo": "68142",
    "uf": "PA",
    "codigoIbge": 1508159,
    "cidade": "Uruará"
  },
  {
    "prefixo": "68143",
    "uf": "PA",
    "codigoIbge": 1501451,
    "cidade": "Belterra"
  },
  {
    "prefixo": "68145",
    "uf": "PA",
    "codigoIbge": 1504455,
    "cidade": "Medicilândia"
  },
  {
    "prefixo": "68147",
    "uf": "PA",
    "codigoIbge": 1504455,
    "cidade": "Medicilândia"
  },
  {
    "prefixo": "68148",
    "uf": "PA",
    "codigoIbge": 1501725,
    "cidade": "Brasil Novo"
  },
  {
    "prefixo": "68150",
    "uf": "PA",
    "codigoIbge": 1501006,
    "cidade": "Aveiro"
  },
  {
    "prefixo": "68155",
    "uf": "PA",
    "codigoIbge": 1501006,
    "cidade": "Aveiro"
  },
  {
    "prefixo": "68160",
    "uf": "PA",
    "codigoIbge": 1501006,
    "cidade": "Aveiro"
  },
  {
    "prefixo": "68165",
    "uf": "PA",
    "codigoIbge": 1506195,
    "cidade": "Rurópolis"
  },
  {
    "prefixo": "68170",
    "uf": "PA",
    "codigoIbge": 1503903,
    "cidade": "Juruti"
  },
  {
    "prefixo": "68178",
    "uf": "PA",
    "codigoIbge": 1503903,
    "cidade": "Juruti"
  },
  {
    "prefixo": "68180",
    "uf": "PA",
    "codigoIbge": 1503606,
    "cidade": "Itaituba"
  },
  {
    "prefixo": "68181",
    "uf": "PA",
    "codigoIbge": 1503606,
    "cidade": "Itaituba"
  },
  {
    "prefixo": "68182",
    "uf": "PA",
    "codigoIbge": 1503606,
    "cidade": "Itaituba"
  },
  {
    "prefixo": "68183",
    "uf": "PA",
    "codigoIbge": 1503606,
    "cidade": "Itaituba"
  },
  {
    "prefixo": "68184",
    "uf": "PA",
    "codigoIbge": 1503606,
    "cidade": "Itaituba"
  },
  {
    "prefixo": "68187",
    "uf": "PA",
    "codigoIbge": 1503606,
    "cidade": "Itaituba"
  },
  {
    "prefixo": "68189",
    "uf": "PA",
    "codigoIbge": 1503606,
    "cidade": "Itaituba"
  },
  {
    "prefixo": "68190",
    "uf": "PA",
    "codigoIbge": 1503606,
    "cidade": "Itaituba"
  },
  {
    "prefixo": "68191",
    "uf": "PA",
    "codigoIbge": 1503606,
    "cidade": "Itaituba"
  },
  {
    "prefixo": "68192",
    "uf": "PA",
    "codigoIbge": 1503606,
    "cidade": "Itaituba"
  },
  {
    "prefixo": "68193",
    "uf": "PA",
    "codigoIbge": 1505031,
    "cidade": "Novo Progresso"
  },
  {
    "prefixo": "68195",
    "uf": "PA",
    "codigoIbge": 1503754,
    "cidade": "Jacareacanga"
  },
  {
    "prefixo": "68198",
    "uf": "PA",
    "codigoIbge": 1508050,
    "cidade": "Trairão"
  },
  {
    "prefixo": "68199",
    "uf": "PA",
    "codigoIbge": 1508050,
    "cidade": "Trairão"
  },
  {
    "prefixo": "68200",
    "uf": "PA",
    "codigoIbge": 1500404,
    "cidade": "Alenquer"
  },
  {
    "prefixo": "68210",
    "uf": "PA",
    "codigoIbge": 1502855,
    "cidade": "Curuá"
  },
  {
    "prefixo": "68220",
    "uf": "PA",
    "codigoIbge": 1504802,
    "cidade": "Monte Alegre"
  },
  {
    "prefixo": "68230",
    "uf": "PA",
    "codigoIbge": 1500503,
    "cidade": "Almeirim"
  },
  {
    "prefixo": "68235",
    "uf": "PA",
    "codigoIbge": 1500503,
    "cidade": "Almeirim"
  },
  {
    "prefixo": "68240",
    "uf": "PA",
    "codigoIbge": 1500503,
    "cidade": "Almeirim"
  },
  {
    "prefixo": "68250",
    "uf": "PA",
    "codigoIbge": 1505106,
    "cidade": "Óbidos"
  },
  {
    "prefixo": "68260",
    "uf": "PA",
    "codigoIbge": 1505106,
    "cidade": "Óbidos"
  },
  {
    "prefixo": "68269",
    "uf": "PA",
    "codigoIbge": 1505106,
    "cidade": "Óbidos"
  },
  {
    "prefixo": "68270",
    "uf": "PA",
    "codigoIbge": 1505304,
    "cidade": "Oriximiná"
  },
  {
    "prefixo": "68275",
    "uf": "PA",
    "codigoIbge": 1505304,
    "cidade": "Oriximiná"
  },
  {
    "prefixo": "68279",
    "uf": "PA",
    "codigoIbge": 1505304,
    "cidade": "Oriximiná"
  },
  {
    "prefixo": "68280",
    "uf": "PA",
    "codigoIbge": 1503002,
    "cidade": "Faro"
  },
  {
    "prefixo": "68285",
    "uf": "PA",
    "codigoIbge": 1507979,
    "cidade": "Terra Santa"
  },
  {
    "prefixo": "68300",
    "uf": "PA",
    "codigoIbge": 1503101,
    "cidade": "Gurupá"
  },
  {
    "prefixo": "68320",
    "uf": "PA",
    "codigoIbge": 1503101,
    "cidade": "Gurupá"
  },
  {
    "prefixo": "68330",
    "uf": "PA",
    "codigoIbge": 1505908,
    "cidade": "Porto de Moz"
  },
  {
    "prefixo": "68350",
    "uf": "PA",
    "codigoIbge": 1502152,
    "cidade": "Canaã dos Carajás"
  },
  {
    "prefixo": "68352",
    "uf": "PA",
    "codigoIbge": 1502152,
    "cidade": "Canaã dos Carajás"
  },
  {
    "prefixo": "68354",
    "uf": "PA",
    "codigoIbge": 1502152,
    "cidade": "Canaã dos Carajás"
  },
  {
    "prefixo": "68356",
    "uf": "PA",
    "codigoIbge": 1502152,
    "cidade": "Canaã dos Carajás"
  },
  {
    "prefixo": "68360",
    "uf": "PA",
    "codigoIbge": 1507805,
    "cidade": "Senador José Porfírio"
  },
  {
    "prefixo": "68365",
    "uf": "PA",
    "codigoIbge": 1500859,
    "cidade": "Anapu"
  },
  {
    "prefixo": "68371",
    "uf": "PA",
    "codigoIbge": 1500602,
    "cidade": "Altamira"
  },
  {
    "prefixo": "68372",
    "uf": "PA",
    "codigoIbge": 1500602,
    "cidade": "Altamira"
  },
  {
    "prefixo": "68373",
    "uf": "PA",
    "codigoIbge": 1500602,
    "cidade": "Altamira"
  },
  {
    "prefixo": "68374",
    "uf": "PA",
    "codigoIbge": 1500602,
    "cidade": "Altamira"
  },
  {
    "prefixo": "68375",
    "uf": "PA",
    "codigoIbge": 1500602,
    "cidade": "Altamira"
  },
  {
    "prefixo": "68376",
    "uf": "PA",
    "codigoIbge": 1500602,
    "cidade": "Altamira"
  },
  {
    "prefixo": "68377",
    "uf": "PA",
    "codigoIbge": 1500602,
    "cidade": "Altamira"
  },
  {
    "prefixo": "68378",
    "uf": "PA",
    "codigoIbge": 1500602,
    "cidade": "Altamira"
  },
  {
    "prefixo": "68379",
    "uf": "PA",
    "codigoIbge": 1500602,
    "cidade": "Altamira"
  },
  {
    "prefixo": "68380",
    "uf": "PA",
    "codigoIbge": 1507300,
    "cidade": "São Félix do Xingu"
  },
  {
    "prefixo": "68382",
    "uf": "PA",
    "codigoIbge": 1507300,
    "cidade": "São Félix do Xingu"
  },
  {
    "prefixo": "68383",
    "uf": "PA",
    "codigoIbge": 1508357,
    "cidade": "Vitória do Xingu"
  },
  {
    "prefixo": "68385",
    "uf": "PA",
    "codigoIbge": 1508084,
    "cidade": "Tucumã"
  },
  {
    "prefixo": "68388",
    "uf": "PA",
    "codigoIbge": 1501253,
    "cidade": "Bannach"
  },
  {
    "prefixo": "68390",
    "uf": "PA",
    "codigoIbge": 1505437,
    "cidade": "Ourilândia do Norte"
  },
  {
    "prefixo": "68394",
    "uf": "PA",
    "codigoIbge": 1505437,
    "cidade": "Ourilândia do Norte"
  },
  {
    "prefixo": "68398",
    "uf": "PA",
    "codigoIbge": 1502764,
    "cidade": "Cumaru do Norte"
  },
  {
    "prefixo": "68400",
    "uf": "PA",
    "codigoIbge": 1502103,
    "cidade": "Cametá"
  },
  {
    "prefixo": "68404",
    "uf": "PA",
    "codigoIbge": 1502103,
    "cidade": "Cametá"
  },
  {
    "prefixo": "68406",
    "uf": "PA",
    "codigoIbge": 1502103,
    "cidade": "Cametá"
  },
  {
    "prefixo": "68408",
    "uf": "PA",
    "codigoIbge": 1502103,
    "cidade": "Cametá"
  },
  {
    "prefixo": "68409",
    "uf": "PA",
    "codigoIbge": 1502103,
    "cidade": "Cametá"
  },
  {
    "prefixo": "68410",
    "uf": "PA",
    "codigoIbge": 1502103,
    "cidade": "Cametá"
  },
  {
    "prefixo": "68415",
    "uf": "PA",
    "codigoIbge": 1504000,
    "cidade": "Limoeiro do Ajuru"
  },
  {
    "prefixo": "68420",
    "uf": "PA",
    "codigoIbge": 1504604,
    "cidade": "Mocajuba"
  },
  {
    "prefixo": "68425",
    "uf": "PA",
    "codigoIbge": 1504604,
    "cidade": "Mocajuba"
  },
  {
    "prefixo": "68428",
    "uf": "PA",
    "codigoIbge": 1504604,
    "cidade": "Mocajuba"
  },
  {
    "prefixo": "68430",
    "uf": "PA",
    "codigoIbge": 1503309,
    "cidade": "Igarapé-Miri"
  },
  {
    "prefixo": "68433",
    "uf": "PA",
    "codigoIbge": 1503309,
    "cidade": "Igarapé-Miri"
  },
  {
    "prefixo": "68435",
    "uf": "PA",
    "codigoIbge": 1503309,
    "cidade": "Igarapé-Miri"
  },
  {
    "prefixo": "68438",
    "uf": "PA",
    "codigoIbge": 1503309,
    "cidade": "Igarapé-Miri"
  },
  {
    "prefixo": "68440",
    "uf": "PA",
    "codigoIbge": 1500107,
    "cidade": "Abaetetuba"
  },
  {
    "prefixo": "68444",
    "uf": "PA",
    "codigoIbge": 1500107,
    "cidade": "Abaetetuba"
  },
  {
    "prefixo": "68445",
    "uf": "PA",
    "codigoIbge": 1501303,
    "cidade": "Barcarena"
  },
  {
    "prefixo": "68447",
    "uf": "PA",
    "codigoIbge": 1501303,
    "cidade": "Barcarena"
  },
  {
    "prefixo": "68448",
    "uf": "PA",
    "codigoIbge": 1501303,
    "cidade": "Barcarena"
  },
  {
    "prefixo": "68450",
    "uf": "PA",
    "codigoIbge": 1504703,
    "cidade": "Moju"
  },
  {
    "prefixo": "68453",
    "uf": "PA",
    "codigoIbge": 1504703,
    "cidade": "Moju"
  },
  {
    "prefixo": "68455",
    "uf": "PA",
    "codigoIbge": 1508100,
    "cidade": "Tucuruí"
  },
  {
    "prefixo": "68456",
    "uf": "PA",
    "codigoIbge": 1508100,
    "cidade": "Tucuruí"
  },
  {
    "prefixo": "68457",
    "uf": "PA",
    "codigoIbge": 1508100,
    "cidade": "Tucuruí"
  },
  {
    "prefixo": "68458",
    "uf": "PA",
    "codigoIbge": 1508100,
    "cidade": "Tucuruí"
  },
  {
    "prefixo": "68459",
    "uf": "PA",
    "codigoIbge": 1508100,
    "cidade": "Tucuruí"
  },
  {
    "prefixo": "68460",
    "uf": "PA",
    "codigoIbge": 1508100,
    "cidade": "Tucuruí"
  },
  {
    "prefixo": "68461",
    "uf": "PA",
    "codigoIbge": 1508100,
    "cidade": "Tucuruí"
  },
  {
    "prefixo": "68464",
    "uf": "PA",
    "codigoIbge": 1508100,
    "cidade": "Tucuruí"
  },
  {
    "prefixo": "68465",
    "uf": "PA",
    "codigoIbge": 1501204,
    "cidade": "Baião"
  },
  {
    "prefixo": "68468",
    "uf": "PA",
    "codigoIbge": 1501204,
    "cidade": "Baião"
  },
  {
    "prefixo": "68470",
    "uf": "PA",
    "codigoIbge": 1505205,
    "cidade": "Oeiras do Pará"
  },
  {
    "prefixo": "68473",
    "uf": "PA",
    "codigoIbge": 1505064,
    "cidade": "Novo Repartimento"
  },
  {
    "prefixo": "68474",
    "uf": "PA",
    "codigoIbge": 1505064,
    "cidade": "Novo Repartimento"
  },
  {
    "prefixo": "68475",
    "uf": "PA",
    "codigoIbge": 1501105,
    "cidade": "Bagre"
  },
  {
    "prefixo": "68478",
    "uf": "PA",
    "codigoIbge": 1501105,
    "cidade": "Bagre"
  },
  {
    "prefixo": "68480",
    "uf": "PA",
    "codigoIbge": 1505809,
    "cidade": "Portel"
  },
  {
    "prefixo": "68482",
    "uf": "PA",
    "codigoIbge": 1505809,
    "cidade": "Portel"
  },
  {
    "prefixo": "68485",
    "uf": "PA",
    "codigoIbge": 1505486,
    "cidade": "Pacajá"
  },
  {
    "prefixo": "68488",
    "uf": "PA",
    "codigoIbge": 1501782,
    "cidade": "Breu Branco"
  },
  {
    "prefixo": "68490",
    "uf": "PA",
    "codigoIbge": 1504505,
    "cidade": "Melgaço"
  },
  {
    "prefixo": "68500",
    "uf": "PA",
    "codigoIbge": 1504208,
    "cidade": "Marabá"
  },
  {
    "prefixo": "68501",
    "uf": "PA",
    "codigoIbge": 1504208,
    "cidade": "Marabá"
  },
  {
    "prefixo": "68502",
    "uf": "PA",
    "codigoIbge": 1504208,
    "cidade": "Marabá"
  },
  {
    "prefixo": "68503",
    "uf": "PA",
    "codigoIbge": 1504208,
    "cidade": "Marabá"
  },
  {
    "prefixo": "68504",
    "uf": "PA",
    "codigoIbge": 1504208,
    "cidade": "Marabá"
  },
  {
    "prefixo": "68505",
    "uf": "PA",
    "codigoIbge": 1504208,
    "cidade": "Marabá"
  },
  {
    "prefixo": "68506",
    "uf": "PA",
    "codigoIbge": 1504208,
    "cidade": "Marabá"
  },
  {
    "prefixo": "68507",
    "uf": "PA",
    "codigoIbge": 1504208,
    "cidade": "Marabá"
  },
  {
    "prefixo": "68508",
    "uf": "PA",
    "codigoIbge": 1504208,
    "cidade": "Marabá"
  },
  {
    "prefixo": "68509",
    "uf": "PA",
    "codigoIbge": 1504208,
    "cidade": "Marabá"
  },
  {
    "prefixo": "68510",
    "uf": "PA",
    "codigoIbge": 1504208,
    "cidade": "Marabá"
  },
  {
    "prefixo": "68511",
    "uf": "PA",
    "codigoIbge": 1504208,
    "cidade": "Marabá"
  },
  {
    "prefixo": "68512",
    "uf": "PA",
    "codigoIbge": 1504208,
    "cidade": "Marabá"
  },
  {
    "prefixo": "68513",
    "uf": "PA",
    "codigoIbge": 1504208,
    "cidade": "Marabá"
  },
  {
    "prefixo": "68514",
    "uf": "PA",
    "codigoIbge": 1504208,
    "cidade": "Marabá"
  },
  {
    "prefixo": "68515",
    "uf": "PA",
    "codigoIbge": 1505536,
    "cidade": "Parauapebas"
  },
  {
    "prefixo": "68516",
    "uf": "PA",
    "codigoIbge": 1505536,
    "cidade": "Parauapebas"
  },
  {
    "prefixo": "68518",
    "uf": "PA",
    "codigoIbge": 1507508,
    "cidade": "São João do Araguaia"
  },
  {
    "prefixo": "68519",
    "uf": "PA",
    "codigoIbge": 1507508,
    "cidade": "São João do Araguaia"
  },
  {
    "prefixo": "68520",
    "uf": "PA",
    "codigoIbge": 1507151,
    "cidade": "São Domingos do Araguaia"
  },
  {
    "prefixo": "68521",
    "uf": "PA",
    "codigoIbge": 1501758,
    "cidade": "Brejo Grande do Araguaia"
  },
  {
    "prefixo": "68523",
    "uf": "PA",
    "codigoIbge": 1502772,
    "cidade": "Curionópolis"
  },
  {
    "prefixo": "68524",
    "uf": "PA",
    "codigoIbge": 1502954,
    "cidade": "Eldorado do Carajás"
  },
  {
    "prefixo": "68525",
    "uf": "PA",
    "codigoIbge": 1501576,
    "cidade": "Bom Jesus do Tocantins"
  },
  {
    "prefixo": "68527",
    "uf": "PA",
    "codigoIbge": 1500131,
    "cidade": "Abel Figueiredo"
  },
  {
    "prefixo": "68530",
    "uf": "PA",
    "codigoIbge": 1506161,
    "cidade": "Rio Maria"
  },
  {
    "prefixo": "68533",
    "uf": "PA",
    "codigoIbge": 1500347,
    "cidade": "Água Azul do Norte"
  },
  {
    "prefixo": "68535",
    "uf": "PA",
    "codigoIbge": 1505494,
    "cidade": "Palestina do Pará"
  },
  {
    "prefixo": "68537",
    "uf": "PA",
    "codigoIbge": 1502152,
    "cidade": "Canaã dos Carajás"
  },
  {
    "prefixo": "68540",
    "uf": "PA",
    "codigoIbge": 1502707,
    "cidade": "Conceição do Araguaia"
  },
  {
    "prefixo": "68543",
    "uf": "PA",
    "codigoIbge": 1503044,
    "cidade": "Floresta do Araguaia"
  },
  {
    "prefixo": "68544",
    "uf": "PA",
    "codigoIbge": 1503044,
    "cidade": "Floresta do Araguaia"
  },
  {
    "prefixo": "68545",
    "uf": "PA",
    "codigoIbge": 1505551,
    "cidade": "Pau D'Arco"
  },
  {
    "prefixo": "68548",
    "uf": "PA",
    "codigoIbge": 1507755,
    "cidade": "Sapucaia"
  },
  {
    "prefixo": "68549",
    "uf": "PA",
    "codigoIbge": 1506138,
    "cidade": "Redenção"
  },
  {
    "prefixo": "68550",
    "uf": "PA",
    "codigoIbge": 1506138,
    "cidade": "Redenção"
  },
  {
    "prefixo": "68551",
    "uf": "PA",
    "codigoIbge": 1506138,
    "cidade": "Redenção"
  },
  {
    "prefixo": "68552",
    "uf": "PA",
    "codigoIbge": 1506138,
    "cidade": "Redenção"
  },
  {
    "prefixo": "68553",
    "uf": "PA",
    "codigoIbge": 1506138,
    "cidade": "Redenção"
  },
  {
    "prefixo": "68554",
    "uf": "PA",
    "codigoIbge": 1506138,
    "cidade": "Redenção"
  },
  {
    "prefixo": "68555",
    "uf": "PA",
    "codigoIbge": 1508407,
    "cidade": "Xinguara"
  },
  {
    "prefixo": "68556",
    "uf": "PA",
    "codigoIbge": 1508407,
    "cidade": "Xinguara"
  },
  {
    "prefixo": "68557",
    "uf": "PA",
    "codigoIbge": 1508407,
    "cidade": "Xinguara"
  },
  {
    "prefixo": "68558",
    "uf": "PA",
    "codigoIbge": 1508407,
    "cidade": "Xinguara"
  },
  {
    "prefixo": "68559",
    "uf": "PA",
    "codigoIbge": 1508407,
    "cidade": "Xinguara"
  },
  {
    "prefixo": "68560",
    "uf": "PA",
    "codigoIbge": 1506708,
    "cidade": "Santana do Araguaia"
  },
  {
    "prefixo": "68562",
    "uf": "PA",
    "codigoIbge": 1506708,
    "cidade": "Santana do Araguaia"
  },
  {
    "prefixo": "68563",
    "uf": "PA",
    "codigoIbge": 1506708,
    "cidade": "Santana do Araguaia"
  },
  {
    "prefixo": "68565",
    "uf": "PA",
    "codigoIbge": 1506583,
    "cidade": "Santa Maria das Barreiras"
  },
  {
    "prefixo": "68567",
    "uf": "PA",
    "codigoIbge": 1506583,
    "cidade": "Santa Maria das Barreiras"
  },
  {
    "prefixo": "68568",
    "uf": "PA",
    "codigoIbge": 1506583,
    "cidade": "Santa Maria das Barreiras"
  },
  {
    "prefixo": "68570",
    "uf": "PA",
    "codigoIbge": 1507458,
    "cidade": "São Geraldo do Araguaia"
  },
  {
    "prefixo": "68575",
    "uf": "PA",
    "codigoIbge": 1505635,
    "cidade": "Piçarra"
  },
  {
    "prefixo": "68580",
    "uf": "PA",
    "codigoIbge": 1503705,
    "cidade": "Itupiranga"
  },
  {
    "prefixo": "68585",
    "uf": "PA",
    "codigoIbge": 1504976,
    "cidade": "Nova Ipixuna"
  },
  {
    "prefixo": "68590",
    "uf": "PA",
    "codigoIbge": 1503804,
    "cidade": "Jacundá"
  },
  {
    "prefixo": "68600",
    "uf": "PA",
    "codigoIbge": 1501709,
    "cidade": "Bragança"
  },
  {
    "prefixo": "68604",
    "uf": "PA",
    "codigoIbge": 1501709,
    "cidade": "Bragança"
  },
  {
    "prefixo": "68606",
    "uf": "PA",
    "codigoIbge": 1501709,
    "cidade": "Bragança"
  },
  {
    "prefixo": "68607",
    "uf": "PA",
    "codigoIbge": 1501709,
    "cidade": "Bragança"
  },
  {
    "prefixo": "68608",
    "uf": "PA",
    "codigoIbge": 1501709,
    "cidade": "Bragança"
  },
  {
    "prefixo": "68609",
    "uf": "PA",
    "codigoIbge": 1501709,
    "cidade": "Bragança"
  },
  {
    "prefixo": "68610",
    "uf": "PA",
    "codigoIbge": 1500909,
    "cidade": "Augusto Corrêa"
  },
  {
    "prefixo": "68615",
    "uf": "PA",
    "codigoIbge": 1500909,
    "cidade": "Augusto Corrêa"
  },
  {
    "prefixo": "68617",
    "uf": "PA",
    "codigoIbge": 1501956,
    "cidade": "Cachoeira do Piriá"
  },
  {
    "prefixo": "68618",
    "uf": "PA",
    "codigoIbge": 1504950,
    "cidade": "Nova Esperança do Piriá"
  },
  {
    "prefixo": "68620",
    "uf": "PA",
    "codigoIbge": 1508308,
    "cidade": "Viseu"
  },
  {
    "prefixo": "68622",
    "uf": "PA",
    "codigoIbge": 1508308,
    "cidade": "Viseu"
  },
  {
    "prefixo": "68623",
    "uf": "PA",
    "codigoIbge": 1508308,
    "cidade": "Viseu"
  },
  {
    "prefixo": "68624",
    "uf": "PA",
    "codigoIbge": 1508308,
    "cidade": "Viseu"
  },
  {
    "prefixo": "68625",
    "uf": "PA",
    "codigoIbge": 1505502,
    "cidade": "Paragominas"
  },
  {
    "prefixo": "68626",
    "uf": "PA",
    "codigoIbge": 1505502,
    "cidade": "Paragominas"
  },
  {
    "prefixo": "68627",
    "uf": "PA",
    "codigoIbge": 1505502,
    "cidade": "Paragominas"
  },
  {
    "prefixo": "68628",
    "uf": "PA",
    "codigoIbge": 1505502,
    "cidade": "Paragominas"
  },
  {
    "prefixo": "68629",
    "uf": "PA",
    "codigoIbge": 1505502,
    "cidade": "Paragominas"
  },
  {
    "prefixo": "68630",
    "uf": "PA",
    "codigoIbge": 1505502,
    "cidade": "Paragominas"
  },
  {
    "prefixo": "68632",
    "uf": "PA",
    "codigoIbge": 1508126,
    "cidade": "Ulianópolis"
  },
  {
    "prefixo": "68633",
    "uf": "PA",
    "codigoIbge": 1502939,
    "cidade": "Dom Eliseu"
  },
  {
    "prefixo": "68635",
    "uf": "PA",
    "codigoIbge": 1507201,
    "cidade": "São Domingos do Capim"
  },
  {
    "prefixo": "68636",
    "uf": "PA",
    "codigoIbge": 1507201,
    "cidade": "São Domingos do Capim"
  },
  {
    "prefixo": "68637",
    "uf": "PA",
    "codigoIbge": 1503457,
    "cidade": "Ipixuna do Pará"
  },
  {
    "prefixo": "68638",
    "uf": "PA",
    "codigoIbge": 1506187,
    "cidade": "Rondon do Pará"
  },
  {
    "prefixo": "68639",
    "uf": "PA",
    "codigoIbge": 1503093,
    "cidade": "Goianésia do Pará"
  },
  {
    "prefixo": "68640",
    "uf": "PA",
    "codigoIbge": 1505403,
    "cidade": "Ourém"
  },
  {
    "prefixo": "68644",
    "uf": "PA",
    "codigoIbge": 1506559,
    "cidade": "Santa Luzia do Pará"
  },
  {
    "prefixo": "68645",
    "uf": "PA",
    "codigoIbge": 1501600,
    "cidade": "Bonito"
  },
  {
    "prefixo": "68647",
    "uf": "PA",
    "codigoIbge": 1508035,
    "cidade": "Tracuateua"
  },
  {
    "prefixo": "68650",
    "uf": "PA",
    "codigoIbge": 1502301,
    "cidade": "Capitão Poço"
  },
  {
    "prefixo": "68655",
    "uf": "PA",
    "codigoIbge": 1503507,
    "cidade": "Irituia"
  },
  {
    "prefixo": "68658",
    "uf": "PA",
    "codigoIbge": 1500958,
    "cidade": "Aurora do Pará"
  },
  {
    "prefixo": "68660",
    "uf": "PA",
    "codigoIbge": 1507607,
    "cidade": "São Miguel do Guamá"
  },
  {
    "prefixo": "68662",
    "uf": "PA",
    "codigoIbge": 1507607,
    "cidade": "São Miguel do Guamá"
  },
  {
    "prefixo": "68663",
    "uf": "PA",
    "codigoIbge": 1507607,
    "cidade": "São Miguel do Guamá"
  },
  {
    "prefixo": "68665",
    "uf": "PA",
    "codigoIbge": 1503077,
    "cidade": "Garrafão do Norte"
  },
  {
    "prefixo": "68670",
    "uf": "PA",
    "codigoIbge": 1501907,
    "cidade": "Bujaru"
  },
  {
    "prefixo": "68672",
    "uf": "PA",
    "codigoIbge": 1501907,
    "cidade": "Bujaru"
  },
  {
    "prefixo": "68675",
    "uf": "PA",
    "codigoIbge": 1504059,
    "cidade": "Mãe do Rio"
  },
  {
    "prefixo": "68680",
    "uf": "PA",
    "codigoIbge": 1508001,
    "cidade": "Tomé-Açu"
  },
  {
    "prefixo": "68682",
    "uf": "PA",
    "codigoIbge": 1508001,
    "cidade": "Tomé-Açu"
  },
  {
    "prefixo": "68685",
    "uf": "PA",
    "codigoIbge": 1502756,
    "cidade": "Concórdia do Pará"
  },
  {
    "prefixo": "68688",
    "uf": "PA",
    "codigoIbge": 1508001,
    "cidade": "Tomé-Açu"
  },
  {
    "prefixo": "68690",
    "uf": "PA",
    "codigoIbge": 1500206,
    "cidade": "Acará"
  },
  {
    "prefixo": "68692",
    "uf": "PA",
    "codigoIbge": 1500206,
    "cidade": "Acará"
  },
  {
    "prefixo": "68693",
    "uf": "PA",
    "codigoIbge": 1500206,
    "cidade": "Acará"
  },
  {
    "prefixo": "68695",
    "uf": "PA",
    "codigoIbge": 1507953,
    "cidade": "Tailândia"
  },
  {
    "prefixo": "68699",
    "uf": "PA",
    "codigoIbge": 1507953,
    "cidade": "Tailândia"
  },
  {
    "prefixo": "68700",
    "uf": "PA",
    "codigoIbge": 1502202,
    "cidade": "Capanema"
  },
  {
    "prefixo": "68701",
    "uf": "PA",
    "codigoIbge": 1502202,
    "cidade": "Capanema"
  },
  {
    "prefixo": "68702",
    "uf": "PA",
    "codigoIbge": 1502202,
    "cidade": "Capanema"
  },
  {
    "prefixo": "68703",
    "uf": "PA",
    "codigoIbge": 1502202,
    "cidade": "Capanema"
  },
  {
    "prefixo": "68704",
    "uf": "PA",
    "codigoIbge": 1502202,
    "cidade": "Capanema"
  },
  {
    "prefixo": "68705",
    "uf": "PA",
    "codigoIbge": 1502202,
    "cidade": "Capanema"
  },
  {
    "prefixo": "68706",
    "uf": "PA",
    "codigoIbge": 1502202,
    "cidade": "Capanema"
  },
  {
    "prefixo": "68707",
    "uf": "PA",
    "codigoIbge": 1506104,
    "cidade": "Primavera"
  },
  {
    "prefixo": "68708",
    "uf": "PA",
    "codigoIbge": 1506104,
    "cidade": "Primavera"
  },
  {
    "prefixo": "68709",
    "uf": "PA",
    "codigoIbge": 1506112,
    "cidade": "Quatipuru"
  },
  {
    "prefixo": "68710",
    "uf": "PA",
    "codigoIbge": 1504307,
    "cidade": "Maracanã"
  },
  {
    "prefixo": "68711",
    "uf": "PA",
    "codigoIbge": 1504307,
    "cidade": "Maracanã"
  },
  {
    "prefixo": "68716",
    "uf": "PA",
    "codigoIbge": 1504307,
    "cidade": "Maracanã"
  },
  {
    "prefixo": "68717",
    "uf": "PA",
    "codigoIbge": 1504307,
    "cidade": "Maracanã"
  },
  {
    "prefixo": "68719",
    "uf": "PA",
    "codigoIbge": 1507474,
    "cidade": "São João de Pirabas"
  },
  {
    "prefixo": "68720",
    "uf": "PA",
    "codigoIbge": 1506906,
    "cidade": "Santarém Novo"
  },
  {
    "prefixo": "68721",
    "uf": "PA",
    "codigoIbge": 1506203,
    "cidade": "Salinópolis"
  },
  {
    "prefixo": "68722",
    "uf": "PA",
    "codigoIbge": 1504109,
    "cidade": "Magalhães Barata"
  },
  {
    "prefixo": "68723",
    "uf": "PA",
    "codigoIbge": 1504109,
    "cidade": "Magalhães Barata"
  },
  {
    "prefixo": "68725",
    "uf": "PA",
    "codigoIbge": 1503200,
    "cidade": "Igarapé-Açu"
  },
  {
    "prefixo": "68726",
    "uf": "PA",
    "codigoIbge": 1503200,
    "cidade": "Igarapé-Açu"
  },
  {
    "prefixo": "68730",
    "uf": "PA",
    "codigoIbge": 1505007,
    "cidade": "Nova Timboteua"
  },
  {
    "prefixo": "68732",
    "uf": "PA",
    "codigoIbge": 1505007,
    "cidade": "Nova Timboteua"
  },
  {
    "prefixo": "68734",
    "uf": "PA",
    "codigoIbge": 1505601,
    "cidade": "Peixe-Boi"
  },
  {
    "prefixo": "68735",
    "uf": "PA",
    "codigoIbge": 1505601,
    "cidade": "Peixe-Boi"
  },
  {
    "prefixo": "68738",
    "uf": "PA",
    "codigoIbge": 1506609,
    "cidade": "Santa Maria do Pará"
  },
  {
    "prefixo": "68740",
    "uf": "PA",
    "codigoIbge": 1502400,
    "cidade": "Castanhal"
  },
  {
    "prefixo": "68741",
    "uf": "PA",
    "codigoIbge": 1502400,
    "cidade": "Castanhal"
  },
  {
    "prefixo": "68742",
    "uf": "PA",
    "codigoIbge": 1502400,
    "cidade": "Castanhal"
  },
  {
    "prefixo": "68743",
    "uf": "PA",
    "codigoIbge": 1502400,
    "cidade": "Castanhal"
  },
  {
    "prefixo": "68744",
    "uf": "PA",
    "codigoIbge": 1502400,
    "cidade": "Castanhal"
  },
  {
    "prefixo": "68745",
    "uf": "PA",
    "codigoIbge": 1502400,
    "cidade": "Castanhal"
  },
  {
    "prefixo": "68746",
    "uf": "PA",
    "codigoIbge": 1502400,
    "cidade": "Castanhal"
  },
  {
    "prefixo": "68747",
    "uf": "PA",
    "codigoIbge": 1502400,
    "cidade": "Castanhal"
  },
  {
    "prefixo": "68748",
    "uf": "PA",
    "codigoIbge": 1507409,
    "cidade": "São Francisco do Pará"
  },
  {
    "prefixo": "68749",
    "uf": "PA",
    "codigoIbge": 1507409,
    "cidade": "São Francisco do Pará"
  },
  {
    "prefixo": "68750",
    "uf": "PA",
    "codigoIbge": 1502905,
    "cidade": "Curuçá"
  },
  {
    "prefixo": "68752",
    "uf": "PA",
    "codigoIbge": 1502905,
    "cidade": "Curuçá"
  },
  {
    "prefixo": "68753",
    "uf": "PA",
    "codigoIbge": 1502905,
    "cidade": "Curuçá"
  },
  {
    "prefixo": "68754",
    "uf": "PA",
    "codigoIbge": 1502905,
    "cidade": "Curuçá"
  },
  {
    "prefixo": "68755",
    "uf": "PA",
    "codigoIbge": 1502905,
    "cidade": "Curuçá"
  },
  {
    "prefixo": "68756",
    "uf": "PA",
    "codigoIbge": 1502905,
    "cidade": "Curuçá"
  },
  {
    "prefixo": "68758",
    "uf": "PA",
    "codigoIbge": 1502905,
    "cidade": "Curuçá"
  },
  {
    "prefixo": "68759",
    "uf": "PA",
    "codigoIbge": 1502905,
    "cidade": "Curuçá"
  },
  {
    "prefixo": "68760",
    "uf": "PA",
    "codigoIbge": 1504406,
    "cidade": "Marapanim"
  },
  {
    "prefixo": "68762",
    "uf": "PA",
    "codigoIbge": 1504406,
    "cidade": "Marapanim"
  },
  {
    "prefixo": "68764",
    "uf": "PA",
    "codigoIbge": 1504406,
    "cidade": "Marapanim"
  },
  {
    "prefixo": "68765",
    "uf": "PA",
    "codigoIbge": 1504406,
    "cidade": "Marapanim"
  },
  {
    "prefixo": "68768",
    "uf": "PA",
    "codigoIbge": 1504406,
    "cidade": "Marapanim"
  },
  {
    "prefixo": "68770",
    "uf": "PA",
    "codigoIbge": 1503408,
    "cidade": "Inhangapi"
  },
  {
    "prefixo": "68772",
    "uf": "PA",
    "codigoIbge": 1503408,
    "cidade": "Inhangapi"
  },
  {
    "prefixo": "68773",
    "uf": "PA",
    "codigoIbge": 1507961,
    "cidade": "Terra Alta"
  },
  {
    "prefixo": "68774",
    "uf": "PA",
    "codigoIbge": 1507466,
    "cidade": "São João da Ponta"
  },
  {
    "prefixo": "68775",
    "uf": "PA",
    "codigoIbge": 1507102,
    "cidade": "São Caetano de Odivelas"
  },
  {
    "prefixo": "68778",
    "uf": "PA",
    "codigoIbge": 1507102,
    "cidade": "São Caetano de Odivelas"
  },
  {
    "prefixo": "68779",
    "uf": "PA",
    "codigoIbge": 1507102,
    "cidade": "São Caetano de Odivelas"
  },
  {
    "prefixo": "68780",
    "uf": "PA",
    "codigoIbge": 1508209,
    "cidade": "Vigia"
  },
  {
    "prefixo": "68781",
    "uf": "PA",
    "codigoIbge": 1508209,
    "cidade": "Vigia"
  },
  {
    "prefixo": "68782",
    "uf": "PA",
    "codigoIbge": 1508209,
    "cidade": "Vigia"
  },
  {
    "prefixo": "68785",
    "uf": "PA",
    "codigoIbge": 1502608,
    "cidade": "Colares"
  },
  {
    "prefixo": "68786",
    "uf": "PA",
    "codigoIbge": 1507003,
    "cidade": "Santo Antônio do Tauá"
  },
  {
    "prefixo": "68787",
    "uf": "PA",
    "codigoIbge": 1507003,
    "cidade": "Santo Antônio do Tauá"
  },
  {
    "prefixo": "68790",
    "uf": "PA",
    "codigoIbge": 1506500,
    "cidade": "Santa Izabel do Pará"
  },
  {
    "prefixo": "68791",
    "uf": "PA",
    "codigoIbge": 1506500,
    "cidade": "Santa Izabel do Pará"
  },
  {
    "prefixo": "68792",
    "uf": "PA",
    "codigoIbge": 1506500,
    "cidade": "Santa Izabel do Pará"
  },
  {
    "prefixo": "68795",
    "uf": "PA",
    "codigoIbge": 1501501,
    "cidade": "Benevides"
  },
  {
    "prefixo": "68797",
    "uf": "PA",
    "codigoIbge": 1501501,
    "cidade": "Benevides"
  },
  {
    "prefixo": "68798",
    "uf": "PA",
    "codigoIbge": 1506351,
    "cidade": "Santa Bárbara do Pará"
  },
  {
    "prefixo": "68800",
    "uf": "PA",
    "codigoIbge": 1501808,
    "cidade": "Breves"
  },
  {
    "prefixo": "68803",
    "uf": "PA",
    "codigoIbge": 1501808,
    "cidade": "Breves"
  },
  {
    "prefixo": "68808",
    "uf": "PA",
    "codigoIbge": 1501808,
    "cidade": "Breves"
  },
  {
    "prefixo": "68810",
    "uf": "PA",
    "codigoIbge": 1500701,
    "cidade": "Anajás"
  },
  {
    "prefixo": "68815",
    "uf": "PA",
    "codigoIbge": 1502806,
    "cidade": "Curralinho"
  },
  {
    "prefixo": "68818",
    "uf": "PA",
    "codigoIbge": 1502806,
    "cidade": "Curralinho"
  },
  {
    "prefixo": "68820",
    "uf": "PA",
    "codigoIbge": 1507706,
    "cidade": "São Sebastião da Boa Vista"
  },
  {
    "prefixo": "68822",
    "uf": "PA",
    "codigoIbge": 1504901,
    "cidade": "Muaná"
  },
  {
    "prefixo": "68825",
    "uf": "PA",
    "codigoIbge": 1504901,
    "cidade": "Muaná"
  },
  {
    "prefixo": "68827",
    "uf": "PA",
    "codigoIbge": 1504901,
    "cidade": "Muaná"
  },
  {
    "prefixo": "68828",
    "uf": "PA",
    "codigoIbge": 1504901,
    "cidade": "Muaná"
  },
  {
    "prefixo": "68830",
    "uf": "PA",
    "codigoIbge": 1505700,
    "cidade": "Ponta de Pedras"
  },
  {
    "prefixo": "68835",
    "uf": "PA",
    "codigoIbge": 1505700,
    "cidade": "Ponta de Pedras"
  },
  {
    "prefixo": "68840",
    "uf": "PA",
    "codigoIbge": 1502004,
    "cidade": "Cachoeira do Arari"
  },
  {
    "prefixo": "68845",
    "uf": "PA",
    "codigoIbge": 1502004,
    "cidade": "Cachoeira do Arari"
  },
  {
    "prefixo": "68848",
    "uf": "PA",
    "codigoIbge": 1502004,
    "cidade": "Cachoeira do Arari"
  },
  {
    "prefixo": "68850",
    "uf": "PA",
    "codigoIbge": 1506401,
    "cidade": "Santa Cruz do Arari"
  },
  {
    "prefixo": "68860",
    "uf": "PA",
    "codigoIbge": 1506302,
    "cidade": "Salvaterra"
  },
  {
    "prefixo": "68862",
    "uf": "PA",
    "codigoIbge": 1506302,
    "cidade": "Salvaterra"
  },
  {
    "prefixo": "68864",
    "uf": "PA",
    "codigoIbge": 1506302,
    "cidade": "Salvaterra"
  },
  {
    "prefixo": "68866",
    "uf": "PA",
    "codigoIbge": 1506302,
    "cidade": "Salvaterra"
  },
  {
    "prefixo": "68868",
    "uf": "PA",
    "codigoIbge": 1506302,
    "cidade": "Salvaterra"
  },
  {
    "prefixo": "68870",
    "uf": "PA",
    "codigoIbge": 1507904,
    "cidade": "Soure"
  },
  {
    "prefixo": "68875",
    "uf": "PA",
    "codigoIbge": 1507904,
    "cidade": "Soure"
  },
  {
    "prefixo": "68880",
    "uf": "PA",
    "codigoIbge": 1502509,
    "cidade": "Chaves"
  },
  {
    "prefixo": "68885",
    "uf": "PA",
    "codigoIbge": 1502509,
    "cidade": "Chaves"
  },
  {
    "prefixo": "68890",
    "uf": "PA",
    "codigoIbge": 1500305,
    "cidade": "Afuá"
  },
  {
    "prefixo": "68892",
    "uf": "PA",
    "codigoIbge": 1500305,
    "cidade": "Afuá"
  },
  {
    "prefixo": "68900",
    "uf": "AP",
    "codigoIbge": 1600303,
    "cidade": "Macapá"
  },
  {
    "prefixo": "68901",
    "uf": "AP",
    "codigoIbge": 1600303,
    "cidade": "Macapá"
  },
  {
    "prefixo": "68902",
    "uf": "AP",
    "codigoIbge": 1600303,
    "cidade": "Macapá"
  },
  {
    "prefixo": "68903",
    "uf": "AP",
    "codigoIbge": 1600303,
    "cidade": "Macapá"
  },
  {
    "prefixo": "68904",
    "uf": "AP",
    "codigoIbge": 1600303,
    "cidade": "Macapá"
  },
  {
    "prefixo": "68905",
    "uf": "AP",
    "codigoIbge": 1600303,
    "cidade": "Macapá"
  },
  {
    "prefixo": "68906",
    "uf": "AP",
    "codigoIbge": 1600303,
    "cidade": "Macapá"
  },
  {
    "prefixo": "68907",
    "uf": "AP",
    "codigoIbge": 1600303,
    "cidade": "Macapá"
  },
  {
    "prefixo": "68908",
    "uf": "AP",
    "codigoIbge": 1600303,
    "cidade": "Macapá"
  },
  {
    "prefixo": "68909",
    "uf": "AP",
    "codigoIbge": 1600303,
    "cidade": "Macapá"
  },
  {
    "prefixo": "68911",
    "uf": "AP",
    "codigoIbge": 1600303,
    "cidade": "Macapá"
  },
  {
    "prefixo": "68912",
    "uf": "AP",
    "codigoIbge": 1600303,
    "cidade": "Macapá"
  },
  {
    "prefixo": "68913",
    "uf": "AP",
    "codigoIbge": 1600303,
    "cidade": "Macapá"
  },
  {
    "prefixo": "68915",
    "uf": "AP",
    "codigoIbge": 1600238,
    "cidade": "Ferreira Gomes"
  },
  {
    "prefixo": "68917",
    "uf": "AP",
    "codigoIbge": 1600238,
    "cidade": "Ferreira Gomes"
  },
  {
    "prefixo": "68918",
    "uf": "AP",
    "codigoIbge": 1600550,
    "cidade": "Pracuúba"
  },
  {
    "prefixo": "68920",
    "uf": "AP",
    "codigoIbge": 1600279,
    "cidade": "Laranjal do Jari"
  },
  {
    "prefixo": "68923",
    "uf": "AP",
    "codigoIbge": 1600279,
    "cidade": "Laranjal do Jari"
  },
  {
    "prefixo": "68924",
    "uf": "AP",
    "codigoIbge": 1600808,
    "cidade": "Vitória do Jari"
  },
  {
    "prefixo": "68925",
    "uf": "AP",
    "codigoIbge": 1600600,
    "cidade": "Santana"
  },
  {
    "prefixo": "68926",
    "uf": "AP",
    "codigoIbge": 1600600,
    "cidade": "Santana"
  },
  {
    "prefixo": "68927",
    "uf": "AP",
    "codigoIbge": 1600600,
    "cidade": "Santana"
  },
  {
    "prefixo": "68928",
    "uf": "AP",
    "codigoIbge": 1600600,
    "cidade": "Santana"
  },
  {
    "prefixo": "68929",
    "uf": "AP",
    "codigoIbge": 1600600,
    "cidade": "Santana"
  },
  {
    "prefixo": "68930",
    "uf": "AP",
    "codigoIbge": 1600600,
    "cidade": "Santana"
  },
  {
    "prefixo": "68933",
    "uf": "AP",
    "codigoIbge": 1600600,
    "cidade": "Santana"
  },
  {
    "prefixo": "68935",
    "uf": "AP",
    "codigoIbge": 1600600,
    "cidade": "Santana"
  },
  {
    "prefixo": "68937",
    "uf": "AP",
    "codigoIbge": 1600600,
    "cidade": "Santana"
  },
  {
    "prefixo": "68940",
    "uf": "AP",
    "codigoIbge": 1600402,
    "cidade": "Mazagão"
  },
  {
    "prefixo": "68943",
    "uf": "AP",
    "codigoIbge": 1600402,
    "cidade": "Mazagão"
  },
  {
    "prefixo": "68945",
    "uf": "AP",
    "codigoIbge": 1600154,
    "cidade": "Pedra Branca do Amapari"
  },
  {
    "prefixo": "68948",
    "uf": "AP",
    "codigoIbge": 1600055,
    "cidade": "Serra do Navio"
  },
  {
    "prefixo": "68950",
    "uf": "AP",
    "codigoIbge": 1600105,
    "cidade": "Amapá"
  },
  {
    "prefixo": "68958",
    "uf": "AP",
    "codigoIbge": 1600105,
    "cidade": "Amapá"
  },
  {
    "prefixo": "68960",
    "uf": "AP",
    "codigoIbge": 1600204,
    "cidade": "Calçoene"
  },
  {
    "prefixo": "68970",
    "uf": "AP",
    "codigoIbge": 1600204,
    "cidade": "Calçoene"
  },
  {
    "prefixo": "68973",
    "uf": "AP",
    "codigoIbge": 1600212,
    "cidade": "Cutias"
  },
  {
    "prefixo": "68976",
    "uf": "AP",
    "codigoIbge": 1600253,
    "cidade": "Itaubal"
  },
  {
    "prefixo": "68980",
    "uf": "AP",
    "codigoIbge": 1600501,
    "cidade": "Oiapoque"
  },
  {
    "prefixo": "68985",
    "uf": "AP",
    "codigoIbge": 1600501,
    "cidade": "Oiapoque"
  },
  {
    "prefixo": "68988",
    "uf": "AP",
    "codigoIbge": 1600501,
    "cidade": "Oiapoque"
  },
  {
    "prefixo": "68990",
    "uf": "AP",
    "codigoIbge": 1600709,
    "cidade": "Tartarugalzinho"
  },
  {
    "prefixo": "68994",
    "uf": "AP",
    "codigoIbge": 1600709,
    "cidade": "Tartarugalzinho"
  },
  {
    "prefixo": "68997",
    "uf": "AP",
    "codigoIbge": 1600535,
    "cidade": "Porto Grande"
  },
  {
    "prefixo": "69001",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69002",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69004",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69005",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69006",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69007",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69008",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69009",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69010",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69015",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69017",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69018",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69019",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69020",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69021",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69022",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69023",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69024",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69025",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69027",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69028",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69029",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69030",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69033",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69034",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69035",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69036",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69037",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69038",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69039",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69040",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69041",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69042",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69043",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69044",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69045",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69046",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69047",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69048",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69049",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69050",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69053",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69054",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69055",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69057",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69058",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69059",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69060",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69063",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69065",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69067",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69068",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69070",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69072",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69073",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69074",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69075",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69076",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69077",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69078",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69079",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69080",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69082",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69083",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69084",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69085",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69086",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69087",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69088",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69089",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69090",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69092",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69093",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69094",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69095",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69096",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69097",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69098",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69099",
    "uf": "AM",
    "codigoIbge": 1302603,
    "cidade": "Manaus"
  },
  {
    "prefixo": "69100",
    "uf": "AM",
    "codigoIbge": 1301902,
    "cidade": "Itacoatiara"
  },
  {
    "prefixo": "69101",
    "uf": "AM",
    "codigoIbge": 1301902,
    "cidade": "Itacoatiara"
  },
  {
    "prefixo": "69103",
    "uf": "AM",
    "codigoIbge": 1301902,
    "cidade": "Itacoatiara"
  },
  {
    "prefixo": "69104",
    "uf": "AM",
    "codigoIbge": 1301902,
    "cidade": "Itacoatiara"
  },
  {
    "prefixo": "69107",
    "uf": "AM",
    "codigoIbge": 1301902,
    "cidade": "Itacoatiara"
  },
  {
    "prefixo": "69109",
    "uf": "AM",
    "codigoIbge": 1301902,
    "cidade": "Itacoatiara"
  },
  {
    "prefixo": "69110",
    "uf": "AM",
    "codigoIbge": 1301902,
    "cidade": "Itacoatiara"
  },
  {
    "prefixo": "69112",
    "uf": "AM",
    "codigoIbge": 1301902,
    "cidade": "Itacoatiara"
  },
  {
    "prefixo": "69113",
    "uf": "AM",
    "codigoIbge": 1301902,
    "cidade": "Itacoatiara"
  },
  {
    "prefixo": "69114",
    "uf": "AM",
    "codigoIbge": 1304005,
    "cidade": "Silves"
  },
  {
    "prefixo": "69117",
    "uf": "AM",
    "codigoIbge": 1303569,
    "cidade": "Rio Preto da Eva"
  },
  {
    "prefixo": "69120",
    "uf": "AM",
    "codigoIbge": 1302009,
    "cidade": "Itapiranga"
  },
  {
    "prefixo": "69130",
    "uf": "AM",
    "codigoIbge": 1304302,
    "cidade": "Urucará"
  },
  {
    "prefixo": "69134",
    "uf": "AM",
    "codigoIbge": 1304302,
    "cidade": "Urucará"
  },
  {
    "prefixo": "69135",
    "uf": "AM",
    "codigoIbge": 1303957,
    "cidade": "São Sebastião do Uatumã"
  },
  {
    "prefixo": "69140",
    "uf": "AM",
    "codigoIbge": 1303007,
    "cidade": "Nhamundá"
  },
  {
    "prefixo": "69150",
    "uf": "AM",
    "codigoIbge": 1303403,
    "cidade": "Parintins"
  },
  {
    "prefixo": "69151",
    "uf": "AM",
    "codigoIbge": 1303403,
    "cidade": "Parintins"
  },
  {
    "prefixo": "69152",
    "uf": "AM",
    "codigoIbge": 1303403,
    "cidade": "Parintins"
  },
  {
    "prefixo": "69153",
    "uf": "AM",
    "codigoIbge": 1303403,
    "cidade": "Parintins"
  },
  {
    "prefixo": "69154",
    "uf": "AM",
    "codigoIbge": 1303403,
    "cidade": "Parintins"
  },
  {
    "prefixo": "69157",
    "uf": "AM",
    "codigoIbge": 1303403,
    "cidade": "Parintins"
  },
  {
    "prefixo": "69158",
    "uf": "AM",
    "codigoIbge": 1303403,
    "cidade": "Parintins"
  },
  {
    "prefixo": "69159",
    "uf": "AM",
    "codigoIbge": 1303403,
    "cidade": "Parintins"
  },
  {
    "prefixo": "69160",
    "uf": "AM",
    "codigoIbge": 1300508,
    "cidade": "Barreirinha"
  },
  {
    "prefixo": "69162",
    "uf": "AM",
    "codigoIbge": 1300508,
    "cidade": "Barreirinha"
  },
  {
    "prefixo": "69165",
    "uf": "AM",
    "codigoIbge": 1300508,
    "cidade": "Barreirinha"
  },
  {
    "prefixo": "69170",
    "uf": "AM",
    "codigoIbge": 1300508,
    "cidade": "Barreirinha"
  },
  {
    "prefixo": "69175",
    "uf": "AM",
    "codigoIbge": 1300508,
    "cidade": "Barreirinha"
  },
  {
    "prefixo": "69180",
    "uf": "AM",
    "codigoIbge": 1304401,
    "cidade": "Urucurituba"
  },
  {
    "prefixo": "69182",
    "uf": "AM",
    "codigoIbge": 1304401,
    "cidade": "Urucurituba"
  },
  {
    "prefixo": "69184",
    "uf": "AM",
    "codigoIbge": 1304401,
    "cidade": "Urucurituba"
  },
  {
    "prefixo": "69190",
    "uf": "AM",
    "codigoIbge": 1302900,
    "cidade": "Maués"
  },
  {
    "prefixo": "69192",
    "uf": "AM",
    "codigoIbge": 1302900,
    "cidade": "Maués"
  },
  {
    "prefixo": "69193",
    "uf": "AM",
    "codigoIbge": 1302900,
    "cidade": "Maués"
  },
  {
    "prefixo": "69195",
    "uf": "AM",
    "codigoIbge": 1300680,
    "cidade": "Boa Vista do Ramos"
  },
  {
    "prefixo": "69196",
    "uf": "AM",
    "codigoIbge": 1300680,
    "cidade": "Boa Vista do Ramos"
  },
  {
    "prefixo": "69197",
    "uf": "AM",
    "codigoIbge": 1300680,
    "cidade": "Boa Vista do Ramos"
  },
  {
    "prefixo": "69200",
    "uf": "AM",
    "codigoIbge": 1300805,
    "cidade": "Borba"
  },
  {
    "prefixo": "69210",
    "uf": "AM",
    "codigoIbge": 1300805,
    "cidade": "Borba"
  },
  {
    "prefixo": "69212",
    "uf": "AM",
    "codigoIbge": 1300805,
    "cidade": "Borba"
  },
  {
    "prefixo": "69230",
    "uf": "AM",
    "codigoIbge": 1303106,
    "cidade": "Nova Olinda do Norte"
  },
  {
    "prefixo": "69240",
    "uf": "AM",
    "codigoIbge": 1300300,
    "cidade": "Autazes"
  },
  {
    "prefixo": "69245",
    "uf": "AM",
    "codigoIbge": 1300300,
    "cidade": "Autazes"
  },
  {
    "prefixo": "69249",
    "uf": "AM",
    "codigoIbge": 1300300,
    "cidade": "Autazes"
  },
  {
    "prefixo": "69250",
    "uf": "AM",
    "codigoIbge": 1301100,
    "cidade": "Careiro"
  },
  {
    "prefixo": "69254",
    "uf": "AM",
    "codigoIbge": 1301100,
    "cidade": "Careiro"
  },
  {
    "prefixo": "69255",
    "uf": "AM",
    "codigoIbge": 1301159,
    "cidade": "Careiro da Várzea"
  },
  {
    "prefixo": "69260",
    "uf": "AM",
    "codigoIbge": 1303304,
    "cidade": "Novo Aripuanã"
  },
  {
    "prefixo": "69265",
    "uf": "AM",
    "codigoIbge": 1300144,
    "cidade": "Apuí"
  },
  {
    "prefixo": "69280",
    "uf": "AM",
    "codigoIbge": 1302702,
    "cidade": "Manicoré"
  },
  {
    "prefixo": "69299",
    "uf": "AM",
    "codigoIbge": 1302702,
    "cidade": "Manicoré"
  },
  {
    "prefixo": "69300",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69301",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69303",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69304",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69305",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69306",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69307",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69308",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69309",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69310",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69311",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69312",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69313",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69314",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69315",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69316",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69317",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69318",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69339",
    "uf": "RR",
    "codigoIbge": 1400100,
    "cidade": "Boa Vista"
  },
  {
    "prefixo": "69340",
    "uf": "RR",
    "codigoIbge": 1400308,
    "cidade": "Mucajaí"
  },
  {
    "prefixo": "69342",
    "uf": "RR",
    "codigoIbge": 1400308,
    "cidade": "Mucajaí"
  },
  {
    "prefixo": "69343",
    "uf": "RR",
    "codigoIbge": 1400027,
    "cidade": "Amajari"
  },
  {
    "prefixo": "69344",
    "uf": "RR",
    "codigoIbge": 1400027,
    "cidade": "Amajari"
  },
  {
    "prefixo": "69345",
    "uf": "RR",
    "codigoIbge": 1400456,
    "cidade": "Pacaraima"
  },
  {
    "prefixo": "69348",
    "uf": "RR",
    "codigoIbge": 1400282,
    "cidade": "Iracema"
  },
  {
    "prefixo": "69349",
    "uf": "RR",
    "codigoIbge": 1400282,
    "cidade": "Iracema"
  },
  {
    "prefixo": "69350",
    "uf": "RR",
    "codigoIbge": 1400050,
    "cidade": "Alto Alegre"
  },
  {
    "prefixo": "69354",
    "uf": "RR",
    "codigoIbge": 1400050,
    "cidade": "Alto Alegre"
  },
  {
    "prefixo": "69355",
    "uf": "RR",
    "codigoIbge": 1400407,
    "cidade": "Normandia"
  },
  {
    "prefixo": "69358",
    "uf": "RR",
    "codigoIbge": 1400704,
    "cidade": "Uiramutã"
  },
  {
    "prefixo": "69360",
    "uf": "RR",
    "codigoIbge": 1400209,
    "cidade": "Caracaraí"
  },
  {
    "prefixo": "69365",
    "uf": "RR",
    "codigoIbge": 1400209,
    "cidade": "Caracaraí"
  },
  {
    "prefixo": "69369",
    "uf": "RR",
    "codigoIbge": 1400209,
    "cidade": "Caracaraí"
  },
  {
    "prefixo": "69370",
    "uf": "RR",
    "codigoIbge": 1400605,
    "cidade": "São Luiz do Anauá"
  },
  {
    "prefixo": "69373",
    "uf": "RR",
    "codigoIbge": 1400472,
    "cidade": "Rorainópolis"
  },
  {
    "prefixo": "69374",
    "uf": "RR",
    "codigoIbge": 1400472,
    "cidade": "Rorainópolis"
  },
  {
    "prefixo": "69375",
    "uf": "RR",
    "codigoIbge": 1400506,
    "cidade": "São João da Baliza"
  },
  {
    "prefixo": "69377",
    "uf": "RR",
    "codigoIbge": 1400506,
    "cidade": "São João da Baliza"
  },
  {
    "prefixo": "69378",
    "uf": "RR",
    "codigoIbge": 1400233,
    "cidade": "Caroebe"
  },
  {
    "prefixo": "69380",
    "uf": "RR",
    "codigoIbge": 1400159,
    "cidade": "Bonfim"
  },
  {
    "prefixo": "69390",
    "uf": "RR",
    "codigoIbge": 1400175,
    "cidade": "Cantá"
  },
  {
    "prefixo": "69395",
    "uf": "RR",
    "codigoIbge": 1400175,
    "cidade": "Cantá"
  },
  {
    "prefixo": "69399",
    "uf": "RR",
    "codigoIbge": 1400175,
    "cidade": "Cantá"
  },
  {
    "prefixo": "69400",
    "uf": "AM",
    "codigoIbge": 1302504,
    "cidade": "Manacapuru"
  },
  {
    "prefixo": "69401",
    "uf": "AM",
    "codigoIbge": 1302504,
    "cidade": "Manacapuru"
  },
  {
    "prefixo": "69402",
    "uf": "AM",
    "codigoIbge": 1302504,
    "cidade": "Manacapuru"
  },
  {
    "prefixo": "69403",
    "uf": "AM",
    "codigoIbge": 1302504,
    "cidade": "Manacapuru"
  },
  {
    "prefixo": "69409",
    "uf": "AM",
    "codigoIbge": 1302504,
    "cidade": "Manacapuru"
  },
  {
    "prefixo": "69414",
    "uf": "AM",
    "codigoIbge": 1302504,
    "cidade": "Manacapuru"
  },
  {
    "prefixo": "69415",
    "uf": "AM",
    "codigoIbge": 1301852,
    "cidade": "Iranduba"
  },
  {
    "prefixo": "69421",
    "uf": "AM",
    "codigoIbge": 1301852,
    "cidade": "Iranduba"
  },
  {
    "prefixo": "69422",
    "uf": "AM",
    "codigoIbge": 1301852,
    "cidade": "Iranduba"
  },
  {
    "prefixo": "69423",
    "uf": "AM",
    "codigoIbge": 1301852,
    "cidade": "Iranduba"
  },
  {
    "prefixo": "69424",
    "uf": "AM",
    "codigoIbge": 1301852,
    "cidade": "Iranduba"
  },
  {
    "prefixo": "69425",
    "uf": "AM",
    "codigoIbge": 1300839,
    "cidade": "Caapiranga"
  },
  {
    "prefixo": "69429",
    "uf": "AM",
    "codigoIbge": 1300839,
    "cidade": "Caapiranga"
  },
  {
    "prefixo": "69430",
    "uf": "AM",
    "codigoIbge": 1300631,
    "cidade": "Beruri"
  },
  {
    "prefixo": "69435",
    "uf": "AM",
    "codigoIbge": 1302553,
    "cidade": "Manaquiri"
  },
  {
    "prefixo": "69440",
    "uf": "AM",
    "codigoIbge": 1300102,
    "cidade": "Anori"
  },
  {
    "prefixo": "69445",
    "uf": "AM",
    "codigoIbge": 1300086,
    "cidade": "Anamã"
  },
  {
    "prefixo": "69450",
    "uf": "AM",
    "codigoIbge": 1301308,
    "cidade": "Codajás"
  },
  {
    "prefixo": "69452",
    "uf": "AM",
    "codigoIbge": 1301308,
    "cidade": "Codajás"
  },
  {
    "prefixo": "69460",
    "uf": "AM",
    "codigoIbge": 1301209,
    "cidade": "Coari"
  },
  {
    "prefixo": "69480",
    "uf": "AM",
    "codigoIbge": 1304104,
    "cidade": "Tapauá"
  },
  {
    "prefixo": "69484",
    "uf": "AM",
    "codigoIbge": 1304104,
    "cidade": "Tapauá"
  },
  {
    "prefixo": "69490",
    "uf": "AM",
    "codigoIbge": 1302801,
    "cidade": "Maraã"
  },
  {
    "prefixo": "69495",
    "uf": "AM",
    "codigoIbge": 1302108,
    "cidade": "Japurá"
  },
  {
    "prefixo": "69499",
    "uf": "AM",
    "codigoIbge": 1302108,
    "cidade": "Japurá"
  },
  {
    "prefixo": "69500",
    "uf": "AM",
    "codigoIbge": 1301001,
    "cidade": "Carauari"
  },
  {
    "prefixo": "69510",
    "uf": "AM",
    "codigoIbge": 1301951,
    "cidade": "Itamarati"
  },
  {
    "prefixo": "69520",
    "uf": "AM",
    "codigoIbge": 1302207,
    "cidade": "Juruá"
  },
  {
    "prefixo": "69530",
    "uf": "AM",
    "codigoIbge": 1304260,
    "cidade": "Uarini"
  },
  {
    "prefixo": "69540",
    "uf": "AM",
    "codigoIbge": 1300029,
    "cidade": "Alvarães"
  },
  {
    "prefixo": "69550",
    "uf": "AM",
    "codigoIbge": 1304203,
    "cidade": "Tefé"
  },
  {
    "prefixo": "69552",
    "uf": "AM",
    "codigoIbge": 1304203,
    "cidade": "Tefé"
  },
  {
    "prefixo": "69553",
    "uf": "AM",
    "codigoIbge": 1304203,
    "cidade": "Tefé"
  },
  {
    "prefixo": "69555",
    "uf": "AM",
    "codigoIbge": 1304203,
    "cidade": "Tefé"
  },
  {
    "prefixo": "69557",
    "uf": "AM",
    "codigoIbge": 1304203,
    "cidade": "Tefé"
  },
  {
    "prefixo": "69558",
    "uf": "AM",
    "codigoIbge": 1304203,
    "cidade": "Tefé"
  },
  {
    "prefixo": "69600",
    "uf": "AM",
    "codigoIbge": 1303908,
    "cidade": "São Paulo de Olivença"
  },
  {
    "prefixo": "69610",
    "uf": "AM",
    "codigoIbge": 1303908,
    "cidade": "São Paulo de Olivença"
  },
  {
    "prefixo": "69620",
    "uf": "AM",
    "codigoIbge": 1300060,
    "cidade": "Amaturá"
  },
  {
    "prefixo": "69630",
    "uf": "AM",
    "codigoIbge": 1300607,
    "cidade": "Benjamin Constant"
  },
  {
    "prefixo": "69639",
    "uf": "AM",
    "codigoIbge": 1300607,
    "cidade": "Benjamin Constant"
  },
  {
    "prefixo": "69640",
    "uf": "AM",
    "codigoIbge": 1304062,
    "cidade": "Tabatinga"
  },
  {
    "prefixo": "69649",
    "uf": "AM",
    "codigoIbge": 1304062,
    "cidade": "Tabatinga"
  },
  {
    "prefixo": "69650",
    "uf": "AM",
    "codigoIbge": 1300201,
    "cidade": "Atalaia do Norte"
  },
  {
    "prefixo": "69659",
    "uf": "AM",
    "codigoIbge": 1300201,
    "cidade": "Atalaia do Norte"
  },
  {
    "prefixo": "69660",
    "uf": "AM",
    "codigoIbge": 1302306,
    "cidade": "Jutaí"
  },
  {
    "prefixo": "69670",
    "uf": "AM",
    "codigoIbge": 1301605,
    "cidade": "Fonte Boa"
  },
  {
    "prefixo": "69680",
    "uf": "AM",
    "codigoIbge": 1303700,
    "cidade": "Santo Antônio do Içá"
  },
  {
    "prefixo": "69685",
    "uf": "AM",
    "codigoIbge": 1304237,
    "cidade": "Tonantins"
  },
  {
    "prefixo": "69700",
    "uf": "AM",
    "codigoIbge": 1300409,
    "cidade": "Barcelos"
  },
  {
    "prefixo": "69720",
    "uf": "AM",
    "codigoIbge": 1300409,
    "cidade": "Barcelos"
  },
  {
    "prefixo": "69729",
    "uf": "AM",
    "codigoIbge": 1300409,
    "cidade": "Barcelos"
  },
  {
    "prefixo": "69730",
    "uf": "AM",
    "codigoIbge": 1303205,
    "cidade": "Novo Airão"
  },
  {
    "prefixo": "69735",
    "uf": "AM",
    "codigoIbge": 1303536,
    "cidade": "Presidente Figueiredo"
  },
  {
    "prefixo": "69736",
    "uf": "AM",
    "codigoIbge": 1303536,
    "cidade": "Presidente Figueiredo"
  },
  {
    "prefixo": "69737",
    "uf": "AM",
    "codigoIbge": 1303536,
    "cidade": "Presidente Figueiredo"
  },
  {
    "prefixo": "69739",
    "uf": "AM",
    "codigoIbge": 1303536,
    "cidade": "Presidente Figueiredo"
  },
  {
    "prefixo": "69740",
    "uf": "AM",
    "codigoIbge": 1303601,
    "cidade": "Santa Isabel do Rio Negro"
  },
  {
    "prefixo": "69749",
    "uf": "AM",
    "codigoIbge": 1303601,
    "cidade": "Santa Isabel do Rio Negro"
  },
  {
    "prefixo": "69750",
    "uf": "AM",
    "codigoIbge": 1303809,
    "cidade": "São Gabriel da Cachoeira"
  },
  {
    "prefixo": "69752",
    "uf": "AM",
    "codigoIbge": 1303809,
    "cidade": "São Gabriel da Cachoeira"
  },
  {
    "prefixo": "69765",
    "uf": "AM",
    "codigoIbge": 1303809,
    "cidade": "São Gabriel da Cachoeira"
  },
  {
    "prefixo": "69790",
    "uf": "AM",
    "codigoIbge": 1303809,
    "cidade": "São Gabriel da Cachoeira"
  },
  {
    "prefixo": "69799",
    "uf": "AM",
    "codigoIbge": 1303809,
    "cidade": "São Gabriel da Cachoeira"
  },
  {
    "prefixo": "69800",
    "uf": "AM",
    "codigoIbge": 1301704,
    "cidade": "Humaitá"
  },
  {
    "prefixo": "69819",
    "uf": "AM",
    "codigoIbge": 1301704,
    "cidade": "Humaitá"
  },
  {
    "prefixo": "69820",
    "uf": "AM",
    "codigoIbge": 1300904,
    "cidade": "Canutama"
  },
  {
    "prefixo": "69829",
    "uf": "AM",
    "codigoIbge": 1300904,
    "cidade": "Canutama"
  },
  {
    "prefixo": "69830",
    "uf": "AM",
    "codigoIbge": 1302405,
    "cidade": "Lábrea"
  },
  {
    "prefixo": "69849",
    "uf": "AM",
    "codigoIbge": 1302405,
    "cidade": "Lábrea"
  },
  {
    "prefixo": "69850",
    "uf": "AM",
    "codigoIbge": 1300706,
    "cidade": "Boca do Acre"
  },
  {
    "prefixo": "69855",
    "uf": "AM",
    "codigoIbge": 1300706,
    "cidade": "Boca do Acre"
  },
  {
    "prefixo": "69859",
    "uf": "AM",
    "codigoIbge": 1300706,
    "cidade": "Boca do Acre"
  },
  {
    "prefixo": "69860",
    "uf": "AM",
    "codigoIbge": 1303502,
    "cidade": "Pauini"
  },
  {
    "prefixo": "69870",
    "uf": "AM",
    "codigoIbge": 1301506,
    "cidade": "Envira"
  },
  {
    "prefixo": "69880",
    "uf": "AM",
    "codigoIbge": 1301407,
    "cidade": "Eirunepé"
  },
  {
    "prefixo": "69890",
    "uf": "AM",
    "codigoIbge": 1301803,
    "cidade": "Ipixuna"
  },
  {
    "prefixo": "69895",
    "uf": "AM",
    "codigoIbge": 1301654,
    "cidade": "Guajará"
  },
  {
    "prefixo": "69900",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69901",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69902",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69903",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69905",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69906",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69907",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69908",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69909",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69911",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69912",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69914",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69915",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69917",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69918",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69919",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69920",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69921",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69922",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69923",
    "uf": "AC",
    "codigoIbge": 1200401,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "69925",
    "uf": "AC",
    "codigoIbge": 1200450,
    "cidade": "Senador Guiomard"
  },
  {
    "prefixo": "69926",
    "uf": "AC",
    "codigoIbge": 1200138,
    "cidade": "Bujari"
  },
  {
    "prefixo": "69927",
    "uf": "AC",
    "codigoIbge": 1200807,
    "cidade": "Porto Acre"
  },
  {
    "prefixo": "69928",
    "uf": "AC",
    "codigoIbge": 1200385,
    "cidade": "Plácido de Castro"
  },
  {
    "prefixo": "69929",
    "uf": "AC",
    "codigoIbge": 1200385,
    "cidade": "Plácido de Castro"
  },
  {
    "prefixo": "69930",
    "uf": "AC",
    "codigoIbge": 1200708,
    "cidade": "Xapuri"
  },
  {
    "prefixo": "69931",
    "uf": "AC",
    "codigoIbge": 1200179,
    "cidade": "Capixaba"
  },
  {
    "prefixo": "69932",
    "uf": "AC",
    "codigoIbge": 1200104,
    "cidade": "Brasiléia"
  },
  {
    "prefixo": "69934",
    "uf": "AC",
    "codigoIbge": 1200252,
    "cidade": "Epitaciolândia"
  },
  {
    "prefixo": "69935",
    "uf": "AC",
    "codigoIbge": 1200054,
    "cidade": "Assis Brasil"
  },
  {
    "prefixo": "69939",
    "uf": "AC",
    "codigoIbge": 1200054,
    "cidade": "Assis Brasil"
  },
  {
    "prefixo": "69940",
    "uf": "AC",
    "codigoIbge": 1200500,
    "cidade": "Sena Madureira"
  },
  {
    "prefixo": "69945",
    "uf": "AC",
    "codigoIbge": 1200013,
    "cidade": "Acrelândia"
  },
  {
    "prefixo": "69950",
    "uf": "AC",
    "codigoIbge": 1200344,
    "cidade": "Manoel Urbano"
  },
  {
    "prefixo": "69955",
    "uf": "AC",
    "codigoIbge": 1200435,
    "cidade": "Santa Rosa do Purus"
  },
  {
    "prefixo": "69960",
    "uf": "AC",
    "codigoIbge": 1200302,
    "cidade": "Feijó"
  },
  {
    "prefixo": "69969",
    "uf": "AC",
    "codigoIbge": 1200302,
    "cidade": "Feijó"
  },
  {
    "prefixo": "69970",
    "uf": "AC",
    "codigoIbge": 1200609,
    "cidade": "Tarauacá"
  },
  {
    "prefixo": "69975",
    "uf": "AC",
    "codigoIbge": 1200328,
    "cidade": "Jordão"
  },
  {
    "prefixo": "69979",
    "uf": "AC",
    "codigoIbge": 1200328,
    "cidade": "Jordão"
  },
  {
    "prefixo": "69980",
    "uf": "AC",
    "codigoIbge": 1200203,
    "cidade": "Cruzeiro do Sul"
  },
  {
    "prefixo": "69982",
    "uf": "AC",
    "codigoIbge": 1200393,
    "cidade": "Porto Walter"
  },
  {
    "prefixo": "69983",
    "uf": "AC",
    "codigoIbge": 1200351,
    "cidade": "Marechal Thaumaturgo"
  },
  {
    "prefixo": "69985",
    "uf": "AC",
    "codigoIbge": 1200427,
    "cidade": "Rodrigues Alves"
  },
  {
    "prefixo": "69990",
    "uf": "AC",
    "codigoIbge": 1200336,
    "cidade": "Mâncio Lima"
  },
  {
    "prefixo": "70002",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70003",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70037",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70040",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70041",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70042",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70043",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70044",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70045",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70046",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70047",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70048",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70049",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70050",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70052",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70053",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70055",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70056",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70057",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70058",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70064",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70065",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70067",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70068",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70070",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70072",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70073",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70074",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70075",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70076",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70077",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70078",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70079",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70089",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70091",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70092",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70093",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70094",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70095",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70097",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70098",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70100",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70150",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70165",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70170",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70175",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70200",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70210",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70232",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70233",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70234",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70235",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70236",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70237",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70238",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70239",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70252",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70253",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70254",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70255",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70256",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70257",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70258",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70272",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70273",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70274",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70275",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70276",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70277",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70278",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70292",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70293",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70294",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70295",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70296",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70297",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70298",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70299",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70300",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70301",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70302",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70303",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70304",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70305",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70306",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70307",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70308",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70309",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70311",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70312",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70313",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70314",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70315",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70316",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70318",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70322",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70328",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70329",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70330",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70331",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70332",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70333",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70335",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70336",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70337",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70338",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70340",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70342",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70343",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70344",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70345",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70346",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70347",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70350",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70351",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70352",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70353",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70354",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70355",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70360",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70361",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70362",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70363",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70364",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70365",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70372",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70373",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70374",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70375",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70376",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70377",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70380",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70381",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70382",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70383",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70384",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70385",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70386",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70387",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70390",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70395",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70396",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70397",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70398",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70399",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70401",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70402",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70430",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70476",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70610",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70620",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70630",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70631",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70632",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70633",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70634",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70635",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70636",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70640",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70645",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70648",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70650",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70655",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70658",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70660",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70670",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70673",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70674",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70675",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70680",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70683",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70684",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70686",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70687",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70688",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70701",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70702",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70703",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70704",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70705",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70710",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70711",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70712",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70713",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70714",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70715",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70716",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70719",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70720",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70722",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70723",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70730",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70732",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70733",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70734",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70735",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70736",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70737",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70740",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70741",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70742",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70743",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70744",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70745",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70746",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70747",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70750",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70752",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70753",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70754",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70755",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70756",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70757",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70760",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70761",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70762",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70763",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70764",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70765",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70766",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70767",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70770",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70772",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70773",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70774",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70775",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70790",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70800",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70801",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70802",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70803",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70804",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70830",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70832",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70833",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70834",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70835",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70836",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70840",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70842",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70843",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70844",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70845",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70846",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70847",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70852",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70853",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70854",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70855",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70856",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70857",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70862",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70863",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70864",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70865",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70866",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70867",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70872",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70873",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70874",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70875",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70876",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70878",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70879",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70904",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70908",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70909",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "70910",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71009",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71010",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71015",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71020",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71025",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71050",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71060",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71065",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71070",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71071",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71080",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71081",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71090",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71100",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71200",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71205",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71215",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71218",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71219",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71225",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71250",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71255",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71256",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71258",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71261",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71266",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71300",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71503",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71505",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71507",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71510",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71515",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71520",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71525",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71530",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71535",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71538",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71539",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71540",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71551",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71555",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71559",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71560",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71570",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71571",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71572",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71573",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71574",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71577",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71585",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71586",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71587",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71588",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71589",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71590",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71591",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71592",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71593",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71596",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71600",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71605",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71608",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71610",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71615",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71620",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71625",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71630",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71635",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71640",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71645",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71650",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71655",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71660",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71665",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71670",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71675",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71676",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71680",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71681",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71684",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71686",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71687",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71691",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71692",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71693",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71694",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71695",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71696",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71697",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71698",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71699",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71705",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71710",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71715",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71720",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71725",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71727",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71730",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71731",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71732",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71735",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71736",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71737",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71738",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71739",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71740",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71741",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71742",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71745",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71746",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71750",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71751",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71761",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71805",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71810",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71820",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71825",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71827",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71828",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71880",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71881",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71882",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71884",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71900",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71901",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71904",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71906",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71907",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71908",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71909",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71910",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71915",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71916",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71917",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71918",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71919",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71920",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71921",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71925",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71926",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71927",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71928",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71929",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71930",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71931",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71936",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71937",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71938",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71939",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71940",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71950",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71953",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71955",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71956",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71957",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71958",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71959",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71960",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71961",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71962",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71963",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71964",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71965",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71966",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71967",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71968",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71969",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71970",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71971",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71972",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71973",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71974",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71975",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71976",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71977",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71978",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71979",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71980",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71981",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71982",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71985",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71986",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71987",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71988",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71989",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71990",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71991",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71993",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71994",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71995",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "71996",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72001",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72002",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72003",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72004",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72005",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72006",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72007",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72008",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72010",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72011",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72015",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72016",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72017",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72019",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72020",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72023",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72025",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72035",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72110",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72115",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72118",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72120",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72121",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72125",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72127",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72130",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72135",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72140",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72145",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72146",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72150",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72151",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72152",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72153",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72155",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72156",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72158",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72160",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72161",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72162",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72199",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72210",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72215",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72220",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72225",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72227",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72230",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72231",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72233",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72235",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72236",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72237",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72238",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72240",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72241",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72242",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72243",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72246",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72250",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72251",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72252",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72255",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72260",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72261",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72262",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72265",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72268",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72270",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72275",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72276",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72280",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72299",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72300",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72301",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72302",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72303",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72304",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72305",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72306",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72307",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72308",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72309",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72310",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72311",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72312",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72313",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72314",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72315",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72316",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72317",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72318",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72319",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72320",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72321",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72322",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72323",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72325",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72327",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72329",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72331",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72333",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72335",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72338",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72339",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72341",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72343",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72345",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72399",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72404",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72405",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72410",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72415",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72420",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72425",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72426",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72427",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72428",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72429",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72430",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72440",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72444",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72445",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72450",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72455",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72457",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72460",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72465",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72492",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72499",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72500",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72501",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72502",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72503",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72504",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72505",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72506",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72507",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72508",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72509",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72510",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72511",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72535",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72536",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72542",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72543",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72544",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72545",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72546",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72547",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72548",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72549",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72550",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72551",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72578",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72579",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72580",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72581",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72583",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72584",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72587",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72592",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72593",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72594",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72595",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72597",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72599",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72600",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72601",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72602",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72603",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72604",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72610",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72620",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72621",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72622",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72625",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72630",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72631",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72640",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72641",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72649",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72650",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72660",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72667",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72668",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72669",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72699",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72701",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72705",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72710",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72715",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72720",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72725",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72726",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72733",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72734",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72735",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72736",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72737",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72738",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72745",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72746",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72747",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72748",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72755",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72760",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72770",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72771",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72772",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72773",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72799",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "72800",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72801",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72803",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72804",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72805",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72806",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72809",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72810",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72811",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72812",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72813",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72814",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72815",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72816",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72818",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72820",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72821",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72822",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72823",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72824",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72830",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72831",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72832",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72833",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72834",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72835",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72836",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72837",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72850",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72851",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72852",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72853",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72854",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72855",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72856",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72858",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72859",
    "uf": "GO",
    "codigoIbge": 5212501,
    "cidade": "Luziânia"
  },
  {
    "prefixo": "72860",
    "uf": "GO",
    "codigoIbge": 5215231,
    "cidade": "Novo Gama"
  },
  {
    "prefixo": "72861",
    "uf": "GO",
    "codigoIbge": 5215231,
    "cidade": "Novo Gama"
  },
  {
    "prefixo": "72862",
    "uf": "GO",
    "codigoIbge": 5215231,
    "cidade": "Novo Gama"
  },
  {
    "prefixo": "72863",
    "uf": "GO",
    "codigoIbge": 5215231,
    "cidade": "Novo Gama"
  },
  {
    "prefixo": "72865",
    "uf": "GO",
    "codigoIbge": 5215231,
    "cidade": "Novo Gama"
  },
  {
    "prefixo": "72866",
    "uf": "GO",
    "codigoIbge": 5215231,
    "cidade": "Novo Gama"
  },
  {
    "prefixo": "72867",
    "uf": "GO",
    "codigoIbge": 5215231,
    "cidade": "Novo Gama"
  },
  {
    "prefixo": "72869",
    "uf": "GO",
    "codigoIbge": 5215231,
    "cidade": "Novo Gama"
  },
  {
    "prefixo": "72870",
    "uf": "GO",
    "codigoIbge": 5221858,
    "cidade": "Valparaíso de Goiás"
  },
  {
    "prefixo": "72871",
    "uf": "GO",
    "codigoIbge": 5221858,
    "cidade": "Valparaíso de Goiás"
  },
  {
    "prefixo": "72872",
    "uf": "GO",
    "codigoIbge": 5221858,
    "cidade": "Valparaíso de Goiás"
  },
  {
    "prefixo": "72873",
    "uf": "GO",
    "codigoIbge": 5221858,
    "cidade": "Valparaíso de Goiás"
  },
  {
    "prefixo": "72874",
    "uf": "GO",
    "codigoIbge": 5221858,
    "cidade": "Valparaíso de Goiás"
  },
  {
    "prefixo": "72875",
    "uf": "GO",
    "codigoIbge": 5221858,
    "cidade": "Valparaíso de Goiás"
  },
  {
    "prefixo": "72876",
    "uf": "GO",
    "codigoIbge": 5221858,
    "cidade": "Valparaíso de Goiás"
  },
  {
    "prefixo": "72878",
    "uf": "GO",
    "codigoIbge": 5221858,
    "cidade": "Valparaíso de Goiás"
  },
  {
    "prefixo": "72879",
    "uf": "GO",
    "codigoIbge": 5221858,
    "cidade": "Valparaíso de Goiás"
  },
  {
    "prefixo": "72880",
    "uf": "GO",
    "codigoIbge": 5205497,
    "cidade": "Cidade Ocidental"
  },
  {
    "prefixo": "72883",
    "uf": "GO",
    "codigoIbge": 5205497,
    "cidade": "Cidade Ocidental"
  },
  {
    "prefixo": "72885",
    "uf": "GO",
    "codigoIbge": 5205497,
    "cidade": "Cidade Ocidental"
  },
  {
    "prefixo": "72887",
    "uf": "GO",
    "codigoIbge": 5205497,
    "cidade": "Cidade Ocidental"
  },
  {
    "prefixo": "72890",
    "uf": "GO",
    "codigoIbge": 5205497,
    "cidade": "Cidade Ocidental"
  },
  {
    "prefixo": "72895",
    "uf": "GO",
    "codigoIbge": 5205497,
    "cidade": "Cidade Ocidental"
  },
  {
    "prefixo": "72896",
    "uf": "GO",
    "codigoIbge": 5205497,
    "cidade": "Cidade Ocidental"
  },
  {
    "prefixo": "72897",
    "uf": "GO",
    "codigoIbge": 5205497,
    "cidade": "Cidade Ocidental"
  },
  {
    "prefixo": "72898",
    "uf": "GO",
    "codigoIbge": 5205497,
    "cidade": "Cidade Ocidental"
  },
  {
    "prefixo": "72899",
    "uf": "GO",
    "codigoIbge": 5205497,
    "cidade": "Cidade Ocidental"
  },
  {
    "prefixo": "72900",
    "uf": "GO",
    "codigoIbge": 5219753,
    "cidade": "Santo Antônio do Descoberto"
  },
  {
    "prefixo": "72901",
    "uf": "GO",
    "codigoIbge": 5219753,
    "cidade": "Santo Antônio do Descoberto"
  },
  {
    "prefixo": "72902",
    "uf": "GO",
    "codigoIbge": 5219753,
    "cidade": "Santo Antônio do Descoberto"
  },
  {
    "prefixo": "72903",
    "uf": "GO",
    "codigoIbge": 5219753,
    "cidade": "Santo Antônio do Descoberto"
  },
  {
    "prefixo": "72904",
    "uf": "GO",
    "codigoIbge": 5219753,
    "cidade": "Santo Antônio do Descoberto"
  },
  {
    "prefixo": "72906",
    "uf": "GO",
    "codigoIbge": 5219753,
    "cidade": "Santo Antônio do Descoberto"
  },
  {
    "prefixo": "72907",
    "uf": "GO",
    "codigoIbge": 5219753,
    "cidade": "Santo Antônio do Descoberto"
  },
  {
    "prefixo": "72908",
    "uf": "GO",
    "codigoIbge": 5219753,
    "cidade": "Santo Antônio do Descoberto"
  },
  {
    "prefixo": "72909",
    "uf": "GO",
    "codigoIbge": 5219753,
    "cidade": "Santo Antônio do Descoberto"
  },
  {
    "prefixo": "72910",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72911",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72912",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72914",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72915",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72916",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72917",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72920",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72921",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72922",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72923",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72925",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72926",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72927",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72928",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72929",
    "uf": "GO",
    "codigoIbge": 5200258,
    "cidade": "Águas Lindas de Goiás"
  },
  {
    "prefixo": "72930",
    "uf": "GO",
    "codigoIbge": 5200308,
    "cidade": "Alexânia"
  },
  {
    "prefixo": "72935",
    "uf": "GO",
    "codigoIbge": 5200308,
    "cidade": "Alexânia"
  },
  {
    "prefixo": "72940",
    "uf": "GO",
    "codigoIbge": 5200100,
    "cidade": "Abadiânia"
  },
  {
    "prefixo": "72944",
    "uf": "GO",
    "codigoIbge": 5200100,
    "cidade": "Abadiânia"
  },
  {
    "prefixo": "72950",
    "uf": "GO",
    "codigoIbge": 5200100,
    "cidade": "Abadiânia"
  },
  {
    "prefixo": "72960",
    "uf": "GO",
    "codigoIbge": 5205802,
    "cidade": "Corumbá de Goiás"
  },
  {
    "prefixo": "72975",
    "uf": "GO",
    "codigoIbge": 5205513,
    "cidade": "Cocalzinho de Goiás"
  },
  {
    "prefixo": "72978",
    "uf": "GO",
    "codigoIbge": 5205513,
    "cidade": "Cocalzinho de Goiás"
  },
  {
    "prefixo": "72979",
    "uf": "GO",
    "codigoIbge": 5205513,
    "cidade": "Cocalzinho de Goiás"
  },
  {
    "prefixo": "72980",
    "uf": "GO",
    "codigoIbge": 5217302,
    "cidade": "Pirenópolis"
  },
  {
    "prefixo": "72982",
    "uf": "GO",
    "codigoIbge": 5217302,
    "cidade": "Pirenópolis"
  },
  {
    "prefixo": "72984",
    "uf": "GO",
    "codigoIbge": 5217302,
    "cidade": "Pirenópolis"
  },
  {
    "prefixo": "72986",
    "uf": "GO",
    "codigoIbge": 5217302,
    "cidade": "Pirenópolis"
  },
  {
    "prefixo": "73005",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73006",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73007",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73010",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73011",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73015",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73017",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73020",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73021",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73025",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73026",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73030",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73031",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73035",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73036",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73040",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73041",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73045",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73046",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73050",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73051",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73053",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73060",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73061",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73062",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73063",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73064",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73065",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73070",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73080",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73081",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73082",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73083",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73084",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73086",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73088",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73090",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73091",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73092",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73093",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73100",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73105",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73130",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73131",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73150",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73151",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73250",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73251",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73252",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73255",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73270",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73271",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73272",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73299",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73307",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73310",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73320",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73330",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73340",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73342",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73343",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73350",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73355",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73356",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73357",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73358",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73360",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73365",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73366",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73367",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73368",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73369",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73370",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73375",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73376",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73377",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73380",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73381",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73389",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73390",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73391",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73401",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73402",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73403",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73499",
    "uf": "DF",
    "codigoIbge": 5300108,
    "cidade": "Brasília"
  },
  {
    "prefixo": "73700",
    "uf": "GO",
    "codigoIbge": 5215603,
    "cidade": "Padre Bernardo"
  },
  {
    "prefixo": "73720",
    "uf": "GO",
    "codigoIbge": 5215603,
    "cidade": "Padre Bernardo"
  },
  {
    "prefixo": "73730",
    "uf": "GO",
    "codigoIbge": 5213053,
    "cidade": "Mimoso de Goiás"
  },
  {
    "prefixo": "73740",
    "uf": "GO",
    "codigoIbge": 5205521,
    "cidade": "Colinas do Sul"
  },
  {
    "prefixo": "73750",
    "uf": "GO",
    "codigoIbge": 5217609,
    "cidade": "Planaltina"
  },
  {
    "prefixo": "73751",
    "uf": "GO",
    "codigoIbge": 5217609,
    "cidade": "Planaltina"
  },
  {
    "prefixo": "73752",
    "uf": "GO",
    "codigoIbge": 5217609,
    "cidade": "Planaltina"
  },
  {
    "prefixo": "73753",
    "uf": "GO",
    "codigoIbge": 5217609,
    "cidade": "Planaltina"
  },
  {
    "prefixo": "73754",
    "uf": "GO",
    "codigoIbge": 5217609,
    "cidade": "Planaltina"
  },
  {
    "prefixo": "73755",
    "uf": "GO",
    "codigoIbge": 5217609,
    "cidade": "Planaltina"
  },
  {
    "prefixo": "73756",
    "uf": "GO",
    "codigoIbge": 5217609,
    "cidade": "Planaltina"
  },
  {
    "prefixo": "73757",
    "uf": "GO",
    "codigoIbge": 5217609,
    "cidade": "Planaltina"
  },
  {
    "prefixo": "73758",
    "uf": "GO",
    "codigoIbge": 5217609,
    "cidade": "Planaltina"
  },
  {
    "prefixo": "73759",
    "uf": "GO",
    "codigoIbge": 5217609,
    "cidade": "Planaltina"
  },
  {
    "prefixo": "73760",
    "uf": "GO",
    "codigoIbge": 5220009,
    "cidade": "São João d'Aliança"
  },
  {
    "prefixo": "73764",
    "uf": "GO",
    "codigoIbge": 5220009,
    "cidade": "São João d'Aliança"
  },
  {
    "prefixo": "73770",
    "uf": "GO",
    "codigoIbge": 5200605,
    "cidade": "Alto Paraíso de Goiás"
  },
  {
    "prefixo": "73778",
    "uf": "GO",
    "codigoIbge": 5200605,
    "cidade": "Alto Paraíso de Goiás"
  },
  {
    "prefixo": "73780",
    "uf": "GO",
    "codigoIbge": 5200175,
    "cidade": "Água Fria de Goiás"
  },
  {
    "prefixo": "73790",
    "uf": "GO",
    "codigoIbge": 5205307,
    "cidade": "Cavalcante"
  },
  {
    "prefixo": "73795",
    "uf": "GO",
    "codigoIbge": 5221080,
    "cidade": "Teresina de Goiás"
  },
  {
    "prefixo": "73801",
    "uf": "GO",
    "codigoIbge": 5208004,
    "cidade": "Formosa"
  },
  {
    "prefixo": "73802",
    "uf": "GO",
    "codigoIbge": 5208004,
    "cidade": "Formosa"
  },
  {
    "prefixo": "73803",
    "uf": "GO",
    "codigoIbge": 5208004,
    "cidade": "Formosa"
  },
  {
    "prefixo": "73804",
    "uf": "GO",
    "codigoIbge": 5208004,
    "cidade": "Formosa"
  },
  {
    "prefixo": "73805",
    "uf": "GO",
    "codigoIbge": 5208004,
    "cidade": "Formosa"
  },
  {
    "prefixo": "73807",
    "uf": "GO",
    "codigoIbge": 5208004,
    "cidade": "Formosa"
  },
  {
    "prefixo": "73808",
    "uf": "GO",
    "codigoIbge": 5208004,
    "cidade": "Formosa"
  },
  {
    "prefixo": "73809",
    "uf": "GO",
    "codigoIbge": 5208004,
    "cidade": "Formosa"
  },
  {
    "prefixo": "73813",
    "uf": "GO",
    "codigoIbge": 5208004,
    "cidade": "Formosa"
  },
  {
    "prefixo": "73814",
    "uf": "GO",
    "codigoIbge": 5208004,
    "cidade": "Formosa"
  },
  {
    "prefixo": "73815",
    "uf": "GO",
    "codigoIbge": 5208004,
    "cidade": "Formosa"
  },
  {
    "prefixo": "73816",
    "uf": "GO",
    "codigoIbge": 5208004,
    "cidade": "Formosa"
  },
  {
    "prefixo": "73817",
    "uf": "GO",
    "codigoIbge": 5208004,
    "cidade": "Formosa"
  },
  {
    "prefixo": "73818",
    "uf": "GO",
    "codigoIbge": 5208004,
    "cidade": "Formosa"
  },
  {
    "prefixo": "73819",
    "uf": "GO",
    "codigoIbge": 5208004,
    "cidade": "Formosa"
  },
  {
    "prefixo": "73820",
    "uf": "GO",
    "codigoIbge": 5214903,
    "cidade": "Nova Roma"
  },
  {
    "prefixo": "73825",
    "uf": "GO",
    "codigoIbge": 5222203,
    "cidade": "Vila Boa"
  },
  {
    "prefixo": "73830",
    "uf": "GO",
    "codigoIbge": 5213509,
    "cidade": "Monte Alegre de Goiás"
  },
  {
    "prefixo": "73838",
    "uf": "GO",
    "codigoIbge": 5213509,
    "cidade": "Monte Alegre de Goiás"
  },
  {
    "prefixo": "73840",
    "uf": "GO",
    "codigoIbge": 5204904,
    "cidade": "Campos Belos"
  },
  {
    "prefixo": "73850",
    "uf": "GO",
    "codigoIbge": 5206206,
    "cidade": "Cristalina"
  },
  {
    "prefixo": "73858",
    "uf": "GO",
    "codigoIbge": 5206206,
    "cidade": "Cristalina"
  },
  {
    "prefixo": "73860",
    "uf": "GO",
    "codigoIbge": 5219803,
    "cidade": "São Domingos"
  },
  {
    "prefixo": "73865",
    "uf": "GO",
    "codigoIbge": 5208301,
    "cidade": "Divinópolis de Goiás"
  },
  {
    "prefixo": "73869",
    "uf": "GO",
    "codigoIbge": 5208301,
    "cidade": "Divinópolis de Goiás"
  },
  {
    "prefixo": "73870",
    "uf": "GO",
    "codigoIbge": 5204003,
    "cidade": "Cabeceiras"
  },
  {
    "prefixo": "73890",
    "uf": "GO",
    "codigoIbge": 5207907,
    "cidade": "Flores de Goiás"
  },
  {
    "prefixo": "73900",
    "uf": "GO",
    "codigoIbge": 5218300,
    "cidade": "Posse"
  },
  {
    "prefixo": "73902",
    "uf": "GO",
    "codigoIbge": 5218300,
    "cidade": "Posse"
  },
  {
    "prefixo": "73904",
    "uf": "GO",
    "codigoIbge": 5218300,
    "cidade": "Posse"
  },
  {
    "prefixo": "73906",
    "uf": "GO",
    "codigoIbge": 5218300,
    "cidade": "Posse"
  },
  {
    "prefixo": "73910",
    "uf": "GO",
    "codigoIbge": 5209408,
    "cidade": "Guarani de Goiás"
  },
  {
    "prefixo": "73920",
    "uf": "GO",
    "codigoIbge": 5209903,
    "cidade": "Iaciara"
  },
  {
    "prefixo": "73928",
    "uf": "GO",
    "codigoIbge": 5209903,
    "cidade": "Iaciara"
  },
  {
    "prefixo": "73930",
    "uf": "GO",
    "codigoIbge": 5220686,
    "cidade": "Simolândia"
  },
  {
    "prefixo": "73950",
    "uf": "GO",
    "codigoIbge": 5200803,
    "cidade": "Alvorada do Norte"
  },
  {
    "prefixo": "73970",
    "uf": "GO",
    "codigoIbge": 5212709,
    "cidade": "Mambaí"
  },
  {
    "prefixo": "73975",
    "uf": "GO",
    "codigoIbge": 5203962,
    "cidade": "Buritinópolis"
  },
  {
    "prefixo": "73980",
    "uf": "GO",
    "codigoIbge": 5206701,
    "cidade": "Damianópolis"
  },
  {
    "prefixo": "73990",
    "uf": "GO",
    "codigoIbge": 5220702,
    "cidade": "Sítio d'Abadia"
  },
  {
    "prefixo": "74001",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74003",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74005",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74010",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74013",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74015",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74020",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74023",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74025",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74030",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74040",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74043",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74045",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74050",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74053",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74055",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74063",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74070",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74075",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74080",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74083",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74085",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74093",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74110",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74115",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74120",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74125",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74130",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74140",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74150",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74160",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74170",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74175",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74180",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74210",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74215",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74223",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74230",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74250",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74255",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74265",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74268",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74270",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74275",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74280",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74290",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74303",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74305",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74310",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74313",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74315",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74320",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74323",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74325",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74330",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74333",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74335",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74340",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74343",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74345",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74350",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74351",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74353",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74354",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74355",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74356",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74357",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74358",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74360",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74363",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74365",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74366",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74367",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74369",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74370",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74371",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74372",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74373",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74375",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74376",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74377",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74390",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74391",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74392",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74393",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74394",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74395",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74396",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74403",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74405",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74410",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74413",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74415",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74420",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74423",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74425",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74430",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74433",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74435",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74440",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74445",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74450",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74453",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74455",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74460",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74461",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74463",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74464",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74465",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74470",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74471",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74473",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74474",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74475",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74476",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74477",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74480",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74481",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74482",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74483",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74484",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74485",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74486",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74487",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74490",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74491",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74492",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74493",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74494",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74495",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74496",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74497",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74503",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74505",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74510",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74513",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74515",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74520",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74523",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74525",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74530",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74533",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74535",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74543",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74550",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74553",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74554",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74555",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74560",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74563",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74565",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74573",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74574",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74575",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74580",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74581",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74583",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74584",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74590",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74591",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74593",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74594",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74595",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74603",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74605",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74610",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74611",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74615",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74620",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74630",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74633",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74635",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74640",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74643",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74645",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74650",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74653",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74655",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74660",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74663",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74665",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74666",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74670",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74672",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74673",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74674",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74675",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74680",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74681",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74682",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74683",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74684",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74685",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74686",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74690",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74691",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74692",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74693",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74694",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74697",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74703",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74705",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74710",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74711",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74713",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74715",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74716",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74720",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74723",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74730",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74735",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74736",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74740",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74765",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74766",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74767",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74769",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74770",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74771",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74775",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74779",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74780",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74781",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74783",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74785",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74786",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74787",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74805",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74810",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74815",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74817",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74820",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74823",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74825",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74830",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74835",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74840",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74843",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74844",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74845",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74850",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74853",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74855",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74860",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74863",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74865",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74866",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74870",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74883",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74884",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74885",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74886",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74888",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74890",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74891",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74893",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74899",
    "uf": "GO",
    "codigoIbge": 5208707,
    "cidade": "Goiânia"
  },
  {
    "prefixo": "74905",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74910",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74911",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74912",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74913",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74914",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74915",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74916",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74917",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74918",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74919",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74920",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74921",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74922",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74923",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74924",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74925",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74926",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74927",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74930",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74932",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74933",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74934",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74935",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74936",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74937",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74938",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74940",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74942",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74943",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74944",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74945",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74946",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74947",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74948",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74950",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74952",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74953",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74954",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74955",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74956",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74957",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74958",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74959",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74960",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74961",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74962",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74963",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74964",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74965",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74966",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74967",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74968",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74969",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74970",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74971",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74973",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74974",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74975",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74976",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74980",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74981",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74982",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74983",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74984",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74985",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74986",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74987",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74988",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74989",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74990",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74992",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74993",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "74999",
    "uf": "GO",
    "codigoIbge": 5201405,
    "cidade": "Aparecida de Goiânia"
  },
  {
    "prefixo": "75020",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75023",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75024",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75025",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75040",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75043",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75044",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75045",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75050",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75053",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75054",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75056",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75060",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75063",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75064",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75065",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75066",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75070",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75071",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75072",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75073",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75074",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75075",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75076",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75080",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75083",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75084",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75085",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75086",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75090",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75091",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75093",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75094",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75095",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75096",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75097",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75100",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75101",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75102",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75103",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75104",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75105",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75106",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75109",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75110",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75113",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75114",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75115",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75120",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75123",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75124",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75125",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75126",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75130",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75131",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75132",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75133",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75134",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75135",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75136",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75140",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75143",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75144",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75145",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75148",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75149",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75151",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75152",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75154",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75157",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75158",
    "uf": "GO",
    "codigoIbge": 5201108,
    "cidade": "Anápolis"
  },
  {
    "prefixo": "75160",
    "uf": "GO",
    "codigoIbge": 5204854,
    "cidade": "Campo Limpo de Goiás"
  },
  {
    "prefixo": "75165",
    "uf": "GO",
    "codigoIbge": 5215405,
    "cidade": "Ouro Verde de Goiás"
  },
  {
    "prefixo": "75169",
    "uf": "GO",
    "codigoIbge": 5215405,
    "cidade": "Ouro Verde de Goiás"
  },
  {
    "prefixo": "75170",
    "uf": "GO",
    "codigoIbge": 5208400,
    "cidade": "Goianápolis"
  },
  {
    "prefixo": "75174",
    "uf": "GO",
    "codigoIbge": 5208400,
    "cidade": "Goianápolis"
  },
  {
    "prefixo": "75175",
    "uf": "GO",
    "codigoIbge": 5221197,
    "cidade": "Terezópolis de Goiás"
  },
  {
    "prefixo": "75180",
    "uf": "GO",
    "codigoIbge": 5220603,
    "cidade": "Silvânia"
  },
  {
    "prefixo": "75183",
    "uf": "GO",
    "codigoIbge": 5220603,
    "cidade": "Silvânia"
  },
  {
    "prefixo": "75184",
    "uf": "GO",
    "codigoIbge": 5208152,
    "cidade": "Gameleira de Goiás"
  },
  {
    "prefixo": "75185",
    "uf": "GO",
    "codigoIbge": 5220264,
    "cidade": "São Miguel do Passa Quatro"
  },
  {
    "prefixo": "75190",
    "uf": "GO",
    "codigoIbge": 5212303,
    "cidade": "Leopoldo de Bulhões"
  },
  {
    "prefixo": "75194",
    "uf": "GO",
    "codigoIbge": 5212303,
    "cidade": "Leopoldo de Bulhões"
  },
  {
    "prefixo": "75195",
    "uf": "GO",
    "codigoIbge": 5203559,
    "cidade": "Bonfinópolis"
  },
  {
    "prefixo": "75200",
    "uf": "GO",
    "codigoIbge": 5217401,
    "cidade": "Pires do Rio"
  },
  {
    "prefixo": "75210",
    "uf": "GO",
    "codigoIbge": 5215801,
    "cidade": "Palmelo"
  },
  {
    "prefixo": "75220",
    "uf": "GO",
    "codigoIbge": 5219209,
    "cidade": "Santa Cruz de Goiás"
  },
  {
    "prefixo": "75229",
    "uf": "GO",
    "codigoIbge": 5219209,
    "cidade": "Santa Cruz de Goiás"
  },
  {
    "prefixo": "75230",
    "uf": "GO",
    "codigoIbge": 5206305,
    "cidade": "Cristianópolis"
  },
  {
    "prefixo": "75240",
    "uf": "GO",
    "codigoIbge": 5203302,
    "cidade": "Bela Vista de Goiás"
  },
  {
    "prefixo": "75244",
    "uf": "GO",
    "codigoIbge": 5203302,
    "cidade": "Bela Vista de Goiás"
  },
  {
    "prefixo": "75245",
    "uf": "GO",
    "codigoIbge": 5204557,
    "cidade": "Caldazinha"
  },
  {
    "prefixo": "75249",
    "uf": "GO",
    "codigoIbge": 5204557,
    "cidade": "Caldazinha"
  },
  {
    "prefixo": "75250",
    "uf": "GO",
    "codigoIbge": 5220454,
    "cidade": "Senador Canedo"
  },
  {
    "prefixo": "75251",
    "uf": "GO",
    "codigoIbge": 5220454,
    "cidade": "Senador Canedo"
  },
  {
    "prefixo": "75252",
    "uf": "GO",
    "codigoIbge": 5220454,
    "cidade": "Senador Canedo"
  },
  {
    "prefixo": "75253",
    "uf": "GO",
    "codigoIbge": 5220454,
    "cidade": "Senador Canedo"
  },
  {
    "prefixo": "75254",
    "uf": "GO",
    "codigoIbge": 5220454,
    "cidade": "Senador Canedo"
  },
  {
    "prefixo": "75255",
    "uf": "GO",
    "codigoIbge": 5220454,
    "cidade": "Senador Canedo"
  },
  {
    "prefixo": "75256",
    "uf": "GO",
    "codigoIbge": 5220454,
    "cidade": "Senador Canedo"
  },
  {
    "prefixo": "75257",
    "uf": "GO",
    "codigoIbge": 5220454,
    "cidade": "Senador Canedo"
  },
  {
    "prefixo": "75258",
    "uf": "GO",
    "codigoIbge": 5220454,
    "cidade": "Senador Canedo"
  },
  {
    "prefixo": "75259",
    "uf": "GO",
    "codigoIbge": 5220454,
    "cidade": "Senador Canedo"
  },
  {
    "prefixo": "75260",
    "uf": "GO",
    "codigoIbge": 5220454,
    "cidade": "Senador Canedo"
  },
  {
    "prefixo": "75261",
    "uf": "GO",
    "codigoIbge": 5220454,
    "cidade": "Senador Canedo"
  },
  {
    "prefixo": "75262",
    "uf": "GO",
    "codigoIbge": 5220454,
    "cidade": "Senador Canedo"
  },
  {
    "prefixo": "75263",
    "uf": "GO",
    "codigoIbge": 5220454,
    "cidade": "Senador Canedo"
  },
  {
    "prefixo": "75264",
    "uf": "GO",
    "codigoIbge": 5220454,
    "cidade": "Senador Canedo"
  },
  {
    "prefixo": "75265",
    "uf": "GO",
    "codigoIbge": 5222005,
    "cidade": "Vianópolis"
  },
  {
    "prefixo": "75280",
    "uf": "GO",
    "codigoIbge": 5215306,
    "cidade": "Orizona"
  },
  {
    "prefixo": "75283",
    "uf": "GO",
    "codigoIbge": 5215306,
    "cidade": "Orizona"
  },
  {
    "prefixo": "75330",
    "uf": "GO",
    "codigoIbge": 5201801,
    "cidade": "Aragoiânia"
  },
  {
    "prefixo": "75340",
    "uf": "GO",
    "codigoIbge": 5209705,
    "cidade": "Hidrolândia"
  },
  {
    "prefixo": "75344",
    "uf": "GO",
    "codigoIbge": 5209705,
    "cidade": "Hidrolândia"
  },
  {
    "prefixo": "75345",
    "uf": "GO",
    "codigoIbge": 5200050,
    "cidade": "Abadia de Goiás"
  },
  {
    "prefixo": "75350",
    "uf": "GO",
    "codigoIbge": 5209200,
    "cidade": "Guapó"
  },
  {
    "prefixo": "75354",
    "uf": "GO",
    "codigoIbge": 5209200,
    "cidade": "Guapó"
  },
  {
    "prefixo": "75355",
    "uf": "GO",
    "codigoIbge": 5221908,
    "cidade": "Varjão"
  },
  {
    "prefixo": "75360",
    "uf": "GO",
    "codigoIbge": 5208806,
    "cidade": "Goianira"
  },
  {
    "prefixo": "75361",
    "uf": "GO",
    "codigoIbge": 5208806,
    "cidade": "Goianira"
  },
  {
    "prefixo": "75362",
    "uf": "GO",
    "codigoIbge": 5208806,
    "cidade": "Goianira"
  },
  {
    "prefixo": "75363",
    "uf": "GO",
    "codigoIbge": 5208806,
    "cidade": "Goianira"
  },
  {
    "prefixo": "75364",
    "uf": "GO",
    "codigoIbge": 5208806,
    "cidade": "Goianira"
  },
  {
    "prefixo": "75365",
    "uf": "GO",
    "codigoIbge": 5208806,
    "cidade": "Goianira"
  },
  {
    "prefixo": "75366",
    "uf": "GO",
    "codigoIbge": 5208806,
    "cidade": "Goianira"
  },
  {
    "prefixo": "75367",
    "uf": "GO",
    "codigoIbge": 5208806,
    "cidade": "Goianira"
  },
  {
    "prefixo": "75368",
    "uf": "GO",
    "codigoIbge": 5208806,
    "cidade": "Goianira"
  },
  {
    "prefixo": "75369",
    "uf": "GO",
    "codigoIbge": 5208806,
    "cidade": "Goianira"
  },
  {
    "prefixo": "75370",
    "uf": "GO",
    "codigoIbge": 5208806,
    "cidade": "Goianira"
  },
  {
    "prefixo": "75371",
    "uf": "GO",
    "codigoIbge": 5208806,
    "cidade": "Goianira"
  },
  {
    "prefixo": "75372",
    "uf": "GO",
    "codigoIbge": 5208806,
    "cidade": "Goianira"
  },
  {
    "prefixo": "75373",
    "uf": "GO",
    "codigoIbge": 5208806,
    "cidade": "Goianira"
  },
  {
    "prefixo": "75375",
    "uf": "GO",
    "codigoIbge": 5219738,
    "cidade": "Santo Antônio de Goiás"
  },
  {
    "prefixo": "75380",
    "uf": "GO",
    "codigoIbge": 5221403,
    "cidade": "Trindade"
  },
  {
    "prefixo": "75381",
    "uf": "GO",
    "codigoIbge": 5221403,
    "cidade": "Trindade"
  },
  {
    "prefixo": "75382",
    "uf": "GO",
    "codigoIbge": 5221403,
    "cidade": "Trindade"
  },
  {
    "prefixo": "75383",
    "uf": "GO",
    "codigoIbge": 5221403,
    "cidade": "Trindade"
  },
  {
    "prefixo": "75384",
    "uf": "GO",
    "codigoIbge": 5221403,
    "cidade": "Trindade"
  },
  {
    "prefixo": "75385",
    "uf": "GO",
    "codigoIbge": 5221403,
    "cidade": "Trindade"
  },
  {
    "prefixo": "75386",
    "uf": "GO",
    "codigoIbge": 5221403,
    "cidade": "Trindade"
  },
  {
    "prefixo": "75387",
    "uf": "GO",
    "codigoIbge": 5221403,
    "cidade": "Trindade"
  },
  {
    "prefixo": "75388",
    "uf": "GO",
    "codigoIbge": 5221403,
    "cidade": "Trindade"
  },
  {
    "prefixo": "75389",
    "uf": "GO",
    "codigoIbge": 5221403,
    "cidade": "Trindade"
  },
  {
    "prefixo": "75390",
    "uf": "GO",
    "codigoIbge": 5221403,
    "cidade": "Trindade"
  },
  {
    "prefixo": "75391",
    "uf": "GO",
    "codigoIbge": 5221403,
    "cidade": "Trindade"
  },
  {
    "prefixo": "75392",
    "uf": "GO",
    "codigoIbge": 5221403,
    "cidade": "Trindade"
  },
  {
    "prefixo": "75393",
    "uf": "GO",
    "codigoIbge": 5221403,
    "cidade": "Trindade"
  },
  {
    "prefixo": "75394",
    "uf": "GO",
    "codigoIbge": 5221403,
    "cidade": "Trindade"
  },
  {
    "prefixo": "75395",
    "uf": "GO",
    "codigoIbge": 5202809,
    "cidade": "Avelinópolis"
  },
  {
    "prefixo": "75396",
    "uf": "GO",
    "codigoIbge": 5204607,
    "cidade": "Campestre de Goiás"
  },
  {
    "prefixo": "75398",
    "uf": "GO",
    "codigoIbge": 5219100,
    "cidade": "Santa Bárbara de Goiás"
  },
  {
    "prefixo": "75400",
    "uf": "GO",
    "codigoIbge": 5210000,
    "cidade": "Inhumas"
  },
  {
    "prefixo": "75401",
    "uf": "GO",
    "codigoIbge": 5210000,
    "cidade": "Inhumas"
  },
  {
    "prefixo": "75402",
    "uf": "GO",
    "codigoIbge": 5210000,
    "cidade": "Inhumas"
  },
  {
    "prefixo": "75403",
    "uf": "GO",
    "codigoIbge": 5210000,
    "cidade": "Inhumas"
  },
  {
    "prefixo": "75404",
    "uf": "GO",
    "codigoIbge": 5210000,
    "cidade": "Inhumas"
  },
  {
    "prefixo": "75405",
    "uf": "GO",
    "codigoIbge": 5210000,
    "cidade": "Inhumas"
  },
  {
    "prefixo": "75406",
    "uf": "GO",
    "codigoIbge": 5210000,
    "cidade": "Inhumas"
  },
  {
    "prefixo": "75407",
    "uf": "GO",
    "codigoIbge": 5210000,
    "cidade": "Inhumas"
  },
  {
    "prefixo": "75408",
    "uf": "GO",
    "codigoIbge": 5210000,
    "cidade": "Inhumas"
  },
  {
    "prefixo": "75410",
    "uf": "GO",
    "codigoIbge": 5201603,
    "cidade": "Araçu"
  },
  {
    "prefixo": "75420",
    "uf": "GO",
    "codigoIbge": 5206800,
    "cidade": "Damolândia"
  },
  {
    "prefixo": "75430",
    "uf": "GO",
    "codigoIbge": 5205208,
    "cidade": "Caturaí"
  },
  {
    "prefixo": "75439",
    "uf": "GO",
    "codigoIbge": 5205208,
    "cidade": "Caturaí"
  },
  {
    "prefixo": "75440",
    "uf": "GO",
    "codigoIbge": 5203609,
    "cidade": "Brazabrantes"
  },
  {
    "prefixo": "75449",
    "uf": "GO",
    "codigoIbge": 5203609,
    "cidade": "Brazabrantes"
  },
  {
    "prefixo": "75450",
    "uf": "GO",
    "codigoIbge": 5211404,
    "cidade": "Itauçu"
  },
  {
    "prefixo": "75455",
    "uf": "GO",
    "codigoIbge": 5219506,
    "cidade": "Santa Rosa de Goiás"
  },
  {
    "prefixo": "75459",
    "uf": "GO",
    "codigoIbge": 5219506,
    "cidade": "Santa Rosa de Goiás"
  },
  {
    "prefixo": "75460",
    "uf": "GO",
    "codigoIbge": 5214507,
    "cidade": "Nerópolis"
  },
  {
    "prefixo": "75469",
    "uf": "GO",
    "codigoIbge": 5214507,
    "cidade": "Nerópolis"
  },
  {
    "prefixo": "75470",
    "uf": "GO",
    "codigoIbge": 5215009,
    "cidade": "Nova Veneza"
  },
  {
    "prefixo": "75479",
    "uf": "GO",
    "codigoIbge": 5215009,
    "cidade": "Nova Veneza"
  },
  {
    "prefixo": "75480",
    "uf": "GO",
    "codigoIbge": 5216809,
    "cidade": "Petrolina de Goiás"
  },
  {
    "prefixo": "75489",
    "uf": "GO",
    "codigoIbge": 5216809,
    "cidade": "Petrolina de Goiás"
  },
  {
    "prefixo": "75490",
    "uf": "GO",
    "codigoIbge": 5219902,
    "cidade": "São Francisco de Goiás"
  },
  {
    "prefixo": "75494",
    "uf": "GO",
    "codigoIbge": 5219902,
    "cidade": "São Francisco de Goiás"
  },
  {
    "prefixo": "75495",
    "uf": "GO",
    "codigoIbge": 5212055,
    "cidade": "Jesúpolis"
  },
  {
    "prefixo": "75503",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75509",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75510",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75513",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75514",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75515",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75516",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75520",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75522",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75523",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75524",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75526",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75528",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75530",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75532",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75533",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75534",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75535",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75536",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75544",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75549",
    "uf": "GO",
    "codigoIbge": 5211503,
    "cidade": "Itumbiara"
  },
  {
    "prefixo": "75550",
    "uf": "GO",
    "codigoIbge": 5209937,
    "cidade": "Inaciolândia"
  },
  {
    "prefixo": "75555",
    "uf": "GO",
    "codigoIbge": 5222054,
    "cidade": "Vicentinópolis"
  },
  {
    "prefixo": "75560",
    "uf": "GO",
    "codigoIbge": 5204250,
    "cidade": "Cachoeira Dourada"
  },
  {
    "prefixo": "75569",
    "uf": "GO",
    "codigoIbge": 5204250,
    "cidade": "Cachoeira Dourada"
  },
  {
    "prefixo": "75570",
    "uf": "GO",
    "codigoIbge": 5203500,
    "cidade": "Bom Jesus de Goiás"
  },
  {
    "prefixo": "75580",
    "uf": "GO",
    "codigoIbge": 5216007,
    "cidade": "Panamá"
  },
  {
    "prefixo": "75600",
    "uf": "GO",
    "codigoIbge": 5209101,
    "cidade": "Goiatuba"
  },
  {
    "prefixo": "75602",
    "uf": "GO",
    "codigoIbge": 5209101,
    "cidade": "Goiatuba"
  },
  {
    "prefixo": "75603",
    "uf": "GO",
    "codigoIbge": 5218052,
    "cidade": "Porteirão"
  },
  {
    "prefixo": "75610",
    "uf": "GO",
    "codigoIbge": 5212105,
    "cidade": "Joviânia"
  },
  {
    "prefixo": "75615",
    "uf": "GO",
    "codigoIbge": 5200506,
    "cidade": "Aloândia"
  },
  {
    "prefixo": "75620",
    "uf": "GO",
    "codigoIbge": 5217708,
    "cidade": "Pontalina"
  },
  {
    "prefixo": "75629",
    "uf": "GO",
    "codigoIbge": 5217708,
    "cidade": "Pontalina"
  },
  {
    "prefixo": "75630",
    "uf": "GO",
    "codigoIbge": 5212600,
    "cidade": "Mairipotaba"
  },
  {
    "prefixo": "75635",
    "uf": "GO",
    "codigoIbge": 5206503,
    "cidade": "Cromínia"
  },
  {
    "prefixo": "75639",
    "uf": "GO",
    "codigoIbge": 5206503,
    "cidade": "Cromínia"
  },
  {
    "prefixo": "75640",
    "uf": "GO",
    "codigoIbge": 5217104,
    "cidade": "Piracanjuba"
  },
  {
    "prefixo": "75644",
    "uf": "GO",
    "codigoIbge": 5217104,
    "cidade": "Piracanjuba"
  },
  {
    "prefixo": "75645",
    "uf": "GO",
    "codigoIbge": 5218391,
    "cidade": "Professor Jamil"
  },
  {
    "prefixo": "75650",
    "uf": "GO",
    "codigoIbge": 5213806,
    "cidade": "Morrinhos"
  },
  {
    "prefixo": "75660",
    "uf": "GO",
    "codigoIbge": 5203906,
    "cidade": "Buriti Alegre"
  },
  {
    "prefixo": "75664",
    "uf": "GO",
    "codigoIbge": 5203906,
    "cidade": "Buriti Alegre"
  },
  {
    "prefixo": "75665",
    "uf": "GO",
    "codigoIbge": 5200209,
    "cidade": "Água Limpa"
  },
  {
    "prefixo": "75667",
    "uf": "GO",
    "codigoIbge": 5218789,
    "cidade": "Rio Quente"
  },
  {
    "prefixo": "75670",
    "uf": "GO",
    "codigoIbge": 5212907,
    "cidade": "Marzagão"
  },
  {
    "prefixo": "75675",
    "uf": "GO",
    "codigoIbge": 5205901,
    "cidade": "Corumbaíba"
  },
  {
    "prefixo": "75680",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75681",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75682",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75683",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75684",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75685",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75686",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75687",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75688",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75689",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75690",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75691",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75692",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75693",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75694",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75695",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75696",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75697",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75698",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75699",
    "uf": "GO",
    "codigoIbge": 5204508,
    "cidade": "Caldas Novas"
  },
  {
    "prefixo": "75701",
    "uf": "GO",
    "codigoIbge": 5205109,
    "cidade": "Catalão"
  },
  {
    "prefixo": "75702",
    "uf": "GO",
    "codigoIbge": 5205109,
    "cidade": "Catalão"
  },
  {
    "prefixo": "75703",
    "uf": "GO",
    "codigoIbge": 5205109,
    "cidade": "Catalão"
  },
  {
    "prefixo": "75704",
    "uf": "GO",
    "codigoIbge": 5205109,
    "cidade": "Catalão"
  },
  {
    "prefixo": "75705",
    "uf": "GO",
    "codigoIbge": 5205109,
    "cidade": "Catalão"
  },
  {
    "prefixo": "75706",
    "uf": "GO",
    "codigoIbge": 5205109,
    "cidade": "Catalão"
  },
  {
    "prefixo": "75707",
    "uf": "GO",
    "codigoIbge": 5205109,
    "cidade": "Catalão"
  },
  {
    "prefixo": "75708",
    "uf": "GO",
    "codigoIbge": 5205109,
    "cidade": "Catalão"
  },
  {
    "prefixo": "75709",
    "uf": "GO",
    "codigoIbge": 5205109,
    "cidade": "Catalão"
  },
  {
    "prefixo": "75710",
    "uf": "GO",
    "codigoIbge": 5205109,
    "cidade": "Catalão"
  },
  {
    "prefixo": "75711",
    "uf": "GO",
    "codigoIbge": 5205109,
    "cidade": "Catalão"
  },
  {
    "prefixo": "75712",
    "uf": "GO",
    "codigoIbge": 5205109,
    "cidade": "Catalão"
  },
  {
    "prefixo": "75713",
    "uf": "GO",
    "codigoIbge": 5205109,
    "cidade": "Catalão"
  },
  {
    "prefixo": "75714",
    "uf": "GO",
    "codigoIbge": 5205109,
    "cidade": "Catalão"
  },
  {
    "prefixo": "75715",
    "uf": "GO",
    "codigoIbge": 5215504,
    "cidade": "Ouvidor"
  },
  {
    "prefixo": "75719",
    "uf": "GO",
    "codigoIbge": 5215504,
    "cidade": "Ouvidor"
  },
  {
    "prefixo": "75720",
    "uf": "GO",
    "codigoIbge": 5221304,
    "cidade": "Três Ranchos"
  },
  {
    "prefixo": "75730",
    "uf": "GO",
    "codigoIbge": 5206909,
    "cidade": "Davinópolis"
  },
  {
    "prefixo": "75740",
    "uf": "GO",
    "codigoIbge": 5208509,
    "cidade": "Goiandira"
  },
  {
    "prefixo": "75750",
    "uf": "GO",
    "codigoIbge": 5214804,
    "cidade": "Nova Aurora"
  },
  {
    "prefixo": "75760",
    "uf": "GO",
    "codigoIbge": 5206602,
    "cidade": "Cumari"
  },
  {
    "prefixo": "75769",
    "uf": "GO",
    "codigoIbge": 5206602,
    "cidade": "Cumari"
  },
  {
    "prefixo": "75770",
    "uf": "GO",
    "codigoIbge": 5201207,
    "cidade": "Anhanguera"
  },
  {
    "prefixo": "75780",
    "uf": "GO",
    "codigoIbge": 5210109,
    "cidade": "Ipameri"
  },
  {
    "prefixo": "75783",
    "uf": "GO",
    "codigoIbge": 5210109,
    "cidade": "Ipameri"
  },
  {
    "prefixo": "75784",
    "uf": "GO",
    "codigoIbge": 5210109,
    "cidade": "Ipameri"
  },
  {
    "prefixo": "75790",
    "uf": "GO",
    "codigoIbge": 5221809,
    "cidade": "Urutaí"
  },
  {
    "prefixo": "75794",
    "uf": "GO",
    "codigoIbge": 5221809,
    "cidade": "Urutaí"
  },
  {
    "prefixo": "75795",
    "uf": "GO",
    "codigoIbge": 5204805,
    "cidade": "Campo Alegre de Goiás"
  },
  {
    "prefixo": "75800",
    "uf": "GO",
    "codigoIbge": 5211909,
    "cidade": "Jataí"
  },
  {
    "prefixo": "75801",
    "uf": "GO",
    "codigoIbge": 5211909,
    "cidade": "Jataí"
  },
  {
    "prefixo": "75802",
    "uf": "GO",
    "codigoIbge": 5211909,
    "cidade": "Jataí"
  },
  {
    "prefixo": "75803",
    "uf": "GO",
    "codigoIbge": 5211909,
    "cidade": "Jataí"
  },
  {
    "prefixo": "75804",
    "uf": "GO",
    "codigoIbge": 5211909,
    "cidade": "Jataí"
  },
  {
    "prefixo": "75805",
    "uf": "GO",
    "codigoIbge": 5211909,
    "cidade": "Jataí"
  },
  {
    "prefixo": "75806",
    "uf": "GO",
    "codigoIbge": 5211909,
    "cidade": "Jataí"
  },
  {
    "prefixo": "75807",
    "uf": "GO",
    "codigoIbge": 5211909,
    "cidade": "Jataí"
  },
  {
    "prefixo": "75809",
    "uf": "GO",
    "codigoIbge": 5211909,
    "cidade": "Jataí"
  },
  {
    "prefixo": "75810",
    "uf": "GO",
    "codigoIbge": 5211305,
    "cidade": "Itarumã"
  },
  {
    "prefixo": "75812",
    "uf": "GO",
    "codigoIbge": 5211305,
    "cidade": "Itarumã"
  },
  {
    "prefixo": "75813",
    "uf": "GO",
    "codigoIbge": 5204300,
    "cidade": "Caçu"
  },
  {
    "prefixo": "75814",
    "uf": "GO",
    "codigoIbge": 5204300,
    "cidade": "Caçu"
  },
  {
    "prefixo": "75815",
    "uf": "GO",
    "codigoIbge": 5210802,
    "cidade": "Itajá"
  },
  {
    "prefixo": "75819",
    "uf": "GO",
    "codigoIbge": 5212253,
    "cidade": "Lagoa Santa"
  },
  {
    "prefixo": "75820",
    "uf": "GO",
    "codigoIbge": 5220504,
    "cidade": "Serranópolis"
  },
  {
    "prefixo": "75822",
    "uf": "GO",
    "codigoIbge": 5220504,
    "cidade": "Serranópolis"
  },
  {
    "prefixo": "75823",
    "uf": "GO",
    "codigoIbge": 5216452,
    "cidade": "Perolândia"
  },
  {
    "prefixo": "75825",
    "uf": "GO",
    "codigoIbge": 5201504,
    "cidade": "Aporé"
  },
  {
    "prefixo": "75827",
    "uf": "GO",
    "codigoIbge": 5201454,
    "cidade": "Aparecida do Rio Doce"
  },
  {
    "prefixo": "75828",
    "uf": "GO",
    "codigoIbge": 5205471,
    "cidade": "Chapadão do Céu"
  },
  {
    "prefixo": "75829",
    "uf": "GO",
    "codigoIbge": 5205471,
    "cidade": "Chapadão do Céu"
  },
  {
    "prefixo": "75830",
    "uf": "GO",
    "codigoIbge": 5213103,
    "cidade": "Mineiros"
  },
  {
    "prefixo": "75831",
    "uf": "GO",
    "codigoIbge": 5213103,
    "cidade": "Mineiros"
  },
  {
    "prefixo": "75832",
    "uf": "GO",
    "codigoIbge": 5213103,
    "cidade": "Mineiros"
  },
  {
    "prefixo": "75833",
    "uf": "GO",
    "codigoIbge": 5213103,
    "cidade": "Mineiros"
  },
  {
    "prefixo": "75834",
    "uf": "GO",
    "codigoIbge": 5213103,
    "cidade": "Mineiros"
  },
  {
    "prefixo": "75835",
    "uf": "GO",
    "codigoIbge": 5213103,
    "cidade": "Mineiros"
  },
  {
    "prefixo": "75836",
    "uf": "GO",
    "codigoIbge": 5213103,
    "cidade": "Mineiros"
  },
  {
    "prefixo": "75837",
    "uf": "GO",
    "codigoIbge": 5213103,
    "cidade": "Mineiros"
  },
  {
    "prefixo": "75838",
    "uf": "GO",
    "codigoIbge": 5213103,
    "cidade": "Mineiros"
  },
  {
    "prefixo": "75840",
    "uf": "GO",
    "codigoIbge": 5219407,
    "cidade": "Santa Rita do Araguaia"
  },
  {
    "prefixo": "75843",
    "uf": "GO",
    "codigoIbge": 5218102,
    "cidade": "Portelândia"
  },
  {
    "prefixo": "75845",
    "uf": "GO",
    "codigoIbge": 5215652,
    "cidade": "Palestina de Goiás"
  },
  {
    "prefixo": "75850",
    "uf": "GO",
    "codigoIbge": 5204409,
    "cidade": "Caiapônia"
  },
  {
    "prefixo": "75854",
    "uf": "GO",
    "codigoIbge": 5204409,
    "cidade": "Caiapônia"
  },
  {
    "prefixo": "75855",
    "uf": "GO",
    "codigoIbge": 5207253,
    "cidade": "Doverlândia"
  },
  {
    "prefixo": "75859",
    "uf": "GO",
    "codigoIbge": 5207253,
    "cidade": "Doverlândia"
  },
  {
    "prefixo": "75860",
    "uf": "GO",
    "codigoIbge": 5218508,
    "cidade": "Quirinópolis"
  },
  {
    "prefixo": "75864",
    "uf": "GO",
    "codigoIbge": 5218508,
    "cidade": "Quirinópolis"
  },
  {
    "prefixo": "75865",
    "uf": "GO",
    "codigoIbge": 5209150,
    "cidade": "Gouvelândia"
  },
  {
    "prefixo": "75870",
    "uf": "GO",
    "codigoIbge": 5204102,
    "cidade": "Cachoeira Alta"
  },
  {
    "prefixo": "75880",
    "uf": "GO",
    "codigoIbge": 5216304,
    "cidade": "Paranaiguara"
  },
  {
    "prefixo": "75890",
    "uf": "GO",
    "codigoIbge": 5220405,
    "cidade": "São Simão"
  },
  {
    "prefixo": "75893",
    "uf": "GO",
    "codigoIbge": 5220405,
    "cidade": "São Simão"
  },
  {
    "prefixo": "75900",
    "uf": "GO",
    "codigoIbge": 5218805,
    "cidade": "Rio Verde"
  },
  {
    "prefixo": "75901",
    "uf": "GO",
    "codigoIbge": 5218805,
    "cidade": "Rio Verde"
  },
  {
    "prefixo": "75902",
    "uf": "GO",
    "codigoIbge": 5218805,
    "cidade": "Rio Verde"
  },
  {
    "prefixo": "75903",
    "uf": "GO",
    "codigoIbge": 5218805,
    "cidade": "Rio Verde"
  },
  {
    "prefixo": "75904",
    "uf": "GO",
    "codigoIbge": 5218805,
    "cidade": "Rio Verde"
  },
  {
    "prefixo": "75905",
    "uf": "GO",
    "codigoIbge": 5218805,
    "cidade": "Rio Verde"
  },
  {
    "prefixo": "75906",
    "uf": "GO",
    "codigoIbge": 5218805,
    "cidade": "Rio Verde"
  },
  {
    "prefixo": "75907",
    "uf": "GO",
    "codigoIbge": 5218805,
    "cidade": "Rio Verde"
  },
  {
    "prefixo": "75908",
    "uf": "GO",
    "codigoIbge": 5218805,
    "cidade": "Rio Verde"
  },
  {
    "prefixo": "75909",
    "uf": "GO",
    "codigoIbge": 5218805,
    "cidade": "Rio Verde"
  },
  {
    "prefixo": "75910",
    "uf": "GO",
    "codigoIbge": 5218805,
    "cidade": "Rio Verde"
  },
  {
    "prefixo": "75911",
    "uf": "GO",
    "codigoIbge": 5218805,
    "cidade": "Rio Verde"
  },
  {
    "prefixo": "75912",
    "uf": "GO",
    "codigoIbge": 5218805,
    "cidade": "Rio Verde"
  },
  {
    "prefixo": "75913",
    "uf": "GO",
    "codigoIbge": 5218805,
    "cidade": "Rio Verde"
  },
  {
    "prefixo": "75914",
    "uf": "GO",
    "codigoIbge": 5218805,
    "cidade": "Rio Verde"
  },
  {
    "prefixo": "75915",
    "uf": "GO",
    "codigoIbge": 5213756,
    "cidade": "Montividiu"
  },
  {
    "prefixo": "75920",
    "uf": "GO",
    "codigoIbge": 5219308,
    "cidade": "Santa Helena de Goiás"
  },
  {
    "prefixo": "75925",
    "uf": "GO",
    "codigoIbge": 5205059,
    "cidade": "Castelândia"
  },
  {
    "prefixo": "75930",
    "uf": "GO",
    "codigoIbge": 5213004,
    "cidade": "Maurilândia"
  },
  {
    "prefixo": "75935",
    "uf": "GO",
    "codigoIbge": 5219712,
    "cidade": "Santo Antônio da Barra"
  },
  {
    "prefixo": "75939",
    "uf": "GO",
    "codigoIbge": 5219712,
    "cidade": "Santo Antônio da Barra"
  },
  {
    "prefixo": "75940",
    "uf": "GO",
    "codigoIbge": 5207402,
    "cidade": "Edéia"
  },
  {
    "prefixo": "75945",
    "uf": "GO",
    "codigoIbge": 5207352,
    "cidade": "Edealina"
  },
  {
    "prefixo": "75950",
    "uf": "GO",
    "codigoIbge": 5211701,
    "cidade": "Jandaia"
  },
  {
    "prefixo": "75955",
    "uf": "GO",
    "codigoIbge": 5209952,
    "cidade": "Indiara"
  },
  {
    "prefixo": "75959",
    "uf": "GO",
    "codigoIbge": 5209952,
    "cidade": "Indiara"
  },
  {
    "prefixo": "75960",
    "uf": "GO",
    "codigoIbge": 5200134,
    "cidade": "Acreúna"
  },
  {
    "prefixo": "75969",
    "uf": "GO",
    "codigoIbge": 5200134,
    "cidade": "Acreúna"
  },
  {
    "prefixo": "75970",
    "uf": "GO",
    "codigoIbge": 5221551,
    "cidade": "Turvelândia"
  },
  {
    "prefixo": "75979",
    "uf": "GO",
    "codigoIbge": 5221551,
    "cidade": "Turvelândia"
  },
  {
    "prefixo": "75980",
    "uf": "GO",
    "codigoIbge": 5216403,
    "cidade": "Paraúna"
  },
  {
    "prefixo": "75985",
    "uf": "GO",
    "codigoIbge": 5220058,
    "cidade": "São João da Paraúna"
  },
  {
    "prefixo": "75989",
    "uf": "GO",
    "codigoIbge": 5220058,
    "cidade": "São João da Paraúna"
  },
  {
    "prefixo": "75990",
    "uf": "GO",
    "codigoIbge": 5215900,
    "cidade": "Palminópolis"
  },
  {
    "prefixo": "76050",
    "uf": "GO",
    "codigoIbge": 5220108,
    "cidade": "São Luís de Montes Belos"
  },
  {
    "prefixo": "76052",
    "uf": "GO",
    "codigoIbge": 5220108,
    "cidade": "São Luís de Montes Belos"
  },
  {
    "prefixo": "76053",
    "uf": "GO",
    "codigoIbge": 5220108,
    "cidade": "São Luís de Montes Belos"
  },
  {
    "prefixo": "76054",
    "uf": "GO",
    "codigoIbge": 5220108,
    "cidade": "São Luís de Montes Belos"
  },
  {
    "prefixo": "76055",
    "uf": "GO",
    "codigoIbge": 5220108,
    "cidade": "São Luís de Montes Belos"
  },
  {
    "prefixo": "76056",
    "uf": "GO",
    "codigoIbge": 5220108,
    "cidade": "São Luís de Montes Belos"
  },
  {
    "prefixo": "76057",
    "uf": "GO",
    "codigoIbge": 5220108,
    "cidade": "São Luís de Montes Belos"
  },
  {
    "prefixo": "76058",
    "uf": "GO",
    "codigoIbge": 5220108,
    "cidade": "São Luís de Montes Belos"
  },
  {
    "prefixo": "76059",
    "uf": "GO",
    "codigoIbge": 5220108,
    "cidade": "São Luís de Montes Belos"
  },
  {
    "prefixo": "76100",
    "uf": "GO",
    "codigoIbge": 5220108,
    "cidade": "São Luís de Montes Belos"
  },
  {
    "prefixo": "76105",
    "uf": "GO",
    "codigoIbge": 5207808,
    "cidade": "Firminópolis"
  },
  {
    "prefixo": "76110",
    "uf": "GO",
    "codigoIbge": 5221502,
    "cidade": "Turvânia"
  },
  {
    "prefixo": "76120",
    "uf": "GO",
    "codigoIbge": 5202601,
    "cidade": "Aurilândia"
  },
  {
    "prefixo": "76124",
    "uf": "GO",
    "codigoIbge": 5202601,
    "cidade": "Aurilândia"
  },
  {
    "prefixo": "76125",
    "uf": "GO",
    "codigoIbge": 5204201,
    "cidade": "Cachoeira de Goiás"
  },
  {
    "prefixo": "76130",
    "uf": "GO",
    "codigoIbge": 5211602,
    "cidade": "Ivolândia"
  },
  {
    "prefixo": "76133",
    "uf": "GO",
    "codigoIbge": 5211602,
    "cidade": "Ivolândia"
  },
  {
    "prefixo": "76134",
    "uf": "GO",
    "codigoIbge": 5211602,
    "cidade": "Ivolândia"
  },
  {
    "prefixo": "76135",
    "uf": "GO",
    "codigoIbge": 5213400,
    "cidade": "Moiporá"
  },
  {
    "prefixo": "76138",
    "uf": "GO",
    "codigoIbge": 5213400,
    "cidade": "Moiporá"
  },
  {
    "prefixo": "76140",
    "uf": "GO",
    "codigoIbge": 5200902,
    "cidade": "Amorinópolis"
  },
  {
    "prefixo": "76145",
    "uf": "GO",
    "codigoIbge": 5205703,
    "cidade": "Córrego do Ouro"
  },
  {
    "prefixo": "76150",
    "uf": "GO",
    "codigoIbge": 5213905,
    "cidade": "Mossâmedes"
  },
  {
    "prefixo": "76151",
    "uf": "GO",
    "codigoIbge": 5213905,
    "cidade": "Mossâmedes"
  },
  {
    "prefixo": "76152",
    "uf": "GO",
    "codigoIbge": 5203939,
    "cidade": "Buriti de Goiás"
  },
  {
    "prefixo": "76155",
    "uf": "GO",
    "codigoIbge": 5200159,
    "cidade": "Adelândia"
  },
  {
    "prefixo": "76159",
    "uf": "GO",
    "codigoIbge": 5200159,
    "cidade": "Adelândia"
  },
  {
    "prefixo": "76160",
    "uf": "GO",
    "codigoIbge": 5219001,
    "cidade": "Sanclerlândia"
  },
  {
    "prefixo": "76165",
    "uf": "GO",
    "codigoIbge": 5200852,
    "cidade": "Americano do Brasil"
  },
  {
    "prefixo": "76170",
    "uf": "GO",
    "codigoIbge": 5201306,
    "cidade": "Anicuns"
  },
  {
    "prefixo": "76172",
    "uf": "GO",
    "codigoIbge": 5201306,
    "cidade": "Anicuns"
  },
  {
    "prefixo": "76174",
    "uf": "GO",
    "codigoIbge": 5201306,
    "cidade": "Anicuns"
  },
  {
    "prefixo": "76179",
    "uf": "GO",
    "codigoIbge": 5201306,
    "cidade": "Anicuns"
  },
  {
    "prefixo": "76180",
    "uf": "GO",
    "codigoIbge": 5214408,
    "cidade": "Nazário"
  },
  {
    "prefixo": "76185",
    "uf": "GO",
    "codigoIbge": 5214408,
    "cidade": "Nazário"
  },
  {
    "prefixo": "76189",
    "uf": "GO",
    "codigoIbge": 5214408,
    "cidade": "Nazário"
  },
  {
    "prefixo": "76190",
    "uf": "GO",
    "codigoIbge": 5215702,
    "cidade": "Palmeiras de Goiás"
  },
  {
    "prefixo": "76194",
    "uf": "GO",
    "codigoIbge": 5215702,
    "cidade": "Palmeiras de Goiás"
  },
  {
    "prefixo": "76195",
    "uf": "GO",
    "codigoIbge": 5205455,
    "cidade": "Cezarina"
  },
  {
    "prefixo": "76199",
    "uf": "GO",
    "codigoIbge": 5205455,
    "cidade": "Cezarina"
  },
  {
    "prefixo": "76200",
    "uf": "GO",
    "codigoIbge": 5210208,
    "cidade": "Iporá"
  },
  {
    "prefixo": "76201",
    "uf": "GO",
    "codigoIbge": 5210208,
    "cidade": "Iporá"
  },
  {
    "prefixo": "76202",
    "uf": "GO",
    "codigoIbge": 5210208,
    "cidade": "Iporá"
  },
  {
    "prefixo": "76204",
    "uf": "GO",
    "codigoIbge": 5210208,
    "cidade": "Iporá"
  },
  {
    "prefixo": "76205",
    "uf": "GO",
    "codigoIbge": 5210307,
    "cidade": "Israelândia"
  },
  {
    "prefixo": "76206",
    "uf": "GO",
    "codigoIbge": 5210208,
    "cidade": "Iporá"
  },
  {
    "prefixo": "76207",
    "uf": "GO",
    "codigoIbge": 5210208,
    "cidade": "Iporá"
  },
  {
    "prefixo": "76208",
    "uf": "GO",
    "codigoIbge": 5210208,
    "cidade": "Iporá"
  },
  {
    "prefixo": "76210",
    "uf": "GO",
    "codigoIbge": 5212006,
    "cidade": "Jaupaci"
  },
  {
    "prefixo": "76220",
    "uf": "GO",
    "codigoIbge": 5207600,
    "cidade": "Fazenda Nova"
  },
  {
    "prefixo": "76222",
    "uf": "GO",
    "codigoIbge": 5207600,
    "cidade": "Fazenda Nova"
  },
  {
    "prefixo": "76230",
    "uf": "GO",
    "codigoIbge": 5217203,
    "cidade": "Piranhas"
  },
  {
    "prefixo": "76234",
    "uf": "GO",
    "codigoIbge": 5217203,
    "cidade": "Piranhas"
  },
  {
    "prefixo": "76235",
    "uf": "GO",
    "codigoIbge": 5202353,
    "cidade": "Arenópolis"
  },
  {
    "prefixo": "76240",
    "uf": "GO",
    "codigoIbge": 5201702,
    "cidade": "Aragarças"
  },
  {
    "prefixo": "76244",
    "uf": "GO",
    "codigoIbge": 5201702,
    "cidade": "Aragarças"
  },
  {
    "prefixo": "76245",
    "uf": "GO",
    "codigoIbge": 5203401,
    "cidade": "Bom Jardim de Goiás"
  },
  {
    "prefixo": "76249",
    "uf": "GO",
    "codigoIbge": 5203401,
    "cidade": "Bom Jardim de Goiás"
  },
  {
    "prefixo": "76250",
    "uf": "GO",
    "codigoIbge": 5203104,
    "cidade": "Baliza"
  },
  {
    "prefixo": "76254",
    "uf": "GO",
    "codigoIbge": 5203104,
    "cidade": "Baliza"
  },
  {
    "prefixo": "76255",
    "uf": "GO",
    "codigoIbge": 5213707,
    "cidade": "Montes Claros de Goiás"
  },
  {
    "prefixo": "76256",
    "uf": "GO",
    "codigoIbge": 5213707,
    "cidade": "Montes Claros de Goiás"
  },
  {
    "prefixo": "76257",
    "uf": "GO",
    "codigoIbge": 5213707,
    "cidade": "Montes Claros de Goiás"
  },
  {
    "prefixo": "76258",
    "uf": "GO",
    "codigoIbge": 5213707,
    "cidade": "Montes Claros de Goiás"
  },
  {
    "prefixo": "76259",
    "uf": "GO",
    "codigoIbge": 5213707,
    "cidade": "Montes Claros de Goiás"
  },
  {
    "prefixo": "76260",
    "uf": "GO",
    "codigoIbge": 5207105,
    "cidade": "Diorama"
  },
  {
    "prefixo": "76265",
    "uf": "GO",
    "codigoIbge": 5219258,
    "cidade": "Santa Fé de Goiás"
  },
  {
    "prefixo": "76270",
    "uf": "GO",
    "codigoIbge": 5212204,
    "cidade": "Jussara"
  },
  {
    "prefixo": "76271",
    "uf": "GO",
    "codigoIbge": 5212204,
    "cidade": "Jussara"
  },
  {
    "prefixo": "76278",
    "uf": "GO",
    "codigoIbge": 5212204,
    "cidade": "Jussara"
  },
  {
    "prefixo": "76279",
    "uf": "GO",
    "codigoIbge": 5212204,
    "cidade": "Jussara"
  },
  {
    "prefixo": "76280",
    "uf": "GO",
    "codigoIbge": 5203807,
    "cidade": "Britânia"
  },
  {
    "prefixo": "76285",
    "uf": "GO",
    "codigoIbge": 5215207,
    "cidade": "Novo Brasil"
  },
  {
    "prefixo": "76289",
    "uf": "GO",
    "codigoIbge": 5215207,
    "cidade": "Novo Brasil"
  },
  {
    "prefixo": "76290",
    "uf": "GO",
    "codigoIbge": 5211008,
    "cidade": "Itapirapuã"
  },
  {
    "prefixo": "76293",
    "uf": "GO",
    "codigoIbge": 5211008,
    "cidade": "Itapirapuã"
  },
  {
    "prefixo": "76300",
    "uf": "GO",
    "codigoIbge": 5205406,
    "cidade": "Ceres"
  },
  {
    "prefixo": "76303",
    "uf": "GO",
    "codigoIbge": 5205406,
    "cidade": "Ceres"
  },
  {
    "prefixo": "76304",
    "uf": "GO",
    "codigoIbge": 5210158,
    "cidade": "Ipiranga de Goiás"
  },
  {
    "prefixo": "76305",
    "uf": "GO",
    "codigoIbge": 5214861,
    "cidade": "Nova Glória"
  },
  {
    "prefixo": "76310",
    "uf": "GO",
    "codigoIbge": 5218607,
    "cidade": "Rialma"
  },
  {
    "prefixo": "76313",
    "uf": "GO",
    "codigoIbge": 5218607,
    "cidade": "Rialma"
  },
  {
    "prefixo": "76315",
    "uf": "GO",
    "codigoIbge": 5218706,
    "cidade": "Rianápolis"
  },
  {
    "prefixo": "76320",
    "uf": "GO",
    "codigoIbge": 5219357,
    "cidade": "Santa Isabel"
  },
  {
    "prefixo": "76323",
    "uf": "GO",
    "codigoIbge": 5219357,
    "cidade": "Santa Isabel"
  },
  {
    "prefixo": "76330",
    "uf": "GO",
    "codigoIbge": 5211800,
    "cidade": "Jaraguá"
  },
  {
    "prefixo": "76334",
    "uf": "GO",
    "codigoIbge": 5211800,
    "cidade": "Jaraguá"
  },
  {
    "prefixo": "76335",
    "uf": "GO",
    "codigoIbge": 5221700,
    "cidade": "Uruana"
  },
  {
    "prefixo": "76338",
    "uf": "GO",
    "codigoIbge": 5221700,
    "cidade": "Uruana"
  },
  {
    "prefixo": "76340",
    "uf": "GO",
    "codigoIbge": 5205000,
    "cidade": "Carmo do Rio Verde"
  },
  {
    "prefixo": "76343",
    "uf": "GO",
    "codigoIbge": 5220280,
    "cidade": "São Patrício"
  },
  {
    "prefixo": "76345",
    "uf": "GO",
    "codigoIbge": 5214705,
    "cidade": "Nova América"
  },
  {
    "prefixo": "76350",
    "uf": "GO",
    "codigoIbge": 5218904,
    "cidade": "Rubiataba"
  },
  {
    "prefixo": "76352",
    "uf": "GO",
    "codigoIbge": 5218904,
    "cidade": "Rubiataba"
  },
  {
    "prefixo": "76355",
    "uf": "GO",
    "codigoIbge": 5213855,
    "cidade": "Morro Agudo de Goiás"
  },
  {
    "prefixo": "76360",
    "uf": "GO",
    "codigoIbge": 5210901,
    "cidade": "Itapaci"
  },
  {
    "prefixo": "76363",
    "uf": "GO",
    "codigoIbge": 5210901,
    "cidade": "Itapaci"
  },
  {
    "prefixo": "76364",
    "uf": "GO",
    "codigoIbge": 5210901,
    "cidade": "Itapaci"
  },
  {
    "prefixo": "76365",
    "uf": "GO",
    "codigoIbge": 5220157,
    "cidade": "São Luiz do Norte"
  },
  {
    "prefixo": "76372",
    "uf": "GO",
    "codigoIbge": 5216908,
    "cidade": "Pilar de Goiás"
  },
  {
    "prefixo": "76374",
    "uf": "GO",
    "codigoIbge": 5209457,
    "cidade": "Guarinos"
  },
  {
    "prefixo": "76375",
    "uf": "GO",
    "codigoIbge": 5209804,
    "cidade": "Hidrolina"
  },
  {
    "prefixo": "76379",
    "uf": "GO",
    "codigoIbge": 5209804,
    "cidade": "Hidrolina"
  },
  {
    "prefixo": "76380",
    "uf": "GO",
    "codigoIbge": 5208608,
    "cidade": "Goianésia"
  },
  {
    "prefixo": "76381",
    "uf": "GO",
    "codigoIbge": 5208608,
    "cidade": "Goianésia"
  },
  {
    "prefixo": "76382",
    "uf": "GO",
    "codigoIbge": 5208608,
    "cidade": "Goianésia"
  },
  {
    "prefixo": "76383",
    "uf": "GO",
    "codigoIbge": 5208608,
    "cidade": "Goianésia"
  },
  {
    "prefixo": "76384",
    "uf": "GO",
    "codigoIbge": 5208608,
    "cidade": "Goianésia"
  },
  {
    "prefixo": "76385",
    "uf": "GO",
    "codigoIbge": 5208608,
    "cidade": "Goianésia"
  },
  {
    "prefixo": "76386",
    "uf": "GO",
    "codigoIbge": 5208608,
    "cidade": "Goianésia"
  },
  {
    "prefixo": "76387",
    "uf": "GO",
    "codigoIbge": 5208608,
    "cidade": "Goianésia"
  },
  {
    "prefixo": "76388",
    "uf": "GO",
    "codigoIbge": 5208608,
    "cidade": "Goianésia"
  },
  {
    "prefixo": "76389",
    "uf": "GO",
    "codigoIbge": 5208608,
    "cidade": "Goianésia"
  },
  {
    "prefixo": "76390",
    "uf": "GO",
    "codigoIbge": 5203203,
    "cidade": "Barro Alto"
  },
  {
    "prefixo": "76392",
    "uf": "GO",
    "codigoIbge": 5203203,
    "cidade": "Barro Alto"
  },
  {
    "prefixo": "76393",
    "uf": "GO",
    "codigoIbge": 5222302,
    "cidade": "Vila Propício"
  },
  {
    "prefixo": "76395",
    "uf": "GO",
    "codigoIbge": 5219456,
    "cidade": "Santa Rita do Novo Destino"
  },
  {
    "prefixo": "76400",
    "uf": "GO",
    "codigoIbge": 5221601,
    "cidade": "Uruaçu"
  },
  {
    "prefixo": "76402",
    "uf": "GO",
    "codigoIbge": 5221601,
    "cidade": "Uruaçu"
  },
  {
    "prefixo": "76410",
    "uf": "GO",
    "codigoIbge": 5204706,
    "cidade": "Campinorte"
  },
  {
    "prefixo": "76412",
    "uf": "GO",
    "codigoIbge": 5204706,
    "cidade": "Campinorte"
  },
  {
    "prefixo": "76419",
    "uf": "GO",
    "codigoIbge": 5204706,
    "cidade": "Campinorte"
  },
  {
    "prefixo": "76420",
    "uf": "GO",
    "codigoIbge": 5214606,
    "cidade": "Niquelândia"
  },
  {
    "prefixo": "76422",
    "uf": "GO",
    "codigoIbge": 5214606,
    "cidade": "Niquelândia"
  },
  {
    "prefixo": "76423",
    "uf": "GO",
    "codigoIbge": 5214606,
    "cidade": "Niquelândia"
  },
  {
    "prefixo": "76424",
    "uf": "GO",
    "codigoIbge": 5214606,
    "cidade": "Niquelândia"
  },
  {
    "prefixo": "76439",
    "uf": "GO",
    "codigoIbge": 5214606,
    "cidade": "Niquelândia"
  },
  {
    "prefixo": "76440",
    "uf": "GO",
    "codigoIbge": 5204656,
    "cidade": "Campinaçu"
  },
  {
    "prefixo": "76450",
    "uf": "GO",
    "codigoIbge": 5213087,
    "cidade": "Minaçu"
  },
  {
    "prefixo": "76458",
    "uf": "GO",
    "codigoIbge": 5213087,
    "cidade": "Minaçu"
  },
  {
    "prefixo": "76460",
    "uf": "GO",
    "codigoIbge": 5221452,
    "cidade": "Trombas"
  },
  {
    "prefixo": "76465",
    "uf": "GO",
    "codigoIbge": 5213772,
    "cidade": "Montividiu do Norte"
  },
  {
    "prefixo": "76470",
    "uf": "GO",
    "codigoIbge": 5208103,
    "cidade": "Formoso"
  },
  {
    "prefixo": "76478",
    "uf": "GO",
    "codigoIbge": 5208103,
    "cidade": "Formoso"
  },
  {
    "prefixo": "76480",
    "uf": "GO",
    "codigoIbge": 5219605,
    "cidade": "Santa Tereza de Goiás"
  },
  {
    "prefixo": "76484",
    "uf": "GO",
    "codigoIbge": 5219605,
    "cidade": "Santa Tereza de Goiás"
  },
  {
    "prefixo": "76485",
    "uf": "GO",
    "codigoIbge": 5207501,
    "cidade": "Estrela do Norte"
  },
  {
    "prefixo": "76490",
    "uf": "GO",
    "codigoIbge": 5212808,
    "cidade": "Mara Rosa"
  },
  {
    "prefixo": "76492",
    "uf": "GO",
    "codigoIbge": 5212808,
    "cidade": "Mara Rosa"
  },
  {
    "prefixo": "76493",
    "uf": "GO",
    "codigoIbge": 5200829,
    "cidade": "Amaralina"
  },
  {
    "prefixo": "76495",
    "uf": "GO",
    "codigoIbge": 5214879,
    "cidade": "Nova Iguaçu de Goiás"
  },
  {
    "prefixo": "76499",
    "uf": "GO",
    "codigoIbge": 5214879,
    "cidade": "Nova Iguaçu de Goiás"
  },
  {
    "prefixo": "76500",
    "uf": "GO",
    "codigoIbge": 5219704,
    "cidade": "Santa Terezinha de Goiás"
  },
  {
    "prefixo": "76510",
    "uf": "GO",
    "codigoIbge": 5206404,
    "cidade": "Crixás"
  },
  {
    "prefixo": "76513",
    "uf": "GO",
    "codigoIbge": 5206404,
    "cidade": "Crixás"
  },
  {
    "prefixo": "76514",
    "uf": "GO",
    "codigoIbge": 5206404,
    "cidade": "Crixás"
  },
  {
    "prefixo": "76515",
    "uf": "GO",
    "codigoIbge": 5204953,
    "cidade": "Campos Verdes"
  },
  {
    "prefixo": "76520",
    "uf": "GO",
    "codigoIbge": 5214838,
    "cidade": "Nova Crixás"
  },
  {
    "prefixo": "76523",
    "uf": "GO",
    "codigoIbge": 5214838,
    "cidade": "Nova Crixás"
  },
  {
    "prefixo": "76524",
    "uf": "GO",
    "codigoIbge": 5214838,
    "cidade": "Nova Crixás"
  },
  {
    "prefixo": "76525",
    "uf": "GO",
    "codigoIbge": 5221577,
    "cidade": "Uirapuru"
  },
  {
    "prefixo": "76528",
    "uf": "GO",
    "codigoIbge": 5221577,
    "cidade": "Uirapuru"
  },
  {
    "prefixo": "76529",
    "uf": "GO",
    "codigoIbge": 5221577,
    "cidade": "Uirapuru"
  },
  {
    "prefixo": "76530",
    "uf": "GO",
    "codigoIbge": 5214051,
    "cidade": "Mundo Novo"
  },
  {
    "prefixo": "76539",
    "uf": "GO",
    "codigoIbge": 5214051,
    "cidade": "Mundo Novo"
  },
  {
    "prefixo": "76540",
    "uf": "GO",
    "codigoIbge": 5214101,
    "cidade": "Mutunópolis"
  },
  {
    "prefixo": "76550",
    "uf": "GO",
    "codigoIbge": 5218003,
    "cidade": "Porangatu"
  },
  {
    "prefixo": "76554",
    "uf": "GO",
    "codigoIbge": 5218003,
    "cidade": "Porangatu"
  },
  {
    "prefixo": "76555",
    "uf": "GO",
    "codigoIbge": 5203575,
    "cidade": "Bonópolis"
  },
  {
    "prefixo": "76560",
    "uf": "GO",
    "codigoIbge": 5200555,
    "cidade": "Alto Horizonte"
  },
  {
    "prefixo": "76580",
    "uf": "GO",
    "codigoIbge": 5215256,
    "cidade": "Novo Planalto"
  },
  {
    "prefixo": "76589",
    "uf": "GO",
    "codigoIbge": 5215256,
    "cidade": "Novo Planalto"
  },
  {
    "prefixo": "76590",
    "uf": "GO",
    "codigoIbge": 5220207,
    "cidade": "São Miguel do Araguaia"
  },
  {
    "prefixo": "76598",
    "uf": "GO",
    "codigoIbge": 5220207,
    "cidade": "São Miguel do Araguaia"
  },
  {
    "prefixo": "76600",
    "uf": "GO",
    "codigoIbge": 5208905,
    "cidade": "Goiás"
  },
  {
    "prefixo": "76604",
    "uf": "GO",
    "codigoIbge": 5208905,
    "cidade": "Goiás"
  },
  {
    "prefixo": "76606",
    "uf": "GO",
    "codigoIbge": 5208905,
    "cidade": "Goiás"
  },
  {
    "prefixo": "76608",
    "uf": "GO",
    "codigoIbge": 5208905,
    "cidade": "Goiás"
  },
  {
    "prefixo": "76630",
    "uf": "GO",
    "codigoIbge": 5210406,
    "cidade": "Itaberaí"
  },
  {
    "prefixo": "76640",
    "uf": "GO",
    "codigoIbge": 5221007,
    "cidade": "Taquaral de Goiás"
  },
  {
    "prefixo": "76650",
    "uf": "GO",
    "codigoIbge": 5210562,
    "cidade": "Itaguari"
  },
  {
    "prefixo": "76660",
    "uf": "GO",
    "codigoIbge": 5210604,
    "cidade": "Itaguaru"
  },
  {
    "prefixo": "76670",
    "uf": "GO",
    "codigoIbge": 5209606,
    "cidade": "Heitoraí"
  },
  {
    "prefixo": "76679",
    "uf": "GO",
    "codigoIbge": 5209606,
    "cidade": "Heitoraí"
  },
  {
    "prefixo": "76680",
    "uf": "GO",
    "codigoIbge": 5211206,
    "cidade": "Itapuranga"
  },
  {
    "prefixo": "76682",
    "uf": "GO",
    "codigoIbge": 5211206,
    "cidade": "Itapuranga"
  },
  {
    "prefixo": "76683",
    "uf": "GO",
    "codigoIbge": 5211206,
    "cidade": "Itapuranga"
  },
  {
    "prefixo": "76689",
    "uf": "GO",
    "codigoIbge": 5211206,
    "cidade": "Itapuranga"
  },
  {
    "prefixo": "76690",
    "uf": "GO",
    "codigoIbge": 5209291,
    "cidade": "Guaraíta"
  },
  {
    "prefixo": "76700",
    "uf": "GO",
    "codigoIbge": 5214002,
    "cidade": "Mozarlândia"
  },
  {
    "prefixo": "76710",
    "uf": "GO",
    "codigoIbge": 5202502,
    "cidade": "Aruanã"
  },
  {
    "prefixo": "76720",
    "uf": "GO",
    "codigoIbge": 5202155,
    "cidade": "Araguapaz"
  },
  {
    "prefixo": "76729",
    "uf": "GO",
    "codigoIbge": 5202155,
    "cidade": "Araguapaz"
  },
  {
    "prefixo": "76730",
    "uf": "GO",
    "codigoIbge": 5212956,
    "cidade": "Matrinchã"
  },
  {
    "prefixo": "76740",
    "uf": "GO",
    "codigoIbge": 5207535,
    "cidade": "Faina"
  },
  {
    "prefixo": "76742",
    "uf": "GO",
    "codigoIbge": 5207535,
    "cidade": "Faina"
  },
  {
    "prefixo": "76744",
    "uf": "GO",
    "codigoIbge": 5207535,
    "cidade": "Faina"
  },
  {
    "prefixo": "76801",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76802",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76803",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76804",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76805",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76806",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76807",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76808",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76809",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76810",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76811",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76812",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76813",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76814",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76815",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76816",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76817",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76820",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76821",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76822",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76823",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76824",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76825",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76828",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76829",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76834",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76835",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76836",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76837",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76840",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76841",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76842",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76843",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76845",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76846",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76847",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76848",
    "uf": "RO",
    "codigoIbge": 1100205,
    "cidade": "Porto Velho"
  },
  {
    "prefixo": "76850",
    "uf": "RO",
    "codigoIbge": 1100106,
    "cidade": "Guajará-Mirim"
  },
  {
    "prefixo": "76856",
    "uf": "RO",
    "codigoIbge": 1100106,
    "cidade": "Guajará-Mirim"
  },
  {
    "prefixo": "76857",
    "uf": "RO",
    "codigoIbge": 1100338,
    "cidade": "Nova Mamoré"
  },
  {
    "prefixo": "76858",
    "uf": "RO",
    "codigoIbge": 1100338,
    "cidade": "Nova Mamoré"
  },
  {
    "prefixo": "76859",
    "uf": "RO",
    "codigoIbge": 1100338,
    "cidade": "Nova Mamoré"
  },
  {
    "prefixo": "76860",
    "uf": "RO",
    "codigoIbge": 1100809,
    "cidade": "Candeias do Jamari"
  },
  {
    "prefixo": "76861",
    "uf": "RO",
    "codigoIbge": 1101104,
    "cidade": "Itapuã do Oeste"
  },
  {
    "prefixo": "76862",
    "uf": "RO",
    "codigoIbge": 1100403,
    "cidade": "Alto Paraíso"
  },
  {
    "prefixo": "76863",
    "uf": "RO",
    "codigoIbge": 1100262,
    "cidade": "Rio Crespo"
  },
  {
    "prefixo": "76864",
    "uf": "RO",
    "codigoIbge": 1100940,
    "cidade": "Cujubim"
  },
  {
    "prefixo": "76866",
    "uf": "RO",
    "codigoIbge": 1101609,
    "cidade": "Theobroma"
  },
  {
    "prefixo": "76867",
    "uf": "RO",
    "codigoIbge": 1101757,
    "cidade": "Vale do Anari"
  },
  {
    "prefixo": "76868",
    "uf": "RO",
    "codigoIbge": 1100130,
    "cidade": "Machadinho D'Oeste"
  },
  {
    "prefixo": "76869",
    "uf": "RO",
    "codigoIbge": 1100130,
    "cidade": "Machadinho D'Oeste"
  },
  {
    "prefixo": "76870",
    "uf": "RO",
    "codigoIbge": 1100023,
    "cidade": "Ariquemes"
  },
  {
    "prefixo": "76871",
    "uf": "RO",
    "codigoIbge": 1100023,
    "cidade": "Ariquemes"
  },
  {
    "prefixo": "76872",
    "uf": "RO",
    "codigoIbge": 1100023,
    "cidade": "Ariquemes"
  },
  {
    "prefixo": "76873",
    "uf": "RO",
    "codigoIbge": 1100023,
    "cidade": "Ariquemes"
  },
  {
    "prefixo": "76874",
    "uf": "RO",
    "codigoIbge": 1100023,
    "cidade": "Ariquemes"
  },
  {
    "prefixo": "76875",
    "uf": "RO",
    "codigoIbge": 1100023,
    "cidade": "Ariquemes"
  },
  {
    "prefixo": "76876",
    "uf": "RO",
    "codigoIbge": 1100023,
    "cidade": "Ariquemes"
  },
  {
    "prefixo": "76877",
    "uf": "RO",
    "codigoIbge": 1100023,
    "cidade": "Ariquemes"
  },
  {
    "prefixo": "76878",
    "uf": "RO",
    "codigoIbge": 1100023,
    "cidade": "Ariquemes"
  },
  {
    "prefixo": "76879",
    "uf": "RO",
    "codigoIbge": 1100023,
    "cidade": "Ariquemes"
  },
  {
    "prefixo": "76880",
    "uf": "RO",
    "codigoIbge": 1100452,
    "cidade": "Buritis"
  },
  {
    "prefixo": "76887",
    "uf": "RO",
    "codigoIbge": 1100700,
    "cidade": "Campo Novo de Rondônia"
  },
  {
    "prefixo": "76888",
    "uf": "RO",
    "codigoIbge": 1101401,
    "cidade": "Monte Negro"
  },
  {
    "prefixo": "76889",
    "uf": "RO",
    "codigoIbge": 1100601,
    "cidade": "Cacaulândia"
  },
  {
    "prefixo": "76890",
    "uf": "RO",
    "codigoIbge": 1100114,
    "cidade": "Jaru"
  },
  {
    "prefixo": "76897",
    "uf": "RO",
    "codigoIbge": 1100114,
    "cidade": "Jaru"
  },
  {
    "prefixo": "76898",
    "uf": "RO",
    "codigoIbge": 1101005,
    "cidade": "Governador Jorge Teixeira"
  },
  {
    "prefixo": "76899",
    "uf": "RO",
    "codigoIbge": 1101005,
    "cidade": "Governador Jorge Teixeira"
  },
  {
    "prefixo": "76900",
    "uf": "RO",
    "codigoIbge": 1100122,
    "cidade": "Ji-Paraná"
  },
  {
    "prefixo": "76901",
    "uf": "RO",
    "codigoIbge": 1100122,
    "cidade": "Ji-Paraná"
  },
  {
    "prefixo": "76904",
    "uf": "RO",
    "codigoIbge": 1100122,
    "cidade": "Ji-Paraná"
  },
  {
    "prefixo": "76906",
    "uf": "RO",
    "codigoIbge": 1100122,
    "cidade": "Ji-Paraná"
  },
  {
    "prefixo": "76907",
    "uf": "RO",
    "codigoIbge": 1100122,
    "cidade": "Ji-Paraná"
  },
  {
    "prefixo": "76908",
    "uf": "RO",
    "codigoIbge": 1100122,
    "cidade": "Ji-Paraná"
  },
  {
    "prefixo": "76909",
    "uf": "RO",
    "codigoIbge": 1100122,
    "cidade": "Ji-Paraná"
  },
  {
    "prefixo": "76912",
    "uf": "RO",
    "codigoIbge": 1100122,
    "cidade": "Ji-Paraná"
  },
  {
    "prefixo": "76913",
    "uf": "RO",
    "codigoIbge": 1100122,
    "cidade": "Ji-Paraná"
  },
  {
    "prefixo": "76914",
    "uf": "RO",
    "codigoIbge": 1100122,
    "cidade": "Ji-Paraná"
  },
  {
    "prefixo": "76915",
    "uf": "RO",
    "codigoIbge": 1100122,
    "cidade": "Ji-Paraná"
  },
  {
    "prefixo": "76916",
    "uf": "RO",
    "codigoIbge": 1100254,
    "cidade": "Presidente Médici"
  },
  {
    "prefixo": "76919",
    "uf": "RO",
    "codigoIbge": 1101203,
    "cidade": "Ministro Andreazza"
  },
  {
    "prefixo": "76920",
    "uf": "RO",
    "codigoIbge": 1100155,
    "cidade": "Ouro Preto do Oeste"
  },
  {
    "prefixo": "76923",
    "uf": "RO",
    "codigoIbge": 1101807,
    "cidade": "Vale do Paraíso"
  },
  {
    "prefixo": "76924",
    "uf": "RO",
    "codigoIbge": 1101435,
    "cidade": "Nova União"
  },
  {
    "prefixo": "76926",
    "uf": "RO",
    "codigoIbge": 1101302,
    "cidade": "Mirante da Serra"
  },
  {
    "prefixo": "76928",
    "uf": "RO",
    "codigoIbge": 1101559,
    "cidade": "Teixeirópolis"
  },
  {
    "prefixo": "76929",
    "uf": "RO",
    "codigoIbge": 1101708,
    "cidade": "Urupá"
  },
  {
    "prefixo": "76930",
    "uf": "RO",
    "codigoIbge": 1100346,
    "cidade": "Alvorada D'Oeste"
  },
  {
    "prefixo": "76932",
    "uf": "RO",
    "codigoIbge": 1100320,
    "cidade": "São Miguel do Guaporé"
  },
  {
    "prefixo": "76933",
    "uf": "RO",
    "codigoIbge": 1100320,
    "cidade": "São Miguel do Guaporé"
  },
  {
    "prefixo": "76934",
    "uf": "RO",
    "codigoIbge": 1101500,
    "cidade": "Seringueiras"
  },
  {
    "prefixo": "76935",
    "uf": "RO",
    "codigoIbge": 1101492,
    "cidade": "São Francisco do Guaporé"
  },
  {
    "prefixo": "76936",
    "uf": "RO",
    "codigoIbge": 1101492,
    "cidade": "São Francisco do Guaporé"
  },
  {
    "prefixo": "76937",
    "uf": "RO",
    "codigoIbge": 1100080,
    "cidade": "Costa Marques"
  },
  {
    "prefixo": "76939",
    "uf": "RO",
    "codigoIbge": 1100080,
    "cidade": "Costa Marques"
  },
  {
    "prefixo": "76940",
    "uf": "RO",
    "codigoIbge": 1100288,
    "cidade": "Rolim de Moura"
  },
  {
    "prefixo": "76948",
    "uf": "RO",
    "codigoIbge": 1100908,
    "cidade": "Castanheiras"
  },
  {
    "prefixo": "76950",
    "uf": "RO",
    "codigoIbge": 1100296,
    "cidade": "Santa Luzia D'Oeste"
  },
  {
    "prefixo": "76952",
    "uf": "RO",
    "codigoIbge": 1100379,
    "cidade": "Alto Alegre dos Parecis"
  },
  {
    "prefixo": "76954",
    "uf": "RO",
    "codigoIbge": 1100015,
    "cidade": "Alta Floresta D'Oeste"
  },
  {
    "prefixo": "76956",
    "uf": "RO",
    "codigoIbge": 1100502,
    "cidade": "Novo Horizonte do Oeste"
  },
  {
    "prefixo": "76958",
    "uf": "RO",
    "codigoIbge": 1100148,
    "cidade": "Nova Brasilândia D'Oeste"
  },
  {
    "prefixo": "76959",
    "uf": "RO",
    "codigoIbge": 1100148,
    "cidade": "Nova Brasilândia D'Oeste"
  },
  {
    "prefixo": "76960",
    "uf": "RO",
    "codigoIbge": 1100049,
    "cidade": "Cacoal"
  },
  {
    "prefixo": "76961",
    "uf": "RO",
    "codigoIbge": 1100049,
    "cidade": "Cacoal"
  },
  {
    "prefixo": "76962",
    "uf": "RO",
    "codigoIbge": 1100049,
    "cidade": "Cacoal"
  },
  {
    "prefixo": "76963",
    "uf": "RO",
    "codigoIbge": 1100049,
    "cidade": "Cacoal"
  },
  {
    "prefixo": "76964",
    "uf": "RO",
    "codigoIbge": 1100049,
    "cidade": "Cacoal"
  },
  {
    "prefixo": "76965",
    "uf": "RO",
    "codigoIbge": 1100049,
    "cidade": "Cacoal"
  },
  {
    "prefixo": "76966",
    "uf": "RO",
    "codigoIbge": 1100049,
    "cidade": "Cacoal"
  },
  {
    "prefixo": "76967",
    "uf": "RO",
    "codigoIbge": 1100049,
    "cidade": "Cacoal"
  },
  {
    "prefixo": "76968",
    "uf": "RO",
    "codigoIbge": 1100049,
    "cidade": "Cacoal"
  },
  {
    "prefixo": "76969",
    "uf": "RO",
    "codigoIbge": 1100049,
    "cidade": "Cacoal"
  },
  {
    "prefixo": "76970",
    "uf": "RO",
    "codigoIbge": 1100189,
    "cidade": "Pimenta Bueno"
  },
  {
    "prefixo": "76973",
    "uf": "RO",
    "codigoIbge": 1100189,
    "cidade": "Pimenta Bueno"
  },
  {
    "prefixo": "76974",
    "uf": "RO",
    "codigoIbge": 1100098,
    "cidade": "Espigão D'Oeste"
  },
  {
    "prefixo": "76975",
    "uf": "RO",
    "codigoIbge": 1100098,
    "cidade": "Espigão D'Oeste"
  },
  {
    "prefixo": "76976",
    "uf": "RO",
    "codigoIbge": 1101476,
    "cidade": "Primavera de Rondônia"
  },
  {
    "prefixo": "76977",
    "uf": "RO",
    "codigoIbge": 1101484,
    "cidade": "São Felipe D'Oeste"
  },
  {
    "prefixo": "76979",
    "uf": "RO",
    "codigoIbge": 1101450,
    "cidade": "Parecis"
  },
  {
    "prefixo": "76980",
    "uf": "RO",
    "codigoIbge": 1100304,
    "cidade": "Vilhena"
  },
  {
    "prefixo": "76981",
    "uf": "RO",
    "codigoIbge": 1100304,
    "cidade": "Vilhena"
  },
  {
    "prefixo": "76982",
    "uf": "RO",
    "codigoIbge": 1100304,
    "cidade": "Vilhena"
  },
  {
    "prefixo": "76983",
    "uf": "RO",
    "codigoIbge": 1100304,
    "cidade": "Vilhena"
  },
  {
    "prefixo": "76984",
    "uf": "RO",
    "codigoIbge": 1100304,
    "cidade": "Vilhena"
  },
  {
    "prefixo": "76985",
    "uf": "RO",
    "codigoIbge": 1100304,
    "cidade": "Vilhena"
  },
  {
    "prefixo": "76986",
    "uf": "RO",
    "codigoIbge": 1100304,
    "cidade": "Vilhena"
  },
  {
    "prefixo": "76987",
    "uf": "RO",
    "codigoIbge": 1100304,
    "cidade": "Vilhena"
  },
  {
    "prefixo": "76988",
    "uf": "RO",
    "codigoIbge": 1100304,
    "cidade": "Vilhena"
  },
  {
    "prefixo": "76989",
    "uf": "RO",
    "codigoIbge": 1100304,
    "cidade": "Vilhena"
  },
  {
    "prefixo": "76990",
    "uf": "RO",
    "codigoIbge": 1100924,
    "cidade": "Chupinguaia"
  },
  {
    "prefixo": "76992",
    "uf": "RO",
    "codigoIbge": 1100924,
    "cidade": "Chupinguaia"
  },
  {
    "prefixo": "76993",
    "uf": "RO",
    "codigoIbge": 1100064,
    "cidade": "Colorado do Oeste"
  },
  {
    "prefixo": "76994",
    "uf": "RO",
    "codigoIbge": 1100031,
    "cidade": "Cabixi"
  },
  {
    "prefixo": "76995",
    "uf": "RO",
    "codigoIbge": 1100072,
    "cidade": "Corumbiara"
  },
  {
    "prefixo": "76996",
    "uf": "RO",
    "codigoIbge": 1100072,
    "cidade": "Corumbiara"
  },
  {
    "prefixo": "76997",
    "uf": "RO",
    "codigoIbge": 1100056,
    "cidade": "Cerejeiras"
  },
  {
    "prefixo": "76999",
    "uf": "RO",
    "codigoIbge": 1101468,
    "cidade": "Pimenteiras do Oeste"
  },
  {
    "prefixo": "77001",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77002",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77003",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77005",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77006",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77007",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77008",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77015",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77016",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77017",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77018",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77019",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77020",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77021",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77022",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77023",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77024",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77025",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77026",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77027",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77059",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77060",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77061",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77062",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77063",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77064",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77066",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77080",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77090",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77249",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77260",
    "uf": "TO",
    "codigoIbge": 1721000,
    "cidade": "Palmas"
  },
  {
    "prefixo": "77300",
    "uf": "TO",
    "codigoIbge": 1707009,
    "cidade": "Dianópolis"
  },
  {
    "prefixo": "77303",
    "uf": "TO",
    "codigoIbge": 1718659,
    "cidade": "Rio da Conceição"
  },
  {
    "prefixo": "77305",
    "uf": "TO",
    "codigoIbge": 1705607,
    "cidade": "Conceição do Tocantins"
  },
  {
    "prefixo": "77308",
    "uf": "TO",
    "codigoIbge": 1720937,
    "cidade": "Taipas do Tocantins"
  },
  {
    "prefixo": "77310",
    "uf": "TO",
    "codigoIbge": 1700400,
    "cidade": "Almas"
  },
  {
    "prefixo": "77315",
    "uf": "TO",
    "codigoIbge": 1717800,
    "cidade": "Ponte Alta do Bom Jesus"
  },
  {
    "prefixo": "77318",
    "uf": "TO",
    "codigoIbge": 1715259,
    "cidade": "Novo Jardim"
  },
  {
    "prefixo": "77320",
    "uf": "TO",
    "codigoIbge": 1720903,
    "cidade": "Taguatinga"
  },
  {
    "prefixo": "77325",
    "uf": "TO",
    "codigoIbge": 1702703,
    "cidade": "Aurora do Tocantins"
  },
  {
    "prefixo": "77328",
    "uf": "TO",
    "codigoIbge": 1712157,
    "cidade": "Lavandeira"
  },
  {
    "prefixo": "77330",
    "uf": "TO",
    "codigoIbge": 1702406,
    "cidade": "Arraias"
  },
  {
    "prefixo": "77333",
    "uf": "TO",
    "codigoIbge": 1702406,
    "cidade": "Arraias"
  },
  {
    "prefixo": "77350",
    "uf": "TO",
    "codigoIbge": 1705557,
    "cidade": "Combinado"
  },
  {
    "prefixo": "77353",
    "uf": "TO",
    "codigoIbge": 1715150,
    "cidade": "Novo Alegre"
  },
  {
    "prefixo": "77360",
    "uf": "TO",
    "codigoIbge": 1716208,
    "cidade": "Paranã"
  },
  {
    "prefixo": "77365",
    "uf": "TO",
    "codigoIbge": 1715754,
    "cidade": "Palmeirópolis"
  },
  {
    "prefixo": "77368",
    "uf": "TO",
    "codigoIbge": 1720259,
    "cidade": "São Salvador do Tocantins"
  },
  {
    "prefixo": "77370",
    "uf": "TO",
    "codigoIbge": 1714203,
    "cidade": "Natividade"
  },
  {
    "prefixo": "77373",
    "uf": "TO",
    "codigoIbge": 1714203,
    "cidade": "Natividade"
  },
  {
    "prefixo": "77375",
    "uf": "TO",
    "codigoIbge": 1718907,
    "cidade": "Santa Rosa do Tocantins"
  },
  {
    "prefixo": "77378",
    "uf": "TO",
    "codigoIbge": 1705102,
    "cidade": "Chapada da Natividade"
  },
  {
    "prefixo": "77380",
    "uf": "TO",
    "codigoIbge": 1717008,
    "cidade": "Pindorama do Tocantins"
  },
  {
    "prefixo": "77390",
    "uf": "TO",
    "codigoIbge": 1720499,
    "cidade": "São Valério"
  },
  {
    "prefixo": "77393",
    "uf": "TO",
    "codigoIbge": 1720499,
    "cidade": "São Valério"
  },
  {
    "prefixo": "77395",
    "uf": "TO",
    "codigoIbge": 1718006,
    "cidade": "Porto Alegre do Tocantins"
  },
  {
    "prefixo": "77400",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77402",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77403",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77404",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77405",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77410",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77411",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77412",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77413",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77414",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77415",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77416",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77418",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77420",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77421",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77422",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77423",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77424",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77425",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77426",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77427",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77428",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77430",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77433",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77434",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77435",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77439",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77440",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77441",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77445",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77448",
    "uf": "TO",
    "codigoIbge": 1709500,
    "cidade": "Gurupi"
  },
  {
    "prefixo": "77450",
    "uf": "TO",
    "codigoIbge": 1711506,
    "cidade": "Jaú do Tocantins"
  },
  {
    "prefixo": "77453",
    "uf": "TO",
    "codigoIbge": 1703867,
    "cidade": "Cariri do Tocantins"
  },
  {
    "prefixo": "77455",
    "uf": "TO",
    "codigoIbge": 1700350,
    "cidade": "Aliança do Tocantins"
  },
  {
    "prefixo": "77458",
    "uf": "TO",
    "codigoIbge": 1720853,
    "cidade": "Sucupira"
  },
  {
    "prefixo": "77460",
    "uf": "TO",
    "codigoIbge": 1716604,
    "cidade": "Peixe"
  },
  {
    "prefixo": "77463",
    "uf": "TO",
    "codigoIbge": 1706258,
    "cidade": "Crixás do Tocantins"
  },
  {
    "prefixo": "77465",
    "uf": "TO",
    "codigoIbge": 1707652,
    "cidade": "Figueirópolis"
  },
  {
    "prefixo": "77470",
    "uf": "TO",
    "codigoIbge": 1708205,
    "cidade": "Formoso do Araguaia"
  },
  {
    "prefixo": "77475",
    "uf": "TO",
    "codigoIbge": 1702000,
    "cidade": "Araguaçu"
  },
  {
    "prefixo": "77478",
    "uf": "TO",
    "codigoIbge": 1718840,
    "cidade": "Sandolândia"
  },
  {
    "prefixo": "77480",
    "uf": "TO",
    "codigoIbge": 1700707,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "77483",
    "uf": "TO",
    "codigoIbge": 1720978,
    "cidade": "Talismã"
  },
  {
    "prefixo": "77485",
    "uf": "TO",
    "codigoIbge": 1707306,
    "cidade": "Dueré"
  },
  {
    "prefixo": "77490",
    "uf": "TO",
    "codigoIbge": 1706100,
    "cidade": "Cristalândia"
  },
  {
    "prefixo": "77493",
    "uf": "TO",
    "codigoIbge": 1711902,
    "cidade": "Lagoa da Confusão"
  },
  {
    "prefixo": "77495",
    "uf": "TO",
    "codigoIbge": 1715002,
    "cidade": "Nova Rosalândia"
  },
  {
    "prefixo": "77500",
    "uf": "TO",
    "codigoIbge": 1718204,
    "cidade": "Porto Nacional"
  },
  {
    "prefixo": "77502",
    "uf": "TO",
    "codigoIbge": 1718204,
    "cidade": "Porto Nacional"
  },
  {
    "prefixo": "77553",
    "uf": "TO",
    "codigoIbge": 1709807,
    "cidade": "Ipueiras"
  },
  {
    "prefixo": "77555",
    "uf": "TO",
    "codigoIbge": 1707553,
    "cidade": "Fátima"
  },
  {
    "prefixo": "77558",
    "uf": "TO",
    "codigoIbge": 1715507,
    "cidade": "Oliveira de Fátima"
  },
  {
    "prefixo": "77560",
    "uf": "TO",
    "codigoIbge": 1703701,
    "cidade": "Brejinho de Nazaré"
  },
  {
    "prefixo": "77565",
    "uf": "TO",
    "codigoIbge": 1718899,
    "cidade": "Santa Rita do Tocantins"
  },
  {
    "prefixo": "77570",
    "uf": "TO",
    "codigoIbge": 1717503,
    "cidade": "Pium"
  },
  {
    "prefixo": "77575",
    "uf": "TO",
    "codigoIbge": 1704600,
    "cidade": "Chapada de Areia"
  },
  {
    "prefixo": "77580",
    "uf": "TO",
    "codigoIbge": 1720655,
    "cidade": "Silvanópolis"
  },
  {
    "prefixo": "77585",
    "uf": "TO",
    "codigoIbge": 1713601,
    "cidade": "Monte do Carmo"
  },
  {
    "prefixo": "77590",
    "uf": "TO",
    "codigoIbge": 1717909,
    "cidade": "Ponte Alta do Tocantins"
  },
  {
    "prefixo": "77593",
    "uf": "TO",
    "codigoIbge": 1712702,
    "cidade": "Mateiros"
  },
  {
    "prefixo": "77600",
    "uf": "TO",
    "codigoIbge": 1716109,
    "cidade": "Paraíso do Tocantins"
  },
  {
    "prefixo": "77603",
    "uf": "TO",
    "codigoIbge": 1718451,
    "cidade": "Pugmil"
  },
  {
    "prefixo": "77605",
    "uf": "TO",
    "codigoIbge": 1720150,
    "cidade": "São Félix do Tocantins"
  },
  {
    "prefixo": "77610",
    "uf": "TO",
    "codigoIbge": 1715101,
    "cidade": "Novo Acordo"
  },
  {
    "prefixo": "77613",
    "uf": "TO",
    "codigoIbge": 1711951,
    "cidade": "Lagoa do Tocantins"
  },
  {
    "prefixo": "77615",
    "uf": "TO",
    "codigoIbge": 1719004,
    "cidade": "Santa Tereza do Tocantins"
  },
  {
    "prefixo": "77620",
    "uf": "TO",
    "codigoIbge": 1701101,
    "cidade": "Aparecida do Rio Negro"
  },
  {
    "prefixo": "77630",
    "uf": "TO",
    "codigoIbge": 1712405,
    "cidade": "Lizarda"
  },
  {
    "prefixo": "77635",
    "uf": "TO",
    "codigoIbge": 1718758,
    "cidade": "Rio Sono"
  },
  {
    "prefixo": "77640",
    "uf": "TO",
    "codigoIbge": 1721109,
    "cidade": "Tocantínia"
  },
  {
    "prefixo": "77645",
    "uf": "TO",
    "codigoIbge": 1712009,
    "cidade": "Lajeado"
  },
  {
    "prefixo": "77650",
    "uf": "TO",
    "codigoIbge": 1713205,
    "cidade": "Miracema do Tocantins"
  },
  {
    "prefixo": "77654",
    "uf": "TO",
    "codigoIbge": 1713205,
    "cidade": "Miracema do Tocantins"
  },
  {
    "prefixo": "77655",
    "uf": "TO",
    "codigoIbge": 1718709,
    "cidade": "Rio dos Bois"
  },
  {
    "prefixo": "77660",
    "uf": "TO",
    "codigoIbge": 1713304,
    "cidade": "Miranorte"
  },
  {
    "prefixo": "77665",
    "uf": "TO",
    "codigoIbge": 1703107,
    "cidade": "Barrolândia"
  },
  {
    "prefixo": "77670",
    "uf": "TO",
    "codigoIbge": 1707108,
    "cidade": "Divinópolis do Tocantins"
  },
  {
    "prefixo": "77673",
    "uf": "TO",
    "codigoIbge": 1713700,
    "cidade": "Monte Santo do Tocantins"
  },
  {
    "prefixo": "77675",
    "uf": "TO",
    "codigoIbge": 1712504,
    "cidade": "Marianópolis do Tocantins"
  },
  {
    "prefixo": "77680",
    "uf": "TO",
    "codigoIbge": 1703909,
    "cidade": "Caseara"
  },
  {
    "prefixo": "77683",
    "uf": "TO",
    "codigoIbge": 1703909,
    "cidade": "Caseara"
  },
  {
    "prefixo": "77685",
    "uf": "TO",
    "codigoIbge": 1707207,
    "cidade": "Dois Irmãos do Tocantins"
  },
  {
    "prefixo": "77690",
    "uf": "TO",
    "codigoIbge": 1701903,
    "cidade": "Araguacema"
  },
  {
    "prefixo": "77693",
    "uf": "TO",
    "codigoIbge": 1700251,
    "cidade": "Abreulândia"
  },
  {
    "prefixo": "77695",
    "uf": "TO",
    "codigoIbge": 1708304,
    "cidade": "Goianorte"
  },
  {
    "prefixo": "77700",
    "uf": "TO",
    "codigoIbge": 1709302,
    "cidade": "Guaraí"
  },
  {
    "prefixo": "77704",
    "uf": "TO",
    "codigoIbge": 1721257,
    "cidade": "Tupirama"
  },
  {
    "prefixo": "77708",
    "uf": "TO",
    "codigoIbge": 1708254,
    "cidade": "Tabocão"
  },
  {
    "prefixo": "77710",
    "uf": "TO",
    "codigoIbge": 1716505,
    "cidade": "Pedro Afonso"
  },
  {
    "prefixo": "77712",
    "uf": "TO",
    "codigoIbge": 1716505,
    "cidade": "Pedro Afonso"
  },
  {
    "prefixo": "77714",
    "uf": "TO",
    "codigoIbge": 1703305,
    "cidade": "Bom Jesus do Tocantins"
  },
  {
    "prefixo": "77716",
    "uf": "TO",
    "codigoIbge": 1718881,
    "cidade": "Santa Maria do Tocantins"
  },
  {
    "prefixo": "77718",
    "uf": "TO",
    "codigoIbge": 1710904,
    "cidade": "Itapiratins"
  },
  {
    "prefixo": "77720",
    "uf": "TO",
    "codigoIbge": 1710508,
    "cidade": "Itacajá"
  },
  {
    "prefixo": "77723",
    "uf": "TO",
    "codigoIbge": 1704105,
    "cidade": "Centenário"
  },
  {
    "prefixo": "77725",
    "uf": "TO",
    "codigoIbge": 1716703,
    "cidade": "Colméia"
  },
  {
    "prefixo": "77730",
    "uf": "TO",
    "codigoIbge": 1716653,
    "cidade": "Pequizeiro"
  },
  {
    "prefixo": "77733",
    "uf": "TO",
    "codigoIbge": 1718501,
    "cidade": "Recursolândia"
  },
  {
    "prefixo": "77735",
    "uf": "TO",
    "codigoIbge": 1703602,
    "cidade": "Brasilândia do Tocantins"
  },
  {
    "prefixo": "77740",
    "uf": "TO",
    "codigoIbge": 1711100,
    "cidade": "Itaporã do Tocantins"
  },
  {
    "prefixo": "77743",
    "uf": "TO",
    "codigoIbge": 1721307,
    "cidade": "Tupiratins"
  },
  {
    "prefixo": "77745",
    "uf": "TO",
    "codigoIbge": 1718402,
    "cidade": "Presidente Kennedy"
  },
  {
    "prefixo": "77750",
    "uf": "TO",
    "codigoIbge": 1706001,
    "cidade": "Couto Magalhães"
  },
  {
    "prefixo": "77753",
    "uf": "TO",
    "codigoIbge": 1711803,
    "cidade": "Juarina"
  },
  {
    "prefixo": "77755",
    "uf": "TO",
    "codigoIbge": 1703206,
    "cidade": "Bernardo Sayão"
  },
  {
    "prefixo": "77760",
    "uf": "TO",
    "codigoIbge": 1705508,
    "cidade": "Colinas do Tocantins"
  },
  {
    "prefixo": "77765",
    "uf": "TO",
    "codigoIbge": 1703073,
    "cidade": "Barra do Ouro"
  },
  {
    "prefixo": "77770",
    "uf": "TO",
    "codigoIbge": 1709005,
    "cidade": "Goiatins"
  },
  {
    "prefixo": "77772",
    "uf": "TO",
    "codigoIbge": 1709005,
    "cidade": "Goiatins"
  },
  {
    "prefixo": "77776",
    "uf": "TO",
    "codigoIbge": 1709005,
    "cidade": "Goiatins"
  },
  {
    "prefixo": "77777",
    "uf": "TO",
    "codigoIbge": 1703842,
    "cidade": "Campos Lindos"
  },
  {
    "prefixo": "77780",
    "uf": "TO",
    "codigoIbge": 1702307,
    "cidade": "Arapoema"
  },
  {
    "prefixo": "77783",
    "uf": "TO",
    "codigoIbge": 1703057,
    "cidade": "Bandeirantes do Tocantins"
  },
  {
    "prefixo": "77785",
    "uf": "TO",
    "codigoIbge": 1716307,
    "cidade": "Pau D'Arco"
  },
  {
    "prefixo": "77790",
    "uf": "TO",
    "codigoIbge": 1714880,
    "cidade": "Nova Olinda"
  },
  {
    "prefixo": "77795",
    "uf": "TO",
    "codigoIbge": 1707702,
    "cidade": "Filadélfia"
  },
  {
    "prefixo": "77798",
    "uf": "TO",
    "codigoIbge": 1715705,
    "cidade": "Palmeirante"
  },
  {
    "prefixo": "77803",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77804",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77805",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77807",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77808",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77809",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77810",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77813",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77814",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77815",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77816",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77817",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77818",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77819",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77820",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77822",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77823",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77824",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77825",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77826",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77827",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77828",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77829",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77834",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77835",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77836",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77837",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77838",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77839",
    "uf": "TO",
    "codigoIbge": 1702109,
    "cidade": "Araguaína"
  },
  {
    "prefixo": "77840",
    "uf": "TO",
    "codigoIbge": 1703883,
    "cidade": "Carmolândia"
  },
  {
    "prefixo": "77845",
    "uf": "TO",
    "codigoIbge": 1701309,
    "cidade": "Aragominas"
  },
  {
    "prefixo": "77848",
    "uf": "TO",
    "codigoIbge": 1718865,
    "cidade": "Santa Fé do Araguaia"
  },
  {
    "prefixo": "77850",
    "uf": "TO",
    "codigoIbge": 1713957,
    "cidade": "Muricilândia"
  },
  {
    "prefixo": "77855",
    "uf": "TO",
    "codigoIbge": 1702158,
    "cidade": "Araguanã"
  },
  {
    "prefixo": "77860",
    "uf": "TO",
    "codigoIbge": 1722081,
    "cidade": "Wanderlândia"
  },
  {
    "prefixo": "77870",
    "uf": "TO",
    "codigoIbge": 1703008,
    "cidade": "Babaçulândia"
  },
  {
    "prefixo": "77880",
    "uf": "TO",
    "codigoIbge": 1722107,
    "cidade": "Xambioá"
  },
  {
    "prefixo": "77885",
    "uf": "TO",
    "codigoIbge": 1720002,
    "cidade": "Santa Terezinha do Tocantins"
  },
  {
    "prefixo": "77888",
    "uf": "TO",
    "codigoIbge": 1717206,
    "cidade": "Piraquê"
  },
  {
    "prefixo": "77890",
    "uf": "TO",
    "codigoIbge": 1701002,
    "cidade": "Ananás"
  },
  {
    "prefixo": "77893",
    "uf": "TO",
    "codigoIbge": 1718550,
    "cidade": "Riachinho"
  },
  {
    "prefixo": "77895",
    "uf": "TO",
    "codigoIbge": 1714302,
    "cidade": "Nazaré"
  },
  {
    "prefixo": "77898",
    "uf": "TO",
    "codigoIbge": 1714302,
    "cidade": "Nazaré"
  },
  {
    "prefixo": "77900",
    "uf": "TO",
    "codigoIbge": 1721208,
    "cidade": "Tocantinópolis"
  },
  {
    "prefixo": "77903",
    "uf": "TO",
    "codigoIbge": 1712454,
    "cidade": "Luzinópolis"
  },
  {
    "prefixo": "77905",
    "uf": "TO",
    "codigoIbge": 1701051,
    "cidade": "Angico"
  },
  {
    "prefixo": "77908",
    "uf": "TO",
    "codigoIbge": 1700301,
    "cidade": "Aguiarnópolis"
  },
  {
    "prefixo": "77910",
    "uf": "TO",
    "codigoIbge": 1706506,
    "cidade": "Darcinópolis"
  },
  {
    "prefixo": "77913",
    "uf": "TO",
    "codigoIbge": 1713809,
    "cidade": "Palmeiras do Tocantins"
  },
  {
    "prefixo": "77915",
    "uf": "TO",
    "codigoIbge": 1703826,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "77918",
    "uf": "TO",
    "codigoIbge": 1712801,
    "cidade": "Maurilândia do Tocantins"
  },
  {
    "prefixo": "77920",
    "uf": "TO",
    "codigoIbge": 1710706,
    "cidade": "Itaguatins"
  },
  {
    "prefixo": "77925",
    "uf": "TO",
    "codigoIbge": 1720200,
    "cidade": "São Miguel do Tocantins"
  },
  {
    "prefixo": "77930",
    "uf": "TO",
    "codigoIbge": 1702901,
    "cidade": "Axixá do Tocantins"
  },
  {
    "prefixo": "77940",
    "uf": "TO",
    "codigoIbge": 1720804,
    "cidade": "Sítio Novo do Tocantins"
  },
  {
    "prefixo": "77950",
    "uf": "TO",
    "codigoIbge": 1702208,
    "cidade": "Araguatins"
  },
  {
    "prefixo": "77953",
    "uf": "TO",
    "codigoIbge": 1702208,
    "cidade": "Araguatins"
  },
  {
    "prefixo": "77958",
    "uf": "TO",
    "codigoIbge": 1720101,
    "cidade": "São Bento do Tocantins"
  },
  {
    "prefixo": "77960",
    "uf": "TO",
    "codigoIbge": 1702554,
    "cidade": "Augustinópolis"
  },
  {
    "prefixo": "77970",
    "uf": "TO",
    "codigoIbge": 1718303,
    "cidade": "Praia Norte"
  },
  {
    "prefixo": "77980",
    "uf": "TO",
    "codigoIbge": 1718808,
    "cidade": "Sampaio"
  },
  {
    "prefixo": "77985",
    "uf": "TO",
    "codigoIbge": 1703891,
    "cidade": "Carrasco Bonito"
  },
  {
    "prefixo": "77990",
    "uf": "TO",
    "codigoIbge": 1720309,
    "cidade": "São Sebastião do Tocantins"
  },
  {
    "prefixo": "77993",
    "uf": "TO",
    "codigoIbge": 1707405,
    "cidade": "Esperantina"
  },
  {
    "prefixo": "77995",
    "uf": "TO",
    "codigoIbge": 1703800,
    "cidade": "Buriti do Tocantins"
  },
  {
    "prefixo": "78005",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78008",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78010",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78015",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78020",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78025",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78028",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78030",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78031",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78032",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78035",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78040",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78042",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78043",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78045",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78048",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78049",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78050",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78051",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78052",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78053",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78055",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78056",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78057",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78058",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78060",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78061",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78065",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78068",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78070",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78074",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78075",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78076",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78077",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78080",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78085",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78087",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78088",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78089",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78090",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78091",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78092",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78093",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78094",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78095",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78096",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78097",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78098",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78099",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78101",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78102",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78104",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78105",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78106",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78108",
    "uf": "MT",
    "codigoIbge": 5103403,
    "cidade": "Cuiabá"
  },
  {
    "prefixo": "78110",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78115",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78116",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78117",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78118",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78120",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78121",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78125",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78128",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78130",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78131",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78132",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78134",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78135",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78138",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78140",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78141",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78142",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78143",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78144",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78145",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78148",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78149",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78150",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78152",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78158",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78164",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78165",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78166",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78167",
    "uf": "MT",
    "codigoIbge": 5108402,
    "cidade": "Várzea Grande"
  },
  {
    "prefixo": "78170",
    "uf": "MT",
    "codigoIbge": 5106109,
    "cidade": "Nossa Senhora do Livramento"
  },
  {
    "prefixo": "78171",
    "uf": "MT",
    "codigoIbge": 5106109,
    "cidade": "Nossa Senhora do Livramento"
  },
  {
    "prefixo": "78172",
    "uf": "MT",
    "codigoIbge": 5106109,
    "cidade": "Nossa Senhora do Livramento"
  },
  {
    "prefixo": "78173",
    "uf": "MT",
    "codigoIbge": 5106109,
    "cidade": "Nossa Senhora do Livramento"
  },
  {
    "prefixo": "78175",
    "uf": "MT",
    "codigoIbge": 5106505,
    "cidade": "Poconé"
  },
  {
    "prefixo": "78177",
    "uf": "MT",
    "codigoIbge": 5106505,
    "cidade": "Poconé"
  },
  {
    "prefixo": "78178",
    "uf": "MT",
    "codigoIbge": 5106505,
    "cidade": "Poconé"
  },
  {
    "prefixo": "78180",
    "uf": "MT",
    "codigoIbge": 5107800,
    "cidade": "Santo Antônio de Leverger"
  },
  {
    "prefixo": "78181",
    "uf": "MT",
    "codigoIbge": 5107800,
    "cidade": "Santo Antônio de Leverger"
  },
  {
    "prefixo": "78182",
    "uf": "MT",
    "codigoIbge": 5107800,
    "cidade": "Santo Antônio de Leverger"
  },
  {
    "prefixo": "78184",
    "uf": "MT",
    "codigoIbge": 5107800,
    "cidade": "Santo Antônio de Leverger"
  },
  {
    "prefixo": "78186",
    "uf": "MT",
    "codigoIbge": 5107800,
    "cidade": "Santo Antônio de Leverger"
  },
  {
    "prefixo": "78188",
    "uf": "MT",
    "codigoIbge": 5107800,
    "cidade": "Santo Antônio de Leverger"
  },
  {
    "prefixo": "78190",
    "uf": "MT",
    "codigoIbge": 5101605,
    "cidade": "Barão de Melgaço"
  },
  {
    "prefixo": "78192",
    "uf": "MT",
    "codigoIbge": 5101605,
    "cidade": "Barão de Melgaço"
  },
  {
    "prefixo": "78195",
    "uf": "MT",
    "codigoIbge": 5103007,
    "cidade": "Chapada dos Guimarães"
  },
  {
    "prefixo": "78197",
    "uf": "MT",
    "codigoIbge": 5103007,
    "cidade": "Chapada dos Guimarães"
  },
  {
    "prefixo": "78198",
    "uf": "MT",
    "codigoIbge": 5103007,
    "cidade": "Chapada dos Guimarães"
  },
  {
    "prefixo": "78199",
    "uf": "MT",
    "codigoIbge": 5103007,
    "cidade": "Chapada dos Guimarães"
  },
  {
    "prefixo": "78200",
    "uf": "MT",
    "codigoIbge": 5102504,
    "cidade": "Cáceres"
  },
  {
    "prefixo": "78201",
    "uf": "MT",
    "codigoIbge": 5102504,
    "cidade": "Cáceres"
  },
  {
    "prefixo": "78202",
    "uf": "MT",
    "codigoIbge": 5102504,
    "cidade": "Cáceres"
  },
  {
    "prefixo": "78205",
    "uf": "MT",
    "codigoIbge": 5102504,
    "cidade": "Cáceres"
  },
  {
    "prefixo": "78206",
    "uf": "MT",
    "codigoIbge": 5102504,
    "cidade": "Cáceres"
  },
  {
    "prefixo": "78210",
    "uf": "MT",
    "codigoIbge": 5102504,
    "cidade": "Cáceres"
  },
  {
    "prefixo": "78211",
    "uf": "MT",
    "codigoIbge": 5102504,
    "cidade": "Cáceres"
  },
  {
    "prefixo": "78216",
    "uf": "MT",
    "codigoIbge": 5102504,
    "cidade": "Cáceres"
  },
  {
    "prefixo": "78217",
    "uf": "MT",
    "codigoIbge": 5102504,
    "cidade": "Cáceres"
  },
  {
    "prefixo": "78218",
    "uf": "MT",
    "codigoIbge": 5102504,
    "cidade": "Cáceres"
  },
  {
    "prefixo": "78219",
    "uf": "MT",
    "codigoIbge": 5102504,
    "cidade": "Cáceres"
  },
  {
    "prefixo": "78233",
    "uf": "MT",
    "codigoIbge": 5102504,
    "cidade": "Cáceres"
  },
  {
    "prefixo": "78234",
    "uf": "MT",
    "codigoIbge": 5102504,
    "cidade": "Cáceres"
  },
  {
    "prefixo": "78235",
    "uf": "MT",
    "codigoIbge": 5102504,
    "cidade": "Cáceres"
  },
  {
    "prefixo": "78236",
    "uf": "MT",
    "codigoIbge": 5102504,
    "cidade": "Cáceres"
  },
  {
    "prefixo": "78237",
    "uf": "MT",
    "codigoIbge": 5103437,
    "cidade": "Curvelândia"
  },
  {
    "prefixo": "78240",
    "uf": "MT",
    "codigoIbge": 5106828,
    "cidade": "Porto Esperidião"
  },
  {
    "prefixo": "78242",
    "uf": "MT",
    "codigoIbge": 5106828,
    "cidade": "Porto Esperidião"
  },
  {
    "prefixo": "78243",
    "uf": "MT",
    "codigoIbge": 5106182,
    "cidade": "Nova Lacerda"
  },
  {
    "prefixo": "78245",
    "uf": "MT",
    "codigoIbge": 5105507,
    "cidade": "Vila Bela da Santíssima Trindade"
  },
  {
    "prefixo": "78246",
    "uf": "MT",
    "codigoIbge": 5105507,
    "cidade": "Vila Bela da Santíssima Trindade"
  },
  {
    "prefixo": "78248",
    "uf": "MT",
    "codigoIbge": 5105507,
    "cidade": "Vila Bela da Santíssima Trindade"
  },
  {
    "prefixo": "78250",
    "uf": "MT",
    "codigoIbge": 5106752,
    "cidade": "Pontes e Lacerda"
  },
  {
    "prefixo": "78253",
    "uf": "MT",
    "codigoIbge": 5108352,
    "cidade": "Vale de São Domingos"
  },
  {
    "prefixo": "78254",
    "uf": "MT",
    "codigoIbge": 5103361,
    "cidade": "Conquista D'Oeste"
  },
  {
    "prefixo": "78255",
    "uf": "MT",
    "codigoIbge": 5105002,
    "cidade": "Jauru"
  },
  {
    "prefixo": "78258",
    "uf": "MT",
    "codigoIbge": 5105002,
    "cidade": "Jauru"
  },
  {
    "prefixo": "78260",
    "uf": "MT",
    "codigoIbge": 5101258,
    "cidade": "Araputanga"
  },
  {
    "prefixo": "78265",
    "uf": "MT",
    "codigoIbge": 5107156,
    "cidade": "Reserva do Cabaçal"
  },
  {
    "prefixo": "78270",
    "uf": "MT",
    "codigoIbge": 5107750,
    "cidade": "Salto do Céu"
  },
  {
    "prefixo": "78272",
    "uf": "MT",
    "codigoIbge": 5107750,
    "cidade": "Salto do Céu"
  },
  {
    "prefixo": "78274",
    "uf": "MT",
    "codigoIbge": 5107750,
    "cidade": "Salto do Céu"
  },
  {
    "prefixo": "78275",
    "uf": "MT",
    "codigoIbge": 5107206,
    "cidade": "Rio Branco"
  },
  {
    "prefixo": "78278",
    "uf": "MT",
    "codigoIbge": 5105234,
    "cidade": "Lambari D'Oeste"
  },
  {
    "prefixo": "78279",
    "uf": "MT",
    "codigoIbge": 5103437,
    "cidade": "Curvelândia"
  },
  {
    "prefixo": "78280",
    "uf": "MT",
    "codigoIbge": 5105622,
    "cidade": "Mirassol d'Oeste"
  },
  {
    "prefixo": "78284",
    "uf": "MT",
    "codigoIbge": 5105622,
    "cidade": "Mirassol d'Oeste"
  },
  {
    "prefixo": "78285",
    "uf": "MT",
    "codigoIbge": 5107107,
    "cidade": "São José dos Quatro Marcos"
  },
  {
    "prefixo": "78290",
    "uf": "MT",
    "codigoIbge": 5103809,
    "cidade": "Figueirópolis D'Oeste"
  },
  {
    "prefixo": "78293",
    "uf": "MT",
    "codigoIbge": 5103957,
    "cidade": "Glória D'Oeste"
  },
  {
    "prefixo": "78294",
    "uf": "MT",
    "codigoIbge": 5103957,
    "cidade": "Glória D'Oeste"
  },
  {
    "prefixo": "78295",
    "uf": "MT",
    "codigoIbge": 5104500,
    "cidade": "Indiavaí"
  },
  {
    "prefixo": "78300",
    "uf": "MT",
    "codigoIbge": 5107958,
    "cidade": "Tangará da Serra"
  },
  {
    "prefixo": "78301",
    "uf": "MT",
    "codigoIbge": 5107958,
    "cidade": "Tangará da Serra"
  },
  {
    "prefixo": "78302",
    "uf": "MT",
    "codigoIbge": 5107958,
    "cidade": "Tangará da Serra"
  },
  {
    "prefixo": "78303",
    "uf": "MT",
    "codigoIbge": 5107958,
    "cidade": "Tangará da Serra"
  },
  {
    "prefixo": "78304",
    "uf": "MT",
    "codigoIbge": 5107958,
    "cidade": "Tangará da Serra"
  },
  {
    "prefixo": "78305",
    "uf": "MT",
    "codigoIbge": 5107958,
    "cidade": "Tangará da Serra"
  },
  {
    "prefixo": "78306",
    "uf": "MT",
    "codigoIbge": 5107958,
    "cidade": "Tangará da Serra"
  },
  {
    "prefixo": "78307",
    "uf": "MT",
    "codigoIbge": 5102686,
    "cidade": "Campos de Júlio"
  },
  {
    "prefixo": "78310",
    "uf": "MT",
    "codigoIbge": 5103304,
    "cidade": "Comodoro"
  },
  {
    "prefixo": "78311",
    "uf": "MT",
    "codigoIbge": 5103304,
    "cidade": "Comodoro"
  },
  {
    "prefixo": "78313",
    "uf": "MT",
    "codigoIbge": 5103304,
    "cidade": "Comodoro"
  },
  {
    "prefixo": "78314",
    "uf": "MT",
    "codigoIbge": 5103304,
    "cidade": "Comodoro"
  },
  {
    "prefixo": "78316",
    "uf": "MT",
    "codigoIbge": 5103304,
    "cidade": "Comodoro"
  },
  {
    "prefixo": "78318",
    "uf": "MT",
    "codigoIbge": 5103304,
    "cidade": "Comodoro"
  },
  {
    "prefixo": "78319",
    "uf": "MT",
    "codigoIbge": 5103304,
    "cidade": "Comodoro"
  },
  {
    "prefixo": "78320",
    "uf": "MT",
    "codigoIbge": 5105150,
    "cidade": "Juína"
  },
  {
    "prefixo": "78321",
    "uf": "MT",
    "codigoIbge": 5105150,
    "cidade": "Juína"
  },
  {
    "prefixo": "78322",
    "uf": "MT",
    "codigoIbge": 5105150,
    "cidade": "Juína"
  },
  {
    "prefixo": "78325",
    "uf": "MT",
    "codigoIbge": 5101407,
    "cidade": "Aripuanã"
  },
  {
    "prefixo": "78326",
    "uf": "MT",
    "codigoIbge": 5101407,
    "cidade": "Aripuanã"
  },
  {
    "prefixo": "78328",
    "uf": "MT",
    "codigoIbge": 5101407,
    "cidade": "Aripuanã"
  },
  {
    "prefixo": "78330",
    "uf": "MT",
    "codigoIbge": 5103379,
    "cidade": "Cotriguaçu"
  },
  {
    "prefixo": "78331",
    "uf": "MT",
    "codigoIbge": 5103379,
    "cidade": "Cotriguaçu"
  },
  {
    "prefixo": "78335",
    "uf": "MT",
    "codigoIbge": 5103254,
    "cidade": "Colniza"
  },
  {
    "prefixo": "78336",
    "uf": "MT",
    "codigoIbge": 5103254,
    "cidade": "Colniza"
  },
  {
    "prefixo": "78337",
    "uf": "MT",
    "codigoIbge": 5103254,
    "cidade": "Colniza"
  },
  {
    "prefixo": "78338",
    "uf": "MT",
    "codigoIbge": 5107578,
    "cidade": "Rondolândia"
  },
  {
    "prefixo": "78339",
    "uf": "MT",
    "codigoIbge": 5107578,
    "cidade": "Rondolândia"
  },
  {
    "prefixo": "78340",
    "uf": "MT",
    "codigoIbge": 5105176,
    "cidade": "Juruena"
  },
  {
    "prefixo": "78345",
    "uf": "MT",
    "codigoIbge": 5102850,
    "cidade": "Castanheira"
  },
  {
    "prefixo": "78348",
    "uf": "MT",
    "codigoIbge": 5102850,
    "cidade": "Castanheira"
  },
  {
    "prefixo": "78350",
    "uf": "MT",
    "codigoIbge": 5101902,
    "cidade": "Brasnorte"
  },
  {
    "prefixo": "78358",
    "uf": "MT",
    "codigoIbge": 5101902,
    "cidade": "Brasnorte"
  },
  {
    "prefixo": "78360",
    "uf": "MT",
    "codigoIbge": 5102637,
    "cidade": "Campo Novo do Parecis"
  },
  {
    "prefixo": "78364",
    "uf": "MT",
    "codigoIbge": 5102637,
    "cidade": "Campo Novo do Parecis"
  },
  {
    "prefixo": "78365",
    "uf": "MT",
    "codigoIbge": 5107875,
    "cidade": "Sapezal"
  },
  {
    "prefixo": "78370",
    "uf": "MT",
    "codigoIbge": 5106232,
    "cidade": "Nova Olímpia"
  },
  {
    "prefixo": "78380",
    "uf": "MT",
    "codigoIbge": 5103452,
    "cidade": "Denise"
  },
  {
    "prefixo": "78390",
    "uf": "MT",
    "codigoIbge": 5101704,
    "cidade": "Barra do Bugres"
  },
  {
    "prefixo": "78394",
    "uf": "MT",
    "codigoIbge": 5101704,
    "cidade": "Barra do Bugres"
  },
  {
    "prefixo": "78396",
    "uf": "MT",
    "codigoIbge": 5101704,
    "cidade": "Barra do Bugres"
  },
  {
    "prefixo": "78398",
    "uf": "MT",
    "codigoIbge": 5106851,
    "cidade": "Porto Estrela"
  },
  {
    "prefixo": "78400",
    "uf": "MT",
    "codigoIbge": 5103502,
    "cidade": "Diamantino"
  },
  {
    "prefixo": "78401",
    "uf": "MT",
    "codigoIbge": 5103502,
    "cidade": "Diamantino"
  },
  {
    "prefixo": "78402",
    "uf": "MT",
    "codigoIbge": 5103502,
    "cidade": "Diamantino"
  },
  {
    "prefixo": "78404",
    "uf": "MT",
    "codigoIbge": 5103502,
    "cidade": "Diamantino"
  },
  {
    "prefixo": "78405",
    "uf": "MT",
    "codigoIbge": 5103502,
    "cidade": "Diamantino"
  },
  {
    "prefixo": "78410",
    "uf": "MT",
    "codigoIbge": 5100508,
    "cidade": "Alto Paraguai"
  },
  {
    "prefixo": "78411",
    "uf": "MT",
    "codigoIbge": 5100508,
    "cidade": "Alto Paraguai"
  },
  {
    "prefixo": "78414",
    "uf": "MT",
    "codigoIbge": 5100508,
    "cidade": "Alto Paraguai"
  },
  {
    "prefixo": "78415",
    "uf": "MT",
    "codigoIbge": 5108857,
    "cidade": "Nova Marilândia"
  },
  {
    "prefixo": "78420",
    "uf": "MT",
    "codigoIbge": 5101308,
    "cidade": "Arenápolis"
  },
  {
    "prefixo": "78425",
    "uf": "MT",
    "codigoIbge": 5107263,
    "cidade": "Santo Afonso"
  },
  {
    "prefixo": "78430",
    "uf": "MT",
    "codigoIbge": 5106000,
    "cidade": "Nortelândia"
  },
  {
    "prefixo": "78435",
    "uf": "MT",
    "codigoIbge": 5107305,
    "cidade": "São José do Rio Claro"
  },
  {
    "prefixo": "78437",
    "uf": "MT",
    "codigoIbge": 5107305,
    "cidade": "São José do Rio Claro"
  },
  {
    "prefixo": "78445",
    "uf": "MT",
    "codigoIbge": 5108907,
    "cidade": "Nova Maringá"
  },
  {
    "prefixo": "78450",
    "uf": "MT",
    "codigoIbge": 5106224,
    "cidade": "Nova Mutum"
  },
  {
    "prefixo": "78452",
    "uf": "MT",
    "codigoIbge": 5106224,
    "cidade": "Nova Mutum"
  },
  {
    "prefixo": "78453",
    "uf": "MT",
    "codigoIbge": 5106224,
    "cidade": "Nova Mutum"
  },
  {
    "prefixo": "78454",
    "uf": "MT",
    "codigoIbge": 5106224,
    "cidade": "Nova Mutum"
  },
  {
    "prefixo": "78455",
    "uf": "MT",
    "codigoIbge": 5105259,
    "cidade": "Lucas do Rio Verde"
  },
  {
    "prefixo": "78456",
    "uf": "MT",
    "codigoIbge": 5106224,
    "cidade": "Nova Mutum"
  },
  {
    "prefixo": "78457",
    "uf": "MT",
    "codigoIbge": 5106224,
    "cidade": "Nova Mutum"
  },
  {
    "prefixo": "78459",
    "uf": "MT",
    "codigoIbge": 5105259,
    "cidade": "Lucas do Rio Verde"
  },
  {
    "prefixo": "78460",
    "uf": "MT",
    "codigoIbge": 5105903,
    "cidade": "Nobres"
  },
  {
    "prefixo": "78461",
    "uf": "MT",
    "codigoIbge": 5105903,
    "cidade": "Nobres"
  },
  {
    "prefixo": "78462",
    "uf": "MT",
    "codigoIbge": 5105259,
    "cidade": "Lucas do Rio Verde"
  },
  {
    "prefixo": "78463",
    "uf": "MT",
    "codigoIbge": 5105903,
    "cidade": "Nobres"
  },
  {
    "prefixo": "78464",
    "uf": "MT",
    "codigoIbge": 5105259,
    "cidade": "Lucas do Rio Verde"
  },
  {
    "prefixo": "78466",
    "uf": "MT",
    "codigoIbge": 5105259,
    "cidade": "Lucas do Rio Verde"
  },
  {
    "prefixo": "78470",
    "uf": "MT",
    "codigoIbge": 5107701,
    "cidade": "Rosário Oeste"
  },
  {
    "prefixo": "78473",
    "uf": "MT",
    "codigoIbge": 5107701,
    "cidade": "Rosário Oeste"
  },
  {
    "prefixo": "78474",
    "uf": "MT",
    "codigoIbge": 5107701,
    "cidade": "Rosário Oeste"
  },
  {
    "prefixo": "78478",
    "uf": "MT",
    "codigoIbge": 5107701,
    "cidade": "Rosário Oeste"
  },
  {
    "prefixo": "78480",
    "uf": "MT",
    "codigoIbge": 5100102,
    "cidade": "Acorizal"
  },
  {
    "prefixo": "78481",
    "uf": "MT",
    "codigoIbge": 5100102,
    "cidade": "Acorizal"
  },
  {
    "prefixo": "78483",
    "uf": "MT",
    "codigoIbge": 5100102,
    "cidade": "Acorizal"
  },
  {
    "prefixo": "78489",
    "uf": "MT",
    "codigoIbge": 5100102,
    "cidade": "Acorizal"
  },
  {
    "prefixo": "78490",
    "uf": "MT",
    "codigoIbge": 5104906,
    "cidade": "Jangada"
  },
  {
    "prefixo": "78500",
    "uf": "MT",
    "codigoIbge": 5103205,
    "cidade": "Colíder"
  },
  {
    "prefixo": "78502",
    "uf": "MT",
    "codigoIbge": 5103205,
    "cidade": "Colíder"
  },
  {
    "prefixo": "78505",
    "uf": "MT",
    "codigoIbge": 5108055,
    "cidade": "Terra Nova do Norte"
  },
  {
    "prefixo": "78506",
    "uf": "MT",
    "codigoIbge": 5108055,
    "cidade": "Terra Nova do Norte"
  },
  {
    "prefixo": "78507",
    "uf": "MT",
    "codigoIbge": 5108055,
    "cidade": "Terra Nova do Norte"
  },
  {
    "prefixo": "78508",
    "uf": "MT",
    "codigoIbge": 5108808,
    "cidade": "Nova Guarita"
  },
  {
    "prefixo": "78510",
    "uf": "MT",
    "codigoIbge": 5104559,
    "cidade": "Itaúba"
  },
  {
    "prefixo": "78515",
    "uf": "MT",
    "codigoIbge": 5106216,
    "cidade": "Nova Canaã do Norte"
  },
  {
    "prefixo": "78518",
    "uf": "MT",
    "codigoIbge": 5106216,
    "cidade": "Nova Canaã do Norte"
  },
  {
    "prefixo": "78520",
    "uf": "MT",
    "codigoIbge": 5104104,
    "cidade": "Guarantã do Norte"
  },
  {
    "prefixo": "78522",
    "uf": "MT",
    "codigoIbge": 5104104,
    "cidade": "Guarantã do Norte"
  },
  {
    "prefixo": "78525",
    "uf": "MT",
    "codigoIbge": 5105606,
    "cidade": "Matupá"
  },
  {
    "prefixo": "78527",
    "uf": "MT",
    "codigoIbge": 5105606,
    "cidade": "Matupá"
  },
  {
    "prefixo": "78528",
    "uf": "MT",
    "codigoIbge": 5106265,
    "cidade": "Novo Mundo"
  },
  {
    "prefixo": "78530",
    "uf": "MT",
    "codigoIbge": 5106422,
    "cidade": "Peixoto de Azevedo"
  },
  {
    "prefixo": "78533",
    "uf": "MT",
    "codigoIbge": 5106422,
    "cidade": "Peixoto de Azevedo"
  },
  {
    "prefixo": "78535",
    "uf": "MT",
    "codigoIbge": 5105580,
    "cidade": "Marcelândia"
  },
  {
    "prefixo": "78536",
    "uf": "MT",
    "codigoIbge": 5105580,
    "cidade": "Marcelândia"
  },
  {
    "prefixo": "78538",
    "uf": "MT",
    "codigoIbge": 5105580,
    "cidade": "Marcelândia"
  },
  {
    "prefixo": "78540",
    "uf": "MT",
    "codigoIbge": 5103056,
    "cidade": "Cláudia"
  },
  {
    "prefixo": "78543",
    "uf": "MT",
    "codigoIbge": 5108303,
    "cidade": "União do Sul"
  },
  {
    "prefixo": "78545",
    "uf": "MT",
    "codigoIbge": 5107248,
    "cidade": "Santa Carmem"
  },
  {
    "prefixo": "78548",
    "uf": "MT",
    "codigoIbge": 5106190,
    "cidade": "Nova Santa Helena"
  },
  {
    "prefixo": "78550",
    "uf": "MT",
    "codigoIbge": 5107909,
    "cidade": "Sinop"
  },
  {
    "prefixo": "78551",
    "uf": "MT",
    "codigoIbge": 5107909,
    "cidade": "Sinop"
  },
  {
    "prefixo": "78552",
    "uf": "MT",
    "codigoIbge": 5107909,
    "cidade": "Sinop"
  },
  {
    "prefixo": "78553",
    "uf": "MT",
    "codigoIbge": 5107909,
    "cidade": "Sinop"
  },
  {
    "prefixo": "78554",
    "uf": "MT",
    "codigoIbge": 5107909,
    "cidade": "Sinop"
  },
  {
    "prefixo": "78555",
    "uf": "MT",
    "codigoIbge": 5107909,
    "cidade": "Sinop"
  },
  {
    "prefixo": "78556",
    "uf": "MT",
    "codigoIbge": 5107909,
    "cidade": "Sinop"
  },
  {
    "prefixo": "78557",
    "uf": "MT",
    "codigoIbge": 5107909,
    "cidade": "Sinop"
  },
  {
    "prefixo": "78558",
    "uf": "MT",
    "codigoIbge": 5107909,
    "cidade": "Sinop"
  },
  {
    "prefixo": "78559",
    "uf": "MT",
    "codigoIbge": 5107909,
    "cidade": "Sinop"
  },
  {
    "prefixo": "78560",
    "uf": "MT",
    "codigoIbge": 5106802,
    "cidade": "Porto dos Gaúchos"
  },
  {
    "prefixo": "78563",
    "uf": "MT",
    "codigoIbge": 5107941,
    "cidade": "Tabaporã"
  },
  {
    "prefixo": "78565",
    "uf": "MT",
    "codigoIbge": 5106158,
    "cidade": "Nova Bandeirantes"
  },
  {
    "prefixo": "78569",
    "uf": "MT",
    "codigoIbge": 5106158,
    "cidade": "Nova Bandeirantes"
  },
  {
    "prefixo": "78570",
    "uf": "MT",
    "codigoIbge": 5106273,
    "cidade": "Novo Horizonte do Norte"
  },
  {
    "prefixo": "78573",
    "uf": "MT",
    "codigoIbge": 5108006,
    "cidade": "Tapurah"
  },
  {
    "prefixo": "78574",
    "uf": "MT",
    "codigoIbge": 5108006,
    "cidade": "Tapurah"
  },
  {
    "prefixo": "78575",
    "uf": "MT",
    "codigoIbge": 5105101,
    "cidade": "Juara"
  },
  {
    "prefixo": "78577",
    "uf": "MT",
    "codigoIbge": 5105101,
    "cidade": "Juara"
  },
  {
    "prefixo": "78578",
    "uf": "MT",
    "codigoIbge": 5104526,
    "cidade": "Ipiranga do Norte"
  },
  {
    "prefixo": "78579",
    "uf": "MT",
    "codigoIbge": 5104542,
    "cidade": "Itanhangá"
  },
  {
    "prefixo": "78580",
    "uf": "MT",
    "codigoIbge": 5100250,
    "cidade": "Alta Floresta"
  },
  {
    "prefixo": "78585",
    "uf": "MT",
    "codigoIbge": 5100250,
    "cidade": "Alta Floresta"
  },
  {
    "prefixo": "78587",
    "uf": "MT",
    "codigoIbge": 5102793,
    "cidade": "Carlinda"
  },
  {
    "prefixo": "78590",
    "uf": "MT",
    "codigoIbge": 5106299,
    "cidade": "Paranaíta"
  },
  {
    "prefixo": "78593",
    "uf": "MT",
    "codigoIbge": 5108956,
    "cidade": "Nova Monte Verde"
  },
  {
    "prefixo": "78594",
    "uf": "MT",
    "codigoIbge": 5108956,
    "cidade": "Nova Monte Verde"
  },
  {
    "prefixo": "78595",
    "uf": "MT",
    "codigoIbge": 5100805,
    "cidade": "Apiacás"
  },
  {
    "prefixo": "78600",
    "uf": "MT",
    "codigoIbge": 5101803,
    "cidade": "Barra do Garças"
  },
  {
    "prefixo": "78601",
    "uf": "MT",
    "codigoIbge": 5101803,
    "cidade": "Barra do Garças"
  },
  {
    "prefixo": "78603",
    "uf": "MT",
    "codigoIbge": 5101803,
    "cidade": "Barra do Garças"
  },
  {
    "prefixo": "78605",
    "uf": "MT",
    "codigoIbge": 5101803,
    "cidade": "Barra do Garças"
  },
  {
    "prefixo": "78606",
    "uf": "MT",
    "codigoIbge": 5101803,
    "cidade": "Barra do Garças"
  },
  {
    "prefixo": "78607",
    "uf": "MT",
    "codigoIbge": 5101803,
    "cidade": "Barra do Garças"
  },
  {
    "prefixo": "78608",
    "uf": "MT",
    "codigoIbge": 5101803,
    "cidade": "Barra do Garças"
  },
  {
    "prefixo": "78609",
    "uf": "MT",
    "codigoIbge": 5103908,
    "cidade": "General Carneiro"
  },
  {
    "prefixo": "78610",
    "uf": "MT",
    "codigoIbge": 5106703,
    "cidade": "Ponte Branca"
  },
  {
    "prefixo": "78613",
    "uf": "MT",
    "codigoIbge": 5107198,
    "cidade": "Ribeirãozinho"
  },
  {
    "prefixo": "78615",
    "uf": "MT",
    "codigoIbge": 5101209,
    "cidade": "Araguainha"
  },
  {
    "prefixo": "78620",
    "uf": "MT",
    "codigoIbge": 5103908,
    "cidade": "General Carneiro"
  },
  {
    "prefixo": "78623",
    "uf": "MT",
    "codigoIbge": 5103908,
    "cidade": "General Carneiro"
  },
  {
    "prefixo": "78625",
    "uf": "MT",
    "codigoIbge": 5106281,
    "cidade": "Novo São Joaquim"
  },
  {
    "prefixo": "78628",
    "uf": "MT",
    "codigoIbge": 5107792,
    "cidade": "Santo Antônio do Leste"
  },
  {
    "prefixo": "78630",
    "uf": "MT",
    "codigoIbge": 5102603,
    "cidade": "Campinápolis"
  },
  {
    "prefixo": "78635",
    "uf": "MT",
    "codigoIbge": 5100201,
    "cidade": "Água Boa"
  },
  {
    "prefixo": "78636",
    "uf": "MT",
    "codigoIbge": 5100201,
    "cidade": "Água Boa"
  },
  {
    "prefixo": "78638",
    "uf": "MT",
    "codigoIbge": 5106174,
    "cidade": "Nova Nazaré"
  },
  {
    "prefixo": "78640",
    "uf": "MT",
    "codigoIbge": 5102702,
    "cidade": "Canarana"
  },
  {
    "prefixo": "78643",
    "uf": "MT",
    "codigoIbge": 5107065,
    "cidade": "Querência"
  },
  {
    "prefixo": "78645",
    "uf": "MT",
    "codigoIbge": 5108600,
    "cidade": "Vila Rica"
  },
  {
    "prefixo": "78648",
    "uf": "MT",
    "codigoIbge": 5108600,
    "cidade": "Vila Rica"
  },
  {
    "prefixo": "78650",
    "uf": "MT",
    "codigoIbge": 5107776,
    "cidade": "Santa Terezinha"
  },
  {
    "prefixo": "78652",
    "uf": "MT",
    "codigoIbge": 5103353,
    "cidade": "Confresa"
  },
  {
    "prefixo": "78653",
    "uf": "MT",
    "codigoIbge": 5103353,
    "cidade": "Confresa"
  },
  {
    "prefixo": "78655",
    "uf": "MT",
    "codigoIbge": 5106778,
    "cidade": "Porto Alegre do Norte"
  },
  {
    "prefixo": "78658",
    "uf": "MT",
    "codigoIbge": 5102694,
    "cidade": "Canabrava do Norte"
  },
  {
    "prefixo": "78660",
    "uf": "MT",
    "codigoIbge": 5105309,
    "cidade": "Luciara"
  },
  {
    "prefixo": "78663",
    "uf": "MT",
    "codigoIbge": 5107354,
    "cidade": "São José do Xingu"
  },
  {
    "prefixo": "78664",
    "uf": "MT",
    "codigoIbge": 5107743,
    "cidade": "Santa Cruz do Xingu"
  },
  {
    "prefixo": "78665",
    "uf": "MT",
    "codigoIbge": 5100359,
    "cidade": "Alto Boa Vista"
  },
  {
    "prefixo": "78668",
    "uf": "MT",
    "codigoIbge": 5107883,
    "cidade": "Serra Nova Dourada"
  },
  {
    "prefixo": "78670",
    "uf": "MT",
    "codigoIbge": 5107859,
    "cidade": "São Félix do Araguaia"
  },
  {
    "prefixo": "78672",
    "uf": "MT",
    "codigoIbge": 5107859,
    "cidade": "São Félix do Araguaia"
  },
  {
    "prefixo": "78673",
    "uf": "MT",
    "codigoIbge": 5107859,
    "cidade": "São Félix do Araguaia"
  },
  {
    "prefixo": "78674",
    "uf": "MT",
    "codigoIbge": 5106315,
    "cidade": "Novo Santo Antônio"
  },
  {
    "prefixo": "78675",
    "uf": "MT",
    "codigoIbge": 5107180,
    "cidade": "Ribeirão Cascalheira"
  },
  {
    "prefixo": "78678",
    "uf": "MT",
    "codigoIbge": 5101852,
    "cidade": "Bom Jesus do Araguaia"
  },
  {
    "prefixo": "78680",
    "uf": "MT",
    "codigoIbge": 5103106,
    "cidade": "Cocalinho"
  },
  {
    "prefixo": "78685",
    "uf": "MT",
    "codigoIbge": 5101001,
    "cidade": "Araguaiana"
  },
  {
    "prefixo": "78690",
    "uf": "MT",
    "codigoIbge": 5106257,
    "cidade": "Nova Xavantina"
  },
  {
    "prefixo": "78691",
    "uf": "MT",
    "codigoIbge": 5106257,
    "cidade": "Nova Xavantina"
  },
  {
    "prefixo": "78695",
    "uf": "MT",
    "codigoIbge": 5108204,
    "cidade": "Torixoréu"
  },
  {
    "prefixo": "78698",
    "uf": "MT",
    "codigoIbge": 5106653,
    "cidade": "Pontal do Araguaia"
  },
  {
    "prefixo": "78700",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78705",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78710",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78711",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78714",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78715",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78716",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78717",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78718",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78719",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78720",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78721",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78725",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78730",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78731",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78734",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78735",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78736",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78739",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78740",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78744",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78745",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78746",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78747",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78749",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78750",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78751",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78752",
    "uf": "MT",
    "codigoIbge": 5107602,
    "cidade": "Rondonópolis"
  },
  {
    "prefixo": "78760",
    "uf": "MT",
    "codigoIbge": 5104203,
    "cidade": "Guiratinga"
  },
  {
    "prefixo": "78762",
    "uf": "MT",
    "codigoIbge": 5104203,
    "cidade": "Guiratinga"
  },
  {
    "prefixo": "78766",
    "uf": "MT",
    "codigoIbge": 5104203,
    "cidade": "Guiratinga"
  },
  {
    "prefixo": "78768",
    "uf": "MT",
    "codigoIbge": 5104203,
    "cidade": "Guiratinga"
  },
  {
    "prefixo": "78770",
    "uf": "MT",
    "codigoIbge": 5100409,
    "cidade": "Alto Garças"
  },
  {
    "prefixo": "78773",
    "uf": "MT",
    "codigoIbge": 5107297,
    "cidade": "São José do Povo"
  },
  {
    "prefixo": "78775",
    "uf": "MT",
    "codigoIbge": 5108105,
    "cidade": "Tesouro"
  },
  {
    "prefixo": "78776",
    "uf": "MT",
    "codigoIbge": 5108105,
    "cidade": "Tesouro"
  },
  {
    "prefixo": "78778",
    "uf": "MT",
    "codigoIbge": 5108105,
    "cidade": "Tesouro"
  },
  {
    "prefixo": "78780",
    "uf": "MT",
    "codigoIbge": 5100300,
    "cidade": "Alto Araguaia"
  },
  {
    "prefixo": "78785",
    "uf": "MT",
    "codigoIbge": 5100607,
    "cidade": "Alto Taquari"
  },
  {
    "prefixo": "78790",
    "uf": "MT",
    "codigoIbge": 5104609,
    "cidade": "Itiquira"
  },
  {
    "prefixo": "78795",
    "uf": "MT",
    "codigoIbge": 5106372,
    "cidade": "Pedra Preta"
  },
  {
    "prefixo": "78798",
    "uf": "MT",
    "codigoIbge": 5106372,
    "cidade": "Pedra Preta"
  },
  {
    "prefixo": "78800",
    "uf": "MT",
    "codigoIbge": 5107008,
    "cidade": "Poxoréu"
  },
  {
    "prefixo": "78803",
    "uf": "MT",
    "codigoIbge": 5107008,
    "cidade": "Poxoréu"
  },
  {
    "prefixo": "78806",
    "uf": "MT",
    "codigoIbge": 5107008,
    "cidade": "Poxoréu"
  },
  {
    "prefixo": "78808",
    "uf": "MT",
    "codigoIbge": 5107008,
    "cidade": "Poxoréu"
  },
  {
    "prefixo": "78810",
    "uf": "MT",
    "codigoIbge": 5105200,
    "cidade": "Juscimeira"
  },
  {
    "prefixo": "78813",
    "uf": "MT",
    "codigoIbge": 5105200,
    "cidade": "Juscimeira"
  },
  {
    "prefixo": "78816",
    "uf": "MT",
    "codigoIbge": 5105200,
    "cidade": "Juscimeira"
  },
  {
    "prefixo": "78818",
    "uf": "MT",
    "codigoIbge": 5105200,
    "cidade": "Juscimeira"
  },
  {
    "prefixo": "78820",
    "uf": "MT",
    "codigoIbge": 5104807,
    "cidade": "Jaciara"
  },
  {
    "prefixo": "78823",
    "uf": "MT",
    "codigoIbge": 5104807,
    "cidade": "Jaciara"
  },
  {
    "prefixo": "78828",
    "uf": "MT",
    "codigoIbge": 5104807,
    "cidade": "Jaciara"
  },
  {
    "prefixo": "78830",
    "uf": "MT",
    "codigoIbge": 5103601,
    "cidade": "Dom Aquino"
  },
  {
    "prefixo": "78833",
    "uf": "MT",
    "codigoIbge": 5103601,
    "cidade": "Dom Aquino"
  },
  {
    "prefixo": "78834",
    "uf": "MT",
    "codigoIbge": 5103601,
    "cidade": "Dom Aquino"
  },
  {
    "prefixo": "78835",
    "uf": "MT",
    "codigoIbge": 5107404,
    "cidade": "São Pedro da Cipa"
  },
  {
    "prefixo": "78840",
    "uf": "MT",
    "codigoIbge": 5102678,
    "cidade": "Campo Verde"
  },
  {
    "prefixo": "78841",
    "uf": "MT",
    "codigoIbge": 5102678,
    "cidade": "Campo Verde"
  },
  {
    "prefixo": "78842",
    "uf": "MT",
    "codigoIbge": 5102678,
    "cidade": "Campo Verde"
  },
  {
    "prefixo": "78843",
    "uf": "MT",
    "codigoIbge": 5102678,
    "cidade": "Campo Verde"
  },
  {
    "prefixo": "78844",
    "uf": "MT",
    "codigoIbge": 5102678,
    "cidade": "Campo Verde"
  },
  {
    "prefixo": "78845",
    "uf": "MT",
    "codigoIbge": 5102678,
    "cidade": "Campo Verde"
  },
  {
    "prefixo": "78846",
    "uf": "MT",
    "codigoIbge": 5102678,
    "cidade": "Campo Verde"
  },
  {
    "prefixo": "78850",
    "uf": "MT",
    "codigoIbge": 5107040,
    "cidade": "Primavera do Leste"
  },
  {
    "prefixo": "78855",
    "uf": "MT",
    "codigoIbge": 5106455,
    "cidade": "Planalto da Serra"
  },
  {
    "prefixo": "78860",
    "uf": "MT",
    "codigoIbge": 5106208,
    "cidade": "Nova Brasilândia"
  },
  {
    "prefixo": "78866",
    "uf": "MT",
    "codigoIbge": 5106208,
    "cidade": "Nova Brasilândia"
  },
  {
    "prefixo": "78868",
    "uf": "MT",
    "codigoIbge": 5106208,
    "cidade": "Nova Brasilândia"
  },
  {
    "prefixo": "78870",
    "uf": "MT",
    "codigoIbge": 5106307,
    "cidade": "Paranatinga"
  },
  {
    "prefixo": "78875",
    "uf": "MT",
    "codigoIbge": 5103858,
    "cidade": "Gaúcha do Norte"
  },
  {
    "prefixo": "78880",
    "uf": "MT",
    "codigoIbge": 5108501,
    "cidade": "Vera"
  },
  {
    "prefixo": "78885",
    "uf": "MT",
    "codigoIbge": 5103700,
    "cidade": "Feliz Natal"
  },
  {
    "prefixo": "78888",
    "uf": "MT",
    "codigoIbge": 5106240,
    "cidade": "Nova Ubiratã"
  },
  {
    "prefixo": "78889",
    "uf": "MT",
    "codigoIbge": 5106240,
    "cidade": "Nova Ubiratã"
  },
  {
    "prefixo": "78890",
    "uf": "MT",
    "codigoIbge": 5107925,
    "cidade": "Sorriso"
  },
  {
    "prefixo": "78891",
    "uf": "MT",
    "codigoIbge": 5107925,
    "cidade": "Sorriso"
  },
  {
    "prefixo": "78892",
    "uf": "MT",
    "codigoIbge": 5107925,
    "cidade": "Sorriso"
  },
  {
    "prefixo": "78893",
    "uf": "MT",
    "codigoIbge": 5107925,
    "cidade": "Sorriso"
  },
  {
    "prefixo": "78894",
    "uf": "MT",
    "codigoIbge": 5107925,
    "cidade": "Sorriso"
  },
  {
    "prefixo": "78895",
    "uf": "MT",
    "codigoIbge": 5107925,
    "cidade": "Sorriso"
  },
  {
    "prefixo": "78896",
    "uf": "MT",
    "codigoIbge": 5107925,
    "cidade": "Sorriso"
  },
  {
    "prefixo": "78897",
    "uf": "MT",
    "codigoIbge": 5107925,
    "cidade": "Sorriso"
  },
  {
    "prefixo": "78898",
    "uf": "MT",
    "codigoIbge": 5107925,
    "cidade": "Sorriso"
  },
  {
    "prefixo": "78899",
    "uf": "MT",
    "codigoIbge": 5107925,
    "cidade": "Sorriso"
  },
  {
    "prefixo": "79002",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79003",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79004",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79005",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79006",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79008",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79009",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79010",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79011",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79012",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79013",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79014",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79015",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79016",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79017",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79018",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79020",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79021",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79022",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79023",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79031",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79032",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79033",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79034",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79035",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79036",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79037",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79040",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79041",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79042",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79043",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79044",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79045",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79046",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79050",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79051",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79052",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79060",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79062",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79063",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79064",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79065",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79070",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79071",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79072",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79073",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79074",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79075",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79076",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79077",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79079",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79080",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79081",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79082",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79083",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79084",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79085",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79086",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79090",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79091",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79092",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79093",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79094",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79095",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79096",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79097",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79100",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79101",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79102",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79103",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79104",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79105",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79106",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79107",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79108",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79110",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79112",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79113",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79114",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79115",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79116",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79117",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79118",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79124",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79125",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79127",
    "uf": "MS",
    "codigoIbge": 5002704,
    "cidade": "Campo Grande"
  },
  {
    "prefixo": "79130",
    "uf": "MS",
    "codigoIbge": 5007208,
    "cidade": "Rio Brilhante"
  },
  {
    "prefixo": "79134",
    "uf": "MS",
    "codigoIbge": 5007208,
    "cidade": "Rio Brilhante"
  },
  {
    "prefixo": "79140",
    "uf": "MS",
    "codigoIbge": 5006002,
    "cidade": "Nova Alvorada do Sul"
  },
  {
    "prefixo": "79148",
    "uf": "MS",
    "codigoIbge": 5006002,
    "cidade": "Nova Alvorada do Sul"
  },
  {
    "prefixo": "79150",
    "uf": "MS",
    "codigoIbge": 5005400,
    "cidade": "Maracaju"
  },
  {
    "prefixo": "79152",
    "uf": "MS",
    "codigoIbge": 5005400,
    "cidade": "Maracaju"
  },
  {
    "prefixo": "79170",
    "uf": "MS",
    "codigoIbge": 5007901,
    "cidade": "Sidrolândia"
  },
  {
    "prefixo": "79173",
    "uf": "MS",
    "codigoIbge": 5007901,
    "cidade": "Sidrolândia"
  },
  {
    "prefixo": "79174",
    "uf": "MS",
    "codigoIbge": 5007901,
    "cidade": "Sidrolândia"
  },
  {
    "prefixo": "79180",
    "uf": "MS",
    "codigoIbge": 5007109,
    "cidade": "Ribas do Rio Pardo"
  },
  {
    "prefixo": "79182",
    "uf": "MS",
    "codigoIbge": 5007109,
    "cidade": "Ribas do Rio Pardo"
  },
  {
    "prefixo": "79190",
    "uf": "MS",
    "codigoIbge": 5008008,
    "cidade": "Terenos"
  },
  {
    "prefixo": "79200",
    "uf": "MS",
    "codigoIbge": 5001102,
    "cidade": "Aquidauana"
  },
  {
    "prefixo": "79202",
    "uf": "MS",
    "codigoIbge": 5001102,
    "cidade": "Aquidauana"
  },
  {
    "prefixo": "79204",
    "uf": "MS",
    "codigoIbge": 5001102,
    "cidade": "Aquidauana"
  },
  {
    "prefixo": "79206",
    "uf": "MS",
    "codigoIbge": 5001102,
    "cidade": "Aquidauana"
  },
  {
    "prefixo": "79208",
    "uf": "MS",
    "codigoIbge": 5001102,
    "cidade": "Aquidauana"
  },
  {
    "prefixo": "79210",
    "uf": "MS",
    "codigoIbge": 5000708,
    "cidade": "Anastácio"
  },
  {
    "prefixo": "79215",
    "uf": "MS",
    "codigoIbge": 5003488,
    "cidade": "Dois Irmãos do Buriti"
  },
  {
    "prefixo": "79217",
    "uf": "MS",
    "codigoIbge": 5003488,
    "cidade": "Dois Irmãos do Buriti"
  },
  {
    "prefixo": "79220",
    "uf": "MS",
    "codigoIbge": 5005806,
    "cidade": "Nioaque"
  },
  {
    "prefixo": "79230",
    "uf": "MS",
    "codigoIbge": 5004106,
    "cidade": "Guia Lopes da Laguna"
  },
  {
    "prefixo": "79240",
    "uf": "MS",
    "codigoIbge": 5005004,
    "cidade": "Jardim"
  },
  {
    "prefixo": "79242",
    "uf": "MS",
    "codigoIbge": 5005004,
    "cidade": "Jardim"
  },
  {
    "prefixo": "79260",
    "uf": "MS",
    "codigoIbge": 5002100,
    "cidade": "Bela Vista"
  },
  {
    "prefixo": "79262",
    "uf": "MS",
    "codigoIbge": 5002100,
    "cidade": "Bela Vista"
  },
  {
    "prefixo": "79270",
    "uf": "MS",
    "codigoIbge": 5002803,
    "cidade": "Caracol"
  },
  {
    "prefixo": "79280",
    "uf": "MS",
    "codigoIbge": 5006903,
    "cidade": "Porto Murtinho"
  },
  {
    "prefixo": "79290",
    "uf": "MS",
    "codigoIbge": 5002209,
    "cidade": "Bonito"
  },
  {
    "prefixo": "79292",
    "uf": "MS",
    "codigoIbge": 5002209,
    "cidade": "Bonito"
  },
  {
    "prefixo": "79300",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79301",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79302",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79303",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79304",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79310",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79311",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79320",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79321",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79330",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79331",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79332",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79333",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79349",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79357",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79359",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79362",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79364",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79368",
    "uf": "MS",
    "codigoIbge": 5003207,
    "cidade": "Corumbá"
  },
  {
    "prefixo": "79370",
    "uf": "MS",
    "codigoIbge": 5005202,
    "cidade": "Ladário"
  },
  {
    "prefixo": "79380",
    "uf": "MS",
    "codigoIbge": 5005608,
    "cidade": "Miranda"
  },
  {
    "prefixo": "79390",
    "uf": "MS",
    "codigoIbge": 5002159,
    "cidade": "Bodoquena"
  },
  {
    "prefixo": "79392",
    "uf": "MS",
    "codigoIbge": 5002159,
    "cidade": "Bodoquena"
  },
  {
    "prefixo": "79400",
    "uf": "MS",
    "codigoIbge": 5003306,
    "cidade": "Coxim"
  },
  {
    "prefixo": "79410",
    "uf": "MS",
    "codigoIbge": 5006408,
    "cidade": "Pedro Gomes"
  },
  {
    "prefixo": "79415",
    "uf": "MS",
    "codigoIbge": 5007935,
    "cidade": "Sonora"
  },
  {
    "prefixo": "79420",
    "uf": "MS",
    "codigoIbge": 5002605,
    "cidade": "Camapuã"
  },
  {
    "prefixo": "79424",
    "uf": "MS",
    "codigoIbge": 5002605,
    "cidade": "Camapuã"
  },
  {
    "prefixo": "79428",
    "uf": "MS",
    "codigoIbge": 5003900,
    "cidade": "Figueirão"
  },
  {
    "prefixo": "79430",
    "uf": "MS",
    "codigoIbge": 5001508,
    "cidade": "Bandeirantes"
  },
  {
    "prefixo": "79432",
    "uf": "MS",
    "codigoIbge": 5001508,
    "cidade": "Bandeirantes"
  },
  {
    "prefixo": "79440",
    "uf": "MS",
    "codigoIbge": 5004908,
    "cidade": "Jaraguari"
  },
  {
    "prefixo": "79442",
    "uf": "MS",
    "codigoIbge": 5004908,
    "cidade": "Jaraguari"
  },
  {
    "prefixo": "79450",
    "uf": "MS",
    "codigoIbge": 5007505,
    "cidade": "Rochedo"
  },
  {
    "prefixo": "79452",
    "uf": "MS",
    "codigoIbge": 5007505,
    "cidade": "Rochedo"
  },
  {
    "prefixo": "79460",
    "uf": "MS",
    "codigoIbge": 5003108,
    "cidade": "Corguinho"
  },
  {
    "prefixo": "79462",
    "uf": "MS",
    "codigoIbge": 5003108,
    "cidade": "Corguinho"
  },
  {
    "prefixo": "79470",
    "uf": "MS",
    "codigoIbge": 5007307,
    "cidade": "Rio Negro"
  },
  {
    "prefixo": "79480",
    "uf": "MS",
    "codigoIbge": 5007406,
    "cidade": "Rio Verde de Mato Grosso"
  },
  {
    "prefixo": "79482",
    "uf": "MS",
    "codigoIbge": 5007406,
    "cidade": "Rio Verde de Mato Grosso"
  },
  {
    "prefixo": "79490",
    "uf": "MS",
    "codigoIbge": 5007695,
    "cidade": "São Gabriel do Oeste"
  },
  {
    "prefixo": "79494",
    "uf": "MS",
    "codigoIbge": 5007695,
    "cidade": "São Gabriel do Oeste"
  },
  {
    "prefixo": "79500",
    "uf": "MS",
    "codigoIbge": 5006309,
    "cidade": "Paranaíba"
  },
  {
    "prefixo": "79504",
    "uf": "MS",
    "codigoIbge": 5006309,
    "cidade": "Paranaíba"
  },
  {
    "prefixo": "79512",
    "uf": "MS",
    "codigoIbge": 5006309,
    "cidade": "Paranaíba"
  },
  {
    "prefixo": "79530",
    "uf": "MS",
    "codigoIbge": 5000252,
    "cidade": "Alcinópolis"
  },
  {
    "prefixo": "79540",
    "uf": "MS",
    "codigoIbge": 5002902,
    "cidade": "Cassilândia"
  },
  {
    "prefixo": "79542",
    "uf": "MS",
    "codigoIbge": 5002902,
    "cidade": "Cassilândia"
  },
  {
    "prefixo": "79550",
    "uf": "MS",
    "codigoIbge": 5003256,
    "cidade": "Costa Rica"
  },
  {
    "prefixo": "79554",
    "uf": "MS",
    "codigoIbge": 5003256,
    "cidade": "Costa Rica"
  },
  {
    "prefixo": "79556",
    "uf": "MS",
    "codigoIbge": 5006275,
    "cidade": "Paraíso das Águas"
  },
  {
    "prefixo": "79560",
    "uf": "MS",
    "codigoIbge": 5002951,
    "cidade": "Chapadão do Sul"
  },
  {
    "prefixo": "79570",
    "uf": "MS",
    "codigoIbge": 5001003,
    "cidade": "Aparecida do Taboado"
  },
  {
    "prefixo": "79580",
    "uf": "MS",
    "codigoIbge": 5004403,
    "cidade": "Inocência"
  },
  {
    "prefixo": "79584",
    "uf": "MS",
    "codigoIbge": 5004403,
    "cidade": "Inocência"
  },
  {
    "prefixo": "79586",
    "uf": "MS",
    "codigoIbge": 5004403,
    "cidade": "Inocência"
  },
  {
    "prefixo": "79590",
    "uf": "MS",
    "codigoIbge": 5007802,
    "cidade": "Selvíria"
  },
  {
    "prefixo": "79600",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79601",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79602",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79603",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79604",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79610",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79611",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79612",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79613",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79620",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79621",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79622",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79630",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79631",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79640",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79641",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79642",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79644",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79645",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79648",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79649",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79654",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79656",
    "uf": "MS",
    "codigoIbge": 5008305,
    "cidade": "Três Lagoas"
  },
  {
    "prefixo": "79670",
    "uf": "MS",
    "codigoIbge": 5002308,
    "cidade": "Brasilândia"
  },
  {
    "prefixo": "79677",
    "uf": "MS",
    "codigoIbge": 5002308,
    "cidade": "Brasilândia"
  },
  {
    "prefixo": "79680",
    "uf": "MS",
    "codigoIbge": 5000203,
    "cidade": "Água Clara"
  },
  {
    "prefixo": "79690",
    "uf": "MS",
    "codigoIbge": 5007554,
    "cidade": "Santa Rita do Pardo"
  },
  {
    "prefixo": "79700",
    "uf": "MS",
    "codigoIbge": 5003801,
    "cidade": "Fátima do Sul"
  },
  {
    "prefixo": "79702",
    "uf": "MS",
    "codigoIbge": 5003801,
    "cidade": "Fátima do Sul"
  },
  {
    "prefixo": "79710",
    "uf": "MS",
    "codigoIbge": 5008404,
    "cidade": "Vicentina"
  },
  {
    "prefixo": "79712",
    "uf": "MS",
    "codigoIbge": 5008404,
    "cidade": "Vicentina"
  },
  {
    "prefixo": "79714",
    "uf": "MS",
    "codigoIbge": 5008404,
    "cidade": "Vicentina"
  },
  {
    "prefixo": "79720",
    "uf": "MS",
    "codigoIbge": 5005103,
    "cidade": "Jateí"
  },
  {
    "prefixo": "79722",
    "uf": "MS",
    "codigoIbge": 5005103,
    "cidade": "Jateí"
  },
  {
    "prefixo": "79730",
    "uf": "MS",
    "codigoIbge": 5004007,
    "cidade": "Glória de Dourados"
  },
  {
    "prefixo": "79734",
    "uf": "MS",
    "codigoIbge": 5004007,
    "cidade": "Glória de Dourados"
  },
  {
    "prefixo": "79740",
    "uf": "MS",
    "codigoIbge": 5004700,
    "cidade": "Ivinhema"
  },
  {
    "prefixo": "79742",
    "uf": "MS",
    "codigoIbge": 5004700,
    "cidade": "Ivinhema"
  },
  {
    "prefixo": "79745",
    "uf": "MS",
    "codigoIbge": 5006259,
    "cidade": "Novo Horizonte do Sul"
  },
  {
    "prefixo": "79750",
    "uf": "MS",
    "codigoIbge": 5006200,
    "cidade": "Nova Andradina"
  },
  {
    "prefixo": "79758",
    "uf": "MS",
    "codigoIbge": 5006200,
    "cidade": "Nova Andradina"
  },
  {
    "prefixo": "79760",
    "uf": "MS",
    "codigoIbge": 5002001,
    "cidade": "Batayporã"
  },
  {
    "prefixo": "79765",
    "uf": "MS",
    "codigoIbge": 5007976,
    "cidade": "Taquarussu"
  },
  {
    "prefixo": "79770",
    "uf": "MS",
    "codigoIbge": 5000807,
    "cidade": "Anaurilândia"
  },
  {
    "prefixo": "79774",
    "uf": "MS",
    "codigoIbge": 5000807,
    "cidade": "Anaurilândia"
  },
  {
    "prefixo": "79780",
    "uf": "MS",
    "codigoIbge": 5001904,
    "cidade": "Bataguassu"
  },
  {
    "prefixo": "79782",
    "uf": "MS",
    "codigoIbge": 5001904,
    "cidade": "Bataguassu"
  },
  {
    "prefixo": "79785",
    "uf": "MS",
    "codigoIbge": 5000856,
    "cidade": "Angélica"
  },
  {
    "prefixo": "79787",
    "uf": "MS",
    "codigoIbge": 5000856,
    "cidade": "Angélica"
  },
  {
    "prefixo": "79790",
    "uf": "MS",
    "codigoIbge": 5003454,
    "cidade": "Deodápolis"
  },
  {
    "prefixo": "79792",
    "uf": "MS",
    "codigoIbge": 5003454,
    "cidade": "Deodápolis"
  },
  {
    "prefixo": "79794",
    "uf": "MS",
    "codigoIbge": 5003454,
    "cidade": "Deodápolis"
  },
  {
    "prefixo": "79796",
    "uf": "MS",
    "codigoIbge": 5003454,
    "cidade": "Deodápolis"
  },
  {
    "prefixo": "79798",
    "uf": "MS",
    "codigoIbge": 5003454,
    "cidade": "Deodápolis"
  },
  {
    "prefixo": "79800",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79801",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79802",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79803",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79804",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79805",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79806",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79810",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79811",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79812",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79813",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79814",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79815",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79816",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79820",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79821",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79822",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79823",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79824",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79825",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79826",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79827",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79830",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79831",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79833",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79834",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79835",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79837",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79839",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79840",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79841",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79842",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79843",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79849",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79862",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79864",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79866",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79868",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79872",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79874",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79876",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79878",
    "uf": "MS",
    "codigoIbge": 5003702,
    "cidade": "Dourados"
  },
  {
    "prefixo": "79880",
    "uf": "MS",
    "codigoIbge": 5003504,
    "cidade": "Douradina"
  },
  {
    "prefixo": "79883",
    "uf": "MS",
    "codigoIbge": 5003504,
    "cidade": "Douradina"
  },
  {
    "prefixo": "79886",
    "uf": "MS",
    "codigoIbge": 5003504,
    "cidade": "Douradina"
  },
  {
    "prefixo": "79890",
    "uf": "MS",
    "codigoIbge": 5004502,
    "cidade": "Itaporã"
  },
  {
    "prefixo": "79892",
    "uf": "MS",
    "codigoIbge": 5004502,
    "cidade": "Itaporã"
  },
  {
    "prefixo": "79894",
    "uf": "MS",
    "codigoIbge": 5004502,
    "cidade": "Itaporã"
  },
  {
    "prefixo": "79896",
    "uf": "MS",
    "codigoIbge": 5004502,
    "cidade": "Itaporã"
  },
  {
    "prefixo": "79898",
    "uf": "MS",
    "codigoIbge": 5004502,
    "cidade": "Itaporã"
  },
  {
    "prefixo": "79900",
    "uf": "MS",
    "codigoIbge": 5006606,
    "cidade": "Ponta Porã"
  },
  {
    "prefixo": "79901",
    "uf": "MS",
    "codigoIbge": 5006606,
    "cidade": "Ponta Porã"
  },
  {
    "prefixo": "79902",
    "uf": "MS",
    "codigoIbge": 5006606,
    "cidade": "Ponta Porã"
  },
  {
    "prefixo": "79903",
    "uf": "MS",
    "codigoIbge": 5006606,
    "cidade": "Ponta Porã"
  },
  {
    "prefixo": "79904",
    "uf": "MS",
    "codigoIbge": 5006606,
    "cidade": "Ponta Porã"
  },
  {
    "prefixo": "79905",
    "uf": "MS",
    "codigoIbge": 5006606,
    "cidade": "Ponta Porã"
  },
  {
    "prefixo": "79906",
    "uf": "MS",
    "codigoIbge": 5006606,
    "cidade": "Ponta Porã"
  },
  {
    "prefixo": "79907",
    "uf": "MS",
    "codigoIbge": 5006606,
    "cidade": "Ponta Porã"
  },
  {
    "prefixo": "79908",
    "uf": "MS",
    "codigoIbge": 5006606,
    "cidade": "Ponta Porã"
  },
  {
    "prefixo": "79909",
    "uf": "MS",
    "codigoIbge": 5006606,
    "cidade": "Ponta Porã"
  },
  {
    "prefixo": "79910",
    "uf": "MS",
    "codigoIbge": 5000906,
    "cidade": "Antônio João"
  },
  {
    "prefixo": "79920",
    "uf": "MS",
    "codigoIbge": 5005251,
    "cidade": "Laguna Carapã"
  },
  {
    "prefixo": "79925",
    "uf": "MS",
    "codigoIbge": 5006358,
    "cidade": "Paranhos"
  },
  {
    "prefixo": "79930",
    "uf": "MS",
    "codigoIbge": 5001243,
    "cidade": "Aral Moreira"
  },
  {
    "prefixo": "79932",
    "uf": "MS",
    "codigoIbge": 5001243,
    "cidade": "Aral Moreira"
  },
  {
    "prefixo": "79935",
    "uf": "MS",
    "codigoIbge": 5007703,
    "cidade": "Sete Quedas"
  },
  {
    "prefixo": "79940",
    "uf": "MS",
    "codigoIbge": 5002407,
    "cidade": "Caarapó"
  },
  {
    "prefixo": "79942",
    "uf": "MS",
    "codigoIbge": 5002407,
    "cidade": "Caarapó"
  },
  {
    "prefixo": "79944",
    "uf": "MS",
    "codigoIbge": 5002407,
    "cidade": "Caarapó"
  },
  {
    "prefixo": "79950",
    "uf": "MS",
    "codigoIbge": 5005707,
    "cidade": "Naviraí"
  },
  {
    "prefixo": "79955",
    "uf": "MS",
    "codigoIbge": 5005152,
    "cidade": "Juti"
  },
  {
    "prefixo": "79960",
    "uf": "MS",
    "codigoIbge": 5004304,
    "cidade": "Iguatemi"
  },
  {
    "prefixo": "79965",
    "uf": "MS",
    "codigoIbge": 5004601,
    "cidade": "Itaquiraí"
  },
  {
    "prefixo": "79970",
    "uf": "MS",
    "codigoIbge": 5003751,
    "cidade": "Eldorado"
  },
  {
    "prefixo": "79972",
    "uf": "MS",
    "codigoIbge": 5003751,
    "cidade": "Eldorado"
  },
  {
    "prefixo": "79975",
    "uf": "MS",
    "codigoIbge": 5007950,
    "cidade": "Tacuru"
  },
  {
    "prefixo": "79980",
    "uf": "MS",
    "codigoIbge": 5005681,
    "cidade": "Mundo Novo"
  },
  {
    "prefixo": "79985",
    "uf": "MS",
    "codigoIbge": 5004809,
    "cidade": "Japorã"
  },
  {
    "prefixo": "79988",
    "uf": "MS",
    "codigoIbge": 5004809,
    "cidade": "Japorã"
  },
  {
    "prefixo": "79990",
    "uf": "MS",
    "codigoIbge": 5000609,
    "cidade": "Amambai"
  },
  {
    "prefixo": "79995",
    "uf": "MS",
    "codigoIbge": 5003157,
    "cidade": "Coronel Sapucaia"
  },
  {
    "prefixo": "80002",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80010",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80020",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80030",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80035",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80040",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80045",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80050",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80060",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80210",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80215",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80220",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80230",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80240",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80250",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80310",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80320",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80330",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80410",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80420",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80430",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80440",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80510",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80520",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80530",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80540",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80610",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80620",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80630",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80710",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80730",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80740",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80810",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "80820",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81010",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81020",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81030",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81050",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81070",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81110",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81130",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81150",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81170",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81200",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81210",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81220",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81230",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81240",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81250",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81260",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81265",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81270",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81280",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81290",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81295",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81305",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81310",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81312",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81315",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81320",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81330",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81350",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81450",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81452",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81460",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81470",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81480",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81490",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81495",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81510",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81520",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81530",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81540",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81550",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81560",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81570",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81580",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81590",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81610",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81630",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81650",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81670",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81690",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81710",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81720",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81730",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81750",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81770",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81810",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81820",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81825",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81830",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81850",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81860",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81870",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81880",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81900",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81910",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81920",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81925",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81930",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81935",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81940",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "81945",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82010",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82015",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82020",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82025",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82030",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82100",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82110",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82115",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82120",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82130",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82200",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82210",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82220",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82300",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82305",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82310",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82315",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82320",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82400",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82410",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82415",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82510",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82515",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82520",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82530",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82540",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82560",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82590",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82600",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82620",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82630",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82640",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82650",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82700",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82710",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82720",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82800",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82810",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82820",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82821",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82840",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82860",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82900",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82920",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82930",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82940",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82950",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82960",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82970",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82980",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "82990",
    "uf": "PR",
    "codigoIbge": 4106902,
    "cidade": "Curitiba"
  },
  {
    "prefixo": "83005",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83010",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83015",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83020",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83021",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83022",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83023",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83024",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83025",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83030",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83035",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83040",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83045",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83050",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83055",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83060",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83065",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83070",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83075",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83085",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83090",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83091",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83095",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83115",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83116",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83149",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83150",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83151",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83153",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83155",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83158",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83159",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83160",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83161",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83162",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83163",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83164",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83165",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83180",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83181",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83183",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83185",
    "uf": "PR",
    "codigoIbge": 4125506,
    "cidade": "São José dos Pinhais"
  },
  {
    "prefixo": "83190",
    "uf": "PR",
    "codigoIbge": 4127601,
    "cidade": "Tijucas do Sul"
  },
  {
    "prefixo": "83203",
    "uf": "PR",
    "codigoIbge": 4118204,
    "cidade": "Paranaguá"
  },
  {
    "prefixo": "83204",
    "uf": "PR",
    "codigoIbge": 4118204,
    "cidade": "Paranaguá"
  },
  {
    "prefixo": "83206",
    "uf": "PR",
    "codigoIbge": 4118204,
    "cidade": "Paranaguá"
  },
  {
    "prefixo": "83209",
    "uf": "PR",
    "codigoIbge": 4118204,
    "cidade": "Paranaguá"
  },
  {
    "prefixo": "83210",
    "uf": "PR",
    "codigoIbge": 4118204,
    "cidade": "Paranaguá"
  },
  {
    "prefixo": "83212",
    "uf": "PR",
    "codigoIbge": 4118204,
    "cidade": "Paranaguá"
  },
  {
    "prefixo": "83215",
    "uf": "PR",
    "codigoIbge": 4118204,
    "cidade": "Paranaguá"
  },
  {
    "prefixo": "83218",
    "uf": "PR",
    "codigoIbge": 4118204,
    "cidade": "Paranaguá"
  },
  {
    "prefixo": "83221",
    "uf": "PR",
    "codigoIbge": 4118204,
    "cidade": "Paranaguá"
  },
  {
    "prefixo": "83249",
    "uf": "PR",
    "codigoIbge": 4118204,
    "cidade": "Paranaguá"
  },
  {
    "prefixo": "83250",
    "uf": "PR",
    "codigoIbge": 4118204,
    "cidade": "Paranaguá"
  },
  {
    "prefixo": "83251",
    "uf": "PR",
    "codigoIbge": 4118204,
    "cidade": "Paranaguá"
  },
  {
    "prefixo": "83252",
    "uf": "PR",
    "codigoIbge": 4118204,
    "cidade": "Paranaguá"
  },
  {
    "prefixo": "83255",
    "uf": "PR",
    "codigoIbge": 4119954,
    "cidade": "Pontal do Paraná"
  },
  {
    "prefixo": "83256",
    "uf": "PR",
    "codigoIbge": 4119954,
    "cidade": "Pontal do Paraná"
  },
  {
    "prefixo": "83260",
    "uf": "PR",
    "codigoIbge": 4115705,
    "cidade": "Matinhos"
  },
  {
    "prefixo": "83280",
    "uf": "PR",
    "codigoIbge": 4109609,
    "cidade": "Guaratuba"
  },
  {
    "prefixo": "83290",
    "uf": "PR",
    "codigoIbge": 4109609,
    "cidade": "Guaratuba"
  },
  {
    "prefixo": "83301",
    "uf": "PR",
    "codigoIbge": 4119509,
    "cidade": "Piraquara"
  },
  {
    "prefixo": "83302",
    "uf": "PR",
    "codigoIbge": 4119509,
    "cidade": "Piraquara"
  },
  {
    "prefixo": "83303",
    "uf": "PR",
    "codigoIbge": 4119509,
    "cidade": "Piraquara"
  },
  {
    "prefixo": "83304",
    "uf": "PR",
    "codigoIbge": 4119509,
    "cidade": "Piraquara"
  },
  {
    "prefixo": "83305",
    "uf": "PR",
    "codigoIbge": 4119509,
    "cidade": "Piraquara"
  },
  {
    "prefixo": "83306",
    "uf": "PR",
    "codigoIbge": 4119509,
    "cidade": "Piraquara"
  },
  {
    "prefixo": "83307",
    "uf": "PR",
    "codigoIbge": 4119509,
    "cidade": "Piraquara"
  },
  {
    "prefixo": "83308",
    "uf": "PR",
    "codigoIbge": 4119509,
    "cidade": "Piraquara"
  },
  {
    "prefixo": "83309",
    "uf": "PR",
    "codigoIbge": 4119509,
    "cidade": "Piraquara"
  },
  {
    "prefixo": "83310",
    "uf": "PR",
    "codigoIbge": 4119509,
    "cidade": "Piraquara"
  },
  {
    "prefixo": "83311",
    "uf": "PR",
    "codigoIbge": 4119509,
    "cidade": "Piraquara"
  },
  {
    "prefixo": "83312",
    "uf": "PR",
    "codigoIbge": 4119509,
    "cidade": "Piraquara"
  },
  {
    "prefixo": "83314",
    "uf": "PR",
    "codigoIbge": 4119509,
    "cidade": "Piraquara"
  },
  {
    "prefixo": "83320",
    "uf": "PR",
    "codigoIbge": 4119152,
    "cidade": "Pinhais"
  },
  {
    "prefixo": "83321",
    "uf": "PR",
    "codigoIbge": 4119152,
    "cidade": "Pinhais"
  },
  {
    "prefixo": "83322",
    "uf": "PR",
    "codigoIbge": 4119152,
    "cidade": "Pinhais"
  },
  {
    "prefixo": "83323",
    "uf": "PR",
    "codigoIbge": 4119152,
    "cidade": "Pinhais"
  },
  {
    "prefixo": "83324",
    "uf": "PR",
    "codigoIbge": 4119152,
    "cidade": "Pinhais"
  },
  {
    "prefixo": "83325",
    "uf": "PR",
    "codigoIbge": 4119152,
    "cidade": "Pinhais"
  },
  {
    "prefixo": "83326",
    "uf": "PR",
    "codigoIbge": 4119152,
    "cidade": "Pinhais"
  },
  {
    "prefixo": "83327",
    "uf": "PR",
    "codigoIbge": 4119152,
    "cidade": "Pinhais"
  },
  {
    "prefixo": "83328",
    "uf": "PR",
    "codigoIbge": 4119152,
    "cidade": "Pinhais"
  },
  {
    "prefixo": "83329",
    "uf": "PR",
    "codigoIbge": 4119152,
    "cidade": "Pinhais"
  },
  {
    "prefixo": "83330",
    "uf": "PR",
    "codigoIbge": 4119152,
    "cidade": "Pinhais"
  },
  {
    "prefixo": "83331",
    "uf": "PR",
    "codigoIbge": 4119152,
    "cidade": "Pinhais"
  },
  {
    "prefixo": "83350",
    "uf": "PR",
    "codigoIbge": 4116208,
    "cidade": "Morretes"
  },
  {
    "prefixo": "83360",
    "uf": "PR",
    "codigoIbge": 4116208,
    "cidade": "Morretes"
  },
  {
    "prefixo": "83370",
    "uf": "PR",
    "codigoIbge": 4101200,
    "cidade": "Antonina"
  },
  {
    "prefixo": "83375",
    "uf": "PR",
    "codigoIbge": 4101200,
    "cidade": "Antonina"
  },
  {
    "prefixo": "83380",
    "uf": "PR",
    "codigoIbge": 4101200,
    "cidade": "Antonina"
  },
  {
    "prefixo": "83390",
    "uf": "PR",
    "codigoIbge": 4109500,
    "cidade": "Guaraqueçaba"
  },
  {
    "prefixo": "83393",
    "uf": "PR",
    "codigoIbge": 4109500,
    "cidade": "Guaraqueçaba"
  },
  {
    "prefixo": "83401",
    "uf": "PR",
    "codigoIbge": 4105805,
    "cidade": "Colombo"
  },
  {
    "prefixo": "83402",
    "uf": "PR",
    "codigoIbge": 4105805,
    "cidade": "Colombo"
  },
  {
    "prefixo": "83403",
    "uf": "PR",
    "codigoIbge": 4105805,
    "cidade": "Colombo"
  },
  {
    "prefixo": "83404",
    "uf": "PR",
    "codigoIbge": 4105805,
    "cidade": "Colombo"
  },
  {
    "prefixo": "83405",
    "uf": "PR",
    "codigoIbge": 4105805,
    "cidade": "Colombo"
  },
  {
    "prefixo": "83406",
    "uf": "PR",
    "codigoIbge": 4105805,
    "cidade": "Colombo"
  },
  {
    "prefixo": "83407",
    "uf": "PR",
    "codigoIbge": 4105805,
    "cidade": "Colombo"
  },
  {
    "prefixo": "83408",
    "uf": "PR",
    "codigoIbge": 4105805,
    "cidade": "Colombo"
  },
  {
    "prefixo": "83409",
    "uf": "PR",
    "codigoIbge": 4105805,
    "cidade": "Colombo"
  },
  {
    "prefixo": "83410",
    "uf": "PR",
    "codigoIbge": 4105805,
    "cidade": "Colombo"
  },
  {
    "prefixo": "83411",
    "uf": "PR",
    "codigoIbge": 4105805,
    "cidade": "Colombo"
  },
  {
    "prefixo": "83412",
    "uf": "PR",
    "codigoIbge": 4105805,
    "cidade": "Colombo"
  },
  {
    "prefixo": "83413",
    "uf": "PR",
    "codigoIbge": 4105805,
    "cidade": "Colombo"
  },
  {
    "prefixo": "83414",
    "uf": "PR",
    "codigoIbge": 4105805,
    "cidade": "Colombo"
  },
  {
    "prefixo": "83415",
    "uf": "PR",
    "codigoIbge": 4105805,
    "cidade": "Colombo"
  },
  {
    "prefixo": "83420",
    "uf": "PR",
    "codigoIbge": 4120804,
    "cidade": "Quatro Barras"
  },
  {
    "prefixo": "83425",
    "uf": "PR",
    "codigoIbge": 4120804,
    "cidade": "Quatro Barras"
  },
  {
    "prefixo": "83430",
    "uf": "PR",
    "codigoIbge": 4104006,
    "cidade": "Campina Grande do Sul"
  },
  {
    "prefixo": "83440",
    "uf": "PR",
    "codigoIbge": 4104006,
    "cidade": "Campina Grande do Sul"
  },
  {
    "prefixo": "83450",
    "uf": "PR",
    "codigoIbge": 4103107,
    "cidade": "Bocaiúva do Sul"
  },
  {
    "prefixo": "83480",
    "uf": "PR",
    "codigoIbge": 4127882,
    "cidade": "Tunas do Paraná"
  },
  {
    "prefixo": "83485",
    "uf": "PR",
    "codigoIbge": 4127882,
    "cidade": "Tunas do Paraná"
  },
  {
    "prefixo": "83490",
    "uf": "PR",
    "codigoIbge": 4100202,
    "cidade": "Adrianópolis"
  },
  {
    "prefixo": "83501",
    "uf": "PR",
    "codigoIbge": 4100400,
    "cidade": "Almirante Tamandaré"
  },
  {
    "prefixo": "83502",
    "uf": "PR",
    "codigoIbge": 4100400,
    "cidade": "Almirante Tamandaré"
  },
  {
    "prefixo": "83503",
    "uf": "PR",
    "codigoIbge": 4100400,
    "cidade": "Almirante Tamandaré"
  },
  {
    "prefixo": "83504",
    "uf": "PR",
    "codigoIbge": 4100400,
    "cidade": "Almirante Tamandaré"
  },
  {
    "prefixo": "83505",
    "uf": "PR",
    "codigoIbge": 4100400,
    "cidade": "Almirante Tamandaré"
  },
  {
    "prefixo": "83506",
    "uf": "PR",
    "codigoIbge": 4100400,
    "cidade": "Almirante Tamandaré"
  },
  {
    "prefixo": "83507",
    "uf": "PR",
    "codigoIbge": 4100400,
    "cidade": "Almirante Tamandaré"
  },
  {
    "prefixo": "83508",
    "uf": "PR",
    "codigoIbge": 4100400,
    "cidade": "Almirante Tamandaré"
  },
  {
    "prefixo": "83511",
    "uf": "PR",
    "codigoIbge": 4100400,
    "cidade": "Almirante Tamandaré"
  },
  {
    "prefixo": "83512",
    "uf": "PR",
    "codigoIbge": 4100400,
    "cidade": "Almirante Tamandaré"
  },
  {
    "prefixo": "83513",
    "uf": "PR",
    "codigoIbge": 4100400,
    "cidade": "Almirante Tamandaré"
  },
  {
    "prefixo": "83514",
    "uf": "PR",
    "codigoIbge": 4100400,
    "cidade": "Almirante Tamandaré"
  },
  {
    "prefixo": "83515",
    "uf": "PR",
    "codigoIbge": 4100400,
    "cidade": "Almirante Tamandaré"
  },
  {
    "prefixo": "83529",
    "uf": "PR",
    "codigoIbge": 4100400,
    "cidade": "Almirante Tamandaré"
  },
  {
    "prefixo": "83531",
    "uf": "PR",
    "codigoIbge": 4100400,
    "cidade": "Almirante Tamandaré"
  },
  {
    "prefixo": "83535",
    "uf": "PR",
    "codigoIbge": 4104253,
    "cidade": "Campo Magro"
  },
  {
    "prefixo": "83540",
    "uf": "PR",
    "codigoIbge": 4122206,
    "cidade": "Rio Branco do Sul"
  },
  {
    "prefixo": "83550",
    "uf": "PR",
    "codigoIbge": 4122206,
    "cidade": "Rio Branco do Sul"
  },
  {
    "prefixo": "83560",
    "uf": "PR",
    "codigoIbge": 4111258,
    "cidade": "Itaperuçu"
  },
  {
    "prefixo": "83562",
    "uf": "PR",
    "codigoIbge": 4111258,
    "cidade": "Itaperuçu"
  },
  {
    "prefixo": "83564",
    "uf": "PR",
    "codigoIbge": 4111258,
    "cidade": "Itaperuçu"
  },
  {
    "prefixo": "83566",
    "uf": "PR",
    "codigoIbge": 4111258,
    "cidade": "Itaperuçu"
  },
  {
    "prefixo": "83570",
    "uf": "PR",
    "codigoIbge": 4105201,
    "cidade": "Cerro Azul"
  },
  {
    "prefixo": "83580",
    "uf": "PR",
    "codigoIbge": 4105201,
    "cidade": "Cerro Azul"
  },
  {
    "prefixo": "83590",
    "uf": "PR",
    "codigoIbge": 4128633,
    "cidade": "Doutor Ulysses"
  },
  {
    "prefixo": "83600",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83601",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83602",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83603",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83604",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83605",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83606",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83607",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83608",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83609",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83610",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83632",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83634",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83640",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83642",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83645",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83646",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83647",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83648",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83649",
    "uf": "PR",
    "codigoIbge": 4104204,
    "cidade": "Campo Largo"
  },
  {
    "prefixo": "83650",
    "uf": "PR",
    "codigoIbge": 4102307,
    "cidade": "Balsa Nova"
  },
  {
    "prefixo": "83660",
    "uf": "PR",
    "codigoIbge": 4102307,
    "cidade": "Balsa Nova"
  },
  {
    "prefixo": "83670",
    "uf": "PR",
    "codigoIbge": 4102307,
    "cidade": "Balsa Nova"
  },
  {
    "prefixo": "83700",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83701",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83702",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83703",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83704",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83705",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83706",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83707",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83708",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83709",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83711",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83724",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83725",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83726",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83728",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83729",
    "uf": "PR",
    "codigoIbge": 4101804,
    "cidade": "Araucária"
  },
  {
    "prefixo": "83730",
    "uf": "PR",
    "codigoIbge": 4106209,
    "cidade": "Contenda"
  },
  {
    "prefixo": "83740",
    "uf": "PR",
    "codigoIbge": 4106209,
    "cidade": "Contenda"
  },
  {
    "prefixo": "83750",
    "uf": "PR",
    "codigoIbge": 4113205,
    "cidade": "Lapa"
  },
  {
    "prefixo": "83751",
    "uf": "PR",
    "codigoIbge": 4113205,
    "cidade": "Lapa"
  },
  {
    "prefixo": "83752",
    "uf": "PR",
    "codigoIbge": 4113205,
    "cidade": "Lapa"
  },
  {
    "prefixo": "83753",
    "uf": "PR",
    "codigoIbge": 4113205,
    "cidade": "Lapa"
  },
  {
    "prefixo": "83755",
    "uf": "PR",
    "codigoIbge": 4113205,
    "cidade": "Lapa"
  },
  {
    "prefixo": "83760",
    "uf": "PR",
    "codigoIbge": 4113205,
    "cidade": "Lapa"
  },
  {
    "prefixo": "83770",
    "uf": "PR",
    "codigoIbge": 4113205,
    "cidade": "Lapa"
  },
  {
    "prefixo": "83800",
    "uf": "PR",
    "codigoIbge": 4114302,
    "cidade": "Mandirituba"
  },
  {
    "prefixo": "83802",
    "uf": "PR",
    "codigoIbge": 4114302,
    "cidade": "Mandirituba"
  },
  {
    "prefixo": "83804",
    "uf": "PR",
    "codigoIbge": 4114302,
    "cidade": "Mandirituba"
  },
  {
    "prefixo": "83805",
    "uf": "PR",
    "codigoIbge": 4114302,
    "cidade": "Mandirituba"
  },
  {
    "prefixo": "83808",
    "uf": "PR",
    "codigoIbge": 4114302,
    "cidade": "Mandirituba"
  },
  {
    "prefixo": "83810",
    "uf": "PR",
    "codigoIbge": 4114302,
    "cidade": "Mandirituba"
  },
  {
    "prefixo": "83820",
    "uf": "PR",
    "codigoIbge": 4107652,
    "cidade": "Fazenda Rio Grande"
  },
  {
    "prefixo": "83821",
    "uf": "PR",
    "codigoIbge": 4107652,
    "cidade": "Fazenda Rio Grande"
  },
  {
    "prefixo": "83823",
    "uf": "PR",
    "codigoIbge": 4107652,
    "cidade": "Fazenda Rio Grande"
  },
  {
    "prefixo": "83824",
    "uf": "PR",
    "codigoIbge": 4107652,
    "cidade": "Fazenda Rio Grande"
  },
  {
    "prefixo": "83825",
    "uf": "PR",
    "codigoIbge": 4107652,
    "cidade": "Fazenda Rio Grande"
  },
  {
    "prefixo": "83829",
    "uf": "PR",
    "codigoIbge": 4107652,
    "cidade": "Fazenda Rio Grande"
  },
  {
    "prefixo": "83830",
    "uf": "PR",
    "codigoIbge": 4107652,
    "cidade": "Fazenda Rio Grande"
  },
  {
    "prefixo": "83833",
    "uf": "PR",
    "codigoIbge": 4107652,
    "cidade": "Fazenda Rio Grande"
  },
  {
    "prefixo": "83835",
    "uf": "PR",
    "codigoIbge": 4107652,
    "cidade": "Fazenda Rio Grande"
  },
  {
    "prefixo": "83839",
    "uf": "PR",
    "codigoIbge": 4107652,
    "cidade": "Fazenda Rio Grande"
  },
  {
    "prefixo": "83840",
    "uf": "PR",
    "codigoIbge": 4121208,
    "cidade": "Quitandinha"
  },
  {
    "prefixo": "83843",
    "uf": "PR",
    "codigoIbge": 4121208,
    "cidade": "Quitandinha"
  },
  {
    "prefixo": "83845",
    "uf": "PR",
    "codigoIbge": 4121208,
    "cidade": "Quitandinha"
  },
  {
    "prefixo": "83848",
    "uf": "PR",
    "codigoIbge": 4121208,
    "cidade": "Quitandinha"
  },
  {
    "prefixo": "83850",
    "uf": "PR",
    "codigoIbge": 4100301,
    "cidade": "Agudos do Sul"
  },
  {
    "prefixo": "83855",
    "uf": "PR",
    "codigoIbge": 4100301,
    "cidade": "Agudos do Sul"
  },
  {
    "prefixo": "83860",
    "uf": "PR",
    "codigoIbge": 4119103,
    "cidade": "Piên"
  },
  {
    "prefixo": "83870",
    "uf": "PR",
    "codigoIbge": 4104105,
    "cidade": "Campo do Tenente"
  },
  {
    "prefixo": "83880",
    "uf": "PR",
    "codigoIbge": 4122305,
    "cidade": "Rio Negro"
  },
  {
    "prefixo": "83881",
    "uf": "PR",
    "codigoIbge": 4122305,
    "cidade": "Rio Negro"
  },
  {
    "prefixo": "83883",
    "uf": "PR",
    "codigoIbge": 4122305,
    "cidade": "Rio Negro"
  },
  {
    "prefixo": "83885",
    "uf": "PR",
    "codigoIbge": 4122305,
    "cidade": "Rio Negro"
  },
  {
    "prefixo": "83900",
    "uf": "PR",
    "codigoIbge": 4125605,
    "cidade": "São Mateus do Sul"
  },
  {
    "prefixo": "83902",
    "uf": "PR",
    "codigoIbge": 4125605,
    "cidade": "São Mateus do Sul"
  },
  {
    "prefixo": "83904",
    "uf": "PR",
    "codigoIbge": 4125605,
    "cidade": "São Mateus do Sul"
  },
  {
    "prefixo": "83905",
    "uf": "PR",
    "codigoIbge": 4125605,
    "cidade": "São Mateus do Sul"
  },
  {
    "prefixo": "83907",
    "uf": "PR",
    "codigoIbge": 4125605,
    "cidade": "São Mateus do Sul"
  },
  {
    "prefixo": "83930",
    "uf": "PR",
    "codigoIbge": 4125605,
    "cidade": "São Mateus do Sul"
  },
  {
    "prefixo": "83980",
    "uf": "PR",
    "codigoIbge": 4101309,
    "cidade": "Antônio Olinto"
  },
  {
    "prefixo": "84001",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84010",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84015",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84016",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84017",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84020",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84021",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84022",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84023",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84025",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84026",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84030",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84031",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84032",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84033",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84034",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84035",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84036",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84037",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84040",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84043",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84045",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84046",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84050",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84051",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84052",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84053",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84059",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84060",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84061",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84062",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84063",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84064",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84065",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84070",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84071",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84072",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84073",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84099",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84105",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84106",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84110",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84115",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84120",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84125",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84126",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84127",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84128",
    "uf": "PR",
    "codigoIbge": 4119905,
    "cidade": "Ponta Grossa"
  },
  {
    "prefixo": "84130",
    "uf": "PR",
    "codigoIbge": 4117701,
    "cidade": "Palmeira"
  },
  {
    "prefixo": "84135",
    "uf": "PR",
    "codigoIbge": 4117701,
    "cidade": "Palmeira"
  },
  {
    "prefixo": "84140",
    "uf": "PR",
    "codigoIbge": 4120101,
    "cidade": "Porto Amazonas"
  },
  {
    "prefixo": "84145",
    "uf": "PR",
    "codigoIbge": 4104659,
    "cidade": "Carambeí"
  },
  {
    "prefixo": "84150",
    "uf": "PR",
    "codigoIbge": 4125100,
    "cidade": "São João do Triunfo"
  },
  {
    "prefixo": "84155",
    "uf": "PR",
    "codigoIbge": 4125100,
    "cidade": "São João do Triunfo"
  },
  {
    "prefixo": "84165",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84168",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84172",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84173",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84174",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84177",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84178",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84181",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84182",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84184",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84185",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84190",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84193",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84194",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84195",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84196",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84197",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84198",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84199",
    "uf": "PR",
    "codigoIbge": 4104907,
    "cidade": "Castro"
  },
  {
    "prefixo": "84200",
    "uf": "PR",
    "codigoIbge": 4112009,
    "cidade": "Jaguariaíva"
  },
  {
    "prefixo": "84210",
    "uf": "PR",
    "codigoIbge": 4112009,
    "cidade": "Jaguariaíva"
  },
  {
    "prefixo": "84220",
    "uf": "PR",
    "codigoIbge": 4126306,
    "cidade": "Sengés"
  },
  {
    "prefixo": "84230",
    "uf": "PR",
    "codigoIbge": 4126306,
    "cidade": "Sengés"
  },
  {
    "prefixo": "84240",
    "uf": "PR",
    "codigoIbge": 4119400,
    "cidade": "Piraí do Sul"
  },
  {
    "prefixo": "84250",
    "uf": "PR",
    "codigoIbge": 4110078,
    "cidade": "Imbaú"
  },
  {
    "prefixo": "84261",
    "uf": "PR",
    "codigoIbge": 4127106,
    "cidade": "Telêmaco Borba"
  },
  {
    "prefixo": "84262",
    "uf": "PR",
    "codigoIbge": 4127106,
    "cidade": "Telêmaco Borba"
  },
  {
    "prefixo": "84263",
    "uf": "PR",
    "codigoIbge": 4127106,
    "cidade": "Telêmaco Borba"
  },
  {
    "prefixo": "84264",
    "uf": "PR",
    "codigoIbge": 4127106,
    "cidade": "Telêmaco Borba"
  },
  {
    "prefixo": "84265",
    "uf": "PR",
    "codigoIbge": 4127106,
    "cidade": "Telêmaco Borba"
  },
  {
    "prefixo": "84266",
    "uf": "PR",
    "codigoIbge": 4127106,
    "cidade": "Telêmaco Borba"
  },
  {
    "prefixo": "84267",
    "uf": "PR",
    "codigoIbge": 4127106,
    "cidade": "Telêmaco Borba"
  },
  {
    "prefixo": "84268",
    "uf": "PR",
    "codigoIbge": 4127106,
    "cidade": "Telêmaco Borba"
  },
  {
    "prefixo": "84269",
    "uf": "PR",
    "codigoIbge": 4127106,
    "cidade": "Telêmaco Borba"
  },
  {
    "prefixo": "84270",
    "uf": "PR",
    "codigoIbge": 4127106,
    "cidade": "Telêmaco Borba"
  },
  {
    "prefixo": "84271",
    "uf": "PR",
    "codigoIbge": 4127106,
    "cidade": "Telêmaco Borba"
  },
  {
    "prefixo": "84272",
    "uf": "PR",
    "codigoIbge": 4127106,
    "cidade": "Telêmaco Borba"
  },
  {
    "prefixo": "84275",
    "uf": "PR",
    "codigoIbge": 4127106,
    "cidade": "Telêmaco Borba"
  },
  {
    "prefixo": "84279",
    "uf": "PR",
    "codigoIbge": 4127106,
    "cidade": "Telêmaco Borba"
  },
  {
    "prefixo": "84280",
    "uf": "PR",
    "codigoIbge": 4107009,
    "cidade": "Curiúva"
  },
  {
    "prefixo": "84284",
    "uf": "PR",
    "codigoIbge": 4107009,
    "cidade": "Curiúva"
  },
  {
    "prefixo": "84285",
    "uf": "PR",
    "codigoIbge": 4107751,
    "cidade": "Figueira"
  },
  {
    "prefixo": "84290",
    "uf": "PR",
    "codigoIbge": 4126207,
    "cidade": "Sapopema"
  },
  {
    "prefixo": "84293",
    "uf": "PR",
    "codigoIbge": 4126207,
    "cidade": "Sapopema"
  },
  {
    "prefixo": "84300",
    "uf": "PR",
    "codigoIbge": 4127502,
    "cidade": "Tibagi"
  },
  {
    "prefixo": "84305",
    "uf": "PR",
    "codigoIbge": 4127502,
    "cidade": "Tibagi"
  },
  {
    "prefixo": "84315",
    "uf": "PR",
    "codigoIbge": 4127502,
    "cidade": "Tibagi"
  },
  {
    "prefixo": "84320",
    "uf": "PR",
    "codigoIbge": 4121703,
    "cidade": "Reserva"
  },
  {
    "prefixo": "84330",
    "uf": "PR",
    "codigoIbge": 4121703,
    "cidade": "Reserva"
  },
  {
    "prefixo": "84340",
    "uf": "PR",
    "codigoIbge": 4121703,
    "cidade": "Reserva"
  },
  {
    "prefixo": "84345",
    "uf": "PR",
    "codigoIbge": 4128534,
    "cidade": "Ventania"
  },
  {
    "prefixo": "84350",
    "uf": "PR",
    "codigoIbge": 4117305,
    "cidade": "Ortigueira"
  },
  {
    "prefixo": "84360",
    "uf": "PR",
    "codigoIbge": 4117305,
    "cidade": "Ortigueira"
  },
  {
    "prefixo": "84380",
    "uf": "PR",
    "codigoIbge": 4117305,
    "cidade": "Ortigueira"
  },
  {
    "prefixo": "84400",
    "uf": "PR",
    "codigoIbge": 4120606,
    "cidade": "Prudentópolis"
  },
  {
    "prefixo": "84410",
    "uf": "PR",
    "codigoIbge": 4120606,
    "cidade": "Prudentópolis"
  },
  {
    "prefixo": "84420",
    "uf": "PR",
    "codigoIbge": 4120606,
    "cidade": "Prudentópolis"
  },
  {
    "prefixo": "84430",
    "uf": "PR",
    "codigoIbge": 4110102,
    "cidade": "Imbituva"
  },
  {
    "prefixo": "84433",
    "uf": "PR",
    "codigoIbge": 4110102,
    "cidade": "Imbituva"
  },
  {
    "prefixo": "84435",
    "uf": "PR",
    "codigoIbge": 4108957,
    "cidade": "Guamiranga"
  },
  {
    "prefixo": "84450",
    "uf": "PR",
    "codigoIbge": 4110508,
    "cidade": "Ipiranga"
  },
  {
    "prefixo": "84460",
    "uf": "PR",
    "codigoIbge": 4111407,
    "cidade": "Ivaí"
  },
  {
    "prefixo": "84465",
    "uf": "PR",
    "codigoIbge": 4111407,
    "cidade": "Ivaí"
  },
  {
    "prefixo": "84470",
    "uf": "PR",
    "codigoIbge": 4104402,
    "cidade": "Cândido de Abreu"
  },
  {
    "prefixo": "84480",
    "uf": "PR",
    "codigoIbge": 4104402,
    "cidade": "Cândido de Abreu"
  },
  {
    "prefixo": "84490",
    "uf": "PR",
    "codigoIbge": 4104402,
    "cidade": "Cândido de Abreu"
  },
  {
    "prefixo": "84500",
    "uf": "PR",
    "codigoIbge": 4110706,
    "cidade": "Irati"
  },
  {
    "prefixo": "84502",
    "uf": "PR",
    "codigoIbge": 4110706,
    "cidade": "Irati"
  },
  {
    "prefixo": "84503",
    "uf": "PR",
    "codigoIbge": 4110706,
    "cidade": "Irati"
  },
  {
    "prefixo": "84504",
    "uf": "PR",
    "codigoIbge": 4110706,
    "cidade": "Irati"
  },
  {
    "prefixo": "84505",
    "uf": "PR",
    "codigoIbge": 4110706,
    "cidade": "Irati"
  },
  {
    "prefixo": "84506",
    "uf": "PR",
    "codigoIbge": 4110706,
    "cidade": "Irati"
  },
  {
    "prefixo": "84507",
    "uf": "PR",
    "codigoIbge": 4110706,
    "cidade": "Irati"
  },
  {
    "prefixo": "84508",
    "uf": "PR",
    "codigoIbge": 4110706,
    "cidade": "Irati"
  },
  {
    "prefixo": "84509",
    "uf": "PR",
    "codigoIbge": 4110706,
    "cidade": "Irati"
  },
  {
    "prefixo": "84530",
    "uf": "PR",
    "codigoIbge": 4127007,
    "cidade": "Teixeira Soares"
  },
  {
    "prefixo": "84534",
    "uf": "PR",
    "codigoIbge": 4127007,
    "cidade": "Teixeira Soares"
  },
  {
    "prefixo": "84535",
    "uf": "PR",
    "codigoIbge": 4107736,
    "cidade": "Fernandes Pinheiro"
  },
  {
    "prefixo": "84538",
    "uf": "PR",
    "codigoIbge": 4107736,
    "cidade": "Fernandes Pinheiro"
  },
  {
    "prefixo": "84550",
    "uf": "PR",
    "codigoIbge": 4121505,
    "cidade": "Rebouças"
  },
  {
    "prefixo": "84560",
    "uf": "PR",
    "codigoIbge": 4122008,
    "cidade": "Rio Azul"
  },
  {
    "prefixo": "84570",
    "uf": "PR",
    "codigoIbge": 4113908,
    "cidade": "Mallet"
  },
  {
    "prefixo": "84574",
    "uf": "PR",
    "codigoIbge": 4113908,
    "cidade": "Mallet"
  },
  {
    "prefixo": "84577",
    "uf": "PR",
    "codigoIbge": 4113908,
    "cidade": "Mallet"
  },
  {
    "prefixo": "84600",
    "uf": "PR",
    "codigoIbge": 4128203,
    "cidade": "União da Vitória"
  },
  {
    "prefixo": "84601",
    "uf": "PR",
    "codigoIbge": 4128203,
    "cidade": "União da Vitória"
  },
  {
    "prefixo": "84602",
    "uf": "PR",
    "codigoIbge": 4128203,
    "cidade": "União da Vitória"
  },
  {
    "prefixo": "84603",
    "uf": "PR",
    "codigoIbge": 4128203,
    "cidade": "União da Vitória"
  },
  {
    "prefixo": "84604",
    "uf": "PR",
    "codigoIbge": 4128203,
    "cidade": "União da Vitória"
  },
  {
    "prefixo": "84605",
    "uf": "PR",
    "codigoIbge": 4128203,
    "cidade": "União da Vitória"
  },
  {
    "prefixo": "84606",
    "uf": "PR",
    "codigoIbge": 4128203,
    "cidade": "União da Vitória"
  },
  {
    "prefixo": "84607",
    "uf": "PR",
    "codigoIbge": 4128203,
    "cidade": "União da Vitória"
  },
  {
    "prefixo": "84608",
    "uf": "PR",
    "codigoIbge": 4128203,
    "cidade": "União da Vitória"
  },
  {
    "prefixo": "84609",
    "uf": "PR",
    "codigoIbge": 4128203,
    "cidade": "União da Vitória"
  },
  {
    "prefixo": "84612",
    "uf": "PR",
    "codigoIbge": 4128203,
    "cidade": "União da Vitória"
  },
  {
    "prefixo": "84613",
    "uf": "PR",
    "codigoIbge": 4128203,
    "cidade": "União da Vitória"
  },
  {
    "prefixo": "84614",
    "uf": "PR",
    "codigoIbge": 4128203,
    "cidade": "União da Vitória"
  },
  {
    "prefixo": "84615",
    "uf": "PR",
    "codigoIbge": 4120309,
    "cidade": "Porto Vitória"
  },
  {
    "prefixo": "84620",
    "uf": "PR",
    "codigoIbge": 4106803,
    "cidade": "Cruz Machado"
  },
  {
    "prefixo": "84623",
    "uf": "PR",
    "codigoIbge": 4106803,
    "cidade": "Cruz Machado"
  },
  {
    "prefixo": "84625",
    "uf": "PR",
    "codigoIbge": 4106803,
    "cidade": "Cruz Machado"
  },
  {
    "prefixo": "84630",
    "uf": "PR",
    "codigoIbge": 4118600,
    "cidade": "Paula Freitas"
  },
  {
    "prefixo": "84634",
    "uf": "PR",
    "codigoIbge": 4118600,
    "cidade": "Paula Freitas"
  },
  {
    "prefixo": "84635",
    "uf": "PR",
    "codigoIbge": 4118709,
    "cidade": "Paulo Frontin"
  },
  {
    "prefixo": "84640",
    "uf": "PR",
    "codigoIbge": 4102901,
    "cidade": "Bituruna"
  },
  {
    "prefixo": "84650",
    "uf": "PR",
    "codigoIbge": 4102901,
    "cidade": "Bituruna"
  },
  {
    "prefixo": "84660",
    "uf": "PR",
    "codigoIbge": 4108502,
    "cidade": "General Carneiro"
  },
  {
    "prefixo": "84662",
    "uf": "PR",
    "codigoIbge": 4108502,
    "cidade": "General Carneiro"
  },
  {
    "prefixo": "84900",
    "uf": "PR",
    "codigoIbge": 4109708,
    "cidade": "Ibaiti"
  },
  {
    "prefixo": "84910",
    "uf": "PR",
    "codigoIbge": 4109708,
    "cidade": "Ibaiti"
  },
  {
    "prefixo": "84912",
    "uf": "PR",
    "codigoIbge": 4109708,
    "cidade": "Ibaiti"
  },
  {
    "prefixo": "84914",
    "uf": "PR",
    "codigoIbge": 4109708,
    "cidade": "Ibaiti"
  },
  {
    "prefixo": "84916",
    "uf": "PR",
    "codigoIbge": 4109708,
    "cidade": "Ibaiti"
  },
  {
    "prefixo": "84920",
    "uf": "PR",
    "codigoIbge": 4112306,
    "cidade": "Japira"
  },
  {
    "prefixo": "84923",
    "uf": "PR",
    "codigoIbge": 4112306,
    "cidade": "Japira"
  },
  {
    "prefixo": "84925",
    "uf": "PR",
    "codigoIbge": 4119202,
    "cidade": "Pinhalão"
  },
  {
    "prefixo": "84928",
    "uf": "PR",
    "codigoIbge": 4119202,
    "cidade": "Pinhalão"
  },
  {
    "prefixo": "84930",
    "uf": "PR",
    "codigoIbge": 4111704,
    "cidade": "Jaboti"
  },
  {
    "prefixo": "84935",
    "uf": "PR",
    "codigoIbge": 4127809,
    "cidade": "Tomazina"
  },
  {
    "prefixo": "84938",
    "uf": "PR",
    "codigoIbge": 4127809,
    "cidade": "Tomazina"
  },
  {
    "prefixo": "84940",
    "uf": "PR",
    "codigoIbge": 4126603,
    "cidade": "Siqueira Campos"
  },
  {
    "prefixo": "84943",
    "uf": "PR",
    "codigoIbge": 4126603,
    "cidade": "Siqueira Campos"
  },
  {
    "prefixo": "84945",
    "uf": "PR",
    "codigoIbge": 4122909,
    "cidade": "Salto do Itararé"
  },
  {
    "prefixo": "84950",
    "uf": "PR",
    "codigoIbge": 4128500,
    "cidade": "Wenceslau Braz"
  },
  {
    "prefixo": "84970",
    "uf": "PR",
    "codigoIbge": 4124004,
    "cidade": "Santana do Itararé"
  },
  {
    "prefixo": "84980",
    "uf": "PR",
    "codigoIbge": 4125407,
    "cidade": "São José da Boa Vista"
  },
  {
    "prefixo": "84990",
    "uf": "PR",
    "codigoIbge": 4101606,
    "cidade": "Arapoti"
  },
  {
    "prefixo": "84995",
    "uf": "PR",
    "codigoIbge": 4101606,
    "cidade": "Arapoti"
  },
  {
    "prefixo": "84998",
    "uf": "PR",
    "codigoIbge": 4101606,
    "cidade": "Arapoti"
  },
  {
    "prefixo": "85010",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85012",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85015",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85020",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85022",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85023",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85025",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85027",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85030",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85031",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85035",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85040",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85045",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85050",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85051",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85053",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85055",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85060",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85063",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85064",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85065",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85067",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85070",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85099",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85101",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85102",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85108",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85110",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85111",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85113",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85115",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85118",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85129",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85130",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85136",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85138",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85139",
    "uf": "PR",
    "codigoIbge": 4109401,
    "cidade": "Guarapuava"
  },
  {
    "prefixo": "85140",
    "uf": "PR",
    "codigoIbge": 4104428,
    "cidade": "Candói"
  },
  {
    "prefixo": "85145",
    "uf": "PR",
    "codigoIbge": 4108452,
    "cidade": "Foz do Jordão"
  },
  {
    "prefixo": "85148",
    "uf": "PR",
    "codigoIbge": 4103958,
    "cidade": "Campina do Simão"
  },
  {
    "prefixo": "85150",
    "uf": "PR",
    "codigoIbge": 4127965,
    "cidade": "Turvo"
  },
  {
    "prefixo": "85155",
    "uf": "PR",
    "codigoIbge": 4110201,
    "cidade": "Inácio Martins"
  },
  {
    "prefixo": "85160",
    "uf": "PR",
    "codigoIbge": 4104451,
    "cidade": "Cantagalo"
  },
  {
    "prefixo": "85162",
    "uf": "PR",
    "codigoIbge": 4108650,
    "cidade": "Goioxim"
  },
  {
    "prefixo": "85167",
    "uf": "PR",
    "codigoIbge": 4108650,
    "cidade": "Goioxim"
  },
  {
    "prefixo": "85168",
    "uf": "PR",
    "codigoIbge": 4115457,
    "cidade": "Marquinho"
  },
  {
    "prefixo": "85170",
    "uf": "PR",
    "codigoIbge": 4119301,
    "cidade": "Pinhão"
  },
  {
    "prefixo": "85172",
    "uf": "PR",
    "codigoIbge": 4119301,
    "cidade": "Pinhão"
  },
  {
    "prefixo": "85173",
    "uf": "PR",
    "codigoIbge": 4119301,
    "cidade": "Pinhão"
  },
  {
    "prefixo": "85174",
    "uf": "PR",
    "codigoIbge": 4119301,
    "cidade": "Pinhão"
  },
  {
    "prefixo": "85175",
    "uf": "PR",
    "codigoIbge": 4119301,
    "cidade": "Pinhão"
  },
  {
    "prefixo": "85180",
    "uf": "PR",
    "codigoIbge": 4119301,
    "cidade": "Pinhão"
  },
  {
    "prefixo": "85195",
    "uf": "PR",
    "codigoIbge": 4121752,
    "cidade": "Reserva do Iguaçu"
  },
  {
    "prefixo": "85200",
    "uf": "PR",
    "codigoIbge": 4119608,
    "cidade": "Pitanga"
  },
  {
    "prefixo": "85201",
    "uf": "PR",
    "codigoIbge": 4119608,
    "cidade": "Pitanga"
  },
  {
    "prefixo": "85202",
    "uf": "PR",
    "codigoIbge": 4119608,
    "cidade": "Pitanga"
  },
  {
    "prefixo": "85203",
    "uf": "PR",
    "codigoIbge": 4119608,
    "cidade": "Pitanga"
  },
  {
    "prefixo": "85216",
    "uf": "PR",
    "codigoIbge": 4119608,
    "cidade": "Pitanga"
  },
  {
    "prefixo": "85225",
    "uf": "PR",
    "codigoIbge": 4103040,
    "cidade": "Boa Ventura de São Roque"
  },
  {
    "prefixo": "85230",
    "uf": "PR",
    "codigoIbge": 4123857,
    "cidade": "Santa Maria do Oeste"
  },
  {
    "prefixo": "85235",
    "uf": "PR",
    "codigoIbge": 4123857,
    "cidade": "Santa Maria do Oeste"
  },
  {
    "prefixo": "85240",
    "uf": "PR",
    "codigoIbge": 4115739,
    "cidade": "Mato Rico"
  },
  {
    "prefixo": "85245",
    "uf": "PR",
    "codigoIbge": 4115739,
    "cidade": "Mato Rico"
  },
  {
    "prefixo": "85250",
    "uf": "PR",
    "codigoIbge": 4117271,
    "cidade": "Nova Tebas"
  },
  {
    "prefixo": "85255",
    "uf": "PR",
    "codigoIbge": 4117271,
    "cidade": "Nova Tebas"
  },
  {
    "prefixo": "85260",
    "uf": "PR",
    "codigoIbge": 4114500,
    "cidade": "Manoel Ribas"
  },
  {
    "prefixo": "85265",
    "uf": "PR",
    "codigoIbge": 4114500,
    "cidade": "Manoel Ribas"
  },
  {
    "prefixo": "85270",
    "uf": "PR",
    "codigoIbge": 4117800,
    "cidade": "Palmital"
  },
  {
    "prefixo": "85275",
    "uf": "PR",
    "codigoIbge": 4113254,
    "cidade": "Laranjal"
  },
  {
    "prefixo": "85280",
    "uf": "PR",
    "codigoIbge": 4100459,
    "cidade": "Altamira do Paraná"
  },
  {
    "prefixo": "85301",
    "uf": "PR",
    "codigoIbge": 4113304,
    "cidade": "Laranjeiras do Sul"
  },
  {
    "prefixo": "85302",
    "uf": "PR",
    "codigoIbge": 4113304,
    "cidade": "Laranjeiras do Sul"
  },
  {
    "prefixo": "85303",
    "uf": "PR",
    "codigoIbge": 4113304,
    "cidade": "Laranjeiras do Sul"
  },
  {
    "prefixo": "85304",
    "uf": "PR",
    "codigoIbge": 4113304,
    "cidade": "Laranjeiras do Sul"
  },
  {
    "prefixo": "85319",
    "uf": "PR",
    "codigoIbge": 4113304,
    "cidade": "Laranjeiras do Sul"
  },
  {
    "prefixo": "85340",
    "uf": "PR",
    "codigoIbge": 4122156,
    "cidade": "Rio Bonito do Iguaçu"
  },
  {
    "prefixo": "85345",
    "uf": "PR",
    "codigoIbge": 4120150,
    "cidade": "Porto Barreiro"
  },
  {
    "prefixo": "85350",
    "uf": "PR",
    "codigoIbge": 4117057,
    "cidade": "Nova Laranjeiras"
  },
  {
    "prefixo": "85360",
    "uf": "PR",
    "codigoIbge": 4117057,
    "cidade": "Nova Laranjeiras"
  },
  {
    "prefixo": "85365",
    "uf": "PR",
    "codigoIbge": 4117057,
    "cidade": "Nova Laranjeiras"
  },
  {
    "prefixo": "85370",
    "uf": "PR",
    "codigoIbge": 4117057,
    "cidade": "Nova Laranjeiras"
  },
  {
    "prefixo": "85380",
    "uf": "PR",
    "codigoIbge": 4117057,
    "cidade": "Nova Laranjeiras"
  },
  {
    "prefixo": "85385",
    "uf": "PR",
    "codigoIbge": 4117057,
    "cidade": "Nova Laranjeiras"
  },
  {
    "prefixo": "85390",
    "uf": "PR",
    "codigoIbge": 4128658,
    "cidade": "Virmond"
  },
  {
    "prefixo": "85400",
    "uf": "PR",
    "codigoIbge": 4109302,
    "cidade": "Guaraniaçu"
  },
  {
    "prefixo": "85405",
    "uf": "PR",
    "codigoIbge": 4109302,
    "cidade": "Guaraniaçu"
  },
  {
    "prefixo": "85406",
    "uf": "PR",
    "codigoIbge": 4109302,
    "cidade": "Guaraniaçu"
  },
  {
    "prefixo": "85407",
    "uf": "PR",
    "codigoIbge": 4109302,
    "cidade": "Guaraniaçu"
  },
  {
    "prefixo": "85408",
    "uf": "PR",
    "codigoIbge": 4107124,
    "cidade": "Diamante do Sul"
  },
  {
    "prefixo": "85410",
    "uf": "PR",
    "codigoIbge": 4116703,
    "cidade": "Nova Aurora"
  },
  {
    "prefixo": "85412",
    "uf": "PR",
    "codigoIbge": 4116703,
    "cidade": "Nova Aurora"
  },
  {
    "prefixo": "85413",
    "uf": "PR",
    "codigoIbge": 4116703,
    "cidade": "Nova Aurora"
  },
  {
    "prefixo": "85415",
    "uf": "PR",
    "codigoIbge": 4103453,
    "cidade": "Cafelândia"
  },
  {
    "prefixo": "85420",
    "uf": "PR",
    "codigoIbge": 4106308,
    "cidade": "Corbélia"
  },
  {
    "prefixo": "85422",
    "uf": "PR",
    "codigoIbge": 4106308,
    "cidade": "Corbélia"
  },
  {
    "prefixo": "85423",
    "uf": "PR",
    "codigoIbge": 4110052,
    "cidade": "Iguatu"
  },
  {
    "prefixo": "85425",
    "uf": "PR",
    "codigoIbge": 4101051,
    "cidade": "Anahy"
  },
  {
    "prefixo": "85430",
    "uf": "PR",
    "codigoIbge": 4103354,
    "cidade": "Braganey"
  },
  {
    "prefixo": "85440",
    "uf": "PR",
    "codigoIbge": 4128005,
    "cidade": "Ubiratã"
  },
  {
    "prefixo": "85445",
    "uf": "PR",
    "codigoIbge": 4128005,
    "cidade": "Ubiratã"
  },
  {
    "prefixo": "85450",
    "uf": "PR",
    "codigoIbge": 4104055,
    "cidade": "Campo Bonito"
  },
  {
    "prefixo": "85460",
    "uf": "PR",
    "codigoIbge": 4120903,
    "cidade": "Quedas do Iguaçu"
  },
  {
    "prefixo": "85465",
    "uf": "PR",
    "codigoIbge": 4107546,
    "cidade": "Espigão Alto do Iguaçu"
  },
  {
    "prefixo": "85470",
    "uf": "PR",
    "codigoIbge": 4105003,
    "cidade": "Catanduvas"
  },
  {
    "prefixo": "85478",
    "uf": "PR",
    "codigoIbge": 4109757,
    "cidade": "Ibema"
  },
  {
    "prefixo": "85485",
    "uf": "PR",
    "codigoIbge": 4127858,
    "cidade": "Três Barras do Paraná"
  },
  {
    "prefixo": "85486",
    "uf": "PR",
    "codigoIbge": 4127858,
    "cidade": "Três Barras do Paraná"
  },
  {
    "prefixo": "85487",
    "uf": "PR",
    "codigoIbge": 4127858,
    "cidade": "Três Barras do Paraná"
  },
  {
    "prefixo": "85489",
    "uf": "PR",
    "codigoIbge": 4127858,
    "cidade": "Três Barras do Paraná"
  },
  {
    "prefixo": "85501",
    "uf": "PR",
    "codigoIbge": 4118501,
    "cidade": "Pato Branco"
  },
  {
    "prefixo": "85502",
    "uf": "PR",
    "codigoIbge": 4118501,
    "cidade": "Pato Branco"
  },
  {
    "prefixo": "85503",
    "uf": "PR",
    "codigoIbge": 4118501,
    "cidade": "Pato Branco"
  },
  {
    "prefixo": "85504",
    "uf": "PR",
    "codigoIbge": 4118501,
    "cidade": "Pato Branco"
  },
  {
    "prefixo": "85505",
    "uf": "PR",
    "codigoIbge": 4118501,
    "cidade": "Pato Branco"
  },
  {
    "prefixo": "85506",
    "uf": "PR",
    "codigoIbge": 4118501,
    "cidade": "Pato Branco"
  },
  {
    "prefixo": "85507",
    "uf": "PR",
    "codigoIbge": 4118501,
    "cidade": "Pato Branco"
  },
  {
    "prefixo": "85508",
    "uf": "PR",
    "codigoIbge": 4118501,
    "cidade": "Pato Branco"
  },
  {
    "prefixo": "85509",
    "uf": "PR",
    "codigoIbge": 4118501,
    "cidade": "Pato Branco"
  },
  {
    "prefixo": "85513",
    "uf": "PR",
    "codigoIbge": 4118501,
    "cidade": "Pato Branco"
  },
  {
    "prefixo": "85514",
    "uf": "PR",
    "codigoIbge": 4118501,
    "cidade": "Pato Branco"
  },
  {
    "prefixo": "85515",
    "uf": "PR",
    "codigoIbge": 4103222,
    "cidade": "Bom Sucesso do Sul"
  },
  {
    "prefixo": "85520",
    "uf": "PR",
    "codigoIbge": 4128708,
    "cidade": "Vitorino"
  },
  {
    "prefixo": "85525",
    "uf": "PR",
    "codigoIbge": 4115309,
    "cidade": "Mariópolis"
  },
  {
    "prefixo": "85528",
    "uf": "PR",
    "codigoIbge": 4115309,
    "cidade": "Mariópolis"
  },
  {
    "prefixo": "85530",
    "uf": "PR",
    "codigoIbge": 4105706,
    "cidade": "Clevelândia"
  },
  {
    "prefixo": "85536",
    "uf": "PR",
    "codigoIbge": 4105706,
    "cidade": "Clevelândia"
  },
  {
    "prefixo": "85538",
    "uf": "PR",
    "codigoIbge": 4105706,
    "cidade": "Clevelândia"
  },
  {
    "prefixo": "85540",
    "uf": "PR",
    "codigoIbge": 4114401,
    "cidade": "Mangueirinha"
  },
  {
    "prefixo": "85545",
    "uf": "PR",
    "codigoIbge": 4114401,
    "cidade": "Mangueirinha"
  },
  {
    "prefixo": "85548",
    "uf": "PR",
    "codigoIbge": 4109658,
    "cidade": "Honório Serpa"
  },
  {
    "prefixo": "85550",
    "uf": "PR",
    "codigoIbge": 4106506,
    "cidade": "Coronel Vivida"
  },
  {
    "prefixo": "85554",
    "uf": "PR",
    "codigoIbge": 4106506,
    "cidade": "Coronel Vivida"
  },
  {
    "prefixo": "85555",
    "uf": "PR",
    "codigoIbge": 4117602,
    "cidade": "Palmas"
  },
  {
    "prefixo": "85556",
    "uf": "PR",
    "codigoIbge": 4117602,
    "cidade": "Palmas"
  },
  {
    "prefixo": "85557",
    "uf": "PR",
    "codigoIbge": 4106456,
    "cidade": "Coronel Domingos Soares"
  },
  {
    "prefixo": "85558",
    "uf": "PR",
    "codigoIbge": 4106456,
    "cidade": "Coronel Domingos Soares"
  },
  {
    "prefixo": "85559",
    "uf": "PR",
    "codigoIbge": 4106456,
    "cidade": "Coronel Domingos Soares"
  },
  {
    "prefixo": "85560",
    "uf": "PR",
    "codigoIbge": 4105409,
    "cidade": "Chopinzinho"
  },
  {
    "prefixo": "85562",
    "uf": "PR",
    "codigoIbge": 4105409,
    "cidade": "Chopinzinho"
  },
  {
    "prefixo": "85563",
    "uf": "PR",
    "codigoIbge": 4105409,
    "cidade": "Chopinzinho"
  },
  {
    "prefixo": "85565",
    "uf": "PR",
    "codigoIbge": 4126652,
    "cidade": "Sulina"
  },
  {
    "prefixo": "85568",
    "uf": "PR",
    "codigoIbge": 4126272,
    "cidade": "Saudade do Iguaçu"
  },
  {
    "prefixo": "85570",
    "uf": "PR",
    "codigoIbge": 4124806,
    "cidade": "São João"
  },
  {
    "prefixo": "85571",
    "uf": "PR",
    "codigoIbge": 4124806,
    "cidade": "São João"
  },
  {
    "prefixo": "85572",
    "uf": "PR",
    "codigoIbge": 4124806,
    "cidade": "São João"
  },
  {
    "prefixo": "85573",
    "uf": "PR",
    "codigoIbge": 4124806,
    "cidade": "São João"
  },
  {
    "prefixo": "85575",
    "uf": "PR",
    "codigoIbge": 4125209,
    "cidade": "São Jorge d'Oeste"
  },
  {
    "prefixo": "85577",
    "uf": "PR",
    "codigoIbge": 4125209,
    "cidade": "São Jorge d'Oeste"
  },
  {
    "prefixo": "85578",
    "uf": "PR",
    "codigoIbge": 4125209,
    "cidade": "São Jorge d'Oeste"
  },
  {
    "prefixo": "85579",
    "uf": "PR",
    "codigoIbge": 4125209,
    "cidade": "São Jorge d'Oeste"
  },
  {
    "prefixo": "85580",
    "uf": "PR",
    "codigoIbge": 4111209,
    "cidade": "Itapejara d'Oeste"
  },
  {
    "prefixo": "85582",
    "uf": "PR",
    "codigoIbge": 4111209,
    "cidade": "Itapejara d'Oeste"
  },
  {
    "prefixo": "85585",
    "uf": "PR",
    "codigoIbge": 4128609,
    "cidade": "Verê"
  },
  {
    "prefixo": "85587",
    "uf": "PR",
    "codigoIbge": 4128609,
    "cidade": "Verê"
  },
  {
    "prefixo": "85588",
    "uf": "PR",
    "codigoIbge": 4128609,
    "cidade": "Verê"
  },
  {
    "prefixo": "85598",
    "uf": "PR",
    "codigoIbge": 4106571,
    "cidade": "Cruzeiro do Iguaçu"
  },
  {
    "prefixo": "85601",
    "uf": "PR",
    "codigoIbge": 4108403,
    "cidade": "Francisco Beltrão"
  },
  {
    "prefixo": "85602",
    "uf": "PR",
    "codigoIbge": 4108403,
    "cidade": "Francisco Beltrão"
  },
  {
    "prefixo": "85603",
    "uf": "PR",
    "codigoIbge": 4108403,
    "cidade": "Francisco Beltrão"
  },
  {
    "prefixo": "85604",
    "uf": "PR",
    "codigoIbge": 4108403,
    "cidade": "Francisco Beltrão"
  },
  {
    "prefixo": "85605",
    "uf": "PR",
    "codigoIbge": 4108403,
    "cidade": "Francisco Beltrão"
  },
  {
    "prefixo": "85606",
    "uf": "PR",
    "codigoIbge": 4108403,
    "cidade": "Francisco Beltrão"
  },
  {
    "prefixo": "85607",
    "uf": "PR",
    "codigoIbge": 4108403,
    "cidade": "Francisco Beltrão"
  },
  {
    "prefixo": "85608",
    "uf": "PR",
    "codigoIbge": 4108403,
    "cidade": "Francisco Beltrão"
  },
  {
    "prefixo": "85609",
    "uf": "PR",
    "codigoIbge": 4108403,
    "cidade": "Francisco Beltrão"
  },
  {
    "prefixo": "85610",
    "uf": "PR",
    "codigoIbge": 4121604,
    "cidade": "Renascença"
  },
  {
    "prefixo": "85615",
    "uf": "PR",
    "codigoIbge": 4115408,
    "cidade": "Marmeleiro"
  },
  {
    "prefixo": "85618",
    "uf": "PR",
    "codigoIbge": 4107850,
    "cidade": "Flor da Serra do Sul"
  },
  {
    "prefixo": "85620",
    "uf": "PR",
    "codigoIbge": 4122800,
    "cidade": "Salgado Filho"
  },
  {
    "prefixo": "85628",
    "uf": "PR",
    "codigoIbge": 4114351,
    "cidade": "Manfrinópolis"
  },
  {
    "prefixo": "85630",
    "uf": "PR",
    "codigoIbge": 4107405,
    "cidade": "Enéas Marques"
  },
  {
    "prefixo": "85633",
    "uf": "PR",
    "codigoIbge": 4107405,
    "cidade": "Enéas Marques"
  },
  {
    "prefixo": "85634",
    "uf": "PR",
    "codigoIbge": 4107405,
    "cidade": "Enéas Marques"
  },
  {
    "prefixo": "85635",
    "uf": "PR",
    "codigoIbge": 4116950,
    "cidade": "Nova Esperança do Sudoeste"
  },
  {
    "prefixo": "85640",
    "uf": "PR",
    "codigoIbge": 4101002,
    "cidade": "Ampére"
  },
  {
    "prefixo": "85643",
    "uf": "PR",
    "codigoIbge": 4101002,
    "cidade": "Ampére"
  },
  {
    "prefixo": "85650",
    "uf": "PR",
    "codigoIbge": 4123808,
    "cidade": "Santa Izabel do Oeste"
  },
  {
    "prefixo": "85654",
    "uf": "PR",
    "codigoIbge": 4123808,
    "cidade": "Santa Izabel do Oeste"
  },
  {
    "prefixo": "85655",
    "uf": "PR",
    "codigoIbge": 4123808,
    "cidade": "Santa Izabel do Oeste"
  },
  {
    "prefixo": "85660",
    "uf": "PR",
    "codigoIbge": 4107207,
    "cidade": "Dois Vizinhos"
  },
  {
    "prefixo": "85668",
    "uf": "PR",
    "codigoIbge": 4107207,
    "cidade": "Dois Vizinhos"
  },
  {
    "prefixo": "85670",
    "uf": "PR",
    "codigoIbge": 4123006,
    "cidade": "Salto do Lontra"
  },
  {
    "prefixo": "85678",
    "uf": "PR",
    "codigoIbge": 4123006,
    "cidade": "Salto do Lontra"
  },
  {
    "prefixo": "85680",
    "uf": "PR",
    "codigoIbge": 4103024,
    "cidade": "Boa Esperança do Iguaçu"
  },
  {
    "prefixo": "85685",
    "uf": "PR",
    "codigoIbge": 4117255,
    "cidade": "Nova Prata do Iguaçu"
  },
  {
    "prefixo": "85690",
    "uf": "PR",
    "codigoIbge": 4117602,
    "cidade": "Palmas"
  },
  {
    "prefixo": "85691",
    "uf": "PR",
    "codigoIbge": 4117602,
    "cidade": "Palmas"
  },
  {
    "prefixo": "85692",
    "uf": "PR",
    "codigoIbge": 4117602,
    "cidade": "Palmas"
  },
  {
    "prefixo": "85693",
    "uf": "PR",
    "codigoIbge": 4117602,
    "cidade": "Palmas"
  },
  {
    "prefixo": "85700",
    "uf": "PR",
    "codigoIbge": 4102604,
    "cidade": "Barracão"
  },
  {
    "prefixo": "85708",
    "uf": "PR",
    "codigoIbge": 4103156,
    "cidade": "Bom Jesus do Sul"
  },
  {
    "prefixo": "85710",
    "uf": "PR",
    "codigoIbge": 4124400,
    "cidade": "Santo Antônio do Sudoeste"
  },
  {
    "prefixo": "85720",
    "uf": "PR",
    "codigoIbge": 4115804,
    "cidade": "Medianeira"
  },
  {
    "prefixo": "85722",
    "uf": "PR",
    "codigoIbge": 4115804,
    "cidade": "Medianeira"
  },
  {
    "prefixo": "85723",
    "uf": "PR",
    "codigoIbge": 4115804,
    "cidade": "Medianeira"
  },
  {
    "prefixo": "85724",
    "uf": "PR",
    "codigoIbge": 4115804,
    "cidade": "Medianeira"
  },
  {
    "prefixo": "85725",
    "uf": "PR",
    "codigoIbge": 4124400,
    "cidade": "Santo Antônio do Sudoeste"
  },
  {
    "prefixo": "85727",
    "uf": "PR",
    "codigoIbge": 4119251,
    "cidade": "Pinhal de São Bento"
  },
  {
    "prefixo": "85730",
    "uf": "PR",
    "codigoIbge": 4120358,
    "cidade": "Pranchita"
  },
  {
    "prefixo": "85735",
    "uf": "PR",
    "codigoIbge": 4120358,
    "cidade": "Pranchita"
  },
  {
    "prefixo": "85740",
    "uf": "PR",
    "codigoIbge": 4119004,
    "cidade": "Pérola d'Oeste"
  },
  {
    "prefixo": "85743",
    "uf": "PR",
    "codigoIbge": 4119004,
    "cidade": "Pérola d'Oeste"
  },
  {
    "prefixo": "85745",
    "uf": "PR",
    "codigoIbge": 4102752,
    "cidade": "Bela Vista da Caroba"
  },
  {
    "prefixo": "85750",
    "uf": "PR",
    "codigoIbge": 4119806,
    "cidade": "Planalto"
  },
  {
    "prefixo": "85756",
    "uf": "PR",
    "codigoIbge": 4119806,
    "cidade": "Planalto"
  },
  {
    "prefixo": "85758",
    "uf": "PR",
    "codigoIbge": 4119806,
    "cidade": "Planalto"
  },
  {
    "prefixo": "85760",
    "uf": "PR",
    "codigoIbge": 4104501,
    "cidade": "Capanema"
  },
  {
    "prefixo": "85763",
    "uf": "PR",
    "codigoIbge": 4104501,
    "cidade": "Capanema"
  },
  {
    "prefixo": "85765",
    "uf": "PR",
    "codigoIbge": 4104501,
    "cidade": "Capanema"
  },
  {
    "prefixo": "85767",
    "uf": "PR",
    "codigoIbge": 4104501,
    "cidade": "Capanema"
  },
  {
    "prefixo": "85770",
    "uf": "PR",
    "codigoIbge": 4121406,
    "cidade": "Realeza"
  },
  {
    "prefixo": "85779",
    "uf": "PR",
    "codigoIbge": 4121406,
    "cidade": "Realeza"
  },
  {
    "prefixo": "85780",
    "uf": "PR",
    "codigoIbge": 4103057,
    "cidade": "Boa Vista da Aparecida"
  },
  {
    "prefixo": "85790",
    "uf": "PR",
    "codigoIbge": 4104600,
    "cidade": "Capitão Leônidas Marques"
  },
  {
    "prefixo": "85794",
    "uf": "PR",
    "codigoIbge": 4104600,
    "cidade": "Capitão Leônidas Marques"
  },
  {
    "prefixo": "85795",
    "uf": "PR",
    "codigoIbge": 4123824,
    "cidade": "Santa Lúcia"
  },
  {
    "prefixo": "85801",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85802",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85803",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85804",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85805",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85806",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85807",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85808",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85810",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85811",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85812",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85813",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85814",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85815",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85816",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85817",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85818",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85819",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85820",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85821",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85822",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85823",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85824",
    "uf": "PR",
    "codigoIbge": 4104808,
    "cidade": "Cascavel"
  },
  {
    "prefixo": "85825",
    "uf": "PR",
    "codigoIbge": 4124020,
    "cidade": "Santa Tereza do Oeste"
  },
  {
    "prefixo": "85826",
    "uf": "PR",
    "codigoIbge": 4113452,
    "cidade": "Lindoeste"
  },
  {
    "prefixo": "85830",
    "uf": "PR",
    "codigoIbge": 4108205,
    "cidade": "Formosa do Oeste"
  },
  {
    "prefixo": "85833",
    "uf": "PR",
    "codigoIbge": 4110656,
    "cidade": "Iracema do Oeste"
  },
  {
    "prefixo": "85835",
    "uf": "PR",
    "codigoIbge": 4112751,
    "cidade": "Jesuítas"
  },
  {
    "prefixo": "85837",
    "uf": "PR",
    "codigoIbge": 4112751,
    "cidade": "Jesuítas"
  },
  {
    "prefixo": "85840",
    "uf": "PR",
    "codigoIbge": 4105300,
    "cidade": "Céu Azul"
  },
  {
    "prefixo": "85845",
    "uf": "PR",
    "codigoIbge": 4128559,
    "cidade": "Vera Cruz do Oeste"
  },
  {
    "prefixo": "85851",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85852",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85853",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85854",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85855",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85856",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85857",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85858",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85859",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85860",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85861",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85862",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85863",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85864",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85865",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85866",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85867",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85868",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85869",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85870",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85871",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85874",
    "uf": "PR",
    "codigoIbge": 4108304,
    "cidade": "Foz do Iguaçu"
  },
  {
    "prefixo": "85875",
    "uf": "PR",
    "codigoIbge": 4124053,
    "cidade": "Santa Terezinha de Itaipu"
  },
  {
    "prefixo": "85877",
    "uf": "PR",
    "codigoIbge": 4125704,
    "cidade": "São Miguel do Iguaçu"
  },
  {
    "prefixo": "85878",
    "uf": "PR",
    "codigoIbge": 4125704,
    "cidade": "São Miguel do Iguaçu"
  },
  {
    "prefixo": "85879",
    "uf": "PR",
    "codigoIbge": 4125704,
    "cidade": "São Miguel do Iguaçu"
  },
  {
    "prefixo": "85880",
    "uf": "PR",
    "codigoIbge": 4110953,
    "cidade": "Itaipulândia"
  },
  {
    "prefixo": "85884",
    "uf": "PR",
    "codigoIbge": 4115804,
    "cidade": "Medianeira"
  },
  {
    "prefixo": "85885",
    "uf": "PR",
    "codigoIbge": 4126355,
    "cidade": "Serranópolis do Iguaçu"
  },
  {
    "prefixo": "85886",
    "uf": "PR",
    "codigoIbge": 4126355,
    "cidade": "Serranópolis do Iguaçu"
  },
  {
    "prefixo": "85887",
    "uf": "PR",
    "codigoIbge": 4115606,
    "cidade": "Matelândia"
  },
  {
    "prefixo": "85888",
    "uf": "PR",
    "codigoIbge": 4121257,
    "cidade": "Ramilândia"
  },
  {
    "prefixo": "85890",
    "uf": "PR",
    "codigoIbge": 4116059,
    "cidade": "Missal"
  },
  {
    "prefixo": "85892",
    "uf": "PR",
    "codigoIbge": 4123501,
    "cidade": "Santa Helena"
  },
  {
    "prefixo": "85893",
    "uf": "PR",
    "codigoIbge": 4123501,
    "cidade": "Santa Helena"
  },
  {
    "prefixo": "85894",
    "uf": "PR",
    "codigoIbge": 4123501,
    "cidade": "Santa Helena"
  },
  {
    "prefixo": "85896",
    "uf": "PR",
    "codigoIbge": 4107157,
    "cidade": "Diamante D'Oeste"
  },
  {
    "prefixo": "85898",
    "uf": "PR",
    "codigoIbge": 4125456,
    "cidade": "São José das Palmeiras"
  },
  {
    "prefixo": "85900",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85901",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85902",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85903",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85904",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85905",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85906",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85907",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85908",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85909",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85910",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85911",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85912",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85913",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85914",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85915",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85919",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85920",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85921",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85922",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85923",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85924",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85925",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85926",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85927",
    "uf": "PR",
    "codigoIbge": 4127700,
    "cidade": "Toledo"
  },
  {
    "prefixo": "85929",
    "uf": "PR",
    "codigoIbge": 4125753,
    "cidade": "São Pedro do Iguaçu"
  },
  {
    "prefixo": "85930",
    "uf": "PR",
    "codigoIbge": 4117222,
    "cidade": "Nova Santa Rosa"
  },
  {
    "prefixo": "85931",
    "uf": "PR",
    "codigoIbge": 4117222,
    "cidade": "Nova Santa Rosa"
  },
  {
    "prefixo": "85933",
    "uf": "PR",
    "codigoIbge": 4117453,
    "cidade": "Ouro Verde do Oeste"
  },
  {
    "prefixo": "85935",
    "uf": "PR",
    "codigoIbge": 4102000,
    "cidade": "Assis Chateaubriand"
  },
  {
    "prefixo": "85936",
    "uf": "PR",
    "codigoIbge": 4102000,
    "cidade": "Assis Chateaubriand"
  },
  {
    "prefixo": "85937",
    "uf": "PR",
    "codigoIbge": 4102000,
    "cidade": "Assis Chateaubriand"
  },
  {
    "prefixo": "85940",
    "uf": "PR",
    "codigoIbge": 4120853,
    "cidade": "Quatro Pontes"
  },
  {
    "prefixo": "85945",
    "uf": "PR",
    "codigoIbge": 4127957,
    "cidade": "Tupãssi"
  },
  {
    "prefixo": "85948",
    "uf": "PR",
    "codigoIbge": 4118451,
    "cidade": "Pato Bragado"
  },
  {
    "prefixo": "85950",
    "uf": "PR",
    "codigoIbge": 4117909,
    "cidade": "Palotina"
  },
  {
    "prefixo": "85951",
    "uf": "PR",
    "codigoIbge": 4117909,
    "cidade": "Palotina"
  },
  {
    "prefixo": "85952",
    "uf": "PR",
    "codigoIbge": 4117909,
    "cidade": "Palotina"
  },
  {
    "prefixo": "85953",
    "uf": "PR",
    "codigoIbge": 4117909,
    "cidade": "Palotina"
  },
  {
    "prefixo": "85954",
    "uf": "PR",
    "codigoIbge": 4117909,
    "cidade": "Palotina"
  },
  {
    "prefixo": "85955",
    "uf": "PR",
    "codigoIbge": 4115358,
    "cidade": "Maripá"
  },
  {
    "prefixo": "85957",
    "uf": "PR",
    "codigoIbge": 4115358,
    "cidade": "Maripá"
  },
  {
    "prefixo": "85958",
    "uf": "PR",
    "codigoIbge": 4115358,
    "cidade": "Maripá"
  },
  {
    "prefixo": "85960",
    "uf": "PR",
    "codigoIbge": 4114609,
    "cidade": "Marechal Cândido Rondon"
  },
  {
    "prefixo": "85963",
    "uf": "PR",
    "codigoIbge": 4114609,
    "cidade": "Marechal Cândido Rondon"
  },
  {
    "prefixo": "85966",
    "uf": "PR",
    "codigoIbge": 4114609,
    "cidade": "Marechal Cândido Rondon"
  },
  {
    "prefixo": "85970",
    "uf": "PR",
    "codigoIbge": 4114609,
    "cidade": "Marechal Cândido Rondon"
  },
  {
    "prefixo": "85971",
    "uf": "PR",
    "codigoIbge": 4114609,
    "cidade": "Marechal Cândido Rondon"
  },
  {
    "prefixo": "85972",
    "uf": "PR",
    "codigoIbge": 4114609,
    "cidade": "Marechal Cândido Rondon"
  },
  {
    "prefixo": "85973",
    "uf": "PR",
    "codigoIbge": 4114609,
    "cidade": "Marechal Cândido Rondon"
  },
  {
    "prefixo": "85974",
    "uf": "PR",
    "codigoIbge": 4114609,
    "cidade": "Marechal Cândido Rondon"
  },
  {
    "prefixo": "85975",
    "uf": "PR",
    "codigoIbge": 4114609,
    "cidade": "Marechal Cândido Rondon"
  },
  {
    "prefixo": "85976",
    "uf": "PR",
    "codigoIbge": 4114609,
    "cidade": "Marechal Cândido Rondon"
  },
  {
    "prefixo": "85977",
    "uf": "PR",
    "codigoIbge": 4114609,
    "cidade": "Marechal Cândido Rondon"
  },
  {
    "prefixo": "85978",
    "uf": "PR",
    "codigoIbge": 4114609,
    "cidade": "Marechal Cândido Rondon"
  },
  {
    "prefixo": "85980",
    "uf": "PR",
    "codigoIbge": 4108809,
    "cidade": "Guaíra"
  },
  {
    "prefixo": "85985",
    "uf": "PR",
    "codigoIbge": 4108809,
    "cidade": "Guaíra"
  },
  {
    "prefixo": "85988",
    "uf": "PR",
    "codigoIbge": 4107538,
    "cidade": "Entre Rios do Oeste"
  },
  {
    "prefixo": "85990",
    "uf": "PR",
    "codigoIbge": 4127403,
    "cidade": "Terra Roxa"
  },
  {
    "prefixo": "85995",
    "uf": "PR",
    "codigoIbge": 4127403,
    "cidade": "Terra Roxa"
  },
  {
    "prefixo": "85998",
    "uf": "PR",
    "codigoIbge": 4115853,
    "cidade": "Mercedes"
  },
  {
    "prefixo": "86001",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86010",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86015",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86020",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86025",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86026",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86027",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86030",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86031",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86032",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86035",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86036",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86037",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86038",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86039",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86040",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86041",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86042",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86043",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86044",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86045",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86046",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86047",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86049",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86050",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86055",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86056",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86057",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86058",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86060",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86061",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86062",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86063",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86065",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86066",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86067",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86068",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86070",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86071",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86072",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86073",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86075",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86076",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86077",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86078",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86079",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86080",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86081",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86082",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86083",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86084",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86085",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86086",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86087",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86088",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86089",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86099",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86101",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86102",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86103",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86105",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86106",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86108",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86109",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86110",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86112",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86113",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86114",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86115",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86117",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86120",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86122",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86123",
    "uf": "PR",
    "codigoIbge": 4113700,
    "cidade": "Londrina"
  },
  {
    "prefixo": "86125",
    "uf": "PR",
    "codigoIbge": 4126678,
    "cidade": "Tamarana"
  },
  {
    "prefixo": "86130",
    "uf": "PR",
    "codigoIbge": 4102802,
    "cidade": "Bela Vista do Paraíso"
  },
  {
    "prefixo": "86140",
    "uf": "PR",
    "codigoIbge": 4120507,
    "cidade": "Primeiro de Maio"
  },
  {
    "prefixo": "86142",
    "uf": "PR",
    "codigoIbge": 4120507,
    "cidade": "Primeiro de Maio"
  },
  {
    "prefixo": "86150",
    "uf": "PR",
    "codigoIbge": 4100806,
    "cidade": "Alvorada do Sul"
  },
  {
    "prefixo": "86155",
    "uf": "PR",
    "codigoIbge": 4100806,
    "cidade": "Alvorada do Sul"
  },
  {
    "prefixo": "86160",
    "uf": "PR",
    "codigoIbge": 4120002,
    "cidade": "Porecatu"
  },
  {
    "prefixo": "86165",
    "uf": "PR",
    "codigoIbge": 4108007,
    "cidade": "Florestópolis"
  },
  {
    "prefixo": "86170",
    "uf": "PR",
    "codigoIbge": 4126504,
    "cidade": "Sertanópolis"
  },
  {
    "prefixo": "86180",
    "uf": "PR",
    "codigoIbge": 4103701,
    "cidade": "Cambé"
  },
  {
    "prefixo": "86181",
    "uf": "PR",
    "codigoIbge": 4103701,
    "cidade": "Cambé"
  },
  {
    "prefixo": "86182",
    "uf": "PR",
    "codigoIbge": 4103701,
    "cidade": "Cambé"
  },
  {
    "prefixo": "86183",
    "uf": "PR",
    "codigoIbge": 4103701,
    "cidade": "Cambé"
  },
  {
    "prefixo": "86184",
    "uf": "PR",
    "codigoIbge": 4103701,
    "cidade": "Cambé"
  },
  {
    "prefixo": "86185",
    "uf": "PR",
    "codigoIbge": 4103701,
    "cidade": "Cambé"
  },
  {
    "prefixo": "86186",
    "uf": "PR",
    "codigoIbge": 4103701,
    "cidade": "Cambé"
  },
  {
    "prefixo": "86187",
    "uf": "PR",
    "codigoIbge": 4103701,
    "cidade": "Cambé"
  },
  {
    "prefixo": "86188",
    "uf": "PR",
    "codigoIbge": 4103701,
    "cidade": "Cambé"
  },
  {
    "prefixo": "86189",
    "uf": "PR",
    "codigoIbge": 4103701,
    "cidade": "Cambé"
  },
  {
    "prefixo": "86191",
    "uf": "PR",
    "codigoIbge": 4103701,
    "cidade": "Cambé"
  },
  {
    "prefixo": "86192",
    "uf": "PR",
    "codigoIbge": 4103701,
    "cidade": "Cambé"
  },
  {
    "prefixo": "86195",
    "uf": "PR",
    "codigoIbge": 4103701,
    "cidade": "Cambé"
  },
  {
    "prefixo": "86198",
    "uf": "PR",
    "codigoIbge": 4103701,
    "cidade": "Cambé"
  },
  {
    "prefixo": "86200",
    "uf": "PR",
    "codigoIbge": 4109807,
    "cidade": "Ibiporã"
  },
  {
    "prefixo": "86210",
    "uf": "PR",
    "codigoIbge": 4112702,
    "cidade": "Jataizinho"
  },
  {
    "prefixo": "86213",
    "uf": "PR",
    "codigoIbge": 4112702,
    "cidade": "Jataizinho"
  },
  {
    "prefixo": "86220",
    "uf": "PR",
    "codigoIbge": 4101903,
    "cidade": "Assaí"
  },
  {
    "prefixo": "86224",
    "uf": "PR",
    "codigoIbge": 4101903,
    "cidade": "Assaí"
  },
  {
    "prefixo": "86225",
    "uf": "PR",
    "codigoIbge": 4123204,
    "cidade": "Santa Cecília do Pavão"
  },
  {
    "prefixo": "86230",
    "uf": "PR",
    "codigoIbge": 4116604,
    "cidade": "Nova América da Colina"
  },
  {
    "prefixo": "86240",
    "uf": "PR",
    "codigoIbge": 4126009,
    "cidade": "São Sebastião da Amoreira"
  },
  {
    "prefixo": "86250",
    "uf": "PR",
    "codigoIbge": 4117214,
    "cidade": "Nova Santa Bárbara"
  },
  {
    "prefixo": "86270",
    "uf": "PR",
    "codigoIbge": 4124707,
    "cidade": "São Jerônimo da Serra"
  },
  {
    "prefixo": "86273",
    "uf": "PR",
    "codigoIbge": 4124707,
    "cidade": "São Jerônimo da Serra"
  },
  {
    "prefixo": "86275",
    "uf": "PR",
    "codigoIbge": 4124707,
    "cidade": "São Jerônimo da Serra"
  },
  {
    "prefixo": "86278",
    "uf": "PR",
    "codigoIbge": 4124707,
    "cidade": "São Jerônimo da Serra"
  },
  {
    "prefixo": "86280",
    "uf": "PR",
    "codigoIbge": 4128401,
    "cidade": "Uraí"
  },
  {
    "prefixo": "86285",
    "uf": "PR",
    "codigoIbge": 4128401,
    "cidade": "Uraí"
  },
  {
    "prefixo": "86290",
    "uf": "PR",
    "codigoIbge": 4121307,
    "cidade": "Rancho Alegre"
  },
  {
    "prefixo": "86300",
    "uf": "PR",
    "codigoIbge": 4106407,
    "cidade": "Cornélio Procópio"
  },
  {
    "prefixo": "86305",
    "uf": "PR",
    "codigoIbge": 4106407,
    "cidade": "Cornélio Procópio"
  },
  {
    "prefixo": "86310",
    "uf": "PR",
    "codigoIbge": 4117008,
    "cidade": "Nova Fátima"
  },
  {
    "prefixo": "86315",
    "uf": "PR",
    "codigoIbge": 4124301,
    "cidade": "Santo Antônio do Paraíso"
  },
  {
    "prefixo": "86318",
    "uf": "PR",
    "codigoIbge": 4124301,
    "cidade": "Santo Antônio do Paraíso"
  },
  {
    "prefixo": "86320",
    "uf": "PR",
    "codigoIbge": 4106001,
    "cidade": "Congonhinhas"
  },
  {
    "prefixo": "86323",
    "uf": "PR",
    "codigoIbge": 4106001,
    "cidade": "Congonhinhas"
  },
  {
    "prefixo": "86330",
    "uf": "PR",
    "codigoIbge": 4113403,
    "cidade": "Leópolis"
  },
  {
    "prefixo": "86335",
    "uf": "PR",
    "codigoIbge": 4113403,
    "cidade": "Leópolis"
  },
  {
    "prefixo": "86340",
    "uf": "PR",
    "codigoIbge": 4126405,
    "cidade": "Sertaneja"
  },
  {
    "prefixo": "86345",
    "uf": "PR",
    "codigoIbge": 4126405,
    "cidade": "Sertaneja"
  },
  {
    "prefixo": "86350",
    "uf": "PR",
    "codigoIbge": 4123907,
    "cidade": "Santa Mariana"
  },
  {
    "prefixo": "86355",
    "uf": "PR",
    "codigoIbge": 4123907,
    "cidade": "Santa Mariana"
  },
  {
    "prefixo": "86358",
    "uf": "PR",
    "codigoIbge": 4123907,
    "cidade": "Santa Mariana"
  },
  {
    "prefixo": "86360",
    "uf": "PR",
    "codigoIbge": 4102406,
    "cidade": "Bandeirantes"
  },
  {
    "prefixo": "86370",
    "uf": "PR",
    "codigoIbge": 4123105,
    "cidade": "Santa Amélia"
  },
  {
    "prefixo": "86375",
    "uf": "PR",
    "codigoIbge": 4111001,
    "cidade": "Itambaracá"
  },
  {
    "prefixo": "86378",
    "uf": "PR",
    "codigoIbge": 4111001,
    "cidade": "Itambaracá"
  },
  {
    "prefixo": "86380",
    "uf": "PR",
    "codigoIbge": 4101101,
    "cidade": "Andirá"
  },
  {
    "prefixo": "86385",
    "uf": "PR",
    "codigoIbge": 4102703,
    "cidade": "Barra do Jacaré"
  },
  {
    "prefixo": "86390",
    "uf": "PR",
    "codigoIbge": 4103602,
    "cidade": "Cambará"
  },
  {
    "prefixo": "86400",
    "uf": "PR",
    "codigoIbge": 4111803,
    "cidade": "Jacarezinho"
  },
  {
    "prefixo": "86409",
    "uf": "PR",
    "codigoIbge": 4111803,
    "cidade": "Jacarezinho"
  },
  {
    "prefixo": "86410",
    "uf": "PR",
    "codigoIbge": 4121802,
    "cidade": "Ribeirão Claro"
  },
  {
    "prefixo": "86415",
    "uf": "PR",
    "codigoIbge": 4121802,
    "cidade": "Ribeirão Claro"
  },
  {
    "prefixo": "86420",
    "uf": "PR",
    "codigoIbge": 4104709,
    "cidade": "Carlópolis"
  },
  {
    "prefixo": "86425",
    "uf": "PR",
    "codigoIbge": 4104709,
    "cidade": "Carlópolis"
  },
  {
    "prefixo": "86430",
    "uf": "PR",
    "codigoIbge": 4124103,
    "cidade": "Santo Antônio da Platina"
  },
  {
    "prefixo": "86440",
    "uf": "PR",
    "codigoIbge": 4124103,
    "cidade": "Santo Antônio da Platina"
  },
  {
    "prefixo": "86450",
    "uf": "PR",
    "codigoIbge": 4120705,
    "cidade": "Quatiguá"
  },
  {
    "prefixo": "86455",
    "uf": "PR",
    "codigoIbge": 4112801,
    "cidade": "Joaquim Távora"
  },
  {
    "prefixo": "86457",
    "uf": "PR",
    "codigoIbge": 4112801,
    "cidade": "Joaquim Távora"
  },
  {
    "prefixo": "86458",
    "uf": "PR",
    "codigoIbge": 4112801,
    "cidade": "Joaquim Távora"
  },
  {
    "prefixo": "86460",
    "uf": "PR",
    "codigoIbge": 4100103,
    "cidade": "Abatiá"
  },
  {
    "prefixo": "86465",
    "uf": "PR",
    "codigoIbge": 4109005,
    "cidade": "Guapirama"
  },
  {
    "prefixo": "86470",
    "uf": "PR",
    "codigoIbge": 4112900,
    "cidade": "Jundiaí do Sul"
  },
  {
    "prefixo": "86480",
    "uf": "PR",
    "codigoIbge": 4106100,
    "cidade": "Conselheiro Mairinck"
  },
  {
    "prefixo": "86490",
    "uf": "PR",
    "codigoIbge": 4121901,
    "cidade": "Ribeirão do Pinhal"
  },
  {
    "prefixo": "86495",
    "uf": "PR",
    "codigoIbge": 4121901,
    "cidade": "Ribeirão do Pinhal"
  },
  {
    "prefixo": "86600",
    "uf": "PR",
    "codigoIbge": 4122404,
    "cidade": "Rolândia"
  },
  {
    "prefixo": "86601",
    "uf": "PR",
    "codigoIbge": 4122404,
    "cidade": "Rolândia"
  },
  {
    "prefixo": "86602",
    "uf": "PR",
    "codigoIbge": 4122404,
    "cidade": "Rolândia"
  },
  {
    "prefixo": "86603",
    "uf": "PR",
    "codigoIbge": 4122404,
    "cidade": "Rolândia"
  },
  {
    "prefixo": "86604",
    "uf": "PR",
    "codigoIbge": 4122404,
    "cidade": "Rolândia"
  },
  {
    "prefixo": "86605",
    "uf": "PR",
    "codigoIbge": 4122404,
    "cidade": "Rolândia"
  },
  {
    "prefixo": "86606",
    "uf": "PR",
    "codigoIbge": 4122404,
    "cidade": "Rolândia"
  },
  {
    "prefixo": "86607",
    "uf": "PR",
    "codigoIbge": 4122404,
    "cidade": "Rolândia"
  },
  {
    "prefixo": "86609",
    "uf": "PR",
    "codigoIbge": 4122404,
    "cidade": "Rolândia"
  },
  {
    "prefixo": "86610",
    "uf": "PR",
    "codigoIbge": 4111902,
    "cidade": "Jaguapitã"
  },
  {
    "prefixo": "86613",
    "uf": "PR",
    "codigoIbge": 4119657,
    "cidade": "Pitangueiras"
  },
  {
    "prefixo": "86615",
    "uf": "PR",
    "codigoIbge": 4116000,
    "cidade": "Miraselva"
  },
  {
    "prefixo": "86618",
    "uf": "PR",
    "codigoIbge": 4120333,
    "cidade": "Prado Ferreira"
  },
  {
    "prefixo": "86620",
    "uf": "PR",
    "codigoIbge": 4109203,
    "cidade": "Guaraci"
  },
  {
    "prefixo": "86625",
    "uf": "PR",
    "codigoIbge": 4109203,
    "cidade": "Guaraci"
  },
  {
    "prefixo": "86630",
    "uf": "PR",
    "codigoIbge": 4105102,
    "cidade": "Centenário do Sul"
  },
  {
    "prefixo": "86635",
    "uf": "PR",
    "codigoIbge": 4113809,
    "cidade": "Lupionópolis"
  },
  {
    "prefixo": "86638",
    "uf": "PR",
    "codigoIbge": 4113809,
    "cidade": "Lupionópolis"
  },
  {
    "prefixo": "86640",
    "uf": "PR",
    "codigoIbge": 4103404,
    "cidade": "Cafeara"
  },
  {
    "prefixo": "86650",
    "uf": "PR",
    "codigoIbge": 4124509,
    "cidade": "Santo Inácio"
  },
  {
    "prefixo": "86660",
    "uf": "PR",
    "codigoIbge": 4123600,
    "cidade": "Santa Inês"
  },
  {
    "prefixo": "86670",
    "uf": "PR",
    "codigoIbge": 4110904,
    "cidade": "Itaguajé"
  },
  {
    "prefixo": "86680",
    "uf": "PR",
    "codigoIbge": 4116406,
    "cidade": "Nossa Senhora das Graças"
  },
  {
    "prefixo": "86685",
    "uf": "PR",
    "codigoIbge": 4116406,
    "cidade": "Nossa Senhora das Graças"
  },
  {
    "prefixo": "86690",
    "uf": "PR",
    "codigoIbge": 4105904,
    "cidade": "Colorado"
  },
  {
    "prefixo": "86695",
    "uf": "PR",
    "codigoIbge": 4105904,
    "cidade": "Colorado"
  },
  {
    "prefixo": "86700",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86701",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86702",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86703",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86704",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86705",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86706",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86707",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86708",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86709",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86710",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86711",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86712",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86713",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86715",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86716",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86719",
    "uf": "PR",
    "codigoIbge": 4101507,
    "cidade": "Arapongas"
  },
  {
    "prefixo": "86720",
    "uf": "PR",
    "codigoIbge": 4122701,
    "cidade": "Sabáudia"
  },
  {
    "prefixo": "86730",
    "uf": "PR",
    "codigoIbge": 4102109,
    "cidade": "Astorga"
  },
  {
    "prefixo": "86742",
    "uf": "PR",
    "codigoIbge": 4102109,
    "cidade": "Astorga"
  },
  {
    "prefixo": "86744",
    "uf": "PR",
    "codigoIbge": 4102109,
    "cidade": "Astorga"
  },
  {
    "prefixo": "86746",
    "uf": "PR",
    "codigoIbge": 4102109,
    "cidade": "Astorga"
  },
  {
    "prefixo": "86750",
    "uf": "PR",
    "codigoIbge": 4110003,
    "cidade": "Iguaraçu"
  },
  {
    "prefixo": "86755",
    "uf": "PR",
    "codigoIbge": 4101150,
    "cidade": "Ângulo"
  },
  {
    "prefixo": "86760",
    "uf": "PR",
    "codigoIbge": 4116307,
    "cidade": "Munhoz de Melo"
  },
  {
    "prefixo": "86765",
    "uf": "PR",
    "codigoIbge": 4116307,
    "cidade": "Munhoz de Melo"
  },
  {
    "prefixo": "86770",
    "uf": "PR",
    "codigoIbge": 4123402,
    "cidade": "Santa Fé"
  },
  {
    "prefixo": "86780",
    "uf": "PR",
    "codigoIbge": 4108106,
    "cidade": "Flórida"
  },
  {
    "prefixo": "86790",
    "uf": "PR",
    "codigoIbge": 4113601,
    "cidade": "Lobato"
  },
  {
    "prefixo": "86800",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86801",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86802",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86803",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86804",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86805",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86806",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86807",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86808",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86809",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86810",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86811",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86812",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86813",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86814",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86815",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86816",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86817",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86818",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86819",
    "uf": "PR",
    "codigoIbge": 4101408,
    "cidade": "Apucarana"
  },
  {
    "prefixo": "86820",
    "uf": "PR",
    "codigoIbge": 4103503,
    "cidade": "Califórnia"
  },
  {
    "prefixo": "86825",
    "uf": "PR",
    "codigoIbge": 4114906,
    "cidade": "Marilândia do Sul"
  },
  {
    "prefixo": "86826",
    "uf": "PR",
    "codigoIbge": 4114906,
    "cidade": "Marilândia do Sul"
  },
  {
    "prefixo": "86828",
    "uf": "PR",
    "codigoIbge": 4115754,
    "cidade": "Mauá da Serra"
  },
  {
    "prefixo": "86830",
    "uf": "PR",
    "codigoIbge": 4122107,
    "cidade": "Rio Bom"
  },
  {
    "prefixo": "86835",
    "uf": "PR",
    "codigoIbge": 4122107,
    "cidade": "Rio Bom"
  },
  {
    "prefixo": "86840",
    "uf": "PR",
    "codigoIbge": 4107603,
    "cidade": "Faxinal"
  },
  {
    "prefixo": "86842",
    "uf": "PR",
    "codigoIbge": 4107603,
    "cidade": "Faxinal"
  },
  {
    "prefixo": "86845",
    "uf": "PR",
    "codigoIbge": 4108700,
    "cidade": "Grandes Rios"
  },
  {
    "prefixo": "86847",
    "uf": "PR",
    "codigoIbge": 4108700,
    "cidade": "Grandes Rios"
  },
  {
    "prefixo": "86848",
    "uf": "PR",
    "codigoIbge": 4122172,
    "cidade": "Rio Branco do Ivaí"
  },
  {
    "prefixo": "86850",
    "uf": "PR",
    "codigoIbge": 4122651,
    "cidade": "Rosário do Ivaí"
  },
  {
    "prefixo": "86855",
    "uf": "PR",
    "codigoIbge": 4106852,
    "cidade": "Cruzmaltina"
  },
  {
    "prefixo": "86859",
    "uf": "PR",
    "codigoIbge": 4106852,
    "cidade": "Cruzmaltina"
  },
  {
    "prefixo": "86860",
    "uf": "PR",
    "codigoIbge": 4112504,
    "cidade": "Jardim Alegre"
  },
  {
    "prefixo": "86865",
    "uf": "PR",
    "codigoIbge": 4113429,
    "cidade": "Lidianópolis"
  },
  {
    "prefixo": "86870",
    "uf": "PR",
    "codigoIbge": 4111506,
    "cidade": "Ivaiporã"
  },
  {
    "prefixo": "86875",
    "uf": "PR",
    "codigoIbge": 4111506,
    "cidade": "Ivaiporã"
  },
  {
    "prefixo": "86878",
    "uf": "PR",
    "codigoIbge": 4111506,
    "cidade": "Ivaiporã"
  },
  {
    "prefixo": "86879",
    "uf": "PR",
    "codigoIbge": 4111506,
    "cidade": "Ivaiporã"
  },
  {
    "prefixo": "86880",
    "uf": "PR",
    "codigoIbge": 4101853,
    "cidade": "Ariranha do Ivaí"
  },
  {
    "prefixo": "86884",
    "uf": "PR",
    "codigoIbge": 4101655,
    "cidade": "Arapuã"
  },
  {
    "prefixo": "86887",
    "uf": "PR",
    "codigoIbge": 4101655,
    "cidade": "Arapuã"
  },
  {
    "prefixo": "86890",
    "uf": "PR",
    "codigoIbge": 4103800,
    "cidade": "Cambira"
  },
  {
    "prefixo": "86895",
    "uf": "PR",
    "codigoIbge": 4117297,
    "cidade": "Novo Itacolomi"
  },
  {
    "prefixo": "86900",
    "uf": "PR",
    "codigoIbge": 4112108,
    "cidade": "Jandaia do Sul"
  },
  {
    "prefixo": "86910",
    "uf": "PR",
    "codigoIbge": 4115507,
    "cidade": "Marumbi"
  },
  {
    "prefixo": "86920",
    "uf": "PR",
    "codigoIbge": 4113106,
    "cidade": "Kaloré"
  },
  {
    "prefixo": "86923",
    "uf": "PR",
    "codigoIbge": 4113106,
    "cidade": "Kaloré"
  },
  {
    "prefixo": "86925",
    "uf": "PR",
    "codigoIbge": 4103305,
    "cidade": "Borrazópolis"
  },
  {
    "prefixo": "86930",
    "uf": "PR",
    "codigoIbge": 4125001,
    "cidade": "São João do Ivaí"
  },
  {
    "prefixo": "86934",
    "uf": "PR",
    "codigoIbge": 4125001,
    "cidade": "São João do Ivaí"
  },
  {
    "prefixo": "86935",
    "uf": "PR",
    "codigoIbge": 4113759,
    "cidade": "Lunardelli"
  },
  {
    "prefixo": "86938",
    "uf": "PR",
    "codigoIbge": 4108551,
    "cidade": "Godoy Moreira"
  },
  {
    "prefixo": "86940",
    "uf": "PR",
    "codigoIbge": 4103206,
    "cidade": "Bom Sucesso"
  },
  {
    "prefixo": "86945",
    "uf": "PR",
    "codigoIbge": 4125803,
    "cidade": "São Pedro do Ivaí"
  },
  {
    "prefixo": "86947",
    "uf": "PR",
    "codigoIbge": 4125803,
    "cidade": "São Pedro do Ivaí"
  },
  {
    "prefixo": "86950",
    "uf": "PR",
    "codigoIbge": 4107702,
    "cidade": "Fênix"
  },
  {
    "prefixo": "86953",
    "uf": "PR",
    "codigoIbge": 4107702,
    "cidade": "Fênix"
  },
  {
    "prefixo": "86955",
    "uf": "PR",
    "codigoIbge": 4107702,
    "cidade": "Fênix"
  },
  {
    "prefixo": "86960",
    "uf": "PR",
    "codigoIbge": 4102505,
    "cidade": "Barbosa Ferraz"
  },
  {
    "prefixo": "86962",
    "uf": "PR",
    "codigoIbge": 4102505,
    "cidade": "Barbosa Ferraz"
  },
  {
    "prefixo": "86963",
    "uf": "PR",
    "codigoIbge": 4102505,
    "cidade": "Barbosa Ferraz"
  },
  {
    "prefixo": "86964",
    "uf": "PR",
    "codigoIbge": 4102505,
    "cidade": "Barbosa Ferraz"
  },
  {
    "prefixo": "86968",
    "uf": "PR",
    "codigoIbge": 4102505,
    "cidade": "Barbosa Ferraz"
  },
  {
    "prefixo": "86970",
    "uf": "PR",
    "codigoIbge": 4106555,
    "cidade": "Corumbataí do Sul"
  },
  {
    "prefixo": "86975",
    "uf": "PR",
    "codigoIbge": 4114203,
    "cidade": "Mandaguari"
  },
  {
    "prefixo": "86990",
    "uf": "PR",
    "codigoIbge": 4114807,
    "cidade": "Marialva"
  },
  {
    "prefixo": "86994",
    "uf": "PR",
    "codigoIbge": 4114807,
    "cidade": "Marialva"
  },
  {
    "prefixo": "86995",
    "uf": "PR",
    "codigoIbge": 4114807,
    "cidade": "Marialva"
  },
  {
    "prefixo": "86996",
    "uf": "PR",
    "codigoIbge": 4114807,
    "cidade": "Marialva"
  },
  {
    "prefixo": "87001",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87005",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87010",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87013",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87014",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87015",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87020",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87023",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87024",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87025",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87030",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87033",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87035",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87040",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87043",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87045",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87047",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87050",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87051",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87053",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87055",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87060",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87062",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87065",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87068",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87069",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87070",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87075",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87076",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87078",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87080",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87083",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87084",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87101",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87103",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87105",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87109",
    "uf": "PR",
    "codigoIbge": 4115200,
    "cidade": "Maringá"
  },
  {
    "prefixo": "87111",
    "uf": "PR",
    "codigoIbge": 4126256,
    "cidade": "Sarandi"
  },
  {
    "prefixo": "87112",
    "uf": "PR",
    "codigoIbge": 4126256,
    "cidade": "Sarandi"
  },
  {
    "prefixo": "87113",
    "uf": "PR",
    "codigoIbge": 4126256,
    "cidade": "Sarandi"
  },
  {
    "prefixo": "87114",
    "uf": "PR",
    "codigoIbge": 4126256,
    "cidade": "Sarandi"
  },
  {
    "prefixo": "87115",
    "uf": "PR",
    "codigoIbge": 4126256,
    "cidade": "Sarandi"
  },
  {
    "prefixo": "87116",
    "uf": "PR",
    "codigoIbge": 4126256,
    "cidade": "Sarandi"
  },
  {
    "prefixo": "87117",
    "uf": "PR",
    "codigoIbge": 4126256,
    "cidade": "Sarandi"
  },
  {
    "prefixo": "87118",
    "uf": "PR",
    "codigoIbge": 4126256,
    "cidade": "Sarandi"
  },
  {
    "prefixo": "87119",
    "uf": "PR",
    "codigoIbge": 4126256,
    "cidade": "Sarandi"
  },
  {
    "prefixo": "87120",
    "uf": "PR",
    "codigoIbge": 4107900,
    "cidade": "Floresta"
  },
  {
    "prefixo": "87130",
    "uf": "PR",
    "codigoIbge": 4111605,
    "cidade": "Ivatuba"
  },
  {
    "prefixo": "87140",
    "uf": "PR",
    "codigoIbge": 4117503,
    "cidade": "Paiçandu"
  },
  {
    "prefixo": "87145",
    "uf": "PR",
    "codigoIbge": 4117503,
    "cidade": "Paiçandu"
  },
  {
    "prefixo": "87155",
    "uf": "PR",
    "codigoIbge": 4107306,
    "cidade": "Doutor Camargo"
  },
  {
    "prefixo": "87160",
    "uf": "PR",
    "codigoIbge": 4114104,
    "cidade": "Mandaguaçu"
  },
  {
    "prefixo": "87170",
    "uf": "PR",
    "codigoIbge": 4117404,
    "cidade": "Ourizona"
  },
  {
    "prefixo": "87175",
    "uf": "PR",
    "codigoIbge": 4111100,
    "cidade": "Itambé"
  },
  {
    "prefixo": "87180",
    "uf": "PR",
    "codigoIbge": 4120408,
    "cidade": "Presidente Castelo Branco"
  },
  {
    "prefixo": "87185",
    "uf": "PR",
    "codigoIbge": 4107801,
    "cidade": "Floraí"
  },
  {
    "prefixo": "87190",
    "uf": "PR",
    "codigoIbge": 4125308,
    "cidade": "São Jorge do Ivaí"
  },
  {
    "prefixo": "87195",
    "uf": "PR",
    "codigoIbge": 4125308,
    "cidade": "São Jorge do Ivaí"
  },
  {
    "prefixo": "87200",
    "uf": "PR",
    "codigoIbge": 4105508,
    "cidade": "Cianorte"
  },
  {
    "prefixo": "87201",
    "uf": "PR",
    "codigoIbge": 4105508,
    "cidade": "Cianorte"
  },
  {
    "prefixo": "87202",
    "uf": "PR",
    "codigoIbge": 4105508,
    "cidade": "Cianorte"
  },
  {
    "prefixo": "87203",
    "uf": "PR",
    "codigoIbge": 4105508,
    "cidade": "Cianorte"
  },
  {
    "prefixo": "87204",
    "uf": "PR",
    "codigoIbge": 4105508,
    "cidade": "Cianorte"
  },
  {
    "prefixo": "87205",
    "uf": "PR",
    "codigoIbge": 4105508,
    "cidade": "Cianorte"
  },
  {
    "prefixo": "87206",
    "uf": "PR",
    "codigoIbge": 4105508,
    "cidade": "Cianorte"
  },
  {
    "prefixo": "87207",
    "uf": "PR",
    "codigoIbge": 4105508,
    "cidade": "Cianorte"
  },
  {
    "prefixo": "87208",
    "uf": "PR",
    "codigoIbge": 4105508,
    "cidade": "Cianorte"
  },
  {
    "prefixo": "87209",
    "uf": "PR",
    "codigoIbge": 4105508,
    "cidade": "Cianorte"
  },
  {
    "prefixo": "87210",
    "uf": "PR",
    "codigoIbge": 4105508,
    "cidade": "Cianorte"
  },
  {
    "prefixo": "87211",
    "uf": "PR",
    "codigoIbge": 4105508,
    "cidade": "Cianorte"
  },
  {
    "prefixo": "87212",
    "uf": "PR",
    "codigoIbge": 4105508,
    "cidade": "Cianorte"
  },
  {
    "prefixo": "87213",
    "uf": "PR",
    "codigoIbge": 4105508,
    "cidade": "Cianorte"
  },
  {
    "prefixo": "87214",
    "uf": "PR",
    "codigoIbge": 4105508,
    "cidade": "Cianorte"
  },
  {
    "prefixo": "87215",
    "uf": "PR",
    "codigoIbge": 4125555,
    "cidade": "São Manoel do Paraná"
  },
  {
    "prefixo": "87220",
    "uf": "PR",
    "codigoIbge": 4126108,
    "cidade": "São Tomé"
  },
  {
    "prefixo": "87225",
    "uf": "PR",
    "codigoIbge": 4112405,
    "cidade": "Japurá"
  },
  {
    "prefixo": "87230",
    "uf": "PR",
    "codigoIbge": 4113007,
    "cidade": "Jussara"
  },
  {
    "prefixo": "87235",
    "uf": "PR",
    "codigoIbge": 4110409,
    "cidade": "Indianópolis"
  },
  {
    "prefixo": "87240",
    "uf": "PR",
    "codigoIbge": 4127205,
    "cidade": "Terra Boa"
  },
  {
    "prefixo": "87245",
    "uf": "PR",
    "codigoIbge": 4127205,
    "cidade": "Terra Boa"
  },
  {
    "prefixo": "87250",
    "uf": "PR",
    "codigoIbge": 4118808,
    "cidade": "Peabiru"
  },
  {
    "prefixo": "87260",
    "uf": "PR",
    "codigoIbge": 4101705,
    "cidade": "Araruna"
  },
  {
    "prefixo": "87262",
    "uf": "PR",
    "codigoIbge": 4101705,
    "cidade": "Araruna"
  },
  {
    "prefixo": "87263",
    "uf": "PR",
    "codigoIbge": 4101705,
    "cidade": "Araruna"
  },
  {
    "prefixo": "87265",
    "uf": "PR",
    "codigoIbge": 4121109,
    "cidade": "Quinta do Sol"
  },
  {
    "prefixo": "87267",
    "uf": "PR",
    "codigoIbge": 4121109,
    "cidade": "Quinta do Sol"
  },
  {
    "prefixo": "87270",
    "uf": "PR",
    "codigoIbge": 4107504,
    "cidade": "Engenheiro Beltrão"
  },
  {
    "prefixo": "87272",
    "uf": "PR",
    "codigoIbge": 4107504,
    "cidade": "Engenheiro Beltrão"
  },
  {
    "prefixo": "87275",
    "uf": "PR",
    "codigoIbge": 4107504,
    "cidade": "Engenheiro Beltrão"
  },
  {
    "prefixo": "87277",
    "uf": "PR",
    "codigoIbge": 4107504,
    "cidade": "Engenheiro Beltrão"
  },
  {
    "prefixo": "87280",
    "uf": "PR",
    "codigoIbge": 4110805,
    "cidade": "Iretama"
  },
  {
    "prefixo": "87282",
    "uf": "PR",
    "codigoIbge": 4110805,
    "cidade": "Iretama"
  },
  {
    "prefixo": "87290",
    "uf": "PR",
    "codigoIbge": 4113734,
    "cidade": "Luiziana"
  },
  {
    "prefixo": "87300",
    "uf": "PR",
    "codigoIbge": 4104303,
    "cidade": "Campo Mourão"
  },
  {
    "prefixo": "87301",
    "uf": "PR",
    "codigoIbge": 4104303,
    "cidade": "Campo Mourão"
  },
  {
    "prefixo": "87302",
    "uf": "PR",
    "codigoIbge": 4104303,
    "cidade": "Campo Mourão"
  },
  {
    "prefixo": "87303",
    "uf": "PR",
    "codigoIbge": 4104303,
    "cidade": "Campo Mourão"
  },
  {
    "prefixo": "87304",
    "uf": "PR",
    "codigoIbge": 4104303,
    "cidade": "Campo Mourão"
  },
  {
    "prefixo": "87305",
    "uf": "PR",
    "codigoIbge": 4104303,
    "cidade": "Campo Mourão"
  },
  {
    "prefixo": "87306",
    "uf": "PR",
    "codigoIbge": 4104303,
    "cidade": "Campo Mourão"
  },
  {
    "prefixo": "87307",
    "uf": "PR",
    "codigoIbge": 4104303,
    "cidade": "Campo Mourão"
  },
  {
    "prefixo": "87308",
    "uf": "PR",
    "codigoIbge": 4104303,
    "cidade": "Campo Mourão"
  },
  {
    "prefixo": "87309",
    "uf": "PR",
    "codigoIbge": 4104303,
    "cidade": "Campo Mourão"
  },
  {
    "prefixo": "87310",
    "uf": "PR",
    "codigoIbge": 4104303,
    "cidade": "Campo Mourão"
  },
  {
    "prefixo": "87311",
    "uf": "PR",
    "codigoIbge": 4104303,
    "cidade": "Campo Mourão"
  },
  {
    "prefixo": "87313",
    "uf": "PR",
    "codigoIbge": 4104303,
    "cidade": "Campo Mourão"
  },
  {
    "prefixo": "87314",
    "uf": "PR",
    "codigoIbge": 4104303,
    "cidade": "Campo Mourão"
  },
  {
    "prefixo": "87318",
    "uf": "PR",
    "codigoIbge": 4104303,
    "cidade": "Campo Mourão"
  },
  {
    "prefixo": "87320",
    "uf": "PR",
    "codigoIbge": 4122503,
    "cidade": "Roncador"
  },
  {
    "prefixo": "87323",
    "uf": "PR",
    "codigoIbge": 4122503,
    "cidade": "Roncador"
  },
  {
    "prefixo": "87325",
    "uf": "PR",
    "codigoIbge": 4107553,
    "cidade": "Farol"
  },
  {
    "prefixo": "87330",
    "uf": "PR",
    "codigoIbge": 4116802,
    "cidade": "Nova Cantu"
  },
  {
    "prefixo": "87333",
    "uf": "PR",
    "codigoIbge": 4116802,
    "cidade": "Nova Cantu"
  },
  {
    "prefixo": "87335",
    "uf": "PR",
    "codigoIbge": 4116802,
    "cidade": "Nova Cantu"
  },
  {
    "prefixo": "87340",
    "uf": "PR",
    "codigoIbge": 4114005,
    "cidade": "Mamborê"
  },
  {
    "prefixo": "87345",
    "uf": "PR",
    "codigoIbge": 4103909,
    "cidade": "Campina da Lagoa"
  },
  {
    "prefixo": "87347",
    "uf": "PR",
    "codigoIbge": 4103909,
    "cidade": "Campina da Lagoa"
  },
  {
    "prefixo": "87348",
    "uf": "PR",
    "codigoIbge": 4103909,
    "cidade": "Campina da Lagoa"
  },
  {
    "prefixo": "87349",
    "uf": "PR",
    "codigoIbge": 4103909,
    "cidade": "Campina da Lagoa"
  },
  {
    "prefixo": "87355",
    "uf": "PR",
    "codigoIbge": 4112959,
    "cidade": "Juranda"
  },
  {
    "prefixo": "87357",
    "uf": "PR",
    "codigoIbge": 4112959,
    "cidade": "Juranda"
  },
  {
    "prefixo": "87360",
    "uf": "PR",
    "codigoIbge": 4108601,
    "cidade": "Goioerê"
  },
  {
    "prefixo": "87365",
    "uf": "PR",
    "codigoIbge": 4120655,
    "cidade": "Quarto Centenário"
  },
  {
    "prefixo": "87368",
    "uf": "PR",
    "codigoIbge": 4120655,
    "cidade": "Quarto Centenário"
  },
  {
    "prefixo": "87370",
    "uf": "PR",
    "codigoIbge": 4116109,
    "cidade": "Moreira Sales"
  },
  {
    "prefixo": "87375",
    "uf": "PR",
    "codigoIbge": 4116109,
    "cidade": "Moreira Sales"
  },
  {
    "prefixo": "87380",
    "uf": "PR",
    "codigoIbge": 4112207,
    "cidade": "Janiópolis"
  },
  {
    "prefixo": "87385",
    "uf": "PR",
    "codigoIbge": 4112207,
    "cidade": "Janiópolis"
  },
  {
    "prefixo": "87390",
    "uf": "PR",
    "codigoIbge": 4103008,
    "cidade": "Boa Esperança"
  },
  {
    "prefixo": "87395",
    "uf": "PR",
    "codigoIbge": 4121356,
    "cidade": "Rancho Alegre D'Oeste"
  },
  {
    "prefixo": "87400",
    "uf": "PR",
    "codigoIbge": 4106605,
    "cidade": "Cruzeiro do Oeste"
  },
  {
    "prefixo": "87408",
    "uf": "PR",
    "codigoIbge": 4106605,
    "cidade": "Cruzeiro do Oeste"
  },
  {
    "prefixo": "87430",
    "uf": "PR",
    "codigoIbge": 4126801,
    "cidade": "Tapejara"
  },
  {
    "prefixo": "87450",
    "uf": "PR",
    "codigoIbge": 4127908,
    "cidade": "Tuneiras do Oeste"
  },
  {
    "prefixo": "87455",
    "uf": "PR",
    "codigoIbge": 4127908,
    "cidade": "Tuneiras do Oeste"
  },
  {
    "prefixo": "87458",
    "uf": "PR",
    "codigoIbge": 4127908,
    "cidade": "Tuneiras do Oeste"
  },
  {
    "prefixo": "87470",
    "uf": "PR",
    "codigoIbge": 4115101,
    "cidade": "Mariluz"
  },
  {
    "prefixo": "87475",
    "uf": "PR",
    "codigoIbge": 4115101,
    "cidade": "Mariluz"
  },
  {
    "prefixo": "87480",
    "uf": "PR",
    "codigoIbge": 4114708,
    "cidade": "Maria Helena"
  },
  {
    "prefixo": "87483",
    "uf": "PR",
    "codigoIbge": 4114708,
    "cidade": "Maria Helena"
  },
  {
    "prefixo": "87485",
    "uf": "PR",
    "codigoIbge": 4107256,
    "cidade": "Douradina"
  },
  {
    "prefixo": "87490",
    "uf": "PR",
    "codigoIbge": 4117206,
    "cidade": "Nova Olímpia"
  },
  {
    "prefixo": "87501",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87502",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87503",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87504",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87505",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87506",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87507",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87508",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87509",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87510",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87511",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87515",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87518",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87520",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87521",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87524",
    "uf": "PR",
    "codigoIbge": 4128104,
    "cidade": "Umuarama"
  },
  {
    "prefixo": "87525",
    "uf": "PR",
    "codigoIbge": 4111555,
    "cidade": "Ivaté"
  },
  {
    "prefixo": "87527",
    "uf": "PR",
    "codigoIbge": 4111555,
    "cidade": "Ivaté"
  },
  {
    "prefixo": "87528",
    "uf": "PR",
    "codigoIbge": 4128625,
    "cidade": "Alto Paraíso"
  },
  {
    "prefixo": "87530",
    "uf": "PR",
    "codigoIbge": 4109906,
    "cidade": "Icaraíma"
  },
  {
    "prefixo": "87532",
    "uf": "PR",
    "codigoIbge": 4109906,
    "cidade": "Icaraíma"
  },
  {
    "prefixo": "87534",
    "uf": "PR",
    "codigoIbge": 4109906,
    "cidade": "Icaraíma"
  },
  {
    "prefixo": "87535",
    "uf": "PR",
    "codigoIbge": 4128807,
    "cidade": "Xambrê"
  },
  {
    "prefixo": "87537",
    "uf": "PR",
    "codigoIbge": 4128807,
    "cidade": "Xambrê"
  },
  {
    "prefixo": "87538",
    "uf": "PR",
    "codigoIbge": 4118857,
    "cidade": "Perobal"
  },
  {
    "prefixo": "87539",
    "uf": "PR",
    "codigoIbge": 4118857,
    "cidade": "Perobal"
  },
  {
    "prefixo": "87540",
    "uf": "PR",
    "codigoIbge": 4118907,
    "cidade": "Pérola"
  },
  {
    "prefixo": "87545",
    "uf": "PR",
    "codigoIbge": 4107520,
    "cidade": "Esperança Nova"
  },
  {
    "prefixo": "87550",
    "uf": "PR",
    "codigoIbge": 4100509,
    "cidade": "Altônia"
  },
  {
    "prefixo": "87552",
    "uf": "PR",
    "codigoIbge": 4100509,
    "cidade": "Altônia"
  },
  {
    "prefixo": "87553",
    "uf": "PR",
    "codigoIbge": 4100509,
    "cidade": "Altônia"
  },
  {
    "prefixo": "87555",
    "uf": "PR",
    "codigoIbge": 4125357,
    "cidade": "São Jorge do Patrocínio"
  },
  {
    "prefixo": "87560",
    "uf": "PR",
    "codigoIbge": 4110607,
    "cidade": "Iporã"
  },
  {
    "prefixo": "87562",
    "uf": "PR",
    "codigoIbge": 4110607,
    "cidade": "Iporã"
  },
  {
    "prefixo": "87564",
    "uf": "PR",
    "codigoIbge": 4110607,
    "cidade": "Iporã"
  },
  {
    "prefixo": "87565",
    "uf": "PR",
    "codigoIbge": 4103479,
    "cidade": "Cafezal do Sul"
  },
  {
    "prefixo": "87567",
    "uf": "PR",
    "codigoIbge": 4103479,
    "cidade": "Cafezal do Sul"
  },
  {
    "prefixo": "87569",
    "uf": "PR",
    "codigoIbge": 4103479,
    "cidade": "Cafezal do Sul"
  },
  {
    "prefixo": "87570",
    "uf": "PR",
    "codigoIbge": 4108320,
    "cidade": "Francisco Alves"
  },
  {
    "prefixo": "87575",
    "uf": "PR",
    "codigoIbge": 4108320,
    "cidade": "Francisco Alves"
  },
  {
    "prefixo": "87580",
    "uf": "PR",
    "codigoIbge": 4100707,
    "cidade": "Alto Piquiri"
  },
  {
    "prefixo": "87585",
    "uf": "PR",
    "codigoIbge": 4100707,
    "cidade": "Alto Piquiri"
  },
  {
    "prefixo": "87588",
    "uf": "PR",
    "codigoIbge": 4100707,
    "cidade": "Alto Piquiri"
  },
  {
    "prefixo": "87590",
    "uf": "PR",
    "codigoIbge": 4100707,
    "cidade": "Alto Piquiri"
  },
  {
    "prefixo": "87595",
    "uf": "PR",
    "codigoIbge": 4103370,
    "cidade": "Brasilândia do Sul"
  },
  {
    "prefixo": "87600",
    "uf": "PR",
    "codigoIbge": 4116901,
    "cidade": "Nova Esperança"
  },
  {
    "prefixo": "87610",
    "uf": "PR",
    "codigoIbge": 4116901,
    "cidade": "Nova Esperança"
  },
  {
    "prefixo": "87620",
    "uf": "PR",
    "codigoIbge": 4116901,
    "cidade": "Nova Esperança"
  },
  {
    "prefixo": "87630",
    "uf": "PR",
    "codigoIbge": 4102208,
    "cidade": "Atalaia"
  },
  {
    "prefixo": "87640",
    "uf": "PR",
    "codigoIbge": 4128302,
    "cidade": "Uniflor"
  },
  {
    "prefixo": "87650",
    "uf": "PR",
    "codigoIbge": 4106704,
    "cidade": "Cruzeiro do Sul"
  },
  {
    "prefixo": "87660",
    "uf": "PR",
    "codigoIbge": 4118105,
    "cidade": "Paranacity"
  },
  {
    "prefixo": "87670",
    "uf": "PR",
    "codigoIbge": 4110300,
    "cidade": "Inajá"
  },
  {
    "prefixo": "87680",
    "uf": "PR",
    "codigoIbge": 4118303,
    "cidade": "Paranapoema"
  },
  {
    "prefixo": "87690",
    "uf": "PR",
    "codigoIbge": 4112603,
    "cidade": "Jardim Olinda"
  },
  {
    "prefixo": "87701",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87702",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87703",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87704",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87705",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87706",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87707",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87708",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87709",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87710",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87711",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87712",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87717",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87720",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87721",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87722",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87726",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87729",
    "uf": "PR",
    "codigoIbge": 4118402,
    "cidade": "Paranavaí"
  },
  {
    "prefixo": "87730",
    "uf": "PR",
    "codigoIbge": 4124202,
    "cidade": "Santo Antônio do Caiuá"
  },
  {
    "prefixo": "87740",
    "uf": "PR",
    "codigoIbge": 4124905,
    "cidade": "São João do Caiuá"
  },
  {
    "prefixo": "87750",
    "uf": "PR",
    "codigoIbge": 4100608,
    "cidade": "Alto Paraná"
  },
  {
    "prefixo": "87753",
    "uf": "PR",
    "codigoIbge": 4100608,
    "cidade": "Alto Paraná"
  },
  {
    "prefixo": "87755",
    "uf": "PR",
    "codigoIbge": 4100608,
    "cidade": "Alto Paraná"
  },
  {
    "prefixo": "87760",
    "uf": "PR",
    "codigoIbge": 4126702,
    "cidade": "Tamboara"
  },
  {
    "prefixo": "87770",
    "uf": "PR",
    "codigoIbge": 4124608,
    "cidade": "São Carlos do Ivaí"
  },
  {
    "prefixo": "87775",
    "uf": "PR",
    "codigoIbge": 4124608,
    "cidade": "São Carlos do Ivaí"
  },
  {
    "prefixo": "87780",
    "uf": "PR",
    "codigoIbge": 4118006,
    "cidade": "Paraíso do Norte"
  },
  {
    "prefixo": "87790",
    "uf": "PR",
    "codigoIbge": 4116505,
    "cidade": "Nova Aliança do Ivaí"
  },
  {
    "prefixo": "87800",
    "uf": "PR",
    "codigoIbge": 4122602,
    "cidade": "Rondon"
  },
  {
    "prefixo": "87805",
    "uf": "PR",
    "codigoIbge": 4122602,
    "cidade": "Rondon"
  },
  {
    "prefixo": "87810",
    "uf": "PR",
    "codigoIbge": 4109104,
    "cidade": "Guaporema"
  },
  {
    "prefixo": "87820",
    "uf": "PR",
    "codigoIbge": 4105607,
    "cidade": "Cidade Gaúcha"
  },
  {
    "prefixo": "87830",
    "uf": "PR",
    "codigoIbge": 4126900,
    "cidade": "Tapira"
  },
  {
    "prefixo": "87840",
    "uf": "PR",
    "codigoIbge": 4115903,
    "cidade": "Mirador"
  },
  {
    "prefixo": "87850",
    "uf": "PR",
    "codigoIbge": 4100905,
    "cidade": "Amaporã"
  },
  {
    "prefixo": "87855",
    "uf": "PR",
    "codigoIbge": 4100905,
    "cidade": "Amaporã"
  },
  {
    "prefixo": "87860",
    "uf": "PR",
    "codigoIbge": 4119707,
    "cidade": "Planaltina do Paraná"
  },
  {
    "prefixo": "87870",
    "uf": "PR",
    "codigoIbge": 4119707,
    "cidade": "Planaltina do Paraná"
  },
  {
    "prefixo": "87880",
    "uf": "PR",
    "codigoIbge": 4108908,
    "cidade": "Guairaçá"
  },
  {
    "prefixo": "87890",
    "uf": "PR",
    "codigoIbge": 4127304,
    "cidade": "Terra Rica"
  },
  {
    "prefixo": "87895",
    "uf": "PR",
    "codigoIbge": 4127304,
    "cidade": "Terra Rica"
  },
  {
    "prefixo": "87900",
    "uf": "PR",
    "codigoIbge": 4113502,
    "cidade": "Loanda"
  },
  {
    "prefixo": "87910",
    "uf": "PR",
    "codigoIbge": 4123709,
    "cidade": "Santa Isabel do Ivaí"
  },
  {
    "prefixo": "87913",
    "uf": "PR",
    "codigoIbge": 4123709,
    "cidade": "Santa Isabel do Ivaí"
  },
  {
    "prefixo": "87915",
    "uf": "PR",
    "codigoIbge": 4123956,
    "cidade": "Santa Mônica"
  },
  {
    "prefixo": "87920",
    "uf": "PR",
    "codigoIbge": 4123303,
    "cidade": "Santa Cruz de Monte Castelo"
  },
  {
    "prefixo": "87930",
    "uf": "PR",
    "codigoIbge": 4121000,
    "cidade": "Querência do Norte"
  },
  {
    "prefixo": "87935",
    "uf": "PR",
    "codigoIbge": 4121000,
    "cidade": "Querência do Norte"
  },
  {
    "prefixo": "87940",
    "uf": "PR",
    "codigoIbge": 4121000,
    "cidade": "Querência do Norte"
  },
  {
    "prefixo": "87950",
    "uf": "PR",
    "codigoIbge": 4120200,
    "cidade": "Porto Rico"
  },
  {
    "prefixo": "87955",
    "uf": "PR",
    "codigoIbge": 4125902,
    "cidade": "São Pedro do Paraná"
  },
  {
    "prefixo": "87957",
    "uf": "PR",
    "codigoIbge": 4125902,
    "cidade": "São Pedro do Paraná"
  },
  {
    "prefixo": "87960",
    "uf": "PR",
    "codigoIbge": 4115002,
    "cidade": "Marilena"
  },
  {
    "prefixo": "87970",
    "uf": "PR",
    "codigoIbge": 4117107,
    "cidade": "Nova Londrina"
  },
  {
    "prefixo": "87980",
    "uf": "PR",
    "codigoIbge": 4111308,
    "cidade": "Itaúna do Sul"
  },
  {
    "prefixo": "87990",
    "uf": "PR",
    "codigoIbge": 4107108,
    "cidade": "Diamante do Norte"
  },
  {
    "prefixo": "88010",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88015",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88020",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88021",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88025",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88030",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88032",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88034",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88035",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88036",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88037",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88040",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88045",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88047",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88048",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88049",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88050",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88051",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88052",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88053",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88054",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88056",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88058",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88060",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88061",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88062",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88063",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88064",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88065",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88066",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88067",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88070",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88075",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88080",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88085",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88090",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88095",
    "uf": "SC",
    "codigoIbge": 4205407,
    "cidade": "Florianópolis"
  },
  {
    "prefixo": "88101",
    "uf": "SC",
    "codigoIbge": 4216602,
    "cidade": "São José"
  },
  {
    "prefixo": "88102",
    "uf": "SC",
    "codigoIbge": 4216602,
    "cidade": "São José"
  },
  {
    "prefixo": "88103",
    "uf": "SC",
    "codigoIbge": 4216602,
    "cidade": "São José"
  },
  {
    "prefixo": "88104",
    "uf": "SC",
    "codigoIbge": 4216602,
    "cidade": "São José"
  },
  {
    "prefixo": "88106",
    "uf": "SC",
    "codigoIbge": 4216602,
    "cidade": "São José"
  },
  {
    "prefixo": "88107",
    "uf": "SC",
    "codigoIbge": 4216602,
    "cidade": "São José"
  },
  {
    "prefixo": "88108",
    "uf": "SC",
    "codigoIbge": 4216602,
    "cidade": "São José"
  },
  {
    "prefixo": "88110",
    "uf": "SC",
    "codigoIbge": 4216602,
    "cidade": "São José"
  },
  {
    "prefixo": "88111",
    "uf": "SC",
    "codigoIbge": 4216602,
    "cidade": "São José"
  },
  {
    "prefixo": "88113",
    "uf": "SC",
    "codigoIbge": 4216602,
    "cidade": "São José"
  },
  {
    "prefixo": "88115",
    "uf": "SC",
    "codigoIbge": 4216602,
    "cidade": "São José"
  },
  {
    "prefixo": "88117",
    "uf": "SC",
    "codigoIbge": 4216602,
    "cidade": "São José"
  },
  {
    "prefixo": "88119",
    "uf": "SC",
    "codigoIbge": 4216602,
    "cidade": "São José"
  },
  {
    "prefixo": "88122",
    "uf": "SC",
    "codigoIbge": 4216602,
    "cidade": "São José"
  },
  {
    "prefixo": "88123",
    "uf": "SC",
    "codigoIbge": 4216602,
    "cidade": "São José"
  },
  {
    "prefixo": "88125",
    "uf": "SC",
    "codigoIbge": 4217253,
    "cidade": "São Pedro de Alcântara"
  },
  {
    "prefixo": "88130",
    "uf": "SC",
    "codigoIbge": 4211900,
    "cidade": "Palhoça"
  },
  {
    "prefixo": "88131",
    "uf": "SC",
    "codigoIbge": 4211900,
    "cidade": "Palhoça"
  },
  {
    "prefixo": "88132",
    "uf": "SC",
    "codigoIbge": 4211900,
    "cidade": "Palhoça"
  },
  {
    "prefixo": "88133",
    "uf": "SC",
    "codigoIbge": 4211900,
    "cidade": "Palhoça"
  },
  {
    "prefixo": "88134",
    "uf": "SC",
    "codigoIbge": 4211900,
    "cidade": "Palhoça"
  },
  {
    "prefixo": "88135",
    "uf": "SC",
    "codigoIbge": 4211900,
    "cidade": "Palhoça"
  },
  {
    "prefixo": "88136",
    "uf": "SC",
    "codigoIbge": 4211900,
    "cidade": "Palhoça"
  },
  {
    "prefixo": "88137",
    "uf": "SC",
    "codigoIbge": 4211900,
    "cidade": "Palhoça"
  },
  {
    "prefixo": "88138",
    "uf": "SC",
    "codigoIbge": 4211900,
    "cidade": "Palhoça"
  },
  {
    "prefixo": "88139",
    "uf": "SC",
    "codigoIbge": 4211900,
    "cidade": "Palhoça"
  },
  {
    "prefixo": "88140",
    "uf": "SC",
    "codigoIbge": 4215703,
    "cidade": "Santo Amaro da Imperatriz"
  },
  {
    "prefixo": "88150",
    "uf": "SC",
    "codigoIbge": 4200606,
    "cidade": "Águas Mornas"
  },
  {
    "prefixo": "88160",
    "uf": "SC",
    "codigoIbge": 4202305,
    "cidade": "Biguaçu"
  },
  {
    "prefixo": "88161",
    "uf": "SC",
    "codigoIbge": 4202305,
    "cidade": "Biguaçu"
  },
  {
    "prefixo": "88162",
    "uf": "SC",
    "codigoIbge": 4202305,
    "cidade": "Biguaçu"
  },
  {
    "prefixo": "88164",
    "uf": "SC",
    "codigoIbge": 4202305,
    "cidade": "Biguaçu"
  },
  {
    "prefixo": "88165",
    "uf": "SC",
    "codigoIbge": 4202305,
    "cidade": "Biguaçu"
  },
  {
    "prefixo": "88168",
    "uf": "SC",
    "codigoIbge": 4202305,
    "cidade": "Biguaçu"
  },
  {
    "prefixo": "88169",
    "uf": "SC",
    "codigoIbge": 4202305,
    "cidade": "Biguaçu"
  },
  {
    "prefixo": "88170",
    "uf": "SC",
    "codigoIbge": 4202305,
    "cidade": "Biguaçu"
  },
  {
    "prefixo": "88180",
    "uf": "SC",
    "codigoIbge": 4201208,
    "cidade": "Antônio Carlos"
  },
  {
    "prefixo": "88181",
    "uf": "SC",
    "codigoIbge": 4201208,
    "cidade": "Antônio Carlos"
  },
  {
    "prefixo": "88183",
    "uf": "SC",
    "codigoIbge": 4201208,
    "cidade": "Antônio Carlos"
  },
  {
    "prefixo": "88190",
    "uf": "SC",
    "codigoIbge": 4206009,
    "cidade": "Governador Celso Ramos"
  },
  {
    "prefixo": "88200",
    "uf": "SC",
    "codigoIbge": 4218004,
    "cidade": "Tijucas"
  },
  {
    "prefixo": "88210",
    "uf": "SC",
    "codigoIbge": 4213500,
    "cidade": "Porto Belo"
  },
  {
    "prefixo": "88215",
    "uf": "SC",
    "codigoIbge": 4202453,
    "cidade": "Bombinhas"
  },
  {
    "prefixo": "88220",
    "uf": "SC",
    "codigoIbge": 4208302,
    "cidade": "Itapema"
  },
  {
    "prefixo": "88230",
    "uf": "SC",
    "codigoIbge": 4203709,
    "cidade": "Canelinha"
  },
  {
    "prefixo": "88240",
    "uf": "SC",
    "codigoIbge": 4216305,
    "cidade": "São João Batista"
  },
  {
    "prefixo": "88245",
    "uf": "SC",
    "codigoIbge": 4216305,
    "cidade": "São João Batista"
  },
  {
    "prefixo": "88260",
    "uf": "SC",
    "codigoIbge": 4210209,
    "cidade": "Major Gercino"
  },
  {
    "prefixo": "88265",
    "uf": "SC",
    "codigoIbge": 4210209,
    "cidade": "Major Gercino"
  },
  {
    "prefixo": "88268",
    "uf": "SC",
    "codigoIbge": 4210209,
    "cidade": "Major Gercino"
  },
  {
    "prefixo": "88270",
    "uf": "SC",
    "codigoIbge": 4211504,
    "cidade": "Nova Trento"
  },
  {
    "prefixo": "88275",
    "uf": "SC",
    "codigoIbge": 4211504,
    "cidade": "Nova Trento"
  },
  {
    "prefixo": "88280",
    "uf": "SC",
    "codigoIbge": 4211504,
    "cidade": "Nova Trento"
  },
  {
    "prefixo": "88295",
    "uf": "SC",
    "codigoIbge": 4202701,
    "cidade": "Botuverá"
  },
  {
    "prefixo": "88301",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88302",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88303",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88304",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88305",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88306",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88307",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88308",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88309",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88310",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88311",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88312",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88313",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88316",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88317",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88318",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88319",
    "uf": "SC",
    "codigoIbge": 4208203,
    "cidade": "Itajaí"
  },
  {
    "prefixo": "88320",
    "uf": "SC",
    "codigoIbge": 4207106,
    "cidade": "Ilhota"
  },
  {
    "prefixo": "88330",
    "uf": "SC",
    "codigoIbge": 4202008,
    "cidade": "Balneário Camboriú"
  },
  {
    "prefixo": "88331",
    "uf": "SC",
    "codigoIbge": 4202008,
    "cidade": "Balneário Camboriú"
  },
  {
    "prefixo": "88332",
    "uf": "SC",
    "codigoIbge": 4202008,
    "cidade": "Balneário Camboriú"
  },
  {
    "prefixo": "88333",
    "uf": "SC",
    "codigoIbge": 4202008,
    "cidade": "Balneário Camboriú"
  },
  {
    "prefixo": "88334",
    "uf": "SC",
    "codigoIbge": 4202008,
    "cidade": "Balneário Camboriú"
  },
  {
    "prefixo": "88336",
    "uf": "SC",
    "codigoIbge": 4202008,
    "cidade": "Balneário Camboriú"
  },
  {
    "prefixo": "88337",
    "uf": "SC",
    "codigoIbge": 4202008,
    "cidade": "Balneário Camboriú"
  },
  {
    "prefixo": "88338",
    "uf": "SC",
    "codigoIbge": 4202008,
    "cidade": "Balneário Camboriú"
  },
  {
    "prefixo": "88339",
    "uf": "SC",
    "codigoIbge": 4202008,
    "cidade": "Balneário Camboriú"
  },
  {
    "prefixo": "88340",
    "uf": "SC",
    "codigoIbge": 4203204,
    "cidade": "Camboriú"
  },
  {
    "prefixo": "88341",
    "uf": "SC",
    "codigoIbge": 4203204,
    "cidade": "Camboriú"
  },
  {
    "prefixo": "88343",
    "uf": "SC",
    "codigoIbge": 4203204,
    "cidade": "Camboriú"
  },
  {
    "prefixo": "88345",
    "uf": "SC",
    "codigoIbge": 4203204,
    "cidade": "Camboriú"
  },
  {
    "prefixo": "88348",
    "uf": "SC",
    "codigoIbge": 4203204,
    "cidade": "Camboriú"
  },
  {
    "prefixo": "88349",
    "uf": "SC",
    "codigoIbge": 4203204,
    "cidade": "Camboriú"
  },
  {
    "prefixo": "88350",
    "uf": "SC",
    "codigoIbge": 4202909,
    "cidade": "Brusque"
  },
  {
    "prefixo": "88351",
    "uf": "SC",
    "codigoIbge": 4202909,
    "cidade": "Brusque"
  },
  {
    "prefixo": "88352",
    "uf": "SC",
    "codigoIbge": 4202909,
    "cidade": "Brusque"
  },
  {
    "prefixo": "88353",
    "uf": "SC",
    "codigoIbge": 4202909,
    "cidade": "Brusque"
  },
  {
    "prefixo": "88354",
    "uf": "SC",
    "codigoIbge": 4202909,
    "cidade": "Brusque"
  },
  {
    "prefixo": "88355",
    "uf": "SC",
    "codigoIbge": 4202909,
    "cidade": "Brusque"
  },
  {
    "prefixo": "88356",
    "uf": "SC",
    "codigoIbge": 4202909,
    "cidade": "Brusque"
  },
  {
    "prefixo": "88357",
    "uf": "SC",
    "codigoIbge": 4202909,
    "cidade": "Brusque"
  },
  {
    "prefixo": "88358",
    "uf": "SC",
    "codigoIbge": 4202909,
    "cidade": "Brusque"
  },
  {
    "prefixo": "88359",
    "uf": "SC",
    "codigoIbge": 4202909,
    "cidade": "Brusque"
  },
  {
    "prefixo": "88360",
    "uf": "SC",
    "codigoIbge": 4206306,
    "cidade": "Guabiruba"
  },
  {
    "prefixo": "88370",
    "uf": "SC",
    "codigoIbge": 4211306,
    "cidade": "Navegantes"
  },
  {
    "prefixo": "88371",
    "uf": "SC",
    "codigoIbge": 4211306,
    "cidade": "Navegantes"
  },
  {
    "prefixo": "88372",
    "uf": "SC",
    "codigoIbge": 4211306,
    "cidade": "Navegantes"
  },
  {
    "prefixo": "88373",
    "uf": "SC",
    "codigoIbge": 4211306,
    "cidade": "Navegantes"
  },
  {
    "prefixo": "88374",
    "uf": "SC",
    "codigoIbge": 4211306,
    "cidade": "Navegantes"
  },
  {
    "prefixo": "88379",
    "uf": "SC",
    "codigoIbge": 4211306,
    "cidade": "Navegantes"
  },
  {
    "prefixo": "88380",
    "uf": "SC",
    "codigoIbge": 4212809,
    "cidade": "Balneário Piçarras"
  },
  {
    "prefixo": "88385",
    "uf": "SC",
    "codigoIbge": 4212502,
    "cidade": "Penha"
  },
  {
    "prefixo": "88390",
    "uf": "SC",
    "codigoIbge": 4202107,
    "cidade": "Barra Velha"
  },
  {
    "prefixo": "88395",
    "uf": "SC",
    "codigoIbge": 4216354,
    "cidade": "São João do Itaperiú"
  },
  {
    "prefixo": "88400",
    "uf": "SC",
    "codigoIbge": 4208500,
    "cidade": "Ituporanga"
  },
  {
    "prefixo": "88403",
    "uf": "SC",
    "codigoIbge": 4208500,
    "cidade": "Ituporanga"
  },
  {
    "prefixo": "88405",
    "uf": "SC",
    "codigoIbge": 4208500,
    "cidade": "Ituporanga"
  },
  {
    "prefixo": "88407",
    "uf": "SC",
    "codigoIbge": 4204194,
    "cidade": "Chapadão do Lageado"
  },
  {
    "prefixo": "88410",
    "uf": "SC",
    "codigoIbge": 4201802,
    "cidade": "Atalanta"
  },
  {
    "prefixo": "88420",
    "uf": "SC",
    "codigoIbge": 4200200,
    "cidade": "Agrolândia"
  },
  {
    "prefixo": "88430",
    "uf": "SC",
    "codigoIbge": 4212700,
    "cidade": "Petrolândia"
  },
  {
    "prefixo": "88440",
    "uf": "SC",
    "codigoIbge": 4207403,
    "cidade": "Imbuia"
  },
  {
    "prefixo": "88443",
    "uf": "SC",
    "codigoIbge": 4219200,
    "cidade": "Vidal Ramos"
  },
  {
    "prefixo": "88445",
    "uf": "SC",
    "codigoIbge": 4209805,
    "cidade": "Leoberto Leal"
  },
  {
    "prefixo": "88450",
    "uf": "SC",
    "codigoIbge": 4200705,
    "cidade": "Alfredo Wagner"
  },
  {
    "prefixo": "88453",
    "uf": "SC",
    "codigoIbge": 4200705,
    "cidade": "Alfredo Wagner"
  },
  {
    "prefixo": "88455",
    "uf": "SC",
    "codigoIbge": 4200705,
    "cidade": "Alfredo Wagner"
  },
  {
    "prefixo": "88460",
    "uf": "SC",
    "codigoIbge": 4200903,
    "cidade": "Angelina"
  },
  {
    "prefixo": "88463",
    "uf": "SC",
    "codigoIbge": 4200903,
    "cidade": "Angelina"
  },
  {
    "prefixo": "88465",
    "uf": "SC",
    "codigoIbge": 4200903,
    "cidade": "Angelina"
  },
  {
    "prefixo": "88470",
    "uf": "SC",
    "codigoIbge": 4214300,
    "cidade": "Rancho Queimado"
  },
  {
    "prefixo": "88474",
    "uf": "SC",
    "codigoIbge": 4214300,
    "cidade": "Rancho Queimado"
  },
  {
    "prefixo": "88475",
    "uf": "SC",
    "codigoIbge": 4201109,
    "cidade": "Anitápolis"
  },
  {
    "prefixo": "88485",
    "uf": "SC",
    "codigoIbge": 4215901,
    "cidade": "São Bonifácio"
  },
  {
    "prefixo": "88490",
    "uf": "SC",
    "codigoIbge": 4212304,
    "cidade": "Paulo Lopes"
  },
  {
    "prefixo": "88495",
    "uf": "SC",
    "codigoIbge": 4205704,
    "cidade": "Garopaba"
  },
  {
    "prefixo": "88501",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88502",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88503",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88504",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88505",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88506",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88508",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88509",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88511",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88512",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88513",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88514",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88516",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88517",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88519",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88520",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88521",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88523",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88524",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88525",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88526",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88531",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88533",
    "uf": "SC",
    "codigoIbge": 4209300,
    "cidade": "Lages"
  },
  {
    "prefixo": "88535",
    "uf": "SC",
    "codigoIbge": 4204558,
    "cidade": "Correia Pinto"
  },
  {
    "prefixo": "88538",
    "uf": "SC",
    "codigoIbge": 4202438,
    "cidade": "Bocaina do Sul"
  },
  {
    "prefixo": "88540",
    "uf": "SC",
    "codigoIbge": 4211751,
    "cidade": "Otacílio Costa"
  },
  {
    "prefixo": "88543",
    "uf": "SC",
    "codigoIbge": 4211892,
    "cidade": "Painel"
  },
  {
    "prefixo": "88545",
    "uf": "SC",
    "codigoIbge": 4212056,
    "cidade": "Palmeira"
  },
  {
    "prefixo": "88548",
    "uf": "SC",
    "codigoIbge": 4203253,
    "cidade": "Capão Alto"
  },
  {
    "prefixo": "88550",
    "uf": "SC",
    "codigoIbge": 4213302,
    "cidade": "Ponte Alta"
  },
  {
    "prefixo": "88570",
    "uf": "SC",
    "codigoIbge": 4216800,
    "cidade": "São José do Cerrito"
  },
  {
    "prefixo": "88580",
    "uf": "SC",
    "codigoIbge": 4203402,
    "cidade": "Campo Belo do Sul"
  },
  {
    "prefixo": "88585",
    "uf": "SC",
    "codigoIbge": 4204178,
    "cidade": "Cerro Negro"
  },
  {
    "prefixo": "88590",
    "uf": "SC",
    "codigoIbge": 4201000,
    "cidade": "Anita Garibaldi"
  },
  {
    "prefixo": "88595",
    "uf": "SC",
    "codigoIbge": 4201000,
    "cidade": "Anita Garibaldi"
  },
  {
    "prefixo": "88598",
    "uf": "SC",
    "codigoIbge": 4204152,
    "cidade": "Celso Ramos"
  },
  {
    "prefixo": "88600",
    "uf": "SC",
    "codigoIbge": 4216503,
    "cidade": "São Joaquim"
  },
  {
    "prefixo": "88610",
    "uf": "SC",
    "codigoIbge": 4216503,
    "cidade": "São Joaquim"
  },
  {
    "prefixo": "88625",
    "uf": "SC",
    "codigoIbge": 4218954,
    "cidade": "Urupema"
  },
  {
    "prefixo": "88640",
    "uf": "SC",
    "codigoIbge": 4202503,
    "cidade": "Bom Jardim da Serra"
  },
  {
    "prefixo": "88650",
    "uf": "SC",
    "codigoIbge": 4218905,
    "cidade": "Urubici"
  },
  {
    "prefixo": "88655",
    "uf": "SC",
    "codigoIbge": 4218905,
    "cidade": "Urubici"
  },
  {
    "prefixo": "88658",
    "uf": "SC",
    "codigoIbge": 4215059,
    "cidade": "Rio Rufino"
  },
  {
    "prefixo": "88680",
    "uf": "SC",
    "codigoIbge": 4202602,
    "cidade": "Bom Retiro"
  },
  {
    "prefixo": "88688",
    "uf": "SC",
    "codigoIbge": 4202602,
    "cidade": "Bom Retiro"
  },
  {
    "prefixo": "88701",
    "uf": "SC",
    "codigoIbge": 4218707,
    "cidade": "Tubarão"
  },
  {
    "prefixo": "88702",
    "uf": "SC",
    "codigoIbge": 4218707,
    "cidade": "Tubarão"
  },
  {
    "prefixo": "88703",
    "uf": "SC",
    "codigoIbge": 4218707,
    "cidade": "Tubarão"
  },
  {
    "prefixo": "88704",
    "uf": "SC",
    "codigoIbge": 4218707,
    "cidade": "Tubarão"
  },
  {
    "prefixo": "88705",
    "uf": "SC",
    "codigoIbge": 4218707,
    "cidade": "Tubarão"
  },
  {
    "prefixo": "88706",
    "uf": "SC",
    "codigoIbge": 4218707,
    "cidade": "Tubarão"
  },
  {
    "prefixo": "88707",
    "uf": "SC",
    "codigoIbge": 4218707,
    "cidade": "Tubarão"
  },
  {
    "prefixo": "88708",
    "uf": "SC",
    "codigoIbge": 4218707,
    "cidade": "Tubarão"
  },
  {
    "prefixo": "88709",
    "uf": "SC",
    "codigoIbge": 4218707,
    "cidade": "Tubarão"
  },
  {
    "prefixo": "88710",
    "uf": "SC",
    "codigoIbge": 4218400,
    "cidade": "Treze de Maio"
  },
  {
    "prefixo": "88712",
    "uf": "SC",
    "codigoIbge": 4218400,
    "cidade": "Treze de Maio"
  },
  {
    "prefixo": "88715",
    "uf": "SC",
    "codigoIbge": 4208807,
    "cidade": "Jaguaruna"
  },
  {
    "prefixo": "88717",
    "uf": "SC",
    "codigoIbge": 4215455,
    "cidade": "Sangão"
  },
  {
    "prefixo": "88720",
    "uf": "SC",
    "codigoIbge": 4212403,
    "cidade": "Pedras Grandes"
  },
  {
    "prefixo": "88725",
    "uf": "SC",
    "codigoIbge": 4212403,
    "cidade": "Pedras Grandes"
  },
  {
    "prefixo": "88730",
    "uf": "SC",
    "codigoIbge": 4217006,
    "cidade": "São Ludgero"
  },
  {
    "prefixo": "88735",
    "uf": "SC",
    "codigoIbge": 4206207,
    "cidade": "Gravatal"
  },
  {
    "prefixo": "88740",
    "uf": "SC",
    "codigoIbge": 4201505,
    "cidade": "Armazém"
  },
  {
    "prefixo": "88745",
    "uf": "SC",
    "codigoIbge": 4203956,
    "cidade": "Capivari de Baixo"
  },
  {
    "prefixo": "88750",
    "uf": "SC",
    "codigoIbge": 4202800,
    "cidade": "Braço do Norte"
  },
  {
    "prefixo": "88760",
    "uf": "SC",
    "codigoIbge": 4214904,
    "cidade": "Rio Fortuna"
  },
  {
    "prefixo": "88763",
    "uf": "SC",
    "codigoIbge": 4215604,
    "cidade": "Santa Rosa de Lima"
  },
  {
    "prefixo": "88765",
    "uf": "SC",
    "codigoIbge": 4217105,
    "cidade": "São Martinho"
  },
  {
    "prefixo": "88766",
    "uf": "SC",
    "codigoIbge": 4217105,
    "cidade": "São Martinho"
  },
  {
    "prefixo": "88770",
    "uf": "SC",
    "codigoIbge": 4207205,
    "cidade": "Imaruí"
  },
  {
    "prefixo": "88775",
    "uf": "SC",
    "codigoIbge": 4207205,
    "cidade": "Imaruí"
  },
  {
    "prefixo": "88780",
    "uf": "SC",
    "codigoIbge": 4207304,
    "cidade": "Imbituba"
  },
  {
    "prefixo": "88782",
    "uf": "SC",
    "codigoIbge": 4207304,
    "cidade": "Imbituba"
  },
  {
    "prefixo": "88787",
    "uf": "SC",
    "codigoIbge": 4207304,
    "cidade": "Imbituba"
  },
  {
    "prefixo": "88790",
    "uf": "SC",
    "codigoIbge": 4209409,
    "cidade": "Laguna"
  },
  {
    "prefixo": "88794",
    "uf": "SC",
    "codigoIbge": 4209409,
    "cidade": "Laguna"
  },
  {
    "prefixo": "88798",
    "uf": "SC",
    "codigoIbge": 4212650,
    "cidade": "Pescaria Brava"
  },
  {
    "prefixo": "88801",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88802",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88803",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88804",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88805",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88806",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88807",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88808",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88809",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88810",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88811",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88812",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88813",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88814",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88815",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88816",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88817",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88818",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88819",
    "uf": "SC",
    "codigoIbge": 4204608,
    "cidade": "Criciúma"
  },
  {
    "prefixo": "88820",
    "uf": "SC",
    "codigoIbge": 4207007,
    "cidade": "Içara"
  },
  {
    "prefixo": "88828",
    "uf": "SC",
    "codigoIbge": 4220000,
    "cidade": "Balneário Rincão"
  },
  {
    "prefixo": "88830",
    "uf": "SC",
    "codigoIbge": 4211207,
    "cidade": "Morro da Fumaça"
  },
  {
    "prefixo": "88835",
    "uf": "SC",
    "codigoIbge": 4211207,
    "cidade": "Morro da Fumaça"
  },
  {
    "prefixo": "88840",
    "uf": "SC",
    "codigoIbge": 4219002,
    "cidade": "Urussanga"
  },
  {
    "prefixo": "88845",
    "uf": "SC",
    "codigoIbge": 4204251,
    "cidade": "Cocal do Sul"
  },
  {
    "prefixo": "88850",
    "uf": "SC",
    "codigoIbge": 4205456,
    "cidade": "Forquilhinha"
  },
  {
    "prefixo": "88860",
    "uf": "SC",
    "codigoIbge": 4217600,
    "cidade": "Siderópolis"
  },
  {
    "prefixo": "88862",
    "uf": "SC",
    "codigoIbge": 4218350,
    "cidade": "Treviso"
  },
  {
    "prefixo": "88865",
    "uf": "SC",
    "codigoIbge": 4211603,
    "cidade": "Nova Veneza"
  },
  {
    "prefixo": "88867",
    "uf": "SC",
    "codigoIbge": 4211603,
    "cidade": "Nova Veneza"
  },
  {
    "prefixo": "88868",
    "uf": "SC",
    "codigoIbge": 4211603,
    "cidade": "Nova Veneza"
  },
  {
    "prefixo": "88870",
    "uf": "SC",
    "codigoIbge": 4211702,
    "cidade": "Orleans"
  },
  {
    "prefixo": "88872",
    "uf": "SC",
    "codigoIbge": 4211702,
    "cidade": "Orleans"
  },
  {
    "prefixo": "88873",
    "uf": "SC",
    "codigoIbge": 4211702,
    "cidade": "Orleans"
  },
  {
    "prefixo": "88880",
    "uf": "SC",
    "codigoIbge": 4209607,
    "cidade": "Lauro Müller"
  },
  {
    "prefixo": "88882",
    "uf": "SC",
    "codigoIbge": 4209607,
    "cidade": "Lauro Müller"
  },
  {
    "prefixo": "88884",
    "uf": "SC",
    "codigoIbge": 4209607,
    "cidade": "Lauro Müller"
  },
  {
    "prefixo": "88890",
    "uf": "SC",
    "codigoIbge": 4206108,
    "cidade": "Grão-Pará"
  },
  {
    "prefixo": "88892",
    "uf": "SC",
    "codigoIbge": 4206108,
    "cidade": "Grão-Pará"
  },
  {
    "prefixo": "88895",
    "uf": "SC",
    "codigoIbge": 4206108,
    "cidade": "Grão-Pará"
  },
  {
    "prefixo": "88900",
    "uf": "SC",
    "codigoIbge": 4201406,
    "cidade": "Araranguá"
  },
  {
    "prefixo": "88901",
    "uf": "SC",
    "codigoIbge": 4201406,
    "cidade": "Araranguá"
  },
  {
    "prefixo": "88902",
    "uf": "SC",
    "codigoIbge": 4201406,
    "cidade": "Araranguá"
  },
  {
    "prefixo": "88904",
    "uf": "SC",
    "codigoIbge": 4201406,
    "cidade": "Araranguá"
  },
  {
    "prefixo": "88905",
    "uf": "SC",
    "codigoIbge": 4201406,
    "cidade": "Araranguá"
  },
  {
    "prefixo": "88906",
    "uf": "SC",
    "codigoIbge": 4201406,
    "cidade": "Araranguá"
  },
  {
    "prefixo": "88907",
    "uf": "SC",
    "codigoIbge": 4201406,
    "cidade": "Araranguá"
  },
  {
    "prefixo": "88910",
    "uf": "SC",
    "codigoIbge": 4201406,
    "cidade": "Araranguá"
  },
  {
    "prefixo": "88911",
    "uf": "SC",
    "codigoIbge": 4201406,
    "cidade": "Araranguá"
  },
  {
    "prefixo": "88912",
    "uf": "SC",
    "codigoIbge": 4201406,
    "cidade": "Araranguá"
  },
  {
    "prefixo": "88913",
    "uf": "SC",
    "codigoIbge": 4201406,
    "cidade": "Araranguá"
  },
  {
    "prefixo": "88914",
    "uf": "SC",
    "codigoIbge": 4201950,
    "cidade": "Balneário Arroio do Silva"
  },
  {
    "prefixo": "88915",
    "uf": "SC",
    "codigoIbge": 4210407,
    "cidade": "Maracajá"
  },
  {
    "prefixo": "88920",
    "uf": "SC",
    "codigoIbge": 4210803,
    "cidade": "Meleiro"
  },
  {
    "prefixo": "88923",
    "uf": "SC",
    "codigoIbge": 4210803,
    "cidade": "Meleiro"
  },
  {
    "prefixo": "88925",
    "uf": "SC",
    "codigoIbge": 4211256,
    "cidade": "Morro Grande"
  },
  {
    "prefixo": "88930",
    "uf": "SC",
    "codigoIbge": 4218806,
    "cidade": "Turvo"
  },
  {
    "prefixo": "88935",
    "uf": "SC",
    "codigoIbge": 4205191,
    "cidade": "Ermo"
  },
  {
    "prefixo": "88940",
    "uf": "SC",
    "codigoIbge": 4218103,
    "cidade": "Timbé do Sul"
  },
  {
    "prefixo": "88950",
    "uf": "SC",
    "codigoIbge": 4208708,
    "cidade": "Jacinto Machado"
  },
  {
    "prefixo": "88955",
    "uf": "SC",
    "codigoIbge": 4202073,
    "cidade": "Balneário Gaivota"
  },
  {
    "prefixo": "88960",
    "uf": "SC",
    "codigoIbge": 4217709,
    "cidade": "Sombrio"
  },
  {
    "prefixo": "88965",
    "uf": "SC",
    "codigoIbge": 4215653,
    "cidade": "Santa Rosa do Sul"
  },
  {
    "prefixo": "88970",
    "uf": "SC",
    "codigoIbge": 4216404,
    "cidade": "São João do Sul"
  },
  {
    "prefixo": "88975",
    "uf": "SC",
    "codigoIbge": 4216404,
    "cidade": "São João do Sul"
  },
  {
    "prefixo": "88980",
    "uf": "SC",
    "codigoIbge": 4212254,
    "cidade": "Passo de Torres"
  },
  {
    "prefixo": "88990",
    "uf": "SC",
    "codigoIbge": 4213807,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "88993",
    "uf": "SC",
    "codigoIbge": 4213807,
    "cidade": "Praia Grande"
  },
  {
    "prefixo": "89010",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89012",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89015",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89020",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89021",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89022",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89023",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89025",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89026",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89027",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89030",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89031",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89032",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89035",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89036",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89037",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89040",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89041",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89042",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89045",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89046",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89050",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89051",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89052",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89053",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89055",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89056",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89057",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89058",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89060",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89062",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89063",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89065",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89066",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89068",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89069",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89070",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89072",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89074",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89075",
    "uf": "SC",
    "codigoIbge": 4202404,
    "cidade": "Blumenau"
  },
  {
    "prefixo": "89080",
    "uf": "SC",
    "codigoIbge": 4207502,
    "cidade": "Indaial"
  },
  {
    "prefixo": "89081",
    "uf": "SC",
    "codigoIbge": 4207502,
    "cidade": "Indaial"
  },
  {
    "prefixo": "89082",
    "uf": "SC",
    "codigoIbge": 4207502,
    "cidade": "Indaial"
  },
  {
    "prefixo": "89083",
    "uf": "SC",
    "codigoIbge": 4207502,
    "cidade": "Indaial"
  },
  {
    "prefixo": "89084",
    "uf": "SC",
    "codigoIbge": 4207502,
    "cidade": "Indaial"
  },
  {
    "prefixo": "89085",
    "uf": "SC",
    "codigoIbge": 4207502,
    "cidade": "Indaial"
  },
  {
    "prefixo": "89086",
    "uf": "SC",
    "codigoIbge": 4207502,
    "cidade": "Indaial"
  },
  {
    "prefixo": "89087",
    "uf": "SC",
    "codigoIbge": 4207502,
    "cidade": "Indaial"
  },
  {
    "prefixo": "89089",
    "uf": "SC",
    "codigoIbge": 4207502,
    "cidade": "Indaial"
  },
  {
    "prefixo": "89107",
    "uf": "SC",
    "codigoIbge": 4213203,
    "cidade": "Pomerode"
  },
  {
    "prefixo": "89108",
    "uf": "SC",
    "codigoIbge": 4210605,
    "cidade": "Massaranduba"
  },
  {
    "prefixo": "89110",
    "uf": "SC",
    "codigoIbge": 4205902,
    "cidade": "Gaspar"
  },
  {
    "prefixo": "89111",
    "uf": "SC",
    "codigoIbge": 4205902,
    "cidade": "Gaspar"
  },
  {
    "prefixo": "89112",
    "uf": "SC",
    "codigoIbge": 4205902,
    "cidade": "Gaspar"
  },
  {
    "prefixo": "89113",
    "uf": "SC",
    "codigoIbge": 4205902,
    "cidade": "Gaspar"
  },
  {
    "prefixo": "89114",
    "uf": "SC",
    "codigoIbge": 4205902,
    "cidade": "Gaspar"
  },
  {
    "prefixo": "89115",
    "uf": "SC",
    "codigoIbge": 4205902,
    "cidade": "Gaspar"
  },
  {
    "prefixo": "89116",
    "uf": "SC",
    "codigoIbge": 4205902,
    "cidade": "Gaspar"
  },
  {
    "prefixo": "89117",
    "uf": "SC",
    "codigoIbge": 4205902,
    "cidade": "Gaspar"
  },
  {
    "prefixo": "89118",
    "uf": "SC",
    "codigoIbge": 4205902,
    "cidade": "Gaspar"
  },
  {
    "prefixo": "89119",
    "uf": "SC",
    "codigoIbge": 4205902,
    "cidade": "Gaspar"
  },
  {
    "prefixo": "89120",
    "uf": "SC",
    "codigoIbge": 4218202,
    "cidade": "Timbó"
  },
  {
    "prefixo": "89121",
    "uf": "SC",
    "codigoIbge": 4214706,
    "cidade": "Rio dos Cedros"
  },
  {
    "prefixo": "89122",
    "uf": "SC",
    "codigoIbge": 4214706,
    "cidade": "Rio dos Cedros"
  },
  {
    "prefixo": "89124",
    "uf": "SC",
    "codigoIbge": 4202206,
    "cidade": "Benedito Novo"
  },
  {
    "prefixo": "89125",
    "uf": "SC",
    "codigoIbge": 4202206,
    "cidade": "Benedito Novo"
  },
  {
    "prefixo": "89126",
    "uf": "SC",
    "codigoIbge": 4205159,
    "cidade": "Doutor Pedrinho"
  },
  {
    "prefixo": "89128",
    "uf": "SC",
    "codigoIbge": 4210001,
    "cidade": "Luiz Alves"
  },
  {
    "prefixo": "89135",
    "uf": "SC",
    "codigoIbge": 4201257,
    "cidade": "Apiúna"
  },
  {
    "prefixo": "89136",
    "uf": "SC",
    "codigoIbge": 4215109,
    "cidade": "Rodeio"
  },
  {
    "prefixo": "89138",
    "uf": "SC",
    "codigoIbge": 4201703,
    "cidade": "Ascurra"
  },
  {
    "prefixo": "89140",
    "uf": "SC",
    "codigoIbge": 4206900,
    "cidade": "Ibirama"
  },
  {
    "prefixo": "89143",
    "uf": "SC",
    "codigoIbge": 4206900,
    "cidade": "Ibirama"
  },
  {
    "prefixo": "89145",
    "uf": "SC",
    "codigoIbge": 4209151,
    "cidade": "José Boiteux"
  },
  {
    "prefixo": "89148",
    "uf": "SC",
    "codigoIbge": 4219358,
    "cidade": "Vitor Meireles"
  },
  {
    "prefixo": "89149",
    "uf": "SC",
    "codigoIbge": 4219358,
    "cidade": "Vitor Meireles"
  },
  {
    "prefixo": "89150",
    "uf": "SC",
    "codigoIbge": 4214003,
    "cidade": "Presidente Getúlio"
  },
  {
    "prefixo": "89153",
    "uf": "SC",
    "codigoIbge": 4214003,
    "cidade": "Presidente Getúlio"
  },
  {
    "prefixo": "89155",
    "uf": "SC",
    "codigoIbge": 4205100,
    "cidade": "Dona Emma"
  },
  {
    "prefixo": "89157",
    "uf": "SC",
    "codigoIbge": 4219408,
    "cidade": "Witmarsum"
  },
  {
    "prefixo": "89160",
    "uf": "SC",
    "codigoIbge": 4214805,
    "cidade": "Rio do Sul"
  },
  {
    "prefixo": "89161",
    "uf": "SC",
    "codigoIbge": 4214805,
    "cidade": "Rio do Sul"
  },
  {
    "prefixo": "89162",
    "uf": "SC",
    "codigoIbge": 4214805,
    "cidade": "Rio do Sul"
  },
  {
    "prefixo": "89163",
    "uf": "SC",
    "codigoIbge": 4214805,
    "cidade": "Rio do Sul"
  },
  {
    "prefixo": "89164",
    "uf": "SC",
    "codigoIbge": 4214805,
    "cidade": "Rio do Sul"
  },
  {
    "prefixo": "89165",
    "uf": "SC",
    "codigoIbge": 4214805,
    "cidade": "Rio do Sul"
  },
  {
    "prefixo": "89167",
    "uf": "SC",
    "codigoIbge": 4214805,
    "cidade": "Rio do Sul"
  },
  {
    "prefixo": "89169",
    "uf": "SC",
    "codigoIbge": 4214805,
    "cidade": "Rio do Sul"
  },
  {
    "prefixo": "89170",
    "uf": "SC",
    "codigoIbge": 4209508,
    "cidade": "Laurentino"
  },
  {
    "prefixo": "89172",
    "uf": "SC",
    "codigoIbge": 4213708,
    "cidade": "Pouso Redondo"
  },
  {
    "prefixo": "89176",
    "uf": "SC",
    "codigoIbge": 4218608,
    "cidade": "Trombudo Central"
  },
  {
    "prefixo": "89178",
    "uf": "SC",
    "codigoIbge": 4202859,
    "cidade": "Braço do Trombudo"
  },
  {
    "prefixo": "89180",
    "uf": "SC",
    "codigoIbge": 4214607,
    "cidade": "Rio do Oeste"
  },
  {
    "prefixo": "89182",
    "uf": "SC",
    "codigoIbge": 4209904,
    "cidade": "Lontras"
  },
  {
    "prefixo": "89184",
    "uf": "SC",
    "codigoIbge": 4214102,
    "cidade": "Presidente Nereu"
  },
  {
    "prefixo": "89186",
    "uf": "SC",
    "codigoIbge": 4201901,
    "cidade": "Aurora"
  },
  {
    "prefixo": "89188",
    "uf": "SC",
    "codigoIbge": 4200309,
    "cidade": "Agronômica"
  },
  {
    "prefixo": "89190",
    "uf": "SC",
    "codigoIbge": 4217808,
    "cidade": "Taió"
  },
  {
    "prefixo": "89192",
    "uf": "SC",
    "codigoIbge": 4217808,
    "cidade": "Taió"
  },
  {
    "prefixo": "89194",
    "uf": "SC",
    "codigoIbge": 4210852,
    "cidade": "Mirim Doce"
  },
  {
    "prefixo": "89196",
    "uf": "SC",
    "codigoIbge": 4215307,
    "cidade": "Salete"
  },
  {
    "prefixo": "89198",
    "uf": "SC",
    "codigoIbge": 4214508,
    "cidade": "Rio do Campo"
  },
  {
    "prefixo": "89199",
    "uf": "SC",
    "codigoIbge": 4215679,
    "cidade": "Santa Terezinha"
  },
  {
    "prefixo": "89201",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89202",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89203",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89204",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89205",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89206",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89207",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89208",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89209",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89210",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89211",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89212",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89213",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89214",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89215",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89216",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89217",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89218",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89219",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89220",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89221",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89222",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89223",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89224",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89225",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89226",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89227",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89228",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89229",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89230",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89231",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89232",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89233",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89234",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89235",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89237",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89239",
    "uf": "SC",
    "codigoIbge": 4209102,
    "cidade": "Joinville"
  },
  {
    "prefixo": "89240",
    "uf": "SC",
    "codigoIbge": 4216206,
    "cidade": "São Francisco do Sul"
  },
  {
    "prefixo": "89243",
    "uf": "SC",
    "codigoIbge": 4216206,
    "cidade": "São Francisco do Sul"
  },
  {
    "prefixo": "89245",
    "uf": "SC",
    "codigoIbge": 4201307,
    "cidade": "Araquari"
  },
  {
    "prefixo": "89246",
    "uf": "SC",
    "codigoIbge": 4201307,
    "cidade": "Araquari"
  },
  {
    "prefixo": "89247",
    "uf": "SC",
    "codigoIbge": 4202057,
    "cidade": "Balneário Barra do Sul"
  },
  {
    "prefixo": "89248",
    "uf": "SC",
    "codigoIbge": 4205803,
    "cidade": "Garuva"
  },
  {
    "prefixo": "89249",
    "uf": "SC",
    "codigoIbge": 4208450,
    "cidade": "Itapoá"
  },
  {
    "prefixo": "89251",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89252",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89253",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89254",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89255",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89256",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89257",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89258",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89259",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89260",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89261",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89262",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89264",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89265",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89266",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89267",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89268",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89269",
    "uf": "SC",
    "codigoIbge": 4208906,
    "cidade": "Jaraguá do Sul"
  },
  {
    "prefixo": "89270",
    "uf": "SC",
    "codigoIbge": 4206504,
    "cidade": "Guaramirim"
  },
  {
    "prefixo": "89275",
    "uf": "SC",
    "codigoIbge": 4217402,
    "cidade": "Schroeder"
  },
  {
    "prefixo": "89278",
    "uf": "SC",
    "codigoIbge": 4204509,
    "cidade": "Corupá"
  },
  {
    "prefixo": "89280",
    "uf": "SC",
    "codigoIbge": 4215802,
    "cidade": "São Bento do Sul"
  },
  {
    "prefixo": "89281",
    "uf": "SC",
    "codigoIbge": 4215802,
    "cidade": "São Bento do Sul"
  },
  {
    "prefixo": "89282",
    "uf": "SC",
    "codigoIbge": 4215802,
    "cidade": "São Bento do Sul"
  },
  {
    "prefixo": "89283",
    "uf": "SC",
    "codigoIbge": 4215802,
    "cidade": "São Bento do Sul"
  },
  {
    "prefixo": "89284",
    "uf": "SC",
    "codigoIbge": 4215802,
    "cidade": "São Bento do Sul"
  },
  {
    "prefixo": "89285",
    "uf": "SC",
    "codigoIbge": 4215802,
    "cidade": "São Bento do Sul"
  },
  {
    "prefixo": "89286",
    "uf": "SC",
    "codigoIbge": 4215802,
    "cidade": "São Bento do Sul"
  },
  {
    "prefixo": "89287",
    "uf": "SC",
    "codigoIbge": 4215802,
    "cidade": "São Bento do Sul"
  },
  {
    "prefixo": "89288",
    "uf": "SC",
    "codigoIbge": 4215802,
    "cidade": "São Bento do Sul"
  },
  {
    "prefixo": "89289",
    "uf": "SC",
    "codigoIbge": 4215802,
    "cidade": "São Bento do Sul"
  },
  {
    "prefixo": "89290",
    "uf": "SC",
    "codigoIbge": 4215802,
    "cidade": "São Bento do Sul"
  },
  {
    "prefixo": "89291",
    "uf": "SC",
    "codigoIbge": 4215802,
    "cidade": "São Bento do Sul"
  },
  {
    "prefixo": "89292",
    "uf": "SC",
    "codigoIbge": 4215802,
    "cidade": "São Bento do Sul"
  },
  {
    "prefixo": "89293",
    "uf": "SC",
    "codigoIbge": 4215802,
    "cidade": "São Bento do Sul"
  },
  {
    "prefixo": "89294",
    "uf": "SC",
    "codigoIbge": 4203303,
    "cidade": "Campo Alegre"
  },
  {
    "prefixo": "89295",
    "uf": "SC",
    "codigoIbge": 4215000,
    "cidade": "Rio Negrinho"
  },
  {
    "prefixo": "89296",
    "uf": "SC",
    "codigoIbge": 4215000,
    "cidade": "Rio Negrinho"
  },
  {
    "prefixo": "89297",
    "uf": "SC",
    "codigoIbge": 4215000,
    "cidade": "Rio Negrinho"
  },
  {
    "prefixo": "89298",
    "uf": "SC",
    "codigoIbge": 4215000,
    "cidade": "Rio Negrinho"
  },
  {
    "prefixo": "89299",
    "uf": "SC",
    "codigoIbge": 4215000,
    "cidade": "Rio Negrinho"
  },
  {
    "prefixo": "89300",
    "uf": "SC",
    "codigoIbge": 4210100,
    "cidade": "Mafra"
  },
  {
    "prefixo": "89302",
    "uf": "SC",
    "codigoIbge": 4210100,
    "cidade": "Mafra"
  },
  {
    "prefixo": "89303",
    "uf": "SC",
    "codigoIbge": 4210100,
    "cidade": "Mafra"
  },
  {
    "prefixo": "89304",
    "uf": "SC",
    "codigoIbge": 4210100,
    "cidade": "Mafra"
  },
  {
    "prefixo": "89306",
    "uf": "SC",
    "codigoIbge": 4210100,
    "cidade": "Mafra"
  },
  {
    "prefixo": "89307",
    "uf": "SC",
    "codigoIbge": 4210100,
    "cidade": "Mafra"
  },
  {
    "prefixo": "89309",
    "uf": "SC",
    "codigoIbge": 4210100,
    "cidade": "Mafra"
  },
  {
    "prefixo": "89310",
    "uf": "SC",
    "codigoIbge": 4210100,
    "cidade": "Mafra"
  },
  {
    "prefixo": "89315",
    "uf": "SC",
    "codigoIbge": 4210100,
    "cidade": "Mafra"
  },
  {
    "prefixo": "89340",
    "uf": "SC",
    "codigoIbge": 4208104,
    "cidade": "Itaiópolis"
  },
  {
    "prefixo": "89344",
    "uf": "SC",
    "codigoIbge": 4208104,
    "cidade": "Itaiópolis"
  },
  {
    "prefixo": "89360",
    "uf": "SC",
    "codigoIbge": 4208450,
    "cidade": "Itapoá"
  },
  {
    "prefixo": "89361",
    "uf": "SC",
    "codigoIbge": 4208450,
    "cidade": "Itapoá"
  },
  {
    "prefixo": "89363",
    "uf": "SC",
    "codigoIbge": 4208450,
    "cidade": "Itapoá"
  },
  {
    "prefixo": "89364",
    "uf": "SC",
    "codigoIbge": 4208450,
    "cidade": "Itapoá"
  },
  {
    "prefixo": "89365",
    "uf": "SC",
    "codigoIbge": 4208450,
    "cidade": "Itapoá"
  },
  {
    "prefixo": "89370",
    "uf": "SC",
    "codigoIbge": 4212205,
    "cidade": "Papanduva"
  },
  {
    "prefixo": "89375",
    "uf": "SC",
    "codigoIbge": 4212205,
    "cidade": "Papanduva"
  },
  {
    "prefixo": "89380",
    "uf": "SC",
    "codigoIbge": 4211108,
    "cidade": "Monte Castelo"
  },
  {
    "prefixo": "89384",
    "uf": "SC",
    "codigoIbge": 4211108,
    "cidade": "Monte Castelo"
  },
  {
    "prefixo": "89400",
    "uf": "SC",
    "codigoIbge": 4213609,
    "cidade": "Porto União"
  },
  {
    "prefixo": "89410",
    "uf": "SC",
    "codigoIbge": 4213609,
    "cidade": "Porto União"
  },
  {
    "prefixo": "89415",
    "uf": "SC",
    "codigoIbge": 4213609,
    "cidade": "Porto União"
  },
  {
    "prefixo": "89420",
    "uf": "SC",
    "codigoIbge": 4210704,
    "cidade": "Matos Costa"
  },
  {
    "prefixo": "89430",
    "uf": "SC",
    "codigoIbge": 4203154,
    "cidade": "Calmon"
  },
  {
    "prefixo": "89440",
    "uf": "SC",
    "codigoIbge": 4207908,
    "cidade": "Irineópolis"
  },
  {
    "prefixo": "89460",
    "uf": "SC",
    "codigoIbge": 4203808,
    "cidade": "Canoinhas"
  },
  {
    "prefixo": "89462",
    "uf": "SC",
    "codigoIbge": 4203808,
    "cidade": "Canoinhas"
  },
  {
    "prefixo": "89464",
    "uf": "SC",
    "codigoIbge": 4203808,
    "cidade": "Canoinhas"
  },
  {
    "prefixo": "89465",
    "uf": "SC",
    "codigoIbge": 4203808,
    "cidade": "Canoinhas"
  },
  {
    "prefixo": "89466",
    "uf": "SC",
    "codigoIbge": 4203808,
    "cidade": "Canoinhas"
  },
  {
    "prefixo": "89469",
    "uf": "SC",
    "codigoIbge": 4203808,
    "cidade": "Canoinhas"
  },
  {
    "prefixo": "89470",
    "uf": "SC",
    "codigoIbge": 4203808,
    "cidade": "Canoinhas"
  },
  {
    "prefixo": "89473",
    "uf": "SC",
    "codigoIbge": 4203808,
    "cidade": "Canoinhas"
  },
  {
    "prefixo": "89476",
    "uf": "SC",
    "codigoIbge": 4203808,
    "cidade": "Canoinhas"
  },
  {
    "prefixo": "89478",
    "uf": "SC",
    "codigoIbge": 4202131,
    "cidade": "Bela Vista do Toldo"
  },
  {
    "prefixo": "89480",
    "uf": "SC",
    "codigoIbge": 4210308,
    "cidade": "Major Vieira"
  },
  {
    "prefixo": "89490",
    "uf": "SC",
    "codigoIbge": 4218301,
    "cidade": "Três Barras"
  },
  {
    "prefixo": "89500",
    "uf": "SC",
    "codigoIbge": 4203006,
    "cidade": "Caçador"
  },
  {
    "prefixo": "89501",
    "uf": "SC",
    "codigoIbge": 4203006,
    "cidade": "Caçador"
  },
  {
    "prefixo": "89503",
    "uf": "SC",
    "codigoIbge": 4203006,
    "cidade": "Caçador"
  },
  {
    "prefixo": "89504",
    "uf": "SC",
    "codigoIbge": 4203006,
    "cidade": "Caçador"
  },
  {
    "prefixo": "89505",
    "uf": "SC",
    "codigoIbge": 4203006,
    "cidade": "Caçador"
  },
  {
    "prefixo": "89506",
    "uf": "SC",
    "codigoIbge": 4203006,
    "cidade": "Caçador"
  },
  {
    "prefixo": "89507",
    "uf": "SC",
    "codigoIbge": 4203006,
    "cidade": "Caçador"
  },
  {
    "prefixo": "89509",
    "uf": "SC",
    "codigoIbge": 4203006,
    "cidade": "Caçador"
  },
  {
    "prefixo": "89510",
    "uf": "SC",
    "codigoIbge": 4203006,
    "cidade": "Caçador"
  },
  {
    "prefixo": "89511",
    "uf": "SC",
    "codigoIbge": 4203006,
    "cidade": "Caçador"
  },
  {
    "prefixo": "89513",
    "uf": "SC",
    "codigoIbge": 4203006,
    "cidade": "Caçador"
  },
  {
    "prefixo": "89514",
    "uf": "SC",
    "codigoIbge": 4203006,
    "cidade": "Caçador"
  },
  {
    "prefixo": "89515",
    "uf": "SC",
    "codigoIbge": 4209706,
    "cidade": "Lebon Régis"
  },
  {
    "prefixo": "89518",
    "uf": "SC",
    "codigoIbge": 4210050,
    "cidade": "Macieira"
  },
  {
    "prefixo": "89520",
    "uf": "SC",
    "codigoIbge": 4204806,
    "cidade": "Curitibanos"
  },
  {
    "prefixo": "89528",
    "uf": "SC",
    "codigoIbge": 4204806,
    "cidade": "Curitibanos"
  },
  {
    "prefixo": "89530",
    "uf": "SC",
    "codigoIbge": 4205555,
    "cidade": "Frei Rogério"
  },
  {
    "prefixo": "89533",
    "uf": "SC",
    "codigoIbge": 4216057,
    "cidade": "São Cristóvão do Sul"
  },
  {
    "prefixo": "89535",
    "uf": "SC",
    "codigoIbge": 4213351,
    "cidade": "Ponte Alta do Norte"
  },
  {
    "prefixo": "89540",
    "uf": "SC",
    "codigoIbge": 4215505,
    "cidade": "Santa Cecília"
  },
  {
    "prefixo": "89545",
    "uf": "SC",
    "codigoIbge": 4218251,
    "cidade": "Timbó Grande"
  },
  {
    "prefixo": "89550",
    "uf": "SC",
    "codigoIbge": 4214409,
    "cidade": "Rio das Antas"
  },
  {
    "prefixo": "89555",
    "uf": "SC",
    "codigoIbge": 4214409,
    "cidade": "Rio das Antas"
  },
  {
    "prefixo": "89558",
    "uf": "SC",
    "codigoIbge": 4207577,
    "cidade": "Iomerê"
  },
  {
    "prefixo": "89560",
    "uf": "SC",
    "codigoIbge": 4219309,
    "cidade": "Videira"
  },
  {
    "prefixo": "89561",
    "uf": "SC",
    "codigoIbge": 4219309,
    "cidade": "Videira"
  },
  {
    "prefixo": "89562",
    "uf": "SC",
    "codigoIbge": 4219309,
    "cidade": "Videira"
  },
  {
    "prefixo": "89563",
    "uf": "SC",
    "codigoIbge": 4219309,
    "cidade": "Videira"
  },
  {
    "prefixo": "89564",
    "uf": "SC",
    "codigoIbge": 4219309,
    "cidade": "Videira"
  },
  {
    "prefixo": "89565",
    "uf": "SC",
    "codigoIbge": 4219309,
    "cidade": "Videira"
  },
  {
    "prefixo": "89566",
    "uf": "SC",
    "codigoIbge": 4219309,
    "cidade": "Videira"
  },
  {
    "prefixo": "89567",
    "uf": "SC",
    "codigoIbge": 4219309,
    "cidade": "Videira"
  },
  {
    "prefixo": "89568",
    "uf": "SC",
    "codigoIbge": 4219309,
    "cidade": "Videira"
  },
  {
    "prefixo": "89569",
    "uf": "SC",
    "codigoIbge": 4219309,
    "cidade": "Videira"
  },
  {
    "prefixo": "89570",
    "uf": "SC",
    "codigoIbge": 4213005,
    "cidade": "Pinheiro Preto"
  },
  {
    "prefixo": "89580",
    "uf": "SC",
    "codigoIbge": 4205506,
    "cidade": "Fraiburgo"
  },
  {
    "prefixo": "89590",
    "uf": "SC",
    "codigoIbge": 4201604,
    "cidade": "Arroio Trinta"
  },
  {
    "prefixo": "89595",
    "uf": "SC",
    "codigoIbge": 4215406,
    "cidade": "Salto Veloso"
  },
  {
    "prefixo": "89600",
    "uf": "SC",
    "codigoIbge": 4209003,
    "cidade": "Joaçaba"
  },
  {
    "prefixo": "89608",
    "uf": "SC",
    "codigoIbge": 4209003,
    "cidade": "Joaçaba"
  },
  {
    "prefixo": "89609",
    "uf": "SC",
    "codigoIbge": 4210035,
    "cidade": "Luzerna"
  },
  {
    "prefixo": "89610",
    "uf": "SC",
    "codigoIbge": 4206702,
    "cidade": "Herval d'Oeste"
  },
  {
    "prefixo": "89613",
    "uf": "SC",
    "codigoIbge": 4205209,
    "cidade": "Erval Velho"
  },
  {
    "prefixo": "89615",
    "uf": "SC",
    "codigoIbge": 4205209,
    "cidade": "Erval Velho"
  },
  {
    "prefixo": "89618",
    "uf": "SC",
    "codigoIbge": 4211058,
    "cidade": "Monte Carlo"
  },
  {
    "prefixo": "89620",
    "uf": "SC",
    "codigoIbge": 4203600,
    "cidade": "Campos Novos"
  },
  {
    "prefixo": "89626",
    "uf": "SC",
    "codigoIbge": 4203600,
    "cidade": "Campos Novos"
  },
  {
    "prefixo": "89628",
    "uf": "SC",
    "codigoIbge": 4203600,
    "cidade": "Campos Novos"
  },
  {
    "prefixo": "89633",
    "uf": "SC",
    "codigoIbge": 4219853,
    "cidade": "Zortéa"
  },
  {
    "prefixo": "89634",
    "uf": "SC",
    "codigoIbge": 4202875,
    "cidade": "Brunópolis"
  },
  {
    "prefixo": "89635",
    "uf": "SC",
    "codigoIbge": 4202875,
    "cidade": "Brunópolis"
  },
  {
    "prefixo": "89636",
    "uf": "SC",
    "codigoIbge": 4200051,
    "cidade": "Abdon Batista"
  },
  {
    "prefixo": "89638",
    "uf": "SC",
    "codigoIbge": 4219150,
    "cidade": "Vargem"
  },
  {
    "prefixo": "89640",
    "uf": "SC",
    "codigoIbge": 4206801,
    "cidade": "Ibicaré"
  },
  {
    "prefixo": "89642",
    "uf": "SC",
    "codigoIbge": 4217907,
    "cidade": "Tangará"
  },
  {
    "prefixo": "89646",
    "uf": "SC",
    "codigoIbge": 4217907,
    "cidade": "Tangará"
  },
  {
    "prefixo": "89648",
    "uf": "SC",
    "codigoIbge": 4217907,
    "cidade": "Tangará"
  },
  {
    "prefixo": "89650",
    "uf": "SC",
    "codigoIbge": 4218509,
    "cidade": "Treze Tílias"
  },
  {
    "prefixo": "89652",
    "uf": "SC",
    "codigoIbge": 4206751,
    "cidade": "Ibiam"
  },
  {
    "prefixo": "89654",
    "uf": "SC",
    "codigoIbge": 4200408,
    "cidade": "Água Doce"
  },
  {
    "prefixo": "89657",
    "uf": "SC",
    "codigoIbge": 4200408,
    "cidade": "Água Doce"
  },
  {
    "prefixo": "89660",
    "uf": "SC",
    "codigoIbge": 4209201,
    "cidade": "Lacerdópolis"
  },
  {
    "prefixo": "89663",
    "uf": "SC",
    "codigoIbge": 4211801,
    "cidade": "Ouro"
  },
  {
    "prefixo": "89664",
    "uf": "SC",
    "codigoIbge": 4211801,
    "cidade": "Ouro"
  },
  {
    "prefixo": "89665",
    "uf": "SC",
    "codigoIbge": 4203907,
    "cidade": "Capinzal"
  },
  {
    "prefixo": "89667",
    "uf": "SC",
    "codigoIbge": 4213104,
    "cidade": "Piratuba"
  },
  {
    "prefixo": "89669",
    "uf": "SC",
    "codigoIbge": 4207601,
    "cidade": "Ipira"
  },
  {
    "prefixo": "89670",
    "uf": "SC",
    "codigoIbge": 4204004,
    "cidade": "Catanduvas"
  },
  {
    "prefixo": "89675",
    "uf": "SC",
    "codigoIbge": 4219176,
    "cidade": "Vargem Bonita"
  },
  {
    "prefixo": "89677",
    "uf": "SC",
    "codigoIbge": 4208609,
    "cidade": "Jaborá"
  },
  {
    "prefixo": "89680",
    "uf": "SC",
    "codigoIbge": 4207809,
    "cidade": "Irani"
  },
  {
    "prefixo": "89683",
    "uf": "SC",
    "codigoIbge": 4213401,
    "cidade": "Ponte Serrada"
  },
  {
    "prefixo": "89685",
    "uf": "SC",
    "codigoIbge": 4213401,
    "cidade": "Ponte Serrada"
  },
  {
    "prefixo": "89687",
    "uf": "SC",
    "codigoIbge": 4212270,
    "cidade": "Passos Maia"
  },
  {
    "prefixo": "89690",
    "uf": "SC",
    "codigoIbge": 4219101,
    "cidade": "Vargeão"
  },
  {
    "prefixo": "89694",
    "uf": "SC",
    "codigoIbge": 4205308,
    "cidade": "Faxinal dos Guedes"
  },
  {
    "prefixo": "89696",
    "uf": "SC",
    "codigoIbge": 4205308,
    "cidade": "Faxinal dos Guedes"
  },
  {
    "prefixo": "89700",
    "uf": "SC",
    "codigoIbge": 4204301,
    "cidade": "Concórdia"
  },
  {
    "prefixo": "89701",
    "uf": "SC",
    "codigoIbge": 4204301,
    "cidade": "Concórdia"
  },
  {
    "prefixo": "89703",
    "uf": "SC",
    "codigoIbge": 4204301,
    "cidade": "Concórdia"
  },
  {
    "prefixo": "89705",
    "uf": "SC",
    "codigoIbge": 4204301,
    "cidade": "Concórdia"
  },
  {
    "prefixo": "89707",
    "uf": "SC",
    "codigoIbge": 4204301,
    "cidade": "Concórdia"
  },
  {
    "prefixo": "89708",
    "uf": "SC",
    "codigoIbge": 4204301,
    "cidade": "Concórdia"
  },
  {
    "prefixo": "89709",
    "uf": "SC",
    "codigoIbge": 4204301,
    "cidade": "Concórdia"
  },
  {
    "prefixo": "89710",
    "uf": "SC",
    "codigoIbge": 4204301,
    "cidade": "Concórdia"
  },
  {
    "prefixo": "89711",
    "uf": "SC",
    "codigoIbge": 4204301,
    "cidade": "Concórdia"
  },
  {
    "prefixo": "89712",
    "uf": "SC",
    "codigoIbge": 4204301,
    "cidade": "Concórdia"
  },
  {
    "prefixo": "89713",
    "uf": "SC",
    "codigoIbge": 4204301,
    "cidade": "Concórdia"
  },
  {
    "prefixo": "89715",
    "uf": "SC",
    "codigoIbge": 4204301,
    "cidade": "Concórdia"
  },
  {
    "prefixo": "89725",
    "uf": "SC",
    "codigoIbge": 4204301,
    "cidade": "Concórdia"
  },
  {
    "prefixo": "89727",
    "uf": "SC",
    "codigoIbge": 4204301,
    "cidade": "Concórdia"
  },
  {
    "prefixo": "89730",
    "uf": "SC",
    "codigoIbge": 4200754,
    "cidade": "Alto Bela Vista"
  },
  {
    "prefixo": "89735",
    "uf": "SC",
    "codigoIbge": 4209854,
    "cidade": "Lindóia do Sul"
  },
  {
    "prefixo": "89740",
    "uf": "SC",
    "codigoIbge": 4201273,
    "cidade": "Arabutã"
  },
  {
    "prefixo": "89745",
    "uf": "SC",
    "codigoIbge": 4213906,
    "cidade": "Presidente Castello Branco"
  },
  {
    "prefixo": "89750",
    "uf": "SC",
    "codigoIbge": 4212601,
    "cidade": "Peritiba"
  },
  {
    "prefixo": "89760",
    "uf": "SC",
    "codigoIbge": 4208005,
    "cidade": "Itá"
  },
  {
    "prefixo": "89765",
    "uf": "SC",
    "codigoIbge": 4211876,
    "cidade": "Paial"
  },
  {
    "prefixo": "89770",
    "uf": "SC",
    "codigoIbge": 4217501,
    "cidade": "Seara"
  },
  {
    "prefixo": "89772",
    "uf": "SC",
    "codigoIbge": 4217501,
    "cidade": "Seara"
  },
  {
    "prefixo": "89778",
    "uf": "SC",
    "codigoIbge": 4201653,
    "cidade": "Arvoredo"
  },
  {
    "prefixo": "89780",
    "uf": "SC",
    "codigoIbge": 4219606,
    "cidade": "Xavantina"
  },
  {
    "prefixo": "89785",
    "uf": "SC",
    "codigoIbge": 4219606,
    "cidade": "Xavantina"
  },
  {
    "prefixo": "89790",
    "uf": "SC",
    "codigoIbge": 4207700,
    "cidade": "Ipumirim"
  },
  {
    "prefixo": "89801",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89802",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89803",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89804",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89805",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89806",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89807",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89808",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89809",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89810",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89811",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89812",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89813",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89814",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89815",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89816",
    "uf": "SC",
    "codigoIbge": 4204202,
    "cidade": "Chapecó"
  },
  {
    "prefixo": "89817",
    "uf": "SC",
    "codigoIbge": 4206652,
    "cidade": "Guatambú"
  },
  {
    "prefixo": "89818",
    "uf": "SC",
    "codigoIbge": 4211454,
    "cidade": "Nova Itaberaba"
  },
  {
    "prefixo": "89819",
    "uf": "SC",
    "codigoIbge": 4204350,
    "cidade": "Cordilheira Alta"
  },
  {
    "prefixo": "89820",
    "uf": "SC",
    "codigoIbge": 4219507,
    "cidade": "Xanxerê"
  },
  {
    "prefixo": "89822",
    "uf": "SC",
    "codigoIbge": 4219507,
    "cidade": "Xanxerê"
  },
  {
    "prefixo": "89824",
    "uf": "SC",
    "codigoIbge": 4202537,
    "cidade": "Bom Jesus"
  },
  {
    "prefixo": "89825",
    "uf": "SC",
    "codigoIbge": 4219705,
    "cidade": "Xaxim"
  },
  {
    "prefixo": "89828",
    "uf": "SC",
    "codigoIbge": 4209458,
    "cidade": "Lajeado Grande"
  },
  {
    "prefixo": "89830",
    "uf": "SC",
    "codigoIbge": 4200101,
    "cidade": "Abelardo Luz"
  },
  {
    "prefixo": "89832",
    "uf": "SC",
    "codigoIbge": 4207684,
    "cidade": "Ipuaçu"
  },
  {
    "prefixo": "89834",
    "uf": "SC",
    "codigoIbge": 4211850,
    "cidade": "Ouro Verde"
  },
  {
    "prefixo": "89835",
    "uf": "SC",
    "codigoIbge": 4216107,
    "cidade": "São Domingos"
  },
  {
    "prefixo": "89836",
    "uf": "SC",
    "codigoIbge": 4216107,
    "cidade": "São Domingos"
  },
  {
    "prefixo": "89837",
    "uf": "SC",
    "codigoIbge": 4204459,
    "cidade": "Coronel Martins"
  },
  {
    "prefixo": "89838",
    "uf": "SC",
    "codigoIbge": 4205605,
    "cidade": "Galvão"
  },
  {
    "prefixo": "89839",
    "uf": "SC",
    "codigoIbge": 4209177,
    "cidade": "Jupiá"
  },
  {
    "prefixo": "89840",
    "uf": "SC",
    "codigoIbge": 4204400,
    "cidade": "Coronel Freitas"
  },
  {
    "prefixo": "89843",
    "uf": "SC",
    "codigoIbge": 4200556,
    "cidade": "Águas Frias"
  },
  {
    "prefixo": "89845",
    "uf": "SC",
    "codigoIbge": 4218855,
    "cidade": "União do Oeste"
  },
  {
    "prefixo": "89848",
    "uf": "SC",
    "codigoIbge": 4208955,
    "cidade": "Jardinópolis"
  },
  {
    "prefixo": "89850",
    "uf": "SC",
    "codigoIbge": 4214201,
    "cidade": "Quilombo"
  },
  {
    "prefixo": "89854",
    "uf": "SC",
    "codigoIbge": 4215695,
    "cidade": "Santiago do Sul"
  },
  {
    "prefixo": "89855",
    "uf": "SC",
    "codigoIbge": 4217758,
    "cidade": "Sul Brasil"
  },
  {
    "prefixo": "89856",
    "uf": "SC",
    "codigoIbge": 4207858,
    "cidade": "Irati"
  },
  {
    "prefixo": "89859",
    "uf": "SC",
    "codigoIbge": 4205431,
    "cidade": "Formosa do Sul"
  },
  {
    "prefixo": "89860",
    "uf": "SC",
    "codigoIbge": 4210555,
    "cidade": "Marema"
  },
  {
    "prefixo": "89862",
    "uf": "SC",
    "codigoIbge": 4205175,
    "cidade": "Entre Rios"
  },
  {
    "prefixo": "89865",
    "uf": "SC",
    "codigoIbge": 4211405,
    "cidade": "Nova Erechim"
  },
  {
    "prefixo": "89868",
    "uf": "SC",
    "codigoIbge": 4217303,
    "cidade": "Saudades"
  },
  {
    "prefixo": "89870",
    "uf": "SC",
    "codigoIbge": 4212908,
    "cidade": "Pinhalzinho"
  },
  {
    "prefixo": "89871",
    "uf": "SC",
    "codigoIbge": 4217550,
    "cidade": "Serra Alta"
  },
  {
    "prefixo": "89872",
    "uf": "SC",
    "codigoIbge": 4210902,
    "cidade": "Modelo"
  },
  {
    "prefixo": "89873",
    "uf": "SC",
    "codigoIbge": 4202578,
    "cidade": "Bom Jesus do Oeste"
  },
  {
    "prefixo": "89874",
    "uf": "SC",
    "codigoIbge": 4210506,
    "cidade": "Maravilha"
  },
  {
    "prefixo": "89875",
    "uf": "SC",
    "codigoIbge": 4217956,
    "cidade": "Tigrinhos"
  },
  {
    "prefixo": "89878",
    "uf": "SC",
    "codigoIbge": 4205357,
    "cidade": "Flor do Sertão"
  },
  {
    "prefixo": "89879",
    "uf": "SC",
    "codigoIbge": 4217154,
    "cidade": "São Miguel da Boa Vista"
  },
  {
    "prefixo": "89880",
    "uf": "SC",
    "codigoIbge": 4204103,
    "cidade": "Caxambu do Sul"
  },
  {
    "prefixo": "89882",
    "uf": "SC",
    "codigoIbge": 4213153,
    "cidade": "Planalto Alegre"
  },
  {
    "prefixo": "89883",
    "uf": "SC",
    "codigoIbge": 4200507,
    "cidade": "Águas de Chapecó"
  },
  {
    "prefixo": "89885",
    "uf": "SC",
    "codigoIbge": 4216008,
    "cidade": "São Carlos"
  },
  {
    "prefixo": "89886",
    "uf": "SC",
    "codigoIbge": 4204756,
    "cidade": "Cunhataí"
  },
  {
    "prefixo": "89887",
    "uf": "SC",
    "codigoIbge": 4212106,
    "cidade": "Palmitos"
  },
  {
    "prefixo": "89888",
    "uf": "SC",
    "codigoIbge": 4203105,
    "cidade": "Caibi"
  },
  {
    "prefixo": "89890",
    "uf": "SC",
    "codigoIbge": 4204707,
    "cidade": "Cunha Porã"
  },
  {
    "prefixo": "89891",
    "uf": "SC",
    "codigoIbge": 4207759,
    "cidade": "Iraceminha"
  },
  {
    "prefixo": "89892",
    "uf": "SC",
    "codigoIbge": 4207759,
    "cidade": "Iraceminha"
  },
  {
    "prefixo": "89893",
    "uf": "SC",
    "codigoIbge": 4211009,
    "cidade": "Mondaí"
  },
  {
    "prefixo": "89895",
    "uf": "SC",
    "codigoIbge": 4215075,
    "cidade": "Riqueza"
  },
  {
    "prefixo": "89896",
    "uf": "SC",
    "codigoIbge": 4208401,
    "cidade": "Itapiranga"
  },
  {
    "prefixo": "89897",
    "uf": "SC",
    "codigoIbge": 4216255,
    "cidade": "São João do Oeste"
  },
  {
    "prefixo": "89898",
    "uf": "SC",
    "codigoIbge": 4218756,
    "cidade": "Tunápolis"
  },
  {
    "prefixo": "89899",
    "uf": "SC",
    "codigoIbge": 4207650,
    "cidade": "Iporã do Oeste"
  },
  {
    "prefixo": "89900",
    "uf": "SC",
    "codigoIbge": 4217204,
    "cidade": "São Miguel do Oeste"
  },
  {
    "prefixo": "89905",
    "uf": "SC",
    "codigoIbge": 4202081,
    "cidade": "Bandeirante"
  },
  {
    "prefixo": "89906",
    "uf": "SC",
    "codigoIbge": 4212239,
    "cidade": "Paraíso"
  },
  {
    "prefixo": "89908",
    "uf": "SC",
    "codigoIbge": 4215208,
    "cidade": "Romelândia"
  },
  {
    "prefixo": "89909",
    "uf": "SC",
    "codigoIbge": 4202099,
    "cidade": "Barra Bonita"
  },
  {
    "prefixo": "89910",
    "uf": "SC",
    "codigoIbge": 4204905,
    "cidade": "Descanso"
  },
  {
    "prefixo": "89915",
    "uf": "SC",
    "codigoIbge": 4215554,
    "cidade": "Santa Helena"
  },
  {
    "prefixo": "89920",
    "uf": "SC",
    "codigoIbge": 4206405,
    "cidade": "Guaraciaba"
  },
  {
    "prefixo": "89925",
    "uf": "SC",
    "codigoIbge": 4202156,
    "cidade": "Belmonte"
  },
  {
    "prefixo": "89930",
    "uf": "SC",
    "codigoIbge": 4216701,
    "cidade": "São José do Cedro"
  },
  {
    "prefixo": "89933",
    "uf": "SC",
    "codigoIbge": 4216701,
    "cidade": "São José do Cedro"
  },
  {
    "prefixo": "89935",
    "uf": "SC",
    "codigoIbge": 4214151,
    "cidade": "Princesa"
  },
  {
    "prefixo": "89940",
    "uf": "SC",
    "codigoIbge": 4206603,
    "cidade": "Guarujá do Sul"
  },
  {
    "prefixo": "89950",
    "uf": "SC",
    "codigoIbge": 4205001,
    "cidade": "Dionísio Cerqueira"
  },
  {
    "prefixo": "89970",
    "uf": "SC",
    "codigoIbge": 4200804,
    "cidade": "Anchieta"
  },
  {
    "prefixo": "89980",
    "uf": "SC",
    "codigoIbge": 4203501,
    "cidade": "Campo Erê"
  },
  {
    "prefixo": "89981",
    "uf": "SC",
    "codigoIbge": 4215356,
    "cidade": "Saltinho"
  },
  {
    "prefixo": "89982",
    "uf": "SC",
    "codigoIbge": 4215752,
    "cidade": "São Bernardino"
  },
  {
    "prefixo": "89983",
    "uf": "SC",
    "codigoIbge": 4215687,
    "cidade": "Santa Terezinha do Progresso"
  },
  {
    "prefixo": "89985",
    "uf": "SC",
    "codigoIbge": 4212007,
    "cidade": "Palma Sola"
  },
  {
    "prefixo": "89990",
    "uf": "SC",
    "codigoIbge": 4216909,
    "cidade": "São Lourenço do Oeste"
  },
  {
    "prefixo": "89996",
    "uf": "SC",
    "codigoIbge": 4216909,
    "cidade": "São Lourenço do Oeste"
  },
  {
    "prefixo": "89998",
    "uf": "SC",
    "codigoIbge": 4211652,
    "cidade": "Novo Horizonte"
  },
  {
    "prefixo": "90001",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90002",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90010",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90020",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90030",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90035",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90040",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90050",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90090",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90110",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90119",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90130",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90150",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90160",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90200",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90220",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90230",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90240",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90245",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90250",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90251",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90410",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90420",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90430",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90440",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90450",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90460",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90470",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90480",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90510",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90520",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90540",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90550",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90560",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90570",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90610",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90620",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90630",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90640",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90650",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90660",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90670",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90680",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90690",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90810",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90820",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90830",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90840",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90843",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90850",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90870",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "90880",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91010",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91020",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91030",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91040",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91050",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91060",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91110",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91120",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91130",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91140",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91150",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91160",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91170",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91175",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91180",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91210",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91215",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91220",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91225",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91230",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91240",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91250",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91253",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91260",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91261",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91263",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91270",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91280",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91310",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91320",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91330",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91340",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91350",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91360",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91370",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91380",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91410",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91420",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91430",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91440",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91450",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91510",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91520",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91530",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91540",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91550",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91560",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91570",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91710",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91712",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91720",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91740",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91750",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91751",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91755",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91760",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91770",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91771",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91778",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91780",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91781",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91782",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91783",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91784",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91785",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91786",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91787",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91788",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91790",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91791",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91792",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91793",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91795",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91796",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91798",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91900",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91910",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "91920",
    "uf": "RS",
    "codigoIbge": 4314902,
    "cidade": "Porto Alegre"
  },
  {
    "prefixo": "92010",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92020",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92022",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92025",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92027",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92030",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92031",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92032",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92035",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92110",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92120",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92130",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92200",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92201",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92310",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92314",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92320",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92323",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92325",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92330",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92340",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92410",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92412",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92415",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92420",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92425",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92426",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92440",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92441",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92442",
    "uf": "RS",
    "codigoIbge": 4304606,
    "cidade": "Canoas"
  },
  {
    "prefixo": "92480",
    "uf": "RS",
    "codigoIbge": 4313375,
    "cidade": "Nova Santa Rita"
  },
  {
    "prefixo": "92510",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92511",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92512",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92513",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92515",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92516",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92518",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92519",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92521",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92523",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92524",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92525",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92527",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92529",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92531",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92532",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92533",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92534",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92535",
    "uf": "RS",
    "codigoIbge": 4312401,
    "cidade": "Montenegro"
  },
  {
    "prefixo": "92700",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92701",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92702",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92703",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92704",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92705",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92706",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92707",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92708",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92709",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92714",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92717",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92718",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92722",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92725",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92726",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92727",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92728",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92729",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92739",
    "uf": "RS",
    "codigoIbge": 4309308,
    "cidade": "Guaíba"
  },
  {
    "prefixo": "92850",
    "uf": "RS",
    "codigoIbge": 4320552,
    "cidade": "Sertão Santana"
  },
  {
    "prefixo": "92870",
    "uf": "RS",
    "codigoIbge": 4301909,
    "cidade": "Barra do Ribeiro"
  },
  {
    "prefixo": "92880",
    "uf": "RS",
    "codigoIbge": 4301909,
    "cidade": "Barra do Ribeiro"
  },
  {
    "prefixo": "92900",
    "uf": "RS",
    "codigoIbge": 4311981,
    "cidade": "Mariana Pimentel"
  },
  {
    "prefixo": "92990",
    "uf": "RS",
    "codigoIbge": 4306767,
    "cidade": "Eldorado do Sul"
  },
  {
    "prefixo": "92995",
    "uf": "RS",
    "codigoIbge": 4306767,
    "cidade": "Eldorado do Sul"
  },
  {
    "prefixo": "92997",
    "uf": "RS",
    "codigoIbge": 4306767,
    "cidade": "Eldorado do Sul"
  },
  {
    "prefixo": "93010",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93017",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93020",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93022",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93025",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93030",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93032",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93035",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93037",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93040",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93042",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93044",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93046",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93048",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93050",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93052",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93054",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93055",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93056",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93110",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93113",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93115",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93120",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93125",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93130",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93135",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93140",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93145",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93150",
    "uf": "RS",
    "codigoIbge": 4318705,
    "cidade": "São Leopoldo"
  },
  {
    "prefixo": "93180",
    "uf": "RS",
    "codigoIbge": 4314803,
    "cidade": "Portão"
  },
  {
    "prefixo": "93210",
    "uf": "RS",
    "codigoIbge": 4320008,
    "cidade": "Sapucaia do Sul"
  },
  {
    "prefixo": "93211",
    "uf": "RS",
    "codigoIbge": 4320008,
    "cidade": "Sapucaia do Sul"
  },
  {
    "prefixo": "93212",
    "uf": "RS",
    "codigoIbge": 4320008,
    "cidade": "Sapucaia do Sul"
  },
  {
    "prefixo": "93214",
    "uf": "RS",
    "codigoIbge": 4320008,
    "cidade": "Sapucaia do Sul"
  },
  {
    "prefixo": "93216",
    "uf": "RS",
    "codigoIbge": 4320008,
    "cidade": "Sapucaia do Sul"
  },
  {
    "prefixo": "93218",
    "uf": "RS",
    "codigoIbge": 4320008,
    "cidade": "Sapucaia do Sul"
  },
  {
    "prefixo": "93219",
    "uf": "RS",
    "codigoIbge": 4320008,
    "cidade": "Sapucaia do Sul"
  },
  {
    "prefixo": "93220",
    "uf": "RS",
    "codigoIbge": 4320008,
    "cidade": "Sapucaia do Sul"
  },
  {
    "prefixo": "93222",
    "uf": "RS",
    "codigoIbge": 4320008,
    "cidade": "Sapucaia do Sul"
  },
  {
    "prefixo": "93224",
    "uf": "RS",
    "codigoIbge": 4320008,
    "cidade": "Sapucaia do Sul"
  },
  {
    "prefixo": "93225",
    "uf": "RS",
    "codigoIbge": 4320008,
    "cidade": "Sapucaia do Sul"
  },
  {
    "prefixo": "93226",
    "uf": "RS",
    "codigoIbge": 4320008,
    "cidade": "Sapucaia do Sul"
  },
  {
    "prefixo": "93228",
    "uf": "RS",
    "codigoIbge": 4320008,
    "cidade": "Sapucaia do Sul"
  },
  {
    "prefixo": "93230",
    "uf": "RS",
    "codigoIbge": 4320008,
    "cidade": "Sapucaia do Sul"
  },
  {
    "prefixo": "93234",
    "uf": "RS",
    "codigoIbge": 4320008,
    "cidade": "Sapucaia do Sul"
  },
  {
    "prefixo": "93260",
    "uf": "RS",
    "codigoIbge": 4307708,
    "cidade": "Esteio"
  },
  {
    "prefixo": "93265",
    "uf": "RS",
    "codigoIbge": 4307708,
    "cidade": "Esteio"
  },
  {
    "prefixo": "93270",
    "uf": "RS",
    "codigoIbge": 4307708,
    "cidade": "Esteio"
  },
  {
    "prefixo": "93280",
    "uf": "RS",
    "codigoIbge": 4307708,
    "cidade": "Esteio"
  },
  {
    "prefixo": "93285",
    "uf": "RS",
    "codigoIbge": 4307708,
    "cidade": "Esteio"
  },
  {
    "prefixo": "93290",
    "uf": "RS",
    "codigoIbge": 4307708,
    "cidade": "Esteio"
  },
  {
    "prefixo": "93295",
    "uf": "RS",
    "codigoIbge": 4307708,
    "cidade": "Esteio"
  },
  {
    "prefixo": "93301",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93310",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93315",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93320",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93330",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93332",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93334",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93336",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93340",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93344",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93346",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93347",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93348",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93351",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93352",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93410",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93415",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93420",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93425",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93490",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93510",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93520",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93525",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93530",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93531",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93534",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93537",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93540",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93542",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93543",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93544",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93546",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93548",
    "uf": "RS",
    "codigoIbge": 4313409,
    "cidade": "Novo Hamburgo"
  },
  {
    "prefixo": "93600",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93601",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93602",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93603",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93604",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93606",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93607",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93608",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93609",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93610",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93611",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93612",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93613",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93614",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93615",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93616",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93617",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93618",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93619",
    "uf": "RS",
    "codigoIbge": 4307609,
    "cidade": "Estância Velha"
  },
  {
    "prefixo": "93700",
    "uf": "RS",
    "codigoIbge": 4303905,
    "cidade": "Campo Bom"
  },
  {
    "prefixo": "93800",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93801",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93804",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93805",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93806",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93807",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93808",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93812",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93813",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93815",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93816",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93819",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93820",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93821",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93822",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93824",
    "uf": "RS",
    "codigoIbge": 4319901,
    "cidade": "Sapiranga"
  },
  {
    "prefixo": "93880",
    "uf": "RS",
    "codigoIbge": 4300877,
    "cidade": "Araricá"
  },
  {
    "prefixo": "93890",
    "uf": "RS",
    "codigoIbge": 4313060,
    "cidade": "Nova Hartz"
  },
  {
    "prefixo": "93893",
    "uf": "RS",
    "codigoIbge": 4313060,
    "cidade": "Nova Hartz"
  },
  {
    "prefixo": "93900",
    "uf": "RS",
    "codigoIbge": 4310801,
    "cidade": "Ivoti"
  },
  {
    "prefixo": "93940",
    "uf": "RS",
    "codigoIbge": 4311627,
    "cidade": "Lindolfo Collor"
  },
  {
    "prefixo": "93945",
    "uf": "RS",
    "codigoIbge": 4315149,
    "cidade": "Presidente Lucena"
  },
  {
    "prefixo": "93950",
    "uf": "RS",
    "codigoIbge": 4306403,
    "cidade": "Dois Irmãos"
  },
  {
    "prefixo": "93990",
    "uf": "RS",
    "codigoIbge": 4312476,
    "cidade": "Morro Reuter"
  },
  {
    "prefixo": "93995",
    "uf": "RS",
    "codigoIbge": 4316956,
    "cidade": "Santa Maria do Herval"
  },
  {
    "prefixo": "94010",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94015",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94020",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94025",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94030",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94035",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94040",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94045",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94050",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94055",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94060",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94065",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94070",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94075",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94080",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94085",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94090",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94100",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94110",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94120",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94130",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94135",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94140",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94150",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94155",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94170",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94175",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94180",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94185",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94190",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94195",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94196",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94197",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94198",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94199",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94230",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94231",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94232",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94233",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94234",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94235",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94236",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94239",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94240",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94241",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94242",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94243",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94244",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94250",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94251",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94252",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94253",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94254",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94255",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94256",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94260",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94264",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94265",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94267",
    "uf": "RS",
    "codigoIbge": 4309209,
    "cidade": "Gravataí"
  },
  {
    "prefixo": "94380",
    "uf": "RS",
    "codigoIbge": 4309050,
    "cidade": "Glorinha"
  },
  {
    "prefixo": "94410",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94415",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94416",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94417",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94420",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94423",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94425",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94426",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94430",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94431",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94435",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94440",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94445",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94450",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94451",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94455",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94457",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94458",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94460",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94463",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94464",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94465",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94470",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94475",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94480",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94490",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94495",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94500",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94510",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94515",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94540",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94541",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94550",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94551",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94553",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94555",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94560",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94561",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94562",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94570",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94571",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94574",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94575",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94576",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94589",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94595",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94740",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94750",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94760",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94770",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94780",
    "uf": "RS",
    "codigoIbge": 4323002,
    "cidade": "Viamão"
  },
  {
    "prefixo": "94810",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94814",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94818",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94820",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94824",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94828",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94830",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94832",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94834",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94836",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94838",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94850",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94852",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94853",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94855",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94856",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94857",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94858",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94859",
    "uf": "RS",
    "codigoIbge": 4300604,
    "cidade": "Alvorada"
  },
  {
    "prefixo": "94901",
    "uf": "RS",
    "codigoIbge": 4303103,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "94910",
    "uf": "RS",
    "codigoIbge": 4303103,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "94920",
    "uf": "RS",
    "codigoIbge": 4303103,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "94930",
    "uf": "RS",
    "codigoIbge": 4303103,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "94931",
    "uf": "RS",
    "codigoIbge": 4303103,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "94935",
    "uf": "RS",
    "codigoIbge": 4303103,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "94940",
    "uf": "RS",
    "codigoIbge": 4303103,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "94945",
    "uf": "RS",
    "codigoIbge": 4303103,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "94950",
    "uf": "RS",
    "codigoIbge": 4303103,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "94955",
    "uf": "RS",
    "codigoIbge": 4303103,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "94960",
    "uf": "RS",
    "codigoIbge": 4303103,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "94965",
    "uf": "RS",
    "codigoIbge": 4303103,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "94967",
    "uf": "RS",
    "codigoIbge": 4303103,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "94970",
    "uf": "RS",
    "codigoIbge": 4303103,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "94971",
    "uf": "RS",
    "codigoIbge": 4303103,
    "cidade": "Cachoeirinha"
  },
  {
    "prefixo": "95010",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95012",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95013",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95020",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95030",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95032",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95033",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95034",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95040",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95041",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95042",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95043",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95044",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95045",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95046",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95047",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95050",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95052",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95054",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95055",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95057",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95058",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95059",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95060",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95061",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95062",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95064",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95065",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95070",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95072",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95074",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95076",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95077",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95080",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95082",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95084",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95086",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95087",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95088",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95090",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95094",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95095",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95096",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95097",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95098",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95099",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95110",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95112",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95113",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95115",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95124",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95125",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95130",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95133",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95135",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95140",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95143",
    "uf": "RS",
    "codigoIbge": 4305108,
    "cidade": "Caxias do Sul"
  },
  {
    "prefixo": "95150",
    "uf": "RS",
    "codigoIbge": 4313201,
    "cidade": "Nova Petrópolis"
  },
  {
    "prefixo": "95160",
    "uf": "RS",
    "codigoIbge": 4313201,
    "cidade": "Nova Petrópolis"
  },
  {
    "prefixo": "95163",
    "uf": "RS",
    "codigoIbge": 4313201,
    "cidade": "Nova Petrópolis"
  },
  {
    "prefixo": "95165",
    "uf": "RS",
    "codigoIbge": 4313201,
    "cidade": "Nova Petrópolis"
  },
  {
    "prefixo": "95166",
    "uf": "RS",
    "codigoIbge": 4314423,
    "cidade": "Picada Café"
  },
  {
    "prefixo": "95170",
    "uf": "RS",
    "codigoIbge": 4307906,
    "cidade": "Farroupilha"
  },
  {
    "prefixo": "95171",
    "uf": "RS",
    "codigoIbge": 4307906,
    "cidade": "Farroupilha"
  },
  {
    "prefixo": "95172",
    "uf": "RS",
    "codigoIbge": 4307906,
    "cidade": "Farroupilha"
  },
  {
    "prefixo": "95173",
    "uf": "RS",
    "codigoIbge": 4307906,
    "cidade": "Farroupilha"
  },
  {
    "prefixo": "95174",
    "uf": "RS",
    "codigoIbge": 4307906,
    "cidade": "Farroupilha"
  },
  {
    "prefixo": "95176",
    "uf": "RS",
    "codigoIbge": 4307906,
    "cidade": "Farroupilha"
  },
  {
    "prefixo": "95177",
    "uf": "RS",
    "codigoIbge": 4307906,
    "cidade": "Farroupilha"
  },
  {
    "prefixo": "95178",
    "uf": "RS",
    "codigoIbge": 4307906,
    "cidade": "Farroupilha"
  },
  {
    "prefixo": "95179",
    "uf": "RS",
    "codigoIbge": 4307906,
    "cidade": "Farroupilha"
  },
  {
    "prefixo": "95180",
    "uf": "RS",
    "codigoIbge": 4307906,
    "cidade": "Farroupilha"
  },
  {
    "prefixo": "95181",
    "uf": "RS",
    "codigoIbge": 4307906,
    "cidade": "Farroupilha"
  },
  {
    "prefixo": "95182",
    "uf": "RS",
    "codigoIbge": 4307906,
    "cidade": "Farroupilha"
  },
  {
    "prefixo": "95183",
    "uf": "RS",
    "codigoIbge": 4307906,
    "cidade": "Farroupilha"
  },
  {
    "prefixo": "95184",
    "uf": "RS",
    "codigoIbge": 4307906,
    "cidade": "Farroupilha"
  },
  {
    "prefixo": "95185",
    "uf": "RS",
    "codigoIbge": 4304804,
    "cidade": "Carlos Barbosa"
  },
  {
    "prefixo": "95186",
    "uf": "RS",
    "codigoIbge": 4304804,
    "cidade": "Carlos Barbosa"
  },
  {
    "prefixo": "95187",
    "uf": "RS",
    "codigoIbge": 4304804,
    "cidade": "Carlos Barbosa"
  },
  {
    "prefixo": "95188",
    "uf": "RS",
    "codigoIbge": 4304804,
    "cidade": "Carlos Barbosa"
  },
  {
    "prefixo": "95189",
    "uf": "RS",
    "codigoIbge": 4304804,
    "cidade": "Carlos Barbosa"
  },
  {
    "prefixo": "95190",
    "uf": "RS",
    "codigoIbge": 4319000,
    "cidade": "São Marcos"
  },
  {
    "prefixo": "95200",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95201",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95204",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95205",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95206",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95207",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95208",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95210",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95211",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95214",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95216",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95217",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95219",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95220",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95227",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95229",
    "uf": "RS",
    "codigoIbge": 4322509,
    "cidade": "Vacaria"
  },
  {
    "prefixo": "95230",
    "uf": "RS",
    "codigoIbge": 4312617,
    "cidade": "Muitos Capões"
  },
  {
    "prefixo": "95233",
    "uf": "RS",
    "codigoIbge": 4312617,
    "cidade": "Muitos Capões"
  },
  {
    "prefixo": "95236",
    "uf": "RS",
    "codigoIbge": 4312377,
    "cidade": "Monte Alegre dos Campos"
  },
  {
    "prefixo": "95237",
    "uf": "RS",
    "codigoIbge": 4312377,
    "cidade": "Monte Alegre dos Campos"
  },
  {
    "prefixo": "95238",
    "uf": "RS",
    "codigoIbge": 4312377,
    "cidade": "Monte Alegre dos Campos"
  },
  {
    "prefixo": "95240",
    "uf": "RS",
    "codigoIbge": 4310439,
    "cidade": "Ipê"
  },
  {
    "prefixo": "95242",
    "uf": "RS",
    "codigoIbge": 4310439,
    "cidade": "Ipê"
  },
  {
    "prefixo": "95244",
    "uf": "RS",
    "codigoIbge": 4310439,
    "cidade": "Ipê"
  },
  {
    "prefixo": "95250",
    "uf": "RS",
    "codigoIbge": 4300802,
    "cidade": "Antônio Prado"
  },
  {
    "prefixo": "95255",
    "uf": "RS",
    "codigoIbge": 4303673,
    "cidade": "Campestre da Serra"
  },
  {
    "prefixo": "95260",
    "uf": "RS",
    "codigoIbge": 4313359,
    "cidade": "Nova Roma do Sul"
  },
  {
    "prefixo": "95270",
    "uf": "RS",
    "codigoIbge": 4308201,
    "cidade": "Flores da Cunha"
  },
  {
    "prefixo": "95272",
    "uf": "RS",
    "codigoIbge": 4308201,
    "cidade": "Flores da Cunha"
  },
  {
    "prefixo": "95274",
    "uf": "RS",
    "codigoIbge": 4308201,
    "cidade": "Flores da Cunha"
  },
  {
    "prefixo": "95275",
    "uf": "RS",
    "codigoIbge": 4313086,
    "cidade": "Nova Pádua"
  },
  {
    "prefixo": "95280",
    "uf": "RS",
    "codigoIbge": 4318622,
    "cidade": "São José dos Ausentes"
  },
  {
    "prefixo": "95283",
    "uf": "RS",
    "codigoIbge": 4318622,
    "cidade": "São José dos Ausentes"
  },
  {
    "prefixo": "95287",
    "uf": "RS",
    "codigoIbge": 4318622,
    "cidade": "São José dos Ausentes"
  },
  {
    "prefixo": "95289",
    "uf": "RS",
    "codigoIbge": 4318622,
    "cidade": "São José dos Ausentes"
  },
  {
    "prefixo": "95290",
    "uf": "RS",
    "codigoIbge": 4302303,
    "cidade": "Bom Jesus"
  },
  {
    "prefixo": "95292",
    "uf": "RS",
    "codigoIbge": 4302303,
    "cidade": "Bom Jesus"
  },
  {
    "prefixo": "95293",
    "uf": "RS",
    "codigoIbge": 4302303,
    "cidade": "Bom Jesus"
  },
  {
    "prefixo": "95295",
    "uf": "RS",
    "codigoIbge": 4302303,
    "cidade": "Bom Jesus"
  },
  {
    "prefixo": "95296",
    "uf": "RS",
    "codigoIbge": 4302303,
    "cidade": "Bom Jesus"
  },
  {
    "prefixo": "95298",
    "uf": "RS",
    "codigoIbge": 4302303,
    "cidade": "Bom Jesus"
  },
  {
    "prefixo": "95300",
    "uf": "RS",
    "codigoIbge": 4311304,
    "cidade": "Lagoa Vermelha"
  },
  {
    "prefixo": "95305",
    "uf": "RS",
    "codigoIbge": 4309902,
    "cidade": "Ibiraiaras"
  },
  {
    "prefixo": "95306",
    "uf": "RS",
    "codigoIbge": 4309902,
    "cidade": "Ibiraiaras"
  },
  {
    "prefixo": "95308",
    "uf": "RS",
    "codigoIbge": 4304622,
    "cidade": "Capão Bonito do Sul"
  },
  {
    "prefixo": "95309",
    "uf": "RS",
    "codigoIbge": 4304622,
    "cidade": "Capão Bonito do Sul"
  },
  {
    "prefixo": "95310",
    "uf": "RS",
    "codigoIbge": 4300661,
    "cidade": "André da Rocha"
  },
  {
    "prefixo": "95315",
    "uf": "RS",
    "codigoIbge": 4304952,
    "cidade": "Caseiros"
  },
  {
    "prefixo": "95320",
    "uf": "RS",
    "codigoIbge": 4313300,
    "cidade": "Nova Prata"
  },
  {
    "prefixo": "95322",
    "uf": "RS",
    "codigoIbge": 4313300,
    "cidade": "Nova Prata"
  },
  {
    "prefixo": "95325",
    "uf": "RS",
    "codigoIbge": 4323606,
    "cidade": "Vista Alegre do Prata"
  },
  {
    "prefixo": "95330",
    "uf": "RS",
    "codigoIbge": 4322806,
    "cidade": "Veranópolis"
  },
  {
    "prefixo": "95333",
    "uf": "RS",
    "codigoIbge": 4307864,
    "cidade": "Fagundes Varela"
  },
  {
    "prefixo": "95334",
    "uf": "RS",
    "codigoIbge": 4323309,
    "cidade": "Vila Flores"
  },
  {
    "prefixo": "95335",
    "uf": "RS",
    "codigoIbge": 4305959,
    "cidade": "Cotiporã"
  },
  {
    "prefixo": "95338",
    "uf": "RS",
    "codigoIbge": 4305959,
    "cidade": "Cotiporã"
  },
  {
    "prefixo": "95340",
    "uf": "RS",
    "codigoIbge": 4312906,
    "cidade": "Nova Bassano"
  },
  {
    "prefixo": "95345",
    "uf": "RS",
    "codigoIbge": 4315172,
    "cidade": "Protásio Alves"
  },
  {
    "prefixo": "95350",
    "uf": "RS",
    "codigoIbge": 4312807,
    "cidade": "Nova Araçá"
  },
  {
    "prefixo": "95355",
    "uf": "RS",
    "codigoIbge": 4309258,
    "cidade": "Guabiju"
  },
  {
    "prefixo": "95360",
    "uf": "RS",
    "codigoIbge": 4314001,
    "cidade": "Paraí"
  },
  {
    "prefixo": "95365",
    "uf": "RS",
    "codigoIbge": 4318440,
    "cidade": "São Jorge"
  },
  {
    "prefixo": "95370",
    "uf": "RS",
    "codigoIbge": 4301800,
    "cidade": "Barracão"
  },
  {
    "prefixo": "95375",
    "uf": "RS",
    "codigoIbge": 4301800,
    "cidade": "Barracão"
  },
  {
    "prefixo": "95380",
    "uf": "RS",
    "codigoIbge": 4307401,
    "cidade": "Esmeralda"
  },
  {
    "prefixo": "95385",
    "uf": "RS",
    "codigoIbge": 4307401,
    "cidade": "Esmeralda"
  },
  {
    "prefixo": "95388",
    "uf": "RS",
    "codigoIbge": 4307401,
    "cidade": "Esmeralda"
  },
  {
    "prefixo": "95390",
    "uf": "RS",
    "codigoIbge": 4314464,
    "cidade": "Pinhal da Serra"
  },
  {
    "prefixo": "95400",
    "uf": "RS",
    "codigoIbge": 4318200,
    "cidade": "São Francisco de Paula"
  },
  {
    "prefixo": "95405",
    "uf": "RS",
    "codigoIbge": 4318200,
    "cidade": "São Francisco de Paula"
  },
  {
    "prefixo": "95410",
    "uf": "RS",
    "codigoIbge": 4318200,
    "cidade": "São Francisco de Paula"
  },
  {
    "prefixo": "95412",
    "uf": "RS",
    "codigoIbge": 4318200,
    "cidade": "São Francisco de Paula"
  },
  {
    "prefixo": "95414",
    "uf": "RS",
    "codigoIbge": 4318200,
    "cidade": "São Francisco de Paula"
  },
  {
    "prefixo": "95416",
    "uf": "RS",
    "codigoIbge": 4318200,
    "cidade": "São Francisco de Paula"
  },
  {
    "prefixo": "95420",
    "uf": "RS",
    "codigoIbge": 4311122,
    "cidade": "Jaquirana"
  },
  {
    "prefixo": "95425",
    "uf": "RS",
    "codigoIbge": 4311122,
    "cidade": "Jaquirana"
  },
  {
    "prefixo": "95480",
    "uf": "RS",
    "codigoIbge": 4303608,
    "cidade": "Cambará do Sul"
  },
  {
    "prefixo": "95485",
    "uf": "RS",
    "codigoIbge": 4303608,
    "cidade": "Cambará do Sul"
  },
  {
    "prefixo": "95500",
    "uf": "RS",
    "codigoIbge": 4317608,
    "cidade": "Santo Antônio da Patrulha"
  },
  {
    "prefixo": "95508",
    "uf": "RS",
    "codigoIbge": 4317608,
    "cidade": "Santo Antônio da Patrulha"
  },
  {
    "prefixo": "95512",
    "uf": "RS",
    "codigoIbge": 4317608,
    "cidade": "Santo Antônio da Patrulha"
  },
  {
    "prefixo": "95515",
    "uf": "RS",
    "codigoIbge": 4304713,
    "cidade": "Caraá"
  },
  {
    "prefixo": "95520",
    "uf": "RS",
    "codigoIbge": 4313508,
    "cidade": "Osório"
  },
  {
    "prefixo": "95525",
    "uf": "RS",
    "codigoIbge": 4313508,
    "cidade": "Osório"
  },
  {
    "prefixo": "95526",
    "uf": "RS",
    "codigoIbge": 4313508,
    "cidade": "Osório"
  },
  {
    "prefixo": "95527",
    "uf": "RS",
    "codigoIbge": 4313508,
    "cidade": "Osório"
  },
  {
    "prefixo": "95528",
    "uf": "RS",
    "codigoIbge": 4313508,
    "cidade": "Osório"
  },
  {
    "prefixo": "95529",
    "uf": "RS",
    "codigoIbge": 4313508,
    "cidade": "Osório"
  },
  {
    "prefixo": "95530",
    "uf": "RS",
    "codigoIbge": 4311775,
    "cidade": "Maquiné"
  },
  {
    "prefixo": "95532",
    "uf": "RS",
    "codigoIbge": 4311775,
    "cidade": "Maquiné"
  },
  {
    "prefixo": "95534",
    "uf": "RS",
    "codigoIbge": 4311775,
    "cidade": "Maquiné"
  },
  {
    "prefixo": "95535",
    "uf": "RS",
    "codigoIbge": 4321436,
    "cidade": "Terra de Areia"
  },
  {
    "prefixo": "95537",
    "uf": "RS",
    "codigoIbge": 4321436,
    "cidade": "Terra de Areia"
  },
  {
    "prefixo": "95538",
    "uf": "RS",
    "codigoIbge": 4310652,
    "cidade": "Itati"
  },
  {
    "prefixo": "95540",
    "uf": "RS",
    "codigoIbge": 4313656,
    "cidade": "Palmares do Sul"
  },
  {
    "prefixo": "95545",
    "uf": "RS",
    "codigoIbge": 4313656,
    "cidade": "Palmares do Sul"
  },
  {
    "prefixo": "95548",
    "uf": "RS",
    "codigoIbge": 4313656,
    "cidade": "Palmares do Sul"
  },
  {
    "prefixo": "95550",
    "uf": "RS",
    "codigoIbge": 4313656,
    "cidade": "Palmares do Sul"
  },
  {
    "prefixo": "95551",
    "uf": "RS",
    "codigoIbge": 4313656,
    "cidade": "Palmares do Sul"
  },
  {
    "prefixo": "95552",
    "uf": "RS",
    "codigoIbge": 4304671,
    "cidade": "Capivari do Sul"
  },
  {
    "prefixo": "95553",
    "uf": "RS",
    "codigoIbge": 4304671,
    "cidade": "Capivari do Sul"
  },
  {
    "prefixo": "95554",
    "uf": "RS",
    "codigoIbge": 4304671,
    "cidade": "Capivari do Sul"
  },
  {
    "prefixo": "95555",
    "uf": "RS",
    "codigoIbge": 4304630,
    "cidade": "Capão da Canoa"
  },
  {
    "prefixo": "95556",
    "uf": "RS",
    "codigoIbge": 4304630,
    "cidade": "Capão da Canoa"
  },
  {
    "prefixo": "95560",
    "uf": "RS",
    "codigoIbge": 4321501,
    "cidade": "Torres"
  },
  {
    "prefixo": "95565",
    "uf": "RS",
    "codigoIbge": 4321501,
    "cidade": "Torres"
  },
  {
    "prefixo": "95568",
    "uf": "RS",
    "codigoIbge": 4306551,
    "cidade": "Dom Pedro de Alcântara"
  },
  {
    "prefixo": "95572",
    "uf": "RS",
    "codigoIbge": 4311734,
    "cidade": "Mampituba"
  },
  {
    "prefixo": "95575",
    "uf": "RS",
    "codigoIbge": 4321832,
    "cidade": "Três Forquilhas"
  },
  {
    "prefixo": "95577",
    "uf": "RS",
    "codigoIbge": 4312443,
    "cidade": "Morrinhos do Sul"
  },
  {
    "prefixo": "95579",
    "uf": "RS",
    "codigoIbge": 4312443,
    "cidade": "Morrinhos do Sul"
  },
  {
    "prefixo": "95580",
    "uf": "RS",
    "codigoIbge": 4321667,
    "cidade": "Três Cachoeiras"
  },
  {
    "prefixo": "95582",
    "uf": "RS",
    "codigoIbge": 4321667,
    "cidade": "Três Cachoeiras"
  },
  {
    "prefixo": "95584",
    "uf": "RS",
    "codigoIbge": 4321667,
    "cidade": "Três Cachoeiras"
  },
  {
    "prefixo": "95585",
    "uf": "RS",
    "codigoIbge": 4301057,
    "cidade": "Arroio do Sal"
  },
  {
    "prefixo": "95588",
    "uf": "RS",
    "codigoIbge": 4323804,
    "cidade": "Xangri-lá"
  },
  {
    "prefixo": "95589",
    "uf": "RS",
    "codigoIbge": 4323804,
    "cidade": "Xangri-lá"
  },
  {
    "prefixo": "95590",
    "uf": "RS",
    "codigoIbge": 4321600,
    "cidade": "Tramandaí"
  },
  {
    "prefixo": "95595",
    "uf": "RS",
    "codigoIbge": 4305454,
    "cidade": "Cidreira"
  },
  {
    "prefixo": "95599",
    "uf": "RS",
    "codigoIbge": 4301636,
    "cidade": "Balneário Pinhal"
  },
  {
    "prefixo": "95600",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95601",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95603",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95604",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95605",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95607",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95609",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95611",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95612",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95613",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95614",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95615",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95617",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95620",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95622",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95623",
    "uf": "RS",
    "codigoIbge": 4321204,
    "cidade": "Taquara"
  },
  {
    "prefixo": "95625",
    "uf": "RS",
    "codigoIbge": 4310330,
    "cidade": "Imbé"
  },
  {
    "prefixo": "95630",
    "uf": "RS",
    "codigoIbge": 4314050,
    "cidade": "Parobé"
  },
  {
    "prefixo": "95640",
    "uf": "RS",
    "codigoIbge": 4314050,
    "cidade": "Parobé"
  },
  {
    "prefixo": "95650",
    "uf": "RS",
    "codigoIbge": 4310108,
    "cidade": "Igrejinha"
  },
  {
    "prefixo": "95660",
    "uf": "RS",
    "codigoIbge": 4321709,
    "cidade": "Três Coroas"
  },
  {
    "prefixo": "95670",
    "uf": "RS",
    "codigoIbge": 4309100,
    "cidade": "Gramado"
  },
  {
    "prefixo": "95671",
    "uf": "RS",
    "codigoIbge": 4309100,
    "cidade": "Gramado"
  },
  {
    "prefixo": "95672",
    "uf": "RS",
    "codigoIbge": 4309100,
    "cidade": "Gramado"
  },
  {
    "prefixo": "95674",
    "uf": "RS",
    "codigoIbge": 4309100,
    "cidade": "Gramado"
  },
  {
    "prefixo": "95675",
    "uf": "RS",
    "codigoIbge": 4309100,
    "cidade": "Gramado"
  },
  {
    "prefixo": "95677",
    "uf": "RS",
    "codigoIbge": 4309100,
    "cidade": "Gramado"
  },
  {
    "prefixo": "95678",
    "uf": "RS",
    "codigoIbge": 4309100,
    "cidade": "Gramado"
  },
  {
    "prefixo": "95679",
    "uf": "RS",
    "codigoIbge": 4309100,
    "cidade": "Gramado"
  },
  {
    "prefixo": "95680",
    "uf": "RS",
    "codigoIbge": 4304408,
    "cidade": "Canela"
  },
  {
    "prefixo": "95681",
    "uf": "RS",
    "codigoIbge": 4304408,
    "cidade": "Canela"
  },
  {
    "prefixo": "95682",
    "uf": "RS",
    "codigoIbge": 4304408,
    "cidade": "Canela"
  },
  {
    "prefixo": "95683",
    "uf": "RS",
    "codigoIbge": 4304408,
    "cidade": "Canela"
  },
  {
    "prefixo": "95684",
    "uf": "RS",
    "codigoIbge": 4304408,
    "cidade": "Canela"
  },
  {
    "prefixo": "95686",
    "uf": "RS",
    "codigoIbge": 4304408,
    "cidade": "Canela"
  },
  {
    "prefixo": "95688",
    "uf": "RS",
    "codigoIbge": 4304408,
    "cidade": "Canela"
  },
  {
    "prefixo": "95689",
    "uf": "RS",
    "codigoIbge": 4304408,
    "cidade": "Canela"
  },
  {
    "prefixo": "95690",
    "uf": "RS",
    "codigoIbge": 4316006,
    "cidade": "Rolante"
  },
  {
    "prefixo": "95692",
    "uf": "RS",
    "codigoIbge": 4316006,
    "cidade": "Rolante"
  },
  {
    "prefixo": "95695",
    "uf": "RS",
    "codigoIbge": 4315750,
    "cidade": "Riozinho"
  },
  {
    "prefixo": "95700",
    "uf": "RS",
    "codigoIbge": 4302105,
    "cidade": "Bento Gonçalves"
  },
  {
    "prefixo": "95701",
    "uf": "RS",
    "codigoIbge": 4302105,
    "cidade": "Bento Gonçalves"
  },
  {
    "prefixo": "95702",
    "uf": "RS",
    "codigoIbge": 4302105,
    "cidade": "Bento Gonçalves"
  },
  {
    "prefixo": "95703",
    "uf": "RS",
    "codigoIbge": 4302105,
    "cidade": "Bento Gonçalves"
  },
  {
    "prefixo": "95704",
    "uf": "RS",
    "codigoIbge": 4302105,
    "cidade": "Bento Gonçalves"
  },
  {
    "prefixo": "95705",
    "uf": "RS",
    "codigoIbge": 4302105,
    "cidade": "Bento Gonçalves"
  },
  {
    "prefixo": "95706",
    "uf": "RS",
    "codigoIbge": 4302105,
    "cidade": "Bento Gonçalves"
  },
  {
    "prefixo": "95707",
    "uf": "RS",
    "codigoIbge": 4302105,
    "cidade": "Bento Gonçalves"
  },
  {
    "prefixo": "95708",
    "uf": "RS",
    "codigoIbge": 4302105,
    "cidade": "Bento Gonçalves"
  },
  {
    "prefixo": "95709",
    "uf": "RS",
    "codigoIbge": 4302105,
    "cidade": "Bento Gonçalves"
  },
  {
    "prefixo": "95710",
    "uf": "RS",
    "codigoIbge": 4302105,
    "cidade": "Bento Gonçalves"
  },
  {
    "prefixo": "95711",
    "uf": "RS",
    "codigoIbge": 4302105,
    "cidade": "Bento Gonçalves"
  },
  {
    "prefixo": "95713",
    "uf": "RS",
    "codigoIbge": 4302105,
    "cidade": "Bento Gonçalves"
  },
  {
    "prefixo": "95714",
    "uf": "RS",
    "codigoIbge": 4302105,
    "cidade": "Bento Gonçalves"
  },
  {
    "prefixo": "95715",
    "uf": "RS",
    "codigoIbge": 4317251,
    "cidade": "Santa Tereza"
  },
  {
    "prefixo": "95717",
    "uf": "RS",
    "codigoIbge": 4314548,
    "cidade": "Pinto Bandeira"
  },
  {
    "prefixo": "95718",
    "uf": "RS",
    "codigoIbge": 4312385,
    "cidade": "Monte Belo do Sul"
  },
  {
    "prefixo": "95720",
    "uf": "RS",
    "codigoIbge": 4308607,
    "cidade": "Garibaldi"
  },
  {
    "prefixo": "95722",
    "uf": "RS",
    "codigoIbge": 4308607,
    "cidade": "Garibaldi"
  },
  {
    "prefixo": "95723",
    "uf": "RS",
    "codigoIbge": 4308607,
    "cidade": "Garibaldi"
  },
  {
    "prefixo": "95725",
    "uf": "RS",
    "codigoIbge": 4308607,
    "cidade": "Garibaldi"
  },
  {
    "prefixo": "95726",
    "uf": "RS",
    "codigoIbge": 4305934,
    "cidade": "Coronel Pilar"
  },
  {
    "prefixo": "95727",
    "uf": "RS",
    "codigoIbge": 4302253,
    "cidade": "Boa Vista do Sul"
  },
  {
    "prefixo": "95730",
    "uf": "RS",
    "codigoIbge": 4301651,
    "cidade": "Barão"
  },
  {
    "prefixo": "95731",
    "uf": "RS",
    "codigoIbge": 4301651,
    "cidade": "Barão"
  },
  {
    "prefixo": "95732",
    "uf": "RS",
    "codigoIbge": 4301651,
    "cidade": "Barão"
  },
  {
    "prefixo": "95733",
    "uf": "RS",
    "codigoIbge": 4301651,
    "cidade": "Barão"
  },
  {
    "prefixo": "95735",
    "uf": "RS",
    "codigoIbge": 4315800,
    "cidade": "Roca Sales"
  },
  {
    "prefixo": "95737",
    "uf": "RS",
    "codigoIbge": 4315800,
    "cidade": "Roca Sales"
  },
  {
    "prefixo": "95740",
    "uf": "RS",
    "codigoIbge": 4314753,
    "cidade": "Poço das Antas"
  },
  {
    "prefixo": "95745",
    "uf": "RS",
    "codigoIbge": 4304689,
    "cidade": "Capela de Santana"
  },
  {
    "prefixo": "95748",
    "uf": "RS",
    "codigoIbge": 4318614,
    "cidade": "São José do Sul"
  },
  {
    "prefixo": "95750",
    "uf": "RS",
    "codigoIbge": 4316501,
    "cidade": "Salvador do Sul"
  },
  {
    "prefixo": "95751",
    "uf": "RS",
    "codigoIbge": 4316501,
    "cidade": "Salvador do Sul"
  },
  {
    "prefixo": "95753",
    "uf": "RS",
    "codigoIbge": 4316501,
    "cidade": "Salvador do Sul"
  },
  {
    "prefixo": "95754",
    "uf": "RS",
    "codigoIbge": 4316501,
    "cidade": "Salvador do Sul"
  },
  {
    "prefixo": "95755",
    "uf": "RS",
    "codigoIbge": 4318481,
    "cidade": "São José do Hortêncio"
  },
  {
    "prefixo": "95758",
    "uf": "RS",
    "codigoIbge": 4319356,
    "cidade": "São Pedro da Serra"
  },
  {
    "prefixo": "95760",
    "uf": "RS",
    "codigoIbge": 4319505,
    "cidade": "São Sebastião do Caí"
  },
  {
    "prefixo": "95763",
    "uf": "RS",
    "codigoIbge": 4319505,
    "cidade": "São Sebastião do Caí"
  },
  {
    "prefixo": "95765",
    "uf": "RS",
    "codigoIbge": 4302352,
    "cidade": "Bom Princípio"
  },
  {
    "prefixo": "95768",
    "uf": "RS",
    "codigoIbge": 4311643,
    "cidade": "Linha Nova"
  },
  {
    "prefixo": "95770",
    "uf": "RS",
    "codigoIbge": 4308102,
    "cidade": "Feliz"
  },
  {
    "prefixo": "95773",
    "uf": "RS",
    "codigoIbge": 4300570,
    "cidade": "Alto Feliz"
  },
  {
    "prefixo": "95775",
    "uf": "RS",
    "codigoIbge": 4322251,
    "cidade": "Tupandi"
  },
  {
    "prefixo": "95778",
    "uf": "RS",
    "codigoIbge": 4322541,
    "cidade": "Vale Real"
  },
  {
    "prefixo": "95783",
    "uf": "RS",
    "codigoIbge": 4314035,
    "cidade": "Pareci Novo"
  },
  {
    "prefixo": "95785",
    "uf": "RS",
    "codigoIbge": 4309555,
    "cidade": "Harmonia"
  },
  {
    "prefixo": "95790",
    "uf": "RS",
    "codigoIbge": 4302659,
    "cidade": "Brochier"
  },
  {
    "prefixo": "95793",
    "uf": "RS",
    "codigoIbge": 4311791,
    "cidade": "Maratá"
  },
  {
    "prefixo": "95795",
    "uf": "RS",
    "codigoIbge": 4319752,
    "cidade": "São Vendelino"
  },
  {
    "prefixo": "95800",
    "uf": "RS",
    "codigoIbge": 4322608,
    "cidade": "Venâncio Aires"
  },
  {
    "prefixo": "95808",
    "uf": "RS",
    "codigoIbge": 4322608,
    "cidade": "Venâncio Aires"
  },
  {
    "prefixo": "95814",
    "uf": "RS",
    "codigoIbge": 4322608,
    "cidade": "Venâncio Aires"
  },
  {
    "prefixo": "95816",
    "uf": "RS",
    "codigoIbge": 4322608,
    "cidade": "Venâncio Aires"
  },
  {
    "prefixo": "95817",
    "uf": "RS",
    "codigoIbge": 4322608,
    "cidade": "Venâncio Aires"
  },
  {
    "prefixo": "95818",
    "uf": "RS",
    "codigoIbge": 4322608,
    "cidade": "Venâncio Aires"
  },
  {
    "prefixo": "95819",
    "uf": "RS",
    "codigoIbge": 4322608,
    "cidade": "Venâncio Aires"
  },
  {
    "prefixo": "95820",
    "uf": "RS",
    "codigoIbge": 4308805,
    "cidade": "General Câmara"
  },
  {
    "prefixo": "95828",
    "uf": "RS",
    "codigoIbge": 4308805,
    "cidade": "General Câmara"
  },
  {
    "prefixo": "95830",
    "uf": "RS",
    "codigoIbge": 4308805,
    "cidade": "General Câmara"
  },
  {
    "prefixo": "95833",
    "uf": "RS",
    "codigoIbge": 4322525,
    "cidade": "Vale Verde"
  },
  {
    "prefixo": "95835",
    "uf": "RS",
    "codigoIbge": 4312153,
    "cidade": "Mato Leitão"
  },
  {
    "prefixo": "95838",
    "uf": "RS",
    "codigoIbge": 4312153,
    "cidade": "Mato Leitão"
  },
  {
    "prefixo": "95840",
    "uf": "RS",
    "codigoIbge": 4322004,
    "cidade": "Triunfo"
  },
  {
    "prefixo": "95845",
    "uf": "RS",
    "codigoIbge": 4322004,
    "cidade": "Triunfo"
  },
  {
    "prefixo": "95850",
    "uf": "RS",
    "codigoIbge": 4322004,
    "cidade": "Triunfo"
  },
  {
    "prefixo": "95853",
    "uf": "RS",
    "codigoIbge": 4322004,
    "cidade": "Triunfo"
  },
  {
    "prefixo": "95855",
    "uf": "RS",
    "codigoIbge": 4322004,
    "cidade": "Triunfo"
  },
  {
    "prefixo": "95860",
    "uf": "RS",
    "codigoIbge": 4321303,
    "cidade": "Taquari"
  },
  {
    "prefixo": "95862",
    "uf": "RS",
    "codigoIbge": 4321303,
    "cidade": "Taquari"
  },
  {
    "prefixo": "95863",
    "uf": "RS",
    "codigoIbge": 4320859,
    "cidade": "Tabaí"
  },
  {
    "prefixo": "95865",
    "uf": "RS",
    "codigoIbge": 4314159,
    "cidade": "Paverama"
  },
  {
    "prefixo": "95870",
    "uf": "RS",
    "codigoIbge": 4302402,
    "cidade": "Bom Retiro do Sul"
  },
  {
    "prefixo": "95873",
    "uf": "RS",
    "codigoIbge": 4302402,
    "cidade": "Bom Retiro do Sul"
  },
  {
    "prefixo": "95875",
    "uf": "RS",
    "codigoIbge": 4308078,
    "cidade": "Fazenda Vilanova"
  },
  {
    "prefixo": "95880",
    "uf": "RS",
    "codigoIbge": 4307807,
    "cidade": "Estrela"
  },
  {
    "prefixo": "95881",
    "uf": "RS",
    "codigoIbge": 4307807,
    "cidade": "Estrela"
  },
  {
    "prefixo": "95885",
    "uf": "RS",
    "codigoIbge": 4310363,
    "cidade": "Imigrante"
  },
  {
    "prefixo": "95888",
    "uf": "RS",
    "codigoIbge": 4310363,
    "cidade": "Imigrante"
  },
  {
    "prefixo": "95890",
    "uf": "RS",
    "codigoIbge": 4321451,
    "cidade": "Teutônia"
  },
  {
    "prefixo": "95893",
    "uf": "RS",
    "codigoIbge": 4323770,
    "cidade": "Westfália"
  },
  {
    "prefixo": "95895",
    "uf": "RS",
    "codigoIbge": 4305587,
    "cidade": "Colinas"
  },
  {
    "prefixo": "95900",
    "uf": "RS",
    "codigoIbge": 4311403,
    "cidade": "Lajeado"
  },
  {
    "prefixo": "95901",
    "uf": "RS",
    "codigoIbge": 4311403,
    "cidade": "Lajeado"
  },
  {
    "prefixo": "95902",
    "uf": "RS",
    "codigoIbge": 4311403,
    "cidade": "Lajeado"
  },
  {
    "prefixo": "95903",
    "uf": "RS",
    "codigoIbge": 4311403,
    "cidade": "Lajeado"
  },
  {
    "prefixo": "95904",
    "uf": "RS",
    "codigoIbge": 4311403,
    "cidade": "Lajeado"
  },
  {
    "prefixo": "95905",
    "uf": "RS",
    "codigoIbge": 4311403,
    "cidade": "Lajeado"
  },
  {
    "prefixo": "95906",
    "uf": "RS",
    "codigoIbge": 4311403,
    "cidade": "Lajeado"
  },
  {
    "prefixo": "95907",
    "uf": "RS",
    "codigoIbge": 4311403,
    "cidade": "Lajeado"
  },
  {
    "prefixo": "95908",
    "uf": "RS",
    "codigoIbge": 4311403,
    "cidade": "Lajeado"
  },
  {
    "prefixo": "95910",
    "uf": "RS",
    "codigoIbge": 4311403,
    "cidade": "Lajeado"
  },
  {
    "prefixo": "95911",
    "uf": "RS",
    "codigoIbge": 4311403,
    "cidade": "Lajeado"
  },
  {
    "prefixo": "95912",
    "uf": "RS",
    "codigoIbge": 4311403,
    "cidade": "Lajeado"
  },
  {
    "prefixo": "95913",
    "uf": "RS",
    "codigoIbge": 4311403,
    "cidade": "Lajeado"
  },
  {
    "prefixo": "95914",
    "uf": "RS",
    "codigoIbge": 4311403,
    "cidade": "Lajeado"
  },
  {
    "prefixo": "95915",
    "uf": "RS",
    "codigoIbge": 4316758,
    "cidade": "Santa Clara do Sul"
  },
  {
    "prefixo": "95918",
    "uf": "RS",
    "codigoIbge": 4320453,
    "cidade": "Sério"
  },
  {
    "prefixo": "95920",
    "uf": "RS",
    "codigoIbge": 4302451,
    "cidade": "Boqueirão do Leão"
  },
  {
    "prefixo": "95923",
    "uf": "RS",
    "codigoIbge": 4312054,
    "cidade": "Marques de Souza"
  },
  {
    "prefixo": "95924",
    "uf": "RS",
    "codigoIbge": 4312054,
    "cidade": "Marques de Souza"
  },
  {
    "prefixo": "95925",
    "uf": "RS",
    "codigoIbge": 4315156,
    "cidade": "Progresso"
  },
  {
    "prefixo": "95926",
    "uf": "RS",
    "codigoIbge": 4315156,
    "cidade": "Progresso"
  },
  {
    "prefixo": "95927",
    "uf": "RS",
    "codigoIbge": 4315156,
    "cidade": "Progresso"
  },
  {
    "prefixo": "95928",
    "uf": "RS",
    "codigoIbge": 4315156,
    "cidade": "Progresso"
  },
  {
    "prefixo": "95930",
    "uf": "RS",
    "codigoIbge": 4306205,
    "cidade": "Cruzeiro do Sul"
  },
  {
    "prefixo": "95933",
    "uf": "RS",
    "codigoIbge": 4304614,
    "cidade": "Canudos do Vale"
  },
  {
    "prefixo": "95935",
    "uf": "RS",
    "codigoIbge": 4304697,
    "cidade": "Capitão"
  },
  {
    "prefixo": "95937",
    "uf": "RS",
    "codigoIbge": 4308433,
    "cidade": "Forquetinha"
  },
  {
    "prefixo": "95940",
    "uf": "RS",
    "codigoIbge": 4301008,
    "cidade": "Arroio do Meio"
  },
  {
    "prefixo": "95944",
    "uf": "RS",
    "codigoIbge": 4301008,
    "cidade": "Arroio do Meio"
  },
  {
    "prefixo": "95945",
    "uf": "RS",
    "codigoIbge": 4315131,
    "cidade": "Pouso Novo"
  },
  {
    "prefixo": "95948",
    "uf": "RS",
    "codigoIbge": 4321626,
    "cidade": "Travesseiro"
  },
  {
    "prefixo": "95950",
    "uf": "RS",
    "codigoIbge": 4313003,
    "cidade": "Nova Bréscia"
  },
  {
    "prefixo": "95955",
    "uf": "RS",
    "codigoIbge": 4305835,
    "cidade": "Coqueiro Baixo"
  },
  {
    "prefixo": "95960",
    "uf": "RS",
    "codigoIbge": 4306809,
    "cidade": "Encantado"
  },
  {
    "prefixo": "95965",
    "uf": "RS",
    "codigoIbge": 4315453,
    "cidade": "Relvado"
  },
  {
    "prefixo": "95967",
    "uf": "RS",
    "codigoIbge": 4306759,
    "cidade": "Doutor Ricardo"
  },
  {
    "prefixo": "95970",
    "uf": "RS",
    "codigoIbge": 4312609,
    "cidade": "Muçum"
  },
  {
    "prefixo": "95972",
    "uf": "RS",
    "codigoIbge": 4322855,
    "cidade": "Vespasiano Corrêa"
  },
  {
    "prefixo": "95975",
    "uf": "RS",
    "codigoIbge": 4315206,
    "cidade": "Putinga"
  },
  {
    "prefixo": "95977",
    "uf": "RS",
    "codigoIbge": 4315206,
    "cidade": "Putinga"
  },
  {
    "prefixo": "95980",
    "uf": "RS",
    "codigoIbge": 4300703,
    "cidade": "Anta Gorda"
  },
  {
    "prefixo": "95983",
    "uf": "RS",
    "codigoIbge": 4300703,
    "cidade": "Anta Gorda"
  },
  {
    "prefixo": "95985",
    "uf": "RS",
    "codigoIbge": 4312757,
    "cidade": "Nova Alvorada"
  },
  {
    "prefixo": "95990",
    "uf": "RS",
    "codigoIbge": 4310306,
    "cidade": "Ilópolis"
  },
  {
    "prefixo": "95995",
    "uf": "RS",
    "codigoIbge": 4301404,
    "cidade": "Arvorezinha"
  },
  {
    "prefixo": "95997",
    "uf": "RS",
    "codigoIbge": 4310579,
    "cidade": "Itapuca"
  },
  {
    "prefixo": "96010",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96015",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96020",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96025",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96030",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96040",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96045",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96050",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96055",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96060",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96065",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96070",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96071",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96072",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96075",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96076",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96077",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96080",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96081",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96083",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96085",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96087",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96090",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96095",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96099",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96105",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96110",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96115",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96127",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96130",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96140",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96143",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96145",
    "uf": "RS",
    "codigoIbge": 4314407,
    "cidade": "Pelotas"
  },
  {
    "prefixo": "96148",
    "uf": "RS",
    "codigoIbge": 4322327,
    "cidade": "Turuçu"
  },
  {
    "prefixo": "96150",
    "uf": "RS",
    "codigoIbge": 4312450,
    "cidade": "Morro Redondo"
  },
  {
    "prefixo": "96155",
    "uf": "RS",
    "codigoIbge": 4301073,
    "cidade": "Arroio do Padre"
  },
  {
    "prefixo": "96160",
    "uf": "RS",
    "codigoIbge": 4304663,
    "cidade": "Capão do Leão"
  },
  {
    "prefixo": "96163",
    "uf": "RS",
    "codigoIbge": 4304663,
    "cidade": "Capão do Leão"
  },
  {
    "prefixo": "96165",
    "uf": "RS",
    "codigoIbge": 4304663,
    "cidade": "Capão do Leão"
  },
  {
    "prefixo": "96168",
    "uf": "RS",
    "codigoIbge": 4304663,
    "cidade": "Capão do Leão"
  },
  {
    "prefixo": "96170",
    "uf": "RS",
    "codigoIbge": 4318804,
    "cidade": "São Lourenço do Sul"
  },
  {
    "prefixo": "96171",
    "uf": "RS",
    "codigoIbge": 4318804,
    "cidade": "São Lourenço do Sul"
  },
  {
    "prefixo": "96174",
    "uf": "RS",
    "codigoIbge": 4318804,
    "cidade": "São Lourenço do Sul"
  },
  {
    "prefixo": "96176",
    "uf": "RS",
    "codigoIbge": 4318804,
    "cidade": "São Lourenço do Sul"
  },
  {
    "prefixo": "96177",
    "uf": "RS",
    "codigoIbge": 4318804,
    "cidade": "São Lourenço do Sul"
  },
  {
    "prefixo": "96178",
    "uf": "RS",
    "codigoIbge": 4300851,
    "cidade": "Arambaré"
  },
  {
    "prefixo": "96179",
    "uf": "RS",
    "codigoIbge": 4300851,
    "cidade": "Arambaré"
  },
  {
    "prefixo": "96180",
    "uf": "RS",
    "codigoIbge": 4303509,
    "cidade": "Camaquã"
  },
  {
    "prefixo": "96190",
    "uf": "RS",
    "codigoIbge": 4306502,
    "cidade": "Dom Feliciano"
  },
  {
    "prefixo": "96193",
    "uf": "RS",
    "codigoIbge": 4305447,
    "cidade": "Chuvisca"
  },
  {
    "prefixo": "96195",
    "uf": "RS",
    "codigoIbge": 4306056,
    "cidade": "Cristal"
  },
  {
    "prefixo": "96197",
    "uf": "RS",
    "codigoIbge": 4306056,
    "cidade": "Cristal"
  },
  {
    "prefixo": "96200",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96201",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96202",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96203",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96204",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96205",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96206",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96207",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96208",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96209",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96210",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96211",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96212",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96213",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96214",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96215",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96216",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96217",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96219",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96220",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96221",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96222",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96223",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96224",
    "uf": "RS",
    "codigoIbge": 4315602,
    "cidade": "Rio Grande"
  },
  {
    "prefixo": "96225",
    "uf": "RS",
    "codigoIbge": 4318507,
    "cidade": "São José do Norte"
  },
  {
    "prefixo": "96228",
    "uf": "RS",
    "codigoIbge": 4318507,
    "cidade": "São José do Norte"
  },
  {
    "prefixo": "96230",
    "uf": "RS",
    "codigoIbge": 4317301,
    "cidade": "Santa Vitória do Palmar"
  },
  {
    "prefixo": "96245",
    "uf": "RS",
    "codigoIbge": 4317301,
    "cidade": "Santa Vitória do Palmar"
  },
  {
    "prefixo": "96252",
    "uf": "RS",
    "codigoIbge": 4317301,
    "cidade": "Santa Vitória do Palmar"
  },
  {
    "prefixo": "96255",
    "uf": "RS",
    "codigoIbge": 4305439,
    "cidade": "Chuí"
  },
  {
    "prefixo": "96270",
    "uf": "RS",
    "codigoIbge": 4312500,
    "cidade": "Mostardas"
  },
  {
    "prefixo": "96275",
    "uf": "RS",
    "codigoIbge": 4312500,
    "cidade": "Mostardas"
  },
  {
    "prefixo": "96280",
    "uf": "RS",
    "codigoIbge": 4312500,
    "cidade": "Mostardas"
  },
  {
    "prefixo": "96290",
    "uf": "RS",
    "codigoIbge": 4321352,
    "cidade": "Tavares"
  },
  {
    "prefixo": "96300",
    "uf": "RS",
    "codigoIbge": 4311007,
    "cidade": "Jaguarão"
  },
  {
    "prefixo": "96310",
    "uf": "RS",
    "codigoIbge": 4307104,
    "cidade": "Herval"
  },
  {
    "prefixo": "96313",
    "uf": "RS",
    "codigoIbge": 4307104,
    "cidade": "Herval"
  },
  {
    "prefixo": "96330",
    "uf": "RS",
    "codigoIbge": 4301305,
    "cidade": "Arroio Grande"
  },
  {
    "prefixo": "96335",
    "uf": "RS",
    "codigoIbge": 4301305,
    "cidade": "Arroio Grande"
  },
  {
    "prefixo": "96340",
    "uf": "RS",
    "codigoIbge": 4301305,
    "cidade": "Arroio Grande"
  },
  {
    "prefixo": "96350",
    "uf": "RS",
    "codigoIbge": 4301305,
    "cidade": "Arroio Grande"
  },
  {
    "prefixo": "96360",
    "uf": "RS",
    "codigoIbge": 4314209,
    "cidade": "Pedro Osório"
  },
  {
    "prefixo": "96395",
    "uf": "RS",
    "codigoIbge": 4305124,
    "cidade": "Cerrito"
  },
  {
    "prefixo": "96400",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96401",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96402",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96405",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96407",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96408",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96410",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96412",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96413",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96415",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96417",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96418",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96419",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96420",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96422",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96425",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96429",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96435",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96437",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96443",
    "uf": "RS",
    "codigoIbge": 4301602,
    "cidade": "Bagé"
  },
  {
    "prefixo": "96445",
    "uf": "RS",
    "codigoIbge": 4300034,
    "cidade": "Aceguá"
  },
  {
    "prefixo": "96446",
    "uf": "RS",
    "codigoIbge": 4300034,
    "cidade": "Aceguá"
  },
  {
    "prefixo": "96448",
    "uf": "RS",
    "codigoIbge": 4300034,
    "cidade": "Aceguá"
  },
  {
    "prefixo": "96450",
    "uf": "RS",
    "codigoIbge": 4306601,
    "cidade": "Dom Pedrito"
  },
  {
    "prefixo": "96455",
    "uf": "RS",
    "codigoIbge": 4306601,
    "cidade": "Dom Pedrito"
  },
  {
    "prefixo": "96460",
    "uf": "RS",
    "codigoIbge": 4309654,
    "cidade": "Hulha Negra"
  },
  {
    "prefixo": "96465",
    "uf": "RS",
    "codigoIbge": 4309654,
    "cidade": "Hulha Negra"
  },
  {
    "prefixo": "96470",
    "uf": "RS",
    "codigoIbge": 4314506,
    "cidade": "Pinheiro Machado"
  },
  {
    "prefixo": "96485",
    "uf": "RS",
    "codigoIbge": 4314506,
    "cidade": "Pinheiro Machado"
  },
  {
    "prefixo": "96487",
    "uf": "RS",
    "codigoIbge": 4314175,
    "cidade": "Pedras Altas"
  },
  {
    "prefixo": "96490",
    "uf": "RS",
    "codigoIbge": 4314605,
    "cidade": "Piratini"
  },
  {
    "prefixo": "96495",
    "uf": "RS",
    "codigoIbge": 4304358,
    "cidade": "Candiota"
  },
  {
    "prefixo": "96496",
    "uf": "RS",
    "codigoIbge": 4304358,
    "cidade": "Candiota"
  },
  {
    "prefixo": "96497",
    "uf": "RS",
    "codigoIbge": 4304358,
    "cidade": "Candiota"
  },
  {
    "prefixo": "96498",
    "uf": "RS",
    "codigoIbge": 4304358,
    "cidade": "Candiota"
  },
  {
    "prefixo": "96499",
    "uf": "RS",
    "codigoIbge": 4304358,
    "cidade": "Candiota"
  },
  {
    "prefixo": "96501",
    "uf": "RS",
    "codigoIbge": 4303004,
    "cidade": "Cachoeira do Sul"
  },
  {
    "prefixo": "96503",
    "uf": "RS",
    "codigoIbge": 4303004,
    "cidade": "Cachoeira do Sul"
  },
  {
    "prefixo": "96504",
    "uf": "RS",
    "codigoIbge": 4303004,
    "cidade": "Cachoeira do Sul"
  },
  {
    "prefixo": "96505",
    "uf": "RS",
    "codigoIbge": 4303004,
    "cidade": "Cachoeira do Sul"
  },
  {
    "prefixo": "96506",
    "uf": "RS",
    "codigoIbge": 4303004,
    "cidade": "Cachoeira do Sul"
  },
  {
    "prefixo": "96507",
    "uf": "RS",
    "codigoIbge": 4303004,
    "cidade": "Cachoeira do Sul"
  },
  {
    "prefixo": "96508",
    "uf": "RS",
    "codigoIbge": 4303004,
    "cidade": "Cachoeira do Sul"
  },
  {
    "prefixo": "96510",
    "uf": "RS",
    "codigoIbge": 4303004,
    "cidade": "Cachoeira do Sul"
  },
  {
    "prefixo": "96511",
    "uf": "RS",
    "codigoIbge": 4303004,
    "cidade": "Cachoeira do Sul"
  },
  {
    "prefixo": "96517",
    "uf": "RS",
    "codigoIbge": 4303004,
    "cidade": "Cachoeira do Sul"
  },
  {
    "prefixo": "96520",
    "uf": "RS",
    "codigoIbge": 4303004,
    "cidade": "Cachoeira do Sul"
  },
  {
    "prefixo": "96521",
    "uf": "RS",
    "codigoIbge": 4303004,
    "cidade": "Cachoeira do Sul"
  },
  {
    "prefixo": "96524",
    "uf": "RS",
    "codigoIbge": 4303004,
    "cidade": "Cachoeira do Sul"
  },
  {
    "prefixo": "96526",
    "uf": "RS",
    "codigoIbge": 4303004,
    "cidade": "Cachoeira do Sul"
  },
  {
    "prefixo": "96528",
    "uf": "RS",
    "codigoIbge": 4303004,
    "cidade": "Cachoeira do Sul"
  },
  {
    "prefixo": "96530",
    "uf": "RS",
    "codigoIbge": 4314027,
    "cidade": "Paraíso do Sul"
  },
  {
    "prefixo": "96535",
    "uf": "RS",
    "codigoIbge": 4305132,
    "cidade": "Cerro Branco"
  },
  {
    "prefixo": "96540",
    "uf": "RS",
    "codigoIbge": 4300109,
    "cidade": "Agudo"
  },
  {
    "prefixo": "96545",
    "uf": "RS",
    "codigoIbge": 4313391,
    "cidade": "Novo Cabrais"
  },
  {
    "prefixo": "96550",
    "uf": "RS",
    "codigoIbge": 4313391,
    "cidade": "Novo Cabrais"
  },
  {
    "prefixo": "96570",
    "uf": "RS",
    "codigoIbge": 4302808,
    "cidade": "Caçapava do Sul"
  },
  {
    "prefixo": "96575",
    "uf": "RS",
    "codigoIbge": 4302808,
    "cidade": "Caçapava do Sul"
  },
  {
    "prefixo": "96585",
    "uf": "RS",
    "codigoIbge": 4302808,
    "cidade": "Caçapava do Sul"
  },
  {
    "prefixo": "96590",
    "uf": "RS",
    "codigoIbge": 4317004,
    "cidade": "Santana da Boa Vista"
  },
  {
    "prefixo": "96600",
    "uf": "RS",
    "codigoIbge": 4304507,
    "cidade": "Canguçu"
  },
  {
    "prefixo": "96610",
    "uf": "RS",
    "codigoIbge": 4306908,
    "cidade": "Encruzilhada do Sul"
  },
  {
    "prefixo": "96622",
    "uf": "RS",
    "codigoIbge": 4306908,
    "cidade": "Encruzilhada do Sul"
  },
  {
    "prefixo": "96623",
    "uf": "RS",
    "codigoIbge": 4306908,
    "cidade": "Encruzilhada do Sul"
  },
  {
    "prefixo": "96635",
    "uf": "RS",
    "codigoIbge": 4300638,
    "cidade": "Amaral Ferrador"
  },
  {
    "prefixo": "96640",
    "uf": "RS",
    "codigoIbge": 4315701,
    "cidade": "Rio Pardo"
  },
  {
    "prefixo": "96655",
    "uf": "RS",
    "codigoIbge": 4315701,
    "cidade": "Rio Pardo"
  },
  {
    "prefixo": "96660",
    "uf": "RS",
    "codigoIbge": 4315701,
    "cidade": "Rio Pardo"
  },
  {
    "prefixo": "96663",
    "uf": "RS",
    "codigoIbge": 4315701,
    "cidade": "Rio Pardo"
  },
  {
    "prefixo": "96665",
    "uf": "RS",
    "codigoIbge": 4315701,
    "cidade": "Rio Pardo"
  },
  {
    "prefixo": "96670",
    "uf": "RS",
    "codigoIbge": 4315701,
    "cidade": "Rio Pardo"
  },
  {
    "prefixo": "96685",
    "uf": "RS",
    "codigoIbge": 4314076,
    "cidade": "Passo do Sobrado"
  },
  {
    "prefixo": "96690",
    "uf": "RS",
    "codigoIbge": 4313953,
    "cidade": "Pantano Grande"
  },
  {
    "prefixo": "96692",
    "uf": "RS",
    "codigoIbge": 4313953,
    "cidade": "Pantano Grande"
  },
  {
    "prefixo": "96694",
    "uf": "RS",
    "codigoIbge": 4313953,
    "cidade": "Pantano Grande"
  },
  {
    "prefixo": "96700",
    "uf": "RS",
    "codigoIbge": 4318408,
    "cidade": "São Jerônimo"
  },
  {
    "prefixo": "96720",
    "uf": "RS",
    "codigoIbge": 4318408,
    "cidade": "São Jerônimo"
  },
  {
    "prefixo": "96730",
    "uf": "RS",
    "codigoIbge": 4318408,
    "cidade": "São Jerônimo"
  },
  {
    "prefixo": "96735",
    "uf": "RS",
    "codigoIbge": 4301750,
    "cidade": "Barão do Triunfo"
  },
  {
    "prefixo": "96740",
    "uf": "RS",
    "codigoIbge": 4301107,
    "cidade": "Arroio dos Ratos"
  },
  {
    "prefixo": "96745",
    "uf": "RS",
    "codigoIbge": 4305355,
    "cidade": "Charqueadas"
  },
  {
    "prefixo": "96750",
    "uf": "RS",
    "codigoIbge": 4302709,
    "cidade": "Butiá"
  },
  {
    "prefixo": "96753",
    "uf": "RS",
    "codigoIbge": 4302709,
    "cidade": "Butiá"
  },
  {
    "prefixo": "96755",
    "uf": "RS",
    "codigoIbge": 4312252,
    "cidade": "Minas do Leão"
  },
  {
    "prefixo": "96760",
    "uf": "RS",
    "codigoIbge": 4321105,
    "cidade": "Tapes"
  },
  {
    "prefixo": "96765",
    "uf": "RS",
    "codigoIbge": 4320354,
    "cidade": "Sentinela do Sul"
  },
  {
    "prefixo": "96770",
    "uf": "RS",
    "codigoIbge": 4305173,
    "cidade": "Cerro Grande do Sul"
  },
  {
    "prefixo": "96780",
    "uf": "RS",
    "codigoIbge": 4303509,
    "cidade": "Camaquã"
  },
  {
    "prefixo": "96781",
    "uf": "RS",
    "codigoIbge": 4303509,
    "cidade": "Camaquã"
  },
  {
    "prefixo": "96783",
    "uf": "RS",
    "codigoIbge": 4303509,
    "cidade": "Camaquã"
  },
  {
    "prefixo": "96784",
    "uf": "RS",
    "codigoIbge": 4303509,
    "cidade": "Camaquã"
  },
  {
    "prefixo": "96785",
    "uf": "RS",
    "codigoIbge": 4303509,
    "cidade": "Camaquã"
  },
  {
    "prefixo": "96787",
    "uf": "RS",
    "codigoIbge": 4303509,
    "cidade": "Camaquã"
  },
  {
    "prefixo": "96789",
    "uf": "RS",
    "codigoIbge": 4303509,
    "cidade": "Camaquã"
  },
  {
    "prefixo": "96792",
    "uf": "RS",
    "codigoIbge": 4303509,
    "cidade": "Camaquã"
  },
  {
    "prefixo": "96793",
    "uf": "RS",
    "codigoIbge": 4303509,
    "cidade": "Camaquã"
  },
  {
    "prefixo": "96794",
    "uf": "RS",
    "codigoIbge": 4303509,
    "cidade": "Camaquã"
  },
  {
    "prefixo": "96795",
    "uf": "RS",
    "codigoIbge": 4303509,
    "cidade": "Camaquã"
  },
  {
    "prefixo": "96796",
    "uf": "RS",
    "codigoIbge": 4303509,
    "cidade": "Camaquã"
  },
  {
    "prefixo": "96798",
    "uf": "RS",
    "codigoIbge": 4303509,
    "cidade": "Camaquã"
  },
  {
    "prefixo": "96799",
    "uf": "RS",
    "codigoIbge": 4303509,
    "cidade": "Camaquã"
  },
  {
    "prefixo": "96810",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96814",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96815",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96816",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96817",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96820",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96821",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96822",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96823",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96824",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96825",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96826",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96830",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96832",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96833",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96835",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96836",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96837",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96840",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96841",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96842",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96843",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96845",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96849",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96850",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96851",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96853",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96855",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96856",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96859",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96860",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96863",
    "uf": "RS",
    "codigoIbge": 4316808,
    "cidade": "Santa Cruz do Sul"
  },
  {
    "prefixo": "96875",
    "uf": "RS",
    "codigoIbge": 4309159,
    "cidade": "Gramado Xavier"
  },
  {
    "prefixo": "96878",
    "uf": "RS",
    "codigoIbge": 4322533,
    "cidade": "Vale do Sol"
  },
  {
    "prefixo": "96880",
    "uf": "RS",
    "codigoIbge": 4322707,
    "cidade": "Vera Cruz"
  },
  {
    "prefixo": "96888",
    "uf": "RS",
    "codigoIbge": 4309571,
    "cidade": "Herveiras"
  },
  {
    "prefixo": "96890",
    "uf": "RS",
    "codigoIbge": 4320677,
    "cidade": "Sinimbu"
  },
  {
    "prefixo": "96894",
    "uf": "RS",
    "codigoIbge": 4320677,
    "cidade": "Sinimbu"
  },
  {
    "prefixo": "96898",
    "uf": "RS",
    "codigoIbge": 4320677,
    "cidade": "Sinimbu"
  },
  {
    "prefixo": "96900",
    "uf": "RS",
    "codigoIbge": 4320701,
    "cidade": "Sobradinho"
  },
  {
    "prefixo": "96908",
    "uf": "RS",
    "codigoIbge": 4314068,
    "cidade": "Passa Sete"
  },
  {
    "prefixo": "96909",
    "uf": "RS",
    "codigoIbge": 4314068,
    "cidade": "Passa Sete"
  },
  {
    "prefixo": "96910",
    "uf": "RS",
    "codigoIbge": 4320263,
    "cidade": "Segredo"
  },
  {
    "prefixo": "96912",
    "uf": "RS",
    "codigoIbge": 4320263,
    "cidade": "Segredo"
  },
  {
    "prefixo": "96913",
    "uf": "RS",
    "codigoIbge": 4320263,
    "cidade": "Segredo"
  },
  {
    "prefixo": "96915",
    "uf": "RS",
    "codigoIbge": 4320263,
    "cidade": "Segredo"
  },
  {
    "prefixo": "96920",
    "uf": "RS",
    "codigoIbge": 4311239,
    "cidade": "Lagoa Bonita do Sul"
  },
  {
    "prefixo": "96925",
    "uf": "RS",
    "codigoIbge": 4309753,
    "cidade": "Ibarama"
  },
  {
    "prefixo": "96930",
    "uf": "RS",
    "codigoIbge": 4304200,
    "cidade": "Candelária"
  },
  {
    "prefixo": "96935",
    "uf": "RS",
    "codigoIbge": 4304200,
    "cidade": "Candelária"
  },
  {
    "prefixo": "96950",
    "uf": "RS",
    "codigoIbge": 4301206,
    "cidade": "Arroio do Tigre"
  },
  {
    "prefixo": "96953",
    "uf": "RS",
    "codigoIbge": 4301206,
    "cidade": "Arroio do Tigre"
  },
  {
    "prefixo": "96955",
    "uf": "RS",
    "codigoIbge": 4301206,
    "cidade": "Arroio do Tigre"
  },
  {
    "prefixo": "96959",
    "uf": "RS",
    "codigoIbge": 4301206,
    "cidade": "Arroio do Tigre"
  },
  {
    "prefixo": "96990",
    "uf": "RS",
    "codigoIbge": 4307815,
    "cidade": "Estrela Velha"
  },
  {
    "prefixo": "96995",
    "uf": "RS",
    "codigoIbge": 4307815,
    "cidade": "Estrela Velha"
  },
  {
    "prefixo": "96999",
    "uf": "RS",
    "codigoIbge": 4307815,
    "cidade": "Estrela Velha"
  },
  {
    "prefixo": "97010",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97015",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97017",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97020",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97021",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97030",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97032",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97035",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97037",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97040",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97043",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97045",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97050",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97060",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97061",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97065",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97070",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97090",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97095",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97105",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97110",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97120",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97130",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97140",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97145",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97150",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97160",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97165",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97170",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97175",
    "uf": "RS",
    "codigoIbge": 4316907,
    "cidade": "Santa Maria"
  },
  {
    "prefixo": "97180",
    "uf": "RS",
    "codigoIbge": 4306379,
    "cidade": "Dilermando de Aguiar"
  },
  {
    "prefixo": "97185",
    "uf": "RS",
    "codigoIbge": 4310538,
    "cidade": "Itaara"
  },
  {
    "prefixo": "97190",
    "uf": "RS",
    "codigoIbge": 4319125,
    "cidade": "São Martinho da Serra"
  },
  {
    "prefixo": "97195",
    "uf": "RS",
    "codigoIbge": 4320651,
    "cidade": "Silveira Martins"
  },
  {
    "prefixo": "97200",
    "uf": "RS",
    "codigoIbge": 4315503,
    "cidade": "Restinga Sêca"
  },
  {
    "prefixo": "97210",
    "uf": "RS",
    "codigoIbge": 4308409,
    "cidade": "Formigueiro"
  },
  {
    "prefixo": "97220",
    "uf": "RS",
    "codigoIbge": 4308003,
    "cidade": "Faxinal do Soturno"
  },
  {
    "prefixo": "97230",
    "uf": "RS",
    "codigoIbge": 4318432,
    "cidade": "São João do Polêsine"
  },
  {
    "prefixo": "97235",
    "uf": "RS",
    "codigoIbge": 4318432,
    "cidade": "São João do Polêsine"
  },
  {
    "prefixo": "97250",
    "uf": "RS",
    "codigoIbge": 4313102,
    "cidade": "Nova Palma"
  },
  {
    "prefixo": "97270",
    "uf": "RS",
    "codigoIbge": 4313102,
    "cidade": "Nova Palma"
  },
  {
    "prefixo": "97280",
    "uf": "RS",
    "codigoIbge": 4306700,
    "cidade": "Dona Francisca"
  },
  {
    "prefixo": "97300",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97301",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97302",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97304",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97306",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97308",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97310",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97311",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97313",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97314",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97315",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97317",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97320",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97323",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97325",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97327",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97330",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97333",
    "uf": "RS",
    "codigoIbge": 4318309,
    "cidade": "São Gabriel"
  },
  {
    "prefixo": "97335",
    "uf": "RS",
    "codigoIbge": 4316972,
    "cidade": "Santa Margarida do Sul"
  },
  {
    "prefixo": "97340",
    "uf": "RS",
    "codigoIbge": 4319604,
    "cidade": "São Sepé"
  },
  {
    "prefixo": "97350",
    "uf": "RS",
    "codigoIbge": 4319604,
    "cidade": "São Sepé"
  },
  {
    "prefixo": "97355",
    "uf": "RS",
    "codigoIbge": 4319604,
    "cidade": "São Sepé"
  },
  {
    "prefixo": "97370",
    "uf": "RS",
    "codigoIbge": 4319604,
    "cidade": "São Sepé"
  },
  {
    "prefixo": "97380",
    "uf": "RS",
    "codigoIbge": 4319604,
    "cidade": "São Sepé"
  },
  {
    "prefixo": "97385",
    "uf": "RS",
    "codigoIbge": 4323457,
    "cidade": "Vila Nova do Sul"
  },
  {
    "prefixo": "97390",
    "uf": "RS",
    "codigoIbge": 4311502,
    "cidade": "Lavras do Sul"
  },
  {
    "prefixo": "97395",
    "uf": "RS",
    "codigoIbge": 4311502,
    "cidade": "Lavras do Sul"
  },
  {
    "prefixo": "97400",
    "uf": "RS",
    "codigoIbge": 4319406,
    "cidade": "São Pedro do Sul"
  },
  {
    "prefixo": "97408",
    "uf": "RS",
    "codigoIbge": 4319406,
    "cidade": "São Pedro do Sul"
  },
  {
    "prefixo": "97410",
    "uf": "RS",
    "codigoIbge": 4312104,
    "cidade": "Mata"
  },
  {
    "prefixo": "97418",
    "uf": "RS",
    "codigoIbge": 4321493,
    "cidade": "Toropi"
  },
  {
    "prefixo": "97420",
    "uf": "RS",
    "codigoIbge": 4319802,
    "cidade": "São Vicente do Sul"
  },
  {
    "prefixo": "97450",
    "uf": "RS",
    "codigoIbge": 4302907,
    "cidade": "Cacequi"
  },
  {
    "prefixo": "97455",
    "uf": "RS",
    "codigoIbge": 4302907,
    "cidade": "Cacequi"
  },
  {
    "prefixo": "97501",
    "uf": "RS",
    "codigoIbge": 4322400,
    "cidade": "Uruguaiana"
  },
  {
    "prefixo": "97502",
    "uf": "RS",
    "codigoIbge": 4322400,
    "cidade": "Uruguaiana"
  },
  {
    "prefixo": "97503",
    "uf": "RS",
    "codigoIbge": 4322400,
    "cidade": "Uruguaiana"
  },
  {
    "prefixo": "97504",
    "uf": "RS",
    "codigoIbge": 4322400,
    "cidade": "Uruguaiana"
  },
  {
    "prefixo": "97507",
    "uf": "RS",
    "codigoIbge": 4322400,
    "cidade": "Uruguaiana"
  },
  {
    "prefixo": "97508",
    "uf": "RS",
    "codigoIbge": 4322400,
    "cidade": "Uruguaiana"
  },
  {
    "prefixo": "97509",
    "uf": "RS",
    "codigoIbge": 4322400,
    "cidade": "Uruguaiana"
  },
  {
    "prefixo": "97511",
    "uf": "RS",
    "codigoIbge": 4322400,
    "cidade": "Uruguaiana"
  },
  {
    "prefixo": "97513",
    "uf": "RS",
    "codigoIbge": 4322400,
    "cidade": "Uruguaiana"
  },
  {
    "prefixo": "97514",
    "uf": "RS",
    "codigoIbge": 4322400,
    "cidade": "Uruguaiana"
  },
  {
    "prefixo": "97515",
    "uf": "RS",
    "codigoIbge": 4322400,
    "cidade": "Uruguaiana"
  },
  {
    "prefixo": "97530",
    "uf": "RS",
    "codigoIbge": 4322400,
    "cidade": "Uruguaiana"
  },
  {
    "prefixo": "97535",
    "uf": "RS",
    "codigoIbge": 4322400,
    "cidade": "Uruguaiana"
  },
  {
    "prefixo": "97538",
    "uf": "RS",
    "codigoIbge": 4301875,
    "cidade": "Barra do Quaraí"
  },
  {
    "prefixo": "97541",
    "uf": "RS",
    "codigoIbge": 4300406,
    "cidade": "Alegrete"
  },
  {
    "prefixo": "97542",
    "uf": "RS",
    "codigoIbge": 4300406,
    "cidade": "Alegrete"
  },
  {
    "prefixo": "97543",
    "uf": "RS",
    "codigoIbge": 4300406,
    "cidade": "Alegrete"
  },
  {
    "prefixo": "97544",
    "uf": "RS",
    "codigoIbge": 4300406,
    "cidade": "Alegrete"
  },
  {
    "prefixo": "97545",
    "uf": "RS",
    "codigoIbge": 4300406,
    "cidade": "Alegrete"
  },
  {
    "prefixo": "97546",
    "uf": "RS",
    "codigoIbge": 4300406,
    "cidade": "Alegrete"
  },
  {
    "prefixo": "97547",
    "uf": "RS",
    "codigoIbge": 4300406,
    "cidade": "Alegrete"
  },
  {
    "prefixo": "97551",
    "uf": "RS",
    "codigoIbge": 4300406,
    "cidade": "Alegrete"
  },
  {
    "prefixo": "97552",
    "uf": "RS",
    "codigoIbge": 4300406,
    "cidade": "Alegrete"
  },
  {
    "prefixo": "97554",
    "uf": "RS",
    "codigoIbge": 4300406,
    "cidade": "Alegrete"
  },
  {
    "prefixo": "97555",
    "uf": "RS",
    "codigoIbge": 4300406,
    "cidade": "Alegrete"
  },
  {
    "prefixo": "97556",
    "uf": "RS",
    "codigoIbge": 4300406,
    "cidade": "Alegrete"
  },
  {
    "prefixo": "97557",
    "uf": "RS",
    "codigoIbge": 4300406,
    "cidade": "Alegrete"
  },
  {
    "prefixo": "97558",
    "uf": "RS",
    "codigoIbge": 4300406,
    "cidade": "Alegrete"
  },
  {
    "prefixo": "97559",
    "uf": "RS",
    "codigoIbge": 4300406,
    "cidade": "Alegrete"
  },
  {
    "prefixo": "97560",
    "uf": "RS",
    "codigoIbge": 4315305,
    "cidade": "Quaraí"
  },
  {
    "prefixo": "97571",
    "uf": "RS",
    "codigoIbge": 4317103,
    "cidade": "Sant'Ana do Livramento"
  },
  {
    "prefixo": "97572",
    "uf": "RS",
    "codigoIbge": 4317103,
    "cidade": "Sant'Ana do Livramento"
  },
  {
    "prefixo": "97573",
    "uf": "RS",
    "codigoIbge": 4317103,
    "cidade": "Sant'Ana do Livramento"
  },
  {
    "prefixo": "97574",
    "uf": "RS",
    "codigoIbge": 4317103,
    "cidade": "Sant'Ana do Livramento"
  },
  {
    "prefixo": "97575",
    "uf": "RS",
    "codigoIbge": 4317103,
    "cidade": "Sant'Ana do Livramento"
  },
  {
    "prefixo": "97576",
    "uf": "RS",
    "codigoIbge": 4317103,
    "cidade": "Sant'Ana do Livramento"
  },
  {
    "prefixo": "97577",
    "uf": "RS",
    "codigoIbge": 4317103,
    "cidade": "Sant'Ana do Livramento"
  },
  {
    "prefixo": "97578",
    "uf": "RS",
    "codigoIbge": 4317103,
    "cidade": "Sant'Ana do Livramento"
  },
  {
    "prefixo": "97584",
    "uf": "RS",
    "codigoIbge": 4317103,
    "cidade": "Sant'Ana do Livramento"
  },
  {
    "prefixo": "97585",
    "uf": "RS",
    "codigoIbge": 4317103,
    "cidade": "Sant'Ana do Livramento"
  },
  {
    "prefixo": "97590",
    "uf": "RS",
    "codigoIbge": 4316402,
    "cidade": "Rosário do Sul"
  },
  {
    "prefixo": "97592",
    "uf": "RS",
    "codigoIbge": 4316402,
    "cidade": "Rosário do Sul"
  },
  {
    "prefixo": "97595",
    "uf": "RS",
    "codigoIbge": 4316402,
    "cidade": "Rosário do Sul"
  },
  {
    "prefixo": "97596",
    "uf": "RS",
    "codigoIbge": 4316402,
    "cidade": "Rosário do Sul"
  },
  {
    "prefixo": "97598",
    "uf": "RS",
    "codigoIbge": 4316402,
    "cidade": "Rosário do Sul"
  },
  {
    "prefixo": "97610",
    "uf": "RS",
    "codigoIbge": 4318101,
    "cidade": "São Francisco de Assis"
  },
  {
    "prefixo": "97640",
    "uf": "RS",
    "codigoIbge": 4311759,
    "cidade": "Manoel Viana"
  },
  {
    "prefixo": "97644",
    "uf": "RS",
    "codigoIbge": 4311759,
    "cidade": "Manoel Viana"
  },
  {
    "prefixo": "97645",
    "uf": "RS",
    "codigoIbge": 4311718,
    "cidade": "Maçambará"
  },
  {
    "prefixo": "97647",
    "uf": "RS",
    "codigoIbge": 4311718,
    "cidade": "Maçambará"
  },
  {
    "prefixo": "97648",
    "uf": "RS",
    "codigoIbge": 4311718,
    "cidade": "Maçambará"
  },
  {
    "prefixo": "97649",
    "uf": "RS",
    "codigoIbge": 4311718,
    "cidade": "Maçambará"
  },
  {
    "prefixo": "97650",
    "uf": "RS",
    "codigoIbge": 4310603,
    "cidade": "Itaqui"
  },
  {
    "prefixo": "97660",
    "uf": "RS",
    "codigoIbge": 4310603,
    "cidade": "Itaqui"
  },
  {
    "prefixo": "97665",
    "uf": "RS",
    "codigoIbge": 4310603,
    "cidade": "Itaqui"
  },
  {
    "prefixo": "97667",
    "uf": "RS",
    "codigoIbge": 4310603,
    "cidade": "Itaqui"
  },
  {
    "prefixo": "97670",
    "uf": "RS",
    "codigoIbge": 4318002,
    "cidade": "São Borja"
  },
  {
    "prefixo": "97685",
    "uf": "RS",
    "codigoIbge": 4310553,
    "cidade": "Itacurubi"
  },
  {
    "prefixo": "97690",
    "uf": "RS",
    "codigoIbge": 4308656,
    "cidade": "Garruchos"
  },
  {
    "prefixo": "97700",
    "uf": "RS",
    "codigoIbge": 4317400,
    "cidade": "Santiago"
  },
  {
    "prefixo": "97701",
    "uf": "RS",
    "codigoIbge": 4317400,
    "cidade": "Santiago"
  },
  {
    "prefixo": "97702",
    "uf": "RS",
    "codigoIbge": 4317400,
    "cidade": "Santiago"
  },
  {
    "prefixo": "97705",
    "uf": "RS",
    "codigoIbge": 4317400,
    "cidade": "Santiago"
  },
  {
    "prefixo": "97707",
    "uf": "RS",
    "codigoIbge": 4317400,
    "cidade": "Santiago"
  },
  {
    "prefixo": "97709",
    "uf": "RS",
    "codigoIbge": 4317400,
    "cidade": "Santiago"
  },
  {
    "prefixo": "97711",
    "uf": "RS",
    "codigoIbge": 4317400,
    "cidade": "Santiago"
  },
  {
    "prefixo": "97712",
    "uf": "RS",
    "codigoIbge": 4317400,
    "cidade": "Santiago"
  },
  {
    "prefixo": "97714",
    "uf": "RS",
    "codigoIbge": 4317400,
    "cidade": "Santiago"
  },
  {
    "prefixo": "97716",
    "uf": "RS",
    "codigoIbge": 4317400,
    "cidade": "Santiago"
  },
  {
    "prefixo": "97718",
    "uf": "RS",
    "codigoIbge": 4317400,
    "cidade": "Santiago"
  },
  {
    "prefixo": "97719",
    "uf": "RS",
    "codigoIbge": 4317400,
    "cidade": "Santiago"
  },
  {
    "prefixo": "97723",
    "uf": "RS",
    "codigoIbge": 4317400,
    "cidade": "Santiago"
  },
  {
    "prefixo": "97725",
    "uf": "RS",
    "codigoIbge": 4317400,
    "cidade": "Santiago"
  },
  {
    "prefixo": "97727",
    "uf": "RS",
    "codigoIbge": 4317400,
    "cidade": "Santiago"
  },
  {
    "prefixo": "97753",
    "uf": "RS",
    "codigoIbge": 4304655,
    "cidade": "Capão do Cipó"
  },
  {
    "prefixo": "97755",
    "uf": "RS",
    "codigoIbge": 4322376,
    "cidade": "Unistalda"
  },
  {
    "prefixo": "97760",
    "uf": "RS",
    "codigoIbge": 4311106,
    "cidade": "Jaguari"
  },
  {
    "prefixo": "97770",
    "uf": "RS",
    "codigoIbge": 4313037,
    "cidade": "Nova Esperança do Sul"
  },
  {
    "prefixo": "97800",
    "uf": "RS",
    "codigoIbge": 4318903,
    "cidade": "São Luiz Gonzaga"
  },
  {
    "prefixo": "97820",
    "uf": "RS",
    "codigoIbge": 4318903,
    "cidade": "São Luiz Gonzaga"
  },
  {
    "prefixo": "97840",
    "uf": "RS",
    "codigoIbge": 4318903,
    "cidade": "São Luiz Gonzaga"
  },
  {
    "prefixo": "97843",
    "uf": "RS",
    "codigoIbge": 4315958,
    "cidade": "Rolador"
  },
  {
    "prefixo": "97845",
    "uf": "RS",
    "codigoIbge": 4306353,
    "cidade": "Dezesseis de Novembro"
  },
  {
    "prefixo": "97850",
    "uf": "RS",
    "codigoIbge": 4302501,
    "cidade": "Bossoroca"
  },
  {
    "prefixo": "97855",
    "uf": "RS",
    "codigoIbge": 4302501,
    "cidade": "Bossoroca"
  },
  {
    "prefixo": "97860",
    "uf": "RS",
    "codigoIbge": 4302501,
    "cidade": "Bossoroca"
  },
  {
    "prefixo": "97865",
    "uf": "RS",
    "codigoIbge": 4302501,
    "cidade": "Bossoroca"
  },
  {
    "prefixo": "97870",
    "uf": "RS",
    "codigoIbge": 4317707,
    "cidade": "Santo Antônio das Missões"
  },
  {
    "prefixo": "97875",
    "uf": "RS",
    "codigoIbge": 4317707,
    "cidade": "Santo Antônio das Missões"
  },
  {
    "prefixo": "97880",
    "uf": "RS",
    "codigoIbge": 4319208,
    "cidade": "São Nicolau"
  },
  {
    "prefixo": "97885",
    "uf": "RS",
    "codigoIbge": 4314555,
    "cidade": "Pirapó"
  },
  {
    "prefixo": "97900",
    "uf": "RS",
    "codigoIbge": 4305207,
    "cidade": "Cerro Largo"
  },
  {
    "prefixo": "97920",
    "uf": "RS",
    "codigoIbge": 4319372,
    "cidade": "São Pedro do Butiá"
  },
  {
    "prefixo": "97930",
    "uf": "RS",
    "codigoIbge": 4303301,
    "cidade": "Caibaté"
  },
  {
    "prefixo": "97935",
    "uf": "RS",
    "codigoIbge": 4312179,
    "cidade": "Mato Queimado"
  },
  {
    "prefixo": "97940",
    "uf": "RS",
    "codigoIbge": 4316477,
    "cidade": "Salvador das Missões"
  },
  {
    "prefixo": "97945",
    "uf": "RS",
    "codigoIbge": 4316477,
    "cidade": "Salvador das Missões"
  },
  {
    "prefixo": "97950",
    "uf": "RS",
    "codigoIbge": 4309506,
    "cidade": "Guarani das Missões"
  },
  {
    "prefixo": "97955",
    "uf": "RS",
    "codigoIbge": 4309506,
    "cidade": "Guarani das Missões"
  },
  {
    "prefixo": "97957",
    "uf": "RS",
    "codigoIbge": 4309506,
    "cidade": "Guarani das Missões"
  },
  {
    "prefixo": "97960",
    "uf": "RS",
    "codigoIbge": 4320578,
    "cidade": "Sete de Setembro"
  },
  {
    "prefixo": "97970",
    "uf": "RS",
    "codigoIbge": 4316303,
    "cidade": "Roque Gonzales"
  },
  {
    "prefixo": "97973",
    "uf": "RS",
    "codigoIbge": 4316303,
    "cidade": "Roque Gonzales"
  },
  {
    "prefixo": "97980",
    "uf": "RS",
    "codigoIbge": 4319307,
    "cidade": "São Paulo das Missões"
  },
  {
    "prefixo": "98005",
    "uf": "RS",
    "codigoIbge": 4306106,
    "cidade": "Cruz Alta"
  },
  {
    "prefixo": "98010",
    "uf": "RS",
    "codigoIbge": 4306106,
    "cidade": "Cruz Alta"
  },
  {
    "prefixo": "98015",
    "uf": "RS",
    "codigoIbge": 4306106,
    "cidade": "Cruz Alta"
  },
  {
    "prefixo": "98020",
    "uf": "RS",
    "codigoIbge": 4306106,
    "cidade": "Cruz Alta"
  },
  {
    "prefixo": "98025",
    "uf": "RS",
    "codigoIbge": 4306106,
    "cidade": "Cruz Alta"
  },
  {
    "prefixo": "98030",
    "uf": "RS",
    "codigoIbge": 4306106,
    "cidade": "Cruz Alta"
  },
  {
    "prefixo": "98035",
    "uf": "RS",
    "codigoIbge": 4306106,
    "cidade": "Cruz Alta"
  },
  {
    "prefixo": "98040",
    "uf": "RS",
    "codigoIbge": 4306106,
    "cidade": "Cruz Alta"
  },
  {
    "prefixo": "98045",
    "uf": "RS",
    "codigoIbge": 4306106,
    "cidade": "Cruz Alta"
  },
  {
    "prefixo": "98050",
    "uf": "RS",
    "codigoIbge": 4306106,
    "cidade": "Cruz Alta"
  },
  {
    "prefixo": "98051",
    "uf": "RS",
    "codigoIbge": 4306106,
    "cidade": "Cruz Alta"
  },
  {
    "prefixo": "98055",
    "uf": "RS",
    "codigoIbge": 4306106,
    "cidade": "Cruz Alta"
  },
  {
    "prefixo": "98118",
    "uf": "RS",
    "codigoIbge": 4302220,
    "cidade": "Boa Vista do Cadeado"
  },
  {
    "prefixo": "98120",
    "uf": "RS",
    "codigoIbge": 4302238,
    "cidade": "Boa Vista do Incra"
  },
  {
    "prefixo": "98125",
    "uf": "RS",
    "codigoIbge": 4308458,
    "cidade": "Fortaleza dos Valos"
  },
  {
    "prefixo": "98127",
    "uf": "RS",
    "codigoIbge": 4308458,
    "cidade": "Fortaleza dos Valos"
  },
  {
    "prefixo": "98130",
    "uf": "RS",
    "codigoIbge": 4311205,
    "cidade": "Júlio de Castilhos"
  },
  {
    "prefixo": "98135",
    "uf": "RS",
    "codigoIbge": 4311205,
    "cidade": "Júlio de Castilhos"
  },
  {
    "prefixo": "98137",
    "uf": "RS",
    "codigoIbge": 4311205,
    "cidade": "Júlio de Castilhos"
  },
  {
    "prefixo": "98140",
    "uf": "RS",
    "codigoIbge": 4315321,
    "cidade": "Quevedos"
  },
  {
    "prefixo": "98150",
    "uf": "RS",
    "codigoIbge": 4314472,
    "cidade": "Pinhal Grande"
  },
  {
    "prefixo": "98157",
    "uf": "RS",
    "codigoIbge": 4314472,
    "cidade": "Pinhal Grande"
  },
  {
    "prefixo": "98160",
    "uf": "RS",
    "codigoIbge": 4310751,
    "cidade": "Ivorá"
  },
  {
    "prefixo": "98170",
    "uf": "RS",
    "codigoIbge": 4322202,
    "cidade": "Tupanciretã"
  },
  {
    "prefixo": "98173",
    "uf": "RS",
    "codigoIbge": 4322202,
    "cidade": "Tupanciretã"
  },
  {
    "prefixo": "98175",
    "uf": "RS",
    "codigoIbge": 4311130,
    "cidade": "Jari"
  },
  {
    "prefixo": "98180",
    "uf": "RS",
    "codigoIbge": 4311155,
    "cidade": "Jóia"
  },
  {
    "prefixo": "98200",
    "uf": "RS",
    "codigoIbge": 4310009,
    "cidade": "Ibirubá"
  },
  {
    "prefixo": "98220",
    "uf": "RS",
    "codigoIbge": 4310009,
    "cidade": "Ibirubá"
  },
  {
    "prefixo": "98230",
    "uf": "RS",
    "codigoIbge": 4315354,
    "cidade": "Quinze de Novembro"
  },
  {
    "prefixo": "98232",
    "uf": "RS",
    "codigoIbge": 4315354,
    "cidade": "Quinze de Novembro"
  },
  {
    "prefixo": "98240",
    "uf": "RS",
    "codigoIbge": 4316709,
    "cidade": "Santa Bárbara do Sul"
  },
  {
    "prefixo": "98245",
    "uf": "RS",
    "codigoIbge": 4316709,
    "cidade": "Santa Bárbara do Sul"
  },
  {
    "prefixo": "98247",
    "uf": "RS",
    "codigoIbge": 4316709,
    "cidade": "Santa Bárbara do Sul"
  },
  {
    "prefixo": "98250",
    "uf": "RS",
    "codigoIbge": 4316436,
    "cidade": "Saldanha Marinho"
  },
  {
    "prefixo": "98255",
    "uf": "RS",
    "codigoIbge": 4316436,
    "cidade": "Saldanha Marinho"
  },
  {
    "prefixo": "98270",
    "uf": "RS",
    "codigoIbge": 4314308,
    "cidade": "Pejuçara"
  },
  {
    "prefixo": "98280",
    "uf": "RS",
    "codigoIbge": 4313904,
    "cidade": "Panambi"
  },
  {
    "prefixo": "98281",
    "uf": "RS",
    "codigoIbge": 4313904,
    "cidade": "Panambi"
  },
  {
    "prefixo": "98290",
    "uf": "RS",
    "codigoIbge": 4305702,
    "cidade": "Condor"
  },
  {
    "prefixo": "98300",
    "uf": "RS",
    "codigoIbge": 4313706,
    "cidade": "Palmeira das Missões"
  },
  {
    "prefixo": "98320",
    "uf": "RS",
    "codigoIbge": 4311429,
    "cidade": "Lajeado do Bugre"
  },
  {
    "prefixo": "98323",
    "uf": "RS",
    "codigoIbge": 4319364,
    "cidade": "São Pedro das Missões"
  },
  {
    "prefixo": "98325",
    "uf": "RS",
    "codigoIbge": 4318457,
    "cidade": "São José das Missões"
  },
  {
    "prefixo": "98330",
    "uf": "RS",
    "codigoIbge": 4316428,
    "cidade": "Sagrada Família"
  },
  {
    "prefixo": "98333",
    "uf": "RS",
    "codigoIbge": 4316428,
    "cidade": "Sagrada Família"
  },
  {
    "prefixo": "98335",
    "uf": "RS",
    "codigoIbge": 4302154,
    "cidade": "Boa Vista das Missões"
  },
  {
    "prefixo": "98338",
    "uf": "RS",
    "codigoIbge": 4313490,
    "cidade": "Novo Barreiro"
  },
  {
    "prefixo": "98340",
    "uf": "RS",
    "codigoIbge": 4305157,
    "cidade": "Cerro Grande"
  },
  {
    "prefixo": "98345",
    "uf": "RS",
    "codigoIbge": 4314456,
    "cidade": "Pinhal"
  },
  {
    "prefixo": "98350",
    "uf": "RS",
    "codigoIbge": 4310850,
    "cidade": "Jaboticaba"
  },
  {
    "prefixo": "98355",
    "uf": "RS",
    "codigoIbge": 4310850,
    "cidade": "Jaboticaba"
  },
  {
    "prefixo": "98360",
    "uf": "RS",
    "codigoIbge": 4315909,
    "cidade": "Rodeio Bonito"
  },
  {
    "prefixo": "98365",
    "uf": "RS",
    "codigoIbge": 4315909,
    "cidade": "Rodeio Bonito"
  },
  {
    "prefixo": "98368",
    "uf": "RS",
    "codigoIbge": 4306072,
    "cidade": "Cristal do Sul"
  },
  {
    "prefixo": "98370",
    "uf": "RS",
    "codigoIbge": 4313441,
    "cidade": "Novo Tiradentes"
  },
  {
    "prefixo": "98380",
    "uf": "RS",
    "codigoIbge": 4320206,
    "cidade": "Seberi"
  },
  {
    "prefixo": "98384",
    "uf": "RS",
    "codigoIbge": 4320206,
    "cidade": "Seberi"
  },
  {
    "prefixo": "98385",
    "uf": "RS",
    "codigoIbge": 4306429,
    "cidade": "Dois Irmãos das Missões"
  },
  {
    "prefixo": "98390",
    "uf": "RS",
    "codigoIbge": 4307302,
    "cidade": "Erval Seco"
  },
  {
    "prefixo": "98393",
    "uf": "RS",
    "codigoIbge": 4307302,
    "cidade": "Erval Seco"
  },
  {
    "prefixo": "98395",
    "uf": "RS",
    "codigoIbge": 4307302,
    "cidade": "Erval Seco"
  },
  {
    "prefixo": "98399",
    "uf": "RS",
    "codigoIbge": 4307302,
    "cidade": "Erval Seco"
  },
  {
    "prefixo": "98400",
    "uf": "RS",
    "codigoIbge": 4308508,
    "cidade": "Frederico Westphalen"
  },
  {
    "prefixo": "98403",
    "uf": "RS",
    "codigoIbge": 4308508,
    "cidade": "Frederico Westphalen"
  },
  {
    "prefixo": "98405",
    "uf": "RS",
    "codigoIbge": 4308508,
    "cidade": "Frederico Westphalen"
  },
  {
    "prefixo": "98410",
    "uf": "RS",
    "codigoIbge": 4321329,
    "cidade": "Taquaruçu do Sul"
  },
  {
    "prefixo": "98415",
    "uf": "RS",
    "codigoIbge": 4323507,
    "cidade": "Vista Alegre"
  },
  {
    "prefixo": "98430",
    "uf": "RS",
    "codigoIbge": 4313805,
    "cidade": "Palmitinho"
  },
  {
    "prefixo": "98435",
    "uf": "RS",
    "codigoIbge": 4314498,
    "cidade": "Pinheirinho do Vale"
  },
  {
    "prefixo": "98440",
    "uf": "RS",
    "codigoIbge": 4303400,
    "cidade": "Caiçara"
  },
  {
    "prefixo": "98445",
    "uf": "RS",
    "codigoIbge": 4303400,
    "cidade": "Caiçara"
  },
  {
    "prefixo": "98450",
    "uf": "RS",
    "codigoIbge": 4323101,
    "cidade": "Vicente Dutra"
  },
  {
    "prefixo": "98455",
    "uf": "RS",
    "codigoIbge": 4323101,
    "cidade": "Vicente Dutra"
  },
  {
    "prefixo": "98460",
    "uf": "RS",
    "codigoIbge": 4310504,
    "cidade": "Iraí"
  },
  {
    "prefixo": "98465",
    "uf": "RS",
    "codigoIbge": 4300646,
    "cidade": "Ametista do Sul"
  },
  {
    "prefixo": "98468",
    "uf": "RS",
    "codigoIbge": 4300646,
    "cidade": "Ametista do Sul"
  },
  {
    "prefixo": "98470",
    "uf": "RS",
    "codigoIbge": 4314704,
    "cidade": "Planalto"
  },
  {
    "prefixo": "98472",
    "uf": "RS",
    "codigoIbge": 4314704,
    "cidade": "Planalto"
  },
  {
    "prefixo": "98476",
    "uf": "RS",
    "codigoIbge": 4314704,
    "cidade": "Planalto"
  },
  {
    "prefixo": "98477",
    "uf": "RS",
    "codigoIbge": 4314704,
    "cidade": "Planalto"
  },
  {
    "prefixo": "98480",
    "uf": "RS",
    "codigoIbge": 4300505,
    "cidade": "Alpestre"
  },
  {
    "prefixo": "98495",
    "uf": "RS",
    "codigoIbge": 4300505,
    "cidade": "Alpestre"
  },
  {
    "prefixo": "98500",
    "uf": "RS",
    "codigoIbge": 4321402,
    "cidade": "Tenente Portela"
  },
  {
    "prefixo": "98525",
    "uf": "RS",
    "codigoIbge": 4321402,
    "cidade": "Tenente Portela"
  },
  {
    "prefixo": "98528",
    "uf": "RS",
    "codigoIbge": 4306320,
    "cidade": "Derrubadas"
  },
  {
    "prefixo": "98530",
    "uf": "RS",
    "codigoIbge": 4301859,
    "cidade": "Barra do Guarita"
  },
  {
    "prefixo": "98535",
    "uf": "RS",
    "codigoIbge": 4323705,
    "cidade": "Vista Gaúcha"
  },
  {
    "prefixo": "98538",
    "uf": "RS",
    "codigoIbge": 4323705,
    "cidade": "Vista Gaúcha"
  },
  {
    "prefixo": "98540",
    "uf": "RS",
    "codigoIbge": 4312302,
    "cidade": "Miraguaí"
  },
  {
    "prefixo": "98545",
    "uf": "RS",
    "codigoIbge": 4312302,
    "cidade": "Miraguaí"
  },
  {
    "prefixo": "98550",
    "uf": "RS",
    "codigoIbge": 4315404,
    "cidade": "Redentora"
  },
  {
    "prefixo": "98555",
    "uf": "RS",
    "codigoIbge": 4315404,
    "cidade": "Redentora"
  },
  {
    "prefixo": "98557",
    "uf": "RS",
    "codigoIbge": 4315404,
    "cidade": "Redentora"
  },
  {
    "prefixo": "98560",
    "uf": "RS",
    "codigoIbge": 4302600,
    "cidade": "Braga"
  },
  {
    "prefixo": "98565",
    "uf": "RS",
    "codigoIbge": 4302600,
    "cidade": "Braga"
  },
  {
    "prefixo": "98570",
    "uf": "RS",
    "codigoIbge": 4304002,
    "cidade": "Campo Novo"
  },
  {
    "prefixo": "98575",
    "uf": "RS",
    "codigoIbge": 4302378,
    "cidade": "Bom Progresso"
  },
  {
    "prefixo": "98580",
    "uf": "RS",
    "codigoIbge": 4305900,
    "cidade": "Coronel Bicaco"
  },
  {
    "prefixo": "98585",
    "uf": "RS",
    "codigoIbge": 4305900,
    "cidade": "Coronel Bicaco"
  },
  {
    "prefixo": "98588",
    "uf": "RS",
    "codigoIbge": 4305900,
    "cidade": "Coronel Bicaco"
  },
  {
    "prefixo": "98590",
    "uf": "RS",
    "codigoIbge": 4317806,
    "cidade": "Santo Augusto"
  },
  {
    "prefixo": "98591",
    "uf": "RS",
    "codigoIbge": 4317806,
    "cidade": "Santo Augusto"
  },
  {
    "prefixo": "98592",
    "uf": "RS",
    "codigoIbge": 4317806,
    "cidade": "Santo Augusto"
  },
  {
    "prefixo": "98593",
    "uf": "RS",
    "codigoIbge": 4317806,
    "cidade": "Santo Augusto"
  },
  {
    "prefixo": "98594",
    "uf": "RS",
    "codigoIbge": 4317806,
    "cidade": "Santo Augusto"
  },
  {
    "prefixo": "98595",
    "uf": "RS",
    "codigoIbge": 4319737,
    "cidade": "São Valério do Sul"
  },
  {
    "prefixo": "98598",
    "uf": "RS",
    "codigoIbge": 4319737,
    "cidade": "São Valério do Sul"
  },
  {
    "prefixo": "98600",
    "uf": "RS",
    "codigoIbge": 4321907,
    "cidade": "Três Passos"
  },
  {
    "prefixo": "98603",
    "uf": "RS",
    "codigoIbge": 4321907,
    "cidade": "Três Passos"
  },
  {
    "prefixo": "98610",
    "uf": "RS",
    "codigoIbge": 4321907,
    "cidade": "Três Passos"
  },
  {
    "prefixo": "98613",
    "uf": "RS",
    "codigoIbge": 4321907,
    "cidade": "Três Passos"
  },
  {
    "prefixo": "98630",
    "uf": "RS",
    "codigoIbge": 4321907,
    "cidade": "Três Passos"
  },
  {
    "prefixo": "98635",
    "uf": "RS",
    "codigoIbge": 4307450,
    "cidade": "Esperança do Sul"
  },
  {
    "prefixo": "98636",
    "uf": "RS",
    "codigoIbge": 4307450,
    "cidade": "Esperança do Sul"
  },
  {
    "prefixo": "98638",
    "uf": "RS",
    "codigoIbge": 4307450,
    "cidade": "Esperança do Sul"
  },
  {
    "prefixo": "98639",
    "uf": "RS",
    "codigoIbge": 4307450,
    "cidade": "Esperança do Sul"
  },
  {
    "prefixo": "98640",
    "uf": "RS",
    "codigoIbge": 4306007,
    "cidade": "Crissiumal"
  },
  {
    "prefixo": "98645",
    "uf": "RS",
    "codigoIbge": 4306007,
    "cidade": "Crissiumal"
  },
  {
    "prefixo": "98655",
    "uf": "RS",
    "codigoIbge": 4306007,
    "cidade": "Crissiumal"
  },
  {
    "prefixo": "98660",
    "uf": "RS",
    "codigoIbge": 4306007,
    "cidade": "Crissiumal"
  },
  {
    "prefixo": "98670",
    "uf": "RS",
    "codigoIbge": 4309704,
    "cidade": "Humaitá"
  },
  {
    "prefixo": "98675",
    "uf": "RS",
    "codigoIbge": 4320230,
    "cidade": "Sede Nova"
  },
  {
    "prefixo": "98678",
    "uf": "RS",
    "codigoIbge": 4320230,
    "cidade": "Sede Nova"
  },
  {
    "prefixo": "98680",
    "uf": "RS",
    "codigoIbge": 4321477,
    "cidade": "Tiradentes do Sul"
  },
  {
    "prefixo": "98683",
    "uf": "RS",
    "codigoIbge": 4321477,
    "cidade": "Tiradentes do Sul"
  },
  {
    "prefixo": "98688",
    "uf": "RS",
    "codigoIbge": 4321477,
    "cidade": "Tiradentes do Sul"
  },
  {
    "prefixo": "98690",
    "uf": "RS",
    "codigoIbge": 4319109,
    "cidade": "São Martinho"
  },
  {
    "prefixo": "98700",
    "uf": "RS",
    "codigoIbge": 4310207,
    "cidade": "Ijuí"
  },
  {
    "prefixo": "98710",
    "uf": "RS",
    "codigoIbge": 4310207,
    "cidade": "Ijuí"
  },
  {
    "prefixo": "98717",
    "uf": "RS",
    "codigoIbge": 4310207,
    "cidade": "Ijuí"
  },
  {
    "prefixo": "98730",
    "uf": "RS",
    "codigoIbge": 4310207,
    "cidade": "Ijuí"
  },
  {
    "prefixo": "98733",
    "uf": "RS",
    "codigoIbge": 4302584,
    "cidade": "Bozano"
  },
  {
    "prefixo": "98735",
    "uf": "RS",
    "codigoIbge": 4305871,
    "cidade": "Coronel Barros"
  },
  {
    "prefixo": "98740",
    "uf": "RS",
    "codigoIbge": 4301503,
    "cidade": "Augusto Pestana"
  },
  {
    "prefixo": "98750",
    "uf": "RS",
    "codigoIbge": 4300208,
    "cidade": "Ajuricaba"
  },
  {
    "prefixo": "98755",
    "uf": "RS",
    "codigoIbge": 4300208,
    "cidade": "Ajuricaba"
  },
  {
    "prefixo": "98758",
    "uf": "RS",
    "codigoIbge": 4313334,
    "cidade": "Nova Ramada"
  },
  {
    "prefixo": "98760",
    "uf": "RS",
    "codigoIbge": 4305405,
    "cidade": "Chiapetta"
  },
  {
    "prefixo": "98765",
    "uf": "RS",
    "codigoIbge": 4310413,
    "cidade": "Inhacorá"
  },
  {
    "prefixo": "98770",
    "uf": "RS",
    "codigoIbge": 4305009,
    "cidade": "Catuípe"
  },
  {
    "prefixo": "98777",
    "uf": "RS",
    "codigoIbge": 4305009,
    "cidade": "Catuípe"
  },
  {
    "prefixo": "98778",
    "uf": "RS",
    "codigoIbge": 4305009,
    "cidade": "Catuípe"
  },
  {
    "prefixo": "98780",
    "uf": "RS",
    "codigoIbge": 4317202,
    "cidade": "Santa Rosa"
  },
  {
    "prefixo": "98781",
    "uf": "RS",
    "codigoIbge": 4317202,
    "cidade": "Santa Rosa"
  },
  {
    "prefixo": "98783",
    "uf": "RS",
    "codigoIbge": 4317202,
    "cidade": "Santa Rosa"
  },
  {
    "prefixo": "98785",
    "uf": "RS",
    "codigoIbge": 4317202,
    "cidade": "Santa Rosa"
  },
  {
    "prefixo": "98787",
    "uf": "RS",
    "codigoIbge": 4317202,
    "cidade": "Santa Rosa"
  },
  {
    "prefixo": "98788",
    "uf": "RS",
    "codigoIbge": 4317202,
    "cidade": "Santa Rosa"
  },
  {
    "prefixo": "98789",
    "uf": "RS",
    "codigoIbge": 4317202,
    "cidade": "Santa Rosa"
  },
  {
    "prefixo": "98790",
    "uf": "RS",
    "codigoIbge": 4317202,
    "cidade": "Santa Rosa"
  },
  {
    "prefixo": "98792",
    "uf": "RS",
    "codigoIbge": 4317202,
    "cidade": "Santa Rosa"
  },
  {
    "prefixo": "98794",
    "uf": "RS",
    "codigoIbge": 4317202,
    "cidade": "Santa Rosa"
  },
  {
    "prefixo": "98795",
    "uf": "RS",
    "codigoIbge": 4317202,
    "cidade": "Santa Rosa"
  },
  {
    "prefixo": "98796",
    "uf": "RS",
    "codigoIbge": 4317202,
    "cidade": "Santa Rosa"
  },
  {
    "prefixo": "98797",
    "uf": "RS",
    "codigoIbge": 4317202,
    "cidade": "Santa Rosa"
  },
  {
    "prefixo": "98798",
    "uf": "RS",
    "codigoIbge": 4317202,
    "cidade": "Santa Rosa"
  },
  {
    "prefixo": "98800",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98801",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98802",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98803",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98804",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98805",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98806",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98807",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98824",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98825",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98829",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98830",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98832",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98833",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98836",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98840",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98841",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98844",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98849",
    "uf": "RS",
    "codigoIbge": 4317509,
    "cidade": "Santo Ângelo"
  },
  {
    "prefixo": "98850",
    "uf": "RS",
    "codigoIbge": 4323754,
    "cidade": "Vitória das Missões"
  },
  {
    "prefixo": "98853",
    "uf": "RS",
    "codigoIbge": 4323754,
    "cidade": "Vitória das Missões"
  },
  {
    "prefixo": "98855",
    "uf": "RS",
    "codigoIbge": 4306932,
    "cidade": "Entre-Ijuís"
  },
  {
    "prefixo": "98857",
    "uf": "RS",
    "codigoIbge": 4306932,
    "cidade": "Entre-Ijuís"
  },
  {
    "prefixo": "98860",
    "uf": "RS",
    "codigoIbge": 4307831,
    "cidade": "Eugênio de Castro"
  },
  {
    "prefixo": "98865",
    "uf": "RS",
    "codigoIbge": 4319158,
    "cidade": "São Miguel das Missões"
  },
  {
    "prefixo": "98866",
    "uf": "RS",
    "codigoIbge": 4319158,
    "cidade": "São Miguel das Missões"
  },
  {
    "prefixo": "98867",
    "uf": "RS",
    "codigoIbge": 4319158,
    "cidade": "São Miguel das Missões"
  },
  {
    "prefixo": "98868",
    "uf": "RS",
    "codigoIbge": 4319158,
    "cidade": "São Miguel das Missões"
  },
  {
    "prefixo": "98869",
    "uf": "RS",
    "codigoIbge": 4319158,
    "cidade": "São Miguel das Missões"
  },
  {
    "prefixo": "98870",
    "uf": "RS",
    "codigoIbge": 4309001,
    "cidade": "Giruá"
  },
  {
    "prefixo": "98887",
    "uf": "RS",
    "codigoIbge": 4309001,
    "cidade": "Giruá"
  },
  {
    "prefixo": "98889",
    "uf": "RS",
    "codigoIbge": 4309001,
    "cidade": "Giruá"
  },
  {
    "prefixo": "98890",
    "uf": "RS",
    "codigoIbge": 4309001,
    "cidade": "Giruá"
  },
  {
    "prefixo": "98895",
    "uf": "RS",
    "codigoIbge": 4320321,
    "cidade": "Senador Salgado Filho"
  },
  {
    "prefixo": "98897",
    "uf": "RS",
    "codigoIbge": 4320321,
    "cidade": "Senador Salgado Filho"
  },
  {
    "prefixo": "98898",
    "uf": "RS",
    "codigoIbge": 4322343,
    "cidade": "Ubiretama"
  },
  {
    "prefixo": "98905",
    "uf": "RS",
    "codigoIbge": 4300455,
    "cidade": "Alegria"
  },
  {
    "prefixo": "98907",
    "uf": "RS",
    "codigoIbge": 4300455,
    "cidade": "Alegria"
  },
  {
    "prefixo": "98910",
    "uf": "RS",
    "codigoIbge": 4321808,
    "cidade": "Três de Maio"
  },
  {
    "prefixo": "98911",
    "uf": "RS",
    "codigoIbge": 4321808,
    "cidade": "Três de Maio"
  },
  {
    "prefixo": "98912",
    "uf": "RS",
    "codigoIbge": 4321808,
    "cidade": "Três de Maio"
  },
  {
    "prefixo": "98913",
    "uf": "RS",
    "codigoIbge": 4321808,
    "cidade": "Três de Maio"
  },
  {
    "prefixo": "98914",
    "uf": "RS",
    "codigoIbge": 4321808,
    "cidade": "Três de Maio"
  },
  {
    "prefixo": "98915",
    "uf": "RS",
    "codigoIbge": 4310405,
    "cidade": "Independência"
  },
  {
    "prefixo": "98917",
    "uf": "RS",
    "codigoIbge": 4310405,
    "cidade": "Independência"
  },
  {
    "prefixo": "98918",
    "uf": "RS",
    "codigoIbge": 4302204,
    "cidade": "Boa Vista do Buricá"
  },
  {
    "prefixo": "98919",
    "uf": "RS",
    "codigoIbge": 4313011,
    "cidade": "Nova Candelária"
  },
  {
    "prefixo": "98920",
    "uf": "RS",
    "codigoIbge": 4309605,
    "cidade": "Horizontina"
  },
  {
    "prefixo": "98922",
    "uf": "RS",
    "codigoIbge": 4309605,
    "cidade": "Horizontina"
  },
  {
    "prefixo": "98925",
    "uf": "RS",
    "codigoIbge": 4306734,
    "cidade": "Doutor Maurício Cardoso"
  },
  {
    "prefixo": "98926",
    "uf": "RS",
    "codigoIbge": 4306734,
    "cidade": "Doutor Maurício Cardoso"
  },
  {
    "prefixo": "98928",
    "uf": "RS",
    "codigoIbge": 4306734,
    "cidade": "Doutor Maurício Cardoso"
  },
  {
    "prefixo": "98930",
    "uf": "RS",
    "codigoIbge": 4322103,
    "cidade": "Tucunduva"
  },
  {
    "prefixo": "98940",
    "uf": "RS",
    "codigoIbge": 4322301,
    "cidade": "Tuparendi"
  },
  {
    "prefixo": "98946",
    "uf": "RS",
    "codigoIbge": 4322301,
    "cidade": "Tuparendi"
  },
  {
    "prefixo": "98947",
    "uf": "RS",
    "codigoIbge": 4315057,
    "cidade": "Porto Mauá"
  },
  {
    "prefixo": "98950",
    "uf": "RS",
    "codigoIbge": 4300307,
    "cidade": "Alecrim"
  },
  {
    "prefixo": "98955",
    "uf": "RS",
    "codigoIbge": 4313425,
    "cidade": "Novo Machado"
  },
  {
    "prefixo": "98957",
    "uf": "RS",
    "codigoIbge": 4313425,
    "cidade": "Novo Machado"
  },
  {
    "prefixo": "98958",
    "uf": "RS",
    "codigoIbge": 4318499,
    "cidade": "São José do Inhacorá"
  },
  {
    "prefixo": "98960",
    "uf": "RS",
    "codigoIbge": 4317905,
    "cidade": "Santo Cristo"
  },
  {
    "prefixo": "98968",
    "uf": "RS",
    "codigoIbge": 4317905,
    "cidade": "Santo Cristo"
  },
  {
    "prefixo": "98970",
    "uf": "RS",
    "codigoIbge": 4304309,
    "cidade": "Cândido Godói"
  },
  {
    "prefixo": "98975",
    "uf": "RS",
    "codigoIbge": 4303707,
    "cidade": "Campina das Missões"
  },
  {
    "prefixo": "98980",
    "uf": "RS",
    "codigoIbge": 4315008,
    "cidade": "Porto Lucena"
  },
  {
    "prefixo": "98985",
    "uf": "RS",
    "codigoIbge": 4315073,
    "cidade": "Porto Vera Cruz"
  },
  {
    "prefixo": "98995",
    "uf": "RS",
    "codigoIbge": 4315107,
    "cidade": "Porto Xavier"
  },
  {
    "prefixo": "98998",
    "uf": "RS",
    "codigoIbge": 4315107,
    "cidade": "Porto Xavier"
  },
  {
    "prefixo": "99001",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99010",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99020",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99022",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99025",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99030",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99032",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99034",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99036",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99040",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99042",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99043",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99050",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99051",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99052",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99054",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99060",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99062",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99064",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99066",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99070",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99072",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99074",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99099",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99125",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99127",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99130",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99132",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99135",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99140",
    "uf": "RS",
    "codigoIbge": 4307054,
    "cidade": "Ernestina"
  },
  {
    "prefixo": "99145",
    "uf": "RS",
    "codigoIbge": 4305975,
    "cidade": "Coxilha"
  },
  {
    "prefixo": "99150",
    "uf": "RS",
    "codigoIbge": 4311809,
    "cidade": "Marau"
  },
  {
    "prefixo": "99152",
    "uf": "RS",
    "codigoIbge": 4311809,
    "cidade": "Marau"
  },
  {
    "prefixo": "99153",
    "uf": "RS",
    "codigoIbge": 4311809,
    "cidade": "Marau"
  },
  {
    "prefixo": "99155",
    "uf": "RS",
    "codigoIbge": 4323408,
    "cidade": "Vila Maria"
  },
  {
    "prefixo": "99160",
    "uf": "RS",
    "codigoIbge": 4308854,
    "cidade": "Gentil"
  },
  {
    "prefixo": "99165",
    "uf": "RS",
    "codigoIbge": 4303558,
    "cidade": "Camargo"
  },
  {
    "prefixo": "99170",
    "uf": "RS",
    "codigoIbge": 4320503,
    "cidade": "Sertão"
  },
  {
    "prefixo": "99173",
    "uf": "RS",
    "codigoIbge": 4320503,
    "cidade": "Sertão"
  },
  {
    "prefixo": "99175",
    "uf": "RS",
    "codigoIbge": 4312674,
    "cidade": "Nicolau Vergueiro"
  },
  {
    "prefixo": "99180",
    "uf": "RS",
    "codigoIbge": 4312138,
    "cidade": "Mato Castelhano"
  },
  {
    "prefixo": "99185",
    "uf": "RS",
    "codigoIbge": 4312138,
    "cidade": "Mato Castelhano"
  },
  {
    "prefixo": "99187",
    "uf": "RS",
    "codigoIbge": 4314100,
    "cidade": "Passo Fundo"
  },
  {
    "prefixo": "99190",
    "uf": "RS",
    "codigoIbge": 4314779,
    "cidade": "Pontão"
  },
  {
    "prefixo": "99200",
    "uf": "RS",
    "codigoIbge": 4309407,
    "cidade": "Guaporé"
  },
  {
    "prefixo": "99210",
    "uf": "RS",
    "codigoIbge": 4309407,
    "cidade": "Guaporé"
  },
  {
    "prefixo": "99215",
    "uf": "RS",
    "codigoIbge": 4322350,
    "cidade": "União da Serra"
  },
  {
    "prefixo": "99220",
    "uf": "RS",
    "codigoIbge": 4306452,
    "cidade": "Dois Lajeados"
  },
  {
    "prefixo": "99240",
    "uf": "RS",
    "codigoIbge": 4319711,
    "cidade": "São Valentim do Sul"
  },
  {
    "prefixo": "99245",
    "uf": "RS",
    "codigoIbge": 4319711,
    "cidade": "São Valentim do Sul"
  },
  {
    "prefixo": "99247",
    "uf": "RS",
    "codigoIbge": 4319711,
    "cidade": "São Valentim do Sul"
  },
  {
    "prefixo": "99250",
    "uf": "RS",
    "codigoIbge": 4320404,
    "cidade": "Serafina Corrêa"
  },
  {
    "prefixo": "99253",
    "uf": "RS",
    "codigoIbge": 4320404,
    "cidade": "Serafina Corrêa"
  },
  {
    "prefixo": "99255",
    "uf": "RS",
    "codigoIbge": 4312351,
    "cidade": "Montauri"
  },
  {
    "prefixo": "99260",
    "uf": "RS",
    "codigoIbge": 4304903,
    "cidade": "Casca"
  },
  {
    "prefixo": "99262",
    "uf": "RS",
    "codigoIbge": 4304903,
    "cidade": "Casca"
  },
  {
    "prefixo": "99265",
    "uf": "RS",
    "codigoIbge": 4317558,
    "cidade": "Santo Antônio do Palma"
  },
  {
    "prefixo": "99270",
    "uf": "RS",
    "codigoIbge": 4318051,
    "cidade": "São Domingos do Sul"
  },
  {
    "prefixo": "99274",
    "uf": "RS",
    "codigoIbge": 4318051,
    "cidade": "São Domingos do Sul"
  },
  {
    "prefixo": "99290",
    "uf": "RS",
    "codigoIbge": 4322558,
    "cidade": "Vanini"
  },
  {
    "prefixo": "99300",
    "uf": "RS",
    "codigoIbge": 4320800,
    "cidade": "Soledade"
  },
  {
    "prefixo": "99307",
    "uf": "RS",
    "codigoIbge": 4320800,
    "cidade": "Soledade"
  },
  {
    "prefixo": "99315",
    "uf": "RS",
    "codigoIbge": 4312427,
    "cidade": "Mormaço"
  },
  {
    "prefixo": "99320",
    "uf": "RS",
    "codigoIbge": 4309951,
    "cidade": "Ibirapuitã"
  },
  {
    "prefixo": "99330",
    "uf": "RS",
    "codigoIbge": 4322152,
    "cidade": "Tunas"
  },
  {
    "prefixo": "99339",
    "uf": "RS",
    "codigoIbge": 4322152,
    "cidade": "Tunas"
  },
  {
    "prefixo": "99340",
    "uf": "RS",
    "codigoIbge": 4311254,
    "cidade": "Lagoão"
  },
  {
    "prefixo": "99345",
    "uf": "RS",
    "codigoIbge": 4321469,
    "cidade": "Tio Hugo"
  },
  {
    "prefixo": "99350",
    "uf": "RS",
    "codigoIbge": 4323200,
    "cidade": "Victor Graeff"
  },
  {
    "prefixo": "99353",
    "uf": "RS",
    "codigoIbge": 4323200,
    "cidade": "Victor Graeff"
  },
  {
    "prefixo": "99355",
    "uf": "RS",
    "codigoIbge": 4323200,
    "cidade": "Victor Graeff"
  },
  {
    "prefixo": "99357",
    "uf": "RS",
    "codigoIbge": 4323200,
    "cidade": "Victor Graeff"
  },
  {
    "prefixo": "99360",
    "uf": "RS",
    "codigoIbge": 4302006,
    "cidade": "Barros Cassal"
  },
  {
    "prefixo": "99370",
    "uf": "RS",
    "codigoIbge": 4308300,
    "cidade": "Fontoura Xavier"
  },
  {
    "prefixo": "99372",
    "uf": "RS",
    "codigoIbge": 4308300,
    "cidade": "Fontoura Xavier"
  },
  {
    "prefixo": "99379",
    "uf": "RS",
    "codigoIbge": 4308300,
    "cidade": "Fontoura Xavier"
  },
  {
    "prefixo": "99380",
    "uf": "RS",
    "codigoIbge": 4318465,
    "cidade": "São José do Herval"
  },
  {
    "prefixo": "99400",
    "uf": "RS",
    "codigoIbge": 4307500,
    "cidade": "Espumoso"
  },
  {
    "prefixo": "99405",
    "uf": "RS",
    "codigoIbge": 4307500,
    "cidade": "Espumoso"
  },
  {
    "prefixo": "99410",
    "uf": "RS",
    "codigoIbge": 4307500,
    "cidade": "Espumoso"
  },
  {
    "prefixo": "99420",
    "uf": "RS",
    "codigoIbge": 4307500,
    "cidade": "Espumoso"
  },
  {
    "prefixo": "99425",
    "uf": "RS",
    "codigoIbge": 4307500,
    "cidade": "Espumoso"
  },
  {
    "prefixo": "99430",
    "uf": "RS",
    "codigoIbge": 4300554,
    "cidade": "Alto Alegre"
  },
  {
    "prefixo": "99434",
    "uf": "RS",
    "codigoIbge": 4300554,
    "cidade": "Alto Alegre"
  },
  {
    "prefixo": "99435",
    "uf": "RS",
    "codigoIbge": 4304101,
    "cidade": "Campos Borges"
  },
  {
    "prefixo": "99436",
    "uf": "RS",
    "codigoIbge": 4304101,
    "cidade": "Campos Borges"
  },
  {
    "prefixo": "99437",
    "uf": "RS",
    "codigoIbge": 4304101,
    "cidade": "Campos Borges"
  },
  {
    "prefixo": "99440",
    "uf": "RS",
    "codigoIbge": 4316451,
    "cidade": "Salto do Jacuí"
  },
  {
    "prefixo": "99447",
    "uf": "RS",
    "codigoIbge": 4316451,
    "cidade": "Salto do Jacuí"
  },
  {
    "prefixo": "99450",
    "uf": "RS",
    "codigoIbge": 4320305,
    "cidade": "Selbach"
  },
  {
    "prefixo": "99455",
    "uf": "RS",
    "codigoIbge": 4320305,
    "cidade": "Selbach"
  },
  {
    "prefixo": "99457",
    "uf": "RS",
    "codigoIbge": 4310876,
    "cidade": "Jacuizinho"
  },
  {
    "prefixo": "99460",
    "uf": "RS",
    "codigoIbge": 4305603,
    "cidade": "Colorado"
  },
  {
    "prefixo": "99465",
    "uf": "RS",
    "codigoIbge": 4305603,
    "cidade": "Colorado"
  },
  {
    "prefixo": "99470",
    "uf": "RS",
    "codigoIbge": 4312658,
    "cidade": "Não-Me-Toque"
  },
  {
    "prefixo": "99490",
    "uf": "RS",
    "codigoIbge": 4321006,
    "cidade": "Tapera"
  },
  {
    "prefixo": "99494",
    "uf": "RS",
    "codigoIbge": 4321006,
    "cidade": "Tapera"
  },
  {
    "prefixo": "99495",
    "uf": "RS",
    "codigoIbge": 4311270,
    "cidade": "Lagoa dos Três Cantos"
  },
  {
    "prefixo": "99500",
    "uf": "RS",
    "codigoIbge": 4304705,
    "cidade": "Carazinho"
  },
  {
    "prefixo": "99518",
    "uf": "RS",
    "codigoIbge": 4304705,
    "cidade": "Carazinho"
  },
  {
    "prefixo": "99520",
    "uf": "RS",
    "codigoIbge": 4304705,
    "cidade": "Carazinho"
  },
  {
    "prefixo": "99523",
    "uf": "RS",
    "codigoIbge": 4300471,
    "cidade": "Almirante Tamandaré do Sul"
  },
  {
    "prefixo": "99525",
    "uf": "RS",
    "codigoIbge": 4317756,
    "cidade": "Santo Antônio do Planalto"
  },
  {
    "prefixo": "99528",
    "uf": "RS",
    "codigoIbge": 4305850,
    "cidade": "Coqueiros do Sul"
  },
  {
    "prefixo": "99529",
    "uf": "RS",
    "codigoIbge": 4305850,
    "cidade": "Coqueiros do Sul"
  },
  {
    "prefixo": "99530",
    "uf": "RS",
    "codigoIbge": 4305306,
    "cidade": "Chapada"
  },
  {
    "prefixo": "99535",
    "uf": "RS",
    "codigoIbge": 4305306,
    "cidade": "Chapada"
  },
  {
    "prefixo": "99540",
    "uf": "RS",
    "codigoIbge": 4305306,
    "cidade": "Chapada"
  },
  {
    "prefixo": "99545",
    "uf": "RS",
    "codigoIbge": 4305306,
    "cidade": "Chapada"
  },
  {
    "prefixo": "99550",
    "uf": "RS",
    "codigoIbge": 4305306,
    "cidade": "Chapada"
  },
  {
    "prefixo": "99555",
    "uf": "RS",
    "codigoIbge": 4305306,
    "cidade": "Chapada"
  },
  {
    "prefixo": "99560",
    "uf": "RS",
    "codigoIbge": 4320107,
    "cidade": "Sarandi"
  },
  {
    "prefixo": "99565",
    "uf": "RS",
    "codigoIbge": 4320107,
    "cidade": "Sarandi"
  },
  {
    "prefixo": "99575",
    "uf": "RS",
    "codigoIbge": 4320107,
    "cidade": "Sarandi"
  },
  {
    "prefixo": "99580",
    "uf": "RS",
    "codigoIbge": 4312955,
    "cidade": "Nova Boa Vista"
  },
  {
    "prefixo": "99585",
    "uf": "RS",
    "codigoIbge": 4301958,
    "cidade": "Barra Funda"
  },
  {
    "prefixo": "99590",
    "uf": "RS",
    "codigoIbge": 4316204,
    "cidade": "Rondinha"
  },
  {
    "prefixo": "99600",
    "uf": "RS",
    "codigoIbge": 4312708,
    "cidade": "Nonoai"
  },
  {
    "prefixo": "99605",
    "uf": "RS",
    "codigoIbge": 4309126,
    "cidade": "Gramado dos Loureiros"
  },
  {
    "prefixo": "99610",
    "uf": "RS",
    "codigoIbge": 4315552,
    "cidade": "Rio dos Índios"
  },
  {
    "prefixo": "99613",
    "uf": "RS",
    "codigoIbge": 4315552,
    "cidade": "Rio dos Índios"
  },
  {
    "prefixo": "99615",
    "uf": "RS",
    "codigoIbge": 4321956,
    "cidade": "Trindade do Sul"
  },
  {
    "prefixo": "99640",
    "uf": "RS",
    "codigoIbge": 4319703,
    "cidade": "São Valentim"
  },
  {
    "prefixo": "99645",
    "uf": "RS",
    "codigoIbge": 4306957,
    "cidade": "Entre Rios do Sul"
  },
  {
    "prefixo": "99650",
    "uf": "RS",
    "codigoIbge": 4302055,
    "cidade": "Benjamin Constant do Sul"
  },
  {
    "prefixo": "99655",
    "uf": "RS",
    "codigoIbge": 4308052,
    "cidade": "Faxinalzinho"
  },
  {
    "prefixo": "99660",
    "uf": "RS",
    "codigoIbge": 4303806,
    "cidade": "Campinas do Sul"
  },
  {
    "prefixo": "99665",
    "uf": "RS",
    "codigoIbge": 4306130,
    "cidade": "Cruzaltense"
  },
  {
    "prefixo": "99670",
    "uf": "RS",
    "codigoIbge": 4316105,
    "cidade": "Ronda Alta"
  },
  {
    "prefixo": "99673",
    "uf": "RS",
    "codigoIbge": 4316105,
    "cidade": "Ronda Alta"
  },
  {
    "prefixo": "99675",
    "uf": "RS",
    "codigoIbge": 4321857,
    "cidade": "Três Palmeiras"
  },
  {
    "prefixo": "99678",
    "uf": "RS",
    "codigoIbge": 4321857,
    "cidade": "Três Palmeiras"
  },
  {
    "prefixo": "99680",
    "uf": "RS",
    "codigoIbge": 4305801,
    "cidade": "Constantina"
  },
  {
    "prefixo": "99686",
    "uf": "RS",
    "codigoIbge": 4305801,
    "cidade": "Constantina"
  },
  {
    "prefixo": "99687",
    "uf": "RS",
    "codigoIbge": 4313466,
    "cidade": "Novo Xingu"
  },
  {
    "prefixo": "99690",
    "uf": "RS",
    "codigoIbge": 4311601,
    "cidade": "Liberato Salzano"
  },
  {
    "prefixo": "99695",
    "uf": "RS",
    "codigoIbge": 4311601,
    "cidade": "Liberato Salzano"
  },
  {
    "prefixo": "99698",
    "uf": "RS",
    "codigoIbge": 4306924,
    "cidade": "Engenho Velho"
  },
  {
    "prefixo": "99700",
    "uf": "RS",
    "codigoIbge": 4307005,
    "cidade": "Erechim"
  },
  {
    "prefixo": "99701",
    "uf": "RS",
    "codigoIbge": 4307005,
    "cidade": "Erechim"
  },
  {
    "prefixo": "99702",
    "uf": "RS",
    "codigoIbge": 4307005,
    "cidade": "Erechim"
  },
  {
    "prefixo": "99704",
    "uf": "RS",
    "codigoIbge": 4307005,
    "cidade": "Erechim"
  },
  {
    "prefixo": "99705",
    "uf": "RS",
    "codigoIbge": 4307005,
    "cidade": "Erechim"
  },
  {
    "prefixo": "99706",
    "uf": "RS",
    "codigoIbge": 4307005,
    "cidade": "Erechim"
  },
  {
    "prefixo": "99708",
    "uf": "RS",
    "codigoIbge": 4307005,
    "cidade": "Erechim"
  },
  {
    "prefixo": "99709",
    "uf": "RS",
    "codigoIbge": 4307005,
    "cidade": "Erechim"
  },
  {
    "prefixo": "99710",
    "uf": "RS",
    "codigoIbge": 4307005,
    "cidade": "Erechim"
  },
  {
    "prefixo": "99711",
    "uf": "RS",
    "codigoIbge": 4307005,
    "cidade": "Erechim"
  },
  {
    "prefixo": "99712",
    "uf": "RS",
    "codigoIbge": 4307005,
    "cidade": "Erechim"
  },
  {
    "prefixo": "99713",
    "uf": "RS",
    "codigoIbge": 4307005,
    "cidade": "Erechim"
  },
  {
    "prefixo": "99714",
    "uf": "RS",
    "codigoIbge": 4307005,
    "cidade": "Erechim"
  },
  {
    "prefixo": "99715",
    "uf": "RS",
    "codigoIbge": 4307005,
    "cidade": "Erechim"
  },
  {
    "prefixo": "99717",
    "uf": "RS",
    "codigoIbge": 4307005,
    "cidade": "Erechim"
  },
  {
    "prefixo": "99718",
    "uf": "RS",
    "codigoIbge": 4314134,
    "cidade": "Paulo Bento"
  },
  {
    "prefixo": "99720",
    "uf": "RS",
    "codigoIbge": 4315313,
    "cidade": "Quatro Irmãos"
  },
  {
    "prefixo": "99725",
    "uf": "RS",
    "codigoIbge": 4321634,
    "cidade": "Três Arroios"
  },
  {
    "prefixo": "99728",
    "uf": "RS",
    "codigoIbge": 4321634,
    "cidade": "Três Arroios"
  },
  {
    "prefixo": "99730",
    "uf": "RS",
    "codigoIbge": 4310900,
    "cidade": "Jacutinga"
  },
  {
    "prefixo": "99735",
    "uf": "RS",
    "codigoIbge": 4314787,
    "cidade": "Ponte Preta"
  },
  {
    "prefixo": "99738",
    "uf": "RS",
    "codigoIbge": 4314787,
    "cidade": "Ponte Preta"
  },
  {
    "prefixo": "99740",
    "uf": "RS",
    "codigoIbge": 4301701,
    "cidade": "Barão de Cotegipe"
  },
  {
    "prefixo": "99750",
    "uf": "RS",
    "codigoIbge": 4307203,
    "cidade": "Erval Grande"
  },
  {
    "prefixo": "99760",
    "uf": "RS",
    "codigoIbge": 4310702,
    "cidade": "Itatiba do Sul"
  },
  {
    "prefixo": "99763",
    "uf": "RS",
    "codigoIbge": 4310702,
    "cidade": "Itatiba do Sul"
  },
  {
    "prefixo": "99765",
    "uf": "RS",
    "codigoIbge": 4310702,
    "cidade": "Itatiba do Sul"
  },
  {
    "prefixo": "99768",
    "uf": "RS",
    "codigoIbge": 4310702,
    "cidade": "Itatiba do Sul"
  },
  {
    "prefixo": "99770",
    "uf": "RS",
    "codigoIbge": 4300901,
    "cidade": "Aratiba"
  },
  {
    "prefixo": "99775",
    "uf": "RS",
    "codigoIbge": 4300901,
    "cidade": "Aratiba"
  },
  {
    "prefixo": "99777",
    "uf": "RS",
    "codigoIbge": 4300901,
    "cidade": "Aratiba"
  },
  {
    "prefixo": "99785",
    "uf": "RS",
    "codigoIbge": 4300901,
    "cidade": "Aratiba"
  },
  {
    "prefixo": "99790",
    "uf": "RS",
    "codigoIbge": 4312005,
    "cidade": "Mariano Moro"
  },
  {
    "prefixo": "99795",
    "uf": "RS",
    "codigoIbge": 4301925,
    "cidade": "Barra do Rio Azul"
  },
  {
    "prefixo": "99800",
    "uf": "RS",
    "codigoIbge": 4311908,
    "cidade": "Marcelino Ramos"
  },
  {
    "prefixo": "99807",
    "uf": "RS",
    "codigoIbge": 4311908,
    "cidade": "Marcelino Ramos"
  },
  {
    "prefixo": "99810",
    "uf": "RS",
    "codigoIbge": 4320602,
    "cidade": "Severiano de Almeida"
  },
  {
    "prefixo": "99820",
    "uf": "RS",
    "codigoIbge": 4322905,
    "cidade": "Viadutos"
  },
  {
    "prefixo": "99825",
    "uf": "RS",
    "codigoIbge": 4304853,
    "cidade": "Carlos Gomes"
  },
  {
    "prefixo": "99830",
    "uf": "RS",
    "codigoIbge": 4308706,
    "cidade": "Gaurama"
  },
  {
    "prefixo": "99833",
    "uf": "RS",
    "codigoIbge": 4308706,
    "cidade": "Gaurama"
  },
  {
    "prefixo": "99835",
    "uf": "RS",
    "codigoIbge": 4301552,
    "cidade": "Áurea"
  },
  {
    "prefixo": "99838",
    "uf": "RS",
    "codigoIbge": 4305116,
    "cidade": "Centenário"
  },
  {
    "prefixo": "99840",
    "uf": "RS",
    "codigoIbge": 4316600,
    "cidade": "Sananduva"
  },
  {
    "prefixo": "99845",
    "uf": "RS",
    "codigoIbge": 4316600,
    "cidade": "Sananduva"
  },
  {
    "prefixo": "99850",
    "uf": "RS",
    "codigoIbge": 4313607,
    "cidade": "Paim Filho"
  },
  {
    "prefixo": "99855",
    "uf": "RS",
    "codigoIbge": 4318424,
    "cidade": "São João da Urtiga"
  },
  {
    "prefixo": "99860",
    "uf": "RS",
    "codigoIbge": 4303202,
    "cidade": "Cacique Doble"
  },
  {
    "prefixo": "99865",
    "uf": "RS",
    "codigoIbge": 4303202,
    "cidade": "Cacique Doble"
  },
  {
    "prefixo": "99870",
    "uf": "RS",
    "codigoIbge": 4318606,
    "cidade": "São José do Ouro"
  },
  {
    "prefixo": "99874",
    "uf": "RS",
    "codigoIbge": 4318606,
    "cidade": "São José do Ouro"
  },
  {
    "prefixo": "99877",
    "uf": "RS",
    "codigoIbge": 4318606,
    "cidade": "São José do Ouro"
  },
  {
    "prefixo": "99878",
    "uf": "RS",
    "codigoIbge": 4322186,
    "cidade": "Tupanci do Sul"
  },
  {
    "prefixo": "99880",
    "uf": "RS",
    "codigoIbge": 4311700,
    "cidade": "Machadinho"
  },
  {
    "prefixo": "99885",
    "uf": "RS",
    "codigoIbge": 4311700,
    "cidade": "Machadinho"
  },
  {
    "prefixo": "99890",
    "uf": "RS",
    "codigoIbge": 4312203,
    "cidade": "Maximiliano de Almeida"
  },
  {
    "prefixo": "99895",
    "uf": "RS",
    "codigoIbge": 4317954,
    "cidade": "Santo Expedito do Sul"
  },
  {
    "prefixo": "99900",
    "uf": "RS",
    "codigoIbge": 4308904,
    "cidade": "Getúlio Vargas"
  },
  {
    "prefixo": "99908",
    "uf": "RS",
    "codigoIbge": 4308904,
    "cidade": "Getúlio Vargas"
  },
  {
    "prefixo": "99910",
    "uf": "RS",
    "codigoIbge": 4308250,
    "cidade": "Floriano Peixoto"
  },
  {
    "prefixo": "99920",
    "uf": "RS",
    "codigoIbge": 4306973,
    "cidade": "Erebango"
  },
  {
    "prefixo": "99925",
    "uf": "RS",
    "codigoIbge": 4310462,
    "cidade": "Ipiranga do Sul"
  },
  {
    "prefixo": "99930",
    "uf": "RS",
    "codigoIbge": 4307559,
    "cidade": "Estação"
  },
  {
    "prefixo": "99940",
    "uf": "RS",
    "codigoIbge": 4309803,
    "cidade": "Ibiaçá"
  },
  {
    "prefixo": "99943",
    "uf": "RS",
    "codigoIbge": 4309803,
    "cidade": "Ibiaçá"
  },
  {
    "prefixo": "99945",
    "uf": "RS",
    "codigoIbge": 4309803,
    "cidade": "Ibiaçá"
  },
  {
    "prefixo": "99950",
    "uf": "RS",
    "codigoIbge": 4320909,
    "cidade": "Tapejara"
  },
  {
    "prefixo": "99951",
    "uf": "RS",
    "codigoIbge": 4320909,
    "cidade": "Tapejara"
  },
  {
    "prefixo": "99952",
    "uf": "RS",
    "codigoIbge": 4316733,
    "cidade": "Santa Cecília do Sul"
  },
  {
    "prefixo": "99955",
    "uf": "RS",
    "codigoIbge": 4323358,
    "cidade": "Vila Lângaro"
  },
  {
    "prefixo": "99960",
    "uf": "RS",
    "codigoIbge": 4305371,
    "cidade": "Charrua"
  },
  {
    "prefixo": "99965",
    "uf": "RS",
    "codigoIbge": 4300059,
    "cidade": "Água Santa"
  },
  {
    "prefixo": "99967",
    "uf": "RS",
    "codigoIbge": 4300059,
    "cidade": "Água Santa"
  },
  {
    "prefixo": "99969",
    "uf": "RS",
    "codigoIbge": 4300059,
    "cidade": "Água Santa"
  },
  {
    "prefixo": "99970",
    "uf": "RS",
    "codigoIbge": 4305504,
    "cidade": "Ciríaco"
  },
  {
    "prefixo": "99980",
    "uf": "RS",
    "codigoIbge": 4306304,
    "cidade": "David Canabarro"
  },
  {
    "prefixo": "99990",
    "uf": "RS",
    "codigoIbge": 4312625,
    "cidade": "Muliterno"
  }
]
